/* eslint-disable */
import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: any; output: any; }
  Json: { input: any; output: any; }
  /** The `Upload` scalar type represents a file upload. */
  Upload: { input: any; output: any; }
};

export type Account = {
  __typename?: 'Account';
  _count: AccountCountOutputType;
  accountRemainingDaysForFreeApplications?: Maybe<Scalars['Int']['output']>;
  activated: Scalars['Boolean']['output'];
  activeCampaignContactId?: Maybe<Scalars['String']['output']>;
  address?: Maybe<Address>;
  addressId?: Maybe<Scalars['Int']['output']>;
  animals: Array<Animal>;
  applications: Array<DogBreederApplication>;
  birthday?: Maybe<Scalars['DateTime']['output']>;
  bookings: Array<Booking>;
  bookmarks: Array<Bookmark>;
  breedersContacted?: Maybe<Scalars['Int']['output']>;
  connectedAt: Scalars['DateTime']['output'];
  contactPreferences?: Maybe<Array<Maybe<ContactPreference>>>;
  createdAt: Scalars['DateTime']['output'];
  createdFrom?: Maybe<AccountCreatedFromEnum>;
  deleted: Scalars['Boolean']['output'];
  dogBreeder?: Maybe<DogBreeder>;
  dogBreederReview: Array<DogBreederReview>;
  dogShelter?: Maybe<DogShelter>;
  email: Scalars['String']['output'];
  facebookId?: Maybe<Scalars['String']['output']>;
  firebaseId?: Maybe<Scalars['String']['output']>;
  firebaseToken?: Maybe<Scalars['String']['output']>;
  firstAccountConversations: Array<Conversation>;
  firstName?: Maybe<Scalars['String']['output']>;
  freeApplicationsDateLimit?: Maybe<Scalars['DateTime']['output']>;
  gender?: Maybe<GenderEnum>;
  googleId?: Maybe<Scalars['String']['output']>;
  hasADog?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  imgs: Array<AccountImg>;
  isIdealBuyer?: Maybe<Scalars['Boolean']['output']>;
  klaviyoId?: Maybe<Scalars['String']['output']>;
  language: Scalars['String']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  marketingEmailConsent: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  notifications: Array<Notification>;
  /** @TypeGraphQL.omit(output: true) */
  password?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  puppies?: Maybe<Array<DogPuppy>>;
  receivedMessages: Array<Message>;
  registrationToken?: Maybe<Scalars['String']['output']>;
  restrictedAccess: Scalars['Boolean']['output'];
  role: Role;
  secondAccountConversations: Array<Conversation>;
  sentMessages: Array<Message>;
  subscriptionType?: Maybe<SubscriptionTypeEnum>;
  updatedAt: Scalars['DateTime']['output'];
};


export type AccountanimalsArgs = {
  cursor?: InputMaybe<AnimalWhereUniqueInput>;
  distinct?: InputMaybe<AnimalScalarFieldEnum>;
  orderBy?: InputMaybe<AnimalOrderByWithRelationAndSearchRelevanceInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AnimalWhereInput>;
};


export type AccountapplicationsArgs = {
  cursor?: InputMaybe<DogBreederApplicationWhereUniqueInput>;
  distinct?: InputMaybe<DogBreederApplicationScalarFieldEnum>;
  orderBy?: InputMaybe<DogBreederApplicationOrderByWithRelationAndSearchRelevanceInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DogBreederApplicationWhereInput>;
};


export type AccountbookingsArgs = {
  cursor?: InputMaybe<BookingWhereUniqueInput>;
  distinct?: InputMaybe<BookingScalarFieldEnum>;
  orderBy?: InputMaybe<BookingOrderByWithRelationAndSearchRelevanceInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<BookingWhereInput>;
};


export type AccountbookmarksArgs = {
  cursor?: InputMaybe<BookmarkWhereUniqueInput>;
  distinct?: InputMaybe<BookmarkScalarFieldEnum>;
  orderBy?: InputMaybe<BookmarkOrderByWithRelationAndSearchRelevanceInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<BookmarkWhereInput>;
};


export type AccountdogBreederReviewArgs = {
  cursor?: InputMaybe<DogBreederReviewWhereUniqueInput>;
  distinct?: InputMaybe<DogBreederReviewScalarFieldEnum>;
  orderBy?: InputMaybe<DogBreederReviewOrderByWithRelationAndSearchRelevanceInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DogBreederReviewWhereInput>;
};


export type AccountfirstAccountConversationsArgs = {
  cursor?: InputMaybe<ConversationWhereUniqueInput>;
  distinct?: InputMaybe<ConversationScalarFieldEnum>;
  orderBy?: InputMaybe<ConversationOrderByWithRelationAndSearchRelevanceInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ConversationWhereInput>;
};


export type AccountimgsArgs = {
  cursor?: InputMaybe<AccountImgWhereUniqueInput>;
  distinct?: InputMaybe<AccountImgScalarFieldEnum>;
  orderBy?: InputMaybe<AccountImgOrderByWithRelationAndSearchRelevanceInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AccountImgWhereInput>;
};


export type AccountnotificationsArgs = {
  cursor?: InputMaybe<NotificationWhereUniqueInput>;
  distinct?: InputMaybe<NotificationScalarFieldEnum>;
  orderBy?: InputMaybe<NotificationOrderByWithRelationAndSearchRelevanceInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<NotificationWhereInput>;
};


export type AccountpuppiesArgs = {
  cursor?: InputMaybe<DogPuppyWhereUniqueInput>;
  distinct?: InputMaybe<DogPuppyScalarFieldEnum>;
  orderBy?: InputMaybe<DogPuppyOrderByWithRelationAndSearchRelevanceInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DogPuppyWhereInput>;
};


export type AccountreceivedMessagesArgs = {
  cursor?: InputMaybe<MessageWhereUniqueInput>;
  distinct?: InputMaybe<MessageScalarFieldEnum>;
  orderBy?: InputMaybe<MessageOrderByWithRelationAndSearchRelevanceInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MessageWhereInput>;
};


export type AccountsecondAccountConversationsArgs = {
  cursor?: InputMaybe<ConversationWhereUniqueInput>;
  distinct?: InputMaybe<ConversationScalarFieldEnum>;
  orderBy?: InputMaybe<ConversationOrderByWithRelationAndSearchRelevanceInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ConversationWhereInput>;
};


export type AccountsentMessagesArgs = {
  cursor?: InputMaybe<MessageWhereUniqueInput>;
  distinct?: InputMaybe<MessageScalarFieldEnum>;
  orderBy?: InputMaybe<MessageOrderByWithRelationAndSearchRelevanceInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MessageWhereInput>;
};

export type AccountActivityAvgAggregateOutputType = {
  __typename?: 'AccountActivityAvgAggregateOutputType';
  accountId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

export type AccountActivityAvgOrderByAggregateInput = {
  accountId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export type AccountActivityCountAggregateOutputType = {
  __typename?: 'AccountActivityCountAggregateOutputType';
  _all: Scalars['Int']['output'];
  accountId: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
};

export type AccountActivityCountOrderByAggregateInput = {
  accountId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export type AccountActivityCreateInput = {
  account: AccountCreateNestedOneWithoutActivityLogsInput;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AccountActivityCreateManyAccountInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type AccountActivityCreateManyAccountInputEnvelope = {
  data: Array<AccountActivityCreateManyAccountInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AccountActivityCreateManyInput = {
  accountId: Scalars['Int']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type AccountActivityCreateNestedManyWithoutAccountInput = {
  connect?: InputMaybe<Array<AccountActivityWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AccountActivityCreateOrConnectWithoutAccountInput>>;
  create?: InputMaybe<Array<AccountActivityCreateWithoutAccountInput>>;
  createMany?: InputMaybe<AccountActivityCreateManyAccountInputEnvelope>;
};

export type AccountActivityCreateOrConnectWithoutAccountInput = {
  create: AccountActivityCreateWithoutAccountInput;
  where: AccountActivityWhereUniqueInput;
};

export type AccountActivityCreateWithoutAccountInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AccountActivityListRelationFilter = {
  every?: InputMaybe<AccountActivityWhereInput>;
  none?: InputMaybe<AccountActivityWhereInput>;
  some?: InputMaybe<AccountActivityWhereInput>;
};

export type AccountActivityMaxAggregateOutputType = {
  __typename?: 'AccountActivityMaxAggregateOutputType';
  accountId?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
};

export type AccountActivityMaxOrderByAggregateInput = {
  accountId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export type AccountActivityMinAggregateOutputType = {
  __typename?: 'AccountActivityMinAggregateOutputType';
  accountId?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
};

export type AccountActivityMinOrderByAggregateInput = {
  accountId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export type AccountActivityOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type AccountActivityOrderByWithAggregationInput = {
  _avg?: InputMaybe<AccountActivityAvgOrderByAggregateInput>;
  _count?: InputMaybe<AccountActivityCountOrderByAggregateInput>;
  _max?: InputMaybe<AccountActivityMaxOrderByAggregateInput>;
  _min?: InputMaybe<AccountActivityMinOrderByAggregateInput>;
  _sum?: InputMaybe<AccountActivitySumOrderByAggregateInput>;
  accountId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export type AccountActivityOrderByWithRelationAndSearchRelevanceInput = {
  account?: InputMaybe<AccountOrderByWithRelationAndSearchRelevanceInput>;
  accountId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export enum AccountActivityScalarFieldEnum {
  accountId = 'accountId',
  createdAt = 'createdAt',
  id = 'id'
}

export type AccountActivityScalarWhereInput = {
  AND?: InputMaybe<Array<AccountActivityScalarWhereInput>>;
  NOT?: InputMaybe<Array<AccountActivityScalarWhereInput>>;
  OR?: InputMaybe<Array<AccountActivityScalarWhereInput>>;
  accountId?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntFilter>;
};

export type AccountActivityScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<AccountActivityScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<AccountActivityScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<AccountActivityScalarWhereWithAggregatesInput>>;
  accountId?: InputMaybe<IntWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
};

export type AccountActivitySumAggregateOutputType = {
  __typename?: 'AccountActivitySumAggregateOutputType';
  accountId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
};

export type AccountActivitySumOrderByAggregateInput = {
  accountId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export type AccountActivityUncheckedCreateInput = {
  accountId: Scalars['Int']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type AccountActivityUncheckedCreateNestedManyWithoutAccountInput = {
  connect?: InputMaybe<Array<AccountActivityWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AccountActivityCreateOrConnectWithoutAccountInput>>;
  create?: InputMaybe<Array<AccountActivityCreateWithoutAccountInput>>;
  createMany?: InputMaybe<AccountActivityCreateManyAccountInputEnvelope>;
};

export type AccountActivityUncheckedCreateWithoutAccountInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type AccountActivityUncheckedUpdateInput = {
  accountId?: InputMaybe<IntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type AccountActivityUncheckedUpdateManyInput = {
  accountId?: InputMaybe<IntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type AccountActivityUncheckedUpdateManyWithoutAccountInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type AccountActivityUncheckedUpdateManyWithoutAccountNestedInput = {
  connect?: InputMaybe<Array<AccountActivityWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AccountActivityCreateOrConnectWithoutAccountInput>>;
  create?: InputMaybe<Array<AccountActivityCreateWithoutAccountInput>>;
  createMany?: InputMaybe<AccountActivityCreateManyAccountInputEnvelope>;
  delete?: InputMaybe<Array<AccountActivityWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<AccountActivityScalarWhereInput>>;
  disconnect?: InputMaybe<Array<AccountActivityWhereUniqueInput>>;
  set?: InputMaybe<Array<AccountActivityWhereUniqueInput>>;
  update?: InputMaybe<Array<AccountActivityUpdateWithWhereUniqueWithoutAccountInput>>;
  updateMany?: InputMaybe<Array<AccountActivityUpdateManyWithWhereWithoutAccountInput>>;
  upsert?: InputMaybe<Array<AccountActivityUpsertWithWhereUniqueWithoutAccountInput>>;
};

export type AccountActivityUncheckedUpdateWithoutAccountInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type AccountActivityUpdateInput = {
  account?: InputMaybe<AccountUpdateOneRequiredWithoutActivityLogsNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type AccountActivityUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type AccountActivityUpdateManyWithWhereWithoutAccountInput = {
  data: AccountActivityUpdateManyMutationInput;
  where: AccountActivityScalarWhereInput;
};

export type AccountActivityUpdateManyWithoutAccountNestedInput = {
  connect?: InputMaybe<Array<AccountActivityWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AccountActivityCreateOrConnectWithoutAccountInput>>;
  create?: InputMaybe<Array<AccountActivityCreateWithoutAccountInput>>;
  createMany?: InputMaybe<AccountActivityCreateManyAccountInputEnvelope>;
  delete?: InputMaybe<Array<AccountActivityWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<AccountActivityScalarWhereInput>>;
  disconnect?: InputMaybe<Array<AccountActivityWhereUniqueInput>>;
  set?: InputMaybe<Array<AccountActivityWhereUniqueInput>>;
  update?: InputMaybe<Array<AccountActivityUpdateWithWhereUniqueWithoutAccountInput>>;
  updateMany?: InputMaybe<Array<AccountActivityUpdateManyWithWhereWithoutAccountInput>>;
  upsert?: InputMaybe<Array<AccountActivityUpsertWithWhereUniqueWithoutAccountInput>>;
};

export type AccountActivityUpdateWithWhereUniqueWithoutAccountInput = {
  data: AccountActivityUpdateWithoutAccountInput;
  where: AccountActivityWhereUniqueInput;
};

export type AccountActivityUpdateWithoutAccountInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type AccountActivityUpsertWithWhereUniqueWithoutAccountInput = {
  create: AccountActivityCreateWithoutAccountInput;
  update: AccountActivityUpdateWithoutAccountInput;
  where: AccountActivityWhereUniqueInput;
};

export type AccountActivityWhereInput = {
  AND?: InputMaybe<Array<AccountActivityWhereInput>>;
  NOT?: InputMaybe<Array<AccountActivityWhereInput>>;
  OR?: InputMaybe<Array<AccountActivityWhereInput>>;
  account?: InputMaybe<AccountRelationFilter>;
  accountId?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntFilter>;
};

export type AccountActivityWhereUniqueInput = {
  AND?: InputMaybe<Array<AccountActivityWhereInput>>;
  NOT?: InputMaybe<Array<AccountActivityWhereInput>>;
  OR?: InputMaybe<Array<AccountActivityWhereInput>>;
  account?: InputMaybe<AccountRelationFilter>;
  accountId?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type AccountAvgAggregateOutputType = {
  __typename?: 'AccountAvgAggregateOutputType';
  addressId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

export type AccountAvgOrderByAggregateInput = {
  addressId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export type AccountCountAggregateOutputType = {
  __typename?: 'AccountCountAggregateOutputType';
  _all: Scalars['Int']['output'];
  activated: Scalars['Int']['output'];
  activeCampaignContactId: Scalars['Int']['output'];
  addressId: Scalars['Int']['output'];
  applicationReminderSent: Scalars['Int']['output'];
  birthday: Scalars['Int']['output'];
  connectedAt: Scalars['Int']['output'];
  contactPreferences: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  deleted: Scalars['Int']['output'];
  draftApplicationReminderSent: Scalars['Int']['output'];
  email: Scalars['Int']['output'];
  facebookId: Scalars['Int']['output'];
  firebaseId: Scalars['Int']['output'];
  firebaseToken: Scalars['Int']['output'];
  firstName: Scalars['Int']['output'];
  freeApplicationsDateLimit: Scalars['Int']['output'];
  gender: Scalars['Int']['output'];
  googleId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  language: Scalars['Int']['output'];
  lastName: Scalars['Int']['output'];
  mailjetId: Scalars['Int']['output'];
  name: Scalars['Int']['output'];
  password: Scalars['Int']['output'];
  payLaterReminderSent: Scalars['Int']['output'];
  phone: Scalars['Int']['output'];
  registrationToken: Scalars['Int']['output'];
  role: Scalars['Int']['output'];
  stripeCustomerId: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type AccountCountOrderByAggregateInput = {
  activated?: InputMaybe<SortOrder>;
  activeCampaignContactId?: InputMaybe<SortOrder>;
  addressId?: InputMaybe<SortOrder>;
  applicationReminderSent?: InputMaybe<SortOrder>;
  birthday?: InputMaybe<SortOrder>;
  connectedAt?: InputMaybe<SortOrder>;
  contactPreferences?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  deleted?: InputMaybe<SortOrder>;
  draftApplicationReminderSent?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  facebookId?: InputMaybe<SortOrder>;
  firebaseId?: InputMaybe<SortOrder>;
  firebaseToken?: InputMaybe<SortOrder>;
  firstName?: InputMaybe<SortOrder>;
  freeApplicationsDateLimit?: InputMaybe<SortOrder>;
  gender?: InputMaybe<SortOrder>;
  googleId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  language?: InputMaybe<SortOrder>;
  lastName?: InputMaybe<SortOrder>;
  mailjetId?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  password?: InputMaybe<SortOrder>;
  payLaterReminderSent?: InputMaybe<SortOrder>;
  phone?: InputMaybe<SortOrder>;
  registrationToken?: InputMaybe<SortOrder>;
  role?: InputMaybe<SortOrder>;
  stripeCustomerId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type AccountCountOutputType = {
  __typename?: 'AccountCountOutputType';
  EducatorReviews: Scalars['Int']['output'];
  activityLogs: Scalars['Int']['output'];
  adminNotes: Scalars['Int']['output'];
  animals: Scalars['Int']['output'];
  applications: Scalars['Int']['output'];
  bookings: Scalars['Int']['output'];
  bookmarks: Scalars['Int']['output'];
  dogBreederReview: Scalars['Int']['output'];
  emailHistory: Scalars['Int']['output'];
  firstAccountConversations: Scalars['Int']['output'];
  imgs: Scalars['Int']['output'];
  notifications: Scalars['Int']['output'];
  payments: Scalars['Int']['output'];
  receivedMessages: Scalars['Int']['output'];
  secondAccountConversations: Scalars['Int']['output'];
  sentMessages: Scalars['Int']['output'];
  updates: Scalars['Int']['output'];
};

export type AccountCreateInput = {
  EducatorReviews?: InputMaybe<EducatorReviewCreateNestedManyWithoutAccountInput>;
  activated?: InputMaybe<Scalars['Boolean']['input']>;
  activeCampaignContactId?: InputMaybe<Scalars['String']['input']>;
  activityLogs?: InputMaybe<AccountActivityCreateNestedManyWithoutAccountInput>;
  address?: InputMaybe<AddressCreateNestedOneWithoutAccountInput>;
  adminNotes?: InputMaybe<AdminNoteCreateNestedManyWithoutAccountInput>;
  animals?: InputMaybe<AnimalCreateNestedManyWithoutOwnerInput>;
  applicationReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  applications?: InputMaybe<DogBreederApplicationCreateNestedManyWithoutAccountInput>;
  birthday?: InputMaybe<Scalars['DateTime']['input']>;
  bookings?: InputMaybe<BookingCreateNestedManyWithoutAccountInput>;
  bookmarks?: InputMaybe<BookmarkCreateNestedManyWithoutAccountInput>;
  connectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  contactPreferences?: InputMaybe<Array<ContactPreference>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdFrom?: InputMaybe<AccountCreatedFromEnum>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  dogBreeder?: InputMaybe<DogBreederCreateNestedOneWithoutAccountInput>;
  dogBreederReview?: InputMaybe<DogBreederReviewCreateNestedManyWithoutAccountInput>;
  draftApplicationReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  email: Scalars['String']['input'];
  emailContact?: InputMaybe<EmailContactCreateNestedOneWithoutAccountInput>;
  emailHistory?: InputMaybe<EmailHistoryCreateNestedManyWithoutAccountInput>;
  facebookId?: InputMaybe<Scalars['String']['input']>;
  facebookToken?: InputMaybe<Scalars['String']['input']>;
  firebaseId?: InputMaybe<Scalars['String']['input']>;
  firebaseToken?: InputMaybe<Scalars['String']['input']>;
  firstAccountConversations?: InputMaybe<ConversationCreateNestedManyWithoutFirstAccountInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  freeApplicationsDateLimit?: InputMaybe<Scalars['DateTime']['input']>;
  gender?: InputMaybe<GenderEnum>;
  googleId?: InputMaybe<Scalars['String']['input']>;
  googleToken?: InputMaybe<Scalars['String']['input']>;
  hasADog?: InputMaybe<Scalars['Boolean']['input']>;
  imgs?: InputMaybe<AccountImgCreateNestedManyWithoutAccountInput>;
  language: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  mailjetId?: InputMaybe<Scalars['String']['input']>;
  marketingEmailConsent?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutAccountInput>;
  otherCountry?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  payLaterReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  payments?: InputMaybe<PaymentCreateNestedManyWithoutAccountInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  receivedMessages?: InputMaybe<MessageCreateNestedManyWithoutToAccountInput>;
  registrationToken?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Role>;
  secondAccountConversations?: InputMaybe<ConversationCreateNestedManyWithoutSecondAccountInput>;
  sentMessages?: InputMaybe<MessageCreateNestedManyWithoutFromAccountInput>;
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updates?: InputMaybe<UpdateCreateNestedManyWithoutAccountInput>;
};

export type AccountCreateManyInput = {
  activated?: InputMaybe<Scalars['Boolean']['input']>;
  activeCampaignContactId?: InputMaybe<Scalars['String']['input']>;
  addressId?: InputMaybe<Scalars['Int']['input']>;
  applicationReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  birthday?: InputMaybe<Scalars['DateTime']['input']>;
  connectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  contactPreferences?: InputMaybe<Array<ContactPreference>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  draftApplicationReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  email: Scalars['String']['input'];
  facebookId?: InputMaybe<Scalars['String']['input']>;
  firebaseId?: InputMaybe<Scalars['String']['input']>;
  firebaseToken?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  freeApplicationsDateLimit?: InputMaybe<Scalars['DateTime']['input']>;
  gender?: InputMaybe<GenderEnum>;
  googleId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  language: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  mailjetId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  payLaterReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  registrationToken?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Role>;
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AccountCreateNestedOneWithoutActivityLogsInput = {
  connect?: InputMaybe<AccountWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AccountCreateOrConnectWithoutActivityLogsInput>;
  create?: InputMaybe<AccountCreateWithoutActivityLogsInput>;
};

export type AccountCreateNestedOneWithoutAddressInput = {
  connect?: InputMaybe<AccountWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AccountCreateOrConnectWithoutAddressInput>;
  create?: InputMaybe<AccountCreateWithoutAddressInput>;
};

export type AccountCreateNestedOneWithoutAdminNotesInput = {
  connect?: InputMaybe<AccountWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AccountCreateOrConnectWithoutAdminNotesInput>;
  create?: InputMaybe<AccountCreateWithoutAdminNotesInput>;
};

export type AccountCreateNestedOneWithoutAnimalsInput = {
  connect?: InputMaybe<AccountWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AccountCreateOrConnectWithoutAnimalsInput>;
  create?: InputMaybe<AccountCreateWithoutAnimalsInput>;
};

export type AccountCreateNestedOneWithoutApplicationsInput = {
  connect?: InputMaybe<AccountWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AccountCreateOrConnectWithoutApplicationsInput>;
  create?: InputMaybe<AccountCreateWithoutApplicationsInput>;
};

export type AccountCreateNestedOneWithoutBookingsInput = {
  connect?: InputMaybe<AccountWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AccountCreateOrConnectWithoutBookingsInput>;
  create?: InputMaybe<AccountCreateWithoutBookingsInput>;
};

export type AccountCreateNestedOneWithoutBookmarksInput = {
  connect?: InputMaybe<AccountWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AccountCreateOrConnectWithoutBookmarksInput>;
  create?: InputMaybe<AccountCreateWithoutBookmarksInput>;
};

export type AccountCreateNestedOneWithoutDogBreederInput = {
  connect?: InputMaybe<AccountWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AccountCreateOrConnectWithoutDogBreederInput>;
  create?: InputMaybe<AccountCreateWithoutDogBreederInput>;
};

export type AccountCreateNestedOneWithoutDogBreederReviewInput = {
  connect?: InputMaybe<AccountWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AccountCreateOrConnectWithoutDogBreederReviewInput>;
  create?: InputMaybe<AccountCreateWithoutDogBreederReviewInput>;
};

export type AccountCreateNestedOneWithoutEducatorReviewsInput = {
  connect?: InputMaybe<AccountWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AccountCreateOrConnectWithoutEducatorReviewsInput>;
  create?: InputMaybe<AccountCreateWithoutEducatorReviewsInput>;
};

export type AccountCreateNestedOneWithoutEmailContactInput = {
  connect?: InputMaybe<AccountWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AccountCreateOrConnectWithoutEmailContactInput>;
  create?: InputMaybe<AccountCreateWithoutEmailContactInput>;
};

export type AccountCreateNestedOneWithoutEmailHistoryInput = {
  connect?: InputMaybe<AccountWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AccountCreateOrConnectWithoutEmailHistoryInput>;
  create?: InputMaybe<AccountCreateWithoutEmailHistoryInput>;
};

export type AccountCreateNestedOneWithoutFirstAccountConversationsInput = {
  connect?: InputMaybe<AccountWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AccountCreateOrConnectWithoutFirstAccountConversationsInput>;
  create?: InputMaybe<AccountCreateWithoutFirstAccountConversationsInput>;
};

export type AccountCreateNestedOneWithoutImgsInput = {
  connect?: InputMaybe<AccountWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AccountCreateOrConnectWithoutImgsInput>;
  create?: InputMaybe<AccountCreateWithoutImgsInput>;
};

export type AccountCreateNestedOneWithoutNotificationsInput = {
  connect?: InputMaybe<AccountWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AccountCreateOrConnectWithoutNotificationsInput>;
  create?: InputMaybe<AccountCreateWithoutNotificationsInput>;
};

export type AccountCreateNestedOneWithoutPaymentsInput = {
  connect?: InputMaybe<AccountWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AccountCreateOrConnectWithoutPaymentsInput>;
  create?: InputMaybe<AccountCreateWithoutPaymentsInput>;
};

export type AccountCreateNestedOneWithoutReceivedMessagesInput = {
  connect?: InputMaybe<AccountWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AccountCreateOrConnectWithoutReceivedMessagesInput>;
  create?: InputMaybe<AccountCreateWithoutReceivedMessagesInput>;
};

export type AccountCreateNestedOneWithoutSecondAccountConversationsInput = {
  connect?: InputMaybe<AccountWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AccountCreateOrConnectWithoutSecondAccountConversationsInput>;
  create?: InputMaybe<AccountCreateWithoutSecondAccountConversationsInput>;
};

export type AccountCreateNestedOneWithoutSentMessagesInput = {
  connect?: InputMaybe<AccountWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AccountCreateOrConnectWithoutSentMessagesInput>;
  create?: InputMaybe<AccountCreateWithoutSentMessagesInput>;
};

export type AccountCreateNestedOneWithoutUpdatesInput = {
  connect?: InputMaybe<AccountWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AccountCreateOrConnectWithoutUpdatesInput>;
  create?: InputMaybe<AccountCreateWithoutUpdatesInput>;
};

export type AccountCreateOrConnectWithoutActivityLogsInput = {
  create: AccountCreateWithoutActivityLogsInput;
  where: AccountWhereUniqueInput;
};

export type AccountCreateOrConnectWithoutAddressInput = {
  create: AccountCreateWithoutAddressInput;
  where: AccountWhereUniqueInput;
};

export type AccountCreateOrConnectWithoutAdminNotesInput = {
  create: AccountCreateWithoutAdminNotesInput;
  where: AccountWhereUniqueInput;
};

export type AccountCreateOrConnectWithoutAnimalsInput = {
  create: AccountCreateWithoutAnimalsInput;
  where: AccountWhereUniqueInput;
};

export type AccountCreateOrConnectWithoutApplicationsInput = {
  create: AccountCreateWithoutApplicationsInput;
  where: AccountWhereUniqueInput;
};

export type AccountCreateOrConnectWithoutBookingsInput = {
  create: AccountCreateWithoutBookingsInput;
  where: AccountWhereUniqueInput;
};

export type AccountCreateOrConnectWithoutBookmarksInput = {
  create: AccountCreateWithoutBookmarksInput;
  where: AccountWhereUniqueInput;
};

export type AccountCreateOrConnectWithoutDogBreederInput = {
  create: AccountCreateWithoutDogBreederInput;
  where: AccountWhereUniqueInput;
};

export type AccountCreateOrConnectWithoutDogBreederReviewInput = {
  create: AccountCreateWithoutDogBreederReviewInput;
  where: AccountWhereUniqueInput;
};

export type AccountCreateOrConnectWithoutEducatorReviewsInput = {
  create: AccountCreateWithoutEducatorReviewsInput;
  where: AccountWhereUniqueInput;
};

export type AccountCreateOrConnectWithoutEmailContactInput = {
  create: AccountCreateWithoutEmailContactInput;
  where: AccountWhereUniqueInput;
};

export type AccountCreateOrConnectWithoutEmailHistoryInput = {
  create: AccountCreateWithoutEmailHistoryInput;
  where: AccountWhereUniqueInput;
};

export type AccountCreateOrConnectWithoutFirstAccountConversationsInput = {
  create: AccountCreateWithoutFirstAccountConversationsInput;
  where: AccountWhereUniqueInput;
};

export type AccountCreateOrConnectWithoutImgsInput = {
  create: AccountCreateWithoutImgsInput;
  where: AccountWhereUniqueInput;
};

export type AccountCreateOrConnectWithoutNotificationsInput = {
  create: AccountCreateWithoutNotificationsInput;
  where: AccountWhereUniqueInput;
};

export type AccountCreateOrConnectWithoutPaymentsInput = {
  create: AccountCreateWithoutPaymentsInput;
  where: AccountWhereUniqueInput;
};

export type AccountCreateOrConnectWithoutReceivedMessagesInput = {
  create: AccountCreateWithoutReceivedMessagesInput;
  where: AccountWhereUniqueInput;
};

export type AccountCreateOrConnectWithoutSecondAccountConversationsInput = {
  create: AccountCreateWithoutSecondAccountConversationsInput;
  where: AccountWhereUniqueInput;
};

export type AccountCreateOrConnectWithoutSentMessagesInput = {
  create: AccountCreateWithoutSentMessagesInput;
  where: AccountWhereUniqueInput;
};

export type AccountCreateOrConnectWithoutUpdatesInput = {
  create: AccountCreateWithoutUpdatesInput;
  where: AccountWhereUniqueInput;
};

export type AccountCreateWithoutActivityLogsInput = {
  EducatorReviews?: InputMaybe<EducatorReviewCreateNestedManyWithoutAccountInput>;
  activated?: InputMaybe<Scalars['Boolean']['input']>;
  activeCampaignContactId?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<AddressCreateNestedOneWithoutAccountInput>;
  adminNotes?: InputMaybe<AdminNoteCreateNestedManyWithoutAccountInput>;
  animals?: InputMaybe<AnimalCreateNestedManyWithoutOwnerInput>;
  applicationReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  applications?: InputMaybe<DogBreederApplicationCreateNestedManyWithoutAccountInput>;
  birthday?: InputMaybe<Scalars['DateTime']['input']>;
  bookings?: InputMaybe<BookingCreateNestedManyWithoutAccountInput>;
  bookmarks?: InputMaybe<BookmarkCreateNestedManyWithoutAccountInput>;
  connectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  contactPreferences?: InputMaybe<Array<ContactPreference>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  dogBreeder?: InputMaybe<DogBreederCreateNestedOneWithoutAccountInput>;
  dogBreederReview?: InputMaybe<DogBreederReviewCreateNestedManyWithoutAccountInput>;
  draftApplicationReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  email: Scalars['String']['input'];
  emailContact?: InputMaybe<EmailContactCreateNestedOneWithoutAccountInput>;
  emailHistory?: InputMaybe<EmailHistoryCreateNestedManyWithoutAccountInput>;
  facebookId?: InputMaybe<Scalars['String']['input']>;
  firebaseId?: InputMaybe<Scalars['String']['input']>;
  firebaseToken?: InputMaybe<Scalars['String']['input']>;
  firstAccountConversations?: InputMaybe<ConversationCreateNestedManyWithoutFirstAccountInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  freeApplicationsDateLimit?: InputMaybe<Scalars['DateTime']['input']>;
  gender?: InputMaybe<GenderEnum>;
  googleId?: InputMaybe<Scalars['String']['input']>;
  imgs?: InputMaybe<AccountImgCreateNestedManyWithoutAccountInput>;
  language: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  mailjetId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutAccountInput>;
  password?: InputMaybe<Scalars['String']['input']>;
  payLaterReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  payments?: InputMaybe<PaymentCreateNestedManyWithoutAccountInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  receivedMessages?: InputMaybe<MessageCreateNestedManyWithoutToAccountInput>;
  registrationToken?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Role>;
  secondAccountConversations?: InputMaybe<ConversationCreateNestedManyWithoutSecondAccountInput>;
  sentMessages?: InputMaybe<MessageCreateNestedManyWithoutFromAccountInput>;
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updates?: InputMaybe<UpdateCreateNestedManyWithoutAccountInput>;
};

export type AccountCreateWithoutAddressInput = {
  EducatorReviews?: InputMaybe<EducatorReviewCreateNestedManyWithoutAccountInput>;
  activated?: InputMaybe<Scalars['Boolean']['input']>;
  activeCampaignContactId?: InputMaybe<Scalars['String']['input']>;
  activityLogs?: InputMaybe<AccountActivityCreateNestedManyWithoutAccountInput>;
  adminNotes?: InputMaybe<AdminNoteCreateNestedManyWithoutAccountInput>;
  animals?: InputMaybe<AnimalCreateNestedManyWithoutOwnerInput>;
  applicationReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  applications?: InputMaybe<DogBreederApplicationCreateNestedManyWithoutAccountInput>;
  birthday?: InputMaybe<Scalars['DateTime']['input']>;
  bookings?: InputMaybe<BookingCreateNestedManyWithoutAccountInput>;
  bookmarks?: InputMaybe<BookmarkCreateNestedManyWithoutAccountInput>;
  connectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  contactPreferences?: InputMaybe<Array<ContactPreference>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  dogBreeder?: InputMaybe<DogBreederCreateNestedOneWithoutAccountInput>;
  dogBreederReview?: InputMaybe<DogBreederReviewCreateNestedManyWithoutAccountInput>;
  draftApplicationReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  email: Scalars['String']['input'];
  emailContact?: InputMaybe<EmailContactCreateNestedOneWithoutAccountInput>;
  emailHistory?: InputMaybe<EmailHistoryCreateNestedManyWithoutAccountInput>;
  facebookId?: InputMaybe<Scalars['String']['input']>;
  firebaseId?: InputMaybe<Scalars['String']['input']>;
  firebaseToken?: InputMaybe<Scalars['String']['input']>;
  firstAccountConversations?: InputMaybe<ConversationCreateNestedManyWithoutFirstAccountInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  freeApplicationsDateLimit?: InputMaybe<Scalars['DateTime']['input']>;
  gender?: InputMaybe<GenderEnum>;
  googleId?: InputMaybe<Scalars['String']['input']>;
  imgs?: InputMaybe<AccountImgCreateNestedManyWithoutAccountInput>;
  language: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  mailjetId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutAccountInput>;
  password?: InputMaybe<Scalars['String']['input']>;
  payLaterReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  payments?: InputMaybe<PaymentCreateNestedManyWithoutAccountInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  receivedMessages?: InputMaybe<MessageCreateNestedManyWithoutToAccountInput>;
  registrationToken?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Role>;
  secondAccountConversations?: InputMaybe<ConversationCreateNestedManyWithoutSecondAccountInput>;
  sentMessages?: InputMaybe<MessageCreateNestedManyWithoutFromAccountInput>;
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updates?: InputMaybe<UpdateCreateNestedManyWithoutAccountInput>;
};

export type AccountCreateWithoutAdminNotesInput = {
  EducatorReviews?: InputMaybe<EducatorReviewCreateNestedManyWithoutAccountInput>;
  activated?: InputMaybe<Scalars['Boolean']['input']>;
  activeCampaignContactId?: InputMaybe<Scalars['String']['input']>;
  activityLogs?: InputMaybe<AccountActivityCreateNestedManyWithoutAccountInput>;
  address?: InputMaybe<AddressCreateNestedOneWithoutAccountInput>;
  animals?: InputMaybe<AnimalCreateNestedManyWithoutOwnerInput>;
  applicationReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  applications?: InputMaybe<DogBreederApplicationCreateNestedManyWithoutAccountInput>;
  birthday?: InputMaybe<Scalars['DateTime']['input']>;
  bookings?: InputMaybe<BookingCreateNestedManyWithoutAccountInput>;
  bookmarks?: InputMaybe<BookmarkCreateNestedManyWithoutAccountInput>;
  connectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  contactPreferences?: InputMaybe<Array<ContactPreference>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  dogBreeder?: InputMaybe<DogBreederCreateNestedOneWithoutAccountInput>;
  dogBreederReview?: InputMaybe<DogBreederReviewCreateNestedManyWithoutAccountInput>;
  draftApplicationReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  email: Scalars['String']['input'];
  emailContact?: InputMaybe<EmailContactCreateNestedOneWithoutAccountInput>;
  emailHistory?: InputMaybe<EmailHistoryCreateNestedManyWithoutAccountInput>;
  facebookId?: InputMaybe<Scalars['String']['input']>;
  firebaseId?: InputMaybe<Scalars['String']['input']>;
  firebaseToken?: InputMaybe<Scalars['String']['input']>;
  firstAccountConversations?: InputMaybe<ConversationCreateNestedManyWithoutFirstAccountInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  freeApplicationsDateLimit?: InputMaybe<Scalars['DateTime']['input']>;
  gender?: InputMaybe<GenderEnum>;
  googleId?: InputMaybe<Scalars['String']['input']>;
  imgs?: InputMaybe<AccountImgCreateNestedManyWithoutAccountInput>;
  language: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  mailjetId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutAccountInput>;
  password?: InputMaybe<Scalars['String']['input']>;
  payLaterReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  payments?: InputMaybe<PaymentCreateNestedManyWithoutAccountInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  receivedMessages?: InputMaybe<MessageCreateNestedManyWithoutToAccountInput>;
  registrationToken?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Role>;
  secondAccountConversations?: InputMaybe<ConversationCreateNestedManyWithoutSecondAccountInput>;
  sentMessages?: InputMaybe<MessageCreateNestedManyWithoutFromAccountInput>;
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updates?: InputMaybe<UpdateCreateNestedManyWithoutAccountInput>;
};

export type AccountCreateWithoutAnimalsInput = {
  EducatorReviews?: InputMaybe<EducatorReviewCreateNestedManyWithoutAccountInput>;
  activated?: InputMaybe<Scalars['Boolean']['input']>;
  activeCampaignContactId?: InputMaybe<Scalars['String']['input']>;
  activityLogs?: InputMaybe<AccountActivityCreateNestedManyWithoutAccountInput>;
  address?: InputMaybe<AddressCreateNestedOneWithoutAccountInput>;
  adminNotes?: InputMaybe<AdminNoteCreateNestedManyWithoutAccountInput>;
  applicationReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  applications?: InputMaybe<DogBreederApplicationCreateNestedManyWithoutAccountInput>;
  birthday?: InputMaybe<Scalars['DateTime']['input']>;
  bookings?: InputMaybe<BookingCreateNestedManyWithoutAccountInput>;
  bookmarks?: InputMaybe<BookmarkCreateNestedManyWithoutAccountInput>;
  connectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  contactPreferences?: InputMaybe<Array<ContactPreference>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  dogBreeder?: InputMaybe<DogBreederCreateNestedOneWithoutAccountInput>;
  dogBreederReview?: InputMaybe<DogBreederReviewCreateNestedManyWithoutAccountInput>;
  draftApplicationReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  email: Scalars['String']['input'];
  emailContact?: InputMaybe<EmailContactCreateNestedOneWithoutAccountInput>;
  emailHistory?: InputMaybe<EmailHistoryCreateNestedManyWithoutAccountInput>;
  facebookId?: InputMaybe<Scalars['String']['input']>;
  firebaseId?: InputMaybe<Scalars['String']['input']>;
  firebaseToken?: InputMaybe<Scalars['String']['input']>;
  firstAccountConversations?: InputMaybe<ConversationCreateNestedManyWithoutFirstAccountInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  freeApplicationsDateLimit?: InputMaybe<Scalars['DateTime']['input']>;
  gender?: InputMaybe<GenderEnum>;
  googleId?: InputMaybe<Scalars['String']['input']>;
  imgs?: InputMaybe<AccountImgCreateNestedManyWithoutAccountInput>;
  language: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  mailjetId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutAccountInput>;
  password?: InputMaybe<Scalars['String']['input']>;
  payLaterReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  payments?: InputMaybe<PaymentCreateNestedManyWithoutAccountInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  receivedMessages?: InputMaybe<MessageCreateNestedManyWithoutToAccountInput>;
  registrationToken?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Role>;
  secondAccountConversations?: InputMaybe<ConversationCreateNestedManyWithoutSecondAccountInput>;
  sentMessages?: InputMaybe<MessageCreateNestedManyWithoutFromAccountInput>;
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updates?: InputMaybe<UpdateCreateNestedManyWithoutAccountInput>;
};

export type AccountCreateWithoutApplicationsInput = {
  EducatorReviews?: InputMaybe<EducatorReviewCreateNestedManyWithoutAccountInput>;
  activated?: InputMaybe<Scalars['Boolean']['input']>;
  activeCampaignContactId?: InputMaybe<Scalars['String']['input']>;
  activityLogs?: InputMaybe<AccountActivityCreateNestedManyWithoutAccountInput>;
  address?: InputMaybe<AddressCreateNestedOneWithoutAccountInput>;
  adminNotes?: InputMaybe<AdminNoteCreateNestedManyWithoutAccountInput>;
  animals?: InputMaybe<AnimalCreateNestedManyWithoutOwnerInput>;
  applicationReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  birthday?: InputMaybe<Scalars['DateTime']['input']>;
  bookings?: InputMaybe<BookingCreateNestedManyWithoutAccountInput>;
  bookmarks?: InputMaybe<BookmarkCreateNestedManyWithoutAccountInput>;
  connectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  contactPreferences?: InputMaybe<Array<ContactPreference>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  dogBreeder?: InputMaybe<DogBreederCreateNestedOneWithoutAccountInput>;
  dogBreederReview?: InputMaybe<DogBreederReviewCreateNestedManyWithoutAccountInput>;
  draftApplicationReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  email: Scalars['String']['input'];
  emailContact?: InputMaybe<EmailContactCreateNestedOneWithoutAccountInput>;
  emailHistory?: InputMaybe<EmailHistoryCreateNestedManyWithoutAccountInput>;
  facebookId?: InputMaybe<Scalars['String']['input']>;
  firebaseId?: InputMaybe<Scalars['String']['input']>;
  firebaseToken?: InputMaybe<Scalars['String']['input']>;
  firstAccountConversations?: InputMaybe<ConversationCreateNestedManyWithoutFirstAccountInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  freeApplicationsDateLimit?: InputMaybe<Scalars['DateTime']['input']>;
  gender?: InputMaybe<GenderEnum>;
  googleId?: InputMaybe<Scalars['String']['input']>;
  imgs?: InputMaybe<AccountImgCreateNestedManyWithoutAccountInput>;
  language: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  mailjetId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutAccountInput>;
  password?: InputMaybe<Scalars['String']['input']>;
  payLaterReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  payments?: InputMaybe<PaymentCreateNestedManyWithoutAccountInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  receivedMessages?: InputMaybe<MessageCreateNestedManyWithoutToAccountInput>;
  registrationToken?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Role>;
  secondAccountConversations?: InputMaybe<ConversationCreateNestedManyWithoutSecondAccountInput>;
  sentMessages?: InputMaybe<MessageCreateNestedManyWithoutFromAccountInput>;
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updates?: InputMaybe<UpdateCreateNestedManyWithoutAccountInput>;
};

export type AccountCreateWithoutBookingsInput = {
  EducatorReviews?: InputMaybe<EducatorReviewCreateNestedManyWithoutAccountInput>;
  activated?: InputMaybe<Scalars['Boolean']['input']>;
  activeCampaignContactId?: InputMaybe<Scalars['String']['input']>;
  activityLogs?: InputMaybe<AccountActivityCreateNestedManyWithoutAccountInput>;
  address?: InputMaybe<AddressCreateNestedOneWithoutAccountInput>;
  adminNotes?: InputMaybe<AdminNoteCreateNestedManyWithoutAccountInput>;
  animals?: InputMaybe<AnimalCreateNestedManyWithoutOwnerInput>;
  applicationReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  applications?: InputMaybe<DogBreederApplicationCreateNestedManyWithoutAccountInput>;
  birthday?: InputMaybe<Scalars['DateTime']['input']>;
  bookmarks?: InputMaybe<BookmarkCreateNestedManyWithoutAccountInput>;
  connectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  contactPreferences?: InputMaybe<Array<ContactPreference>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  dogBreeder?: InputMaybe<DogBreederCreateNestedOneWithoutAccountInput>;
  dogBreederReview?: InputMaybe<DogBreederReviewCreateNestedManyWithoutAccountInput>;
  draftApplicationReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  email: Scalars['String']['input'];
  emailContact?: InputMaybe<EmailContactCreateNestedOneWithoutAccountInput>;
  emailHistory?: InputMaybe<EmailHistoryCreateNestedManyWithoutAccountInput>;
  facebookId?: InputMaybe<Scalars['String']['input']>;
  firebaseId?: InputMaybe<Scalars['String']['input']>;
  firebaseToken?: InputMaybe<Scalars['String']['input']>;
  firstAccountConversations?: InputMaybe<ConversationCreateNestedManyWithoutFirstAccountInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  freeApplicationsDateLimit?: InputMaybe<Scalars['DateTime']['input']>;
  gender?: InputMaybe<GenderEnum>;
  googleId?: InputMaybe<Scalars['String']['input']>;
  imgs?: InputMaybe<AccountImgCreateNestedManyWithoutAccountInput>;
  language: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  mailjetId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutAccountInput>;
  password?: InputMaybe<Scalars['String']['input']>;
  payLaterReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  payments?: InputMaybe<PaymentCreateNestedManyWithoutAccountInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  receivedMessages?: InputMaybe<MessageCreateNestedManyWithoutToAccountInput>;
  registrationToken?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Role>;
  secondAccountConversations?: InputMaybe<ConversationCreateNestedManyWithoutSecondAccountInput>;
  sentMessages?: InputMaybe<MessageCreateNestedManyWithoutFromAccountInput>;
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updates?: InputMaybe<UpdateCreateNestedManyWithoutAccountInput>;
};

export type AccountCreateWithoutBookmarksInput = {
  EducatorReviews?: InputMaybe<EducatorReviewCreateNestedManyWithoutAccountInput>;
  activated?: InputMaybe<Scalars['Boolean']['input']>;
  activeCampaignContactId?: InputMaybe<Scalars['String']['input']>;
  activityLogs?: InputMaybe<AccountActivityCreateNestedManyWithoutAccountInput>;
  address?: InputMaybe<AddressCreateNestedOneWithoutAccountInput>;
  adminNotes?: InputMaybe<AdminNoteCreateNestedManyWithoutAccountInput>;
  animals?: InputMaybe<AnimalCreateNestedManyWithoutOwnerInput>;
  applicationReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  applications?: InputMaybe<DogBreederApplicationCreateNestedManyWithoutAccountInput>;
  birthday?: InputMaybe<Scalars['DateTime']['input']>;
  bookings?: InputMaybe<BookingCreateNestedManyWithoutAccountInput>;
  connectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  contactPreferences?: InputMaybe<Array<ContactPreference>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  dogBreeder?: InputMaybe<DogBreederCreateNestedOneWithoutAccountInput>;
  dogBreederReview?: InputMaybe<DogBreederReviewCreateNestedManyWithoutAccountInput>;
  draftApplicationReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  email: Scalars['String']['input'];
  emailContact?: InputMaybe<EmailContactCreateNestedOneWithoutAccountInput>;
  emailHistory?: InputMaybe<EmailHistoryCreateNestedManyWithoutAccountInput>;
  facebookId?: InputMaybe<Scalars['String']['input']>;
  firebaseId?: InputMaybe<Scalars['String']['input']>;
  firebaseToken?: InputMaybe<Scalars['String']['input']>;
  firstAccountConversations?: InputMaybe<ConversationCreateNestedManyWithoutFirstAccountInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  freeApplicationsDateLimit?: InputMaybe<Scalars['DateTime']['input']>;
  gender?: InputMaybe<GenderEnum>;
  googleId?: InputMaybe<Scalars['String']['input']>;
  imgs?: InputMaybe<AccountImgCreateNestedManyWithoutAccountInput>;
  language: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  mailjetId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutAccountInput>;
  password?: InputMaybe<Scalars['String']['input']>;
  payLaterReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  payments?: InputMaybe<PaymentCreateNestedManyWithoutAccountInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  receivedMessages?: InputMaybe<MessageCreateNestedManyWithoutToAccountInput>;
  registrationToken?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Role>;
  secondAccountConversations?: InputMaybe<ConversationCreateNestedManyWithoutSecondAccountInput>;
  sentMessages?: InputMaybe<MessageCreateNestedManyWithoutFromAccountInput>;
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updates?: InputMaybe<UpdateCreateNestedManyWithoutAccountInput>;
};

export type AccountCreateWithoutDogBreederInput = {
  EducatorReviews?: InputMaybe<EducatorReviewCreateNestedManyWithoutAccountInput>;
  activated?: InputMaybe<Scalars['Boolean']['input']>;
  activeCampaignContactId?: InputMaybe<Scalars['String']['input']>;
  activityLogs?: InputMaybe<AccountActivityCreateNestedManyWithoutAccountInput>;
  address?: InputMaybe<AddressCreateNestedOneWithoutAccountInput>;
  adminNotes?: InputMaybe<AdminNoteCreateNestedManyWithoutAccountInput>;
  animals?: InputMaybe<AnimalCreateNestedManyWithoutOwnerInput>;
  applicationReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  applications?: InputMaybe<DogBreederApplicationCreateNestedManyWithoutAccountInput>;
  birthday?: InputMaybe<Scalars['DateTime']['input']>;
  bookings?: InputMaybe<BookingCreateNestedManyWithoutAccountInput>;
  bookmarks?: InputMaybe<BookmarkCreateNestedManyWithoutAccountInput>;
  connectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  contactPreferences?: InputMaybe<Array<ContactPreference>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  dogBreederReview?: InputMaybe<DogBreederReviewCreateNestedManyWithoutAccountInput>;
  draftApplicationReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  email: Scalars['String']['input'];
  emailContact?: InputMaybe<EmailContactCreateNestedOneWithoutAccountInput>;
  emailHistory?: InputMaybe<EmailHistoryCreateNestedManyWithoutAccountInput>;
  facebookId?: InputMaybe<Scalars['String']['input']>;
  firebaseId?: InputMaybe<Scalars['String']['input']>;
  firebaseToken?: InputMaybe<Scalars['String']['input']>;
  firstAccountConversations?: InputMaybe<ConversationCreateNestedManyWithoutFirstAccountInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  freeApplicationsDateLimit?: InputMaybe<Scalars['DateTime']['input']>;
  gender?: InputMaybe<GenderEnum>;
  googleId?: InputMaybe<Scalars['String']['input']>;
  imgs?: InputMaybe<AccountImgCreateNestedManyWithoutAccountInput>;
  language: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  mailjetId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutAccountInput>;
  password?: InputMaybe<Scalars['String']['input']>;
  payLaterReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  payments?: InputMaybe<PaymentCreateNestedManyWithoutAccountInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  receivedMessages?: InputMaybe<MessageCreateNestedManyWithoutToAccountInput>;
  registrationToken?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Role>;
  secondAccountConversations?: InputMaybe<ConversationCreateNestedManyWithoutSecondAccountInput>;
  sentMessages?: InputMaybe<MessageCreateNestedManyWithoutFromAccountInput>;
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updates?: InputMaybe<UpdateCreateNestedManyWithoutAccountInput>;
};

export type AccountCreateWithoutDogBreederReviewInput = {
  EducatorReviews?: InputMaybe<EducatorReviewCreateNestedManyWithoutAccountInput>;
  activated?: InputMaybe<Scalars['Boolean']['input']>;
  activeCampaignContactId?: InputMaybe<Scalars['String']['input']>;
  activityLogs?: InputMaybe<AccountActivityCreateNestedManyWithoutAccountInput>;
  address?: InputMaybe<AddressCreateNestedOneWithoutAccountInput>;
  adminNotes?: InputMaybe<AdminNoteCreateNestedManyWithoutAccountInput>;
  animals?: InputMaybe<AnimalCreateNestedManyWithoutOwnerInput>;
  applicationReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  applications?: InputMaybe<DogBreederApplicationCreateNestedManyWithoutAccountInput>;
  birthday?: InputMaybe<Scalars['DateTime']['input']>;
  bookings?: InputMaybe<BookingCreateNestedManyWithoutAccountInput>;
  bookmarks?: InputMaybe<BookmarkCreateNestedManyWithoutAccountInput>;
  connectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  contactPreferences?: InputMaybe<Array<ContactPreference>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  dogBreeder?: InputMaybe<DogBreederCreateNestedOneWithoutAccountInput>;
  draftApplicationReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  email: Scalars['String']['input'];
  emailContact?: InputMaybe<EmailContactCreateNestedOneWithoutAccountInput>;
  emailHistory?: InputMaybe<EmailHistoryCreateNestedManyWithoutAccountInput>;
  facebookId?: InputMaybe<Scalars['String']['input']>;
  firebaseId?: InputMaybe<Scalars['String']['input']>;
  firebaseToken?: InputMaybe<Scalars['String']['input']>;
  firstAccountConversations?: InputMaybe<ConversationCreateNestedManyWithoutFirstAccountInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  freeApplicationsDateLimit?: InputMaybe<Scalars['DateTime']['input']>;
  gender?: InputMaybe<GenderEnum>;
  googleId?: InputMaybe<Scalars['String']['input']>;
  imgs?: InputMaybe<AccountImgCreateNestedManyWithoutAccountInput>;
  language: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  mailjetId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutAccountInput>;
  password?: InputMaybe<Scalars['String']['input']>;
  payLaterReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  payments?: InputMaybe<PaymentCreateNestedManyWithoutAccountInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  receivedMessages?: InputMaybe<MessageCreateNestedManyWithoutToAccountInput>;
  registrationToken?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Role>;
  secondAccountConversations?: InputMaybe<ConversationCreateNestedManyWithoutSecondAccountInput>;
  sentMessages?: InputMaybe<MessageCreateNestedManyWithoutFromAccountInput>;
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updates?: InputMaybe<UpdateCreateNestedManyWithoutAccountInput>;
};

export type AccountCreateWithoutEducatorReviewsInput = {
  activated?: InputMaybe<Scalars['Boolean']['input']>;
  activeCampaignContactId?: InputMaybe<Scalars['String']['input']>;
  activityLogs?: InputMaybe<AccountActivityCreateNestedManyWithoutAccountInput>;
  address?: InputMaybe<AddressCreateNestedOneWithoutAccountInput>;
  adminNotes?: InputMaybe<AdminNoteCreateNestedManyWithoutAccountInput>;
  animals?: InputMaybe<AnimalCreateNestedManyWithoutOwnerInput>;
  applicationReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  applications?: InputMaybe<DogBreederApplicationCreateNestedManyWithoutAccountInput>;
  birthday?: InputMaybe<Scalars['DateTime']['input']>;
  bookings?: InputMaybe<BookingCreateNestedManyWithoutAccountInput>;
  bookmarks?: InputMaybe<BookmarkCreateNestedManyWithoutAccountInput>;
  connectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  contactPreferences?: InputMaybe<Array<ContactPreference>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  dogBreeder?: InputMaybe<DogBreederCreateNestedOneWithoutAccountInput>;
  dogBreederReview?: InputMaybe<DogBreederReviewCreateNestedManyWithoutAccountInput>;
  draftApplicationReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  email: Scalars['String']['input'];
  emailContact?: InputMaybe<EmailContactCreateNestedOneWithoutAccountInput>;
  emailHistory?: InputMaybe<EmailHistoryCreateNestedManyWithoutAccountInput>;
  facebookId?: InputMaybe<Scalars['String']['input']>;
  firebaseId?: InputMaybe<Scalars['String']['input']>;
  firebaseToken?: InputMaybe<Scalars['String']['input']>;
  firstAccountConversations?: InputMaybe<ConversationCreateNestedManyWithoutFirstAccountInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  freeApplicationsDateLimit?: InputMaybe<Scalars['DateTime']['input']>;
  gender?: InputMaybe<GenderEnum>;
  googleId?: InputMaybe<Scalars['String']['input']>;
  imgs?: InputMaybe<AccountImgCreateNestedManyWithoutAccountInput>;
  language: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  mailjetId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutAccountInput>;
  password?: InputMaybe<Scalars['String']['input']>;
  payLaterReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  payments?: InputMaybe<PaymentCreateNestedManyWithoutAccountInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  receivedMessages?: InputMaybe<MessageCreateNestedManyWithoutToAccountInput>;
  registrationToken?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Role>;
  secondAccountConversations?: InputMaybe<ConversationCreateNestedManyWithoutSecondAccountInput>;
  sentMessages?: InputMaybe<MessageCreateNestedManyWithoutFromAccountInput>;
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updates?: InputMaybe<UpdateCreateNestedManyWithoutAccountInput>;
};

export type AccountCreateWithoutEmailContactInput = {
  EducatorReviews?: InputMaybe<EducatorReviewCreateNestedManyWithoutAccountInput>;
  activated?: InputMaybe<Scalars['Boolean']['input']>;
  activeCampaignContactId?: InputMaybe<Scalars['String']['input']>;
  activityLogs?: InputMaybe<AccountActivityCreateNestedManyWithoutAccountInput>;
  address?: InputMaybe<AddressCreateNestedOneWithoutAccountInput>;
  adminNotes?: InputMaybe<AdminNoteCreateNestedManyWithoutAccountInput>;
  animals?: InputMaybe<AnimalCreateNestedManyWithoutOwnerInput>;
  applicationReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  applications?: InputMaybe<DogBreederApplicationCreateNestedManyWithoutAccountInput>;
  birthday?: InputMaybe<Scalars['DateTime']['input']>;
  bookings?: InputMaybe<BookingCreateNestedManyWithoutAccountInput>;
  bookmarks?: InputMaybe<BookmarkCreateNestedManyWithoutAccountInput>;
  connectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  contactPreferences?: InputMaybe<Array<ContactPreference>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  dogBreeder?: InputMaybe<DogBreederCreateNestedOneWithoutAccountInput>;
  dogBreederReview?: InputMaybe<DogBreederReviewCreateNestedManyWithoutAccountInput>;
  draftApplicationReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  email: Scalars['String']['input'];
  emailHistory?: InputMaybe<EmailHistoryCreateNestedManyWithoutAccountInput>;
  facebookId?: InputMaybe<Scalars['String']['input']>;
  firebaseId?: InputMaybe<Scalars['String']['input']>;
  firebaseToken?: InputMaybe<Scalars['String']['input']>;
  firstAccountConversations?: InputMaybe<ConversationCreateNestedManyWithoutFirstAccountInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  freeApplicationsDateLimit?: InputMaybe<Scalars['DateTime']['input']>;
  gender?: InputMaybe<GenderEnum>;
  googleId?: InputMaybe<Scalars['String']['input']>;
  imgs?: InputMaybe<AccountImgCreateNestedManyWithoutAccountInput>;
  language: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  mailjetId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutAccountInput>;
  password?: InputMaybe<Scalars['String']['input']>;
  payLaterReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  payments?: InputMaybe<PaymentCreateNestedManyWithoutAccountInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  receivedMessages?: InputMaybe<MessageCreateNestedManyWithoutToAccountInput>;
  registrationToken?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Role>;
  secondAccountConversations?: InputMaybe<ConversationCreateNestedManyWithoutSecondAccountInput>;
  sentMessages?: InputMaybe<MessageCreateNestedManyWithoutFromAccountInput>;
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updates?: InputMaybe<UpdateCreateNestedManyWithoutAccountInput>;
};

export type AccountCreateWithoutEmailHistoryInput = {
  EducatorReviews?: InputMaybe<EducatorReviewCreateNestedManyWithoutAccountInput>;
  activated?: InputMaybe<Scalars['Boolean']['input']>;
  activeCampaignContactId?: InputMaybe<Scalars['String']['input']>;
  activityLogs?: InputMaybe<AccountActivityCreateNestedManyWithoutAccountInput>;
  address?: InputMaybe<AddressCreateNestedOneWithoutAccountInput>;
  adminNotes?: InputMaybe<AdminNoteCreateNestedManyWithoutAccountInput>;
  animals?: InputMaybe<AnimalCreateNestedManyWithoutOwnerInput>;
  applicationReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  applications?: InputMaybe<DogBreederApplicationCreateNestedManyWithoutAccountInput>;
  birthday?: InputMaybe<Scalars['DateTime']['input']>;
  bookings?: InputMaybe<BookingCreateNestedManyWithoutAccountInput>;
  bookmarks?: InputMaybe<BookmarkCreateNestedManyWithoutAccountInput>;
  connectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  contactPreferences?: InputMaybe<Array<ContactPreference>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  dogBreeder?: InputMaybe<DogBreederCreateNestedOneWithoutAccountInput>;
  dogBreederReview?: InputMaybe<DogBreederReviewCreateNestedManyWithoutAccountInput>;
  draftApplicationReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  email: Scalars['String']['input'];
  emailContact?: InputMaybe<EmailContactCreateNestedOneWithoutAccountInput>;
  facebookId?: InputMaybe<Scalars['String']['input']>;
  firebaseId?: InputMaybe<Scalars['String']['input']>;
  firebaseToken?: InputMaybe<Scalars['String']['input']>;
  firstAccountConversations?: InputMaybe<ConversationCreateNestedManyWithoutFirstAccountInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  freeApplicationsDateLimit?: InputMaybe<Scalars['DateTime']['input']>;
  gender?: InputMaybe<GenderEnum>;
  googleId?: InputMaybe<Scalars['String']['input']>;
  imgs?: InputMaybe<AccountImgCreateNestedManyWithoutAccountInput>;
  language: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  mailjetId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutAccountInput>;
  password?: InputMaybe<Scalars['String']['input']>;
  payLaterReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  payments?: InputMaybe<PaymentCreateNestedManyWithoutAccountInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  receivedMessages?: InputMaybe<MessageCreateNestedManyWithoutToAccountInput>;
  registrationToken?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Role>;
  secondAccountConversations?: InputMaybe<ConversationCreateNestedManyWithoutSecondAccountInput>;
  sentMessages?: InputMaybe<MessageCreateNestedManyWithoutFromAccountInput>;
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updates?: InputMaybe<UpdateCreateNestedManyWithoutAccountInput>;
};

export type AccountCreateWithoutFirstAccountConversationsInput = {
  EducatorReviews?: InputMaybe<EducatorReviewCreateNestedManyWithoutAccountInput>;
  activated?: InputMaybe<Scalars['Boolean']['input']>;
  activeCampaignContactId?: InputMaybe<Scalars['String']['input']>;
  activityLogs?: InputMaybe<AccountActivityCreateNestedManyWithoutAccountInput>;
  address?: InputMaybe<AddressCreateNestedOneWithoutAccountInput>;
  adminNotes?: InputMaybe<AdminNoteCreateNestedManyWithoutAccountInput>;
  animals?: InputMaybe<AnimalCreateNestedManyWithoutOwnerInput>;
  applicationReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  applications?: InputMaybe<DogBreederApplicationCreateNestedManyWithoutAccountInput>;
  birthday?: InputMaybe<Scalars['DateTime']['input']>;
  bookings?: InputMaybe<BookingCreateNestedManyWithoutAccountInput>;
  bookmarks?: InputMaybe<BookmarkCreateNestedManyWithoutAccountInput>;
  connectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  contactPreferences?: InputMaybe<Array<ContactPreference>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  dogBreeder?: InputMaybe<DogBreederCreateNestedOneWithoutAccountInput>;
  dogBreederReview?: InputMaybe<DogBreederReviewCreateNestedManyWithoutAccountInput>;
  draftApplicationReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  email: Scalars['String']['input'];
  emailContact?: InputMaybe<EmailContactCreateNestedOneWithoutAccountInput>;
  emailHistory?: InputMaybe<EmailHistoryCreateNestedManyWithoutAccountInput>;
  facebookId?: InputMaybe<Scalars['String']['input']>;
  firebaseId?: InputMaybe<Scalars['String']['input']>;
  firebaseToken?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  freeApplicationsDateLimit?: InputMaybe<Scalars['DateTime']['input']>;
  gender?: InputMaybe<GenderEnum>;
  googleId?: InputMaybe<Scalars['String']['input']>;
  imgs?: InputMaybe<AccountImgCreateNestedManyWithoutAccountInput>;
  language: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  mailjetId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutAccountInput>;
  password?: InputMaybe<Scalars['String']['input']>;
  payLaterReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  payments?: InputMaybe<PaymentCreateNestedManyWithoutAccountInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  receivedMessages?: InputMaybe<MessageCreateNestedManyWithoutToAccountInput>;
  registrationToken?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Role>;
  secondAccountConversations?: InputMaybe<ConversationCreateNestedManyWithoutSecondAccountInput>;
  sentMessages?: InputMaybe<MessageCreateNestedManyWithoutFromAccountInput>;
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updates?: InputMaybe<UpdateCreateNestedManyWithoutAccountInput>;
};

export type AccountCreateWithoutImgsInput = {
  EducatorReviews?: InputMaybe<EducatorReviewCreateNestedManyWithoutAccountInput>;
  activated?: InputMaybe<Scalars['Boolean']['input']>;
  activeCampaignContactId?: InputMaybe<Scalars['String']['input']>;
  activityLogs?: InputMaybe<AccountActivityCreateNestedManyWithoutAccountInput>;
  address?: InputMaybe<AddressCreateNestedOneWithoutAccountInput>;
  adminNotes?: InputMaybe<AdminNoteCreateNestedManyWithoutAccountInput>;
  animals?: InputMaybe<AnimalCreateNestedManyWithoutOwnerInput>;
  applicationReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  applications?: InputMaybe<DogBreederApplicationCreateNestedManyWithoutAccountInput>;
  birthday?: InputMaybe<Scalars['DateTime']['input']>;
  bookings?: InputMaybe<BookingCreateNestedManyWithoutAccountInput>;
  bookmarks?: InputMaybe<BookmarkCreateNestedManyWithoutAccountInput>;
  connectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  contactPreferences?: InputMaybe<Array<ContactPreference>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  dogBreeder?: InputMaybe<DogBreederCreateNestedOneWithoutAccountInput>;
  dogBreederReview?: InputMaybe<DogBreederReviewCreateNestedManyWithoutAccountInput>;
  draftApplicationReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  email: Scalars['String']['input'];
  emailContact?: InputMaybe<EmailContactCreateNestedOneWithoutAccountInput>;
  emailHistory?: InputMaybe<EmailHistoryCreateNestedManyWithoutAccountInput>;
  facebookId?: InputMaybe<Scalars['String']['input']>;
  firebaseId?: InputMaybe<Scalars['String']['input']>;
  firebaseToken?: InputMaybe<Scalars['String']['input']>;
  firstAccountConversations?: InputMaybe<ConversationCreateNestedManyWithoutFirstAccountInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  freeApplicationsDateLimit?: InputMaybe<Scalars['DateTime']['input']>;
  gender?: InputMaybe<GenderEnum>;
  googleId?: InputMaybe<Scalars['String']['input']>;
  language: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  mailjetId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutAccountInput>;
  password?: InputMaybe<Scalars['String']['input']>;
  payLaterReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  payments?: InputMaybe<PaymentCreateNestedManyWithoutAccountInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  receivedMessages?: InputMaybe<MessageCreateNestedManyWithoutToAccountInput>;
  registrationToken?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Role>;
  secondAccountConversations?: InputMaybe<ConversationCreateNestedManyWithoutSecondAccountInput>;
  sentMessages?: InputMaybe<MessageCreateNestedManyWithoutFromAccountInput>;
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updates?: InputMaybe<UpdateCreateNestedManyWithoutAccountInput>;
};

export type AccountCreateWithoutNotificationsInput = {
  EducatorReviews?: InputMaybe<EducatorReviewCreateNestedManyWithoutAccountInput>;
  activated?: InputMaybe<Scalars['Boolean']['input']>;
  activeCampaignContactId?: InputMaybe<Scalars['String']['input']>;
  activityLogs?: InputMaybe<AccountActivityCreateNestedManyWithoutAccountInput>;
  address?: InputMaybe<AddressCreateNestedOneWithoutAccountInput>;
  adminNotes?: InputMaybe<AdminNoteCreateNestedManyWithoutAccountInput>;
  animals?: InputMaybe<AnimalCreateNestedManyWithoutOwnerInput>;
  applicationReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  applications?: InputMaybe<DogBreederApplicationCreateNestedManyWithoutAccountInput>;
  birthday?: InputMaybe<Scalars['DateTime']['input']>;
  bookings?: InputMaybe<BookingCreateNestedManyWithoutAccountInput>;
  bookmarks?: InputMaybe<BookmarkCreateNestedManyWithoutAccountInput>;
  connectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  contactPreferences?: InputMaybe<Array<ContactPreference>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  dogBreeder?: InputMaybe<DogBreederCreateNestedOneWithoutAccountInput>;
  dogBreederReview?: InputMaybe<DogBreederReviewCreateNestedManyWithoutAccountInput>;
  draftApplicationReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  email: Scalars['String']['input'];
  emailContact?: InputMaybe<EmailContactCreateNestedOneWithoutAccountInput>;
  emailHistory?: InputMaybe<EmailHistoryCreateNestedManyWithoutAccountInput>;
  facebookId?: InputMaybe<Scalars['String']['input']>;
  firebaseId?: InputMaybe<Scalars['String']['input']>;
  firebaseToken?: InputMaybe<Scalars['String']['input']>;
  firstAccountConversations?: InputMaybe<ConversationCreateNestedManyWithoutFirstAccountInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  freeApplicationsDateLimit?: InputMaybe<Scalars['DateTime']['input']>;
  gender?: InputMaybe<GenderEnum>;
  googleId?: InputMaybe<Scalars['String']['input']>;
  imgs?: InputMaybe<AccountImgCreateNestedManyWithoutAccountInput>;
  language: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  mailjetId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  payLaterReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  payments?: InputMaybe<PaymentCreateNestedManyWithoutAccountInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  receivedMessages?: InputMaybe<MessageCreateNestedManyWithoutToAccountInput>;
  registrationToken?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Role>;
  secondAccountConversations?: InputMaybe<ConversationCreateNestedManyWithoutSecondAccountInput>;
  sentMessages?: InputMaybe<MessageCreateNestedManyWithoutFromAccountInput>;
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updates?: InputMaybe<UpdateCreateNestedManyWithoutAccountInput>;
};

export type AccountCreateWithoutPaymentsInput = {
  EducatorReviews?: InputMaybe<EducatorReviewCreateNestedManyWithoutAccountInput>;
  activated?: InputMaybe<Scalars['Boolean']['input']>;
  activeCampaignContactId?: InputMaybe<Scalars['String']['input']>;
  activityLogs?: InputMaybe<AccountActivityCreateNestedManyWithoutAccountInput>;
  address?: InputMaybe<AddressCreateNestedOneWithoutAccountInput>;
  adminNotes?: InputMaybe<AdminNoteCreateNestedManyWithoutAccountInput>;
  animals?: InputMaybe<AnimalCreateNestedManyWithoutOwnerInput>;
  applicationReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  applications?: InputMaybe<DogBreederApplicationCreateNestedManyWithoutAccountInput>;
  birthday?: InputMaybe<Scalars['DateTime']['input']>;
  bookings?: InputMaybe<BookingCreateNestedManyWithoutAccountInput>;
  bookmarks?: InputMaybe<BookmarkCreateNestedManyWithoutAccountInput>;
  connectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  contactPreferences?: InputMaybe<Array<ContactPreference>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  dogBreeder?: InputMaybe<DogBreederCreateNestedOneWithoutAccountInput>;
  dogBreederReview?: InputMaybe<DogBreederReviewCreateNestedManyWithoutAccountInput>;
  draftApplicationReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  email: Scalars['String']['input'];
  emailContact?: InputMaybe<EmailContactCreateNestedOneWithoutAccountInput>;
  emailHistory?: InputMaybe<EmailHistoryCreateNestedManyWithoutAccountInput>;
  facebookId?: InputMaybe<Scalars['String']['input']>;
  firebaseId?: InputMaybe<Scalars['String']['input']>;
  firebaseToken?: InputMaybe<Scalars['String']['input']>;
  firstAccountConversations?: InputMaybe<ConversationCreateNestedManyWithoutFirstAccountInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  freeApplicationsDateLimit?: InputMaybe<Scalars['DateTime']['input']>;
  gender?: InputMaybe<GenderEnum>;
  googleId?: InputMaybe<Scalars['String']['input']>;
  imgs?: InputMaybe<AccountImgCreateNestedManyWithoutAccountInput>;
  language: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  mailjetId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutAccountInput>;
  password?: InputMaybe<Scalars['String']['input']>;
  payLaterReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  receivedMessages?: InputMaybe<MessageCreateNestedManyWithoutToAccountInput>;
  registrationToken?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Role>;
  secondAccountConversations?: InputMaybe<ConversationCreateNestedManyWithoutSecondAccountInput>;
  sentMessages?: InputMaybe<MessageCreateNestedManyWithoutFromAccountInput>;
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updates?: InputMaybe<UpdateCreateNestedManyWithoutAccountInput>;
};

export type AccountCreateWithoutReceivedMessagesInput = {
  EducatorReviews?: InputMaybe<EducatorReviewCreateNestedManyWithoutAccountInput>;
  activated?: InputMaybe<Scalars['Boolean']['input']>;
  activeCampaignContactId?: InputMaybe<Scalars['String']['input']>;
  activityLogs?: InputMaybe<AccountActivityCreateNestedManyWithoutAccountInput>;
  address?: InputMaybe<AddressCreateNestedOneWithoutAccountInput>;
  adminNotes?: InputMaybe<AdminNoteCreateNestedManyWithoutAccountInput>;
  animals?: InputMaybe<AnimalCreateNestedManyWithoutOwnerInput>;
  applicationReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  applications?: InputMaybe<DogBreederApplicationCreateNestedManyWithoutAccountInput>;
  birthday?: InputMaybe<Scalars['DateTime']['input']>;
  bookings?: InputMaybe<BookingCreateNestedManyWithoutAccountInput>;
  bookmarks?: InputMaybe<BookmarkCreateNestedManyWithoutAccountInput>;
  connectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  contactPreferences?: InputMaybe<Array<ContactPreference>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  dogBreeder?: InputMaybe<DogBreederCreateNestedOneWithoutAccountInput>;
  dogBreederReview?: InputMaybe<DogBreederReviewCreateNestedManyWithoutAccountInput>;
  draftApplicationReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  email: Scalars['String']['input'];
  emailContact?: InputMaybe<EmailContactCreateNestedOneWithoutAccountInput>;
  emailHistory?: InputMaybe<EmailHistoryCreateNestedManyWithoutAccountInput>;
  facebookId?: InputMaybe<Scalars['String']['input']>;
  firebaseId?: InputMaybe<Scalars['String']['input']>;
  firebaseToken?: InputMaybe<Scalars['String']['input']>;
  firstAccountConversations?: InputMaybe<ConversationCreateNestedManyWithoutFirstAccountInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  freeApplicationsDateLimit?: InputMaybe<Scalars['DateTime']['input']>;
  gender?: InputMaybe<GenderEnum>;
  googleId?: InputMaybe<Scalars['String']['input']>;
  imgs?: InputMaybe<AccountImgCreateNestedManyWithoutAccountInput>;
  language: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  mailjetId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutAccountInput>;
  password?: InputMaybe<Scalars['String']['input']>;
  payLaterReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  payments?: InputMaybe<PaymentCreateNestedManyWithoutAccountInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  registrationToken?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Role>;
  secondAccountConversations?: InputMaybe<ConversationCreateNestedManyWithoutSecondAccountInput>;
  sentMessages?: InputMaybe<MessageCreateNestedManyWithoutFromAccountInput>;
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updates?: InputMaybe<UpdateCreateNestedManyWithoutAccountInput>;
};

export type AccountCreateWithoutSecondAccountConversationsInput = {
  EducatorReviews?: InputMaybe<EducatorReviewCreateNestedManyWithoutAccountInput>;
  activated?: InputMaybe<Scalars['Boolean']['input']>;
  activeCampaignContactId?: InputMaybe<Scalars['String']['input']>;
  activityLogs?: InputMaybe<AccountActivityCreateNestedManyWithoutAccountInput>;
  address?: InputMaybe<AddressCreateNestedOneWithoutAccountInput>;
  adminNotes?: InputMaybe<AdminNoteCreateNestedManyWithoutAccountInput>;
  animals?: InputMaybe<AnimalCreateNestedManyWithoutOwnerInput>;
  applicationReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  applications?: InputMaybe<DogBreederApplicationCreateNestedManyWithoutAccountInput>;
  birthday?: InputMaybe<Scalars['DateTime']['input']>;
  bookings?: InputMaybe<BookingCreateNestedManyWithoutAccountInput>;
  bookmarks?: InputMaybe<BookmarkCreateNestedManyWithoutAccountInput>;
  connectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  contactPreferences?: InputMaybe<Array<ContactPreference>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  dogBreeder?: InputMaybe<DogBreederCreateNestedOneWithoutAccountInput>;
  dogBreederReview?: InputMaybe<DogBreederReviewCreateNestedManyWithoutAccountInput>;
  draftApplicationReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  email: Scalars['String']['input'];
  emailContact?: InputMaybe<EmailContactCreateNestedOneWithoutAccountInput>;
  emailHistory?: InputMaybe<EmailHistoryCreateNestedManyWithoutAccountInput>;
  facebookId?: InputMaybe<Scalars['String']['input']>;
  firebaseId?: InputMaybe<Scalars['String']['input']>;
  firebaseToken?: InputMaybe<Scalars['String']['input']>;
  firstAccountConversations?: InputMaybe<ConversationCreateNestedManyWithoutFirstAccountInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  freeApplicationsDateLimit?: InputMaybe<Scalars['DateTime']['input']>;
  gender?: InputMaybe<GenderEnum>;
  googleId?: InputMaybe<Scalars['String']['input']>;
  imgs?: InputMaybe<AccountImgCreateNestedManyWithoutAccountInput>;
  language: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  mailjetId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutAccountInput>;
  password?: InputMaybe<Scalars['String']['input']>;
  payLaterReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  payments?: InputMaybe<PaymentCreateNestedManyWithoutAccountInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  receivedMessages?: InputMaybe<MessageCreateNestedManyWithoutToAccountInput>;
  registrationToken?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Role>;
  sentMessages?: InputMaybe<MessageCreateNestedManyWithoutFromAccountInput>;
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updates?: InputMaybe<UpdateCreateNestedManyWithoutAccountInput>;
};

export type AccountCreateWithoutSentMessagesInput = {
  EducatorReviews?: InputMaybe<EducatorReviewCreateNestedManyWithoutAccountInput>;
  activated?: InputMaybe<Scalars['Boolean']['input']>;
  activeCampaignContactId?: InputMaybe<Scalars['String']['input']>;
  activityLogs?: InputMaybe<AccountActivityCreateNestedManyWithoutAccountInput>;
  address?: InputMaybe<AddressCreateNestedOneWithoutAccountInput>;
  adminNotes?: InputMaybe<AdminNoteCreateNestedManyWithoutAccountInput>;
  animals?: InputMaybe<AnimalCreateNestedManyWithoutOwnerInput>;
  applicationReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  applications?: InputMaybe<DogBreederApplicationCreateNestedManyWithoutAccountInput>;
  birthday?: InputMaybe<Scalars['DateTime']['input']>;
  bookings?: InputMaybe<BookingCreateNestedManyWithoutAccountInput>;
  bookmarks?: InputMaybe<BookmarkCreateNestedManyWithoutAccountInput>;
  connectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  contactPreferences?: InputMaybe<Array<ContactPreference>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  dogBreeder?: InputMaybe<DogBreederCreateNestedOneWithoutAccountInput>;
  dogBreederReview?: InputMaybe<DogBreederReviewCreateNestedManyWithoutAccountInput>;
  draftApplicationReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  email: Scalars['String']['input'];
  emailContact?: InputMaybe<EmailContactCreateNestedOneWithoutAccountInput>;
  emailHistory?: InputMaybe<EmailHistoryCreateNestedManyWithoutAccountInput>;
  facebookId?: InputMaybe<Scalars['String']['input']>;
  firebaseId?: InputMaybe<Scalars['String']['input']>;
  firebaseToken?: InputMaybe<Scalars['String']['input']>;
  firstAccountConversations?: InputMaybe<ConversationCreateNestedManyWithoutFirstAccountInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  freeApplicationsDateLimit?: InputMaybe<Scalars['DateTime']['input']>;
  gender?: InputMaybe<GenderEnum>;
  googleId?: InputMaybe<Scalars['String']['input']>;
  imgs?: InputMaybe<AccountImgCreateNestedManyWithoutAccountInput>;
  language: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  mailjetId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutAccountInput>;
  password?: InputMaybe<Scalars['String']['input']>;
  payLaterReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  payments?: InputMaybe<PaymentCreateNestedManyWithoutAccountInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  receivedMessages?: InputMaybe<MessageCreateNestedManyWithoutToAccountInput>;
  registrationToken?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Role>;
  secondAccountConversations?: InputMaybe<ConversationCreateNestedManyWithoutSecondAccountInput>;
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updates?: InputMaybe<UpdateCreateNestedManyWithoutAccountInput>;
};

export type AccountCreateWithoutUpdatesInput = {
  EducatorReviews?: InputMaybe<EducatorReviewCreateNestedManyWithoutAccountInput>;
  activated?: InputMaybe<Scalars['Boolean']['input']>;
  activeCampaignContactId?: InputMaybe<Scalars['String']['input']>;
  activityLogs?: InputMaybe<AccountActivityCreateNestedManyWithoutAccountInput>;
  address?: InputMaybe<AddressCreateNestedOneWithoutAccountInput>;
  adminNotes?: InputMaybe<AdminNoteCreateNestedManyWithoutAccountInput>;
  animals?: InputMaybe<AnimalCreateNestedManyWithoutOwnerInput>;
  applicationReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  applications?: InputMaybe<DogBreederApplicationCreateNestedManyWithoutAccountInput>;
  birthday?: InputMaybe<Scalars['DateTime']['input']>;
  bookings?: InputMaybe<BookingCreateNestedManyWithoutAccountInput>;
  bookmarks?: InputMaybe<BookmarkCreateNestedManyWithoutAccountInput>;
  connectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  contactPreferences?: InputMaybe<Array<ContactPreference>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  dogBreeder?: InputMaybe<DogBreederCreateNestedOneWithoutAccountInput>;
  dogBreederReview?: InputMaybe<DogBreederReviewCreateNestedManyWithoutAccountInput>;
  draftApplicationReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  email: Scalars['String']['input'];
  emailContact?: InputMaybe<EmailContactCreateNestedOneWithoutAccountInput>;
  emailHistory?: InputMaybe<EmailHistoryCreateNestedManyWithoutAccountInput>;
  facebookId?: InputMaybe<Scalars['String']['input']>;
  firebaseId?: InputMaybe<Scalars['String']['input']>;
  firebaseToken?: InputMaybe<Scalars['String']['input']>;
  firstAccountConversations?: InputMaybe<ConversationCreateNestedManyWithoutFirstAccountInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  freeApplicationsDateLimit?: InputMaybe<Scalars['DateTime']['input']>;
  gender?: InputMaybe<GenderEnum>;
  googleId?: InputMaybe<Scalars['String']['input']>;
  imgs?: InputMaybe<AccountImgCreateNestedManyWithoutAccountInput>;
  language: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  mailjetId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutAccountInput>;
  password?: InputMaybe<Scalars['String']['input']>;
  payLaterReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  payments?: InputMaybe<PaymentCreateNestedManyWithoutAccountInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  receivedMessages?: InputMaybe<MessageCreateNestedManyWithoutToAccountInput>;
  registrationToken?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Role>;
  secondAccountConversations?: InputMaybe<ConversationCreateNestedManyWithoutSecondAccountInput>;
  sentMessages?: InputMaybe<MessageCreateNestedManyWithoutFromAccountInput>;
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AccountCreatecontactPreferencesInput = {
  set: Array<ContactPreference>;
};

export enum AccountCreatedFromEnum {
  APPLICATION = 'APPLICATION',
  BOOKING = 'BOOKING',
  SIGNUP = 'SIGNUP'
}

export type AccountDogBreederImgUploadInput = {
  file: Scalars['Upload']['input'];
  type: Scalars['String']['input'];
};

export type AccountImg = {
  __typename?: 'AccountImg';
  account: Account;
  accountId: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  large?: Maybe<Scalars['String']['output']>;
  medium?: Maybe<Scalars['String']['output']>;
  small?: Maybe<Scalars['String']['output']>;
  type: AccountImgType;
  updatedAt: Scalars['DateTime']['output'];
};

export type AccountImgAvgAggregateOutputType = {
  __typename?: 'AccountImgAvgAggregateOutputType';
  accountId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

export type AccountImgAvgOrderByAggregateInput = {
  accountId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export type AccountImgCountAggregateOutputType = {
  __typename?: 'AccountImgCountAggregateOutputType';
  _all: Scalars['Int']['output'];
  accountId: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  large: Scalars['Int']['output'];
  medium: Scalars['Int']['output'];
  small: Scalars['Int']['output'];
  type: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type AccountImgCountOrderByAggregateInput = {
  accountId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  large?: InputMaybe<SortOrder>;
  medium?: InputMaybe<SortOrder>;
  small?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type AccountImgCreateInput = {
  account: AccountCreateNestedOneWithoutImgsInput;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  large?: InputMaybe<Scalars['String']['input']>;
  medium?: InputMaybe<Scalars['String']['input']>;
  small?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<AccountImgType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AccountImgCreateManyAccountInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  large?: InputMaybe<Scalars['String']['input']>;
  medium?: InputMaybe<Scalars['String']['input']>;
  small?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<AccountImgType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AccountImgCreateManyAccountInputEnvelope = {
  data: Array<AccountImgCreateManyAccountInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AccountImgCreateManyInput = {
  accountId: Scalars['Int']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  large?: InputMaybe<Scalars['String']['input']>;
  medium?: InputMaybe<Scalars['String']['input']>;
  small?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<AccountImgType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AccountImgCreateNestedManyWithoutAccountInput = {
  connect?: InputMaybe<Array<AccountImgWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AccountImgCreateOrConnectWithoutAccountInput>>;
  create?: InputMaybe<Array<AccountImgCreateWithoutAccountInput>>;
  createMany?: InputMaybe<AccountImgCreateManyAccountInputEnvelope>;
};

export type AccountImgCreateOrConnectWithoutAccountInput = {
  create: AccountImgCreateWithoutAccountInput;
  where: AccountImgWhereUniqueInput;
};

export type AccountImgCreateWithoutAccountInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  large?: InputMaybe<Scalars['String']['input']>;
  medium?: InputMaybe<Scalars['String']['input']>;
  small?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<AccountImgType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AccountImgListRelationFilter = {
  every?: InputMaybe<AccountImgWhereInput>;
  none?: InputMaybe<AccountImgWhereInput>;
  some?: InputMaybe<AccountImgWhereInput>;
};

export type AccountImgMaxAggregateOutputType = {
  __typename?: 'AccountImgMaxAggregateOutputType';
  accountId?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  large?: Maybe<Scalars['String']['output']>;
  medium?: Maybe<Scalars['String']['output']>;
  small?: Maybe<Scalars['String']['output']>;
  type?: Maybe<AccountImgType>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type AccountImgMaxOrderByAggregateInput = {
  accountId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  large?: InputMaybe<SortOrder>;
  medium?: InputMaybe<SortOrder>;
  small?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type AccountImgMinAggregateOutputType = {
  __typename?: 'AccountImgMinAggregateOutputType';
  accountId?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  large?: Maybe<Scalars['String']['output']>;
  medium?: Maybe<Scalars['String']['output']>;
  small?: Maybe<Scalars['String']['output']>;
  type?: Maybe<AccountImgType>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type AccountImgMinOrderByAggregateInput = {
  accountId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  large?: InputMaybe<SortOrder>;
  medium?: InputMaybe<SortOrder>;
  small?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type AccountImgOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export enum AccountImgOrderByRelevanceFieldEnum {
  large = 'large',
  medium = 'medium',
  small = 'small'
}

export type AccountImgOrderByRelevanceInput = {
  fields: Array<AccountImgOrderByRelevanceFieldEnum>;
  search: Scalars['String']['input'];
  sort: SortOrder;
};

export type AccountImgOrderByWithAggregationInput = {
  _avg?: InputMaybe<AccountImgAvgOrderByAggregateInput>;
  _count?: InputMaybe<AccountImgCountOrderByAggregateInput>;
  _max?: InputMaybe<AccountImgMaxOrderByAggregateInput>;
  _min?: InputMaybe<AccountImgMinOrderByAggregateInput>;
  _sum?: InputMaybe<AccountImgSumOrderByAggregateInput>;
  accountId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  large?: InputMaybe<SortOrderInput>;
  medium?: InputMaybe<SortOrderInput>;
  small?: InputMaybe<SortOrderInput>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type AccountImgOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: InputMaybe<AccountImgOrderByRelevanceInput>;
  account?: InputMaybe<AccountOrderByWithRelationAndSearchRelevanceInput>;
  accountId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  large?: InputMaybe<SortOrderInput>;
  medium?: InputMaybe<SortOrderInput>;
  small?: InputMaybe<SortOrderInput>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum AccountImgScalarFieldEnum {
  accountId = 'accountId',
  createdAt = 'createdAt',
  id = 'id',
  large = 'large',
  medium = 'medium',
  small = 'small',
  type = 'type',
  updatedAt = 'updatedAt'
}

export type AccountImgScalarWhereInput = {
  AND?: InputMaybe<Array<AccountImgScalarWhereInput>>;
  NOT?: InputMaybe<Array<AccountImgScalarWhereInput>>;
  OR?: InputMaybe<Array<AccountImgScalarWhereInput>>;
  accountId?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntFilter>;
  large?: InputMaybe<StringNullableFilter>;
  medium?: InputMaybe<StringNullableFilter>;
  small?: InputMaybe<StringNullableFilter>;
  type?: InputMaybe<EnumAccountImgTypeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type AccountImgScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<AccountImgScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<AccountImgScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<AccountImgScalarWhereWithAggregatesInput>>;
  accountId?: InputMaybe<IntWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  large?: InputMaybe<StringNullableWithAggregatesFilter>;
  medium?: InputMaybe<StringNullableWithAggregatesFilter>;
  small?: InputMaybe<StringNullableWithAggregatesFilter>;
  type?: InputMaybe<EnumAccountImgTypeWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type AccountImgSumAggregateOutputType = {
  __typename?: 'AccountImgSumAggregateOutputType';
  accountId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
};

export type AccountImgSumOrderByAggregateInput = {
  accountId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export enum AccountImgType {
  PROFILE = 'PROFILE'
}

export type AccountImgUncheckedCreateInput = {
  accountId: Scalars['Int']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  large?: InputMaybe<Scalars['String']['input']>;
  medium?: InputMaybe<Scalars['String']['input']>;
  small?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<AccountImgType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AccountImgUncheckedCreateNestedManyWithoutAccountInput = {
  connect?: InputMaybe<Array<AccountImgWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AccountImgCreateOrConnectWithoutAccountInput>>;
  create?: InputMaybe<Array<AccountImgCreateWithoutAccountInput>>;
  createMany?: InputMaybe<AccountImgCreateManyAccountInputEnvelope>;
};

export type AccountImgUncheckedCreateWithoutAccountInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  large?: InputMaybe<Scalars['String']['input']>;
  medium?: InputMaybe<Scalars['String']['input']>;
  small?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<AccountImgType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AccountImgUncheckedUpdateInput = {
  accountId?: InputMaybe<IntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  large?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  medium?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  small?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumAccountImgTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type AccountImgUncheckedUpdateManyInput = {
  accountId?: InputMaybe<IntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  large?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  medium?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  small?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumAccountImgTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type AccountImgUncheckedUpdateManyWithoutAccountInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  large?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  medium?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  small?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumAccountImgTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type AccountImgUncheckedUpdateManyWithoutAccountNestedInput = {
  connect?: InputMaybe<Array<AccountImgWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AccountImgCreateOrConnectWithoutAccountInput>>;
  create?: InputMaybe<Array<AccountImgCreateWithoutAccountInput>>;
  createMany?: InputMaybe<AccountImgCreateManyAccountInputEnvelope>;
  delete?: InputMaybe<Array<AccountImgWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<AccountImgScalarWhereInput>>;
  disconnect?: InputMaybe<Array<AccountImgWhereUniqueInput>>;
  set?: InputMaybe<Array<AccountImgWhereUniqueInput>>;
  update?: InputMaybe<Array<AccountImgUpdateWithWhereUniqueWithoutAccountInput>>;
  updateMany?: InputMaybe<Array<AccountImgUpdateManyWithWhereWithoutAccountInput>>;
  upsert?: InputMaybe<Array<AccountImgUpsertWithWhereUniqueWithoutAccountInput>>;
};

export type AccountImgUncheckedUpdateWithoutAccountInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  large?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  medium?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  small?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumAccountImgTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type AccountImgUpdateInput = {
  account?: InputMaybe<AccountUpdateOneRequiredWithoutImgsNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  large?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  medium?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  small?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumAccountImgTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type AccountImgUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  large?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  medium?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  small?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumAccountImgTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type AccountImgUpdateManyWithWhereWithoutAccountInput = {
  data: AccountImgUpdateManyMutationInput;
  where: AccountImgScalarWhereInput;
};

export type AccountImgUpdateManyWithoutAccountNestedInput = {
  connect?: InputMaybe<Array<AccountImgWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AccountImgCreateOrConnectWithoutAccountInput>>;
  create?: InputMaybe<Array<AccountImgCreateWithoutAccountInput>>;
  createMany?: InputMaybe<AccountImgCreateManyAccountInputEnvelope>;
  delete?: InputMaybe<Array<AccountImgWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<AccountImgScalarWhereInput>>;
  disconnect?: InputMaybe<Array<AccountImgWhereUniqueInput>>;
  set?: InputMaybe<Array<AccountImgWhereUniqueInput>>;
  update?: InputMaybe<Array<AccountImgUpdateWithWhereUniqueWithoutAccountInput>>;
  updateMany?: InputMaybe<Array<AccountImgUpdateManyWithWhereWithoutAccountInput>>;
  upsert?: InputMaybe<Array<AccountImgUpsertWithWhereUniqueWithoutAccountInput>>;
};

export type AccountImgUpdateWithWhereUniqueWithoutAccountInput = {
  data: AccountImgUpdateWithoutAccountInput;
  where: AccountImgWhereUniqueInput;
};

export type AccountImgUpdateWithoutAccountInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  large?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  medium?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  small?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumAccountImgTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type AccountImgUploadInput = {
  file: Scalars['Upload']['input'];
  type: AccountImgType;
};

export type AccountImgUpsertWithWhereUniqueWithoutAccountInput = {
  create: AccountImgCreateWithoutAccountInput;
  update: AccountImgUpdateWithoutAccountInput;
  where: AccountImgWhereUniqueInput;
};

export type AccountImgWhereInput = {
  AND?: InputMaybe<Array<AccountImgWhereInput>>;
  NOT?: InputMaybe<Array<AccountImgWhereInput>>;
  OR?: InputMaybe<Array<AccountImgWhereInput>>;
  account?: InputMaybe<AccountRelationFilter>;
  accountId?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntFilter>;
  large?: InputMaybe<StringNullableFilter>;
  medium?: InputMaybe<StringNullableFilter>;
  small?: InputMaybe<StringNullableFilter>;
  type?: InputMaybe<EnumAccountImgTypeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type AccountImgWhereUniqueInput = {
  AND?: InputMaybe<Array<AccountImgWhereInput>>;
  NOT?: InputMaybe<Array<AccountImgWhereInput>>;
  OR?: InputMaybe<Array<AccountImgWhereInput>>;
  account?: InputMaybe<AccountRelationFilter>;
  accountId?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  large?: InputMaybe<StringNullableFilter>;
  medium?: InputMaybe<StringNullableFilter>;
  small?: InputMaybe<StringNullableFilter>;
  type?: InputMaybe<EnumAccountImgTypeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type AccountLoginInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  facebookToken?: InputMaybe<Scalars['String']['input']>;
  googleToken?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
};

export type AccountMaxAggregateOutputType = {
  __typename?: 'AccountMaxAggregateOutputType';
  activated?: Maybe<Scalars['Boolean']['output']>;
  activeCampaignContactId?: Maybe<Scalars['String']['output']>;
  addressId?: Maybe<Scalars['Int']['output']>;
  applicationReminderSent?: Maybe<Scalars['Boolean']['output']>;
  birthday?: Maybe<Scalars['DateTime']['output']>;
  connectedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  draftApplicationReminderSent?: Maybe<Scalars['Boolean']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  facebookId?: Maybe<Scalars['String']['output']>;
  firebaseId?: Maybe<Scalars['String']['output']>;
  firebaseToken?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  freeApplicationsDateLimit?: Maybe<Scalars['DateTime']['output']>;
  gender?: Maybe<GenderEnum>;
  googleId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  mailjetId?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  password?: Maybe<Scalars['String']['output']>;
  payLaterReminderSent?: Maybe<Scalars['Boolean']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  registrationToken?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Role>;
  stripeCustomerId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type AccountMaxOrderByAggregateInput = {
  activated?: InputMaybe<SortOrder>;
  activeCampaignContactId?: InputMaybe<SortOrder>;
  addressId?: InputMaybe<SortOrder>;
  applicationReminderSent?: InputMaybe<SortOrder>;
  birthday?: InputMaybe<SortOrder>;
  connectedAt?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  deleted?: InputMaybe<SortOrder>;
  draftApplicationReminderSent?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  facebookId?: InputMaybe<SortOrder>;
  firebaseId?: InputMaybe<SortOrder>;
  firebaseToken?: InputMaybe<SortOrder>;
  firstName?: InputMaybe<SortOrder>;
  freeApplicationsDateLimit?: InputMaybe<SortOrder>;
  gender?: InputMaybe<SortOrder>;
  googleId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  language?: InputMaybe<SortOrder>;
  lastName?: InputMaybe<SortOrder>;
  mailjetId?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  password?: InputMaybe<SortOrder>;
  payLaterReminderSent?: InputMaybe<SortOrder>;
  phone?: InputMaybe<SortOrder>;
  registrationToken?: InputMaybe<SortOrder>;
  role?: InputMaybe<SortOrder>;
  stripeCustomerId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type AccountMinAggregateOutputType = {
  __typename?: 'AccountMinAggregateOutputType';
  activated?: Maybe<Scalars['Boolean']['output']>;
  activeCampaignContactId?: Maybe<Scalars['String']['output']>;
  addressId?: Maybe<Scalars['Int']['output']>;
  applicationReminderSent?: Maybe<Scalars['Boolean']['output']>;
  birthday?: Maybe<Scalars['DateTime']['output']>;
  connectedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  draftApplicationReminderSent?: Maybe<Scalars['Boolean']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  facebookId?: Maybe<Scalars['String']['output']>;
  firebaseId?: Maybe<Scalars['String']['output']>;
  firebaseToken?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  freeApplicationsDateLimit?: Maybe<Scalars['DateTime']['output']>;
  gender?: Maybe<GenderEnum>;
  googleId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  mailjetId?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  password?: Maybe<Scalars['String']['output']>;
  payLaterReminderSent?: Maybe<Scalars['Boolean']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  registrationToken?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Role>;
  stripeCustomerId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type AccountMinOrderByAggregateInput = {
  activated?: InputMaybe<SortOrder>;
  activeCampaignContactId?: InputMaybe<SortOrder>;
  addressId?: InputMaybe<SortOrder>;
  applicationReminderSent?: InputMaybe<SortOrder>;
  birthday?: InputMaybe<SortOrder>;
  connectedAt?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  deleted?: InputMaybe<SortOrder>;
  draftApplicationReminderSent?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  facebookId?: InputMaybe<SortOrder>;
  firebaseId?: InputMaybe<SortOrder>;
  firebaseToken?: InputMaybe<SortOrder>;
  firstName?: InputMaybe<SortOrder>;
  freeApplicationsDateLimit?: InputMaybe<SortOrder>;
  gender?: InputMaybe<SortOrder>;
  googleId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  language?: InputMaybe<SortOrder>;
  lastName?: InputMaybe<SortOrder>;
  mailjetId?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  password?: InputMaybe<SortOrder>;
  payLaterReminderSent?: InputMaybe<SortOrder>;
  phone?: InputMaybe<SortOrder>;
  registrationToken?: InputMaybe<SortOrder>;
  role?: InputMaybe<SortOrder>;
  stripeCustomerId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type AccountNullableRelationFilter = {
  is?: InputMaybe<AccountWhereInput>;
  isNot?: InputMaybe<AccountWhereInput>;
};

export enum AccountOrderByRelevanceFieldEnum {
  activeCampaignContactId = 'activeCampaignContactId',
  email = 'email',
  facebookId = 'facebookId',
  firebaseId = 'firebaseId',
  firebaseToken = 'firebaseToken',
  firstName = 'firstName',
  googleId = 'googleId',
  language = 'language',
  lastName = 'lastName',
  mailjetId = 'mailjetId',
  name = 'name',
  password = 'password',
  phone = 'phone',
  registrationToken = 'registrationToken',
  stripeCustomerId = 'stripeCustomerId'
}

export type AccountOrderByRelevanceInput = {
  fields: Array<AccountOrderByRelevanceFieldEnum>;
  search: Scalars['String']['input'];
  sort: SortOrder;
};

export type AccountOrderByWithAggregationInput = {
  _avg?: InputMaybe<AccountAvgOrderByAggregateInput>;
  _count?: InputMaybe<AccountCountOrderByAggregateInput>;
  _max?: InputMaybe<AccountMaxOrderByAggregateInput>;
  _min?: InputMaybe<AccountMinOrderByAggregateInput>;
  _sum?: InputMaybe<AccountSumOrderByAggregateInput>;
  activated?: InputMaybe<SortOrder>;
  activeCampaignContactId?: InputMaybe<SortOrderInput>;
  addressId?: InputMaybe<SortOrderInput>;
  applicationReminderSent?: InputMaybe<SortOrder>;
  birthday?: InputMaybe<SortOrderInput>;
  connectedAt?: InputMaybe<SortOrder>;
  contactPreferences?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  deleted?: InputMaybe<SortOrder>;
  draftApplicationReminderSent?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  facebookId?: InputMaybe<SortOrderInput>;
  firebaseId?: InputMaybe<SortOrderInput>;
  firebaseToken?: InputMaybe<SortOrderInput>;
  firstName?: InputMaybe<SortOrderInput>;
  freeApplicationsDateLimit?: InputMaybe<SortOrderInput>;
  gender?: InputMaybe<SortOrderInput>;
  googleId?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  language?: InputMaybe<SortOrder>;
  lastName?: InputMaybe<SortOrderInput>;
  mailjetId?: InputMaybe<SortOrderInput>;
  name?: InputMaybe<SortOrderInput>;
  password?: InputMaybe<SortOrderInput>;
  payLaterReminderSent?: InputMaybe<SortOrder>;
  phone?: InputMaybe<SortOrderInput>;
  registrationToken?: InputMaybe<SortOrderInput>;
  role?: InputMaybe<SortOrder>;
  stripeCustomerId?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type AccountOrderByWithRelationAndSearchRelevanceInput = {
  EducatorReviews?: InputMaybe<EducatorReviewOrderByRelationAggregateInput>;
  _relevance?: InputMaybe<AccountOrderByRelevanceInput>;
  activated?: InputMaybe<SortOrder>;
  activeCampaignContactId?: InputMaybe<SortOrderInput>;
  activityLogs?: InputMaybe<AccountActivityOrderByRelationAggregateInput>;
  address?: InputMaybe<AddressOrderByWithRelationAndSearchRelevanceInput>;
  addressId?: InputMaybe<SortOrderInput>;
  adminNotes?: InputMaybe<AdminNoteOrderByRelationAggregateInput>;
  animals?: InputMaybe<AnimalOrderByRelationAggregateInput>;
  applicationReminderSent?: InputMaybe<SortOrder>;
  applications?: InputMaybe<DogBreederApplicationOrderByRelationAggregateInput>;
  birthday?: InputMaybe<SortOrderInput>;
  bookings?: InputMaybe<BookingOrderByRelationAggregateInput>;
  bookmarks?: InputMaybe<BookmarkOrderByRelationAggregateInput>;
  connectedAt?: InputMaybe<SortOrder>;
  contactPreferences?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  deleted?: InputMaybe<SortOrder>;
  dogBreeder?: InputMaybe<DogBreederOrderByWithRelationAndSearchRelevanceInput>;
  dogBreederReview?: InputMaybe<DogBreederReviewOrderByRelationAggregateInput>;
  draftApplicationReminderSent?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  emailContact?: InputMaybe<EmailContactOrderByWithRelationAndSearchRelevanceInput>;
  emailHistory?: InputMaybe<EmailHistoryOrderByRelationAggregateInput>;
  facebookId?: InputMaybe<SortOrderInput>;
  firebaseId?: InputMaybe<SortOrderInput>;
  firebaseToken?: InputMaybe<SortOrderInput>;
  firstAccountConversations?: InputMaybe<ConversationOrderByRelationAggregateInput>;
  firstName?: InputMaybe<SortOrderInput>;
  freeApplicationsDateLimit?: InputMaybe<SortOrderInput>;
  gender?: InputMaybe<SortOrderInput>;
  googleId?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  imgs?: InputMaybe<AccountImgOrderByRelationAggregateInput>;
  language?: InputMaybe<SortOrder>;
  lastName?: InputMaybe<SortOrderInput>;
  mailjetId?: InputMaybe<SortOrderInput>;
  name?: InputMaybe<SortOrderInput>;
  notifications?: InputMaybe<NotificationOrderByRelationAggregateInput>;
  password?: InputMaybe<SortOrderInput>;
  payLaterReminderSent?: InputMaybe<SortOrder>;
  payments?: InputMaybe<PaymentOrderByRelationAggregateInput>;
  phone?: InputMaybe<SortOrderInput>;
  receivedMessages?: InputMaybe<MessageOrderByRelationAggregateInput>;
  registrationToken?: InputMaybe<SortOrderInput>;
  role?: InputMaybe<SortOrder>;
  secondAccountConversations?: InputMaybe<ConversationOrderByRelationAggregateInput>;
  sentMessages?: InputMaybe<MessageOrderByRelationAggregateInput>;
  stripeCustomerId?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
  updates?: InputMaybe<UpdateOrderByRelationAggregateInput>;
};

export type AccountRelationFilter = {
  is?: InputMaybe<AccountWhereInput>;
  isNot?: InputMaybe<AccountWhereInput>;
};

export enum AccountScalarFieldEnum {
  activated = 'activated',
  activeCampaignContactId = 'activeCampaignContactId',
  addressId = 'addressId',
  applicationReminderSent = 'applicationReminderSent',
  birthday = 'birthday',
  connectedAt = 'connectedAt',
  contactPreferences = 'contactPreferences',
  createdAt = 'createdAt',
  deleted = 'deleted',
  draftApplicationReminderSent = 'draftApplicationReminderSent',
  email = 'email',
  facebookId = 'facebookId',
  firebaseId = 'firebaseId',
  firebaseToken = 'firebaseToken',
  firstName = 'firstName',
  freeApplicationsDateLimit = 'freeApplicationsDateLimit',
  gender = 'gender',
  googleId = 'googleId',
  id = 'id',
  language = 'language',
  lastName = 'lastName',
  mailjetId = 'mailjetId',
  name = 'name',
  password = 'password',
  payLaterReminderSent = 'payLaterReminderSent',
  phone = 'phone',
  registrationToken = 'registrationToken',
  role = 'role',
  stripeCustomerId = 'stripeCustomerId',
  updatedAt = 'updatedAt'
}

export type AccountScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<AccountScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<AccountScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<AccountScalarWhereWithAggregatesInput>>;
  activated?: InputMaybe<BoolWithAggregatesFilter>;
  activeCampaignContactId?: InputMaybe<StringNullableWithAggregatesFilter>;
  addressId?: InputMaybe<IntNullableWithAggregatesFilter>;
  applicationReminderSent?: InputMaybe<BoolWithAggregatesFilter>;
  birthday?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  connectedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  contactPreferences?: InputMaybe<EnumContactPreferenceNullableListFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  deleted?: InputMaybe<BoolWithAggregatesFilter>;
  draftApplicationReminderSent?: InputMaybe<BoolWithAggregatesFilter>;
  email?: InputMaybe<StringWithAggregatesFilter>;
  facebookId?: InputMaybe<StringNullableWithAggregatesFilter>;
  firebaseId?: InputMaybe<StringNullableWithAggregatesFilter>;
  firebaseToken?: InputMaybe<StringNullableWithAggregatesFilter>;
  firstName?: InputMaybe<StringNullableWithAggregatesFilter>;
  freeApplicationsDateLimit?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  gender?: InputMaybe<EnumGenderEnumNullableWithAggregatesFilter>;
  googleId?: InputMaybe<StringNullableWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  language?: InputMaybe<StringWithAggregatesFilter>;
  lastName?: InputMaybe<StringNullableWithAggregatesFilter>;
  mailjetId?: InputMaybe<StringNullableWithAggregatesFilter>;
  name?: InputMaybe<StringNullableWithAggregatesFilter>;
  password?: InputMaybe<StringNullableWithAggregatesFilter>;
  payLaterReminderSent?: InputMaybe<BoolWithAggregatesFilter>;
  phone?: InputMaybe<StringNullableWithAggregatesFilter>;
  registrationToken?: InputMaybe<StringNullableWithAggregatesFilter>;
  role?: InputMaybe<EnumRoleWithAggregatesFilter>;
  stripeCustomerId?: InputMaybe<StringNullableWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type AccountSumAggregateOutputType = {
  __typename?: 'AccountSumAggregateOutputType';
  addressId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
};

export type AccountSumOrderByAggregateInput = {
  addressId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export type AccountUncheckedCreateInput = {
  EducatorReviews?: InputMaybe<EducatorReviewUncheckedCreateNestedManyWithoutAccountInput>;
  activated?: InputMaybe<Scalars['Boolean']['input']>;
  activeCampaignContactId?: InputMaybe<Scalars['String']['input']>;
  activityLogs?: InputMaybe<AccountActivityUncheckedCreateNestedManyWithoutAccountInput>;
  addressId?: InputMaybe<Scalars['Int']['input']>;
  adminNotes?: InputMaybe<AdminNoteUncheckedCreateNestedManyWithoutAccountInput>;
  animals?: InputMaybe<AnimalUncheckedCreateNestedManyWithoutOwnerInput>;
  applicationReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  applications?: InputMaybe<DogBreederApplicationUncheckedCreateNestedManyWithoutAccountInput>;
  birthday?: InputMaybe<Scalars['DateTime']['input']>;
  bookings?: InputMaybe<BookingUncheckedCreateNestedManyWithoutAccountInput>;
  bookmarks?: InputMaybe<BookmarkUncheckedCreateNestedManyWithoutAccountInput>;
  connectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  contactPreferences?: InputMaybe<Array<ContactPreference>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  dogBreeder?: InputMaybe<DogBreederUncheckedCreateNestedOneWithoutAccountInput>;
  dogBreederReview?: InputMaybe<DogBreederReviewUncheckedCreateNestedManyWithoutAccountInput>;
  draftApplicationReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  email: Scalars['String']['input'];
  emailContact?: InputMaybe<EmailContactUncheckedCreateNestedOneWithoutAccountInput>;
  emailHistory?: InputMaybe<EmailHistoryUncheckedCreateNestedManyWithoutAccountInput>;
  facebookId?: InputMaybe<Scalars['String']['input']>;
  firebaseId?: InputMaybe<Scalars['String']['input']>;
  firebaseToken?: InputMaybe<Scalars['String']['input']>;
  firstAccountConversations?: InputMaybe<ConversationUncheckedCreateNestedManyWithoutFirstAccountInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  freeApplicationsDateLimit?: InputMaybe<Scalars['DateTime']['input']>;
  gender?: InputMaybe<GenderEnum>;
  googleId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  imgs?: InputMaybe<AccountImgUncheckedCreateNestedManyWithoutAccountInput>;
  language: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  mailjetId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notifications?: InputMaybe<NotificationUncheckedCreateNestedManyWithoutAccountInput>;
  password?: InputMaybe<Scalars['String']['input']>;
  payLaterReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  payments?: InputMaybe<PaymentUncheckedCreateNestedManyWithoutAccountInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  receivedMessages?: InputMaybe<MessageUncheckedCreateNestedManyWithoutToAccountInput>;
  registrationToken?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Role>;
  secondAccountConversations?: InputMaybe<ConversationUncheckedCreateNestedManyWithoutSecondAccountInput>;
  sentMessages?: InputMaybe<MessageUncheckedCreateNestedManyWithoutFromAccountInput>;
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updates?: InputMaybe<UpdateUncheckedCreateNestedManyWithoutAccountInput>;
};

export type AccountUncheckedCreateNestedOneWithoutAddressInput = {
  connect?: InputMaybe<AccountWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AccountCreateOrConnectWithoutAddressInput>;
  create?: InputMaybe<AccountCreateWithoutAddressInput>;
};

export type AccountUncheckedCreateWithoutActivityLogsInput = {
  EducatorReviews?: InputMaybe<EducatorReviewUncheckedCreateNestedManyWithoutAccountInput>;
  activated?: InputMaybe<Scalars['Boolean']['input']>;
  activeCampaignContactId?: InputMaybe<Scalars['String']['input']>;
  addressId?: InputMaybe<Scalars['Int']['input']>;
  adminNotes?: InputMaybe<AdminNoteUncheckedCreateNestedManyWithoutAccountInput>;
  animals?: InputMaybe<AnimalUncheckedCreateNestedManyWithoutOwnerInput>;
  applicationReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  applications?: InputMaybe<DogBreederApplicationUncheckedCreateNestedManyWithoutAccountInput>;
  birthday?: InputMaybe<Scalars['DateTime']['input']>;
  bookings?: InputMaybe<BookingUncheckedCreateNestedManyWithoutAccountInput>;
  bookmarks?: InputMaybe<BookmarkUncheckedCreateNestedManyWithoutAccountInput>;
  connectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  contactPreferences?: InputMaybe<Array<ContactPreference>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  dogBreeder?: InputMaybe<DogBreederUncheckedCreateNestedOneWithoutAccountInput>;
  dogBreederReview?: InputMaybe<DogBreederReviewUncheckedCreateNestedManyWithoutAccountInput>;
  draftApplicationReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  email: Scalars['String']['input'];
  emailContact?: InputMaybe<EmailContactUncheckedCreateNestedOneWithoutAccountInput>;
  emailHistory?: InputMaybe<EmailHistoryUncheckedCreateNestedManyWithoutAccountInput>;
  facebookId?: InputMaybe<Scalars['String']['input']>;
  firebaseId?: InputMaybe<Scalars['String']['input']>;
  firebaseToken?: InputMaybe<Scalars['String']['input']>;
  firstAccountConversations?: InputMaybe<ConversationUncheckedCreateNestedManyWithoutFirstAccountInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  freeApplicationsDateLimit?: InputMaybe<Scalars['DateTime']['input']>;
  gender?: InputMaybe<GenderEnum>;
  googleId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  imgs?: InputMaybe<AccountImgUncheckedCreateNestedManyWithoutAccountInput>;
  language: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  mailjetId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notifications?: InputMaybe<NotificationUncheckedCreateNestedManyWithoutAccountInput>;
  password?: InputMaybe<Scalars['String']['input']>;
  payLaterReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  payments?: InputMaybe<PaymentUncheckedCreateNestedManyWithoutAccountInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  receivedMessages?: InputMaybe<MessageUncheckedCreateNestedManyWithoutToAccountInput>;
  registrationToken?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Role>;
  secondAccountConversations?: InputMaybe<ConversationUncheckedCreateNestedManyWithoutSecondAccountInput>;
  sentMessages?: InputMaybe<MessageUncheckedCreateNestedManyWithoutFromAccountInput>;
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updates?: InputMaybe<UpdateUncheckedCreateNestedManyWithoutAccountInput>;
};

export type AccountUncheckedCreateWithoutAddressInput = {
  EducatorReviews?: InputMaybe<EducatorReviewUncheckedCreateNestedManyWithoutAccountInput>;
  activated?: InputMaybe<Scalars['Boolean']['input']>;
  activeCampaignContactId?: InputMaybe<Scalars['String']['input']>;
  activityLogs?: InputMaybe<AccountActivityUncheckedCreateNestedManyWithoutAccountInput>;
  adminNotes?: InputMaybe<AdminNoteUncheckedCreateNestedManyWithoutAccountInput>;
  animals?: InputMaybe<AnimalUncheckedCreateNestedManyWithoutOwnerInput>;
  applicationReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  applications?: InputMaybe<DogBreederApplicationUncheckedCreateNestedManyWithoutAccountInput>;
  birthday?: InputMaybe<Scalars['DateTime']['input']>;
  bookings?: InputMaybe<BookingUncheckedCreateNestedManyWithoutAccountInput>;
  bookmarks?: InputMaybe<BookmarkUncheckedCreateNestedManyWithoutAccountInput>;
  connectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  contactPreferences?: InputMaybe<Array<ContactPreference>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  dogBreeder?: InputMaybe<DogBreederUncheckedCreateNestedOneWithoutAccountInput>;
  dogBreederReview?: InputMaybe<DogBreederReviewUncheckedCreateNestedManyWithoutAccountInput>;
  draftApplicationReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  email: Scalars['String']['input'];
  emailContact?: InputMaybe<EmailContactUncheckedCreateNestedOneWithoutAccountInput>;
  emailHistory?: InputMaybe<EmailHistoryUncheckedCreateNestedManyWithoutAccountInput>;
  facebookId?: InputMaybe<Scalars['String']['input']>;
  firebaseId?: InputMaybe<Scalars['String']['input']>;
  firebaseToken?: InputMaybe<Scalars['String']['input']>;
  firstAccountConversations?: InputMaybe<ConversationUncheckedCreateNestedManyWithoutFirstAccountInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  freeApplicationsDateLimit?: InputMaybe<Scalars['DateTime']['input']>;
  gender?: InputMaybe<GenderEnum>;
  googleId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  imgs?: InputMaybe<AccountImgUncheckedCreateNestedManyWithoutAccountInput>;
  language: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  mailjetId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notifications?: InputMaybe<NotificationUncheckedCreateNestedManyWithoutAccountInput>;
  password?: InputMaybe<Scalars['String']['input']>;
  payLaterReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  payments?: InputMaybe<PaymentUncheckedCreateNestedManyWithoutAccountInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  receivedMessages?: InputMaybe<MessageUncheckedCreateNestedManyWithoutToAccountInput>;
  registrationToken?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Role>;
  secondAccountConversations?: InputMaybe<ConversationUncheckedCreateNestedManyWithoutSecondAccountInput>;
  sentMessages?: InputMaybe<MessageUncheckedCreateNestedManyWithoutFromAccountInput>;
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updates?: InputMaybe<UpdateUncheckedCreateNestedManyWithoutAccountInput>;
};

export type AccountUncheckedCreateWithoutAdminNotesInput = {
  EducatorReviews?: InputMaybe<EducatorReviewUncheckedCreateNestedManyWithoutAccountInput>;
  activated?: InputMaybe<Scalars['Boolean']['input']>;
  activeCampaignContactId?: InputMaybe<Scalars['String']['input']>;
  activityLogs?: InputMaybe<AccountActivityUncheckedCreateNestedManyWithoutAccountInput>;
  addressId?: InputMaybe<Scalars['Int']['input']>;
  animals?: InputMaybe<AnimalUncheckedCreateNestedManyWithoutOwnerInput>;
  applicationReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  applications?: InputMaybe<DogBreederApplicationUncheckedCreateNestedManyWithoutAccountInput>;
  birthday?: InputMaybe<Scalars['DateTime']['input']>;
  bookings?: InputMaybe<BookingUncheckedCreateNestedManyWithoutAccountInput>;
  bookmarks?: InputMaybe<BookmarkUncheckedCreateNestedManyWithoutAccountInput>;
  connectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  contactPreferences?: InputMaybe<Array<ContactPreference>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  dogBreeder?: InputMaybe<DogBreederUncheckedCreateNestedOneWithoutAccountInput>;
  dogBreederReview?: InputMaybe<DogBreederReviewUncheckedCreateNestedManyWithoutAccountInput>;
  draftApplicationReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  email: Scalars['String']['input'];
  emailContact?: InputMaybe<EmailContactUncheckedCreateNestedOneWithoutAccountInput>;
  emailHistory?: InputMaybe<EmailHistoryUncheckedCreateNestedManyWithoutAccountInput>;
  facebookId?: InputMaybe<Scalars['String']['input']>;
  firebaseId?: InputMaybe<Scalars['String']['input']>;
  firebaseToken?: InputMaybe<Scalars['String']['input']>;
  firstAccountConversations?: InputMaybe<ConversationUncheckedCreateNestedManyWithoutFirstAccountInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  freeApplicationsDateLimit?: InputMaybe<Scalars['DateTime']['input']>;
  gender?: InputMaybe<GenderEnum>;
  googleId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  imgs?: InputMaybe<AccountImgUncheckedCreateNestedManyWithoutAccountInput>;
  language: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  mailjetId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notifications?: InputMaybe<NotificationUncheckedCreateNestedManyWithoutAccountInput>;
  password?: InputMaybe<Scalars['String']['input']>;
  payLaterReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  payments?: InputMaybe<PaymentUncheckedCreateNestedManyWithoutAccountInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  receivedMessages?: InputMaybe<MessageUncheckedCreateNestedManyWithoutToAccountInput>;
  registrationToken?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Role>;
  secondAccountConversations?: InputMaybe<ConversationUncheckedCreateNestedManyWithoutSecondAccountInput>;
  sentMessages?: InputMaybe<MessageUncheckedCreateNestedManyWithoutFromAccountInput>;
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updates?: InputMaybe<UpdateUncheckedCreateNestedManyWithoutAccountInput>;
};

export type AccountUncheckedCreateWithoutAnimalsInput = {
  EducatorReviews?: InputMaybe<EducatorReviewUncheckedCreateNestedManyWithoutAccountInput>;
  activated?: InputMaybe<Scalars['Boolean']['input']>;
  activeCampaignContactId?: InputMaybe<Scalars['String']['input']>;
  activityLogs?: InputMaybe<AccountActivityUncheckedCreateNestedManyWithoutAccountInput>;
  addressId?: InputMaybe<Scalars['Int']['input']>;
  adminNotes?: InputMaybe<AdminNoteUncheckedCreateNestedManyWithoutAccountInput>;
  applicationReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  applications?: InputMaybe<DogBreederApplicationUncheckedCreateNestedManyWithoutAccountInput>;
  birthday?: InputMaybe<Scalars['DateTime']['input']>;
  bookings?: InputMaybe<BookingUncheckedCreateNestedManyWithoutAccountInput>;
  bookmarks?: InputMaybe<BookmarkUncheckedCreateNestedManyWithoutAccountInput>;
  connectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  contactPreferences?: InputMaybe<Array<ContactPreference>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  dogBreeder?: InputMaybe<DogBreederUncheckedCreateNestedOneWithoutAccountInput>;
  dogBreederReview?: InputMaybe<DogBreederReviewUncheckedCreateNestedManyWithoutAccountInput>;
  draftApplicationReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  email: Scalars['String']['input'];
  emailContact?: InputMaybe<EmailContactUncheckedCreateNestedOneWithoutAccountInput>;
  emailHistory?: InputMaybe<EmailHistoryUncheckedCreateNestedManyWithoutAccountInput>;
  facebookId?: InputMaybe<Scalars['String']['input']>;
  firebaseId?: InputMaybe<Scalars['String']['input']>;
  firebaseToken?: InputMaybe<Scalars['String']['input']>;
  firstAccountConversations?: InputMaybe<ConversationUncheckedCreateNestedManyWithoutFirstAccountInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  freeApplicationsDateLimit?: InputMaybe<Scalars['DateTime']['input']>;
  gender?: InputMaybe<GenderEnum>;
  googleId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  imgs?: InputMaybe<AccountImgUncheckedCreateNestedManyWithoutAccountInput>;
  language: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  mailjetId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notifications?: InputMaybe<NotificationUncheckedCreateNestedManyWithoutAccountInput>;
  password?: InputMaybe<Scalars['String']['input']>;
  payLaterReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  payments?: InputMaybe<PaymentUncheckedCreateNestedManyWithoutAccountInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  receivedMessages?: InputMaybe<MessageUncheckedCreateNestedManyWithoutToAccountInput>;
  registrationToken?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Role>;
  secondAccountConversations?: InputMaybe<ConversationUncheckedCreateNestedManyWithoutSecondAccountInput>;
  sentMessages?: InputMaybe<MessageUncheckedCreateNestedManyWithoutFromAccountInput>;
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updates?: InputMaybe<UpdateUncheckedCreateNestedManyWithoutAccountInput>;
};

export type AccountUncheckedCreateWithoutApplicationsInput = {
  EducatorReviews?: InputMaybe<EducatorReviewUncheckedCreateNestedManyWithoutAccountInput>;
  activated?: InputMaybe<Scalars['Boolean']['input']>;
  activeCampaignContactId?: InputMaybe<Scalars['String']['input']>;
  activityLogs?: InputMaybe<AccountActivityUncheckedCreateNestedManyWithoutAccountInput>;
  addressId?: InputMaybe<Scalars['Int']['input']>;
  adminNotes?: InputMaybe<AdminNoteUncheckedCreateNestedManyWithoutAccountInput>;
  animals?: InputMaybe<AnimalUncheckedCreateNestedManyWithoutOwnerInput>;
  applicationReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  birthday?: InputMaybe<Scalars['DateTime']['input']>;
  bookings?: InputMaybe<BookingUncheckedCreateNestedManyWithoutAccountInput>;
  bookmarks?: InputMaybe<BookmarkUncheckedCreateNestedManyWithoutAccountInput>;
  connectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  contactPreferences?: InputMaybe<Array<ContactPreference>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  dogBreeder?: InputMaybe<DogBreederUncheckedCreateNestedOneWithoutAccountInput>;
  dogBreederReview?: InputMaybe<DogBreederReviewUncheckedCreateNestedManyWithoutAccountInput>;
  draftApplicationReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  email: Scalars['String']['input'];
  emailContact?: InputMaybe<EmailContactUncheckedCreateNestedOneWithoutAccountInput>;
  emailHistory?: InputMaybe<EmailHistoryUncheckedCreateNestedManyWithoutAccountInput>;
  facebookId?: InputMaybe<Scalars['String']['input']>;
  firebaseId?: InputMaybe<Scalars['String']['input']>;
  firebaseToken?: InputMaybe<Scalars['String']['input']>;
  firstAccountConversations?: InputMaybe<ConversationUncheckedCreateNestedManyWithoutFirstAccountInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  freeApplicationsDateLimit?: InputMaybe<Scalars['DateTime']['input']>;
  gender?: InputMaybe<GenderEnum>;
  googleId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  imgs?: InputMaybe<AccountImgUncheckedCreateNestedManyWithoutAccountInput>;
  language: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  mailjetId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notifications?: InputMaybe<NotificationUncheckedCreateNestedManyWithoutAccountInput>;
  password?: InputMaybe<Scalars['String']['input']>;
  payLaterReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  payments?: InputMaybe<PaymentUncheckedCreateNestedManyWithoutAccountInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  receivedMessages?: InputMaybe<MessageUncheckedCreateNestedManyWithoutToAccountInput>;
  registrationToken?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Role>;
  secondAccountConversations?: InputMaybe<ConversationUncheckedCreateNestedManyWithoutSecondAccountInput>;
  sentMessages?: InputMaybe<MessageUncheckedCreateNestedManyWithoutFromAccountInput>;
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updates?: InputMaybe<UpdateUncheckedCreateNestedManyWithoutAccountInput>;
};

export type AccountUncheckedCreateWithoutBookingsInput = {
  EducatorReviews?: InputMaybe<EducatorReviewUncheckedCreateNestedManyWithoutAccountInput>;
  activated?: InputMaybe<Scalars['Boolean']['input']>;
  activeCampaignContactId?: InputMaybe<Scalars['String']['input']>;
  activityLogs?: InputMaybe<AccountActivityUncheckedCreateNestedManyWithoutAccountInput>;
  addressId?: InputMaybe<Scalars['Int']['input']>;
  adminNotes?: InputMaybe<AdminNoteUncheckedCreateNestedManyWithoutAccountInput>;
  animals?: InputMaybe<AnimalUncheckedCreateNestedManyWithoutOwnerInput>;
  applicationReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  applications?: InputMaybe<DogBreederApplicationUncheckedCreateNestedManyWithoutAccountInput>;
  birthday?: InputMaybe<Scalars['DateTime']['input']>;
  bookmarks?: InputMaybe<BookmarkUncheckedCreateNestedManyWithoutAccountInput>;
  connectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  contactPreferences?: InputMaybe<Array<ContactPreference>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  dogBreeder?: InputMaybe<DogBreederUncheckedCreateNestedOneWithoutAccountInput>;
  dogBreederReview?: InputMaybe<DogBreederReviewUncheckedCreateNestedManyWithoutAccountInput>;
  draftApplicationReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  email: Scalars['String']['input'];
  emailContact?: InputMaybe<EmailContactUncheckedCreateNestedOneWithoutAccountInput>;
  emailHistory?: InputMaybe<EmailHistoryUncheckedCreateNestedManyWithoutAccountInput>;
  facebookId?: InputMaybe<Scalars['String']['input']>;
  firebaseId?: InputMaybe<Scalars['String']['input']>;
  firebaseToken?: InputMaybe<Scalars['String']['input']>;
  firstAccountConversations?: InputMaybe<ConversationUncheckedCreateNestedManyWithoutFirstAccountInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  freeApplicationsDateLimit?: InputMaybe<Scalars['DateTime']['input']>;
  gender?: InputMaybe<GenderEnum>;
  googleId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  imgs?: InputMaybe<AccountImgUncheckedCreateNestedManyWithoutAccountInput>;
  language: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  mailjetId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notifications?: InputMaybe<NotificationUncheckedCreateNestedManyWithoutAccountInput>;
  password?: InputMaybe<Scalars['String']['input']>;
  payLaterReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  payments?: InputMaybe<PaymentUncheckedCreateNestedManyWithoutAccountInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  receivedMessages?: InputMaybe<MessageUncheckedCreateNestedManyWithoutToAccountInput>;
  registrationToken?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Role>;
  secondAccountConversations?: InputMaybe<ConversationUncheckedCreateNestedManyWithoutSecondAccountInput>;
  sentMessages?: InputMaybe<MessageUncheckedCreateNestedManyWithoutFromAccountInput>;
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updates?: InputMaybe<UpdateUncheckedCreateNestedManyWithoutAccountInput>;
};

export type AccountUncheckedCreateWithoutBookmarksInput = {
  EducatorReviews?: InputMaybe<EducatorReviewUncheckedCreateNestedManyWithoutAccountInput>;
  activated?: InputMaybe<Scalars['Boolean']['input']>;
  activeCampaignContactId?: InputMaybe<Scalars['String']['input']>;
  activityLogs?: InputMaybe<AccountActivityUncheckedCreateNestedManyWithoutAccountInput>;
  addressId?: InputMaybe<Scalars['Int']['input']>;
  adminNotes?: InputMaybe<AdminNoteUncheckedCreateNestedManyWithoutAccountInput>;
  animals?: InputMaybe<AnimalUncheckedCreateNestedManyWithoutOwnerInput>;
  applicationReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  applications?: InputMaybe<DogBreederApplicationUncheckedCreateNestedManyWithoutAccountInput>;
  birthday?: InputMaybe<Scalars['DateTime']['input']>;
  bookings?: InputMaybe<BookingUncheckedCreateNestedManyWithoutAccountInput>;
  connectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  contactPreferences?: InputMaybe<Array<ContactPreference>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  dogBreeder?: InputMaybe<DogBreederUncheckedCreateNestedOneWithoutAccountInput>;
  dogBreederReview?: InputMaybe<DogBreederReviewUncheckedCreateNestedManyWithoutAccountInput>;
  draftApplicationReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  email: Scalars['String']['input'];
  emailContact?: InputMaybe<EmailContactUncheckedCreateNestedOneWithoutAccountInput>;
  emailHistory?: InputMaybe<EmailHistoryUncheckedCreateNestedManyWithoutAccountInput>;
  facebookId?: InputMaybe<Scalars['String']['input']>;
  firebaseId?: InputMaybe<Scalars['String']['input']>;
  firebaseToken?: InputMaybe<Scalars['String']['input']>;
  firstAccountConversations?: InputMaybe<ConversationUncheckedCreateNestedManyWithoutFirstAccountInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  freeApplicationsDateLimit?: InputMaybe<Scalars['DateTime']['input']>;
  gender?: InputMaybe<GenderEnum>;
  googleId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  imgs?: InputMaybe<AccountImgUncheckedCreateNestedManyWithoutAccountInput>;
  language: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  mailjetId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notifications?: InputMaybe<NotificationUncheckedCreateNestedManyWithoutAccountInput>;
  password?: InputMaybe<Scalars['String']['input']>;
  payLaterReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  payments?: InputMaybe<PaymentUncheckedCreateNestedManyWithoutAccountInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  receivedMessages?: InputMaybe<MessageUncheckedCreateNestedManyWithoutToAccountInput>;
  registrationToken?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Role>;
  secondAccountConversations?: InputMaybe<ConversationUncheckedCreateNestedManyWithoutSecondAccountInput>;
  sentMessages?: InputMaybe<MessageUncheckedCreateNestedManyWithoutFromAccountInput>;
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updates?: InputMaybe<UpdateUncheckedCreateNestedManyWithoutAccountInput>;
};

export type AccountUncheckedCreateWithoutDogBreederInput = {
  EducatorReviews?: InputMaybe<EducatorReviewUncheckedCreateNestedManyWithoutAccountInput>;
  activated?: InputMaybe<Scalars['Boolean']['input']>;
  activeCampaignContactId?: InputMaybe<Scalars['String']['input']>;
  activityLogs?: InputMaybe<AccountActivityUncheckedCreateNestedManyWithoutAccountInput>;
  addressId?: InputMaybe<Scalars['Int']['input']>;
  adminNotes?: InputMaybe<AdminNoteUncheckedCreateNestedManyWithoutAccountInput>;
  animals?: InputMaybe<AnimalUncheckedCreateNestedManyWithoutOwnerInput>;
  applicationReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  applications?: InputMaybe<DogBreederApplicationUncheckedCreateNestedManyWithoutAccountInput>;
  birthday?: InputMaybe<Scalars['DateTime']['input']>;
  bookings?: InputMaybe<BookingUncheckedCreateNestedManyWithoutAccountInput>;
  bookmarks?: InputMaybe<BookmarkUncheckedCreateNestedManyWithoutAccountInput>;
  connectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  contactPreferences?: InputMaybe<Array<ContactPreference>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  dogBreederReview?: InputMaybe<DogBreederReviewUncheckedCreateNestedManyWithoutAccountInput>;
  draftApplicationReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  email: Scalars['String']['input'];
  emailContact?: InputMaybe<EmailContactUncheckedCreateNestedOneWithoutAccountInput>;
  emailHistory?: InputMaybe<EmailHistoryUncheckedCreateNestedManyWithoutAccountInput>;
  facebookId?: InputMaybe<Scalars['String']['input']>;
  firebaseId?: InputMaybe<Scalars['String']['input']>;
  firebaseToken?: InputMaybe<Scalars['String']['input']>;
  firstAccountConversations?: InputMaybe<ConversationUncheckedCreateNestedManyWithoutFirstAccountInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  freeApplicationsDateLimit?: InputMaybe<Scalars['DateTime']['input']>;
  gender?: InputMaybe<GenderEnum>;
  googleId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  imgs?: InputMaybe<AccountImgUncheckedCreateNestedManyWithoutAccountInput>;
  language: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  mailjetId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notifications?: InputMaybe<NotificationUncheckedCreateNestedManyWithoutAccountInput>;
  password?: InputMaybe<Scalars['String']['input']>;
  payLaterReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  payments?: InputMaybe<PaymentUncheckedCreateNestedManyWithoutAccountInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  receivedMessages?: InputMaybe<MessageUncheckedCreateNestedManyWithoutToAccountInput>;
  registrationToken?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Role>;
  secondAccountConversations?: InputMaybe<ConversationUncheckedCreateNestedManyWithoutSecondAccountInput>;
  sentMessages?: InputMaybe<MessageUncheckedCreateNestedManyWithoutFromAccountInput>;
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updates?: InputMaybe<UpdateUncheckedCreateNestedManyWithoutAccountInput>;
};

export type AccountUncheckedCreateWithoutDogBreederReviewInput = {
  EducatorReviews?: InputMaybe<EducatorReviewUncheckedCreateNestedManyWithoutAccountInput>;
  activated?: InputMaybe<Scalars['Boolean']['input']>;
  activeCampaignContactId?: InputMaybe<Scalars['String']['input']>;
  activityLogs?: InputMaybe<AccountActivityUncheckedCreateNestedManyWithoutAccountInput>;
  addressId?: InputMaybe<Scalars['Int']['input']>;
  adminNotes?: InputMaybe<AdminNoteUncheckedCreateNestedManyWithoutAccountInput>;
  animals?: InputMaybe<AnimalUncheckedCreateNestedManyWithoutOwnerInput>;
  applicationReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  applications?: InputMaybe<DogBreederApplicationUncheckedCreateNestedManyWithoutAccountInput>;
  birthday?: InputMaybe<Scalars['DateTime']['input']>;
  bookings?: InputMaybe<BookingUncheckedCreateNestedManyWithoutAccountInput>;
  bookmarks?: InputMaybe<BookmarkUncheckedCreateNestedManyWithoutAccountInput>;
  connectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  contactPreferences?: InputMaybe<Array<ContactPreference>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  dogBreeder?: InputMaybe<DogBreederUncheckedCreateNestedOneWithoutAccountInput>;
  draftApplicationReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  email: Scalars['String']['input'];
  emailContact?: InputMaybe<EmailContactUncheckedCreateNestedOneWithoutAccountInput>;
  emailHistory?: InputMaybe<EmailHistoryUncheckedCreateNestedManyWithoutAccountInput>;
  facebookId?: InputMaybe<Scalars['String']['input']>;
  firebaseId?: InputMaybe<Scalars['String']['input']>;
  firebaseToken?: InputMaybe<Scalars['String']['input']>;
  firstAccountConversations?: InputMaybe<ConversationUncheckedCreateNestedManyWithoutFirstAccountInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  freeApplicationsDateLimit?: InputMaybe<Scalars['DateTime']['input']>;
  gender?: InputMaybe<GenderEnum>;
  googleId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  imgs?: InputMaybe<AccountImgUncheckedCreateNestedManyWithoutAccountInput>;
  language: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  mailjetId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notifications?: InputMaybe<NotificationUncheckedCreateNestedManyWithoutAccountInput>;
  password?: InputMaybe<Scalars['String']['input']>;
  payLaterReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  payments?: InputMaybe<PaymentUncheckedCreateNestedManyWithoutAccountInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  receivedMessages?: InputMaybe<MessageUncheckedCreateNestedManyWithoutToAccountInput>;
  registrationToken?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Role>;
  secondAccountConversations?: InputMaybe<ConversationUncheckedCreateNestedManyWithoutSecondAccountInput>;
  sentMessages?: InputMaybe<MessageUncheckedCreateNestedManyWithoutFromAccountInput>;
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updates?: InputMaybe<UpdateUncheckedCreateNestedManyWithoutAccountInput>;
};

export type AccountUncheckedCreateWithoutEducatorReviewsInput = {
  activated?: InputMaybe<Scalars['Boolean']['input']>;
  activeCampaignContactId?: InputMaybe<Scalars['String']['input']>;
  activityLogs?: InputMaybe<AccountActivityUncheckedCreateNestedManyWithoutAccountInput>;
  addressId?: InputMaybe<Scalars['Int']['input']>;
  adminNotes?: InputMaybe<AdminNoteUncheckedCreateNestedManyWithoutAccountInput>;
  animals?: InputMaybe<AnimalUncheckedCreateNestedManyWithoutOwnerInput>;
  applicationReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  applications?: InputMaybe<DogBreederApplicationUncheckedCreateNestedManyWithoutAccountInput>;
  birthday?: InputMaybe<Scalars['DateTime']['input']>;
  bookings?: InputMaybe<BookingUncheckedCreateNestedManyWithoutAccountInput>;
  bookmarks?: InputMaybe<BookmarkUncheckedCreateNestedManyWithoutAccountInput>;
  connectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  contactPreferences?: InputMaybe<Array<ContactPreference>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  dogBreeder?: InputMaybe<DogBreederUncheckedCreateNestedOneWithoutAccountInput>;
  dogBreederReview?: InputMaybe<DogBreederReviewUncheckedCreateNestedManyWithoutAccountInput>;
  draftApplicationReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  email: Scalars['String']['input'];
  emailContact?: InputMaybe<EmailContactUncheckedCreateNestedOneWithoutAccountInput>;
  emailHistory?: InputMaybe<EmailHistoryUncheckedCreateNestedManyWithoutAccountInput>;
  facebookId?: InputMaybe<Scalars['String']['input']>;
  firebaseId?: InputMaybe<Scalars['String']['input']>;
  firebaseToken?: InputMaybe<Scalars['String']['input']>;
  firstAccountConversations?: InputMaybe<ConversationUncheckedCreateNestedManyWithoutFirstAccountInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  freeApplicationsDateLimit?: InputMaybe<Scalars['DateTime']['input']>;
  gender?: InputMaybe<GenderEnum>;
  googleId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  imgs?: InputMaybe<AccountImgUncheckedCreateNestedManyWithoutAccountInput>;
  language: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  mailjetId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notifications?: InputMaybe<NotificationUncheckedCreateNestedManyWithoutAccountInput>;
  password?: InputMaybe<Scalars['String']['input']>;
  payLaterReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  payments?: InputMaybe<PaymentUncheckedCreateNestedManyWithoutAccountInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  receivedMessages?: InputMaybe<MessageUncheckedCreateNestedManyWithoutToAccountInput>;
  registrationToken?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Role>;
  secondAccountConversations?: InputMaybe<ConversationUncheckedCreateNestedManyWithoutSecondAccountInput>;
  sentMessages?: InputMaybe<MessageUncheckedCreateNestedManyWithoutFromAccountInput>;
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updates?: InputMaybe<UpdateUncheckedCreateNestedManyWithoutAccountInput>;
};

export type AccountUncheckedCreateWithoutEmailContactInput = {
  EducatorReviews?: InputMaybe<EducatorReviewUncheckedCreateNestedManyWithoutAccountInput>;
  activated?: InputMaybe<Scalars['Boolean']['input']>;
  activeCampaignContactId?: InputMaybe<Scalars['String']['input']>;
  activityLogs?: InputMaybe<AccountActivityUncheckedCreateNestedManyWithoutAccountInput>;
  addressId?: InputMaybe<Scalars['Int']['input']>;
  adminNotes?: InputMaybe<AdminNoteUncheckedCreateNestedManyWithoutAccountInput>;
  animals?: InputMaybe<AnimalUncheckedCreateNestedManyWithoutOwnerInput>;
  applicationReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  applications?: InputMaybe<DogBreederApplicationUncheckedCreateNestedManyWithoutAccountInput>;
  birthday?: InputMaybe<Scalars['DateTime']['input']>;
  bookings?: InputMaybe<BookingUncheckedCreateNestedManyWithoutAccountInput>;
  bookmarks?: InputMaybe<BookmarkUncheckedCreateNestedManyWithoutAccountInput>;
  connectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  contactPreferences?: InputMaybe<Array<ContactPreference>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  dogBreeder?: InputMaybe<DogBreederUncheckedCreateNestedOneWithoutAccountInput>;
  dogBreederReview?: InputMaybe<DogBreederReviewUncheckedCreateNestedManyWithoutAccountInput>;
  draftApplicationReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  email: Scalars['String']['input'];
  emailHistory?: InputMaybe<EmailHistoryUncheckedCreateNestedManyWithoutAccountInput>;
  facebookId?: InputMaybe<Scalars['String']['input']>;
  firebaseId?: InputMaybe<Scalars['String']['input']>;
  firebaseToken?: InputMaybe<Scalars['String']['input']>;
  firstAccountConversations?: InputMaybe<ConversationUncheckedCreateNestedManyWithoutFirstAccountInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  freeApplicationsDateLimit?: InputMaybe<Scalars['DateTime']['input']>;
  gender?: InputMaybe<GenderEnum>;
  googleId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  imgs?: InputMaybe<AccountImgUncheckedCreateNestedManyWithoutAccountInput>;
  language: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  mailjetId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notifications?: InputMaybe<NotificationUncheckedCreateNestedManyWithoutAccountInput>;
  password?: InputMaybe<Scalars['String']['input']>;
  payLaterReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  payments?: InputMaybe<PaymentUncheckedCreateNestedManyWithoutAccountInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  receivedMessages?: InputMaybe<MessageUncheckedCreateNestedManyWithoutToAccountInput>;
  registrationToken?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Role>;
  secondAccountConversations?: InputMaybe<ConversationUncheckedCreateNestedManyWithoutSecondAccountInput>;
  sentMessages?: InputMaybe<MessageUncheckedCreateNestedManyWithoutFromAccountInput>;
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updates?: InputMaybe<UpdateUncheckedCreateNestedManyWithoutAccountInput>;
};

export type AccountUncheckedCreateWithoutEmailHistoryInput = {
  EducatorReviews?: InputMaybe<EducatorReviewUncheckedCreateNestedManyWithoutAccountInput>;
  activated?: InputMaybe<Scalars['Boolean']['input']>;
  activeCampaignContactId?: InputMaybe<Scalars['String']['input']>;
  activityLogs?: InputMaybe<AccountActivityUncheckedCreateNestedManyWithoutAccountInput>;
  addressId?: InputMaybe<Scalars['Int']['input']>;
  adminNotes?: InputMaybe<AdminNoteUncheckedCreateNestedManyWithoutAccountInput>;
  animals?: InputMaybe<AnimalUncheckedCreateNestedManyWithoutOwnerInput>;
  applicationReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  applications?: InputMaybe<DogBreederApplicationUncheckedCreateNestedManyWithoutAccountInput>;
  birthday?: InputMaybe<Scalars['DateTime']['input']>;
  bookings?: InputMaybe<BookingUncheckedCreateNestedManyWithoutAccountInput>;
  bookmarks?: InputMaybe<BookmarkUncheckedCreateNestedManyWithoutAccountInput>;
  connectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  contactPreferences?: InputMaybe<Array<ContactPreference>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  dogBreeder?: InputMaybe<DogBreederUncheckedCreateNestedOneWithoutAccountInput>;
  dogBreederReview?: InputMaybe<DogBreederReviewUncheckedCreateNestedManyWithoutAccountInput>;
  draftApplicationReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  email: Scalars['String']['input'];
  emailContact?: InputMaybe<EmailContactUncheckedCreateNestedOneWithoutAccountInput>;
  facebookId?: InputMaybe<Scalars['String']['input']>;
  firebaseId?: InputMaybe<Scalars['String']['input']>;
  firebaseToken?: InputMaybe<Scalars['String']['input']>;
  firstAccountConversations?: InputMaybe<ConversationUncheckedCreateNestedManyWithoutFirstAccountInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  freeApplicationsDateLimit?: InputMaybe<Scalars['DateTime']['input']>;
  gender?: InputMaybe<GenderEnum>;
  googleId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  imgs?: InputMaybe<AccountImgUncheckedCreateNestedManyWithoutAccountInput>;
  language: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  mailjetId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notifications?: InputMaybe<NotificationUncheckedCreateNestedManyWithoutAccountInput>;
  password?: InputMaybe<Scalars['String']['input']>;
  payLaterReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  payments?: InputMaybe<PaymentUncheckedCreateNestedManyWithoutAccountInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  receivedMessages?: InputMaybe<MessageUncheckedCreateNestedManyWithoutToAccountInput>;
  registrationToken?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Role>;
  secondAccountConversations?: InputMaybe<ConversationUncheckedCreateNestedManyWithoutSecondAccountInput>;
  sentMessages?: InputMaybe<MessageUncheckedCreateNestedManyWithoutFromAccountInput>;
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updates?: InputMaybe<UpdateUncheckedCreateNestedManyWithoutAccountInput>;
};

export type AccountUncheckedCreateWithoutFirstAccountConversationsInput = {
  EducatorReviews?: InputMaybe<EducatorReviewUncheckedCreateNestedManyWithoutAccountInput>;
  activated?: InputMaybe<Scalars['Boolean']['input']>;
  activeCampaignContactId?: InputMaybe<Scalars['String']['input']>;
  activityLogs?: InputMaybe<AccountActivityUncheckedCreateNestedManyWithoutAccountInput>;
  addressId?: InputMaybe<Scalars['Int']['input']>;
  adminNotes?: InputMaybe<AdminNoteUncheckedCreateNestedManyWithoutAccountInput>;
  animals?: InputMaybe<AnimalUncheckedCreateNestedManyWithoutOwnerInput>;
  applicationReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  applications?: InputMaybe<DogBreederApplicationUncheckedCreateNestedManyWithoutAccountInput>;
  birthday?: InputMaybe<Scalars['DateTime']['input']>;
  bookings?: InputMaybe<BookingUncheckedCreateNestedManyWithoutAccountInput>;
  bookmarks?: InputMaybe<BookmarkUncheckedCreateNestedManyWithoutAccountInput>;
  connectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  contactPreferences?: InputMaybe<Array<ContactPreference>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  dogBreeder?: InputMaybe<DogBreederUncheckedCreateNestedOneWithoutAccountInput>;
  dogBreederReview?: InputMaybe<DogBreederReviewUncheckedCreateNestedManyWithoutAccountInput>;
  draftApplicationReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  email: Scalars['String']['input'];
  emailContact?: InputMaybe<EmailContactUncheckedCreateNestedOneWithoutAccountInput>;
  emailHistory?: InputMaybe<EmailHistoryUncheckedCreateNestedManyWithoutAccountInput>;
  facebookId?: InputMaybe<Scalars['String']['input']>;
  firebaseId?: InputMaybe<Scalars['String']['input']>;
  firebaseToken?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  freeApplicationsDateLimit?: InputMaybe<Scalars['DateTime']['input']>;
  gender?: InputMaybe<GenderEnum>;
  googleId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  imgs?: InputMaybe<AccountImgUncheckedCreateNestedManyWithoutAccountInput>;
  language: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  mailjetId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notifications?: InputMaybe<NotificationUncheckedCreateNestedManyWithoutAccountInput>;
  password?: InputMaybe<Scalars['String']['input']>;
  payLaterReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  payments?: InputMaybe<PaymentUncheckedCreateNestedManyWithoutAccountInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  receivedMessages?: InputMaybe<MessageUncheckedCreateNestedManyWithoutToAccountInput>;
  registrationToken?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Role>;
  secondAccountConversations?: InputMaybe<ConversationUncheckedCreateNestedManyWithoutSecondAccountInput>;
  sentMessages?: InputMaybe<MessageUncheckedCreateNestedManyWithoutFromAccountInput>;
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updates?: InputMaybe<UpdateUncheckedCreateNestedManyWithoutAccountInput>;
};

export type AccountUncheckedCreateWithoutImgsInput = {
  EducatorReviews?: InputMaybe<EducatorReviewUncheckedCreateNestedManyWithoutAccountInput>;
  activated?: InputMaybe<Scalars['Boolean']['input']>;
  activeCampaignContactId?: InputMaybe<Scalars['String']['input']>;
  activityLogs?: InputMaybe<AccountActivityUncheckedCreateNestedManyWithoutAccountInput>;
  addressId?: InputMaybe<Scalars['Int']['input']>;
  adminNotes?: InputMaybe<AdminNoteUncheckedCreateNestedManyWithoutAccountInput>;
  animals?: InputMaybe<AnimalUncheckedCreateNestedManyWithoutOwnerInput>;
  applicationReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  applications?: InputMaybe<DogBreederApplicationUncheckedCreateNestedManyWithoutAccountInput>;
  birthday?: InputMaybe<Scalars['DateTime']['input']>;
  bookings?: InputMaybe<BookingUncheckedCreateNestedManyWithoutAccountInput>;
  bookmarks?: InputMaybe<BookmarkUncheckedCreateNestedManyWithoutAccountInput>;
  connectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  contactPreferences?: InputMaybe<Array<ContactPreference>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  dogBreeder?: InputMaybe<DogBreederUncheckedCreateNestedOneWithoutAccountInput>;
  dogBreederReview?: InputMaybe<DogBreederReviewUncheckedCreateNestedManyWithoutAccountInput>;
  draftApplicationReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  email: Scalars['String']['input'];
  emailContact?: InputMaybe<EmailContactUncheckedCreateNestedOneWithoutAccountInput>;
  emailHistory?: InputMaybe<EmailHistoryUncheckedCreateNestedManyWithoutAccountInput>;
  facebookId?: InputMaybe<Scalars['String']['input']>;
  firebaseId?: InputMaybe<Scalars['String']['input']>;
  firebaseToken?: InputMaybe<Scalars['String']['input']>;
  firstAccountConversations?: InputMaybe<ConversationUncheckedCreateNestedManyWithoutFirstAccountInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  freeApplicationsDateLimit?: InputMaybe<Scalars['DateTime']['input']>;
  gender?: InputMaybe<GenderEnum>;
  googleId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  language: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  mailjetId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notifications?: InputMaybe<NotificationUncheckedCreateNestedManyWithoutAccountInput>;
  password?: InputMaybe<Scalars['String']['input']>;
  payLaterReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  payments?: InputMaybe<PaymentUncheckedCreateNestedManyWithoutAccountInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  receivedMessages?: InputMaybe<MessageUncheckedCreateNestedManyWithoutToAccountInput>;
  registrationToken?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Role>;
  secondAccountConversations?: InputMaybe<ConversationUncheckedCreateNestedManyWithoutSecondAccountInput>;
  sentMessages?: InputMaybe<MessageUncheckedCreateNestedManyWithoutFromAccountInput>;
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updates?: InputMaybe<UpdateUncheckedCreateNestedManyWithoutAccountInput>;
};

export type AccountUncheckedCreateWithoutNotificationsInput = {
  EducatorReviews?: InputMaybe<EducatorReviewUncheckedCreateNestedManyWithoutAccountInput>;
  activated?: InputMaybe<Scalars['Boolean']['input']>;
  activeCampaignContactId?: InputMaybe<Scalars['String']['input']>;
  activityLogs?: InputMaybe<AccountActivityUncheckedCreateNestedManyWithoutAccountInput>;
  addressId?: InputMaybe<Scalars['Int']['input']>;
  adminNotes?: InputMaybe<AdminNoteUncheckedCreateNestedManyWithoutAccountInput>;
  animals?: InputMaybe<AnimalUncheckedCreateNestedManyWithoutOwnerInput>;
  applicationReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  applications?: InputMaybe<DogBreederApplicationUncheckedCreateNestedManyWithoutAccountInput>;
  birthday?: InputMaybe<Scalars['DateTime']['input']>;
  bookings?: InputMaybe<BookingUncheckedCreateNestedManyWithoutAccountInput>;
  bookmarks?: InputMaybe<BookmarkUncheckedCreateNestedManyWithoutAccountInput>;
  connectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  contactPreferences?: InputMaybe<Array<ContactPreference>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  dogBreeder?: InputMaybe<DogBreederUncheckedCreateNestedOneWithoutAccountInput>;
  dogBreederReview?: InputMaybe<DogBreederReviewUncheckedCreateNestedManyWithoutAccountInput>;
  draftApplicationReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  email: Scalars['String']['input'];
  emailContact?: InputMaybe<EmailContactUncheckedCreateNestedOneWithoutAccountInput>;
  emailHistory?: InputMaybe<EmailHistoryUncheckedCreateNestedManyWithoutAccountInput>;
  facebookId?: InputMaybe<Scalars['String']['input']>;
  firebaseId?: InputMaybe<Scalars['String']['input']>;
  firebaseToken?: InputMaybe<Scalars['String']['input']>;
  firstAccountConversations?: InputMaybe<ConversationUncheckedCreateNestedManyWithoutFirstAccountInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  freeApplicationsDateLimit?: InputMaybe<Scalars['DateTime']['input']>;
  gender?: InputMaybe<GenderEnum>;
  googleId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  imgs?: InputMaybe<AccountImgUncheckedCreateNestedManyWithoutAccountInput>;
  language: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  mailjetId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  payLaterReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  payments?: InputMaybe<PaymentUncheckedCreateNestedManyWithoutAccountInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  receivedMessages?: InputMaybe<MessageUncheckedCreateNestedManyWithoutToAccountInput>;
  registrationToken?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Role>;
  secondAccountConversations?: InputMaybe<ConversationUncheckedCreateNestedManyWithoutSecondAccountInput>;
  sentMessages?: InputMaybe<MessageUncheckedCreateNestedManyWithoutFromAccountInput>;
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updates?: InputMaybe<UpdateUncheckedCreateNestedManyWithoutAccountInput>;
};

export type AccountUncheckedCreateWithoutPaymentsInput = {
  EducatorReviews?: InputMaybe<EducatorReviewUncheckedCreateNestedManyWithoutAccountInput>;
  activated?: InputMaybe<Scalars['Boolean']['input']>;
  activeCampaignContactId?: InputMaybe<Scalars['String']['input']>;
  activityLogs?: InputMaybe<AccountActivityUncheckedCreateNestedManyWithoutAccountInput>;
  addressId?: InputMaybe<Scalars['Int']['input']>;
  adminNotes?: InputMaybe<AdminNoteUncheckedCreateNestedManyWithoutAccountInput>;
  animals?: InputMaybe<AnimalUncheckedCreateNestedManyWithoutOwnerInput>;
  applicationReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  applications?: InputMaybe<DogBreederApplicationUncheckedCreateNestedManyWithoutAccountInput>;
  birthday?: InputMaybe<Scalars['DateTime']['input']>;
  bookings?: InputMaybe<BookingUncheckedCreateNestedManyWithoutAccountInput>;
  bookmarks?: InputMaybe<BookmarkUncheckedCreateNestedManyWithoutAccountInput>;
  connectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  contactPreferences?: InputMaybe<Array<ContactPreference>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  dogBreeder?: InputMaybe<DogBreederUncheckedCreateNestedOneWithoutAccountInput>;
  dogBreederReview?: InputMaybe<DogBreederReviewUncheckedCreateNestedManyWithoutAccountInput>;
  draftApplicationReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  email: Scalars['String']['input'];
  emailContact?: InputMaybe<EmailContactUncheckedCreateNestedOneWithoutAccountInput>;
  emailHistory?: InputMaybe<EmailHistoryUncheckedCreateNestedManyWithoutAccountInput>;
  facebookId?: InputMaybe<Scalars['String']['input']>;
  firebaseId?: InputMaybe<Scalars['String']['input']>;
  firebaseToken?: InputMaybe<Scalars['String']['input']>;
  firstAccountConversations?: InputMaybe<ConversationUncheckedCreateNestedManyWithoutFirstAccountInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  freeApplicationsDateLimit?: InputMaybe<Scalars['DateTime']['input']>;
  gender?: InputMaybe<GenderEnum>;
  googleId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  imgs?: InputMaybe<AccountImgUncheckedCreateNestedManyWithoutAccountInput>;
  language: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  mailjetId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notifications?: InputMaybe<NotificationUncheckedCreateNestedManyWithoutAccountInput>;
  password?: InputMaybe<Scalars['String']['input']>;
  payLaterReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  receivedMessages?: InputMaybe<MessageUncheckedCreateNestedManyWithoutToAccountInput>;
  registrationToken?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Role>;
  secondAccountConversations?: InputMaybe<ConversationUncheckedCreateNestedManyWithoutSecondAccountInput>;
  sentMessages?: InputMaybe<MessageUncheckedCreateNestedManyWithoutFromAccountInput>;
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updates?: InputMaybe<UpdateUncheckedCreateNestedManyWithoutAccountInput>;
};

export type AccountUncheckedCreateWithoutReceivedMessagesInput = {
  EducatorReviews?: InputMaybe<EducatorReviewUncheckedCreateNestedManyWithoutAccountInput>;
  activated?: InputMaybe<Scalars['Boolean']['input']>;
  activeCampaignContactId?: InputMaybe<Scalars['String']['input']>;
  activityLogs?: InputMaybe<AccountActivityUncheckedCreateNestedManyWithoutAccountInput>;
  addressId?: InputMaybe<Scalars['Int']['input']>;
  adminNotes?: InputMaybe<AdminNoteUncheckedCreateNestedManyWithoutAccountInput>;
  animals?: InputMaybe<AnimalUncheckedCreateNestedManyWithoutOwnerInput>;
  applicationReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  applications?: InputMaybe<DogBreederApplicationUncheckedCreateNestedManyWithoutAccountInput>;
  birthday?: InputMaybe<Scalars['DateTime']['input']>;
  bookings?: InputMaybe<BookingUncheckedCreateNestedManyWithoutAccountInput>;
  bookmarks?: InputMaybe<BookmarkUncheckedCreateNestedManyWithoutAccountInput>;
  connectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  contactPreferences?: InputMaybe<Array<ContactPreference>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  dogBreeder?: InputMaybe<DogBreederUncheckedCreateNestedOneWithoutAccountInput>;
  dogBreederReview?: InputMaybe<DogBreederReviewUncheckedCreateNestedManyWithoutAccountInput>;
  draftApplicationReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  email: Scalars['String']['input'];
  emailContact?: InputMaybe<EmailContactUncheckedCreateNestedOneWithoutAccountInput>;
  emailHistory?: InputMaybe<EmailHistoryUncheckedCreateNestedManyWithoutAccountInput>;
  facebookId?: InputMaybe<Scalars['String']['input']>;
  firebaseId?: InputMaybe<Scalars['String']['input']>;
  firebaseToken?: InputMaybe<Scalars['String']['input']>;
  firstAccountConversations?: InputMaybe<ConversationUncheckedCreateNestedManyWithoutFirstAccountInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  freeApplicationsDateLimit?: InputMaybe<Scalars['DateTime']['input']>;
  gender?: InputMaybe<GenderEnum>;
  googleId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  imgs?: InputMaybe<AccountImgUncheckedCreateNestedManyWithoutAccountInput>;
  language: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  mailjetId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notifications?: InputMaybe<NotificationUncheckedCreateNestedManyWithoutAccountInput>;
  password?: InputMaybe<Scalars['String']['input']>;
  payLaterReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  payments?: InputMaybe<PaymentUncheckedCreateNestedManyWithoutAccountInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  registrationToken?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Role>;
  secondAccountConversations?: InputMaybe<ConversationUncheckedCreateNestedManyWithoutSecondAccountInput>;
  sentMessages?: InputMaybe<MessageUncheckedCreateNestedManyWithoutFromAccountInput>;
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updates?: InputMaybe<UpdateUncheckedCreateNestedManyWithoutAccountInput>;
};

export type AccountUncheckedCreateWithoutSecondAccountConversationsInput = {
  EducatorReviews?: InputMaybe<EducatorReviewUncheckedCreateNestedManyWithoutAccountInput>;
  activated?: InputMaybe<Scalars['Boolean']['input']>;
  activeCampaignContactId?: InputMaybe<Scalars['String']['input']>;
  activityLogs?: InputMaybe<AccountActivityUncheckedCreateNestedManyWithoutAccountInput>;
  addressId?: InputMaybe<Scalars['Int']['input']>;
  adminNotes?: InputMaybe<AdminNoteUncheckedCreateNestedManyWithoutAccountInput>;
  animals?: InputMaybe<AnimalUncheckedCreateNestedManyWithoutOwnerInput>;
  applicationReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  applications?: InputMaybe<DogBreederApplicationUncheckedCreateNestedManyWithoutAccountInput>;
  birthday?: InputMaybe<Scalars['DateTime']['input']>;
  bookings?: InputMaybe<BookingUncheckedCreateNestedManyWithoutAccountInput>;
  bookmarks?: InputMaybe<BookmarkUncheckedCreateNestedManyWithoutAccountInput>;
  connectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  contactPreferences?: InputMaybe<Array<ContactPreference>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  dogBreeder?: InputMaybe<DogBreederUncheckedCreateNestedOneWithoutAccountInput>;
  dogBreederReview?: InputMaybe<DogBreederReviewUncheckedCreateNestedManyWithoutAccountInput>;
  draftApplicationReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  email: Scalars['String']['input'];
  emailContact?: InputMaybe<EmailContactUncheckedCreateNestedOneWithoutAccountInput>;
  emailHistory?: InputMaybe<EmailHistoryUncheckedCreateNestedManyWithoutAccountInput>;
  facebookId?: InputMaybe<Scalars['String']['input']>;
  firebaseId?: InputMaybe<Scalars['String']['input']>;
  firebaseToken?: InputMaybe<Scalars['String']['input']>;
  firstAccountConversations?: InputMaybe<ConversationUncheckedCreateNestedManyWithoutFirstAccountInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  freeApplicationsDateLimit?: InputMaybe<Scalars['DateTime']['input']>;
  gender?: InputMaybe<GenderEnum>;
  googleId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  imgs?: InputMaybe<AccountImgUncheckedCreateNestedManyWithoutAccountInput>;
  language: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  mailjetId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notifications?: InputMaybe<NotificationUncheckedCreateNestedManyWithoutAccountInput>;
  password?: InputMaybe<Scalars['String']['input']>;
  payLaterReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  payments?: InputMaybe<PaymentUncheckedCreateNestedManyWithoutAccountInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  receivedMessages?: InputMaybe<MessageUncheckedCreateNestedManyWithoutToAccountInput>;
  registrationToken?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Role>;
  sentMessages?: InputMaybe<MessageUncheckedCreateNestedManyWithoutFromAccountInput>;
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updates?: InputMaybe<UpdateUncheckedCreateNestedManyWithoutAccountInput>;
};

export type AccountUncheckedCreateWithoutSentMessagesInput = {
  EducatorReviews?: InputMaybe<EducatorReviewUncheckedCreateNestedManyWithoutAccountInput>;
  activated?: InputMaybe<Scalars['Boolean']['input']>;
  activeCampaignContactId?: InputMaybe<Scalars['String']['input']>;
  activityLogs?: InputMaybe<AccountActivityUncheckedCreateNestedManyWithoutAccountInput>;
  addressId?: InputMaybe<Scalars['Int']['input']>;
  adminNotes?: InputMaybe<AdminNoteUncheckedCreateNestedManyWithoutAccountInput>;
  animals?: InputMaybe<AnimalUncheckedCreateNestedManyWithoutOwnerInput>;
  applicationReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  applications?: InputMaybe<DogBreederApplicationUncheckedCreateNestedManyWithoutAccountInput>;
  birthday?: InputMaybe<Scalars['DateTime']['input']>;
  bookings?: InputMaybe<BookingUncheckedCreateNestedManyWithoutAccountInput>;
  bookmarks?: InputMaybe<BookmarkUncheckedCreateNestedManyWithoutAccountInput>;
  connectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  contactPreferences?: InputMaybe<Array<ContactPreference>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  dogBreeder?: InputMaybe<DogBreederUncheckedCreateNestedOneWithoutAccountInput>;
  dogBreederReview?: InputMaybe<DogBreederReviewUncheckedCreateNestedManyWithoutAccountInput>;
  draftApplicationReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  email: Scalars['String']['input'];
  emailContact?: InputMaybe<EmailContactUncheckedCreateNestedOneWithoutAccountInput>;
  emailHistory?: InputMaybe<EmailHistoryUncheckedCreateNestedManyWithoutAccountInput>;
  facebookId?: InputMaybe<Scalars['String']['input']>;
  firebaseId?: InputMaybe<Scalars['String']['input']>;
  firebaseToken?: InputMaybe<Scalars['String']['input']>;
  firstAccountConversations?: InputMaybe<ConversationUncheckedCreateNestedManyWithoutFirstAccountInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  freeApplicationsDateLimit?: InputMaybe<Scalars['DateTime']['input']>;
  gender?: InputMaybe<GenderEnum>;
  googleId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  imgs?: InputMaybe<AccountImgUncheckedCreateNestedManyWithoutAccountInput>;
  language: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  mailjetId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notifications?: InputMaybe<NotificationUncheckedCreateNestedManyWithoutAccountInput>;
  password?: InputMaybe<Scalars['String']['input']>;
  payLaterReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  payments?: InputMaybe<PaymentUncheckedCreateNestedManyWithoutAccountInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  receivedMessages?: InputMaybe<MessageUncheckedCreateNestedManyWithoutToAccountInput>;
  registrationToken?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Role>;
  secondAccountConversations?: InputMaybe<ConversationUncheckedCreateNestedManyWithoutSecondAccountInput>;
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updates?: InputMaybe<UpdateUncheckedCreateNestedManyWithoutAccountInput>;
};

export type AccountUncheckedCreateWithoutUpdatesInput = {
  EducatorReviews?: InputMaybe<EducatorReviewUncheckedCreateNestedManyWithoutAccountInput>;
  activated?: InputMaybe<Scalars['Boolean']['input']>;
  activeCampaignContactId?: InputMaybe<Scalars['String']['input']>;
  activityLogs?: InputMaybe<AccountActivityUncheckedCreateNestedManyWithoutAccountInput>;
  addressId?: InputMaybe<Scalars['Int']['input']>;
  adminNotes?: InputMaybe<AdminNoteUncheckedCreateNestedManyWithoutAccountInput>;
  animals?: InputMaybe<AnimalUncheckedCreateNestedManyWithoutOwnerInput>;
  applicationReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  applications?: InputMaybe<DogBreederApplicationUncheckedCreateNestedManyWithoutAccountInput>;
  birthday?: InputMaybe<Scalars['DateTime']['input']>;
  bookings?: InputMaybe<BookingUncheckedCreateNestedManyWithoutAccountInput>;
  bookmarks?: InputMaybe<BookmarkUncheckedCreateNestedManyWithoutAccountInput>;
  connectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  contactPreferences?: InputMaybe<Array<ContactPreference>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  dogBreeder?: InputMaybe<DogBreederUncheckedCreateNestedOneWithoutAccountInput>;
  dogBreederReview?: InputMaybe<DogBreederReviewUncheckedCreateNestedManyWithoutAccountInput>;
  draftApplicationReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  email: Scalars['String']['input'];
  emailContact?: InputMaybe<EmailContactUncheckedCreateNestedOneWithoutAccountInput>;
  emailHistory?: InputMaybe<EmailHistoryUncheckedCreateNestedManyWithoutAccountInput>;
  facebookId?: InputMaybe<Scalars['String']['input']>;
  firebaseId?: InputMaybe<Scalars['String']['input']>;
  firebaseToken?: InputMaybe<Scalars['String']['input']>;
  firstAccountConversations?: InputMaybe<ConversationUncheckedCreateNestedManyWithoutFirstAccountInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  freeApplicationsDateLimit?: InputMaybe<Scalars['DateTime']['input']>;
  gender?: InputMaybe<GenderEnum>;
  googleId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  imgs?: InputMaybe<AccountImgUncheckedCreateNestedManyWithoutAccountInput>;
  language: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  mailjetId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notifications?: InputMaybe<NotificationUncheckedCreateNestedManyWithoutAccountInput>;
  password?: InputMaybe<Scalars['String']['input']>;
  payLaterReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  payments?: InputMaybe<PaymentUncheckedCreateNestedManyWithoutAccountInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  receivedMessages?: InputMaybe<MessageUncheckedCreateNestedManyWithoutToAccountInput>;
  registrationToken?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Role>;
  secondAccountConversations?: InputMaybe<ConversationUncheckedCreateNestedManyWithoutSecondAccountInput>;
  sentMessages?: InputMaybe<MessageUncheckedCreateNestedManyWithoutFromAccountInput>;
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AccountUncheckedUpdateInput = {
  EducatorReviews?: InputMaybe<EducatorReviewUncheckedUpdateManyWithoutAccountNestedInput>;
  activated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  activeCampaignContactId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  activityLogs?: InputMaybe<AccountActivityUncheckedUpdateManyWithoutAccountNestedInput>;
  addressId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  adminNotes?: InputMaybe<AdminNoteUncheckedUpdateManyWithoutAccountNestedInput>;
  animals?: InputMaybe<AnimalUncheckedUpdateManyWithoutOwnerNestedInput>;
  applicationReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  applications?: InputMaybe<DogBreederApplicationUncheckedUpdateManyWithoutAccountNestedInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  bookings?: InputMaybe<BookingUncheckedUpdateManyWithoutAccountNestedInput>;
  bookmarks?: InputMaybe<BookmarkUncheckedUpdateManyWithoutAccountNestedInput>;
  connectedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  contactPreferences?: InputMaybe<Array<ContactPreference>>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deleted?: InputMaybe<BoolFieldUpdateOperationsInput>;
  dogBreeder?: InputMaybe<DogBreederUncheckedUpdateOneWithoutAccountNestedInput>;
  dogBreederReview?: InputMaybe<DogBreederReviewUncheckedUpdateManyWithoutAccountNestedInput>;
  draftApplicationReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailContact?: InputMaybe<EmailContactUncheckedUpdateOneWithoutAccountNestedInput>;
  emailHistory?: InputMaybe<EmailHistoryUncheckedUpdateManyWithoutAccountNestedInput>;
  facebookId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firebaseId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firebaseToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstAccountConversations?: InputMaybe<ConversationUncheckedUpdateManyWithoutFirstAccountNestedInput>;
  firstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freeApplicationsDateLimit?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableEnumGenderEnumFieldUpdateOperationsInput>;
  googleId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  imgs?: InputMaybe<AccountImgUncheckedUpdateManyWithoutAccountNestedInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mailjetId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUncheckedUpdateManyWithoutAccountNestedInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payLaterReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  payments?: InputMaybe<PaymentUncheckedUpdateManyWithoutAccountNestedInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  receivedMessages?: InputMaybe<MessageUncheckedUpdateManyWithoutToAccountNestedInput>;
  registrationToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  role?: InputMaybe<EnumRoleFieldUpdateOperationsInput>;
  secondAccountConversations?: InputMaybe<ConversationUncheckedUpdateManyWithoutSecondAccountNestedInput>;
  sentMessages?: InputMaybe<MessageUncheckedUpdateManyWithoutFromAccountNestedInput>;
  stripeCustomerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updates?: InputMaybe<UpdateUncheckedUpdateManyWithoutAccountNestedInput>;
};

export type AccountUncheckedUpdateManyInput = {
  activated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  activeCampaignContactId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  applicationReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  connectedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  contactPreferences?: InputMaybe<Array<ContactPreference>>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deleted?: InputMaybe<BoolFieldUpdateOperationsInput>;
  draftApplicationReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  facebookId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firebaseId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firebaseToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freeApplicationsDateLimit?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableEnumGenderEnumFieldUpdateOperationsInput>;
  googleId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mailjetId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payLaterReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registrationToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  role?: InputMaybe<EnumRoleFieldUpdateOperationsInput>;
  stripeCustomerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type AccountUncheckedUpdateOneWithoutAddressNestedInput = {
  connect?: InputMaybe<AccountWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AccountCreateOrConnectWithoutAddressInput>;
  create?: InputMaybe<AccountCreateWithoutAddressInput>;
  delete?: InputMaybe<AccountWhereInput>;
  disconnect?: InputMaybe<AccountWhereInput>;
  update?: InputMaybe<AccountUpdateToOneWithWhereWithoutAddressInput>;
  upsert?: InputMaybe<AccountUpsertWithoutAddressInput>;
};

export type AccountUncheckedUpdateWithoutActivityLogsInput = {
  EducatorReviews?: InputMaybe<EducatorReviewUncheckedUpdateManyWithoutAccountNestedInput>;
  activated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  activeCampaignContactId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  addressId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  adminNotes?: InputMaybe<AdminNoteUncheckedUpdateManyWithoutAccountNestedInput>;
  animals?: InputMaybe<AnimalUncheckedUpdateManyWithoutOwnerNestedInput>;
  applicationReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  applications?: InputMaybe<DogBreederApplicationUncheckedUpdateManyWithoutAccountNestedInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  bookings?: InputMaybe<BookingUncheckedUpdateManyWithoutAccountNestedInput>;
  bookmarks?: InputMaybe<BookmarkUncheckedUpdateManyWithoutAccountNestedInput>;
  connectedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  contactPreferences?: InputMaybe<Array<ContactPreference>>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deleted?: InputMaybe<BoolFieldUpdateOperationsInput>;
  dogBreeder?: InputMaybe<DogBreederUncheckedUpdateOneWithoutAccountNestedInput>;
  dogBreederReview?: InputMaybe<DogBreederReviewUncheckedUpdateManyWithoutAccountNestedInput>;
  draftApplicationReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailContact?: InputMaybe<EmailContactUncheckedUpdateOneWithoutAccountNestedInput>;
  emailHistory?: InputMaybe<EmailHistoryUncheckedUpdateManyWithoutAccountNestedInput>;
  facebookId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firebaseId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firebaseToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstAccountConversations?: InputMaybe<ConversationUncheckedUpdateManyWithoutFirstAccountNestedInput>;
  firstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freeApplicationsDateLimit?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableEnumGenderEnumFieldUpdateOperationsInput>;
  googleId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  imgs?: InputMaybe<AccountImgUncheckedUpdateManyWithoutAccountNestedInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mailjetId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUncheckedUpdateManyWithoutAccountNestedInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payLaterReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  payments?: InputMaybe<PaymentUncheckedUpdateManyWithoutAccountNestedInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  receivedMessages?: InputMaybe<MessageUncheckedUpdateManyWithoutToAccountNestedInput>;
  registrationToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  role?: InputMaybe<EnumRoleFieldUpdateOperationsInput>;
  secondAccountConversations?: InputMaybe<ConversationUncheckedUpdateManyWithoutSecondAccountNestedInput>;
  sentMessages?: InputMaybe<MessageUncheckedUpdateManyWithoutFromAccountNestedInput>;
  stripeCustomerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updates?: InputMaybe<UpdateUncheckedUpdateManyWithoutAccountNestedInput>;
};

export type AccountUncheckedUpdateWithoutAddressInput = {
  EducatorReviews?: InputMaybe<EducatorReviewUncheckedUpdateManyWithoutAccountNestedInput>;
  activated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  activeCampaignContactId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  activityLogs?: InputMaybe<AccountActivityUncheckedUpdateManyWithoutAccountNestedInput>;
  adminNotes?: InputMaybe<AdminNoteUncheckedUpdateManyWithoutAccountNestedInput>;
  animals?: InputMaybe<AnimalUncheckedUpdateManyWithoutOwnerNestedInput>;
  applicationReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  applications?: InputMaybe<DogBreederApplicationUncheckedUpdateManyWithoutAccountNestedInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  bookings?: InputMaybe<BookingUncheckedUpdateManyWithoutAccountNestedInput>;
  bookmarks?: InputMaybe<BookmarkUncheckedUpdateManyWithoutAccountNestedInput>;
  connectedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  contactPreferences?: InputMaybe<Array<ContactPreference>>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deleted?: InputMaybe<BoolFieldUpdateOperationsInput>;
  dogBreeder?: InputMaybe<DogBreederUncheckedUpdateOneWithoutAccountNestedInput>;
  dogBreederReview?: InputMaybe<DogBreederReviewUncheckedUpdateManyWithoutAccountNestedInput>;
  draftApplicationReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailContact?: InputMaybe<EmailContactUncheckedUpdateOneWithoutAccountNestedInput>;
  emailHistory?: InputMaybe<EmailHistoryUncheckedUpdateManyWithoutAccountNestedInput>;
  facebookId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firebaseId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firebaseToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstAccountConversations?: InputMaybe<ConversationUncheckedUpdateManyWithoutFirstAccountNestedInput>;
  firstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freeApplicationsDateLimit?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableEnumGenderEnumFieldUpdateOperationsInput>;
  googleId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  imgs?: InputMaybe<AccountImgUncheckedUpdateManyWithoutAccountNestedInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mailjetId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUncheckedUpdateManyWithoutAccountNestedInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payLaterReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  payments?: InputMaybe<PaymentUncheckedUpdateManyWithoutAccountNestedInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  receivedMessages?: InputMaybe<MessageUncheckedUpdateManyWithoutToAccountNestedInput>;
  registrationToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  role?: InputMaybe<EnumRoleFieldUpdateOperationsInput>;
  secondAccountConversations?: InputMaybe<ConversationUncheckedUpdateManyWithoutSecondAccountNestedInput>;
  sentMessages?: InputMaybe<MessageUncheckedUpdateManyWithoutFromAccountNestedInput>;
  stripeCustomerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updates?: InputMaybe<UpdateUncheckedUpdateManyWithoutAccountNestedInput>;
};

export type AccountUncheckedUpdateWithoutAdminNotesInput = {
  EducatorReviews?: InputMaybe<EducatorReviewUncheckedUpdateManyWithoutAccountNestedInput>;
  activated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  activeCampaignContactId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  activityLogs?: InputMaybe<AccountActivityUncheckedUpdateManyWithoutAccountNestedInput>;
  addressId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  animals?: InputMaybe<AnimalUncheckedUpdateManyWithoutOwnerNestedInput>;
  applicationReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  applications?: InputMaybe<DogBreederApplicationUncheckedUpdateManyWithoutAccountNestedInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  bookings?: InputMaybe<BookingUncheckedUpdateManyWithoutAccountNestedInput>;
  bookmarks?: InputMaybe<BookmarkUncheckedUpdateManyWithoutAccountNestedInput>;
  connectedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  contactPreferences?: InputMaybe<Array<ContactPreference>>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deleted?: InputMaybe<BoolFieldUpdateOperationsInput>;
  dogBreeder?: InputMaybe<DogBreederUncheckedUpdateOneWithoutAccountNestedInput>;
  dogBreederReview?: InputMaybe<DogBreederReviewUncheckedUpdateManyWithoutAccountNestedInput>;
  draftApplicationReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailContact?: InputMaybe<EmailContactUncheckedUpdateOneWithoutAccountNestedInput>;
  emailHistory?: InputMaybe<EmailHistoryUncheckedUpdateManyWithoutAccountNestedInput>;
  facebookId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firebaseId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firebaseToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstAccountConversations?: InputMaybe<ConversationUncheckedUpdateManyWithoutFirstAccountNestedInput>;
  firstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freeApplicationsDateLimit?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableEnumGenderEnumFieldUpdateOperationsInput>;
  googleId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  imgs?: InputMaybe<AccountImgUncheckedUpdateManyWithoutAccountNestedInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mailjetId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUncheckedUpdateManyWithoutAccountNestedInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payLaterReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  payments?: InputMaybe<PaymentUncheckedUpdateManyWithoutAccountNestedInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  receivedMessages?: InputMaybe<MessageUncheckedUpdateManyWithoutToAccountNestedInput>;
  registrationToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  role?: InputMaybe<EnumRoleFieldUpdateOperationsInput>;
  secondAccountConversations?: InputMaybe<ConversationUncheckedUpdateManyWithoutSecondAccountNestedInput>;
  sentMessages?: InputMaybe<MessageUncheckedUpdateManyWithoutFromAccountNestedInput>;
  stripeCustomerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updates?: InputMaybe<UpdateUncheckedUpdateManyWithoutAccountNestedInput>;
};

export type AccountUncheckedUpdateWithoutAnimalsInput = {
  EducatorReviews?: InputMaybe<EducatorReviewUncheckedUpdateManyWithoutAccountNestedInput>;
  activated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  activeCampaignContactId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  activityLogs?: InputMaybe<AccountActivityUncheckedUpdateManyWithoutAccountNestedInput>;
  addressId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  adminNotes?: InputMaybe<AdminNoteUncheckedUpdateManyWithoutAccountNestedInput>;
  applicationReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  applications?: InputMaybe<DogBreederApplicationUncheckedUpdateManyWithoutAccountNestedInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  bookings?: InputMaybe<BookingUncheckedUpdateManyWithoutAccountNestedInput>;
  bookmarks?: InputMaybe<BookmarkUncheckedUpdateManyWithoutAccountNestedInput>;
  connectedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  contactPreferences?: InputMaybe<Array<ContactPreference>>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deleted?: InputMaybe<BoolFieldUpdateOperationsInput>;
  dogBreeder?: InputMaybe<DogBreederUncheckedUpdateOneWithoutAccountNestedInput>;
  dogBreederReview?: InputMaybe<DogBreederReviewUncheckedUpdateManyWithoutAccountNestedInput>;
  draftApplicationReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailContact?: InputMaybe<EmailContactUncheckedUpdateOneWithoutAccountNestedInput>;
  emailHistory?: InputMaybe<EmailHistoryUncheckedUpdateManyWithoutAccountNestedInput>;
  facebookId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firebaseId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firebaseToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstAccountConversations?: InputMaybe<ConversationUncheckedUpdateManyWithoutFirstAccountNestedInput>;
  firstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freeApplicationsDateLimit?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableEnumGenderEnumFieldUpdateOperationsInput>;
  googleId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  imgs?: InputMaybe<AccountImgUncheckedUpdateManyWithoutAccountNestedInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mailjetId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUncheckedUpdateManyWithoutAccountNestedInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payLaterReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  payments?: InputMaybe<PaymentUncheckedUpdateManyWithoutAccountNestedInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  receivedMessages?: InputMaybe<MessageUncheckedUpdateManyWithoutToAccountNestedInput>;
  registrationToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  role?: InputMaybe<EnumRoleFieldUpdateOperationsInput>;
  secondAccountConversations?: InputMaybe<ConversationUncheckedUpdateManyWithoutSecondAccountNestedInput>;
  sentMessages?: InputMaybe<MessageUncheckedUpdateManyWithoutFromAccountNestedInput>;
  stripeCustomerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updates?: InputMaybe<UpdateUncheckedUpdateManyWithoutAccountNestedInput>;
};

export type AccountUncheckedUpdateWithoutApplicationsInput = {
  EducatorReviews?: InputMaybe<EducatorReviewUncheckedUpdateManyWithoutAccountNestedInput>;
  activated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  activeCampaignContactId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  activityLogs?: InputMaybe<AccountActivityUncheckedUpdateManyWithoutAccountNestedInput>;
  addressId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  adminNotes?: InputMaybe<AdminNoteUncheckedUpdateManyWithoutAccountNestedInput>;
  animals?: InputMaybe<AnimalUncheckedUpdateManyWithoutOwnerNestedInput>;
  applicationReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  bookings?: InputMaybe<BookingUncheckedUpdateManyWithoutAccountNestedInput>;
  bookmarks?: InputMaybe<BookmarkUncheckedUpdateManyWithoutAccountNestedInput>;
  connectedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  contactPreferences?: InputMaybe<Array<ContactPreference>>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deleted?: InputMaybe<BoolFieldUpdateOperationsInput>;
  dogBreeder?: InputMaybe<DogBreederUncheckedUpdateOneWithoutAccountNestedInput>;
  dogBreederReview?: InputMaybe<DogBreederReviewUncheckedUpdateManyWithoutAccountNestedInput>;
  draftApplicationReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailContact?: InputMaybe<EmailContactUncheckedUpdateOneWithoutAccountNestedInput>;
  emailHistory?: InputMaybe<EmailHistoryUncheckedUpdateManyWithoutAccountNestedInput>;
  facebookId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firebaseId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firebaseToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstAccountConversations?: InputMaybe<ConversationUncheckedUpdateManyWithoutFirstAccountNestedInput>;
  firstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freeApplicationsDateLimit?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableEnumGenderEnumFieldUpdateOperationsInput>;
  googleId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  imgs?: InputMaybe<AccountImgUncheckedUpdateManyWithoutAccountNestedInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mailjetId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUncheckedUpdateManyWithoutAccountNestedInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payLaterReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  payments?: InputMaybe<PaymentUncheckedUpdateManyWithoutAccountNestedInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  receivedMessages?: InputMaybe<MessageUncheckedUpdateManyWithoutToAccountNestedInput>;
  registrationToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  role?: InputMaybe<EnumRoleFieldUpdateOperationsInput>;
  secondAccountConversations?: InputMaybe<ConversationUncheckedUpdateManyWithoutSecondAccountNestedInput>;
  sentMessages?: InputMaybe<MessageUncheckedUpdateManyWithoutFromAccountNestedInput>;
  stripeCustomerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updates?: InputMaybe<UpdateUncheckedUpdateManyWithoutAccountNestedInput>;
};

export type AccountUncheckedUpdateWithoutBookingsInput = {
  EducatorReviews?: InputMaybe<EducatorReviewUncheckedUpdateManyWithoutAccountNestedInput>;
  activated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  activeCampaignContactId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  activityLogs?: InputMaybe<AccountActivityUncheckedUpdateManyWithoutAccountNestedInput>;
  addressId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  adminNotes?: InputMaybe<AdminNoteUncheckedUpdateManyWithoutAccountNestedInput>;
  animals?: InputMaybe<AnimalUncheckedUpdateManyWithoutOwnerNestedInput>;
  applicationReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  applications?: InputMaybe<DogBreederApplicationUncheckedUpdateManyWithoutAccountNestedInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  bookmarks?: InputMaybe<BookmarkUncheckedUpdateManyWithoutAccountNestedInput>;
  connectedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  contactPreferences?: InputMaybe<Array<ContactPreference>>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deleted?: InputMaybe<BoolFieldUpdateOperationsInput>;
  dogBreeder?: InputMaybe<DogBreederUncheckedUpdateOneWithoutAccountNestedInput>;
  dogBreederReview?: InputMaybe<DogBreederReviewUncheckedUpdateManyWithoutAccountNestedInput>;
  draftApplicationReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailContact?: InputMaybe<EmailContactUncheckedUpdateOneWithoutAccountNestedInput>;
  emailHistory?: InputMaybe<EmailHistoryUncheckedUpdateManyWithoutAccountNestedInput>;
  facebookId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firebaseId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firebaseToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstAccountConversations?: InputMaybe<ConversationUncheckedUpdateManyWithoutFirstAccountNestedInput>;
  firstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freeApplicationsDateLimit?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableEnumGenderEnumFieldUpdateOperationsInput>;
  googleId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  imgs?: InputMaybe<AccountImgUncheckedUpdateManyWithoutAccountNestedInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mailjetId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUncheckedUpdateManyWithoutAccountNestedInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payLaterReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  payments?: InputMaybe<PaymentUncheckedUpdateManyWithoutAccountNestedInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  receivedMessages?: InputMaybe<MessageUncheckedUpdateManyWithoutToAccountNestedInput>;
  registrationToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  role?: InputMaybe<EnumRoleFieldUpdateOperationsInput>;
  secondAccountConversations?: InputMaybe<ConversationUncheckedUpdateManyWithoutSecondAccountNestedInput>;
  sentMessages?: InputMaybe<MessageUncheckedUpdateManyWithoutFromAccountNestedInput>;
  stripeCustomerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updates?: InputMaybe<UpdateUncheckedUpdateManyWithoutAccountNestedInput>;
};

export type AccountUncheckedUpdateWithoutBookmarksInput = {
  EducatorReviews?: InputMaybe<EducatorReviewUncheckedUpdateManyWithoutAccountNestedInput>;
  activated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  activeCampaignContactId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  activityLogs?: InputMaybe<AccountActivityUncheckedUpdateManyWithoutAccountNestedInput>;
  addressId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  adminNotes?: InputMaybe<AdminNoteUncheckedUpdateManyWithoutAccountNestedInput>;
  animals?: InputMaybe<AnimalUncheckedUpdateManyWithoutOwnerNestedInput>;
  applicationReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  applications?: InputMaybe<DogBreederApplicationUncheckedUpdateManyWithoutAccountNestedInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  bookings?: InputMaybe<BookingUncheckedUpdateManyWithoutAccountNestedInput>;
  connectedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  contactPreferences?: InputMaybe<Array<ContactPreference>>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deleted?: InputMaybe<BoolFieldUpdateOperationsInput>;
  dogBreeder?: InputMaybe<DogBreederUncheckedUpdateOneWithoutAccountNestedInput>;
  dogBreederReview?: InputMaybe<DogBreederReviewUncheckedUpdateManyWithoutAccountNestedInput>;
  draftApplicationReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailContact?: InputMaybe<EmailContactUncheckedUpdateOneWithoutAccountNestedInput>;
  emailHistory?: InputMaybe<EmailHistoryUncheckedUpdateManyWithoutAccountNestedInput>;
  facebookId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firebaseId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firebaseToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstAccountConversations?: InputMaybe<ConversationUncheckedUpdateManyWithoutFirstAccountNestedInput>;
  firstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freeApplicationsDateLimit?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableEnumGenderEnumFieldUpdateOperationsInput>;
  googleId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  imgs?: InputMaybe<AccountImgUncheckedUpdateManyWithoutAccountNestedInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mailjetId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUncheckedUpdateManyWithoutAccountNestedInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payLaterReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  payments?: InputMaybe<PaymentUncheckedUpdateManyWithoutAccountNestedInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  receivedMessages?: InputMaybe<MessageUncheckedUpdateManyWithoutToAccountNestedInput>;
  registrationToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  role?: InputMaybe<EnumRoleFieldUpdateOperationsInput>;
  secondAccountConversations?: InputMaybe<ConversationUncheckedUpdateManyWithoutSecondAccountNestedInput>;
  sentMessages?: InputMaybe<MessageUncheckedUpdateManyWithoutFromAccountNestedInput>;
  stripeCustomerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updates?: InputMaybe<UpdateUncheckedUpdateManyWithoutAccountNestedInput>;
};

export type AccountUncheckedUpdateWithoutDogBreederInput = {
  EducatorReviews?: InputMaybe<EducatorReviewUncheckedUpdateManyWithoutAccountNestedInput>;
  activated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  activeCampaignContactId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  activityLogs?: InputMaybe<AccountActivityUncheckedUpdateManyWithoutAccountNestedInput>;
  addressId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  adminNotes?: InputMaybe<AdminNoteUncheckedUpdateManyWithoutAccountNestedInput>;
  animals?: InputMaybe<AnimalUncheckedUpdateManyWithoutOwnerNestedInput>;
  applicationReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  applications?: InputMaybe<DogBreederApplicationUncheckedUpdateManyWithoutAccountNestedInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  bookings?: InputMaybe<BookingUncheckedUpdateManyWithoutAccountNestedInput>;
  bookmarks?: InputMaybe<BookmarkUncheckedUpdateManyWithoutAccountNestedInput>;
  connectedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  contactPreferences?: InputMaybe<Array<ContactPreference>>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deleted?: InputMaybe<BoolFieldUpdateOperationsInput>;
  dogBreederReview?: InputMaybe<DogBreederReviewUncheckedUpdateManyWithoutAccountNestedInput>;
  draftApplicationReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailContact?: InputMaybe<EmailContactUncheckedUpdateOneWithoutAccountNestedInput>;
  emailHistory?: InputMaybe<EmailHistoryUncheckedUpdateManyWithoutAccountNestedInput>;
  facebookId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firebaseId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firebaseToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstAccountConversations?: InputMaybe<ConversationUncheckedUpdateManyWithoutFirstAccountNestedInput>;
  firstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freeApplicationsDateLimit?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableEnumGenderEnumFieldUpdateOperationsInput>;
  googleId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  imgs?: InputMaybe<AccountImgUncheckedUpdateManyWithoutAccountNestedInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mailjetId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUncheckedUpdateManyWithoutAccountNestedInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payLaterReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  payments?: InputMaybe<PaymentUncheckedUpdateManyWithoutAccountNestedInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  receivedMessages?: InputMaybe<MessageUncheckedUpdateManyWithoutToAccountNestedInput>;
  registrationToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  role?: InputMaybe<EnumRoleFieldUpdateOperationsInput>;
  secondAccountConversations?: InputMaybe<ConversationUncheckedUpdateManyWithoutSecondAccountNestedInput>;
  sentMessages?: InputMaybe<MessageUncheckedUpdateManyWithoutFromAccountNestedInput>;
  stripeCustomerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updates?: InputMaybe<UpdateUncheckedUpdateManyWithoutAccountNestedInput>;
};

export type AccountUncheckedUpdateWithoutDogBreederReviewInput = {
  EducatorReviews?: InputMaybe<EducatorReviewUncheckedUpdateManyWithoutAccountNestedInput>;
  activated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  activeCampaignContactId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  activityLogs?: InputMaybe<AccountActivityUncheckedUpdateManyWithoutAccountNestedInput>;
  addressId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  adminNotes?: InputMaybe<AdminNoteUncheckedUpdateManyWithoutAccountNestedInput>;
  animals?: InputMaybe<AnimalUncheckedUpdateManyWithoutOwnerNestedInput>;
  applicationReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  applications?: InputMaybe<DogBreederApplicationUncheckedUpdateManyWithoutAccountNestedInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  bookings?: InputMaybe<BookingUncheckedUpdateManyWithoutAccountNestedInput>;
  bookmarks?: InputMaybe<BookmarkUncheckedUpdateManyWithoutAccountNestedInput>;
  connectedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  contactPreferences?: InputMaybe<Array<ContactPreference>>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deleted?: InputMaybe<BoolFieldUpdateOperationsInput>;
  dogBreeder?: InputMaybe<DogBreederUncheckedUpdateOneWithoutAccountNestedInput>;
  draftApplicationReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailContact?: InputMaybe<EmailContactUncheckedUpdateOneWithoutAccountNestedInput>;
  emailHistory?: InputMaybe<EmailHistoryUncheckedUpdateManyWithoutAccountNestedInput>;
  facebookId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firebaseId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firebaseToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstAccountConversations?: InputMaybe<ConversationUncheckedUpdateManyWithoutFirstAccountNestedInput>;
  firstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freeApplicationsDateLimit?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableEnumGenderEnumFieldUpdateOperationsInput>;
  googleId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  imgs?: InputMaybe<AccountImgUncheckedUpdateManyWithoutAccountNestedInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mailjetId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUncheckedUpdateManyWithoutAccountNestedInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payLaterReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  payments?: InputMaybe<PaymentUncheckedUpdateManyWithoutAccountNestedInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  receivedMessages?: InputMaybe<MessageUncheckedUpdateManyWithoutToAccountNestedInput>;
  registrationToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  role?: InputMaybe<EnumRoleFieldUpdateOperationsInput>;
  secondAccountConversations?: InputMaybe<ConversationUncheckedUpdateManyWithoutSecondAccountNestedInput>;
  sentMessages?: InputMaybe<MessageUncheckedUpdateManyWithoutFromAccountNestedInput>;
  stripeCustomerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updates?: InputMaybe<UpdateUncheckedUpdateManyWithoutAccountNestedInput>;
};

export type AccountUncheckedUpdateWithoutEducatorReviewsInput = {
  activated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  activeCampaignContactId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  activityLogs?: InputMaybe<AccountActivityUncheckedUpdateManyWithoutAccountNestedInput>;
  addressId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  adminNotes?: InputMaybe<AdminNoteUncheckedUpdateManyWithoutAccountNestedInput>;
  animals?: InputMaybe<AnimalUncheckedUpdateManyWithoutOwnerNestedInput>;
  applicationReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  applications?: InputMaybe<DogBreederApplicationUncheckedUpdateManyWithoutAccountNestedInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  bookings?: InputMaybe<BookingUncheckedUpdateManyWithoutAccountNestedInput>;
  bookmarks?: InputMaybe<BookmarkUncheckedUpdateManyWithoutAccountNestedInput>;
  connectedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  contactPreferences?: InputMaybe<Array<ContactPreference>>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deleted?: InputMaybe<BoolFieldUpdateOperationsInput>;
  dogBreeder?: InputMaybe<DogBreederUncheckedUpdateOneWithoutAccountNestedInput>;
  dogBreederReview?: InputMaybe<DogBreederReviewUncheckedUpdateManyWithoutAccountNestedInput>;
  draftApplicationReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailContact?: InputMaybe<EmailContactUncheckedUpdateOneWithoutAccountNestedInput>;
  emailHistory?: InputMaybe<EmailHistoryUncheckedUpdateManyWithoutAccountNestedInput>;
  facebookId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firebaseId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firebaseToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstAccountConversations?: InputMaybe<ConversationUncheckedUpdateManyWithoutFirstAccountNestedInput>;
  firstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freeApplicationsDateLimit?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableEnumGenderEnumFieldUpdateOperationsInput>;
  googleId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  imgs?: InputMaybe<AccountImgUncheckedUpdateManyWithoutAccountNestedInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mailjetId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUncheckedUpdateManyWithoutAccountNestedInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payLaterReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  payments?: InputMaybe<PaymentUncheckedUpdateManyWithoutAccountNestedInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  receivedMessages?: InputMaybe<MessageUncheckedUpdateManyWithoutToAccountNestedInput>;
  registrationToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  role?: InputMaybe<EnumRoleFieldUpdateOperationsInput>;
  secondAccountConversations?: InputMaybe<ConversationUncheckedUpdateManyWithoutSecondAccountNestedInput>;
  sentMessages?: InputMaybe<MessageUncheckedUpdateManyWithoutFromAccountNestedInput>;
  stripeCustomerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updates?: InputMaybe<UpdateUncheckedUpdateManyWithoutAccountNestedInput>;
};

export type AccountUncheckedUpdateWithoutEmailContactInput = {
  EducatorReviews?: InputMaybe<EducatorReviewUncheckedUpdateManyWithoutAccountNestedInput>;
  activated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  activeCampaignContactId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  activityLogs?: InputMaybe<AccountActivityUncheckedUpdateManyWithoutAccountNestedInput>;
  addressId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  adminNotes?: InputMaybe<AdminNoteUncheckedUpdateManyWithoutAccountNestedInput>;
  animals?: InputMaybe<AnimalUncheckedUpdateManyWithoutOwnerNestedInput>;
  applicationReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  applications?: InputMaybe<DogBreederApplicationUncheckedUpdateManyWithoutAccountNestedInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  bookings?: InputMaybe<BookingUncheckedUpdateManyWithoutAccountNestedInput>;
  bookmarks?: InputMaybe<BookmarkUncheckedUpdateManyWithoutAccountNestedInput>;
  connectedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  contactPreferences?: InputMaybe<Array<ContactPreference>>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deleted?: InputMaybe<BoolFieldUpdateOperationsInput>;
  dogBreeder?: InputMaybe<DogBreederUncheckedUpdateOneWithoutAccountNestedInput>;
  dogBreederReview?: InputMaybe<DogBreederReviewUncheckedUpdateManyWithoutAccountNestedInput>;
  draftApplicationReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailHistory?: InputMaybe<EmailHistoryUncheckedUpdateManyWithoutAccountNestedInput>;
  facebookId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firebaseId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firebaseToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstAccountConversations?: InputMaybe<ConversationUncheckedUpdateManyWithoutFirstAccountNestedInput>;
  firstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freeApplicationsDateLimit?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableEnumGenderEnumFieldUpdateOperationsInput>;
  googleId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  imgs?: InputMaybe<AccountImgUncheckedUpdateManyWithoutAccountNestedInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mailjetId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUncheckedUpdateManyWithoutAccountNestedInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payLaterReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  payments?: InputMaybe<PaymentUncheckedUpdateManyWithoutAccountNestedInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  receivedMessages?: InputMaybe<MessageUncheckedUpdateManyWithoutToAccountNestedInput>;
  registrationToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  role?: InputMaybe<EnumRoleFieldUpdateOperationsInput>;
  secondAccountConversations?: InputMaybe<ConversationUncheckedUpdateManyWithoutSecondAccountNestedInput>;
  sentMessages?: InputMaybe<MessageUncheckedUpdateManyWithoutFromAccountNestedInput>;
  stripeCustomerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updates?: InputMaybe<UpdateUncheckedUpdateManyWithoutAccountNestedInput>;
};

export type AccountUncheckedUpdateWithoutEmailHistoryInput = {
  EducatorReviews?: InputMaybe<EducatorReviewUncheckedUpdateManyWithoutAccountNestedInput>;
  activated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  activeCampaignContactId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  activityLogs?: InputMaybe<AccountActivityUncheckedUpdateManyWithoutAccountNestedInput>;
  addressId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  adminNotes?: InputMaybe<AdminNoteUncheckedUpdateManyWithoutAccountNestedInput>;
  animals?: InputMaybe<AnimalUncheckedUpdateManyWithoutOwnerNestedInput>;
  applicationReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  applications?: InputMaybe<DogBreederApplicationUncheckedUpdateManyWithoutAccountNestedInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  bookings?: InputMaybe<BookingUncheckedUpdateManyWithoutAccountNestedInput>;
  bookmarks?: InputMaybe<BookmarkUncheckedUpdateManyWithoutAccountNestedInput>;
  connectedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  contactPreferences?: InputMaybe<Array<ContactPreference>>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deleted?: InputMaybe<BoolFieldUpdateOperationsInput>;
  dogBreeder?: InputMaybe<DogBreederUncheckedUpdateOneWithoutAccountNestedInput>;
  dogBreederReview?: InputMaybe<DogBreederReviewUncheckedUpdateManyWithoutAccountNestedInput>;
  draftApplicationReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailContact?: InputMaybe<EmailContactUncheckedUpdateOneWithoutAccountNestedInput>;
  facebookId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firebaseId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firebaseToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstAccountConversations?: InputMaybe<ConversationUncheckedUpdateManyWithoutFirstAccountNestedInput>;
  firstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freeApplicationsDateLimit?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableEnumGenderEnumFieldUpdateOperationsInput>;
  googleId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  imgs?: InputMaybe<AccountImgUncheckedUpdateManyWithoutAccountNestedInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mailjetId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUncheckedUpdateManyWithoutAccountNestedInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payLaterReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  payments?: InputMaybe<PaymentUncheckedUpdateManyWithoutAccountNestedInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  receivedMessages?: InputMaybe<MessageUncheckedUpdateManyWithoutToAccountNestedInput>;
  registrationToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  role?: InputMaybe<EnumRoleFieldUpdateOperationsInput>;
  secondAccountConversations?: InputMaybe<ConversationUncheckedUpdateManyWithoutSecondAccountNestedInput>;
  sentMessages?: InputMaybe<MessageUncheckedUpdateManyWithoutFromAccountNestedInput>;
  stripeCustomerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updates?: InputMaybe<UpdateUncheckedUpdateManyWithoutAccountNestedInput>;
};

export type AccountUncheckedUpdateWithoutFirstAccountConversationsInput = {
  EducatorReviews?: InputMaybe<EducatorReviewUncheckedUpdateManyWithoutAccountNestedInput>;
  activated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  activeCampaignContactId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  activityLogs?: InputMaybe<AccountActivityUncheckedUpdateManyWithoutAccountNestedInput>;
  addressId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  adminNotes?: InputMaybe<AdminNoteUncheckedUpdateManyWithoutAccountNestedInput>;
  animals?: InputMaybe<AnimalUncheckedUpdateManyWithoutOwnerNestedInput>;
  applicationReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  applications?: InputMaybe<DogBreederApplicationUncheckedUpdateManyWithoutAccountNestedInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  bookings?: InputMaybe<BookingUncheckedUpdateManyWithoutAccountNestedInput>;
  bookmarks?: InputMaybe<BookmarkUncheckedUpdateManyWithoutAccountNestedInput>;
  connectedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  contactPreferences?: InputMaybe<Array<ContactPreference>>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deleted?: InputMaybe<BoolFieldUpdateOperationsInput>;
  dogBreeder?: InputMaybe<DogBreederUncheckedUpdateOneWithoutAccountNestedInput>;
  dogBreederReview?: InputMaybe<DogBreederReviewUncheckedUpdateManyWithoutAccountNestedInput>;
  draftApplicationReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailContact?: InputMaybe<EmailContactUncheckedUpdateOneWithoutAccountNestedInput>;
  emailHistory?: InputMaybe<EmailHistoryUncheckedUpdateManyWithoutAccountNestedInput>;
  facebookId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firebaseId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firebaseToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freeApplicationsDateLimit?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableEnumGenderEnumFieldUpdateOperationsInput>;
  googleId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  imgs?: InputMaybe<AccountImgUncheckedUpdateManyWithoutAccountNestedInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mailjetId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUncheckedUpdateManyWithoutAccountNestedInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payLaterReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  payments?: InputMaybe<PaymentUncheckedUpdateManyWithoutAccountNestedInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  receivedMessages?: InputMaybe<MessageUncheckedUpdateManyWithoutToAccountNestedInput>;
  registrationToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  role?: InputMaybe<EnumRoleFieldUpdateOperationsInput>;
  secondAccountConversations?: InputMaybe<ConversationUncheckedUpdateManyWithoutSecondAccountNestedInput>;
  sentMessages?: InputMaybe<MessageUncheckedUpdateManyWithoutFromAccountNestedInput>;
  stripeCustomerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updates?: InputMaybe<UpdateUncheckedUpdateManyWithoutAccountNestedInput>;
};

export type AccountUncheckedUpdateWithoutImgsInput = {
  EducatorReviews?: InputMaybe<EducatorReviewUncheckedUpdateManyWithoutAccountNestedInput>;
  activated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  activeCampaignContactId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  activityLogs?: InputMaybe<AccountActivityUncheckedUpdateManyWithoutAccountNestedInput>;
  addressId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  adminNotes?: InputMaybe<AdminNoteUncheckedUpdateManyWithoutAccountNestedInput>;
  animals?: InputMaybe<AnimalUncheckedUpdateManyWithoutOwnerNestedInput>;
  applicationReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  applications?: InputMaybe<DogBreederApplicationUncheckedUpdateManyWithoutAccountNestedInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  bookings?: InputMaybe<BookingUncheckedUpdateManyWithoutAccountNestedInput>;
  bookmarks?: InputMaybe<BookmarkUncheckedUpdateManyWithoutAccountNestedInput>;
  connectedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  contactPreferences?: InputMaybe<Array<ContactPreference>>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deleted?: InputMaybe<BoolFieldUpdateOperationsInput>;
  dogBreeder?: InputMaybe<DogBreederUncheckedUpdateOneWithoutAccountNestedInput>;
  dogBreederReview?: InputMaybe<DogBreederReviewUncheckedUpdateManyWithoutAccountNestedInput>;
  draftApplicationReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailContact?: InputMaybe<EmailContactUncheckedUpdateOneWithoutAccountNestedInput>;
  emailHistory?: InputMaybe<EmailHistoryUncheckedUpdateManyWithoutAccountNestedInput>;
  facebookId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firebaseId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firebaseToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstAccountConversations?: InputMaybe<ConversationUncheckedUpdateManyWithoutFirstAccountNestedInput>;
  firstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freeApplicationsDateLimit?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableEnumGenderEnumFieldUpdateOperationsInput>;
  googleId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mailjetId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUncheckedUpdateManyWithoutAccountNestedInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payLaterReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  payments?: InputMaybe<PaymentUncheckedUpdateManyWithoutAccountNestedInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  receivedMessages?: InputMaybe<MessageUncheckedUpdateManyWithoutToAccountNestedInput>;
  registrationToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  role?: InputMaybe<EnumRoleFieldUpdateOperationsInput>;
  secondAccountConversations?: InputMaybe<ConversationUncheckedUpdateManyWithoutSecondAccountNestedInput>;
  sentMessages?: InputMaybe<MessageUncheckedUpdateManyWithoutFromAccountNestedInput>;
  stripeCustomerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updates?: InputMaybe<UpdateUncheckedUpdateManyWithoutAccountNestedInput>;
};

export type AccountUncheckedUpdateWithoutNotificationsInput = {
  EducatorReviews?: InputMaybe<EducatorReviewUncheckedUpdateManyWithoutAccountNestedInput>;
  activated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  activeCampaignContactId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  activityLogs?: InputMaybe<AccountActivityUncheckedUpdateManyWithoutAccountNestedInput>;
  addressId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  adminNotes?: InputMaybe<AdminNoteUncheckedUpdateManyWithoutAccountNestedInput>;
  animals?: InputMaybe<AnimalUncheckedUpdateManyWithoutOwnerNestedInput>;
  applicationReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  applications?: InputMaybe<DogBreederApplicationUncheckedUpdateManyWithoutAccountNestedInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  bookings?: InputMaybe<BookingUncheckedUpdateManyWithoutAccountNestedInput>;
  bookmarks?: InputMaybe<BookmarkUncheckedUpdateManyWithoutAccountNestedInput>;
  connectedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  contactPreferences?: InputMaybe<Array<ContactPreference>>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deleted?: InputMaybe<BoolFieldUpdateOperationsInput>;
  dogBreeder?: InputMaybe<DogBreederUncheckedUpdateOneWithoutAccountNestedInput>;
  dogBreederReview?: InputMaybe<DogBreederReviewUncheckedUpdateManyWithoutAccountNestedInput>;
  draftApplicationReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailContact?: InputMaybe<EmailContactUncheckedUpdateOneWithoutAccountNestedInput>;
  emailHistory?: InputMaybe<EmailHistoryUncheckedUpdateManyWithoutAccountNestedInput>;
  facebookId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firebaseId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firebaseToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstAccountConversations?: InputMaybe<ConversationUncheckedUpdateManyWithoutFirstAccountNestedInput>;
  firstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freeApplicationsDateLimit?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableEnumGenderEnumFieldUpdateOperationsInput>;
  googleId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  imgs?: InputMaybe<AccountImgUncheckedUpdateManyWithoutAccountNestedInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mailjetId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payLaterReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  payments?: InputMaybe<PaymentUncheckedUpdateManyWithoutAccountNestedInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  receivedMessages?: InputMaybe<MessageUncheckedUpdateManyWithoutToAccountNestedInput>;
  registrationToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  role?: InputMaybe<EnumRoleFieldUpdateOperationsInput>;
  secondAccountConversations?: InputMaybe<ConversationUncheckedUpdateManyWithoutSecondAccountNestedInput>;
  sentMessages?: InputMaybe<MessageUncheckedUpdateManyWithoutFromAccountNestedInput>;
  stripeCustomerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updates?: InputMaybe<UpdateUncheckedUpdateManyWithoutAccountNestedInput>;
};

export type AccountUncheckedUpdateWithoutPaymentsInput = {
  EducatorReviews?: InputMaybe<EducatorReviewUncheckedUpdateManyWithoutAccountNestedInput>;
  activated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  activeCampaignContactId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  activityLogs?: InputMaybe<AccountActivityUncheckedUpdateManyWithoutAccountNestedInput>;
  addressId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  adminNotes?: InputMaybe<AdminNoteUncheckedUpdateManyWithoutAccountNestedInput>;
  animals?: InputMaybe<AnimalUncheckedUpdateManyWithoutOwnerNestedInput>;
  applicationReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  applications?: InputMaybe<DogBreederApplicationUncheckedUpdateManyWithoutAccountNestedInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  bookings?: InputMaybe<BookingUncheckedUpdateManyWithoutAccountNestedInput>;
  bookmarks?: InputMaybe<BookmarkUncheckedUpdateManyWithoutAccountNestedInput>;
  connectedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  contactPreferences?: InputMaybe<Array<ContactPreference>>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deleted?: InputMaybe<BoolFieldUpdateOperationsInput>;
  dogBreeder?: InputMaybe<DogBreederUncheckedUpdateOneWithoutAccountNestedInput>;
  dogBreederReview?: InputMaybe<DogBreederReviewUncheckedUpdateManyWithoutAccountNestedInput>;
  draftApplicationReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailContact?: InputMaybe<EmailContactUncheckedUpdateOneWithoutAccountNestedInput>;
  emailHistory?: InputMaybe<EmailHistoryUncheckedUpdateManyWithoutAccountNestedInput>;
  facebookId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firebaseId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firebaseToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstAccountConversations?: InputMaybe<ConversationUncheckedUpdateManyWithoutFirstAccountNestedInput>;
  firstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freeApplicationsDateLimit?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableEnumGenderEnumFieldUpdateOperationsInput>;
  googleId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  imgs?: InputMaybe<AccountImgUncheckedUpdateManyWithoutAccountNestedInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mailjetId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUncheckedUpdateManyWithoutAccountNestedInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payLaterReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  receivedMessages?: InputMaybe<MessageUncheckedUpdateManyWithoutToAccountNestedInput>;
  registrationToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  role?: InputMaybe<EnumRoleFieldUpdateOperationsInput>;
  secondAccountConversations?: InputMaybe<ConversationUncheckedUpdateManyWithoutSecondAccountNestedInput>;
  sentMessages?: InputMaybe<MessageUncheckedUpdateManyWithoutFromAccountNestedInput>;
  stripeCustomerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updates?: InputMaybe<UpdateUncheckedUpdateManyWithoutAccountNestedInput>;
};

export type AccountUncheckedUpdateWithoutReceivedMessagesInput = {
  EducatorReviews?: InputMaybe<EducatorReviewUncheckedUpdateManyWithoutAccountNestedInput>;
  activated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  activeCampaignContactId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  activityLogs?: InputMaybe<AccountActivityUncheckedUpdateManyWithoutAccountNestedInput>;
  addressId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  adminNotes?: InputMaybe<AdminNoteUncheckedUpdateManyWithoutAccountNestedInput>;
  animals?: InputMaybe<AnimalUncheckedUpdateManyWithoutOwnerNestedInput>;
  applicationReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  applications?: InputMaybe<DogBreederApplicationUncheckedUpdateManyWithoutAccountNestedInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  bookings?: InputMaybe<BookingUncheckedUpdateManyWithoutAccountNestedInput>;
  bookmarks?: InputMaybe<BookmarkUncheckedUpdateManyWithoutAccountNestedInput>;
  connectedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  contactPreferences?: InputMaybe<Array<ContactPreference>>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deleted?: InputMaybe<BoolFieldUpdateOperationsInput>;
  dogBreeder?: InputMaybe<DogBreederUncheckedUpdateOneWithoutAccountNestedInput>;
  dogBreederReview?: InputMaybe<DogBreederReviewUncheckedUpdateManyWithoutAccountNestedInput>;
  draftApplicationReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailContact?: InputMaybe<EmailContactUncheckedUpdateOneWithoutAccountNestedInput>;
  emailHistory?: InputMaybe<EmailHistoryUncheckedUpdateManyWithoutAccountNestedInput>;
  facebookId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firebaseId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firebaseToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstAccountConversations?: InputMaybe<ConversationUncheckedUpdateManyWithoutFirstAccountNestedInput>;
  firstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freeApplicationsDateLimit?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableEnumGenderEnumFieldUpdateOperationsInput>;
  googleId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  imgs?: InputMaybe<AccountImgUncheckedUpdateManyWithoutAccountNestedInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mailjetId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUncheckedUpdateManyWithoutAccountNestedInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payLaterReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  payments?: InputMaybe<PaymentUncheckedUpdateManyWithoutAccountNestedInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registrationToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  role?: InputMaybe<EnumRoleFieldUpdateOperationsInput>;
  secondAccountConversations?: InputMaybe<ConversationUncheckedUpdateManyWithoutSecondAccountNestedInput>;
  sentMessages?: InputMaybe<MessageUncheckedUpdateManyWithoutFromAccountNestedInput>;
  stripeCustomerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updates?: InputMaybe<UpdateUncheckedUpdateManyWithoutAccountNestedInput>;
};

export type AccountUncheckedUpdateWithoutSecondAccountConversationsInput = {
  EducatorReviews?: InputMaybe<EducatorReviewUncheckedUpdateManyWithoutAccountNestedInput>;
  activated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  activeCampaignContactId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  activityLogs?: InputMaybe<AccountActivityUncheckedUpdateManyWithoutAccountNestedInput>;
  addressId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  adminNotes?: InputMaybe<AdminNoteUncheckedUpdateManyWithoutAccountNestedInput>;
  animals?: InputMaybe<AnimalUncheckedUpdateManyWithoutOwnerNestedInput>;
  applicationReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  applications?: InputMaybe<DogBreederApplicationUncheckedUpdateManyWithoutAccountNestedInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  bookings?: InputMaybe<BookingUncheckedUpdateManyWithoutAccountNestedInput>;
  bookmarks?: InputMaybe<BookmarkUncheckedUpdateManyWithoutAccountNestedInput>;
  connectedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  contactPreferences?: InputMaybe<Array<ContactPreference>>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deleted?: InputMaybe<BoolFieldUpdateOperationsInput>;
  dogBreeder?: InputMaybe<DogBreederUncheckedUpdateOneWithoutAccountNestedInput>;
  dogBreederReview?: InputMaybe<DogBreederReviewUncheckedUpdateManyWithoutAccountNestedInput>;
  draftApplicationReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailContact?: InputMaybe<EmailContactUncheckedUpdateOneWithoutAccountNestedInput>;
  emailHistory?: InputMaybe<EmailHistoryUncheckedUpdateManyWithoutAccountNestedInput>;
  facebookId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firebaseId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firebaseToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstAccountConversations?: InputMaybe<ConversationUncheckedUpdateManyWithoutFirstAccountNestedInput>;
  firstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freeApplicationsDateLimit?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableEnumGenderEnumFieldUpdateOperationsInput>;
  googleId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  imgs?: InputMaybe<AccountImgUncheckedUpdateManyWithoutAccountNestedInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mailjetId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUncheckedUpdateManyWithoutAccountNestedInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payLaterReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  payments?: InputMaybe<PaymentUncheckedUpdateManyWithoutAccountNestedInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  receivedMessages?: InputMaybe<MessageUncheckedUpdateManyWithoutToAccountNestedInput>;
  registrationToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  role?: InputMaybe<EnumRoleFieldUpdateOperationsInput>;
  sentMessages?: InputMaybe<MessageUncheckedUpdateManyWithoutFromAccountNestedInput>;
  stripeCustomerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updates?: InputMaybe<UpdateUncheckedUpdateManyWithoutAccountNestedInput>;
};

export type AccountUncheckedUpdateWithoutSentMessagesInput = {
  EducatorReviews?: InputMaybe<EducatorReviewUncheckedUpdateManyWithoutAccountNestedInput>;
  activated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  activeCampaignContactId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  activityLogs?: InputMaybe<AccountActivityUncheckedUpdateManyWithoutAccountNestedInput>;
  addressId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  adminNotes?: InputMaybe<AdminNoteUncheckedUpdateManyWithoutAccountNestedInput>;
  animals?: InputMaybe<AnimalUncheckedUpdateManyWithoutOwnerNestedInput>;
  applicationReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  applications?: InputMaybe<DogBreederApplicationUncheckedUpdateManyWithoutAccountNestedInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  bookings?: InputMaybe<BookingUncheckedUpdateManyWithoutAccountNestedInput>;
  bookmarks?: InputMaybe<BookmarkUncheckedUpdateManyWithoutAccountNestedInput>;
  connectedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  contactPreferences?: InputMaybe<Array<ContactPreference>>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deleted?: InputMaybe<BoolFieldUpdateOperationsInput>;
  dogBreeder?: InputMaybe<DogBreederUncheckedUpdateOneWithoutAccountNestedInput>;
  dogBreederReview?: InputMaybe<DogBreederReviewUncheckedUpdateManyWithoutAccountNestedInput>;
  draftApplicationReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailContact?: InputMaybe<EmailContactUncheckedUpdateOneWithoutAccountNestedInput>;
  emailHistory?: InputMaybe<EmailHistoryUncheckedUpdateManyWithoutAccountNestedInput>;
  facebookId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firebaseId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firebaseToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstAccountConversations?: InputMaybe<ConversationUncheckedUpdateManyWithoutFirstAccountNestedInput>;
  firstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freeApplicationsDateLimit?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableEnumGenderEnumFieldUpdateOperationsInput>;
  googleId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  imgs?: InputMaybe<AccountImgUncheckedUpdateManyWithoutAccountNestedInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mailjetId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUncheckedUpdateManyWithoutAccountNestedInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payLaterReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  payments?: InputMaybe<PaymentUncheckedUpdateManyWithoutAccountNestedInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  receivedMessages?: InputMaybe<MessageUncheckedUpdateManyWithoutToAccountNestedInput>;
  registrationToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  role?: InputMaybe<EnumRoleFieldUpdateOperationsInput>;
  secondAccountConversations?: InputMaybe<ConversationUncheckedUpdateManyWithoutSecondAccountNestedInput>;
  stripeCustomerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updates?: InputMaybe<UpdateUncheckedUpdateManyWithoutAccountNestedInput>;
};

export type AccountUncheckedUpdateWithoutUpdatesInput = {
  EducatorReviews?: InputMaybe<EducatorReviewUncheckedUpdateManyWithoutAccountNestedInput>;
  activated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  activeCampaignContactId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  activityLogs?: InputMaybe<AccountActivityUncheckedUpdateManyWithoutAccountNestedInput>;
  addressId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  adminNotes?: InputMaybe<AdminNoteUncheckedUpdateManyWithoutAccountNestedInput>;
  animals?: InputMaybe<AnimalUncheckedUpdateManyWithoutOwnerNestedInput>;
  applicationReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  applications?: InputMaybe<DogBreederApplicationUncheckedUpdateManyWithoutAccountNestedInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  bookings?: InputMaybe<BookingUncheckedUpdateManyWithoutAccountNestedInput>;
  bookmarks?: InputMaybe<BookmarkUncheckedUpdateManyWithoutAccountNestedInput>;
  connectedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  contactPreferences?: InputMaybe<Array<ContactPreference>>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deleted?: InputMaybe<BoolFieldUpdateOperationsInput>;
  dogBreeder?: InputMaybe<DogBreederUncheckedUpdateOneWithoutAccountNestedInput>;
  dogBreederReview?: InputMaybe<DogBreederReviewUncheckedUpdateManyWithoutAccountNestedInput>;
  draftApplicationReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailContact?: InputMaybe<EmailContactUncheckedUpdateOneWithoutAccountNestedInput>;
  emailHistory?: InputMaybe<EmailHistoryUncheckedUpdateManyWithoutAccountNestedInput>;
  facebookId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firebaseId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firebaseToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstAccountConversations?: InputMaybe<ConversationUncheckedUpdateManyWithoutFirstAccountNestedInput>;
  firstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freeApplicationsDateLimit?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableEnumGenderEnumFieldUpdateOperationsInput>;
  googleId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  imgs?: InputMaybe<AccountImgUncheckedUpdateManyWithoutAccountNestedInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mailjetId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUncheckedUpdateManyWithoutAccountNestedInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payLaterReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  payments?: InputMaybe<PaymentUncheckedUpdateManyWithoutAccountNestedInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  receivedMessages?: InputMaybe<MessageUncheckedUpdateManyWithoutToAccountNestedInput>;
  registrationToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  role?: InputMaybe<EnumRoleFieldUpdateOperationsInput>;
  secondAccountConversations?: InputMaybe<ConversationUncheckedUpdateManyWithoutSecondAccountNestedInput>;
  sentMessages?: InputMaybe<MessageUncheckedUpdateManyWithoutFromAccountNestedInput>;
  stripeCustomerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type AccountUpdateInput = {
  EducatorReviews?: InputMaybe<EducatorReviewUpdateManyWithoutAccountNestedInput>;
  activated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  activeCampaignContactId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  activityLogs?: InputMaybe<AccountActivityUpdateManyWithoutAccountNestedInput>;
  address?: InputMaybe<AddressUpdateOneWithoutAccountNestedInput>;
  adminNotes?: InputMaybe<AdminNoteUpdateManyWithoutAccountNestedInput>;
  animals?: InputMaybe<AnimalUpdateManyWithoutOwnerNestedInput>;
  applicationReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  applications?: InputMaybe<DogBreederApplicationUpdateManyWithoutAccountNestedInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  bookings?: InputMaybe<BookingUpdateManyWithoutAccountNestedInput>;
  bookmarks?: InputMaybe<BookmarkUpdateManyWithoutAccountNestedInput>;
  connectedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  contactPreferences?: InputMaybe<Array<ContactPreference>>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deleted?: InputMaybe<BoolFieldUpdateOperationsInput>;
  dogBreeder?: InputMaybe<DogBreederUpdateOneWithoutAccountNestedInput>;
  dogBreederReview?: InputMaybe<DogBreederReviewUpdateManyWithoutAccountNestedInput>;
  draftApplicationReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailContact?: InputMaybe<EmailContactUpdateOneWithoutAccountNestedInput>;
  emailHistory?: InputMaybe<EmailHistoryUpdateManyWithoutAccountNestedInput>;
  facebookId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firebaseId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firebaseToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstAccountConversations?: InputMaybe<ConversationUpdateManyWithoutFirstAccountNestedInput>;
  firstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freeApplicationsDateLimit?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableEnumGenderEnumFieldUpdateOperationsInput>;
  googleId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hasADog?: InputMaybe<BoolFieldUpdateOperationsInput>;
  imgs?: InputMaybe<AccountImgUpdateManyWithoutAccountNestedInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mailjetId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutAccountNestedInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payLaterReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  payments?: InputMaybe<PaymentUpdateManyWithoutAccountNestedInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  receivedMessages?: InputMaybe<MessageUpdateManyWithoutToAccountNestedInput>;
  registrationToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  role?: InputMaybe<EnumRoleFieldUpdateOperationsInput>;
  secondAccountConversations?: InputMaybe<ConversationUpdateManyWithoutSecondAccountNestedInput>;
  sentMessages?: InputMaybe<MessageUpdateManyWithoutFromAccountNestedInput>;
  stripeCustomerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updates?: InputMaybe<UpdateUpdateManyWithoutAccountNestedInput>;
};

export type AccountUpdateManyMutationInput = {
  activated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  activeCampaignContactId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  applicationReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  connectedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  contactPreferences?: InputMaybe<Array<ContactPreference>>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deleted?: InputMaybe<BoolFieldUpdateOperationsInput>;
  draftApplicationReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  facebookId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firebaseId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firebaseToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freeApplicationsDateLimit?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableEnumGenderEnumFieldUpdateOperationsInput>;
  googleId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mailjetId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payLaterReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registrationToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  role?: InputMaybe<EnumRoleFieldUpdateOperationsInput>;
  stripeCustomerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type AccountUpdateOneRequiredWithoutActivityLogsNestedInput = {
  connect?: InputMaybe<AccountWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AccountCreateOrConnectWithoutActivityLogsInput>;
  create?: InputMaybe<AccountCreateWithoutActivityLogsInput>;
  update?: InputMaybe<AccountUpdateToOneWithWhereWithoutActivityLogsInput>;
  upsert?: InputMaybe<AccountUpsertWithoutActivityLogsInput>;
};

export type AccountUpdateOneRequiredWithoutApplicationsNestedInput = {
  connect?: InputMaybe<AccountWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AccountCreateOrConnectWithoutApplicationsInput>;
  create?: InputMaybe<AccountCreateWithoutApplicationsInput>;
  update?: InputMaybe<AccountUpdateToOneWithWhereWithoutApplicationsInput>;
  upsert?: InputMaybe<AccountUpsertWithoutApplicationsInput>;
};

export type AccountUpdateOneRequiredWithoutBookmarksNestedInput = {
  connect?: InputMaybe<AccountWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AccountCreateOrConnectWithoutBookmarksInput>;
  create?: InputMaybe<AccountCreateWithoutBookmarksInput>;
  update?: InputMaybe<AccountUpdateToOneWithWhereWithoutBookmarksInput>;
  upsert?: InputMaybe<AccountUpsertWithoutBookmarksInput>;
};

export type AccountUpdateOneRequiredWithoutDogBreederNestedInput = {
  connect?: InputMaybe<AccountWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AccountCreateOrConnectWithoutDogBreederInput>;
  create?: InputMaybe<AccountCreateWithoutDogBreederInput>;
  update?: InputMaybe<AccountUpdateToOneWithWhereWithoutDogBreederInput>;
  upsert?: InputMaybe<AccountUpsertWithoutDogBreederInput>;
};

export type AccountUpdateOneRequiredWithoutDogBreederReviewNestedInput = {
  connect?: InputMaybe<AccountWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AccountCreateOrConnectWithoutDogBreederReviewInput>;
  create?: InputMaybe<AccountCreateWithoutDogBreederReviewInput>;
  update?: InputMaybe<AccountUpdateToOneWithWhereWithoutDogBreederReviewInput>;
  upsert?: InputMaybe<AccountUpsertWithoutDogBreederReviewInput>;
};

export type AccountUpdateOneRequiredWithoutEducatorReviewsNestedInput = {
  connect?: InputMaybe<AccountWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AccountCreateOrConnectWithoutEducatorReviewsInput>;
  create?: InputMaybe<AccountCreateWithoutEducatorReviewsInput>;
  update?: InputMaybe<AccountUpdateToOneWithWhereWithoutEducatorReviewsInput>;
  upsert?: InputMaybe<AccountUpsertWithoutEducatorReviewsInput>;
};

export type AccountUpdateOneRequiredWithoutFirstAccountConversationsNestedInput = {
  connect?: InputMaybe<AccountWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AccountCreateOrConnectWithoutFirstAccountConversationsInput>;
  create?: InputMaybe<AccountCreateWithoutFirstAccountConversationsInput>;
  update?: InputMaybe<AccountUpdateToOneWithWhereWithoutFirstAccountConversationsInput>;
  upsert?: InputMaybe<AccountUpsertWithoutFirstAccountConversationsInput>;
};

export type AccountUpdateOneRequiredWithoutImgsNestedInput = {
  connect?: InputMaybe<AccountWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AccountCreateOrConnectWithoutImgsInput>;
  create?: InputMaybe<AccountCreateWithoutImgsInput>;
  update?: InputMaybe<AccountUpdateToOneWithWhereWithoutImgsInput>;
  upsert?: InputMaybe<AccountUpsertWithoutImgsInput>;
};

export type AccountUpdateOneRequiredWithoutPaymentsNestedInput = {
  connect?: InputMaybe<AccountWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AccountCreateOrConnectWithoutPaymentsInput>;
  create?: InputMaybe<AccountCreateWithoutPaymentsInput>;
  update?: InputMaybe<AccountUpdateToOneWithWhereWithoutPaymentsInput>;
  upsert?: InputMaybe<AccountUpsertWithoutPaymentsInput>;
};

export type AccountUpdateOneRequiredWithoutReceivedMessagesNestedInput = {
  connect?: InputMaybe<AccountWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AccountCreateOrConnectWithoutReceivedMessagesInput>;
  create?: InputMaybe<AccountCreateWithoutReceivedMessagesInput>;
  update?: InputMaybe<AccountUpdateToOneWithWhereWithoutReceivedMessagesInput>;
  upsert?: InputMaybe<AccountUpsertWithoutReceivedMessagesInput>;
};

export type AccountUpdateOneRequiredWithoutSecondAccountConversationsNestedInput = {
  connect?: InputMaybe<AccountWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AccountCreateOrConnectWithoutSecondAccountConversationsInput>;
  create?: InputMaybe<AccountCreateWithoutSecondAccountConversationsInput>;
  update?: InputMaybe<AccountUpdateToOneWithWhereWithoutSecondAccountConversationsInput>;
  upsert?: InputMaybe<AccountUpsertWithoutSecondAccountConversationsInput>;
};

export type AccountUpdateOneRequiredWithoutSentMessagesNestedInput = {
  connect?: InputMaybe<AccountWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AccountCreateOrConnectWithoutSentMessagesInput>;
  create?: InputMaybe<AccountCreateWithoutSentMessagesInput>;
  update?: InputMaybe<AccountUpdateToOneWithWhereWithoutSentMessagesInput>;
  upsert?: InputMaybe<AccountUpsertWithoutSentMessagesInput>;
};

export type AccountUpdateOneWithoutAddressNestedInput = {
  connect?: InputMaybe<AccountWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AccountCreateOrConnectWithoutAddressInput>;
  create?: InputMaybe<AccountCreateWithoutAddressInput>;
  delete?: InputMaybe<AccountWhereInput>;
  disconnect?: InputMaybe<AccountWhereInput>;
  update?: InputMaybe<AccountUpdateToOneWithWhereWithoutAddressInput>;
  upsert?: InputMaybe<AccountUpsertWithoutAddressInput>;
};

export type AccountUpdateOneWithoutAdminNotesNestedInput = {
  connect?: InputMaybe<AccountWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AccountCreateOrConnectWithoutAdminNotesInput>;
  create?: InputMaybe<AccountCreateWithoutAdminNotesInput>;
  delete?: InputMaybe<AccountWhereInput>;
  disconnect?: InputMaybe<AccountWhereInput>;
  update?: InputMaybe<AccountUpdateToOneWithWhereWithoutAdminNotesInput>;
  upsert?: InputMaybe<AccountUpsertWithoutAdminNotesInput>;
};

export type AccountUpdateOneWithoutAnimalsNestedInput = {
  connect?: InputMaybe<AccountWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AccountCreateOrConnectWithoutAnimalsInput>;
  create?: InputMaybe<AccountCreateWithoutAnimalsInput>;
  delete?: InputMaybe<AccountWhereInput>;
  disconnect?: InputMaybe<AccountWhereInput>;
  update?: InputMaybe<AccountUpdateToOneWithWhereWithoutAnimalsInput>;
  upsert?: InputMaybe<AccountUpsertWithoutAnimalsInput>;
};

export type AccountUpdateOneWithoutBookingsNestedInput = {
  connect?: InputMaybe<AccountWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AccountCreateOrConnectWithoutBookingsInput>;
  create?: InputMaybe<AccountCreateWithoutBookingsInput>;
  delete?: InputMaybe<AccountWhereInput>;
  disconnect?: InputMaybe<AccountWhereInput>;
  update?: InputMaybe<AccountUpdateToOneWithWhereWithoutBookingsInput>;
  upsert?: InputMaybe<AccountUpsertWithoutBookingsInput>;
};

export type AccountUpdateOneWithoutEmailContactNestedInput = {
  connect?: InputMaybe<AccountWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AccountCreateOrConnectWithoutEmailContactInput>;
  create?: InputMaybe<AccountCreateWithoutEmailContactInput>;
  delete?: InputMaybe<AccountWhereInput>;
  disconnect?: InputMaybe<AccountWhereInput>;
  update?: InputMaybe<AccountUpdateToOneWithWhereWithoutEmailContactInput>;
  upsert?: InputMaybe<AccountUpsertWithoutEmailContactInput>;
};

export type AccountUpdateOneWithoutEmailHistoryNestedInput = {
  connect?: InputMaybe<AccountWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AccountCreateOrConnectWithoutEmailHistoryInput>;
  create?: InputMaybe<AccountCreateWithoutEmailHistoryInput>;
  delete?: InputMaybe<AccountWhereInput>;
  disconnect?: InputMaybe<AccountWhereInput>;
  update?: InputMaybe<AccountUpdateToOneWithWhereWithoutEmailHistoryInput>;
  upsert?: InputMaybe<AccountUpsertWithoutEmailHistoryInput>;
};

export type AccountUpdateOneWithoutNotificationsNestedInput = {
  connect?: InputMaybe<AccountWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AccountCreateOrConnectWithoutNotificationsInput>;
  create?: InputMaybe<AccountCreateWithoutNotificationsInput>;
  delete?: InputMaybe<AccountWhereInput>;
  disconnect?: InputMaybe<AccountWhereInput>;
  update?: InputMaybe<AccountUpdateToOneWithWhereWithoutNotificationsInput>;
  upsert?: InputMaybe<AccountUpsertWithoutNotificationsInput>;
};

export type AccountUpdateOneWithoutUpdatesNestedInput = {
  connect?: InputMaybe<AccountWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AccountCreateOrConnectWithoutUpdatesInput>;
  create?: InputMaybe<AccountCreateWithoutUpdatesInput>;
  delete?: InputMaybe<AccountWhereInput>;
  disconnect?: InputMaybe<AccountWhereInput>;
  update?: InputMaybe<AccountUpdateToOneWithWhereWithoutUpdatesInput>;
  upsert?: InputMaybe<AccountUpsertWithoutUpdatesInput>;
};

export type AccountUpdateToOneWithWhereWithoutActivityLogsInput = {
  data: AccountUpdateWithoutActivityLogsInput;
  where?: InputMaybe<AccountWhereInput>;
};

export type AccountUpdateToOneWithWhereWithoutAddressInput = {
  data: AccountUpdateWithoutAddressInput;
  where?: InputMaybe<AccountWhereInput>;
};

export type AccountUpdateToOneWithWhereWithoutAdminNotesInput = {
  data: AccountUpdateWithoutAdminNotesInput;
  where?: InputMaybe<AccountWhereInput>;
};

export type AccountUpdateToOneWithWhereWithoutAnimalsInput = {
  data: AccountUpdateWithoutAnimalsInput;
  where?: InputMaybe<AccountWhereInput>;
};

export type AccountUpdateToOneWithWhereWithoutApplicationsInput = {
  data: AccountUpdateWithoutApplicationsInput;
  where?: InputMaybe<AccountWhereInput>;
};

export type AccountUpdateToOneWithWhereWithoutBookingsInput = {
  data: AccountUpdateWithoutBookingsInput;
  where?: InputMaybe<AccountWhereInput>;
};

export type AccountUpdateToOneWithWhereWithoutBookmarksInput = {
  data: AccountUpdateWithoutBookmarksInput;
  where?: InputMaybe<AccountWhereInput>;
};

export type AccountUpdateToOneWithWhereWithoutDogBreederInput = {
  data: AccountUpdateWithoutDogBreederInput;
  where?: InputMaybe<AccountWhereInput>;
};

export type AccountUpdateToOneWithWhereWithoutDogBreederReviewInput = {
  data: AccountUpdateWithoutDogBreederReviewInput;
  where?: InputMaybe<AccountWhereInput>;
};

export type AccountUpdateToOneWithWhereWithoutEducatorReviewsInput = {
  data: AccountUpdateWithoutEducatorReviewsInput;
  where?: InputMaybe<AccountWhereInput>;
};

export type AccountUpdateToOneWithWhereWithoutEmailContactInput = {
  data: AccountUpdateWithoutEmailContactInput;
  where?: InputMaybe<AccountWhereInput>;
};

export type AccountUpdateToOneWithWhereWithoutEmailHistoryInput = {
  data: AccountUpdateWithoutEmailHistoryInput;
  where?: InputMaybe<AccountWhereInput>;
};

export type AccountUpdateToOneWithWhereWithoutFirstAccountConversationsInput = {
  data: AccountUpdateWithoutFirstAccountConversationsInput;
  where?: InputMaybe<AccountWhereInput>;
};

export type AccountUpdateToOneWithWhereWithoutImgsInput = {
  data: AccountUpdateWithoutImgsInput;
  where?: InputMaybe<AccountWhereInput>;
};

export type AccountUpdateToOneWithWhereWithoutNotificationsInput = {
  data: AccountUpdateWithoutNotificationsInput;
  where?: InputMaybe<AccountWhereInput>;
};

export type AccountUpdateToOneWithWhereWithoutPaymentsInput = {
  data: AccountUpdateWithoutPaymentsInput;
  where?: InputMaybe<AccountWhereInput>;
};

export type AccountUpdateToOneWithWhereWithoutReceivedMessagesInput = {
  data: AccountUpdateWithoutReceivedMessagesInput;
  where?: InputMaybe<AccountWhereInput>;
};

export type AccountUpdateToOneWithWhereWithoutSecondAccountConversationsInput = {
  data: AccountUpdateWithoutSecondAccountConversationsInput;
  where?: InputMaybe<AccountWhereInput>;
};

export type AccountUpdateToOneWithWhereWithoutSentMessagesInput = {
  data: AccountUpdateWithoutSentMessagesInput;
  where?: InputMaybe<AccountWhereInput>;
};

export type AccountUpdateToOneWithWhereWithoutUpdatesInput = {
  data: AccountUpdateWithoutUpdatesInput;
  where?: InputMaybe<AccountWhereInput>;
};

export type AccountUpdateWithoutActivityLogsInput = {
  EducatorReviews?: InputMaybe<EducatorReviewUpdateManyWithoutAccountNestedInput>;
  activated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  activeCampaignContactId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  address?: InputMaybe<AddressUpdateOneWithoutAccountNestedInput>;
  adminNotes?: InputMaybe<AdminNoteUpdateManyWithoutAccountNestedInput>;
  animals?: InputMaybe<AnimalUpdateManyWithoutOwnerNestedInput>;
  applicationReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  applications?: InputMaybe<DogBreederApplicationUpdateManyWithoutAccountNestedInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  bookings?: InputMaybe<BookingUpdateManyWithoutAccountNestedInput>;
  bookmarks?: InputMaybe<BookmarkUpdateManyWithoutAccountNestedInput>;
  connectedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  contactPreferences?: InputMaybe<Array<ContactPreference>>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deleted?: InputMaybe<BoolFieldUpdateOperationsInput>;
  dogBreeder?: InputMaybe<DogBreederUpdateOneWithoutAccountNestedInput>;
  dogBreederReview?: InputMaybe<DogBreederReviewUpdateManyWithoutAccountNestedInput>;
  draftApplicationReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailContact?: InputMaybe<EmailContactUpdateOneWithoutAccountNestedInput>;
  emailHistory?: InputMaybe<EmailHistoryUpdateManyWithoutAccountNestedInput>;
  facebookId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firebaseId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firebaseToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstAccountConversations?: InputMaybe<ConversationUpdateManyWithoutFirstAccountNestedInput>;
  firstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freeApplicationsDateLimit?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableEnumGenderEnumFieldUpdateOperationsInput>;
  googleId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  imgs?: InputMaybe<AccountImgUpdateManyWithoutAccountNestedInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mailjetId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutAccountNestedInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payLaterReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  payments?: InputMaybe<PaymentUpdateManyWithoutAccountNestedInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  receivedMessages?: InputMaybe<MessageUpdateManyWithoutToAccountNestedInput>;
  registrationToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  role?: InputMaybe<EnumRoleFieldUpdateOperationsInput>;
  secondAccountConversations?: InputMaybe<ConversationUpdateManyWithoutSecondAccountNestedInput>;
  sentMessages?: InputMaybe<MessageUpdateManyWithoutFromAccountNestedInput>;
  stripeCustomerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updates?: InputMaybe<UpdateUpdateManyWithoutAccountNestedInput>;
};

export type AccountUpdateWithoutAddressInput = {
  EducatorReviews?: InputMaybe<EducatorReviewUpdateManyWithoutAccountNestedInput>;
  activated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  activeCampaignContactId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  activityLogs?: InputMaybe<AccountActivityUpdateManyWithoutAccountNestedInput>;
  adminNotes?: InputMaybe<AdminNoteUpdateManyWithoutAccountNestedInput>;
  animals?: InputMaybe<AnimalUpdateManyWithoutOwnerNestedInput>;
  applicationReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  applications?: InputMaybe<DogBreederApplicationUpdateManyWithoutAccountNestedInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  bookings?: InputMaybe<BookingUpdateManyWithoutAccountNestedInput>;
  bookmarks?: InputMaybe<BookmarkUpdateManyWithoutAccountNestedInput>;
  connectedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  contactPreferences?: InputMaybe<Array<ContactPreference>>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deleted?: InputMaybe<BoolFieldUpdateOperationsInput>;
  dogBreeder?: InputMaybe<DogBreederUpdateOneWithoutAccountNestedInput>;
  dogBreederReview?: InputMaybe<DogBreederReviewUpdateManyWithoutAccountNestedInput>;
  draftApplicationReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailContact?: InputMaybe<EmailContactUpdateOneWithoutAccountNestedInput>;
  emailHistory?: InputMaybe<EmailHistoryUpdateManyWithoutAccountNestedInput>;
  facebookId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firebaseId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firebaseToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstAccountConversations?: InputMaybe<ConversationUpdateManyWithoutFirstAccountNestedInput>;
  firstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freeApplicationsDateLimit?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableEnumGenderEnumFieldUpdateOperationsInput>;
  googleId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  imgs?: InputMaybe<AccountImgUpdateManyWithoutAccountNestedInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mailjetId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutAccountNestedInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payLaterReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  payments?: InputMaybe<PaymentUpdateManyWithoutAccountNestedInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  receivedMessages?: InputMaybe<MessageUpdateManyWithoutToAccountNestedInput>;
  registrationToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  role?: InputMaybe<EnumRoleFieldUpdateOperationsInput>;
  secondAccountConversations?: InputMaybe<ConversationUpdateManyWithoutSecondAccountNestedInput>;
  sentMessages?: InputMaybe<MessageUpdateManyWithoutFromAccountNestedInput>;
  stripeCustomerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updates?: InputMaybe<UpdateUpdateManyWithoutAccountNestedInput>;
};

export type AccountUpdateWithoutAdminNotesInput = {
  EducatorReviews?: InputMaybe<EducatorReviewUpdateManyWithoutAccountNestedInput>;
  activated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  activeCampaignContactId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  activityLogs?: InputMaybe<AccountActivityUpdateManyWithoutAccountNestedInput>;
  address?: InputMaybe<AddressUpdateOneWithoutAccountNestedInput>;
  animals?: InputMaybe<AnimalUpdateManyWithoutOwnerNestedInput>;
  applicationReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  applications?: InputMaybe<DogBreederApplicationUpdateManyWithoutAccountNestedInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  bookings?: InputMaybe<BookingUpdateManyWithoutAccountNestedInput>;
  bookmarks?: InputMaybe<BookmarkUpdateManyWithoutAccountNestedInput>;
  connectedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  contactPreferences?: InputMaybe<Array<ContactPreference>>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deleted?: InputMaybe<BoolFieldUpdateOperationsInput>;
  dogBreeder?: InputMaybe<DogBreederUpdateOneWithoutAccountNestedInput>;
  dogBreederReview?: InputMaybe<DogBreederReviewUpdateManyWithoutAccountNestedInput>;
  draftApplicationReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailContact?: InputMaybe<EmailContactUpdateOneWithoutAccountNestedInput>;
  emailHistory?: InputMaybe<EmailHistoryUpdateManyWithoutAccountNestedInput>;
  facebookId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firebaseId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firebaseToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstAccountConversations?: InputMaybe<ConversationUpdateManyWithoutFirstAccountNestedInput>;
  firstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freeApplicationsDateLimit?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableEnumGenderEnumFieldUpdateOperationsInput>;
  googleId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  imgs?: InputMaybe<AccountImgUpdateManyWithoutAccountNestedInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mailjetId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutAccountNestedInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payLaterReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  payments?: InputMaybe<PaymentUpdateManyWithoutAccountNestedInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  receivedMessages?: InputMaybe<MessageUpdateManyWithoutToAccountNestedInput>;
  registrationToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  role?: InputMaybe<EnumRoleFieldUpdateOperationsInput>;
  secondAccountConversations?: InputMaybe<ConversationUpdateManyWithoutSecondAccountNestedInput>;
  sentMessages?: InputMaybe<MessageUpdateManyWithoutFromAccountNestedInput>;
  stripeCustomerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updates?: InputMaybe<UpdateUpdateManyWithoutAccountNestedInput>;
};

export type AccountUpdateWithoutAnimalsInput = {
  EducatorReviews?: InputMaybe<EducatorReviewUpdateManyWithoutAccountNestedInput>;
  activated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  activeCampaignContactId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  activityLogs?: InputMaybe<AccountActivityUpdateManyWithoutAccountNestedInput>;
  address?: InputMaybe<AddressUpdateOneWithoutAccountNestedInput>;
  adminNotes?: InputMaybe<AdminNoteUpdateManyWithoutAccountNestedInput>;
  applicationReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  applications?: InputMaybe<DogBreederApplicationUpdateManyWithoutAccountNestedInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  bookings?: InputMaybe<BookingUpdateManyWithoutAccountNestedInput>;
  bookmarks?: InputMaybe<BookmarkUpdateManyWithoutAccountNestedInput>;
  connectedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  contactPreferences?: InputMaybe<Array<ContactPreference>>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deleted?: InputMaybe<BoolFieldUpdateOperationsInput>;
  dogBreeder?: InputMaybe<DogBreederUpdateOneWithoutAccountNestedInput>;
  dogBreederReview?: InputMaybe<DogBreederReviewUpdateManyWithoutAccountNestedInput>;
  draftApplicationReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailContact?: InputMaybe<EmailContactUpdateOneWithoutAccountNestedInput>;
  emailHistory?: InputMaybe<EmailHistoryUpdateManyWithoutAccountNestedInput>;
  facebookId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firebaseId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firebaseToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstAccountConversations?: InputMaybe<ConversationUpdateManyWithoutFirstAccountNestedInput>;
  firstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freeApplicationsDateLimit?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableEnumGenderEnumFieldUpdateOperationsInput>;
  googleId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  imgs?: InputMaybe<AccountImgUpdateManyWithoutAccountNestedInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mailjetId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutAccountNestedInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payLaterReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  payments?: InputMaybe<PaymentUpdateManyWithoutAccountNestedInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  receivedMessages?: InputMaybe<MessageUpdateManyWithoutToAccountNestedInput>;
  registrationToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  role?: InputMaybe<EnumRoleFieldUpdateOperationsInput>;
  secondAccountConversations?: InputMaybe<ConversationUpdateManyWithoutSecondAccountNestedInput>;
  sentMessages?: InputMaybe<MessageUpdateManyWithoutFromAccountNestedInput>;
  stripeCustomerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updates?: InputMaybe<UpdateUpdateManyWithoutAccountNestedInput>;
};

export type AccountUpdateWithoutApplicationsInput = {
  EducatorReviews?: InputMaybe<EducatorReviewUpdateManyWithoutAccountNestedInput>;
  activated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  activeCampaignContactId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  activityLogs?: InputMaybe<AccountActivityUpdateManyWithoutAccountNestedInput>;
  address?: InputMaybe<AddressUpdateOneWithoutAccountNestedInput>;
  adminNotes?: InputMaybe<AdminNoteUpdateManyWithoutAccountNestedInput>;
  animals?: InputMaybe<AnimalUpdateManyWithoutOwnerNestedInput>;
  applicationReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  bookings?: InputMaybe<BookingUpdateManyWithoutAccountNestedInput>;
  bookmarks?: InputMaybe<BookmarkUpdateManyWithoutAccountNestedInput>;
  connectedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  contactPreferences?: InputMaybe<Array<ContactPreference>>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deleted?: InputMaybe<BoolFieldUpdateOperationsInput>;
  dogBreeder?: InputMaybe<DogBreederUpdateOneWithoutAccountNestedInput>;
  dogBreederReview?: InputMaybe<DogBreederReviewUpdateManyWithoutAccountNestedInput>;
  draftApplicationReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailContact?: InputMaybe<EmailContactUpdateOneWithoutAccountNestedInput>;
  emailHistory?: InputMaybe<EmailHistoryUpdateManyWithoutAccountNestedInput>;
  facebookId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firebaseId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firebaseToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstAccountConversations?: InputMaybe<ConversationUpdateManyWithoutFirstAccountNestedInput>;
  firstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freeApplicationsDateLimit?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableEnumGenderEnumFieldUpdateOperationsInput>;
  googleId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  imgs?: InputMaybe<AccountImgUpdateManyWithoutAccountNestedInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mailjetId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutAccountNestedInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payLaterReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  payments?: InputMaybe<PaymentUpdateManyWithoutAccountNestedInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  receivedMessages?: InputMaybe<MessageUpdateManyWithoutToAccountNestedInput>;
  registrationToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  role?: InputMaybe<EnumRoleFieldUpdateOperationsInput>;
  secondAccountConversations?: InputMaybe<ConversationUpdateManyWithoutSecondAccountNestedInput>;
  sentMessages?: InputMaybe<MessageUpdateManyWithoutFromAccountNestedInput>;
  stripeCustomerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updates?: InputMaybe<UpdateUpdateManyWithoutAccountNestedInput>;
};

export type AccountUpdateWithoutBookingsInput = {
  EducatorReviews?: InputMaybe<EducatorReviewUpdateManyWithoutAccountNestedInput>;
  activated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  activeCampaignContactId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  activityLogs?: InputMaybe<AccountActivityUpdateManyWithoutAccountNestedInput>;
  address?: InputMaybe<AddressUpdateOneWithoutAccountNestedInput>;
  adminNotes?: InputMaybe<AdminNoteUpdateManyWithoutAccountNestedInput>;
  animals?: InputMaybe<AnimalUpdateManyWithoutOwnerNestedInput>;
  applicationReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  applications?: InputMaybe<DogBreederApplicationUpdateManyWithoutAccountNestedInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  bookmarks?: InputMaybe<BookmarkUpdateManyWithoutAccountNestedInput>;
  connectedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  contactPreferences?: InputMaybe<Array<ContactPreference>>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deleted?: InputMaybe<BoolFieldUpdateOperationsInput>;
  dogBreeder?: InputMaybe<DogBreederUpdateOneWithoutAccountNestedInput>;
  dogBreederReview?: InputMaybe<DogBreederReviewUpdateManyWithoutAccountNestedInput>;
  draftApplicationReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailContact?: InputMaybe<EmailContactUpdateOneWithoutAccountNestedInput>;
  emailHistory?: InputMaybe<EmailHistoryUpdateManyWithoutAccountNestedInput>;
  facebookId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firebaseId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firebaseToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstAccountConversations?: InputMaybe<ConversationUpdateManyWithoutFirstAccountNestedInput>;
  firstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freeApplicationsDateLimit?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableEnumGenderEnumFieldUpdateOperationsInput>;
  googleId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  imgs?: InputMaybe<AccountImgUpdateManyWithoutAccountNestedInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mailjetId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutAccountNestedInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payLaterReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  payments?: InputMaybe<PaymentUpdateManyWithoutAccountNestedInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  receivedMessages?: InputMaybe<MessageUpdateManyWithoutToAccountNestedInput>;
  registrationToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  role?: InputMaybe<EnumRoleFieldUpdateOperationsInput>;
  secondAccountConversations?: InputMaybe<ConversationUpdateManyWithoutSecondAccountNestedInput>;
  sentMessages?: InputMaybe<MessageUpdateManyWithoutFromAccountNestedInput>;
  stripeCustomerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updates?: InputMaybe<UpdateUpdateManyWithoutAccountNestedInput>;
};

export type AccountUpdateWithoutBookmarksInput = {
  EducatorReviews?: InputMaybe<EducatorReviewUpdateManyWithoutAccountNestedInput>;
  activated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  activeCampaignContactId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  activityLogs?: InputMaybe<AccountActivityUpdateManyWithoutAccountNestedInput>;
  address?: InputMaybe<AddressUpdateOneWithoutAccountNestedInput>;
  adminNotes?: InputMaybe<AdminNoteUpdateManyWithoutAccountNestedInput>;
  animals?: InputMaybe<AnimalUpdateManyWithoutOwnerNestedInput>;
  applicationReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  applications?: InputMaybe<DogBreederApplicationUpdateManyWithoutAccountNestedInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  bookings?: InputMaybe<BookingUpdateManyWithoutAccountNestedInput>;
  connectedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  contactPreferences?: InputMaybe<Array<ContactPreference>>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deleted?: InputMaybe<BoolFieldUpdateOperationsInput>;
  dogBreeder?: InputMaybe<DogBreederUpdateOneWithoutAccountNestedInput>;
  dogBreederReview?: InputMaybe<DogBreederReviewUpdateManyWithoutAccountNestedInput>;
  draftApplicationReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailContact?: InputMaybe<EmailContactUpdateOneWithoutAccountNestedInput>;
  emailHistory?: InputMaybe<EmailHistoryUpdateManyWithoutAccountNestedInput>;
  facebookId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firebaseId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firebaseToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstAccountConversations?: InputMaybe<ConversationUpdateManyWithoutFirstAccountNestedInput>;
  firstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freeApplicationsDateLimit?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableEnumGenderEnumFieldUpdateOperationsInput>;
  googleId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  imgs?: InputMaybe<AccountImgUpdateManyWithoutAccountNestedInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mailjetId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutAccountNestedInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payLaterReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  payments?: InputMaybe<PaymentUpdateManyWithoutAccountNestedInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  receivedMessages?: InputMaybe<MessageUpdateManyWithoutToAccountNestedInput>;
  registrationToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  role?: InputMaybe<EnumRoleFieldUpdateOperationsInput>;
  secondAccountConversations?: InputMaybe<ConversationUpdateManyWithoutSecondAccountNestedInput>;
  sentMessages?: InputMaybe<MessageUpdateManyWithoutFromAccountNestedInput>;
  stripeCustomerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updates?: InputMaybe<UpdateUpdateManyWithoutAccountNestedInput>;
};

export type AccountUpdateWithoutDogBreederInput = {
  EducatorReviews?: InputMaybe<EducatorReviewUpdateManyWithoutAccountNestedInput>;
  activated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  activeCampaignContactId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  activityLogs?: InputMaybe<AccountActivityUpdateManyWithoutAccountNestedInput>;
  address?: InputMaybe<AddressUpdateOneWithoutAccountNestedInput>;
  adminNotes?: InputMaybe<AdminNoteUpdateManyWithoutAccountNestedInput>;
  animals?: InputMaybe<AnimalUpdateManyWithoutOwnerNestedInput>;
  applicationReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  applications?: InputMaybe<DogBreederApplicationUpdateManyWithoutAccountNestedInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  bookings?: InputMaybe<BookingUpdateManyWithoutAccountNestedInput>;
  bookmarks?: InputMaybe<BookmarkUpdateManyWithoutAccountNestedInput>;
  connectedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  contactPreferences?: InputMaybe<Array<ContactPreference>>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deleted?: InputMaybe<BoolFieldUpdateOperationsInput>;
  dogBreederReview?: InputMaybe<DogBreederReviewUpdateManyWithoutAccountNestedInput>;
  draftApplicationReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailContact?: InputMaybe<EmailContactUpdateOneWithoutAccountNestedInput>;
  emailHistory?: InputMaybe<EmailHistoryUpdateManyWithoutAccountNestedInput>;
  facebookId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firebaseId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firebaseToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstAccountConversations?: InputMaybe<ConversationUpdateManyWithoutFirstAccountNestedInput>;
  firstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freeApplicationsDateLimit?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableEnumGenderEnumFieldUpdateOperationsInput>;
  googleId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  imgs?: InputMaybe<AccountImgUpdateManyWithoutAccountNestedInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mailjetId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutAccountNestedInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payLaterReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  payments?: InputMaybe<PaymentUpdateManyWithoutAccountNestedInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  receivedMessages?: InputMaybe<MessageUpdateManyWithoutToAccountNestedInput>;
  registrationToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  role?: InputMaybe<EnumRoleFieldUpdateOperationsInput>;
  secondAccountConversations?: InputMaybe<ConversationUpdateManyWithoutSecondAccountNestedInput>;
  sentMessages?: InputMaybe<MessageUpdateManyWithoutFromAccountNestedInput>;
  stripeCustomerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updates?: InputMaybe<UpdateUpdateManyWithoutAccountNestedInput>;
};

export type AccountUpdateWithoutDogBreederReviewInput = {
  EducatorReviews?: InputMaybe<EducatorReviewUpdateManyWithoutAccountNestedInput>;
  activated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  activeCampaignContactId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  activityLogs?: InputMaybe<AccountActivityUpdateManyWithoutAccountNestedInput>;
  address?: InputMaybe<AddressUpdateOneWithoutAccountNestedInput>;
  adminNotes?: InputMaybe<AdminNoteUpdateManyWithoutAccountNestedInput>;
  animals?: InputMaybe<AnimalUpdateManyWithoutOwnerNestedInput>;
  applicationReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  applications?: InputMaybe<DogBreederApplicationUpdateManyWithoutAccountNestedInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  bookings?: InputMaybe<BookingUpdateManyWithoutAccountNestedInput>;
  bookmarks?: InputMaybe<BookmarkUpdateManyWithoutAccountNestedInput>;
  connectedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  contactPreferences?: InputMaybe<Array<ContactPreference>>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deleted?: InputMaybe<BoolFieldUpdateOperationsInput>;
  dogBreeder?: InputMaybe<DogBreederUpdateOneWithoutAccountNestedInput>;
  draftApplicationReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailContact?: InputMaybe<EmailContactUpdateOneWithoutAccountNestedInput>;
  emailHistory?: InputMaybe<EmailHistoryUpdateManyWithoutAccountNestedInput>;
  facebookId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firebaseId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firebaseToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstAccountConversations?: InputMaybe<ConversationUpdateManyWithoutFirstAccountNestedInput>;
  firstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freeApplicationsDateLimit?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableEnumGenderEnumFieldUpdateOperationsInput>;
  googleId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  imgs?: InputMaybe<AccountImgUpdateManyWithoutAccountNestedInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mailjetId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutAccountNestedInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payLaterReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  payments?: InputMaybe<PaymentUpdateManyWithoutAccountNestedInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  receivedMessages?: InputMaybe<MessageUpdateManyWithoutToAccountNestedInput>;
  registrationToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  role?: InputMaybe<EnumRoleFieldUpdateOperationsInput>;
  secondAccountConversations?: InputMaybe<ConversationUpdateManyWithoutSecondAccountNestedInput>;
  sentMessages?: InputMaybe<MessageUpdateManyWithoutFromAccountNestedInput>;
  stripeCustomerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updates?: InputMaybe<UpdateUpdateManyWithoutAccountNestedInput>;
};

export type AccountUpdateWithoutEducatorReviewsInput = {
  activated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  activeCampaignContactId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  activityLogs?: InputMaybe<AccountActivityUpdateManyWithoutAccountNestedInput>;
  address?: InputMaybe<AddressUpdateOneWithoutAccountNestedInput>;
  adminNotes?: InputMaybe<AdminNoteUpdateManyWithoutAccountNestedInput>;
  animals?: InputMaybe<AnimalUpdateManyWithoutOwnerNestedInput>;
  applicationReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  applications?: InputMaybe<DogBreederApplicationUpdateManyWithoutAccountNestedInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  bookings?: InputMaybe<BookingUpdateManyWithoutAccountNestedInput>;
  bookmarks?: InputMaybe<BookmarkUpdateManyWithoutAccountNestedInput>;
  connectedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  contactPreferences?: InputMaybe<Array<ContactPreference>>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deleted?: InputMaybe<BoolFieldUpdateOperationsInput>;
  dogBreeder?: InputMaybe<DogBreederUpdateOneWithoutAccountNestedInput>;
  dogBreederReview?: InputMaybe<DogBreederReviewUpdateManyWithoutAccountNestedInput>;
  draftApplicationReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailContact?: InputMaybe<EmailContactUpdateOneWithoutAccountNestedInput>;
  emailHistory?: InputMaybe<EmailHistoryUpdateManyWithoutAccountNestedInput>;
  facebookId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firebaseId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firebaseToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstAccountConversations?: InputMaybe<ConversationUpdateManyWithoutFirstAccountNestedInput>;
  firstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freeApplicationsDateLimit?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableEnumGenderEnumFieldUpdateOperationsInput>;
  googleId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  imgs?: InputMaybe<AccountImgUpdateManyWithoutAccountNestedInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mailjetId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutAccountNestedInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payLaterReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  payments?: InputMaybe<PaymentUpdateManyWithoutAccountNestedInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  receivedMessages?: InputMaybe<MessageUpdateManyWithoutToAccountNestedInput>;
  registrationToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  role?: InputMaybe<EnumRoleFieldUpdateOperationsInput>;
  secondAccountConversations?: InputMaybe<ConversationUpdateManyWithoutSecondAccountNestedInput>;
  sentMessages?: InputMaybe<MessageUpdateManyWithoutFromAccountNestedInput>;
  stripeCustomerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updates?: InputMaybe<UpdateUpdateManyWithoutAccountNestedInput>;
};

export type AccountUpdateWithoutEmailContactInput = {
  EducatorReviews?: InputMaybe<EducatorReviewUpdateManyWithoutAccountNestedInput>;
  activated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  activeCampaignContactId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  activityLogs?: InputMaybe<AccountActivityUpdateManyWithoutAccountNestedInput>;
  address?: InputMaybe<AddressUpdateOneWithoutAccountNestedInput>;
  adminNotes?: InputMaybe<AdminNoteUpdateManyWithoutAccountNestedInput>;
  animals?: InputMaybe<AnimalUpdateManyWithoutOwnerNestedInput>;
  applicationReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  applications?: InputMaybe<DogBreederApplicationUpdateManyWithoutAccountNestedInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  bookings?: InputMaybe<BookingUpdateManyWithoutAccountNestedInput>;
  bookmarks?: InputMaybe<BookmarkUpdateManyWithoutAccountNestedInput>;
  connectedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  contactPreferences?: InputMaybe<Array<ContactPreference>>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deleted?: InputMaybe<BoolFieldUpdateOperationsInput>;
  dogBreeder?: InputMaybe<DogBreederUpdateOneWithoutAccountNestedInput>;
  dogBreederReview?: InputMaybe<DogBreederReviewUpdateManyWithoutAccountNestedInput>;
  draftApplicationReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailHistory?: InputMaybe<EmailHistoryUpdateManyWithoutAccountNestedInput>;
  facebookId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firebaseId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firebaseToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstAccountConversations?: InputMaybe<ConversationUpdateManyWithoutFirstAccountNestedInput>;
  firstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freeApplicationsDateLimit?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableEnumGenderEnumFieldUpdateOperationsInput>;
  googleId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  imgs?: InputMaybe<AccountImgUpdateManyWithoutAccountNestedInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mailjetId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutAccountNestedInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payLaterReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  payments?: InputMaybe<PaymentUpdateManyWithoutAccountNestedInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  receivedMessages?: InputMaybe<MessageUpdateManyWithoutToAccountNestedInput>;
  registrationToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  role?: InputMaybe<EnumRoleFieldUpdateOperationsInput>;
  secondAccountConversations?: InputMaybe<ConversationUpdateManyWithoutSecondAccountNestedInput>;
  sentMessages?: InputMaybe<MessageUpdateManyWithoutFromAccountNestedInput>;
  stripeCustomerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updates?: InputMaybe<UpdateUpdateManyWithoutAccountNestedInput>;
};

export type AccountUpdateWithoutEmailHistoryInput = {
  EducatorReviews?: InputMaybe<EducatorReviewUpdateManyWithoutAccountNestedInput>;
  activated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  activeCampaignContactId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  activityLogs?: InputMaybe<AccountActivityUpdateManyWithoutAccountNestedInput>;
  address?: InputMaybe<AddressUpdateOneWithoutAccountNestedInput>;
  adminNotes?: InputMaybe<AdminNoteUpdateManyWithoutAccountNestedInput>;
  animals?: InputMaybe<AnimalUpdateManyWithoutOwnerNestedInput>;
  applicationReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  applications?: InputMaybe<DogBreederApplicationUpdateManyWithoutAccountNestedInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  bookings?: InputMaybe<BookingUpdateManyWithoutAccountNestedInput>;
  bookmarks?: InputMaybe<BookmarkUpdateManyWithoutAccountNestedInput>;
  connectedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  contactPreferences?: InputMaybe<Array<ContactPreference>>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deleted?: InputMaybe<BoolFieldUpdateOperationsInput>;
  dogBreeder?: InputMaybe<DogBreederUpdateOneWithoutAccountNestedInput>;
  dogBreederReview?: InputMaybe<DogBreederReviewUpdateManyWithoutAccountNestedInput>;
  draftApplicationReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailContact?: InputMaybe<EmailContactUpdateOneWithoutAccountNestedInput>;
  facebookId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firebaseId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firebaseToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstAccountConversations?: InputMaybe<ConversationUpdateManyWithoutFirstAccountNestedInput>;
  firstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freeApplicationsDateLimit?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableEnumGenderEnumFieldUpdateOperationsInput>;
  googleId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  imgs?: InputMaybe<AccountImgUpdateManyWithoutAccountNestedInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mailjetId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutAccountNestedInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payLaterReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  payments?: InputMaybe<PaymentUpdateManyWithoutAccountNestedInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  receivedMessages?: InputMaybe<MessageUpdateManyWithoutToAccountNestedInput>;
  registrationToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  role?: InputMaybe<EnumRoleFieldUpdateOperationsInput>;
  secondAccountConversations?: InputMaybe<ConversationUpdateManyWithoutSecondAccountNestedInput>;
  sentMessages?: InputMaybe<MessageUpdateManyWithoutFromAccountNestedInput>;
  stripeCustomerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updates?: InputMaybe<UpdateUpdateManyWithoutAccountNestedInput>;
};

export type AccountUpdateWithoutFirstAccountConversationsInput = {
  EducatorReviews?: InputMaybe<EducatorReviewUpdateManyWithoutAccountNestedInput>;
  activated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  activeCampaignContactId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  activityLogs?: InputMaybe<AccountActivityUpdateManyWithoutAccountNestedInput>;
  address?: InputMaybe<AddressUpdateOneWithoutAccountNestedInput>;
  adminNotes?: InputMaybe<AdminNoteUpdateManyWithoutAccountNestedInput>;
  animals?: InputMaybe<AnimalUpdateManyWithoutOwnerNestedInput>;
  applicationReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  applications?: InputMaybe<DogBreederApplicationUpdateManyWithoutAccountNestedInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  bookings?: InputMaybe<BookingUpdateManyWithoutAccountNestedInput>;
  bookmarks?: InputMaybe<BookmarkUpdateManyWithoutAccountNestedInput>;
  connectedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  contactPreferences?: InputMaybe<Array<ContactPreference>>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deleted?: InputMaybe<BoolFieldUpdateOperationsInput>;
  dogBreeder?: InputMaybe<DogBreederUpdateOneWithoutAccountNestedInput>;
  dogBreederReview?: InputMaybe<DogBreederReviewUpdateManyWithoutAccountNestedInput>;
  draftApplicationReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailContact?: InputMaybe<EmailContactUpdateOneWithoutAccountNestedInput>;
  emailHistory?: InputMaybe<EmailHistoryUpdateManyWithoutAccountNestedInput>;
  facebookId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firebaseId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firebaseToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freeApplicationsDateLimit?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableEnumGenderEnumFieldUpdateOperationsInput>;
  googleId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  imgs?: InputMaybe<AccountImgUpdateManyWithoutAccountNestedInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mailjetId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutAccountNestedInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payLaterReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  payments?: InputMaybe<PaymentUpdateManyWithoutAccountNestedInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  receivedMessages?: InputMaybe<MessageUpdateManyWithoutToAccountNestedInput>;
  registrationToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  role?: InputMaybe<EnumRoleFieldUpdateOperationsInput>;
  secondAccountConversations?: InputMaybe<ConversationUpdateManyWithoutSecondAccountNestedInput>;
  sentMessages?: InputMaybe<MessageUpdateManyWithoutFromAccountNestedInput>;
  stripeCustomerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updates?: InputMaybe<UpdateUpdateManyWithoutAccountNestedInput>;
};

export type AccountUpdateWithoutImgsInput = {
  EducatorReviews?: InputMaybe<EducatorReviewUpdateManyWithoutAccountNestedInput>;
  activated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  activeCampaignContactId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  activityLogs?: InputMaybe<AccountActivityUpdateManyWithoutAccountNestedInput>;
  address?: InputMaybe<AddressUpdateOneWithoutAccountNestedInput>;
  adminNotes?: InputMaybe<AdminNoteUpdateManyWithoutAccountNestedInput>;
  animals?: InputMaybe<AnimalUpdateManyWithoutOwnerNestedInput>;
  applicationReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  applications?: InputMaybe<DogBreederApplicationUpdateManyWithoutAccountNestedInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  bookings?: InputMaybe<BookingUpdateManyWithoutAccountNestedInput>;
  bookmarks?: InputMaybe<BookmarkUpdateManyWithoutAccountNestedInput>;
  connectedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  contactPreferences?: InputMaybe<Array<ContactPreference>>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deleted?: InputMaybe<BoolFieldUpdateOperationsInput>;
  dogBreeder?: InputMaybe<DogBreederUpdateOneWithoutAccountNestedInput>;
  dogBreederReview?: InputMaybe<DogBreederReviewUpdateManyWithoutAccountNestedInput>;
  draftApplicationReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailContact?: InputMaybe<EmailContactUpdateOneWithoutAccountNestedInput>;
  emailHistory?: InputMaybe<EmailHistoryUpdateManyWithoutAccountNestedInput>;
  facebookId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firebaseId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firebaseToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstAccountConversations?: InputMaybe<ConversationUpdateManyWithoutFirstAccountNestedInput>;
  firstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freeApplicationsDateLimit?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableEnumGenderEnumFieldUpdateOperationsInput>;
  googleId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mailjetId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutAccountNestedInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payLaterReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  payments?: InputMaybe<PaymentUpdateManyWithoutAccountNestedInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  receivedMessages?: InputMaybe<MessageUpdateManyWithoutToAccountNestedInput>;
  registrationToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  role?: InputMaybe<EnumRoleFieldUpdateOperationsInput>;
  secondAccountConversations?: InputMaybe<ConversationUpdateManyWithoutSecondAccountNestedInput>;
  sentMessages?: InputMaybe<MessageUpdateManyWithoutFromAccountNestedInput>;
  stripeCustomerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updates?: InputMaybe<UpdateUpdateManyWithoutAccountNestedInput>;
};

export type AccountUpdateWithoutNotificationsInput = {
  EducatorReviews?: InputMaybe<EducatorReviewUpdateManyWithoutAccountNestedInput>;
  activated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  activeCampaignContactId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  activityLogs?: InputMaybe<AccountActivityUpdateManyWithoutAccountNestedInput>;
  address?: InputMaybe<AddressUpdateOneWithoutAccountNestedInput>;
  adminNotes?: InputMaybe<AdminNoteUpdateManyWithoutAccountNestedInput>;
  animals?: InputMaybe<AnimalUpdateManyWithoutOwnerNestedInput>;
  applicationReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  applications?: InputMaybe<DogBreederApplicationUpdateManyWithoutAccountNestedInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  bookings?: InputMaybe<BookingUpdateManyWithoutAccountNestedInput>;
  bookmarks?: InputMaybe<BookmarkUpdateManyWithoutAccountNestedInput>;
  connectedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  contactPreferences?: InputMaybe<Array<ContactPreference>>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deleted?: InputMaybe<BoolFieldUpdateOperationsInput>;
  dogBreeder?: InputMaybe<DogBreederUpdateOneWithoutAccountNestedInput>;
  dogBreederReview?: InputMaybe<DogBreederReviewUpdateManyWithoutAccountNestedInput>;
  draftApplicationReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailContact?: InputMaybe<EmailContactUpdateOneWithoutAccountNestedInput>;
  emailHistory?: InputMaybe<EmailHistoryUpdateManyWithoutAccountNestedInput>;
  facebookId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firebaseId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firebaseToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstAccountConversations?: InputMaybe<ConversationUpdateManyWithoutFirstAccountNestedInput>;
  firstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freeApplicationsDateLimit?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableEnumGenderEnumFieldUpdateOperationsInput>;
  googleId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  imgs?: InputMaybe<AccountImgUpdateManyWithoutAccountNestedInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mailjetId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payLaterReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  payments?: InputMaybe<PaymentUpdateManyWithoutAccountNestedInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  receivedMessages?: InputMaybe<MessageUpdateManyWithoutToAccountNestedInput>;
  registrationToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  role?: InputMaybe<EnumRoleFieldUpdateOperationsInput>;
  secondAccountConversations?: InputMaybe<ConversationUpdateManyWithoutSecondAccountNestedInput>;
  sentMessages?: InputMaybe<MessageUpdateManyWithoutFromAccountNestedInput>;
  stripeCustomerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updates?: InputMaybe<UpdateUpdateManyWithoutAccountNestedInput>;
};

export type AccountUpdateWithoutPaymentsInput = {
  EducatorReviews?: InputMaybe<EducatorReviewUpdateManyWithoutAccountNestedInput>;
  activated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  activeCampaignContactId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  activityLogs?: InputMaybe<AccountActivityUpdateManyWithoutAccountNestedInput>;
  address?: InputMaybe<AddressUpdateOneWithoutAccountNestedInput>;
  adminNotes?: InputMaybe<AdminNoteUpdateManyWithoutAccountNestedInput>;
  animals?: InputMaybe<AnimalUpdateManyWithoutOwnerNestedInput>;
  applicationReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  applications?: InputMaybe<DogBreederApplicationUpdateManyWithoutAccountNestedInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  bookings?: InputMaybe<BookingUpdateManyWithoutAccountNestedInput>;
  bookmarks?: InputMaybe<BookmarkUpdateManyWithoutAccountNestedInput>;
  connectedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  contactPreferences?: InputMaybe<Array<ContactPreference>>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deleted?: InputMaybe<BoolFieldUpdateOperationsInput>;
  dogBreeder?: InputMaybe<DogBreederUpdateOneWithoutAccountNestedInput>;
  dogBreederReview?: InputMaybe<DogBreederReviewUpdateManyWithoutAccountNestedInput>;
  draftApplicationReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailContact?: InputMaybe<EmailContactUpdateOneWithoutAccountNestedInput>;
  emailHistory?: InputMaybe<EmailHistoryUpdateManyWithoutAccountNestedInput>;
  facebookId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firebaseId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firebaseToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstAccountConversations?: InputMaybe<ConversationUpdateManyWithoutFirstAccountNestedInput>;
  firstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freeApplicationsDateLimit?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableEnumGenderEnumFieldUpdateOperationsInput>;
  googleId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  imgs?: InputMaybe<AccountImgUpdateManyWithoutAccountNestedInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mailjetId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutAccountNestedInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payLaterReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  receivedMessages?: InputMaybe<MessageUpdateManyWithoutToAccountNestedInput>;
  registrationToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  role?: InputMaybe<EnumRoleFieldUpdateOperationsInput>;
  secondAccountConversations?: InputMaybe<ConversationUpdateManyWithoutSecondAccountNestedInput>;
  sentMessages?: InputMaybe<MessageUpdateManyWithoutFromAccountNestedInput>;
  stripeCustomerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updates?: InputMaybe<UpdateUpdateManyWithoutAccountNestedInput>;
};

export type AccountUpdateWithoutReceivedMessagesInput = {
  EducatorReviews?: InputMaybe<EducatorReviewUpdateManyWithoutAccountNestedInput>;
  activated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  activeCampaignContactId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  activityLogs?: InputMaybe<AccountActivityUpdateManyWithoutAccountNestedInput>;
  address?: InputMaybe<AddressUpdateOneWithoutAccountNestedInput>;
  adminNotes?: InputMaybe<AdminNoteUpdateManyWithoutAccountNestedInput>;
  animals?: InputMaybe<AnimalUpdateManyWithoutOwnerNestedInput>;
  applicationReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  applications?: InputMaybe<DogBreederApplicationUpdateManyWithoutAccountNestedInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  bookings?: InputMaybe<BookingUpdateManyWithoutAccountNestedInput>;
  bookmarks?: InputMaybe<BookmarkUpdateManyWithoutAccountNestedInput>;
  connectedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  contactPreferences?: InputMaybe<Array<ContactPreference>>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deleted?: InputMaybe<BoolFieldUpdateOperationsInput>;
  dogBreeder?: InputMaybe<DogBreederUpdateOneWithoutAccountNestedInput>;
  dogBreederReview?: InputMaybe<DogBreederReviewUpdateManyWithoutAccountNestedInput>;
  draftApplicationReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailContact?: InputMaybe<EmailContactUpdateOneWithoutAccountNestedInput>;
  emailHistory?: InputMaybe<EmailHistoryUpdateManyWithoutAccountNestedInput>;
  facebookId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firebaseId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firebaseToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstAccountConversations?: InputMaybe<ConversationUpdateManyWithoutFirstAccountNestedInput>;
  firstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freeApplicationsDateLimit?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableEnumGenderEnumFieldUpdateOperationsInput>;
  googleId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  imgs?: InputMaybe<AccountImgUpdateManyWithoutAccountNestedInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mailjetId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutAccountNestedInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payLaterReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  payments?: InputMaybe<PaymentUpdateManyWithoutAccountNestedInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  registrationToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  role?: InputMaybe<EnumRoleFieldUpdateOperationsInput>;
  secondAccountConversations?: InputMaybe<ConversationUpdateManyWithoutSecondAccountNestedInput>;
  sentMessages?: InputMaybe<MessageUpdateManyWithoutFromAccountNestedInput>;
  stripeCustomerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updates?: InputMaybe<UpdateUpdateManyWithoutAccountNestedInput>;
};

export type AccountUpdateWithoutSecondAccountConversationsInput = {
  EducatorReviews?: InputMaybe<EducatorReviewUpdateManyWithoutAccountNestedInput>;
  activated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  activeCampaignContactId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  activityLogs?: InputMaybe<AccountActivityUpdateManyWithoutAccountNestedInput>;
  address?: InputMaybe<AddressUpdateOneWithoutAccountNestedInput>;
  adminNotes?: InputMaybe<AdminNoteUpdateManyWithoutAccountNestedInput>;
  animals?: InputMaybe<AnimalUpdateManyWithoutOwnerNestedInput>;
  applicationReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  applications?: InputMaybe<DogBreederApplicationUpdateManyWithoutAccountNestedInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  bookings?: InputMaybe<BookingUpdateManyWithoutAccountNestedInput>;
  bookmarks?: InputMaybe<BookmarkUpdateManyWithoutAccountNestedInput>;
  connectedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  contactPreferences?: InputMaybe<Array<ContactPreference>>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deleted?: InputMaybe<BoolFieldUpdateOperationsInput>;
  dogBreeder?: InputMaybe<DogBreederUpdateOneWithoutAccountNestedInput>;
  dogBreederReview?: InputMaybe<DogBreederReviewUpdateManyWithoutAccountNestedInput>;
  draftApplicationReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailContact?: InputMaybe<EmailContactUpdateOneWithoutAccountNestedInput>;
  emailHistory?: InputMaybe<EmailHistoryUpdateManyWithoutAccountNestedInput>;
  facebookId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firebaseId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firebaseToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstAccountConversations?: InputMaybe<ConversationUpdateManyWithoutFirstAccountNestedInput>;
  firstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freeApplicationsDateLimit?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableEnumGenderEnumFieldUpdateOperationsInput>;
  googleId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  imgs?: InputMaybe<AccountImgUpdateManyWithoutAccountNestedInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mailjetId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutAccountNestedInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payLaterReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  payments?: InputMaybe<PaymentUpdateManyWithoutAccountNestedInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  receivedMessages?: InputMaybe<MessageUpdateManyWithoutToAccountNestedInput>;
  registrationToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  role?: InputMaybe<EnumRoleFieldUpdateOperationsInput>;
  sentMessages?: InputMaybe<MessageUpdateManyWithoutFromAccountNestedInput>;
  stripeCustomerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updates?: InputMaybe<UpdateUpdateManyWithoutAccountNestedInput>;
};

export type AccountUpdateWithoutSentMessagesInput = {
  EducatorReviews?: InputMaybe<EducatorReviewUpdateManyWithoutAccountNestedInput>;
  activated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  activeCampaignContactId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  activityLogs?: InputMaybe<AccountActivityUpdateManyWithoutAccountNestedInput>;
  address?: InputMaybe<AddressUpdateOneWithoutAccountNestedInput>;
  adminNotes?: InputMaybe<AdminNoteUpdateManyWithoutAccountNestedInput>;
  animals?: InputMaybe<AnimalUpdateManyWithoutOwnerNestedInput>;
  applicationReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  applications?: InputMaybe<DogBreederApplicationUpdateManyWithoutAccountNestedInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  bookings?: InputMaybe<BookingUpdateManyWithoutAccountNestedInput>;
  bookmarks?: InputMaybe<BookmarkUpdateManyWithoutAccountNestedInput>;
  connectedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  contactPreferences?: InputMaybe<Array<ContactPreference>>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deleted?: InputMaybe<BoolFieldUpdateOperationsInput>;
  dogBreeder?: InputMaybe<DogBreederUpdateOneWithoutAccountNestedInput>;
  dogBreederReview?: InputMaybe<DogBreederReviewUpdateManyWithoutAccountNestedInput>;
  draftApplicationReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailContact?: InputMaybe<EmailContactUpdateOneWithoutAccountNestedInput>;
  emailHistory?: InputMaybe<EmailHistoryUpdateManyWithoutAccountNestedInput>;
  facebookId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firebaseId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firebaseToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstAccountConversations?: InputMaybe<ConversationUpdateManyWithoutFirstAccountNestedInput>;
  firstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freeApplicationsDateLimit?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableEnumGenderEnumFieldUpdateOperationsInput>;
  googleId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  imgs?: InputMaybe<AccountImgUpdateManyWithoutAccountNestedInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mailjetId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutAccountNestedInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payLaterReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  payments?: InputMaybe<PaymentUpdateManyWithoutAccountNestedInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  receivedMessages?: InputMaybe<MessageUpdateManyWithoutToAccountNestedInput>;
  registrationToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  role?: InputMaybe<EnumRoleFieldUpdateOperationsInput>;
  secondAccountConversations?: InputMaybe<ConversationUpdateManyWithoutSecondAccountNestedInput>;
  stripeCustomerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updates?: InputMaybe<UpdateUpdateManyWithoutAccountNestedInput>;
};

export type AccountUpdateWithoutUpdatesInput = {
  EducatorReviews?: InputMaybe<EducatorReviewUpdateManyWithoutAccountNestedInput>;
  activated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  activeCampaignContactId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  activityLogs?: InputMaybe<AccountActivityUpdateManyWithoutAccountNestedInput>;
  address?: InputMaybe<AddressUpdateOneWithoutAccountNestedInput>;
  adminNotes?: InputMaybe<AdminNoteUpdateManyWithoutAccountNestedInput>;
  animals?: InputMaybe<AnimalUpdateManyWithoutOwnerNestedInput>;
  applicationReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  applications?: InputMaybe<DogBreederApplicationUpdateManyWithoutAccountNestedInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  bookings?: InputMaybe<BookingUpdateManyWithoutAccountNestedInput>;
  bookmarks?: InputMaybe<BookmarkUpdateManyWithoutAccountNestedInput>;
  connectedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  contactPreferences?: InputMaybe<Array<ContactPreference>>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deleted?: InputMaybe<BoolFieldUpdateOperationsInput>;
  dogBreeder?: InputMaybe<DogBreederUpdateOneWithoutAccountNestedInput>;
  dogBreederReview?: InputMaybe<DogBreederReviewUpdateManyWithoutAccountNestedInput>;
  draftApplicationReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailContact?: InputMaybe<EmailContactUpdateOneWithoutAccountNestedInput>;
  emailHistory?: InputMaybe<EmailHistoryUpdateManyWithoutAccountNestedInput>;
  facebookId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firebaseId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firebaseToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstAccountConversations?: InputMaybe<ConversationUpdateManyWithoutFirstAccountNestedInput>;
  firstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  freeApplicationsDateLimit?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableEnumGenderEnumFieldUpdateOperationsInput>;
  googleId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  imgs?: InputMaybe<AccountImgUpdateManyWithoutAccountNestedInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mailjetId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutAccountNestedInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payLaterReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  payments?: InputMaybe<PaymentUpdateManyWithoutAccountNestedInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  receivedMessages?: InputMaybe<MessageUpdateManyWithoutToAccountNestedInput>;
  registrationToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  role?: InputMaybe<EnumRoleFieldUpdateOperationsInput>;
  secondAccountConversations?: InputMaybe<ConversationUpdateManyWithoutSecondAccountNestedInput>;
  sentMessages?: InputMaybe<MessageUpdateManyWithoutFromAccountNestedInput>;
  stripeCustomerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type AccountUpdatecontactPreferencesInput = {
  push?: InputMaybe<Array<ContactPreference>>;
  set?: InputMaybe<Array<ContactPreference>>;
};

export type AccountUpsertWithoutActivityLogsInput = {
  create: AccountCreateWithoutActivityLogsInput;
  update: AccountUpdateWithoutActivityLogsInput;
  where?: InputMaybe<AccountWhereInput>;
};

export type AccountUpsertWithoutAddressInput = {
  create: AccountCreateWithoutAddressInput;
  update: AccountUpdateWithoutAddressInput;
  where?: InputMaybe<AccountWhereInput>;
};

export type AccountUpsertWithoutAdminNotesInput = {
  create: AccountCreateWithoutAdminNotesInput;
  update: AccountUpdateWithoutAdminNotesInput;
  where?: InputMaybe<AccountWhereInput>;
};

export type AccountUpsertWithoutAnimalsInput = {
  create: AccountCreateWithoutAnimalsInput;
  update: AccountUpdateWithoutAnimalsInput;
  where?: InputMaybe<AccountWhereInput>;
};

export type AccountUpsertWithoutApplicationsInput = {
  create: AccountCreateWithoutApplicationsInput;
  update: AccountUpdateWithoutApplicationsInput;
  where?: InputMaybe<AccountWhereInput>;
};

export type AccountUpsertWithoutBookingsInput = {
  create: AccountCreateWithoutBookingsInput;
  update: AccountUpdateWithoutBookingsInput;
  where?: InputMaybe<AccountWhereInput>;
};

export type AccountUpsertWithoutBookmarksInput = {
  create: AccountCreateWithoutBookmarksInput;
  update: AccountUpdateWithoutBookmarksInput;
  where?: InputMaybe<AccountWhereInput>;
};

export type AccountUpsertWithoutDogBreederInput = {
  create: AccountCreateWithoutDogBreederInput;
  update: AccountUpdateWithoutDogBreederInput;
  where?: InputMaybe<AccountWhereInput>;
};

export type AccountUpsertWithoutDogBreederReviewInput = {
  create: AccountCreateWithoutDogBreederReviewInput;
  update: AccountUpdateWithoutDogBreederReviewInput;
  where?: InputMaybe<AccountWhereInput>;
};

export type AccountUpsertWithoutEducatorReviewsInput = {
  create: AccountCreateWithoutEducatorReviewsInput;
  update: AccountUpdateWithoutEducatorReviewsInput;
  where?: InputMaybe<AccountWhereInput>;
};

export type AccountUpsertWithoutEmailContactInput = {
  create: AccountCreateWithoutEmailContactInput;
  update: AccountUpdateWithoutEmailContactInput;
  where?: InputMaybe<AccountWhereInput>;
};

export type AccountUpsertWithoutEmailHistoryInput = {
  create: AccountCreateWithoutEmailHistoryInput;
  update: AccountUpdateWithoutEmailHistoryInput;
  where?: InputMaybe<AccountWhereInput>;
};

export type AccountUpsertWithoutFirstAccountConversationsInput = {
  create: AccountCreateWithoutFirstAccountConversationsInput;
  update: AccountUpdateWithoutFirstAccountConversationsInput;
  where?: InputMaybe<AccountWhereInput>;
};

export type AccountUpsertWithoutImgsInput = {
  create: AccountCreateWithoutImgsInput;
  update: AccountUpdateWithoutImgsInput;
  where?: InputMaybe<AccountWhereInput>;
};

export type AccountUpsertWithoutNotificationsInput = {
  create: AccountCreateWithoutNotificationsInput;
  update: AccountUpdateWithoutNotificationsInput;
  where?: InputMaybe<AccountWhereInput>;
};

export type AccountUpsertWithoutPaymentsInput = {
  create: AccountCreateWithoutPaymentsInput;
  update: AccountUpdateWithoutPaymentsInput;
  where?: InputMaybe<AccountWhereInput>;
};

export type AccountUpsertWithoutReceivedMessagesInput = {
  create: AccountCreateWithoutReceivedMessagesInput;
  update: AccountUpdateWithoutReceivedMessagesInput;
  where?: InputMaybe<AccountWhereInput>;
};

export type AccountUpsertWithoutSecondAccountConversationsInput = {
  create: AccountCreateWithoutSecondAccountConversationsInput;
  update: AccountUpdateWithoutSecondAccountConversationsInput;
  where?: InputMaybe<AccountWhereInput>;
};

export type AccountUpsertWithoutSentMessagesInput = {
  create: AccountCreateWithoutSentMessagesInput;
  update: AccountUpdateWithoutSentMessagesInput;
  where?: InputMaybe<AccountWhereInput>;
};

export type AccountUpsertWithoutUpdatesInput = {
  create: AccountCreateWithoutUpdatesInput;
  update: AccountUpdateWithoutUpdatesInput;
  where?: InputMaybe<AccountWhereInput>;
};

export type AccountWhereInput = {
  AND?: InputMaybe<Array<AccountWhereInput>>;
  EducatorReviews?: InputMaybe<EducatorReviewListRelationFilter>;
  NOT?: InputMaybe<Array<AccountWhereInput>>;
  OR?: InputMaybe<Array<AccountWhereInput>>;
  activated?: InputMaybe<BoolFilter>;
  activeCampaignContactId?: InputMaybe<StringNullableFilter>;
  activityLogs?: InputMaybe<AccountActivityListRelationFilter>;
  address?: InputMaybe<AddressNullableRelationFilter>;
  addressId?: InputMaybe<IntNullableFilter>;
  adminNotes?: InputMaybe<AdminNoteListRelationFilter>;
  animals?: InputMaybe<AnimalListRelationFilter>;
  applicationReminderSent?: InputMaybe<BoolFilter>;
  applications?: InputMaybe<DogBreederApplicationListRelationFilter>;
  birthday?: InputMaybe<DateTimeNullableFilter>;
  bookings?: InputMaybe<BookingListRelationFilter>;
  bookmarks?: InputMaybe<BookmarkListRelationFilter>;
  connectedAt?: InputMaybe<DateTimeFilter>;
  contactPreferences?: InputMaybe<EnumContactPreferenceNullableListFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deleted?: InputMaybe<BoolFilter>;
  dogBreeder?: InputMaybe<DogBreederNullableRelationFilter>;
  dogBreederReview?: InputMaybe<DogBreederReviewListRelationFilter>;
  draftApplicationReminderSent?: InputMaybe<BoolFilter>;
  email?: InputMaybe<StringFilter>;
  emailContact?: InputMaybe<EmailContactNullableRelationFilter>;
  emailHistory?: InputMaybe<EmailHistoryListRelationFilter>;
  facebookId?: InputMaybe<StringNullableFilter>;
  firebaseId?: InputMaybe<StringNullableFilter>;
  firebaseToken?: InputMaybe<StringNullableFilter>;
  firstAccountConversations?: InputMaybe<ConversationListRelationFilter>;
  firstName?: InputMaybe<StringNullableFilter>;
  freeApplicationsDateLimit?: InputMaybe<DateTimeNullableFilter>;
  gender?: InputMaybe<EnumGenderEnumNullableFilter>;
  googleId?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<IntFilter>;
  imgs?: InputMaybe<AccountImgListRelationFilter>;
  language?: InputMaybe<StringFilter>;
  lastName?: InputMaybe<StringNullableFilter>;
  mailjetId?: InputMaybe<StringNullableFilter>;
  name?: InputMaybe<StringNullableFilter>;
  notifications?: InputMaybe<NotificationListRelationFilter>;
  password?: InputMaybe<StringNullableFilter>;
  payLaterReminderSent?: InputMaybe<BoolFilter>;
  payments?: InputMaybe<PaymentListRelationFilter>;
  phone?: InputMaybe<StringNullableFilter>;
  receivedMessages?: InputMaybe<MessageListRelationFilter>;
  registrationToken?: InputMaybe<StringNullableFilter>;
  role?: InputMaybe<EnumRoleFilter>;
  secondAccountConversations?: InputMaybe<ConversationListRelationFilter>;
  sentMessages?: InputMaybe<MessageListRelationFilter>;
  stripeCustomerId?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  updates?: InputMaybe<UpdateListRelationFilter>;
};

export type AccountWhereUniqueInput = {
  AND?: InputMaybe<Array<AccountWhereInput>>;
  EducatorReviews?: InputMaybe<EducatorReviewListRelationFilter>;
  NOT?: InputMaybe<Array<AccountWhereInput>>;
  OR?: InputMaybe<Array<AccountWhereInput>>;
  activated?: InputMaybe<BoolFilter>;
  activeCampaignContactId?: InputMaybe<StringNullableFilter>;
  activityLogs?: InputMaybe<AccountActivityListRelationFilter>;
  address?: InputMaybe<AddressNullableRelationFilter>;
  addressId?: InputMaybe<Scalars['Int']['input']>;
  adminNotes?: InputMaybe<AdminNoteListRelationFilter>;
  animals?: InputMaybe<AnimalListRelationFilter>;
  applicationReminderSent?: InputMaybe<BoolFilter>;
  applications?: InputMaybe<DogBreederApplicationListRelationFilter>;
  birthday?: InputMaybe<DateTimeNullableFilter>;
  bookings?: InputMaybe<BookingListRelationFilter>;
  bookmarks?: InputMaybe<BookmarkListRelationFilter>;
  connectedAt?: InputMaybe<DateTimeFilter>;
  contactPreferences?: InputMaybe<EnumContactPreferenceNullableListFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deleted?: InputMaybe<BoolFilter>;
  dogBreeder?: InputMaybe<DogBreederNullableRelationFilter>;
  dogBreederReview?: InputMaybe<DogBreederReviewListRelationFilter>;
  draftApplicationReminderSent?: InputMaybe<BoolFilter>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailContact?: InputMaybe<EmailContactNullableRelationFilter>;
  emailHistory?: InputMaybe<EmailHistoryListRelationFilter>;
  facebookId?: InputMaybe<StringNullableFilter>;
  firebaseId?: InputMaybe<Scalars['String']['input']>;
  firebaseToken?: InputMaybe<StringNullableFilter>;
  firstAccountConversations?: InputMaybe<ConversationListRelationFilter>;
  firstName?: InputMaybe<StringNullableFilter>;
  freeApplicationsDateLimit?: InputMaybe<DateTimeNullableFilter>;
  gender?: InputMaybe<EnumGenderEnumNullableFilter>;
  googleId?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  imgs?: InputMaybe<AccountImgListRelationFilter>;
  language?: InputMaybe<StringFilter>;
  lastName?: InputMaybe<StringNullableFilter>;
  mailjetId?: InputMaybe<StringNullableFilter>;
  name?: InputMaybe<StringNullableFilter>;
  notifications?: InputMaybe<NotificationListRelationFilter>;
  password?: InputMaybe<StringNullableFilter>;
  payLaterReminderSent?: InputMaybe<BoolFilter>;
  payments?: InputMaybe<PaymentListRelationFilter>;
  phone?: InputMaybe<StringNullableFilter>;
  receivedMessages?: InputMaybe<MessageListRelationFilter>;
  registrationToken?: InputMaybe<StringNullableFilter>;
  role?: InputMaybe<EnumRoleFilter>;
  secondAccountConversations?: InputMaybe<ConversationListRelationFilter>;
  sentMessages?: InputMaybe<MessageListRelationFilter>;
  stripeCustomerId?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  updates?: InputMaybe<UpdateListRelationFilter>;
};

export type AccountWithToken = {
  __typename?: 'AccountWithToken';
  account?: Maybe<Account>;
  token?: Maybe<Scalars['String']['output']>;
};

export type Address = {
  __typename?: 'Address';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<CountryCode>;
  createdAt: Scalars['DateTime']['output'];
  formatted?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  otherCountry?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  streetNumber?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  zip?: Maybe<Scalars['String']['output']>;
};

export type AddressAvgAggregateOutputType = {
  __typename?: 'AddressAvgAggregateOutputType';
  id?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

export type AddressAvgOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
  lat?: InputMaybe<SortOrder>;
  lng?: InputMaybe<SortOrder>;
};

export type AddressCountAggregateOutputType = {
  __typename?: 'AddressCountAggregateOutputType';
  _all: Scalars['Int']['output'];
  city: Scalars['Int']['output'];
  country: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  lat: Scalars['Int']['output'];
  lng: Scalars['Int']['output'];
  region: Scalars['Int']['output'];
  street: Scalars['Int']['output'];
  streetNumber: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
  zip: Scalars['Int']['output'];
};

export type AddressCountOrderByAggregateInput = {
  city?: InputMaybe<SortOrder>;
  country?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  lat?: InputMaybe<SortOrder>;
  lng?: InputMaybe<SortOrder>;
  region?: InputMaybe<SortOrder>;
  street?: InputMaybe<SortOrder>;
  streetNumber?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  zip?: InputMaybe<SortOrder>;
};

export type AddressCreateInput = {
  account?: InputMaybe<AccountCreateNestedOneWithoutAddressInput>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<CountryCode>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dogShelter?: InputMaybe<DogShelterCreateNestedOneWithoutAddressInput>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  pro?: InputMaybe<ProfessionalCreateNestedOneWithoutAddressInput>;
  region?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  streetNumber?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type AddressCreateManyInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<CountryCode>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  streetNumber?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type AddressCreateNestedOneWithoutAccountInput = {
  connect?: InputMaybe<AddressWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AddressCreateOrConnectWithoutAccountInput>;
  create?: InputMaybe<AddressCreateWithoutAccountInput>;
};

export type AddressCreateNestedOneWithoutDogShelterInput = {
  connect?: InputMaybe<AddressWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AddressCreateOrConnectWithoutDogShelterInput>;
  create?: InputMaybe<AddressCreateWithoutDogShelterInput>;
};

export type AddressCreateNestedOneWithoutProInput = {
  connect?: InputMaybe<AddressWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AddressCreateOrConnectWithoutProInput>;
  create?: InputMaybe<AddressCreateWithoutProInput>;
};

export type AddressCreateOrConnectWithoutAccountInput = {
  create: AddressCreateWithoutAccountInput;
  where: AddressWhereUniqueInput;
};

export type AddressCreateOrConnectWithoutDogShelterInput = {
  create: AddressCreateWithoutDogShelterInput;
  where: AddressWhereUniqueInput;
};

export type AddressCreateOrConnectWithoutProInput = {
  create: AddressCreateWithoutProInput;
  where: AddressWhereUniqueInput;
};

export type AddressCreateWithoutAccountInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<CountryCode>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dogShelter?: InputMaybe<DogShelterCreateNestedOneWithoutAddressInput>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  pro?: InputMaybe<ProfessionalCreateNestedOneWithoutAddressInput>;
  region?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  streetNumber?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type AddressCreateWithoutDogShelterInput = {
  account?: InputMaybe<AccountCreateNestedOneWithoutAddressInput>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<CountryCode>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  pro?: InputMaybe<ProfessionalCreateNestedOneWithoutAddressInput>;
  region?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  streetNumber?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type AddressCreateWithoutProInput = {
  account?: InputMaybe<AccountCreateNestedOneWithoutAddressInput>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<CountryCode>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dogShelter?: InputMaybe<DogShelterCreateNestedOneWithoutAddressInput>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  streetNumber?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type AddressMaxAggregateOutputType = {
  __typename?: 'AddressMaxAggregateOutputType';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<CountryCode>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  streetNumber?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type AddressMaxOrderByAggregateInput = {
  city?: InputMaybe<SortOrder>;
  country?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  lat?: InputMaybe<SortOrder>;
  lng?: InputMaybe<SortOrder>;
  region?: InputMaybe<SortOrder>;
  street?: InputMaybe<SortOrder>;
  streetNumber?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  zip?: InputMaybe<SortOrder>;
};

export type AddressMinAggregateOutputType = {
  __typename?: 'AddressMinAggregateOutputType';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<CountryCode>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  streetNumber?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type AddressMinOrderByAggregateInput = {
  city?: InputMaybe<SortOrder>;
  country?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  lat?: InputMaybe<SortOrder>;
  lng?: InputMaybe<SortOrder>;
  region?: InputMaybe<SortOrder>;
  street?: InputMaybe<SortOrder>;
  streetNumber?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  zip?: InputMaybe<SortOrder>;
};

export type AddressNullableRelationFilter = {
  is?: InputMaybe<AddressWhereInput>;
  isNot?: InputMaybe<AddressWhereInput>;
};

export enum AddressOrderByRelevanceFieldEnum {
  city = 'city',
  region = 'region',
  street = 'street',
  streetNumber = 'streetNumber',
  zip = 'zip'
}

export type AddressOrderByRelevanceInput = {
  fields: Array<AddressOrderByRelevanceFieldEnum>;
  search: Scalars['String']['input'];
  sort: SortOrder;
};

export type AddressOrderByWithAggregationInput = {
  _avg?: InputMaybe<AddressAvgOrderByAggregateInput>;
  _count?: InputMaybe<AddressCountOrderByAggregateInput>;
  _max?: InputMaybe<AddressMaxOrderByAggregateInput>;
  _min?: InputMaybe<AddressMinOrderByAggregateInput>;
  _sum?: InputMaybe<AddressSumOrderByAggregateInput>;
  city?: InputMaybe<SortOrderInput>;
  country?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  lat?: InputMaybe<SortOrderInput>;
  lng?: InputMaybe<SortOrderInput>;
  region?: InputMaybe<SortOrderInput>;
  street?: InputMaybe<SortOrderInput>;
  streetNumber?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
  zip?: InputMaybe<SortOrderInput>;
};

export type AddressOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: InputMaybe<AddressOrderByRelevanceInput>;
  account?: InputMaybe<AccountOrderByWithRelationAndSearchRelevanceInput>;
  city?: InputMaybe<SortOrderInput>;
  country?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  dogShelter?: InputMaybe<DogShelterOrderByWithRelationAndSearchRelevanceInput>;
  id?: InputMaybe<SortOrder>;
  lat?: InputMaybe<SortOrderInput>;
  lng?: InputMaybe<SortOrderInput>;
  pro?: InputMaybe<ProfessionalOrderByWithRelationAndSearchRelevanceInput>;
  region?: InputMaybe<SortOrderInput>;
  street?: InputMaybe<SortOrderInput>;
  streetNumber?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
  zip?: InputMaybe<SortOrderInput>;
};

export enum AddressScalarFieldEnum {
  city = 'city',
  country = 'country',
  createdAt = 'createdAt',
  id = 'id',
  lat = 'lat',
  lng = 'lng',
  region = 'region',
  street = 'street',
  streetNumber = 'streetNumber',
  updatedAt = 'updatedAt',
  zip = 'zip'
}

export type AddressScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<AddressScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<AddressScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<AddressScalarWhereWithAggregatesInput>>;
  city?: InputMaybe<StringNullableWithAggregatesFilter>;
  country?: InputMaybe<EnumCountryCodeNullableWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  lat?: InputMaybe<FloatNullableWithAggregatesFilter>;
  lng?: InputMaybe<FloatNullableWithAggregatesFilter>;
  region?: InputMaybe<StringNullableWithAggregatesFilter>;
  street?: InputMaybe<StringNullableWithAggregatesFilter>;
  streetNumber?: InputMaybe<StringNullableWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  zip?: InputMaybe<StringNullableWithAggregatesFilter>;
};

export type AddressSumAggregateOutputType = {
  __typename?: 'AddressSumAggregateOutputType';
  id?: Maybe<Scalars['Int']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

export type AddressSumOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
  lat?: InputMaybe<SortOrder>;
  lng?: InputMaybe<SortOrder>;
};

export type AddressUncheckedCreateInput = {
  account?: InputMaybe<AccountUncheckedCreateNestedOneWithoutAddressInput>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<CountryCode>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dogShelter?: InputMaybe<DogShelterUncheckedCreateNestedOneWithoutAddressInput>;
  id?: InputMaybe<Scalars['Int']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  pro?: InputMaybe<ProfessionalUncheckedCreateNestedOneWithoutAddressInput>;
  region?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  streetNumber?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type AddressUncheckedCreateWithoutAccountInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<CountryCode>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dogShelter?: InputMaybe<DogShelterUncheckedCreateNestedOneWithoutAddressInput>;
  id?: InputMaybe<Scalars['Int']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  pro?: InputMaybe<ProfessionalUncheckedCreateNestedOneWithoutAddressInput>;
  region?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  streetNumber?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type AddressUncheckedCreateWithoutDogShelterInput = {
  account?: InputMaybe<AccountUncheckedCreateNestedOneWithoutAddressInput>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<CountryCode>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  pro?: InputMaybe<ProfessionalUncheckedCreateNestedOneWithoutAddressInput>;
  region?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  streetNumber?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type AddressUncheckedCreateWithoutProInput = {
  account?: InputMaybe<AccountUncheckedCreateNestedOneWithoutAddressInput>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<CountryCode>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dogShelter?: InputMaybe<DogShelterUncheckedCreateNestedOneWithoutAddressInput>;
  id?: InputMaybe<Scalars['Int']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  streetNumber?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type AddressUncheckedUpdateInput = {
  account?: InputMaybe<AccountUncheckedUpdateOneWithoutAddressNestedInput>;
  city?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  country?: InputMaybe<NullableEnumCountryCodeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dogShelter?: InputMaybe<DogShelterUncheckedUpdateOneWithoutAddressNestedInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  lat?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  lng?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  pro?: InputMaybe<ProfessionalUncheckedUpdateOneWithoutAddressNestedInput>;
  region?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  street?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  streetNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  zip?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type AddressUncheckedUpdateManyInput = {
  city?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  country?: InputMaybe<NullableEnumCountryCodeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  lat?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  lng?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  region?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  street?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  streetNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  zip?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type AddressUncheckedUpdateWithoutAccountInput = {
  city?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  country?: InputMaybe<NullableEnumCountryCodeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dogShelter?: InputMaybe<DogShelterUncheckedUpdateOneWithoutAddressNestedInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  lat?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  lng?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  pro?: InputMaybe<ProfessionalUncheckedUpdateOneWithoutAddressNestedInput>;
  region?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  street?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  streetNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  zip?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type AddressUncheckedUpdateWithoutDogShelterInput = {
  account?: InputMaybe<AccountUncheckedUpdateOneWithoutAddressNestedInput>;
  city?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  country?: InputMaybe<NullableEnumCountryCodeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  lat?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  lng?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  pro?: InputMaybe<ProfessionalUncheckedUpdateOneWithoutAddressNestedInput>;
  region?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  street?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  streetNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  zip?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type AddressUncheckedUpdateWithoutProInput = {
  account?: InputMaybe<AccountUncheckedUpdateOneWithoutAddressNestedInput>;
  city?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  country?: InputMaybe<NullableEnumCountryCodeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dogShelter?: InputMaybe<DogShelterUncheckedUpdateOneWithoutAddressNestedInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  lat?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  lng?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  region?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  street?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  streetNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  zip?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type AddressUpdateInput = {
  account?: InputMaybe<AccountUpdateOneWithoutAddressNestedInput>;
  city?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  country?: InputMaybe<NullableEnumCountryCodeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dogShelter?: InputMaybe<DogShelterUpdateOneWithoutAddressNestedInput>;
  lat?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  lng?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  pro?: InputMaybe<ProfessionalUpdateOneWithoutAddressNestedInput>;
  region?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  street?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  streetNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  zip?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type AddressUpdateManyMutationInput = {
  city?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  country?: InputMaybe<NullableEnumCountryCodeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  lat?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  lng?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  region?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  street?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  streetNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  zip?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type AddressUpdateOneWithoutAccountNestedInput = {
  connect?: InputMaybe<AddressWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AddressCreateOrConnectWithoutAccountInput>;
  create?: InputMaybe<AddressCreateWithoutAccountInput>;
  delete?: InputMaybe<AddressWhereInput>;
  disconnect?: InputMaybe<AddressWhereInput>;
  update?: InputMaybe<AddressUpdateToOneWithWhereWithoutAccountInput>;
  upsert?: InputMaybe<AddressUpsertWithoutAccountInput>;
};

export type AddressUpdateOneWithoutDogShelterNestedInput = {
  connect?: InputMaybe<AddressWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AddressCreateOrConnectWithoutDogShelterInput>;
  create?: InputMaybe<AddressCreateWithoutDogShelterInput>;
  delete?: InputMaybe<AddressWhereInput>;
  disconnect?: InputMaybe<AddressWhereInput>;
  update?: InputMaybe<AddressUpdateToOneWithWhereWithoutDogShelterInput>;
  upsert?: InputMaybe<AddressUpsertWithoutDogShelterInput>;
};

export type AddressUpdateOneWithoutProNestedInput = {
  connect?: InputMaybe<AddressWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AddressCreateOrConnectWithoutProInput>;
  create?: InputMaybe<AddressCreateWithoutProInput>;
  delete?: InputMaybe<AddressWhereInput>;
  disconnect?: InputMaybe<AddressWhereInput>;
  update?: InputMaybe<AddressUpdateToOneWithWhereWithoutProInput>;
  upsert?: InputMaybe<AddressUpsertWithoutProInput>;
};

export type AddressUpdateToOneWithWhereWithoutAccountInput = {
  data: AddressUpdateWithoutAccountInput;
  where?: InputMaybe<AddressWhereInput>;
};

export type AddressUpdateToOneWithWhereWithoutDogShelterInput = {
  data: AddressUpdateWithoutDogShelterInput;
  where?: InputMaybe<AddressWhereInput>;
};

export type AddressUpdateToOneWithWhereWithoutProInput = {
  data: AddressUpdateWithoutProInput;
  where?: InputMaybe<AddressWhereInput>;
};

export type AddressUpdateWithoutAccountInput = {
  city?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  country?: InputMaybe<NullableEnumCountryCodeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dogShelter?: InputMaybe<DogShelterUpdateOneWithoutAddressNestedInput>;
  lat?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  lng?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  pro?: InputMaybe<ProfessionalUpdateOneWithoutAddressNestedInput>;
  region?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  street?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  streetNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  zip?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type AddressUpdateWithoutDogShelterInput = {
  account?: InputMaybe<AccountUpdateOneWithoutAddressNestedInput>;
  city?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  country?: InputMaybe<NullableEnumCountryCodeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  lat?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  lng?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  pro?: InputMaybe<ProfessionalUpdateOneWithoutAddressNestedInput>;
  region?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  street?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  streetNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  zip?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type AddressUpdateWithoutProInput = {
  account?: InputMaybe<AccountUpdateOneWithoutAddressNestedInput>;
  city?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  country?: InputMaybe<NullableEnumCountryCodeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dogShelter?: InputMaybe<DogShelterUpdateOneWithoutAddressNestedInput>;
  lat?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  lng?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  region?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  street?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  streetNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  zip?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type AddressUpsertWithoutAccountInput = {
  create: AddressCreateWithoutAccountInput;
  update: AddressUpdateWithoutAccountInput;
  where?: InputMaybe<AddressWhereInput>;
};

export type AddressUpsertWithoutDogShelterInput = {
  create: AddressCreateWithoutDogShelterInput;
  update: AddressUpdateWithoutDogShelterInput;
  where?: InputMaybe<AddressWhereInput>;
};

export type AddressUpsertWithoutProInput = {
  create: AddressCreateWithoutProInput;
  update: AddressUpdateWithoutProInput;
  where?: InputMaybe<AddressWhereInput>;
};

export type AddressWhereInput = {
  AND?: InputMaybe<Array<AddressWhereInput>>;
  NOT?: InputMaybe<Array<AddressWhereInput>>;
  OR?: InputMaybe<Array<AddressWhereInput>>;
  account?: InputMaybe<AccountNullableRelationFilter>;
  city?: InputMaybe<StringNullableFilter>;
  country?: InputMaybe<EnumCountryCodeNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  dogShelter?: InputMaybe<DogShelterNullableRelationFilter>;
  id?: InputMaybe<IntFilter>;
  lat?: InputMaybe<FloatNullableFilter>;
  lng?: InputMaybe<FloatNullableFilter>;
  pro?: InputMaybe<ProfessionalNullableRelationFilter>;
  region?: InputMaybe<StringNullableFilter>;
  street?: InputMaybe<StringNullableFilter>;
  streetNumber?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  zip?: InputMaybe<StringNullableFilter>;
};

export type AddressWhereUniqueInput = {
  AND?: InputMaybe<Array<AddressWhereInput>>;
  NOT?: InputMaybe<Array<AddressWhereInput>>;
  OR?: InputMaybe<Array<AddressWhereInput>>;
  account?: InputMaybe<AccountNullableRelationFilter>;
  city?: InputMaybe<StringNullableFilter>;
  country?: InputMaybe<EnumCountryCodeNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  dogShelter?: InputMaybe<DogShelterNullableRelationFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  lat?: InputMaybe<FloatNullableFilter>;
  lng?: InputMaybe<FloatNullableFilter>;
  pro?: InputMaybe<ProfessionalNullableRelationFilter>;
  region?: InputMaybe<StringNullableFilter>;
  street?: InputMaybe<StringNullableFilter>;
  streetNumber?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  zip?: InputMaybe<StringNullableFilter>;
};

export type AdminNoteAvgAggregateOutputType = {
  __typename?: 'AdminNoteAvgAggregateOutputType';
  accountId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  litterId?: Maybe<Scalars['Float']['output']>;
  proId?: Maybe<Scalars['Float']['output']>;
};

export type AdminNoteAvgOrderByAggregateInput = {
  accountId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  litterId?: InputMaybe<SortOrder>;
  proId?: InputMaybe<SortOrder>;
};

export type AdminNoteCountAggregateOutputType = {
  __typename?: 'AdminNoteCountAggregateOutputType';
  _all: Scalars['Int']['output'];
  accountId: Scalars['Int']['output'];
  author: Scalars['Int']['output'];
  content: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  litterId: Scalars['Int']['output'];
  proId: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type AdminNoteCountOrderByAggregateInput = {
  accountId?: InputMaybe<SortOrder>;
  author?: InputMaybe<SortOrder>;
  content?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  litterId?: InputMaybe<SortOrder>;
  proId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type AdminNoteCreateInput = {
  account?: InputMaybe<AccountCreateNestedOneWithoutAdminNotesInput>;
  author: Scalars['String']['input'];
  content: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  litter?: InputMaybe<LitterCreateNestedOneWithoutAdminNotesInput>;
  professional?: InputMaybe<ProfessionalCreateNestedOneWithoutAdminNotesInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AdminNoteCreateManyAccountInput = {
  author: Scalars['String']['input'];
  content: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  litterId?: InputMaybe<Scalars['Int']['input']>;
  proId?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AdminNoteCreateManyAccountInputEnvelope = {
  data: Array<AdminNoteCreateManyAccountInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AdminNoteCreateManyInput = {
  accountId?: InputMaybe<Scalars['Int']['input']>;
  author: Scalars['String']['input'];
  content: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  litterId?: InputMaybe<Scalars['Int']['input']>;
  proId?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AdminNoteCreateManyLitterInput = {
  accountId?: InputMaybe<Scalars['Int']['input']>;
  author: Scalars['String']['input'];
  content: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  proId?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AdminNoteCreateManyLitterInputEnvelope = {
  data: Array<AdminNoteCreateManyLitterInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AdminNoteCreateManyProfessionalInput = {
  accountId?: InputMaybe<Scalars['Int']['input']>;
  author: Scalars['String']['input'];
  content: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  litterId?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AdminNoteCreateManyProfessionalInputEnvelope = {
  data: Array<AdminNoteCreateManyProfessionalInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AdminNoteCreateNestedManyWithoutAccountInput = {
  connect?: InputMaybe<Array<AdminNoteWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AdminNoteCreateOrConnectWithoutAccountInput>>;
  create?: InputMaybe<Array<AdminNoteCreateWithoutAccountInput>>;
  createMany?: InputMaybe<AdminNoteCreateManyAccountInputEnvelope>;
};

export type AdminNoteCreateNestedManyWithoutLitterInput = {
  connect?: InputMaybe<Array<AdminNoteWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AdminNoteCreateOrConnectWithoutLitterInput>>;
  create?: InputMaybe<Array<AdminNoteCreateWithoutLitterInput>>;
  createMany?: InputMaybe<AdminNoteCreateManyLitterInputEnvelope>;
};

export type AdminNoteCreateNestedManyWithoutProfessionalInput = {
  connect?: InputMaybe<Array<AdminNoteWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AdminNoteCreateOrConnectWithoutProfessionalInput>>;
  create?: InputMaybe<Array<AdminNoteCreateWithoutProfessionalInput>>;
  createMany?: InputMaybe<AdminNoteCreateManyProfessionalInputEnvelope>;
};

export type AdminNoteCreateOrConnectWithoutAccountInput = {
  create: AdminNoteCreateWithoutAccountInput;
  where: AdminNoteWhereUniqueInput;
};

export type AdminNoteCreateOrConnectWithoutLitterInput = {
  create: AdminNoteCreateWithoutLitterInput;
  where: AdminNoteWhereUniqueInput;
};

export type AdminNoteCreateOrConnectWithoutProfessionalInput = {
  create: AdminNoteCreateWithoutProfessionalInput;
  where: AdminNoteWhereUniqueInput;
};

export type AdminNoteCreateWithoutAccountInput = {
  author: Scalars['String']['input'];
  content: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  litter?: InputMaybe<LitterCreateNestedOneWithoutAdminNotesInput>;
  professional?: InputMaybe<ProfessionalCreateNestedOneWithoutAdminNotesInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AdminNoteCreateWithoutLitterInput = {
  account?: InputMaybe<AccountCreateNestedOneWithoutAdminNotesInput>;
  author: Scalars['String']['input'];
  content: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  professional?: InputMaybe<ProfessionalCreateNestedOneWithoutAdminNotesInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AdminNoteCreateWithoutProfessionalInput = {
  account?: InputMaybe<AccountCreateNestedOneWithoutAdminNotesInput>;
  author: Scalars['String']['input'];
  content: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  litter?: InputMaybe<LitterCreateNestedOneWithoutAdminNotesInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AdminNoteListRelationFilter = {
  every?: InputMaybe<AdminNoteWhereInput>;
  none?: InputMaybe<AdminNoteWhereInput>;
  some?: InputMaybe<AdminNoteWhereInput>;
};

export type AdminNoteMaxAggregateOutputType = {
  __typename?: 'AdminNoteMaxAggregateOutputType';
  accountId?: Maybe<Scalars['Int']['output']>;
  author?: Maybe<Scalars['String']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  litterId?: Maybe<Scalars['Int']['output']>;
  proId?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type AdminNoteMaxOrderByAggregateInput = {
  accountId?: InputMaybe<SortOrder>;
  author?: InputMaybe<SortOrder>;
  content?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  litterId?: InputMaybe<SortOrder>;
  proId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type AdminNoteMinAggregateOutputType = {
  __typename?: 'AdminNoteMinAggregateOutputType';
  accountId?: Maybe<Scalars['Int']['output']>;
  author?: Maybe<Scalars['String']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  litterId?: Maybe<Scalars['Int']['output']>;
  proId?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type AdminNoteMinOrderByAggregateInput = {
  accountId?: InputMaybe<SortOrder>;
  author?: InputMaybe<SortOrder>;
  content?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  litterId?: InputMaybe<SortOrder>;
  proId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type AdminNoteOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export enum AdminNoteOrderByRelevanceFieldEnum {
  author = 'author',
  content = 'content'
}

export type AdminNoteOrderByRelevanceInput = {
  fields: Array<AdminNoteOrderByRelevanceFieldEnum>;
  search: Scalars['String']['input'];
  sort: SortOrder;
};

export type AdminNoteOrderByWithAggregationInput = {
  _avg?: InputMaybe<AdminNoteAvgOrderByAggregateInput>;
  _count?: InputMaybe<AdminNoteCountOrderByAggregateInput>;
  _max?: InputMaybe<AdminNoteMaxOrderByAggregateInput>;
  _min?: InputMaybe<AdminNoteMinOrderByAggregateInput>;
  _sum?: InputMaybe<AdminNoteSumOrderByAggregateInput>;
  accountId?: InputMaybe<SortOrderInput>;
  author?: InputMaybe<SortOrder>;
  content?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  litterId?: InputMaybe<SortOrderInput>;
  proId?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type AdminNoteOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: InputMaybe<AdminNoteOrderByRelevanceInput>;
  account?: InputMaybe<AccountOrderByWithRelationAndSearchRelevanceInput>;
  accountId?: InputMaybe<SortOrderInput>;
  author?: InputMaybe<SortOrder>;
  content?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  litter?: InputMaybe<LitterOrderByWithRelationAndSearchRelevanceInput>;
  litterId?: InputMaybe<SortOrderInput>;
  proId?: InputMaybe<SortOrderInput>;
  professional?: InputMaybe<ProfessionalOrderByWithRelationAndSearchRelevanceInput>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum AdminNoteScalarFieldEnum {
  accountId = 'accountId',
  author = 'author',
  content = 'content',
  createdAt = 'createdAt',
  id = 'id',
  litterId = 'litterId',
  proId = 'proId',
  updatedAt = 'updatedAt'
}

export type AdminNoteScalarWhereInput = {
  AND?: InputMaybe<Array<AdminNoteScalarWhereInput>>;
  NOT?: InputMaybe<Array<AdminNoteScalarWhereInput>>;
  OR?: InputMaybe<Array<AdminNoteScalarWhereInput>>;
  accountId?: InputMaybe<IntNullableFilter>;
  author?: InputMaybe<StringFilter>;
  content?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntFilter>;
  litterId?: InputMaybe<IntNullableFilter>;
  proId?: InputMaybe<IntNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type AdminNoteScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<AdminNoteScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<AdminNoteScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<AdminNoteScalarWhereWithAggregatesInput>>;
  accountId?: InputMaybe<IntNullableWithAggregatesFilter>;
  author?: InputMaybe<StringWithAggregatesFilter>;
  content?: InputMaybe<StringWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  litterId?: InputMaybe<IntNullableWithAggregatesFilter>;
  proId?: InputMaybe<IntNullableWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type AdminNoteSumAggregateOutputType = {
  __typename?: 'AdminNoteSumAggregateOutputType';
  accountId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  litterId?: Maybe<Scalars['Int']['output']>;
  proId?: Maybe<Scalars['Int']['output']>;
};

export type AdminNoteSumOrderByAggregateInput = {
  accountId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  litterId?: InputMaybe<SortOrder>;
  proId?: InputMaybe<SortOrder>;
};

export type AdminNoteUncheckedCreateInput = {
  accountId?: InputMaybe<Scalars['Int']['input']>;
  author: Scalars['String']['input'];
  content: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  litterId?: InputMaybe<Scalars['Int']['input']>;
  proId?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AdminNoteUncheckedCreateNestedManyWithoutAccountInput = {
  connect?: InputMaybe<Array<AdminNoteWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AdminNoteCreateOrConnectWithoutAccountInput>>;
  create?: InputMaybe<Array<AdminNoteCreateWithoutAccountInput>>;
  createMany?: InputMaybe<AdminNoteCreateManyAccountInputEnvelope>;
};

export type AdminNoteUncheckedCreateNestedManyWithoutLitterInput = {
  connect?: InputMaybe<Array<AdminNoteWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AdminNoteCreateOrConnectWithoutLitterInput>>;
  create?: InputMaybe<Array<AdminNoteCreateWithoutLitterInput>>;
  createMany?: InputMaybe<AdminNoteCreateManyLitterInputEnvelope>;
};

export type AdminNoteUncheckedCreateNestedManyWithoutProfessionalInput = {
  connect?: InputMaybe<Array<AdminNoteWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AdminNoteCreateOrConnectWithoutProfessionalInput>>;
  create?: InputMaybe<Array<AdminNoteCreateWithoutProfessionalInput>>;
  createMany?: InputMaybe<AdminNoteCreateManyProfessionalInputEnvelope>;
};

export type AdminNoteUncheckedCreateWithoutAccountInput = {
  author: Scalars['String']['input'];
  content: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  litterId?: InputMaybe<Scalars['Int']['input']>;
  proId?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AdminNoteUncheckedCreateWithoutLitterInput = {
  accountId?: InputMaybe<Scalars['Int']['input']>;
  author: Scalars['String']['input'];
  content: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  proId?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AdminNoteUncheckedCreateWithoutProfessionalInput = {
  accountId?: InputMaybe<Scalars['Int']['input']>;
  author: Scalars['String']['input'];
  content: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  litterId?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AdminNoteUncheckedUpdateInput = {
  accountId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  author?: InputMaybe<StringFieldUpdateOperationsInput>;
  content?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  litterId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  proId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type AdminNoteUncheckedUpdateManyInput = {
  accountId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  author?: InputMaybe<StringFieldUpdateOperationsInput>;
  content?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  litterId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  proId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type AdminNoteUncheckedUpdateManyWithoutAccountInput = {
  author?: InputMaybe<StringFieldUpdateOperationsInput>;
  content?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  litterId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  proId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type AdminNoteUncheckedUpdateManyWithoutAccountNestedInput = {
  connect?: InputMaybe<Array<AdminNoteWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AdminNoteCreateOrConnectWithoutAccountInput>>;
  create?: InputMaybe<Array<AdminNoteCreateWithoutAccountInput>>;
  createMany?: InputMaybe<AdminNoteCreateManyAccountInputEnvelope>;
  delete?: InputMaybe<Array<AdminNoteWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<AdminNoteScalarWhereInput>>;
  disconnect?: InputMaybe<Array<AdminNoteWhereUniqueInput>>;
  set?: InputMaybe<Array<AdminNoteWhereUniqueInput>>;
  update?: InputMaybe<Array<AdminNoteUpdateWithWhereUniqueWithoutAccountInput>>;
  updateMany?: InputMaybe<Array<AdminNoteUpdateManyWithWhereWithoutAccountInput>>;
  upsert?: InputMaybe<Array<AdminNoteUpsertWithWhereUniqueWithoutAccountInput>>;
};

export type AdminNoteUncheckedUpdateManyWithoutLitterInput = {
  accountId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  author?: InputMaybe<StringFieldUpdateOperationsInput>;
  content?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  proId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type AdminNoteUncheckedUpdateManyWithoutLitterNestedInput = {
  connect?: InputMaybe<Array<AdminNoteWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AdminNoteCreateOrConnectWithoutLitterInput>>;
  create?: InputMaybe<Array<AdminNoteCreateWithoutLitterInput>>;
  createMany?: InputMaybe<AdminNoteCreateManyLitterInputEnvelope>;
  delete?: InputMaybe<Array<AdminNoteWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<AdminNoteScalarWhereInput>>;
  disconnect?: InputMaybe<Array<AdminNoteWhereUniqueInput>>;
  set?: InputMaybe<Array<AdminNoteWhereUniqueInput>>;
  update?: InputMaybe<Array<AdminNoteUpdateWithWhereUniqueWithoutLitterInput>>;
  updateMany?: InputMaybe<Array<AdminNoteUpdateManyWithWhereWithoutLitterInput>>;
  upsert?: InputMaybe<Array<AdminNoteUpsertWithWhereUniqueWithoutLitterInput>>;
};

export type AdminNoteUncheckedUpdateManyWithoutProfessionalInput = {
  accountId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  author?: InputMaybe<StringFieldUpdateOperationsInput>;
  content?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  litterId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type AdminNoteUncheckedUpdateManyWithoutProfessionalNestedInput = {
  connect?: InputMaybe<Array<AdminNoteWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AdminNoteCreateOrConnectWithoutProfessionalInput>>;
  create?: InputMaybe<Array<AdminNoteCreateWithoutProfessionalInput>>;
  createMany?: InputMaybe<AdminNoteCreateManyProfessionalInputEnvelope>;
  delete?: InputMaybe<Array<AdminNoteWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<AdminNoteScalarWhereInput>>;
  disconnect?: InputMaybe<Array<AdminNoteWhereUniqueInput>>;
  set?: InputMaybe<Array<AdminNoteWhereUniqueInput>>;
  update?: InputMaybe<Array<AdminNoteUpdateWithWhereUniqueWithoutProfessionalInput>>;
  updateMany?: InputMaybe<Array<AdminNoteUpdateManyWithWhereWithoutProfessionalInput>>;
  upsert?: InputMaybe<Array<AdminNoteUpsertWithWhereUniqueWithoutProfessionalInput>>;
};

export type AdminNoteUncheckedUpdateWithoutAccountInput = {
  author?: InputMaybe<StringFieldUpdateOperationsInput>;
  content?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  litterId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  proId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type AdminNoteUncheckedUpdateWithoutLitterInput = {
  accountId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  author?: InputMaybe<StringFieldUpdateOperationsInput>;
  content?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  proId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type AdminNoteUncheckedUpdateWithoutProfessionalInput = {
  accountId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  author?: InputMaybe<StringFieldUpdateOperationsInput>;
  content?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  litterId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type AdminNoteUpdateInput = {
  account?: InputMaybe<AccountUpdateOneWithoutAdminNotesNestedInput>;
  author?: InputMaybe<StringFieldUpdateOperationsInput>;
  content?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  litter?: InputMaybe<LitterUpdateOneWithoutAdminNotesNestedInput>;
  professional?: InputMaybe<ProfessionalUpdateOneWithoutAdminNotesNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type AdminNoteUpdateManyMutationInput = {
  author?: InputMaybe<StringFieldUpdateOperationsInput>;
  content?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type AdminNoteUpdateManyWithWhereWithoutAccountInput = {
  data: AdminNoteUpdateManyMutationInput;
  where: AdminNoteScalarWhereInput;
};

export type AdminNoteUpdateManyWithWhereWithoutLitterInput = {
  data: AdminNoteUpdateManyMutationInput;
  where: AdminNoteScalarWhereInput;
};

export type AdminNoteUpdateManyWithWhereWithoutProfessionalInput = {
  data: AdminNoteUpdateManyMutationInput;
  where: AdminNoteScalarWhereInput;
};

export type AdminNoteUpdateManyWithoutAccountNestedInput = {
  connect?: InputMaybe<Array<AdminNoteWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AdminNoteCreateOrConnectWithoutAccountInput>>;
  create?: InputMaybe<Array<AdminNoteCreateWithoutAccountInput>>;
  createMany?: InputMaybe<AdminNoteCreateManyAccountInputEnvelope>;
  delete?: InputMaybe<Array<AdminNoteWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<AdminNoteScalarWhereInput>>;
  disconnect?: InputMaybe<Array<AdminNoteWhereUniqueInput>>;
  set?: InputMaybe<Array<AdminNoteWhereUniqueInput>>;
  update?: InputMaybe<Array<AdminNoteUpdateWithWhereUniqueWithoutAccountInput>>;
  updateMany?: InputMaybe<Array<AdminNoteUpdateManyWithWhereWithoutAccountInput>>;
  upsert?: InputMaybe<Array<AdminNoteUpsertWithWhereUniqueWithoutAccountInput>>;
};

export type AdminNoteUpdateManyWithoutLitterNestedInput = {
  connect?: InputMaybe<Array<AdminNoteWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AdminNoteCreateOrConnectWithoutLitterInput>>;
  create?: InputMaybe<Array<AdminNoteCreateWithoutLitterInput>>;
  createMany?: InputMaybe<AdminNoteCreateManyLitterInputEnvelope>;
  delete?: InputMaybe<Array<AdminNoteWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<AdminNoteScalarWhereInput>>;
  disconnect?: InputMaybe<Array<AdminNoteWhereUniqueInput>>;
  set?: InputMaybe<Array<AdminNoteWhereUniqueInput>>;
  update?: InputMaybe<Array<AdminNoteUpdateWithWhereUniqueWithoutLitterInput>>;
  updateMany?: InputMaybe<Array<AdminNoteUpdateManyWithWhereWithoutLitterInput>>;
  upsert?: InputMaybe<Array<AdminNoteUpsertWithWhereUniqueWithoutLitterInput>>;
};

export type AdminNoteUpdateManyWithoutProfessionalNestedInput = {
  connect?: InputMaybe<Array<AdminNoteWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AdminNoteCreateOrConnectWithoutProfessionalInput>>;
  create?: InputMaybe<Array<AdminNoteCreateWithoutProfessionalInput>>;
  createMany?: InputMaybe<AdminNoteCreateManyProfessionalInputEnvelope>;
  delete?: InputMaybe<Array<AdminNoteWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<AdminNoteScalarWhereInput>>;
  disconnect?: InputMaybe<Array<AdminNoteWhereUniqueInput>>;
  set?: InputMaybe<Array<AdminNoteWhereUniqueInput>>;
  update?: InputMaybe<Array<AdminNoteUpdateWithWhereUniqueWithoutProfessionalInput>>;
  updateMany?: InputMaybe<Array<AdminNoteUpdateManyWithWhereWithoutProfessionalInput>>;
  upsert?: InputMaybe<Array<AdminNoteUpsertWithWhereUniqueWithoutProfessionalInput>>;
};

export type AdminNoteUpdateWithWhereUniqueWithoutAccountInput = {
  data: AdminNoteUpdateWithoutAccountInput;
  where: AdminNoteWhereUniqueInput;
};

export type AdminNoteUpdateWithWhereUniqueWithoutLitterInput = {
  data: AdminNoteUpdateWithoutLitterInput;
  where: AdminNoteWhereUniqueInput;
};

export type AdminNoteUpdateWithWhereUniqueWithoutProfessionalInput = {
  data: AdminNoteUpdateWithoutProfessionalInput;
  where: AdminNoteWhereUniqueInput;
};

export type AdminNoteUpdateWithoutAccountInput = {
  author?: InputMaybe<StringFieldUpdateOperationsInput>;
  content?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  litter?: InputMaybe<LitterUpdateOneWithoutAdminNotesNestedInput>;
  professional?: InputMaybe<ProfessionalUpdateOneWithoutAdminNotesNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type AdminNoteUpdateWithoutLitterInput = {
  account?: InputMaybe<AccountUpdateOneWithoutAdminNotesNestedInput>;
  author?: InputMaybe<StringFieldUpdateOperationsInput>;
  content?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  professional?: InputMaybe<ProfessionalUpdateOneWithoutAdminNotesNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type AdminNoteUpdateWithoutProfessionalInput = {
  account?: InputMaybe<AccountUpdateOneWithoutAdminNotesNestedInput>;
  author?: InputMaybe<StringFieldUpdateOperationsInput>;
  content?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  litter?: InputMaybe<LitterUpdateOneWithoutAdminNotesNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type AdminNoteUpsertWithWhereUniqueWithoutAccountInput = {
  create: AdminNoteCreateWithoutAccountInput;
  update: AdminNoteUpdateWithoutAccountInput;
  where: AdminNoteWhereUniqueInput;
};

export type AdminNoteUpsertWithWhereUniqueWithoutLitterInput = {
  create: AdminNoteCreateWithoutLitterInput;
  update: AdminNoteUpdateWithoutLitterInput;
  where: AdminNoteWhereUniqueInput;
};

export type AdminNoteUpsertWithWhereUniqueWithoutProfessionalInput = {
  create: AdminNoteCreateWithoutProfessionalInput;
  update: AdminNoteUpdateWithoutProfessionalInput;
  where: AdminNoteWhereUniqueInput;
};

export type AdminNoteWhereInput = {
  AND?: InputMaybe<Array<AdminNoteWhereInput>>;
  NOT?: InputMaybe<Array<AdminNoteWhereInput>>;
  OR?: InputMaybe<Array<AdminNoteWhereInput>>;
  account?: InputMaybe<AccountNullableRelationFilter>;
  accountId?: InputMaybe<IntNullableFilter>;
  author?: InputMaybe<StringFilter>;
  content?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntFilter>;
  litter?: InputMaybe<LitterNullableRelationFilter>;
  litterId?: InputMaybe<IntNullableFilter>;
  proId?: InputMaybe<IntNullableFilter>;
  professional?: InputMaybe<ProfessionalNullableRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type AdminNoteWhereUniqueInput = {
  AND?: InputMaybe<Array<AdminNoteWhereInput>>;
  NOT?: InputMaybe<Array<AdminNoteWhereInput>>;
  OR?: InputMaybe<Array<AdminNoteWhereInput>>;
  account?: InputMaybe<AccountNullableRelationFilter>;
  accountId?: InputMaybe<IntNullableFilter>;
  author?: InputMaybe<StringFilter>;
  content?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  litter?: InputMaybe<LitterNullableRelationFilter>;
  litterId?: InputMaybe<IntNullableFilter>;
  proId?: InputMaybe<IntNullableFilter>;
  professional?: InputMaybe<ProfessionalNullableRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type AdministratorAvgAggregateOutputType = {
  __typename?: 'AdministratorAvgAggregateOutputType';
  id?: Maybe<Scalars['Float']['output']>;
};

export type AdministratorAvgOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
};

export type AdministratorCountAggregateOutputType = {
  __typename?: 'AdministratorCountAggregateOutputType';
  _all: Scalars['Int']['output'];
  connectedAt: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  displayName: Scalars['Int']['output'];
  email: Scalars['Int']['output'];
  emailVerificationCode: Scalars['Int']['output'];
  firstName: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  lastConfirmedAt: Scalars['Int']['output'];
  lastCountryCode: Scalars['Int']['output'];
  lastName: Scalars['Int']['output'];
  password: Scalars['Int']['output'];
  profilePicture: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type AdministratorCountOrderByAggregateInput = {
  connectedAt?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  displayName?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  emailVerificationCode?: InputMaybe<SortOrder>;
  firstName?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  lastConfirmedAt?: InputMaybe<SortOrder>;
  lastCountryCode?: InputMaybe<SortOrder>;
  lastName?: InputMaybe<SortOrder>;
  password?: InputMaybe<SortOrder>;
  profilePicture?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type AdministratorCreateInput = {
  connectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  emailVerificationCode?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastConfirmedAt?: InputMaybe<Scalars['DateTime']['input']>;
  lastCountryCode?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  profilePicture?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AdministratorCreateManyInput = {
  connectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  emailVerificationCode?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  lastConfirmedAt?: InputMaybe<Scalars['DateTime']['input']>;
  lastCountryCode?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  profilePicture?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AdministratorMaxAggregateOutputType = {
  __typename?: 'AdministratorMaxAggregateOutputType';
  connectedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  emailVerificationCode?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  lastConfirmedAt?: Maybe<Scalars['DateTime']['output']>;
  lastCountryCode?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  password?: Maybe<Scalars['String']['output']>;
  profilePicture?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type AdministratorMaxOrderByAggregateInput = {
  connectedAt?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  displayName?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  emailVerificationCode?: InputMaybe<SortOrder>;
  firstName?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  lastConfirmedAt?: InputMaybe<SortOrder>;
  lastCountryCode?: InputMaybe<SortOrder>;
  lastName?: InputMaybe<SortOrder>;
  password?: InputMaybe<SortOrder>;
  profilePicture?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type AdministratorMinAggregateOutputType = {
  __typename?: 'AdministratorMinAggregateOutputType';
  connectedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  emailVerificationCode?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  lastConfirmedAt?: Maybe<Scalars['DateTime']['output']>;
  lastCountryCode?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  password?: Maybe<Scalars['String']['output']>;
  profilePicture?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type AdministratorMinOrderByAggregateInput = {
  connectedAt?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  displayName?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  emailVerificationCode?: InputMaybe<SortOrder>;
  firstName?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  lastConfirmedAt?: InputMaybe<SortOrder>;
  lastCountryCode?: InputMaybe<SortOrder>;
  lastName?: InputMaybe<SortOrder>;
  password?: InputMaybe<SortOrder>;
  profilePicture?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum AdministratorOrderByRelevanceFieldEnum {
  displayName = 'displayName',
  email = 'email',
  emailVerificationCode = 'emailVerificationCode',
  firstName = 'firstName',
  lastCountryCode = 'lastCountryCode',
  lastName = 'lastName',
  password = 'password',
  profilePicture = 'profilePicture'
}

export type AdministratorOrderByRelevanceInput = {
  fields: Array<AdministratorOrderByRelevanceFieldEnum>;
  search: Scalars['String']['input'];
  sort: SortOrder;
};

export type AdministratorOrderByWithAggregationInput = {
  _avg?: InputMaybe<AdministratorAvgOrderByAggregateInput>;
  _count?: InputMaybe<AdministratorCountOrderByAggregateInput>;
  _max?: InputMaybe<AdministratorMaxOrderByAggregateInput>;
  _min?: InputMaybe<AdministratorMinOrderByAggregateInput>;
  _sum?: InputMaybe<AdministratorSumOrderByAggregateInput>;
  connectedAt?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  displayName?: InputMaybe<SortOrderInput>;
  email?: InputMaybe<SortOrder>;
  emailVerificationCode?: InputMaybe<SortOrderInput>;
  firstName?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  lastConfirmedAt?: InputMaybe<SortOrderInput>;
  lastCountryCode?: InputMaybe<SortOrderInput>;
  lastName?: InputMaybe<SortOrderInput>;
  password?: InputMaybe<SortOrderInput>;
  profilePicture?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type AdministratorOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: InputMaybe<AdministratorOrderByRelevanceInput>;
  connectedAt?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  displayName?: InputMaybe<SortOrderInput>;
  email?: InputMaybe<SortOrder>;
  emailVerificationCode?: InputMaybe<SortOrderInput>;
  firstName?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  lastConfirmedAt?: InputMaybe<SortOrderInput>;
  lastCountryCode?: InputMaybe<SortOrderInput>;
  lastName?: InputMaybe<SortOrderInput>;
  password?: InputMaybe<SortOrderInput>;
  profilePicture?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum AdministratorScalarFieldEnum {
  connectedAt = 'connectedAt',
  createdAt = 'createdAt',
  displayName = 'displayName',
  email = 'email',
  emailVerificationCode = 'emailVerificationCode',
  firstName = 'firstName',
  id = 'id',
  lastConfirmedAt = 'lastConfirmedAt',
  lastCountryCode = 'lastCountryCode',
  lastName = 'lastName',
  password = 'password',
  profilePicture = 'profilePicture',
  updatedAt = 'updatedAt'
}

export type AdministratorScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<AdministratorScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<AdministratorScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<AdministratorScalarWhereWithAggregatesInput>>;
  connectedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  displayName?: InputMaybe<StringNullableWithAggregatesFilter>;
  email?: InputMaybe<StringWithAggregatesFilter>;
  emailVerificationCode?: InputMaybe<StringNullableWithAggregatesFilter>;
  firstName?: InputMaybe<StringNullableWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  lastConfirmedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  lastCountryCode?: InputMaybe<StringNullableWithAggregatesFilter>;
  lastName?: InputMaybe<StringNullableWithAggregatesFilter>;
  password?: InputMaybe<StringNullableWithAggregatesFilter>;
  profilePicture?: InputMaybe<StringNullableWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type AdministratorSumAggregateOutputType = {
  __typename?: 'AdministratorSumAggregateOutputType';
  id?: Maybe<Scalars['Int']['output']>;
};

export type AdministratorSumOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
};

export type AdministratorUncheckedCreateInput = {
  connectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  emailVerificationCode?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  lastConfirmedAt?: InputMaybe<Scalars['DateTime']['input']>;
  lastCountryCode?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  profilePicture?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AdministratorUncheckedUpdateInput = {
  connectedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  displayName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailVerificationCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  lastConfirmedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  lastCountryCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  profilePicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type AdministratorUncheckedUpdateManyInput = {
  connectedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  displayName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailVerificationCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  lastConfirmedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  lastCountryCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  profilePicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type AdministratorUpdateInput = {
  connectedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  displayName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailVerificationCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastConfirmedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  lastCountryCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  profilePicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type AdministratorUpdateManyMutationInput = {
  connectedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  displayName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailVerificationCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastConfirmedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  lastCountryCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  profilePicture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type AdministratorWhereInput = {
  AND?: InputMaybe<Array<AdministratorWhereInput>>;
  NOT?: InputMaybe<Array<AdministratorWhereInput>>;
  OR?: InputMaybe<Array<AdministratorWhereInput>>;
  connectedAt?: InputMaybe<DateTimeFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  displayName?: InputMaybe<StringNullableFilter>;
  email?: InputMaybe<StringFilter>;
  emailVerificationCode?: InputMaybe<StringNullableFilter>;
  firstName?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<IntFilter>;
  lastConfirmedAt?: InputMaybe<DateTimeNullableFilter>;
  lastCountryCode?: InputMaybe<StringNullableFilter>;
  lastName?: InputMaybe<StringNullableFilter>;
  password?: InputMaybe<StringNullableFilter>;
  profilePicture?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type AdministratorWhereUniqueInput = {
  AND?: InputMaybe<Array<AdministratorWhereInput>>;
  NOT?: InputMaybe<Array<AdministratorWhereInput>>;
  OR?: InputMaybe<Array<AdministratorWhereInput>>;
  connectedAt?: InputMaybe<DateTimeFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  displayName?: InputMaybe<StringNullableFilter>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailVerificationCode?: InputMaybe<StringNullableFilter>;
  firstName?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  lastConfirmedAt?: InputMaybe<DateTimeNullableFilter>;
  lastCountryCode?: InputMaybe<StringNullableFilter>;
  lastName?: InputMaybe<StringNullableFilter>;
  password?: InputMaybe<StringNullableFilter>;
  profilePicture?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type AggregateAccount = {
  __typename?: 'AggregateAccount';
  _avg?: Maybe<AccountAvgAggregateOutputType>;
  _count?: Maybe<AccountCountAggregateOutputType>;
  _max?: Maybe<AccountMaxAggregateOutputType>;
  _min?: Maybe<AccountMinAggregateOutputType>;
  _sum?: Maybe<AccountSumAggregateOutputType>;
};

export type AggregateAccountActivity = {
  __typename?: 'AggregateAccountActivity';
  _avg?: Maybe<AccountActivityAvgAggregateOutputType>;
  _count?: Maybe<AccountActivityCountAggregateOutputType>;
  _max?: Maybe<AccountActivityMaxAggregateOutputType>;
  _min?: Maybe<AccountActivityMinAggregateOutputType>;
  _sum?: Maybe<AccountActivitySumAggregateOutputType>;
};

export type AggregateAccountImg = {
  __typename?: 'AggregateAccountImg';
  _avg?: Maybe<AccountImgAvgAggregateOutputType>;
  _count?: Maybe<AccountImgCountAggregateOutputType>;
  _max?: Maybe<AccountImgMaxAggregateOutputType>;
  _min?: Maybe<AccountImgMinAggregateOutputType>;
  _sum?: Maybe<AccountImgSumAggregateOutputType>;
};

export type AggregateAddress = {
  __typename?: 'AggregateAddress';
  _avg?: Maybe<AddressAvgAggregateOutputType>;
  _count?: Maybe<AddressCountAggregateOutputType>;
  _max?: Maybe<AddressMaxAggregateOutputType>;
  _min?: Maybe<AddressMinAggregateOutputType>;
  _sum?: Maybe<AddressSumAggregateOutputType>;
};

export type AggregateAdminNote = {
  __typename?: 'AggregateAdminNote';
  _avg?: Maybe<AdminNoteAvgAggregateOutputType>;
  _count?: Maybe<AdminNoteCountAggregateOutputType>;
  _max?: Maybe<AdminNoteMaxAggregateOutputType>;
  _min?: Maybe<AdminNoteMinAggregateOutputType>;
  _sum?: Maybe<AdminNoteSumAggregateOutputType>;
};

export type AggregateAdministrator = {
  __typename?: 'AggregateAdministrator';
  _avg?: Maybe<AdministratorAvgAggregateOutputType>;
  _count?: Maybe<AdministratorCountAggregateOutputType>;
  _max?: Maybe<AdministratorMaxAggregateOutputType>;
  _min?: Maybe<AdministratorMinAggregateOutputType>;
  _sum?: Maybe<AdministratorSumAggregateOutputType>;
};

export type AggregateAnimal = {
  __typename?: 'AggregateAnimal';
  _avg?: Maybe<AnimalAvgAggregateOutputType>;
  _count?: Maybe<AnimalCountAggregateOutputType>;
  _max?: Maybe<AnimalMaxAggregateOutputType>;
  _min?: Maybe<AnimalMinAggregateOutputType>;
  _sum?: Maybe<AnimalSumAggregateOutputType>;
};

export type AggregateAnimalImg = {
  __typename?: 'AggregateAnimalImg';
  _avg?: Maybe<AnimalImgAvgAggregateOutputType>;
  _count?: Maybe<AnimalImgCountAggregateOutputType>;
  _max?: Maybe<AnimalImgMaxAggregateOutputType>;
  _min?: Maybe<AnimalImgMinAggregateOutputType>;
  _sum?: Maybe<AnimalImgSumAggregateOutputType>;
};

export type AggregateAnimalStat = {
  __typename?: 'AggregateAnimalStat';
  _avg?: Maybe<AnimalStatAvgAggregateOutputType>;
  _count?: Maybe<AnimalStatCountAggregateOutputType>;
  _max?: Maybe<AnimalStatMaxAggregateOutputType>;
  _min?: Maybe<AnimalStatMinAggregateOutputType>;
  _sum?: Maybe<AnimalStatSumAggregateOutputType>;
};

export type AggregateAnnouncement = {
  __typename?: 'AggregateAnnouncement';
  _avg?: Maybe<AnnouncementAvgAggregateOutputType>;
  _count?: Maybe<AnnouncementCountAggregateOutputType>;
  _max?: Maybe<AnnouncementMaxAggregateOutputType>;
  _min?: Maybe<AnnouncementMinAggregateOutputType>;
  _sum?: Maybe<AnnouncementSumAggregateOutputType>;
};

export type AggregateAnnouncementTranslation = {
  __typename?: 'AggregateAnnouncementTranslation';
  _avg?: Maybe<AnnouncementTranslationAvgAggregateOutputType>;
  _count?: Maybe<AnnouncementTranslationCountAggregateOutputType>;
  _max?: Maybe<AnnouncementTranslationMaxAggregateOutputType>;
  _min?: Maybe<AnnouncementTranslationMinAggregateOutputType>;
  _sum?: Maybe<AnnouncementTranslationSumAggregateOutputType>;
};

export type AggregateArticle = {
  __typename?: 'AggregateArticle';
  _avg?: Maybe<ArticleAvgAggregateOutputType>;
  _count?: Maybe<ArticleCountAggregateOutputType>;
  _max?: Maybe<ArticleMaxAggregateOutputType>;
  _min?: Maybe<ArticleMinAggregateOutputType>;
  _sum?: Maybe<ArticleSumAggregateOutputType>;
};

export type AggregateArticleImg = {
  __typename?: 'AggregateArticleImg';
  _avg?: Maybe<ArticleImgAvgAggregateOutputType>;
  _count?: Maybe<ArticleImgCountAggregateOutputType>;
  _max?: Maybe<ArticleImgMaxAggregateOutputType>;
  _min?: Maybe<ArticleImgMinAggregateOutputType>;
  _sum?: Maybe<ArticleImgSumAggregateOutputType>;
};

export type AggregateArticleTranslations = {
  __typename?: 'AggregateArticleTranslations';
  _avg?: Maybe<ArticleTranslationsAvgAggregateOutputType>;
  _count?: Maybe<ArticleTranslationsCountAggregateOutputType>;
  _max?: Maybe<ArticleTranslationsMaxAggregateOutputType>;
  _min?: Maybe<ArticleTranslationsMinAggregateOutputType>;
  _sum?: Maybe<ArticleTranslationsSumAggregateOutputType>;
};

export type AggregateBooking = {
  __typename?: 'AggregateBooking';
  _avg?: Maybe<BookingAvgAggregateOutputType>;
  _count?: Maybe<BookingCountAggregateOutputType>;
  _max?: Maybe<BookingMaxAggregateOutputType>;
  _min?: Maybe<BookingMinAggregateOutputType>;
  _sum?: Maybe<BookingSumAggregateOutputType>;
};

export type AggregateBookingAnimal = {
  __typename?: 'AggregateBookingAnimal';
  _avg?: Maybe<BookingAnimalAvgAggregateOutputType>;
  _count?: Maybe<BookingAnimalCountAggregateOutputType>;
  _max?: Maybe<BookingAnimalMaxAggregateOutputType>;
  _min?: Maybe<BookingAnimalMinAggregateOutputType>;
  _sum?: Maybe<BookingAnimalSumAggregateOutputType>;
};

export type AggregateBookmark = {
  __typename?: 'AggregateBookmark';
  _avg?: Maybe<BookmarkAvgAggregateOutputType>;
  _count?: Maybe<BookmarkCountAggregateOutputType>;
  _max?: Maybe<BookmarkMaxAggregateOutputType>;
  _min?: Maybe<BookmarkMinAggregateOutputType>;
  _sum?: Maybe<BookmarkSumAggregateOutputType>;
};

export type AggregateCategory = {
  __typename?: 'AggregateCategory';
  _avg?: Maybe<CategoryAvgAggregateOutputType>;
  _count?: Maybe<CategoryCountAggregateOutputType>;
  _max?: Maybe<CategoryMaxAggregateOutputType>;
  _min?: Maybe<CategoryMinAggregateOutputType>;
  _sum?: Maybe<CategorySumAggregateOutputType>;
};

export type AggregateCategoryTranslation = {
  __typename?: 'AggregateCategoryTranslation';
  _avg?: Maybe<CategoryTranslationAvgAggregateOutputType>;
  _count?: Maybe<CategoryTranslationCountAggregateOutputType>;
  _max?: Maybe<CategoryTranslationMaxAggregateOutputType>;
  _min?: Maybe<CategoryTranslationMinAggregateOutputType>;
  _sum?: Maybe<CategoryTranslationSumAggregateOutputType>;
};

export type AggregateConversation = {
  __typename?: 'AggregateConversation';
  _avg?: Maybe<ConversationAvgAggregateOutputType>;
  _count?: Maybe<ConversationCountAggregateOutputType>;
  _max?: Maybe<ConversationMaxAggregateOutputType>;
  _min?: Maybe<ConversationMinAggregateOutputType>;
  _sum?: Maybe<ConversationSumAggregateOutputType>;
};

export type AggregateDashboardStatistics = {
  __typename?: 'AggregateDashboardStatistics';
  _avg?: Maybe<DashboardStatisticsAvgAggregateOutputType>;
  _count?: Maybe<DashboardStatisticsCountAggregateOutputType>;
  _max?: Maybe<DashboardStatisticsMaxAggregateOutputType>;
  _min?: Maybe<DashboardStatisticsMinAggregateOutputType>;
  _sum?: Maybe<DashboardStatisticsSumAggregateOutputType>;
};

export type AggregateDogBreed = {
  __typename?: 'AggregateDogBreed';
  _avg?: Maybe<DogBreedAvgAggregateOutputType>;
  _count?: Maybe<DogBreedCountAggregateOutputType>;
  _max?: Maybe<DogBreedMaxAggregateOutputType>;
  _min?: Maybe<DogBreedMinAggregateOutputType>;
  _sum?: Maybe<DogBreedSumAggregateOutputType>;
};

export type AggregateDogBreedImg = {
  __typename?: 'AggregateDogBreedImg';
  _avg?: Maybe<DogBreedImgAvgAggregateOutputType>;
  _count?: Maybe<DogBreedImgCountAggregateOutputType>;
  _max?: Maybe<DogBreedImgMaxAggregateOutputType>;
  _min?: Maybe<DogBreedImgMinAggregateOutputType>;
  _sum?: Maybe<DogBreedImgSumAggregateOutputType>;
};

export type AggregateDogBreedInterestSubscription = {
  __typename?: 'AggregateDogBreedInterestSubscription';
  _avg?: Maybe<DogBreedInterestSubscriptionAvgAggregateOutputType>;
  _count?: Maybe<DogBreedInterestSubscriptionCountAggregateOutputType>;
  _max?: Maybe<DogBreedInterestSubscriptionMaxAggregateOutputType>;
  _min?: Maybe<DogBreedInterestSubscriptionMinAggregateOutputType>;
  _sum?: Maybe<DogBreedInterestSubscriptionSumAggregateOutputType>;
};

export type AggregateDogBreedTranslation = {
  __typename?: 'AggregateDogBreedTranslation';
  _avg?: Maybe<DogBreedTranslationAvgAggregateOutputType>;
  _count?: Maybe<DogBreedTranslationCountAggregateOutputType>;
  _max?: Maybe<DogBreedTranslationMaxAggregateOutputType>;
  _min?: Maybe<DogBreedTranslationMinAggregateOutputType>;
  _sum?: Maybe<DogBreedTranslationSumAggregateOutputType>;
};

export type AggregateDogBreeder = {
  __typename?: 'AggregateDogBreeder';
  _avg?: Maybe<DogBreederAvgAggregateOutputType>;
  _count?: Maybe<DogBreederCountAggregateOutputType>;
  _max?: Maybe<DogBreederMaxAggregateOutputType>;
  _min?: Maybe<DogBreederMinAggregateOutputType>;
  _sum?: Maybe<DogBreederSumAggregateOutputType>;
};

export type AggregateDogBreederApplication = {
  __typename?: 'AggregateDogBreederApplication';
  _avg?: Maybe<DogBreederApplicationAvgAggregateOutputType>;
  _count?: Maybe<DogBreederApplicationCountAggregateOutputType>;
  _max?: Maybe<DogBreederApplicationMaxAggregateOutputType>;
  _min?: Maybe<DogBreederApplicationMinAggregateOutputType>;
  _sum?: Maybe<DogBreederApplicationSumAggregateOutputType>;
};

export type AggregateDogBreederApplicationStatusHistory = {
  __typename?: 'AggregateDogBreederApplicationStatusHistory';
  _avg?: Maybe<DogBreederApplicationStatusHistoryAvgAggregateOutputType>;
  _count?: Maybe<DogBreederApplicationStatusHistoryCountAggregateOutputType>;
  _max?: Maybe<DogBreederApplicationStatusHistoryMaxAggregateOutputType>;
  _min?: Maybe<DogBreederApplicationStatusHistoryMinAggregateOutputType>;
  _sum?: Maybe<DogBreederApplicationStatusHistorySumAggregateOutputType>;
};

export type AggregateDogBreederBreeds = {
  __typename?: 'AggregateDogBreederBreeds';
  _avg?: Maybe<DogBreederBreedsAvgAggregateOutputType>;
  _count?: Maybe<DogBreederBreedsCountAggregateOutputType>;
  _max?: Maybe<DogBreederBreedsMaxAggregateOutputType>;
  _min?: Maybe<DogBreederBreedsMinAggregateOutputType>;
  _sum?: Maybe<DogBreederBreedsSumAggregateOutputType>;
};

export type AggregateDogBreederImg = {
  __typename?: 'AggregateDogBreederImg';
  _avg?: Maybe<DogBreederImgAvgAggregateOutputType>;
  _count?: Maybe<DogBreederImgCountAggregateOutputType>;
  _max?: Maybe<DogBreederImgMaxAggregateOutputType>;
  _min?: Maybe<DogBreederImgMinAggregateOutputType>;
  _sum?: Maybe<DogBreederImgSumAggregateOutputType>;
};

export type AggregateDogBreederReview = {
  __typename?: 'AggregateDogBreederReview';
  _avg?: Maybe<DogBreederReviewAvgAggregateOutputType>;
  _count?: Maybe<DogBreederReviewCountAggregateOutputType>;
  _max?: Maybe<DogBreederReviewMaxAggregateOutputType>;
  _min?: Maybe<DogBreederReviewMinAggregateOutputType>;
  _sum?: Maybe<DogBreederReviewSumAggregateOutputType>;
};

export type AggregateDogBreederReviewAnswer = {
  __typename?: 'AggregateDogBreederReviewAnswer';
  _avg?: Maybe<DogBreederReviewAnswerAvgAggregateOutputType>;
  _count?: Maybe<DogBreederReviewAnswerCountAggregateOutputType>;
  _max?: Maybe<DogBreederReviewAnswerMaxAggregateOutputType>;
  _min?: Maybe<DogBreederReviewAnswerMinAggregateOutputType>;
  _sum?: Maybe<DogBreederReviewAnswerSumAggregateOutputType>;
};

export type AggregateDogBreederTranslation = {
  __typename?: 'AggregateDogBreederTranslation';
  _avg?: Maybe<DogBreederTranslationAvgAggregateOutputType>;
  _count?: Maybe<DogBreederTranslationCountAggregateOutputType>;
  _max?: Maybe<DogBreederTranslationMaxAggregateOutputType>;
  _min?: Maybe<DogBreederTranslationMinAggregateOutputType>;
  _sum?: Maybe<DogBreederTranslationSumAggregateOutputType>;
};

export type AggregateDogInfo = {
  __typename?: 'AggregateDogInfo';
  _avg?: Maybe<DogInfoAvgAggregateOutputType>;
  _count?: Maybe<DogInfoCountAggregateOutputType>;
  _max?: Maybe<DogInfoMaxAggregateOutputType>;
  _min?: Maybe<DogInfoMinAggregateOutputType>;
  _sum?: Maybe<DogInfoSumAggregateOutputType>;
};

export type AggregateDogMedicalAffection = {
  __typename?: 'AggregateDogMedicalAffection';
  _avg?: Maybe<DogMedicalAffectionAvgAggregateOutputType>;
  _count?: Maybe<DogMedicalAffectionCountAggregateOutputType>;
  _max?: Maybe<DogMedicalAffectionMaxAggregateOutputType>;
  _min?: Maybe<DogMedicalAffectionMinAggregateOutputType>;
  _sum?: Maybe<DogMedicalAffectionSumAggregateOutputType>;
};

export type AggregateDogPuppy = {
  __typename?: 'AggregateDogPuppy';
  _avg?: Maybe<DogPuppyAvgAggregateOutputType>;
  _count?: Maybe<DogPuppyCountAggregateOutputType>;
  _max?: Maybe<DogPuppyMaxAggregateOutputType>;
  _min?: Maybe<DogPuppyMinAggregateOutputType>;
  _sum?: Maybe<DogPuppySumAggregateOutputType>;
};

export type AggregateDogShelter = {
  __typename?: 'AggregateDogShelter';
  _avg?: Maybe<DogShelterAvgAggregateOutputType>;
  _count?: Maybe<DogShelterCountAggregateOutputType>;
  _max?: Maybe<DogShelterMaxAggregateOutputType>;
  _min?: Maybe<DogShelterMinAggregateOutputType>;
  _sum?: Maybe<DogShelterSumAggregateOutputType>;
};

export type AggregateDogShelterImg = {
  __typename?: 'AggregateDogShelterImg';
  _avg?: Maybe<DogShelterImgAvgAggregateOutputType>;
  _count?: Maybe<DogShelterImgCountAggregateOutputType>;
  _max?: Maybe<DogShelterImgMaxAggregateOutputType>;
  _min?: Maybe<DogShelterImgMinAggregateOutputType>;
  _sum?: Maybe<DogShelterImgSumAggregateOutputType>;
};

export type AggregateDogShelterLink = {
  __typename?: 'AggregateDogShelterLink';
  _avg?: Maybe<DogShelterLinkAvgAggregateOutputType>;
  _count?: Maybe<DogShelterLinkCountAggregateOutputType>;
  _max?: Maybe<DogShelterLinkMaxAggregateOutputType>;
  _min?: Maybe<DogShelterLinkMinAggregateOutputType>;
  _sum?: Maybe<DogShelterLinkSumAggregateOutputType>;
};

export type AggregateDogShelterOpeningHours = {
  __typename?: 'AggregateDogShelterOpeningHours';
  _avg?: Maybe<DogShelterOpeningHoursAvgAggregateOutputType>;
  _count?: Maybe<DogShelterOpeningHoursCountAggregateOutputType>;
  _max?: Maybe<DogShelterOpeningHoursMaxAggregateOutputType>;
  _min?: Maybe<DogShelterOpeningHoursMinAggregateOutputType>;
  _sum?: Maybe<DogShelterOpeningHoursSumAggregateOutputType>;
};

export type AggregateDogShelterTranslation = {
  __typename?: 'AggregateDogShelterTranslation';
  _avg?: Maybe<DogShelterTranslationAvgAggregateOutputType>;
  _count?: Maybe<DogShelterTranslationCountAggregateOutputType>;
  _max?: Maybe<DogShelterTranslationMaxAggregateOutputType>;
  _min?: Maybe<DogShelterTranslationMinAggregateOutputType>;
  _sum?: Maybe<DogShelterTranslationSumAggregateOutputType>;
};

export type AggregateEducatorReview = {
  __typename?: 'AggregateEducatorReview';
  _avg?: Maybe<EducatorReviewAvgAggregateOutputType>;
  _count?: Maybe<EducatorReviewCountAggregateOutputType>;
  _max?: Maybe<EducatorReviewMaxAggregateOutputType>;
  _min?: Maybe<EducatorReviewMinAggregateOutputType>;
  _sum?: Maybe<EducatorReviewSumAggregateOutputType>;
};

export type AggregateEmailBlacklist = {
  __typename?: 'AggregateEmailBlacklist';
  _avg?: Maybe<EmailBlacklistAvgAggregateOutputType>;
  _count?: Maybe<EmailBlacklistCountAggregateOutputType>;
  _max?: Maybe<EmailBlacklistMaxAggregateOutputType>;
  _min?: Maybe<EmailBlacklistMinAggregateOutputType>;
  _sum?: Maybe<EmailBlacklistSumAggregateOutputType>;
};

export type AggregateEmailContact = {
  __typename?: 'AggregateEmailContact';
  _avg?: Maybe<EmailContactAvgAggregateOutputType>;
  _count?: Maybe<EmailContactCountAggregateOutputType>;
  _max?: Maybe<EmailContactMaxAggregateOutputType>;
  _min?: Maybe<EmailContactMinAggregateOutputType>;
  _sum?: Maybe<EmailContactSumAggregateOutputType>;
};

export type AggregateEmailHistory = {
  __typename?: 'AggregateEmailHistory';
  _avg?: Maybe<EmailHistoryAvgAggregateOutputType>;
  _count?: Maybe<EmailHistoryCountAggregateOutputType>;
  _max?: Maybe<EmailHistoryMaxAggregateOutputType>;
  _min?: Maybe<EmailHistoryMinAggregateOutputType>;
  _sum?: Maybe<EmailHistorySumAggregateOutputType>;
};

export type AggregateEmailTemplate = {
  __typename?: 'AggregateEmailTemplate';
  _avg?: Maybe<EmailTemplateAvgAggregateOutputType>;
  _count?: Maybe<EmailTemplateCountAggregateOutputType>;
  _max?: Maybe<EmailTemplateMaxAggregateOutputType>;
  _min?: Maybe<EmailTemplateMinAggregateOutputType>;
  _sum?: Maybe<EmailTemplateSumAggregateOutputType>;
};

export type AggregateEmailTemplateButton = {
  __typename?: 'AggregateEmailTemplateButton';
  _avg?: Maybe<EmailTemplateButtonAvgAggregateOutputType>;
  _count?: Maybe<EmailTemplateButtonCountAggregateOutputType>;
  _max?: Maybe<EmailTemplateButtonMaxAggregateOutputType>;
  _min?: Maybe<EmailTemplateButtonMinAggregateOutputType>;
  _sum?: Maybe<EmailTemplateButtonSumAggregateOutputType>;
};

export type AggregateLitter = {
  __typename?: 'AggregateLitter';
  _avg?: Maybe<LitterAvgAggregateOutputType>;
  _count?: Maybe<LitterCountAggregateOutputType>;
  _max?: Maybe<LitterMaxAggregateOutputType>;
  _min?: Maybe<LitterMinAggregateOutputType>;
  _sum?: Maybe<LitterSumAggregateOutputType>;
};

export type AggregateLitterImg = {
  __typename?: 'AggregateLitterImg';
  _avg?: Maybe<LitterImgAvgAggregateOutputType>;
  _count?: Maybe<LitterImgCountAggregateOutputType>;
  _max?: Maybe<LitterImgMaxAggregateOutputType>;
  _min?: Maybe<LitterImgMinAggregateOutputType>;
  _sum?: Maybe<LitterImgSumAggregateOutputType>;
};

export type AggregateLitterParent = {
  __typename?: 'AggregateLitterParent';
  _avg?: Maybe<LitterParentAvgAggregateOutputType>;
  _count?: Maybe<LitterParentCountAggregateOutputType>;
  _max?: Maybe<LitterParentMaxAggregateOutputType>;
  _min?: Maybe<LitterParentMinAggregateOutputType>;
  _sum?: Maybe<LitterParentSumAggregateOutputType>;
};

export type AggregateLitterTranslation = {
  __typename?: 'AggregateLitterTranslation';
  _avg?: Maybe<LitterTranslationAvgAggregateOutputType>;
  _count?: Maybe<LitterTranslationCountAggregateOutputType>;
  _max?: Maybe<LitterTranslationMaxAggregateOutputType>;
  _min?: Maybe<LitterTranslationMinAggregateOutputType>;
  _sum?: Maybe<LitterTranslationSumAggregateOutputType>;
};

export type AggregateMessage = {
  __typename?: 'AggregateMessage';
  _avg?: Maybe<MessageAvgAggregateOutputType>;
  _count?: Maybe<MessageCountAggregateOutputType>;
  _max?: Maybe<MessageMaxAggregateOutputType>;
  _min?: Maybe<MessageMinAggregateOutputType>;
  _sum?: Maybe<MessageSumAggregateOutputType>;
};

export type AggregateMissingTranslation = {
  __typename?: 'AggregateMissingTranslation';
  _avg?: Maybe<MissingTranslationAvgAggregateOutputType>;
  _count?: Maybe<MissingTranslationCountAggregateOutputType>;
  _max?: Maybe<MissingTranslationMaxAggregateOutputType>;
  _min?: Maybe<MissingTranslationMinAggregateOutputType>;
  _sum?: Maybe<MissingTranslationSumAggregateOutputType>;
};

export type AggregateNotification = {
  __typename?: 'AggregateNotification';
  _avg?: Maybe<NotificationAvgAggregateOutputType>;
  _count?: Maybe<NotificationCountAggregateOutputType>;
  _max?: Maybe<NotificationMaxAggregateOutputType>;
  _min?: Maybe<NotificationMinAggregateOutputType>;
  _sum?: Maybe<NotificationSumAggregateOutputType>;
};

export type AggregatePayment = {
  __typename?: 'AggregatePayment';
  _avg?: Maybe<PaymentAvgAggregateOutputType>;
  _count?: Maybe<PaymentCountAggregateOutputType>;
  _max?: Maybe<PaymentMaxAggregateOutputType>;
  _min?: Maybe<PaymentMinAggregateOutputType>;
  _sum?: Maybe<PaymentSumAggregateOutputType>;
};

export type AggregateProAvailability = {
  __typename?: 'AggregateProAvailability';
  _avg?: Maybe<ProAvailabilityAvgAggregateOutputType>;
  _count?: Maybe<ProAvailabilityCountAggregateOutputType>;
  _max?: Maybe<ProAvailabilityMaxAggregateOutputType>;
  _min?: Maybe<ProAvailabilityMinAggregateOutputType>;
  _sum?: Maybe<ProAvailabilitySumAggregateOutputType>;
};

export type AggregateProDegrees = {
  __typename?: 'AggregateProDegrees';
  _avg?: Maybe<ProDegreesAvgAggregateOutputType>;
  _count?: Maybe<ProDegreesCountAggregateOutputType>;
  _max?: Maybe<ProDegreesMaxAggregateOutputType>;
  _min?: Maybe<ProDegreesMinAggregateOutputType>;
  _sum?: Maybe<ProDegreesSumAggregateOutputType>;
};

export type AggregateProImg = {
  __typename?: 'AggregateProImg';
  _avg?: Maybe<ProImgAvgAggregateOutputType>;
  _count?: Maybe<ProImgCountAggregateOutputType>;
  _max?: Maybe<ProImgMaxAggregateOutputType>;
  _min?: Maybe<ProImgMinAggregateOutputType>;
  _sum?: Maybe<ProImgSumAggregateOutputType>;
};

export type AggregateProShopOpeningHour = {
  __typename?: 'AggregateProShopOpeningHour';
  _avg?: Maybe<ProShopOpeningHourAvgAggregateOutputType>;
  _count?: Maybe<ProShopOpeningHourCountAggregateOutputType>;
  _max?: Maybe<ProShopOpeningHourMaxAggregateOutputType>;
  _min?: Maybe<ProShopOpeningHourMinAggregateOutputType>;
  _sum?: Maybe<ProShopOpeningHourSumAggregateOutputType>;
};

export type AggregateProStat = {
  __typename?: 'AggregateProStat';
  _avg?: Maybe<ProStatAvgAggregateOutputType>;
  _count?: Maybe<ProStatCountAggregateOutputType>;
  _max?: Maybe<ProStatMaxAggregateOutputType>;
  _min?: Maybe<ProStatMinAggregateOutputType>;
  _sum?: Maybe<ProStatSumAggregateOutputType>;
};

export type AggregateProTranslation = {
  __typename?: 'AggregateProTranslation';
  _avg?: Maybe<ProTranslationAvgAggregateOutputType>;
  _count?: Maybe<ProTranslationCountAggregateOutputType>;
  _max?: Maybe<ProTranslationMaxAggregateOutputType>;
  _min?: Maybe<ProTranslationMinAggregateOutputType>;
  _sum?: Maybe<ProTranslationSumAggregateOutputType>;
};

export type AggregateProUrgencyAvailability = {
  __typename?: 'AggregateProUrgencyAvailability';
  _avg?: Maybe<ProUrgencyAvailabilityAvgAggregateOutputType>;
  _count?: Maybe<ProUrgencyAvailabilityCountAggregateOutputType>;
  _max?: Maybe<ProUrgencyAvailabilityMaxAggregateOutputType>;
  _min?: Maybe<ProUrgencyAvailabilityMinAggregateOutputType>;
  _sum?: Maybe<ProUrgencyAvailabilitySumAggregateOutputType>;
};

export type AggregateProfessional = {
  __typename?: 'AggregateProfessional';
  _avg?: Maybe<ProfessionalAvgAggregateOutputType>;
  _count?: Maybe<ProfessionalCountAggregateOutputType>;
  _max?: Maybe<ProfessionalMaxAggregateOutputType>;
  _min?: Maybe<ProfessionalMinAggregateOutputType>;
  _sum?: Maybe<ProfessionalSumAggregateOutputType>;
};

export type AggregateSMSTemplate = {
  __typename?: 'AggregateSMSTemplate';
  _avg?: Maybe<SMSTemplateAvgAggregateOutputType>;
  _count?: Maybe<SMSTemplateCountAggregateOutputType>;
  _max?: Maybe<SMSTemplateMaxAggregateOutputType>;
  _min?: Maybe<SMSTemplateMinAggregateOutputType>;
  _sum?: Maybe<SMSTemplateSumAggregateOutputType>;
};

export type AggregateService = {
  __typename?: 'AggregateService';
  _avg?: Maybe<ServiceAvgAggregateOutputType>;
  _count?: Maybe<ServiceCountAggregateOutputType>;
  _max?: Maybe<ServiceMaxAggregateOutputType>;
  _min?: Maybe<ServiceMinAggregateOutputType>;
  _sum?: Maybe<ServiceSumAggregateOutputType>;
};

export type AggregateServiceTranslation = {
  __typename?: 'AggregateServiceTranslation';
  _avg?: Maybe<ServiceTranslationAvgAggregateOutputType>;
  _count?: Maybe<ServiceTranslationCountAggregateOutputType>;
  _max?: Maybe<ServiceTranslationMaxAggregateOutputType>;
  _min?: Maybe<ServiceTranslationMinAggregateOutputType>;
  _sum?: Maybe<ServiceTranslationSumAggregateOutputType>;
};

export type AggregateStudInfo = {
  __typename?: 'AggregateStudInfo';
  _avg?: Maybe<StudInfoAvgAggregateOutputType>;
  _count?: Maybe<StudInfoCountAggregateOutputType>;
  _max?: Maybe<StudInfoMaxAggregateOutputType>;
  _min?: Maybe<StudInfoMinAggregateOutputType>;
  _sum?: Maybe<StudInfoSumAggregateOutputType>;
};

export type AggregateUpdate = {
  __typename?: 'AggregateUpdate';
  _avg?: Maybe<UpdateAvgAggregateOutputType>;
  _count?: Maybe<UpdateCountAggregateOutputType>;
  _max?: Maybe<UpdateMaxAggregateOutputType>;
  _min?: Maybe<UpdateMinAggregateOutputType>;
  _sum?: Maybe<UpdateSumAggregateOutputType>;
};

export type AggregateWebsiteTranslation = {
  __typename?: 'AggregateWebsiteTranslation';
  _avg?: Maybe<WebsiteTranslationAvgAggregateOutputType>;
  _count?: Maybe<WebsiteTranslationCountAggregateOutputType>;
  _max?: Maybe<WebsiteTranslationMaxAggregateOutputType>;
  _min?: Maybe<WebsiteTranslationMinAggregateOutputType>;
  _sum?: Maybe<WebsiteTranslationSumAggregateOutputType>;
};

export type AggregateWorker = {
  __typename?: 'AggregateWorker';
  _avg?: Maybe<WorkerAvgAggregateOutputType>;
  _count?: Maybe<WorkerCountAggregateOutputType>;
  _max?: Maybe<WorkerMaxAggregateOutputType>;
  _min?: Maybe<WorkerMinAggregateOutputType>;
  _sum?: Maybe<WorkerSumAggregateOutputType>;
};

export type AggregateWorkerAvailability = {
  __typename?: 'AggregateWorkerAvailability';
  _avg?: Maybe<WorkerAvailabilityAvgAggregateOutputType>;
  _count?: Maybe<WorkerAvailabilityCountAggregateOutputType>;
  _max?: Maybe<WorkerAvailabilityMaxAggregateOutputType>;
  _min?: Maybe<WorkerAvailabilityMinAggregateOutputType>;
  _sum?: Maybe<WorkerAvailabilitySumAggregateOutputType>;
};

export type AggregateWorkerService = {
  __typename?: 'AggregateWorkerService';
  _avg?: Maybe<WorkerServiceAvgAggregateOutputType>;
  _count?: Maybe<WorkerServiceCountAggregateOutputType>;
  _max?: Maybe<WorkerServiceMaxAggregateOutputType>;
  _min?: Maybe<WorkerServiceMinAggregateOutputType>;
  _sum?: Maybe<WorkerServiceSumAggregateOutputType>;
};

export type AggregateWorkerServiceTranslation = {
  __typename?: 'AggregateWorkerServiceTranslation';
  _avg?: Maybe<WorkerServiceTranslationAvgAggregateOutputType>;
  _count?: Maybe<WorkerServiceTranslationCountAggregateOutputType>;
  _max?: Maybe<WorkerServiceTranslationMaxAggregateOutputType>;
  _min?: Maybe<WorkerServiceTranslationMinAggregateOutputType>;
  _sum?: Maybe<WorkerServiceTranslationSumAggregateOutputType>;
};

export type Animal = {
  __typename?: 'Animal';
  _count: AnimalCountOutputType;
  adopted?: Maybe<Scalars['Boolean']['output']>;
  adoptionDate?: Maybe<Scalars['DateTime']['output']>;
  archived: Scalars['Boolean']['output'];
  birthday?: Maybe<Scalars['DateTime']['output']>;
  birthdayType?: Maybe<BirthdayType>;
  birthedLitters: Array<LitterParent>;
  bookingAnimals: Array<BookingAnimal>;
  bookings: Array<Booking>;
  calved?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['DateTime']['output'];
  dogInfos?: Maybe<DogInfo>;
  dogShelter?: Maybe<DogShelter>;
  dogShelterId?: Maybe<Scalars['Int']['output']>;
  gender?: Maybe<GenderEnum>;
  id: Scalars['Int']['output'];
  imgs: Array<AnimalImg>;
  litter?: Maybe<Litter>;
  litterId?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  neutered?: Maybe<Scalars['Boolean']['output']>;
  owner: Account;
  passportFile?: Maybe<Scalars['String']['output']>;
  sensitivities?: Maybe<Array<Maybe<AnimalSensitivityEnum>>>;
  size?: Maybe<AnimalSizeEnum>;
  stats?: Maybe<AnimalStat>;
  sterilized?: Maybe<Scalars['Boolean']['output']>;
  studInfos?: Maybe<StudInfo>;
  type: AnimalTypeEnum;
  updatedAt: Scalars['DateTime']['output'];
  weight?: Maybe<Scalars['Int']['output']>;
};


export type AnimalbirthedLittersArgs = {
  cursor?: InputMaybe<LitterParentWhereUniqueInput>;
  distinct?: InputMaybe<LitterParentScalarFieldEnum>;
  orderBy?: InputMaybe<LitterParentOrderByWithRelationAndSearchRelevanceInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<LitterParentWhereInput>;
};


export type AnimalbookingAnimalsArgs = {
  cursor?: InputMaybe<BookingAnimalWhereUniqueInput>;
  distinct?: InputMaybe<BookingAnimalScalarFieldEnum>;
  orderBy?: InputMaybe<BookingAnimalOrderByWithRelationAndSearchRelevanceInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<BookingAnimalWhereInput>;
};


export type AnimalbookingsArgs = {
  cursor?: InputMaybe<BookingWhereUniqueInput>;
  distinct?: InputMaybe<BookingScalarFieldEnum>;
  orderBy?: InputMaybe<BookingOrderByWithRelationAndSearchRelevanceInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<BookingWhereInput>;
};


export type AnimalimgsArgs = {
  cursor?: InputMaybe<AnimalImgWhereUniqueInput>;
  distinct?: InputMaybe<AnimalImgScalarFieldEnum>;
  orderBy?: InputMaybe<AnimalImgOrderByWithRelationAndSearchRelevanceInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AnimalImgWhereInput>;
};

export type AnimalAvgAggregateOutputType = {
  __typename?: 'AnimalAvgAggregateOutputType';
  dogShelterId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  litterId?: Maybe<Scalars['Float']['output']>;
  ownerId?: Maybe<Scalars['Float']['output']>;
  statsId?: Maybe<Scalars['Float']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
};

export type AnimalAvgOrderByAggregateInput = {
  dogShelterId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  litterId?: InputMaybe<SortOrder>;
  ownerId?: InputMaybe<SortOrder>;
  statsId?: InputMaybe<SortOrder>;
  weight?: InputMaybe<SortOrder>;
};

export type AnimalCountAggregateOutputType = {
  __typename?: 'AnimalCountAggregateOutputType';
  _all: Scalars['Int']['output'];
  adopted: Scalars['Int']['output'];
  adoptionDate: Scalars['Int']['output'];
  archived: Scalars['Int']['output'];
  birthday: Scalars['Int']['output'];
  birthdayType: Scalars['Int']['output'];
  calved: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  dogShelterId: Scalars['Int']['output'];
  gender: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  litterId: Scalars['Int']['output'];
  name: Scalars['Int']['output'];
  neutered: Scalars['Int']['output'];
  ownerId: Scalars['Int']['output'];
  passportFile: Scalars['Int']['output'];
  size: Scalars['Int']['output'];
  statsId: Scalars['Int']['output'];
  sterilized: Scalars['Int']['output'];
  tags: Scalars['Int']['output'];
  type: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
  weight: Scalars['Int']['output'];
};

export type AnimalCountOrderByAggregateInput = {
  adopted?: InputMaybe<SortOrder>;
  adoptionDate?: InputMaybe<SortOrder>;
  archived?: InputMaybe<SortOrder>;
  birthday?: InputMaybe<SortOrder>;
  birthdayType?: InputMaybe<SortOrder>;
  calved?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  dogShelterId?: InputMaybe<SortOrder>;
  gender?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  litterId?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  neutered?: InputMaybe<SortOrder>;
  ownerId?: InputMaybe<SortOrder>;
  passportFile?: InputMaybe<SortOrder>;
  size?: InputMaybe<SortOrder>;
  statsId?: InputMaybe<SortOrder>;
  sterilized?: InputMaybe<SortOrder>;
  tags?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  weight?: InputMaybe<SortOrder>;
};

export type AnimalCountOutputType = {
  __typename?: 'AnimalCountOutputType';
  birthedLitters: Scalars['Int']['output'];
  bookingAnimals: Scalars['Int']['output'];
  bookings: Scalars['Int']['output'];
  imgs: Scalars['Int']['output'];
};

export type AnimalCreateInput = {
  adopted?: InputMaybe<Scalars['Boolean']['input']>;
  adoptionDate?: InputMaybe<Scalars['DateTime']['input']>;
  application?: InputMaybe<DogBreederApplicationCreateNestedOneWithoutAnimalInput>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  birthday?: InputMaybe<Scalars['DateTime']['input']>;
  birthdayType?: InputMaybe<BirthdayType>;
  birthedLitters?: InputMaybe<LitterParentCreateNestedManyWithoutParentInput>;
  bookingAnimals?: InputMaybe<BookingAnimalCreateNestedManyWithoutAnimalInput>;
  bookings?: InputMaybe<BookingCreateNestedManyWithoutAnimalInput>;
  calved?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dogInfos?: InputMaybe<DogInfoCreateNestedOneWithoutAnimalInput>;
  dogShelter?: InputMaybe<DogShelterCreateNestedOneWithoutAnimalsInput>;
  gender?: InputMaybe<GenderEnum>;
  imgs?: InputMaybe<AnimalImgCreateNestedManyWithoutAnimalInput>;
  litter?: InputMaybe<LitterCreateNestedOneWithoutAnimalsBornInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  neutered?: InputMaybe<Scalars['Boolean']['input']>;
  owner?: InputMaybe<AccountCreateNestedOneWithoutAnimalsInput>;
  passportFile?: InputMaybe<Scalars['String']['input']>;
  sensitivities?: InputMaybe<Array<InputMaybe<AnimalSensitivityEnum>>>;
  size?: InputMaybe<AnimalSizeEnum>;
  stats?: InputMaybe<AnimalStatCreateNestedOneWithoutAnimalInput>;
  statsId?: InputMaybe<Scalars['Int']['input']>;
  sterilized?: InputMaybe<Scalars['Boolean']['input']>;
  studInfos?: InputMaybe<StudInfoCreateNestedOneWithoutAnimalInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  type: AnimalTypeEnum;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  weight?: InputMaybe<Scalars['Int']['input']>;
};

export type AnimalCreateManyDogShelterInput = {
  adopted?: InputMaybe<Scalars['Boolean']['input']>;
  adoptionDate?: InputMaybe<Scalars['DateTime']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  birthday?: InputMaybe<Scalars['DateTime']['input']>;
  birthdayType?: InputMaybe<BirthdayType>;
  calved?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  gender?: InputMaybe<GenderEnum>;
  id?: InputMaybe<Scalars['Int']['input']>;
  litterId?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  neutered?: InputMaybe<Scalars['Boolean']['input']>;
  ownerId?: InputMaybe<Scalars['Int']['input']>;
  passportFile?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<AnimalSizeEnum>;
  statsId?: InputMaybe<Scalars['Int']['input']>;
  sterilized?: InputMaybe<Scalars['Boolean']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  type: AnimalTypeEnum;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  weight?: InputMaybe<Scalars['Int']['input']>;
};

export type AnimalCreateManyDogShelterInputEnvelope = {
  data: Array<AnimalCreateManyDogShelterInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AnimalCreateManyInput = {
  adopted?: InputMaybe<Scalars['Boolean']['input']>;
  adoptionDate?: InputMaybe<Scalars['DateTime']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  birthday?: InputMaybe<Scalars['DateTime']['input']>;
  birthdayType?: InputMaybe<BirthdayType>;
  calved?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dogShelterId?: InputMaybe<Scalars['Int']['input']>;
  gender?: InputMaybe<GenderEnum>;
  id?: InputMaybe<Scalars['Int']['input']>;
  litterId?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  neutered?: InputMaybe<Scalars['Boolean']['input']>;
  ownerId?: InputMaybe<Scalars['Int']['input']>;
  passportFile?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<AnimalSizeEnum>;
  statsId?: InputMaybe<Scalars['Int']['input']>;
  sterilized?: InputMaybe<Scalars['Boolean']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  type: AnimalTypeEnum;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  weight?: InputMaybe<Scalars['Int']['input']>;
};

export type AnimalCreateManyLitterInput = {
  adopted?: InputMaybe<Scalars['Boolean']['input']>;
  adoptionDate?: InputMaybe<Scalars['DateTime']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  birthday?: InputMaybe<Scalars['DateTime']['input']>;
  birthdayType?: InputMaybe<BirthdayType>;
  calved?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dogShelterId?: InputMaybe<Scalars['Int']['input']>;
  gender?: InputMaybe<GenderEnum>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  neutered?: InputMaybe<Scalars['Boolean']['input']>;
  ownerId?: InputMaybe<Scalars['Int']['input']>;
  passportFile?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<AnimalSizeEnum>;
  statsId?: InputMaybe<Scalars['Int']['input']>;
  sterilized?: InputMaybe<Scalars['Boolean']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  type: AnimalTypeEnum;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  weight?: InputMaybe<Scalars['Int']['input']>;
};

export type AnimalCreateManyLitterInputEnvelope = {
  data: Array<AnimalCreateManyLitterInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AnimalCreateManyOwnerInput = {
  adopted?: InputMaybe<Scalars['Boolean']['input']>;
  adoptionDate?: InputMaybe<Scalars['DateTime']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  birthday?: InputMaybe<Scalars['DateTime']['input']>;
  birthdayType?: InputMaybe<BirthdayType>;
  calved?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dogShelterId?: InputMaybe<Scalars['Int']['input']>;
  gender?: InputMaybe<GenderEnum>;
  id?: InputMaybe<Scalars['Int']['input']>;
  litterId?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  neutered?: InputMaybe<Scalars['Boolean']['input']>;
  passportFile?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<AnimalSizeEnum>;
  statsId?: InputMaybe<Scalars['Int']['input']>;
  sterilized?: InputMaybe<Scalars['Boolean']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  type: AnimalTypeEnum;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  weight?: InputMaybe<Scalars['Int']['input']>;
};

export type AnimalCreateManyOwnerInputEnvelope = {
  data: Array<AnimalCreateManyOwnerInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AnimalCreateNestedManyWithoutDogShelterInput = {
  connect?: InputMaybe<Array<AnimalWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AnimalCreateOrConnectWithoutDogShelterInput>>;
  create?: InputMaybe<Array<AnimalCreateWithoutDogShelterInput>>;
  createMany?: InputMaybe<AnimalCreateManyDogShelterInputEnvelope>;
};

export type AnimalCreateNestedManyWithoutLitterInput = {
  connect?: InputMaybe<Array<AnimalWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AnimalCreateOrConnectWithoutLitterInput>>;
  create?: InputMaybe<Array<AnimalCreateWithoutLitterInput>>;
  createMany?: InputMaybe<AnimalCreateManyLitterInputEnvelope>;
};

export type AnimalCreateNestedManyWithoutOwnerInput = {
  connect?: InputMaybe<Array<AnimalWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AnimalCreateOrConnectWithoutOwnerInput>>;
  create?: InputMaybe<Array<AnimalCreateWithoutOwnerInput>>;
  createMany?: InputMaybe<AnimalCreateManyOwnerInputEnvelope>;
};

export type AnimalCreateNestedOneWithoutApplicationInput = {
  connect?: InputMaybe<AnimalWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AnimalCreateOrConnectWithoutApplicationInput>;
  create?: InputMaybe<AnimalCreateWithoutApplicationInput>;
};

export type AnimalCreateNestedOneWithoutBirthedLittersInput = {
  connect?: InputMaybe<AnimalWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AnimalCreateOrConnectWithoutBirthedLittersInput>;
  create?: InputMaybe<AnimalCreateWithoutBirthedLittersInput>;
};

export type AnimalCreateNestedOneWithoutBookingAnimalsInput = {
  connect?: InputMaybe<AnimalWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AnimalCreateOrConnectWithoutBookingAnimalsInput>;
  create?: InputMaybe<AnimalCreateWithoutBookingAnimalsInput>;
};

export type AnimalCreateNestedOneWithoutBookingsInput = {
  connect?: InputMaybe<AnimalWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AnimalCreateOrConnectWithoutBookingsInput>;
  create?: InputMaybe<AnimalCreateWithoutBookingsInput>;
};

export type AnimalCreateNestedOneWithoutDogInfosInput = {
  connect?: InputMaybe<AnimalWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AnimalCreateOrConnectWithoutDogInfosInput>;
  create?: InputMaybe<AnimalCreateWithoutDogInfosInput>;
};

export type AnimalCreateNestedOneWithoutImgsInput = {
  connect?: InputMaybe<AnimalWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AnimalCreateOrConnectWithoutImgsInput>;
  create?: InputMaybe<AnimalCreateWithoutImgsInput>;
};

export type AnimalCreateNestedOneWithoutStatsInput = {
  connect?: InputMaybe<AnimalWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AnimalCreateOrConnectWithoutStatsInput>;
  create?: InputMaybe<AnimalCreateWithoutStatsInput>;
};

export type AnimalCreateNestedOneWithoutStudInfosInput = {
  connect?: InputMaybe<AnimalWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AnimalCreateOrConnectWithoutStudInfosInput>;
  create?: InputMaybe<AnimalCreateWithoutStudInfosInput>;
};

export type AnimalCreateOrConnectWithoutApplicationInput = {
  create: AnimalCreateWithoutApplicationInput;
  where: AnimalWhereUniqueInput;
};

export type AnimalCreateOrConnectWithoutBirthedLittersInput = {
  create: AnimalCreateWithoutBirthedLittersInput;
  where: AnimalWhereUniqueInput;
};

export type AnimalCreateOrConnectWithoutBookingAnimalsInput = {
  create: AnimalCreateWithoutBookingAnimalsInput;
  where: AnimalWhereUniqueInput;
};

export type AnimalCreateOrConnectWithoutBookingsInput = {
  create: AnimalCreateWithoutBookingsInput;
  where: AnimalWhereUniqueInput;
};

export type AnimalCreateOrConnectWithoutDogInfosInput = {
  create: AnimalCreateWithoutDogInfosInput;
  where: AnimalWhereUniqueInput;
};

export type AnimalCreateOrConnectWithoutDogShelterInput = {
  create: AnimalCreateWithoutDogShelterInput;
  where: AnimalWhereUniqueInput;
};

export type AnimalCreateOrConnectWithoutImgsInput = {
  create: AnimalCreateWithoutImgsInput;
  where: AnimalWhereUniqueInput;
};

export type AnimalCreateOrConnectWithoutLitterInput = {
  create: AnimalCreateWithoutLitterInput;
  where: AnimalWhereUniqueInput;
};

export type AnimalCreateOrConnectWithoutOwnerInput = {
  create: AnimalCreateWithoutOwnerInput;
  where: AnimalWhereUniqueInput;
};

export type AnimalCreateOrConnectWithoutStatsInput = {
  create: AnimalCreateWithoutStatsInput;
  where: AnimalWhereUniqueInput;
};

export type AnimalCreateOrConnectWithoutStudInfosInput = {
  create: AnimalCreateWithoutStudInfosInput;
  where: AnimalWhereUniqueInput;
};

export type AnimalCreateWithoutApplicationInput = {
  adopted?: InputMaybe<Scalars['Boolean']['input']>;
  adoptionDate?: InputMaybe<Scalars['DateTime']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  birthday?: InputMaybe<Scalars['DateTime']['input']>;
  birthdayType?: InputMaybe<BirthdayType>;
  birthedLitters?: InputMaybe<LitterParentCreateNestedManyWithoutParentInput>;
  bookingAnimals?: InputMaybe<BookingAnimalCreateNestedManyWithoutAnimalInput>;
  bookings?: InputMaybe<BookingCreateNestedManyWithoutAnimalInput>;
  calved?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dogInfos?: InputMaybe<DogInfoCreateNestedOneWithoutAnimalInput>;
  dogShelter?: InputMaybe<DogShelterCreateNestedOneWithoutAnimalsInput>;
  gender?: InputMaybe<GenderEnum>;
  imgs?: InputMaybe<AnimalImgCreateNestedManyWithoutAnimalInput>;
  litter?: InputMaybe<LitterCreateNestedOneWithoutAnimalsBornInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  neutered?: InputMaybe<Scalars['Boolean']['input']>;
  owner?: InputMaybe<AccountCreateNestedOneWithoutAnimalsInput>;
  passportFile?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<AnimalSizeEnum>;
  stats?: InputMaybe<AnimalStatCreateNestedOneWithoutAnimalInput>;
  statsId?: InputMaybe<Scalars['Int']['input']>;
  sterilized?: InputMaybe<Scalars['Boolean']['input']>;
  studInfos?: InputMaybe<StudInfoCreateNestedOneWithoutAnimalInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  type: AnimalTypeEnum;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  weight?: InputMaybe<Scalars['Int']['input']>;
};

export type AnimalCreateWithoutBirthedLittersInput = {
  adopted?: InputMaybe<Scalars['Boolean']['input']>;
  adoptionDate?: InputMaybe<Scalars['DateTime']['input']>;
  application?: InputMaybe<DogBreederApplicationCreateNestedOneWithoutAnimalInput>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  birthday?: InputMaybe<Scalars['DateTime']['input']>;
  birthdayType?: InputMaybe<BirthdayType>;
  bookingAnimals?: InputMaybe<BookingAnimalCreateNestedManyWithoutAnimalInput>;
  bookings?: InputMaybe<BookingCreateNestedManyWithoutAnimalInput>;
  calved?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dogInfos?: InputMaybe<DogInfoCreateNestedOneWithoutAnimalInput>;
  dogShelter?: InputMaybe<DogShelterCreateNestedOneWithoutAnimalsInput>;
  gender?: InputMaybe<GenderEnum>;
  imgs?: InputMaybe<AnimalImgCreateNestedManyWithoutAnimalInput>;
  litter?: InputMaybe<LitterCreateNestedOneWithoutAnimalsBornInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  neutered?: InputMaybe<Scalars['Boolean']['input']>;
  owner?: InputMaybe<AccountCreateNestedOneWithoutAnimalsInput>;
  passportFile?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<AnimalSizeEnum>;
  stats?: InputMaybe<AnimalStatCreateNestedOneWithoutAnimalInput>;
  statsId?: InputMaybe<Scalars['Int']['input']>;
  sterilized?: InputMaybe<Scalars['Boolean']['input']>;
  studInfos?: InputMaybe<StudInfoCreateNestedOneWithoutAnimalInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  type: AnimalTypeEnum;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  weight?: InputMaybe<Scalars['Int']['input']>;
};

export type AnimalCreateWithoutBookingAnimalsInput = {
  adopted?: InputMaybe<Scalars['Boolean']['input']>;
  adoptionDate?: InputMaybe<Scalars['DateTime']['input']>;
  application?: InputMaybe<DogBreederApplicationCreateNestedOneWithoutAnimalInput>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  birthday?: InputMaybe<Scalars['DateTime']['input']>;
  birthdayType?: InputMaybe<BirthdayType>;
  birthedLitters?: InputMaybe<LitterParentCreateNestedManyWithoutParentInput>;
  bookings?: InputMaybe<BookingCreateNestedManyWithoutAnimalInput>;
  calved?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dogInfos?: InputMaybe<DogInfoCreateNestedOneWithoutAnimalInput>;
  dogShelter?: InputMaybe<DogShelterCreateNestedOneWithoutAnimalsInput>;
  gender?: InputMaybe<GenderEnum>;
  imgs?: InputMaybe<AnimalImgCreateNestedManyWithoutAnimalInput>;
  litter?: InputMaybe<LitterCreateNestedOneWithoutAnimalsBornInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  neutered?: InputMaybe<Scalars['Boolean']['input']>;
  owner?: InputMaybe<AccountCreateNestedOneWithoutAnimalsInput>;
  passportFile?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<AnimalSizeEnum>;
  stats?: InputMaybe<AnimalStatCreateNestedOneWithoutAnimalInput>;
  statsId?: InputMaybe<Scalars['Int']['input']>;
  sterilized?: InputMaybe<Scalars['Boolean']['input']>;
  studInfos?: InputMaybe<StudInfoCreateNestedOneWithoutAnimalInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  type: AnimalTypeEnum;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  weight?: InputMaybe<Scalars['Int']['input']>;
};

export type AnimalCreateWithoutBookingsInput = {
  adopted?: InputMaybe<Scalars['Boolean']['input']>;
  adoptionDate?: InputMaybe<Scalars['DateTime']['input']>;
  application?: InputMaybe<DogBreederApplicationCreateNestedOneWithoutAnimalInput>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  birthday?: InputMaybe<Scalars['DateTime']['input']>;
  birthdayType?: InputMaybe<BirthdayType>;
  birthedLitters?: InputMaybe<LitterParentCreateNestedManyWithoutParentInput>;
  bookingAnimals?: InputMaybe<BookingAnimalCreateNestedManyWithoutAnimalInput>;
  calved?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dogInfos?: InputMaybe<DogInfoCreateNestedOneWithoutAnimalInput>;
  dogShelter?: InputMaybe<DogShelterCreateNestedOneWithoutAnimalsInput>;
  gender?: InputMaybe<GenderEnum>;
  imgs?: InputMaybe<AnimalImgCreateNestedManyWithoutAnimalInput>;
  litter?: InputMaybe<LitterCreateNestedOneWithoutAnimalsBornInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  neutered?: InputMaybe<Scalars['Boolean']['input']>;
  owner?: InputMaybe<AccountCreateNestedOneWithoutAnimalsInput>;
  passportFile?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<AnimalSizeEnum>;
  stats?: InputMaybe<AnimalStatCreateNestedOneWithoutAnimalInput>;
  statsId?: InputMaybe<Scalars['Int']['input']>;
  sterilized?: InputMaybe<Scalars['Boolean']['input']>;
  studInfos?: InputMaybe<StudInfoCreateNestedOneWithoutAnimalInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  type: AnimalTypeEnum;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  weight?: InputMaybe<Scalars['Int']['input']>;
};

export type AnimalCreateWithoutDogInfosInput = {
  adopted?: InputMaybe<Scalars['Boolean']['input']>;
  adoptionDate?: InputMaybe<Scalars['DateTime']['input']>;
  application?: InputMaybe<DogBreederApplicationCreateNestedOneWithoutAnimalInput>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  birthday?: InputMaybe<Scalars['DateTime']['input']>;
  birthdayType?: InputMaybe<BirthdayType>;
  birthedLitters?: InputMaybe<LitterParentCreateNestedManyWithoutParentInput>;
  bookingAnimals?: InputMaybe<BookingAnimalCreateNestedManyWithoutAnimalInput>;
  bookings?: InputMaybe<BookingCreateNestedManyWithoutAnimalInput>;
  calved?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dogShelter?: InputMaybe<DogShelterCreateNestedOneWithoutAnimalsInput>;
  gender?: InputMaybe<GenderEnum>;
  imgs?: InputMaybe<AnimalImgCreateNestedManyWithoutAnimalInput>;
  litter?: InputMaybe<LitterCreateNestedOneWithoutAnimalsBornInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  neutered?: InputMaybe<Scalars['Boolean']['input']>;
  owner?: InputMaybe<AccountCreateNestedOneWithoutAnimalsInput>;
  passportFile?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<AnimalSizeEnum>;
  stats?: InputMaybe<AnimalStatCreateNestedOneWithoutAnimalInput>;
  statsId?: InputMaybe<Scalars['Int']['input']>;
  sterilized?: InputMaybe<Scalars['Boolean']['input']>;
  studInfos?: InputMaybe<StudInfoCreateNestedOneWithoutAnimalInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  type: AnimalTypeEnum;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  weight?: InputMaybe<Scalars['Int']['input']>;
};

export type AnimalCreateWithoutDogShelterInput = {
  adopted?: InputMaybe<Scalars['Boolean']['input']>;
  adoptionDate?: InputMaybe<Scalars['DateTime']['input']>;
  application?: InputMaybe<DogBreederApplicationCreateNestedOneWithoutAnimalInput>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  birthday?: InputMaybe<Scalars['DateTime']['input']>;
  birthdayType?: InputMaybe<BirthdayType>;
  birthedLitters?: InputMaybe<LitterParentCreateNestedManyWithoutParentInput>;
  bookingAnimals?: InputMaybe<BookingAnimalCreateNestedManyWithoutAnimalInput>;
  bookings?: InputMaybe<BookingCreateNestedManyWithoutAnimalInput>;
  calved?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dogInfos?: InputMaybe<DogInfoCreateNestedOneWithoutAnimalInput>;
  gender?: InputMaybe<GenderEnum>;
  imgs?: InputMaybe<AnimalImgCreateNestedManyWithoutAnimalInput>;
  litter?: InputMaybe<LitterCreateNestedOneWithoutAnimalsBornInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  neutered?: InputMaybe<Scalars['Boolean']['input']>;
  owner?: InputMaybe<AccountCreateNestedOneWithoutAnimalsInput>;
  passportFile?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<AnimalSizeEnum>;
  stats?: InputMaybe<AnimalStatCreateNestedOneWithoutAnimalInput>;
  statsId?: InputMaybe<Scalars['Int']['input']>;
  sterilized?: InputMaybe<Scalars['Boolean']['input']>;
  studInfos?: InputMaybe<StudInfoCreateNestedOneWithoutAnimalInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  type: AnimalTypeEnum;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  weight?: InputMaybe<Scalars['Int']['input']>;
};

export type AnimalCreateWithoutImgsInput = {
  adopted?: InputMaybe<Scalars['Boolean']['input']>;
  adoptionDate?: InputMaybe<Scalars['DateTime']['input']>;
  application?: InputMaybe<DogBreederApplicationCreateNestedOneWithoutAnimalInput>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  birthday?: InputMaybe<Scalars['DateTime']['input']>;
  birthdayType?: InputMaybe<BirthdayType>;
  birthedLitters?: InputMaybe<LitterParentCreateNestedManyWithoutParentInput>;
  bookingAnimals?: InputMaybe<BookingAnimalCreateNestedManyWithoutAnimalInput>;
  bookings?: InputMaybe<BookingCreateNestedManyWithoutAnimalInput>;
  calved?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dogInfos?: InputMaybe<DogInfoCreateNestedOneWithoutAnimalInput>;
  dogShelter?: InputMaybe<DogShelterCreateNestedOneWithoutAnimalsInput>;
  gender?: InputMaybe<GenderEnum>;
  litter?: InputMaybe<LitterCreateNestedOneWithoutAnimalsBornInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  neutered?: InputMaybe<Scalars['Boolean']['input']>;
  owner?: InputMaybe<AccountCreateNestedOneWithoutAnimalsInput>;
  passportFile?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<AnimalSizeEnum>;
  stats?: InputMaybe<AnimalStatCreateNestedOneWithoutAnimalInput>;
  statsId?: InputMaybe<Scalars['Int']['input']>;
  sterilized?: InputMaybe<Scalars['Boolean']['input']>;
  studInfos?: InputMaybe<StudInfoCreateNestedOneWithoutAnimalInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  type: AnimalTypeEnum;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  weight?: InputMaybe<Scalars['Int']['input']>;
};

export type AnimalCreateWithoutLitterInput = {
  adopted?: InputMaybe<Scalars['Boolean']['input']>;
  adoptionDate?: InputMaybe<Scalars['DateTime']['input']>;
  application?: InputMaybe<DogBreederApplicationCreateNestedOneWithoutAnimalInput>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  birthday?: InputMaybe<Scalars['DateTime']['input']>;
  birthdayType?: InputMaybe<BirthdayType>;
  birthedLitters?: InputMaybe<LitterParentCreateNestedManyWithoutParentInput>;
  bookingAnimals?: InputMaybe<BookingAnimalCreateNestedManyWithoutAnimalInput>;
  bookings?: InputMaybe<BookingCreateNestedManyWithoutAnimalInput>;
  calved?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dogInfos?: InputMaybe<DogInfoCreateNestedOneWithoutAnimalInput>;
  dogShelter?: InputMaybe<DogShelterCreateNestedOneWithoutAnimalsInput>;
  gender?: InputMaybe<GenderEnum>;
  imgs?: InputMaybe<AnimalImgCreateNestedManyWithoutAnimalInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  neutered?: InputMaybe<Scalars['Boolean']['input']>;
  owner?: InputMaybe<AccountCreateNestedOneWithoutAnimalsInput>;
  passportFile?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<AnimalSizeEnum>;
  stats?: InputMaybe<AnimalStatCreateNestedOneWithoutAnimalInput>;
  statsId?: InputMaybe<Scalars['Int']['input']>;
  sterilized?: InputMaybe<Scalars['Boolean']['input']>;
  studInfos?: InputMaybe<StudInfoCreateNestedOneWithoutAnimalInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  type: AnimalTypeEnum;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  weight?: InputMaybe<Scalars['Int']['input']>;
};

export type AnimalCreateWithoutOwnerInput = {
  adopted?: InputMaybe<Scalars['Boolean']['input']>;
  adoptionDate?: InputMaybe<Scalars['DateTime']['input']>;
  application?: InputMaybe<DogBreederApplicationCreateNestedOneWithoutAnimalInput>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  birthday?: InputMaybe<Scalars['DateTime']['input']>;
  birthdayType?: InputMaybe<BirthdayType>;
  birthedLitters?: InputMaybe<LitterParentCreateNestedManyWithoutParentInput>;
  bookingAnimals?: InputMaybe<BookingAnimalCreateNestedManyWithoutAnimalInput>;
  bookings?: InputMaybe<BookingCreateNestedManyWithoutAnimalInput>;
  calved?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dogInfos?: InputMaybe<DogInfoCreateNestedOneWithoutAnimalInput>;
  dogShelter?: InputMaybe<DogShelterCreateNestedOneWithoutAnimalsInput>;
  gender?: InputMaybe<GenderEnum>;
  imgs?: InputMaybe<AnimalImgCreateNestedManyWithoutAnimalInput>;
  litter?: InputMaybe<LitterCreateNestedOneWithoutAnimalsBornInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  neutered?: InputMaybe<Scalars['Boolean']['input']>;
  passportFile?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<AnimalSizeEnum>;
  stats?: InputMaybe<AnimalStatCreateNestedOneWithoutAnimalInput>;
  statsId?: InputMaybe<Scalars['Int']['input']>;
  sterilized?: InputMaybe<Scalars['Boolean']['input']>;
  studInfos?: InputMaybe<StudInfoCreateNestedOneWithoutAnimalInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  type: AnimalTypeEnum;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  weight?: InputMaybe<Scalars['Int']['input']>;
};

export type AnimalCreateWithoutStatsInput = {
  adopted?: InputMaybe<Scalars['Boolean']['input']>;
  adoptionDate?: InputMaybe<Scalars['DateTime']['input']>;
  application?: InputMaybe<DogBreederApplicationCreateNestedOneWithoutAnimalInput>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  birthday?: InputMaybe<Scalars['DateTime']['input']>;
  birthdayType?: InputMaybe<BirthdayType>;
  birthedLitters?: InputMaybe<LitterParentCreateNestedManyWithoutParentInput>;
  bookingAnimals?: InputMaybe<BookingAnimalCreateNestedManyWithoutAnimalInput>;
  bookings?: InputMaybe<BookingCreateNestedManyWithoutAnimalInput>;
  calved?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dogInfos?: InputMaybe<DogInfoCreateNestedOneWithoutAnimalInput>;
  dogShelter?: InputMaybe<DogShelterCreateNestedOneWithoutAnimalsInput>;
  gender?: InputMaybe<GenderEnum>;
  imgs?: InputMaybe<AnimalImgCreateNestedManyWithoutAnimalInput>;
  litter?: InputMaybe<LitterCreateNestedOneWithoutAnimalsBornInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  neutered?: InputMaybe<Scalars['Boolean']['input']>;
  owner?: InputMaybe<AccountCreateNestedOneWithoutAnimalsInput>;
  passportFile?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<AnimalSizeEnum>;
  statsId?: InputMaybe<Scalars['Int']['input']>;
  sterilized?: InputMaybe<Scalars['Boolean']['input']>;
  studInfos?: InputMaybe<StudInfoCreateNestedOneWithoutAnimalInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  type: AnimalTypeEnum;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  weight?: InputMaybe<Scalars['Int']['input']>;
};

export type AnimalCreateWithoutStudInfosInput = {
  adopted?: InputMaybe<Scalars['Boolean']['input']>;
  adoptionDate?: InputMaybe<Scalars['DateTime']['input']>;
  application?: InputMaybe<DogBreederApplicationCreateNestedOneWithoutAnimalInput>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  birthday?: InputMaybe<Scalars['DateTime']['input']>;
  birthdayType?: InputMaybe<BirthdayType>;
  birthedLitters?: InputMaybe<LitterParentCreateNestedManyWithoutParentInput>;
  bookingAnimals?: InputMaybe<BookingAnimalCreateNestedManyWithoutAnimalInput>;
  bookings?: InputMaybe<BookingCreateNestedManyWithoutAnimalInput>;
  calved?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dogInfos?: InputMaybe<DogInfoCreateNestedOneWithoutAnimalInput>;
  dogShelter?: InputMaybe<DogShelterCreateNestedOneWithoutAnimalsInput>;
  gender?: InputMaybe<GenderEnum>;
  imgs?: InputMaybe<AnimalImgCreateNestedManyWithoutAnimalInput>;
  litter?: InputMaybe<LitterCreateNestedOneWithoutAnimalsBornInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  neutered?: InputMaybe<Scalars['Boolean']['input']>;
  owner?: InputMaybe<AccountCreateNestedOneWithoutAnimalsInput>;
  passportFile?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<AnimalSizeEnum>;
  stats?: InputMaybe<AnimalStatCreateNestedOneWithoutAnimalInput>;
  statsId?: InputMaybe<Scalars['Int']['input']>;
  sterilized?: InputMaybe<Scalars['Boolean']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  type: AnimalTypeEnum;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  weight?: InputMaybe<Scalars['Int']['input']>;
};

export type AnimalCreatetagsInput = {
  set: Array<Scalars['String']['input']>;
};

export type AnimalImg = {
  __typename?: 'AnimalImg';
  animal: Animal;
  animalId: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  large?: Maybe<Scalars['String']['output']>;
  medium?: Maybe<Scalars['String']['output']>;
  small?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type AnimalImgAvgAggregateOutputType = {
  __typename?: 'AnimalImgAvgAggregateOutputType';
  animalId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

export type AnimalImgAvgOrderByAggregateInput = {
  animalId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export type AnimalImgCountAggregateOutputType = {
  __typename?: 'AnimalImgCountAggregateOutputType';
  _all: Scalars['Int']['output'];
  animalId: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  large: Scalars['Int']['output'];
  medium: Scalars['Int']['output'];
  small: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type AnimalImgCountOrderByAggregateInput = {
  animalId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  large?: InputMaybe<SortOrder>;
  medium?: InputMaybe<SortOrder>;
  small?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type AnimalImgCreateInput = {
  animal: AnimalCreateNestedOneWithoutImgsInput;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  large?: InputMaybe<Scalars['String']['input']>;
  medium?: InputMaybe<Scalars['String']['input']>;
  small?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AnimalImgCreateManyAnimalInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  large?: InputMaybe<Scalars['String']['input']>;
  medium?: InputMaybe<Scalars['String']['input']>;
  small?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AnimalImgCreateManyAnimalInputEnvelope = {
  data: Array<AnimalImgCreateManyAnimalInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AnimalImgCreateManyInput = {
  animalId: Scalars['Int']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  large?: InputMaybe<Scalars['String']['input']>;
  medium?: InputMaybe<Scalars['String']['input']>;
  small?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AnimalImgCreateNestedManyWithoutAnimalInput = {
  connect?: InputMaybe<Array<AnimalImgWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AnimalImgCreateOrConnectWithoutAnimalInput>>;
  create?: InputMaybe<Array<AnimalImgCreateWithoutAnimalInput>>;
  createMany?: InputMaybe<AnimalImgCreateManyAnimalInputEnvelope>;
};

export type AnimalImgCreateOrConnectWithoutAnimalInput = {
  create: AnimalImgCreateWithoutAnimalInput;
  where: AnimalImgWhereUniqueInput;
};

export type AnimalImgCreateWithoutAnimalInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  large?: InputMaybe<Scalars['String']['input']>;
  medium?: InputMaybe<Scalars['String']['input']>;
  small?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AnimalImgListRelationFilter = {
  every?: InputMaybe<AnimalImgWhereInput>;
  none?: InputMaybe<AnimalImgWhereInput>;
  some?: InputMaybe<AnimalImgWhereInput>;
};

export type AnimalImgMaxAggregateOutputType = {
  __typename?: 'AnimalImgMaxAggregateOutputType';
  animalId?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  large?: Maybe<Scalars['String']['output']>;
  medium?: Maybe<Scalars['String']['output']>;
  small?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type AnimalImgMaxOrderByAggregateInput = {
  animalId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  large?: InputMaybe<SortOrder>;
  medium?: InputMaybe<SortOrder>;
  small?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type AnimalImgMinAggregateOutputType = {
  __typename?: 'AnimalImgMinAggregateOutputType';
  animalId?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  large?: Maybe<Scalars['String']['output']>;
  medium?: Maybe<Scalars['String']['output']>;
  small?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type AnimalImgMinOrderByAggregateInput = {
  animalId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  large?: InputMaybe<SortOrder>;
  medium?: InputMaybe<SortOrder>;
  small?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type AnimalImgOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export enum AnimalImgOrderByRelevanceFieldEnum {
  large = 'large',
  medium = 'medium',
  small = 'small'
}

export type AnimalImgOrderByRelevanceInput = {
  fields: Array<AnimalImgOrderByRelevanceFieldEnum>;
  search: Scalars['String']['input'];
  sort: SortOrder;
};

export type AnimalImgOrderByWithAggregationInput = {
  _avg?: InputMaybe<AnimalImgAvgOrderByAggregateInput>;
  _count?: InputMaybe<AnimalImgCountOrderByAggregateInput>;
  _max?: InputMaybe<AnimalImgMaxOrderByAggregateInput>;
  _min?: InputMaybe<AnimalImgMinOrderByAggregateInput>;
  _sum?: InputMaybe<AnimalImgSumOrderByAggregateInput>;
  animalId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  large?: InputMaybe<SortOrderInput>;
  medium?: InputMaybe<SortOrderInput>;
  small?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type AnimalImgOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: InputMaybe<AnimalImgOrderByRelevanceInput>;
  animal?: InputMaybe<AnimalOrderByWithRelationAndSearchRelevanceInput>;
  animalId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  large?: InputMaybe<SortOrderInput>;
  medium?: InputMaybe<SortOrderInput>;
  small?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum AnimalImgScalarFieldEnum {
  animalId = 'animalId',
  createdAt = 'createdAt',
  id = 'id',
  large = 'large',
  medium = 'medium',
  small = 'small',
  updatedAt = 'updatedAt'
}

export type AnimalImgScalarWhereInput = {
  AND?: InputMaybe<Array<AnimalImgScalarWhereInput>>;
  NOT?: InputMaybe<Array<AnimalImgScalarWhereInput>>;
  OR?: InputMaybe<Array<AnimalImgScalarWhereInput>>;
  animalId?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntFilter>;
  large?: InputMaybe<StringNullableFilter>;
  medium?: InputMaybe<StringNullableFilter>;
  small?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type AnimalImgScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<AnimalImgScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<AnimalImgScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<AnimalImgScalarWhereWithAggregatesInput>>;
  animalId?: InputMaybe<IntWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  large?: InputMaybe<StringNullableWithAggregatesFilter>;
  medium?: InputMaybe<StringNullableWithAggregatesFilter>;
  small?: InputMaybe<StringNullableWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type AnimalImgSumAggregateOutputType = {
  __typename?: 'AnimalImgSumAggregateOutputType';
  animalId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
};

export type AnimalImgSumOrderByAggregateInput = {
  animalId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export type AnimalImgUncheckedCreateInput = {
  animalId: Scalars['Int']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  large?: InputMaybe<Scalars['String']['input']>;
  medium?: InputMaybe<Scalars['String']['input']>;
  small?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AnimalImgUncheckedCreateNestedManyWithoutAnimalInput = {
  connect?: InputMaybe<Array<AnimalImgWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AnimalImgCreateOrConnectWithoutAnimalInput>>;
  create?: InputMaybe<Array<AnimalImgCreateWithoutAnimalInput>>;
  createMany?: InputMaybe<AnimalImgCreateManyAnimalInputEnvelope>;
};

export type AnimalImgUncheckedCreateWithoutAnimalInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  large?: InputMaybe<Scalars['String']['input']>;
  medium?: InputMaybe<Scalars['String']['input']>;
  small?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AnimalImgUncheckedUpdateInput = {
  animalId?: InputMaybe<IntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  large?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  medium?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  small?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type AnimalImgUncheckedUpdateManyInput = {
  animalId?: InputMaybe<IntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  large?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  medium?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  small?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type AnimalImgUncheckedUpdateManyWithoutAnimalInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  large?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  medium?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  small?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type AnimalImgUncheckedUpdateManyWithoutAnimalNestedInput = {
  connect?: InputMaybe<Array<AnimalImgWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AnimalImgCreateOrConnectWithoutAnimalInput>>;
  create?: InputMaybe<Array<AnimalImgCreateWithoutAnimalInput>>;
  createMany?: InputMaybe<AnimalImgCreateManyAnimalInputEnvelope>;
  delete?: InputMaybe<Array<AnimalImgWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<AnimalImgScalarWhereInput>>;
  disconnect?: InputMaybe<Array<AnimalImgWhereUniqueInput>>;
  set?: InputMaybe<Array<AnimalImgWhereUniqueInput>>;
  update?: InputMaybe<Array<AnimalImgUpdateWithWhereUniqueWithoutAnimalInput>>;
  updateMany?: InputMaybe<Array<AnimalImgUpdateManyWithWhereWithoutAnimalInput>>;
  upsert?: InputMaybe<Array<AnimalImgUpsertWithWhereUniqueWithoutAnimalInput>>;
};

export type AnimalImgUncheckedUpdateWithoutAnimalInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  large?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  medium?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  small?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type AnimalImgUpdateInput = {
  animal?: InputMaybe<AnimalUpdateOneRequiredWithoutImgsNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  large?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  medium?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  small?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type AnimalImgUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  large?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  medium?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  small?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type AnimalImgUpdateManyWithWhereWithoutAnimalInput = {
  data: AnimalImgUpdateManyMutationInput;
  where: AnimalImgScalarWhereInput;
};

export type AnimalImgUpdateManyWithoutAnimalNestedInput = {
  connect?: InputMaybe<Array<AnimalImgWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AnimalImgCreateOrConnectWithoutAnimalInput>>;
  create?: InputMaybe<Array<AnimalImgCreateWithoutAnimalInput>>;
  createMany?: InputMaybe<AnimalImgCreateManyAnimalInputEnvelope>;
  delete?: InputMaybe<Array<AnimalImgWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<AnimalImgScalarWhereInput>>;
  disconnect?: InputMaybe<Array<AnimalImgWhereUniqueInput>>;
  set?: InputMaybe<Array<AnimalImgWhereUniqueInput>>;
  update?: InputMaybe<Array<AnimalImgUpdateWithWhereUniqueWithoutAnimalInput>>;
  updateMany?: InputMaybe<Array<AnimalImgUpdateManyWithWhereWithoutAnimalInput>>;
  upsert?: InputMaybe<Array<AnimalImgUpsertWithWhereUniqueWithoutAnimalInput>>;
};

export type AnimalImgUpdateWithWhereUniqueWithoutAnimalInput = {
  data: AnimalImgUpdateWithoutAnimalInput;
  where: AnimalImgWhereUniqueInput;
};

export type AnimalImgUpdateWithoutAnimalInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  large?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  medium?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  small?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type AnimalImgUpsertWithWhereUniqueWithoutAnimalInput = {
  create: AnimalImgCreateWithoutAnimalInput;
  update: AnimalImgUpdateWithoutAnimalInput;
  where: AnimalImgWhereUniqueInput;
};

export type AnimalImgWhereInput = {
  AND?: InputMaybe<Array<AnimalImgWhereInput>>;
  NOT?: InputMaybe<Array<AnimalImgWhereInput>>;
  OR?: InputMaybe<Array<AnimalImgWhereInput>>;
  animal?: InputMaybe<AnimalRelationFilter>;
  animalId?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntFilter>;
  large?: InputMaybe<StringNullableFilter>;
  medium?: InputMaybe<StringNullableFilter>;
  small?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type AnimalImgWhereUniqueInput = {
  AND?: InputMaybe<Array<AnimalImgWhereInput>>;
  NOT?: InputMaybe<Array<AnimalImgWhereInput>>;
  OR?: InputMaybe<Array<AnimalImgWhereInput>>;
  animal?: InputMaybe<AnimalRelationFilter>;
  animalId?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  large?: InputMaybe<StringNullableFilter>;
  medium?: InputMaybe<StringNullableFilter>;
  small?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type AnimalListRelationFilter = {
  every?: InputMaybe<AnimalWhereInput>;
  none?: InputMaybe<AnimalWhereInput>;
  some?: InputMaybe<AnimalWhereInput>;
};

export type AnimalMaxAggregateOutputType = {
  __typename?: 'AnimalMaxAggregateOutputType';
  adopted?: Maybe<Scalars['Boolean']['output']>;
  adoptionDate?: Maybe<Scalars['DateTime']['output']>;
  archived?: Maybe<Scalars['Boolean']['output']>;
  birthday?: Maybe<Scalars['DateTime']['output']>;
  birthdayType?: Maybe<BirthdayType>;
  calved?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  dogShelterId?: Maybe<Scalars['Int']['output']>;
  gender?: Maybe<GenderEnum>;
  id?: Maybe<Scalars['Int']['output']>;
  litterId?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  neutered?: Maybe<Scalars['Boolean']['output']>;
  ownerId?: Maybe<Scalars['Int']['output']>;
  passportFile?: Maybe<Scalars['String']['output']>;
  size?: Maybe<AnimalSizeEnum>;
  statsId?: Maybe<Scalars['Int']['output']>;
  sterilized?: Maybe<Scalars['Boolean']['output']>;
  type?: Maybe<AnimalTypeEnum>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  weight?: Maybe<Scalars['Int']['output']>;
};

export type AnimalMaxOrderByAggregateInput = {
  adopted?: InputMaybe<SortOrder>;
  adoptionDate?: InputMaybe<SortOrder>;
  archived?: InputMaybe<SortOrder>;
  birthday?: InputMaybe<SortOrder>;
  birthdayType?: InputMaybe<SortOrder>;
  calved?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  dogShelterId?: InputMaybe<SortOrder>;
  gender?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  litterId?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  neutered?: InputMaybe<SortOrder>;
  ownerId?: InputMaybe<SortOrder>;
  passportFile?: InputMaybe<SortOrder>;
  size?: InputMaybe<SortOrder>;
  statsId?: InputMaybe<SortOrder>;
  sterilized?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  weight?: InputMaybe<SortOrder>;
};

export type AnimalMinAggregateOutputType = {
  __typename?: 'AnimalMinAggregateOutputType';
  adopted?: Maybe<Scalars['Boolean']['output']>;
  adoptionDate?: Maybe<Scalars['DateTime']['output']>;
  archived?: Maybe<Scalars['Boolean']['output']>;
  birthday?: Maybe<Scalars['DateTime']['output']>;
  birthdayType?: Maybe<BirthdayType>;
  calved?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  dogShelterId?: Maybe<Scalars['Int']['output']>;
  gender?: Maybe<GenderEnum>;
  id?: Maybe<Scalars['Int']['output']>;
  litterId?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  neutered?: Maybe<Scalars['Boolean']['output']>;
  ownerId?: Maybe<Scalars['Int']['output']>;
  passportFile?: Maybe<Scalars['String']['output']>;
  size?: Maybe<AnimalSizeEnum>;
  statsId?: Maybe<Scalars['Int']['output']>;
  sterilized?: Maybe<Scalars['Boolean']['output']>;
  type?: Maybe<AnimalTypeEnum>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  weight?: Maybe<Scalars['Int']['output']>;
};

export type AnimalMinOrderByAggregateInput = {
  adopted?: InputMaybe<SortOrder>;
  adoptionDate?: InputMaybe<SortOrder>;
  archived?: InputMaybe<SortOrder>;
  birthday?: InputMaybe<SortOrder>;
  birthdayType?: InputMaybe<SortOrder>;
  calved?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  dogShelterId?: InputMaybe<SortOrder>;
  gender?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  litterId?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  neutered?: InputMaybe<SortOrder>;
  ownerId?: InputMaybe<SortOrder>;
  passportFile?: InputMaybe<SortOrder>;
  size?: InputMaybe<SortOrder>;
  statsId?: InputMaybe<SortOrder>;
  sterilized?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  weight?: InputMaybe<SortOrder>;
};

export type AnimalNullableRelationFilter = {
  is?: InputMaybe<AnimalWhereInput>;
  isNot?: InputMaybe<AnimalWhereInput>;
};

export type AnimalOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export enum AnimalOrderByRelevanceFieldEnum {
  name = 'name',
  passportFile = 'passportFile',
  tags = 'tags'
}

export type AnimalOrderByRelevanceInput = {
  fields: Array<AnimalOrderByRelevanceFieldEnum>;
  search: Scalars['String']['input'];
  sort: SortOrder;
};

export type AnimalOrderByWithAggregationInput = {
  _avg?: InputMaybe<AnimalAvgOrderByAggregateInput>;
  _count?: InputMaybe<AnimalCountOrderByAggregateInput>;
  _max?: InputMaybe<AnimalMaxOrderByAggregateInput>;
  _min?: InputMaybe<AnimalMinOrderByAggregateInput>;
  _sum?: InputMaybe<AnimalSumOrderByAggregateInput>;
  adopted?: InputMaybe<SortOrderInput>;
  adoptionDate?: InputMaybe<SortOrderInput>;
  archived?: InputMaybe<SortOrder>;
  birthday?: InputMaybe<SortOrderInput>;
  birthdayType?: InputMaybe<SortOrderInput>;
  calved?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  dogShelterId?: InputMaybe<SortOrderInput>;
  gender?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  litterId?: InputMaybe<SortOrderInput>;
  name?: InputMaybe<SortOrderInput>;
  neutered?: InputMaybe<SortOrderInput>;
  ownerId?: InputMaybe<SortOrderInput>;
  passportFile?: InputMaybe<SortOrderInput>;
  size?: InputMaybe<SortOrderInput>;
  statsId?: InputMaybe<SortOrderInput>;
  sterilized?: InputMaybe<SortOrderInput>;
  tags?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  weight?: InputMaybe<SortOrderInput>;
};

export type AnimalOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: InputMaybe<AnimalOrderByRelevanceInput>;
  adopted?: InputMaybe<SortOrderInput>;
  adoptionDate?: InputMaybe<SortOrderInput>;
  application?: InputMaybe<DogBreederApplicationOrderByWithRelationAndSearchRelevanceInput>;
  archived?: InputMaybe<SortOrder>;
  birthday?: InputMaybe<SortOrderInput>;
  birthdayType?: InputMaybe<SortOrderInput>;
  birthedLitters?: InputMaybe<LitterParentOrderByRelationAggregateInput>;
  bookingAnimals?: InputMaybe<BookingAnimalOrderByRelationAggregateInput>;
  bookings?: InputMaybe<BookingOrderByRelationAggregateInput>;
  calved?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  dogInfos?: InputMaybe<DogInfoOrderByWithRelationAndSearchRelevanceInput>;
  dogShelter?: InputMaybe<DogShelterOrderByWithRelationAndSearchRelevanceInput>;
  dogShelterId?: InputMaybe<SortOrderInput>;
  gender?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  imgs?: InputMaybe<AnimalImgOrderByRelationAggregateInput>;
  litter?: InputMaybe<LitterOrderByWithRelationAndSearchRelevanceInput>;
  litterId?: InputMaybe<SortOrderInput>;
  name?: InputMaybe<SortOrderInput>;
  neutered?: InputMaybe<SortOrderInput>;
  owner?: InputMaybe<AccountOrderByWithRelationAndSearchRelevanceInput>;
  ownerId?: InputMaybe<SortOrderInput>;
  passportFile?: InputMaybe<SortOrderInput>;
  size?: InputMaybe<SortOrderInput>;
  stats?: InputMaybe<AnimalStatOrderByWithRelationAndSearchRelevanceInput>;
  statsId?: InputMaybe<SortOrderInput>;
  sterilized?: InputMaybe<SortOrderInput>;
  studInfos?: InputMaybe<StudInfoOrderByWithRelationAndSearchRelevanceInput>;
  tags?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  weight?: InputMaybe<SortOrderInput>;
};

export type AnimalRelationFilter = {
  is?: InputMaybe<AnimalWhereInput>;
  isNot?: InputMaybe<AnimalWhereInput>;
};

export enum AnimalScalarFieldEnum {
  adopted = 'adopted',
  adoptionDate = 'adoptionDate',
  archived = 'archived',
  birthday = 'birthday',
  birthdayType = 'birthdayType',
  calved = 'calved',
  createdAt = 'createdAt',
  dogShelterId = 'dogShelterId',
  gender = 'gender',
  id = 'id',
  litterId = 'litterId',
  name = 'name',
  neutered = 'neutered',
  ownerId = 'ownerId',
  passportFile = 'passportFile',
  size = 'size',
  statsId = 'statsId',
  sterilized = 'sterilized',
  tags = 'tags',
  type = 'type',
  updatedAt = 'updatedAt',
  weight = 'weight'
}

export type AnimalScalarWhereInput = {
  AND?: InputMaybe<Array<AnimalScalarWhereInput>>;
  NOT?: InputMaybe<Array<AnimalScalarWhereInput>>;
  OR?: InputMaybe<Array<AnimalScalarWhereInput>>;
  adopted?: InputMaybe<BoolNullableFilter>;
  adoptionDate?: InputMaybe<DateTimeNullableFilter>;
  archived?: InputMaybe<BoolFilter>;
  birthday?: InputMaybe<DateTimeNullableFilter>;
  birthdayType?: InputMaybe<EnumBirthdayTypeNullableFilter>;
  calved?: InputMaybe<BoolNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  dogShelterId?: InputMaybe<IntNullableFilter>;
  gender?: InputMaybe<EnumGenderEnumNullableFilter>;
  id?: InputMaybe<IntFilter>;
  litterId?: InputMaybe<IntNullableFilter>;
  name?: InputMaybe<StringNullableFilter>;
  neutered?: InputMaybe<BoolNullableFilter>;
  ownerId?: InputMaybe<IntNullableFilter>;
  passportFile?: InputMaybe<StringNullableFilter>;
  size?: InputMaybe<EnumAnimalSizeEnumNullableFilter>;
  statsId?: InputMaybe<IntNullableFilter>;
  sterilized?: InputMaybe<BoolNullableFilter>;
  tags?: InputMaybe<StringNullableListFilter>;
  type?: InputMaybe<EnumAnimalTypeEnumFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  weight?: InputMaybe<IntNullableFilter>;
};

export type AnimalScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<AnimalScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<AnimalScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<AnimalScalarWhereWithAggregatesInput>>;
  adopted?: InputMaybe<BoolNullableWithAggregatesFilter>;
  adoptionDate?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  archived?: InputMaybe<BoolWithAggregatesFilter>;
  birthday?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  birthdayType?: InputMaybe<EnumBirthdayTypeNullableWithAggregatesFilter>;
  calved?: InputMaybe<BoolNullableWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  dogShelterId?: InputMaybe<IntNullableWithAggregatesFilter>;
  gender?: InputMaybe<EnumGenderEnumNullableWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  litterId?: InputMaybe<IntNullableWithAggregatesFilter>;
  name?: InputMaybe<StringNullableWithAggregatesFilter>;
  neutered?: InputMaybe<BoolNullableWithAggregatesFilter>;
  ownerId?: InputMaybe<IntNullableWithAggregatesFilter>;
  passportFile?: InputMaybe<StringNullableWithAggregatesFilter>;
  size?: InputMaybe<EnumAnimalSizeEnumNullableWithAggregatesFilter>;
  statsId?: InputMaybe<IntNullableWithAggregatesFilter>;
  sterilized?: InputMaybe<BoolNullableWithAggregatesFilter>;
  tags?: InputMaybe<StringNullableListFilter>;
  type?: InputMaybe<EnumAnimalTypeEnumWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  weight?: InputMaybe<IntNullableWithAggregatesFilter>;
};

export enum AnimalSensitivityEnum {
  DIGESTION = 'DIGESTION',
  GROWTH = 'GROWTH',
  ITCHING = 'ITCHING',
  MOBILITY = 'MOBILITY',
  NONE = 'NONE',
  STRESS = 'STRESS'
}

export enum AnimalSizeEnum {
  BIG = 'BIG',
  MEDIUM = 'MEDIUM',
  SMALL = 'SMALL'
}

export type AnimalStat = {
  __typename?: 'AnimalStat';
  createdAt: Scalars['DateTime']['output'];
  createdFrom?: Maybe<AnimalStatCreatedFromEnum>;
  id: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type AnimalStatAvgAggregateOutputType = {
  __typename?: 'AnimalStatAvgAggregateOutputType';
  animalId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

export type AnimalStatAvgOrderByAggregateInput = {
  animalId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export type AnimalStatCountAggregateOutputType = {
  __typename?: 'AnimalStatCountAggregateOutputType';
  _all: Scalars['Int']['output'];
  animalId: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  createdFrom: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type AnimalStatCountOrderByAggregateInput = {
  animalId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  createdFrom?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type AnimalStatCreateInput = {
  animal: AnimalCreateNestedOneWithoutStatsInput;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdFrom: AnimalStatCreatedFromEnum;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AnimalStatCreateManyInput = {
  animalId: Scalars['Int']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdFrom: AnimalStatCreatedFromEnum;
  id?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AnimalStatCreateNestedOneWithoutAnimalInput = {
  connect?: InputMaybe<AnimalStatWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AnimalStatCreateOrConnectWithoutAnimalInput>;
  create?: InputMaybe<AnimalStatCreateWithoutAnimalInput>;
};

export type AnimalStatCreateOrConnectWithoutAnimalInput = {
  create: AnimalStatCreateWithoutAnimalInput;
  where: AnimalStatWhereUniqueInput;
};

export type AnimalStatCreateWithoutAnimalInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdFrom: AnimalStatCreatedFromEnum;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export enum AnimalStatCreatedFromEnum {
  ADOPTION_BREEDER = 'ADOPTION_BREEDER',
  ADOPTION_BUYER = 'ADOPTION_BUYER',
  BOOKING = 'BOOKING',
  MANUAL_BREEDER = 'MANUAL_BREEDER',
  MANUAL_BUYER = 'MANUAL_BUYER',
  WAITING_LIST = 'WAITING_LIST'
}

export type AnimalStatMaxAggregateOutputType = {
  __typename?: 'AnimalStatMaxAggregateOutputType';
  animalId?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdFrom?: Maybe<AnimalStatCreatedFromEnum>;
  id?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type AnimalStatMaxOrderByAggregateInput = {
  animalId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  createdFrom?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type AnimalStatMinAggregateOutputType = {
  __typename?: 'AnimalStatMinAggregateOutputType';
  animalId?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdFrom?: Maybe<AnimalStatCreatedFromEnum>;
  id?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type AnimalStatMinOrderByAggregateInput = {
  animalId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  createdFrom?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type AnimalStatNullableRelationFilter = {
  is?: InputMaybe<AnimalStatWhereInput>;
  isNot?: InputMaybe<AnimalStatWhereInput>;
};

export type AnimalStatOrderByWithAggregationInput = {
  _avg?: InputMaybe<AnimalStatAvgOrderByAggregateInput>;
  _count?: InputMaybe<AnimalStatCountOrderByAggregateInput>;
  _max?: InputMaybe<AnimalStatMaxOrderByAggregateInput>;
  _min?: InputMaybe<AnimalStatMinOrderByAggregateInput>;
  _sum?: InputMaybe<AnimalStatSumOrderByAggregateInput>;
  animalId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  createdFrom?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type AnimalStatOrderByWithRelationAndSearchRelevanceInput = {
  animal?: InputMaybe<AnimalOrderByWithRelationAndSearchRelevanceInput>;
  animalId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  createdFrom?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum AnimalStatScalarFieldEnum {
  animalId = 'animalId',
  createdAt = 'createdAt',
  createdFrom = 'createdFrom',
  id = 'id',
  updatedAt = 'updatedAt'
}

export type AnimalStatScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<AnimalStatScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<AnimalStatScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<AnimalStatScalarWhereWithAggregatesInput>>;
  animalId?: InputMaybe<IntWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  createdFrom?: InputMaybe<EnumAnimalStatCreatedFromEnumWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type AnimalStatSumAggregateOutputType = {
  __typename?: 'AnimalStatSumAggregateOutputType';
  animalId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
};

export type AnimalStatSumOrderByAggregateInput = {
  animalId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export type AnimalStatUncheckedCreateInput = {
  animalId: Scalars['Int']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdFrom: AnimalStatCreatedFromEnum;
  id?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AnimalStatUncheckedCreateNestedOneWithoutAnimalInput = {
  connect?: InputMaybe<AnimalStatWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AnimalStatCreateOrConnectWithoutAnimalInput>;
  create?: InputMaybe<AnimalStatCreateWithoutAnimalInput>;
};

export type AnimalStatUncheckedCreateWithoutAnimalInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdFrom: AnimalStatCreatedFromEnum;
  id?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AnimalStatUncheckedUpdateInput = {
  animalId?: InputMaybe<IntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdFrom?: InputMaybe<EnumAnimalStatCreatedFromEnumFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type AnimalStatUncheckedUpdateManyInput = {
  animalId?: InputMaybe<IntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdFrom?: InputMaybe<EnumAnimalStatCreatedFromEnumFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type AnimalStatUncheckedUpdateOneWithoutAnimalNestedInput = {
  connect?: InputMaybe<AnimalStatWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AnimalStatCreateOrConnectWithoutAnimalInput>;
  create?: InputMaybe<AnimalStatCreateWithoutAnimalInput>;
  delete?: InputMaybe<AnimalStatWhereInput>;
  disconnect?: InputMaybe<AnimalStatWhereInput>;
  update?: InputMaybe<AnimalStatUpdateToOneWithWhereWithoutAnimalInput>;
  upsert?: InputMaybe<AnimalStatUpsertWithoutAnimalInput>;
};

export type AnimalStatUncheckedUpdateWithoutAnimalInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdFrom?: InputMaybe<EnumAnimalStatCreatedFromEnumFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type AnimalStatUpdateInput = {
  animal?: InputMaybe<AnimalUpdateOneRequiredWithoutStatsNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdFrom?: InputMaybe<EnumAnimalStatCreatedFromEnumFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type AnimalStatUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdFrom?: InputMaybe<EnumAnimalStatCreatedFromEnumFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type AnimalStatUpdateOneWithoutAnimalNestedInput = {
  connect?: InputMaybe<AnimalStatWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AnimalStatCreateOrConnectWithoutAnimalInput>;
  create?: InputMaybe<AnimalStatCreateWithoutAnimalInput>;
  delete?: InputMaybe<AnimalStatWhereInput>;
  disconnect?: InputMaybe<AnimalStatWhereInput>;
  update?: InputMaybe<AnimalStatUpdateToOneWithWhereWithoutAnimalInput>;
  upsert?: InputMaybe<AnimalStatUpsertWithoutAnimalInput>;
};

export type AnimalStatUpdateToOneWithWhereWithoutAnimalInput = {
  data: AnimalStatUpdateWithoutAnimalInput;
  where?: InputMaybe<AnimalStatWhereInput>;
};

export type AnimalStatUpdateWithoutAnimalInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdFrom?: InputMaybe<EnumAnimalStatCreatedFromEnumFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type AnimalStatUpsertWithoutAnimalInput = {
  create: AnimalStatCreateWithoutAnimalInput;
  update: AnimalStatUpdateWithoutAnimalInput;
  where?: InputMaybe<AnimalStatWhereInput>;
};

export type AnimalStatWhereInput = {
  AND?: InputMaybe<Array<AnimalStatWhereInput>>;
  NOT?: InputMaybe<Array<AnimalStatWhereInput>>;
  OR?: InputMaybe<Array<AnimalStatWhereInput>>;
  animal?: InputMaybe<AnimalRelationFilter>;
  animalId?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdFrom?: InputMaybe<EnumAnimalStatCreatedFromEnumFilter>;
  id?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type AnimalStatWhereUniqueInput = {
  AND?: InputMaybe<Array<AnimalStatWhereInput>>;
  NOT?: InputMaybe<Array<AnimalStatWhereInput>>;
  OR?: InputMaybe<Array<AnimalStatWhereInput>>;
  animal?: InputMaybe<AnimalRelationFilter>;
  animalId?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdFrom?: InputMaybe<EnumAnimalStatCreatedFromEnumFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type AnimalSumAggregateOutputType = {
  __typename?: 'AnimalSumAggregateOutputType';
  dogShelterId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  litterId?: Maybe<Scalars['Int']['output']>;
  ownerId?: Maybe<Scalars['Int']['output']>;
  statsId?: Maybe<Scalars['Int']['output']>;
  weight?: Maybe<Scalars['Int']['output']>;
};

export type AnimalSumOrderByAggregateInput = {
  dogShelterId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  litterId?: InputMaybe<SortOrder>;
  ownerId?: InputMaybe<SortOrder>;
  statsId?: InputMaybe<SortOrder>;
  weight?: InputMaybe<SortOrder>;
};

export enum AnimalTypeEnum {
  ARACHNIDS = 'ARACHNIDS',
  CAPRINE = 'CAPRINE',
  CAT = 'CAT',
  CATTLE = 'CATTLE',
  CHICKENS = 'CHICKENS',
  DOG = 'DOG',
  FERRETS = 'FERRETS',
  FISH = 'FISH',
  GUINEAPIGS = 'GUINEAPIGS',
  HORSE = 'HORSE',
  NAC = 'NAC',
  NACALL = 'NACALL',
  NACBIRD = 'NACBIRD',
  NACREPTILE = 'NACREPTILE',
  NACREPTILEARACHNIDS = 'NACREPTILEARACHNIDS',
  NACSMALL = 'NACSMALL',
  OTHER = 'OTHER',
  PIGS = 'PIGS',
  RABBITS = 'RABBITS',
  SHEEP = 'SHEEP',
  SMALLRODENT = 'SMALLRODENT'
}

export type AnimalUncheckedCreateInput = {
  adopted?: InputMaybe<Scalars['Boolean']['input']>;
  adoptionDate?: InputMaybe<Scalars['DateTime']['input']>;
  application?: InputMaybe<DogBreederApplicationUncheckedCreateNestedOneWithoutAnimalInput>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  birthday?: InputMaybe<Scalars['DateTime']['input']>;
  birthdayType?: InputMaybe<BirthdayType>;
  birthedLitters?: InputMaybe<LitterParentUncheckedCreateNestedManyWithoutParentInput>;
  bookingAnimals?: InputMaybe<BookingAnimalUncheckedCreateNestedManyWithoutAnimalInput>;
  bookings?: InputMaybe<BookingUncheckedCreateNestedManyWithoutAnimalInput>;
  calved?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dogInfos?: InputMaybe<DogInfoUncheckedCreateNestedOneWithoutAnimalInput>;
  dogShelterId?: InputMaybe<Scalars['Int']['input']>;
  gender?: InputMaybe<GenderEnum>;
  id?: InputMaybe<Scalars['Int']['input']>;
  imgs?: InputMaybe<AnimalImgUncheckedCreateNestedManyWithoutAnimalInput>;
  litterId?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  neutered?: InputMaybe<Scalars['Boolean']['input']>;
  ownerId?: InputMaybe<Scalars['Int']['input']>;
  passportFile?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<AnimalSizeEnum>;
  stats?: InputMaybe<AnimalStatUncheckedCreateNestedOneWithoutAnimalInput>;
  statsId?: InputMaybe<Scalars['Int']['input']>;
  sterilized?: InputMaybe<Scalars['Boolean']['input']>;
  studInfos?: InputMaybe<StudInfoUncheckedCreateNestedOneWithoutAnimalInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  type: AnimalTypeEnum;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  weight?: InputMaybe<Scalars['Int']['input']>;
};

export type AnimalUncheckedCreateNestedManyWithoutDogShelterInput = {
  connect?: InputMaybe<Array<AnimalWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AnimalCreateOrConnectWithoutDogShelterInput>>;
  create?: InputMaybe<Array<AnimalCreateWithoutDogShelterInput>>;
  createMany?: InputMaybe<AnimalCreateManyDogShelterInputEnvelope>;
};

export type AnimalUncheckedCreateNestedManyWithoutLitterInput = {
  connect?: InputMaybe<Array<AnimalWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AnimalCreateOrConnectWithoutLitterInput>>;
  create?: InputMaybe<Array<AnimalCreateWithoutLitterInput>>;
  createMany?: InputMaybe<AnimalCreateManyLitterInputEnvelope>;
};

export type AnimalUncheckedCreateNestedManyWithoutOwnerInput = {
  connect?: InputMaybe<Array<AnimalWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AnimalCreateOrConnectWithoutOwnerInput>>;
  create?: InputMaybe<Array<AnimalCreateWithoutOwnerInput>>;
  createMany?: InputMaybe<AnimalCreateManyOwnerInputEnvelope>;
};

export type AnimalUncheckedCreateWithoutApplicationInput = {
  adopted?: InputMaybe<Scalars['Boolean']['input']>;
  adoptionDate?: InputMaybe<Scalars['DateTime']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  birthday?: InputMaybe<Scalars['DateTime']['input']>;
  birthdayType?: InputMaybe<BirthdayType>;
  birthedLitters?: InputMaybe<LitterParentUncheckedCreateNestedManyWithoutParentInput>;
  bookingAnimals?: InputMaybe<BookingAnimalUncheckedCreateNestedManyWithoutAnimalInput>;
  bookings?: InputMaybe<BookingUncheckedCreateNestedManyWithoutAnimalInput>;
  calved?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dogInfos?: InputMaybe<DogInfoUncheckedCreateNestedOneWithoutAnimalInput>;
  dogShelterId?: InputMaybe<Scalars['Int']['input']>;
  gender?: InputMaybe<GenderEnum>;
  id?: InputMaybe<Scalars['Int']['input']>;
  imgs?: InputMaybe<AnimalImgUncheckedCreateNestedManyWithoutAnimalInput>;
  litterId?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  neutered?: InputMaybe<Scalars['Boolean']['input']>;
  ownerId?: InputMaybe<Scalars['Int']['input']>;
  passportFile?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<AnimalSizeEnum>;
  stats?: InputMaybe<AnimalStatUncheckedCreateNestedOneWithoutAnimalInput>;
  statsId?: InputMaybe<Scalars['Int']['input']>;
  sterilized?: InputMaybe<Scalars['Boolean']['input']>;
  studInfos?: InputMaybe<StudInfoUncheckedCreateNestedOneWithoutAnimalInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  type: AnimalTypeEnum;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  weight?: InputMaybe<Scalars['Int']['input']>;
};

export type AnimalUncheckedCreateWithoutBirthedLittersInput = {
  adopted?: InputMaybe<Scalars['Boolean']['input']>;
  adoptionDate?: InputMaybe<Scalars['DateTime']['input']>;
  application?: InputMaybe<DogBreederApplicationUncheckedCreateNestedOneWithoutAnimalInput>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  birthday?: InputMaybe<Scalars['DateTime']['input']>;
  birthdayType?: InputMaybe<BirthdayType>;
  bookingAnimals?: InputMaybe<BookingAnimalUncheckedCreateNestedManyWithoutAnimalInput>;
  bookings?: InputMaybe<BookingUncheckedCreateNestedManyWithoutAnimalInput>;
  calved?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dogInfos?: InputMaybe<DogInfoUncheckedCreateNestedOneWithoutAnimalInput>;
  dogShelterId?: InputMaybe<Scalars['Int']['input']>;
  gender?: InputMaybe<GenderEnum>;
  id?: InputMaybe<Scalars['Int']['input']>;
  imgs?: InputMaybe<AnimalImgUncheckedCreateNestedManyWithoutAnimalInput>;
  litterId?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  neutered?: InputMaybe<Scalars['Boolean']['input']>;
  ownerId?: InputMaybe<Scalars['Int']['input']>;
  passportFile?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<AnimalSizeEnum>;
  stats?: InputMaybe<AnimalStatUncheckedCreateNestedOneWithoutAnimalInput>;
  statsId?: InputMaybe<Scalars['Int']['input']>;
  sterilized?: InputMaybe<Scalars['Boolean']['input']>;
  studInfos?: InputMaybe<StudInfoUncheckedCreateNestedOneWithoutAnimalInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  type: AnimalTypeEnum;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  weight?: InputMaybe<Scalars['Int']['input']>;
};

export type AnimalUncheckedCreateWithoutBookingAnimalsInput = {
  adopted?: InputMaybe<Scalars['Boolean']['input']>;
  adoptionDate?: InputMaybe<Scalars['DateTime']['input']>;
  application?: InputMaybe<DogBreederApplicationUncheckedCreateNestedOneWithoutAnimalInput>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  birthday?: InputMaybe<Scalars['DateTime']['input']>;
  birthdayType?: InputMaybe<BirthdayType>;
  birthedLitters?: InputMaybe<LitterParentUncheckedCreateNestedManyWithoutParentInput>;
  bookings?: InputMaybe<BookingUncheckedCreateNestedManyWithoutAnimalInput>;
  calved?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dogInfos?: InputMaybe<DogInfoUncheckedCreateNestedOneWithoutAnimalInput>;
  dogShelterId?: InputMaybe<Scalars['Int']['input']>;
  gender?: InputMaybe<GenderEnum>;
  id?: InputMaybe<Scalars['Int']['input']>;
  imgs?: InputMaybe<AnimalImgUncheckedCreateNestedManyWithoutAnimalInput>;
  litterId?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  neutered?: InputMaybe<Scalars['Boolean']['input']>;
  ownerId?: InputMaybe<Scalars['Int']['input']>;
  passportFile?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<AnimalSizeEnum>;
  stats?: InputMaybe<AnimalStatUncheckedCreateNestedOneWithoutAnimalInput>;
  statsId?: InputMaybe<Scalars['Int']['input']>;
  sterilized?: InputMaybe<Scalars['Boolean']['input']>;
  studInfos?: InputMaybe<StudInfoUncheckedCreateNestedOneWithoutAnimalInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  type: AnimalTypeEnum;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  weight?: InputMaybe<Scalars['Int']['input']>;
};

export type AnimalUncheckedCreateWithoutBookingsInput = {
  adopted?: InputMaybe<Scalars['Boolean']['input']>;
  adoptionDate?: InputMaybe<Scalars['DateTime']['input']>;
  application?: InputMaybe<DogBreederApplicationUncheckedCreateNestedOneWithoutAnimalInput>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  birthday?: InputMaybe<Scalars['DateTime']['input']>;
  birthdayType?: InputMaybe<BirthdayType>;
  birthedLitters?: InputMaybe<LitterParentUncheckedCreateNestedManyWithoutParentInput>;
  bookingAnimals?: InputMaybe<BookingAnimalUncheckedCreateNestedManyWithoutAnimalInput>;
  calved?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dogInfos?: InputMaybe<DogInfoUncheckedCreateNestedOneWithoutAnimalInput>;
  dogShelterId?: InputMaybe<Scalars['Int']['input']>;
  gender?: InputMaybe<GenderEnum>;
  id?: InputMaybe<Scalars['Int']['input']>;
  imgs?: InputMaybe<AnimalImgUncheckedCreateNestedManyWithoutAnimalInput>;
  litterId?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  neutered?: InputMaybe<Scalars['Boolean']['input']>;
  ownerId?: InputMaybe<Scalars['Int']['input']>;
  passportFile?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<AnimalSizeEnum>;
  stats?: InputMaybe<AnimalStatUncheckedCreateNestedOneWithoutAnimalInput>;
  statsId?: InputMaybe<Scalars['Int']['input']>;
  sterilized?: InputMaybe<Scalars['Boolean']['input']>;
  studInfos?: InputMaybe<StudInfoUncheckedCreateNestedOneWithoutAnimalInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  type: AnimalTypeEnum;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  weight?: InputMaybe<Scalars['Int']['input']>;
};

export type AnimalUncheckedCreateWithoutDogInfosInput = {
  adopted?: InputMaybe<Scalars['Boolean']['input']>;
  adoptionDate?: InputMaybe<Scalars['DateTime']['input']>;
  application?: InputMaybe<DogBreederApplicationUncheckedCreateNestedOneWithoutAnimalInput>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  birthday?: InputMaybe<Scalars['DateTime']['input']>;
  birthdayType?: InputMaybe<BirthdayType>;
  birthedLitters?: InputMaybe<LitterParentUncheckedCreateNestedManyWithoutParentInput>;
  bookingAnimals?: InputMaybe<BookingAnimalUncheckedCreateNestedManyWithoutAnimalInput>;
  bookings?: InputMaybe<BookingUncheckedCreateNestedManyWithoutAnimalInput>;
  calved?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dogShelterId?: InputMaybe<Scalars['Int']['input']>;
  gender?: InputMaybe<GenderEnum>;
  id?: InputMaybe<Scalars['Int']['input']>;
  imgs?: InputMaybe<AnimalImgUncheckedCreateNestedManyWithoutAnimalInput>;
  litterId?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  neutered?: InputMaybe<Scalars['Boolean']['input']>;
  ownerId?: InputMaybe<Scalars['Int']['input']>;
  passportFile?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<AnimalSizeEnum>;
  stats?: InputMaybe<AnimalStatUncheckedCreateNestedOneWithoutAnimalInput>;
  statsId?: InputMaybe<Scalars['Int']['input']>;
  sterilized?: InputMaybe<Scalars['Boolean']['input']>;
  studInfos?: InputMaybe<StudInfoUncheckedCreateNestedOneWithoutAnimalInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  type: AnimalTypeEnum;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  weight?: InputMaybe<Scalars['Int']['input']>;
};

export type AnimalUncheckedCreateWithoutDogShelterInput = {
  adopted?: InputMaybe<Scalars['Boolean']['input']>;
  adoptionDate?: InputMaybe<Scalars['DateTime']['input']>;
  application?: InputMaybe<DogBreederApplicationUncheckedCreateNestedOneWithoutAnimalInput>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  birthday?: InputMaybe<Scalars['DateTime']['input']>;
  birthdayType?: InputMaybe<BirthdayType>;
  birthedLitters?: InputMaybe<LitterParentUncheckedCreateNestedManyWithoutParentInput>;
  bookingAnimals?: InputMaybe<BookingAnimalUncheckedCreateNestedManyWithoutAnimalInput>;
  bookings?: InputMaybe<BookingUncheckedCreateNestedManyWithoutAnimalInput>;
  calved?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dogInfos?: InputMaybe<DogInfoUncheckedCreateNestedOneWithoutAnimalInput>;
  gender?: InputMaybe<GenderEnum>;
  id?: InputMaybe<Scalars['Int']['input']>;
  imgs?: InputMaybe<AnimalImgUncheckedCreateNestedManyWithoutAnimalInput>;
  litterId?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  neutered?: InputMaybe<Scalars['Boolean']['input']>;
  ownerId?: InputMaybe<Scalars['Int']['input']>;
  passportFile?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<AnimalSizeEnum>;
  stats?: InputMaybe<AnimalStatUncheckedCreateNestedOneWithoutAnimalInput>;
  statsId?: InputMaybe<Scalars['Int']['input']>;
  sterilized?: InputMaybe<Scalars['Boolean']['input']>;
  studInfos?: InputMaybe<StudInfoUncheckedCreateNestedOneWithoutAnimalInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  type: AnimalTypeEnum;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  weight?: InputMaybe<Scalars['Int']['input']>;
};

export type AnimalUncheckedCreateWithoutImgsInput = {
  adopted?: InputMaybe<Scalars['Boolean']['input']>;
  adoptionDate?: InputMaybe<Scalars['DateTime']['input']>;
  application?: InputMaybe<DogBreederApplicationUncheckedCreateNestedOneWithoutAnimalInput>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  birthday?: InputMaybe<Scalars['DateTime']['input']>;
  birthdayType?: InputMaybe<BirthdayType>;
  birthedLitters?: InputMaybe<LitterParentUncheckedCreateNestedManyWithoutParentInput>;
  bookingAnimals?: InputMaybe<BookingAnimalUncheckedCreateNestedManyWithoutAnimalInput>;
  bookings?: InputMaybe<BookingUncheckedCreateNestedManyWithoutAnimalInput>;
  calved?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dogInfos?: InputMaybe<DogInfoUncheckedCreateNestedOneWithoutAnimalInput>;
  dogShelterId?: InputMaybe<Scalars['Int']['input']>;
  gender?: InputMaybe<GenderEnum>;
  id?: InputMaybe<Scalars['Int']['input']>;
  litterId?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  neutered?: InputMaybe<Scalars['Boolean']['input']>;
  ownerId?: InputMaybe<Scalars['Int']['input']>;
  passportFile?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<AnimalSizeEnum>;
  stats?: InputMaybe<AnimalStatUncheckedCreateNestedOneWithoutAnimalInput>;
  statsId?: InputMaybe<Scalars['Int']['input']>;
  sterilized?: InputMaybe<Scalars['Boolean']['input']>;
  studInfos?: InputMaybe<StudInfoUncheckedCreateNestedOneWithoutAnimalInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  type: AnimalTypeEnum;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  weight?: InputMaybe<Scalars['Int']['input']>;
};

export type AnimalUncheckedCreateWithoutLitterInput = {
  adopted?: InputMaybe<Scalars['Boolean']['input']>;
  adoptionDate?: InputMaybe<Scalars['DateTime']['input']>;
  application?: InputMaybe<DogBreederApplicationUncheckedCreateNestedOneWithoutAnimalInput>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  birthday?: InputMaybe<Scalars['DateTime']['input']>;
  birthdayType?: InputMaybe<BirthdayType>;
  birthedLitters?: InputMaybe<LitterParentUncheckedCreateNestedManyWithoutParentInput>;
  bookingAnimals?: InputMaybe<BookingAnimalUncheckedCreateNestedManyWithoutAnimalInput>;
  bookings?: InputMaybe<BookingUncheckedCreateNestedManyWithoutAnimalInput>;
  calved?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dogInfos?: InputMaybe<DogInfoUncheckedCreateNestedOneWithoutAnimalInput>;
  dogShelterId?: InputMaybe<Scalars['Int']['input']>;
  gender?: InputMaybe<GenderEnum>;
  id?: InputMaybe<Scalars['Int']['input']>;
  imgs?: InputMaybe<AnimalImgUncheckedCreateNestedManyWithoutAnimalInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  neutered?: InputMaybe<Scalars['Boolean']['input']>;
  ownerId?: InputMaybe<Scalars['Int']['input']>;
  passportFile?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<AnimalSizeEnum>;
  stats?: InputMaybe<AnimalStatUncheckedCreateNestedOneWithoutAnimalInput>;
  statsId?: InputMaybe<Scalars['Int']['input']>;
  sterilized?: InputMaybe<Scalars['Boolean']['input']>;
  studInfos?: InputMaybe<StudInfoUncheckedCreateNestedOneWithoutAnimalInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  type: AnimalTypeEnum;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  weight?: InputMaybe<Scalars['Int']['input']>;
};

export type AnimalUncheckedCreateWithoutOwnerInput = {
  adopted?: InputMaybe<Scalars['Boolean']['input']>;
  adoptionDate?: InputMaybe<Scalars['DateTime']['input']>;
  application?: InputMaybe<DogBreederApplicationUncheckedCreateNestedOneWithoutAnimalInput>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  birthday?: InputMaybe<Scalars['DateTime']['input']>;
  birthdayType?: InputMaybe<BirthdayType>;
  birthedLitters?: InputMaybe<LitterParentUncheckedCreateNestedManyWithoutParentInput>;
  bookingAnimals?: InputMaybe<BookingAnimalUncheckedCreateNestedManyWithoutAnimalInput>;
  bookings?: InputMaybe<BookingUncheckedCreateNestedManyWithoutAnimalInput>;
  calved?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dogInfos?: InputMaybe<DogInfoUncheckedCreateNestedOneWithoutAnimalInput>;
  dogShelterId?: InputMaybe<Scalars['Int']['input']>;
  gender?: InputMaybe<GenderEnum>;
  id?: InputMaybe<Scalars['Int']['input']>;
  imgs?: InputMaybe<AnimalImgUncheckedCreateNestedManyWithoutAnimalInput>;
  litterId?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  neutered?: InputMaybe<Scalars['Boolean']['input']>;
  passportFile?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<AnimalSizeEnum>;
  stats?: InputMaybe<AnimalStatUncheckedCreateNestedOneWithoutAnimalInput>;
  statsId?: InputMaybe<Scalars['Int']['input']>;
  sterilized?: InputMaybe<Scalars['Boolean']['input']>;
  studInfos?: InputMaybe<StudInfoUncheckedCreateNestedOneWithoutAnimalInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  type: AnimalTypeEnum;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  weight?: InputMaybe<Scalars['Int']['input']>;
};

export type AnimalUncheckedCreateWithoutStatsInput = {
  adopted?: InputMaybe<Scalars['Boolean']['input']>;
  adoptionDate?: InputMaybe<Scalars['DateTime']['input']>;
  application?: InputMaybe<DogBreederApplicationUncheckedCreateNestedOneWithoutAnimalInput>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  birthday?: InputMaybe<Scalars['DateTime']['input']>;
  birthdayType?: InputMaybe<BirthdayType>;
  birthedLitters?: InputMaybe<LitterParentUncheckedCreateNestedManyWithoutParentInput>;
  bookingAnimals?: InputMaybe<BookingAnimalUncheckedCreateNestedManyWithoutAnimalInput>;
  bookings?: InputMaybe<BookingUncheckedCreateNestedManyWithoutAnimalInput>;
  calved?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dogInfos?: InputMaybe<DogInfoUncheckedCreateNestedOneWithoutAnimalInput>;
  dogShelterId?: InputMaybe<Scalars['Int']['input']>;
  gender?: InputMaybe<GenderEnum>;
  id?: InputMaybe<Scalars['Int']['input']>;
  imgs?: InputMaybe<AnimalImgUncheckedCreateNestedManyWithoutAnimalInput>;
  litterId?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  neutered?: InputMaybe<Scalars['Boolean']['input']>;
  ownerId?: InputMaybe<Scalars['Int']['input']>;
  passportFile?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<AnimalSizeEnum>;
  statsId?: InputMaybe<Scalars['Int']['input']>;
  sterilized?: InputMaybe<Scalars['Boolean']['input']>;
  studInfos?: InputMaybe<StudInfoUncheckedCreateNestedOneWithoutAnimalInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  type: AnimalTypeEnum;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  weight?: InputMaybe<Scalars['Int']['input']>;
};

export type AnimalUncheckedCreateWithoutStudInfosInput = {
  adopted?: InputMaybe<Scalars['Boolean']['input']>;
  adoptionDate?: InputMaybe<Scalars['DateTime']['input']>;
  application?: InputMaybe<DogBreederApplicationUncheckedCreateNestedOneWithoutAnimalInput>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  birthday?: InputMaybe<Scalars['DateTime']['input']>;
  birthdayType?: InputMaybe<BirthdayType>;
  birthedLitters?: InputMaybe<LitterParentUncheckedCreateNestedManyWithoutParentInput>;
  bookingAnimals?: InputMaybe<BookingAnimalUncheckedCreateNestedManyWithoutAnimalInput>;
  bookings?: InputMaybe<BookingUncheckedCreateNestedManyWithoutAnimalInput>;
  calved?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dogInfos?: InputMaybe<DogInfoUncheckedCreateNestedOneWithoutAnimalInput>;
  dogShelterId?: InputMaybe<Scalars['Int']['input']>;
  gender?: InputMaybe<GenderEnum>;
  id?: InputMaybe<Scalars['Int']['input']>;
  imgs?: InputMaybe<AnimalImgUncheckedCreateNestedManyWithoutAnimalInput>;
  litterId?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  neutered?: InputMaybe<Scalars['Boolean']['input']>;
  ownerId?: InputMaybe<Scalars['Int']['input']>;
  passportFile?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<AnimalSizeEnum>;
  stats?: InputMaybe<AnimalStatUncheckedCreateNestedOneWithoutAnimalInput>;
  statsId?: InputMaybe<Scalars['Int']['input']>;
  sterilized?: InputMaybe<Scalars['Boolean']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  type: AnimalTypeEnum;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  weight?: InputMaybe<Scalars['Int']['input']>;
};

export type AnimalUncheckedUpdateInput = {
  adopted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  adoptionDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  application?: InputMaybe<DogBreederApplicationUncheckedUpdateOneWithoutAnimalNestedInput>;
  archived?: InputMaybe<BoolFieldUpdateOperationsInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  birthdayType?: InputMaybe<NullableEnumBirthdayTypeFieldUpdateOperationsInput>;
  birthedLitters?: InputMaybe<LitterParentUncheckedUpdateManyWithoutParentNestedInput>;
  bookingAnimals?: InputMaybe<BookingAnimalUncheckedUpdateManyWithoutAnimalNestedInput>;
  bookings?: InputMaybe<BookingUncheckedUpdateManyWithoutAnimalNestedInput>;
  calved?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dogInfos?: InputMaybe<DogInfoUncheckedUpdateOneWithoutAnimalNestedInput>;
  dogShelterId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableEnumGenderEnumFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  imgs?: InputMaybe<AnimalImgUncheckedUpdateManyWithoutAnimalNestedInput>;
  litterId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  neutered?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  ownerId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  passportFile?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  size?: InputMaybe<NullableEnumAnimalSizeEnumFieldUpdateOperationsInput>;
  stats?: InputMaybe<AnimalStatUncheckedUpdateOneWithoutAnimalNestedInput>;
  statsId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  sterilized?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  studInfos?: InputMaybe<StudInfoUncheckedUpdateOneWithoutAnimalNestedInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<EnumAnimalTypeEnumFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  weight?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type AnimalUncheckedUpdateManyInput = {
  adopted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  adoptionDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  archived?: InputMaybe<BoolFieldUpdateOperationsInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  birthdayType?: InputMaybe<NullableEnumBirthdayTypeFieldUpdateOperationsInput>;
  calved?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dogShelterId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableEnumGenderEnumFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  litterId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  neutered?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  ownerId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  passportFile?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  size?: InputMaybe<NullableEnumAnimalSizeEnumFieldUpdateOperationsInput>;
  statsId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  sterilized?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<EnumAnimalTypeEnumFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  weight?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type AnimalUncheckedUpdateManyWithoutDogShelterInput = {
  adopted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  adoptionDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  archived?: InputMaybe<BoolFieldUpdateOperationsInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  birthdayType?: InputMaybe<NullableEnumBirthdayTypeFieldUpdateOperationsInput>;
  calved?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableEnumGenderEnumFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  litterId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  neutered?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  ownerId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  passportFile?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  size?: InputMaybe<NullableEnumAnimalSizeEnumFieldUpdateOperationsInput>;
  statsId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  sterilized?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<EnumAnimalTypeEnumFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  weight?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type AnimalUncheckedUpdateManyWithoutDogShelterNestedInput = {
  connect?: InputMaybe<Array<AnimalWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AnimalCreateOrConnectWithoutDogShelterInput>>;
  create?: InputMaybe<Array<AnimalCreateWithoutDogShelterInput>>;
  createMany?: InputMaybe<AnimalCreateManyDogShelterInputEnvelope>;
  delete?: InputMaybe<Array<AnimalWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<AnimalScalarWhereInput>>;
  disconnect?: InputMaybe<Array<AnimalWhereUniqueInput>>;
  set?: InputMaybe<Array<AnimalWhereUniqueInput>>;
  update?: InputMaybe<Array<AnimalUpdateWithWhereUniqueWithoutDogShelterInput>>;
  updateMany?: InputMaybe<Array<AnimalUpdateManyWithWhereWithoutDogShelterInput>>;
  upsert?: InputMaybe<Array<AnimalUpsertWithWhereUniqueWithoutDogShelterInput>>;
};

export type AnimalUncheckedUpdateManyWithoutLitterInput = {
  adopted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  adoptionDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  archived?: InputMaybe<BoolFieldUpdateOperationsInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  birthdayType?: InputMaybe<NullableEnumBirthdayTypeFieldUpdateOperationsInput>;
  calved?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dogShelterId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableEnumGenderEnumFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  neutered?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  ownerId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  passportFile?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  size?: InputMaybe<NullableEnumAnimalSizeEnumFieldUpdateOperationsInput>;
  statsId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  sterilized?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<EnumAnimalTypeEnumFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  weight?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type AnimalUncheckedUpdateManyWithoutLitterNestedInput = {
  connect?: InputMaybe<Array<AnimalWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AnimalCreateOrConnectWithoutLitterInput>>;
  create?: InputMaybe<Array<AnimalCreateWithoutLitterInput>>;
  createMany?: InputMaybe<AnimalCreateManyLitterInputEnvelope>;
  delete?: InputMaybe<Array<AnimalWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<AnimalScalarWhereInput>>;
  disconnect?: InputMaybe<Array<AnimalWhereUniqueInput>>;
  set?: InputMaybe<Array<AnimalWhereUniqueInput>>;
  update?: InputMaybe<Array<AnimalUpdateWithWhereUniqueWithoutLitterInput>>;
  updateMany?: InputMaybe<Array<AnimalUpdateManyWithWhereWithoutLitterInput>>;
  upsert?: InputMaybe<Array<AnimalUpsertWithWhereUniqueWithoutLitterInput>>;
};

export type AnimalUncheckedUpdateManyWithoutOwnerInput = {
  adopted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  adoptionDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  archived?: InputMaybe<BoolFieldUpdateOperationsInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  birthdayType?: InputMaybe<NullableEnumBirthdayTypeFieldUpdateOperationsInput>;
  calved?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dogShelterId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableEnumGenderEnumFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  litterId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  neutered?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  passportFile?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  size?: InputMaybe<NullableEnumAnimalSizeEnumFieldUpdateOperationsInput>;
  statsId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  sterilized?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<EnumAnimalTypeEnumFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  weight?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type AnimalUncheckedUpdateManyWithoutOwnerNestedInput = {
  connect?: InputMaybe<Array<AnimalWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AnimalCreateOrConnectWithoutOwnerInput>>;
  create?: InputMaybe<Array<AnimalCreateWithoutOwnerInput>>;
  createMany?: InputMaybe<AnimalCreateManyOwnerInputEnvelope>;
  delete?: InputMaybe<Array<AnimalWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<AnimalScalarWhereInput>>;
  disconnect?: InputMaybe<Array<AnimalWhereUniqueInput>>;
  set?: InputMaybe<Array<AnimalWhereUniqueInput>>;
  update?: InputMaybe<Array<AnimalUpdateWithWhereUniqueWithoutOwnerInput>>;
  updateMany?: InputMaybe<Array<AnimalUpdateManyWithWhereWithoutOwnerInput>>;
  upsert?: InputMaybe<Array<AnimalUpsertWithWhereUniqueWithoutOwnerInput>>;
};

export type AnimalUncheckedUpdateWithoutApplicationInput = {
  adopted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  adoptionDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  archived?: InputMaybe<BoolFieldUpdateOperationsInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  birthdayType?: InputMaybe<NullableEnumBirthdayTypeFieldUpdateOperationsInput>;
  birthedLitters?: InputMaybe<LitterParentUncheckedUpdateManyWithoutParentNestedInput>;
  bookingAnimals?: InputMaybe<BookingAnimalUncheckedUpdateManyWithoutAnimalNestedInput>;
  bookings?: InputMaybe<BookingUncheckedUpdateManyWithoutAnimalNestedInput>;
  calved?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dogInfos?: InputMaybe<DogInfoUncheckedUpdateOneWithoutAnimalNestedInput>;
  dogShelterId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableEnumGenderEnumFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  imgs?: InputMaybe<AnimalImgUncheckedUpdateManyWithoutAnimalNestedInput>;
  litterId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  neutered?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  ownerId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  passportFile?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  size?: InputMaybe<NullableEnumAnimalSizeEnumFieldUpdateOperationsInput>;
  stats?: InputMaybe<AnimalStatUncheckedUpdateOneWithoutAnimalNestedInput>;
  statsId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  sterilized?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  studInfos?: InputMaybe<StudInfoUncheckedUpdateOneWithoutAnimalNestedInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<EnumAnimalTypeEnumFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  weight?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type AnimalUncheckedUpdateWithoutBirthedLittersInput = {
  adopted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  adoptionDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  application?: InputMaybe<DogBreederApplicationUncheckedUpdateOneWithoutAnimalNestedInput>;
  archived?: InputMaybe<BoolFieldUpdateOperationsInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  birthdayType?: InputMaybe<NullableEnumBirthdayTypeFieldUpdateOperationsInput>;
  bookingAnimals?: InputMaybe<BookingAnimalUncheckedUpdateManyWithoutAnimalNestedInput>;
  bookings?: InputMaybe<BookingUncheckedUpdateManyWithoutAnimalNestedInput>;
  calved?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dogInfos?: InputMaybe<DogInfoUncheckedUpdateOneWithoutAnimalNestedInput>;
  dogShelterId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableEnumGenderEnumFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  imgs?: InputMaybe<AnimalImgUncheckedUpdateManyWithoutAnimalNestedInput>;
  litterId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  neutered?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  ownerId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  passportFile?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  size?: InputMaybe<NullableEnumAnimalSizeEnumFieldUpdateOperationsInput>;
  stats?: InputMaybe<AnimalStatUncheckedUpdateOneWithoutAnimalNestedInput>;
  statsId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  sterilized?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  studInfos?: InputMaybe<StudInfoUncheckedUpdateOneWithoutAnimalNestedInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<EnumAnimalTypeEnumFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  weight?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type AnimalUncheckedUpdateWithoutBookingAnimalsInput = {
  adopted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  adoptionDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  application?: InputMaybe<DogBreederApplicationUncheckedUpdateOneWithoutAnimalNestedInput>;
  archived?: InputMaybe<BoolFieldUpdateOperationsInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  birthdayType?: InputMaybe<NullableEnumBirthdayTypeFieldUpdateOperationsInput>;
  birthedLitters?: InputMaybe<LitterParentUncheckedUpdateManyWithoutParentNestedInput>;
  bookings?: InputMaybe<BookingUncheckedUpdateManyWithoutAnimalNestedInput>;
  calved?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dogInfos?: InputMaybe<DogInfoUncheckedUpdateOneWithoutAnimalNestedInput>;
  dogShelterId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableEnumGenderEnumFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  imgs?: InputMaybe<AnimalImgUncheckedUpdateManyWithoutAnimalNestedInput>;
  litterId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  neutered?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  ownerId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  passportFile?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  size?: InputMaybe<NullableEnumAnimalSizeEnumFieldUpdateOperationsInput>;
  stats?: InputMaybe<AnimalStatUncheckedUpdateOneWithoutAnimalNestedInput>;
  statsId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  sterilized?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  studInfos?: InputMaybe<StudInfoUncheckedUpdateOneWithoutAnimalNestedInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<EnumAnimalTypeEnumFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  weight?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type AnimalUncheckedUpdateWithoutBookingsInput = {
  adopted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  adoptionDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  application?: InputMaybe<DogBreederApplicationUncheckedUpdateOneWithoutAnimalNestedInput>;
  archived?: InputMaybe<BoolFieldUpdateOperationsInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  birthdayType?: InputMaybe<NullableEnumBirthdayTypeFieldUpdateOperationsInput>;
  birthedLitters?: InputMaybe<LitterParentUncheckedUpdateManyWithoutParentNestedInput>;
  bookingAnimals?: InputMaybe<BookingAnimalUncheckedUpdateManyWithoutAnimalNestedInput>;
  calved?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dogInfos?: InputMaybe<DogInfoUncheckedUpdateOneWithoutAnimalNestedInput>;
  dogShelterId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableEnumGenderEnumFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  imgs?: InputMaybe<AnimalImgUncheckedUpdateManyWithoutAnimalNestedInput>;
  litterId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  neutered?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  ownerId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  passportFile?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  size?: InputMaybe<NullableEnumAnimalSizeEnumFieldUpdateOperationsInput>;
  stats?: InputMaybe<AnimalStatUncheckedUpdateOneWithoutAnimalNestedInput>;
  statsId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  sterilized?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  studInfos?: InputMaybe<StudInfoUncheckedUpdateOneWithoutAnimalNestedInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<EnumAnimalTypeEnumFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  weight?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type AnimalUncheckedUpdateWithoutDogInfosInput = {
  adopted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  adoptionDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  application?: InputMaybe<DogBreederApplicationUncheckedUpdateOneWithoutAnimalNestedInput>;
  archived?: InputMaybe<BoolFieldUpdateOperationsInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  birthdayType?: InputMaybe<NullableEnumBirthdayTypeFieldUpdateOperationsInput>;
  birthedLitters?: InputMaybe<LitterParentUncheckedUpdateManyWithoutParentNestedInput>;
  bookingAnimals?: InputMaybe<BookingAnimalUncheckedUpdateManyWithoutAnimalNestedInput>;
  bookings?: InputMaybe<BookingUncheckedUpdateManyWithoutAnimalNestedInput>;
  calved?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dogShelterId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableEnumGenderEnumFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  imgs?: InputMaybe<AnimalImgUncheckedUpdateManyWithoutAnimalNestedInput>;
  litterId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  neutered?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  ownerId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  passportFile?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  size?: InputMaybe<NullableEnumAnimalSizeEnumFieldUpdateOperationsInput>;
  stats?: InputMaybe<AnimalStatUncheckedUpdateOneWithoutAnimalNestedInput>;
  statsId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  sterilized?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  studInfos?: InputMaybe<StudInfoUncheckedUpdateOneWithoutAnimalNestedInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<EnumAnimalTypeEnumFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  weight?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type AnimalUncheckedUpdateWithoutDogShelterInput = {
  adopted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  adoptionDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  application?: InputMaybe<DogBreederApplicationUncheckedUpdateOneWithoutAnimalNestedInput>;
  archived?: InputMaybe<BoolFieldUpdateOperationsInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  birthdayType?: InputMaybe<NullableEnumBirthdayTypeFieldUpdateOperationsInput>;
  birthedLitters?: InputMaybe<LitterParentUncheckedUpdateManyWithoutParentNestedInput>;
  bookingAnimals?: InputMaybe<BookingAnimalUncheckedUpdateManyWithoutAnimalNestedInput>;
  bookings?: InputMaybe<BookingUncheckedUpdateManyWithoutAnimalNestedInput>;
  calved?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dogInfos?: InputMaybe<DogInfoUncheckedUpdateOneWithoutAnimalNestedInput>;
  gender?: InputMaybe<NullableEnumGenderEnumFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  imgs?: InputMaybe<AnimalImgUncheckedUpdateManyWithoutAnimalNestedInput>;
  litterId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  neutered?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  ownerId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  passportFile?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  size?: InputMaybe<NullableEnumAnimalSizeEnumFieldUpdateOperationsInput>;
  stats?: InputMaybe<AnimalStatUncheckedUpdateOneWithoutAnimalNestedInput>;
  statsId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  sterilized?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  studInfos?: InputMaybe<StudInfoUncheckedUpdateOneWithoutAnimalNestedInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<EnumAnimalTypeEnumFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  weight?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type AnimalUncheckedUpdateWithoutImgsInput = {
  adopted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  adoptionDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  application?: InputMaybe<DogBreederApplicationUncheckedUpdateOneWithoutAnimalNestedInput>;
  archived?: InputMaybe<BoolFieldUpdateOperationsInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  birthdayType?: InputMaybe<NullableEnumBirthdayTypeFieldUpdateOperationsInput>;
  birthedLitters?: InputMaybe<LitterParentUncheckedUpdateManyWithoutParentNestedInput>;
  bookingAnimals?: InputMaybe<BookingAnimalUncheckedUpdateManyWithoutAnimalNestedInput>;
  bookings?: InputMaybe<BookingUncheckedUpdateManyWithoutAnimalNestedInput>;
  calved?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dogInfos?: InputMaybe<DogInfoUncheckedUpdateOneWithoutAnimalNestedInput>;
  dogShelterId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableEnumGenderEnumFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  litterId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  neutered?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  ownerId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  passportFile?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  size?: InputMaybe<NullableEnumAnimalSizeEnumFieldUpdateOperationsInput>;
  stats?: InputMaybe<AnimalStatUncheckedUpdateOneWithoutAnimalNestedInput>;
  statsId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  sterilized?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  studInfos?: InputMaybe<StudInfoUncheckedUpdateOneWithoutAnimalNestedInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<EnumAnimalTypeEnumFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  weight?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type AnimalUncheckedUpdateWithoutLitterInput = {
  adopted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  adoptionDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  application?: InputMaybe<DogBreederApplicationUncheckedUpdateOneWithoutAnimalNestedInput>;
  archived?: InputMaybe<BoolFieldUpdateOperationsInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  birthdayType?: InputMaybe<NullableEnumBirthdayTypeFieldUpdateOperationsInput>;
  birthedLitters?: InputMaybe<LitterParentUncheckedUpdateManyWithoutParentNestedInput>;
  bookingAnimals?: InputMaybe<BookingAnimalUncheckedUpdateManyWithoutAnimalNestedInput>;
  bookings?: InputMaybe<BookingUncheckedUpdateManyWithoutAnimalNestedInput>;
  calved?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dogInfos?: InputMaybe<DogInfoUncheckedUpdateOneWithoutAnimalNestedInput>;
  dogShelterId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableEnumGenderEnumFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  imgs?: InputMaybe<AnimalImgUncheckedUpdateManyWithoutAnimalNestedInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  neutered?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  ownerId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  passportFile?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  size?: InputMaybe<NullableEnumAnimalSizeEnumFieldUpdateOperationsInput>;
  stats?: InputMaybe<AnimalStatUncheckedUpdateOneWithoutAnimalNestedInput>;
  statsId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  sterilized?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  studInfos?: InputMaybe<StudInfoUncheckedUpdateOneWithoutAnimalNestedInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<EnumAnimalTypeEnumFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  weight?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type AnimalUncheckedUpdateWithoutOwnerInput = {
  adopted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  adoptionDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  application?: InputMaybe<DogBreederApplicationUncheckedUpdateOneWithoutAnimalNestedInput>;
  archived?: InputMaybe<BoolFieldUpdateOperationsInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  birthdayType?: InputMaybe<NullableEnumBirthdayTypeFieldUpdateOperationsInput>;
  birthedLitters?: InputMaybe<LitterParentUncheckedUpdateManyWithoutParentNestedInput>;
  bookingAnimals?: InputMaybe<BookingAnimalUncheckedUpdateManyWithoutAnimalNestedInput>;
  bookings?: InputMaybe<BookingUncheckedUpdateManyWithoutAnimalNestedInput>;
  calved?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dogInfos?: InputMaybe<DogInfoUncheckedUpdateOneWithoutAnimalNestedInput>;
  dogShelterId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableEnumGenderEnumFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  imgs?: InputMaybe<AnimalImgUncheckedUpdateManyWithoutAnimalNestedInput>;
  litterId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  neutered?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  passportFile?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  size?: InputMaybe<NullableEnumAnimalSizeEnumFieldUpdateOperationsInput>;
  stats?: InputMaybe<AnimalStatUncheckedUpdateOneWithoutAnimalNestedInput>;
  statsId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  sterilized?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  studInfos?: InputMaybe<StudInfoUncheckedUpdateOneWithoutAnimalNestedInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<EnumAnimalTypeEnumFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  weight?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type AnimalUncheckedUpdateWithoutStatsInput = {
  adopted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  adoptionDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  application?: InputMaybe<DogBreederApplicationUncheckedUpdateOneWithoutAnimalNestedInput>;
  archived?: InputMaybe<BoolFieldUpdateOperationsInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  birthdayType?: InputMaybe<NullableEnumBirthdayTypeFieldUpdateOperationsInput>;
  birthedLitters?: InputMaybe<LitterParentUncheckedUpdateManyWithoutParentNestedInput>;
  bookingAnimals?: InputMaybe<BookingAnimalUncheckedUpdateManyWithoutAnimalNestedInput>;
  bookings?: InputMaybe<BookingUncheckedUpdateManyWithoutAnimalNestedInput>;
  calved?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dogInfos?: InputMaybe<DogInfoUncheckedUpdateOneWithoutAnimalNestedInput>;
  dogShelterId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableEnumGenderEnumFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  imgs?: InputMaybe<AnimalImgUncheckedUpdateManyWithoutAnimalNestedInput>;
  litterId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  neutered?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  ownerId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  passportFile?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  size?: InputMaybe<NullableEnumAnimalSizeEnumFieldUpdateOperationsInput>;
  statsId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  sterilized?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  studInfos?: InputMaybe<StudInfoUncheckedUpdateOneWithoutAnimalNestedInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<EnumAnimalTypeEnumFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  weight?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type AnimalUncheckedUpdateWithoutStudInfosInput = {
  adopted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  adoptionDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  application?: InputMaybe<DogBreederApplicationUncheckedUpdateOneWithoutAnimalNestedInput>;
  archived?: InputMaybe<BoolFieldUpdateOperationsInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  birthdayType?: InputMaybe<NullableEnumBirthdayTypeFieldUpdateOperationsInput>;
  birthedLitters?: InputMaybe<LitterParentUncheckedUpdateManyWithoutParentNestedInput>;
  bookingAnimals?: InputMaybe<BookingAnimalUncheckedUpdateManyWithoutAnimalNestedInput>;
  bookings?: InputMaybe<BookingUncheckedUpdateManyWithoutAnimalNestedInput>;
  calved?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dogInfos?: InputMaybe<DogInfoUncheckedUpdateOneWithoutAnimalNestedInput>;
  dogShelterId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableEnumGenderEnumFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  imgs?: InputMaybe<AnimalImgUncheckedUpdateManyWithoutAnimalNestedInput>;
  litterId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  neutered?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  ownerId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  passportFile?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  size?: InputMaybe<NullableEnumAnimalSizeEnumFieldUpdateOperationsInput>;
  stats?: InputMaybe<AnimalStatUncheckedUpdateOneWithoutAnimalNestedInput>;
  statsId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  sterilized?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<EnumAnimalTypeEnumFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  weight?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type AnimalUpdateInput = {
  adopted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  adoptionDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  application?: InputMaybe<DogBreederApplicationUpdateOneWithoutAnimalNestedInput>;
  archived?: InputMaybe<BoolFieldUpdateOperationsInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  birthdayType?: InputMaybe<NullableEnumBirthdayTypeFieldUpdateOperationsInput>;
  birthedLitters?: InputMaybe<LitterParentUpdateManyWithoutParentNestedInput>;
  bookingAnimals?: InputMaybe<BookingAnimalUpdateManyWithoutAnimalNestedInput>;
  bookings?: InputMaybe<BookingUpdateManyWithoutAnimalNestedInput>;
  calved?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dogInfos?: InputMaybe<DogInfoUpdateOneWithoutAnimalNestedInput>;
  dogShelter?: InputMaybe<DogShelterUpdateOneWithoutAnimalsNestedInput>;
  gender?: InputMaybe<NullableEnumGenderEnumFieldUpdateOperationsInput>;
  imgs?: InputMaybe<AnimalImgUpdateManyWithoutAnimalNestedInput>;
  litter?: InputMaybe<LitterUpdateOneWithoutAnimalsBornNestedInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  neutered?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  owner?: InputMaybe<AccountUpdateOneWithoutAnimalsNestedInput>;
  passportFile?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  sensitivities?: InputMaybe<Array<InputMaybe<AnimalSensitivityEnum>>>;
  size?: InputMaybe<NullableEnumAnimalSizeEnumFieldUpdateOperationsInput>;
  stats?: InputMaybe<AnimalStatUpdateOneWithoutAnimalNestedInput>;
  statsId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  sterilized?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  studInfos?: InputMaybe<StudInfoUpdateOneWithoutAnimalNestedInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<EnumAnimalTypeEnumFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  weight?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type AnimalUpdateManyMutationInput = {
  adopted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  adoptionDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  archived?: InputMaybe<BoolFieldUpdateOperationsInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  birthdayType?: InputMaybe<NullableEnumBirthdayTypeFieldUpdateOperationsInput>;
  calved?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  gender?: InputMaybe<NullableEnumGenderEnumFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  neutered?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  passportFile?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  size?: InputMaybe<NullableEnumAnimalSizeEnumFieldUpdateOperationsInput>;
  statsId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  sterilized?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<EnumAnimalTypeEnumFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  weight?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type AnimalUpdateManyWithWhereWithoutDogShelterInput = {
  data: AnimalUpdateManyMutationInput;
  where: AnimalScalarWhereInput;
};

export type AnimalUpdateManyWithWhereWithoutLitterInput = {
  data: AnimalUpdateManyMutationInput;
  where: AnimalScalarWhereInput;
};

export type AnimalUpdateManyWithWhereWithoutOwnerInput = {
  data: AnimalUpdateManyMutationInput;
  where: AnimalScalarWhereInput;
};

export type AnimalUpdateManyWithoutDogShelterNestedInput = {
  connect?: InputMaybe<Array<AnimalWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AnimalCreateOrConnectWithoutDogShelterInput>>;
  create?: InputMaybe<Array<AnimalCreateWithoutDogShelterInput>>;
  createMany?: InputMaybe<AnimalCreateManyDogShelterInputEnvelope>;
  delete?: InputMaybe<Array<AnimalWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<AnimalScalarWhereInput>>;
  disconnect?: InputMaybe<Array<AnimalWhereUniqueInput>>;
  set?: InputMaybe<Array<AnimalWhereUniqueInput>>;
  update?: InputMaybe<Array<AnimalUpdateWithWhereUniqueWithoutDogShelterInput>>;
  updateMany?: InputMaybe<Array<AnimalUpdateManyWithWhereWithoutDogShelterInput>>;
  upsert?: InputMaybe<Array<AnimalUpsertWithWhereUniqueWithoutDogShelterInput>>;
};

export type AnimalUpdateManyWithoutLitterNestedInput = {
  connect?: InputMaybe<Array<AnimalWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AnimalCreateOrConnectWithoutLitterInput>>;
  create?: InputMaybe<Array<AnimalCreateWithoutLitterInput>>;
  createMany?: InputMaybe<AnimalCreateManyLitterInputEnvelope>;
  delete?: InputMaybe<Array<AnimalWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<AnimalScalarWhereInput>>;
  disconnect?: InputMaybe<Array<AnimalWhereUniqueInput>>;
  set?: InputMaybe<Array<AnimalWhereUniqueInput>>;
  update?: InputMaybe<Array<AnimalUpdateWithWhereUniqueWithoutLitterInput>>;
  updateMany?: InputMaybe<Array<AnimalUpdateManyWithWhereWithoutLitterInput>>;
  upsert?: InputMaybe<Array<AnimalUpsertWithWhereUniqueWithoutLitterInput>>;
};

export type AnimalUpdateManyWithoutOwnerNestedInput = {
  connect?: InputMaybe<Array<AnimalWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AnimalCreateOrConnectWithoutOwnerInput>>;
  create?: InputMaybe<Array<AnimalCreateWithoutOwnerInput>>;
  createMany?: InputMaybe<AnimalCreateManyOwnerInputEnvelope>;
  delete?: InputMaybe<Array<AnimalWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<AnimalScalarWhereInput>>;
  disconnect?: InputMaybe<Array<AnimalWhereUniqueInput>>;
  set?: InputMaybe<Array<AnimalWhereUniqueInput>>;
  update?: InputMaybe<Array<AnimalUpdateWithWhereUniqueWithoutOwnerInput>>;
  updateMany?: InputMaybe<Array<AnimalUpdateManyWithWhereWithoutOwnerInput>>;
  upsert?: InputMaybe<Array<AnimalUpsertWithWhereUniqueWithoutOwnerInput>>;
};

export type AnimalUpdateOneRequiredWithoutBookingAnimalsNestedInput = {
  connect?: InputMaybe<AnimalWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AnimalCreateOrConnectWithoutBookingAnimalsInput>;
  create?: InputMaybe<AnimalCreateWithoutBookingAnimalsInput>;
  update?: InputMaybe<AnimalUpdateToOneWithWhereWithoutBookingAnimalsInput>;
  upsert?: InputMaybe<AnimalUpsertWithoutBookingAnimalsInput>;
};

export type AnimalUpdateOneRequiredWithoutDogInfosNestedInput = {
  connect?: InputMaybe<AnimalWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AnimalCreateOrConnectWithoutDogInfosInput>;
  create?: InputMaybe<AnimalCreateWithoutDogInfosInput>;
  update?: InputMaybe<AnimalUpdateToOneWithWhereWithoutDogInfosInput>;
  upsert?: InputMaybe<AnimalUpsertWithoutDogInfosInput>;
};

export type AnimalUpdateOneRequiredWithoutImgsNestedInput = {
  connect?: InputMaybe<AnimalWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AnimalCreateOrConnectWithoutImgsInput>;
  create?: InputMaybe<AnimalCreateWithoutImgsInput>;
  update?: InputMaybe<AnimalUpdateToOneWithWhereWithoutImgsInput>;
  upsert?: InputMaybe<AnimalUpsertWithoutImgsInput>;
};

export type AnimalUpdateOneRequiredWithoutStatsNestedInput = {
  connect?: InputMaybe<AnimalWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AnimalCreateOrConnectWithoutStatsInput>;
  create?: InputMaybe<AnimalCreateWithoutStatsInput>;
  update?: InputMaybe<AnimalUpdateToOneWithWhereWithoutStatsInput>;
  upsert?: InputMaybe<AnimalUpsertWithoutStatsInput>;
};

export type AnimalUpdateOneRequiredWithoutStudInfosNestedInput = {
  connect?: InputMaybe<AnimalWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AnimalCreateOrConnectWithoutStudInfosInput>;
  create?: InputMaybe<AnimalCreateWithoutStudInfosInput>;
  update?: InputMaybe<AnimalUpdateToOneWithWhereWithoutStudInfosInput>;
  upsert?: InputMaybe<AnimalUpsertWithoutStudInfosInput>;
};

export type AnimalUpdateOneWithoutApplicationNestedInput = {
  connect?: InputMaybe<AnimalWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AnimalCreateOrConnectWithoutApplicationInput>;
  create?: InputMaybe<AnimalCreateWithoutApplicationInput>;
  delete?: InputMaybe<AnimalWhereInput>;
  disconnect?: InputMaybe<AnimalWhereInput>;
  update?: InputMaybe<AnimalUpdateToOneWithWhereWithoutApplicationInput>;
  upsert?: InputMaybe<AnimalUpsertWithoutApplicationInput>;
};

export type AnimalUpdateOneWithoutBirthedLittersNestedInput = {
  connect?: InputMaybe<AnimalWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AnimalCreateOrConnectWithoutBirthedLittersInput>;
  create?: InputMaybe<AnimalCreateWithoutBirthedLittersInput>;
  delete?: InputMaybe<AnimalWhereInput>;
  disconnect?: InputMaybe<AnimalWhereInput>;
  update?: InputMaybe<AnimalUpdateToOneWithWhereWithoutBirthedLittersInput>;
  upsert?: InputMaybe<AnimalUpsertWithoutBirthedLittersInput>;
};

export type AnimalUpdateOneWithoutBookingsNestedInput = {
  connect?: InputMaybe<AnimalWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AnimalCreateOrConnectWithoutBookingsInput>;
  create?: InputMaybe<AnimalCreateWithoutBookingsInput>;
  delete?: InputMaybe<AnimalWhereInput>;
  disconnect?: InputMaybe<AnimalWhereInput>;
  update?: InputMaybe<AnimalUpdateToOneWithWhereWithoutBookingsInput>;
  upsert?: InputMaybe<AnimalUpsertWithoutBookingsInput>;
};

export type AnimalUpdateToOneWithWhereWithoutApplicationInput = {
  data: AnimalUpdateWithoutApplicationInput;
  where?: InputMaybe<AnimalWhereInput>;
};

export type AnimalUpdateToOneWithWhereWithoutBirthedLittersInput = {
  data: AnimalUpdateWithoutBirthedLittersInput;
  where?: InputMaybe<AnimalWhereInput>;
};

export type AnimalUpdateToOneWithWhereWithoutBookingAnimalsInput = {
  data: AnimalUpdateWithoutBookingAnimalsInput;
  where?: InputMaybe<AnimalWhereInput>;
};

export type AnimalUpdateToOneWithWhereWithoutBookingsInput = {
  data: AnimalUpdateWithoutBookingsInput;
  where?: InputMaybe<AnimalWhereInput>;
};

export type AnimalUpdateToOneWithWhereWithoutDogInfosInput = {
  data: AnimalUpdateWithoutDogInfosInput;
  where?: InputMaybe<AnimalWhereInput>;
};

export type AnimalUpdateToOneWithWhereWithoutImgsInput = {
  data: AnimalUpdateWithoutImgsInput;
  where?: InputMaybe<AnimalWhereInput>;
};

export type AnimalUpdateToOneWithWhereWithoutStatsInput = {
  data: AnimalUpdateWithoutStatsInput;
  where?: InputMaybe<AnimalWhereInput>;
};

export type AnimalUpdateToOneWithWhereWithoutStudInfosInput = {
  data: AnimalUpdateWithoutStudInfosInput;
  where?: InputMaybe<AnimalWhereInput>;
};

export type AnimalUpdateWithWhereUniqueWithoutDogShelterInput = {
  data: AnimalUpdateWithoutDogShelterInput;
  where: AnimalWhereUniqueInput;
};

export type AnimalUpdateWithWhereUniqueWithoutLitterInput = {
  data: AnimalUpdateWithoutLitterInput;
  where: AnimalWhereUniqueInput;
};

export type AnimalUpdateWithWhereUniqueWithoutOwnerInput = {
  data: AnimalUpdateWithoutOwnerInput;
  where: AnimalWhereUniqueInput;
};

export type AnimalUpdateWithoutApplicationInput = {
  adopted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  adoptionDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  archived?: InputMaybe<BoolFieldUpdateOperationsInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  birthdayType?: InputMaybe<NullableEnumBirthdayTypeFieldUpdateOperationsInput>;
  birthedLitters?: InputMaybe<LitterParentUpdateManyWithoutParentNestedInput>;
  bookingAnimals?: InputMaybe<BookingAnimalUpdateManyWithoutAnimalNestedInput>;
  bookings?: InputMaybe<BookingUpdateManyWithoutAnimalNestedInput>;
  calved?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dogInfos?: InputMaybe<DogInfoUpdateOneWithoutAnimalNestedInput>;
  dogShelter?: InputMaybe<DogShelterUpdateOneWithoutAnimalsNestedInput>;
  gender?: InputMaybe<NullableEnumGenderEnumFieldUpdateOperationsInput>;
  imgs?: InputMaybe<AnimalImgUpdateManyWithoutAnimalNestedInput>;
  litter?: InputMaybe<LitterUpdateOneWithoutAnimalsBornNestedInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  neutered?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  owner?: InputMaybe<AccountUpdateOneWithoutAnimalsNestedInput>;
  passportFile?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  size?: InputMaybe<NullableEnumAnimalSizeEnumFieldUpdateOperationsInput>;
  stats?: InputMaybe<AnimalStatUpdateOneWithoutAnimalNestedInput>;
  statsId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  sterilized?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  studInfos?: InputMaybe<StudInfoUpdateOneWithoutAnimalNestedInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<EnumAnimalTypeEnumFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  weight?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type AnimalUpdateWithoutBirthedLittersInput = {
  adopted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  adoptionDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  application?: InputMaybe<DogBreederApplicationUpdateOneWithoutAnimalNestedInput>;
  archived?: InputMaybe<BoolFieldUpdateOperationsInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  birthdayType?: InputMaybe<NullableEnumBirthdayTypeFieldUpdateOperationsInput>;
  bookingAnimals?: InputMaybe<BookingAnimalUpdateManyWithoutAnimalNestedInput>;
  bookings?: InputMaybe<BookingUpdateManyWithoutAnimalNestedInput>;
  calved?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dogInfos?: InputMaybe<DogInfoUpdateOneWithoutAnimalNestedInput>;
  dogShelter?: InputMaybe<DogShelterUpdateOneWithoutAnimalsNestedInput>;
  gender?: InputMaybe<NullableEnumGenderEnumFieldUpdateOperationsInput>;
  imgs?: InputMaybe<AnimalImgUpdateManyWithoutAnimalNestedInput>;
  litter?: InputMaybe<LitterUpdateOneWithoutAnimalsBornNestedInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  neutered?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  owner?: InputMaybe<AccountUpdateOneWithoutAnimalsNestedInput>;
  passportFile?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  size?: InputMaybe<NullableEnumAnimalSizeEnumFieldUpdateOperationsInput>;
  stats?: InputMaybe<AnimalStatUpdateOneWithoutAnimalNestedInput>;
  statsId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  sterilized?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  studInfos?: InputMaybe<StudInfoUpdateOneWithoutAnimalNestedInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<EnumAnimalTypeEnumFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  weight?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type AnimalUpdateWithoutBookingAnimalsInput = {
  adopted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  adoptionDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  application?: InputMaybe<DogBreederApplicationUpdateOneWithoutAnimalNestedInput>;
  archived?: InputMaybe<BoolFieldUpdateOperationsInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  birthdayType?: InputMaybe<NullableEnumBirthdayTypeFieldUpdateOperationsInput>;
  birthedLitters?: InputMaybe<LitterParentUpdateManyWithoutParentNestedInput>;
  bookings?: InputMaybe<BookingUpdateManyWithoutAnimalNestedInput>;
  calved?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dogInfos?: InputMaybe<DogInfoUpdateOneWithoutAnimalNestedInput>;
  dogShelter?: InputMaybe<DogShelterUpdateOneWithoutAnimalsNestedInput>;
  gender?: InputMaybe<NullableEnumGenderEnumFieldUpdateOperationsInput>;
  imgs?: InputMaybe<AnimalImgUpdateManyWithoutAnimalNestedInput>;
  litter?: InputMaybe<LitterUpdateOneWithoutAnimalsBornNestedInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  neutered?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  owner?: InputMaybe<AccountUpdateOneWithoutAnimalsNestedInput>;
  passportFile?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  size?: InputMaybe<NullableEnumAnimalSizeEnumFieldUpdateOperationsInput>;
  stats?: InputMaybe<AnimalStatUpdateOneWithoutAnimalNestedInput>;
  statsId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  sterilized?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  studInfos?: InputMaybe<StudInfoUpdateOneWithoutAnimalNestedInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<EnumAnimalTypeEnumFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  weight?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type AnimalUpdateWithoutBookingsInput = {
  adopted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  adoptionDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  application?: InputMaybe<DogBreederApplicationUpdateOneWithoutAnimalNestedInput>;
  archived?: InputMaybe<BoolFieldUpdateOperationsInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  birthdayType?: InputMaybe<NullableEnumBirthdayTypeFieldUpdateOperationsInput>;
  birthedLitters?: InputMaybe<LitterParentUpdateManyWithoutParentNestedInput>;
  bookingAnimals?: InputMaybe<BookingAnimalUpdateManyWithoutAnimalNestedInput>;
  calved?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dogInfos?: InputMaybe<DogInfoUpdateOneWithoutAnimalNestedInput>;
  dogShelter?: InputMaybe<DogShelterUpdateOneWithoutAnimalsNestedInput>;
  gender?: InputMaybe<NullableEnumGenderEnumFieldUpdateOperationsInput>;
  imgs?: InputMaybe<AnimalImgUpdateManyWithoutAnimalNestedInput>;
  litter?: InputMaybe<LitterUpdateOneWithoutAnimalsBornNestedInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  neutered?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  owner?: InputMaybe<AccountUpdateOneWithoutAnimalsNestedInput>;
  passportFile?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  size?: InputMaybe<NullableEnumAnimalSizeEnumFieldUpdateOperationsInput>;
  stats?: InputMaybe<AnimalStatUpdateOneWithoutAnimalNestedInput>;
  statsId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  sterilized?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  studInfos?: InputMaybe<StudInfoUpdateOneWithoutAnimalNestedInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<EnumAnimalTypeEnumFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  weight?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type AnimalUpdateWithoutDogInfosInput = {
  adopted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  adoptionDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  application?: InputMaybe<DogBreederApplicationUpdateOneWithoutAnimalNestedInput>;
  archived?: InputMaybe<BoolFieldUpdateOperationsInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  birthdayType?: InputMaybe<NullableEnumBirthdayTypeFieldUpdateOperationsInput>;
  birthedLitters?: InputMaybe<LitterParentUpdateManyWithoutParentNestedInput>;
  bookingAnimals?: InputMaybe<BookingAnimalUpdateManyWithoutAnimalNestedInput>;
  bookings?: InputMaybe<BookingUpdateManyWithoutAnimalNestedInput>;
  calved?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dogShelter?: InputMaybe<DogShelterUpdateOneWithoutAnimalsNestedInput>;
  gender?: InputMaybe<NullableEnumGenderEnumFieldUpdateOperationsInput>;
  imgs?: InputMaybe<AnimalImgUpdateManyWithoutAnimalNestedInput>;
  litter?: InputMaybe<LitterUpdateOneWithoutAnimalsBornNestedInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  neutered?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  owner?: InputMaybe<AccountUpdateOneWithoutAnimalsNestedInput>;
  passportFile?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  size?: InputMaybe<NullableEnumAnimalSizeEnumFieldUpdateOperationsInput>;
  stats?: InputMaybe<AnimalStatUpdateOneWithoutAnimalNestedInput>;
  statsId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  sterilized?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  studInfos?: InputMaybe<StudInfoUpdateOneWithoutAnimalNestedInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<EnumAnimalTypeEnumFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  weight?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type AnimalUpdateWithoutDogShelterInput = {
  adopted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  adoptionDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  application?: InputMaybe<DogBreederApplicationUpdateOneWithoutAnimalNestedInput>;
  archived?: InputMaybe<BoolFieldUpdateOperationsInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  birthdayType?: InputMaybe<NullableEnumBirthdayTypeFieldUpdateOperationsInput>;
  birthedLitters?: InputMaybe<LitterParentUpdateManyWithoutParentNestedInput>;
  bookingAnimals?: InputMaybe<BookingAnimalUpdateManyWithoutAnimalNestedInput>;
  bookings?: InputMaybe<BookingUpdateManyWithoutAnimalNestedInput>;
  calved?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dogInfos?: InputMaybe<DogInfoUpdateOneWithoutAnimalNestedInput>;
  gender?: InputMaybe<NullableEnumGenderEnumFieldUpdateOperationsInput>;
  imgs?: InputMaybe<AnimalImgUpdateManyWithoutAnimalNestedInput>;
  litter?: InputMaybe<LitterUpdateOneWithoutAnimalsBornNestedInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  neutered?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  owner?: InputMaybe<AccountUpdateOneWithoutAnimalsNestedInput>;
  passportFile?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  size?: InputMaybe<NullableEnumAnimalSizeEnumFieldUpdateOperationsInput>;
  stats?: InputMaybe<AnimalStatUpdateOneWithoutAnimalNestedInput>;
  statsId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  sterilized?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  studInfos?: InputMaybe<StudInfoUpdateOneWithoutAnimalNestedInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<EnumAnimalTypeEnumFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  weight?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type AnimalUpdateWithoutImgsInput = {
  adopted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  adoptionDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  application?: InputMaybe<DogBreederApplicationUpdateOneWithoutAnimalNestedInput>;
  archived?: InputMaybe<BoolFieldUpdateOperationsInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  birthdayType?: InputMaybe<NullableEnumBirthdayTypeFieldUpdateOperationsInput>;
  birthedLitters?: InputMaybe<LitterParentUpdateManyWithoutParentNestedInput>;
  bookingAnimals?: InputMaybe<BookingAnimalUpdateManyWithoutAnimalNestedInput>;
  bookings?: InputMaybe<BookingUpdateManyWithoutAnimalNestedInput>;
  calved?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dogInfos?: InputMaybe<DogInfoUpdateOneWithoutAnimalNestedInput>;
  dogShelter?: InputMaybe<DogShelterUpdateOneWithoutAnimalsNestedInput>;
  gender?: InputMaybe<NullableEnumGenderEnumFieldUpdateOperationsInput>;
  litter?: InputMaybe<LitterUpdateOneWithoutAnimalsBornNestedInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  neutered?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  owner?: InputMaybe<AccountUpdateOneWithoutAnimalsNestedInput>;
  passportFile?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  size?: InputMaybe<NullableEnumAnimalSizeEnumFieldUpdateOperationsInput>;
  stats?: InputMaybe<AnimalStatUpdateOneWithoutAnimalNestedInput>;
  statsId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  sterilized?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  studInfos?: InputMaybe<StudInfoUpdateOneWithoutAnimalNestedInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<EnumAnimalTypeEnumFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  weight?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type AnimalUpdateWithoutLitterInput = {
  adopted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  adoptionDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  application?: InputMaybe<DogBreederApplicationUpdateOneWithoutAnimalNestedInput>;
  archived?: InputMaybe<BoolFieldUpdateOperationsInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  birthdayType?: InputMaybe<NullableEnumBirthdayTypeFieldUpdateOperationsInput>;
  birthedLitters?: InputMaybe<LitterParentUpdateManyWithoutParentNestedInput>;
  bookingAnimals?: InputMaybe<BookingAnimalUpdateManyWithoutAnimalNestedInput>;
  bookings?: InputMaybe<BookingUpdateManyWithoutAnimalNestedInput>;
  calved?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dogInfos?: InputMaybe<DogInfoUpdateOneWithoutAnimalNestedInput>;
  dogShelter?: InputMaybe<DogShelterUpdateOneWithoutAnimalsNestedInput>;
  gender?: InputMaybe<NullableEnumGenderEnumFieldUpdateOperationsInput>;
  imgs?: InputMaybe<AnimalImgUpdateManyWithoutAnimalNestedInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  neutered?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  owner?: InputMaybe<AccountUpdateOneWithoutAnimalsNestedInput>;
  passportFile?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  size?: InputMaybe<NullableEnumAnimalSizeEnumFieldUpdateOperationsInput>;
  stats?: InputMaybe<AnimalStatUpdateOneWithoutAnimalNestedInput>;
  statsId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  sterilized?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  studInfos?: InputMaybe<StudInfoUpdateOneWithoutAnimalNestedInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<EnumAnimalTypeEnumFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  weight?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type AnimalUpdateWithoutOwnerInput = {
  adopted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  adoptionDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  application?: InputMaybe<DogBreederApplicationUpdateOneWithoutAnimalNestedInput>;
  archived?: InputMaybe<BoolFieldUpdateOperationsInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  birthdayType?: InputMaybe<NullableEnumBirthdayTypeFieldUpdateOperationsInput>;
  birthedLitters?: InputMaybe<LitterParentUpdateManyWithoutParentNestedInput>;
  bookingAnimals?: InputMaybe<BookingAnimalUpdateManyWithoutAnimalNestedInput>;
  bookings?: InputMaybe<BookingUpdateManyWithoutAnimalNestedInput>;
  calved?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dogInfos?: InputMaybe<DogInfoUpdateOneWithoutAnimalNestedInput>;
  dogShelter?: InputMaybe<DogShelterUpdateOneWithoutAnimalsNestedInput>;
  gender?: InputMaybe<NullableEnumGenderEnumFieldUpdateOperationsInput>;
  imgs?: InputMaybe<AnimalImgUpdateManyWithoutAnimalNestedInput>;
  litter?: InputMaybe<LitterUpdateOneWithoutAnimalsBornNestedInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  neutered?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  passportFile?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  size?: InputMaybe<NullableEnumAnimalSizeEnumFieldUpdateOperationsInput>;
  stats?: InputMaybe<AnimalStatUpdateOneWithoutAnimalNestedInput>;
  statsId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  sterilized?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  studInfos?: InputMaybe<StudInfoUpdateOneWithoutAnimalNestedInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<EnumAnimalTypeEnumFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  weight?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type AnimalUpdateWithoutStatsInput = {
  adopted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  adoptionDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  application?: InputMaybe<DogBreederApplicationUpdateOneWithoutAnimalNestedInput>;
  archived?: InputMaybe<BoolFieldUpdateOperationsInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  birthdayType?: InputMaybe<NullableEnumBirthdayTypeFieldUpdateOperationsInput>;
  birthedLitters?: InputMaybe<LitterParentUpdateManyWithoutParentNestedInput>;
  bookingAnimals?: InputMaybe<BookingAnimalUpdateManyWithoutAnimalNestedInput>;
  bookings?: InputMaybe<BookingUpdateManyWithoutAnimalNestedInput>;
  calved?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dogInfos?: InputMaybe<DogInfoUpdateOneWithoutAnimalNestedInput>;
  dogShelter?: InputMaybe<DogShelterUpdateOneWithoutAnimalsNestedInput>;
  gender?: InputMaybe<NullableEnumGenderEnumFieldUpdateOperationsInput>;
  imgs?: InputMaybe<AnimalImgUpdateManyWithoutAnimalNestedInput>;
  litter?: InputMaybe<LitterUpdateOneWithoutAnimalsBornNestedInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  neutered?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  owner?: InputMaybe<AccountUpdateOneWithoutAnimalsNestedInput>;
  passportFile?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  size?: InputMaybe<NullableEnumAnimalSizeEnumFieldUpdateOperationsInput>;
  statsId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  sterilized?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  studInfos?: InputMaybe<StudInfoUpdateOneWithoutAnimalNestedInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<EnumAnimalTypeEnumFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  weight?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type AnimalUpdateWithoutStudInfosInput = {
  adopted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  adoptionDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  application?: InputMaybe<DogBreederApplicationUpdateOneWithoutAnimalNestedInput>;
  archived?: InputMaybe<BoolFieldUpdateOperationsInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  birthdayType?: InputMaybe<NullableEnumBirthdayTypeFieldUpdateOperationsInput>;
  birthedLitters?: InputMaybe<LitterParentUpdateManyWithoutParentNestedInput>;
  bookingAnimals?: InputMaybe<BookingAnimalUpdateManyWithoutAnimalNestedInput>;
  bookings?: InputMaybe<BookingUpdateManyWithoutAnimalNestedInput>;
  calved?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dogInfos?: InputMaybe<DogInfoUpdateOneWithoutAnimalNestedInput>;
  dogShelter?: InputMaybe<DogShelterUpdateOneWithoutAnimalsNestedInput>;
  gender?: InputMaybe<NullableEnumGenderEnumFieldUpdateOperationsInput>;
  imgs?: InputMaybe<AnimalImgUpdateManyWithoutAnimalNestedInput>;
  litter?: InputMaybe<LitterUpdateOneWithoutAnimalsBornNestedInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  neutered?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  owner?: InputMaybe<AccountUpdateOneWithoutAnimalsNestedInput>;
  passportFile?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  size?: InputMaybe<NullableEnumAnimalSizeEnumFieldUpdateOperationsInput>;
  stats?: InputMaybe<AnimalStatUpdateOneWithoutAnimalNestedInput>;
  statsId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  sterilized?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<EnumAnimalTypeEnumFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  weight?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type AnimalUpdatetagsInput = {
  push?: InputMaybe<Array<Scalars['String']['input']>>;
  set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type AnimalUpsertWithWhereUniqueWithoutDogShelterInput = {
  create: AnimalCreateWithoutDogShelterInput;
  update: AnimalUpdateWithoutDogShelterInput;
  where: AnimalWhereUniqueInput;
};

export type AnimalUpsertWithWhereUniqueWithoutLitterInput = {
  create: AnimalCreateWithoutLitterInput;
  update: AnimalUpdateWithoutLitterInput;
  where: AnimalWhereUniqueInput;
};

export type AnimalUpsertWithWhereUniqueWithoutOwnerInput = {
  create: AnimalCreateWithoutOwnerInput;
  update: AnimalUpdateWithoutOwnerInput;
  where: AnimalWhereUniqueInput;
};

export type AnimalUpsertWithoutApplicationInput = {
  create: AnimalCreateWithoutApplicationInput;
  update: AnimalUpdateWithoutApplicationInput;
  where?: InputMaybe<AnimalWhereInput>;
};

export type AnimalUpsertWithoutBirthedLittersInput = {
  create: AnimalCreateWithoutBirthedLittersInput;
  update: AnimalUpdateWithoutBirthedLittersInput;
  where?: InputMaybe<AnimalWhereInput>;
};

export type AnimalUpsertWithoutBookingAnimalsInput = {
  create: AnimalCreateWithoutBookingAnimalsInput;
  update: AnimalUpdateWithoutBookingAnimalsInput;
  where?: InputMaybe<AnimalWhereInput>;
};

export type AnimalUpsertWithoutBookingsInput = {
  create: AnimalCreateWithoutBookingsInput;
  update: AnimalUpdateWithoutBookingsInput;
  where?: InputMaybe<AnimalWhereInput>;
};

export type AnimalUpsertWithoutDogInfosInput = {
  create: AnimalCreateWithoutDogInfosInput;
  update: AnimalUpdateWithoutDogInfosInput;
  where?: InputMaybe<AnimalWhereInput>;
};

export type AnimalUpsertWithoutImgsInput = {
  create: AnimalCreateWithoutImgsInput;
  update: AnimalUpdateWithoutImgsInput;
  where?: InputMaybe<AnimalWhereInput>;
};

export type AnimalUpsertWithoutStatsInput = {
  create: AnimalCreateWithoutStatsInput;
  update: AnimalUpdateWithoutStatsInput;
  where?: InputMaybe<AnimalWhereInput>;
};

export type AnimalUpsertWithoutStudInfosInput = {
  create: AnimalCreateWithoutStudInfosInput;
  update: AnimalUpdateWithoutStudInfosInput;
  where?: InputMaybe<AnimalWhereInput>;
};

export type AnimalWhereInput = {
  AND?: InputMaybe<Array<AnimalWhereInput>>;
  NOT?: InputMaybe<Array<AnimalWhereInput>>;
  OR?: InputMaybe<Array<AnimalWhereInput>>;
  adopted?: InputMaybe<BoolNullableFilter>;
  adoptionDate?: InputMaybe<DateTimeNullableFilter>;
  application?: InputMaybe<DogBreederApplicationNullableRelationFilter>;
  archived?: InputMaybe<BoolFilter>;
  birthday?: InputMaybe<DateTimeNullableFilter>;
  birthdayType?: InputMaybe<EnumBirthdayTypeNullableFilter>;
  birthedLitters?: InputMaybe<LitterParentListRelationFilter>;
  bookingAnimals?: InputMaybe<BookingAnimalListRelationFilter>;
  bookings?: InputMaybe<BookingListRelationFilter>;
  calved?: InputMaybe<BoolNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  dogInfos?: InputMaybe<DogInfoNullableRelationFilter>;
  dogShelter?: InputMaybe<DogShelterNullableRelationFilter>;
  dogShelterId?: InputMaybe<IntNullableFilter>;
  gender?: InputMaybe<EnumGenderEnumNullableFilter>;
  id?: InputMaybe<IntFilter>;
  imgs?: InputMaybe<AnimalImgListRelationFilter>;
  litter?: InputMaybe<LitterNullableRelationFilter>;
  litterId?: InputMaybe<IntNullableFilter>;
  name?: InputMaybe<StringNullableFilter>;
  neutered?: InputMaybe<BoolNullableFilter>;
  owner?: InputMaybe<AccountNullableRelationFilter>;
  ownerId?: InputMaybe<IntNullableFilter>;
  passportFile?: InputMaybe<StringNullableFilter>;
  size?: InputMaybe<EnumAnimalSizeEnumNullableFilter>;
  stats?: InputMaybe<AnimalStatNullableRelationFilter>;
  statsId?: InputMaybe<IntNullableFilter>;
  sterilized?: InputMaybe<BoolNullableFilter>;
  studInfos?: InputMaybe<StudInfoNullableRelationFilter>;
  tags?: InputMaybe<StringNullableListFilter>;
  type?: InputMaybe<EnumAnimalTypeEnumFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  weight?: InputMaybe<IntNullableFilter>;
};

export type AnimalWhereUniqueInput = {
  AND?: InputMaybe<Array<AnimalWhereInput>>;
  NOT?: InputMaybe<Array<AnimalWhereInput>>;
  OR?: InputMaybe<Array<AnimalWhereInput>>;
  adopted?: InputMaybe<BoolNullableFilter>;
  adoptionDate?: InputMaybe<DateTimeNullableFilter>;
  application?: InputMaybe<DogBreederApplicationNullableRelationFilter>;
  archived?: InputMaybe<BoolFilter>;
  birthday?: InputMaybe<DateTimeNullableFilter>;
  birthdayType?: InputMaybe<EnumBirthdayTypeNullableFilter>;
  birthedLitters?: InputMaybe<LitterParentListRelationFilter>;
  bookingAnimals?: InputMaybe<BookingAnimalListRelationFilter>;
  bookings?: InputMaybe<BookingListRelationFilter>;
  calved?: InputMaybe<BoolNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  dogInfos?: InputMaybe<DogInfoNullableRelationFilter>;
  dogShelter?: InputMaybe<DogShelterNullableRelationFilter>;
  dogShelterId?: InputMaybe<IntNullableFilter>;
  gender?: InputMaybe<EnumGenderEnumNullableFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  imgs?: InputMaybe<AnimalImgListRelationFilter>;
  litter?: InputMaybe<LitterNullableRelationFilter>;
  litterId?: InputMaybe<IntNullableFilter>;
  name?: InputMaybe<StringNullableFilter>;
  neutered?: InputMaybe<BoolNullableFilter>;
  owner?: InputMaybe<AccountNullableRelationFilter>;
  ownerId?: InputMaybe<IntNullableFilter>;
  passportFile?: InputMaybe<StringNullableFilter>;
  size?: InputMaybe<EnumAnimalSizeEnumNullableFilter>;
  stats?: InputMaybe<AnimalStatNullableRelationFilter>;
  statsId?: InputMaybe<IntNullableFilter>;
  sterilized?: InputMaybe<BoolNullableFilter>;
  studInfos?: InputMaybe<StudInfoNullableRelationFilter>;
  tags?: InputMaybe<StringNullableListFilter>;
  type?: InputMaybe<EnumAnimalTypeEnumFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  weight?: InputMaybe<IntNullableFilter>;
};

export type Announcement = {
  __typename?: 'Announcement';
  countries: Array<CountryCode>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  published: Scalars['Boolean']['output'];
  translations: Array<AnnouncementTranslation>;
  updatedAt: Scalars['DateTime']['output'];
};


export type AnnouncementtranslationsArgs = {
  cursor?: InputMaybe<AnnouncementTranslationWhereUniqueInput>;
  distinct?: InputMaybe<AnnouncementTranslationScalarFieldEnum>;
  orderBy?: InputMaybe<AnnouncementTranslationOrderByWithRelationAndSearchRelevanceInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AnnouncementTranslationWhereInput>;
};

export type AnnouncementAvgAggregateOutputType = {
  __typename?: 'AnnouncementAvgAggregateOutputType';
  id?: Maybe<Scalars['Float']['output']>;
};

export type AnnouncementAvgOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
};

export type AnnouncementCountAggregateOutputType = {
  __typename?: 'AnnouncementCountAggregateOutputType';
  _all: Scalars['Int']['output'];
  countries: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  published: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type AnnouncementCountOrderByAggregateInput = {
  countries?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  published?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type AnnouncementCountOutputType = {
  __typename?: 'AnnouncementCountOutputType';
  translations: Scalars['Int']['output'];
};

export type AnnouncementCreateInput = {
  countries?: InputMaybe<Array<CountryCode>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  translations?: InputMaybe<AnnouncementTranslationCreateNestedManyWithoutAnnouncementInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AnnouncementCreateManyInput = {
  countries?: InputMaybe<Array<CountryCode>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AnnouncementCreateNestedOneWithoutTranslationsInput = {
  connect?: InputMaybe<AnnouncementWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AnnouncementCreateOrConnectWithoutTranslationsInput>;
  create?: InputMaybe<AnnouncementCreateWithoutTranslationsInput>;
};

export type AnnouncementCreateOrConnectWithoutTranslationsInput = {
  create: AnnouncementCreateWithoutTranslationsInput;
  where: AnnouncementWhereUniqueInput;
};

export type AnnouncementCreateWithoutTranslationsInput = {
  countries?: InputMaybe<Array<CountryCode>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AnnouncementCreatecountriesInput = {
  set: Array<CountryCode>;
};

export type AnnouncementMaxAggregateOutputType = {
  __typename?: 'AnnouncementMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  published?: Maybe<Scalars['Boolean']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type AnnouncementMaxOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  published?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type AnnouncementMinAggregateOutputType = {
  __typename?: 'AnnouncementMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  published?: Maybe<Scalars['Boolean']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type AnnouncementMinOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  published?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type AnnouncementOrderByWithAggregationInput = {
  _avg?: InputMaybe<AnnouncementAvgOrderByAggregateInput>;
  _count?: InputMaybe<AnnouncementCountOrderByAggregateInput>;
  _max?: InputMaybe<AnnouncementMaxOrderByAggregateInput>;
  _min?: InputMaybe<AnnouncementMinOrderByAggregateInput>;
  _sum?: InputMaybe<AnnouncementSumOrderByAggregateInput>;
  countries?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  published?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type AnnouncementOrderByWithRelationAndSearchRelevanceInput = {
  countries?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  published?: InputMaybe<SortOrder>;
  translations?: InputMaybe<AnnouncementTranslationOrderByRelationAggregateInput>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type AnnouncementRelationFilter = {
  is?: InputMaybe<AnnouncementWhereInput>;
  isNot?: InputMaybe<AnnouncementWhereInput>;
};

export enum AnnouncementScalarFieldEnum {
  countries = 'countries',
  createdAt = 'createdAt',
  id = 'id',
  published = 'published',
  updatedAt = 'updatedAt'
}

export type AnnouncementScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<AnnouncementScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<AnnouncementScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<AnnouncementScalarWhereWithAggregatesInput>>;
  countries?: InputMaybe<EnumCountryCodeNullableListFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  published?: InputMaybe<BoolWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type AnnouncementSumAggregateOutputType = {
  __typename?: 'AnnouncementSumAggregateOutputType';
  id?: Maybe<Scalars['Int']['output']>;
};

export type AnnouncementSumOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
};

export type AnnouncementTranslation = {
  __typename?: 'AnnouncementTranslation';
  content?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  language: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type AnnouncementTranslationAvgAggregateOutputType = {
  __typename?: 'AnnouncementTranslationAvgAggregateOutputType';
  announcementId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

export type AnnouncementTranslationAvgOrderByAggregateInput = {
  announcementId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export type AnnouncementTranslationCountAggregateOutputType = {
  __typename?: 'AnnouncementTranslationCountAggregateOutputType';
  _all: Scalars['Int']['output'];
  announcementId: Scalars['Int']['output'];
  content: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  language: Scalars['Int']['output'];
  title: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type AnnouncementTranslationCountOrderByAggregateInput = {
  announcementId?: InputMaybe<SortOrder>;
  content?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  language?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type AnnouncementTranslationCreateInput = {
  announcement: AnnouncementCreateNestedOneWithoutTranslationsInput;
  content?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  language: Scalars['String']['input'];
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AnnouncementTranslationCreateManyAnnouncementInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  language: Scalars['String']['input'];
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AnnouncementTranslationCreateManyAnnouncementInputEnvelope = {
  data: Array<AnnouncementTranslationCreateManyAnnouncementInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AnnouncementTranslationCreateManyInput = {
  announcementId: Scalars['Int']['input'];
  content?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  language: Scalars['String']['input'];
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AnnouncementTranslationCreateNestedManyWithoutAnnouncementInput = {
  connect?: InputMaybe<Array<AnnouncementTranslationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AnnouncementTranslationCreateOrConnectWithoutAnnouncementInput>>;
  create?: InputMaybe<Array<AnnouncementTranslationCreateWithoutAnnouncementInput>>;
  createMany?: InputMaybe<AnnouncementTranslationCreateManyAnnouncementInputEnvelope>;
};

export type AnnouncementTranslationCreateOrConnectWithoutAnnouncementInput = {
  create: AnnouncementTranslationCreateWithoutAnnouncementInput;
  where: AnnouncementTranslationWhereUniqueInput;
};

export type AnnouncementTranslationCreateWithoutAnnouncementInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  language: Scalars['String']['input'];
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AnnouncementTranslationListRelationFilter = {
  every?: InputMaybe<AnnouncementTranslationWhereInput>;
  none?: InputMaybe<AnnouncementTranslationWhereInput>;
  some?: InputMaybe<AnnouncementTranslationWhereInput>;
};

export type AnnouncementTranslationMaxAggregateOutputType = {
  __typename?: 'AnnouncementTranslationMaxAggregateOutputType';
  announcementId?: Maybe<Scalars['Int']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type AnnouncementTranslationMaxOrderByAggregateInput = {
  announcementId?: InputMaybe<SortOrder>;
  content?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  language?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type AnnouncementTranslationMinAggregateOutputType = {
  __typename?: 'AnnouncementTranslationMinAggregateOutputType';
  announcementId?: Maybe<Scalars['Int']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type AnnouncementTranslationMinOrderByAggregateInput = {
  announcementId?: InputMaybe<SortOrder>;
  content?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  language?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type AnnouncementTranslationOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export enum AnnouncementTranslationOrderByRelevanceFieldEnum {
  content = 'content',
  language = 'language',
  title = 'title'
}

export type AnnouncementTranslationOrderByRelevanceInput = {
  fields: Array<AnnouncementTranslationOrderByRelevanceFieldEnum>;
  search: Scalars['String']['input'];
  sort: SortOrder;
};

export type AnnouncementTranslationOrderByWithAggregationInput = {
  _avg?: InputMaybe<AnnouncementTranslationAvgOrderByAggregateInput>;
  _count?: InputMaybe<AnnouncementTranslationCountOrderByAggregateInput>;
  _max?: InputMaybe<AnnouncementTranslationMaxOrderByAggregateInput>;
  _min?: InputMaybe<AnnouncementTranslationMinOrderByAggregateInput>;
  _sum?: InputMaybe<AnnouncementTranslationSumOrderByAggregateInput>;
  announcementId?: InputMaybe<SortOrder>;
  content?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  language?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type AnnouncementTranslationOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: InputMaybe<AnnouncementTranslationOrderByRelevanceInput>;
  announcement?: InputMaybe<AnnouncementOrderByWithRelationAndSearchRelevanceInput>;
  announcementId?: InputMaybe<SortOrder>;
  content?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  language?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum AnnouncementTranslationScalarFieldEnum {
  announcementId = 'announcementId',
  content = 'content',
  createdAt = 'createdAt',
  id = 'id',
  language = 'language',
  title = 'title',
  updatedAt = 'updatedAt'
}

export type AnnouncementTranslationScalarWhereInput = {
  AND?: InputMaybe<Array<AnnouncementTranslationScalarWhereInput>>;
  NOT?: InputMaybe<Array<AnnouncementTranslationScalarWhereInput>>;
  OR?: InputMaybe<Array<AnnouncementTranslationScalarWhereInput>>;
  announcementId?: InputMaybe<IntFilter>;
  content?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntFilter>;
  language?: InputMaybe<StringFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type AnnouncementTranslationScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<AnnouncementTranslationScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<AnnouncementTranslationScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<AnnouncementTranslationScalarWhereWithAggregatesInput>>;
  announcementId?: InputMaybe<IntWithAggregatesFilter>;
  content?: InputMaybe<StringNullableWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  language?: InputMaybe<StringWithAggregatesFilter>;
  title?: InputMaybe<StringWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type AnnouncementTranslationSumAggregateOutputType = {
  __typename?: 'AnnouncementTranslationSumAggregateOutputType';
  announcementId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
};

export type AnnouncementTranslationSumOrderByAggregateInput = {
  announcementId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export type AnnouncementTranslationUncheckedCreateInput = {
  announcementId: Scalars['Int']['input'];
  content?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  language: Scalars['String']['input'];
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AnnouncementTranslationUncheckedCreateNestedManyWithoutAnnouncementInput = {
  connect?: InputMaybe<Array<AnnouncementTranslationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AnnouncementTranslationCreateOrConnectWithoutAnnouncementInput>>;
  create?: InputMaybe<Array<AnnouncementTranslationCreateWithoutAnnouncementInput>>;
  createMany?: InputMaybe<AnnouncementTranslationCreateManyAnnouncementInputEnvelope>;
};

export type AnnouncementTranslationUncheckedCreateWithoutAnnouncementInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  language: Scalars['String']['input'];
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AnnouncementTranslationUncheckedUpdateInput = {
  announcementId?: InputMaybe<IntFieldUpdateOperationsInput>;
  content?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type AnnouncementTranslationUncheckedUpdateManyInput = {
  announcementId?: InputMaybe<IntFieldUpdateOperationsInput>;
  content?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type AnnouncementTranslationUncheckedUpdateManyWithoutAnnouncementInput = {
  content?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type AnnouncementTranslationUncheckedUpdateManyWithoutAnnouncementNestedInput = {
  connect?: InputMaybe<Array<AnnouncementTranslationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AnnouncementTranslationCreateOrConnectWithoutAnnouncementInput>>;
  create?: InputMaybe<Array<AnnouncementTranslationCreateWithoutAnnouncementInput>>;
  createMany?: InputMaybe<AnnouncementTranslationCreateManyAnnouncementInputEnvelope>;
  delete?: InputMaybe<Array<AnnouncementTranslationWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<AnnouncementTranslationScalarWhereInput>>;
  disconnect?: InputMaybe<Array<AnnouncementTranslationWhereUniqueInput>>;
  set?: InputMaybe<Array<AnnouncementTranslationWhereUniqueInput>>;
  update?: InputMaybe<Array<AnnouncementTranslationUpdateWithWhereUniqueWithoutAnnouncementInput>>;
  updateMany?: InputMaybe<Array<AnnouncementTranslationUpdateManyWithWhereWithoutAnnouncementInput>>;
  upsert?: InputMaybe<Array<AnnouncementTranslationUpsertWithWhereUniqueWithoutAnnouncementInput>>;
};

export type AnnouncementTranslationUncheckedUpdateWithoutAnnouncementInput = {
  content?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type AnnouncementTranslationUpdateInput = {
  announcement?: InputMaybe<AnnouncementUpdateOneRequiredWithoutTranslationsNestedInput>;
  content?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type AnnouncementTranslationUpdateManyMutationInput = {
  content?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type AnnouncementTranslationUpdateManyWithWhereWithoutAnnouncementInput = {
  data: AnnouncementTranslationUpdateManyMutationInput;
  where: AnnouncementTranslationScalarWhereInput;
};

export type AnnouncementTranslationUpdateManyWithoutAnnouncementNestedInput = {
  connect?: InputMaybe<Array<AnnouncementTranslationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AnnouncementTranslationCreateOrConnectWithoutAnnouncementInput>>;
  create?: InputMaybe<Array<AnnouncementTranslationCreateWithoutAnnouncementInput>>;
  createMany?: InputMaybe<AnnouncementTranslationCreateManyAnnouncementInputEnvelope>;
  delete?: InputMaybe<Array<AnnouncementTranslationWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<AnnouncementTranslationScalarWhereInput>>;
  disconnect?: InputMaybe<Array<AnnouncementTranslationWhereUniqueInput>>;
  set?: InputMaybe<Array<AnnouncementTranslationWhereUniqueInput>>;
  update?: InputMaybe<Array<AnnouncementTranslationUpdateWithWhereUniqueWithoutAnnouncementInput>>;
  updateMany?: InputMaybe<Array<AnnouncementTranslationUpdateManyWithWhereWithoutAnnouncementInput>>;
  upsert?: InputMaybe<Array<AnnouncementTranslationUpsertWithWhereUniqueWithoutAnnouncementInput>>;
};

export type AnnouncementTranslationUpdateWithWhereUniqueWithoutAnnouncementInput = {
  data: AnnouncementTranslationUpdateWithoutAnnouncementInput;
  where: AnnouncementTranslationWhereUniqueInput;
};

export type AnnouncementTranslationUpdateWithoutAnnouncementInput = {
  content?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type AnnouncementTranslationUpsertWithWhereUniqueWithoutAnnouncementInput = {
  create: AnnouncementTranslationCreateWithoutAnnouncementInput;
  update: AnnouncementTranslationUpdateWithoutAnnouncementInput;
  where: AnnouncementTranslationWhereUniqueInput;
};

export type AnnouncementTranslationWhereInput = {
  AND?: InputMaybe<Array<AnnouncementTranslationWhereInput>>;
  NOT?: InputMaybe<Array<AnnouncementTranslationWhereInput>>;
  OR?: InputMaybe<Array<AnnouncementTranslationWhereInput>>;
  announcement?: InputMaybe<AnnouncementRelationFilter>;
  announcementId?: InputMaybe<IntFilter>;
  content?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntFilter>;
  language?: InputMaybe<StringFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type AnnouncementTranslationWhereUniqueInput = {
  AND?: InputMaybe<Array<AnnouncementTranslationWhereInput>>;
  NOT?: InputMaybe<Array<AnnouncementTranslationWhereInput>>;
  OR?: InputMaybe<Array<AnnouncementTranslationWhereInput>>;
  announcement?: InputMaybe<AnnouncementRelationFilter>;
  announcementId?: InputMaybe<IntFilter>;
  content?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  language?: InputMaybe<StringFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type AnnouncementUncheckedCreateInput = {
  countries?: InputMaybe<Array<CountryCode>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  translations?: InputMaybe<AnnouncementTranslationUncheckedCreateNestedManyWithoutAnnouncementInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AnnouncementUncheckedCreateWithoutTranslationsInput = {
  countries?: InputMaybe<Array<CountryCode>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AnnouncementUncheckedUpdateInput = {
  countries?: InputMaybe<Array<CountryCode>>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  published?: InputMaybe<BoolFieldUpdateOperationsInput>;
  translations?: InputMaybe<AnnouncementTranslationUncheckedUpdateManyWithoutAnnouncementNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type AnnouncementUncheckedUpdateManyInput = {
  countries?: InputMaybe<Array<CountryCode>>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  published?: InputMaybe<BoolFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type AnnouncementUncheckedUpdateWithoutTranslationsInput = {
  countries?: InputMaybe<Array<CountryCode>>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  published?: InputMaybe<BoolFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type AnnouncementUpdateInput = {
  countries?: InputMaybe<Array<CountryCode>>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  published?: InputMaybe<BoolFieldUpdateOperationsInput>;
  translations?: InputMaybe<AnnouncementTranslationUpdateManyWithoutAnnouncementNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type AnnouncementUpdateManyMutationInput = {
  countries?: InputMaybe<Array<CountryCode>>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  published?: InputMaybe<BoolFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type AnnouncementUpdateOneRequiredWithoutTranslationsNestedInput = {
  connect?: InputMaybe<AnnouncementWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AnnouncementCreateOrConnectWithoutTranslationsInput>;
  create?: InputMaybe<AnnouncementCreateWithoutTranslationsInput>;
  update?: InputMaybe<AnnouncementUpdateToOneWithWhereWithoutTranslationsInput>;
  upsert?: InputMaybe<AnnouncementUpsertWithoutTranslationsInput>;
};

export type AnnouncementUpdateToOneWithWhereWithoutTranslationsInput = {
  data: AnnouncementUpdateWithoutTranslationsInput;
  where?: InputMaybe<AnnouncementWhereInput>;
};

export type AnnouncementUpdateWithoutTranslationsInput = {
  countries?: InputMaybe<Array<CountryCode>>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  published?: InputMaybe<BoolFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type AnnouncementUpdatecountriesInput = {
  push?: InputMaybe<Array<CountryCode>>;
  set?: InputMaybe<Array<CountryCode>>;
};

export type AnnouncementUpsertWithoutTranslationsInput = {
  create: AnnouncementCreateWithoutTranslationsInput;
  update: AnnouncementUpdateWithoutTranslationsInput;
  where?: InputMaybe<AnnouncementWhereInput>;
};

export type AnnouncementWhereInput = {
  AND?: InputMaybe<Array<AnnouncementWhereInput>>;
  NOT?: InputMaybe<Array<AnnouncementWhereInput>>;
  OR?: InputMaybe<Array<AnnouncementWhereInput>>;
  countries?: InputMaybe<EnumCountryCodeNullableListFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntFilter>;
  published?: InputMaybe<BoolFilter>;
  translations?: InputMaybe<AnnouncementTranslationListRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type AnnouncementWhereUniqueInput = {
  AND?: InputMaybe<Array<AnnouncementWhereInput>>;
  NOT?: InputMaybe<Array<AnnouncementWhereInput>>;
  OR?: InputMaybe<Array<AnnouncementWhereInput>>;
  countries?: InputMaybe<EnumCountryCodeNullableListFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  published?: InputMaybe<BoolFilter>;
  translations?: InputMaybe<AnnouncementTranslationListRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type Article = {
  __typename?: 'Article';
  _count: ArticleCountOutputType;
  authorName?: Maybe<Scalars['String']['output']>;
  coverImg?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  published: Scalars['Boolean']['output'];
  reviewed: Scalars['Boolean']['output'];
  tags: Array<Scalars['String']['output']>;
  translations: Array<ArticleTranslations>;
  updatedAt: Scalars['DateTime']['output'];
};


export type ArticletranslationsArgs = {
  cursor?: InputMaybe<ArticleTranslationsWhereUniqueInput>;
  distinct?: InputMaybe<ArticleTranslationsScalarFieldEnum>;
  orderBy?: InputMaybe<ArticleTranslationsOrderByWithRelationAndSearchRelevanceInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ArticleTranslationsWhereInput>;
};

export type ArticleAvgAggregateOutputType = {
  __typename?: 'ArticleAvgAggregateOutputType';
  id?: Maybe<Scalars['Float']['output']>;
};

export type ArticleAvgOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
};

export type ArticleCountAggregateOutputType = {
  __typename?: 'ArticleCountAggregateOutputType';
  _all: Scalars['Int']['output'];
  authorName: Scalars['Int']['output'];
  coverImg: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  published: Scalars['Int']['output'];
  reviewed: Scalars['Int']['output'];
  tags: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type ArticleCountOrderByAggregateInput = {
  authorName?: InputMaybe<SortOrder>;
  coverImg?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  published?: InputMaybe<SortOrder>;
  reviewed?: InputMaybe<SortOrder>;
  tags?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ArticleCountOutputType = {
  __typename?: 'ArticleCountOutputType';
  images: Scalars['Int']['output'];
  translations: Scalars['Int']['output'];
};

export type ArticleCreateInput = {
  authorName?: InputMaybe<Scalars['String']['input']>;
  coverImg?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  images?: InputMaybe<ArticleImgCreateNestedManyWithoutArticleInput>;
  published: Scalars['Boolean']['input'];
  reviewed?: InputMaybe<Scalars['Boolean']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  translations?: InputMaybe<ArticleTranslationsCreateNestedManyWithoutArticleInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ArticleCreateManyInput = {
  authorName?: InputMaybe<Scalars['String']['input']>;
  coverImg?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  published: Scalars['Boolean']['input'];
  reviewed?: InputMaybe<Scalars['Boolean']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ArticleCreateNestedOneWithoutImagesInput = {
  connect?: InputMaybe<ArticleWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ArticleCreateOrConnectWithoutImagesInput>;
  create?: InputMaybe<ArticleCreateWithoutImagesInput>;
};

export type ArticleCreateNestedOneWithoutTranslationsInput = {
  connect?: InputMaybe<ArticleWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ArticleCreateOrConnectWithoutTranslationsInput>;
  create?: InputMaybe<ArticleCreateWithoutTranslationsInput>;
};

export type ArticleCreateOrConnectWithoutImagesInput = {
  create: ArticleCreateWithoutImagesInput;
  where: ArticleWhereUniqueInput;
};

export type ArticleCreateOrConnectWithoutTranslationsInput = {
  create: ArticleCreateWithoutTranslationsInput;
  where: ArticleWhereUniqueInput;
};

export type ArticleCreateWithoutImagesInput = {
  authorName?: InputMaybe<Scalars['String']['input']>;
  coverImg?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  published: Scalars['Boolean']['input'];
  reviewed?: InputMaybe<Scalars['Boolean']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  translations?: InputMaybe<ArticleTranslationsCreateNestedManyWithoutArticleInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ArticleCreateWithoutTranslationsInput = {
  authorName?: InputMaybe<Scalars['String']['input']>;
  coverImg?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  images?: InputMaybe<ArticleImgCreateNestedManyWithoutArticleInput>;
  published: Scalars['Boolean']['input'];
  reviewed?: InputMaybe<Scalars['Boolean']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ArticleCreatetagsInput = {
  set: Array<Scalars['String']['input']>;
};

export type ArticleImgAvgAggregateOutputType = {
  __typename?: 'ArticleImgAvgAggregateOutputType';
  articleId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

export type ArticleImgAvgOrderByAggregateInput = {
  articleId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export type ArticleImgCountAggregateOutputType = {
  __typename?: 'ArticleImgCountAggregateOutputType';
  _all: Scalars['Int']['output'];
  articleId: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  src: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type ArticleImgCountOrderByAggregateInput = {
  articleId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  src?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ArticleImgCreateInput = {
  article: ArticleCreateNestedOneWithoutImagesInput;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  src: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ArticleImgCreateManyArticleInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  src: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ArticleImgCreateManyArticleInputEnvelope = {
  data: Array<ArticleImgCreateManyArticleInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ArticleImgCreateManyInput = {
  articleId: Scalars['Int']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  src: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ArticleImgCreateNestedManyWithoutArticleInput = {
  connect?: InputMaybe<Array<ArticleImgWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ArticleImgCreateOrConnectWithoutArticleInput>>;
  create?: InputMaybe<Array<ArticleImgCreateWithoutArticleInput>>;
  createMany?: InputMaybe<ArticleImgCreateManyArticleInputEnvelope>;
};

export type ArticleImgCreateOrConnectWithoutArticleInput = {
  create: ArticleImgCreateWithoutArticleInput;
  where: ArticleImgWhereUniqueInput;
};

export type ArticleImgCreateWithoutArticleInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  src: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ArticleImgListRelationFilter = {
  every?: InputMaybe<ArticleImgWhereInput>;
  none?: InputMaybe<ArticleImgWhereInput>;
  some?: InputMaybe<ArticleImgWhereInput>;
};

export type ArticleImgMaxAggregateOutputType = {
  __typename?: 'ArticleImgMaxAggregateOutputType';
  articleId?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  src?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ArticleImgMaxOrderByAggregateInput = {
  articleId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  src?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ArticleImgMinAggregateOutputType = {
  __typename?: 'ArticleImgMinAggregateOutputType';
  articleId?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  src?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ArticleImgMinOrderByAggregateInput = {
  articleId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  src?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ArticleImgOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export enum ArticleImgOrderByRelevanceFieldEnum {
  src = 'src'
}

export type ArticleImgOrderByRelevanceInput = {
  fields: Array<ArticleImgOrderByRelevanceFieldEnum>;
  search: Scalars['String']['input'];
  sort: SortOrder;
};

export type ArticleImgOrderByWithAggregationInput = {
  _avg?: InputMaybe<ArticleImgAvgOrderByAggregateInput>;
  _count?: InputMaybe<ArticleImgCountOrderByAggregateInput>;
  _max?: InputMaybe<ArticleImgMaxOrderByAggregateInput>;
  _min?: InputMaybe<ArticleImgMinOrderByAggregateInput>;
  _sum?: InputMaybe<ArticleImgSumOrderByAggregateInput>;
  articleId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  src?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ArticleImgOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: InputMaybe<ArticleImgOrderByRelevanceInput>;
  article?: InputMaybe<ArticleOrderByWithRelationAndSearchRelevanceInput>;
  articleId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  src?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum ArticleImgScalarFieldEnum {
  articleId = 'articleId',
  createdAt = 'createdAt',
  id = 'id',
  src = 'src',
  updatedAt = 'updatedAt'
}

export type ArticleImgScalarWhereInput = {
  AND?: InputMaybe<Array<ArticleImgScalarWhereInput>>;
  NOT?: InputMaybe<Array<ArticleImgScalarWhereInput>>;
  OR?: InputMaybe<Array<ArticleImgScalarWhereInput>>;
  articleId?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntFilter>;
  src?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ArticleImgScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<ArticleImgScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<ArticleImgScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<ArticleImgScalarWhereWithAggregatesInput>>;
  articleId?: InputMaybe<IntWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  src?: InputMaybe<StringWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type ArticleImgSumAggregateOutputType = {
  __typename?: 'ArticleImgSumAggregateOutputType';
  articleId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
};

export type ArticleImgSumOrderByAggregateInput = {
  articleId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export type ArticleImgUncheckedCreateInput = {
  articleId: Scalars['Int']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  src: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ArticleImgUncheckedCreateNestedManyWithoutArticleInput = {
  connect?: InputMaybe<Array<ArticleImgWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ArticleImgCreateOrConnectWithoutArticleInput>>;
  create?: InputMaybe<Array<ArticleImgCreateWithoutArticleInput>>;
  createMany?: InputMaybe<ArticleImgCreateManyArticleInputEnvelope>;
};

export type ArticleImgUncheckedCreateWithoutArticleInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  src: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ArticleImgUncheckedUpdateInput = {
  articleId?: InputMaybe<IntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  src?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ArticleImgUncheckedUpdateManyInput = {
  articleId?: InputMaybe<IntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  src?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ArticleImgUncheckedUpdateManyWithoutArticleInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  src?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ArticleImgUncheckedUpdateManyWithoutArticleNestedInput = {
  connect?: InputMaybe<Array<ArticleImgWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ArticleImgCreateOrConnectWithoutArticleInput>>;
  create?: InputMaybe<Array<ArticleImgCreateWithoutArticleInput>>;
  createMany?: InputMaybe<ArticleImgCreateManyArticleInputEnvelope>;
  delete?: InputMaybe<Array<ArticleImgWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ArticleImgScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ArticleImgWhereUniqueInput>>;
  set?: InputMaybe<Array<ArticleImgWhereUniqueInput>>;
  update?: InputMaybe<Array<ArticleImgUpdateWithWhereUniqueWithoutArticleInput>>;
  updateMany?: InputMaybe<Array<ArticleImgUpdateManyWithWhereWithoutArticleInput>>;
  upsert?: InputMaybe<Array<ArticleImgUpsertWithWhereUniqueWithoutArticleInput>>;
};

export type ArticleImgUncheckedUpdateWithoutArticleInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  src?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ArticleImgUpdateInput = {
  article?: InputMaybe<ArticleUpdateOneRequiredWithoutImagesNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  src?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ArticleImgUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  src?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ArticleImgUpdateManyWithWhereWithoutArticleInput = {
  data: ArticleImgUpdateManyMutationInput;
  where: ArticleImgScalarWhereInput;
};

export type ArticleImgUpdateManyWithoutArticleNestedInput = {
  connect?: InputMaybe<Array<ArticleImgWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ArticleImgCreateOrConnectWithoutArticleInput>>;
  create?: InputMaybe<Array<ArticleImgCreateWithoutArticleInput>>;
  createMany?: InputMaybe<ArticleImgCreateManyArticleInputEnvelope>;
  delete?: InputMaybe<Array<ArticleImgWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ArticleImgScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ArticleImgWhereUniqueInput>>;
  set?: InputMaybe<Array<ArticleImgWhereUniqueInput>>;
  update?: InputMaybe<Array<ArticleImgUpdateWithWhereUniqueWithoutArticleInput>>;
  updateMany?: InputMaybe<Array<ArticleImgUpdateManyWithWhereWithoutArticleInput>>;
  upsert?: InputMaybe<Array<ArticleImgUpsertWithWhereUniqueWithoutArticleInput>>;
};

export type ArticleImgUpdateWithWhereUniqueWithoutArticleInput = {
  data: ArticleImgUpdateWithoutArticleInput;
  where: ArticleImgWhereUniqueInput;
};

export type ArticleImgUpdateWithoutArticleInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  src?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ArticleImgUpsertWithWhereUniqueWithoutArticleInput = {
  create: ArticleImgCreateWithoutArticleInput;
  update: ArticleImgUpdateWithoutArticleInput;
  where: ArticleImgWhereUniqueInput;
};

export type ArticleImgWhereInput = {
  AND?: InputMaybe<Array<ArticleImgWhereInput>>;
  NOT?: InputMaybe<Array<ArticleImgWhereInput>>;
  OR?: InputMaybe<Array<ArticleImgWhereInput>>;
  article?: InputMaybe<ArticleRelationFilter>;
  articleId?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntFilter>;
  src?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ArticleImgWhereUniqueInput = {
  AND?: InputMaybe<Array<ArticleImgWhereInput>>;
  NOT?: InputMaybe<Array<ArticleImgWhereInput>>;
  OR?: InputMaybe<Array<ArticleImgWhereInput>>;
  article?: InputMaybe<ArticleRelationFilter>;
  articleId?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  src?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ArticleMaxAggregateOutputType = {
  __typename?: 'ArticleMaxAggregateOutputType';
  authorName?: Maybe<Scalars['String']['output']>;
  coverImg?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  published?: Maybe<Scalars['Boolean']['output']>;
  reviewed?: Maybe<Scalars['Boolean']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ArticleMaxOrderByAggregateInput = {
  authorName?: InputMaybe<SortOrder>;
  coverImg?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  published?: InputMaybe<SortOrder>;
  reviewed?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ArticleMinAggregateOutputType = {
  __typename?: 'ArticleMinAggregateOutputType';
  authorName?: Maybe<Scalars['String']['output']>;
  coverImg?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  published?: Maybe<Scalars['Boolean']['output']>;
  reviewed?: Maybe<Scalars['Boolean']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ArticleMinOrderByAggregateInput = {
  authorName?: InputMaybe<SortOrder>;
  coverImg?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  published?: InputMaybe<SortOrder>;
  reviewed?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum ArticleOrderByRelevanceFieldEnum {
  authorName = 'authorName',
  coverImg = 'coverImg',
  tags = 'tags'
}

export type ArticleOrderByRelevanceInput = {
  fields: Array<ArticleOrderByRelevanceFieldEnum>;
  search: Scalars['String']['input'];
  sort: SortOrder;
};

export type ArticleOrderByWithAggregationInput = {
  _avg?: InputMaybe<ArticleAvgOrderByAggregateInput>;
  _count?: InputMaybe<ArticleCountOrderByAggregateInput>;
  _max?: InputMaybe<ArticleMaxOrderByAggregateInput>;
  _min?: InputMaybe<ArticleMinOrderByAggregateInput>;
  _sum?: InputMaybe<ArticleSumOrderByAggregateInput>;
  authorName?: InputMaybe<SortOrderInput>;
  coverImg?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  published?: InputMaybe<SortOrder>;
  reviewed?: InputMaybe<SortOrder>;
  tags?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ArticleOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: InputMaybe<ArticleOrderByRelevanceInput>;
  authorName?: InputMaybe<SortOrderInput>;
  coverImg?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  images?: InputMaybe<ArticleImgOrderByRelationAggregateInput>;
  published?: InputMaybe<SortOrder>;
  reviewed?: InputMaybe<SortOrder>;
  tags?: InputMaybe<SortOrder>;
  translations?: InputMaybe<ArticleTranslationsOrderByRelationAggregateInput>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ArticleRelationFilter = {
  is?: InputMaybe<ArticleWhereInput>;
  isNot?: InputMaybe<ArticleWhereInput>;
};

export enum ArticleScalarFieldEnum {
  authorName = 'authorName',
  coverImg = 'coverImg',
  createdAt = 'createdAt',
  id = 'id',
  published = 'published',
  reviewed = 'reviewed',
  tags = 'tags',
  updatedAt = 'updatedAt'
}

export type ArticleScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<ArticleScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<ArticleScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<ArticleScalarWhereWithAggregatesInput>>;
  authorName?: InputMaybe<StringNullableWithAggregatesFilter>;
  coverImg?: InputMaybe<StringNullableWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  published?: InputMaybe<BoolWithAggregatesFilter>;
  reviewed?: InputMaybe<BoolWithAggregatesFilter>;
  tags?: InputMaybe<StringNullableListFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type ArticleSumAggregateOutputType = {
  __typename?: 'ArticleSumAggregateOutputType';
  id?: Maybe<Scalars['Int']['output']>;
};

export type ArticleSumOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
};

export type ArticleTranslations = {
  __typename?: 'ArticleTranslations';
  article: Article;
  articleId: Scalars['Int']['output'];
  content: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  languageCode: LanguageCode;
  seoDescription?: Maybe<Scalars['String']['output']>;
  seoKeywords?: Maybe<Scalars['String']['output']>;
  seoTitle?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  url: Scalars['String']['output'];
};

export type ArticleTranslationsAvgAggregateOutputType = {
  __typename?: 'ArticleTranslationsAvgAggregateOutputType';
  articleId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

export type ArticleTranslationsAvgOrderByAggregateInput = {
  articleId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export type ArticleTranslationsCountAggregateOutputType = {
  __typename?: 'ArticleTranslationsCountAggregateOutputType';
  _all: Scalars['Int']['output'];
  active: Scalars['Int']['output'];
  articleId: Scalars['Int']['output'];
  content: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  languageCode: Scalars['Int']['output'];
  seoDescription: Scalars['Int']['output'];
  seoKeywords: Scalars['Int']['output'];
  seoTitle: Scalars['Int']['output'];
  title: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
  url: Scalars['Int']['output'];
};

export type ArticleTranslationsCountOrderByAggregateInput = {
  active?: InputMaybe<SortOrder>;
  articleId?: InputMaybe<SortOrder>;
  content?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  languageCode?: InputMaybe<SortOrder>;
  seoDescription?: InputMaybe<SortOrder>;
  seoKeywords?: InputMaybe<SortOrder>;
  seoTitle?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  url?: InputMaybe<SortOrder>;
};

export type ArticleTranslationsCreateInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  article: ArticleCreateNestedOneWithoutTranslationsInput;
  content: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  languageCode?: InputMaybe<LanguageCode>;
  seoDescription?: InputMaybe<Scalars['String']['input']>;
  seoKeywords?: InputMaybe<Scalars['String']['input']>;
  seoTitle?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type ArticleTranslationsCreateManyArticleInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  content: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  languageCode?: InputMaybe<LanguageCode>;
  seoDescription?: InputMaybe<Scalars['String']['input']>;
  seoKeywords?: InputMaybe<Scalars['String']['input']>;
  seoTitle?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type ArticleTranslationsCreateManyArticleInputEnvelope = {
  data: Array<ArticleTranslationsCreateManyArticleInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ArticleTranslationsCreateManyInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  articleId: Scalars['Int']['input'];
  content: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  languageCode?: InputMaybe<LanguageCode>;
  seoDescription?: InputMaybe<Scalars['String']['input']>;
  seoKeywords?: InputMaybe<Scalars['String']['input']>;
  seoTitle?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type ArticleTranslationsCreateNestedManyWithoutArticleInput = {
  connect?: InputMaybe<Array<ArticleTranslationsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ArticleTranslationsCreateOrConnectWithoutArticleInput>>;
  create?: InputMaybe<Array<ArticleTranslationsCreateWithoutArticleInput>>;
  createMany?: InputMaybe<ArticleTranslationsCreateManyArticleInputEnvelope>;
};

export type ArticleTranslationsCreateOrConnectWithoutArticleInput = {
  create: ArticleTranslationsCreateWithoutArticleInput;
  where: ArticleTranslationsWhereUniqueInput;
};

export type ArticleTranslationsCreateWithoutArticleInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  content: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  languageCode?: InputMaybe<LanguageCode>;
  seoDescription?: InputMaybe<Scalars['String']['input']>;
  seoKeywords?: InputMaybe<Scalars['String']['input']>;
  seoTitle?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type ArticleTranslationsListRelationFilter = {
  every?: InputMaybe<ArticleTranslationsWhereInput>;
  none?: InputMaybe<ArticleTranslationsWhereInput>;
  some?: InputMaybe<ArticleTranslationsWhereInput>;
};

export type ArticleTranslationsMaxAggregateOutputType = {
  __typename?: 'ArticleTranslationsMaxAggregateOutputType';
  active?: Maybe<Scalars['Boolean']['output']>;
  articleId?: Maybe<Scalars['Int']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  languageCode?: Maybe<LanguageCode>;
  seoDescription?: Maybe<Scalars['String']['output']>;
  seoKeywords?: Maybe<Scalars['String']['output']>;
  seoTitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type ArticleTranslationsMaxOrderByAggregateInput = {
  active?: InputMaybe<SortOrder>;
  articleId?: InputMaybe<SortOrder>;
  content?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  languageCode?: InputMaybe<SortOrder>;
  seoDescription?: InputMaybe<SortOrder>;
  seoKeywords?: InputMaybe<SortOrder>;
  seoTitle?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  url?: InputMaybe<SortOrder>;
};

export type ArticleTranslationsMinAggregateOutputType = {
  __typename?: 'ArticleTranslationsMinAggregateOutputType';
  active?: Maybe<Scalars['Boolean']['output']>;
  articleId?: Maybe<Scalars['Int']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  languageCode?: Maybe<LanguageCode>;
  seoDescription?: Maybe<Scalars['String']['output']>;
  seoKeywords?: Maybe<Scalars['String']['output']>;
  seoTitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type ArticleTranslationsMinOrderByAggregateInput = {
  active?: InputMaybe<SortOrder>;
  articleId?: InputMaybe<SortOrder>;
  content?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  languageCode?: InputMaybe<SortOrder>;
  seoDescription?: InputMaybe<SortOrder>;
  seoKeywords?: InputMaybe<SortOrder>;
  seoTitle?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  url?: InputMaybe<SortOrder>;
};

export type ArticleTranslationsOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export enum ArticleTranslationsOrderByRelevanceFieldEnum {
  content = 'content',
  seoDescription = 'seoDescription',
  seoKeywords = 'seoKeywords',
  seoTitle = 'seoTitle',
  title = 'title',
  url = 'url'
}

export type ArticleTranslationsOrderByRelevanceInput = {
  fields: Array<ArticleTranslationsOrderByRelevanceFieldEnum>;
  search: Scalars['String']['input'];
  sort: SortOrder;
};

export type ArticleTranslationsOrderByWithAggregationInput = {
  _avg?: InputMaybe<ArticleTranslationsAvgOrderByAggregateInput>;
  _count?: InputMaybe<ArticleTranslationsCountOrderByAggregateInput>;
  _max?: InputMaybe<ArticleTranslationsMaxOrderByAggregateInput>;
  _min?: InputMaybe<ArticleTranslationsMinOrderByAggregateInput>;
  _sum?: InputMaybe<ArticleTranslationsSumOrderByAggregateInput>;
  active?: InputMaybe<SortOrder>;
  articleId?: InputMaybe<SortOrder>;
  content?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  languageCode?: InputMaybe<SortOrder>;
  seoDescription?: InputMaybe<SortOrderInput>;
  seoKeywords?: InputMaybe<SortOrderInput>;
  seoTitle?: InputMaybe<SortOrderInput>;
  title?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  url?: InputMaybe<SortOrderInput>;
};

export type ArticleTranslationsOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: InputMaybe<ArticleTranslationsOrderByRelevanceInput>;
  active?: InputMaybe<SortOrder>;
  article?: InputMaybe<ArticleOrderByWithRelationAndSearchRelevanceInput>;
  articleId?: InputMaybe<SortOrder>;
  content?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  languageCode?: InputMaybe<SortOrder>;
  seoDescription?: InputMaybe<SortOrderInput>;
  seoKeywords?: InputMaybe<SortOrderInput>;
  seoTitle?: InputMaybe<SortOrderInput>;
  title?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  url?: InputMaybe<SortOrderInput>;
};

export enum ArticleTranslationsScalarFieldEnum {
  active = 'active',
  articleId = 'articleId',
  content = 'content',
  createdAt = 'createdAt',
  id = 'id',
  languageCode = 'languageCode',
  seoDescription = 'seoDescription',
  seoKeywords = 'seoKeywords',
  seoTitle = 'seoTitle',
  title = 'title',
  updatedAt = 'updatedAt',
  url = 'url'
}

export type ArticleTranslationsScalarWhereInput = {
  AND?: InputMaybe<Array<ArticleTranslationsScalarWhereInput>>;
  NOT?: InputMaybe<Array<ArticleTranslationsScalarWhereInput>>;
  OR?: InputMaybe<Array<ArticleTranslationsScalarWhereInput>>;
  active?: InputMaybe<BoolFilter>;
  articleId?: InputMaybe<IntFilter>;
  content?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntFilter>;
  languageCode?: InputMaybe<EnumLanguageCodeFilter>;
  seoDescription?: InputMaybe<StringNullableFilter>;
  seoKeywords?: InputMaybe<StringNullableFilter>;
  seoTitle?: InputMaybe<StringNullableFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  url?: InputMaybe<StringNullableFilter>;
};

export type ArticleTranslationsScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<ArticleTranslationsScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<ArticleTranslationsScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<ArticleTranslationsScalarWhereWithAggregatesInput>>;
  active?: InputMaybe<BoolWithAggregatesFilter>;
  articleId?: InputMaybe<IntWithAggregatesFilter>;
  content?: InputMaybe<StringWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  languageCode?: InputMaybe<EnumLanguageCodeWithAggregatesFilter>;
  seoDescription?: InputMaybe<StringNullableWithAggregatesFilter>;
  seoKeywords?: InputMaybe<StringNullableWithAggregatesFilter>;
  seoTitle?: InputMaybe<StringNullableWithAggregatesFilter>;
  title?: InputMaybe<StringWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  url?: InputMaybe<StringNullableWithAggregatesFilter>;
};

export type ArticleTranslationsSumAggregateOutputType = {
  __typename?: 'ArticleTranslationsSumAggregateOutputType';
  articleId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
};

export type ArticleTranslationsSumOrderByAggregateInput = {
  articleId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export type ArticleTranslationsUncheckedCreateInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  articleId: Scalars['Int']['input'];
  content: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  languageCode?: InputMaybe<LanguageCode>;
  seoDescription?: InputMaybe<Scalars['String']['input']>;
  seoKeywords?: InputMaybe<Scalars['String']['input']>;
  seoTitle?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type ArticleTranslationsUncheckedCreateNestedManyWithoutArticleInput = {
  connect?: InputMaybe<Array<ArticleTranslationsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ArticleTranslationsCreateOrConnectWithoutArticleInput>>;
  create?: InputMaybe<Array<ArticleTranslationsCreateWithoutArticleInput>>;
  createMany?: InputMaybe<ArticleTranslationsCreateManyArticleInputEnvelope>;
};

export type ArticleTranslationsUncheckedCreateWithoutArticleInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  content: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  languageCode?: InputMaybe<LanguageCode>;
  seoDescription?: InputMaybe<Scalars['String']['input']>;
  seoKeywords?: InputMaybe<Scalars['String']['input']>;
  seoTitle?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type ArticleTranslationsUncheckedUpdateInput = {
  active?: InputMaybe<BoolFieldUpdateOperationsInput>;
  articleId?: InputMaybe<IntFieldUpdateOperationsInput>;
  content?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  languageCode?: InputMaybe<EnumLanguageCodeFieldUpdateOperationsInput>;
  seoDescription?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  seoKeywords?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  seoTitle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  url?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ArticleTranslationsUncheckedUpdateManyInput = {
  active?: InputMaybe<BoolFieldUpdateOperationsInput>;
  articleId?: InputMaybe<IntFieldUpdateOperationsInput>;
  content?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  languageCode?: InputMaybe<EnumLanguageCodeFieldUpdateOperationsInput>;
  seoDescription?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  seoKeywords?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  seoTitle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  url?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ArticleTranslationsUncheckedUpdateManyWithoutArticleInput = {
  active?: InputMaybe<BoolFieldUpdateOperationsInput>;
  content?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  languageCode?: InputMaybe<EnumLanguageCodeFieldUpdateOperationsInput>;
  seoDescription?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  seoKeywords?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  seoTitle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  url?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ArticleTranslationsUncheckedUpdateManyWithoutArticleNestedInput = {
  connect?: InputMaybe<Array<ArticleTranslationsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ArticleTranslationsCreateOrConnectWithoutArticleInput>>;
  create?: InputMaybe<Array<ArticleTranslationsCreateWithoutArticleInput>>;
  createMany?: InputMaybe<ArticleTranslationsCreateManyArticleInputEnvelope>;
  delete?: InputMaybe<Array<ArticleTranslationsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ArticleTranslationsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ArticleTranslationsWhereUniqueInput>>;
  set?: InputMaybe<Array<ArticleTranslationsWhereUniqueInput>>;
  update?: InputMaybe<Array<ArticleTranslationsUpdateWithWhereUniqueWithoutArticleInput>>;
  updateMany?: InputMaybe<Array<ArticleTranslationsUpdateManyWithWhereWithoutArticleInput>>;
  upsert?: InputMaybe<Array<ArticleTranslationsUpsertWithWhereUniqueWithoutArticleInput>>;
};

export type ArticleTranslationsUncheckedUpdateWithoutArticleInput = {
  active?: InputMaybe<BoolFieldUpdateOperationsInput>;
  content?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  languageCode?: InputMaybe<EnumLanguageCodeFieldUpdateOperationsInput>;
  seoDescription?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  seoKeywords?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  seoTitle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  url?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ArticleTranslationsUpdateInput = {
  active?: InputMaybe<BoolFieldUpdateOperationsInput>;
  article?: InputMaybe<ArticleUpdateOneRequiredWithoutTranslationsNestedInput>;
  content?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  languageCode?: InputMaybe<EnumLanguageCodeFieldUpdateOperationsInput>;
  seoDescription?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  seoKeywords?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  seoTitle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  url?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ArticleTranslationsUpdateManyMutationInput = {
  active?: InputMaybe<BoolFieldUpdateOperationsInput>;
  content?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  languageCode?: InputMaybe<EnumLanguageCodeFieldUpdateOperationsInput>;
  seoDescription?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  seoKeywords?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  seoTitle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  url?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ArticleTranslationsUpdateManyWithWhereWithoutArticleInput = {
  data: ArticleTranslationsUpdateManyMutationInput;
  where: ArticleTranslationsScalarWhereInput;
};

export type ArticleTranslationsUpdateManyWithoutArticleNestedInput = {
  connect?: InputMaybe<Array<ArticleTranslationsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ArticleTranslationsCreateOrConnectWithoutArticleInput>>;
  create?: InputMaybe<Array<ArticleTranslationsCreateWithoutArticleInput>>;
  createMany?: InputMaybe<ArticleTranslationsCreateManyArticleInputEnvelope>;
  delete?: InputMaybe<Array<ArticleTranslationsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ArticleTranslationsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ArticleTranslationsWhereUniqueInput>>;
  set?: InputMaybe<Array<ArticleTranslationsWhereUniqueInput>>;
  update?: InputMaybe<Array<ArticleTranslationsUpdateWithWhereUniqueWithoutArticleInput>>;
  updateMany?: InputMaybe<Array<ArticleTranslationsUpdateManyWithWhereWithoutArticleInput>>;
  upsert?: InputMaybe<Array<ArticleTranslationsUpsertWithWhereUniqueWithoutArticleInput>>;
};

export type ArticleTranslationsUpdateWithWhereUniqueWithoutArticleInput = {
  data: ArticleTranslationsUpdateWithoutArticleInput;
  where: ArticleTranslationsWhereUniqueInput;
};

export type ArticleTranslationsUpdateWithoutArticleInput = {
  active?: InputMaybe<BoolFieldUpdateOperationsInput>;
  content?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  languageCode?: InputMaybe<EnumLanguageCodeFieldUpdateOperationsInput>;
  seoDescription?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  seoKeywords?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  seoTitle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  url?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ArticleTranslationsUpsertWithWhereUniqueWithoutArticleInput = {
  create: ArticleTranslationsCreateWithoutArticleInput;
  update: ArticleTranslationsUpdateWithoutArticleInput;
  where: ArticleTranslationsWhereUniqueInput;
};

export type ArticleTranslationsWhereInput = {
  AND?: InputMaybe<Array<ArticleTranslationsWhereInput>>;
  NOT?: InputMaybe<Array<ArticleTranslationsWhereInput>>;
  OR?: InputMaybe<Array<ArticleTranslationsWhereInput>>;
  active?: InputMaybe<BoolFilter>;
  article?: InputMaybe<ArticleRelationFilter>;
  articleId?: InputMaybe<IntFilter>;
  content?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntFilter>;
  languageCode?: InputMaybe<EnumLanguageCodeFilter>;
  seoDescription?: InputMaybe<StringNullableFilter>;
  seoKeywords?: InputMaybe<StringNullableFilter>;
  seoTitle?: InputMaybe<StringNullableFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  url?: InputMaybe<StringNullableFilter>;
};

export type ArticleTranslationsWhereUniqueInput = {
  AND?: InputMaybe<Array<ArticleTranslationsWhereInput>>;
  NOT?: InputMaybe<Array<ArticleTranslationsWhereInput>>;
  OR?: InputMaybe<Array<ArticleTranslationsWhereInput>>;
  active?: InputMaybe<BoolFilter>;
  article?: InputMaybe<ArticleRelationFilter>;
  articleId?: InputMaybe<IntFilter>;
  content?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  languageCode?: InputMaybe<EnumLanguageCodeFilter>;
  seoDescription?: InputMaybe<StringNullableFilter>;
  seoKeywords?: InputMaybe<StringNullableFilter>;
  seoTitle?: InputMaybe<StringNullableFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  url?: InputMaybe<StringNullableFilter>;
};

export type ArticleUncheckedCreateInput = {
  authorName?: InputMaybe<Scalars['String']['input']>;
  coverImg?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  images?: InputMaybe<ArticleImgUncheckedCreateNestedManyWithoutArticleInput>;
  published: Scalars['Boolean']['input'];
  reviewed?: InputMaybe<Scalars['Boolean']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  translations?: InputMaybe<ArticleTranslationsUncheckedCreateNestedManyWithoutArticleInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ArticleUncheckedCreateWithoutImagesInput = {
  authorName?: InputMaybe<Scalars['String']['input']>;
  coverImg?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  published: Scalars['Boolean']['input'];
  reviewed?: InputMaybe<Scalars['Boolean']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  translations?: InputMaybe<ArticleTranslationsUncheckedCreateNestedManyWithoutArticleInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ArticleUncheckedCreateWithoutTranslationsInput = {
  authorName?: InputMaybe<Scalars['String']['input']>;
  coverImg?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  images?: InputMaybe<ArticleImgUncheckedCreateNestedManyWithoutArticleInput>;
  published: Scalars['Boolean']['input'];
  reviewed?: InputMaybe<Scalars['Boolean']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ArticleUncheckedUpdateInput = {
  authorName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coverImg?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  images?: InputMaybe<ArticleImgUncheckedUpdateManyWithoutArticleNestedInput>;
  published?: InputMaybe<BoolFieldUpdateOperationsInput>;
  reviewed?: InputMaybe<BoolFieldUpdateOperationsInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  translations?: InputMaybe<ArticleTranslationsUncheckedUpdateManyWithoutArticleNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ArticleUncheckedUpdateManyInput = {
  authorName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coverImg?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  published?: InputMaybe<BoolFieldUpdateOperationsInput>;
  reviewed?: InputMaybe<BoolFieldUpdateOperationsInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ArticleUncheckedUpdateWithoutImagesInput = {
  authorName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coverImg?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  published?: InputMaybe<BoolFieldUpdateOperationsInput>;
  reviewed?: InputMaybe<BoolFieldUpdateOperationsInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  translations?: InputMaybe<ArticleTranslationsUncheckedUpdateManyWithoutArticleNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ArticleUncheckedUpdateWithoutTranslationsInput = {
  authorName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coverImg?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  images?: InputMaybe<ArticleImgUncheckedUpdateManyWithoutArticleNestedInput>;
  published?: InputMaybe<BoolFieldUpdateOperationsInput>;
  reviewed?: InputMaybe<BoolFieldUpdateOperationsInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ArticleUpdateInput = {
  authorName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coverImg?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  images?: InputMaybe<ArticleImgUpdateManyWithoutArticleNestedInput>;
  published?: InputMaybe<BoolFieldUpdateOperationsInput>;
  reviewed?: InputMaybe<BoolFieldUpdateOperationsInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  translations?: InputMaybe<ArticleTranslationsUpdateManyWithoutArticleNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ArticleUpdateManyMutationInput = {
  authorName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coverImg?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  published?: InputMaybe<BoolFieldUpdateOperationsInput>;
  reviewed?: InputMaybe<BoolFieldUpdateOperationsInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ArticleUpdateOneRequiredWithoutImagesNestedInput = {
  connect?: InputMaybe<ArticleWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ArticleCreateOrConnectWithoutImagesInput>;
  create?: InputMaybe<ArticleCreateWithoutImagesInput>;
  update?: InputMaybe<ArticleUpdateToOneWithWhereWithoutImagesInput>;
  upsert?: InputMaybe<ArticleUpsertWithoutImagesInput>;
};

export type ArticleUpdateOneRequiredWithoutTranslationsNestedInput = {
  connect?: InputMaybe<ArticleWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ArticleCreateOrConnectWithoutTranslationsInput>;
  create?: InputMaybe<ArticleCreateWithoutTranslationsInput>;
  update?: InputMaybe<ArticleUpdateToOneWithWhereWithoutTranslationsInput>;
  upsert?: InputMaybe<ArticleUpsertWithoutTranslationsInput>;
};

export type ArticleUpdateToOneWithWhereWithoutImagesInput = {
  data: ArticleUpdateWithoutImagesInput;
  where?: InputMaybe<ArticleWhereInput>;
};

export type ArticleUpdateToOneWithWhereWithoutTranslationsInput = {
  data: ArticleUpdateWithoutTranslationsInput;
  where?: InputMaybe<ArticleWhereInput>;
};

export type ArticleUpdateWithoutImagesInput = {
  authorName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coverImg?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  published?: InputMaybe<BoolFieldUpdateOperationsInput>;
  reviewed?: InputMaybe<BoolFieldUpdateOperationsInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  translations?: InputMaybe<ArticleTranslationsUpdateManyWithoutArticleNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ArticleUpdateWithoutTranslationsInput = {
  authorName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  coverImg?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  images?: InputMaybe<ArticleImgUpdateManyWithoutArticleNestedInput>;
  published?: InputMaybe<BoolFieldUpdateOperationsInput>;
  reviewed?: InputMaybe<BoolFieldUpdateOperationsInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ArticleUpdatetagsInput = {
  push?: InputMaybe<Array<Scalars['String']['input']>>;
  set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ArticleUpsertWithoutImagesInput = {
  create: ArticleCreateWithoutImagesInput;
  update: ArticleUpdateWithoutImagesInput;
  where?: InputMaybe<ArticleWhereInput>;
};

export type ArticleUpsertWithoutTranslationsInput = {
  create: ArticleCreateWithoutTranslationsInput;
  update: ArticleUpdateWithoutTranslationsInput;
  where?: InputMaybe<ArticleWhereInput>;
};

export type ArticleWhereInput = {
  AND?: InputMaybe<Array<ArticleWhereInput>>;
  NOT?: InputMaybe<Array<ArticleWhereInput>>;
  OR?: InputMaybe<Array<ArticleWhereInput>>;
  authorName?: InputMaybe<StringNullableFilter>;
  coverImg?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntFilter>;
  images?: InputMaybe<ArticleImgListRelationFilter>;
  published?: InputMaybe<BoolFilter>;
  reviewed?: InputMaybe<BoolFilter>;
  tags?: InputMaybe<StringNullableListFilter>;
  translations?: InputMaybe<ArticleTranslationsListRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ArticleWhereUniqueInput = {
  AND?: InputMaybe<Array<ArticleWhereInput>>;
  NOT?: InputMaybe<Array<ArticleWhereInput>>;
  OR?: InputMaybe<Array<ArticleWhereInput>>;
  authorName?: InputMaybe<StringNullableFilter>;
  coverImg?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  images?: InputMaybe<ArticleImgListRelationFilter>;
  published?: InputMaybe<BoolFilter>;
  reviewed?: InputMaybe<BoolFilter>;
  tags?: InputMaybe<StringNullableListFilter>;
  translations?: InputMaybe<ArticleTranslationsListRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export enum AuthTokenInfoType {
  facebook = 'facebook',
  firebase = 'firebase',
  google = 'google'
}

export type AutocompleteSuggestion = {
  __typename?: 'AutocompleteSuggestion';
  label?: Maybe<Scalars['String']['output']>;
  lat?: Maybe<Scalars['String']['output']>;
  lon?: Maybe<Scalars['String']['output']>;
  placeId?: Maybe<Scalars['String']['output']>;
};

export type BatchPayload = {
  __typename?: 'BatchPayload';
  count: Scalars['Int']['output'];
};

export enum BirthdayType {
  DATE = 'DATE',
  MONTH = 'MONTH',
  YEAR = 'YEAR'
}

export type Booking = {
  __typename?: 'Booking';
  _count: BookingCountOutputType;
  account?: Maybe<Account>;
  accountId?: Maybe<Scalars['Int']['output']>;
  animal?: Maybe<Animal>;
  animalBrushingFrequency?: Maybe<FrequencyType>;
  animalFirstTimeAtGroomer?: Maybe<Scalars['Boolean']['output']>;
  animalHasKnottedFur?: Maybe<YesNoUnknownStatus>;
  animalId?: Maybe<Scalars['Int']['output']>;
  animalLastVisit?: Maybe<LastVisitType>;
  animalRecentlyAdopted?: Maybe<Scalars['Boolean']['output']>;
  animalTemper?: Maybe<TemperType>;
  bookingAnimals: Array<BookingAnimal>;
  bookingReason: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  endDateTime: Scalars['DateTime']['output'];
  forMultiAnimals: Scalars['Boolean']['output'];
  googleEventId: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  notifications: Array<Notification>;
  reminder6hSent: Scalars['Boolean']['output'];
  reminder24hSent: Scalars['Boolean']['output'];
  startDateTime: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  worker: Worker;
  workerId: Scalars['Int']['output'];
  workerService: WorkerService;
  workerServiceId: Scalars['Int']['output'];
};


export type BookingbookingAnimalsArgs = {
  cursor?: InputMaybe<BookingAnimalWhereUniqueInput>;
  distinct?: InputMaybe<BookingAnimalScalarFieldEnum>;
  orderBy?: InputMaybe<BookingAnimalOrderByWithRelationAndSearchRelevanceInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<BookingAnimalWhereInput>;
};


export type BookingnotificationsArgs = {
  cursor?: InputMaybe<NotificationWhereUniqueInput>;
  distinct?: InputMaybe<NotificationScalarFieldEnum>;
  orderBy?: InputMaybe<NotificationOrderByWithRelationAndSearchRelevanceInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<NotificationWhereInput>;
};

export type BookingAnimal = {
  __typename?: 'BookingAnimal';
  animal: Animal;
  animalBrushingFrequency?: Maybe<FrequencyType>;
  animalFirstTimeAtGroomer?: Maybe<Scalars['Boolean']['output']>;
  animalHasKnottedFur?: Maybe<YesNoUnknownStatus>;
  animalId: Scalars['Int']['output'];
  animalLastVisit?: Maybe<LastVisitType>;
  animalRecentlyAdopted?: Maybe<Scalars['Boolean']['output']>;
  animalTemper?: Maybe<TemperType>;
  booking: Booking;
  bookingId: Scalars['Int']['output'];
  bookingReason?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type BookingAnimalAvgAggregateOutputType = {
  __typename?: 'BookingAnimalAvgAggregateOutputType';
  animalId?: Maybe<Scalars['Float']['output']>;
  bookingId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

export type BookingAnimalAvgOrderByAggregateInput = {
  animalId?: InputMaybe<SortOrder>;
  bookingId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export type BookingAnimalCountAggregateOutputType = {
  __typename?: 'BookingAnimalCountAggregateOutputType';
  _all: Scalars['Int']['output'];
  animalBrushingFrequency: Scalars['Int']['output'];
  animalFirstTimeAtGroomer: Scalars['Int']['output'];
  animalHasKnottedFur: Scalars['Int']['output'];
  animalId: Scalars['Int']['output'];
  animalLastVisit: Scalars['Int']['output'];
  animalRecentlyAdopted: Scalars['Int']['output'];
  animalTemper: Scalars['Int']['output'];
  bookingId: Scalars['Int']['output'];
  bookingReason: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type BookingAnimalCountOrderByAggregateInput = {
  animalBrushingFrequency?: InputMaybe<SortOrder>;
  animalFirstTimeAtGroomer?: InputMaybe<SortOrder>;
  animalHasKnottedFur?: InputMaybe<SortOrder>;
  animalId?: InputMaybe<SortOrder>;
  animalLastVisit?: InputMaybe<SortOrder>;
  animalRecentlyAdopted?: InputMaybe<SortOrder>;
  animalTemper?: InputMaybe<SortOrder>;
  bookingId?: InputMaybe<SortOrder>;
  bookingReason?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type BookingAnimalCreate = {
  animalBrushingFrequency?: InputMaybe<FrequencyType>;
  animalFirstTimeAtGroomer?: InputMaybe<Scalars['Boolean']['input']>;
  animalHasKnottedFur?: InputMaybe<YesNoUnknownStatus>;
  animalId: Scalars['Int']['input'];
  animalLastVisit?: InputMaybe<LastVisitType>;
  animalRecentlyAdopted?: InputMaybe<Scalars['Boolean']['input']>;
  animalTemper?: InputMaybe<TemperType>;
  bookingReason?: InputMaybe<Scalars['String']['input']>;
};

export type BookingAnimalCreateInput = {
  animal: AnimalCreateNestedOneWithoutBookingAnimalsInput;
  animalBrushingFrequency?: InputMaybe<FrequencyType>;
  animalFirstTimeAtGroomer?: InputMaybe<Scalars['Boolean']['input']>;
  animalHasKnottedFur?: InputMaybe<YesNoUnknownStatus>;
  animalLastVisit?: InputMaybe<LastVisitType>;
  animalRecentlyAdopted?: InputMaybe<Scalars['Boolean']['input']>;
  animalTemper?: InputMaybe<TemperType>;
  booking: BookingCreateNestedOneWithoutBookingAnimalsInput;
  bookingReason?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type BookingAnimalCreateManyAnimalInput = {
  animalBrushingFrequency?: InputMaybe<FrequencyType>;
  animalFirstTimeAtGroomer?: InputMaybe<Scalars['Boolean']['input']>;
  animalHasKnottedFur?: InputMaybe<YesNoUnknownStatus>;
  animalLastVisit?: InputMaybe<LastVisitType>;
  animalRecentlyAdopted?: InputMaybe<Scalars['Boolean']['input']>;
  animalTemper?: InputMaybe<TemperType>;
  bookingId: Scalars['Int']['input'];
  bookingReason?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type BookingAnimalCreateManyAnimalInputEnvelope = {
  data: Array<BookingAnimalCreateManyAnimalInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BookingAnimalCreateManyBookingInput = {
  animalBrushingFrequency?: InputMaybe<FrequencyType>;
  animalFirstTimeAtGroomer?: InputMaybe<Scalars['Boolean']['input']>;
  animalHasKnottedFur?: InputMaybe<YesNoUnknownStatus>;
  animalId: Scalars['Int']['input'];
  animalLastVisit?: InputMaybe<LastVisitType>;
  animalRecentlyAdopted?: InputMaybe<Scalars['Boolean']['input']>;
  animalTemper?: InputMaybe<TemperType>;
  bookingReason?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type BookingAnimalCreateManyBookingInputEnvelope = {
  data: Array<BookingAnimalCreateManyBookingInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BookingAnimalCreateManyInput = {
  animalBrushingFrequency?: InputMaybe<FrequencyType>;
  animalFirstTimeAtGroomer?: InputMaybe<Scalars['Boolean']['input']>;
  animalHasKnottedFur?: InputMaybe<YesNoUnknownStatus>;
  animalId: Scalars['Int']['input'];
  animalLastVisit?: InputMaybe<LastVisitType>;
  animalRecentlyAdopted?: InputMaybe<Scalars['Boolean']['input']>;
  animalTemper?: InputMaybe<TemperType>;
  bookingId: Scalars['Int']['input'];
  bookingReason?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type BookingAnimalCreateNestedManyWithoutAnimalInput = {
  connect?: InputMaybe<Array<BookingAnimalWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<BookingAnimalCreateOrConnectWithoutAnimalInput>>;
  create?: InputMaybe<Array<BookingAnimalCreateWithoutAnimalInput>>;
  createMany?: InputMaybe<BookingAnimalCreateManyAnimalInputEnvelope>;
};

export type BookingAnimalCreateNestedManyWithoutBookingInput = {
  connect?: InputMaybe<Array<BookingAnimalWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<BookingAnimalCreateOrConnectWithoutBookingInput>>;
  create?: InputMaybe<Array<BookingAnimalCreateWithoutBookingInput>>;
  createMany?: InputMaybe<BookingAnimalCreateManyBookingInputEnvelope>;
};

export type BookingAnimalCreateOrConnectWithoutAnimalInput = {
  create: BookingAnimalCreateWithoutAnimalInput;
  where: BookingAnimalWhereUniqueInput;
};

export type BookingAnimalCreateOrConnectWithoutBookingInput = {
  create: BookingAnimalCreateWithoutBookingInput;
  where: BookingAnimalWhereUniqueInput;
};

export type BookingAnimalCreateWithoutAnimalInput = {
  animalBrushingFrequency?: InputMaybe<FrequencyType>;
  animalFirstTimeAtGroomer?: InputMaybe<Scalars['Boolean']['input']>;
  animalHasKnottedFur?: InputMaybe<YesNoUnknownStatus>;
  animalLastVisit?: InputMaybe<LastVisitType>;
  animalRecentlyAdopted?: InputMaybe<Scalars['Boolean']['input']>;
  animalTemper?: InputMaybe<TemperType>;
  booking: BookingCreateNestedOneWithoutBookingAnimalsInput;
  bookingReason?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type BookingAnimalCreateWithoutBookingInput = {
  animal: AnimalCreateNestedOneWithoutBookingAnimalsInput;
  animalBrushingFrequency?: InputMaybe<FrequencyType>;
  animalFirstTimeAtGroomer?: InputMaybe<Scalars['Boolean']['input']>;
  animalHasKnottedFur?: InputMaybe<YesNoUnknownStatus>;
  animalLastVisit?: InputMaybe<LastVisitType>;
  animalRecentlyAdopted?: InputMaybe<Scalars['Boolean']['input']>;
  animalTemper?: InputMaybe<TemperType>;
  bookingReason?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type BookingAnimalListRelationFilter = {
  every?: InputMaybe<BookingAnimalWhereInput>;
  none?: InputMaybe<BookingAnimalWhereInput>;
  some?: InputMaybe<BookingAnimalWhereInput>;
};

export type BookingAnimalMaxAggregateOutputType = {
  __typename?: 'BookingAnimalMaxAggregateOutputType';
  animalBrushingFrequency?: Maybe<FrequencyType>;
  animalFirstTimeAtGroomer?: Maybe<Scalars['Boolean']['output']>;
  animalHasKnottedFur?: Maybe<YesNoUnknownStatus>;
  animalId?: Maybe<Scalars['Int']['output']>;
  animalLastVisit?: Maybe<LastVisitType>;
  animalRecentlyAdopted?: Maybe<Scalars['Boolean']['output']>;
  animalTemper?: Maybe<TemperType>;
  bookingId?: Maybe<Scalars['Int']['output']>;
  bookingReason?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type BookingAnimalMaxOrderByAggregateInput = {
  animalBrushingFrequency?: InputMaybe<SortOrder>;
  animalFirstTimeAtGroomer?: InputMaybe<SortOrder>;
  animalHasKnottedFur?: InputMaybe<SortOrder>;
  animalId?: InputMaybe<SortOrder>;
  animalLastVisit?: InputMaybe<SortOrder>;
  animalRecentlyAdopted?: InputMaybe<SortOrder>;
  animalTemper?: InputMaybe<SortOrder>;
  bookingId?: InputMaybe<SortOrder>;
  bookingReason?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type BookingAnimalMinAggregateOutputType = {
  __typename?: 'BookingAnimalMinAggregateOutputType';
  animalBrushingFrequency?: Maybe<FrequencyType>;
  animalFirstTimeAtGroomer?: Maybe<Scalars['Boolean']['output']>;
  animalHasKnottedFur?: Maybe<YesNoUnknownStatus>;
  animalId?: Maybe<Scalars['Int']['output']>;
  animalLastVisit?: Maybe<LastVisitType>;
  animalRecentlyAdopted?: Maybe<Scalars['Boolean']['output']>;
  animalTemper?: Maybe<TemperType>;
  bookingId?: Maybe<Scalars['Int']['output']>;
  bookingReason?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type BookingAnimalMinOrderByAggregateInput = {
  animalBrushingFrequency?: InputMaybe<SortOrder>;
  animalFirstTimeAtGroomer?: InputMaybe<SortOrder>;
  animalHasKnottedFur?: InputMaybe<SortOrder>;
  animalId?: InputMaybe<SortOrder>;
  animalLastVisit?: InputMaybe<SortOrder>;
  animalRecentlyAdopted?: InputMaybe<SortOrder>;
  animalTemper?: InputMaybe<SortOrder>;
  bookingId?: InputMaybe<SortOrder>;
  bookingReason?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type BookingAnimalOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export enum BookingAnimalOrderByRelevanceFieldEnum {
  bookingReason = 'bookingReason'
}

export type BookingAnimalOrderByRelevanceInput = {
  fields: Array<BookingAnimalOrderByRelevanceFieldEnum>;
  search: Scalars['String']['input'];
  sort: SortOrder;
};

export type BookingAnimalOrderByWithAggregationInput = {
  _avg?: InputMaybe<BookingAnimalAvgOrderByAggregateInput>;
  _count?: InputMaybe<BookingAnimalCountOrderByAggregateInput>;
  _max?: InputMaybe<BookingAnimalMaxOrderByAggregateInput>;
  _min?: InputMaybe<BookingAnimalMinOrderByAggregateInput>;
  _sum?: InputMaybe<BookingAnimalSumOrderByAggregateInput>;
  animalBrushingFrequency?: InputMaybe<SortOrderInput>;
  animalFirstTimeAtGroomer?: InputMaybe<SortOrderInput>;
  animalHasKnottedFur?: InputMaybe<SortOrderInput>;
  animalId?: InputMaybe<SortOrder>;
  animalLastVisit?: InputMaybe<SortOrderInput>;
  animalRecentlyAdopted?: InputMaybe<SortOrderInput>;
  animalTemper?: InputMaybe<SortOrderInput>;
  bookingId?: InputMaybe<SortOrder>;
  bookingReason?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type BookingAnimalOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: InputMaybe<BookingAnimalOrderByRelevanceInput>;
  animal?: InputMaybe<AnimalOrderByWithRelationAndSearchRelevanceInput>;
  animalBrushingFrequency?: InputMaybe<SortOrderInput>;
  animalFirstTimeAtGroomer?: InputMaybe<SortOrderInput>;
  animalHasKnottedFur?: InputMaybe<SortOrderInput>;
  animalId?: InputMaybe<SortOrder>;
  animalLastVisit?: InputMaybe<SortOrderInput>;
  animalRecentlyAdopted?: InputMaybe<SortOrderInput>;
  animalTemper?: InputMaybe<SortOrderInput>;
  booking?: InputMaybe<BookingOrderByWithRelationAndSearchRelevanceInput>;
  bookingId?: InputMaybe<SortOrder>;
  bookingReason?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum BookingAnimalScalarFieldEnum {
  animalBrushingFrequency = 'animalBrushingFrequency',
  animalFirstTimeAtGroomer = 'animalFirstTimeAtGroomer',
  animalHasKnottedFur = 'animalHasKnottedFur',
  animalId = 'animalId',
  animalLastVisit = 'animalLastVisit',
  animalRecentlyAdopted = 'animalRecentlyAdopted',
  animalTemper = 'animalTemper',
  bookingId = 'bookingId',
  bookingReason = 'bookingReason',
  createdAt = 'createdAt',
  id = 'id',
  updatedAt = 'updatedAt'
}

export type BookingAnimalScalarWhereInput = {
  AND?: InputMaybe<Array<BookingAnimalScalarWhereInput>>;
  NOT?: InputMaybe<Array<BookingAnimalScalarWhereInput>>;
  OR?: InputMaybe<Array<BookingAnimalScalarWhereInput>>;
  animalBrushingFrequency?: InputMaybe<EnumFrequencyTypeNullableFilter>;
  animalFirstTimeAtGroomer?: InputMaybe<BoolNullableFilter>;
  animalHasKnottedFur?: InputMaybe<EnumYesNoUnknownStatusNullableFilter>;
  animalId?: InputMaybe<IntFilter>;
  animalLastVisit?: InputMaybe<EnumLastVisitTypeNullableFilter>;
  animalRecentlyAdopted?: InputMaybe<BoolNullableFilter>;
  animalTemper?: InputMaybe<EnumTemperTypeNullableFilter>;
  bookingId?: InputMaybe<IntFilter>;
  bookingReason?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type BookingAnimalScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<BookingAnimalScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<BookingAnimalScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<BookingAnimalScalarWhereWithAggregatesInput>>;
  animalBrushingFrequency?: InputMaybe<EnumFrequencyTypeNullableWithAggregatesFilter>;
  animalFirstTimeAtGroomer?: InputMaybe<BoolNullableWithAggregatesFilter>;
  animalHasKnottedFur?: InputMaybe<EnumYesNoUnknownStatusNullableWithAggregatesFilter>;
  animalId?: InputMaybe<IntWithAggregatesFilter>;
  animalLastVisit?: InputMaybe<EnumLastVisitTypeNullableWithAggregatesFilter>;
  animalRecentlyAdopted?: InputMaybe<BoolNullableWithAggregatesFilter>;
  animalTemper?: InputMaybe<EnumTemperTypeNullableWithAggregatesFilter>;
  bookingId?: InputMaybe<IntWithAggregatesFilter>;
  bookingReason?: InputMaybe<StringNullableWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type BookingAnimalSumAggregateOutputType = {
  __typename?: 'BookingAnimalSumAggregateOutputType';
  animalId?: Maybe<Scalars['Int']['output']>;
  bookingId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
};

export type BookingAnimalSumOrderByAggregateInput = {
  animalId?: InputMaybe<SortOrder>;
  bookingId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export type BookingAnimalUncheckedCreateInput = {
  animalBrushingFrequency?: InputMaybe<FrequencyType>;
  animalFirstTimeAtGroomer?: InputMaybe<Scalars['Boolean']['input']>;
  animalHasKnottedFur?: InputMaybe<YesNoUnknownStatus>;
  animalId: Scalars['Int']['input'];
  animalLastVisit?: InputMaybe<LastVisitType>;
  animalRecentlyAdopted?: InputMaybe<Scalars['Boolean']['input']>;
  animalTemper?: InputMaybe<TemperType>;
  bookingId: Scalars['Int']['input'];
  bookingReason?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type BookingAnimalUncheckedCreateNestedManyWithoutAnimalInput = {
  connect?: InputMaybe<Array<BookingAnimalWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<BookingAnimalCreateOrConnectWithoutAnimalInput>>;
  create?: InputMaybe<Array<BookingAnimalCreateWithoutAnimalInput>>;
  createMany?: InputMaybe<BookingAnimalCreateManyAnimalInputEnvelope>;
};

export type BookingAnimalUncheckedCreateNestedManyWithoutBookingInput = {
  connect?: InputMaybe<Array<BookingAnimalWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<BookingAnimalCreateOrConnectWithoutBookingInput>>;
  create?: InputMaybe<Array<BookingAnimalCreateWithoutBookingInput>>;
  createMany?: InputMaybe<BookingAnimalCreateManyBookingInputEnvelope>;
};

export type BookingAnimalUncheckedCreateWithoutAnimalInput = {
  animalBrushingFrequency?: InputMaybe<FrequencyType>;
  animalFirstTimeAtGroomer?: InputMaybe<Scalars['Boolean']['input']>;
  animalHasKnottedFur?: InputMaybe<YesNoUnknownStatus>;
  animalLastVisit?: InputMaybe<LastVisitType>;
  animalRecentlyAdopted?: InputMaybe<Scalars['Boolean']['input']>;
  animalTemper?: InputMaybe<TemperType>;
  bookingId: Scalars['Int']['input'];
  bookingReason?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type BookingAnimalUncheckedCreateWithoutBookingInput = {
  animalBrushingFrequency?: InputMaybe<FrequencyType>;
  animalFirstTimeAtGroomer?: InputMaybe<Scalars['Boolean']['input']>;
  animalHasKnottedFur?: InputMaybe<YesNoUnknownStatus>;
  animalId: Scalars['Int']['input'];
  animalLastVisit?: InputMaybe<LastVisitType>;
  animalRecentlyAdopted?: InputMaybe<Scalars['Boolean']['input']>;
  animalTemper?: InputMaybe<TemperType>;
  bookingReason?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type BookingAnimalUncheckedUpdateInput = {
  animalBrushingFrequency?: InputMaybe<NullableEnumFrequencyTypeFieldUpdateOperationsInput>;
  animalFirstTimeAtGroomer?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  animalHasKnottedFur?: InputMaybe<NullableEnumYesNoUnknownStatusFieldUpdateOperationsInput>;
  animalId?: InputMaybe<IntFieldUpdateOperationsInput>;
  animalLastVisit?: InputMaybe<NullableEnumLastVisitTypeFieldUpdateOperationsInput>;
  animalRecentlyAdopted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  animalTemper?: InputMaybe<NullableEnumTemperTypeFieldUpdateOperationsInput>;
  bookingId?: InputMaybe<IntFieldUpdateOperationsInput>;
  bookingReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type BookingAnimalUncheckedUpdateManyInput = {
  animalBrushingFrequency?: InputMaybe<NullableEnumFrequencyTypeFieldUpdateOperationsInput>;
  animalFirstTimeAtGroomer?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  animalHasKnottedFur?: InputMaybe<NullableEnumYesNoUnknownStatusFieldUpdateOperationsInput>;
  animalId?: InputMaybe<IntFieldUpdateOperationsInput>;
  animalLastVisit?: InputMaybe<NullableEnumLastVisitTypeFieldUpdateOperationsInput>;
  animalRecentlyAdopted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  animalTemper?: InputMaybe<NullableEnumTemperTypeFieldUpdateOperationsInput>;
  bookingId?: InputMaybe<IntFieldUpdateOperationsInput>;
  bookingReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type BookingAnimalUncheckedUpdateManyWithoutAnimalInput = {
  animalBrushingFrequency?: InputMaybe<NullableEnumFrequencyTypeFieldUpdateOperationsInput>;
  animalFirstTimeAtGroomer?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  animalHasKnottedFur?: InputMaybe<NullableEnumYesNoUnknownStatusFieldUpdateOperationsInput>;
  animalLastVisit?: InputMaybe<NullableEnumLastVisitTypeFieldUpdateOperationsInput>;
  animalRecentlyAdopted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  animalTemper?: InputMaybe<NullableEnumTemperTypeFieldUpdateOperationsInput>;
  bookingId?: InputMaybe<IntFieldUpdateOperationsInput>;
  bookingReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type BookingAnimalUncheckedUpdateManyWithoutAnimalNestedInput = {
  connect?: InputMaybe<Array<BookingAnimalWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<BookingAnimalCreateOrConnectWithoutAnimalInput>>;
  create?: InputMaybe<Array<BookingAnimalCreateWithoutAnimalInput>>;
  createMany?: InputMaybe<BookingAnimalCreateManyAnimalInputEnvelope>;
  delete?: InputMaybe<Array<BookingAnimalWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<BookingAnimalScalarWhereInput>>;
  disconnect?: InputMaybe<Array<BookingAnimalWhereUniqueInput>>;
  set?: InputMaybe<Array<BookingAnimalWhereUniqueInput>>;
  update?: InputMaybe<Array<BookingAnimalUpdateWithWhereUniqueWithoutAnimalInput>>;
  updateMany?: InputMaybe<Array<BookingAnimalUpdateManyWithWhereWithoutAnimalInput>>;
  upsert?: InputMaybe<Array<BookingAnimalUpsertWithWhereUniqueWithoutAnimalInput>>;
};

export type BookingAnimalUncheckedUpdateManyWithoutBookingInput = {
  animalBrushingFrequency?: InputMaybe<NullableEnumFrequencyTypeFieldUpdateOperationsInput>;
  animalFirstTimeAtGroomer?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  animalHasKnottedFur?: InputMaybe<NullableEnumYesNoUnknownStatusFieldUpdateOperationsInput>;
  animalId?: InputMaybe<IntFieldUpdateOperationsInput>;
  animalLastVisit?: InputMaybe<NullableEnumLastVisitTypeFieldUpdateOperationsInput>;
  animalRecentlyAdopted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  animalTemper?: InputMaybe<NullableEnumTemperTypeFieldUpdateOperationsInput>;
  bookingReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type BookingAnimalUncheckedUpdateManyWithoutBookingNestedInput = {
  connect?: InputMaybe<Array<BookingAnimalWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<BookingAnimalCreateOrConnectWithoutBookingInput>>;
  create?: InputMaybe<Array<BookingAnimalCreateWithoutBookingInput>>;
  createMany?: InputMaybe<BookingAnimalCreateManyBookingInputEnvelope>;
  delete?: InputMaybe<Array<BookingAnimalWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<BookingAnimalScalarWhereInput>>;
  disconnect?: InputMaybe<Array<BookingAnimalWhereUniqueInput>>;
  set?: InputMaybe<Array<BookingAnimalWhereUniqueInput>>;
  update?: InputMaybe<Array<BookingAnimalUpdateWithWhereUniqueWithoutBookingInput>>;
  updateMany?: InputMaybe<Array<BookingAnimalUpdateManyWithWhereWithoutBookingInput>>;
  upsert?: InputMaybe<Array<BookingAnimalUpsertWithWhereUniqueWithoutBookingInput>>;
};

export type BookingAnimalUncheckedUpdateWithoutAnimalInput = {
  animalBrushingFrequency?: InputMaybe<NullableEnumFrequencyTypeFieldUpdateOperationsInput>;
  animalFirstTimeAtGroomer?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  animalHasKnottedFur?: InputMaybe<NullableEnumYesNoUnknownStatusFieldUpdateOperationsInput>;
  animalLastVisit?: InputMaybe<NullableEnumLastVisitTypeFieldUpdateOperationsInput>;
  animalRecentlyAdopted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  animalTemper?: InputMaybe<NullableEnumTemperTypeFieldUpdateOperationsInput>;
  bookingId?: InputMaybe<IntFieldUpdateOperationsInput>;
  bookingReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type BookingAnimalUncheckedUpdateWithoutBookingInput = {
  animalBrushingFrequency?: InputMaybe<NullableEnumFrequencyTypeFieldUpdateOperationsInput>;
  animalFirstTimeAtGroomer?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  animalHasKnottedFur?: InputMaybe<NullableEnumYesNoUnknownStatusFieldUpdateOperationsInput>;
  animalId?: InputMaybe<IntFieldUpdateOperationsInput>;
  animalLastVisit?: InputMaybe<NullableEnumLastVisitTypeFieldUpdateOperationsInput>;
  animalRecentlyAdopted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  animalTemper?: InputMaybe<NullableEnumTemperTypeFieldUpdateOperationsInput>;
  bookingReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type BookingAnimalUpdateInput = {
  animal?: InputMaybe<AnimalUpdateOneRequiredWithoutBookingAnimalsNestedInput>;
  animalBrushingFrequency?: InputMaybe<NullableEnumFrequencyTypeFieldUpdateOperationsInput>;
  animalFirstTimeAtGroomer?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  animalHasKnottedFur?: InputMaybe<NullableEnumYesNoUnknownStatusFieldUpdateOperationsInput>;
  animalLastVisit?: InputMaybe<NullableEnumLastVisitTypeFieldUpdateOperationsInput>;
  animalRecentlyAdopted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  animalTemper?: InputMaybe<NullableEnumTemperTypeFieldUpdateOperationsInput>;
  booking?: InputMaybe<BookingUpdateOneRequiredWithoutBookingAnimalsNestedInput>;
  bookingReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type BookingAnimalUpdateManyMutationInput = {
  animalBrushingFrequency?: InputMaybe<NullableEnumFrequencyTypeFieldUpdateOperationsInput>;
  animalFirstTimeAtGroomer?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  animalHasKnottedFur?: InputMaybe<NullableEnumYesNoUnknownStatusFieldUpdateOperationsInput>;
  animalLastVisit?: InputMaybe<NullableEnumLastVisitTypeFieldUpdateOperationsInput>;
  animalRecentlyAdopted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  animalTemper?: InputMaybe<NullableEnumTemperTypeFieldUpdateOperationsInput>;
  bookingReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type BookingAnimalUpdateManyWithWhereWithoutAnimalInput = {
  data: BookingAnimalUpdateManyMutationInput;
  where: BookingAnimalScalarWhereInput;
};

export type BookingAnimalUpdateManyWithWhereWithoutBookingInput = {
  data: BookingAnimalUpdateManyMutationInput;
  where: BookingAnimalScalarWhereInput;
};

export type BookingAnimalUpdateManyWithoutAnimalNestedInput = {
  connect?: InputMaybe<Array<BookingAnimalWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<BookingAnimalCreateOrConnectWithoutAnimalInput>>;
  create?: InputMaybe<Array<BookingAnimalCreateWithoutAnimalInput>>;
  createMany?: InputMaybe<BookingAnimalCreateManyAnimalInputEnvelope>;
  delete?: InputMaybe<Array<BookingAnimalWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<BookingAnimalScalarWhereInput>>;
  disconnect?: InputMaybe<Array<BookingAnimalWhereUniqueInput>>;
  set?: InputMaybe<Array<BookingAnimalWhereUniqueInput>>;
  update?: InputMaybe<Array<BookingAnimalUpdateWithWhereUniqueWithoutAnimalInput>>;
  updateMany?: InputMaybe<Array<BookingAnimalUpdateManyWithWhereWithoutAnimalInput>>;
  upsert?: InputMaybe<Array<BookingAnimalUpsertWithWhereUniqueWithoutAnimalInput>>;
};

export type BookingAnimalUpdateManyWithoutBookingNestedInput = {
  connect?: InputMaybe<Array<BookingAnimalWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<BookingAnimalCreateOrConnectWithoutBookingInput>>;
  create?: InputMaybe<Array<BookingAnimalCreateWithoutBookingInput>>;
  createMany?: InputMaybe<BookingAnimalCreateManyBookingInputEnvelope>;
  delete?: InputMaybe<Array<BookingAnimalWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<BookingAnimalScalarWhereInput>>;
  disconnect?: InputMaybe<Array<BookingAnimalWhereUniqueInput>>;
  set?: InputMaybe<Array<BookingAnimalWhereUniqueInput>>;
  update?: InputMaybe<Array<BookingAnimalUpdateWithWhereUniqueWithoutBookingInput>>;
  updateMany?: InputMaybe<Array<BookingAnimalUpdateManyWithWhereWithoutBookingInput>>;
  upsert?: InputMaybe<Array<BookingAnimalUpsertWithWhereUniqueWithoutBookingInput>>;
};

export type BookingAnimalUpdateWithWhereUniqueWithoutAnimalInput = {
  data: BookingAnimalUpdateWithoutAnimalInput;
  where: BookingAnimalWhereUniqueInput;
};

export type BookingAnimalUpdateWithWhereUniqueWithoutBookingInput = {
  data: BookingAnimalUpdateWithoutBookingInput;
  where: BookingAnimalWhereUniqueInput;
};

export type BookingAnimalUpdateWithoutAnimalInput = {
  animalBrushingFrequency?: InputMaybe<NullableEnumFrequencyTypeFieldUpdateOperationsInput>;
  animalFirstTimeAtGroomer?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  animalHasKnottedFur?: InputMaybe<NullableEnumYesNoUnknownStatusFieldUpdateOperationsInput>;
  animalLastVisit?: InputMaybe<NullableEnumLastVisitTypeFieldUpdateOperationsInput>;
  animalRecentlyAdopted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  animalTemper?: InputMaybe<NullableEnumTemperTypeFieldUpdateOperationsInput>;
  booking?: InputMaybe<BookingUpdateOneRequiredWithoutBookingAnimalsNestedInput>;
  bookingReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type BookingAnimalUpdateWithoutBookingInput = {
  animal?: InputMaybe<AnimalUpdateOneRequiredWithoutBookingAnimalsNestedInput>;
  animalBrushingFrequency?: InputMaybe<NullableEnumFrequencyTypeFieldUpdateOperationsInput>;
  animalFirstTimeAtGroomer?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  animalHasKnottedFur?: InputMaybe<NullableEnumYesNoUnknownStatusFieldUpdateOperationsInput>;
  animalLastVisit?: InputMaybe<NullableEnumLastVisitTypeFieldUpdateOperationsInput>;
  animalRecentlyAdopted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  animalTemper?: InputMaybe<NullableEnumTemperTypeFieldUpdateOperationsInput>;
  bookingReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type BookingAnimalUpsertWithWhereUniqueWithoutAnimalInput = {
  create: BookingAnimalCreateWithoutAnimalInput;
  update: BookingAnimalUpdateWithoutAnimalInput;
  where: BookingAnimalWhereUniqueInput;
};

export type BookingAnimalUpsertWithWhereUniqueWithoutBookingInput = {
  create: BookingAnimalCreateWithoutBookingInput;
  update: BookingAnimalUpdateWithoutBookingInput;
  where: BookingAnimalWhereUniqueInput;
};

export type BookingAnimalWhereInput = {
  AND?: InputMaybe<Array<BookingAnimalWhereInput>>;
  NOT?: InputMaybe<Array<BookingAnimalWhereInput>>;
  OR?: InputMaybe<Array<BookingAnimalWhereInput>>;
  animal?: InputMaybe<AnimalRelationFilter>;
  animalBrushingFrequency?: InputMaybe<EnumFrequencyTypeNullableFilter>;
  animalFirstTimeAtGroomer?: InputMaybe<BoolNullableFilter>;
  animalHasKnottedFur?: InputMaybe<EnumYesNoUnknownStatusNullableFilter>;
  animalId?: InputMaybe<IntFilter>;
  animalLastVisit?: InputMaybe<EnumLastVisitTypeNullableFilter>;
  animalRecentlyAdopted?: InputMaybe<BoolNullableFilter>;
  animalTemper?: InputMaybe<EnumTemperTypeNullableFilter>;
  booking?: InputMaybe<BookingRelationFilter>;
  bookingId?: InputMaybe<IntFilter>;
  bookingReason?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type BookingAnimalWhereUniqueInput = {
  AND?: InputMaybe<Array<BookingAnimalWhereInput>>;
  NOT?: InputMaybe<Array<BookingAnimalWhereInput>>;
  OR?: InputMaybe<Array<BookingAnimalWhereInput>>;
  animal?: InputMaybe<AnimalRelationFilter>;
  animalBrushingFrequency?: InputMaybe<EnumFrequencyTypeNullableFilter>;
  animalFirstTimeAtGroomer?: InputMaybe<BoolNullableFilter>;
  animalHasKnottedFur?: InputMaybe<EnumYesNoUnknownStatusNullableFilter>;
  animalId?: InputMaybe<IntFilter>;
  animalLastVisit?: InputMaybe<EnumLastVisitTypeNullableFilter>;
  animalRecentlyAdopted?: InputMaybe<BoolNullableFilter>;
  animalTemper?: InputMaybe<EnumTemperTypeNullableFilter>;
  booking?: InputMaybe<BookingRelationFilter>;
  bookingId?: InputMaybe<IntFilter>;
  bookingReason?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type BookingAvailabilities = {
  __typename?: 'BookingAvailabilities';
  mergedWorkerAvailabilities?: Maybe<Array<Maybe<BookingAvailability>>>;
  nextAvailability?: Maybe<NextAvailability>;
};

export type BookingAvailability = {
  __typename?: 'BookingAvailability';
  endDateTime: Scalars['DateTime']['output'];
  startDateTime: Scalars['DateTime']['output'];
  workerIds?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  workerServiceIds?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
};

export type BookingAvgAggregateOutputType = {
  __typename?: 'BookingAvgAggregateOutputType';
  accountId?: Maybe<Scalars['Float']['output']>;
  animalId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  workerId?: Maybe<Scalars['Float']['output']>;
  workerServiceId?: Maybe<Scalars['Float']['output']>;
};

export type BookingAvgOrderByAggregateInput = {
  accountId?: InputMaybe<SortOrder>;
  animalId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  workerId?: InputMaybe<SortOrder>;
  workerServiceId?: InputMaybe<SortOrder>;
};

export type BookingCountAggregateOutputType = {
  __typename?: 'BookingCountAggregateOutputType';
  _all: Scalars['Int']['output'];
  accountId: Scalars['Int']['output'];
  animalBrushingFrequency: Scalars['Int']['output'];
  animalFirstTimeAtGroomer: Scalars['Int']['output'];
  animalHasKnottedFur: Scalars['Int']['output'];
  animalId: Scalars['Int']['output'];
  animalLastVisit: Scalars['Int']['output'];
  animalRecentlyAdopted: Scalars['Int']['output'];
  animalTemper: Scalars['Int']['output'];
  bookingReason: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  endDateTime: Scalars['Int']['output'];
  forMultiAnimals: Scalars['Int']['output'];
  googleEventId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  reminder6hSent: Scalars['Int']['output'];
  reminder24hSent: Scalars['Int']['output'];
  startDateTime: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
  workerId: Scalars['Int']['output'];
  workerServiceId: Scalars['Int']['output'];
};

export type BookingCountOrderByAggregateInput = {
  accountId?: InputMaybe<SortOrder>;
  animalBrushingFrequency?: InputMaybe<SortOrder>;
  animalFirstTimeAtGroomer?: InputMaybe<SortOrder>;
  animalHasKnottedFur?: InputMaybe<SortOrder>;
  animalId?: InputMaybe<SortOrder>;
  animalLastVisit?: InputMaybe<SortOrder>;
  animalRecentlyAdopted?: InputMaybe<SortOrder>;
  animalTemper?: InputMaybe<SortOrder>;
  bookingReason?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  endDateTime?: InputMaybe<SortOrder>;
  forMultiAnimals?: InputMaybe<SortOrder>;
  googleEventId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  reminder6hSent?: InputMaybe<SortOrder>;
  reminder24hSent?: InputMaybe<SortOrder>;
  startDateTime?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  workerId?: InputMaybe<SortOrder>;
  workerServiceId?: InputMaybe<SortOrder>;
};

export type BookingCountOutputType = {
  __typename?: 'BookingCountOutputType';
  bookingAnimals: Scalars['Int']['output'];
  emailHistory: Scalars['Int']['output'];
  notifications: Scalars['Int']['output'];
};

export type BookingCreateInput = {
  account?: InputMaybe<AccountCreateNestedOneWithoutBookingsInput>;
  animal?: InputMaybe<AnimalCreateNestedOneWithoutBookingsInput>;
  animalBrushingFrequency?: InputMaybe<FrequencyType>;
  animalFirstTimeAtGroomer?: InputMaybe<Scalars['Boolean']['input']>;
  animalHasKnottedFur?: InputMaybe<YesNoUnknownStatus>;
  animalLastVisit?: InputMaybe<LastVisitType>;
  animalRecentlyAdopted?: InputMaybe<Scalars['Boolean']['input']>;
  animalTemper?: InputMaybe<TemperType>;
  bookingAnimals?: InputMaybe<BookingAnimalCreateNestedManyWithoutBookingInput>;
  bookingReason: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  emailHistory?: InputMaybe<EmailHistoryCreateNestedManyWithoutBookingInput>;
  endDateTime: Scalars['DateTime']['input'];
  forMultiAnimals?: InputMaybe<Scalars['Boolean']['input']>;
  googleEventId: Scalars['String']['input'];
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutBookingInput>;
  reminder6hSent?: InputMaybe<Scalars['Boolean']['input']>;
  reminder24hSent?: InputMaybe<Scalars['Boolean']['input']>;
  startDateTime: Scalars['DateTime']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  worker: WorkerCreateNestedOneWithoutBookingsInput;
  workerService: WorkerServiceCreateNestedOneWithoutBookingsInput;
};

export type BookingCreateManyAccountInput = {
  animalBrushingFrequency?: InputMaybe<FrequencyType>;
  animalFirstTimeAtGroomer?: InputMaybe<Scalars['Boolean']['input']>;
  animalHasKnottedFur?: InputMaybe<YesNoUnknownStatus>;
  animalId?: InputMaybe<Scalars['Int']['input']>;
  animalLastVisit?: InputMaybe<LastVisitType>;
  animalRecentlyAdopted?: InputMaybe<Scalars['Boolean']['input']>;
  animalTemper?: InputMaybe<TemperType>;
  bookingReason: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  endDateTime: Scalars['DateTime']['input'];
  forMultiAnimals?: InputMaybe<Scalars['Boolean']['input']>;
  googleEventId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  reminder6hSent?: InputMaybe<Scalars['Boolean']['input']>;
  reminder24hSent?: InputMaybe<Scalars['Boolean']['input']>;
  startDateTime: Scalars['DateTime']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  workerId: Scalars['Int']['input'];
  workerServiceId: Scalars['Int']['input'];
};

export type BookingCreateManyAccountInputEnvelope = {
  data: Array<BookingCreateManyAccountInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BookingCreateManyAnimalInput = {
  accountId?: InputMaybe<Scalars['Int']['input']>;
  animalBrushingFrequency?: InputMaybe<FrequencyType>;
  animalFirstTimeAtGroomer?: InputMaybe<Scalars['Boolean']['input']>;
  animalHasKnottedFur?: InputMaybe<YesNoUnknownStatus>;
  animalLastVisit?: InputMaybe<LastVisitType>;
  animalRecentlyAdopted?: InputMaybe<Scalars['Boolean']['input']>;
  animalTemper?: InputMaybe<TemperType>;
  bookingReason: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  endDateTime: Scalars['DateTime']['input'];
  forMultiAnimals?: InputMaybe<Scalars['Boolean']['input']>;
  googleEventId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  reminder6hSent?: InputMaybe<Scalars['Boolean']['input']>;
  reminder24hSent?: InputMaybe<Scalars['Boolean']['input']>;
  startDateTime: Scalars['DateTime']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  workerId: Scalars['Int']['input'];
  workerServiceId: Scalars['Int']['input'];
};

export type BookingCreateManyAnimalInputEnvelope = {
  data: Array<BookingCreateManyAnimalInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BookingCreateManyInput = {
  accountId?: InputMaybe<Scalars['Int']['input']>;
  animalBrushingFrequency?: InputMaybe<FrequencyType>;
  animalFirstTimeAtGroomer?: InputMaybe<Scalars['Boolean']['input']>;
  animalHasKnottedFur?: InputMaybe<YesNoUnknownStatus>;
  animalId?: InputMaybe<Scalars['Int']['input']>;
  animalLastVisit?: InputMaybe<LastVisitType>;
  animalRecentlyAdopted?: InputMaybe<Scalars['Boolean']['input']>;
  animalTemper?: InputMaybe<TemperType>;
  bookingReason: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  endDateTime: Scalars['DateTime']['input'];
  forMultiAnimals?: InputMaybe<Scalars['Boolean']['input']>;
  googleEventId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  reminder6hSent?: InputMaybe<Scalars['Boolean']['input']>;
  reminder24hSent?: InputMaybe<Scalars['Boolean']['input']>;
  startDateTime: Scalars['DateTime']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  workerId: Scalars['Int']['input'];
  workerServiceId: Scalars['Int']['input'];
};

export type BookingCreateManyWorkerInput = {
  accountId?: InputMaybe<Scalars['Int']['input']>;
  animalBrushingFrequency?: InputMaybe<FrequencyType>;
  animalFirstTimeAtGroomer?: InputMaybe<Scalars['Boolean']['input']>;
  animalHasKnottedFur?: InputMaybe<YesNoUnknownStatus>;
  animalId?: InputMaybe<Scalars['Int']['input']>;
  animalLastVisit?: InputMaybe<LastVisitType>;
  animalRecentlyAdopted?: InputMaybe<Scalars['Boolean']['input']>;
  animalTemper?: InputMaybe<TemperType>;
  bookingReason: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  endDateTime: Scalars['DateTime']['input'];
  forMultiAnimals?: InputMaybe<Scalars['Boolean']['input']>;
  googleEventId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  reminder6hSent?: InputMaybe<Scalars['Boolean']['input']>;
  reminder24hSent?: InputMaybe<Scalars['Boolean']['input']>;
  startDateTime: Scalars['DateTime']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  workerServiceId: Scalars['Int']['input'];
};

export type BookingCreateManyWorkerInputEnvelope = {
  data: Array<BookingCreateManyWorkerInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BookingCreateManyWorkerServiceInput = {
  accountId?: InputMaybe<Scalars['Int']['input']>;
  animalBrushingFrequency?: InputMaybe<FrequencyType>;
  animalFirstTimeAtGroomer?: InputMaybe<Scalars['Boolean']['input']>;
  animalHasKnottedFur?: InputMaybe<YesNoUnknownStatus>;
  animalId?: InputMaybe<Scalars['Int']['input']>;
  animalLastVisit?: InputMaybe<LastVisitType>;
  animalRecentlyAdopted?: InputMaybe<Scalars['Boolean']['input']>;
  animalTemper?: InputMaybe<TemperType>;
  bookingReason: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  endDateTime: Scalars['DateTime']['input'];
  forMultiAnimals?: InputMaybe<Scalars['Boolean']['input']>;
  googleEventId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  reminder6hSent?: InputMaybe<Scalars['Boolean']['input']>;
  reminder24hSent?: InputMaybe<Scalars['Boolean']['input']>;
  startDateTime: Scalars['DateTime']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  workerId: Scalars['Int']['input'];
};

export type BookingCreateManyWorkerServiceInputEnvelope = {
  data: Array<BookingCreateManyWorkerServiceInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BookingCreateNestedManyWithoutAccountInput = {
  connect?: InputMaybe<Array<BookingWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<BookingCreateOrConnectWithoutAccountInput>>;
  create?: InputMaybe<Array<BookingCreateWithoutAccountInput>>;
  createMany?: InputMaybe<BookingCreateManyAccountInputEnvelope>;
};

export type BookingCreateNestedManyWithoutAnimalInput = {
  connect?: InputMaybe<Array<BookingWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<BookingCreateOrConnectWithoutAnimalInput>>;
  create?: InputMaybe<Array<BookingCreateWithoutAnimalInput>>;
  createMany?: InputMaybe<BookingCreateManyAnimalInputEnvelope>;
};

export type BookingCreateNestedManyWithoutWorkerInput = {
  connect?: InputMaybe<Array<BookingWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<BookingCreateOrConnectWithoutWorkerInput>>;
  create?: InputMaybe<Array<BookingCreateWithoutWorkerInput>>;
  createMany?: InputMaybe<BookingCreateManyWorkerInputEnvelope>;
};

export type BookingCreateNestedManyWithoutWorkerServiceInput = {
  connect?: InputMaybe<Array<BookingWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<BookingCreateOrConnectWithoutWorkerServiceInput>>;
  create?: InputMaybe<Array<BookingCreateWithoutWorkerServiceInput>>;
  createMany?: InputMaybe<BookingCreateManyWorkerServiceInputEnvelope>;
};

export type BookingCreateNestedOneWithoutBookingAnimalsInput = {
  connect?: InputMaybe<BookingWhereUniqueInput>;
  connectOrCreate?: InputMaybe<BookingCreateOrConnectWithoutBookingAnimalsInput>;
  create?: InputMaybe<BookingCreateWithoutBookingAnimalsInput>;
};

export type BookingCreateNestedOneWithoutEmailHistoryInput = {
  connect?: InputMaybe<BookingWhereUniqueInput>;
  connectOrCreate?: InputMaybe<BookingCreateOrConnectWithoutEmailHistoryInput>;
  create?: InputMaybe<BookingCreateWithoutEmailHistoryInput>;
};

export type BookingCreateNestedOneWithoutNotificationsInput = {
  connect?: InputMaybe<BookingWhereUniqueInput>;
  connectOrCreate?: InputMaybe<BookingCreateOrConnectWithoutNotificationsInput>;
  create?: InputMaybe<BookingCreateWithoutNotificationsInput>;
};

export type BookingCreateOrConnectWithoutAccountInput = {
  create: BookingCreateWithoutAccountInput;
  where: BookingWhereUniqueInput;
};

export type BookingCreateOrConnectWithoutAnimalInput = {
  create: BookingCreateWithoutAnimalInput;
  where: BookingWhereUniqueInput;
};

export type BookingCreateOrConnectWithoutBookingAnimalsInput = {
  create: BookingCreateWithoutBookingAnimalsInput;
  where: BookingWhereUniqueInput;
};

export type BookingCreateOrConnectWithoutEmailHistoryInput = {
  create: BookingCreateWithoutEmailHistoryInput;
  where: BookingWhereUniqueInput;
};

export type BookingCreateOrConnectWithoutNotificationsInput = {
  create: BookingCreateWithoutNotificationsInput;
  where: BookingWhereUniqueInput;
};

export type BookingCreateOrConnectWithoutWorkerInput = {
  create: BookingCreateWithoutWorkerInput;
  where: BookingWhereUniqueInput;
};

export type BookingCreateOrConnectWithoutWorkerServiceInput = {
  create: BookingCreateWithoutWorkerServiceInput;
  where: BookingWhereUniqueInput;
};

export type BookingCreateWithoutAccountInput = {
  animal?: InputMaybe<AnimalCreateNestedOneWithoutBookingsInput>;
  animalBrushingFrequency?: InputMaybe<FrequencyType>;
  animalFirstTimeAtGroomer?: InputMaybe<Scalars['Boolean']['input']>;
  animalHasKnottedFur?: InputMaybe<YesNoUnknownStatus>;
  animalLastVisit?: InputMaybe<LastVisitType>;
  animalRecentlyAdopted?: InputMaybe<Scalars['Boolean']['input']>;
  animalTemper?: InputMaybe<TemperType>;
  bookingAnimals?: InputMaybe<BookingAnimalCreateNestedManyWithoutBookingInput>;
  bookingReason: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  emailHistory?: InputMaybe<EmailHistoryCreateNestedManyWithoutBookingInput>;
  endDateTime: Scalars['DateTime']['input'];
  forMultiAnimals?: InputMaybe<Scalars['Boolean']['input']>;
  googleEventId: Scalars['String']['input'];
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutBookingInput>;
  reminder6hSent?: InputMaybe<Scalars['Boolean']['input']>;
  reminder24hSent?: InputMaybe<Scalars['Boolean']['input']>;
  startDateTime: Scalars['DateTime']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  worker: WorkerCreateNestedOneWithoutBookingsInput;
  workerService: WorkerServiceCreateNestedOneWithoutBookingsInput;
};

export type BookingCreateWithoutAnimalInput = {
  account?: InputMaybe<AccountCreateNestedOneWithoutBookingsInput>;
  animalBrushingFrequency?: InputMaybe<FrequencyType>;
  animalFirstTimeAtGroomer?: InputMaybe<Scalars['Boolean']['input']>;
  animalHasKnottedFur?: InputMaybe<YesNoUnknownStatus>;
  animalLastVisit?: InputMaybe<LastVisitType>;
  animalRecentlyAdopted?: InputMaybe<Scalars['Boolean']['input']>;
  animalTemper?: InputMaybe<TemperType>;
  bookingAnimals?: InputMaybe<BookingAnimalCreateNestedManyWithoutBookingInput>;
  bookingReason: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  emailHistory?: InputMaybe<EmailHistoryCreateNestedManyWithoutBookingInput>;
  endDateTime: Scalars['DateTime']['input'];
  forMultiAnimals?: InputMaybe<Scalars['Boolean']['input']>;
  googleEventId: Scalars['String']['input'];
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutBookingInput>;
  reminder6hSent?: InputMaybe<Scalars['Boolean']['input']>;
  reminder24hSent?: InputMaybe<Scalars['Boolean']['input']>;
  startDateTime: Scalars['DateTime']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  worker: WorkerCreateNestedOneWithoutBookingsInput;
  workerService: WorkerServiceCreateNestedOneWithoutBookingsInput;
};

export type BookingCreateWithoutBookingAnimalsInput = {
  account?: InputMaybe<AccountCreateNestedOneWithoutBookingsInput>;
  animal?: InputMaybe<AnimalCreateNestedOneWithoutBookingsInput>;
  animalBrushingFrequency?: InputMaybe<FrequencyType>;
  animalFirstTimeAtGroomer?: InputMaybe<Scalars['Boolean']['input']>;
  animalHasKnottedFur?: InputMaybe<YesNoUnknownStatus>;
  animalLastVisit?: InputMaybe<LastVisitType>;
  animalRecentlyAdopted?: InputMaybe<Scalars['Boolean']['input']>;
  animalTemper?: InputMaybe<TemperType>;
  bookingReason: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  emailHistory?: InputMaybe<EmailHistoryCreateNestedManyWithoutBookingInput>;
  endDateTime: Scalars['DateTime']['input'];
  forMultiAnimals?: InputMaybe<Scalars['Boolean']['input']>;
  googleEventId: Scalars['String']['input'];
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutBookingInput>;
  reminder6hSent?: InputMaybe<Scalars['Boolean']['input']>;
  reminder24hSent?: InputMaybe<Scalars['Boolean']['input']>;
  startDateTime: Scalars['DateTime']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  worker: WorkerCreateNestedOneWithoutBookingsInput;
  workerService: WorkerServiceCreateNestedOneWithoutBookingsInput;
};

export type BookingCreateWithoutEmailHistoryInput = {
  account?: InputMaybe<AccountCreateNestedOneWithoutBookingsInput>;
  animal?: InputMaybe<AnimalCreateNestedOneWithoutBookingsInput>;
  animalBrushingFrequency?: InputMaybe<FrequencyType>;
  animalFirstTimeAtGroomer?: InputMaybe<Scalars['Boolean']['input']>;
  animalHasKnottedFur?: InputMaybe<YesNoUnknownStatus>;
  animalLastVisit?: InputMaybe<LastVisitType>;
  animalRecentlyAdopted?: InputMaybe<Scalars['Boolean']['input']>;
  animalTemper?: InputMaybe<TemperType>;
  bookingAnimals?: InputMaybe<BookingAnimalCreateNestedManyWithoutBookingInput>;
  bookingReason: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  endDateTime: Scalars['DateTime']['input'];
  forMultiAnimals?: InputMaybe<Scalars['Boolean']['input']>;
  googleEventId: Scalars['String']['input'];
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutBookingInput>;
  reminder6hSent?: InputMaybe<Scalars['Boolean']['input']>;
  reminder24hSent?: InputMaybe<Scalars['Boolean']['input']>;
  startDateTime: Scalars['DateTime']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  worker: WorkerCreateNestedOneWithoutBookingsInput;
  workerService: WorkerServiceCreateNestedOneWithoutBookingsInput;
};

export type BookingCreateWithoutNotificationsInput = {
  account?: InputMaybe<AccountCreateNestedOneWithoutBookingsInput>;
  animal?: InputMaybe<AnimalCreateNestedOneWithoutBookingsInput>;
  animalBrushingFrequency?: InputMaybe<FrequencyType>;
  animalFirstTimeAtGroomer?: InputMaybe<Scalars['Boolean']['input']>;
  animalHasKnottedFur?: InputMaybe<YesNoUnknownStatus>;
  animalLastVisit?: InputMaybe<LastVisitType>;
  animalRecentlyAdopted?: InputMaybe<Scalars['Boolean']['input']>;
  animalTemper?: InputMaybe<TemperType>;
  bookingAnimals?: InputMaybe<BookingAnimalCreateNestedManyWithoutBookingInput>;
  bookingReason: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  emailHistory?: InputMaybe<EmailHistoryCreateNestedManyWithoutBookingInput>;
  endDateTime: Scalars['DateTime']['input'];
  forMultiAnimals?: InputMaybe<Scalars['Boolean']['input']>;
  googleEventId: Scalars['String']['input'];
  reminder6hSent?: InputMaybe<Scalars['Boolean']['input']>;
  reminder24hSent?: InputMaybe<Scalars['Boolean']['input']>;
  startDateTime: Scalars['DateTime']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  worker: WorkerCreateNestedOneWithoutBookingsInput;
  workerService: WorkerServiceCreateNestedOneWithoutBookingsInput;
};

export type BookingCreateWithoutWorkerInput = {
  account?: InputMaybe<AccountCreateNestedOneWithoutBookingsInput>;
  animal?: InputMaybe<AnimalCreateNestedOneWithoutBookingsInput>;
  animalBrushingFrequency?: InputMaybe<FrequencyType>;
  animalFirstTimeAtGroomer?: InputMaybe<Scalars['Boolean']['input']>;
  animalHasKnottedFur?: InputMaybe<YesNoUnknownStatus>;
  animalLastVisit?: InputMaybe<LastVisitType>;
  animalRecentlyAdopted?: InputMaybe<Scalars['Boolean']['input']>;
  animalTemper?: InputMaybe<TemperType>;
  bookingAnimals?: InputMaybe<BookingAnimalCreateNestedManyWithoutBookingInput>;
  bookingReason: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  emailHistory?: InputMaybe<EmailHistoryCreateNestedManyWithoutBookingInput>;
  endDateTime: Scalars['DateTime']['input'];
  forMultiAnimals?: InputMaybe<Scalars['Boolean']['input']>;
  googleEventId: Scalars['String']['input'];
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutBookingInput>;
  reminder6hSent?: InputMaybe<Scalars['Boolean']['input']>;
  reminder24hSent?: InputMaybe<Scalars['Boolean']['input']>;
  startDateTime: Scalars['DateTime']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  workerService: WorkerServiceCreateNestedOneWithoutBookingsInput;
};

export type BookingCreateWithoutWorkerServiceInput = {
  account?: InputMaybe<AccountCreateNestedOneWithoutBookingsInput>;
  animal?: InputMaybe<AnimalCreateNestedOneWithoutBookingsInput>;
  animalBrushingFrequency?: InputMaybe<FrequencyType>;
  animalFirstTimeAtGroomer?: InputMaybe<Scalars['Boolean']['input']>;
  animalHasKnottedFur?: InputMaybe<YesNoUnknownStatus>;
  animalLastVisit?: InputMaybe<LastVisitType>;
  animalRecentlyAdopted?: InputMaybe<Scalars['Boolean']['input']>;
  animalTemper?: InputMaybe<TemperType>;
  bookingAnimals?: InputMaybe<BookingAnimalCreateNestedManyWithoutBookingInput>;
  bookingReason: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  emailHistory?: InputMaybe<EmailHistoryCreateNestedManyWithoutBookingInput>;
  endDateTime: Scalars['DateTime']['input'];
  forMultiAnimals?: InputMaybe<Scalars['Boolean']['input']>;
  googleEventId: Scalars['String']['input'];
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutBookingInput>;
  reminder6hSent?: InputMaybe<Scalars['Boolean']['input']>;
  reminder24hSent?: InputMaybe<Scalars['Boolean']['input']>;
  startDateTime: Scalars['DateTime']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  worker: WorkerCreateNestedOneWithoutBookingsInput;
};

export type BookingDeleteOutput = {
  __typename?: 'BookingDeleteOutput';
  deletedBookingId?: Maybe<Scalars['Int']['output']>;
};

export type BookingListRelationFilter = {
  every?: InputMaybe<BookingWhereInput>;
  none?: InputMaybe<BookingWhereInput>;
  some?: InputMaybe<BookingWhereInput>;
};

export type BookingMaxAggregateOutputType = {
  __typename?: 'BookingMaxAggregateOutputType';
  accountId?: Maybe<Scalars['Int']['output']>;
  animalBrushingFrequency?: Maybe<FrequencyType>;
  animalFirstTimeAtGroomer?: Maybe<Scalars['Boolean']['output']>;
  animalHasKnottedFur?: Maybe<YesNoUnknownStatus>;
  animalId?: Maybe<Scalars['Int']['output']>;
  animalLastVisit?: Maybe<LastVisitType>;
  animalRecentlyAdopted?: Maybe<Scalars['Boolean']['output']>;
  animalTemper?: Maybe<TemperType>;
  bookingReason?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  endDateTime?: Maybe<Scalars['DateTime']['output']>;
  forMultiAnimals?: Maybe<Scalars['Boolean']['output']>;
  googleEventId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  reminder6hSent?: Maybe<Scalars['Boolean']['output']>;
  reminder24hSent?: Maybe<Scalars['Boolean']['output']>;
  startDateTime?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  workerId?: Maybe<Scalars['Int']['output']>;
  workerServiceId?: Maybe<Scalars['Int']['output']>;
};

export type BookingMaxOrderByAggregateInput = {
  accountId?: InputMaybe<SortOrder>;
  animalBrushingFrequency?: InputMaybe<SortOrder>;
  animalFirstTimeAtGroomer?: InputMaybe<SortOrder>;
  animalHasKnottedFur?: InputMaybe<SortOrder>;
  animalId?: InputMaybe<SortOrder>;
  animalLastVisit?: InputMaybe<SortOrder>;
  animalRecentlyAdopted?: InputMaybe<SortOrder>;
  animalTemper?: InputMaybe<SortOrder>;
  bookingReason?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  endDateTime?: InputMaybe<SortOrder>;
  forMultiAnimals?: InputMaybe<SortOrder>;
  googleEventId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  reminder6hSent?: InputMaybe<SortOrder>;
  reminder24hSent?: InputMaybe<SortOrder>;
  startDateTime?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  workerId?: InputMaybe<SortOrder>;
  workerServiceId?: InputMaybe<SortOrder>;
};

export type BookingMinAggregateOutputType = {
  __typename?: 'BookingMinAggregateOutputType';
  accountId?: Maybe<Scalars['Int']['output']>;
  animalBrushingFrequency?: Maybe<FrequencyType>;
  animalFirstTimeAtGroomer?: Maybe<Scalars['Boolean']['output']>;
  animalHasKnottedFur?: Maybe<YesNoUnknownStatus>;
  animalId?: Maybe<Scalars['Int']['output']>;
  animalLastVisit?: Maybe<LastVisitType>;
  animalRecentlyAdopted?: Maybe<Scalars['Boolean']['output']>;
  animalTemper?: Maybe<TemperType>;
  bookingReason?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  endDateTime?: Maybe<Scalars['DateTime']['output']>;
  forMultiAnimals?: Maybe<Scalars['Boolean']['output']>;
  googleEventId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  reminder6hSent?: Maybe<Scalars['Boolean']['output']>;
  reminder24hSent?: Maybe<Scalars['Boolean']['output']>;
  startDateTime?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  workerId?: Maybe<Scalars['Int']['output']>;
  workerServiceId?: Maybe<Scalars['Int']['output']>;
};

export type BookingMinOrderByAggregateInput = {
  accountId?: InputMaybe<SortOrder>;
  animalBrushingFrequency?: InputMaybe<SortOrder>;
  animalFirstTimeAtGroomer?: InputMaybe<SortOrder>;
  animalHasKnottedFur?: InputMaybe<SortOrder>;
  animalId?: InputMaybe<SortOrder>;
  animalLastVisit?: InputMaybe<SortOrder>;
  animalRecentlyAdopted?: InputMaybe<SortOrder>;
  animalTemper?: InputMaybe<SortOrder>;
  bookingReason?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  endDateTime?: InputMaybe<SortOrder>;
  forMultiAnimals?: InputMaybe<SortOrder>;
  googleEventId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  reminder6hSent?: InputMaybe<SortOrder>;
  reminder24hSent?: InputMaybe<SortOrder>;
  startDateTime?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  workerId?: InputMaybe<SortOrder>;
  workerServiceId?: InputMaybe<SortOrder>;
};

export type BookingNullableRelationFilter = {
  is?: InputMaybe<BookingWhereInput>;
  isNot?: InputMaybe<BookingWhereInput>;
};

export type BookingOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export enum BookingOrderByRelevanceFieldEnum {
  bookingReason = 'bookingReason',
  googleEventId = 'googleEventId'
}

export type BookingOrderByRelevanceInput = {
  fields: Array<BookingOrderByRelevanceFieldEnum>;
  search: Scalars['String']['input'];
  sort: SortOrder;
};

export type BookingOrderByWithAggregationInput = {
  _avg?: InputMaybe<BookingAvgOrderByAggregateInput>;
  _count?: InputMaybe<BookingCountOrderByAggregateInput>;
  _max?: InputMaybe<BookingMaxOrderByAggregateInput>;
  _min?: InputMaybe<BookingMinOrderByAggregateInput>;
  _sum?: InputMaybe<BookingSumOrderByAggregateInput>;
  accountId?: InputMaybe<SortOrderInput>;
  animalBrushingFrequency?: InputMaybe<SortOrderInput>;
  animalFirstTimeAtGroomer?: InputMaybe<SortOrderInput>;
  animalHasKnottedFur?: InputMaybe<SortOrderInput>;
  animalId?: InputMaybe<SortOrderInput>;
  animalLastVisit?: InputMaybe<SortOrderInput>;
  animalRecentlyAdopted?: InputMaybe<SortOrderInput>;
  animalTemper?: InputMaybe<SortOrderInput>;
  bookingReason?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  endDateTime?: InputMaybe<SortOrder>;
  forMultiAnimals?: InputMaybe<SortOrder>;
  googleEventId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  reminder6hSent?: InputMaybe<SortOrder>;
  reminder24hSent?: InputMaybe<SortOrder>;
  startDateTime?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  workerId?: InputMaybe<SortOrder>;
  workerServiceId?: InputMaybe<SortOrder>;
};

export type BookingOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: InputMaybe<BookingOrderByRelevanceInput>;
  account?: InputMaybe<AccountOrderByWithRelationAndSearchRelevanceInput>;
  accountId?: InputMaybe<SortOrderInput>;
  animal?: InputMaybe<AnimalOrderByWithRelationAndSearchRelevanceInput>;
  animalBrushingFrequency?: InputMaybe<SortOrderInput>;
  animalFirstTimeAtGroomer?: InputMaybe<SortOrderInput>;
  animalHasKnottedFur?: InputMaybe<SortOrderInput>;
  animalId?: InputMaybe<SortOrderInput>;
  animalLastVisit?: InputMaybe<SortOrderInput>;
  animalRecentlyAdopted?: InputMaybe<SortOrderInput>;
  animalTemper?: InputMaybe<SortOrderInput>;
  bookingAnimals?: InputMaybe<BookingAnimalOrderByRelationAggregateInput>;
  bookingReason?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  emailHistory?: InputMaybe<EmailHistoryOrderByRelationAggregateInput>;
  endDateTime?: InputMaybe<SortOrder>;
  forMultiAnimals?: InputMaybe<SortOrder>;
  googleEventId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  notifications?: InputMaybe<NotificationOrderByRelationAggregateInput>;
  reminder6hSent?: InputMaybe<SortOrder>;
  reminder24hSent?: InputMaybe<SortOrder>;
  startDateTime?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  worker?: InputMaybe<WorkerOrderByWithRelationAndSearchRelevanceInput>;
  workerId?: InputMaybe<SortOrder>;
  workerService?: InputMaybe<WorkerServiceOrderByWithRelationAndSearchRelevanceInput>;
  workerServiceId?: InputMaybe<SortOrder>;
};

export type BookingRelationFilter = {
  is?: InputMaybe<BookingWhereInput>;
  isNot?: InputMaybe<BookingWhereInput>;
};

export enum BookingScalarFieldEnum {
  accountId = 'accountId',
  animalBrushingFrequency = 'animalBrushingFrequency',
  animalFirstTimeAtGroomer = 'animalFirstTimeAtGroomer',
  animalHasKnottedFur = 'animalHasKnottedFur',
  animalId = 'animalId',
  animalLastVisit = 'animalLastVisit',
  animalRecentlyAdopted = 'animalRecentlyAdopted',
  animalTemper = 'animalTemper',
  bookingReason = 'bookingReason',
  createdAt = 'createdAt',
  endDateTime = 'endDateTime',
  forMultiAnimals = 'forMultiAnimals',
  googleEventId = 'googleEventId',
  id = 'id',
  reminder6hSent = 'reminder6hSent',
  reminder24hSent = 'reminder24hSent',
  startDateTime = 'startDateTime',
  updatedAt = 'updatedAt',
  workerId = 'workerId',
  workerServiceId = 'workerServiceId'
}

export type BookingScalarWhereInput = {
  AND?: InputMaybe<Array<BookingScalarWhereInput>>;
  NOT?: InputMaybe<Array<BookingScalarWhereInput>>;
  OR?: InputMaybe<Array<BookingScalarWhereInput>>;
  accountId?: InputMaybe<IntNullableFilter>;
  animalBrushingFrequency?: InputMaybe<EnumFrequencyTypeNullableFilter>;
  animalFirstTimeAtGroomer?: InputMaybe<BoolNullableFilter>;
  animalHasKnottedFur?: InputMaybe<EnumYesNoUnknownStatusNullableFilter>;
  animalId?: InputMaybe<IntNullableFilter>;
  animalLastVisit?: InputMaybe<EnumLastVisitTypeNullableFilter>;
  animalRecentlyAdopted?: InputMaybe<BoolNullableFilter>;
  animalTemper?: InputMaybe<EnumTemperTypeNullableFilter>;
  bookingReason?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  endDateTime?: InputMaybe<DateTimeFilter>;
  forMultiAnimals?: InputMaybe<BoolFilter>;
  googleEventId?: InputMaybe<StringFilter>;
  id?: InputMaybe<IntFilter>;
  reminder6hSent?: InputMaybe<BoolFilter>;
  reminder24hSent?: InputMaybe<BoolFilter>;
  startDateTime?: InputMaybe<DateTimeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  workerId?: InputMaybe<IntFilter>;
  workerServiceId?: InputMaybe<IntFilter>;
};

export type BookingScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<BookingScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<BookingScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<BookingScalarWhereWithAggregatesInput>>;
  accountId?: InputMaybe<IntNullableWithAggregatesFilter>;
  animalBrushingFrequency?: InputMaybe<EnumFrequencyTypeNullableWithAggregatesFilter>;
  animalFirstTimeAtGroomer?: InputMaybe<BoolNullableWithAggregatesFilter>;
  animalHasKnottedFur?: InputMaybe<EnumYesNoUnknownStatusNullableWithAggregatesFilter>;
  animalId?: InputMaybe<IntNullableWithAggregatesFilter>;
  animalLastVisit?: InputMaybe<EnumLastVisitTypeNullableWithAggregatesFilter>;
  animalRecentlyAdopted?: InputMaybe<BoolNullableWithAggregatesFilter>;
  animalTemper?: InputMaybe<EnumTemperTypeNullableWithAggregatesFilter>;
  bookingReason?: InputMaybe<StringWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  endDateTime?: InputMaybe<DateTimeWithAggregatesFilter>;
  forMultiAnimals?: InputMaybe<BoolWithAggregatesFilter>;
  googleEventId?: InputMaybe<StringWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  reminder6hSent?: InputMaybe<BoolWithAggregatesFilter>;
  reminder24hSent?: InputMaybe<BoolWithAggregatesFilter>;
  startDateTime?: InputMaybe<DateTimeWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  workerId?: InputMaybe<IntWithAggregatesFilter>;
  workerServiceId?: InputMaybe<IntWithAggregatesFilter>;
};

export type BookingSumAggregateOutputType = {
  __typename?: 'BookingSumAggregateOutputType';
  accountId?: Maybe<Scalars['Int']['output']>;
  animalId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  workerId?: Maybe<Scalars['Int']['output']>;
  workerServiceId?: Maybe<Scalars['Int']['output']>;
};

export type BookingSumOrderByAggregateInput = {
  accountId?: InputMaybe<SortOrder>;
  animalId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  workerId?: InputMaybe<SortOrder>;
  workerServiceId?: InputMaybe<SortOrder>;
};

export type BookingUncheckedCreateInput = {
  accountId?: InputMaybe<Scalars['Int']['input']>;
  animalBrushingFrequency?: InputMaybe<FrequencyType>;
  animalFirstTimeAtGroomer?: InputMaybe<Scalars['Boolean']['input']>;
  animalHasKnottedFur?: InputMaybe<YesNoUnknownStatus>;
  animalId?: InputMaybe<Scalars['Int']['input']>;
  animalLastVisit?: InputMaybe<LastVisitType>;
  animalRecentlyAdopted?: InputMaybe<Scalars['Boolean']['input']>;
  animalTemper?: InputMaybe<TemperType>;
  bookingAnimals?: InputMaybe<BookingAnimalUncheckedCreateNestedManyWithoutBookingInput>;
  bookingReason: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  emailHistory?: InputMaybe<EmailHistoryUncheckedCreateNestedManyWithoutBookingInput>;
  endDateTime: Scalars['DateTime']['input'];
  forMultiAnimals?: InputMaybe<Scalars['Boolean']['input']>;
  googleEventId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  notifications?: InputMaybe<NotificationUncheckedCreateNestedManyWithoutBookingInput>;
  reminder6hSent?: InputMaybe<Scalars['Boolean']['input']>;
  reminder24hSent?: InputMaybe<Scalars['Boolean']['input']>;
  startDateTime: Scalars['DateTime']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  workerId: Scalars['Int']['input'];
  workerServiceId: Scalars['Int']['input'];
};

export type BookingUncheckedCreateNestedManyWithoutAccountInput = {
  connect?: InputMaybe<Array<BookingWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<BookingCreateOrConnectWithoutAccountInput>>;
  create?: InputMaybe<Array<BookingCreateWithoutAccountInput>>;
  createMany?: InputMaybe<BookingCreateManyAccountInputEnvelope>;
};

export type BookingUncheckedCreateNestedManyWithoutAnimalInput = {
  connect?: InputMaybe<Array<BookingWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<BookingCreateOrConnectWithoutAnimalInput>>;
  create?: InputMaybe<Array<BookingCreateWithoutAnimalInput>>;
  createMany?: InputMaybe<BookingCreateManyAnimalInputEnvelope>;
};

export type BookingUncheckedCreateNestedManyWithoutWorkerInput = {
  connect?: InputMaybe<Array<BookingWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<BookingCreateOrConnectWithoutWorkerInput>>;
  create?: InputMaybe<Array<BookingCreateWithoutWorkerInput>>;
  createMany?: InputMaybe<BookingCreateManyWorkerInputEnvelope>;
};

export type BookingUncheckedCreateNestedManyWithoutWorkerServiceInput = {
  connect?: InputMaybe<Array<BookingWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<BookingCreateOrConnectWithoutWorkerServiceInput>>;
  create?: InputMaybe<Array<BookingCreateWithoutWorkerServiceInput>>;
  createMany?: InputMaybe<BookingCreateManyWorkerServiceInputEnvelope>;
};

export type BookingUncheckedCreateWithoutAccountInput = {
  animalBrushingFrequency?: InputMaybe<FrequencyType>;
  animalFirstTimeAtGroomer?: InputMaybe<Scalars['Boolean']['input']>;
  animalHasKnottedFur?: InputMaybe<YesNoUnknownStatus>;
  animalId?: InputMaybe<Scalars['Int']['input']>;
  animalLastVisit?: InputMaybe<LastVisitType>;
  animalRecentlyAdopted?: InputMaybe<Scalars['Boolean']['input']>;
  animalTemper?: InputMaybe<TemperType>;
  bookingAnimals?: InputMaybe<BookingAnimalUncheckedCreateNestedManyWithoutBookingInput>;
  bookingReason: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  emailHistory?: InputMaybe<EmailHistoryUncheckedCreateNestedManyWithoutBookingInput>;
  endDateTime: Scalars['DateTime']['input'];
  forMultiAnimals?: InputMaybe<Scalars['Boolean']['input']>;
  googleEventId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  notifications?: InputMaybe<NotificationUncheckedCreateNestedManyWithoutBookingInput>;
  reminder6hSent?: InputMaybe<Scalars['Boolean']['input']>;
  reminder24hSent?: InputMaybe<Scalars['Boolean']['input']>;
  startDateTime: Scalars['DateTime']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  workerId: Scalars['Int']['input'];
  workerServiceId: Scalars['Int']['input'];
};

export type BookingUncheckedCreateWithoutAnimalInput = {
  accountId?: InputMaybe<Scalars['Int']['input']>;
  animalBrushingFrequency?: InputMaybe<FrequencyType>;
  animalFirstTimeAtGroomer?: InputMaybe<Scalars['Boolean']['input']>;
  animalHasKnottedFur?: InputMaybe<YesNoUnknownStatus>;
  animalLastVisit?: InputMaybe<LastVisitType>;
  animalRecentlyAdopted?: InputMaybe<Scalars['Boolean']['input']>;
  animalTemper?: InputMaybe<TemperType>;
  bookingAnimals?: InputMaybe<BookingAnimalUncheckedCreateNestedManyWithoutBookingInput>;
  bookingReason: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  emailHistory?: InputMaybe<EmailHistoryUncheckedCreateNestedManyWithoutBookingInput>;
  endDateTime: Scalars['DateTime']['input'];
  forMultiAnimals?: InputMaybe<Scalars['Boolean']['input']>;
  googleEventId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  notifications?: InputMaybe<NotificationUncheckedCreateNestedManyWithoutBookingInput>;
  reminder6hSent?: InputMaybe<Scalars['Boolean']['input']>;
  reminder24hSent?: InputMaybe<Scalars['Boolean']['input']>;
  startDateTime: Scalars['DateTime']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  workerId: Scalars['Int']['input'];
  workerServiceId: Scalars['Int']['input'];
};

export type BookingUncheckedCreateWithoutBookingAnimalsInput = {
  accountId?: InputMaybe<Scalars['Int']['input']>;
  animalBrushingFrequency?: InputMaybe<FrequencyType>;
  animalFirstTimeAtGroomer?: InputMaybe<Scalars['Boolean']['input']>;
  animalHasKnottedFur?: InputMaybe<YesNoUnknownStatus>;
  animalId?: InputMaybe<Scalars['Int']['input']>;
  animalLastVisit?: InputMaybe<LastVisitType>;
  animalRecentlyAdopted?: InputMaybe<Scalars['Boolean']['input']>;
  animalTemper?: InputMaybe<TemperType>;
  bookingReason: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  emailHistory?: InputMaybe<EmailHistoryUncheckedCreateNestedManyWithoutBookingInput>;
  endDateTime: Scalars['DateTime']['input'];
  forMultiAnimals?: InputMaybe<Scalars['Boolean']['input']>;
  googleEventId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  notifications?: InputMaybe<NotificationUncheckedCreateNestedManyWithoutBookingInput>;
  reminder6hSent?: InputMaybe<Scalars['Boolean']['input']>;
  reminder24hSent?: InputMaybe<Scalars['Boolean']['input']>;
  startDateTime: Scalars['DateTime']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  workerId: Scalars['Int']['input'];
  workerServiceId: Scalars['Int']['input'];
};

export type BookingUncheckedCreateWithoutEmailHistoryInput = {
  accountId?: InputMaybe<Scalars['Int']['input']>;
  animalBrushingFrequency?: InputMaybe<FrequencyType>;
  animalFirstTimeAtGroomer?: InputMaybe<Scalars['Boolean']['input']>;
  animalHasKnottedFur?: InputMaybe<YesNoUnknownStatus>;
  animalId?: InputMaybe<Scalars['Int']['input']>;
  animalLastVisit?: InputMaybe<LastVisitType>;
  animalRecentlyAdopted?: InputMaybe<Scalars['Boolean']['input']>;
  animalTemper?: InputMaybe<TemperType>;
  bookingAnimals?: InputMaybe<BookingAnimalUncheckedCreateNestedManyWithoutBookingInput>;
  bookingReason: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  endDateTime: Scalars['DateTime']['input'];
  forMultiAnimals?: InputMaybe<Scalars['Boolean']['input']>;
  googleEventId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  notifications?: InputMaybe<NotificationUncheckedCreateNestedManyWithoutBookingInput>;
  reminder6hSent?: InputMaybe<Scalars['Boolean']['input']>;
  reminder24hSent?: InputMaybe<Scalars['Boolean']['input']>;
  startDateTime: Scalars['DateTime']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  workerId: Scalars['Int']['input'];
  workerServiceId: Scalars['Int']['input'];
};

export type BookingUncheckedCreateWithoutNotificationsInput = {
  accountId?: InputMaybe<Scalars['Int']['input']>;
  animalBrushingFrequency?: InputMaybe<FrequencyType>;
  animalFirstTimeAtGroomer?: InputMaybe<Scalars['Boolean']['input']>;
  animalHasKnottedFur?: InputMaybe<YesNoUnknownStatus>;
  animalId?: InputMaybe<Scalars['Int']['input']>;
  animalLastVisit?: InputMaybe<LastVisitType>;
  animalRecentlyAdopted?: InputMaybe<Scalars['Boolean']['input']>;
  animalTemper?: InputMaybe<TemperType>;
  bookingAnimals?: InputMaybe<BookingAnimalUncheckedCreateNestedManyWithoutBookingInput>;
  bookingReason: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  emailHistory?: InputMaybe<EmailHistoryUncheckedCreateNestedManyWithoutBookingInput>;
  endDateTime: Scalars['DateTime']['input'];
  forMultiAnimals?: InputMaybe<Scalars['Boolean']['input']>;
  googleEventId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  reminder6hSent?: InputMaybe<Scalars['Boolean']['input']>;
  reminder24hSent?: InputMaybe<Scalars['Boolean']['input']>;
  startDateTime: Scalars['DateTime']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  workerId: Scalars['Int']['input'];
  workerServiceId: Scalars['Int']['input'];
};

export type BookingUncheckedCreateWithoutWorkerInput = {
  accountId?: InputMaybe<Scalars['Int']['input']>;
  animalBrushingFrequency?: InputMaybe<FrequencyType>;
  animalFirstTimeAtGroomer?: InputMaybe<Scalars['Boolean']['input']>;
  animalHasKnottedFur?: InputMaybe<YesNoUnknownStatus>;
  animalId?: InputMaybe<Scalars['Int']['input']>;
  animalLastVisit?: InputMaybe<LastVisitType>;
  animalRecentlyAdopted?: InputMaybe<Scalars['Boolean']['input']>;
  animalTemper?: InputMaybe<TemperType>;
  bookingAnimals?: InputMaybe<BookingAnimalUncheckedCreateNestedManyWithoutBookingInput>;
  bookingReason: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  emailHistory?: InputMaybe<EmailHistoryUncheckedCreateNestedManyWithoutBookingInput>;
  endDateTime: Scalars['DateTime']['input'];
  forMultiAnimals?: InputMaybe<Scalars['Boolean']['input']>;
  googleEventId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  notifications?: InputMaybe<NotificationUncheckedCreateNestedManyWithoutBookingInput>;
  reminder6hSent?: InputMaybe<Scalars['Boolean']['input']>;
  reminder24hSent?: InputMaybe<Scalars['Boolean']['input']>;
  startDateTime: Scalars['DateTime']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  workerServiceId: Scalars['Int']['input'];
};

export type BookingUncheckedCreateWithoutWorkerServiceInput = {
  accountId?: InputMaybe<Scalars['Int']['input']>;
  animalBrushingFrequency?: InputMaybe<FrequencyType>;
  animalFirstTimeAtGroomer?: InputMaybe<Scalars['Boolean']['input']>;
  animalHasKnottedFur?: InputMaybe<YesNoUnknownStatus>;
  animalId?: InputMaybe<Scalars['Int']['input']>;
  animalLastVisit?: InputMaybe<LastVisitType>;
  animalRecentlyAdopted?: InputMaybe<Scalars['Boolean']['input']>;
  animalTemper?: InputMaybe<TemperType>;
  bookingAnimals?: InputMaybe<BookingAnimalUncheckedCreateNestedManyWithoutBookingInput>;
  bookingReason: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  emailHistory?: InputMaybe<EmailHistoryUncheckedCreateNestedManyWithoutBookingInput>;
  endDateTime: Scalars['DateTime']['input'];
  forMultiAnimals?: InputMaybe<Scalars['Boolean']['input']>;
  googleEventId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  notifications?: InputMaybe<NotificationUncheckedCreateNestedManyWithoutBookingInput>;
  reminder6hSent?: InputMaybe<Scalars['Boolean']['input']>;
  reminder24hSent?: InputMaybe<Scalars['Boolean']['input']>;
  startDateTime: Scalars['DateTime']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  workerId: Scalars['Int']['input'];
};

export type BookingUncheckedUpdateInput = {
  accountId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  animalBrushingFrequency?: InputMaybe<NullableEnumFrequencyTypeFieldUpdateOperationsInput>;
  animalFirstTimeAtGroomer?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  animalHasKnottedFur?: InputMaybe<NullableEnumYesNoUnknownStatusFieldUpdateOperationsInput>;
  animalId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  animalLastVisit?: InputMaybe<NullableEnumLastVisitTypeFieldUpdateOperationsInput>;
  animalRecentlyAdopted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  animalTemper?: InputMaybe<NullableEnumTemperTypeFieldUpdateOperationsInput>;
  bookingAnimals?: InputMaybe<BookingAnimalUncheckedUpdateManyWithoutBookingNestedInput>;
  bookingReason?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  emailHistory?: InputMaybe<EmailHistoryUncheckedUpdateManyWithoutBookingNestedInput>;
  endDateTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  forMultiAnimals?: InputMaybe<BoolFieldUpdateOperationsInput>;
  googleEventId?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUncheckedUpdateManyWithoutBookingNestedInput>;
  reminder6hSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  reminder24hSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  startDateTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  workerId?: InputMaybe<IntFieldUpdateOperationsInput>;
  workerServiceId?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type BookingUncheckedUpdateManyInput = {
  accountId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  animalBrushingFrequency?: InputMaybe<NullableEnumFrequencyTypeFieldUpdateOperationsInput>;
  animalFirstTimeAtGroomer?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  animalHasKnottedFur?: InputMaybe<NullableEnumYesNoUnknownStatusFieldUpdateOperationsInput>;
  animalId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  animalLastVisit?: InputMaybe<NullableEnumLastVisitTypeFieldUpdateOperationsInput>;
  animalRecentlyAdopted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  animalTemper?: InputMaybe<NullableEnumTemperTypeFieldUpdateOperationsInput>;
  bookingReason?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  endDateTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  forMultiAnimals?: InputMaybe<BoolFieldUpdateOperationsInput>;
  googleEventId?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  reminder6hSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  reminder24hSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  startDateTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  workerId?: InputMaybe<IntFieldUpdateOperationsInput>;
  workerServiceId?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type BookingUncheckedUpdateManyWithoutAccountInput = {
  animalBrushingFrequency?: InputMaybe<NullableEnumFrequencyTypeFieldUpdateOperationsInput>;
  animalFirstTimeAtGroomer?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  animalHasKnottedFur?: InputMaybe<NullableEnumYesNoUnknownStatusFieldUpdateOperationsInput>;
  animalId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  animalLastVisit?: InputMaybe<NullableEnumLastVisitTypeFieldUpdateOperationsInput>;
  animalRecentlyAdopted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  animalTemper?: InputMaybe<NullableEnumTemperTypeFieldUpdateOperationsInput>;
  bookingReason?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  endDateTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  forMultiAnimals?: InputMaybe<BoolFieldUpdateOperationsInput>;
  googleEventId?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  reminder6hSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  reminder24hSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  startDateTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  workerId?: InputMaybe<IntFieldUpdateOperationsInput>;
  workerServiceId?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type BookingUncheckedUpdateManyWithoutAccountNestedInput = {
  connect?: InputMaybe<Array<BookingWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<BookingCreateOrConnectWithoutAccountInput>>;
  create?: InputMaybe<Array<BookingCreateWithoutAccountInput>>;
  createMany?: InputMaybe<BookingCreateManyAccountInputEnvelope>;
  delete?: InputMaybe<Array<BookingWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<BookingScalarWhereInput>>;
  disconnect?: InputMaybe<Array<BookingWhereUniqueInput>>;
  set?: InputMaybe<Array<BookingWhereUniqueInput>>;
  update?: InputMaybe<Array<BookingUpdateWithWhereUniqueWithoutAccountInput>>;
  updateMany?: InputMaybe<Array<BookingUpdateManyWithWhereWithoutAccountInput>>;
  upsert?: InputMaybe<Array<BookingUpsertWithWhereUniqueWithoutAccountInput>>;
};

export type BookingUncheckedUpdateManyWithoutAnimalInput = {
  accountId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  animalBrushingFrequency?: InputMaybe<NullableEnumFrequencyTypeFieldUpdateOperationsInput>;
  animalFirstTimeAtGroomer?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  animalHasKnottedFur?: InputMaybe<NullableEnumYesNoUnknownStatusFieldUpdateOperationsInput>;
  animalLastVisit?: InputMaybe<NullableEnumLastVisitTypeFieldUpdateOperationsInput>;
  animalRecentlyAdopted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  animalTemper?: InputMaybe<NullableEnumTemperTypeFieldUpdateOperationsInput>;
  bookingReason?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  endDateTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  forMultiAnimals?: InputMaybe<BoolFieldUpdateOperationsInput>;
  googleEventId?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  reminder6hSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  reminder24hSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  startDateTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  workerId?: InputMaybe<IntFieldUpdateOperationsInput>;
  workerServiceId?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type BookingUncheckedUpdateManyWithoutAnimalNestedInput = {
  connect?: InputMaybe<Array<BookingWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<BookingCreateOrConnectWithoutAnimalInput>>;
  create?: InputMaybe<Array<BookingCreateWithoutAnimalInput>>;
  createMany?: InputMaybe<BookingCreateManyAnimalInputEnvelope>;
  delete?: InputMaybe<Array<BookingWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<BookingScalarWhereInput>>;
  disconnect?: InputMaybe<Array<BookingWhereUniqueInput>>;
  set?: InputMaybe<Array<BookingWhereUniqueInput>>;
  update?: InputMaybe<Array<BookingUpdateWithWhereUniqueWithoutAnimalInput>>;
  updateMany?: InputMaybe<Array<BookingUpdateManyWithWhereWithoutAnimalInput>>;
  upsert?: InputMaybe<Array<BookingUpsertWithWhereUniqueWithoutAnimalInput>>;
};

export type BookingUncheckedUpdateManyWithoutWorkerInput = {
  accountId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  animalBrushingFrequency?: InputMaybe<NullableEnumFrequencyTypeFieldUpdateOperationsInput>;
  animalFirstTimeAtGroomer?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  animalHasKnottedFur?: InputMaybe<NullableEnumYesNoUnknownStatusFieldUpdateOperationsInput>;
  animalId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  animalLastVisit?: InputMaybe<NullableEnumLastVisitTypeFieldUpdateOperationsInput>;
  animalRecentlyAdopted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  animalTemper?: InputMaybe<NullableEnumTemperTypeFieldUpdateOperationsInput>;
  bookingReason?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  endDateTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  forMultiAnimals?: InputMaybe<BoolFieldUpdateOperationsInput>;
  googleEventId?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  reminder6hSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  reminder24hSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  startDateTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  workerServiceId?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type BookingUncheckedUpdateManyWithoutWorkerNestedInput = {
  connect?: InputMaybe<Array<BookingWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<BookingCreateOrConnectWithoutWorkerInput>>;
  create?: InputMaybe<Array<BookingCreateWithoutWorkerInput>>;
  createMany?: InputMaybe<BookingCreateManyWorkerInputEnvelope>;
  delete?: InputMaybe<Array<BookingWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<BookingScalarWhereInput>>;
  disconnect?: InputMaybe<Array<BookingWhereUniqueInput>>;
  set?: InputMaybe<Array<BookingWhereUniqueInput>>;
  update?: InputMaybe<Array<BookingUpdateWithWhereUniqueWithoutWorkerInput>>;
  updateMany?: InputMaybe<Array<BookingUpdateManyWithWhereWithoutWorkerInput>>;
  upsert?: InputMaybe<Array<BookingUpsertWithWhereUniqueWithoutWorkerInput>>;
};

export type BookingUncheckedUpdateManyWithoutWorkerServiceInput = {
  accountId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  animalBrushingFrequency?: InputMaybe<NullableEnumFrequencyTypeFieldUpdateOperationsInput>;
  animalFirstTimeAtGroomer?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  animalHasKnottedFur?: InputMaybe<NullableEnumYesNoUnknownStatusFieldUpdateOperationsInput>;
  animalId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  animalLastVisit?: InputMaybe<NullableEnumLastVisitTypeFieldUpdateOperationsInput>;
  animalRecentlyAdopted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  animalTemper?: InputMaybe<NullableEnumTemperTypeFieldUpdateOperationsInput>;
  bookingReason?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  endDateTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  forMultiAnimals?: InputMaybe<BoolFieldUpdateOperationsInput>;
  googleEventId?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  reminder6hSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  reminder24hSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  startDateTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  workerId?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type BookingUncheckedUpdateManyWithoutWorkerServiceNestedInput = {
  connect?: InputMaybe<Array<BookingWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<BookingCreateOrConnectWithoutWorkerServiceInput>>;
  create?: InputMaybe<Array<BookingCreateWithoutWorkerServiceInput>>;
  createMany?: InputMaybe<BookingCreateManyWorkerServiceInputEnvelope>;
  delete?: InputMaybe<Array<BookingWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<BookingScalarWhereInput>>;
  disconnect?: InputMaybe<Array<BookingWhereUniqueInput>>;
  set?: InputMaybe<Array<BookingWhereUniqueInput>>;
  update?: InputMaybe<Array<BookingUpdateWithWhereUniqueWithoutWorkerServiceInput>>;
  updateMany?: InputMaybe<Array<BookingUpdateManyWithWhereWithoutWorkerServiceInput>>;
  upsert?: InputMaybe<Array<BookingUpsertWithWhereUniqueWithoutWorkerServiceInput>>;
};

export type BookingUncheckedUpdateWithoutAccountInput = {
  animalBrushingFrequency?: InputMaybe<NullableEnumFrequencyTypeFieldUpdateOperationsInput>;
  animalFirstTimeAtGroomer?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  animalHasKnottedFur?: InputMaybe<NullableEnumYesNoUnknownStatusFieldUpdateOperationsInput>;
  animalId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  animalLastVisit?: InputMaybe<NullableEnumLastVisitTypeFieldUpdateOperationsInput>;
  animalRecentlyAdopted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  animalTemper?: InputMaybe<NullableEnumTemperTypeFieldUpdateOperationsInput>;
  bookingAnimals?: InputMaybe<BookingAnimalUncheckedUpdateManyWithoutBookingNestedInput>;
  bookingReason?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  emailHistory?: InputMaybe<EmailHistoryUncheckedUpdateManyWithoutBookingNestedInput>;
  endDateTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  forMultiAnimals?: InputMaybe<BoolFieldUpdateOperationsInput>;
  googleEventId?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUncheckedUpdateManyWithoutBookingNestedInput>;
  reminder6hSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  reminder24hSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  startDateTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  workerId?: InputMaybe<IntFieldUpdateOperationsInput>;
  workerServiceId?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type BookingUncheckedUpdateWithoutAnimalInput = {
  accountId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  animalBrushingFrequency?: InputMaybe<NullableEnumFrequencyTypeFieldUpdateOperationsInput>;
  animalFirstTimeAtGroomer?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  animalHasKnottedFur?: InputMaybe<NullableEnumYesNoUnknownStatusFieldUpdateOperationsInput>;
  animalLastVisit?: InputMaybe<NullableEnumLastVisitTypeFieldUpdateOperationsInput>;
  animalRecentlyAdopted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  animalTemper?: InputMaybe<NullableEnumTemperTypeFieldUpdateOperationsInput>;
  bookingAnimals?: InputMaybe<BookingAnimalUncheckedUpdateManyWithoutBookingNestedInput>;
  bookingReason?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  emailHistory?: InputMaybe<EmailHistoryUncheckedUpdateManyWithoutBookingNestedInput>;
  endDateTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  forMultiAnimals?: InputMaybe<BoolFieldUpdateOperationsInput>;
  googleEventId?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUncheckedUpdateManyWithoutBookingNestedInput>;
  reminder6hSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  reminder24hSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  startDateTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  workerId?: InputMaybe<IntFieldUpdateOperationsInput>;
  workerServiceId?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type BookingUncheckedUpdateWithoutBookingAnimalsInput = {
  accountId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  animalBrushingFrequency?: InputMaybe<NullableEnumFrequencyTypeFieldUpdateOperationsInput>;
  animalFirstTimeAtGroomer?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  animalHasKnottedFur?: InputMaybe<NullableEnumYesNoUnknownStatusFieldUpdateOperationsInput>;
  animalId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  animalLastVisit?: InputMaybe<NullableEnumLastVisitTypeFieldUpdateOperationsInput>;
  animalRecentlyAdopted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  animalTemper?: InputMaybe<NullableEnumTemperTypeFieldUpdateOperationsInput>;
  bookingReason?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  emailHistory?: InputMaybe<EmailHistoryUncheckedUpdateManyWithoutBookingNestedInput>;
  endDateTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  forMultiAnimals?: InputMaybe<BoolFieldUpdateOperationsInput>;
  googleEventId?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUncheckedUpdateManyWithoutBookingNestedInput>;
  reminder6hSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  reminder24hSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  startDateTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  workerId?: InputMaybe<IntFieldUpdateOperationsInput>;
  workerServiceId?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type BookingUncheckedUpdateWithoutEmailHistoryInput = {
  accountId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  animalBrushingFrequency?: InputMaybe<NullableEnumFrequencyTypeFieldUpdateOperationsInput>;
  animalFirstTimeAtGroomer?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  animalHasKnottedFur?: InputMaybe<NullableEnumYesNoUnknownStatusFieldUpdateOperationsInput>;
  animalId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  animalLastVisit?: InputMaybe<NullableEnumLastVisitTypeFieldUpdateOperationsInput>;
  animalRecentlyAdopted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  animalTemper?: InputMaybe<NullableEnumTemperTypeFieldUpdateOperationsInput>;
  bookingAnimals?: InputMaybe<BookingAnimalUncheckedUpdateManyWithoutBookingNestedInput>;
  bookingReason?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  endDateTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  forMultiAnimals?: InputMaybe<BoolFieldUpdateOperationsInput>;
  googleEventId?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUncheckedUpdateManyWithoutBookingNestedInput>;
  reminder6hSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  reminder24hSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  startDateTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  workerId?: InputMaybe<IntFieldUpdateOperationsInput>;
  workerServiceId?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type BookingUncheckedUpdateWithoutNotificationsInput = {
  accountId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  animalBrushingFrequency?: InputMaybe<NullableEnumFrequencyTypeFieldUpdateOperationsInput>;
  animalFirstTimeAtGroomer?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  animalHasKnottedFur?: InputMaybe<NullableEnumYesNoUnknownStatusFieldUpdateOperationsInput>;
  animalId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  animalLastVisit?: InputMaybe<NullableEnumLastVisitTypeFieldUpdateOperationsInput>;
  animalRecentlyAdopted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  animalTemper?: InputMaybe<NullableEnumTemperTypeFieldUpdateOperationsInput>;
  bookingAnimals?: InputMaybe<BookingAnimalUncheckedUpdateManyWithoutBookingNestedInput>;
  bookingReason?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  emailHistory?: InputMaybe<EmailHistoryUncheckedUpdateManyWithoutBookingNestedInput>;
  endDateTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  forMultiAnimals?: InputMaybe<BoolFieldUpdateOperationsInput>;
  googleEventId?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  reminder6hSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  reminder24hSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  startDateTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  workerId?: InputMaybe<IntFieldUpdateOperationsInput>;
  workerServiceId?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type BookingUncheckedUpdateWithoutWorkerInput = {
  accountId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  animalBrushingFrequency?: InputMaybe<NullableEnumFrequencyTypeFieldUpdateOperationsInput>;
  animalFirstTimeAtGroomer?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  animalHasKnottedFur?: InputMaybe<NullableEnumYesNoUnknownStatusFieldUpdateOperationsInput>;
  animalId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  animalLastVisit?: InputMaybe<NullableEnumLastVisitTypeFieldUpdateOperationsInput>;
  animalRecentlyAdopted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  animalTemper?: InputMaybe<NullableEnumTemperTypeFieldUpdateOperationsInput>;
  bookingAnimals?: InputMaybe<BookingAnimalUncheckedUpdateManyWithoutBookingNestedInput>;
  bookingReason?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  emailHistory?: InputMaybe<EmailHistoryUncheckedUpdateManyWithoutBookingNestedInput>;
  endDateTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  forMultiAnimals?: InputMaybe<BoolFieldUpdateOperationsInput>;
  googleEventId?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUncheckedUpdateManyWithoutBookingNestedInput>;
  reminder6hSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  reminder24hSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  startDateTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  workerServiceId?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type BookingUncheckedUpdateWithoutWorkerServiceInput = {
  accountId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  animalBrushingFrequency?: InputMaybe<NullableEnumFrequencyTypeFieldUpdateOperationsInput>;
  animalFirstTimeAtGroomer?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  animalHasKnottedFur?: InputMaybe<NullableEnumYesNoUnknownStatusFieldUpdateOperationsInput>;
  animalId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  animalLastVisit?: InputMaybe<NullableEnumLastVisitTypeFieldUpdateOperationsInput>;
  animalRecentlyAdopted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  animalTemper?: InputMaybe<NullableEnumTemperTypeFieldUpdateOperationsInput>;
  bookingAnimals?: InputMaybe<BookingAnimalUncheckedUpdateManyWithoutBookingNestedInput>;
  bookingReason?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  emailHistory?: InputMaybe<EmailHistoryUncheckedUpdateManyWithoutBookingNestedInput>;
  endDateTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  forMultiAnimals?: InputMaybe<BoolFieldUpdateOperationsInput>;
  googleEventId?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUncheckedUpdateManyWithoutBookingNestedInput>;
  reminder6hSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  reminder24hSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  startDateTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  workerId?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type BookingUpdateInput = {
  account?: InputMaybe<AccountUpdateOneWithoutBookingsNestedInput>;
  animal?: InputMaybe<AnimalUpdateOneWithoutBookingsNestedInput>;
  animalBrushingFrequency?: InputMaybe<NullableEnumFrequencyTypeFieldUpdateOperationsInput>;
  animalFirstTimeAtGroomer?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  animalHasKnottedFur?: InputMaybe<NullableEnumYesNoUnknownStatusFieldUpdateOperationsInput>;
  animalLastVisit?: InputMaybe<NullableEnumLastVisitTypeFieldUpdateOperationsInput>;
  animalRecentlyAdopted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  animalTemper?: InputMaybe<NullableEnumTemperTypeFieldUpdateOperationsInput>;
  bookingAnimals?: InputMaybe<BookingAnimalUpdateManyWithoutBookingNestedInput>;
  bookingReason?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  emailHistory?: InputMaybe<EmailHistoryUpdateManyWithoutBookingNestedInput>;
  endDateTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  forMultiAnimals?: InputMaybe<BoolFieldUpdateOperationsInput>;
  googleEventId?: InputMaybe<StringFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutBookingNestedInput>;
  reminder6hSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  reminder24hSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  startDateTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  worker?: InputMaybe<WorkerUpdateOneRequiredWithoutBookingsNestedInput>;
  workerService?: InputMaybe<WorkerServiceUpdateOneRequiredWithoutBookingsNestedInput>;
};

export type BookingUpdateManyMutationInput = {
  animalBrushingFrequency?: InputMaybe<NullableEnumFrequencyTypeFieldUpdateOperationsInput>;
  animalFirstTimeAtGroomer?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  animalHasKnottedFur?: InputMaybe<NullableEnumYesNoUnknownStatusFieldUpdateOperationsInput>;
  animalLastVisit?: InputMaybe<NullableEnumLastVisitTypeFieldUpdateOperationsInput>;
  animalRecentlyAdopted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  animalTemper?: InputMaybe<NullableEnumTemperTypeFieldUpdateOperationsInput>;
  bookingReason?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  endDateTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  forMultiAnimals?: InputMaybe<BoolFieldUpdateOperationsInput>;
  googleEventId?: InputMaybe<StringFieldUpdateOperationsInput>;
  reminder6hSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  reminder24hSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  startDateTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type BookingUpdateManyWithWhereWithoutAccountInput = {
  data: BookingUpdateManyMutationInput;
  where: BookingScalarWhereInput;
};

export type BookingUpdateManyWithWhereWithoutAnimalInput = {
  data: BookingUpdateManyMutationInput;
  where: BookingScalarWhereInput;
};

export type BookingUpdateManyWithWhereWithoutWorkerInput = {
  data: BookingUpdateManyMutationInput;
  where: BookingScalarWhereInput;
};

export type BookingUpdateManyWithWhereWithoutWorkerServiceInput = {
  data: BookingUpdateManyMutationInput;
  where: BookingScalarWhereInput;
};

export type BookingUpdateManyWithoutAccountNestedInput = {
  connect?: InputMaybe<Array<BookingWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<BookingCreateOrConnectWithoutAccountInput>>;
  create?: InputMaybe<Array<BookingCreateWithoutAccountInput>>;
  createMany?: InputMaybe<BookingCreateManyAccountInputEnvelope>;
  delete?: InputMaybe<Array<BookingWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<BookingScalarWhereInput>>;
  disconnect?: InputMaybe<Array<BookingWhereUniqueInput>>;
  set?: InputMaybe<Array<BookingWhereUniqueInput>>;
  update?: InputMaybe<Array<BookingUpdateWithWhereUniqueWithoutAccountInput>>;
  updateMany?: InputMaybe<Array<BookingUpdateManyWithWhereWithoutAccountInput>>;
  upsert?: InputMaybe<Array<BookingUpsertWithWhereUniqueWithoutAccountInput>>;
};

export type BookingUpdateManyWithoutAnimalNestedInput = {
  connect?: InputMaybe<Array<BookingWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<BookingCreateOrConnectWithoutAnimalInput>>;
  create?: InputMaybe<Array<BookingCreateWithoutAnimalInput>>;
  createMany?: InputMaybe<BookingCreateManyAnimalInputEnvelope>;
  delete?: InputMaybe<Array<BookingWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<BookingScalarWhereInput>>;
  disconnect?: InputMaybe<Array<BookingWhereUniqueInput>>;
  set?: InputMaybe<Array<BookingWhereUniqueInput>>;
  update?: InputMaybe<Array<BookingUpdateWithWhereUniqueWithoutAnimalInput>>;
  updateMany?: InputMaybe<Array<BookingUpdateManyWithWhereWithoutAnimalInput>>;
  upsert?: InputMaybe<Array<BookingUpsertWithWhereUniqueWithoutAnimalInput>>;
};

export type BookingUpdateManyWithoutWorkerNestedInput = {
  connect?: InputMaybe<Array<BookingWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<BookingCreateOrConnectWithoutWorkerInput>>;
  create?: InputMaybe<Array<BookingCreateWithoutWorkerInput>>;
  createMany?: InputMaybe<BookingCreateManyWorkerInputEnvelope>;
  delete?: InputMaybe<Array<BookingWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<BookingScalarWhereInput>>;
  disconnect?: InputMaybe<Array<BookingWhereUniqueInput>>;
  set?: InputMaybe<Array<BookingWhereUniqueInput>>;
  update?: InputMaybe<Array<BookingUpdateWithWhereUniqueWithoutWorkerInput>>;
  updateMany?: InputMaybe<Array<BookingUpdateManyWithWhereWithoutWorkerInput>>;
  upsert?: InputMaybe<Array<BookingUpsertWithWhereUniqueWithoutWorkerInput>>;
};

export type BookingUpdateManyWithoutWorkerServiceNestedInput = {
  connect?: InputMaybe<Array<BookingWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<BookingCreateOrConnectWithoutWorkerServiceInput>>;
  create?: InputMaybe<Array<BookingCreateWithoutWorkerServiceInput>>;
  createMany?: InputMaybe<BookingCreateManyWorkerServiceInputEnvelope>;
  delete?: InputMaybe<Array<BookingWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<BookingScalarWhereInput>>;
  disconnect?: InputMaybe<Array<BookingWhereUniqueInput>>;
  set?: InputMaybe<Array<BookingWhereUniqueInput>>;
  update?: InputMaybe<Array<BookingUpdateWithWhereUniqueWithoutWorkerServiceInput>>;
  updateMany?: InputMaybe<Array<BookingUpdateManyWithWhereWithoutWorkerServiceInput>>;
  upsert?: InputMaybe<Array<BookingUpsertWithWhereUniqueWithoutWorkerServiceInput>>;
};

export type BookingUpdateOneRequiredWithoutBookingAnimalsNestedInput = {
  connect?: InputMaybe<BookingWhereUniqueInput>;
  connectOrCreate?: InputMaybe<BookingCreateOrConnectWithoutBookingAnimalsInput>;
  create?: InputMaybe<BookingCreateWithoutBookingAnimalsInput>;
  update?: InputMaybe<BookingUpdateToOneWithWhereWithoutBookingAnimalsInput>;
  upsert?: InputMaybe<BookingUpsertWithoutBookingAnimalsInput>;
};

export type BookingUpdateOneWithoutEmailHistoryNestedInput = {
  connect?: InputMaybe<BookingWhereUniqueInput>;
  connectOrCreate?: InputMaybe<BookingCreateOrConnectWithoutEmailHistoryInput>;
  create?: InputMaybe<BookingCreateWithoutEmailHistoryInput>;
  delete?: InputMaybe<BookingWhereInput>;
  disconnect?: InputMaybe<BookingWhereInput>;
  update?: InputMaybe<BookingUpdateToOneWithWhereWithoutEmailHistoryInput>;
  upsert?: InputMaybe<BookingUpsertWithoutEmailHistoryInput>;
};

export type BookingUpdateOneWithoutNotificationsNestedInput = {
  connect?: InputMaybe<BookingWhereUniqueInput>;
  connectOrCreate?: InputMaybe<BookingCreateOrConnectWithoutNotificationsInput>;
  create?: InputMaybe<BookingCreateWithoutNotificationsInput>;
  delete?: InputMaybe<BookingWhereInput>;
  disconnect?: InputMaybe<BookingWhereInput>;
  update?: InputMaybe<BookingUpdateToOneWithWhereWithoutNotificationsInput>;
  upsert?: InputMaybe<BookingUpsertWithoutNotificationsInput>;
};

export type BookingUpdateToOneWithWhereWithoutBookingAnimalsInput = {
  data: BookingUpdateWithoutBookingAnimalsInput;
  where?: InputMaybe<BookingWhereInput>;
};

export type BookingUpdateToOneWithWhereWithoutEmailHistoryInput = {
  data: BookingUpdateWithoutEmailHistoryInput;
  where?: InputMaybe<BookingWhereInput>;
};

export type BookingUpdateToOneWithWhereWithoutNotificationsInput = {
  data: BookingUpdateWithoutNotificationsInput;
  where?: InputMaybe<BookingWhereInput>;
};

export type BookingUpdateWithWhereUniqueWithoutAccountInput = {
  data: BookingUpdateWithoutAccountInput;
  where: BookingWhereUniqueInput;
};

export type BookingUpdateWithWhereUniqueWithoutAnimalInput = {
  data: BookingUpdateWithoutAnimalInput;
  where: BookingWhereUniqueInput;
};

export type BookingUpdateWithWhereUniqueWithoutWorkerInput = {
  data: BookingUpdateWithoutWorkerInput;
  where: BookingWhereUniqueInput;
};

export type BookingUpdateWithWhereUniqueWithoutWorkerServiceInput = {
  data: BookingUpdateWithoutWorkerServiceInput;
  where: BookingWhereUniqueInput;
};

export type BookingUpdateWithoutAccountInput = {
  animal?: InputMaybe<AnimalUpdateOneWithoutBookingsNestedInput>;
  animalBrushingFrequency?: InputMaybe<NullableEnumFrequencyTypeFieldUpdateOperationsInput>;
  animalFirstTimeAtGroomer?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  animalHasKnottedFur?: InputMaybe<NullableEnumYesNoUnknownStatusFieldUpdateOperationsInput>;
  animalLastVisit?: InputMaybe<NullableEnumLastVisitTypeFieldUpdateOperationsInput>;
  animalRecentlyAdopted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  animalTemper?: InputMaybe<NullableEnumTemperTypeFieldUpdateOperationsInput>;
  bookingAnimals?: InputMaybe<BookingAnimalUpdateManyWithoutBookingNestedInput>;
  bookingReason?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  emailHistory?: InputMaybe<EmailHistoryUpdateManyWithoutBookingNestedInput>;
  endDateTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  forMultiAnimals?: InputMaybe<BoolFieldUpdateOperationsInput>;
  googleEventId?: InputMaybe<StringFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutBookingNestedInput>;
  reminder6hSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  reminder24hSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  startDateTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  worker?: InputMaybe<WorkerUpdateOneRequiredWithoutBookingsNestedInput>;
  workerService?: InputMaybe<WorkerServiceUpdateOneRequiredWithoutBookingsNestedInput>;
};

export type BookingUpdateWithoutAnimalInput = {
  account?: InputMaybe<AccountUpdateOneWithoutBookingsNestedInput>;
  animalBrushingFrequency?: InputMaybe<NullableEnumFrequencyTypeFieldUpdateOperationsInput>;
  animalFirstTimeAtGroomer?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  animalHasKnottedFur?: InputMaybe<NullableEnumYesNoUnknownStatusFieldUpdateOperationsInput>;
  animalLastVisit?: InputMaybe<NullableEnumLastVisitTypeFieldUpdateOperationsInput>;
  animalRecentlyAdopted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  animalTemper?: InputMaybe<NullableEnumTemperTypeFieldUpdateOperationsInput>;
  bookingAnimals?: InputMaybe<BookingAnimalUpdateManyWithoutBookingNestedInput>;
  bookingReason?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  emailHistory?: InputMaybe<EmailHistoryUpdateManyWithoutBookingNestedInput>;
  endDateTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  forMultiAnimals?: InputMaybe<BoolFieldUpdateOperationsInput>;
  googleEventId?: InputMaybe<StringFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutBookingNestedInput>;
  reminder6hSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  reminder24hSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  startDateTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  worker?: InputMaybe<WorkerUpdateOneRequiredWithoutBookingsNestedInput>;
  workerService?: InputMaybe<WorkerServiceUpdateOneRequiredWithoutBookingsNestedInput>;
};

export type BookingUpdateWithoutBookingAnimalsInput = {
  account?: InputMaybe<AccountUpdateOneWithoutBookingsNestedInput>;
  animal?: InputMaybe<AnimalUpdateOneWithoutBookingsNestedInput>;
  animalBrushingFrequency?: InputMaybe<NullableEnumFrequencyTypeFieldUpdateOperationsInput>;
  animalFirstTimeAtGroomer?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  animalHasKnottedFur?: InputMaybe<NullableEnumYesNoUnknownStatusFieldUpdateOperationsInput>;
  animalLastVisit?: InputMaybe<NullableEnumLastVisitTypeFieldUpdateOperationsInput>;
  animalRecentlyAdopted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  animalTemper?: InputMaybe<NullableEnumTemperTypeFieldUpdateOperationsInput>;
  bookingReason?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  emailHistory?: InputMaybe<EmailHistoryUpdateManyWithoutBookingNestedInput>;
  endDateTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  forMultiAnimals?: InputMaybe<BoolFieldUpdateOperationsInput>;
  googleEventId?: InputMaybe<StringFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutBookingNestedInput>;
  reminder6hSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  reminder24hSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  startDateTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  worker?: InputMaybe<WorkerUpdateOneRequiredWithoutBookingsNestedInput>;
  workerService?: InputMaybe<WorkerServiceUpdateOneRequiredWithoutBookingsNestedInput>;
};

export type BookingUpdateWithoutEmailHistoryInput = {
  account?: InputMaybe<AccountUpdateOneWithoutBookingsNestedInput>;
  animal?: InputMaybe<AnimalUpdateOneWithoutBookingsNestedInput>;
  animalBrushingFrequency?: InputMaybe<NullableEnumFrequencyTypeFieldUpdateOperationsInput>;
  animalFirstTimeAtGroomer?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  animalHasKnottedFur?: InputMaybe<NullableEnumYesNoUnknownStatusFieldUpdateOperationsInput>;
  animalLastVisit?: InputMaybe<NullableEnumLastVisitTypeFieldUpdateOperationsInput>;
  animalRecentlyAdopted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  animalTemper?: InputMaybe<NullableEnumTemperTypeFieldUpdateOperationsInput>;
  bookingAnimals?: InputMaybe<BookingAnimalUpdateManyWithoutBookingNestedInput>;
  bookingReason?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  endDateTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  forMultiAnimals?: InputMaybe<BoolFieldUpdateOperationsInput>;
  googleEventId?: InputMaybe<StringFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutBookingNestedInput>;
  reminder6hSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  reminder24hSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  startDateTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  worker?: InputMaybe<WorkerUpdateOneRequiredWithoutBookingsNestedInput>;
  workerService?: InputMaybe<WorkerServiceUpdateOneRequiredWithoutBookingsNestedInput>;
};

export type BookingUpdateWithoutNotificationsInput = {
  account?: InputMaybe<AccountUpdateOneWithoutBookingsNestedInput>;
  animal?: InputMaybe<AnimalUpdateOneWithoutBookingsNestedInput>;
  animalBrushingFrequency?: InputMaybe<NullableEnumFrequencyTypeFieldUpdateOperationsInput>;
  animalFirstTimeAtGroomer?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  animalHasKnottedFur?: InputMaybe<NullableEnumYesNoUnknownStatusFieldUpdateOperationsInput>;
  animalLastVisit?: InputMaybe<NullableEnumLastVisitTypeFieldUpdateOperationsInput>;
  animalRecentlyAdopted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  animalTemper?: InputMaybe<NullableEnumTemperTypeFieldUpdateOperationsInput>;
  bookingAnimals?: InputMaybe<BookingAnimalUpdateManyWithoutBookingNestedInput>;
  bookingReason?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  emailHistory?: InputMaybe<EmailHistoryUpdateManyWithoutBookingNestedInput>;
  endDateTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  forMultiAnimals?: InputMaybe<BoolFieldUpdateOperationsInput>;
  googleEventId?: InputMaybe<StringFieldUpdateOperationsInput>;
  reminder6hSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  reminder24hSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  startDateTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  worker?: InputMaybe<WorkerUpdateOneRequiredWithoutBookingsNestedInput>;
  workerService?: InputMaybe<WorkerServiceUpdateOneRequiredWithoutBookingsNestedInput>;
};

export type BookingUpdateWithoutWorkerInput = {
  account?: InputMaybe<AccountUpdateOneWithoutBookingsNestedInput>;
  animal?: InputMaybe<AnimalUpdateOneWithoutBookingsNestedInput>;
  animalBrushingFrequency?: InputMaybe<NullableEnumFrequencyTypeFieldUpdateOperationsInput>;
  animalFirstTimeAtGroomer?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  animalHasKnottedFur?: InputMaybe<NullableEnumYesNoUnknownStatusFieldUpdateOperationsInput>;
  animalLastVisit?: InputMaybe<NullableEnumLastVisitTypeFieldUpdateOperationsInput>;
  animalRecentlyAdopted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  animalTemper?: InputMaybe<NullableEnumTemperTypeFieldUpdateOperationsInput>;
  bookingAnimals?: InputMaybe<BookingAnimalUpdateManyWithoutBookingNestedInput>;
  bookingReason?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  emailHistory?: InputMaybe<EmailHistoryUpdateManyWithoutBookingNestedInput>;
  endDateTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  forMultiAnimals?: InputMaybe<BoolFieldUpdateOperationsInput>;
  googleEventId?: InputMaybe<StringFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutBookingNestedInput>;
  reminder6hSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  reminder24hSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  startDateTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  workerService?: InputMaybe<WorkerServiceUpdateOneRequiredWithoutBookingsNestedInput>;
};

export type BookingUpdateWithoutWorkerServiceInput = {
  account?: InputMaybe<AccountUpdateOneWithoutBookingsNestedInput>;
  animal?: InputMaybe<AnimalUpdateOneWithoutBookingsNestedInput>;
  animalBrushingFrequency?: InputMaybe<NullableEnumFrequencyTypeFieldUpdateOperationsInput>;
  animalFirstTimeAtGroomer?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  animalHasKnottedFur?: InputMaybe<NullableEnumYesNoUnknownStatusFieldUpdateOperationsInput>;
  animalLastVisit?: InputMaybe<NullableEnumLastVisitTypeFieldUpdateOperationsInput>;
  animalRecentlyAdopted?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  animalTemper?: InputMaybe<NullableEnumTemperTypeFieldUpdateOperationsInput>;
  bookingAnimals?: InputMaybe<BookingAnimalUpdateManyWithoutBookingNestedInput>;
  bookingReason?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  emailHistory?: InputMaybe<EmailHistoryUpdateManyWithoutBookingNestedInput>;
  endDateTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  forMultiAnimals?: InputMaybe<BoolFieldUpdateOperationsInput>;
  googleEventId?: InputMaybe<StringFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutBookingNestedInput>;
  reminder6hSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  reminder24hSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  startDateTime?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  worker?: InputMaybe<WorkerUpdateOneRequiredWithoutBookingsNestedInput>;
};

export type BookingUpsertWithWhereUniqueWithoutAccountInput = {
  create: BookingCreateWithoutAccountInput;
  update: BookingUpdateWithoutAccountInput;
  where: BookingWhereUniqueInput;
};

export type BookingUpsertWithWhereUniqueWithoutAnimalInput = {
  create: BookingCreateWithoutAnimalInput;
  update: BookingUpdateWithoutAnimalInput;
  where: BookingWhereUniqueInput;
};

export type BookingUpsertWithWhereUniqueWithoutWorkerInput = {
  create: BookingCreateWithoutWorkerInput;
  update: BookingUpdateWithoutWorkerInput;
  where: BookingWhereUniqueInput;
};

export type BookingUpsertWithWhereUniqueWithoutWorkerServiceInput = {
  create: BookingCreateWithoutWorkerServiceInput;
  update: BookingUpdateWithoutWorkerServiceInput;
  where: BookingWhereUniqueInput;
};

export type BookingUpsertWithoutBookingAnimalsInput = {
  create: BookingCreateWithoutBookingAnimalsInput;
  update: BookingUpdateWithoutBookingAnimalsInput;
  where?: InputMaybe<BookingWhereInput>;
};

export type BookingUpsertWithoutEmailHistoryInput = {
  create: BookingCreateWithoutEmailHistoryInput;
  update: BookingUpdateWithoutEmailHistoryInput;
  where?: InputMaybe<BookingWhereInput>;
};

export type BookingUpsertWithoutNotificationsInput = {
  create: BookingCreateWithoutNotificationsInput;
  update: BookingUpdateWithoutNotificationsInput;
  where?: InputMaybe<BookingWhereInput>;
};

export type BookingWhereInput = {
  AND?: InputMaybe<Array<BookingWhereInput>>;
  NOT?: InputMaybe<Array<BookingWhereInput>>;
  OR?: InputMaybe<Array<BookingWhereInput>>;
  account?: InputMaybe<AccountNullableRelationFilter>;
  accountId?: InputMaybe<IntNullableFilter>;
  animal?: InputMaybe<AnimalNullableRelationFilter>;
  animalBrushingFrequency?: InputMaybe<EnumFrequencyTypeNullableFilter>;
  animalFirstTimeAtGroomer?: InputMaybe<BoolNullableFilter>;
  animalHasKnottedFur?: InputMaybe<EnumYesNoUnknownStatusNullableFilter>;
  animalId?: InputMaybe<IntNullableFilter>;
  animalLastVisit?: InputMaybe<EnumLastVisitTypeNullableFilter>;
  animalRecentlyAdopted?: InputMaybe<BoolNullableFilter>;
  animalTemper?: InputMaybe<EnumTemperTypeNullableFilter>;
  bookingAnimals?: InputMaybe<BookingAnimalListRelationFilter>;
  bookingReason?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  emailHistory?: InputMaybe<EmailHistoryListRelationFilter>;
  endDateTime?: InputMaybe<DateTimeFilter>;
  forMultiAnimals?: InputMaybe<BoolFilter>;
  googleEventId?: InputMaybe<StringFilter>;
  id?: InputMaybe<IntFilter>;
  notifications?: InputMaybe<NotificationListRelationFilter>;
  reminder6hSent?: InputMaybe<BoolFilter>;
  reminder24hSent?: InputMaybe<BoolFilter>;
  startDateTime?: InputMaybe<DateTimeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  worker?: InputMaybe<WorkerRelationFilter>;
  workerId?: InputMaybe<IntFilter>;
  workerService?: InputMaybe<WorkerServiceRelationFilter>;
  workerServiceId?: InputMaybe<IntFilter>;
};

export type BookingWhereUniqueInput = {
  AND?: InputMaybe<Array<BookingWhereInput>>;
  NOT?: InputMaybe<Array<BookingWhereInput>>;
  OR?: InputMaybe<Array<BookingWhereInput>>;
  account?: InputMaybe<AccountNullableRelationFilter>;
  accountId?: InputMaybe<IntNullableFilter>;
  animal?: InputMaybe<AnimalNullableRelationFilter>;
  animalBrushingFrequency?: InputMaybe<EnumFrequencyTypeNullableFilter>;
  animalFirstTimeAtGroomer?: InputMaybe<BoolNullableFilter>;
  animalHasKnottedFur?: InputMaybe<EnumYesNoUnknownStatusNullableFilter>;
  animalId?: InputMaybe<IntNullableFilter>;
  animalLastVisit?: InputMaybe<EnumLastVisitTypeNullableFilter>;
  animalRecentlyAdopted?: InputMaybe<BoolNullableFilter>;
  animalTemper?: InputMaybe<EnumTemperTypeNullableFilter>;
  bookingAnimals?: InputMaybe<BookingAnimalListRelationFilter>;
  bookingReason?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  emailHistory?: InputMaybe<EmailHistoryListRelationFilter>;
  endDateTime?: InputMaybe<DateTimeFilter>;
  forMultiAnimals?: InputMaybe<BoolFilter>;
  googleEventId?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  notifications?: InputMaybe<NotificationListRelationFilter>;
  reminder6hSent?: InputMaybe<BoolFilter>;
  reminder24hSent?: InputMaybe<BoolFilter>;
  startDateTime?: InputMaybe<DateTimeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  worker?: InputMaybe<WorkerRelationFilter>;
  workerId?: InputMaybe<IntFilter>;
  workerService?: InputMaybe<WorkerServiceRelationFilter>;
  workerServiceId?: InputMaybe<IntFilter>;
};

export type Bookmark = {
  __typename?: 'Bookmark';
  account: Account;
  accountId: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  litter: Litter;
  litterId: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type BookmarkAvgAggregateOutputType = {
  __typename?: 'BookmarkAvgAggregateOutputType';
  accountId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  litterId?: Maybe<Scalars['Float']['output']>;
};

export type BookmarkAvgOrderByAggregateInput = {
  accountId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  litterId?: InputMaybe<SortOrder>;
};

export type BookmarkCountAggregateOutputType = {
  __typename?: 'BookmarkCountAggregateOutputType';
  _all: Scalars['Int']['output'];
  accountId: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  litterId: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type BookmarkCountOrderByAggregateInput = {
  accountId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  litterId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type BookmarkCreateInput = {
  account: AccountCreateNestedOneWithoutBookmarksInput;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  litter: LitterCreateNestedOneWithoutBookmarksInput;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type BookmarkCreateManyAccountInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  litterId: Scalars['Int']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type BookmarkCreateManyAccountInputEnvelope = {
  data: Array<BookmarkCreateManyAccountInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BookmarkCreateManyInput = {
  accountId: Scalars['Int']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  litterId: Scalars['Int']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type BookmarkCreateManyLitterInput = {
  accountId: Scalars['Int']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type BookmarkCreateManyLitterInputEnvelope = {
  data: Array<BookmarkCreateManyLitterInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BookmarkCreateNestedManyWithoutAccountInput = {
  connect?: InputMaybe<Array<BookmarkWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<BookmarkCreateOrConnectWithoutAccountInput>>;
  create?: InputMaybe<Array<BookmarkCreateWithoutAccountInput>>;
  createMany?: InputMaybe<BookmarkCreateManyAccountInputEnvelope>;
};

export type BookmarkCreateNestedManyWithoutLitterInput = {
  connect?: InputMaybe<Array<BookmarkWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<BookmarkCreateOrConnectWithoutLitterInput>>;
  create?: InputMaybe<Array<BookmarkCreateWithoutLitterInput>>;
  createMany?: InputMaybe<BookmarkCreateManyLitterInputEnvelope>;
};

export type BookmarkCreateOrConnectWithoutAccountInput = {
  create: BookmarkCreateWithoutAccountInput;
  where: BookmarkWhereUniqueInput;
};

export type BookmarkCreateOrConnectWithoutLitterInput = {
  create: BookmarkCreateWithoutLitterInput;
  where: BookmarkWhereUniqueInput;
};

export type BookmarkCreateWithoutAccountInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  litter: LitterCreateNestedOneWithoutBookmarksInput;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type BookmarkCreateWithoutLitterInput = {
  account: AccountCreateNestedOneWithoutBookmarksInput;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type BookmarkListRelationFilter = {
  every?: InputMaybe<BookmarkWhereInput>;
  none?: InputMaybe<BookmarkWhereInput>;
  some?: InputMaybe<BookmarkWhereInput>;
};

export type BookmarkMaxAggregateOutputType = {
  __typename?: 'BookmarkMaxAggregateOutputType';
  accountId?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  litterId?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type BookmarkMaxOrderByAggregateInput = {
  accountId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  litterId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type BookmarkMinAggregateOutputType = {
  __typename?: 'BookmarkMinAggregateOutputType';
  accountId?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  litterId?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type BookmarkMinOrderByAggregateInput = {
  accountId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  litterId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type BookmarkOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type BookmarkOrderByWithAggregationInput = {
  _avg?: InputMaybe<BookmarkAvgOrderByAggregateInput>;
  _count?: InputMaybe<BookmarkCountOrderByAggregateInput>;
  _max?: InputMaybe<BookmarkMaxOrderByAggregateInput>;
  _min?: InputMaybe<BookmarkMinOrderByAggregateInput>;
  _sum?: InputMaybe<BookmarkSumOrderByAggregateInput>;
  accountId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  litterId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type BookmarkOrderByWithRelationAndSearchRelevanceInput = {
  account?: InputMaybe<AccountOrderByWithRelationAndSearchRelevanceInput>;
  accountId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  litter?: InputMaybe<LitterOrderByWithRelationAndSearchRelevanceInput>;
  litterId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum BookmarkScalarFieldEnum {
  accountId = 'accountId',
  createdAt = 'createdAt',
  id = 'id',
  litterId = 'litterId',
  updatedAt = 'updatedAt'
}

export type BookmarkScalarWhereInput = {
  AND?: InputMaybe<Array<BookmarkScalarWhereInput>>;
  NOT?: InputMaybe<Array<BookmarkScalarWhereInput>>;
  OR?: InputMaybe<Array<BookmarkScalarWhereInput>>;
  accountId?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntFilter>;
  litterId?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type BookmarkScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<BookmarkScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<BookmarkScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<BookmarkScalarWhereWithAggregatesInput>>;
  accountId?: InputMaybe<IntWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  litterId?: InputMaybe<IntWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type BookmarkSumAggregateOutputType = {
  __typename?: 'BookmarkSumAggregateOutputType';
  accountId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  litterId?: Maybe<Scalars['Int']['output']>;
};

export type BookmarkSumOrderByAggregateInput = {
  accountId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  litterId?: InputMaybe<SortOrder>;
};

export type BookmarkUncheckedCreateInput = {
  accountId: Scalars['Int']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  litterId: Scalars['Int']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type BookmarkUncheckedCreateNestedManyWithoutAccountInput = {
  connect?: InputMaybe<Array<BookmarkWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<BookmarkCreateOrConnectWithoutAccountInput>>;
  create?: InputMaybe<Array<BookmarkCreateWithoutAccountInput>>;
  createMany?: InputMaybe<BookmarkCreateManyAccountInputEnvelope>;
};

export type BookmarkUncheckedCreateNestedManyWithoutLitterInput = {
  connect?: InputMaybe<Array<BookmarkWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<BookmarkCreateOrConnectWithoutLitterInput>>;
  create?: InputMaybe<Array<BookmarkCreateWithoutLitterInput>>;
  createMany?: InputMaybe<BookmarkCreateManyLitterInputEnvelope>;
};

export type BookmarkUncheckedCreateWithoutAccountInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  litterId: Scalars['Int']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type BookmarkUncheckedCreateWithoutLitterInput = {
  accountId: Scalars['Int']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type BookmarkUncheckedUpdateInput = {
  accountId?: InputMaybe<IntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  litterId?: InputMaybe<IntFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type BookmarkUncheckedUpdateManyInput = {
  accountId?: InputMaybe<IntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  litterId?: InputMaybe<IntFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type BookmarkUncheckedUpdateManyWithoutAccountInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  litterId?: InputMaybe<IntFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type BookmarkUncheckedUpdateManyWithoutAccountNestedInput = {
  connect?: InputMaybe<Array<BookmarkWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<BookmarkCreateOrConnectWithoutAccountInput>>;
  create?: InputMaybe<Array<BookmarkCreateWithoutAccountInput>>;
  createMany?: InputMaybe<BookmarkCreateManyAccountInputEnvelope>;
  delete?: InputMaybe<Array<BookmarkWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<BookmarkScalarWhereInput>>;
  disconnect?: InputMaybe<Array<BookmarkWhereUniqueInput>>;
  set?: InputMaybe<Array<BookmarkWhereUniqueInput>>;
  update?: InputMaybe<Array<BookmarkUpdateWithWhereUniqueWithoutAccountInput>>;
  updateMany?: InputMaybe<Array<BookmarkUpdateManyWithWhereWithoutAccountInput>>;
  upsert?: InputMaybe<Array<BookmarkUpsertWithWhereUniqueWithoutAccountInput>>;
};

export type BookmarkUncheckedUpdateManyWithoutLitterInput = {
  accountId?: InputMaybe<IntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type BookmarkUncheckedUpdateManyWithoutLitterNestedInput = {
  connect?: InputMaybe<Array<BookmarkWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<BookmarkCreateOrConnectWithoutLitterInput>>;
  create?: InputMaybe<Array<BookmarkCreateWithoutLitterInput>>;
  createMany?: InputMaybe<BookmarkCreateManyLitterInputEnvelope>;
  delete?: InputMaybe<Array<BookmarkWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<BookmarkScalarWhereInput>>;
  disconnect?: InputMaybe<Array<BookmarkWhereUniqueInput>>;
  set?: InputMaybe<Array<BookmarkWhereUniqueInput>>;
  update?: InputMaybe<Array<BookmarkUpdateWithWhereUniqueWithoutLitterInput>>;
  updateMany?: InputMaybe<Array<BookmarkUpdateManyWithWhereWithoutLitterInput>>;
  upsert?: InputMaybe<Array<BookmarkUpsertWithWhereUniqueWithoutLitterInput>>;
};

export type BookmarkUncheckedUpdateWithoutAccountInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  litterId?: InputMaybe<IntFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type BookmarkUncheckedUpdateWithoutLitterInput = {
  accountId?: InputMaybe<IntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type BookmarkUpdateInput = {
  account?: InputMaybe<AccountUpdateOneRequiredWithoutBookmarksNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  litter?: InputMaybe<LitterUpdateOneRequiredWithoutBookmarksNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type BookmarkUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type BookmarkUpdateManyWithWhereWithoutAccountInput = {
  data: BookmarkUpdateManyMutationInput;
  where: BookmarkScalarWhereInput;
};

export type BookmarkUpdateManyWithWhereWithoutLitterInput = {
  data: BookmarkUpdateManyMutationInput;
  where: BookmarkScalarWhereInput;
};

export type BookmarkUpdateManyWithoutAccountNestedInput = {
  connect?: InputMaybe<Array<BookmarkWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<BookmarkCreateOrConnectWithoutAccountInput>>;
  create?: InputMaybe<Array<BookmarkCreateWithoutAccountInput>>;
  createMany?: InputMaybe<BookmarkCreateManyAccountInputEnvelope>;
  delete?: InputMaybe<Array<BookmarkWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<BookmarkScalarWhereInput>>;
  disconnect?: InputMaybe<Array<BookmarkWhereUniqueInput>>;
  set?: InputMaybe<Array<BookmarkWhereUniqueInput>>;
  update?: InputMaybe<Array<BookmarkUpdateWithWhereUniqueWithoutAccountInput>>;
  updateMany?: InputMaybe<Array<BookmarkUpdateManyWithWhereWithoutAccountInput>>;
  upsert?: InputMaybe<Array<BookmarkUpsertWithWhereUniqueWithoutAccountInput>>;
};

export type BookmarkUpdateManyWithoutLitterNestedInput = {
  connect?: InputMaybe<Array<BookmarkWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<BookmarkCreateOrConnectWithoutLitterInput>>;
  create?: InputMaybe<Array<BookmarkCreateWithoutLitterInput>>;
  createMany?: InputMaybe<BookmarkCreateManyLitterInputEnvelope>;
  delete?: InputMaybe<Array<BookmarkWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<BookmarkScalarWhereInput>>;
  disconnect?: InputMaybe<Array<BookmarkWhereUniqueInput>>;
  set?: InputMaybe<Array<BookmarkWhereUniqueInput>>;
  update?: InputMaybe<Array<BookmarkUpdateWithWhereUniqueWithoutLitterInput>>;
  updateMany?: InputMaybe<Array<BookmarkUpdateManyWithWhereWithoutLitterInput>>;
  upsert?: InputMaybe<Array<BookmarkUpsertWithWhereUniqueWithoutLitterInput>>;
};

export type BookmarkUpdateWithWhereUniqueWithoutAccountInput = {
  data: BookmarkUpdateWithoutAccountInput;
  where: BookmarkWhereUniqueInput;
};

export type BookmarkUpdateWithWhereUniqueWithoutLitterInput = {
  data: BookmarkUpdateWithoutLitterInput;
  where: BookmarkWhereUniqueInput;
};

export type BookmarkUpdateWithoutAccountInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  litter?: InputMaybe<LitterUpdateOneRequiredWithoutBookmarksNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type BookmarkUpdateWithoutLitterInput = {
  account?: InputMaybe<AccountUpdateOneRequiredWithoutBookmarksNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type BookmarkUpsertWithWhereUniqueWithoutAccountInput = {
  create: BookmarkCreateWithoutAccountInput;
  update: BookmarkUpdateWithoutAccountInput;
  where: BookmarkWhereUniqueInput;
};

export type BookmarkUpsertWithWhereUniqueWithoutLitterInput = {
  create: BookmarkCreateWithoutLitterInput;
  update: BookmarkUpdateWithoutLitterInput;
  where: BookmarkWhereUniqueInput;
};

export type BookmarkWhereInput = {
  AND?: InputMaybe<Array<BookmarkWhereInput>>;
  NOT?: InputMaybe<Array<BookmarkWhereInput>>;
  OR?: InputMaybe<Array<BookmarkWhereInput>>;
  account?: InputMaybe<AccountRelationFilter>;
  accountId?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntFilter>;
  litter?: InputMaybe<LitterRelationFilter>;
  litterId?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type BookmarkWhereUniqueInput = {
  AND?: InputMaybe<Array<BookmarkWhereInput>>;
  NOT?: InputMaybe<Array<BookmarkWhereInput>>;
  OR?: InputMaybe<Array<BookmarkWhereInput>>;
  account?: InputMaybe<AccountRelationFilter>;
  accountId?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  litter?: InputMaybe<LitterRelationFilter>;
  litterId?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type BoolFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BoolFilter = {
  equals?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedBoolFilter>;
};

export type BoolNullableFilter = {
  equals?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedBoolNullableFilter>;
};

export type BoolNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedBoolNullableFilter>;
  _min?: InputMaybe<NestedBoolNullableFilter>;
  equals?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedBoolNullableWithAggregatesFilter>;
};

export type BoolWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedBoolFilter>;
  _min?: InputMaybe<NestedBoolFilter>;
  equals?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedBoolWithAggregatesFilter>;
};

export enum BreedGeneticAnalyzeType {
  ESSENTIAL = 'ESSENTIAL',
  SPECIFIC = 'SPECIFIC'
}

export type BreedInterest = {
  __typename?: 'BreedInterest';
  account: Account;
  accountId: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  dogBreed: DogBreed;
  dogBreedId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export enum BreedType {
  MIXED = 'MIXED',
  PURE = 'PURE',
  UNKNOWN = 'UNKNOWN'
}

export type Category = {
  __typename?: 'Category';
  _count: CategoryCountOutputType;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  proType?: Maybe<ProfessionalTypeEnum>;
  translations: Array<CategoryTranslation>;
  updatedAt: Scalars['DateTime']['output'];
  workerServices: Array<WorkerService>;
};


export type CategorytranslationsArgs = {
  cursor?: InputMaybe<CategoryTranslationWhereUniqueInput>;
  distinct?: InputMaybe<CategoryTranslationScalarFieldEnum>;
  orderBy?: InputMaybe<CategoryTranslationOrderByWithRelationAndSearchRelevanceInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CategoryTranslationWhereInput>;
};


export type CategoryworkerServicesArgs = {
  cursor?: InputMaybe<WorkerServiceWhereUniqueInput>;
  distinct?: InputMaybe<WorkerServiceScalarFieldEnum>;
  orderBy?: InputMaybe<WorkerServiceOrderByWithRelationAndSearchRelevanceInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<WorkerServiceWhereInput>;
};

export type CategoryAvgAggregateOutputType = {
  __typename?: 'CategoryAvgAggregateOutputType';
  id?: Maybe<Scalars['Float']['output']>;
};

export type CategoryAvgOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
};

export type CategoryCountAggregateOutputType = {
  __typename?: 'CategoryCountAggregateOutputType';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  proType: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type CategoryCountOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  proType?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type CategoryCountOutputType = {
  __typename?: 'CategoryCountOutputType';
  translations: Scalars['Int']['output'];
  workerServices: Scalars['Int']['output'];
};

export type CategoryCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  proType?: InputMaybe<ProfessionalTypeEnum>;
  translations?: InputMaybe<CategoryTranslationCreateNestedManyWithoutCategoryInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  workerServices?: InputMaybe<WorkerServiceCreateNestedManyWithoutCategoryInput>;
};

export type CategoryCreateManyInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  proType?: InputMaybe<ProfessionalTypeEnum>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CategoryCreateNestedOneWithoutTranslationsInput = {
  connect?: InputMaybe<CategoryWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CategoryCreateOrConnectWithoutTranslationsInput>;
  create?: InputMaybe<CategoryCreateWithoutTranslationsInput>;
};

export type CategoryCreateNestedOneWithoutWorkerServicesInput = {
  connect?: InputMaybe<CategoryWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CategoryCreateOrConnectWithoutWorkerServicesInput>;
  create?: InputMaybe<CategoryCreateWithoutWorkerServicesInput>;
};

export type CategoryCreateOrConnectWithoutTranslationsInput = {
  create: CategoryCreateWithoutTranslationsInput;
  where: CategoryWhereUniqueInput;
};

export type CategoryCreateOrConnectWithoutWorkerServicesInput = {
  create: CategoryCreateWithoutWorkerServicesInput;
  where: CategoryWhereUniqueInput;
};

export type CategoryCreateWithoutTranslationsInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  proType?: InputMaybe<ProfessionalTypeEnum>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  workerServices?: InputMaybe<WorkerServiceCreateNestedManyWithoutCategoryInput>;
};

export type CategoryCreateWithoutWorkerServicesInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  proType?: InputMaybe<ProfessionalTypeEnum>;
  translations?: InputMaybe<CategoryTranslationCreateNestedManyWithoutCategoryInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CategoryMaxAggregateOutputType = {
  __typename?: 'CategoryMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  proType?: Maybe<ProfessionalTypeEnum>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CategoryMaxOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  proType?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type CategoryMinAggregateOutputType = {
  __typename?: 'CategoryMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  proType?: Maybe<ProfessionalTypeEnum>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CategoryMinOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  proType?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type CategoryOrderByWithAggregationInput = {
  _avg?: InputMaybe<CategoryAvgOrderByAggregateInput>;
  _count?: InputMaybe<CategoryCountOrderByAggregateInput>;
  _max?: InputMaybe<CategoryMaxOrderByAggregateInput>;
  _min?: InputMaybe<CategoryMinOrderByAggregateInput>;
  _sum?: InputMaybe<CategorySumOrderByAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  proType?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type CategoryOrderByWithRelationAndSearchRelevanceInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  proType?: InputMaybe<SortOrderInput>;
  translations?: InputMaybe<CategoryTranslationOrderByRelationAggregateInput>;
  updatedAt?: InputMaybe<SortOrder>;
  workerServices?: InputMaybe<WorkerServiceOrderByRelationAggregateInput>;
};

export type CategoryRelationFilter = {
  is?: InputMaybe<CategoryWhereInput>;
  isNot?: InputMaybe<CategoryWhereInput>;
};

export enum CategoryScalarFieldEnum {
  createdAt = 'createdAt',
  id = 'id',
  proType = 'proType',
  updatedAt = 'updatedAt'
}

export type CategoryScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<CategoryScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<CategoryScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<CategoryScalarWhereWithAggregatesInput>>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  proType?: InputMaybe<EnumProfessionalTypeEnumNullableWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type CategorySumAggregateOutputType = {
  __typename?: 'CategorySumAggregateOutputType';
  id?: Maybe<Scalars['Int']['output']>;
};

export type CategorySumOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
};

export type CategoryTranslation = {
  __typename?: 'CategoryTranslation';
  category: Category;
  categoryId: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  language: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type CategoryTranslationAvgAggregateOutputType = {
  __typename?: 'CategoryTranslationAvgAggregateOutputType';
  categoryId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

export type CategoryTranslationAvgOrderByAggregateInput = {
  categoryId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export type CategoryTranslationCountAggregateOutputType = {
  __typename?: 'CategoryTranslationCountAggregateOutputType';
  _all: Scalars['Int']['output'];
  categoryId: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  description: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  language: Scalars['Int']['output'];
  title: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type CategoryTranslationCountOrderByAggregateInput = {
  categoryId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  language?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type CategoryTranslationCreateInput = {
  category: CategoryCreateNestedOneWithoutTranslationsInput;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  language: Scalars['String']['input'];
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CategoryTranslationCreateManyCategoryInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  language: Scalars['String']['input'];
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CategoryTranslationCreateManyCategoryInputEnvelope = {
  data: Array<CategoryTranslationCreateManyCategoryInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CategoryTranslationCreateManyInput = {
  categoryId: Scalars['Int']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  language: Scalars['String']['input'];
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CategoryTranslationCreateNestedManyWithoutCategoryInput = {
  connect?: InputMaybe<Array<CategoryTranslationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CategoryTranslationCreateOrConnectWithoutCategoryInput>>;
  create?: InputMaybe<Array<CategoryTranslationCreateWithoutCategoryInput>>;
  createMany?: InputMaybe<CategoryTranslationCreateManyCategoryInputEnvelope>;
};

export type CategoryTranslationCreateOrConnectWithoutCategoryInput = {
  create: CategoryTranslationCreateWithoutCategoryInput;
  where: CategoryTranslationWhereUniqueInput;
};

export type CategoryTranslationCreateWithoutCategoryInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  language: Scalars['String']['input'];
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CategoryTranslationListRelationFilter = {
  every?: InputMaybe<CategoryTranslationWhereInput>;
  none?: InputMaybe<CategoryTranslationWhereInput>;
  some?: InputMaybe<CategoryTranslationWhereInput>;
};

export type CategoryTranslationMaxAggregateOutputType = {
  __typename?: 'CategoryTranslationMaxAggregateOutputType';
  categoryId?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CategoryTranslationMaxOrderByAggregateInput = {
  categoryId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  language?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type CategoryTranslationMinAggregateOutputType = {
  __typename?: 'CategoryTranslationMinAggregateOutputType';
  categoryId?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CategoryTranslationMinOrderByAggregateInput = {
  categoryId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  language?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type CategoryTranslationOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export enum CategoryTranslationOrderByRelevanceFieldEnum {
  description = 'description',
  language = 'language',
  title = 'title'
}

export type CategoryTranslationOrderByRelevanceInput = {
  fields: Array<CategoryTranslationOrderByRelevanceFieldEnum>;
  search: Scalars['String']['input'];
  sort: SortOrder;
};

export type CategoryTranslationOrderByWithAggregationInput = {
  _avg?: InputMaybe<CategoryTranslationAvgOrderByAggregateInput>;
  _count?: InputMaybe<CategoryTranslationCountOrderByAggregateInput>;
  _max?: InputMaybe<CategoryTranslationMaxOrderByAggregateInput>;
  _min?: InputMaybe<CategoryTranslationMinOrderByAggregateInput>;
  _sum?: InputMaybe<CategoryTranslationSumOrderByAggregateInput>;
  categoryId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  language?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type CategoryTranslationOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: InputMaybe<CategoryTranslationOrderByRelevanceInput>;
  category?: InputMaybe<CategoryOrderByWithRelationAndSearchRelevanceInput>;
  categoryId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  language?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum CategoryTranslationScalarFieldEnum {
  categoryId = 'categoryId',
  createdAt = 'createdAt',
  description = 'description',
  id = 'id',
  language = 'language',
  title = 'title',
  updatedAt = 'updatedAt'
}

export type CategoryTranslationScalarWhereInput = {
  AND?: InputMaybe<Array<CategoryTranslationScalarWhereInput>>;
  NOT?: InputMaybe<Array<CategoryTranslationScalarWhereInput>>;
  OR?: InputMaybe<Array<CategoryTranslationScalarWhereInput>>;
  categoryId?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<IntFilter>;
  language?: InputMaybe<StringFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type CategoryTranslationScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<CategoryTranslationScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<CategoryTranslationScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<CategoryTranslationScalarWhereWithAggregatesInput>>;
  categoryId?: InputMaybe<IntWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  description?: InputMaybe<StringNullableWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  language?: InputMaybe<StringWithAggregatesFilter>;
  title?: InputMaybe<StringWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type CategoryTranslationSumAggregateOutputType = {
  __typename?: 'CategoryTranslationSumAggregateOutputType';
  categoryId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
};

export type CategoryTranslationSumOrderByAggregateInput = {
  categoryId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export type CategoryTranslationUncheckedCreateInput = {
  categoryId: Scalars['Int']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  language: Scalars['String']['input'];
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CategoryTranslationUncheckedCreateNestedManyWithoutCategoryInput = {
  connect?: InputMaybe<Array<CategoryTranslationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CategoryTranslationCreateOrConnectWithoutCategoryInput>>;
  create?: InputMaybe<Array<CategoryTranslationCreateWithoutCategoryInput>>;
  createMany?: InputMaybe<CategoryTranslationCreateManyCategoryInputEnvelope>;
};

export type CategoryTranslationUncheckedCreateWithoutCategoryInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  language: Scalars['String']['input'];
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CategoryTranslationUncheckedUpdateInput = {
  categoryId?: InputMaybe<IntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type CategoryTranslationUncheckedUpdateManyInput = {
  categoryId?: InputMaybe<IntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type CategoryTranslationUncheckedUpdateManyWithoutCategoryInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type CategoryTranslationUncheckedUpdateManyWithoutCategoryNestedInput = {
  connect?: InputMaybe<Array<CategoryTranslationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CategoryTranslationCreateOrConnectWithoutCategoryInput>>;
  create?: InputMaybe<Array<CategoryTranslationCreateWithoutCategoryInput>>;
  createMany?: InputMaybe<CategoryTranslationCreateManyCategoryInputEnvelope>;
  delete?: InputMaybe<Array<CategoryTranslationWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<CategoryTranslationScalarWhereInput>>;
  disconnect?: InputMaybe<Array<CategoryTranslationWhereUniqueInput>>;
  set?: InputMaybe<Array<CategoryTranslationWhereUniqueInput>>;
  update?: InputMaybe<Array<CategoryTranslationUpdateWithWhereUniqueWithoutCategoryInput>>;
  updateMany?: InputMaybe<Array<CategoryTranslationUpdateManyWithWhereWithoutCategoryInput>>;
  upsert?: InputMaybe<Array<CategoryTranslationUpsertWithWhereUniqueWithoutCategoryInput>>;
};

export type CategoryTranslationUncheckedUpdateWithoutCategoryInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type CategoryTranslationUpdateInput = {
  category?: InputMaybe<CategoryUpdateOneRequiredWithoutTranslationsNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type CategoryTranslationUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type CategoryTranslationUpdateManyWithWhereWithoutCategoryInput = {
  data: CategoryTranslationUpdateManyMutationInput;
  where: CategoryTranslationScalarWhereInput;
};

export type CategoryTranslationUpdateManyWithoutCategoryNestedInput = {
  connect?: InputMaybe<Array<CategoryTranslationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CategoryTranslationCreateOrConnectWithoutCategoryInput>>;
  create?: InputMaybe<Array<CategoryTranslationCreateWithoutCategoryInput>>;
  createMany?: InputMaybe<CategoryTranslationCreateManyCategoryInputEnvelope>;
  delete?: InputMaybe<Array<CategoryTranslationWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<CategoryTranslationScalarWhereInput>>;
  disconnect?: InputMaybe<Array<CategoryTranslationWhereUniqueInput>>;
  set?: InputMaybe<Array<CategoryTranslationWhereUniqueInput>>;
  update?: InputMaybe<Array<CategoryTranslationUpdateWithWhereUniqueWithoutCategoryInput>>;
  updateMany?: InputMaybe<Array<CategoryTranslationUpdateManyWithWhereWithoutCategoryInput>>;
  upsert?: InputMaybe<Array<CategoryTranslationUpsertWithWhereUniqueWithoutCategoryInput>>;
};

export type CategoryTranslationUpdateWithWhereUniqueWithoutCategoryInput = {
  data: CategoryTranslationUpdateWithoutCategoryInput;
  where: CategoryTranslationWhereUniqueInput;
};

export type CategoryTranslationUpdateWithoutCategoryInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type CategoryTranslationUpsertWithWhereUniqueWithoutCategoryInput = {
  create: CategoryTranslationCreateWithoutCategoryInput;
  update: CategoryTranslationUpdateWithoutCategoryInput;
  where: CategoryTranslationWhereUniqueInput;
};

export type CategoryTranslationWhereInput = {
  AND?: InputMaybe<Array<CategoryTranslationWhereInput>>;
  NOT?: InputMaybe<Array<CategoryTranslationWhereInput>>;
  OR?: InputMaybe<Array<CategoryTranslationWhereInput>>;
  category?: InputMaybe<CategoryRelationFilter>;
  categoryId?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<IntFilter>;
  language?: InputMaybe<StringFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type CategoryTranslationWhereUniqueInput = {
  AND?: InputMaybe<Array<CategoryTranslationWhereInput>>;
  NOT?: InputMaybe<Array<CategoryTranslationWhereInput>>;
  OR?: InputMaybe<Array<CategoryTranslationWhereInput>>;
  category?: InputMaybe<CategoryRelationFilter>;
  categoryId?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  language?: InputMaybe<StringFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type CategoryUncheckedCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  proType?: InputMaybe<ProfessionalTypeEnum>;
  translations?: InputMaybe<CategoryTranslationUncheckedCreateNestedManyWithoutCategoryInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  workerServices?: InputMaybe<WorkerServiceUncheckedCreateNestedManyWithoutCategoryInput>;
};

export type CategoryUncheckedCreateWithoutTranslationsInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  proType?: InputMaybe<ProfessionalTypeEnum>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  workerServices?: InputMaybe<WorkerServiceUncheckedCreateNestedManyWithoutCategoryInput>;
};

export type CategoryUncheckedCreateWithoutWorkerServicesInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  proType?: InputMaybe<ProfessionalTypeEnum>;
  translations?: InputMaybe<CategoryTranslationUncheckedCreateNestedManyWithoutCategoryInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CategoryUncheckedUpdateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  proType?: InputMaybe<NullableEnumProfessionalTypeEnumFieldUpdateOperationsInput>;
  translations?: InputMaybe<CategoryTranslationUncheckedUpdateManyWithoutCategoryNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  workerServices?: InputMaybe<WorkerServiceUncheckedUpdateManyWithoutCategoryNestedInput>;
};

export type CategoryUncheckedUpdateManyInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  proType?: InputMaybe<NullableEnumProfessionalTypeEnumFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type CategoryUncheckedUpdateWithoutTranslationsInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  proType?: InputMaybe<NullableEnumProfessionalTypeEnumFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  workerServices?: InputMaybe<WorkerServiceUncheckedUpdateManyWithoutCategoryNestedInput>;
};

export type CategoryUncheckedUpdateWithoutWorkerServicesInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  proType?: InputMaybe<NullableEnumProfessionalTypeEnumFieldUpdateOperationsInput>;
  translations?: InputMaybe<CategoryTranslationUncheckedUpdateManyWithoutCategoryNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type CategoryUpdateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  proType?: InputMaybe<NullableEnumProfessionalTypeEnumFieldUpdateOperationsInput>;
  translations?: InputMaybe<CategoryTranslationUpdateManyWithoutCategoryNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  workerServices?: InputMaybe<WorkerServiceUpdateManyWithoutCategoryNestedInput>;
};

export type CategoryUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  proType?: InputMaybe<NullableEnumProfessionalTypeEnumFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type CategoryUpdateOneRequiredWithoutTranslationsNestedInput = {
  connect?: InputMaybe<CategoryWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CategoryCreateOrConnectWithoutTranslationsInput>;
  create?: InputMaybe<CategoryCreateWithoutTranslationsInput>;
  update?: InputMaybe<CategoryUpdateToOneWithWhereWithoutTranslationsInput>;
  upsert?: InputMaybe<CategoryUpsertWithoutTranslationsInput>;
};

export type CategoryUpdateOneRequiredWithoutWorkerServicesNestedInput = {
  connect?: InputMaybe<CategoryWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CategoryCreateOrConnectWithoutWorkerServicesInput>;
  create?: InputMaybe<CategoryCreateWithoutWorkerServicesInput>;
  update?: InputMaybe<CategoryUpdateToOneWithWhereWithoutWorkerServicesInput>;
  upsert?: InputMaybe<CategoryUpsertWithoutWorkerServicesInput>;
};

export type CategoryUpdateToOneWithWhereWithoutTranslationsInput = {
  data: CategoryUpdateWithoutTranslationsInput;
  where?: InputMaybe<CategoryWhereInput>;
};

export type CategoryUpdateToOneWithWhereWithoutWorkerServicesInput = {
  data: CategoryUpdateWithoutWorkerServicesInput;
  where?: InputMaybe<CategoryWhereInput>;
};

export type CategoryUpdateWithoutTranslationsInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  proType?: InputMaybe<NullableEnumProfessionalTypeEnumFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  workerServices?: InputMaybe<WorkerServiceUpdateManyWithoutCategoryNestedInput>;
};

export type CategoryUpdateWithoutWorkerServicesInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  proType?: InputMaybe<NullableEnumProfessionalTypeEnumFieldUpdateOperationsInput>;
  translations?: InputMaybe<CategoryTranslationUpdateManyWithoutCategoryNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type CategoryUpsertWithoutTranslationsInput = {
  create: CategoryCreateWithoutTranslationsInput;
  update: CategoryUpdateWithoutTranslationsInput;
  where?: InputMaybe<CategoryWhereInput>;
};

export type CategoryUpsertWithoutWorkerServicesInput = {
  create: CategoryCreateWithoutWorkerServicesInput;
  update: CategoryUpdateWithoutWorkerServicesInput;
  where?: InputMaybe<CategoryWhereInput>;
};

export type CategoryWhereInput = {
  AND?: InputMaybe<Array<CategoryWhereInput>>;
  NOT?: InputMaybe<Array<CategoryWhereInput>>;
  OR?: InputMaybe<Array<CategoryWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntFilter>;
  proType?: InputMaybe<EnumProfessionalTypeEnumNullableFilter>;
  translations?: InputMaybe<CategoryTranslationListRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  workerServices?: InputMaybe<WorkerServiceListRelationFilter>;
};

export type CategoryWhereUniqueInput = {
  AND?: InputMaybe<Array<CategoryWhereInput>>;
  NOT?: InputMaybe<Array<CategoryWhereInput>>;
  OR?: InputMaybe<Array<CategoryWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  proType?: InputMaybe<EnumProfessionalTypeEnumNullableFilter>;
  translations?: InputMaybe<CategoryTranslationListRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  workerServices?: InputMaybe<WorkerServiceListRelationFilter>;
};

export enum CenterTypeEnum {
  CABINET = 'CABINET',
  CENTRE = 'CENTRE',
  CLINIC = 'CLINIC'
}

export type CheckoutApplicationInput = {
  applicationId: Scalars['Int']['input'];
  cancelUrl: Scalars['String']['input'];
  language: Scalars['String']['input'];
  successUrl: Scalars['String']['input'];
};

export enum ContactPreference {
  BREEDER_ONBOARDING_UNFINISHED = 'BREEDER_ONBOARDING_UNFINISHED',
  BREED_COMPARATOR = 'BREED_COMPARATOR',
  BREED_INTEREST = 'BREED_INTEREST',
  DIRECT_EMAIL = 'DIRECT_EMAIL',
  EMAIL_ON_APPLICATION_UPDATE = 'EMAIL_ON_APPLICATION_UPDATE',
  EMAIL_ON_BOOKING_UPDATE = 'EMAIL_ON_BOOKING_UPDATE',
  EMAIL_ON_LITTER_UPDATE = 'EMAIL_ON_LITTER_UPDATE',
  EMAIL_ON_MESSAGE_RECEIVED = 'EMAIL_ON_MESSAGE_RECEIVED',
  KLAVIYO = 'KLAVIYO',
  MAILJET = 'MAILJET',
  NEWSLETTER = 'NEWSLETTER',
  OTHER = 'OTHER',
  QUIZZ = 'QUIZZ',
  RECURRENT_UDPATES_NEW_BREEDERS_LITTERS = 'RECURRENT_UDPATES_NEW_BREEDERS_LITTERS',
  SMS_ON_APPLICATION_UPDATE = 'SMS_ON_APPLICATION_UPDATE',
  SMS_ON_BOOKING_UPDATE = 'SMS_ON_BOOKING_UPDATE'
}

export enum ContactReasonTypeEnum {
  EDUCATOR_REGISTRATION_REQUEST = 'EDUCATOR_REGISTRATION_REQUEST',
  GENETIC_ADVICE = 'GENETIC_ADVICE',
  GROOMER_REGISTRATION_REQUEST = 'GROOMER_REGISTRATION_REQUEST',
  SHELTER_REGISTRATION_REQUEST = 'SHELTER_REGISTRATION_REQUEST',
  USER_CONTACT = 'USER_CONTACT',
  VET_REGISTRATION_REQUEST = 'VET_REGISTRATION_REQUEST'
}

export type Conversation = {
  __typename?: 'Conversation';
  id: Scalars['Int']['output'];
  lastMessage: Scalars['DateTime']['output'];
  otherAccountFullName: Scalars['String']['output'];
  otherAccountId: Scalars['Int']['output'];
  otherAccountIsDeleted: Scalars['Boolean']['output'];
  otherAccountProfileImage?: Maybe<Scalars['String']['output']>;
  otherAccountType: Scalars['String']['output'];
};

export type ConversationAvgAggregateOutputType = {
  __typename?: 'ConversationAvgAggregateOutputType';
  firstAccountId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  secondAccountId?: Maybe<Scalars['Float']['output']>;
};

export type ConversationAvgOrderByAggregateInput = {
  firstAccountId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  secondAccountId?: InputMaybe<SortOrder>;
};

export type ConversationCountAggregateOutputType = {
  __typename?: 'ConversationCountAggregateOutputType';
  _all: Scalars['Int']['output'];
  answered: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  deletedByFirstAccount: Scalars['Int']['output'];
  deletedBySecondAccount: Scalars['Int']['output'];
  firstAccountId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  reminderSent: Scalars['Int']['output'];
  reviewed: Scalars['Int']['output'];
  secondAccountId: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type ConversationCountOrderByAggregateInput = {
  answered?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  deletedByFirstAccount?: InputMaybe<SortOrder>;
  deletedBySecondAccount?: InputMaybe<SortOrder>;
  firstAccountId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  reminderSent?: InputMaybe<SortOrder>;
  reviewed?: InputMaybe<SortOrder>;
  secondAccountId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ConversationCreateInput = {
  answered?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deletedByFirstAccount?: InputMaybe<Scalars['Boolean']['input']>;
  deletedBySecondAccount?: InputMaybe<Scalars['Boolean']['input']>;
  firstAccount: AccountCreateNestedOneWithoutFirstAccountConversationsInput;
  reminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  reviewed?: InputMaybe<Scalars['Boolean']['input']>;
  secondAccount: AccountCreateNestedOneWithoutSecondAccountConversationsInput;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ConversationCreateManyFirstAccountInput = {
  answered?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deletedByFirstAccount?: InputMaybe<Scalars['Boolean']['input']>;
  deletedBySecondAccount?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  reminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  reviewed?: InputMaybe<Scalars['Boolean']['input']>;
  secondAccountId: Scalars['Int']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ConversationCreateManyFirstAccountInputEnvelope = {
  data: Array<ConversationCreateManyFirstAccountInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ConversationCreateManyInput = {
  answered?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deletedByFirstAccount?: InputMaybe<Scalars['Boolean']['input']>;
  deletedBySecondAccount?: InputMaybe<Scalars['Boolean']['input']>;
  firstAccountId: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  reminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  reviewed?: InputMaybe<Scalars['Boolean']['input']>;
  secondAccountId: Scalars['Int']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ConversationCreateManySecondAccountInput = {
  answered?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deletedByFirstAccount?: InputMaybe<Scalars['Boolean']['input']>;
  deletedBySecondAccount?: InputMaybe<Scalars['Boolean']['input']>;
  firstAccountId: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  reminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  reviewed?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ConversationCreateManySecondAccountInputEnvelope = {
  data: Array<ConversationCreateManySecondAccountInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ConversationCreateNestedManyWithoutFirstAccountInput = {
  connect?: InputMaybe<Array<ConversationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ConversationCreateOrConnectWithoutFirstAccountInput>>;
  create?: InputMaybe<Array<ConversationCreateWithoutFirstAccountInput>>;
  createMany?: InputMaybe<ConversationCreateManyFirstAccountInputEnvelope>;
};

export type ConversationCreateNestedManyWithoutSecondAccountInput = {
  connect?: InputMaybe<Array<ConversationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ConversationCreateOrConnectWithoutSecondAccountInput>>;
  create?: InputMaybe<Array<ConversationCreateWithoutSecondAccountInput>>;
  createMany?: InputMaybe<ConversationCreateManySecondAccountInputEnvelope>;
};

export type ConversationCreateOrConnectWithoutFirstAccountInput = {
  create: ConversationCreateWithoutFirstAccountInput;
  where: ConversationWhereUniqueInput;
};

export type ConversationCreateOrConnectWithoutSecondAccountInput = {
  create: ConversationCreateWithoutSecondAccountInput;
  where: ConversationWhereUniqueInput;
};

export type ConversationCreateWithoutFirstAccountInput = {
  answered?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deletedByFirstAccount?: InputMaybe<Scalars['Boolean']['input']>;
  deletedBySecondAccount?: InputMaybe<Scalars['Boolean']['input']>;
  reminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  reviewed?: InputMaybe<Scalars['Boolean']['input']>;
  secondAccount: AccountCreateNestedOneWithoutSecondAccountConversationsInput;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ConversationCreateWithoutSecondAccountInput = {
  answered?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deletedByFirstAccount?: InputMaybe<Scalars['Boolean']['input']>;
  deletedBySecondAccount?: InputMaybe<Scalars['Boolean']['input']>;
  firstAccount: AccountCreateNestedOneWithoutFirstAccountConversationsInput;
  reminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  reviewed?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ConversationListRelationFilter = {
  every?: InputMaybe<ConversationWhereInput>;
  none?: InputMaybe<ConversationWhereInput>;
  some?: InputMaybe<ConversationWhereInput>;
};

export type ConversationMaxAggregateOutputType = {
  __typename?: 'ConversationMaxAggregateOutputType';
  answered?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedByFirstAccount?: Maybe<Scalars['Boolean']['output']>;
  deletedBySecondAccount?: Maybe<Scalars['Boolean']['output']>;
  firstAccountId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  reminderSent?: Maybe<Scalars['Boolean']['output']>;
  reviewed?: Maybe<Scalars['Boolean']['output']>;
  secondAccountId?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ConversationMaxOrderByAggregateInput = {
  answered?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  deletedByFirstAccount?: InputMaybe<SortOrder>;
  deletedBySecondAccount?: InputMaybe<SortOrder>;
  firstAccountId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  reminderSent?: InputMaybe<SortOrder>;
  reviewed?: InputMaybe<SortOrder>;
  secondAccountId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ConversationMinAggregateOutputType = {
  __typename?: 'ConversationMinAggregateOutputType';
  answered?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedByFirstAccount?: Maybe<Scalars['Boolean']['output']>;
  deletedBySecondAccount?: Maybe<Scalars['Boolean']['output']>;
  firstAccountId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  reminderSent?: Maybe<Scalars['Boolean']['output']>;
  reviewed?: Maybe<Scalars['Boolean']['output']>;
  secondAccountId?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ConversationMinOrderByAggregateInput = {
  answered?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  deletedByFirstAccount?: InputMaybe<SortOrder>;
  deletedBySecondAccount?: InputMaybe<SortOrder>;
  firstAccountId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  reminderSent?: InputMaybe<SortOrder>;
  reviewed?: InputMaybe<SortOrder>;
  secondAccountId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ConversationOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ConversationOrderByWithAggregationInput = {
  _avg?: InputMaybe<ConversationAvgOrderByAggregateInput>;
  _count?: InputMaybe<ConversationCountOrderByAggregateInput>;
  _max?: InputMaybe<ConversationMaxOrderByAggregateInput>;
  _min?: InputMaybe<ConversationMinOrderByAggregateInput>;
  _sum?: InputMaybe<ConversationSumOrderByAggregateInput>;
  answered?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  deletedByFirstAccount?: InputMaybe<SortOrder>;
  deletedBySecondAccount?: InputMaybe<SortOrder>;
  firstAccountId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  reminderSent?: InputMaybe<SortOrder>;
  reviewed?: InputMaybe<SortOrder>;
  secondAccountId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ConversationOrderByWithRelationAndSearchRelevanceInput = {
  answered?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  deletedByFirstAccount?: InputMaybe<SortOrder>;
  deletedBySecondAccount?: InputMaybe<SortOrder>;
  firstAccount?: InputMaybe<AccountOrderByWithRelationAndSearchRelevanceInput>;
  firstAccountId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  reminderSent?: InputMaybe<SortOrder>;
  reviewed?: InputMaybe<SortOrder>;
  secondAccount?: InputMaybe<AccountOrderByWithRelationAndSearchRelevanceInput>;
  secondAccountId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum ConversationScalarFieldEnum {
  answered = 'answered',
  createdAt = 'createdAt',
  deletedByFirstAccount = 'deletedByFirstAccount',
  deletedBySecondAccount = 'deletedBySecondAccount',
  firstAccountId = 'firstAccountId',
  id = 'id',
  reminderSent = 'reminderSent',
  reviewed = 'reviewed',
  secondAccountId = 'secondAccountId',
  updatedAt = 'updatedAt'
}

export type ConversationScalarWhereInput = {
  AND?: InputMaybe<Array<ConversationScalarWhereInput>>;
  NOT?: InputMaybe<Array<ConversationScalarWhereInput>>;
  OR?: InputMaybe<Array<ConversationScalarWhereInput>>;
  answered?: InputMaybe<BoolFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedByFirstAccount?: InputMaybe<BoolFilter>;
  deletedBySecondAccount?: InputMaybe<BoolFilter>;
  firstAccountId?: InputMaybe<IntFilter>;
  id?: InputMaybe<IntFilter>;
  reminderSent?: InputMaybe<BoolFilter>;
  reviewed?: InputMaybe<BoolFilter>;
  secondAccountId?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ConversationScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<ConversationScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<ConversationScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<ConversationScalarWhereWithAggregatesInput>>;
  answered?: InputMaybe<BoolWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  deletedByFirstAccount?: InputMaybe<BoolWithAggregatesFilter>;
  deletedBySecondAccount?: InputMaybe<BoolWithAggregatesFilter>;
  firstAccountId?: InputMaybe<IntWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  reminderSent?: InputMaybe<BoolWithAggregatesFilter>;
  reviewed?: InputMaybe<BoolWithAggregatesFilter>;
  secondAccountId?: InputMaybe<IntWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type ConversationSumAggregateOutputType = {
  __typename?: 'ConversationSumAggregateOutputType';
  firstAccountId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  secondAccountId?: Maybe<Scalars['Int']['output']>;
};

export type ConversationSumOrderByAggregateInput = {
  firstAccountId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  secondAccountId?: InputMaybe<SortOrder>;
};

export type ConversationUncheckedCreateInput = {
  answered?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deletedByFirstAccount?: InputMaybe<Scalars['Boolean']['input']>;
  deletedBySecondAccount?: InputMaybe<Scalars['Boolean']['input']>;
  firstAccountId: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  reminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  reviewed?: InputMaybe<Scalars['Boolean']['input']>;
  secondAccountId: Scalars['Int']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ConversationUncheckedCreateNestedManyWithoutFirstAccountInput = {
  connect?: InputMaybe<Array<ConversationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ConversationCreateOrConnectWithoutFirstAccountInput>>;
  create?: InputMaybe<Array<ConversationCreateWithoutFirstAccountInput>>;
  createMany?: InputMaybe<ConversationCreateManyFirstAccountInputEnvelope>;
};

export type ConversationUncheckedCreateNestedManyWithoutSecondAccountInput = {
  connect?: InputMaybe<Array<ConversationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ConversationCreateOrConnectWithoutSecondAccountInput>>;
  create?: InputMaybe<Array<ConversationCreateWithoutSecondAccountInput>>;
  createMany?: InputMaybe<ConversationCreateManySecondAccountInputEnvelope>;
};

export type ConversationUncheckedCreateWithoutFirstAccountInput = {
  answered?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deletedByFirstAccount?: InputMaybe<Scalars['Boolean']['input']>;
  deletedBySecondAccount?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  reminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  reviewed?: InputMaybe<Scalars['Boolean']['input']>;
  secondAccountId: Scalars['Int']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ConversationUncheckedCreateWithoutSecondAccountInput = {
  answered?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deletedByFirstAccount?: InputMaybe<Scalars['Boolean']['input']>;
  deletedBySecondAccount?: InputMaybe<Scalars['Boolean']['input']>;
  firstAccountId: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  reminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  reviewed?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ConversationUncheckedUpdateInput = {
  answered?: InputMaybe<BoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedByFirstAccount?: InputMaybe<BoolFieldUpdateOperationsInput>;
  deletedBySecondAccount?: InputMaybe<BoolFieldUpdateOperationsInput>;
  firstAccountId?: InputMaybe<IntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  reminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  reviewed?: InputMaybe<BoolFieldUpdateOperationsInput>;
  secondAccountId?: InputMaybe<IntFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ConversationUncheckedUpdateManyInput = {
  answered?: InputMaybe<BoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedByFirstAccount?: InputMaybe<BoolFieldUpdateOperationsInput>;
  deletedBySecondAccount?: InputMaybe<BoolFieldUpdateOperationsInput>;
  firstAccountId?: InputMaybe<IntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  reminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  reviewed?: InputMaybe<BoolFieldUpdateOperationsInput>;
  secondAccountId?: InputMaybe<IntFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ConversationUncheckedUpdateManyWithoutFirstAccountInput = {
  answered?: InputMaybe<BoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedByFirstAccount?: InputMaybe<BoolFieldUpdateOperationsInput>;
  deletedBySecondAccount?: InputMaybe<BoolFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  reminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  reviewed?: InputMaybe<BoolFieldUpdateOperationsInput>;
  secondAccountId?: InputMaybe<IntFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ConversationUncheckedUpdateManyWithoutFirstAccountNestedInput = {
  connect?: InputMaybe<Array<ConversationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ConversationCreateOrConnectWithoutFirstAccountInput>>;
  create?: InputMaybe<Array<ConversationCreateWithoutFirstAccountInput>>;
  createMany?: InputMaybe<ConversationCreateManyFirstAccountInputEnvelope>;
  delete?: InputMaybe<Array<ConversationWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ConversationScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ConversationWhereUniqueInput>>;
  set?: InputMaybe<Array<ConversationWhereUniqueInput>>;
  update?: InputMaybe<Array<ConversationUpdateWithWhereUniqueWithoutFirstAccountInput>>;
  updateMany?: InputMaybe<Array<ConversationUpdateManyWithWhereWithoutFirstAccountInput>>;
  upsert?: InputMaybe<Array<ConversationUpsertWithWhereUniqueWithoutFirstAccountInput>>;
};

export type ConversationUncheckedUpdateManyWithoutSecondAccountInput = {
  answered?: InputMaybe<BoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedByFirstAccount?: InputMaybe<BoolFieldUpdateOperationsInput>;
  deletedBySecondAccount?: InputMaybe<BoolFieldUpdateOperationsInput>;
  firstAccountId?: InputMaybe<IntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  reminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  reviewed?: InputMaybe<BoolFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ConversationUncheckedUpdateManyWithoutSecondAccountNestedInput = {
  connect?: InputMaybe<Array<ConversationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ConversationCreateOrConnectWithoutSecondAccountInput>>;
  create?: InputMaybe<Array<ConversationCreateWithoutSecondAccountInput>>;
  createMany?: InputMaybe<ConversationCreateManySecondAccountInputEnvelope>;
  delete?: InputMaybe<Array<ConversationWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ConversationScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ConversationWhereUniqueInput>>;
  set?: InputMaybe<Array<ConversationWhereUniqueInput>>;
  update?: InputMaybe<Array<ConversationUpdateWithWhereUniqueWithoutSecondAccountInput>>;
  updateMany?: InputMaybe<Array<ConversationUpdateManyWithWhereWithoutSecondAccountInput>>;
  upsert?: InputMaybe<Array<ConversationUpsertWithWhereUniqueWithoutSecondAccountInput>>;
};

export type ConversationUncheckedUpdateWithoutFirstAccountInput = {
  answered?: InputMaybe<BoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedByFirstAccount?: InputMaybe<BoolFieldUpdateOperationsInput>;
  deletedBySecondAccount?: InputMaybe<BoolFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  reminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  reviewed?: InputMaybe<BoolFieldUpdateOperationsInput>;
  secondAccountId?: InputMaybe<IntFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ConversationUncheckedUpdateWithoutSecondAccountInput = {
  answered?: InputMaybe<BoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedByFirstAccount?: InputMaybe<BoolFieldUpdateOperationsInput>;
  deletedBySecondAccount?: InputMaybe<BoolFieldUpdateOperationsInput>;
  firstAccountId?: InputMaybe<IntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  reminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  reviewed?: InputMaybe<BoolFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ConversationUpdateInput = {
  answered?: InputMaybe<BoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedByFirstAccount?: InputMaybe<BoolFieldUpdateOperationsInput>;
  deletedBySecondAccount?: InputMaybe<BoolFieldUpdateOperationsInput>;
  firstAccount?: InputMaybe<AccountUpdateOneRequiredWithoutFirstAccountConversationsNestedInput>;
  reminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  reviewed?: InputMaybe<BoolFieldUpdateOperationsInput>;
  secondAccount?: InputMaybe<AccountUpdateOneRequiredWithoutSecondAccountConversationsNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ConversationUpdateManyMutationInput = {
  answered?: InputMaybe<BoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedByFirstAccount?: InputMaybe<BoolFieldUpdateOperationsInput>;
  deletedBySecondAccount?: InputMaybe<BoolFieldUpdateOperationsInput>;
  reminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  reviewed?: InputMaybe<BoolFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ConversationUpdateManyWithWhereWithoutFirstAccountInput = {
  data: ConversationUpdateManyMutationInput;
  where: ConversationScalarWhereInput;
};

export type ConversationUpdateManyWithWhereWithoutSecondAccountInput = {
  data: ConversationUpdateManyMutationInput;
  where: ConversationScalarWhereInput;
};

export type ConversationUpdateManyWithoutFirstAccountNestedInput = {
  connect?: InputMaybe<Array<ConversationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ConversationCreateOrConnectWithoutFirstAccountInput>>;
  create?: InputMaybe<Array<ConversationCreateWithoutFirstAccountInput>>;
  createMany?: InputMaybe<ConversationCreateManyFirstAccountInputEnvelope>;
  delete?: InputMaybe<Array<ConversationWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ConversationScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ConversationWhereUniqueInput>>;
  set?: InputMaybe<Array<ConversationWhereUniqueInput>>;
  update?: InputMaybe<Array<ConversationUpdateWithWhereUniqueWithoutFirstAccountInput>>;
  updateMany?: InputMaybe<Array<ConversationUpdateManyWithWhereWithoutFirstAccountInput>>;
  upsert?: InputMaybe<Array<ConversationUpsertWithWhereUniqueWithoutFirstAccountInput>>;
};

export type ConversationUpdateManyWithoutSecondAccountNestedInput = {
  connect?: InputMaybe<Array<ConversationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ConversationCreateOrConnectWithoutSecondAccountInput>>;
  create?: InputMaybe<Array<ConversationCreateWithoutSecondAccountInput>>;
  createMany?: InputMaybe<ConversationCreateManySecondAccountInputEnvelope>;
  delete?: InputMaybe<Array<ConversationWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ConversationScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ConversationWhereUniqueInput>>;
  set?: InputMaybe<Array<ConversationWhereUniqueInput>>;
  update?: InputMaybe<Array<ConversationUpdateWithWhereUniqueWithoutSecondAccountInput>>;
  updateMany?: InputMaybe<Array<ConversationUpdateManyWithWhereWithoutSecondAccountInput>>;
  upsert?: InputMaybe<Array<ConversationUpsertWithWhereUniqueWithoutSecondAccountInput>>;
};

export type ConversationUpdateWithWhereUniqueWithoutFirstAccountInput = {
  data: ConversationUpdateWithoutFirstAccountInput;
  where: ConversationWhereUniqueInput;
};

export type ConversationUpdateWithWhereUniqueWithoutSecondAccountInput = {
  data: ConversationUpdateWithoutSecondAccountInput;
  where: ConversationWhereUniqueInput;
};

export type ConversationUpdateWithoutFirstAccountInput = {
  answered?: InputMaybe<BoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedByFirstAccount?: InputMaybe<BoolFieldUpdateOperationsInput>;
  deletedBySecondAccount?: InputMaybe<BoolFieldUpdateOperationsInput>;
  reminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  reviewed?: InputMaybe<BoolFieldUpdateOperationsInput>;
  secondAccount?: InputMaybe<AccountUpdateOneRequiredWithoutSecondAccountConversationsNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ConversationUpdateWithoutSecondAccountInput = {
  answered?: InputMaybe<BoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedByFirstAccount?: InputMaybe<BoolFieldUpdateOperationsInput>;
  deletedBySecondAccount?: InputMaybe<BoolFieldUpdateOperationsInput>;
  firstAccount?: InputMaybe<AccountUpdateOneRequiredWithoutFirstAccountConversationsNestedInput>;
  reminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  reviewed?: InputMaybe<BoolFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ConversationUpsertWithWhereUniqueWithoutFirstAccountInput = {
  create: ConversationCreateWithoutFirstAccountInput;
  update: ConversationUpdateWithoutFirstAccountInput;
  where: ConversationWhereUniqueInput;
};

export type ConversationUpsertWithWhereUniqueWithoutSecondAccountInput = {
  create: ConversationCreateWithoutSecondAccountInput;
  update: ConversationUpdateWithoutSecondAccountInput;
  where: ConversationWhereUniqueInput;
};

export type ConversationWhereInput = {
  AND?: InputMaybe<Array<ConversationWhereInput>>;
  NOT?: InputMaybe<Array<ConversationWhereInput>>;
  OR?: InputMaybe<Array<ConversationWhereInput>>;
  answered?: InputMaybe<BoolFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedByFirstAccount?: InputMaybe<BoolFilter>;
  deletedBySecondAccount?: InputMaybe<BoolFilter>;
  firstAccount?: InputMaybe<AccountRelationFilter>;
  firstAccountId?: InputMaybe<IntFilter>;
  id?: InputMaybe<IntFilter>;
  reminderSent?: InputMaybe<BoolFilter>;
  reviewed?: InputMaybe<BoolFilter>;
  secondAccount?: InputMaybe<AccountRelationFilter>;
  secondAccountId?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ConversationWhereUniqueInput = {
  AND?: InputMaybe<Array<ConversationWhereInput>>;
  NOT?: InputMaybe<Array<ConversationWhereInput>>;
  OR?: InputMaybe<Array<ConversationWhereInput>>;
  answered?: InputMaybe<BoolFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedByFirstAccount?: InputMaybe<BoolFilter>;
  deletedBySecondAccount?: InputMaybe<BoolFilter>;
  firstAccount?: InputMaybe<AccountRelationFilter>;
  firstAccountId?: InputMaybe<IntFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  reminderSent?: InputMaybe<BoolFilter>;
  reviewed?: InputMaybe<BoolFilter>;
  secondAccount?: InputMaybe<AccountRelationFilter>;
  secondAccountId?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export enum CountryCode {
  BE = 'BE',
  CA = 'CA',
  CH = 'CH',
  DE = 'DE',
  EU = 'EU',
  FR = 'FR',
  NL = 'NL'
}

export enum CouplingType {
  FRESH_ARTIFICIAL = 'FRESH_ARTIFICIAL',
  FROZEN_ARTIFICIAL = 'FROZEN_ARTIFICIAL',
  NATURAL = 'NATURAL',
  REFRIGERATED_ARTIFICIAL = 'REFRIGERATED_ARTIFICIAL'
}

export type CreateApplicationInput = {
  accommodation: DogBreederApplicationAccommodation;
  accommodationDescription?: InputMaybe<Scalars['String']['input']>;
  dogBreedId: Scalars['Int']['input'];
  dogBreederId: Scalars['Int']['input'];
  experiences?: InputMaybe<Array<DogBreederApplicationExperience>>;
  genderPreferences?: InputMaybe<Array<GenderEnum>>;
  motive?: InputMaybe<Scalars['String']['input']>;
  otherAnimals?: InputMaybe<Array<DogBreederApplicationOtherAnimal>>;
  otherAnimalsDescription?: InputMaybe<Scalars['String']['input']>;
  otherPreferences?: InputMaybe<Scalars['String']['input']>;
  questions?: InputMaybe<Scalars['String']['input']>;
  timeAlone: DogBreederApplicationTimeAlone;
  trainers?: InputMaybe<Array<DogBreederApplicationTrainer>>;
};

export type CreateDogBreedInterestSubscriptionInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  country?: InputMaybe<CountryCode>;
  dogBreedNames: Array<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  hasADog?: InputMaybe<Scalars['Boolean']['input']>;
  language: Scalars['String']['input'];
  lookingFor?: InputMaybe<Scalars['String']['input']>;
  marketingEmailConsent: Scalars['Boolean']['input'];
  sensitivities?: InputMaybe<Array<InputMaybe<AnimalSensitivityEnum>>>;
};

export type CreateDogBreederReviewInput = {
  contactDate?: InputMaybe<Scalars['DateTime']['input']>;
  contactType?: InputMaybe<DogBreederContactType>;
  description?: InputMaybe<Scalars['String']['input']>;
  dogBreederId: Scalars['Int']['input'];
  dogsWellBeingGrade?: InputMaybe<Scalars['Int']['input']>;
  followUpGrade?: InputMaybe<Scalars['Int']['input']>;
  globalGrade?: InputMaybe<Scalars['Int']['input']>;
  humanContactGrade?: InputMaybe<Scalars['Int']['input']>;
  hygieneGrade?: InputMaybe<Scalars['Int']['input']>;
  microchip?: InputMaybe<Scalars['String']['input']>;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateEducatorReviewInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  grade?: InputMaybe<Scalars['Int']['input']>;
  professionalId: Scalars['Int']['input'];
  verified?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateEmailContactInput = {
  country?: InputMaybe<CountryCode>;
  createdFrom?: InputMaybe<EmailContactCreatedFromEnum>;
  email: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  hasADog?: InputMaybe<Scalars['Boolean']['input']>;
  hasTakenBreedTest?: InputMaybe<Scalars['Boolean']['input']>;
  language: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  lookingFor?: InputMaybe<Scalars['String']['input']>;
  marketingEmailConsent?: InputMaybe<Scalars['Boolean']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  sensitivities?: InputMaybe<Array<InputMaybe<AnimalSensitivityEnum>>>;
};

export type CreateLitterInput = {
  availabilityDate?: InputMaybe<Scalars['DateTime']['input']>;
  birthday?: InputMaybe<Scalars['DateTime']['input']>;
  born?: InputMaybe<Scalars['Boolean']['input']>;
  certified?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dewormed?: InputMaybe<Scalars['Boolean']['input']>;
  dogBreedId: Scalars['Int']['input'];
  fatherParentId?: InputMaybe<Scalars['Int']['input']>;
  femalesCount?: InputMaybe<Scalars['Int']['input']>;
  femalesLeftCount?: InputMaybe<Scalars['Int']['input']>;
  fixedPrice?: InputMaybe<Scalars['Boolean']['input']>;
  litterCode?: InputMaybe<Scalars['String']['input']>;
  malesCount?: InputMaybe<Scalars['Int']['input']>;
  malesLeftCount?: InputMaybe<Scalars['Int']['input']>;
  microchipped?: InputMaybe<Scalars['Boolean']['input']>;
  motherParentId?: InputMaybe<Scalars['Int']['input']>;
  pedigree?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  priceFrom?: InputMaybe<Scalars['Float']['input']>;
  priceTo?: InputMaybe<Scalars['Float']['input']>;
  vaccinated?: InputMaybe<Scalars['Boolean']['input']>;
  vaccinationDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CustomContactPreferences = {
  __typename?: 'CustomContactPreferences';
  contactPreferences: Array<ContactPreference>;
  email: Scalars['String']['output'];
  isRegisteredUser?: Maybe<Scalars['Boolean']['output']>;
};

export type DashboardStatisticsAvgAggregateOutputType = {
  __typename?: 'DashboardStatisticsAvgAggregateOutputType';
  id?: Maybe<Scalars['Float']['output']>;
};

export type DashboardStatisticsAvgOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
};

export type DashboardStatisticsCountAggregateOutputType = {
  __typename?: 'DashboardStatisticsCountAggregateOutputType';
  _all: Scalars['Int']['output'];
  country: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  data: Scalars['Int']['output'];
  displayType: Scalars['Int']['output'];
  endDate: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  startDate: Scalars['Int']['output'];
  type: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type DashboardStatisticsCountOrderByAggregateInput = {
  country?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  data?: InputMaybe<SortOrder>;
  displayType?: InputMaybe<SortOrder>;
  endDate?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  startDate?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type DashboardStatisticsCreateInput = {
  country?: InputMaybe<CountryCode>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  data: Scalars['Json']['input'];
  displayType: DashboardStatsDisplayTypeEnum;
  endDate: Scalars['DateTime']['input'];
  startDate: Scalars['DateTime']['input'];
  type: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DashboardStatisticsCreateManyInput = {
  country?: InputMaybe<CountryCode>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  data: Scalars['Json']['input'];
  displayType: DashboardStatsDisplayTypeEnum;
  endDate: Scalars['DateTime']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  startDate: Scalars['DateTime']['input'];
  type: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DashboardStatisticsMaxAggregateOutputType = {
  __typename?: 'DashboardStatisticsMaxAggregateOutputType';
  country?: Maybe<CountryCode>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  displayType?: Maybe<DashboardStatsDisplayTypeEnum>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type DashboardStatisticsMaxOrderByAggregateInput = {
  country?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  displayType?: InputMaybe<SortOrder>;
  endDate?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  startDate?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type DashboardStatisticsMinAggregateOutputType = {
  __typename?: 'DashboardStatisticsMinAggregateOutputType';
  country?: Maybe<CountryCode>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  displayType?: Maybe<DashboardStatsDisplayTypeEnum>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type DashboardStatisticsMinOrderByAggregateInput = {
  country?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  displayType?: InputMaybe<SortOrder>;
  endDate?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  startDate?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum DashboardStatisticsOrderByRelevanceFieldEnum {
  type = 'type'
}

export type DashboardStatisticsOrderByRelevanceInput = {
  fields: Array<DashboardStatisticsOrderByRelevanceFieldEnum>;
  search: Scalars['String']['input'];
  sort: SortOrder;
};

export type DashboardStatisticsOrderByWithAggregationInput = {
  _avg?: InputMaybe<DashboardStatisticsAvgOrderByAggregateInput>;
  _count?: InputMaybe<DashboardStatisticsCountOrderByAggregateInput>;
  _max?: InputMaybe<DashboardStatisticsMaxOrderByAggregateInput>;
  _min?: InputMaybe<DashboardStatisticsMinOrderByAggregateInput>;
  _sum?: InputMaybe<DashboardStatisticsSumOrderByAggregateInput>;
  country?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  data?: InputMaybe<SortOrder>;
  displayType?: InputMaybe<SortOrder>;
  endDate?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  startDate?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type DashboardStatisticsOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: InputMaybe<DashboardStatisticsOrderByRelevanceInput>;
  country?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  data?: InputMaybe<SortOrder>;
  displayType?: InputMaybe<SortOrder>;
  endDate?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  startDate?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum DashboardStatisticsScalarFieldEnum {
  country = 'country',
  createdAt = 'createdAt',
  data = 'data',
  displayType = 'displayType',
  endDate = 'endDate',
  id = 'id',
  startDate = 'startDate',
  type = 'type',
  updatedAt = 'updatedAt'
}

export type DashboardStatisticsScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<DashboardStatisticsScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<DashboardStatisticsScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<DashboardStatisticsScalarWhereWithAggregatesInput>>;
  country?: InputMaybe<EnumCountryCodeNullableWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  data?: InputMaybe<JsonWithAggregatesFilter>;
  displayType?: InputMaybe<EnumDashboardStatsDisplayTypeEnumWithAggregatesFilter>;
  endDate?: InputMaybe<DateTimeWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  startDate?: InputMaybe<DateTimeWithAggregatesFilter>;
  type?: InputMaybe<StringWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type DashboardStatisticsSumAggregateOutputType = {
  __typename?: 'DashboardStatisticsSumAggregateOutputType';
  id?: Maybe<Scalars['Int']['output']>;
};

export type DashboardStatisticsSumOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
};

export type DashboardStatisticsUncheckedCreateInput = {
  country?: InputMaybe<CountryCode>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  data: Scalars['Json']['input'];
  displayType: DashboardStatsDisplayTypeEnum;
  endDate: Scalars['DateTime']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  startDate: Scalars['DateTime']['input'];
  type: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DashboardStatisticsUncheckedUpdateInput = {
  country?: InputMaybe<NullableEnumCountryCodeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['Json']['input']>;
  displayType?: InputMaybe<EnumDashboardStatsDisplayTypeEnumFieldUpdateOperationsInput>;
  endDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  startDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  type?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DashboardStatisticsUncheckedUpdateManyInput = {
  country?: InputMaybe<NullableEnumCountryCodeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['Json']['input']>;
  displayType?: InputMaybe<EnumDashboardStatsDisplayTypeEnumFieldUpdateOperationsInput>;
  endDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  startDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  type?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DashboardStatisticsUpdateInput = {
  country?: InputMaybe<NullableEnumCountryCodeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['Json']['input']>;
  displayType?: InputMaybe<EnumDashboardStatsDisplayTypeEnumFieldUpdateOperationsInput>;
  endDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  startDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  type?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DashboardStatisticsUpdateManyMutationInput = {
  country?: InputMaybe<NullableEnumCountryCodeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['Json']['input']>;
  displayType?: InputMaybe<EnumDashboardStatsDisplayTypeEnumFieldUpdateOperationsInput>;
  endDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  startDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  type?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DashboardStatisticsWhereInput = {
  AND?: InputMaybe<Array<DashboardStatisticsWhereInput>>;
  NOT?: InputMaybe<Array<DashboardStatisticsWhereInput>>;
  OR?: InputMaybe<Array<DashboardStatisticsWhereInput>>;
  country?: InputMaybe<EnumCountryCodeNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  data?: InputMaybe<JsonFilter>;
  displayType?: InputMaybe<EnumDashboardStatsDisplayTypeEnumFilter>;
  endDate?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntFilter>;
  startDate?: InputMaybe<DateTimeFilter>;
  type?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type DashboardStatisticsWhereUniqueInput = {
  AND?: InputMaybe<Array<DashboardStatisticsWhereInput>>;
  NOT?: InputMaybe<Array<DashboardStatisticsWhereInput>>;
  OR?: InputMaybe<Array<DashboardStatisticsWhereInput>>;
  country?: InputMaybe<EnumCountryCodeNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  data?: InputMaybe<JsonFilter>;
  displayType?: InputMaybe<EnumDashboardStatsDisplayTypeEnumFilter>;
  endDate?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<DateTimeFilter>;
  type?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export enum DashboardStatsDisplayTypeEnum {
  DAY = 'DAY',
  MONTH = 'MONTH',
  WEEK = 'WEEK',
  YEAR = 'YEAR'
}

export type DateTimeFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DateTimeFilter = {
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  not?: InputMaybe<NestedDateTimeFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

export type DateTimeNullableFilter = {
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  not?: InputMaybe<NestedDateTimeNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

export type DateTimeNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedDateTimeNullableFilter>;
  _min?: InputMaybe<NestedDateTimeNullableFilter>;
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  not?: InputMaybe<NestedDateTimeNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

export type DateTimeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedDateTimeFilter>;
  _min?: InputMaybe<NestedDateTimeFilter>;
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  not?: InputMaybe<NestedDateTimeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

export enum DayOfWeek {
  FRIDAY = 'FRIDAY',
  MONDAY = 'MONDAY',
  SATURDAY = 'SATURDAY',
  SUNDAY = 'SUNDAY',
  THURSDAY = 'THURSDAY',
  TUESDAY = 'TUESDAY',
  WEDNESDAY = 'WEDNESDAY'
}

export type DayTimeRange = {
  __typename?: 'DayTimeRange';
  end: Scalars['String']['output'];
  start: Scalars['String']['output'];
};

export type DeleteApplicationInput = {
  applicationId: Scalars['Int']['input'];
  rejectedReason: Scalars['String']['input'];
};

export type DogBreed = {
  __typename?: 'DogBreed';
  _count: DogBreedCountOutputType;
  adultSizeAge?: Maybe<Scalars['Int']['output']>;
  barkingTendancyIndex?: Maybe<Scalars['Float']['output']>;
  baseBreedName?: Maybe<Scalars['String']['output']>;
  careIndex?: Maybe<Scalars['Int']['output']>;
  coldToleranceIndex?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['DateTime']['output'];
  dogBreeders: Array<DogBreederBreeds>;
  dogInfos: Array<DogInfo>;
  dogType: Array<DogType>;
  educationIndex?: Maybe<Scalars['Int']['output']>;
  exerciseIndex?: Maybe<Scalars['Int']['output']>;
  fciGroup?: Maybe<Scalars['String']['output']>;
  foreignerSociabilityIndex?: Maybe<Scalars['Float']['output']>;
  hairLossIndex?: Maybe<Scalars['Float']['output']>;
  hairType?: Maybe<DogHairType>;
  headShape?: Maybe<HeadShape>;
  heatToleranceIndex?: Maybe<Scalars['Float']['output']>;
  homeCountryCode?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  imgs: Array<DogBreedImg>;
  independenceIndex?: Maybe<Scalars['Float']['output']>;
  intellectualActivityNeedIndex?: Maybe<Scalars['Float']['output']>;
  isSubBreed: Scalars['Boolean']['output'];
  litters: Array<Litter>;
  maintenanceIndex?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  physicalActivityNeedIndex?: Maybe<Scalars['Float']['output']>;
  predatoryInstinctIndex?: Maybe<Scalars['Float']['output']>;
  robustnessIndex?: Maybe<Scalars['Int']['output']>;
  sizeCategory?: Maybe<AnimalSizeEnum>;
  sociabilityIndex?: Maybe<Scalars['Int']['output']>;
  sortingIndex?: Maybe<Scalars['Int']['output']>;
  translations: Array<DogBreedTranslation>;
  updatedAt: Scalars['DateTime']['output'];
  videoUrl?: Maybe<Scalars['String']['output']>;
};


export type DogBreeddogBreedersArgs = {
  cursor?: InputMaybe<DogBreederBreedsWhereUniqueInput>;
  distinct?: InputMaybe<DogBreederBreedsScalarFieldEnum>;
  orderBy?: InputMaybe<DogBreederBreedsOrderByWithRelationAndSearchRelevanceInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DogBreederBreedsWhereInput>;
};


export type DogBreeddogInfosArgs = {
  cursor?: InputMaybe<DogInfoWhereUniqueInput>;
  distinct?: InputMaybe<DogInfoScalarFieldEnum>;
  orderBy?: InputMaybe<DogInfoOrderByWithRelationAndSearchRelevanceInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DogInfoWhereInput>;
};


export type DogBreedimgsArgs = {
  cursor?: InputMaybe<DogBreedImgWhereUniqueInput>;
  distinct?: InputMaybe<DogBreedImgScalarFieldEnum>;
  orderBy?: InputMaybe<DogBreedImgOrderByWithRelationAndSearchRelevanceInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DogBreedImgWhereInput>;
};


export type DogBreedlittersArgs = {
  cursor?: InputMaybe<LitterWhereUniqueInput>;
  distinct?: InputMaybe<LitterScalarFieldEnum>;
  orderBy?: InputMaybe<LitterOrderByWithRelationAndSearchRelevanceInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<LitterWhereInput>;
};


export type DogBreedtranslationsArgs = {
  cursor?: InputMaybe<DogBreedTranslationWhereUniqueInput>;
  distinct?: InputMaybe<DogBreedTranslationScalarFieldEnum>;
  orderBy?: InputMaybe<DogBreedTranslationOrderByWithRelationAndSearchRelevanceInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DogBreedTranslationWhereInput>;
};

export type DogBreedAvgAggregateOutputType = {
  __typename?: 'DogBreedAvgAggregateOutputType';
  adultSizeAge?: Maybe<Scalars['Float']['output']>;
  barkingTendancyIndex?: Maybe<Scalars['Float']['output']>;
  careIndex?: Maybe<Scalars['Float']['output']>;
  coldToleranceIndex?: Maybe<Scalars['Float']['output']>;
  educationIndex?: Maybe<Scalars['Float']['output']>;
  exerciseIndex?: Maybe<Scalars['Float']['output']>;
  foreignerSociabilityIndex?: Maybe<Scalars['Float']['output']>;
  hairLossIndex?: Maybe<Scalars['Float']['output']>;
  heatToleranceIndex?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  independenceIndex?: Maybe<Scalars['Float']['output']>;
  intellectualActivityNeedIndex?: Maybe<Scalars['Float']['output']>;
  maintenanceIndex?: Maybe<Scalars['Float']['output']>;
  physicalActivityNeedIndex?: Maybe<Scalars['Float']['output']>;
  predatoryInstinctIndex?: Maybe<Scalars['Float']['output']>;
  robustnessIndex?: Maybe<Scalars['Float']['output']>;
  sociabilityIndex?: Maybe<Scalars['Float']['output']>;
  sortingIndex?: Maybe<Scalars['Float']['output']>;
};

export type DogBreedAvgOrderByAggregateInput = {
  adultSizeAge?: InputMaybe<SortOrder>;
  barkingTendancyIndex?: InputMaybe<SortOrder>;
  careIndex?: InputMaybe<SortOrder>;
  coldToleranceIndex?: InputMaybe<SortOrder>;
  educationIndex?: InputMaybe<SortOrder>;
  exerciseIndex?: InputMaybe<SortOrder>;
  foreignerSociabilityIndex?: InputMaybe<SortOrder>;
  hairLossIndex?: InputMaybe<SortOrder>;
  heatToleranceIndex?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  independenceIndex?: InputMaybe<SortOrder>;
  intellectualActivityNeedIndex?: InputMaybe<SortOrder>;
  maintenanceIndex?: InputMaybe<SortOrder>;
  physicalActivityNeedIndex?: InputMaybe<SortOrder>;
  predatoryInstinctIndex?: InputMaybe<SortOrder>;
  robustnessIndex?: InputMaybe<SortOrder>;
  sociabilityIndex?: InputMaybe<SortOrder>;
  sortingIndex?: InputMaybe<SortOrder>;
};

export type DogBreedCountAggregateOutputType = {
  __typename?: 'DogBreedCountAggregateOutputType';
  _all: Scalars['Int']['output'];
  adultSizeAge: Scalars['Int']['output'];
  barkingTendancyIndex: Scalars['Int']['output'];
  baseBreedName: Scalars['Int']['output'];
  careIndex: Scalars['Int']['output'];
  coldToleranceIndex: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  dogType: Scalars['Int']['output'];
  educationIndex: Scalars['Int']['output'];
  exerciseIndex: Scalars['Int']['output'];
  fciGroup: Scalars['Int']['output'];
  foreignerSociabilityIndex: Scalars['Int']['output'];
  hairLossIndex: Scalars['Int']['output'];
  hairType: Scalars['Int']['output'];
  headShape: Scalars['Int']['output'];
  heatToleranceIndex: Scalars['Int']['output'];
  homeCountryCode: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  independenceIndex: Scalars['Int']['output'];
  intellectualActivityNeedIndex: Scalars['Int']['output'];
  isSubBreed: Scalars['Int']['output'];
  maintenanceIndex: Scalars['Int']['output'];
  name: Scalars['Int']['output'];
  physicalActivityNeedIndex: Scalars['Int']['output'];
  predatoryInstinctIndex: Scalars['Int']['output'];
  robustnessIndex: Scalars['Int']['output'];
  sizeCategory: Scalars['Int']['output'];
  sociabilityIndex: Scalars['Int']['output'];
  sortingIndex: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
  videoUrl: Scalars['Int']['output'];
};

export type DogBreedCountOrderByAggregateInput = {
  adultSizeAge?: InputMaybe<SortOrder>;
  barkingTendancyIndex?: InputMaybe<SortOrder>;
  baseBreedName?: InputMaybe<SortOrder>;
  careIndex?: InputMaybe<SortOrder>;
  coldToleranceIndex?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  dogType?: InputMaybe<SortOrder>;
  educationIndex?: InputMaybe<SortOrder>;
  exerciseIndex?: InputMaybe<SortOrder>;
  fciGroup?: InputMaybe<SortOrder>;
  foreignerSociabilityIndex?: InputMaybe<SortOrder>;
  hairLossIndex?: InputMaybe<SortOrder>;
  hairType?: InputMaybe<SortOrder>;
  headShape?: InputMaybe<SortOrder>;
  heatToleranceIndex?: InputMaybe<SortOrder>;
  homeCountryCode?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  independenceIndex?: InputMaybe<SortOrder>;
  intellectualActivityNeedIndex?: InputMaybe<SortOrder>;
  isSubBreed?: InputMaybe<SortOrder>;
  maintenanceIndex?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  physicalActivityNeedIndex?: InputMaybe<SortOrder>;
  predatoryInstinctIndex?: InputMaybe<SortOrder>;
  robustnessIndex?: InputMaybe<SortOrder>;
  sizeCategory?: InputMaybe<SortOrder>;
  sociabilityIndex?: InputMaybe<SortOrder>;
  sortingIndex?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  videoUrl?: InputMaybe<SortOrder>;
};

export type DogBreedCountOutputType = {
  __typename?: 'DogBreedCountOutputType';
  applications: Scalars['Int']['output'];
  breedInterestSubscriptions: Scalars['Int']['output'];
  dogBreeders: Scalars['Int']['output'];
  dogInfos: Scalars['Int']['output'];
  imgs: Scalars['Int']['output'];
  litters: Scalars['Int']['output'];
  puppies: Scalars['Int']['output'];
  translations: Scalars['Int']['output'];
};

export type DogBreedCreateInput = {
  adultSizeAge?: InputMaybe<Scalars['Int']['input']>;
  applications?: InputMaybe<DogBreederApplicationCreateNestedManyWithoutBreedPreferenceInput>;
  barkingTendancyIndex?: InputMaybe<Scalars['Float']['input']>;
  baseBreedName?: InputMaybe<Scalars['String']['input']>;
  breedInterestSubscriptions?: InputMaybe<DogBreedInterestSubscriptionCreateNestedManyWithoutDogBreedsInput>;
  careIndex?: InputMaybe<Scalars['Int']['input']>;
  coldToleranceIndex?: InputMaybe<Scalars['Float']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dogBreeders?: InputMaybe<DogBreederBreedsCreateNestedManyWithoutDogBreedInput>;
  dogInfos?: InputMaybe<DogInfoCreateNestedManyWithoutDogBreedInput>;
  dogType?: InputMaybe<Array<DogType>>;
  educationIndex?: InputMaybe<Scalars['Int']['input']>;
  exerciseIndex?: InputMaybe<Scalars['Int']['input']>;
  fciGroup?: InputMaybe<Scalars['String']['input']>;
  foreignerSociabilityIndex?: InputMaybe<Scalars['Float']['input']>;
  hairLossIndex?: InputMaybe<Scalars['Float']['input']>;
  hairType?: InputMaybe<DogHairType>;
  headShape?: InputMaybe<HeadShape>;
  heatToleranceIndex?: InputMaybe<Scalars['Float']['input']>;
  homeCountryCode?: InputMaybe<Scalars['String']['input']>;
  imgs?: InputMaybe<DogBreedImgCreateNestedManyWithoutDogBreedInput>;
  independenceIndex?: InputMaybe<Scalars['Float']['input']>;
  intellectualActivityNeedIndex?: InputMaybe<Scalars['Float']['input']>;
  isSubBreed?: InputMaybe<Scalars['Boolean']['input']>;
  litters?: InputMaybe<LitterCreateNestedManyWithoutDogBreedInput>;
  maintenanceIndex?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  physicalActivityNeedIndex?: InputMaybe<Scalars['Float']['input']>;
  predatoryInstinctIndex?: InputMaybe<Scalars['Float']['input']>;
  puppies?: InputMaybe<DogPuppyCreateNestedManyWithoutBreedInput>;
  robustnessIndex?: InputMaybe<Scalars['Int']['input']>;
  sizeCategory?: InputMaybe<AnimalSizeEnum>;
  sociabilityIndex?: InputMaybe<Scalars['Int']['input']>;
  sortingIndex?: InputMaybe<Scalars['Int']['input']>;
  translations?: InputMaybe<DogBreedTranslationCreateNestedManyWithoutDogBreedInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  videoUrl?: InputMaybe<Scalars['String']['input']>;
};

export type DogBreedCreateManyInput = {
  adultSizeAge?: InputMaybe<Scalars['Int']['input']>;
  barkingTendancyIndex?: InputMaybe<Scalars['Float']['input']>;
  baseBreedName?: InputMaybe<Scalars['String']['input']>;
  careIndex?: InputMaybe<Scalars['Int']['input']>;
  coldToleranceIndex?: InputMaybe<Scalars['Float']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dogType?: InputMaybe<Array<DogType>>;
  educationIndex?: InputMaybe<Scalars['Int']['input']>;
  exerciseIndex?: InputMaybe<Scalars['Int']['input']>;
  fciGroup?: InputMaybe<Scalars['String']['input']>;
  foreignerSociabilityIndex?: InputMaybe<Scalars['Float']['input']>;
  hairLossIndex?: InputMaybe<Scalars['Float']['input']>;
  hairType?: InputMaybe<DogHairType>;
  headShape?: InputMaybe<HeadShape>;
  heatToleranceIndex?: InputMaybe<Scalars['Float']['input']>;
  homeCountryCode?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  independenceIndex?: InputMaybe<Scalars['Float']['input']>;
  intellectualActivityNeedIndex?: InputMaybe<Scalars['Float']['input']>;
  isSubBreed?: InputMaybe<Scalars['Boolean']['input']>;
  maintenanceIndex?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  physicalActivityNeedIndex?: InputMaybe<Scalars['Float']['input']>;
  predatoryInstinctIndex?: InputMaybe<Scalars['Float']['input']>;
  robustnessIndex?: InputMaybe<Scalars['Int']['input']>;
  sizeCategory?: InputMaybe<AnimalSizeEnum>;
  sociabilityIndex?: InputMaybe<Scalars['Int']['input']>;
  sortingIndex?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  videoUrl?: InputMaybe<Scalars['String']['input']>;
};

export type DogBreedCreateNestedManyWithoutBreedInterestSubscriptionsInput = {
  connect?: InputMaybe<Array<DogBreedWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DogBreedCreateOrConnectWithoutBreedInterestSubscriptionsInput>>;
  create?: InputMaybe<Array<DogBreedCreateWithoutBreedInterestSubscriptionsInput>>;
};

export type DogBreedCreateNestedOneWithoutApplicationsInput = {
  connect?: InputMaybe<DogBreedWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DogBreedCreateOrConnectWithoutApplicationsInput>;
  create?: InputMaybe<DogBreedCreateWithoutApplicationsInput>;
};

export type DogBreedCreateNestedOneWithoutDogBreedersInput = {
  connect?: InputMaybe<DogBreedWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DogBreedCreateOrConnectWithoutDogBreedersInput>;
  create?: InputMaybe<DogBreedCreateWithoutDogBreedersInput>;
};

export type DogBreedCreateNestedOneWithoutDogInfosInput = {
  connect?: InputMaybe<DogBreedWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DogBreedCreateOrConnectWithoutDogInfosInput>;
  create?: InputMaybe<DogBreedCreateWithoutDogInfosInput>;
};

export type DogBreedCreateNestedOneWithoutImgsInput = {
  connect?: InputMaybe<DogBreedWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DogBreedCreateOrConnectWithoutImgsInput>;
  create?: InputMaybe<DogBreedCreateWithoutImgsInput>;
};

export type DogBreedCreateNestedOneWithoutLittersInput = {
  connect?: InputMaybe<DogBreedWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DogBreedCreateOrConnectWithoutLittersInput>;
  create?: InputMaybe<DogBreedCreateWithoutLittersInput>;
};

export type DogBreedCreateNestedOneWithoutPuppiesInput = {
  connect?: InputMaybe<DogBreedWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DogBreedCreateOrConnectWithoutPuppiesInput>;
  create?: InputMaybe<DogBreedCreateWithoutPuppiesInput>;
};

export type DogBreedCreateNestedOneWithoutTranslationsInput = {
  connect?: InputMaybe<DogBreedWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DogBreedCreateOrConnectWithoutTranslationsInput>;
  create?: InputMaybe<DogBreedCreateWithoutTranslationsInput>;
};

export type DogBreedCreateOrConnectWithoutApplicationsInput = {
  create: DogBreedCreateWithoutApplicationsInput;
  where: DogBreedWhereUniqueInput;
};

export type DogBreedCreateOrConnectWithoutBreedInterestSubscriptionsInput = {
  create: DogBreedCreateWithoutBreedInterestSubscriptionsInput;
  where: DogBreedWhereUniqueInput;
};

export type DogBreedCreateOrConnectWithoutDogBreedersInput = {
  create: DogBreedCreateWithoutDogBreedersInput;
  where: DogBreedWhereUniqueInput;
};

export type DogBreedCreateOrConnectWithoutDogInfosInput = {
  create: DogBreedCreateWithoutDogInfosInput;
  where: DogBreedWhereUniqueInput;
};

export type DogBreedCreateOrConnectWithoutImgsInput = {
  create: DogBreedCreateWithoutImgsInput;
  where: DogBreedWhereUniqueInput;
};

export type DogBreedCreateOrConnectWithoutLittersInput = {
  create: DogBreedCreateWithoutLittersInput;
  where: DogBreedWhereUniqueInput;
};

export type DogBreedCreateOrConnectWithoutPuppiesInput = {
  create: DogBreedCreateWithoutPuppiesInput;
  where: DogBreedWhereUniqueInput;
};

export type DogBreedCreateOrConnectWithoutTranslationsInput = {
  create: DogBreedCreateWithoutTranslationsInput;
  where: DogBreedWhereUniqueInput;
};

export type DogBreedCreateWithoutApplicationsInput = {
  adultSizeAge?: InputMaybe<Scalars['Int']['input']>;
  barkingTendancyIndex?: InputMaybe<Scalars['Float']['input']>;
  baseBreedName?: InputMaybe<Scalars['String']['input']>;
  breedInterestSubscriptions?: InputMaybe<DogBreedInterestSubscriptionCreateNestedManyWithoutDogBreedsInput>;
  careIndex?: InputMaybe<Scalars['Int']['input']>;
  coldToleranceIndex?: InputMaybe<Scalars['Float']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dogBreeders?: InputMaybe<DogBreederBreedsCreateNestedManyWithoutDogBreedInput>;
  dogInfos?: InputMaybe<DogInfoCreateNestedManyWithoutDogBreedInput>;
  dogType?: InputMaybe<Array<DogType>>;
  educationIndex?: InputMaybe<Scalars['Int']['input']>;
  exerciseIndex?: InputMaybe<Scalars['Int']['input']>;
  fciGroup?: InputMaybe<Scalars['String']['input']>;
  foreignerSociabilityIndex?: InputMaybe<Scalars['Float']['input']>;
  hairLossIndex?: InputMaybe<Scalars['Float']['input']>;
  hairType?: InputMaybe<DogHairType>;
  headShape?: InputMaybe<HeadShape>;
  heatToleranceIndex?: InputMaybe<Scalars['Float']['input']>;
  homeCountryCode?: InputMaybe<Scalars['String']['input']>;
  imgs?: InputMaybe<DogBreedImgCreateNestedManyWithoutDogBreedInput>;
  independenceIndex?: InputMaybe<Scalars['Float']['input']>;
  intellectualActivityNeedIndex?: InputMaybe<Scalars['Float']['input']>;
  isSubBreed?: InputMaybe<Scalars['Boolean']['input']>;
  litters?: InputMaybe<LitterCreateNestedManyWithoutDogBreedInput>;
  maintenanceIndex?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  physicalActivityNeedIndex?: InputMaybe<Scalars['Float']['input']>;
  predatoryInstinctIndex?: InputMaybe<Scalars['Float']['input']>;
  puppies?: InputMaybe<DogPuppyCreateNestedManyWithoutBreedInput>;
  robustnessIndex?: InputMaybe<Scalars['Int']['input']>;
  sizeCategory?: InputMaybe<AnimalSizeEnum>;
  sociabilityIndex?: InputMaybe<Scalars['Int']['input']>;
  sortingIndex?: InputMaybe<Scalars['Int']['input']>;
  translations?: InputMaybe<DogBreedTranslationCreateNestedManyWithoutDogBreedInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  videoUrl?: InputMaybe<Scalars['String']['input']>;
};

export type DogBreedCreateWithoutBreedInterestSubscriptionsInput = {
  adultSizeAge?: InputMaybe<Scalars['Int']['input']>;
  applications?: InputMaybe<DogBreederApplicationCreateNestedManyWithoutBreedPreferenceInput>;
  barkingTendancyIndex?: InputMaybe<Scalars['Float']['input']>;
  baseBreedName?: InputMaybe<Scalars['String']['input']>;
  careIndex?: InputMaybe<Scalars['Int']['input']>;
  coldToleranceIndex?: InputMaybe<Scalars['Float']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dogBreeders?: InputMaybe<DogBreederBreedsCreateNestedManyWithoutDogBreedInput>;
  dogInfos?: InputMaybe<DogInfoCreateNestedManyWithoutDogBreedInput>;
  dogType?: InputMaybe<Array<DogType>>;
  educationIndex?: InputMaybe<Scalars['Int']['input']>;
  exerciseIndex?: InputMaybe<Scalars['Int']['input']>;
  fciGroup?: InputMaybe<Scalars['String']['input']>;
  foreignerSociabilityIndex?: InputMaybe<Scalars['Float']['input']>;
  hairLossIndex?: InputMaybe<Scalars['Float']['input']>;
  hairType?: InputMaybe<DogHairType>;
  headShape?: InputMaybe<HeadShape>;
  heatToleranceIndex?: InputMaybe<Scalars['Float']['input']>;
  homeCountryCode?: InputMaybe<Scalars['String']['input']>;
  imgs?: InputMaybe<DogBreedImgCreateNestedManyWithoutDogBreedInput>;
  independenceIndex?: InputMaybe<Scalars['Float']['input']>;
  intellectualActivityNeedIndex?: InputMaybe<Scalars['Float']['input']>;
  isSubBreed?: InputMaybe<Scalars['Boolean']['input']>;
  litters?: InputMaybe<LitterCreateNestedManyWithoutDogBreedInput>;
  maintenanceIndex?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  physicalActivityNeedIndex?: InputMaybe<Scalars['Float']['input']>;
  predatoryInstinctIndex?: InputMaybe<Scalars['Float']['input']>;
  puppies?: InputMaybe<DogPuppyCreateNestedManyWithoutBreedInput>;
  robustnessIndex?: InputMaybe<Scalars['Int']['input']>;
  sizeCategory?: InputMaybe<AnimalSizeEnum>;
  sociabilityIndex?: InputMaybe<Scalars['Int']['input']>;
  sortingIndex?: InputMaybe<Scalars['Int']['input']>;
  translations?: InputMaybe<DogBreedTranslationCreateNestedManyWithoutDogBreedInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  videoUrl?: InputMaybe<Scalars['String']['input']>;
};

export type DogBreedCreateWithoutDogBreedersInput = {
  adultSizeAge?: InputMaybe<Scalars['Int']['input']>;
  applications?: InputMaybe<DogBreederApplicationCreateNestedManyWithoutBreedPreferenceInput>;
  barkingTendancyIndex?: InputMaybe<Scalars['Float']['input']>;
  baseBreedName?: InputMaybe<Scalars['String']['input']>;
  breedInterestSubscriptions?: InputMaybe<DogBreedInterestSubscriptionCreateNestedManyWithoutDogBreedsInput>;
  careIndex?: InputMaybe<Scalars['Int']['input']>;
  coldToleranceIndex?: InputMaybe<Scalars['Float']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dogInfos?: InputMaybe<DogInfoCreateNestedManyWithoutDogBreedInput>;
  dogType?: InputMaybe<Array<DogType>>;
  educationIndex?: InputMaybe<Scalars['Int']['input']>;
  exerciseIndex?: InputMaybe<Scalars['Int']['input']>;
  fciGroup?: InputMaybe<Scalars['String']['input']>;
  foreignerSociabilityIndex?: InputMaybe<Scalars['Float']['input']>;
  hairLossIndex?: InputMaybe<Scalars['Float']['input']>;
  hairType?: InputMaybe<DogHairType>;
  headShape?: InputMaybe<HeadShape>;
  heatToleranceIndex?: InputMaybe<Scalars['Float']['input']>;
  homeCountryCode?: InputMaybe<Scalars['String']['input']>;
  imgs?: InputMaybe<DogBreedImgCreateNestedManyWithoutDogBreedInput>;
  independenceIndex?: InputMaybe<Scalars['Float']['input']>;
  intellectualActivityNeedIndex?: InputMaybe<Scalars['Float']['input']>;
  isSubBreed?: InputMaybe<Scalars['Boolean']['input']>;
  litters?: InputMaybe<LitterCreateNestedManyWithoutDogBreedInput>;
  maintenanceIndex?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  physicalActivityNeedIndex?: InputMaybe<Scalars['Float']['input']>;
  predatoryInstinctIndex?: InputMaybe<Scalars['Float']['input']>;
  puppies?: InputMaybe<DogPuppyCreateNestedManyWithoutBreedInput>;
  robustnessIndex?: InputMaybe<Scalars['Int']['input']>;
  sizeCategory?: InputMaybe<AnimalSizeEnum>;
  sociabilityIndex?: InputMaybe<Scalars['Int']['input']>;
  sortingIndex?: InputMaybe<Scalars['Int']['input']>;
  translations?: InputMaybe<DogBreedTranslationCreateNestedManyWithoutDogBreedInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  videoUrl?: InputMaybe<Scalars['String']['input']>;
};

export type DogBreedCreateWithoutDogInfosInput = {
  adultSizeAge?: InputMaybe<Scalars['Int']['input']>;
  applications?: InputMaybe<DogBreederApplicationCreateNestedManyWithoutBreedPreferenceInput>;
  barkingTendancyIndex?: InputMaybe<Scalars['Float']['input']>;
  baseBreedName?: InputMaybe<Scalars['String']['input']>;
  breedInterestSubscriptions?: InputMaybe<DogBreedInterestSubscriptionCreateNestedManyWithoutDogBreedsInput>;
  careIndex?: InputMaybe<Scalars['Int']['input']>;
  coldToleranceIndex?: InputMaybe<Scalars['Float']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dogBreeders?: InputMaybe<DogBreederBreedsCreateNestedManyWithoutDogBreedInput>;
  dogType?: InputMaybe<Array<DogType>>;
  educationIndex?: InputMaybe<Scalars['Int']['input']>;
  exerciseIndex?: InputMaybe<Scalars['Int']['input']>;
  fciGroup?: InputMaybe<Scalars['String']['input']>;
  foreignerSociabilityIndex?: InputMaybe<Scalars['Float']['input']>;
  hairLossIndex?: InputMaybe<Scalars['Float']['input']>;
  hairType?: InputMaybe<DogHairType>;
  headShape?: InputMaybe<HeadShape>;
  heatToleranceIndex?: InputMaybe<Scalars['Float']['input']>;
  homeCountryCode?: InputMaybe<Scalars['String']['input']>;
  imgs?: InputMaybe<DogBreedImgCreateNestedManyWithoutDogBreedInput>;
  independenceIndex?: InputMaybe<Scalars['Float']['input']>;
  intellectualActivityNeedIndex?: InputMaybe<Scalars['Float']['input']>;
  isSubBreed?: InputMaybe<Scalars['Boolean']['input']>;
  litters?: InputMaybe<LitterCreateNestedManyWithoutDogBreedInput>;
  maintenanceIndex?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  physicalActivityNeedIndex?: InputMaybe<Scalars['Float']['input']>;
  predatoryInstinctIndex?: InputMaybe<Scalars['Float']['input']>;
  puppies?: InputMaybe<DogPuppyCreateNestedManyWithoutBreedInput>;
  robustnessIndex?: InputMaybe<Scalars['Int']['input']>;
  sizeCategory?: InputMaybe<AnimalSizeEnum>;
  sociabilityIndex?: InputMaybe<Scalars['Int']['input']>;
  sortingIndex?: InputMaybe<Scalars['Int']['input']>;
  translations?: InputMaybe<DogBreedTranslationCreateNestedManyWithoutDogBreedInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  videoUrl?: InputMaybe<Scalars['String']['input']>;
};

export type DogBreedCreateWithoutImgsInput = {
  adultSizeAge?: InputMaybe<Scalars['Int']['input']>;
  applications?: InputMaybe<DogBreederApplicationCreateNestedManyWithoutBreedPreferenceInput>;
  barkingTendancyIndex?: InputMaybe<Scalars['Float']['input']>;
  baseBreedName?: InputMaybe<Scalars['String']['input']>;
  breedInterestSubscriptions?: InputMaybe<DogBreedInterestSubscriptionCreateNestedManyWithoutDogBreedsInput>;
  careIndex?: InputMaybe<Scalars['Int']['input']>;
  coldToleranceIndex?: InputMaybe<Scalars['Float']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dogBreeders?: InputMaybe<DogBreederBreedsCreateNestedManyWithoutDogBreedInput>;
  dogInfos?: InputMaybe<DogInfoCreateNestedManyWithoutDogBreedInput>;
  dogType?: InputMaybe<Array<DogType>>;
  educationIndex?: InputMaybe<Scalars['Int']['input']>;
  exerciseIndex?: InputMaybe<Scalars['Int']['input']>;
  fciGroup?: InputMaybe<Scalars['String']['input']>;
  foreignerSociabilityIndex?: InputMaybe<Scalars['Float']['input']>;
  hairLossIndex?: InputMaybe<Scalars['Float']['input']>;
  hairType?: InputMaybe<DogHairType>;
  headShape?: InputMaybe<HeadShape>;
  heatToleranceIndex?: InputMaybe<Scalars['Float']['input']>;
  homeCountryCode?: InputMaybe<Scalars['String']['input']>;
  independenceIndex?: InputMaybe<Scalars['Float']['input']>;
  intellectualActivityNeedIndex?: InputMaybe<Scalars['Float']['input']>;
  isSubBreed?: InputMaybe<Scalars['Boolean']['input']>;
  litters?: InputMaybe<LitterCreateNestedManyWithoutDogBreedInput>;
  maintenanceIndex?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  physicalActivityNeedIndex?: InputMaybe<Scalars['Float']['input']>;
  predatoryInstinctIndex?: InputMaybe<Scalars['Float']['input']>;
  puppies?: InputMaybe<DogPuppyCreateNestedManyWithoutBreedInput>;
  robustnessIndex?: InputMaybe<Scalars['Int']['input']>;
  sizeCategory?: InputMaybe<AnimalSizeEnum>;
  sociabilityIndex?: InputMaybe<Scalars['Int']['input']>;
  sortingIndex?: InputMaybe<Scalars['Int']['input']>;
  translations?: InputMaybe<DogBreedTranslationCreateNestedManyWithoutDogBreedInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  videoUrl?: InputMaybe<Scalars['String']['input']>;
};

export type DogBreedCreateWithoutLittersInput = {
  adultSizeAge?: InputMaybe<Scalars['Int']['input']>;
  applications?: InputMaybe<DogBreederApplicationCreateNestedManyWithoutBreedPreferenceInput>;
  barkingTendancyIndex?: InputMaybe<Scalars['Float']['input']>;
  baseBreedName?: InputMaybe<Scalars['String']['input']>;
  breedInterestSubscriptions?: InputMaybe<DogBreedInterestSubscriptionCreateNestedManyWithoutDogBreedsInput>;
  careIndex?: InputMaybe<Scalars['Int']['input']>;
  coldToleranceIndex?: InputMaybe<Scalars['Float']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dogBreeders?: InputMaybe<DogBreederBreedsCreateNestedManyWithoutDogBreedInput>;
  dogInfos?: InputMaybe<DogInfoCreateNestedManyWithoutDogBreedInput>;
  dogType?: InputMaybe<Array<DogType>>;
  educationIndex?: InputMaybe<Scalars['Int']['input']>;
  exerciseIndex?: InputMaybe<Scalars['Int']['input']>;
  fciGroup?: InputMaybe<Scalars['String']['input']>;
  foreignerSociabilityIndex?: InputMaybe<Scalars['Float']['input']>;
  hairLossIndex?: InputMaybe<Scalars['Float']['input']>;
  hairType?: InputMaybe<DogHairType>;
  headShape?: InputMaybe<HeadShape>;
  heatToleranceIndex?: InputMaybe<Scalars['Float']['input']>;
  homeCountryCode?: InputMaybe<Scalars['String']['input']>;
  imgs?: InputMaybe<DogBreedImgCreateNestedManyWithoutDogBreedInput>;
  independenceIndex?: InputMaybe<Scalars['Float']['input']>;
  intellectualActivityNeedIndex?: InputMaybe<Scalars['Float']['input']>;
  isSubBreed?: InputMaybe<Scalars['Boolean']['input']>;
  maintenanceIndex?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  physicalActivityNeedIndex?: InputMaybe<Scalars['Float']['input']>;
  predatoryInstinctIndex?: InputMaybe<Scalars['Float']['input']>;
  puppies?: InputMaybe<DogPuppyCreateNestedManyWithoutBreedInput>;
  robustnessIndex?: InputMaybe<Scalars['Int']['input']>;
  sizeCategory?: InputMaybe<AnimalSizeEnum>;
  sociabilityIndex?: InputMaybe<Scalars['Int']['input']>;
  sortingIndex?: InputMaybe<Scalars['Int']['input']>;
  translations?: InputMaybe<DogBreedTranslationCreateNestedManyWithoutDogBreedInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  videoUrl?: InputMaybe<Scalars['String']['input']>;
};

export type DogBreedCreateWithoutPuppiesInput = {
  adultSizeAge?: InputMaybe<Scalars['Int']['input']>;
  applications?: InputMaybe<DogBreederApplicationCreateNestedManyWithoutBreedPreferenceInput>;
  barkingTendancyIndex?: InputMaybe<Scalars['Float']['input']>;
  baseBreedName?: InputMaybe<Scalars['String']['input']>;
  breedInterestSubscriptions?: InputMaybe<DogBreedInterestSubscriptionCreateNestedManyWithoutDogBreedsInput>;
  careIndex?: InputMaybe<Scalars['Int']['input']>;
  coldToleranceIndex?: InputMaybe<Scalars['Float']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dogBreeders?: InputMaybe<DogBreederBreedsCreateNestedManyWithoutDogBreedInput>;
  dogInfos?: InputMaybe<DogInfoCreateNestedManyWithoutDogBreedInput>;
  dogType?: InputMaybe<Array<DogType>>;
  educationIndex?: InputMaybe<Scalars['Int']['input']>;
  exerciseIndex?: InputMaybe<Scalars['Int']['input']>;
  fciGroup?: InputMaybe<Scalars['String']['input']>;
  foreignerSociabilityIndex?: InputMaybe<Scalars['Float']['input']>;
  hairLossIndex?: InputMaybe<Scalars['Float']['input']>;
  hairType?: InputMaybe<DogHairType>;
  headShape?: InputMaybe<HeadShape>;
  heatToleranceIndex?: InputMaybe<Scalars['Float']['input']>;
  homeCountryCode?: InputMaybe<Scalars['String']['input']>;
  imgs?: InputMaybe<DogBreedImgCreateNestedManyWithoutDogBreedInput>;
  independenceIndex?: InputMaybe<Scalars['Float']['input']>;
  intellectualActivityNeedIndex?: InputMaybe<Scalars['Float']['input']>;
  isSubBreed?: InputMaybe<Scalars['Boolean']['input']>;
  litters?: InputMaybe<LitterCreateNestedManyWithoutDogBreedInput>;
  maintenanceIndex?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  physicalActivityNeedIndex?: InputMaybe<Scalars['Float']['input']>;
  predatoryInstinctIndex?: InputMaybe<Scalars['Float']['input']>;
  robustnessIndex?: InputMaybe<Scalars['Int']['input']>;
  sizeCategory?: InputMaybe<AnimalSizeEnum>;
  sociabilityIndex?: InputMaybe<Scalars['Int']['input']>;
  sortingIndex?: InputMaybe<Scalars['Int']['input']>;
  translations?: InputMaybe<DogBreedTranslationCreateNestedManyWithoutDogBreedInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  videoUrl?: InputMaybe<Scalars['String']['input']>;
};

export type DogBreedCreateWithoutTranslationsInput = {
  adultSizeAge?: InputMaybe<Scalars['Int']['input']>;
  applications?: InputMaybe<DogBreederApplicationCreateNestedManyWithoutBreedPreferenceInput>;
  barkingTendancyIndex?: InputMaybe<Scalars['Float']['input']>;
  baseBreedName?: InputMaybe<Scalars['String']['input']>;
  breedInterestSubscriptions?: InputMaybe<DogBreedInterestSubscriptionCreateNestedManyWithoutDogBreedsInput>;
  careIndex?: InputMaybe<Scalars['Int']['input']>;
  coldToleranceIndex?: InputMaybe<Scalars['Float']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dogBreeders?: InputMaybe<DogBreederBreedsCreateNestedManyWithoutDogBreedInput>;
  dogInfos?: InputMaybe<DogInfoCreateNestedManyWithoutDogBreedInput>;
  dogType?: InputMaybe<Array<DogType>>;
  educationIndex?: InputMaybe<Scalars['Int']['input']>;
  exerciseIndex?: InputMaybe<Scalars['Int']['input']>;
  fciGroup?: InputMaybe<Scalars['String']['input']>;
  foreignerSociabilityIndex?: InputMaybe<Scalars['Float']['input']>;
  hairLossIndex?: InputMaybe<Scalars['Float']['input']>;
  hairType?: InputMaybe<DogHairType>;
  headShape?: InputMaybe<HeadShape>;
  heatToleranceIndex?: InputMaybe<Scalars['Float']['input']>;
  homeCountryCode?: InputMaybe<Scalars['String']['input']>;
  imgs?: InputMaybe<DogBreedImgCreateNestedManyWithoutDogBreedInput>;
  independenceIndex?: InputMaybe<Scalars['Float']['input']>;
  intellectualActivityNeedIndex?: InputMaybe<Scalars['Float']['input']>;
  isSubBreed?: InputMaybe<Scalars['Boolean']['input']>;
  litters?: InputMaybe<LitterCreateNestedManyWithoutDogBreedInput>;
  maintenanceIndex?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  physicalActivityNeedIndex?: InputMaybe<Scalars['Float']['input']>;
  predatoryInstinctIndex?: InputMaybe<Scalars['Float']['input']>;
  puppies?: InputMaybe<DogPuppyCreateNestedManyWithoutBreedInput>;
  robustnessIndex?: InputMaybe<Scalars['Int']['input']>;
  sizeCategory?: InputMaybe<AnimalSizeEnum>;
  sociabilityIndex?: InputMaybe<Scalars['Int']['input']>;
  sortingIndex?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  videoUrl?: InputMaybe<Scalars['String']['input']>;
};

export type DogBreedCreatedogTypeInput = {
  set: Array<DogType>;
};

export type DogBreedImg = {
  __typename?: 'DogBreedImg';
  createdAt: Scalars['DateTime']['output'];
  dogBreed: DogBreed;
  dogBreedId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  large?: Maybe<Scalars['String']['output']>;
  medium?: Maybe<Scalars['String']['output']>;
  small?: Maybe<Scalars['String']['output']>;
  type: DogBreedImgType;
  updatedAt: Scalars['DateTime']['output'];
};

export type DogBreedImgAvgAggregateOutputType = {
  __typename?: 'DogBreedImgAvgAggregateOutputType';
  dogBreedId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

export type DogBreedImgAvgOrderByAggregateInput = {
  dogBreedId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export type DogBreedImgCountAggregateOutputType = {
  __typename?: 'DogBreedImgCountAggregateOutputType';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  dogBreedId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  large: Scalars['Int']['output'];
  medium: Scalars['Int']['output'];
  small: Scalars['Int']['output'];
  type: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type DogBreedImgCountOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  dogBreedId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  large?: InputMaybe<SortOrder>;
  medium?: InputMaybe<SortOrder>;
  small?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type DogBreedImgCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dogBreed: DogBreedCreateNestedOneWithoutImgsInput;
  large?: InputMaybe<Scalars['String']['input']>;
  medium?: InputMaybe<Scalars['String']['input']>;
  small?: InputMaybe<Scalars['String']['input']>;
  type: DogBreedImgType;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DogBreedImgCreateManyDogBreedInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  large?: InputMaybe<Scalars['String']['input']>;
  medium?: InputMaybe<Scalars['String']['input']>;
  small?: InputMaybe<Scalars['String']['input']>;
  type: DogBreedImgType;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DogBreedImgCreateManyDogBreedInputEnvelope = {
  data: Array<DogBreedImgCreateManyDogBreedInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DogBreedImgCreateManyInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dogBreedId: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  large?: InputMaybe<Scalars['String']['input']>;
  medium?: InputMaybe<Scalars['String']['input']>;
  small?: InputMaybe<Scalars['String']['input']>;
  type: DogBreedImgType;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DogBreedImgCreateNestedManyWithoutDogBreedInput = {
  connect?: InputMaybe<Array<DogBreedImgWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DogBreedImgCreateOrConnectWithoutDogBreedInput>>;
  create?: InputMaybe<Array<DogBreedImgCreateWithoutDogBreedInput>>;
  createMany?: InputMaybe<DogBreedImgCreateManyDogBreedInputEnvelope>;
};

export type DogBreedImgCreateOrConnectWithoutDogBreedInput = {
  create: DogBreedImgCreateWithoutDogBreedInput;
  where: DogBreedImgWhereUniqueInput;
};

export type DogBreedImgCreateWithoutDogBreedInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  large?: InputMaybe<Scalars['String']['input']>;
  medium?: InputMaybe<Scalars['String']['input']>;
  small?: InputMaybe<Scalars['String']['input']>;
  type: DogBreedImgType;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DogBreedImgListRelationFilter = {
  every?: InputMaybe<DogBreedImgWhereInput>;
  none?: InputMaybe<DogBreedImgWhereInput>;
  some?: InputMaybe<DogBreedImgWhereInput>;
};

export type DogBreedImgMaxAggregateOutputType = {
  __typename?: 'DogBreedImgMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  dogBreedId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  large?: Maybe<Scalars['String']['output']>;
  medium?: Maybe<Scalars['String']['output']>;
  small?: Maybe<Scalars['String']['output']>;
  type?: Maybe<DogBreedImgType>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type DogBreedImgMaxOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  dogBreedId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  large?: InputMaybe<SortOrder>;
  medium?: InputMaybe<SortOrder>;
  small?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type DogBreedImgMinAggregateOutputType = {
  __typename?: 'DogBreedImgMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  dogBreedId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  large?: Maybe<Scalars['String']['output']>;
  medium?: Maybe<Scalars['String']['output']>;
  small?: Maybe<Scalars['String']['output']>;
  type?: Maybe<DogBreedImgType>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type DogBreedImgMinOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  dogBreedId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  large?: InputMaybe<SortOrder>;
  medium?: InputMaybe<SortOrder>;
  small?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type DogBreedImgOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export enum DogBreedImgOrderByRelevanceFieldEnum {
  large = 'large',
  medium = 'medium',
  small = 'small'
}

export type DogBreedImgOrderByRelevanceInput = {
  fields: Array<DogBreedImgOrderByRelevanceFieldEnum>;
  search: Scalars['String']['input'];
  sort: SortOrder;
};

export type DogBreedImgOrderByWithAggregationInput = {
  _avg?: InputMaybe<DogBreedImgAvgOrderByAggregateInput>;
  _count?: InputMaybe<DogBreedImgCountOrderByAggregateInput>;
  _max?: InputMaybe<DogBreedImgMaxOrderByAggregateInput>;
  _min?: InputMaybe<DogBreedImgMinOrderByAggregateInput>;
  _sum?: InputMaybe<DogBreedImgSumOrderByAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  dogBreedId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  large?: InputMaybe<SortOrderInput>;
  medium?: InputMaybe<SortOrderInput>;
  small?: InputMaybe<SortOrderInput>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type DogBreedImgOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: InputMaybe<DogBreedImgOrderByRelevanceInput>;
  createdAt?: InputMaybe<SortOrder>;
  dogBreed?: InputMaybe<DogBreedOrderByWithRelationAndSearchRelevanceInput>;
  dogBreedId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  large?: InputMaybe<SortOrderInput>;
  medium?: InputMaybe<SortOrderInput>;
  small?: InputMaybe<SortOrderInput>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum DogBreedImgScalarFieldEnum {
  createdAt = 'createdAt',
  dogBreedId = 'dogBreedId',
  id = 'id',
  large = 'large',
  medium = 'medium',
  small = 'small',
  type = 'type',
  updatedAt = 'updatedAt'
}

export type DogBreedImgScalarWhereInput = {
  AND?: InputMaybe<Array<DogBreedImgScalarWhereInput>>;
  NOT?: InputMaybe<Array<DogBreedImgScalarWhereInput>>;
  OR?: InputMaybe<Array<DogBreedImgScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  dogBreedId?: InputMaybe<IntFilter>;
  id?: InputMaybe<IntFilter>;
  large?: InputMaybe<StringNullableFilter>;
  medium?: InputMaybe<StringNullableFilter>;
  small?: InputMaybe<StringNullableFilter>;
  type?: InputMaybe<EnumDogBreedImgTypeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type DogBreedImgScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<DogBreedImgScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<DogBreedImgScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<DogBreedImgScalarWhereWithAggregatesInput>>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  dogBreedId?: InputMaybe<IntWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  large?: InputMaybe<StringNullableWithAggregatesFilter>;
  medium?: InputMaybe<StringNullableWithAggregatesFilter>;
  small?: InputMaybe<StringNullableWithAggregatesFilter>;
  type?: InputMaybe<EnumDogBreedImgTypeWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type DogBreedImgSumAggregateOutputType = {
  __typename?: 'DogBreedImgSumAggregateOutputType';
  dogBreedId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
};

export type DogBreedImgSumOrderByAggregateInput = {
  dogBreedId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export enum DogBreedImgType {
  COVER = 'COVER',
  MAIN = 'MAIN'
}

export type DogBreedImgUncheckedCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dogBreedId: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  large?: InputMaybe<Scalars['String']['input']>;
  medium?: InputMaybe<Scalars['String']['input']>;
  small?: InputMaybe<Scalars['String']['input']>;
  type: DogBreedImgType;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DogBreedImgUncheckedCreateNestedManyWithoutDogBreedInput = {
  connect?: InputMaybe<Array<DogBreedImgWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DogBreedImgCreateOrConnectWithoutDogBreedInput>>;
  create?: InputMaybe<Array<DogBreedImgCreateWithoutDogBreedInput>>;
  createMany?: InputMaybe<DogBreedImgCreateManyDogBreedInputEnvelope>;
};

export type DogBreedImgUncheckedCreateWithoutDogBreedInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  large?: InputMaybe<Scalars['String']['input']>;
  medium?: InputMaybe<Scalars['String']['input']>;
  small?: InputMaybe<Scalars['String']['input']>;
  type: DogBreedImgType;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DogBreedImgUncheckedUpdateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dogBreedId?: InputMaybe<IntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  large?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  medium?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  small?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumDogBreedImgTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DogBreedImgUncheckedUpdateManyInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dogBreedId?: InputMaybe<IntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  large?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  medium?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  small?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumDogBreedImgTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DogBreedImgUncheckedUpdateManyWithoutDogBreedInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  large?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  medium?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  small?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumDogBreedImgTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DogBreedImgUncheckedUpdateManyWithoutDogBreedNestedInput = {
  connect?: InputMaybe<Array<DogBreedImgWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DogBreedImgCreateOrConnectWithoutDogBreedInput>>;
  create?: InputMaybe<Array<DogBreedImgCreateWithoutDogBreedInput>>;
  createMany?: InputMaybe<DogBreedImgCreateManyDogBreedInputEnvelope>;
  delete?: InputMaybe<Array<DogBreedImgWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<DogBreedImgScalarWhereInput>>;
  disconnect?: InputMaybe<Array<DogBreedImgWhereUniqueInput>>;
  set?: InputMaybe<Array<DogBreedImgWhereUniqueInput>>;
  update?: InputMaybe<Array<DogBreedImgUpdateWithWhereUniqueWithoutDogBreedInput>>;
  updateMany?: InputMaybe<Array<DogBreedImgUpdateManyWithWhereWithoutDogBreedInput>>;
  upsert?: InputMaybe<Array<DogBreedImgUpsertWithWhereUniqueWithoutDogBreedInput>>;
};

export type DogBreedImgUncheckedUpdateWithoutDogBreedInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  large?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  medium?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  small?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumDogBreedImgTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DogBreedImgUpdateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dogBreed?: InputMaybe<DogBreedUpdateOneRequiredWithoutImgsNestedInput>;
  large?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  medium?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  small?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumDogBreedImgTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DogBreedImgUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  large?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  medium?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  small?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumDogBreedImgTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DogBreedImgUpdateManyWithWhereWithoutDogBreedInput = {
  data: DogBreedImgUpdateManyMutationInput;
  where: DogBreedImgScalarWhereInput;
};

export type DogBreedImgUpdateManyWithoutDogBreedNestedInput = {
  connect?: InputMaybe<Array<DogBreedImgWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DogBreedImgCreateOrConnectWithoutDogBreedInput>>;
  create?: InputMaybe<Array<DogBreedImgCreateWithoutDogBreedInput>>;
  createMany?: InputMaybe<DogBreedImgCreateManyDogBreedInputEnvelope>;
  delete?: InputMaybe<Array<DogBreedImgWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<DogBreedImgScalarWhereInput>>;
  disconnect?: InputMaybe<Array<DogBreedImgWhereUniqueInput>>;
  set?: InputMaybe<Array<DogBreedImgWhereUniqueInput>>;
  update?: InputMaybe<Array<DogBreedImgUpdateWithWhereUniqueWithoutDogBreedInput>>;
  updateMany?: InputMaybe<Array<DogBreedImgUpdateManyWithWhereWithoutDogBreedInput>>;
  upsert?: InputMaybe<Array<DogBreedImgUpsertWithWhereUniqueWithoutDogBreedInput>>;
};

export type DogBreedImgUpdateWithWhereUniqueWithoutDogBreedInput = {
  data: DogBreedImgUpdateWithoutDogBreedInput;
  where: DogBreedImgWhereUniqueInput;
};

export type DogBreedImgUpdateWithoutDogBreedInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  large?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  medium?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  small?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumDogBreedImgTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DogBreedImgUpsertWithWhereUniqueWithoutDogBreedInput = {
  create: DogBreedImgCreateWithoutDogBreedInput;
  update: DogBreedImgUpdateWithoutDogBreedInput;
  where: DogBreedImgWhereUniqueInput;
};

export type DogBreedImgWhereInput = {
  AND?: InputMaybe<Array<DogBreedImgWhereInput>>;
  NOT?: InputMaybe<Array<DogBreedImgWhereInput>>;
  OR?: InputMaybe<Array<DogBreedImgWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  dogBreed?: InputMaybe<DogBreedRelationFilter>;
  dogBreedId?: InputMaybe<IntFilter>;
  id?: InputMaybe<IntFilter>;
  large?: InputMaybe<StringNullableFilter>;
  medium?: InputMaybe<StringNullableFilter>;
  small?: InputMaybe<StringNullableFilter>;
  type?: InputMaybe<EnumDogBreedImgTypeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type DogBreedImgWhereUniqueInput = {
  AND?: InputMaybe<Array<DogBreedImgWhereInput>>;
  NOT?: InputMaybe<Array<DogBreedImgWhereInput>>;
  OR?: InputMaybe<Array<DogBreedImgWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  dogBreed?: InputMaybe<DogBreedRelationFilter>;
  dogBreedId?: InputMaybe<IntFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  large?: InputMaybe<StringNullableFilter>;
  medium?: InputMaybe<StringNullableFilter>;
  small?: InputMaybe<StringNullableFilter>;
  type?: InputMaybe<EnumDogBreedImgTypeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type DogBreedInterestSubscription = {
  __typename?: 'DogBreedInterestSubscription';
  active?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['DateTime']['output'];
  dogBreeds: Array<DogBreed>;
  emailContact?: Maybe<EmailContact>;
  id: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type DogBreedInterestSubscriptionAvgAggregateOutputType = {
  __typename?: 'DogBreedInterestSubscriptionAvgAggregateOutputType';
  emailContactId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

export type DogBreedInterestSubscriptionAvgOrderByAggregateInput = {
  emailContactId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export type DogBreedInterestSubscriptionCountAggregateOutputType = {
  __typename?: 'DogBreedInterestSubscriptionCountAggregateOutputType';
  _all: Scalars['Int']['output'];
  active: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  emailContactId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  token: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type DogBreedInterestSubscriptionCountOrderByAggregateInput = {
  active?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  emailContactId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  token?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type DogBreedInterestSubscriptionCountOutputType = {
  __typename?: 'DogBreedInterestSubscriptionCountOutputType';
  dogBreeds: Scalars['Int']['output'];
};

export type DogBreedInterestSubscriptionCreateInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dogBreeds?: InputMaybe<DogBreedCreateNestedManyWithoutBreedInterestSubscriptionsInput>;
  emailContact: EmailContactCreateNestedOneWithoutBreedInterestSubscriptionInput;
  token: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DogBreedInterestSubscriptionCreateManyInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  emailContactId: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  token: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DogBreedInterestSubscriptionCreateNestedManyWithoutDogBreedsInput = {
  connect?: InputMaybe<Array<DogBreedInterestSubscriptionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DogBreedInterestSubscriptionCreateOrConnectWithoutDogBreedsInput>>;
  create?: InputMaybe<Array<DogBreedInterestSubscriptionCreateWithoutDogBreedsInput>>;
};

export type DogBreedInterestSubscriptionCreateNestedOneWithoutEmailContactInput = {
  connect?: InputMaybe<DogBreedInterestSubscriptionWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DogBreedInterestSubscriptionCreateOrConnectWithoutEmailContactInput>;
  create?: InputMaybe<DogBreedInterestSubscriptionCreateWithoutEmailContactInput>;
};

export type DogBreedInterestSubscriptionCreateOrConnectWithoutDogBreedsInput = {
  create: DogBreedInterestSubscriptionCreateWithoutDogBreedsInput;
  where: DogBreedInterestSubscriptionWhereUniqueInput;
};

export type DogBreedInterestSubscriptionCreateOrConnectWithoutEmailContactInput = {
  create: DogBreedInterestSubscriptionCreateWithoutEmailContactInput;
  where: DogBreedInterestSubscriptionWhereUniqueInput;
};

export type DogBreedInterestSubscriptionCreateWithoutDogBreedsInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  emailContact: EmailContactCreateNestedOneWithoutBreedInterestSubscriptionInput;
  token: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DogBreedInterestSubscriptionCreateWithoutEmailContactInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dogBreeds?: InputMaybe<DogBreedCreateNestedManyWithoutBreedInterestSubscriptionsInput>;
  token: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DogBreedInterestSubscriptionListRelationFilter = {
  every?: InputMaybe<DogBreedInterestSubscriptionWhereInput>;
  none?: InputMaybe<DogBreedInterestSubscriptionWhereInput>;
  some?: InputMaybe<DogBreedInterestSubscriptionWhereInput>;
};

export type DogBreedInterestSubscriptionMaxAggregateOutputType = {
  __typename?: 'DogBreedInterestSubscriptionMaxAggregateOutputType';
  active?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  emailContactId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  token?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type DogBreedInterestSubscriptionMaxOrderByAggregateInput = {
  active?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  emailContactId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  token?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type DogBreedInterestSubscriptionMinAggregateOutputType = {
  __typename?: 'DogBreedInterestSubscriptionMinAggregateOutputType';
  active?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  emailContactId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  token?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type DogBreedInterestSubscriptionMinOrderByAggregateInput = {
  active?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  emailContactId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  token?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type DogBreedInterestSubscriptionNullableRelationFilter = {
  is?: InputMaybe<DogBreedInterestSubscriptionWhereInput>;
  isNot?: InputMaybe<DogBreedInterestSubscriptionWhereInput>;
};

export type DogBreedInterestSubscriptionOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export enum DogBreedInterestSubscriptionOrderByRelevanceFieldEnum {
  token = 'token'
}

export type DogBreedInterestSubscriptionOrderByRelevanceInput = {
  fields: Array<DogBreedInterestSubscriptionOrderByRelevanceFieldEnum>;
  search: Scalars['String']['input'];
  sort: SortOrder;
};

export type DogBreedInterestSubscriptionOrderByWithAggregationInput = {
  _avg?: InputMaybe<DogBreedInterestSubscriptionAvgOrderByAggregateInput>;
  _count?: InputMaybe<DogBreedInterestSubscriptionCountOrderByAggregateInput>;
  _max?: InputMaybe<DogBreedInterestSubscriptionMaxOrderByAggregateInput>;
  _min?: InputMaybe<DogBreedInterestSubscriptionMinOrderByAggregateInput>;
  _sum?: InputMaybe<DogBreedInterestSubscriptionSumOrderByAggregateInput>;
  active?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  emailContactId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  token?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type DogBreedInterestSubscriptionOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: InputMaybe<DogBreedInterestSubscriptionOrderByRelevanceInput>;
  active?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  dogBreeds?: InputMaybe<DogBreedOrderByRelationAggregateInput>;
  emailContact?: InputMaybe<EmailContactOrderByWithRelationAndSearchRelevanceInput>;
  emailContactId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  token?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum DogBreedInterestSubscriptionScalarFieldEnum {
  active = 'active',
  createdAt = 'createdAt',
  emailContactId = 'emailContactId',
  id = 'id',
  token = 'token',
  updatedAt = 'updatedAt'
}

export type DogBreedInterestSubscriptionScalarWhereInput = {
  AND?: InputMaybe<Array<DogBreedInterestSubscriptionScalarWhereInput>>;
  NOT?: InputMaybe<Array<DogBreedInterestSubscriptionScalarWhereInput>>;
  OR?: InputMaybe<Array<DogBreedInterestSubscriptionScalarWhereInput>>;
  active?: InputMaybe<BoolNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  emailContactId?: InputMaybe<IntFilter>;
  id?: InputMaybe<IntFilter>;
  token?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type DogBreedInterestSubscriptionScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<DogBreedInterestSubscriptionScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<DogBreedInterestSubscriptionScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<DogBreedInterestSubscriptionScalarWhereWithAggregatesInput>>;
  active?: InputMaybe<BoolNullableWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  emailContactId?: InputMaybe<IntWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  token?: InputMaybe<StringWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type DogBreedInterestSubscriptionSumAggregateOutputType = {
  __typename?: 'DogBreedInterestSubscriptionSumAggregateOutputType';
  emailContactId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
};

export type DogBreedInterestSubscriptionSumOrderByAggregateInput = {
  emailContactId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export type DogBreedInterestSubscriptionUncheckedCreateInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dogBreeds?: InputMaybe<DogBreedUncheckedCreateNestedManyWithoutBreedInterestSubscriptionsInput>;
  emailContactId: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  token: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DogBreedInterestSubscriptionUncheckedCreateNestedManyWithoutDogBreedsInput = {
  connect?: InputMaybe<Array<DogBreedInterestSubscriptionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DogBreedInterestSubscriptionCreateOrConnectWithoutDogBreedsInput>>;
  create?: InputMaybe<Array<DogBreedInterestSubscriptionCreateWithoutDogBreedsInput>>;
};

export type DogBreedInterestSubscriptionUncheckedCreateNestedOneWithoutEmailContactInput = {
  connect?: InputMaybe<DogBreedInterestSubscriptionWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DogBreedInterestSubscriptionCreateOrConnectWithoutEmailContactInput>;
  create?: InputMaybe<DogBreedInterestSubscriptionCreateWithoutEmailContactInput>;
};

export type DogBreedInterestSubscriptionUncheckedCreateWithoutDogBreedsInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  emailContactId: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  token: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DogBreedInterestSubscriptionUncheckedCreateWithoutEmailContactInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dogBreeds?: InputMaybe<DogBreedUncheckedCreateNestedManyWithoutBreedInterestSubscriptionsInput>;
  id?: InputMaybe<Scalars['Int']['input']>;
  token: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DogBreedInterestSubscriptionUncheckedUpdateInput = {
  active?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dogBreeds?: InputMaybe<DogBreedUncheckedUpdateManyWithoutBreedInterestSubscriptionsNestedInput>;
  emailContactId?: InputMaybe<IntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  token?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DogBreedInterestSubscriptionUncheckedUpdateManyInput = {
  active?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  emailContactId?: InputMaybe<IntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  token?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DogBreedInterestSubscriptionUncheckedUpdateManyWithoutDogBreedsInput = {
  active?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  emailContactId?: InputMaybe<IntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  token?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DogBreedInterestSubscriptionUncheckedUpdateManyWithoutDogBreedsNestedInput = {
  connect?: InputMaybe<Array<DogBreedInterestSubscriptionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DogBreedInterestSubscriptionCreateOrConnectWithoutDogBreedsInput>>;
  create?: InputMaybe<Array<DogBreedInterestSubscriptionCreateWithoutDogBreedsInput>>;
  delete?: InputMaybe<Array<DogBreedInterestSubscriptionWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<DogBreedInterestSubscriptionScalarWhereInput>>;
  disconnect?: InputMaybe<Array<DogBreedInterestSubscriptionWhereUniqueInput>>;
  set?: InputMaybe<Array<DogBreedInterestSubscriptionWhereUniqueInput>>;
  update?: InputMaybe<Array<DogBreedInterestSubscriptionUpdateWithWhereUniqueWithoutDogBreedsInput>>;
  updateMany?: InputMaybe<Array<DogBreedInterestSubscriptionUpdateManyWithWhereWithoutDogBreedsInput>>;
  upsert?: InputMaybe<Array<DogBreedInterestSubscriptionUpsertWithWhereUniqueWithoutDogBreedsInput>>;
};

export type DogBreedInterestSubscriptionUncheckedUpdateOneWithoutEmailContactNestedInput = {
  connect?: InputMaybe<DogBreedInterestSubscriptionWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DogBreedInterestSubscriptionCreateOrConnectWithoutEmailContactInput>;
  create?: InputMaybe<DogBreedInterestSubscriptionCreateWithoutEmailContactInput>;
  delete?: InputMaybe<DogBreedInterestSubscriptionWhereInput>;
  disconnect?: InputMaybe<DogBreedInterestSubscriptionWhereInput>;
  update?: InputMaybe<DogBreedInterestSubscriptionUpdateToOneWithWhereWithoutEmailContactInput>;
  upsert?: InputMaybe<DogBreedInterestSubscriptionUpsertWithoutEmailContactInput>;
};

export type DogBreedInterestSubscriptionUncheckedUpdateWithoutDogBreedsInput = {
  active?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  emailContactId?: InputMaybe<IntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  token?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DogBreedInterestSubscriptionUncheckedUpdateWithoutEmailContactInput = {
  active?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dogBreeds?: InputMaybe<DogBreedUncheckedUpdateManyWithoutBreedInterestSubscriptionsNestedInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  token?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DogBreedInterestSubscriptionUpdateInput = {
  active?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dogBreeds?: InputMaybe<DogBreedUpdateManyWithoutBreedInterestSubscriptionsNestedInput>;
  emailContact?: InputMaybe<EmailContactUpdateOneRequiredWithoutBreedInterestSubscriptionNestedInput>;
  token?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DogBreedInterestSubscriptionUpdateManyMutationInput = {
  active?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  token?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DogBreedInterestSubscriptionUpdateManyWithWhereWithoutDogBreedsInput = {
  data: DogBreedInterestSubscriptionUpdateManyMutationInput;
  where: DogBreedInterestSubscriptionScalarWhereInput;
};

export type DogBreedInterestSubscriptionUpdateManyWithoutDogBreedsNestedInput = {
  connect?: InputMaybe<Array<DogBreedInterestSubscriptionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DogBreedInterestSubscriptionCreateOrConnectWithoutDogBreedsInput>>;
  create?: InputMaybe<Array<DogBreedInterestSubscriptionCreateWithoutDogBreedsInput>>;
  delete?: InputMaybe<Array<DogBreedInterestSubscriptionWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<DogBreedInterestSubscriptionScalarWhereInput>>;
  disconnect?: InputMaybe<Array<DogBreedInterestSubscriptionWhereUniqueInput>>;
  set?: InputMaybe<Array<DogBreedInterestSubscriptionWhereUniqueInput>>;
  update?: InputMaybe<Array<DogBreedInterestSubscriptionUpdateWithWhereUniqueWithoutDogBreedsInput>>;
  updateMany?: InputMaybe<Array<DogBreedInterestSubscriptionUpdateManyWithWhereWithoutDogBreedsInput>>;
  upsert?: InputMaybe<Array<DogBreedInterestSubscriptionUpsertWithWhereUniqueWithoutDogBreedsInput>>;
};

export type DogBreedInterestSubscriptionUpdateOneWithoutEmailContactNestedInput = {
  connect?: InputMaybe<DogBreedInterestSubscriptionWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DogBreedInterestSubscriptionCreateOrConnectWithoutEmailContactInput>;
  create?: InputMaybe<DogBreedInterestSubscriptionCreateWithoutEmailContactInput>;
  delete?: InputMaybe<DogBreedInterestSubscriptionWhereInput>;
  disconnect?: InputMaybe<DogBreedInterestSubscriptionWhereInput>;
  update?: InputMaybe<DogBreedInterestSubscriptionUpdateToOneWithWhereWithoutEmailContactInput>;
  upsert?: InputMaybe<DogBreedInterestSubscriptionUpsertWithoutEmailContactInput>;
};

export type DogBreedInterestSubscriptionUpdateToOneWithWhereWithoutEmailContactInput = {
  data: DogBreedInterestSubscriptionUpdateWithoutEmailContactInput;
  where?: InputMaybe<DogBreedInterestSubscriptionWhereInput>;
};

export type DogBreedInterestSubscriptionUpdateWithWhereUniqueWithoutDogBreedsInput = {
  data: DogBreedInterestSubscriptionUpdateWithoutDogBreedsInput;
  where: DogBreedInterestSubscriptionWhereUniqueInput;
};

export type DogBreedInterestSubscriptionUpdateWithoutDogBreedsInput = {
  active?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  emailContact?: InputMaybe<EmailContactUpdateOneRequiredWithoutBreedInterestSubscriptionNestedInput>;
  token?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DogBreedInterestSubscriptionUpdateWithoutEmailContactInput = {
  active?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dogBreeds?: InputMaybe<DogBreedUpdateManyWithoutBreedInterestSubscriptionsNestedInput>;
  token?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DogBreedInterestSubscriptionUpsertWithWhereUniqueWithoutDogBreedsInput = {
  create: DogBreedInterestSubscriptionCreateWithoutDogBreedsInput;
  update: DogBreedInterestSubscriptionUpdateWithoutDogBreedsInput;
  where: DogBreedInterestSubscriptionWhereUniqueInput;
};

export type DogBreedInterestSubscriptionUpsertWithoutEmailContactInput = {
  create: DogBreedInterestSubscriptionCreateWithoutEmailContactInput;
  update: DogBreedInterestSubscriptionUpdateWithoutEmailContactInput;
  where?: InputMaybe<DogBreedInterestSubscriptionWhereInput>;
};

export type DogBreedInterestSubscriptionWhereInput = {
  AND?: InputMaybe<Array<DogBreedInterestSubscriptionWhereInput>>;
  NOT?: InputMaybe<Array<DogBreedInterestSubscriptionWhereInput>>;
  OR?: InputMaybe<Array<DogBreedInterestSubscriptionWhereInput>>;
  active?: InputMaybe<BoolNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  dogBreeds?: InputMaybe<DogBreedListRelationFilter>;
  emailContact?: InputMaybe<EmailContactRelationFilter>;
  emailContactId?: InputMaybe<IntFilter>;
  id?: InputMaybe<IntFilter>;
  token?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type DogBreedInterestSubscriptionWhereUniqueInput = {
  AND?: InputMaybe<Array<DogBreedInterestSubscriptionWhereInput>>;
  NOT?: InputMaybe<Array<DogBreedInterestSubscriptionWhereInput>>;
  OR?: InputMaybe<Array<DogBreedInterestSubscriptionWhereInput>>;
  active?: InputMaybe<BoolNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  dogBreeds?: InputMaybe<DogBreedListRelationFilter>;
  emailContact?: InputMaybe<EmailContactRelationFilter>;
  emailContactId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type DogBreedListRelationFilter = {
  every?: InputMaybe<DogBreedWhereInput>;
  none?: InputMaybe<DogBreedWhereInput>;
  some?: InputMaybe<DogBreedWhereInput>;
};

export type DogBreedMaxAggregateOutputType = {
  __typename?: 'DogBreedMaxAggregateOutputType';
  adultSizeAge?: Maybe<Scalars['Int']['output']>;
  barkingTendancyIndex?: Maybe<Scalars['Float']['output']>;
  baseBreedName?: Maybe<Scalars['String']['output']>;
  careIndex?: Maybe<Scalars['Int']['output']>;
  coldToleranceIndex?: Maybe<Scalars['Float']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  educationIndex?: Maybe<Scalars['Int']['output']>;
  exerciseIndex?: Maybe<Scalars['Int']['output']>;
  fciGroup?: Maybe<Scalars['String']['output']>;
  foreignerSociabilityIndex?: Maybe<Scalars['Float']['output']>;
  hairLossIndex?: Maybe<Scalars['Float']['output']>;
  hairType?: Maybe<DogHairType>;
  headShape?: Maybe<HeadShape>;
  heatToleranceIndex?: Maybe<Scalars['Float']['output']>;
  homeCountryCode?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  independenceIndex?: Maybe<Scalars['Float']['output']>;
  intellectualActivityNeedIndex?: Maybe<Scalars['Float']['output']>;
  isSubBreed?: Maybe<Scalars['Boolean']['output']>;
  maintenanceIndex?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  physicalActivityNeedIndex?: Maybe<Scalars['Float']['output']>;
  predatoryInstinctIndex?: Maybe<Scalars['Float']['output']>;
  robustnessIndex?: Maybe<Scalars['Int']['output']>;
  sizeCategory?: Maybe<AnimalSizeEnum>;
  sociabilityIndex?: Maybe<Scalars['Int']['output']>;
  sortingIndex?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  videoUrl?: Maybe<Scalars['String']['output']>;
};

export type DogBreedMaxOrderByAggregateInput = {
  adultSizeAge?: InputMaybe<SortOrder>;
  barkingTendancyIndex?: InputMaybe<SortOrder>;
  baseBreedName?: InputMaybe<SortOrder>;
  careIndex?: InputMaybe<SortOrder>;
  coldToleranceIndex?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  educationIndex?: InputMaybe<SortOrder>;
  exerciseIndex?: InputMaybe<SortOrder>;
  fciGroup?: InputMaybe<SortOrder>;
  foreignerSociabilityIndex?: InputMaybe<SortOrder>;
  hairLossIndex?: InputMaybe<SortOrder>;
  hairType?: InputMaybe<SortOrder>;
  headShape?: InputMaybe<SortOrder>;
  heatToleranceIndex?: InputMaybe<SortOrder>;
  homeCountryCode?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  independenceIndex?: InputMaybe<SortOrder>;
  intellectualActivityNeedIndex?: InputMaybe<SortOrder>;
  isSubBreed?: InputMaybe<SortOrder>;
  maintenanceIndex?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  physicalActivityNeedIndex?: InputMaybe<SortOrder>;
  predatoryInstinctIndex?: InputMaybe<SortOrder>;
  robustnessIndex?: InputMaybe<SortOrder>;
  sizeCategory?: InputMaybe<SortOrder>;
  sociabilityIndex?: InputMaybe<SortOrder>;
  sortingIndex?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  videoUrl?: InputMaybe<SortOrder>;
};

export type DogBreedMinAggregateOutputType = {
  __typename?: 'DogBreedMinAggregateOutputType';
  adultSizeAge?: Maybe<Scalars['Int']['output']>;
  barkingTendancyIndex?: Maybe<Scalars['Float']['output']>;
  baseBreedName?: Maybe<Scalars['String']['output']>;
  careIndex?: Maybe<Scalars['Int']['output']>;
  coldToleranceIndex?: Maybe<Scalars['Float']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  educationIndex?: Maybe<Scalars['Int']['output']>;
  exerciseIndex?: Maybe<Scalars['Int']['output']>;
  fciGroup?: Maybe<Scalars['String']['output']>;
  foreignerSociabilityIndex?: Maybe<Scalars['Float']['output']>;
  hairLossIndex?: Maybe<Scalars['Float']['output']>;
  hairType?: Maybe<DogHairType>;
  headShape?: Maybe<HeadShape>;
  heatToleranceIndex?: Maybe<Scalars['Float']['output']>;
  homeCountryCode?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  independenceIndex?: Maybe<Scalars['Float']['output']>;
  intellectualActivityNeedIndex?: Maybe<Scalars['Float']['output']>;
  isSubBreed?: Maybe<Scalars['Boolean']['output']>;
  maintenanceIndex?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  physicalActivityNeedIndex?: Maybe<Scalars['Float']['output']>;
  predatoryInstinctIndex?: Maybe<Scalars['Float']['output']>;
  robustnessIndex?: Maybe<Scalars['Int']['output']>;
  sizeCategory?: Maybe<AnimalSizeEnum>;
  sociabilityIndex?: Maybe<Scalars['Int']['output']>;
  sortingIndex?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  videoUrl?: Maybe<Scalars['String']['output']>;
};

export type DogBreedMinOrderByAggregateInput = {
  adultSizeAge?: InputMaybe<SortOrder>;
  barkingTendancyIndex?: InputMaybe<SortOrder>;
  baseBreedName?: InputMaybe<SortOrder>;
  careIndex?: InputMaybe<SortOrder>;
  coldToleranceIndex?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  educationIndex?: InputMaybe<SortOrder>;
  exerciseIndex?: InputMaybe<SortOrder>;
  fciGroup?: InputMaybe<SortOrder>;
  foreignerSociabilityIndex?: InputMaybe<SortOrder>;
  hairLossIndex?: InputMaybe<SortOrder>;
  hairType?: InputMaybe<SortOrder>;
  headShape?: InputMaybe<SortOrder>;
  heatToleranceIndex?: InputMaybe<SortOrder>;
  homeCountryCode?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  independenceIndex?: InputMaybe<SortOrder>;
  intellectualActivityNeedIndex?: InputMaybe<SortOrder>;
  isSubBreed?: InputMaybe<SortOrder>;
  maintenanceIndex?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  physicalActivityNeedIndex?: InputMaybe<SortOrder>;
  predatoryInstinctIndex?: InputMaybe<SortOrder>;
  robustnessIndex?: InputMaybe<SortOrder>;
  sizeCategory?: InputMaybe<SortOrder>;
  sociabilityIndex?: InputMaybe<SortOrder>;
  sortingIndex?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  videoUrl?: InputMaybe<SortOrder>;
};

export type DogBreedNullableRelationFilter = {
  is?: InputMaybe<DogBreedWhereInput>;
  isNot?: InputMaybe<DogBreedWhereInput>;
};

export type DogBreedOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export enum DogBreedOrderByRelevanceFieldEnum {
  baseBreedName = 'baseBreedName',
  fciGroup = 'fciGroup',
  homeCountryCode = 'homeCountryCode',
  name = 'name',
  videoUrl = 'videoUrl'
}

export type DogBreedOrderByRelevanceInput = {
  fields: Array<DogBreedOrderByRelevanceFieldEnum>;
  search: Scalars['String']['input'];
  sort: SortOrder;
};

export type DogBreedOrderByWithAggregationInput = {
  _avg?: InputMaybe<DogBreedAvgOrderByAggregateInput>;
  _count?: InputMaybe<DogBreedCountOrderByAggregateInput>;
  _max?: InputMaybe<DogBreedMaxOrderByAggregateInput>;
  _min?: InputMaybe<DogBreedMinOrderByAggregateInput>;
  _sum?: InputMaybe<DogBreedSumOrderByAggregateInput>;
  adultSizeAge?: InputMaybe<SortOrderInput>;
  barkingTendancyIndex?: InputMaybe<SortOrderInput>;
  baseBreedName?: InputMaybe<SortOrderInput>;
  careIndex?: InputMaybe<SortOrderInput>;
  coldToleranceIndex?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  dogType?: InputMaybe<SortOrder>;
  educationIndex?: InputMaybe<SortOrderInput>;
  exerciseIndex?: InputMaybe<SortOrderInput>;
  fciGroup?: InputMaybe<SortOrderInput>;
  foreignerSociabilityIndex?: InputMaybe<SortOrderInput>;
  hairLossIndex?: InputMaybe<SortOrderInput>;
  hairType?: InputMaybe<SortOrderInput>;
  headShape?: InputMaybe<SortOrderInput>;
  heatToleranceIndex?: InputMaybe<SortOrderInput>;
  homeCountryCode?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  independenceIndex?: InputMaybe<SortOrderInput>;
  intellectualActivityNeedIndex?: InputMaybe<SortOrderInput>;
  isSubBreed?: InputMaybe<SortOrder>;
  maintenanceIndex?: InputMaybe<SortOrderInput>;
  name?: InputMaybe<SortOrder>;
  physicalActivityNeedIndex?: InputMaybe<SortOrderInput>;
  predatoryInstinctIndex?: InputMaybe<SortOrderInput>;
  robustnessIndex?: InputMaybe<SortOrderInput>;
  sizeCategory?: InputMaybe<SortOrderInput>;
  sociabilityIndex?: InputMaybe<SortOrderInput>;
  sortingIndex?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
  videoUrl?: InputMaybe<SortOrderInput>;
};

export type DogBreedOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: InputMaybe<DogBreedOrderByRelevanceInput>;
  adultSizeAge?: InputMaybe<SortOrderInput>;
  applications?: InputMaybe<DogBreederApplicationOrderByRelationAggregateInput>;
  barkingTendancyIndex?: InputMaybe<SortOrderInput>;
  baseBreedName?: InputMaybe<SortOrderInput>;
  breedInterestSubscriptions?: InputMaybe<DogBreedInterestSubscriptionOrderByRelationAggregateInput>;
  careIndex?: InputMaybe<SortOrderInput>;
  coldToleranceIndex?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  dogBreeders?: InputMaybe<DogBreederBreedsOrderByRelationAggregateInput>;
  dogInfos?: InputMaybe<DogInfoOrderByRelationAggregateInput>;
  dogType?: InputMaybe<SortOrder>;
  educationIndex?: InputMaybe<SortOrderInput>;
  exerciseIndex?: InputMaybe<SortOrderInput>;
  fciGroup?: InputMaybe<SortOrderInput>;
  foreignerSociabilityIndex?: InputMaybe<SortOrderInput>;
  hairLossIndex?: InputMaybe<SortOrderInput>;
  hairType?: InputMaybe<SortOrderInput>;
  headShape?: InputMaybe<SortOrderInput>;
  heatToleranceIndex?: InputMaybe<SortOrderInput>;
  homeCountryCode?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  imgs?: InputMaybe<DogBreedImgOrderByRelationAggregateInput>;
  independenceIndex?: InputMaybe<SortOrderInput>;
  intellectualActivityNeedIndex?: InputMaybe<SortOrderInput>;
  isSubBreed?: InputMaybe<SortOrder>;
  litters?: InputMaybe<LitterOrderByRelationAggregateInput>;
  maintenanceIndex?: InputMaybe<SortOrderInput>;
  name?: InputMaybe<SortOrder>;
  physicalActivityNeedIndex?: InputMaybe<SortOrderInput>;
  predatoryInstinctIndex?: InputMaybe<SortOrderInput>;
  puppies?: InputMaybe<DogPuppyOrderByRelationAggregateInput>;
  robustnessIndex?: InputMaybe<SortOrderInput>;
  sizeCategory?: InputMaybe<SortOrderInput>;
  sociabilityIndex?: InputMaybe<SortOrderInput>;
  sortingIndex?: InputMaybe<SortOrderInput>;
  translations?: InputMaybe<DogBreedTranslationOrderByRelationAggregateInput>;
  updatedAt?: InputMaybe<SortOrder>;
  videoUrl?: InputMaybe<SortOrderInput>;
};

export type DogBreedRelationFilter = {
  is?: InputMaybe<DogBreedWhereInput>;
  isNot?: InputMaybe<DogBreedWhereInput>;
};

export enum DogBreedScalarFieldEnum {
  adultSizeAge = 'adultSizeAge',
  barkingTendancyIndex = 'barkingTendancyIndex',
  baseBreedName = 'baseBreedName',
  careIndex = 'careIndex',
  coldToleranceIndex = 'coldToleranceIndex',
  createdAt = 'createdAt',
  dogType = 'dogType',
  educationIndex = 'educationIndex',
  exerciseIndex = 'exerciseIndex',
  fciGroup = 'fciGroup',
  foreignerSociabilityIndex = 'foreignerSociabilityIndex',
  hairLossIndex = 'hairLossIndex',
  hairType = 'hairType',
  headShape = 'headShape',
  heatToleranceIndex = 'heatToleranceIndex',
  homeCountryCode = 'homeCountryCode',
  id = 'id',
  independenceIndex = 'independenceIndex',
  intellectualActivityNeedIndex = 'intellectualActivityNeedIndex',
  isSubBreed = 'isSubBreed',
  maintenanceIndex = 'maintenanceIndex',
  name = 'name',
  physicalActivityNeedIndex = 'physicalActivityNeedIndex',
  predatoryInstinctIndex = 'predatoryInstinctIndex',
  robustnessIndex = 'robustnessIndex',
  sizeCategory = 'sizeCategory',
  sociabilityIndex = 'sociabilityIndex',
  sortingIndex = 'sortingIndex',
  updatedAt = 'updatedAt',
  videoUrl = 'videoUrl'
}

export type DogBreedScalarWhereInput = {
  AND?: InputMaybe<Array<DogBreedScalarWhereInput>>;
  NOT?: InputMaybe<Array<DogBreedScalarWhereInput>>;
  OR?: InputMaybe<Array<DogBreedScalarWhereInput>>;
  adultSizeAge?: InputMaybe<IntNullableFilter>;
  barkingTendancyIndex?: InputMaybe<FloatNullableFilter>;
  baseBreedName?: InputMaybe<StringNullableFilter>;
  careIndex?: InputMaybe<IntNullableFilter>;
  coldToleranceIndex?: InputMaybe<FloatNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  dogType?: InputMaybe<EnumDogTypeNullableListFilter>;
  educationIndex?: InputMaybe<IntNullableFilter>;
  exerciseIndex?: InputMaybe<IntNullableFilter>;
  fciGroup?: InputMaybe<StringNullableFilter>;
  foreignerSociabilityIndex?: InputMaybe<FloatNullableFilter>;
  hairLossIndex?: InputMaybe<FloatNullableFilter>;
  hairType?: InputMaybe<EnumDogHairTypeNullableFilter>;
  headShape?: InputMaybe<EnumHeadShapeNullableFilter>;
  heatToleranceIndex?: InputMaybe<FloatNullableFilter>;
  homeCountryCode?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<IntFilter>;
  independenceIndex?: InputMaybe<FloatNullableFilter>;
  intellectualActivityNeedIndex?: InputMaybe<FloatNullableFilter>;
  isSubBreed?: InputMaybe<BoolFilter>;
  maintenanceIndex?: InputMaybe<IntNullableFilter>;
  name?: InputMaybe<StringFilter>;
  physicalActivityNeedIndex?: InputMaybe<FloatNullableFilter>;
  predatoryInstinctIndex?: InputMaybe<FloatNullableFilter>;
  robustnessIndex?: InputMaybe<IntNullableFilter>;
  sizeCategory?: InputMaybe<EnumAnimalSizeEnumNullableFilter>;
  sociabilityIndex?: InputMaybe<IntNullableFilter>;
  sortingIndex?: InputMaybe<IntNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  videoUrl?: InputMaybe<StringNullableFilter>;
};

export type DogBreedScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<DogBreedScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<DogBreedScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<DogBreedScalarWhereWithAggregatesInput>>;
  adultSizeAge?: InputMaybe<IntNullableWithAggregatesFilter>;
  barkingTendancyIndex?: InputMaybe<FloatNullableWithAggregatesFilter>;
  baseBreedName?: InputMaybe<StringNullableWithAggregatesFilter>;
  careIndex?: InputMaybe<IntNullableWithAggregatesFilter>;
  coldToleranceIndex?: InputMaybe<FloatNullableWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  dogType?: InputMaybe<EnumDogTypeNullableListFilter>;
  educationIndex?: InputMaybe<IntNullableWithAggregatesFilter>;
  exerciseIndex?: InputMaybe<IntNullableWithAggregatesFilter>;
  fciGroup?: InputMaybe<StringNullableWithAggregatesFilter>;
  foreignerSociabilityIndex?: InputMaybe<FloatNullableWithAggregatesFilter>;
  hairLossIndex?: InputMaybe<FloatNullableWithAggregatesFilter>;
  hairType?: InputMaybe<EnumDogHairTypeNullableWithAggregatesFilter>;
  headShape?: InputMaybe<EnumHeadShapeNullableWithAggregatesFilter>;
  heatToleranceIndex?: InputMaybe<FloatNullableWithAggregatesFilter>;
  homeCountryCode?: InputMaybe<StringNullableWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  independenceIndex?: InputMaybe<FloatNullableWithAggregatesFilter>;
  intellectualActivityNeedIndex?: InputMaybe<FloatNullableWithAggregatesFilter>;
  isSubBreed?: InputMaybe<BoolWithAggregatesFilter>;
  maintenanceIndex?: InputMaybe<IntNullableWithAggregatesFilter>;
  name?: InputMaybe<StringWithAggregatesFilter>;
  physicalActivityNeedIndex?: InputMaybe<FloatNullableWithAggregatesFilter>;
  predatoryInstinctIndex?: InputMaybe<FloatNullableWithAggregatesFilter>;
  robustnessIndex?: InputMaybe<IntNullableWithAggregatesFilter>;
  sizeCategory?: InputMaybe<EnumAnimalSizeEnumNullableWithAggregatesFilter>;
  sociabilityIndex?: InputMaybe<IntNullableWithAggregatesFilter>;
  sortingIndex?: InputMaybe<IntNullableWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  videoUrl?: InputMaybe<StringNullableWithAggregatesFilter>;
};

export type DogBreedSumAggregateOutputType = {
  __typename?: 'DogBreedSumAggregateOutputType';
  adultSizeAge?: Maybe<Scalars['Int']['output']>;
  barkingTendancyIndex?: Maybe<Scalars['Float']['output']>;
  careIndex?: Maybe<Scalars['Int']['output']>;
  coldToleranceIndex?: Maybe<Scalars['Float']['output']>;
  educationIndex?: Maybe<Scalars['Int']['output']>;
  exerciseIndex?: Maybe<Scalars['Int']['output']>;
  foreignerSociabilityIndex?: Maybe<Scalars['Float']['output']>;
  hairLossIndex?: Maybe<Scalars['Float']['output']>;
  heatToleranceIndex?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  independenceIndex?: Maybe<Scalars['Float']['output']>;
  intellectualActivityNeedIndex?: Maybe<Scalars['Float']['output']>;
  maintenanceIndex?: Maybe<Scalars['Int']['output']>;
  physicalActivityNeedIndex?: Maybe<Scalars['Float']['output']>;
  predatoryInstinctIndex?: Maybe<Scalars['Float']['output']>;
  robustnessIndex?: Maybe<Scalars['Int']['output']>;
  sociabilityIndex?: Maybe<Scalars['Int']['output']>;
  sortingIndex?: Maybe<Scalars['Int']['output']>;
};

export type DogBreedSumOrderByAggregateInput = {
  adultSizeAge?: InputMaybe<SortOrder>;
  barkingTendancyIndex?: InputMaybe<SortOrder>;
  careIndex?: InputMaybe<SortOrder>;
  coldToleranceIndex?: InputMaybe<SortOrder>;
  educationIndex?: InputMaybe<SortOrder>;
  exerciseIndex?: InputMaybe<SortOrder>;
  foreignerSociabilityIndex?: InputMaybe<SortOrder>;
  hairLossIndex?: InputMaybe<SortOrder>;
  heatToleranceIndex?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  independenceIndex?: InputMaybe<SortOrder>;
  intellectualActivityNeedIndex?: InputMaybe<SortOrder>;
  maintenanceIndex?: InputMaybe<SortOrder>;
  physicalActivityNeedIndex?: InputMaybe<SortOrder>;
  predatoryInstinctIndex?: InputMaybe<SortOrder>;
  robustnessIndex?: InputMaybe<SortOrder>;
  sociabilityIndex?: InputMaybe<SortOrder>;
  sortingIndex?: InputMaybe<SortOrder>;
};

export type DogBreedTranslation = {
  __typename?: 'DogBreedTranslation';
  advices?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  dogBreed: DogBreed;
  dogBreedId: Scalars['Int']['output'];
  fragilities?: Maybe<Scalars['String']['output']>;
  geneticAnalyzeType?: Maybe<BreedGeneticAnalyzeType>;
  genetics?: Maybe<Array<Scalars['String']['output']>>;
  historic?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  language: Scalars['String']['output'];
  morphology?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  otherNames: Array<Scalars['String']['output']>;
  seoDescription?: Maybe<Scalars['String']['output']>;
  seoKeywords?: Maybe<Scalars['String']['output']>;
  synologyRank?: Maybe<Scalars['String']['output']>;
  temper?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type DogBreedTranslationAvgAggregateOutputType = {
  __typename?: 'DogBreedTranslationAvgAggregateOutputType';
  dogBreedId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

export type DogBreedTranslationAvgOrderByAggregateInput = {
  dogBreedId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export type DogBreedTranslationCountAggregateOutputType = {
  __typename?: 'DogBreedTranslationCountAggregateOutputType';
  _all: Scalars['Int']['output'];
  advices: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  description: Scalars['Int']['output'];
  dogBreedId: Scalars['Int']['output'];
  fragilities: Scalars['Int']['output'];
  geneticAnalyzeType: Scalars['Int']['output'];
  genetics: Scalars['Int']['output'];
  historic: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  language: Scalars['Int']['output'];
  morphology: Scalars['Int']['output'];
  name: Scalars['Int']['output'];
  otherNames: Scalars['Int']['output'];
  seoDescription: Scalars['Int']['output'];
  seoKeywords: Scalars['Int']['output'];
  synologyRank: Scalars['Int']['output'];
  temper: Scalars['Int']['output'];
  title: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
  url: Scalars['Int']['output'];
};

export type DogBreedTranslationCountOrderByAggregateInput = {
  advices?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  dogBreedId?: InputMaybe<SortOrder>;
  fragilities?: InputMaybe<SortOrder>;
  geneticAnalyzeType?: InputMaybe<SortOrder>;
  genetics?: InputMaybe<SortOrder>;
  historic?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  language?: InputMaybe<SortOrder>;
  morphology?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  otherNames?: InputMaybe<SortOrder>;
  seoDescription?: InputMaybe<SortOrder>;
  seoKeywords?: InputMaybe<SortOrder>;
  synologyRank?: InputMaybe<SortOrder>;
  temper?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  url?: InputMaybe<SortOrder>;
};

export type DogBreedTranslationCreateInput = {
  advices?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dogBreed: DogBreedCreateNestedOneWithoutTranslationsInput;
  fragilities?: InputMaybe<Scalars['String']['input']>;
  geneticAnalyzeType?: InputMaybe<BreedGeneticAnalyzeType>;
  genetics?: InputMaybe<Array<Scalars['String']['input']>>;
  historic?: InputMaybe<Scalars['String']['input']>;
  language: Scalars['String']['input'];
  morphology?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  otherNames?: InputMaybe<Array<Scalars['String']['input']>>;
  seoDescription?: InputMaybe<Scalars['String']['input']>;
  seoKeywords?: InputMaybe<Scalars['String']['input']>;
  synologyRank?: InputMaybe<Scalars['String']['input']>;
  temper?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type DogBreedTranslationCreateManyDogBreedInput = {
  advices?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  fragilities?: InputMaybe<Scalars['String']['input']>;
  geneticAnalyzeType?: InputMaybe<BreedGeneticAnalyzeType>;
  genetics?: InputMaybe<Array<Scalars['String']['input']>>;
  historic?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  language: Scalars['String']['input'];
  morphology?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  otherNames?: InputMaybe<Array<Scalars['String']['input']>>;
  seoDescription?: InputMaybe<Scalars['String']['input']>;
  seoKeywords?: InputMaybe<Scalars['String']['input']>;
  synologyRank?: InputMaybe<Scalars['String']['input']>;
  temper?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type DogBreedTranslationCreateManyDogBreedInputEnvelope = {
  data: Array<DogBreedTranslationCreateManyDogBreedInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DogBreedTranslationCreateManyInput = {
  advices?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dogBreedId: Scalars['Int']['input'];
  fragilities?: InputMaybe<Scalars['String']['input']>;
  geneticAnalyzeType?: InputMaybe<BreedGeneticAnalyzeType>;
  genetics?: InputMaybe<Array<Scalars['String']['input']>>;
  historic?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  language: Scalars['String']['input'];
  morphology?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  otherNames?: InputMaybe<Array<Scalars['String']['input']>>;
  seoDescription?: InputMaybe<Scalars['String']['input']>;
  seoKeywords?: InputMaybe<Scalars['String']['input']>;
  synologyRank?: InputMaybe<Scalars['String']['input']>;
  temper?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type DogBreedTranslationCreateNestedManyWithoutDogBreedInput = {
  connect?: InputMaybe<Array<DogBreedTranslationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DogBreedTranslationCreateOrConnectWithoutDogBreedInput>>;
  create?: InputMaybe<Array<DogBreedTranslationCreateWithoutDogBreedInput>>;
  createMany?: InputMaybe<DogBreedTranslationCreateManyDogBreedInputEnvelope>;
};

export type DogBreedTranslationCreateOrConnectWithoutDogBreedInput = {
  create: DogBreedTranslationCreateWithoutDogBreedInput;
  where: DogBreedTranslationWhereUniqueInput;
};

export type DogBreedTranslationCreateWithoutDogBreedInput = {
  advices?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  fragilities?: InputMaybe<Scalars['String']['input']>;
  geneticAnalyzeType?: InputMaybe<BreedGeneticAnalyzeType>;
  genetics?: InputMaybe<Array<Scalars['String']['input']>>;
  historic?: InputMaybe<Scalars['String']['input']>;
  language: Scalars['String']['input'];
  morphology?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  otherNames?: InputMaybe<Array<Scalars['String']['input']>>;
  seoDescription?: InputMaybe<Scalars['String']['input']>;
  seoKeywords?: InputMaybe<Scalars['String']['input']>;
  synologyRank?: InputMaybe<Scalars['String']['input']>;
  temper?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type DogBreedTranslationCreategeneticsInput = {
  set: Array<Scalars['String']['input']>;
};

export type DogBreedTranslationCreateotherNamesInput = {
  set: Array<Scalars['String']['input']>;
};

export type DogBreedTranslationListRelationFilter = {
  every?: InputMaybe<DogBreedTranslationWhereInput>;
  none?: InputMaybe<DogBreedTranslationWhereInput>;
  some?: InputMaybe<DogBreedTranslationWhereInput>;
};

export type DogBreedTranslationMaxAggregateOutputType = {
  __typename?: 'DogBreedTranslationMaxAggregateOutputType';
  advices?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dogBreedId?: Maybe<Scalars['Int']['output']>;
  fragilities?: Maybe<Scalars['String']['output']>;
  geneticAnalyzeType?: Maybe<BreedGeneticAnalyzeType>;
  historic?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  morphology?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  seoDescription?: Maybe<Scalars['String']['output']>;
  seoKeywords?: Maybe<Scalars['String']['output']>;
  synologyRank?: Maybe<Scalars['String']['output']>;
  temper?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type DogBreedTranslationMaxOrderByAggregateInput = {
  advices?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  dogBreedId?: InputMaybe<SortOrder>;
  fragilities?: InputMaybe<SortOrder>;
  geneticAnalyzeType?: InputMaybe<SortOrder>;
  historic?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  language?: InputMaybe<SortOrder>;
  morphology?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  seoDescription?: InputMaybe<SortOrder>;
  seoKeywords?: InputMaybe<SortOrder>;
  synologyRank?: InputMaybe<SortOrder>;
  temper?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  url?: InputMaybe<SortOrder>;
};

export type DogBreedTranslationMinAggregateOutputType = {
  __typename?: 'DogBreedTranslationMinAggregateOutputType';
  advices?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dogBreedId?: Maybe<Scalars['Int']['output']>;
  fragilities?: Maybe<Scalars['String']['output']>;
  geneticAnalyzeType?: Maybe<BreedGeneticAnalyzeType>;
  historic?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  morphology?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  seoDescription?: Maybe<Scalars['String']['output']>;
  seoKeywords?: Maybe<Scalars['String']['output']>;
  synologyRank?: Maybe<Scalars['String']['output']>;
  temper?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type DogBreedTranslationMinOrderByAggregateInput = {
  advices?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  dogBreedId?: InputMaybe<SortOrder>;
  fragilities?: InputMaybe<SortOrder>;
  geneticAnalyzeType?: InputMaybe<SortOrder>;
  historic?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  language?: InputMaybe<SortOrder>;
  morphology?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  seoDescription?: InputMaybe<SortOrder>;
  seoKeywords?: InputMaybe<SortOrder>;
  synologyRank?: InputMaybe<SortOrder>;
  temper?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  url?: InputMaybe<SortOrder>;
};

export type DogBreedTranslationOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export enum DogBreedTranslationOrderByRelevanceFieldEnum {
  advices = 'advices',
  description = 'description',
  fragilities = 'fragilities',
  genetics = 'genetics',
  historic = 'historic',
  language = 'language',
  morphology = 'morphology',
  name = 'name',
  otherNames = 'otherNames',
  seoDescription = 'seoDescription',
  seoKeywords = 'seoKeywords',
  synologyRank = 'synologyRank',
  temper = 'temper',
  title = 'title',
  url = 'url'
}

export type DogBreedTranslationOrderByRelevanceInput = {
  fields: Array<DogBreedTranslationOrderByRelevanceFieldEnum>;
  search: Scalars['String']['input'];
  sort: SortOrder;
};

export type DogBreedTranslationOrderByWithAggregationInput = {
  _avg?: InputMaybe<DogBreedTranslationAvgOrderByAggregateInput>;
  _count?: InputMaybe<DogBreedTranslationCountOrderByAggregateInput>;
  _max?: InputMaybe<DogBreedTranslationMaxOrderByAggregateInput>;
  _min?: InputMaybe<DogBreedTranslationMinOrderByAggregateInput>;
  _sum?: InputMaybe<DogBreedTranslationSumOrderByAggregateInput>;
  advices?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrderInput>;
  dogBreedId?: InputMaybe<SortOrder>;
  fragilities?: InputMaybe<SortOrderInput>;
  geneticAnalyzeType?: InputMaybe<SortOrderInput>;
  genetics?: InputMaybe<SortOrder>;
  historic?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  language?: InputMaybe<SortOrder>;
  morphology?: InputMaybe<SortOrderInput>;
  name?: InputMaybe<SortOrderInput>;
  otherNames?: InputMaybe<SortOrder>;
  seoDescription?: InputMaybe<SortOrderInput>;
  seoKeywords?: InputMaybe<SortOrderInput>;
  synologyRank?: InputMaybe<SortOrderInput>;
  temper?: InputMaybe<SortOrderInput>;
  title?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
  url?: InputMaybe<SortOrderInput>;
};

export type DogBreedTranslationOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: InputMaybe<DogBreedTranslationOrderByRelevanceInput>;
  advices?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrderInput>;
  dogBreed?: InputMaybe<DogBreedOrderByWithRelationAndSearchRelevanceInput>;
  dogBreedId?: InputMaybe<SortOrder>;
  fragilities?: InputMaybe<SortOrderInput>;
  geneticAnalyzeType?: InputMaybe<SortOrderInput>;
  genetics?: InputMaybe<SortOrder>;
  historic?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  language?: InputMaybe<SortOrder>;
  morphology?: InputMaybe<SortOrderInput>;
  name?: InputMaybe<SortOrderInput>;
  otherNames?: InputMaybe<SortOrder>;
  seoDescription?: InputMaybe<SortOrderInput>;
  seoKeywords?: InputMaybe<SortOrderInput>;
  synologyRank?: InputMaybe<SortOrderInput>;
  temper?: InputMaybe<SortOrderInput>;
  title?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
  url?: InputMaybe<SortOrderInput>;
};

export enum DogBreedTranslationScalarFieldEnum {
  advices = 'advices',
  createdAt = 'createdAt',
  description = 'description',
  dogBreedId = 'dogBreedId',
  fragilities = 'fragilities',
  geneticAnalyzeType = 'geneticAnalyzeType',
  genetics = 'genetics',
  historic = 'historic',
  id = 'id',
  language = 'language',
  morphology = 'morphology',
  name = 'name',
  otherNames = 'otherNames',
  seoDescription = 'seoDescription',
  seoKeywords = 'seoKeywords',
  synologyRank = 'synologyRank',
  temper = 'temper',
  title = 'title',
  updatedAt = 'updatedAt',
  url = 'url'
}

export type DogBreedTranslationScalarWhereInput = {
  AND?: InputMaybe<Array<DogBreedTranslationScalarWhereInput>>;
  NOT?: InputMaybe<Array<DogBreedTranslationScalarWhereInput>>;
  OR?: InputMaybe<Array<DogBreedTranslationScalarWhereInput>>;
  advices?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringNullableFilter>;
  dogBreedId?: InputMaybe<IntFilter>;
  fragilities?: InputMaybe<StringNullableFilter>;
  geneticAnalyzeType?: InputMaybe<EnumBreedGeneticAnalyzeTypeNullableFilter>;
  genetics?: InputMaybe<StringNullableListFilter>;
  historic?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<IntFilter>;
  language?: InputMaybe<StringFilter>;
  morphology?: InputMaybe<StringNullableFilter>;
  name?: InputMaybe<StringNullableFilter>;
  otherNames?: InputMaybe<StringNullableListFilter>;
  seoDescription?: InputMaybe<StringNullableFilter>;
  seoKeywords?: InputMaybe<StringNullableFilter>;
  synologyRank?: InputMaybe<StringNullableFilter>;
  temper?: InputMaybe<StringNullableFilter>;
  title?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  url?: InputMaybe<StringNullableFilter>;
};

export type DogBreedTranslationScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<DogBreedTranslationScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<DogBreedTranslationScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<DogBreedTranslationScalarWhereWithAggregatesInput>>;
  advices?: InputMaybe<StringNullableWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  description?: InputMaybe<StringNullableWithAggregatesFilter>;
  dogBreedId?: InputMaybe<IntWithAggregatesFilter>;
  fragilities?: InputMaybe<StringNullableWithAggregatesFilter>;
  geneticAnalyzeType?: InputMaybe<EnumBreedGeneticAnalyzeTypeNullableWithAggregatesFilter>;
  genetics?: InputMaybe<StringNullableListFilter>;
  historic?: InputMaybe<StringNullableWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  language?: InputMaybe<StringWithAggregatesFilter>;
  morphology?: InputMaybe<StringNullableWithAggregatesFilter>;
  name?: InputMaybe<StringNullableWithAggregatesFilter>;
  otherNames?: InputMaybe<StringNullableListFilter>;
  seoDescription?: InputMaybe<StringNullableWithAggregatesFilter>;
  seoKeywords?: InputMaybe<StringNullableWithAggregatesFilter>;
  synologyRank?: InputMaybe<StringNullableWithAggregatesFilter>;
  temper?: InputMaybe<StringNullableWithAggregatesFilter>;
  title?: InputMaybe<StringNullableWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  url?: InputMaybe<StringNullableWithAggregatesFilter>;
};

export type DogBreedTranslationSumAggregateOutputType = {
  __typename?: 'DogBreedTranslationSumAggregateOutputType';
  dogBreedId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
};

export type DogBreedTranslationSumOrderByAggregateInput = {
  dogBreedId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export type DogBreedTranslationUncheckedCreateInput = {
  advices?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dogBreedId: Scalars['Int']['input'];
  fragilities?: InputMaybe<Scalars['String']['input']>;
  geneticAnalyzeType?: InputMaybe<BreedGeneticAnalyzeType>;
  genetics?: InputMaybe<Array<Scalars['String']['input']>>;
  historic?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  language: Scalars['String']['input'];
  morphology?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  otherNames?: InputMaybe<Array<Scalars['String']['input']>>;
  seoDescription?: InputMaybe<Scalars['String']['input']>;
  seoKeywords?: InputMaybe<Scalars['String']['input']>;
  synologyRank?: InputMaybe<Scalars['String']['input']>;
  temper?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type DogBreedTranslationUncheckedCreateNestedManyWithoutDogBreedInput = {
  connect?: InputMaybe<Array<DogBreedTranslationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DogBreedTranslationCreateOrConnectWithoutDogBreedInput>>;
  create?: InputMaybe<Array<DogBreedTranslationCreateWithoutDogBreedInput>>;
  createMany?: InputMaybe<DogBreedTranslationCreateManyDogBreedInputEnvelope>;
};

export type DogBreedTranslationUncheckedCreateWithoutDogBreedInput = {
  advices?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  fragilities?: InputMaybe<Scalars['String']['input']>;
  geneticAnalyzeType?: InputMaybe<BreedGeneticAnalyzeType>;
  genetics?: InputMaybe<Array<Scalars['String']['input']>>;
  historic?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  language: Scalars['String']['input'];
  morphology?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  otherNames?: InputMaybe<Array<Scalars['String']['input']>>;
  seoDescription?: InputMaybe<Scalars['String']['input']>;
  seoKeywords?: InputMaybe<Scalars['String']['input']>;
  synologyRank?: InputMaybe<Scalars['String']['input']>;
  temper?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type DogBreedTranslationUncheckedUpdateInput = {
  advices?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dogBreedId?: InputMaybe<IntFieldUpdateOperationsInput>;
  fragilities?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  geneticAnalyzeType?: InputMaybe<NullableEnumBreedGeneticAnalyzeTypeFieldUpdateOperationsInput>;
  genetics?: InputMaybe<Array<Scalars['String']['input']>>;
  historic?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  morphology?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  otherNames?: InputMaybe<Array<Scalars['String']['input']>>;
  seoDescription?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  seoKeywords?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  synologyRank?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  temper?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  url?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type DogBreedTranslationUncheckedUpdateManyInput = {
  advices?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dogBreedId?: InputMaybe<IntFieldUpdateOperationsInput>;
  fragilities?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  geneticAnalyzeType?: InputMaybe<NullableEnumBreedGeneticAnalyzeTypeFieldUpdateOperationsInput>;
  genetics?: InputMaybe<Array<Scalars['String']['input']>>;
  historic?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  morphology?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  otherNames?: InputMaybe<Array<Scalars['String']['input']>>;
  seoDescription?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  seoKeywords?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  synologyRank?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  temper?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  url?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type DogBreedTranslationUncheckedUpdateManyWithoutDogBreedInput = {
  advices?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  fragilities?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  geneticAnalyzeType?: InputMaybe<NullableEnumBreedGeneticAnalyzeTypeFieldUpdateOperationsInput>;
  genetics?: InputMaybe<Array<Scalars['String']['input']>>;
  historic?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  morphology?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  otherNames?: InputMaybe<Array<Scalars['String']['input']>>;
  seoDescription?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  seoKeywords?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  synologyRank?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  temper?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  url?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type DogBreedTranslationUncheckedUpdateManyWithoutDogBreedNestedInput = {
  connect?: InputMaybe<Array<DogBreedTranslationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DogBreedTranslationCreateOrConnectWithoutDogBreedInput>>;
  create?: InputMaybe<Array<DogBreedTranslationCreateWithoutDogBreedInput>>;
  createMany?: InputMaybe<DogBreedTranslationCreateManyDogBreedInputEnvelope>;
  delete?: InputMaybe<Array<DogBreedTranslationWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<DogBreedTranslationScalarWhereInput>>;
  disconnect?: InputMaybe<Array<DogBreedTranslationWhereUniqueInput>>;
  set?: InputMaybe<Array<DogBreedTranslationWhereUniqueInput>>;
  update?: InputMaybe<Array<DogBreedTranslationUpdateWithWhereUniqueWithoutDogBreedInput>>;
  updateMany?: InputMaybe<Array<DogBreedTranslationUpdateManyWithWhereWithoutDogBreedInput>>;
  upsert?: InputMaybe<Array<DogBreedTranslationUpsertWithWhereUniqueWithoutDogBreedInput>>;
};

export type DogBreedTranslationUncheckedUpdateWithoutDogBreedInput = {
  advices?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  fragilities?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  geneticAnalyzeType?: InputMaybe<NullableEnumBreedGeneticAnalyzeTypeFieldUpdateOperationsInput>;
  genetics?: InputMaybe<Array<Scalars['String']['input']>>;
  historic?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  morphology?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  otherNames?: InputMaybe<Array<Scalars['String']['input']>>;
  seoDescription?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  seoKeywords?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  synologyRank?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  temper?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  url?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type DogBreedTranslationUpdateInput = {
  advices?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dogBreed?: InputMaybe<DogBreedUpdateOneRequiredWithoutTranslationsNestedInput>;
  fragilities?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  geneticAnalyzeType?: InputMaybe<NullableEnumBreedGeneticAnalyzeTypeFieldUpdateOperationsInput>;
  genetics?: InputMaybe<Array<Scalars['String']['input']>>;
  historic?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  morphology?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  otherNames?: InputMaybe<Array<Scalars['String']['input']>>;
  seoDescription?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  seoKeywords?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  synologyRank?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  temper?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  url?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type DogBreedTranslationUpdateManyMutationInput = {
  advices?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  fragilities?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  geneticAnalyzeType?: InputMaybe<NullableEnumBreedGeneticAnalyzeTypeFieldUpdateOperationsInput>;
  genetics?: InputMaybe<Array<Scalars['String']['input']>>;
  historic?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  morphology?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  otherNames?: InputMaybe<Array<Scalars['String']['input']>>;
  seoDescription?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  seoKeywords?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  synologyRank?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  temper?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  url?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type DogBreedTranslationUpdateManyWithWhereWithoutDogBreedInput = {
  data: DogBreedTranslationUpdateManyMutationInput;
  where: DogBreedTranslationScalarWhereInput;
};

export type DogBreedTranslationUpdateManyWithoutDogBreedNestedInput = {
  connect?: InputMaybe<Array<DogBreedTranslationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DogBreedTranslationCreateOrConnectWithoutDogBreedInput>>;
  create?: InputMaybe<Array<DogBreedTranslationCreateWithoutDogBreedInput>>;
  createMany?: InputMaybe<DogBreedTranslationCreateManyDogBreedInputEnvelope>;
  delete?: InputMaybe<Array<DogBreedTranslationWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<DogBreedTranslationScalarWhereInput>>;
  disconnect?: InputMaybe<Array<DogBreedTranslationWhereUniqueInput>>;
  set?: InputMaybe<Array<DogBreedTranslationWhereUniqueInput>>;
  update?: InputMaybe<Array<DogBreedTranslationUpdateWithWhereUniqueWithoutDogBreedInput>>;
  updateMany?: InputMaybe<Array<DogBreedTranslationUpdateManyWithWhereWithoutDogBreedInput>>;
  upsert?: InputMaybe<Array<DogBreedTranslationUpsertWithWhereUniqueWithoutDogBreedInput>>;
};

export type DogBreedTranslationUpdateWithWhereUniqueWithoutDogBreedInput = {
  data: DogBreedTranslationUpdateWithoutDogBreedInput;
  where: DogBreedTranslationWhereUniqueInput;
};

export type DogBreedTranslationUpdateWithoutDogBreedInput = {
  advices?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  fragilities?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  geneticAnalyzeType?: InputMaybe<NullableEnumBreedGeneticAnalyzeTypeFieldUpdateOperationsInput>;
  genetics?: InputMaybe<Array<Scalars['String']['input']>>;
  historic?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  morphology?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  otherNames?: InputMaybe<Array<Scalars['String']['input']>>;
  seoDescription?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  seoKeywords?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  synologyRank?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  temper?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  url?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type DogBreedTranslationUpdategeneticsInput = {
  push?: InputMaybe<Array<Scalars['String']['input']>>;
  set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type DogBreedTranslationUpdateotherNamesInput = {
  push?: InputMaybe<Array<Scalars['String']['input']>>;
  set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type DogBreedTranslationUpsertWithWhereUniqueWithoutDogBreedInput = {
  create: DogBreedTranslationCreateWithoutDogBreedInput;
  update: DogBreedTranslationUpdateWithoutDogBreedInput;
  where: DogBreedTranslationWhereUniqueInput;
};

export type DogBreedTranslationWhereInput = {
  AND?: InputMaybe<Array<DogBreedTranslationWhereInput>>;
  NOT?: InputMaybe<Array<DogBreedTranslationWhereInput>>;
  OR?: InputMaybe<Array<DogBreedTranslationWhereInput>>;
  advices?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringNullableFilter>;
  dogBreed?: InputMaybe<DogBreedRelationFilter>;
  dogBreedId?: InputMaybe<IntFilter>;
  fragilities?: InputMaybe<StringNullableFilter>;
  geneticAnalyzeType?: InputMaybe<EnumBreedGeneticAnalyzeTypeNullableFilter>;
  genetics?: InputMaybe<StringNullableListFilter>;
  historic?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<IntFilter>;
  language?: InputMaybe<StringFilter>;
  morphology?: InputMaybe<StringNullableFilter>;
  name?: InputMaybe<StringNullableFilter>;
  otherNames?: InputMaybe<StringNullableListFilter>;
  seoDescription?: InputMaybe<StringNullableFilter>;
  seoKeywords?: InputMaybe<StringNullableFilter>;
  synologyRank?: InputMaybe<StringNullableFilter>;
  temper?: InputMaybe<StringNullableFilter>;
  title?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  url?: InputMaybe<StringNullableFilter>;
};

export type DogBreedTranslationWhereUniqueInput = {
  AND?: InputMaybe<Array<DogBreedTranslationWhereInput>>;
  NOT?: InputMaybe<Array<DogBreedTranslationWhereInput>>;
  OR?: InputMaybe<Array<DogBreedTranslationWhereInput>>;
  advices?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringNullableFilter>;
  dogBreed?: InputMaybe<DogBreedRelationFilter>;
  dogBreedId?: InputMaybe<IntFilter>;
  fragilities?: InputMaybe<StringNullableFilter>;
  geneticAnalyzeType?: InputMaybe<EnumBreedGeneticAnalyzeTypeNullableFilter>;
  genetics?: InputMaybe<StringNullableListFilter>;
  historic?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  language?: InputMaybe<StringFilter>;
  morphology?: InputMaybe<StringNullableFilter>;
  name?: InputMaybe<StringNullableFilter>;
  otherNames?: InputMaybe<StringNullableListFilter>;
  seoDescription?: InputMaybe<StringNullableFilter>;
  seoKeywords?: InputMaybe<StringNullableFilter>;
  synologyRank?: InputMaybe<StringNullableFilter>;
  temper?: InputMaybe<StringNullableFilter>;
  title?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  url?: InputMaybe<StringNullableFilter>;
};

export type DogBreedUncheckedCreateInput = {
  adultSizeAge?: InputMaybe<Scalars['Int']['input']>;
  applications?: InputMaybe<DogBreederApplicationUncheckedCreateNestedManyWithoutBreedPreferenceInput>;
  barkingTendancyIndex?: InputMaybe<Scalars['Float']['input']>;
  baseBreedName?: InputMaybe<Scalars['String']['input']>;
  breedInterestSubscriptions?: InputMaybe<DogBreedInterestSubscriptionUncheckedCreateNestedManyWithoutDogBreedsInput>;
  careIndex?: InputMaybe<Scalars['Int']['input']>;
  coldToleranceIndex?: InputMaybe<Scalars['Float']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dogBreeders?: InputMaybe<DogBreederBreedsUncheckedCreateNestedManyWithoutDogBreedInput>;
  dogInfos?: InputMaybe<DogInfoUncheckedCreateNestedManyWithoutDogBreedInput>;
  dogType?: InputMaybe<Array<DogType>>;
  educationIndex?: InputMaybe<Scalars['Int']['input']>;
  exerciseIndex?: InputMaybe<Scalars['Int']['input']>;
  fciGroup?: InputMaybe<Scalars['String']['input']>;
  foreignerSociabilityIndex?: InputMaybe<Scalars['Float']['input']>;
  hairLossIndex?: InputMaybe<Scalars['Float']['input']>;
  hairType?: InputMaybe<DogHairType>;
  headShape?: InputMaybe<HeadShape>;
  heatToleranceIndex?: InputMaybe<Scalars['Float']['input']>;
  homeCountryCode?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  imgs?: InputMaybe<DogBreedImgUncheckedCreateNestedManyWithoutDogBreedInput>;
  independenceIndex?: InputMaybe<Scalars['Float']['input']>;
  intellectualActivityNeedIndex?: InputMaybe<Scalars['Float']['input']>;
  isSubBreed?: InputMaybe<Scalars['Boolean']['input']>;
  litters?: InputMaybe<LitterUncheckedCreateNestedManyWithoutDogBreedInput>;
  maintenanceIndex?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  physicalActivityNeedIndex?: InputMaybe<Scalars['Float']['input']>;
  predatoryInstinctIndex?: InputMaybe<Scalars['Float']['input']>;
  puppies?: InputMaybe<DogPuppyUncheckedCreateNestedManyWithoutBreedInput>;
  robustnessIndex?: InputMaybe<Scalars['Int']['input']>;
  sizeCategory?: InputMaybe<AnimalSizeEnum>;
  sociabilityIndex?: InputMaybe<Scalars['Int']['input']>;
  sortingIndex?: InputMaybe<Scalars['Int']['input']>;
  translations?: InputMaybe<DogBreedTranslationUncheckedCreateNestedManyWithoutDogBreedInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  videoUrl?: InputMaybe<Scalars['String']['input']>;
};

export type DogBreedUncheckedCreateNestedManyWithoutBreedInterestSubscriptionsInput = {
  connect?: InputMaybe<Array<DogBreedWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DogBreedCreateOrConnectWithoutBreedInterestSubscriptionsInput>>;
  create?: InputMaybe<Array<DogBreedCreateWithoutBreedInterestSubscriptionsInput>>;
};

export type DogBreedUncheckedCreateWithoutApplicationsInput = {
  adultSizeAge?: InputMaybe<Scalars['Int']['input']>;
  barkingTendancyIndex?: InputMaybe<Scalars['Float']['input']>;
  baseBreedName?: InputMaybe<Scalars['String']['input']>;
  breedInterestSubscriptions?: InputMaybe<DogBreedInterestSubscriptionUncheckedCreateNestedManyWithoutDogBreedsInput>;
  careIndex?: InputMaybe<Scalars['Int']['input']>;
  coldToleranceIndex?: InputMaybe<Scalars['Float']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dogBreeders?: InputMaybe<DogBreederBreedsUncheckedCreateNestedManyWithoutDogBreedInput>;
  dogInfos?: InputMaybe<DogInfoUncheckedCreateNestedManyWithoutDogBreedInput>;
  dogType?: InputMaybe<Array<DogType>>;
  educationIndex?: InputMaybe<Scalars['Int']['input']>;
  exerciseIndex?: InputMaybe<Scalars['Int']['input']>;
  fciGroup?: InputMaybe<Scalars['String']['input']>;
  foreignerSociabilityIndex?: InputMaybe<Scalars['Float']['input']>;
  hairLossIndex?: InputMaybe<Scalars['Float']['input']>;
  hairType?: InputMaybe<DogHairType>;
  headShape?: InputMaybe<HeadShape>;
  heatToleranceIndex?: InputMaybe<Scalars['Float']['input']>;
  homeCountryCode?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  imgs?: InputMaybe<DogBreedImgUncheckedCreateNestedManyWithoutDogBreedInput>;
  independenceIndex?: InputMaybe<Scalars['Float']['input']>;
  intellectualActivityNeedIndex?: InputMaybe<Scalars['Float']['input']>;
  isSubBreed?: InputMaybe<Scalars['Boolean']['input']>;
  litters?: InputMaybe<LitterUncheckedCreateNestedManyWithoutDogBreedInput>;
  maintenanceIndex?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  physicalActivityNeedIndex?: InputMaybe<Scalars['Float']['input']>;
  predatoryInstinctIndex?: InputMaybe<Scalars['Float']['input']>;
  puppies?: InputMaybe<DogPuppyUncheckedCreateNestedManyWithoutBreedInput>;
  robustnessIndex?: InputMaybe<Scalars['Int']['input']>;
  sizeCategory?: InputMaybe<AnimalSizeEnum>;
  sociabilityIndex?: InputMaybe<Scalars['Int']['input']>;
  sortingIndex?: InputMaybe<Scalars['Int']['input']>;
  translations?: InputMaybe<DogBreedTranslationUncheckedCreateNestedManyWithoutDogBreedInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  videoUrl?: InputMaybe<Scalars['String']['input']>;
};

export type DogBreedUncheckedCreateWithoutBreedInterestSubscriptionsInput = {
  adultSizeAge?: InputMaybe<Scalars['Int']['input']>;
  applications?: InputMaybe<DogBreederApplicationUncheckedCreateNestedManyWithoutBreedPreferenceInput>;
  barkingTendancyIndex?: InputMaybe<Scalars['Float']['input']>;
  baseBreedName?: InputMaybe<Scalars['String']['input']>;
  careIndex?: InputMaybe<Scalars['Int']['input']>;
  coldToleranceIndex?: InputMaybe<Scalars['Float']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dogBreeders?: InputMaybe<DogBreederBreedsUncheckedCreateNestedManyWithoutDogBreedInput>;
  dogInfos?: InputMaybe<DogInfoUncheckedCreateNestedManyWithoutDogBreedInput>;
  dogType?: InputMaybe<Array<DogType>>;
  educationIndex?: InputMaybe<Scalars['Int']['input']>;
  exerciseIndex?: InputMaybe<Scalars['Int']['input']>;
  fciGroup?: InputMaybe<Scalars['String']['input']>;
  foreignerSociabilityIndex?: InputMaybe<Scalars['Float']['input']>;
  hairLossIndex?: InputMaybe<Scalars['Float']['input']>;
  hairType?: InputMaybe<DogHairType>;
  headShape?: InputMaybe<HeadShape>;
  heatToleranceIndex?: InputMaybe<Scalars['Float']['input']>;
  homeCountryCode?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  imgs?: InputMaybe<DogBreedImgUncheckedCreateNestedManyWithoutDogBreedInput>;
  independenceIndex?: InputMaybe<Scalars['Float']['input']>;
  intellectualActivityNeedIndex?: InputMaybe<Scalars['Float']['input']>;
  isSubBreed?: InputMaybe<Scalars['Boolean']['input']>;
  litters?: InputMaybe<LitterUncheckedCreateNestedManyWithoutDogBreedInput>;
  maintenanceIndex?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  physicalActivityNeedIndex?: InputMaybe<Scalars['Float']['input']>;
  predatoryInstinctIndex?: InputMaybe<Scalars['Float']['input']>;
  puppies?: InputMaybe<DogPuppyUncheckedCreateNestedManyWithoutBreedInput>;
  robustnessIndex?: InputMaybe<Scalars['Int']['input']>;
  sizeCategory?: InputMaybe<AnimalSizeEnum>;
  sociabilityIndex?: InputMaybe<Scalars['Int']['input']>;
  sortingIndex?: InputMaybe<Scalars['Int']['input']>;
  translations?: InputMaybe<DogBreedTranslationUncheckedCreateNestedManyWithoutDogBreedInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  videoUrl?: InputMaybe<Scalars['String']['input']>;
};

export type DogBreedUncheckedCreateWithoutDogBreedersInput = {
  adultSizeAge?: InputMaybe<Scalars['Int']['input']>;
  applications?: InputMaybe<DogBreederApplicationUncheckedCreateNestedManyWithoutBreedPreferenceInput>;
  barkingTendancyIndex?: InputMaybe<Scalars['Float']['input']>;
  baseBreedName?: InputMaybe<Scalars['String']['input']>;
  breedInterestSubscriptions?: InputMaybe<DogBreedInterestSubscriptionUncheckedCreateNestedManyWithoutDogBreedsInput>;
  careIndex?: InputMaybe<Scalars['Int']['input']>;
  coldToleranceIndex?: InputMaybe<Scalars['Float']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dogInfos?: InputMaybe<DogInfoUncheckedCreateNestedManyWithoutDogBreedInput>;
  dogType?: InputMaybe<Array<DogType>>;
  educationIndex?: InputMaybe<Scalars['Int']['input']>;
  exerciseIndex?: InputMaybe<Scalars['Int']['input']>;
  fciGroup?: InputMaybe<Scalars['String']['input']>;
  foreignerSociabilityIndex?: InputMaybe<Scalars['Float']['input']>;
  hairLossIndex?: InputMaybe<Scalars['Float']['input']>;
  hairType?: InputMaybe<DogHairType>;
  headShape?: InputMaybe<HeadShape>;
  heatToleranceIndex?: InputMaybe<Scalars['Float']['input']>;
  homeCountryCode?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  imgs?: InputMaybe<DogBreedImgUncheckedCreateNestedManyWithoutDogBreedInput>;
  independenceIndex?: InputMaybe<Scalars['Float']['input']>;
  intellectualActivityNeedIndex?: InputMaybe<Scalars['Float']['input']>;
  isSubBreed?: InputMaybe<Scalars['Boolean']['input']>;
  litters?: InputMaybe<LitterUncheckedCreateNestedManyWithoutDogBreedInput>;
  maintenanceIndex?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  physicalActivityNeedIndex?: InputMaybe<Scalars['Float']['input']>;
  predatoryInstinctIndex?: InputMaybe<Scalars['Float']['input']>;
  puppies?: InputMaybe<DogPuppyUncheckedCreateNestedManyWithoutBreedInput>;
  robustnessIndex?: InputMaybe<Scalars['Int']['input']>;
  sizeCategory?: InputMaybe<AnimalSizeEnum>;
  sociabilityIndex?: InputMaybe<Scalars['Int']['input']>;
  sortingIndex?: InputMaybe<Scalars['Int']['input']>;
  translations?: InputMaybe<DogBreedTranslationUncheckedCreateNestedManyWithoutDogBreedInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  videoUrl?: InputMaybe<Scalars['String']['input']>;
};

export type DogBreedUncheckedCreateWithoutDogInfosInput = {
  adultSizeAge?: InputMaybe<Scalars['Int']['input']>;
  applications?: InputMaybe<DogBreederApplicationUncheckedCreateNestedManyWithoutBreedPreferenceInput>;
  barkingTendancyIndex?: InputMaybe<Scalars['Float']['input']>;
  baseBreedName?: InputMaybe<Scalars['String']['input']>;
  breedInterestSubscriptions?: InputMaybe<DogBreedInterestSubscriptionUncheckedCreateNestedManyWithoutDogBreedsInput>;
  careIndex?: InputMaybe<Scalars['Int']['input']>;
  coldToleranceIndex?: InputMaybe<Scalars['Float']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dogBreeders?: InputMaybe<DogBreederBreedsUncheckedCreateNestedManyWithoutDogBreedInput>;
  dogType?: InputMaybe<Array<DogType>>;
  educationIndex?: InputMaybe<Scalars['Int']['input']>;
  exerciseIndex?: InputMaybe<Scalars['Int']['input']>;
  fciGroup?: InputMaybe<Scalars['String']['input']>;
  foreignerSociabilityIndex?: InputMaybe<Scalars['Float']['input']>;
  hairLossIndex?: InputMaybe<Scalars['Float']['input']>;
  hairType?: InputMaybe<DogHairType>;
  headShape?: InputMaybe<HeadShape>;
  heatToleranceIndex?: InputMaybe<Scalars['Float']['input']>;
  homeCountryCode?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  imgs?: InputMaybe<DogBreedImgUncheckedCreateNestedManyWithoutDogBreedInput>;
  independenceIndex?: InputMaybe<Scalars['Float']['input']>;
  intellectualActivityNeedIndex?: InputMaybe<Scalars['Float']['input']>;
  isSubBreed?: InputMaybe<Scalars['Boolean']['input']>;
  litters?: InputMaybe<LitterUncheckedCreateNestedManyWithoutDogBreedInput>;
  maintenanceIndex?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  physicalActivityNeedIndex?: InputMaybe<Scalars['Float']['input']>;
  predatoryInstinctIndex?: InputMaybe<Scalars['Float']['input']>;
  puppies?: InputMaybe<DogPuppyUncheckedCreateNestedManyWithoutBreedInput>;
  robustnessIndex?: InputMaybe<Scalars['Int']['input']>;
  sizeCategory?: InputMaybe<AnimalSizeEnum>;
  sociabilityIndex?: InputMaybe<Scalars['Int']['input']>;
  sortingIndex?: InputMaybe<Scalars['Int']['input']>;
  translations?: InputMaybe<DogBreedTranslationUncheckedCreateNestedManyWithoutDogBreedInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  videoUrl?: InputMaybe<Scalars['String']['input']>;
};

export type DogBreedUncheckedCreateWithoutImgsInput = {
  adultSizeAge?: InputMaybe<Scalars['Int']['input']>;
  applications?: InputMaybe<DogBreederApplicationUncheckedCreateNestedManyWithoutBreedPreferenceInput>;
  barkingTendancyIndex?: InputMaybe<Scalars['Float']['input']>;
  baseBreedName?: InputMaybe<Scalars['String']['input']>;
  breedInterestSubscriptions?: InputMaybe<DogBreedInterestSubscriptionUncheckedCreateNestedManyWithoutDogBreedsInput>;
  careIndex?: InputMaybe<Scalars['Int']['input']>;
  coldToleranceIndex?: InputMaybe<Scalars['Float']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dogBreeders?: InputMaybe<DogBreederBreedsUncheckedCreateNestedManyWithoutDogBreedInput>;
  dogInfos?: InputMaybe<DogInfoUncheckedCreateNestedManyWithoutDogBreedInput>;
  dogType?: InputMaybe<Array<DogType>>;
  educationIndex?: InputMaybe<Scalars['Int']['input']>;
  exerciseIndex?: InputMaybe<Scalars['Int']['input']>;
  fciGroup?: InputMaybe<Scalars['String']['input']>;
  foreignerSociabilityIndex?: InputMaybe<Scalars['Float']['input']>;
  hairLossIndex?: InputMaybe<Scalars['Float']['input']>;
  hairType?: InputMaybe<DogHairType>;
  headShape?: InputMaybe<HeadShape>;
  heatToleranceIndex?: InputMaybe<Scalars['Float']['input']>;
  homeCountryCode?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  independenceIndex?: InputMaybe<Scalars['Float']['input']>;
  intellectualActivityNeedIndex?: InputMaybe<Scalars['Float']['input']>;
  isSubBreed?: InputMaybe<Scalars['Boolean']['input']>;
  litters?: InputMaybe<LitterUncheckedCreateNestedManyWithoutDogBreedInput>;
  maintenanceIndex?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  physicalActivityNeedIndex?: InputMaybe<Scalars['Float']['input']>;
  predatoryInstinctIndex?: InputMaybe<Scalars['Float']['input']>;
  puppies?: InputMaybe<DogPuppyUncheckedCreateNestedManyWithoutBreedInput>;
  robustnessIndex?: InputMaybe<Scalars['Int']['input']>;
  sizeCategory?: InputMaybe<AnimalSizeEnum>;
  sociabilityIndex?: InputMaybe<Scalars['Int']['input']>;
  sortingIndex?: InputMaybe<Scalars['Int']['input']>;
  translations?: InputMaybe<DogBreedTranslationUncheckedCreateNestedManyWithoutDogBreedInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  videoUrl?: InputMaybe<Scalars['String']['input']>;
};

export type DogBreedUncheckedCreateWithoutLittersInput = {
  adultSizeAge?: InputMaybe<Scalars['Int']['input']>;
  applications?: InputMaybe<DogBreederApplicationUncheckedCreateNestedManyWithoutBreedPreferenceInput>;
  barkingTendancyIndex?: InputMaybe<Scalars['Float']['input']>;
  baseBreedName?: InputMaybe<Scalars['String']['input']>;
  breedInterestSubscriptions?: InputMaybe<DogBreedInterestSubscriptionUncheckedCreateNestedManyWithoutDogBreedsInput>;
  careIndex?: InputMaybe<Scalars['Int']['input']>;
  coldToleranceIndex?: InputMaybe<Scalars['Float']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dogBreeders?: InputMaybe<DogBreederBreedsUncheckedCreateNestedManyWithoutDogBreedInput>;
  dogInfos?: InputMaybe<DogInfoUncheckedCreateNestedManyWithoutDogBreedInput>;
  dogType?: InputMaybe<Array<DogType>>;
  educationIndex?: InputMaybe<Scalars['Int']['input']>;
  exerciseIndex?: InputMaybe<Scalars['Int']['input']>;
  fciGroup?: InputMaybe<Scalars['String']['input']>;
  foreignerSociabilityIndex?: InputMaybe<Scalars['Float']['input']>;
  hairLossIndex?: InputMaybe<Scalars['Float']['input']>;
  hairType?: InputMaybe<DogHairType>;
  headShape?: InputMaybe<HeadShape>;
  heatToleranceIndex?: InputMaybe<Scalars['Float']['input']>;
  homeCountryCode?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  imgs?: InputMaybe<DogBreedImgUncheckedCreateNestedManyWithoutDogBreedInput>;
  independenceIndex?: InputMaybe<Scalars['Float']['input']>;
  intellectualActivityNeedIndex?: InputMaybe<Scalars['Float']['input']>;
  isSubBreed?: InputMaybe<Scalars['Boolean']['input']>;
  maintenanceIndex?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  physicalActivityNeedIndex?: InputMaybe<Scalars['Float']['input']>;
  predatoryInstinctIndex?: InputMaybe<Scalars['Float']['input']>;
  puppies?: InputMaybe<DogPuppyUncheckedCreateNestedManyWithoutBreedInput>;
  robustnessIndex?: InputMaybe<Scalars['Int']['input']>;
  sizeCategory?: InputMaybe<AnimalSizeEnum>;
  sociabilityIndex?: InputMaybe<Scalars['Int']['input']>;
  sortingIndex?: InputMaybe<Scalars['Int']['input']>;
  translations?: InputMaybe<DogBreedTranslationUncheckedCreateNestedManyWithoutDogBreedInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  videoUrl?: InputMaybe<Scalars['String']['input']>;
};

export type DogBreedUncheckedCreateWithoutPuppiesInput = {
  adultSizeAge?: InputMaybe<Scalars['Int']['input']>;
  applications?: InputMaybe<DogBreederApplicationUncheckedCreateNestedManyWithoutBreedPreferenceInput>;
  barkingTendancyIndex?: InputMaybe<Scalars['Float']['input']>;
  baseBreedName?: InputMaybe<Scalars['String']['input']>;
  breedInterestSubscriptions?: InputMaybe<DogBreedInterestSubscriptionUncheckedCreateNestedManyWithoutDogBreedsInput>;
  careIndex?: InputMaybe<Scalars['Int']['input']>;
  coldToleranceIndex?: InputMaybe<Scalars['Float']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dogBreeders?: InputMaybe<DogBreederBreedsUncheckedCreateNestedManyWithoutDogBreedInput>;
  dogInfos?: InputMaybe<DogInfoUncheckedCreateNestedManyWithoutDogBreedInput>;
  dogType?: InputMaybe<Array<DogType>>;
  educationIndex?: InputMaybe<Scalars['Int']['input']>;
  exerciseIndex?: InputMaybe<Scalars['Int']['input']>;
  fciGroup?: InputMaybe<Scalars['String']['input']>;
  foreignerSociabilityIndex?: InputMaybe<Scalars['Float']['input']>;
  hairLossIndex?: InputMaybe<Scalars['Float']['input']>;
  hairType?: InputMaybe<DogHairType>;
  headShape?: InputMaybe<HeadShape>;
  heatToleranceIndex?: InputMaybe<Scalars['Float']['input']>;
  homeCountryCode?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  imgs?: InputMaybe<DogBreedImgUncheckedCreateNestedManyWithoutDogBreedInput>;
  independenceIndex?: InputMaybe<Scalars['Float']['input']>;
  intellectualActivityNeedIndex?: InputMaybe<Scalars['Float']['input']>;
  isSubBreed?: InputMaybe<Scalars['Boolean']['input']>;
  litters?: InputMaybe<LitterUncheckedCreateNestedManyWithoutDogBreedInput>;
  maintenanceIndex?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  physicalActivityNeedIndex?: InputMaybe<Scalars['Float']['input']>;
  predatoryInstinctIndex?: InputMaybe<Scalars['Float']['input']>;
  robustnessIndex?: InputMaybe<Scalars['Int']['input']>;
  sizeCategory?: InputMaybe<AnimalSizeEnum>;
  sociabilityIndex?: InputMaybe<Scalars['Int']['input']>;
  sortingIndex?: InputMaybe<Scalars['Int']['input']>;
  translations?: InputMaybe<DogBreedTranslationUncheckedCreateNestedManyWithoutDogBreedInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  videoUrl?: InputMaybe<Scalars['String']['input']>;
};

export type DogBreedUncheckedCreateWithoutTranslationsInput = {
  adultSizeAge?: InputMaybe<Scalars['Int']['input']>;
  applications?: InputMaybe<DogBreederApplicationUncheckedCreateNestedManyWithoutBreedPreferenceInput>;
  barkingTendancyIndex?: InputMaybe<Scalars['Float']['input']>;
  baseBreedName?: InputMaybe<Scalars['String']['input']>;
  breedInterestSubscriptions?: InputMaybe<DogBreedInterestSubscriptionUncheckedCreateNestedManyWithoutDogBreedsInput>;
  careIndex?: InputMaybe<Scalars['Int']['input']>;
  coldToleranceIndex?: InputMaybe<Scalars['Float']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dogBreeders?: InputMaybe<DogBreederBreedsUncheckedCreateNestedManyWithoutDogBreedInput>;
  dogInfos?: InputMaybe<DogInfoUncheckedCreateNestedManyWithoutDogBreedInput>;
  dogType?: InputMaybe<Array<DogType>>;
  educationIndex?: InputMaybe<Scalars['Int']['input']>;
  exerciseIndex?: InputMaybe<Scalars['Int']['input']>;
  fciGroup?: InputMaybe<Scalars['String']['input']>;
  foreignerSociabilityIndex?: InputMaybe<Scalars['Float']['input']>;
  hairLossIndex?: InputMaybe<Scalars['Float']['input']>;
  hairType?: InputMaybe<DogHairType>;
  headShape?: InputMaybe<HeadShape>;
  heatToleranceIndex?: InputMaybe<Scalars['Float']['input']>;
  homeCountryCode?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  imgs?: InputMaybe<DogBreedImgUncheckedCreateNestedManyWithoutDogBreedInput>;
  independenceIndex?: InputMaybe<Scalars['Float']['input']>;
  intellectualActivityNeedIndex?: InputMaybe<Scalars['Float']['input']>;
  isSubBreed?: InputMaybe<Scalars['Boolean']['input']>;
  litters?: InputMaybe<LitterUncheckedCreateNestedManyWithoutDogBreedInput>;
  maintenanceIndex?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  physicalActivityNeedIndex?: InputMaybe<Scalars['Float']['input']>;
  predatoryInstinctIndex?: InputMaybe<Scalars['Float']['input']>;
  puppies?: InputMaybe<DogPuppyUncheckedCreateNestedManyWithoutBreedInput>;
  robustnessIndex?: InputMaybe<Scalars['Int']['input']>;
  sizeCategory?: InputMaybe<AnimalSizeEnum>;
  sociabilityIndex?: InputMaybe<Scalars['Int']['input']>;
  sortingIndex?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  videoUrl?: InputMaybe<Scalars['String']['input']>;
};

export type DogBreedUncheckedUpdateInput = {
  adultSizeAge?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  applications?: InputMaybe<DogBreederApplicationUncheckedUpdateManyWithoutBreedPreferenceNestedInput>;
  barkingTendancyIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  baseBreedName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  breedInterestSubscriptions?: InputMaybe<DogBreedInterestSubscriptionUncheckedUpdateManyWithoutDogBreedsNestedInput>;
  careIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  coldToleranceIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dogBreeders?: InputMaybe<DogBreederBreedsUncheckedUpdateManyWithoutDogBreedNestedInput>;
  dogInfos?: InputMaybe<DogInfoUncheckedUpdateManyWithoutDogBreedNestedInput>;
  dogType?: InputMaybe<Array<DogType>>;
  educationIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  exerciseIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  fciGroup?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  foreignerSociabilityIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  hairLossIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  hairType?: InputMaybe<NullableEnumDogHairTypeFieldUpdateOperationsInput>;
  headShape?: InputMaybe<NullableEnumHeadShapeFieldUpdateOperationsInput>;
  heatToleranceIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  homeCountryCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  imgs?: InputMaybe<DogBreedImgUncheckedUpdateManyWithoutDogBreedNestedInput>;
  independenceIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  intellectualActivityNeedIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  isSubBreed?: InputMaybe<BoolFieldUpdateOperationsInput>;
  litters?: InputMaybe<LitterUncheckedUpdateManyWithoutDogBreedNestedInput>;
  maintenanceIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  physicalActivityNeedIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  predatoryInstinctIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  puppies?: InputMaybe<DogPuppyUncheckedUpdateManyWithoutBreedNestedInput>;
  robustnessIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  sizeCategory?: InputMaybe<NullableEnumAnimalSizeEnumFieldUpdateOperationsInput>;
  sociabilityIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  sortingIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  translations?: InputMaybe<DogBreedTranslationUncheckedUpdateManyWithoutDogBreedNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  videoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type DogBreedUncheckedUpdateManyInput = {
  adultSizeAge?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  barkingTendancyIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  baseBreedName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  careIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  coldToleranceIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dogType?: InputMaybe<Array<DogType>>;
  educationIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  exerciseIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  fciGroup?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  foreignerSociabilityIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  hairLossIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  hairType?: InputMaybe<NullableEnumDogHairTypeFieldUpdateOperationsInput>;
  headShape?: InputMaybe<NullableEnumHeadShapeFieldUpdateOperationsInput>;
  heatToleranceIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  homeCountryCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  independenceIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  intellectualActivityNeedIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  isSubBreed?: InputMaybe<BoolFieldUpdateOperationsInput>;
  maintenanceIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  physicalActivityNeedIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  predatoryInstinctIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  robustnessIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  sizeCategory?: InputMaybe<NullableEnumAnimalSizeEnumFieldUpdateOperationsInput>;
  sociabilityIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  sortingIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  videoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type DogBreedUncheckedUpdateManyWithoutBreedInterestSubscriptionsInput = {
  adultSizeAge?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  barkingTendancyIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  baseBreedName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  careIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  coldToleranceIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dogType?: InputMaybe<Array<DogType>>;
  educationIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  exerciseIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  fciGroup?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  foreignerSociabilityIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  hairLossIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  hairType?: InputMaybe<NullableEnumDogHairTypeFieldUpdateOperationsInput>;
  headShape?: InputMaybe<NullableEnumHeadShapeFieldUpdateOperationsInput>;
  heatToleranceIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  homeCountryCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  independenceIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  intellectualActivityNeedIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  isSubBreed?: InputMaybe<BoolFieldUpdateOperationsInput>;
  maintenanceIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  physicalActivityNeedIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  predatoryInstinctIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  robustnessIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  sizeCategory?: InputMaybe<NullableEnumAnimalSizeEnumFieldUpdateOperationsInput>;
  sociabilityIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  sortingIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  videoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type DogBreedUncheckedUpdateManyWithoutBreedInterestSubscriptionsNestedInput = {
  connect?: InputMaybe<Array<DogBreedWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DogBreedCreateOrConnectWithoutBreedInterestSubscriptionsInput>>;
  create?: InputMaybe<Array<DogBreedCreateWithoutBreedInterestSubscriptionsInput>>;
  delete?: InputMaybe<Array<DogBreedWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<DogBreedScalarWhereInput>>;
  disconnect?: InputMaybe<Array<DogBreedWhereUniqueInput>>;
  set?: InputMaybe<Array<DogBreedWhereUniqueInput>>;
  update?: InputMaybe<Array<DogBreedUpdateWithWhereUniqueWithoutBreedInterestSubscriptionsInput>>;
  updateMany?: InputMaybe<Array<DogBreedUpdateManyWithWhereWithoutBreedInterestSubscriptionsInput>>;
  upsert?: InputMaybe<Array<DogBreedUpsertWithWhereUniqueWithoutBreedInterestSubscriptionsInput>>;
};

export type DogBreedUncheckedUpdateWithoutApplicationsInput = {
  adultSizeAge?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  barkingTendancyIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  baseBreedName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  breedInterestSubscriptions?: InputMaybe<DogBreedInterestSubscriptionUncheckedUpdateManyWithoutDogBreedsNestedInput>;
  careIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  coldToleranceIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dogBreeders?: InputMaybe<DogBreederBreedsUncheckedUpdateManyWithoutDogBreedNestedInput>;
  dogInfos?: InputMaybe<DogInfoUncheckedUpdateManyWithoutDogBreedNestedInput>;
  dogType?: InputMaybe<Array<DogType>>;
  educationIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  exerciseIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  fciGroup?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  foreignerSociabilityIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  hairLossIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  hairType?: InputMaybe<NullableEnumDogHairTypeFieldUpdateOperationsInput>;
  headShape?: InputMaybe<NullableEnumHeadShapeFieldUpdateOperationsInput>;
  heatToleranceIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  homeCountryCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  imgs?: InputMaybe<DogBreedImgUncheckedUpdateManyWithoutDogBreedNestedInput>;
  independenceIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  intellectualActivityNeedIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  isSubBreed?: InputMaybe<BoolFieldUpdateOperationsInput>;
  litters?: InputMaybe<LitterUncheckedUpdateManyWithoutDogBreedNestedInput>;
  maintenanceIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  physicalActivityNeedIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  predatoryInstinctIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  puppies?: InputMaybe<DogPuppyUncheckedUpdateManyWithoutBreedNestedInput>;
  robustnessIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  sizeCategory?: InputMaybe<NullableEnumAnimalSizeEnumFieldUpdateOperationsInput>;
  sociabilityIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  sortingIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  translations?: InputMaybe<DogBreedTranslationUncheckedUpdateManyWithoutDogBreedNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  videoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type DogBreedUncheckedUpdateWithoutBreedInterestSubscriptionsInput = {
  adultSizeAge?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  applications?: InputMaybe<DogBreederApplicationUncheckedUpdateManyWithoutBreedPreferenceNestedInput>;
  barkingTendancyIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  baseBreedName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  careIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  coldToleranceIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dogBreeders?: InputMaybe<DogBreederBreedsUncheckedUpdateManyWithoutDogBreedNestedInput>;
  dogInfos?: InputMaybe<DogInfoUncheckedUpdateManyWithoutDogBreedNestedInput>;
  dogType?: InputMaybe<Array<DogType>>;
  educationIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  exerciseIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  fciGroup?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  foreignerSociabilityIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  hairLossIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  hairType?: InputMaybe<NullableEnumDogHairTypeFieldUpdateOperationsInput>;
  headShape?: InputMaybe<NullableEnumHeadShapeFieldUpdateOperationsInput>;
  heatToleranceIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  homeCountryCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  imgs?: InputMaybe<DogBreedImgUncheckedUpdateManyWithoutDogBreedNestedInput>;
  independenceIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  intellectualActivityNeedIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  isSubBreed?: InputMaybe<BoolFieldUpdateOperationsInput>;
  litters?: InputMaybe<LitterUncheckedUpdateManyWithoutDogBreedNestedInput>;
  maintenanceIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  physicalActivityNeedIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  predatoryInstinctIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  puppies?: InputMaybe<DogPuppyUncheckedUpdateManyWithoutBreedNestedInput>;
  robustnessIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  sizeCategory?: InputMaybe<NullableEnumAnimalSizeEnumFieldUpdateOperationsInput>;
  sociabilityIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  sortingIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  translations?: InputMaybe<DogBreedTranslationUncheckedUpdateManyWithoutDogBreedNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  videoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type DogBreedUncheckedUpdateWithoutDogBreedersInput = {
  adultSizeAge?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  applications?: InputMaybe<DogBreederApplicationUncheckedUpdateManyWithoutBreedPreferenceNestedInput>;
  barkingTendancyIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  baseBreedName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  breedInterestSubscriptions?: InputMaybe<DogBreedInterestSubscriptionUncheckedUpdateManyWithoutDogBreedsNestedInput>;
  careIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  coldToleranceIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dogInfos?: InputMaybe<DogInfoUncheckedUpdateManyWithoutDogBreedNestedInput>;
  dogType?: InputMaybe<Array<DogType>>;
  educationIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  exerciseIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  fciGroup?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  foreignerSociabilityIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  hairLossIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  hairType?: InputMaybe<NullableEnumDogHairTypeFieldUpdateOperationsInput>;
  headShape?: InputMaybe<NullableEnumHeadShapeFieldUpdateOperationsInput>;
  heatToleranceIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  homeCountryCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  imgs?: InputMaybe<DogBreedImgUncheckedUpdateManyWithoutDogBreedNestedInput>;
  independenceIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  intellectualActivityNeedIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  isSubBreed?: InputMaybe<BoolFieldUpdateOperationsInput>;
  litters?: InputMaybe<LitterUncheckedUpdateManyWithoutDogBreedNestedInput>;
  maintenanceIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  physicalActivityNeedIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  predatoryInstinctIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  puppies?: InputMaybe<DogPuppyUncheckedUpdateManyWithoutBreedNestedInput>;
  robustnessIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  sizeCategory?: InputMaybe<NullableEnumAnimalSizeEnumFieldUpdateOperationsInput>;
  sociabilityIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  sortingIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  translations?: InputMaybe<DogBreedTranslationUncheckedUpdateManyWithoutDogBreedNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  videoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type DogBreedUncheckedUpdateWithoutDogInfosInput = {
  adultSizeAge?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  applications?: InputMaybe<DogBreederApplicationUncheckedUpdateManyWithoutBreedPreferenceNestedInput>;
  barkingTendancyIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  baseBreedName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  breedInterestSubscriptions?: InputMaybe<DogBreedInterestSubscriptionUncheckedUpdateManyWithoutDogBreedsNestedInput>;
  careIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  coldToleranceIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dogBreeders?: InputMaybe<DogBreederBreedsUncheckedUpdateManyWithoutDogBreedNestedInput>;
  dogType?: InputMaybe<Array<DogType>>;
  educationIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  exerciseIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  fciGroup?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  foreignerSociabilityIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  hairLossIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  hairType?: InputMaybe<NullableEnumDogHairTypeFieldUpdateOperationsInput>;
  headShape?: InputMaybe<NullableEnumHeadShapeFieldUpdateOperationsInput>;
  heatToleranceIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  homeCountryCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  imgs?: InputMaybe<DogBreedImgUncheckedUpdateManyWithoutDogBreedNestedInput>;
  independenceIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  intellectualActivityNeedIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  isSubBreed?: InputMaybe<BoolFieldUpdateOperationsInput>;
  litters?: InputMaybe<LitterUncheckedUpdateManyWithoutDogBreedNestedInput>;
  maintenanceIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  physicalActivityNeedIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  predatoryInstinctIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  puppies?: InputMaybe<DogPuppyUncheckedUpdateManyWithoutBreedNestedInput>;
  robustnessIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  sizeCategory?: InputMaybe<NullableEnumAnimalSizeEnumFieldUpdateOperationsInput>;
  sociabilityIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  sortingIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  translations?: InputMaybe<DogBreedTranslationUncheckedUpdateManyWithoutDogBreedNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  videoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type DogBreedUncheckedUpdateWithoutImgsInput = {
  adultSizeAge?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  applications?: InputMaybe<DogBreederApplicationUncheckedUpdateManyWithoutBreedPreferenceNestedInput>;
  barkingTendancyIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  baseBreedName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  breedInterestSubscriptions?: InputMaybe<DogBreedInterestSubscriptionUncheckedUpdateManyWithoutDogBreedsNestedInput>;
  careIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  coldToleranceIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dogBreeders?: InputMaybe<DogBreederBreedsUncheckedUpdateManyWithoutDogBreedNestedInput>;
  dogInfos?: InputMaybe<DogInfoUncheckedUpdateManyWithoutDogBreedNestedInput>;
  dogType?: InputMaybe<Array<DogType>>;
  educationIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  exerciseIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  fciGroup?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  foreignerSociabilityIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  hairLossIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  hairType?: InputMaybe<NullableEnumDogHairTypeFieldUpdateOperationsInput>;
  headShape?: InputMaybe<NullableEnumHeadShapeFieldUpdateOperationsInput>;
  heatToleranceIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  homeCountryCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  independenceIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  intellectualActivityNeedIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  isSubBreed?: InputMaybe<BoolFieldUpdateOperationsInput>;
  litters?: InputMaybe<LitterUncheckedUpdateManyWithoutDogBreedNestedInput>;
  maintenanceIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  physicalActivityNeedIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  predatoryInstinctIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  puppies?: InputMaybe<DogPuppyUncheckedUpdateManyWithoutBreedNestedInput>;
  robustnessIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  sizeCategory?: InputMaybe<NullableEnumAnimalSizeEnumFieldUpdateOperationsInput>;
  sociabilityIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  sortingIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  translations?: InputMaybe<DogBreedTranslationUncheckedUpdateManyWithoutDogBreedNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  videoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type DogBreedUncheckedUpdateWithoutLittersInput = {
  adultSizeAge?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  applications?: InputMaybe<DogBreederApplicationUncheckedUpdateManyWithoutBreedPreferenceNestedInput>;
  barkingTendancyIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  baseBreedName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  breedInterestSubscriptions?: InputMaybe<DogBreedInterestSubscriptionUncheckedUpdateManyWithoutDogBreedsNestedInput>;
  careIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  coldToleranceIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dogBreeders?: InputMaybe<DogBreederBreedsUncheckedUpdateManyWithoutDogBreedNestedInput>;
  dogInfos?: InputMaybe<DogInfoUncheckedUpdateManyWithoutDogBreedNestedInput>;
  dogType?: InputMaybe<Array<DogType>>;
  educationIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  exerciseIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  fciGroup?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  foreignerSociabilityIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  hairLossIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  hairType?: InputMaybe<NullableEnumDogHairTypeFieldUpdateOperationsInput>;
  headShape?: InputMaybe<NullableEnumHeadShapeFieldUpdateOperationsInput>;
  heatToleranceIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  homeCountryCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  imgs?: InputMaybe<DogBreedImgUncheckedUpdateManyWithoutDogBreedNestedInput>;
  independenceIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  intellectualActivityNeedIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  isSubBreed?: InputMaybe<BoolFieldUpdateOperationsInput>;
  maintenanceIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  physicalActivityNeedIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  predatoryInstinctIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  puppies?: InputMaybe<DogPuppyUncheckedUpdateManyWithoutBreedNestedInput>;
  robustnessIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  sizeCategory?: InputMaybe<NullableEnumAnimalSizeEnumFieldUpdateOperationsInput>;
  sociabilityIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  sortingIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  translations?: InputMaybe<DogBreedTranslationUncheckedUpdateManyWithoutDogBreedNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  videoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type DogBreedUncheckedUpdateWithoutPuppiesInput = {
  adultSizeAge?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  applications?: InputMaybe<DogBreederApplicationUncheckedUpdateManyWithoutBreedPreferenceNestedInput>;
  barkingTendancyIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  baseBreedName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  breedInterestSubscriptions?: InputMaybe<DogBreedInterestSubscriptionUncheckedUpdateManyWithoutDogBreedsNestedInput>;
  careIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  coldToleranceIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dogBreeders?: InputMaybe<DogBreederBreedsUncheckedUpdateManyWithoutDogBreedNestedInput>;
  dogInfos?: InputMaybe<DogInfoUncheckedUpdateManyWithoutDogBreedNestedInput>;
  dogType?: InputMaybe<Array<DogType>>;
  educationIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  exerciseIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  fciGroup?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  foreignerSociabilityIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  hairLossIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  hairType?: InputMaybe<NullableEnumDogHairTypeFieldUpdateOperationsInput>;
  headShape?: InputMaybe<NullableEnumHeadShapeFieldUpdateOperationsInput>;
  heatToleranceIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  homeCountryCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  imgs?: InputMaybe<DogBreedImgUncheckedUpdateManyWithoutDogBreedNestedInput>;
  independenceIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  intellectualActivityNeedIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  isSubBreed?: InputMaybe<BoolFieldUpdateOperationsInput>;
  litters?: InputMaybe<LitterUncheckedUpdateManyWithoutDogBreedNestedInput>;
  maintenanceIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  physicalActivityNeedIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  predatoryInstinctIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  robustnessIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  sizeCategory?: InputMaybe<NullableEnumAnimalSizeEnumFieldUpdateOperationsInput>;
  sociabilityIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  sortingIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  translations?: InputMaybe<DogBreedTranslationUncheckedUpdateManyWithoutDogBreedNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  videoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type DogBreedUncheckedUpdateWithoutTranslationsInput = {
  adultSizeAge?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  applications?: InputMaybe<DogBreederApplicationUncheckedUpdateManyWithoutBreedPreferenceNestedInput>;
  barkingTendancyIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  baseBreedName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  breedInterestSubscriptions?: InputMaybe<DogBreedInterestSubscriptionUncheckedUpdateManyWithoutDogBreedsNestedInput>;
  careIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  coldToleranceIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dogBreeders?: InputMaybe<DogBreederBreedsUncheckedUpdateManyWithoutDogBreedNestedInput>;
  dogInfos?: InputMaybe<DogInfoUncheckedUpdateManyWithoutDogBreedNestedInput>;
  dogType?: InputMaybe<Array<DogType>>;
  educationIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  exerciseIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  fciGroup?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  foreignerSociabilityIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  hairLossIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  hairType?: InputMaybe<NullableEnumDogHairTypeFieldUpdateOperationsInput>;
  headShape?: InputMaybe<NullableEnumHeadShapeFieldUpdateOperationsInput>;
  heatToleranceIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  homeCountryCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  imgs?: InputMaybe<DogBreedImgUncheckedUpdateManyWithoutDogBreedNestedInput>;
  independenceIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  intellectualActivityNeedIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  isSubBreed?: InputMaybe<BoolFieldUpdateOperationsInput>;
  litters?: InputMaybe<LitterUncheckedUpdateManyWithoutDogBreedNestedInput>;
  maintenanceIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  physicalActivityNeedIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  predatoryInstinctIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  puppies?: InputMaybe<DogPuppyUncheckedUpdateManyWithoutBreedNestedInput>;
  robustnessIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  sizeCategory?: InputMaybe<NullableEnumAnimalSizeEnumFieldUpdateOperationsInput>;
  sociabilityIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  sortingIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  videoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type DogBreedUpdateInput = {
  adultSizeAge?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  applications?: InputMaybe<DogBreederApplicationUpdateManyWithoutBreedPreferenceNestedInput>;
  barkingTendancyIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  baseBreedName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  breedInterestSubscriptions?: InputMaybe<DogBreedInterestSubscriptionUpdateManyWithoutDogBreedsNestedInput>;
  careIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  coldToleranceIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dogBreeders?: InputMaybe<DogBreederBreedsUpdateManyWithoutDogBreedNestedInput>;
  dogInfos?: InputMaybe<DogInfoUpdateManyWithoutDogBreedNestedInput>;
  dogType?: InputMaybe<Array<DogType>>;
  educationIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  exerciseIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  fciGroup?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  foreignerSociabilityIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  hairLossIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  hairType?: InputMaybe<NullableEnumDogHairTypeFieldUpdateOperationsInput>;
  headShape?: InputMaybe<NullableEnumHeadShapeFieldUpdateOperationsInput>;
  heatToleranceIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  homeCountryCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  imgs?: InputMaybe<DogBreedImgUpdateManyWithoutDogBreedNestedInput>;
  independenceIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  intellectualActivityNeedIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  isSubBreed?: InputMaybe<BoolFieldUpdateOperationsInput>;
  litters?: InputMaybe<LitterUpdateManyWithoutDogBreedNestedInput>;
  maintenanceIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  physicalActivityNeedIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  predatoryInstinctIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  puppies?: InputMaybe<DogPuppyUpdateManyWithoutBreedNestedInput>;
  robustnessIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  sizeCategory?: InputMaybe<NullableEnumAnimalSizeEnumFieldUpdateOperationsInput>;
  sociabilityIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  sortingIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  translations?: InputMaybe<DogBreedTranslationUpdateManyWithoutDogBreedNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  videoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type DogBreedUpdateManyMutationInput = {
  adultSizeAge?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  barkingTendancyIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  baseBreedName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  careIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  coldToleranceIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dogType?: InputMaybe<Array<DogType>>;
  educationIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  exerciseIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  fciGroup?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  foreignerSociabilityIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  hairLossIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  hairType?: InputMaybe<NullableEnumDogHairTypeFieldUpdateOperationsInput>;
  headShape?: InputMaybe<NullableEnumHeadShapeFieldUpdateOperationsInput>;
  heatToleranceIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  homeCountryCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  independenceIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  intellectualActivityNeedIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  isSubBreed?: InputMaybe<BoolFieldUpdateOperationsInput>;
  maintenanceIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  physicalActivityNeedIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  predatoryInstinctIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  robustnessIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  sizeCategory?: InputMaybe<NullableEnumAnimalSizeEnumFieldUpdateOperationsInput>;
  sociabilityIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  sortingIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  videoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type DogBreedUpdateManyWithWhereWithoutBreedInterestSubscriptionsInput = {
  data: DogBreedUpdateManyMutationInput;
  where: DogBreedScalarWhereInput;
};

export type DogBreedUpdateManyWithoutBreedInterestSubscriptionsNestedInput = {
  connect?: InputMaybe<Array<DogBreedWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DogBreedCreateOrConnectWithoutBreedInterestSubscriptionsInput>>;
  create?: InputMaybe<Array<DogBreedCreateWithoutBreedInterestSubscriptionsInput>>;
  delete?: InputMaybe<Array<DogBreedWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<DogBreedScalarWhereInput>>;
  disconnect?: InputMaybe<Array<DogBreedWhereUniqueInput>>;
  set?: InputMaybe<Array<DogBreedWhereUniqueInput>>;
  update?: InputMaybe<Array<DogBreedUpdateWithWhereUniqueWithoutBreedInterestSubscriptionsInput>>;
  updateMany?: InputMaybe<Array<DogBreedUpdateManyWithWhereWithoutBreedInterestSubscriptionsInput>>;
  upsert?: InputMaybe<Array<DogBreedUpsertWithWhereUniqueWithoutBreedInterestSubscriptionsInput>>;
};

export type DogBreedUpdateOneRequiredWithoutApplicationsNestedInput = {
  connect?: InputMaybe<DogBreedWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DogBreedCreateOrConnectWithoutApplicationsInput>;
  create?: InputMaybe<DogBreedCreateWithoutApplicationsInput>;
  update?: InputMaybe<DogBreedUpdateToOneWithWhereWithoutApplicationsInput>;
  upsert?: InputMaybe<DogBreedUpsertWithoutApplicationsInput>;
};

export type DogBreedUpdateOneRequiredWithoutDogBreedersNestedInput = {
  connect?: InputMaybe<DogBreedWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DogBreedCreateOrConnectWithoutDogBreedersInput>;
  create?: InputMaybe<DogBreedCreateWithoutDogBreedersInput>;
  update?: InputMaybe<DogBreedUpdateToOneWithWhereWithoutDogBreedersInput>;
  upsert?: InputMaybe<DogBreedUpsertWithoutDogBreedersInput>;
};

export type DogBreedUpdateOneRequiredWithoutImgsNestedInput = {
  connect?: InputMaybe<DogBreedWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DogBreedCreateOrConnectWithoutImgsInput>;
  create?: InputMaybe<DogBreedCreateWithoutImgsInput>;
  update?: InputMaybe<DogBreedUpdateToOneWithWhereWithoutImgsInput>;
  upsert?: InputMaybe<DogBreedUpsertWithoutImgsInput>;
};

export type DogBreedUpdateOneRequiredWithoutPuppiesNestedInput = {
  connect?: InputMaybe<DogBreedWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DogBreedCreateOrConnectWithoutPuppiesInput>;
  create?: InputMaybe<DogBreedCreateWithoutPuppiesInput>;
  update?: InputMaybe<DogBreedUpdateToOneWithWhereWithoutPuppiesInput>;
  upsert?: InputMaybe<DogBreedUpsertWithoutPuppiesInput>;
};

export type DogBreedUpdateOneRequiredWithoutTranslationsNestedInput = {
  connect?: InputMaybe<DogBreedWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DogBreedCreateOrConnectWithoutTranslationsInput>;
  create?: InputMaybe<DogBreedCreateWithoutTranslationsInput>;
  update?: InputMaybe<DogBreedUpdateToOneWithWhereWithoutTranslationsInput>;
  upsert?: InputMaybe<DogBreedUpsertWithoutTranslationsInput>;
};

export type DogBreedUpdateOneWithoutDogInfosNestedInput = {
  connect?: InputMaybe<DogBreedWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DogBreedCreateOrConnectWithoutDogInfosInput>;
  create?: InputMaybe<DogBreedCreateWithoutDogInfosInput>;
  delete?: InputMaybe<DogBreedWhereInput>;
  disconnect?: InputMaybe<DogBreedWhereInput>;
  update?: InputMaybe<DogBreedUpdateToOneWithWhereWithoutDogInfosInput>;
  upsert?: InputMaybe<DogBreedUpsertWithoutDogInfosInput>;
};

export type DogBreedUpdateOneWithoutLittersNestedInput = {
  connect?: InputMaybe<DogBreedWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DogBreedCreateOrConnectWithoutLittersInput>;
  create?: InputMaybe<DogBreedCreateWithoutLittersInput>;
  delete?: InputMaybe<DogBreedWhereInput>;
  disconnect?: InputMaybe<DogBreedWhereInput>;
  update?: InputMaybe<DogBreedUpdateToOneWithWhereWithoutLittersInput>;
  upsert?: InputMaybe<DogBreedUpsertWithoutLittersInput>;
};

export type DogBreedUpdateToOneWithWhereWithoutApplicationsInput = {
  data: DogBreedUpdateWithoutApplicationsInput;
  where?: InputMaybe<DogBreedWhereInput>;
};

export type DogBreedUpdateToOneWithWhereWithoutDogBreedersInput = {
  data: DogBreedUpdateWithoutDogBreedersInput;
  where?: InputMaybe<DogBreedWhereInput>;
};

export type DogBreedUpdateToOneWithWhereWithoutDogInfosInput = {
  data: DogBreedUpdateWithoutDogInfosInput;
  where?: InputMaybe<DogBreedWhereInput>;
};

export type DogBreedUpdateToOneWithWhereWithoutImgsInput = {
  data: DogBreedUpdateWithoutImgsInput;
  where?: InputMaybe<DogBreedWhereInput>;
};

export type DogBreedUpdateToOneWithWhereWithoutLittersInput = {
  data: DogBreedUpdateWithoutLittersInput;
  where?: InputMaybe<DogBreedWhereInput>;
};

export type DogBreedUpdateToOneWithWhereWithoutPuppiesInput = {
  data: DogBreedUpdateWithoutPuppiesInput;
  where?: InputMaybe<DogBreedWhereInput>;
};

export type DogBreedUpdateToOneWithWhereWithoutTranslationsInput = {
  data: DogBreedUpdateWithoutTranslationsInput;
  where?: InputMaybe<DogBreedWhereInput>;
};

export type DogBreedUpdateWithWhereUniqueWithoutBreedInterestSubscriptionsInput = {
  data: DogBreedUpdateWithoutBreedInterestSubscriptionsInput;
  where: DogBreedWhereUniqueInput;
};

export type DogBreedUpdateWithoutApplicationsInput = {
  adultSizeAge?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  barkingTendancyIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  baseBreedName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  breedInterestSubscriptions?: InputMaybe<DogBreedInterestSubscriptionUpdateManyWithoutDogBreedsNestedInput>;
  careIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  coldToleranceIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dogBreeders?: InputMaybe<DogBreederBreedsUpdateManyWithoutDogBreedNestedInput>;
  dogInfos?: InputMaybe<DogInfoUpdateManyWithoutDogBreedNestedInput>;
  dogType?: InputMaybe<Array<DogType>>;
  educationIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  exerciseIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  fciGroup?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  foreignerSociabilityIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  hairLossIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  hairType?: InputMaybe<NullableEnumDogHairTypeFieldUpdateOperationsInput>;
  headShape?: InputMaybe<NullableEnumHeadShapeFieldUpdateOperationsInput>;
  heatToleranceIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  homeCountryCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  imgs?: InputMaybe<DogBreedImgUpdateManyWithoutDogBreedNestedInput>;
  independenceIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  intellectualActivityNeedIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  isSubBreed?: InputMaybe<BoolFieldUpdateOperationsInput>;
  litters?: InputMaybe<LitterUpdateManyWithoutDogBreedNestedInput>;
  maintenanceIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  physicalActivityNeedIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  predatoryInstinctIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  puppies?: InputMaybe<DogPuppyUpdateManyWithoutBreedNestedInput>;
  robustnessIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  sizeCategory?: InputMaybe<NullableEnumAnimalSizeEnumFieldUpdateOperationsInput>;
  sociabilityIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  sortingIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  translations?: InputMaybe<DogBreedTranslationUpdateManyWithoutDogBreedNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  videoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type DogBreedUpdateWithoutBreedInterestSubscriptionsInput = {
  adultSizeAge?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  applications?: InputMaybe<DogBreederApplicationUpdateManyWithoutBreedPreferenceNestedInput>;
  barkingTendancyIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  baseBreedName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  careIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  coldToleranceIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dogBreeders?: InputMaybe<DogBreederBreedsUpdateManyWithoutDogBreedNestedInput>;
  dogInfos?: InputMaybe<DogInfoUpdateManyWithoutDogBreedNestedInput>;
  dogType?: InputMaybe<Array<DogType>>;
  educationIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  exerciseIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  fciGroup?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  foreignerSociabilityIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  hairLossIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  hairType?: InputMaybe<NullableEnumDogHairTypeFieldUpdateOperationsInput>;
  headShape?: InputMaybe<NullableEnumHeadShapeFieldUpdateOperationsInput>;
  heatToleranceIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  homeCountryCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  imgs?: InputMaybe<DogBreedImgUpdateManyWithoutDogBreedNestedInput>;
  independenceIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  intellectualActivityNeedIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  isSubBreed?: InputMaybe<BoolFieldUpdateOperationsInput>;
  litters?: InputMaybe<LitterUpdateManyWithoutDogBreedNestedInput>;
  maintenanceIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  physicalActivityNeedIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  predatoryInstinctIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  puppies?: InputMaybe<DogPuppyUpdateManyWithoutBreedNestedInput>;
  robustnessIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  sizeCategory?: InputMaybe<NullableEnumAnimalSizeEnumFieldUpdateOperationsInput>;
  sociabilityIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  sortingIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  translations?: InputMaybe<DogBreedTranslationUpdateManyWithoutDogBreedNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  videoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type DogBreedUpdateWithoutDogBreedersInput = {
  adultSizeAge?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  applications?: InputMaybe<DogBreederApplicationUpdateManyWithoutBreedPreferenceNestedInput>;
  barkingTendancyIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  baseBreedName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  breedInterestSubscriptions?: InputMaybe<DogBreedInterestSubscriptionUpdateManyWithoutDogBreedsNestedInput>;
  careIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  coldToleranceIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dogInfos?: InputMaybe<DogInfoUpdateManyWithoutDogBreedNestedInput>;
  dogType?: InputMaybe<Array<DogType>>;
  educationIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  exerciseIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  fciGroup?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  foreignerSociabilityIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  hairLossIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  hairType?: InputMaybe<NullableEnumDogHairTypeFieldUpdateOperationsInput>;
  headShape?: InputMaybe<NullableEnumHeadShapeFieldUpdateOperationsInput>;
  heatToleranceIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  homeCountryCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  imgs?: InputMaybe<DogBreedImgUpdateManyWithoutDogBreedNestedInput>;
  independenceIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  intellectualActivityNeedIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  isSubBreed?: InputMaybe<BoolFieldUpdateOperationsInput>;
  litters?: InputMaybe<LitterUpdateManyWithoutDogBreedNestedInput>;
  maintenanceIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  physicalActivityNeedIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  predatoryInstinctIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  puppies?: InputMaybe<DogPuppyUpdateManyWithoutBreedNestedInput>;
  robustnessIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  sizeCategory?: InputMaybe<NullableEnumAnimalSizeEnumFieldUpdateOperationsInput>;
  sociabilityIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  sortingIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  translations?: InputMaybe<DogBreedTranslationUpdateManyWithoutDogBreedNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  videoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type DogBreedUpdateWithoutDogInfosInput = {
  adultSizeAge?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  applications?: InputMaybe<DogBreederApplicationUpdateManyWithoutBreedPreferenceNestedInput>;
  barkingTendancyIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  baseBreedName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  breedInterestSubscriptions?: InputMaybe<DogBreedInterestSubscriptionUpdateManyWithoutDogBreedsNestedInput>;
  careIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  coldToleranceIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dogBreeders?: InputMaybe<DogBreederBreedsUpdateManyWithoutDogBreedNestedInput>;
  dogType?: InputMaybe<Array<DogType>>;
  educationIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  exerciseIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  fciGroup?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  foreignerSociabilityIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  hairLossIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  hairType?: InputMaybe<NullableEnumDogHairTypeFieldUpdateOperationsInput>;
  headShape?: InputMaybe<NullableEnumHeadShapeFieldUpdateOperationsInput>;
  heatToleranceIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  homeCountryCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  imgs?: InputMaybe<DogBreedImgUpdateManyWithoutDogBreedNestedInput>;
  independenceIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  intellectualActivityNeedIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  isSubBreed?: InputMaybe<BoolFieldUpdateOperationsInput>;
  litters?: InputMaybe<LitterUpdateManyWithoutDogBreedNestedInput>;
  maintenanceIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  physicalActivityNeedIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  predatoryInstinctIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  puppies?: InputMaybe<DogPuppyUpdateManyWithoutBreedNestedInput>;
  robustnessIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  sizeCategory?: InputMaybe<NullableEnumAnimalSizeEnumFieldUpdateOperationsInput>;
  sociabilityIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  sortingIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  translations?: InputMaybe<DogBreedTranslationUpdateManyWithoutDogBreedNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  videoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type DogBreedUpdateWithoutImgsInput = {
  adultSizeAge?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  applications?: InputMaybe<DogBreederApplicationUpdateManyWithoutBreedPreferenceNestedInput>;
  barkingTendancyIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  baseBreedName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  breedInterestSubscriptions?: InputMaybe<DogBreedInterestSubscriptionUpdateManyWithoutDogBreedsNestedInput>;
  careIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  coldToleranceIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dogBreeders?: InputMaybe<DogBreederBreedsUpdateManyWithoutDogBreedNestedInput>;
  dogInfos?: InputMaybe<DogInfoUpdateManyWithoutDogBreedNestedInput>;
  dogType?: InputMaybe<Array<DogType>>;
  educationIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  exerciseIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  fciGroup?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  foreignerSociabilityIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  hairLossIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  hairType?: InputMaybe<NullableEnumDogHairTypeFieldUpdateOperationsInput>;
  headShape?: InputMaybe<NullableEnumHeadShapeFieldUpdateOperationsInput>;
  heatToleranceIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  homeCountryCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  independenceIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  intellectualActivityNeedIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  isSubBreed?: InputMaybe<BoolFieldUpdateOperationsInput>;
  litters?: InputMaybe<LitterUpdateManyWithoutDogBreedNestedInput>;
  maintenanceIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  physicalActivityNeedIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  predatoryInstinctIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  puppies?: InputMaybe<DogPuppyUpdateManyWithoutBreedNestedInput>;
  robustnessIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  sizeCategory?: InputMaybe<NullableEnumAnimalSizeEnumFieldUpdateOperationsInput>;
  sociabilityIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  sortingIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  translations?: InputMaybe<DogBreedTranslationUpdateManyWithoutDogBreedNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  videoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type DogBreedUpdateWithoutLittersInput = {
  adultSizeAge?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  applications?: InputMaybe<DogBreederApplicationUpdateManyWithoutBreedPreferenceNestedInput>;
  barkingTendancyIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  baseBreedName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  breedInterestSubscriptions?: InputMaybe<DogBreedInterestSubscriptionUpdateManyWithoutDogBreedsNestedInput>;
  careIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  coldToleranceIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dogBreeders?: InputMaybe<DogBreederBreedsUpdateManyWithoutDogBreedNestedInput>;
  dogInfos?: InputMaybe<DogInfoUpdateManyWithoutDogBreedNestedInput>;
  dogType?: InputMaybe<Array<DogType>>;
  educationIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  exerciseIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  fciGroup?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  foreignerSociabilityIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  hairLossIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  hairType?: InputMaybe<NullableEnumDogHairTypeFieldUpdateOperationsInput>;
  headShape?: InputMaybe<NullableEnumHeadShapeFieldUpdateOperationsInput>;
  heatToleranceIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  homeCountryCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  imgs?: InputMaybe<DogBreedImgUpdateManyWithoutDogBreedNestedInput>;
  independenceIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  intellectualActivityNeedIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  isSubBreed?: InputMaybe<BoolFieldUpdateOperationsInput>;
  maintenanceIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  physicalActivityNeedIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  predatoryInstinctIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  puppies?: InputMaybe<DogPuppyUpdateManyWithoutBreedNestedInput>;
  robustnessIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  sizeCategory?: InputMaybe<NullableEnumAnimalSizeEnumFieldUpdateOperationsInput>;
  sociabilityIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  sortingIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  translations?: InputMaybe<DogBreedTranslationUpdateManyWithoutDogBreedNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  videoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type DogBreedUpdateWithoutPuppiesInput = {
  adultSizeAge?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  applications?: InputMaybe<DogBreederApplicationUpdateManyWithoutBreedPreferenceNestedInput>;
  barkingTendancyIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  baseBreedName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  breedInterestSubscriptions?: InputMaybe<DogBreedInterestSubscriptionUpdateManyWithoutDogBreedsNestedInput>;
  careIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  coldToleranceIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dogBreeders?: InputMaybe<DogBreederBreedsUpdateManyWithoutDogBreedNestedInput>;
  dogInfos?: InputMaybe<DogInfoUpdateManyWithoutDogBreedNestedInput>;
  dogType?: InputMaybe<Array<DogType>>;
  educationIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  exerciseIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  fciGroup?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  foreignerSociabilityIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  hairLossIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  hairType?: InputMaybe<NullableEnumDogHairTypeFieldUpdateOperationsInput>;
  headShape?: InputMaybe<NullableEnumHeadShapeFieldUpdateOperationsInput>;
  heatToleranceIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  homeCountryCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  imgs?: InputMaybe<DogBreedImgUpdateManyWithoutDogBreedNestedInput>;
  independenceIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  intellectualActivityNeedIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  isSubBreed?: InputMaybe<BoolFieldUpdateOperationsInput>;
  litters?: InputMaybe<LitterUpdateManyWithoutDogBreedNestedInput>;
  maintenanceIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  physicalActivityNeedIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  predatoryInstinctIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  robustnessIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  sizeCategory?: InputMaybe<NullableEnumAnimalSizeEnumFieldUpdateOperationsInput>;
  sociabilityIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  sortingIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  translations?: InputMaybe<DogBreedTranslationUpdateManyWithoutDogBreedNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  videoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type DogBreedUpdateWithoutTranslationsInput = {
  adultSizeAge?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  applications?: InputMaybe<DogBreederApplicationUpdateManyWithoutBreedPreferenceNestedInput>;
  barkingTendancyIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  baseBreedName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  breedInterestSubscriptions?: InputMaybe<DogBreedInterestSubscriptionUpdateManyWithoutDogBreedsNestedInput>;
  careIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  coldToleranceIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dogBreeders?: InputMaybe<DogBreederBreedsUpdateManyWithoutDogBreedNestedInput>;
  dogInfos?: InputMaybe<DogInfoUpdateManyWithoutDogBreedNestedInput>;
  dogType?: InputMaybe<Array<DogType>>;
  educationIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  exerciseIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  fciGroup?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  foreignerSociabilityIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  hairLossIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  hairType?: InputMaybe<NullableEnumDogHairTypeFieldUpdateOperationsInput>;
  headShape?: InputMaybe<NullableEnumHeadShapeFieldUpdateOperationsInput>;
  heatToleranceIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  homeCountryCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  imgs?: InputMaybe<DogBreedImgUpdateManyWithoutDogBreedNestedInput>;
  independenceIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  intellectualActivityNeedIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  isSubBreed?: InputMaybe<BoolFieldUpdateOperationsInput>;
  litters?: InputMaybe<LitterUpdateManyWithoutDogBreedNestedInput>;
  maintenanceIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  physicalActivityNeedIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  predatoryInstinctIndex?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  puppies?: InputMaybe<DogPuppyUpdateManyWithoutBreedNestedInput>;
  robustnessIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  sizeCategory?: InputMaybe<NullableEnumAnimalSizeEnumFieldUpdateOperationsInput>;
  sociabilityIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  sortingIndex?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  videoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type DogBreedUpdatedogTypeInput = {
  push?: InputMaybe<Array<DogType>>;
  set?: InputMaybe<Array<DogType>>;
};

export type DogBreedUpsertWithWhereUniqueWithoutBreedInterestSubscriptionsInput = {
  create: DogBreedCreateWithoutBreedInterestSubscriptionsInput;
  update: DogBreedUpdateWithoutBreedInterestSubscriptionsInput;
  where: DogBreedWhereUniqueInput;
};

export type DogBreedUpsertWithoutApplicationsInput = {
  create: DogBreedCreateWithoutApplicationsInput;
  update: DogBreedUpdateWithoutApplicationsInput;
  where?: InputMaybe<DogBreedWhereInput>;
};

export type DogBreedUpsertWithoutDogBreedersInput = {
  create: DogBreedCreateWithoutDogBreedersInput;
  update: DogBreedUpdateWithoutDogBreedersInput;
  where?: InputMaybe<DogBreedWhereInput>;
};

export type DogBreedUpsertWithoutDogInfosInput = {
  create: DogBreedCreateWithoutDogInfosInput;
  update: DogBreedUpdateWithoutDogInfosInput;
  where?: InputMaybe<DogBreedWhereInput>;
};

export type DogBreedUpsertWithoutImgsInput = {
  create: DogBreedCreateWithoutImgsInput;
  update: DogBreedUpdateWithoutImgsInput;
  where?: InputMaybe<DogBreedWhereInput>;
};

export type DogBreedUpsertWithoutLittersInput = {
  create: DogBreedCreateWithoutLittersInput;
  update: DogBreedUpdateWithoutLittersInput;
  where?: InputMaybe<DogBreedWhereInput>;
};

export type DogBreedUpsertWithoutPuppiesInput = {
  create: DogBreedCreateWithoutPuppiesInput;
  update: DogBreedUpdateWithoutPuppiesInput;
  where?: InputMaybe<DogBreedWhereInput>;
};

export type DogBreedUpsertWithoutTranslationsInput = {
  create: DogBreedCreateWithoutTranslationsInput;
  update: DogBreedUpdateWithoutTranslationsInput;
  where?: InputMaybe<DogBreedWhereInput>;
};

export type DogBreedWhereInput = {
  AND?: InputMaybe<Array<DogBreedWhereInput>>;
  NOT?: InputMaybe<Array<DogBreedWhereInput>>;
  OR?: InputMaybe<Array<DogBreedWhereInput>>;
  adultSizeAge?: InputMaybe<IntNullableFilter>;
  applications?: InputMaybe<DogBreederApplicationListRelationFilter>;
  barkingTendancyIndex?: InputMaybe<FloatNullableFilter>;
  baseBreedName?: InputMaybe<StringNullableFilter>;
  breedInterestSubscriptions?: InputMaybe<DogBreedInterestSubscriptionListRelationFilter>;
  careIndex?: InputMaybe<IntNullableFilter>;
  coldToleranceIndex?: InputMaybe<FloatNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  dogBreeders?: InputMaybe<DogBreederBreedsListRelationFilter>;
  dogInfos?: InputMaybe<DogInfoListRelationFilter>;
  dogType?: InputMaybe<EnumDogTypeNullableListFilter>;
  educationIndex?: InputMaybe<IntNullableFilter>;
  exerciseIndex?: InputMaybe<IntNullableFilter>;
  fciGroup?: InputMaybe<StringNullableFilter>;
  foreignerSociabilityIndex?: InputMaybe<FloatNullableFilter>;
  hairLossIndex?: InputMaybe<FloatNullableFilter>;
  hairType?: InputMaybe<EnumDogHairTypeNullableFilter>;
  headShape?: InputMaybe<EnumHeadShapeNullableFilter>;
  heatToleranceIndex?: InputMaybe<FloatNullableFilter>;
  homeCountryCode?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<IntFilter>;
  imgs?: InputMaybe<DogBreedImgListRelationFilter>;
  independenceIndex?: InputMaybe<FloatNullableFilter>;
  intellectualActivityNeedIndex?: InputMaybe<FloatNullableFilter>;
  isSubBreed?: InputMaybe<BoolFilter>;
  litters?: InputMaybe<LitterListRelationFilter>;
  maintenanceIndex?: InputMaybe<IntNullableFilter>;
  name?: InputMaybe<StringFilter>;
  physicalActivityNeedIndex?: InputMaybe<FloatNullableFilter>;
  predatoryInstinctIndex?: InputMaybe<FloatNullableFilter>;
  puppies?: InputMaybe<DogPuppyListRelationFilter>;
  robustnessIndex?: InputMaybe<IntNullableFilter>;
  sizeCategory?: InputMaybe<EnumAnimalSizeEnumNullableFilter>;
  sociabilityIndex?: InputMaybe<IntNullableFilter>;
  sortingIndex?: InputMaybe<IntNullableFilter>;
  translations?: InputMaybe<DogBreedTranslationListRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  videoUrl?: InputMaybe<StringNullableFilter>;
};

export type DogBreedWhereUniqueInput = {
  AND?: InputMaybe<Array<DogBreedWhereInput>>;
  NOT?: InputMaybe<Array<DogBreedWhereInput>>;
  OR?: InputMaybe<Array<DogBreedWhereInput>>;
  adultSizeAge?: InputMaybe<IntNullableFilter>;
  applications?: InputMaybe<DogBreederApplicationListRelationFilter>;
  barkingTendancyIndex?: InputMaybe<FloatNullableFilter>;
  baseBreedName?: InputMaybe<StringNullableFilter>;
  breedInterestSubscriptions?: InputMaybe<DogBreedInterestSubscriptionListRelationFilter>;
  careIndex?: InputMaybe<IntNullableFilter>;
  coldToleranceIndex?: InputMaybe<FloatNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  dogBreeders?: InputMaybe<DogBreederBreedsListRelationFilter>;
  dogInfos?: InputMaybe<DogInfoListRelationFilter>;
  dogType?: InputMaybe<EnumDogTypeNullableListFilter>;
  educationIndex?: InputMaybe<IntNullableFilter>;
  exerciseIndex?: InputMaybe<IntNullableFilter>;
  fciGroup?: InputMaybe<StringNullableFilter>;
  foreignerSociabilityIndex?: InputMaybe<FloatNullableFilter>;
  hairLossIndex?: InputMaybe<FloatNullableFilter>;
  hairType?: InputMaybe<EnumDogHairTypeNullableFilter>;
  headShape?: InputMaybe<EnumHeadShapeNullableFilter>;
  heatToleranceIndex?: InputMaybe<FloatNullableFilter>;
  homeCountryCode?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  imgs?: InputMaybe<DogBreedImgListRelationFilter>;
  independenceIndex?: InputMaybe<FloatNullableFilter>;
  intellectualActivityNeedIndex?: InputMaybe<FloatNullableFilter>;
  isSubBreed?: InputMaybe<BoolFilter>;
  litters?: InputMaybe<LitterListRelationFilter>;
  maintenanceIndex?: InputMaybe<IntNullableFilter>;
  name?: InputMaybe<Scalars['String']['input']>;
  physicalActivityNeedIndex?: InputMaybe<FloatNullableFilter>;
  predatoryInstinctIndex?: InputMaybe<FloatNullableFilter>;
  puppies?: InputMaybe<DogPuppyListRelationFilter>;
  robustnessIndex?: InputMaybe<IntNullableFilter>;
  sizeCategory?: InputMaybe<EnumAnimalSizeEnumNullableFilter>;
  sociabilityIndex?: InputMaybe<IntNullableFilter>;
  sortingIndex?: InputMaybe<IntNullableFilter>;
  translations?: InputMaybe<DogBreedTranslationListRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  videoUrl?: InputMaybe<StringNullableFilter>;
};

export type DogBreeder = {
  __typename?: 'DogBreeder';
  _count: DogBreederCountOutputType;
  account: DogBreederAccount;
  adminNote?: Maybe<Scalars['String']['output']>;
  agreementNumber?: Maybe<Scalars['String']['output']>;
  applications: Array<DogBreederApplication>;
  breedClubFiles?: Maybe<Array<Scalars['String']['output']>>;
  breedClubValidated?: Maybe<Scalars['Boolean']['output']>;
  breederBreeds: Array<DogBreederBreeds>;
  breedingName?: Maybe<Scalars['String']['output']>;
  certificationFile?: Maybe<Scalars['String']['output']>;
  certified?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['DateTime']['output'];
  displayEmail?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  displayPhone?: Maybe<Scalars['String']['output']>;
  dogInfos: Array<DogInfo>;
  dogsConsanguinity?: Maybe<Scalars['String']['output']>;
  dogsPedigree?: Maybe<Scalars['String']['output']>;
  dogsTemper?: Maybe<Scalars['String']['output']>;
  facebookUrl?: Maybe<Scalars['String']['output']>;
  failedMedicalTestsProtocol?: Maybe<Scalars['String']['output']>;
  femaleBreedersCount?: Maybe<Scalars['Int']['output']>;
  hasFinishedOnboarding: Scalars['Boolean']['output'];
  hasStartedOnboarding: Scalars['Boolean']['output'];
  hkFile?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  identityFiles?: Maybe<Array<Scalars['String']['output']>>;
  imgs: Array<DogBreederImg>;
  lastConnectedType?: Maybe<DogBreederLastConnectedTypeEnum>;
  level?: Maybe<Scalars['String']['output']>;
  litters: Array<Litter>;
  littersByFemale?: Maybe<Scalars['String']['output']>;
  littersByFemaleCount?: Maybe<Scalars['Int']['output']>;
  maleBreedersCount?: Maybe<Scalars['Int']['output']>;
  medicalTestsPerformed?: Maybe<Scalars['String']['output']>;
  motherRestBetweenLitters?: Maybe<Scalars['String']['output']>;
  notifications: Array<Notification>;
  permissionFiles?: Maybe<Array<Scalars['String']['output']>>;
  profileImg?: Maybe<Scalars['String']['output']>;
  public?: Maybe<Scalars['Boolean']['output']>;
  puppies?: Maybe<Array<DogPuppy>>;
  puppiesBirthPlace?: Maybe<Scalars['String']['output']>;
  reviews: Array<DogBreederReview>;
  spokenLanguages: Array<Scalars['String']['output']>;
  translations: Array<DogBreederTranslation>;
  updatedAt: Scalars['DateTime']['output'];
  vatNumber?: Maybe<Scalars['String']['output']>;
  veterinaryInfo?: Maybe<Scalars['String']['output']>;
  videoUrl?: Maybe<Scalars['String']['output']>;
  visitedByTipaw: Scalars['Boolean']['output'];
  websiteUrl?: Maybe<Scalars['String']['output']>;
  whatsappNumber?: Maybe<Scalars['String']['output']>;
};


export type DogBreederapplicationsArgs = {
  cursor?: InputMaybe<DogBreederApplicationWhereUniqueInput>;
  distinct?: InputMaybe<DogBreederApplicationScalarFieldEnum>;
  orderBy?: InputMaybe<DogBreederApplicationOrderByWithRelationAndSearchRelevanceInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DogBreederApplicationWhereInput>;
};


export type DogBreederbreederBreedsArgs = {
  cursor?: InputMaybe<DogBreederBreedsWhereUniqueInput>;
  distinct?: InputMaybe<DogBreederBreedsScalarFieldEnum>;
  orderBy?: InputMaybe<DogBreederBreedsOrderByWithRelationAndSearchRelevanceInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DogBreederBreedsWhereInput>;
};


export type DogBreederdogInfosArgs = {
  cursor?: InputMaybe<DogInfoWhereUniqueInput>;
  distinct?: InputMaybe<DogInfoScalarFieldEnum>;
  orderBy?: InputMaybe<DogInfoOrderByWithRelationAndSearchRelevanceInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DogInfoWhereInput>;
};


export type DogBreederimgsArgs = {
  cursor?: InputMaybe<DogBreederImgWhereUniqueInput>;
  distinct?: InputMaybe<DogBreederImgScalarFieldEnum>;
  orderBy?: InputMaybe<DogBreederImgOrderByWithRelationAndSearchRelevanceInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DogBreederImgWhereInput>;
};


export type DogBreederlittersArgs = {
  cursor?: InputMaybe<LitterWhereUniqueInput>;
  distinct?: InputMaybe<LitterScalarFieldEnum>;
  orderBy?: InputMaybe<LitterOrderByWithRelationAndSearchRelevanceInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<LitterWhereInput>;
};


export type DogBreedernotificationsArgs = {
  cursor?: InputMaybe<NotificationWhereUniqueInput>;
  distinct?: InputMaybe<NotificationScalarFieldEnum>;
  orderBy?: InputMaybe<NotificationOrderByWithRelationAndSearchRelevanceInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<NotificationWhereInput>;
};


export type DogBreederreviewsArgs = {
  cursor?: InputMaybe<DogBreederReviewWhereUniqueInput>;
  distinct?: InputMaybe<DogBreederReviewScalarFieldEnum>;
  orderBy?: InputMaybe<DogBreederReviewOrderByWithRelationAndSearchRelevanceInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DogBreederReviewWhereInput>;
};


export type DogBreedertranslationsArgs = {
  cursor?: InputMaybe<DogBreederTranslationWhereUniqueInput>;
  distinct?: InputMaybe<DogBreederTranslationScalarFieldEnum>;
  orderBy?: InputMaybe<DogBreederTranslationOrderByWithRelationAndSearchRelevanceInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DogBreederTranslationWhereInput>;
};

export type DogBreederAccount = {
  __typename?: 'DogBreederAccount';
  address?: Maybe<Address>;
  connectedAt: Scalars['DateTime']['output'];
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  language?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
};

export type DogBreederApplication = {
  __typename?: 'DogBreederApplication';
  accommodation: DogBreederApplicationAccommodation;
  accommodationDescription?: Maybe<Scalars['String']['output']>;
  account: DogBreederApplicationAccount;
  animal?: Maybe<Animal>;
  animalId?: Maybe<Scalars['Int']['output']>;
  archivedReason?: Maybe<Scalars['String']['output']>;
  breedPreference: DogBreed;
  breedPreferenceId: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedReason?: Maybe<Scalars['String']['output']>;
  dogBreeder: DogBreeder;
  dogBreederId: Scalars['Int']['output'];
  experiences: Array<DogBreederApplicationExperience>;
  genderPreferences: Array<GenderEnum>;
  id: Scalars['Int']['output'];
  motive?: Maybe<Scalars['String']['output']>;
  otherAnimals: Array<DogBreederApplicationOtherAnimal>;
  otherAnimalsDescription?: Maybe<Scalars['String']['output']>;
  otherPreferences?: Maybe<Scalars['String']['output']>;
  puppy?: Maybe<DogPuppy>;
  questions?: Maybe<Scalars['String']['output']>;
  seenByBreeder?: Maybe<Scalars['Boolean']['output']>;
  seenByBuyer?: Maybe<Scalars['Boolean']['output']>;
  status: DogBreederApplicationStatus;
  timeAlone: DogBreederApplicationTimeAlone;
  trainers: Array<DogBreederApplicationTrainer>;
  updatedAt: Scalars['DateTime']['output'];
};

export enum DogBreederApplicationAccommodation {
  APPARTMENT = 'APPARTMENT',
  APPARTMENT_NO_GARDEN = 'APPARTMENT_NO_GARDEN',
  HOUSE = 'HOUSE',
  HOUSE_NO_GARDEN = 'HOUSE_NO_GARDEN'
}

export type DogBreederApplicationAccount = {
  __typename?: 'DogBreederApplicationAccount';
  address?: Maybe<Address>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  imgs: Array<AccountImg>;
  language?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
};


export type DogBreederApplicationAccountimgsArgs = {
  cursor?: InputMaybe<AccountImgWhereUniqueInput>;
  distinct?: InputMaybe<AccountImgScalarFieldEnum>;
  orderBy?: InputMaybe<AccountImgOrderByWithRelationAndSearchRelevanceInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AccountImgWhereInput>;
};

export type DogBreederApplicationAvgAggregateOutputType = {
  __typename?: 'DogBreederApplicationAvgAggregateOutputType';
  accountId?: Maybe<Scalars['Float']['output']>;
  animalId?: Maybe<Scalars['Float']['output']>;
  breedPreferenceId?: Maybe<Scalars['Float']['output']>;
  dogBreederId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

export type DogBreederApplicationAvgOrderByAggregateInput = {
  accountId?: InputMaybe<SortOrder>;
  animalId?: InputMaybe<SortOrder>;
  breedPreferenceId?: InputMaybe<SortOrder>;
  dogBreederId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export type DogBreederApplicationCountAggregateOutputType = {
  __typename?: 'DogBreederApplicationCountAggregateOutputType';
  _all: Scalars['Int']['output'];
  accommodation: Scalars['Int']['output'];
  accommodationDescription: Scalars['Int']['output'];
  accountId: Scalars['Int']['output'];
  animalId: Scalars['Int']['output'];
  archived: Scalars['Int']['output'];
  breedPreferenceId: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  dogBreederId: Scalars['Int']['output'];
  experiences: Scalars['Int']['output'];
  genderPreferences: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  motive: Scalars['Int']['output'];
  otherAnimals: Scalars['Int']['output'];
  otherAnimalsDescription: Scalars['Int']['output'];
  otherPreferences: Scalars['Int']['output'];
  paymentId: Scalars['Int']['output'];
  questions: Scalars['Int']['output'];
  rejectedReason: Scalars['Int']['output'];
  seenByBreeder: Scalars['Int']['output'];
  seenByBuyer: Scalars['Int']['output'];
  status: Scalars['Int']['output'];
  timeAlone: Scalars['Int']['output'];
  trainers: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type DogBreederApplicationCountOrderByAggregateInput = {
  accommodation?: InputMaybe<SortOrder>;
  accommodationDescription?: InputMaybe<SortOrder>;
  accountId?: InputMaybe<SortOrder>;
  animalId?: InputMaybe<SortOrder>;
  archived?: InputMaybe<SortOrder>;
  breedPreferenceId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  dogBreederId?: InputMaybe<SortOrder>;
  experiences?: InputMaybe<SortOrder>;
  genderPreferences?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  motive?: InputMaybe<SortOrder>;
  otherAnimals?: InputMaybe<SortOrder>;
  otherAnimalsDescription?: InputMaybe<SortOrder>;
  otherPreferences?: InputMaybe<SortOrder>;
  paymentId?: InputMaybe<SortOrder>;
  questions?: InputMaybe<SortOrder>;
  rejectedReason?: InputMaybe<SortOrder>;
  seenByBreeder?: InputMaybe<SortOrder>;
  seenByBuyer?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  timeAlone?: InputMaybe<SortOrder>;
  trainers?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type DogBreederApplicationCountOutputType = {
  __typename?: 'DogBreederApplicationCountOutputType';
  notifications: Scalars['Int']['output'];
  statusHistory: Scalars['Int']['output'];
};

export type DogBreederApplicationCreateInput = {
  accommodation: DogBreederApplicationAccommodation;
  accommodationDescription?: InputMaybe<Scalars['String']['input']>;
  account: AccountCreateNestedOneWithoutApplicationsInput;
  animal?: InputMaybe<AnimalCreateNestedOneWithoutApplicationInput>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  breedPreference: DogBreedCreateNestedOneWithoutApplicationsInput;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dogBreeder: DogBreederCreateNestedOneWithoutApplicationsInput;
  experiences?: InputMaybe<Array<DogBreederApplicationExperience>>;
  genderPreferences?: InputMaybe<Array<GenderEnum>>;
  motive?: InputMaybe<Scalars['String']['input']>;
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutApplicationInput>;
  otherAnimals?: InputMaybe<Array<DogBreederApplicationOtherAnimal>>;
  otherAnimalsDescription?: InputMaybe<Scalars['String']['input']>;
  otherPreferences?: InputMaybe<Scalars['String']['input']>;
  payment?: InputMaybe<PaymentCreateNestedOneWithoutApplicationInput>;
  questions?: InputMaybe<Scalars['String']['input']>;
  rejectedReason?: InputMaybe<Scalars['String']['input']>;
  seenByBreeder?: InputMaybe<Scalars['Boolean']['input']>;
  seenByBuyer?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<DogBreederApplicationStatus>;
  statusHistory?: InputMaybe<DogBreederApplicationStatusHistoryCreateNestedManyWithoutApplicationInput>;
  timeAlone: DogBreederApplicationTimeAlone;
  trainers?: InputMaybe<Array<DogBreederApplicationTrainer>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DogBreederApplicationCreateManyAccountInput = {
  accommodation: DogBreederApplicationAccommodation;
  accommodationDescription?: InputMaybe<Scalars['String']['input']>;
  animalId?: InputMaybe<Scalars['Int']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  breedPreferenceId: Scalars['Int']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dogBreederId: Scalars['Int']['input'];
  experiences?: InputMaybe<Array<DogBreederApplicationExperience>>;
  genderPreferences?: InputMaybe<Array<GenderEnum>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  motive?: InputMaybe<Scalars['String']['input']>;
  otherAnimals?: InputMaybe<Array<DogBreederApplicationOtherAnimal>>;
  otherAnimalsDescription?: InputMaybe<Scalars['String']['input']>;
  otherPreferences?: InputMaybe<Scalars['String']['input']>;
  paymentId?: InputMaybe<Scalars['String']['input']>;
  questions?: InputMaybe<Scalars['String']['input']>;
  rejectedReason?: InputMaybe<Scalars['String']['input']>;
  seenByBreeder?: InputMaybe<Scalars['Boolean']['input']>;
  seenByBuyer?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<DogBreederApplicationStatus>;
  timeAlone: DogBreederApplicationTimeAlone;
  trainers?: InputMaybe<Array<DogBreederApplicationTrainer>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DogBreederApplicationCreateManyAccountInputEnvelope = {
  data: Array<DogBreederApplicationCreateManyAccountInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DogBreederApplicationCreateManyBreedPreferenceInput = {
  accommodation: DogBreederApplicationAccommodation;
  accommodationDescription?: InputMaybe<Scalars['String']['input']>;
  accountId: Scalars['Int']['input'];
  animalId?: InputMaybe<Scalars['Int']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dogBreederId: Scalars['Int']['input'];
  experiences?: InputMaybe<Array<DogBreederApplicationExperience>>;
  genderPreferences?: InputMaybe<Array<GenderEnum>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  motive?: InputMaybe<Scalars['String']['input']>;
  otherAnimals?: InputMaybe<Array<DogBreederApplicationOtherAnimal>>;
  otherAnimalsDescription?: InputMaybe<Scalars['String']['input']>;
  otherPreferences?: InputMaybe<Scalars['String']['input']>;
  paymentId?: InputMaybe<Scalars['String']['input']>;
  questions?: InputMaybe<Scalars['String']['input']>;
  rejectedReason?: InputMaybe<Scalars['String']['input']>;
  seenByBreeder?: InputMaybe<Scalars['Boolean']['input']>;
  seenByBuyer?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<DogBreederApplicationStatus>;
  timeAlone: DogBreederApplicationTimeAlone;
  trainers?: InputMaybe<Array<DogBreederApplicationTrainer>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DogBreederApplicationCreateManyBreedPreferenceInputEnvelope = {
  data: Array<DogBreederApplicationCreateManyBreedPreferenceInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DogBreederApplicationCreateManyDogBreederInput = {
  accommodation: DogBreederApplicationAccommodation;
  accommodationDescription?: InputMaybe<Scalars['String']['input']>;
  accountId: Scalars['Int']['input'];
  animalId?: InputMaybe<Scalars['Int']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  breedPreferenceId: Scalars['Int']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  experiences?: InputMaybe<Array<DogBreederApplicationExperience>>;
  genderPreferences?: InputMaybe<Array<GenderEnum>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  motive?: InputMaybe<Scalars['String']['input']>;
  otherAnimals?: InputMaybe<Array<DogBreederApplicationOtherAnimal>>;
  otherAnimalsDescription?: InputMaybe<Scalars['String']['input']>;
  otherPreferences?: InputMaybe<Scalars['String']['input']>;
  paymentId?: InputMaybe<Scalars['String']['input']>;
  questions?: InputMaybe<Scalars['String']['input']>;
  rejectedReason?: InputMaybe<Scalars['String']['input']>;
  seenByBreeder?: InputMaybe<Scalars['Boolean']['input']>;
  seenByBuyer?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<DogBreederApplicationStatus>;
  timeAlone: DogBreederApplicationTimeAlone;
  trainers?: InputMaybe<Array<DogBreederApplicationTrainer>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DogBreederApplicationCreateManyDogBreederInputEnvelope = {
  data: Array<DogBreederApplicationCreateManyDogBreederInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DogBreederApplicationCreateManyInput = {
  accommodation: DogBreederApplicationAccommodation;
  accommodationDescription?: InputMaybe<Scalars['String']['input']>;
  accountId: Scalars['Int']['input'];
  animalId?: InputMaybe<Scalars['Int']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  breedPreferenceId: Scalars['Int']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dogBreederId: Scalars['Int']['input'];
  experiences?: InputMaybe<Array<DogBreederApplicationExperience>>;
  genderPreferences?: InputMaybe<Array<GenderEnum>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  motive?: InputMaybe<Scalars['String']['input']>;
  otherAnimals?: InputMaybe<Array<DogBreederApplicationOtherAnimal>>;
  otherAnimalsDescription?: InputMaybe<Scalars['String']['input']>;
  otherPreferences?: InputMaybe<Scalars['String']['input']>;
  paymentId?: InputMaybe<Scalars['String']['input']>;
  questions?: InputMaybe<Scalars['String']['input']>;
  rejectedReason?: InputMaybe<Scalars['String']['input']>;
  seenByBreeder?: InputMaybe<Scalars['Boolean']['input']>;
  seenByBuyer?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<DogBreederApplicationStatus>;
  timeAlone: DogBreederApplicationTimeAlone;
  trainers?: InputMaybe<Array<DogBreederApplicationTrainer>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DogBreederApplicationCreateNestedManyWithoutAccountInput = {
  connect?: InputMaybe<Array<DogBreederApplicationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DogBreederApplicationCreateOrConnectWithoutAccountInput>>;
  create?: InputMaybe<Array<DogBreederApplicationCreateWithoutAccountInput>>;
  createMany?: InputMaybe<DogBreederApplicationCreateManyAccountInputEnvelope>;
};

export type DogBreederApplicationCreateNestedManyWithoutBreedPreferenceInput = {
  connect?: InputMaybe<Array<DogBreederApplicationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DogBreederApplicationCreateOrConnectWithoutBreedPreferenceInput>>;
  create?: InputMaybe<Array<DogBreederApplicationCreateWithoutBreedPreferenceInput>>;
  createMany?: InputMaybe<DogBreederApplicationCreateManyBreedPreferenceInputEnvelope>;
};

export type DogBreederApplicationCreateNestedManyWithoutDogBreederInput = {
  connect?: InputMaybe<Array<DogBreederApplicationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DogBreederApplicationCreateOrConnectWithoutDogBreederInput>>;
  create?: InputMaybe<Array<DogBreederApplicationCreateWithoutDogBreederInput>>;
  createMany?: InputMaybe<DogBreederApplicationCreateManyDogBreederInputEnvelope>;
};

export type DogBreederApplicationCreateNestedOneWithoutAnimalInput = {
  connect?: InputMaybe<DogBreederApplicationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DogBreederApplicationCreateOrConnectWithoutAnimalInput>;
  create?: InputMaybe<DogBreederApplicationCreateWithoutAnimalInput>;
};

export type DogBreederApplicationCreateNestedOneWithoutNotificationsInput = {
  connect?: InputMaybe<DogBreederApplicationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DogBreederApplicationCreateOrConnectWithoutNotificationsInput>;
  create?: InputMaybe<DogBreederApplicationCreateWithoutNotificationsInput>;
};

export type DogBreederApplicationCreateNestedOneWithoutPaymentInput = {
  connect?: InputMaybe<DogBreederApplicationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DogBreederApplicationCreateOrConnectWithoutPaymentInput>;
  create?: InputMaybe<DogBreederApplicationCreateWithoutPaymentInput>;
};

export type DogBreederApplicationCreateNestedOneWithoutStatusHistoryInput = {
  connect?: InputMaybe<DogBreederApplicationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DogBreederApplicationCreateOrConnectWithoutStatusHistoryInput>;
  create?: InputMaybe<DogBreederApplicationCreateWithoutStatusHistoryInput>;
};

export type DogBreederApplicationCreateOrConnectWithoutAccountInput = {
  create: DogBreederApplicationCreateWithoutAccountInput;
  where: DogBreederApplicationWhereUniqueInput;
};

export type DogBreederApplicationCreateOrConnectWithoutAnimalInput = {
  create: DogBreederApplicationCreateWithoutAnimalInput;
  where: DogBreederApplicationWhereUniqueInput;
};

export type DogBreederApplicationCreateOrConnectWithoutBreedPreferenceInput = {
  create: DogBreederApplicationCreateWithoutBreedPreferenceInput;
  where: DogBreederApplicationWhereUniqueInput;
};

export type DogBreederApplicationCreateOrConnectWithoutDogBreederInput = {
  create: DogBreederApplicationCreateWithoutDogBreederInput;
  where: DogBreederApplicationWhereUniqueInput;
};

export type DogBreederApplicationCreateOrConnectWithoutNotificationsInput = {
  create: DogBreederApplicationCreateWithoutNotificationsInput;
  where: DogBreederApplicationWhereUniqueInput;
};

export type DogBreederApplicationCreateOrConnectWithoutPaymentInput = {
  create: DogBreederApplicationCreateWithoutPaymentInput;
  where: DogBreederApplicationWhereUniqueInput;
};

export type DogBreederApplicationCreateOrConnectWithoutStatusHistoryInput = {
  create: DogBreederApplicationCreateWithoutStatusHistoryInput;
  where: DogBreederApplicationWhereUniqueInput;
};

export type DogBreederApplicationCreateWithoutAccountInput = {
  accommodation: DogBreederApplicationAccommodation;
  accommodationDescription?: InputMaybe<Scalars['String']['input']>;
  animal?: InputMaybe<AnimalCreateNestedOneWithoutApplicationInput>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  breedPreference: DogBreedCreateNestedOneWithoutApplicationsInput;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dogBreeder: DogBreederCreateNestedOneWithoutApplicationsInput;
  experiences?: InputMaybe<Array<DogBreederApplicationExperience>>;
  genderPreferences?: InputMaybe<Array<GenderEnum>>;
  motive?: InputMaybe<Scalars['String']['input']>;
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutApplicationInput>;
  otherAnimals?: InputMaybe<Array<DogBreederApplicationOtherAnimal>>;
  otherAnimalsDescription?: InputMaybe<Scalars['String']['input']>;
  otherPreferences?: InputMaybe<Scalars['String']['input']>;
  payment?: InputMaybe<PaymentCreateNestedOneWithoutApplicationInput>;
  questions?: InputMaybe<Scalars['String']['input']>;
  rejectedReason?: InputMaybe<Scalars['String']['input']>;
  seenByBreeder?: InputMaybe<Scalars['Boolean']['input']>;
  seenByBuyer?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<DogBreederApplicationStatus>;
  statusHistory?: InputMaybe<DogBreederApplicationStatusHistoryCreateNestedManyWithoutApplicationInput>;
  timeAlone: DogBreederApplicationTimeAlone;
  trainers?: InputMaybe<Array<DogBreederApplicationTrainer>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DogBreederApplicationCreateWithoutAnimalInput = {
  accommodation: DogBreederApplicationAccommodation;
  accommodationDescription?: InputMaybe<Scalars['String']['input']>;
  account: AccountCreateNestedOneWithoutApplicationsInput;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  breedPreference: DogBreedCreateNestedOneWithoutApplicationsInput;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dogBreeder: DogBreederCreateNestedOneWithoutApplicationsInput;
  experiences?: InputMaybe<Array<DogBreederApplicationExperience>>;
  genderPreferences?: InputMaybe<Array<GenderEnum>>;
  motive?: InputMaybe<Scalars['String']['input']>;
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutApplicationInput>;
  otherAnimals?: InputMaybe<Array<DogBreederApplicationOtherAnimal>>;
  otherAnimalsDescription?: InputMaybe<Scalars['String']['input']>;
  otherPreferences?: InputMaybe<Scalars['String']['input']>;
  payment?: InputMaybe<PaymentCreateNestedOneWithoutApplicationInput>;
  questions?: InputMaybe<Scalars['String']['input']>;
  rejectedReason?: InputMaybe<Scalars['String']['input']>;
  seenByBreeder?: InputMaybe<Scalars['Boolean']['input']>;
  seenByBuyer?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<DogBreederApplicationStatus>;
  statusHistory?: InputMaybe<DogBreederApplicationStatusHistoryCreateNestedManyWithoutApplicationInput>;
  timeAlone: DogBreederApplicationTimeAlone;
  trainers?: InputMaybe<Array<DogBreederApplicationTrainer>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DogBreederApplicationCreateWithoutBreedPreferenceInput = {
  accommodation: DogBreederApplicationAccommodation;
  accommodationDescription?: InputMaybe<Scalars['String']['input']>;
  account: AccountCreateNestedOneWithoutApplicationsInput;
  animal?: InputMaybe<AnimalCreateNestedOneWithoutApplicationInput>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dogBreeder: DogBreederCreateNestedOneWithoutApplicationsInput;
  experiences?: InputMaybe<Array<DogBreederApplicationExperience>>;
  genderPreferences?: InputMaybe<Array<GenderEnum>>;
  motive?: InputMaybe<Scalars['String']['input']>;
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutApplicationInput>;
  otherAnimals?: InputMaybe<Array<DogBreederApplicationOtherAnimal>>;
  otherAnimalsDescription?: InputMaybe<Scalars['String']['input']>;
  otherPreferences?: InputMaybe<Scalars['String']['input']>;
  payment?: InputMaybe<PaymentCreateNestedOneWithoutApplicationInput>;
  questions?: InputMaybe<Scalars['String']['input']>;
  rejectedReason?: InputMaybe<Scalars['String']['input']>;
  seenByBreeder?: InputMaybe<Scalars['Boolean']['input']>;
  seenByBuyer?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<DogBreederApplicationStatus>;
  statusHistory?: InputMaybe<DogBreederApplicationStatusHistoryCreateNestedManyWithoutApplicationInput>;
  timeAlone: DogBreederApplicationTimeAlone;
  trainers?: InputMaybe<Array<DogBreederApplicationTrainer>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DogBreederApplicationCreateWithoutDogBreederInput = {
  accommodation: DogBreederApplicationAccommodation;
  accommodationDescription?: InputMaybe<Scalars['String']['input']>;
  account: AccountCreateNestedOneWithoutApplicationsInput;
  animal?: InputMaybe<AnimalCreateNestedOneWithoutApplicationInput>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  breedPreference: DogBreedCreateNestedOneWithoutApplicationsInput;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  experiences?: InputMaybe<Array<DogBreederApplicationExperience>>;
  genderPreferences?: InputMaybe<Array<GenderEnum>>;
  motive?: InputMaybe<Scalars['String']['input']>;
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutApplicationInput>;
  otherAnimals?: InputMaybe<Array<DogBreederApplicationOtherAnimal>>;
  otherAnimalsDescription?: InputMaybe<Scalars['String']['input']>;
  otherPreferences?: InputMaybe<Scalars['String']['input']>;
  payment?: InputMaybe<PaymentCreateNestedOneWithoutApplicationInput>;
  questions?: InputMaybe<Scalars['String']['input']>;
  rejectedReason?: InputMaybe<Scalars['String']['input']>;
  seenByBreeder?: InputMaybe<Scalars['Boolean']['input']>;
  seenByBuyer?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<DogBreederApplicationStatus>;
  statusHistory?: InputMaybe<DogBreederApplicationStatusHistoryCreateNestedManyWithoutApplicationInput>;
  timeAlone: DogBreederApplicationTimeAlone;
  trainers?: InputMaybe<Array<DogBreederApplicationTrainer>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DogBreederApplicationCreateWithoutNotificationsInput = {
  accommodation: DogBreederApplicationAccommodation;
  accommodationDescription?: InputMaybe<Scalars['String']['input']>;
  account: AccountCreateNestedOneWithoutApplicationsInput;
  animal?: InputMaybe<AnimalCreateNestedOneWithoutApplicationInput>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  breedPreference: DogBreedCreateNestedOneWithoutApplicationsInput;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dogBreeder: DogBreederCreateNestedOneWithoutApplicationsInput;
  experiences?: InputMaybe<Array<DogBreederApplicationExperience>>;
  genderPreferences?: InputMaybe<Array<GenderEnum>>;
  motive?: InputMaybe<Scalars['String']['input']>;
  otherAnimals?: InputMaybe<Array<DogBreederApplicationOtherAnimal>>;
  otherAnimalsDescription?: InputMaybe<Scalars['String']['input']>;
  otherPreferences?: InputMaybe<Scalars['String']['input']>;
  payment?: InputMaybe<PaymentCreateNestedOneWithoutApplicationInput>;
  questions?: InputMaybe<Scalars['String']['input']>;
  rejectedReason?: InputMaybe<Scalars['String']['input']>;
  seenByBreeder?: InputMaybe<Scalars['Boolean']['input']>;
  seenByBuyer?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<DogBreederApplicationStatus>;
  statusHistory?: InputMaybe<DogBreederApplicationStatusHistoryCreateNestedManyWithoutApplicationInput>;
  timeAlone: DogBreederApplicationTimeAlone;
  trainers?: InputMaybe<Array<DogBreederApplicationTrainer>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DogBreederApplicationCreateWithoutPaymentInput = {
  accommodation: DogBreederApplicationAccommodation;
  accommodationDescription?: InputMaybe<Scalars['String']['input']>;
  account: AccountCreateNestedOneWithoutApplicationsInput;
  animal?: InputMaybe<AnimalCreateNestedOneWithoutApplicationInput>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  breedPreference: DogBreedCreateNestedOneWithoutApplicationsInput;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dogBreeder: DogBreederCreateNestedOneWithoutApplicationsInput;
  experiences?: InputMaybe<Array<DogBreederApplicationExperience>>;
  genderPreferences?: InputMaybe<Array<GenderEnum>>;
  motive?: InputMaybe<Scalars['String']['input']>;
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutApplicationInput>;
  otherAnimals?: InputMaybe<Array<DogBreederApplicationOtherAnimal>>;
  otherAnimalsDescription?: InputMaybe<Scalars['String']['input']>;
  otherPreferences?: InputMaybe<Scalars['String']['input']>;
  questions?: InputMaybe<Scalars['String']['input']>;
  rejectedReason?: InputMaybe<Scalars['String']['input']>;
  seenByBreeder?: InputMaybe<Scalars['Boolean']['input']>;
  seenByBuyer?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<DogBreederApplicationStatus>;
  statusHistory?: InputMaybe<DogBreederApplicationStatusHistoryCreateNestedManyWithoutApplicationInput>;
  timeAlone: DogBreederApplicationTimeAlone;
  trainers?: InputMaybe<Array<DogBreederApplicationTrainer>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DogBreederApplicationCreateWithoutStatusHistoryInput = {
  accommodation: DogBreederApplicationAccommodation;
  accommodationDescription?: InputMaybe<Scalars['String']['input']>;
  account: AccountCreateNestedOneWithoutApplicationsInput;
  animal?: InputMaybe<AnimalCreateNestedOneWithoutApplicationInput>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  breedPreference: DogBreedCreateNestedOneWithoutApplicationsInput;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dogBreeder: DogBreederCreateNestedOneWithoutApplicationsInput;
  experiences?: InputMaybe<Array<DogBreederApplicationExperience>>;
  genderPreferences?: InputMaybe<Array<GenderEnum>>;
  motive?: InputMaybe<Scalars['String']['input']>;
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutApplicationInput>;
  otherAnimals?: InputMaybe<Array<DogBreederApplicationOtherAnimal>>;
  otherAnimalsDescription?: InputMaybe<Scalars['String']['input']>;
  otherPreferences?: InputMaybe<Scalars['String']['input']>;
  payment?: InputMaybe<PaymentCreateNestedOneWithoutApplicationInput>;
  questions?: InputMaybe<Scalars['String']['input']>;
  rejectedReason?: InputMaybe<Scalars['String']['input']>;
  seenByBreeder?: InputMaybe<Scalars['Boolean']['input']>;
  seenByBuyer?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<DogBreederApplicationStatus>;
  timeAlone: DogBreederApplicationTimeAlone;
  trainers?: InputMaybe<Array<DogBreederApplicationTrainer>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DogBreederApplicationCreateexperiencesInput = {
  set: Array<DogBreederApplicationExperience>;
};

export type DogBreederApplicationCreategenderPreferencesInput = {
  set: Array<GenderEnum>;
};

export type DogBreederApplicationCreateotherAnimalsInput = {
  set: Array<DogBreederApplicationOtherAnimal>;
};

export type DogBreederApplicationCreatetrainersInput = {
  set: Array<DogBreederApplicationTrainer>;
};

export enum DogBreederApplicationExperience {
  LIVED_CHILDHOOD = 'LIVED_CHILDHOOD',
  LIVED_PARTNER = 'LIVED_PARTNER',
  NONE = 'NONE',
  OWNED = 'OWNED',
  WORKED = 'WORKED'
}

export enum DogBreederApplicationInitiatorEnum {
  ADMIN = 'ADMIN',
  BREEDER = 'BREEDER',
  BUYER = 'BUYER',
  SYSTEM = 'SYSTEM'
}

export type DogBreederApplicationListRelationFilter = {
  every?: InputMaybe<DogBreederApplicationWhereInput>;
  none?: InputMaybe<DogBreederApplicationWhereInput>;
  some?: InputMaybe<DogBreederApplicationWhereInput>;
};

export type DogBreederApplicationMaxAggregateOutputType = {
  __typename?: 'DogBreederApplicationMaxAggregateOutputType';
  accommodation?: Maybe<DogBreederApplicationAccommodation>;
  accommodationDescription?: Maybe<Scalars['String']['output']>;
  accountId?: Maybe<Scalars['Int']['output']>;
  animalId?: Maybe<Scalars['Int']['output']>;
  archived?: Maybe<Scalars['Boolean']['output']>;
  breedPreferenceId?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  dogBreederId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  motive?: Maybe<Scalars['String']['output']>;
  otherAnimalsDescription?: Maybe<Scalars['String']['output']>;
  otherPreferences?: Maybe<Scalars['String']['output']>;
  paymentId?: Maybe<Scalars['String']['output']>;
  questions?: Maybe<Scalars['String']['output']>;
  rejectedReason?: Maybe<Scalars['String']['output']>;
  seenByBreeder?: Maybe<Scalars['Boolean']['output']>;
  seenByBuyer?: Maybe<Scalars['Boolean']['output']>;
  status?: Maybe<DogBreederApplicationStatus>;
  timeAlone?: Maybe<DogBreederApplicationTimeAlone>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type DogBreederApplicationMaxOrderByAggregateInput = {
  accommodation?: InputMaybe<SortOrder>;
  accommodationDescription?: InputMaybe<SortOrder>;
  accountId?: InputMaybe<SortOrder>;
  animalId?: InputMaybe<SortOrder>;
  archived?: InputMaybe<SortOrder>;
  breedPreferenceId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  dogBreederId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  motive?: InputMaybe<SortOrder>;
  otherAnimalsDescription?: InputMaybe<SortOrder>;
  otherPreferences?: InputMaybe<SortOrder>;
  paymentId?: InputMaybe<SortOrder>;
  questions?: InputMaybe<SortOrder>;
  rejectedReason?: InputMaybe<SortOrder>;
  seenByBreeder?: InputMaybe<SortOrder>;
  seenByBuyer?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  timeAlone?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type DogBreederApplicationMinAggregateOutputType = {
  __typename?: 'DogBreederApplicationMinAggregateOutputType';
  accommodation?: Maybe<DogBreederApplicationAccommodation>;
  accommodationDescription?: Maybe<Scalars['String']['output']>;
  accountId?: Maybe<Scalars['Int']['output']>;
  animalId?: Maybe<Scalars['Int']['output']>;
  archived?: Maybe<Scalars['Boolean']['output']>;
  breedPreferenceId?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  dogBreederId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  motive?: Maybe<Scalars['String']['output']>;
  otherAnimalsDescription?: Maybe<Scalars['String']['output']>;
  otherPreferences?: Maybe<Scalars['String']['output']>;
  paymentId?: Maybe<Scalars['String']['output']>;
  questions?: Maybe<Scalars['String']['output']>;
  rejectedReason?: Maybe<Scalars['String']['output']>;
  seenByBreeder?: Maybe<Scalars['Boolean']['output']>;
  seenByBuyer?: Maybe<Scalars['Boolean']['output']>;
  status?: Maybe<DogBreederApplicationStatus>;
  timeAlone?: Maybe<DogBreederApplicationTimeAlone>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type DogBreederApplicationMinOrderByAggregateInput = {
  accommodation?: InputMaybe<SortOrder>;
  accommodationDescription?: InputMaybe<SortOrder>;
  accountId?: InputMaybe<SortOrder>;
  animalId?: InputMaybe<SortOrder>;
  archived?: InputMaybe<SortOrder>;
  breedPreferenceId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  dogBreederId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  motive?: InputMaybe<SortOrder>;
  otherAnimalsDescription?: InputMaybe<SortOrder>;
  otherPreferences?: InputMaybe<SortOrder>;
  paymentId?: InputMaybe<SortOrder>;
  questions?: InputMaybe<SortOrder>;
  rejectedReason?: InputMaybe<SortOrder>;
  seenByBreeder?: InputMaybe<SortOrder>;
  seenByBuyer?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  timeAlone?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type DogBreederApplicationNullableRelationFilter = {
  is?: InputMaybe<DogBreederApplicationWhereInput>;
  isNot?: InputMaybe<DogBreederApplicationWhereInput>;
};

export type DogBreederApplicationOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export enum DogBreederApplicationOrderByRelevanceFieldEnum {
  accommodationDescription = 'accommodationDescription',
  motive = 'motive',
  otherAnimalsDescription = 'otherAnimalsDescription',
  otherPreferences = 'otherPreferences',
  paymentId = 'paymentId',
  questions = 'questions',
  rejectedReason = 'rejectedReason'
}

export type DogBreederApplicationOrderByRelevanceInput = {
  fields: Array<DogBreederApplicationOrderByRelevanceFieldEnum>;
  search: Scalars['String']['input'];
  sort: SortOrder;
};

export type DogBreederApplicationOrderByWithAggregationInput = {
  _avg?: InputMaybe<DogBreederApplicationAvgOrderByAggregateInput>;
  _count?: InputMaybe<DogBreederApplicationCountOrderByAggregateInput>;
  _max?: InputMaybe<DogBreederApplicationMaxOrderByAggregateInput>;
  _min?: InputMaybe<DogBreederApplicationMinOrderByAggregateInput>;
  _sum?: InputMaybe<DogBreederApplicationSumOrderByAggregateInput>;
  accommodation?: InputMaybe<SortOrder>;
  accommodationDescription?: InputMaybe<SortOrderInput>;
  accountId?: InputMaybe<SortOrder>;
  animalId?: InputMaybe<SortOrderInput>;
  archived?: InputMaybe<SortOrder>;
  breedPreferenceId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  dogBreederId?: InputMaybe<SortOrder>;
  experiences?: InputMaybe<SortOrder>;
  genderPreferences?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  motive?: InputMaybe<SortOrderInput>;
  otherAnimals?: InputMaybe<SortOrder>;
  otherAnimalsDescription?: InputMaybe<SortOrderInput>;
  otherPreferences?: InputMaybe<SortOrderInput>;
  paymentId?: InputMaybe<SortOrderInput>;
  questions?: InputMaybe<SortOrderInput>;
  rejectedReason?: InputMaybe<SortOrderInput>;
  seenByBreeder?: InputMaybe<SortOrderInput>;
  seenByBuyer?: InputMaybe<SortOrderInput>;
  status?: InputMaybe<SortOrder>;
  timeAlone?: InputMaybe<SortOrder>;
  trainers?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type DogBreederApplicationOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: InputMaybe<DogBreederApplicationOrderByRelevanceInput>;
  accommodation?: InputMaybe<SortOrder>;
  accommodationDescription?: InputMaybe<SortOrderInput>;
  account?: InputMaybe<AccountOrderByWithRelationAndSearchRelevanceInput>;
  accountId?: InputMaybe<SortOrder>;
  animal?: InputMaybe<AnimalOrderByWithRelationAndSearchRelevanceInput>;
  animalId?: InputMaybe<SortOrderInput>;
  archived?: InputMaybe<SortOrder>;
  breedPreference?: InputMaybe<DogBreedOrderByWithRelationAndSearchRelevanceInput>;
  breedPreferenceId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  dogBreeder?: InputMaybe<DogBreederOrderByWithRelationAndSearchRelevanceInput>;
  dogBreederId?: InputMaybe<SortOrder>;
  experiences?: InputMaybe<SortOrder>;
  genderPreferences?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  motive?: InputMaybe<SortOrderInput>;
  notifications?: InputMaybe<NotificationOrderByRelationAggregateInput>;
  otherAnimals?: InputMaybe<SortOrder>;
  otherAnimalsDescription?: InputMaybe<SortOrderInput>;
  otherPreferences?: InputMaybe<SortOrderInput>;
  payment?: InputMaybe<PaymentOrderByWithRelationAndSearchRelevanceInput>;
  paymentId?: InputMaybe<SortOrderInput>;
  questions?: InputMaybe<SortOrderInput>;
  rejectedReason?: InputMaybe<SortOrderInput>;
  seenByBreeder?: InputMaybe<SortOrderInput>;
  seenByBuyer?: InputMaybe<SortOrderInput>;
  status?: InputMaybe<SortOrder>;
  statusHistory?: InputMaybe<DogBreederApplicationStatusHistoryOrderByRelationAggregateInput>;
  timeAlone?: InputMaybe<SortOrder>;
  trainers?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum DogBreederApplicationOtherAnimal {
  CATS = 'CATS',
  DOG = 'DOG',
  DOGS = 'DOGS',
  MAMMALS = 'MAMMALS',
  NONE = 'NONE',
  OTHER = 'OTHER'
}

export type DogBreederApplicationRelationFilter = {
  is?: InputMaybe<DogBreederApplicationWhereInput>;
  isNot?: InputMaybe<DogBreederApplicationWhereInput>;
};

export enum DogBreederApplicationScalarFieldEnum {
  accommodation = 'accommodation',
  accommodationDescription = 'accommodationDescription',
  accountId = 'accountId',
  animalId = 'animalId',
  archived = 'archived',
  breedPreferenceId = 'breedPreferenceId',
  createdAt = 'createdAt',
  dogBreederId = 'dogBreederId',
  experiences = 'experiences',
  genderPreferences = 'genderPreferences',
  id = 'id',
  motive = 'motive',
  otherAnimals = 'otherAnimals',
  otherAnimalsDescription = 'otherAnimalsDescription',
  otherPreferences = 'otherPreferences',
  paymentId = 'paymentId',
  questions = 'questions',
  rejectedReason = 'rejectedReason',
  seenByBreeder = 'seenByBreeder',
  seenByBuyer = 'seenByBuyer',
  status = 'status',
  timeAlone = 'timeAlone',
  trainers = 'trainers',
  updatedAt = 'updatedAt'
}

export type DogBreederApplicationScalarWhereInput = {
  AND?: InputMaybe<Array<DogBreederApplicationScalarWhereInput>>;
  NOT?: InputMaybe<Array<DogBreederApplicationScalarWhereInput>>;
  OR?: InputMaybe<Array<DogBreederApplicationScalarWhereInput>>;
  accommodation?: InputMaybe<EnumDogBreederApplicationAccommodationFilter>;
  accommodationDescription?: InputMaybe<StringNullableFilter>;
  accountId?: InputMaybe<IntFilter>;
  animalId?: InputMaybe<IntNullableFilter>;
  archived?: InputMaybe<BoolFilter>;
  breedPreferenceId?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  dogBreederId?: InputMaybe<IntFilter>;
  experiences?: InputMaybe<EnumDogBreederApplicationExperienceNullableListFilter>;
  genderPreferences?: InputMaybe<EnumGenderEnumNullableListFilter>;
  id?: InputMaybe<IntFilter>;
  motive?: InputMaybe<StringNullableFilter>;
  otherAnimals?: InputMaybe<EnumDogBreederApplicationOtherAnimalNullableListFilter>;
  otherAnimalsDescription?: InputMaybe<StringNullableFilter>;
  otherPreferences?: InputMaybe<StringNullableFilter>;
  paymentId?: InputMaybe<StringNullableFilter>;
  questions?: InputMaybe<StringNullableFilter>;
  rejectedReason?: InputMaybe<StringNullableFilter>;
  seenByBreeder?: InputMaybe<BoolNullableFilter>;
  seenByBuyer?: InputMaybe<BoolNullableFilter>;
  status?: InputMaybe<EnumDogBreederApplicationStatusFilter>;
  timeAlone?: InputMaybe<EnumDogBreederApplicationTimeAloneFilter>;
  trainers?: InputMaybe<EnumDogBreederApplicationTrainerNullableListFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type DogBreederApplicationScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<DogBreederApplicationScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<DogBreederApplicationScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<DogBreederApplicationScalarWhereWithAggregatesInput>>;
  accommodation?: InputMaybe<EnumDogBreederApplicationAccommodationWithAggregatesFilter>;
  accommodationDescription?: InputMaybe<StringNullableWithAggregatesFilter>;
  accountId?: InputMaybe<IntWithAggregatesFilter>;
  animalId?: InputMaybe<IntNullableWithAggregatesFilter>;
  archived?: InputMaybe<BoolWithAggregatesFilter>;
  breedPreferenceId?: InputMaybe<IntWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  dogBreederId?: InputMaybe<IntWithAggregatesFilter>;
  experiences?: InputMaybe<EnumDogBreederApplicationExperienceNullableListFilter>;
  genderPreferences?: InputMaybe<EnumGenderEnumNullableListFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  motive?: InputMaybe<StringNullableWithAggregatesFilter>;
  otherAnimals?: InputMaybe<EnumDogBreederApplicationOtherAnimalNullableListFilter>;
  otherAnimalsDescription?: InputMaybe<StringNullableWithAggregatesFilter>;
  otherPreferences?: InputMaybe<StringNullableWithAggregatesFilter>;
  paymentId?: InputMaybe<StringNullableWithAggregatesFilter>;
  questions?: InputMaybe<StringNullableWithAggregatesFilter>;
  rejectedReason?: InputMaybe<StringNullableWithAggregatesFilter>;
  seenByBreeder?: InputMaybe<BoolNullableWithAggregatesFilter>;
  seenByBuyer?: InputMaybe<BoolNullableWithAggregatesFilter>;
  status?: InputMaybe<EnumDogBreederApplicationStatusWithAggregatesFilter>;
  timeAlone?: InputMaybe<EnumDogBreederApplicationTimeAloneWithAggregatesFilter>;
  trainers?: InputMaybe<EnumDogBreederApplicationTrainerNullableListFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export enum DogBreederApplicationStatus {
  AWAITING_PAYMENT = 'AWAITING_PAYMENT',
  CANCELED = 'CANCELED',
  CONTACT_AVAILABLE = 'CONTACT_AVAILABLE',
  DONE = 'DONE',
  DRAFT = 'DRAFT',
  EXPIRED = 'EXPIRED',
  NONE = 'NONE',
  REFUNDED = 'REFUNDED',
  REJECTED = 'REJECTED',
  WAITING_LIST = 'WAITING_LIST'
}

export type DogBreederApplicationStatusHistory = {
  __typename?: 'DogBreederApplicationStatusHistory';
  application: DogBreederApplication;
  applicationId: Scalars['Int']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  initiatedBy: DogBreederApplicationInitiatorEnum;
  newStatus: DogBreederApplicationStatus;
  oldStatus: DogBreederApplicationStatus;
  reason?: Maybe<Scalars['String']['output']>;
};

export type DogBreederApplicationStatusHistoryAvgAggregateOutputType = {
  __typename?: 'DogBreederApplicationStatusHistoryAvgAggregateOutputType';
  applicationId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

export type DogBreederApplicationStatusHistoryAvgOrderByAggregateInput = {
  applicationId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export type DogBreederApplicationStatusHistoryCountAggregateOutputType = {
  __typename?: 'DogBreederApplicationStatusHistoryCountAggregateOutputType';
  _all: Scalars['Int']['output'];
  applicationId: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  newStatus: Scalars['Int']['output'];
  oldStatus: Scalars['Int']['output'];
};

export type DogBreederApplicationStatusHistoryCountOrderByAggregateInput = {
  applicationId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  newStatus?: InputMaybe<SortOrder>;
  oldStatus?: InputMaybe<SortOrder>;
};

export type DogBreederApplicationStatusHistoryCreateInput = {
  application: DogBreederApplicationCreateNestedOneWithoutStatusHistoryInput;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  newStatus: DogBreederApplicationStatus;
  oldStatus: DogBreederApplicationStatus;
};

export type DogBreederApplicationStatusHistoryCreateManyApplicationInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  newStatus: DogBreederApplicationStatus;
  oldStatus: DogBreederApplicationStatus;
};

export type DogBreederApplicationStatusHistoryCreateManyApplicationInputEnvelope = {
  data: Array<DogBreederApplicationStatusHistoryCreateManyApplicationInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DogBreederApplicationStatusHistoryCreateManyInput = {
  applicationId: Scalars['Int']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  newStatus: DogBreederApplicationStatus;
  oldStatus: DogBreederApplicationStatus;
};

export type DogBreederApplicationStatusHistoryCreateNestedManyWithoutApplicationInput = {
  connect?: InputMaybe<Array<DogBreederApplicationStatusHistoryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DogBreederApplicationStatusHistoryCreateOrConnectWithoutApplicationInput>>;
  create?: InputMaybe<Array<DogBreederApplicationStatusHistoryCreateWithoutApplicationInput>>;
  createMany?: InputMaybe<DogBreederApplicationStatusHistoryCreateManyApplicationInputEnvelope>;
};

export type DogBreederApplicationStatusHistoryCreateOrConnectWithoutApplicationInput = {
  create: DogBreederApplicationStatusHistoryCreateWithoutApplicationInput;
  where: DogBreederApplicationStatusHistoryWhereUniqueInput;
};

export type DogBreederApplicationStatusHistoryCreateWithoutApplicationInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  newStatus: DogBreederApplicationStatus;
  oldStatus: DogBreederApplicationStatus;
};

export type DogBreederApplicationStatusHistoryListRelationFilter = {
  every?: InputMaybe<DogBreederApplicationStatusHistoryWhereInput>;
  none?: InputMaybe<DogBreederApplicationStatusHistoryWhereInput>;
  some?: InputMaybe<DogBreederApplicationStatusHistoryWhereInput>;
};

export type DogBreederApplicationStatusHistoryMaxAggregateOutputType = {
  __typename?: 'DogBreederApplicationStatusHistoryMaxAggregateOutputType';
  applicationId?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  newStatus?: Maybe<DogBreederApplicationStatus>;
  oldStatus?: Maybe<DogBreederApplicationStatus>;
};

export type DogBreederApplicationStatusHistoryMaxOrderByAggregateInput = {
  applicationId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  newStatus?: InputMaybe<SortOrder>;
  oldStatus?: InputMaybe<SortOrder>;
};

export type DogBreederApplicationStatusHistoryMinAggregateOutputType = {
  __typename?: 'DogBreederApplicationStatusHistoryMinAggregateOutputType';
  applicationId?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  newStatus?: Maybe<DogBreederApplicationStatus>;
  oldStatus?: Maybe<DogBreederApplicationStatus>;
};

export type DogBreederApplicationStatusHistoryMinOrderByAggregateInput = {
  applicationId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  newStatus?: InputMaybe<SortOrder>;
  oldStatus?: InputMaybe<SortOrder>;
};

export type DogBreederApplicationStatusHistoryOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type DogBreederApplicationStatusHistoryOrderByWithAggregationInput = {
  _avg?: InputMaybe<DogBreederApplicationStatusHistoryAvgOrderByAggregateInput>;
  _count?: InputMaybe<DogBreederApplicationStatusHistoryCountOrderByAggregateInput>;
  _max?: InputMaybe<DogBreederApplicationStatusHistoryMaxOrderByAggregateInput>;
  _min?: InputMaybe<DogBreederApplicationStatusHistoryMinOrderByAggregateInput>;
  _sum?: InputMaybe<DogBreederApplicationStatusHistorySumOrderByAggregateInput>;
  applicationId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  newStatus?: InputMaybe<SortOrder>;
  oldStatus?: InputMaybe<SortOrder>;
};

export type DogBreederApplicationStatusHistoryOrderByWithRelationAndSearchRelevanceInput = {
  application?: InputMaybe<DogBreederApplicationOrderByWithRelationAndSearchRelevanceInput>;
  applicationId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  newStatus?: InputMaybe<SortOrder>;
  oldStatus?: InputMaybe<SortOrder>;
};

export enum DogBreederApplicationStatusHistoryScalarFieldEnum {
  applicationId = 'applicationId',
  createdAt = 'createdAt',
  id = 'id',
  newStatus = 'newStatus',
  oldStatus = 'oldStatus'
}

export type DogBreederApplicationStatusHistoryScalarWhereInput = {
  AND?: InputMaybe<Array<DogBreederApplicationStatusHistoryScalarWhereInput>>;
  NOT?: InputMaybe<Array<DogBreederApplicationStatusHistoryScalarWhereInput>>;
  OR?: InputMaybe<Array<DogBreederApplicationStatusHistoryScalarWhereInput>>;
  applicationId?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntFilter>;
  newStatus?: InputMaybe<EnumDogBreederApplicationStatusFilter>;
  oldStatus?: InputMaybe<EnumDogBreederApplicationStatusFilter>;
};

export type DogBreederApplicationStatusHistoryScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<DogBreederApplicationStatusHistoryScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<DogBreederApplicationStatusHistoryScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<DogBreederApplicationStatusHistoryScalarWhereWithAggregatesInput>>;
  applicationId?: InputMaybe<IntWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  newStatus?: InputMaybe<EnumDogBreederApplicationStatusWithAggregatesFilter>;
  oldStatus?: InputMaybe<EnumDogBreederApplicationStatusWithAggregatesFilter>;
};

export type DogBreederApplicationStatusHistorySumAggregateOutputType = {
  __typename?: 'DogBreederApplicationStatusHistorySumAggregateOutputType';
  applicationId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
};

export type DogBreederApplicationStatusHistorySumOrderByAggregateInput = {
  applicationId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export type DogBreederApplicationStatusHistoryUncheckedCreateInput = {
  applicationId: Scalars['Int']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  newStatus: DogBreederApplicationStatus;
  oldStatus: DogBreederApplicationStatus;
};

export type DogBreederApplicationStatusHistoryUncheckedCreateNestedManyWithoutApplicationInput = {
  connect?: InputMaybe<Array<DogBreederApplicationStatusHistoryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DogBreederApplicationStatusHistoryCreateOrConnectWithoutApplicationInput>>;
  create?: InputMaybe<Array<DogBreederApplicationStatusHistoryCreateWithoutApplicationInput>>;
  createMany?: InputMaybe<DogBreederApplicationStatusHistoryCreateManyApplicationInputEnvelope>;
};

export type DogBreederApplicationStatusHistoryUncheckedCreateWithoutApplicationInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  newStatus: DogBreederApplicationStatus;
  oldStatus: DogBreederApplicationStatus;
};

export type DogBreederApplicationStatusHistoryUncheckedUpdateInput = {
  applicationId?: InputMaybe<IntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  newStatus?: InputMaybe<EnumDogBreederApplicationStatusFieldUpdateOperationsInput>;
  oldStatus?: InputMaybe<EnumDogBreederApplicationStatusFieldUpdateOperationsInput>;
};

export type DogBreederApplicationStatusHistoryUncheckedUpdateManyInput = {
  applicationId?: InputMaybe<IntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  newStatus?: InputMaybe<EnumDogBreederApplicationStatusFieldUpdateOperationsInput>;
  oldStatus?: InputMaybe<EnumDogBreederApplicationStatusFieldUpdateOperationsInput>;
};

export type DogBreederApplicationStatusHistoryUncheckedUpdateManyWithoutApplicationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  newStatus?: InputMaybe<EnumDogBreederApplicationStatusFieldUpdateOperationsInput>;
  oldStatus?: InputMaybe<EnumDogBreederApplicationStatusFieldUpdateOperationsInput>;
};

export type DogBreederApplicationStatusHistoryUncheckedUpdateManyWithoutApplicationNestedInput = {
  connect?: InputMaybe<Array<DogBreederApplicationStatusHistoryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DogBreederApplicationStatusHistoryCreateOrConnectWithoutApplicationInput>>;
  create?: InputMaybe<Array<DogBreederApplicationStatusHistoryCreateWithoutApplicationInput>>;
  createMany?: InputMaybe<DogBreederApplicationStatusHistoryCreateManyApplicationInputEnvelope>;
  delete?: InputMaybe<Array<DogBreederApplicationStatusHistoryWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<DogBreederApplicationStatusHistoryScalarWhereInput>>;
  disconnect?: InputMaybe<Array<DogBreederApplicationStatusHistoryWhereUniqueInput>>;
  set?: InputMaybe<Array<DogBreederApplicationStatusHistoryWhereUniqueInput>>;
  update?: InputMaybe<Array<DogBreederApplicationStatusHistoryUpdateWithWhereUniqueWithoutApplicationInput>>;
  updateMany?: InputMaybe<Array<DogBreederApplicationStatusHistoryUpdateManyWithWhereWithoutApplicationInput>>;
  upsert?: InputMaybe<Array<DogBreederApplicationStatusHistoryUpsertWithWhereUniqueWithoutApplicationInput>>;
};

export type DogBreederApplicationStatusHistoryUncheckedUpdateWithoutApplicationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  newStatus?: InputMaybe<EnumDogBreederApplicationStatusFieldUpdateOperationsInput>;
  oldStatus?: InputMaybe<EnumDogBreederApplicationStatusFieldUpdateOperationsInput>;
};

export type DogBreederApplicationStatusHistoryUpdateInput = {
  application?: InputMaybe<DogBreederApplicationUpdateOneRequiredWithoutStatusHistoryNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  newStatus?: InputMaybe<EnumDogBreederApplicationStatusFieldUpdateOperationsInput>;
  oldStatus?: InputMaybe<EnumDogBreederApplicationStatusFieldUpdateOperationsInput>;
};

export type DogBreederApplicationStatusHistoryUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  newStatus?: InputMaybe<EnumDogBreederApplicationStatusFieldUpdateOperationsInput>;
  oldStatus?: InputMaybe<EnumDogBreederApplicationStatusFieldUpdateOperationsInput>;
};

export type DogBreederApplicationStatusHistoryUpdateManyWithWhereWithoutApplicationInput = {
  data: DogBreederApplicationStatusHistoryUpdateManyMutationInput;
  where: DogBreederApplicationStatusHistoryScalarWhereInput;
};

export type DogBreederApplicationStatusHistoryUpdateManyWithoutApplicationNestedInput = {
  connect?: InputMaybe<Array<DogBreederApplicationStatusHistoryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DogBreederApplicationStatusHistoryCreateOrConnectWithoutApplicationInput>>;
  create?: InputMaybe<Array<DogBreederApplicationStatusHistoryCreateWithoutApplicationInput>>;
  createMany?: InputMaybe<DogBreederApplicationStatusHistoryCreateManyApplicationInputEnvelope>;
  delete?: InputMaybe<Array<DogBreederApplicationStatusHistoryWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<DogBreederApplicationStatusHistoryScalarWhereInput>>;
  disconnect?: InputMaybe<Array<DogBreederApplicationStatusHistoryWhereUniqueInput>>;
  set?: InputMaybe<Array<DogBreederApplicationStatusHistoryWhereUniqueInput>>;
  update?: InputMaybe<Array<DogBreederApplicationStatusHistoryUpdateWithWhereUniqueWithoutApplicationInput>>;
  updateMany?: InputMaybe<Array<DogBreederApplicationStatusHistoryUpdateManyWithWhereWithoutApplicationInput>>;
  upsert?: InputMaybe<Array<DogBreederApplicationStatusHistoryUpsertWithWhereUniqueWithoutApplicationInput>>;
};

export type DogBreederApplicationStatusHistoryUpdateWithWhereUniqueWithoutApplicationInput = {
  data: DogBreederApplicationStatusHistoryUpdateWithoutApplicationInput;
  where: DogBreederApplicationStatusHistoryWhereUniqueInput;
};

export type DogBreederApplicationStatusHistoryUpdateWithoutApplicationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  newStatus?: InputMaybe<EnumDogBreederApplicationStatusFieldUpdateOperationsInput>;
  oldStatus?: InputMaybe<EnumDogBreederApplicationStatusFieldUpdateOperationsInput>;
};

export type DogBreederApplicationStatusHistoryUpsertWithWhereUniqueWithoutApplicationInput = {
  create: DogBreederApplicationStatusHistoryCreateWithoutApplicationInput;
  update: DogBreederApplicationStatusHistoryUpdateWithoutApplicationInput;
  where: DogBreederApplicationStatusHistoryWhereUniqueInput;
};

export type DogBreederApplicationStatusHistoryWhereInput = {
  AND?: InputMaybe<Array<DogBreederApplicationStatusHistoryWhereInput>>;
  NOT?: InputMaybe<Array<DogBreederApplicationStatusHistoryWhereInput>>;
  OR?: InputMaybe<Array<DogBreederApplicationStatusHistoryWhereInput>>;
  application?: InputMaybe<DogBreederApplicationRelationFilter>;
  applicationId?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntFilter>;
  newStatus?: InputMaybe<EnumDogBreederApplicationStatusFilter>;
  oldStatus?: InputMaybe<EnumDogBreederApplicationStatusFilter>;
};

export type DogBreederApplicationStatusHistoryWhereUniqueInput = {
  AND?: InputMaybe<Array<DogBreederApplicationStatusHistoryWhereInput>>;
  NOT?: InputMaybe<Array<DogBreederApplicationStatusHistoryWhereInput>>;
  OR?: InputMaybe<Array<DogBreederApplicationStatusHistoryWhereInput>>;
  application?: InputMaybe<DogBreederApplicationRelationFilter>;
  applicationId?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  newStatus?: InputMaybe<EnumDogBreederApplicationStatusFilter>;
  oldStatus?: InputMaybe<EnumDogBreederApplicationStatusFilter>;
};

export type DogBreederApplicationSumAggregateOutputType = {
  __typename?: 'DogBreederApplicationSumAggregateOutputType';
  accountId?: Maybe<Scalars['Int']['output']>;
  animalId?: Maybe<Scalars['Int']['output']>;
  breedPreferenceId?: Maybe<Scalars['Int']['output']>;
  dogBreederId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
};

export type DogBreederApplicationSumOrderByAggregateInput = {
  accountId?: InputMaybe<SortOrder>;
  animalId?: InputMaybe<SortOrder>;
  breedPreferenceId?: InputMaybe<SortOrder>;
  dogBreederId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export enum DogBreederApplicationTimeAlone {
  HIGH = 'HIGH',
  LOW = 'LOW',
  MEDIUM = 'MEDIUM'
}

export enum DogBreederApplicationTrainer {
  CHILDREN = 'CHILDREN',
  MYSELF = 'MYSELF',
  NEW_CHILDREN = 'NEW_CHILDREN',
  OTHER_ADULTS = 'OTHER_ADULTS',
  TEENAGERS = 'TEENAGERS',
  YOUNG_CHILDREN = 'YOUNG_CHILDREN'
}

export type DogBreederApplicationUncheckedCreateInput = {
  accommodation: DogBreederApplicationAccommodation;
  accommodationDescription?: InputMaybe<Scalars['String']['input']>;
  accountId: Scalars['Int']['input'];
  animalId?: InputMaybe<Scalars['Int']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  breedPreferenceId: Scalars['Int']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dogBreederId: Scalars['Int']['input'];
  experiences?: InputMaybe<Array<DogBreederApplicationExperience>>;
  genderPreferences?: InputMaybe<Array<GenderEnum>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  motive?: InputMaybe<Scalars['String']['input']>;
  notifications?: InputMaybe<NotificationUncheckedCreateNestedManyWithoutApplicationInput>;
  otherAnimals?: InputMaybe<Array<DogBreederApplicationOtherAnimal>>;
  otherAnimalsDescription?: InputMaybe<Scalars['String']['input']>;
  otherPreferences?: InputMaybe<Scalars['String']['input']>;
  paymentId?: InputMaybe<Scalars['String']['input']>;
  questions?: InputMaybe<Scalars['String']['input']>;
  rejectedReason?: InputMaybe<Scalars['String']['input']>;
  seenByBreeder?: InputMaybe<Scalars['Boolean']['input']>;
  seenByBuyer?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<DogBreederApplicationStatus>;
  statusHistory?: InputMaybe<DogBreederApplicationStatusHistoryUncheckedCreateNestedManyWithoutApplicationInput>;
  timeAlone: DogBreederApplicationTimeAlone;
  trainers?: InputMaybe<Array<DogBreederApplicationTrainer>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DogBreederApplicationUncheckedCreateNestedManyWithoutAccountInput = {
  connect?: InputMaybe<Array<DogBreederApplicationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DogBreederApplicationCreateOrConnectWithoutAccountInput>>;
  create?: InputMaybe<Array<DogBreederApplicationCreateWithoutAccountInput>>;
  createMany?: InputMaybe<DogBreederApplicationCreateManyAccountInputEnvelope>;
};

export type DogBreederApplicationUncheckedCreateNestedManyWithoutBreedPreferenceInput = {
  connect?: InputMaybe<Array<DogBreederApplicationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DogBreederApplicationCreateOrConnectWithoutBreedPreferenceInput>>;
  create?: InputMaybe<Array<DogBreederApplicationCreateWithoutBreedPreferenceInput>>;
  createMany?: InputMaybe<DogBreederApplicationCreateManyBreedPreferenceInputEnvelope>;
};

export type DogBreederApplicationUncheckedCreateNestedManyWithoutDogBreederInput = {
  connect?: InputMaybe<Array<DogBreederApplicationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DogBreederApplicationCreateOrConnectWithoutDogBreederInput>>;
  create?: InputMaybe<Array<DogBreederApplicationCreateWithoutDogBreederInput>>;
  createMany?: InputMaybe<DogBreederApplicationCreateManyDogBreederInputEnvelope>;
};

export type DogBreederApplicationUncheckedCreateNestedOneWithoutAnimalInput = {
  connect?: InputMaybe<DogBreederApplicationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DogBreederApplicationCreateOrConnectWithoutAnimalInput>;
  create?: InputMaybe<DogBreederApplicationCreateWithoutAnimalInput>;
};

export type DogBreederApplicationUncheckedCreateNestedOneWithoutPaymentInput = {
  connect?: InputMaybe<DogBreederApplicationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DogBreederApplicationCreateOrConnectWithoutPaymentInput>;
  create?: InputMaybe<DogBreederApplicationCreateWithoutPaymentInput>;
};

export type DogBreederApplicationUncheckedCreateWithoutAccountInput = {
  accommodation: DogBreederApplicationAccommodation;
  accommodationDescription?: InputMaybe<Scalars['String']['input']>;
  animalId?: InputMaybe<Scalars['Int']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  breedPreferenceId: Scalars['Int']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dogBreederId: Scalars['Int']['input'];
  experiences?: InputMaybe<Array<DogBreederApplicationExperience>>;
  genderPreferences?: InputMaybe<Array<GenderEnum>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  motive?: InputMaybe<Scalars['String']['input']>;
  notifications?: InputMaybe<NotificationUncheckedCreateNestedManyWithoutApplicationInput>;
  otherAnimals?: InputMaybe<Array<DogBreederApplicationOtherAnimal>>;
  otherAnimalsDescription?: InputMaybe<Scalars['String']['input']>;
  otherPreferences?: InputMaybe<Scalars['String']['input']>;
  paymentId?: InputMaybe<Scalars['String']['input']>;
  questions?: InputMaybe<Scalars['String']['input']>;
  rejectedReason?: InputMaybe<Scalars['String']['input']>;
  seenByBreeder?: InputMaybe<Scalars['Boolean']['input']>;
  seenByBuyer?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<DogBreederApplicationStatus>;
  statusHistory?: InputMaybe<DogBreederApplicationStatusHistoryUncheckedCreateNestedManyWithoutApplicationInput>;
  timeAlone: DogBreederApplicationTimeAlone;
  trainers?: InputMaybe<Array<DogBreederApplicationTrainer>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DogBreederApplicationUncheckedCreateWithoutAnimalInput = {
  accommodation: DogBreederApplicationAccommodation;
  accommodationDescription?: InputMaybe<Scalars['String']['input']>;
  accountId: Scalars['Int']['input'];
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  breedPreferenceId: Scalars['Int']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dogBreederId: Scalars['Int']['input'];
  experiences?: InputMaybe<Array<DogBreederApplicationExperience>>;
  genderPreferences?: InputMaybe<Array<GenderEnum>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  motive?: InputMaybe<Scalars['String']['input']>;
  notifications?: InputMaybe<NotificationUncheckedCreateNestedManyWithoutApplicationInput>;
  otherAnimals?: InputMaybe<Array<DogBreederApplicationOtherAnimal>>;
  otherAnimalsDescription?: InputMaybe<Scalars['String']['input']>;
  otherPreferences?: InputMaybe<Scalars['String']['input']>;
  paymentId?: InputMaybe<Scalars['String']['input']>;
  questions?: InputMaybe<Scalars['String']['input']>;
  rejectedReason?: InputMaybe<Scalars['String']['input']>;
  seenByBreeder?: InputMaybe<Scalars['Boolean']['input']>;
  seenByBuyer?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<DogBreederApplicationStatus>;
  statusHistory?: InputMaybe<DogBreederApplicationStatusHistoryUncheckedCreateNestedManyWithoutApplicationInput>;
  timeAlone: DogBreederApplicationTimeAlone;
  trainers?: InputMaybe<Array<DogBreederApplicationTrainer>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DogBreederApplicationUncheckedCreateWithoutBreedPreferenceInput = {
  accommodation: DogBreederApplicationAccommodation;
  accommodationDescription?: InputMaybe<Scalars['String']['input']>;
  accountId: Scalars['Int']['input'];
  animalId?: InputMaybe<Scalars['Int']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dogBreederId: Scalars['Int']['input'];
  experiences?: InputMaybe<Array<DogBreederApplicationExperience>>;
  genderPreferences?: InputMaybe<Array<GenderEnum>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  motive?: InputMaybe<Scalars['String']['input']>;
  notifications?: InputMaybe<NotificationUncheckedCreateNestedManyWithoutApplicationInput>;
  otherAnimals?: InputMaybe<Array<DogBreederApplicationOtherAnimal>>;
  otherAnimalsDescription?: InputMaybe<Scalars['String']['input']>;
  otherPreferences?: InputMaybe<Scalars['String']['input']>;
  paymentId?: InputMaybe<Scalars['String']['input']>;
  questions?: InputMaybe<Scalars['String']['input']>;
  rejectedReason?: InputMaybe<Scalars['String']['input']>;
  seenByBreeder?: InputMaybe<Scalars['Boolean']['input']>;
  seenByBuyer?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<DogBreederApplicationStatus>;
  statusHistory?: InputMaybe<DogBreederApplicationStatusHistoryUncheckedCreateNestedManyWithoutApplicationInput>;
  timeAlone: DogBreederApplicationTimeAlone;
  trainers?: InputMaybe<Array<DogBreederApplicationTrainer>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DogBreederApplicationUncheckedCreateWithoutDogBreederInput = {
  accommodation: DogBreederApplicationAccommodation;
  accommodationDescription?: InputMaybe<Scalars['String']['input']>;
  accountId: Scalars['Int']['input'];
  animalId?: InputMaybe<Scalars['Int']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  breedPreferenceId: Scalars['Int']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  experiences?: InputMaybe<Array<DogBreederApplicationExperience>>;
  genderPreferences?: InputMaybe<Array<GenderEnum>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  motive?: InputMaybe<Scalars['String']['input']>;
  notifications?: InputMaybe<NotificationUncheckedCreateNestedManyWithoutApplicationInput>;
  otherAnimals?: InputMaybe<Array<DogBreederApplicationOtherAnimal>>;
  otherAnimalsDescription?: InputMaybe<Scalars['String']['input']>;
  otherPreferences?: InputMaybe<Scalars['String']['input']>;
  paymentId?: InputMaybe<Scalars['String']['input']>;
  questions?: InputMaybe<Scalars['String']['input']>;
  rejectedReason?: InputMaybe<Scalars['String']['input']>;
  seenByBreeder?: InputMaybe<Scalars['Boolean']['input']>;
  seenByBuyer?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<DogBreederApplicationStatus>;
  statusHistory?: InputMaybe<DogBreederApplicationStatusHistoryUncheckedCreateNestedManyWithoutApplicationInput>;
  timeAlone: DogBreederApplicationTimeAlone;
  trainers?: InputMaybe<Array<DogBreederApplicationTrainer>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DogBreederApplicationUncheckedCreateWithoutNotificationsInput = {
  accommodation: DogBreederApplicationAccommodation;
  accommodationDescription?: InputMaybe<Scalars['String']['input']>;
  accountId: Scalars['Int']['input'];
  animalId?: InputMaybe<Scalars['Int']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  breedPreferenceId: Scalars['Int']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dogBreederId: Scalars['Int']['input'];
  experiences?: InputMaybe<Array<DogBreederApplicationExperience>>;
  genderPreferences?: InputMaybe<Array<GenderEnum>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  motive?: InputMaybe<Scalars['String']['input']>;
  otherAnimals?: InputMaybe<Array<DogBreederApplicationOtherAnimal>>;
  otherAnimalsDescription?: InputMaybe<Scalars['String']['input']>;
  otherPreferences?: InputMaybe<Scalars['String']['input']>;
  paymentId?: InputMaybe<Scalars['String']['input']>;
  questions?: InputMaybe<Scalars['String']['input']>;
  rejectedReason?: InputMaybe<Scalars['String']['input']>;
  seenByBreeder?: InputMaybe<Scalars['Boolean']['input']>;
  seenByBuyer?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<DogBreederApplicationStatus>;
  statusHistory?: InputMaybe<DogBreederApplicationStatusHistoryUncheckedCreateNestedManyWithoutApplicationInput>;
  timeAlone: DogBreederApplicationTimeAlone;
  trainers?: InputMaybe<Array<DogBreederApplicationTrainer>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DogBreederApplicationUncheckedCreateWithoutPaymentInput = {
  accommodation: DogBreederApplicationAccommodation;
  accommodationDescription?: InputMaybe<Scalars['String']['input']>;
  accountId: Scalars['Int']['input'];
  animalId?: InputMaybe<Scalars['Int']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  breedPreferenceId: Scalars['Int']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dogBreederId: Scalars['Int']['input'];
  experiences?: InputMaybe<Array<DogBreederApplicationExperience>>;
  genderPreferences?: InputMaybe<Array<GenderEnum>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  motive?: InputMaybe<Scalars['String']['input']>;
  notifications?: InputMaybe<NotificationUncheckedCreateNestedManyWithoutApplicationInput>;
  otherAnimals?: InputMaybe<Array<DogBreederApplicationOtherAnimal>>;
  otherAnimalsDescription?: InputMaybe<Scalars['String']['input']>;
  otherPreferences?: InputMaybe<Scalars['String']['input']>;
  questions?: InputMaybe<Scalars['String']['input']>;
  rejectedReason?: InputMaybe<Scalars['String']['input']>;
  seenByBreeder?: InputMaybe<Scalars['Boolean']['input']>;
  seenByBuyer?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<DogBreederApplicationStatus>;
  statusHistory?: InputMaybe<DogBreederApplicationStatusHistoryUncheckedCreateNestedManyWithoutApplicationInput>;
  timeAlone: DogBreederApplicationTimeAlone;
  trainers?: InputMaybe<Array<DogBreederApplicationTrainer>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DogBreederApplicationUncheckedCreateWithoutStatusHistoryInput = {
  accommodation: DogBreederApplicationAccommodation;
  accommodationDescription?: InputMaybe<Scalars['String']['input']>;
  accountId: Scalars['Int']['input'];
  animalId?: InputMaybe<Scalars['Int']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  breedPreferenceId: Scalars['Int']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dogBreederId: Scalars['Int']['input'];
  experiences?: InputMaybe<Array<DogBreederApplicationExperience>>;
  genderPreferences?: InputMaybe<Array<GenderEnum>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  motive?: InputMaybe<Scalars['String']['input']>;
  notifications?: InputMaybe<NotificationUncheckedCreateNestedManyWithoutApplicationInput>;
  otherAnimals?: InputMaybe<Array<DogBreederApplicationOtherAnimal>>;
  otherAnimalsDescription?: InputMaybe<Scalars['String']['input']>;
  otherPreferences?: InputMaybe<Scalars['String']['input']>;
  paymentId?: InputMaybe<Scalars['String']['input']>;
  questions?: InputMaybe<Scalars['String']['input']>;
  rejectedReason?: InputMaybe<Scalars['String']['input']>;
  seenByBreeder?: InputMaybe<Scalars['Boolean']['input']>;
  seenByBuyer?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<DogBreederApplicationStatus>;
  timeAlone: DogBreederApplicationTimeAlone;
  trainers?: InputMaybe<Array<DogBreederApplicationTrainer>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DogBreederApplicationUncheckedUpdateInput = {
  accommodation?: InputMaybe<EnumDogBreederApplicationAccommodationFieldUpdateOperationsInput>;
  accommodationDescription?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  accountId?: InputMaybe<IntFieldUpdateOperationsInput>;
  animalId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  archived?: InputMaybe<BoolFieldUpdateOperationsInput>;
  breedPreferenceId?: InputMaybe<IntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dogBreederId?: InputMaybe<IntFieldUpdateOperationsInput>;
  experiences?: InputMaybe<Array<DogBreederApplicationExperience>>;
  genderPreferences?: InputMaybe<Array<GenderEnum>>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  motive?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUncheckedUpdateManyWithoutApplicationNestedInput>;
  otherAnimals?: InputMaybe<Array<DogBreederApplicationOtherAnimal>>;
  otherAnimalsDescription?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  otherPreferences?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  paymentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  questions?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  rejectedReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  seenByBreeder?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  seenByBuyer?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumDogBreederApplicationStatusFieldUpdateOperationsInput>;
  statusHistory?: InputMaybe<DogBreederApplicationStatusHistoryUncheckedUpdateManyWithoutApplicationNestedInput>;
  timeAlone?: InputMaybe<EnumDogBreederApplicationTimeAloneFieldUpdateOperationsInput>;
  trainers?: InputMaybe<Array<DogBreederApplicationTrainer>>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DogBreederApplicationUncheckedUpdateManyInput = {
  accommodation?: InputMaybe<EnumDogBreederApplicationAccommodationFieldUpdateOperationsInput>;
  accommodationDescription?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  accountId?: InputMaybe<IntFieldUpdateOperationsInput>;
  animalId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  archived?: InputMaybe<BoolFieldUpdateOperationsInput>;
  breedPreferenceId?: InputMaybe<IntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dogBreederId?: InputMaybe<IntFieldUpdateOperationsInput>;
  experiences?: InputMaybe<Array<DogBreederApplicationExperience>>;
  genderPreferences?: InputMaybe<Array<GenderEnum>>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  motive?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  otherAnimals?: InputMaybe<Array<DogBreederApplicationOtherAnimal>>;
  otherAnimalsDescription?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  otherPreferences?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  paymentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  questions?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  rejectedReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  seenByBreeder?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  seenByBuyer?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumDogBreederApplicationStatusFieldUpdateOperationsInput>;
  timeAlone?: InputMaybe<EnumDogBreederApplicationTimeAloneFieldUpdateOperationsInput>;
  trainers?: InputMaybe<Array<DogBreederApplicationTrainer>>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DogBreederApplicationUncheckedUpdateManyWithoutAccountInput = {
  accommodation?: InputMaybe<EnumDogBreederApplicationAccommodationFieldUpdateOperationsInput>;
  accommodationDescription?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  animalId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  archived?: InputMaybe<BoolFieldUpdateOperationsInput>;
  breedPreferenceId?: InputMaybe<IntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dogBreederId?: InputMaybe<IntFieldUpdateOperationsInput>;
  experiences?: InputMaybe<Array<DogBreederApplicationExperience>>;
  genderPreferences?: InputMaybe<Array<GenderEnum>>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  motive?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  otherAnimals?: InputMaybe<Array<DogBreederApplicationOtherAnimal>>;
  otherAnimalsDescription?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  otherPreferences?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  paymentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  questions?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  rejectedReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  seenByBreeder?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  seenByBuyer?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumDogBreederApplicationStatusFieldUpdateOperationsInput>;
  timeAlone?: InputMaybe<EnumDogBreederApplicationTimeAloneFieldUpdateOperationsInput>;
  trainers?: InputMaybe<Array<DogBreederApplicationTrainer>>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DogBreederApplicationUncheckedUpdateManyWithoutAccountNestedInput = {
  connect?: InputMaybe<Array<DogBreederApplicationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DogBreederApplicationCreateOrConnectWithoutAccountInput>>;
  create?: InputMaybe<Array<DogBreederApplicationCreateWithoutAccountInput>>;
  createMany?: InputMaybe<DogBreederApplicationCreateManyAccountInputEnvelope>;
  delete?: InputMaybe<Array<DogBreederApplicationWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<DogBreederApplicationScalarWhereInput>>;
  disconnect?: InputMaybe<Array<DogBreederApplicationWhereUniqueInput>>;
  set?: InputMaybe<Array<DogBreederApplicationWhereUniqueInput>>;
  update?: InputMaybe<Array<DogBreederApplicationUpdateWithWhereUniqueWithoutAccountInput>>;
  updateMany?: InputMaybe<Array<DogBreederApplicationUpdateManyWithWhereWithoutAccountInput>>;
  upsert?: InputMaybe<Array<DogBreederApplicationUpsertWithWhereUniqueWithoutAccountInput>>;
};

export type DogBreederApplicationUncheckedUpdateManyWithoutBreedPreferenceInput = {
  accommodation?: InputMaybe<EnumDogBreederApplicationAccommodationFieldUpdateOperationsInput>;
  accommodationDescription?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  accountId?: InputMaybe<IntFieldUpdateOperationsInput>;
  animalId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  archived?: InputMaybe<BoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dogBreederId?: InputMaybe<IntFieldUpdateOperationsInput>;
  experiences?: InputMaybe<Array<DogBreederApplicationExperience>>;
  genderPreferences?: InputMaybe<Array<GenderEnum>>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  motive?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  otherAnimals?: InputMaybe<Array<DogBreederApplicationOtherAnimal>>;
  otherAnimalsDescription?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  otherPreferences?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  paymentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  questions?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  rejectedReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  seenByBreeder?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  seenByBuyer?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumDogBreederApplicationStatusFieldUpdateOperationsInput>;
  timeAlone?: InputMaybe<EnumDogBreederApplicationTimeAloneFieldUpdateOperationsInput>;
  trainers?: InputMaybe<Array<DogBreederApplicationTrainer>>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DogBreederApplicationUncheckedUpdateManyWithoutBreedPreferenceNestedInput = {
  connect?: InputMaybe<Array<DogBreederApplicationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DogBreederApplicationCreateOrConnectWithoutBreedPreferenceInput>>;
  create?: InputMaybe<Array<DogBreederApplicationCreateWithoutBreedPreferenceInput>>;
  createMany?: InputMaybe<DogBreederApplicationCreateManyBreedPreferenceInputEnvelope>;
  delete?: InputMaybe<Array<DogBreederApplicationWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<DogBreederApplicationScalarWhereInput>>;
  disconnect?: InputMaybe<Array<DogBreederApplicationWhereUniqueInput>>;
  set?: InputMaybe<Array<DogBreederApplicationWhereUniqueInput>>;
  update?: InputMaybe<Array<DogBreederApplicationUpdateWithWhereUniqueWithoutBreedPreferenceInput>>;
  updateMany?: InputMaybe<Array<DogBreederApplicationUpdateManyWithWhereWithoutBreedPreferenceInput>>;
  upsert?: InputMaybe<Array<DogBreederApplicationUpsertWithWhereUniqueWithoutBreedPreferenceInput>>;
};

export type DogBreederApplicationUncheckedUpdateManyWithoutDogBreederInput = {
  accommodation?: InputMaybe<EnumDogBreederApplicationAccommodationFieldUpdateOperationsInput>;
  accommodationDescription?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  accountId?: InputMaybe<IntFieldUpdateOperationsInput>;
  animalId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  archived?: InputMaybe<BoolFieldUpdateOperationsInput>;
  breedPreferenceId?: InputMaybe<IntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  experiences?: InputMaybe<Array<DogBreederApplicationExperience>>;
  genderPreferences?: InputMaybe<Array<GenderEnum>>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  motive?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  otherAnimals?: InputMaybe<Array<DogBreederApplicationOtherAnimal>>;
  otherAnimalsDescription?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  otherPreferences?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  paymentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  questions?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  rejectedReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  seenByBreeder?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  seenByBuyer?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumDogBreederApplicationStatusFieldUpdateOperationsInput>;
  timeAlone?: InputMaybe<EnumDogBreederApplicationTimeAloneFieldUpdateOperationsInput>;
  trainers?: InputMaybe<Array<DogBreederApplicationTrainer>>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DogBreederApplicationUncheckedUpdateManyWithoutDogBreederNestedInput = {
  connect?: InputMaybe<Array<DogBreederApplicationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DogBreederApplicationCreateOrConnectWithoutDogBreederInput>>;
  create?: InputMaybe<Array<DogBreederApplicationCreateWithoutDogBreederInput>>;
  createMany?: InputMaybe<DogBreederApplicationCreateManyDogBreederInputEnvelope>;
  delete?: InputMaybe<Array<DogBreederApplicationWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<DogBreederApplicationScalarWhereInput>>;
  disconnect?: InputMaybe<Array<DogBreederApplicationWhereUniqueInput>>;
  set?: InputMaybe<Array<DogBreederApplicationWhereUniqueInput>>;
  update?: InputMaybe<Array<DogBreederApplicationUpdateWithWhereUniqueWithoutDogBreederInput>>;
  updateMany?: InputMaybe<Array<DogBreederApplicationUpdateManyWithWhereWithoutDogBreederInput>>;
  upsert?: InputMaybe<Array<DogBreederApplicationUpsertWithWhereUniqueWithoutDogBreederInput>>;
};

export type DogBreederApplicationUncheckedUpdateOneWithoutAnimalNestedInput = {
  connect?: InputMaybe<DogBreederApplicationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DogBreederApplicationCreateOrConnectWithoutAnimalInput>;
  create?: InputMaybe<DogBreederApplicationCreateWithoutAnimalInput>;
  delete?: InputMaybe<DogBreederApplicationWhereInput>;
  disconnect?: InputMaybe<DogBreederApplicationWhereInput>;
  update?: InputMaybe<DogBreederApplicationUpdateToOneWithWhereWithoutAnimalInput>;
  upsert?: InputMaybe<DogBreederApplicationUpsertWithoutAnimalInput>;
};

export type DogBreederApplicationUncheckedUpdateOneWithoutPaymentNestedInput = {
  connect?: InputMaybe<DogBreederApplicationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DogBreederApplicationCreateOrConnectWithoutPaymentInput>;
  create?: InputMaybe<DogBreederApplicationCreateWithoutPaymentInput>;
  delete?: InputMaybe<DogBreederApplicationWhereInput>;
  disconnect?: InputMaybe<DogBreederApplicationWhereInput>;
  update?: InputMaybe<DogBreederApplicationUpdateToOneWithWhereWithoutPaymentInput>;
  upsert?: InputMaybe<DogBreederApplicationUpsertWithoutPaymentInput>;
};

export type DogBreederApplicationUncheckedUpdateWithoutAccountInput = {
  accommodation?: InputMaybe<EnumDogBreederApplicationAccommodationFieldUpdateOperationsInput>;
  accommodationDescription?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  animalId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  archived?: InputMaybe<BoolFieldUpdateOperationsInput>;
  breedPreferenceId?: InputMaybe<IntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dogBreederId?: InputMaybe<IntFieldUpdateOperationsInput>;
  experiences?: InputMaybe<Array<DogBreederApplicationExperience>>;
  genderPreferences?: InputMaybe<Array<GenderEnum>>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  motive?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUncheckedUpdateManyWithoutApplicationNestedInput>;
  otherAnimals?: InputMaybe<Array<DogBreederApplicationOtherAnimal>>;
  otherAnimalsDescription?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  otherPreferences?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  paymentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  questions?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  rejectedReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  seenByBreeder?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  seenByBuyer?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumDogBreederApplicationStatusFieldUpdateOperationsInput>;
  statusHistory?: InputMaybe<DogBreederApplicationStatusHistoryUncheckedUpdateManyWithoutApplicationNestedInput>;
  timeAlone?: InputMaybe<EnumDogBreederApplicationTimeAloneFieldUpdateOperationsInput>;
  trainers?: InputMaybe<Array<DogBreederApplicationTrainer>>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DogBreederApplicationUncheckedUpdateWithoutAnimalInput = {
  accommodation?: InputMaybe<EnumDogBreederApplicationAccommodationFieldUpdateOperationsInput>;
  accommodationDescription?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  accountId?: InputMaybe<IntFieldUpdateOperationsInput>;
  archived?: InputMaybe<BoolFieldUpdateOperationsInput>;
  breedPreferenceId?: InputMaybe<IntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dogBreederId?: InputMaybe<IntFieldUpdateOperationsInput>;
  experiences?: InputMaybe<Array<DogBreederApplicationExperience>>;
  genderPreferences?: InputMaybe<Array<GenderEnum>>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  motive?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUncheckedUpdateManyWithoutApplicationNestedInput>;
  otherAnimals?: InputMaybe<Array<DogBreederApplicationOtherAnimal>>;
  otherAnimalsDescription?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  otherPreferences?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  paymentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  questions?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  rejectedReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  seenByBreeder?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  seenByBuyer?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumDogBreederApplicationStatusFieldUpdateOperationsInput>;
  statusHistory?: InputMaybe<DogBreederApplicationStatusHistoryUncheckedUpdateManyWithoutApplicationNestedInput>;
  timeAlone?: InputMaybe<EnumDogBreederApplicationTimeAloneFieldUpdateOperationsInput>;
  trainers?: InputMaybe<Array<DogBreederApplicationTrainer>>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DogBreederApplicationUncheckedUpdateWithoutBreedPreferenceInput = {
  accommodation?: InputMaybe<EnumDogBreederApplicationAccommodationFieldUpdateOperationsInput>;
  accommodationDescription?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  accountId?: InputMaybe<IntFieldUpdateOperationsInput>;
  animalId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  archived?: InputMaybe<BoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dogBreederId?: InputMaybe<IntFieldUpdateOperationsInput>;
  experiences?: InputMaybe<Array<DogBreederApplicationExperience>>;
  genderPreferences?: InputMaybe<Array<GenderEnum>>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  motive?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUncheckedUpdateManyWithoutApplicationNestedInput>;
  otherAnimals?: InputMaybe<Array<DogBreederApplicationOtherAnimal>>;
  otherAnimalsDescription?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  otherPreferences?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  paymentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  questions?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  rejectedReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  seenByBreeder?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  seenByBuyer?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumDogBreederApplicationStatusFieldUpdateOperationsInput>;
  statusHistory?: InputMaybe<DogBreederApplicationStatusHistoryUncheckedUpdateManyWithoutApplicationNestedInput>;
  timeAlone?: InputMaybe<EnumDogBreederApplicationTimeAloneFieldUpdateOperationsInput>;
  trainers?: InputMaybe<Array<DogBreederApplicationTrainer>>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DogBreederApplicationUncheckedUpdateWithoutDogBreederInput = {
  accommodation?: InputMaybe<EnumDogBreederApplicationAccommodationFieldUpdateOperationsInput>;
  accommodationDescription?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  accountId?: InputMaybe<IntFieldUpdateOperationsInput>;
  animalId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  archived?: InputMaybe<BoolFieldUpdateOperationsInput>;
  breedPreferenceId?: InputMaybe<IntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  experiences?: InputMaybe<Array<DogBreederApplicationExperience>>;
  genderPreferences?: InputMaybe<Array<GenderEnum>>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  motive?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUncheckedUpdateManyWithoutApplicationNestedInput>;
  otherAnimals?: InputMaybe<Array<DogBreederApplicationOtherAnimal>>;
  otherAnimalsDescription?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  otherPreferences?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  paymentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  questions?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  rejectedReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  seenByBreeder?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  seenByBuyer?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumDogBreederApplicationStatusFieldUpdateOperationsInput>;
  statusHistory?: InputMaybe<DogBreederApplicationStatusHistoryUncheckedUpdateManyWithoutApplicationNestedInput>;
  timeAlone?: InputMaybe<EnumDogBreederApplicationTimeAloneFieldUpdateOperationsInput>;
  trainers?: InputMaybe<Array<DogBreederApplicationTrainer>>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DogBreederApplicationUncheckedUpdateWithoutNotificationsInput = {
  accommodation?: InputMaybe<EnumDogBreederApplicationAccommodationFieldUpdateOperationsInput>;
  accommodationDescription?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  accountId?: InputMaybe<IntFieldUpdateOperationsInput>;
  animalId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  archived?: InputMaybe<BoolFieldUpdateOperationsInput>;
  breedPreferenceId?: InputMaybe<IntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dogBreederId?: InputMaybe<IntFieldUpdateOperationsInput>;
  experiences?: InputMaybe<Array<DogBreederApplicationExperience>>;
  genderPreferences?: InputMaybe<Array<GenderEnum>>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  motive?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  otherAnimals?: InputMaybe<Array<DogBreederApplicationOtherAnimal>>;
  otherAnimalsDescription?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  otherPreferences?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  paymentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  questions?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  rejectedReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  seenByBreeder?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  seenByBuyer?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumDogBreederApplicationStatusFieldUpdateOperationsInput>;
  statusHistory?: InputMaybe<DogBreederApplicationStatusHistoryUncheckedUpdateManyWithoutApplicationNestedInput>;
  timeAlone?: InputMaybe<EnumDogBreederApplicationTimeAloneFieldUpdateOperationsInput>;
  trainers?: InputMaybe<Array<DogBreederApplicationTrainer>>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DogBreederApplicationUncheckedUpdateWithoutPaymentInput = {
  accommodation?: InputMaybe<EnumDogBreederApplicationAccommodationFieldUpdateOperationsInput>;
  accommodationDescription?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  accountId?: InputMaybe<IntFieldUpdateOperationsInput>;
  animalId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  archived?: InputMaybe<BoolFieldUpdateOperationsInput>;
  breedPreferenceId?: InputMaybe<IntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dogBreederId?: InputMaybe<IntFieldUpdateOperationsInput>;
  experiences?: InputMaybe<Array<DogBreederApplicationExperience>>;
  genderPreferences?: InputMaybe<Array<GenderEnum>>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  motive?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUncheckedUpdateManyWithoutApplicationNestedInput>;
  otherAnimals?: InputMaybe<Array<DogBreederApplicationOtherAnimal>>;
  otherAnimalsDescription?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  otherPreferences?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  questions?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  rejectedReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  seenByBreeder?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  seenByBuyer?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumDogBreederApplicationStatusFieldUpdateOperationsInput>;
  statusHistory?: InputMaybe<DogBreederApplicationStatusHistoryUncheckedUpdateManyWithoutApplicationNestedInput>;
  timeAlone?: InputMaybe<EnumDogBreederApplicationTimeAloneFieldUpdateOperationsInput>;
  trainers?: InputMaybe<Array<DogBreederApplicationTrainer>>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DogBreederApplicationUncheckedUpdateWithoutStatusHistoryInput = {
  accommodation?: InputMaybe<EnumDogBreederApplicationAccommodationFieldUpdateOperationsInput>;
  accommodationDescription?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  accountId?: InputMaybe<IntFieldUpdateOperationsInput>;
  animalId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  archived?: InputMaybe<BoolFieldUpdateOperationsInput>;
  breedPreferenceId?: InputMaybe<IntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dogBreederId?: InputMaybe<IntFieldUpdateOperationsInput>;
  experiences?: InputMaybe<Array<DogBreederApplicationExperience>>;
  genderPreferences?: InputMaybe<Array<GenderEnum>>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  motive?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUncheckedUpdateManyWithoutApplicationNestedInput>;
  otherAnimals?: InputMaybe<Array<DogBreederApplicationOtherAnimal>>;
  otherAnimalsDescription?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  otherPreferences?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  paymentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  questions?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  rejectedReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  seenByBreeder?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  seenByBuyer?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumDogBreederApplicationStatusFieldUpdateOperationsInput>;
  timeAlone?: InputMaybe<EnumDogBreederApplicationTimeAloneFieldUpdateOperationsInput>;
  trainers?: InputMaybe<Array<DogBreederApplicationTrainer>>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DogBreederApplicationUpdateInput = {
  accommodation?: InputMaybe<EnumDogBreederApplicationAccommodationFieldUpdateOperationsInput>;
  accommodationDescription?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  account?: InputMaybe<AccountUpdateOneRequiredWithoutApplicationsNestedInput>;
  animal?: InputMaybe<AnimalUpdateOneWithoutApplicationNestedInput>;
  archived?: InputMaybe<BoolFieldUpdateOperationsInput>;
  breedPreference?: InputMaybe<DogBreedUpdateOneRequiredWithoutApplicationsNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dogBreeder?: InputMaybe<DogBreederUpdateOneRequiredWithoutApplicationsNestedInput>;
  experiences?: InputMaybe<Array<DogBreederApplicationExperience>>;
  genderPreferences?: InputMaybe<Array<GenderEnum>>;
  motive?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutApplicationNestedInput>;
  otherAnimals?: InputMaybe<Array<DogBreederApplicationOtherAnimal>>;
  otherAnimalsDescription?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  otherPreferences?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payment?: InputMaybe<PaymentUpdateOneWithoutApplicationNestedInput>;
  questions?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  rejectedReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  seenByBreeder?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  seenByBuyer?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumDogBreederApplicationStatusFieldUpdateOperationsInput>;
  statusHistory?: InputMaybe<DogBreederApplicationStatusHistoryUpdateManyWithoutApplicationNestedInput>;
  timeAlone?: InputMaybe<EnumDogBreederApplicationTimeAloneFieldUpdateOperationsInput>;
  trainers?: InputMaybe<Array<DogBreederApplicationTrainer>>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DogBreederApplicationUpdateManyMutationInput = {
  accommodation?: InputMaybe<EnumDogBreederApplicationAccommodationFieldUpdateOperationsInput>;
  accommodationDescription?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  archived?: InputMaybe<BoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  experiences?: InputMaybe<Array<DogBreederApplicationExperience>>;
  genderPreferences?: InputMaybe<Array<GenderEnum>>;
  motive?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  otherAnimals?: InputMaybe<Array<DogBreederApplicationOtherAnimal>>;
  otherAnimalsDescription?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  otherPreferences?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  questions?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  rejectedReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  seenByBreeder?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  seenByBuyer?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumDogBreederApplicationStatusFieldUpdateOperationsInput>;
  timeAlone?: InputMaybe<EnumDogBreederApplicationTimeAloneFieldUpdateOperationsInput>;
  trainers?: InputMaybe<Array<DogBreederApplicationTrainer>>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DogBreederApplicationUpdateManyWithWhereWithoutAccountInput = {
  data: DogBreederApplicationUpdateManyMutationInput;
  where: DogBreederApplicationScalarWhereInput;
};

export type DogBreederApplicationUpdateManyWithWhereWithoutBreedPreferenceInput = {
  data: DogBreederApplicationUpdateManyMutationInput;
  where: DogBreederApplicationScalarWhereInput;
};

export type DogBreederApplicationUpdateManyWithWhereWithoutDogBreederInput = {
  data: DogBreederApplicationUpdateManyMutationInput;
  where: DogBreederApplicationScalarWhereInput;
};

export type DogBreederApplicationUpdateManyWithoutAccountNestedInput = {
  connect?: InputMaybe<Array<DogBreederApplicationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DogBreederApplicationCreateOrConnectWithoutAccountInput>>;
  create?: InputMaybe<Array<DogBreederApplicationCreateWithoutAccountInput>>;
  createMany?: InputMaybe<DogBreederApplicationCreateManyAccountInputEnvelope>;
  delete?: InputMaybe<Array<DogBreederApplicationWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<DogBreederApplicationScalarWhereInput>>;
  disconnect?: InputMaybe<Array<DogBreederApplicationWhereUniqueInput>>;
  set?: InputMaybe<Array<DogBreederApplicationWhereUniqueInput>>;
  update?: InputMaybe<Array<DogBreederApplicationUpdateWithWhereUniqueWithoutAccountInput>>;
  updateMany?: InputMaybe<Array<DogBreederApplicationUpdateManyWithWhereWithoutAccountInput>>;
  upsert?: InputMaybe<Array<DogBreederApplicationUpsertWithWhereUniqueWithoutAccountInput>>;
};

export type DogBreederApplicationUpdateManyWithoutBreedPreferenceNestedInput = {
  connect?: InputMaybe<Array<DogBreederApplicationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DogBreederApplicationCreateOrConnectWithoutBreedPreferenceInput>>;
  create?: InputMaybe<Array<DogBreederApplicationCreateWithoutBreedPreferenceInput>>;
  createMany?: InputMaybe<DogBreederApplicationCreateManyBreedPreferenceInputEnvelope>;
  delete?: InputMaybe<Array<DogBreederApplicationWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<DogBreederApplicationScalarWhereInput>>;
  disconnect?: InputMaybe<Array<DogBreederApplicationWhereUniqueInput>>;
  set?: InputMaybe<Array<DogBreederApplicationWhereUniqueInput>>;
  update?: InputMaybe<Array<DogBreederApplicationUpdateWithWhereUniqueWithoutBreedPreferenceInput>>;
  updateMany?: InputMaybe<Array<DogBreederApplicationUpdateManyWithWhereWithoutBreedPreferenceInput>>;
  upsert?: InputMaybe<Array<DogBreederApplicationUpsertWithWhereUniqueWithoutBreedPreferenceInput>>;
};

export type DogBreederApplicationUpdateManyWithoutDogBreederNestedInput = {
  connect?: InputMaybe<Array<DogBreederApplicationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DogBreederApplicationCreateOrConnectWithoutDogBreederInput>>;
  create?: InputMaybe<Array<DogBreederApplicationCreateWithoutDogBreederInput>>;
  createMany?: InputMaybe<DogBreederApplicationCreateManyDogBreederInputEnvelope>;
  delete?: InputMaybe<Array<DogBreederApplicationWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<DogBreederApplicationScalarWhereInput>>;
  disconnect?: InputMaybe<Array<DogBreederApplicationWhereUniqueInput>>;
  set?: InputMaybe<Array<DogBreederApplicationWhereUniqueInput>>;
  update?: InputMaybe<Array<DogBreederApplicationUpdateWithWhereUniqueWithoutDogBreederInput>>;
  updateMany?: InputMaybe<Array<DogBreederApplicationUpdateManyWithWhereWithoutDogBreederInput>>;
  upsert?: InputMaybe<Array<DogBreederApplicationUpsertWithWhereUniqueWithoutDogBreederInput>>;
};

export type DogBreederApplicationUpdateOneRequiredWithoutStatusHistoryNestedInput = {
  connect?: InputMaybe<DogBreederApplicationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DogBreederApplicationCreateOrConnectWithoutStatusHistoryInput>;
  create?: InputMaybe<DogBreederApplicationCreateWithoutStatusHistoryInput>;
  update?: InputMaybe<DogBreederApplicationUpdateToOneWithWhereWithoutStatusHistoryInput>;
  upsert?: InputMaybe<DogBreederApplicationUpsertWithoutStatusHistoryInput>;
};

export type DogBreederApplicationUpdateOneWithoutAnimalNestedInput = {
  connect?: InputMaybe<DogBreederApplicationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DogBreederApplicationCreateOrConnectWithoutAnimalInput>;
  create?: InputMaybe<DogBreederApplicationCreateWithoutAnimalInput>;
  delete?: InputMaybe<DogBreederApplicationWhereInput>;
  disconnect?: InputMaybe<DogBreederApplicationWhereInput>;
  update?: InputMaybe<DogBreederApplicationUpdateToOneWithWhereWithoutAnimalInput>;
  upsert?: InputMaybe<DogBreederApplicationUpsertWithoutAnimalInput>;
};

export type DogBreederApplicationUpdateOneWithoutNotificationsNestedInput = {
  connect?: InputMaybe<DogBreederApplicationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DogBreederApplicationCreateOrConnectWithoutNotificationsInput>;
  create?: InputMaybe<DogBreederApplicationCreateWithoutNotificationsInput>;
  delete?: InputMaybe<DogBreederApplicationWhereInput>;
  disconnect?: InputMaybe<DogBreederApplicationWhereInput>;
  update?: InputMaybe<DogBreederApplicationUpdateToOneWithWhereWithoutNotificationsInput>;
  upsert?: InputMaybe<DogBreederApplicationUpsertWithoutNotificationsInput>;
};

export type DogBreederApplicationUpdateOneWithoutPaymentNestedInput = {
  connect?: InputMaybe<DogBreederApplicationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DogBreederApplicationCreateOrConnectWithoutPaymentInput>;
  create?: InputMaybe<DogBreederApplicationCreateWithoutPaymentInput>;
  delete?: InputMaybe<DogBreederApplicationWhereInput>;
  disconnect?: InputMaybe<DogBreederApplicationWhereInput>;
  update?: InputMaybe<DogBreederApplicationUpdateToOneWithWhereWithoutPaymentInput>;
  upsert?: InputMaybe<DogBreederApplicationUpsertWithoutPaymentInput>;
};

export type DogBreederApplicationUpdateToOneWithWhereWithoutAnimalInput = {
  data: DogBreederApplicationUpdateWithoutAnimalInput;
  where?: InputMaybe<DogBreederApplicationWhereInput>;
};

export type DogBreederApplicationUpdateToOneWithWhereWithoutNotificationsInput = {
  data: DogBreederApplicationUpdateWithoutNotificationsInput;
  where?: InputMaybe<DogBreederApplicationWhereInput>;
};

export type DogBreederApplicationUpdateToOneWithWhereWithoutPaymentInput = {
  data: DogBreederApplicationUpdateWithoutPaymentInput;
  where?: InputMaybe<DogBreederApplicationWhereInput>;
};

export type DogBreederApplicationUpdateToOneWithWhereWithoutStatusHistoryInput = {
  data: DogBreederApplicationUpdateWithoutStatusHistoryInput;
  where?: InputMaybe<DogBreederApplicationWhereInput>;
};

export type DogBreederApplicationUpdateWithWhereUniqueWithoutAccountInput = {
  data: DogBreederApplicationUpdateWithoutAccountInput;
  where: DogBreederApplicationWhereUniqueInput;
};

export type DogBreederApplicationUpdateWithWhereUniqueWithoutBreedPreferenceInput = {
  data: DogBreederApplicationUpdateWithoutBreedPreferenceInput;
  where: DogBreederApplicationWhereUniqueInput;
};

export type DogBreederApplicationUpdateWithWhereUniqueWithoutDogBreederInput = {
  data: DogBreederApplicationUpdateWithoutDogBreederInput;
  where: DogBreederApplicationWhereUniqueInput;
};

export type DogBreederApplicationUpdateWithoutAccountInput = {
  accommodation?: InputMaybe<EnumDogBreederApplicationAccommodationFieldUpdateOperationsInput>;
  accommodationDescription?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  animal?: InputMaybe<AnimalUpdateOneWithoutApplicationNestedInput>;
  archived?: InputMaybe<BoolFieldUpdateOperationsInput>;
  breedPreference?: InputMaybe<DogBreedUpdateOneRequiredWithoutApplicationsNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dogBreeder?: InputMaybe<DogBreederUpdateOneRequiredWithoutApplicationsNestedInput>;
  experiences?: InputMaybe<Array<DogBreederApplicationExperience>>;
  genderPreferences?: InputMaybe<Array<GenderEnum>>;
  motive?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutApplicationNestedInput>;
  otherAnimals?: InputMaybe<Array<DogBreederApplicationOtherAnimal>>;
  otherAnimalsDescription?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  otherPreferences?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payment?: InputMaybe<PaymentUpdateOneWithoutApplicationNestedInput>;
  questions?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  rejectedReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  seenByBreeder?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  seenByBuyer?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumDogBreederApplicationStatusFieldUpdateOperationsInput>;
  statusHistory?: InputMaybe<DogBreederApplicationStatusHistoryUpdateManyWithoutApplicationNestedInput>;
  timeAlone?: InputMaybe<EnumDogBreederApplicationTimeAloneFieldUpdateOperationsInput>;
  trainers?: InputMaybe<Array<DogBreederApplicationTrainer>>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DogBreederApplicationUpdateWithoutAnimalInput = {
  accommodation?: InputMaybe<EnumDogBreederApplicationAccommodationFieldUpdateOperationsInput>;
  accommodationDescription?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  account?: InputMaybe<AccountUpdateOneRequiredWithoutApplicationsNestedInput>;
  archived?: InputMaybe<BoolFieldUpdateOperationsInput>;
  breedPreference?: InputMaybe<DogBreedUpdateOneRequiredWithoutApplicationsNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dogBreeder?: InputMaybe<DogBreederUpdateOneRequiredWithoutApplicationsNestedInput>;
  experiences?: InputMaybe<Array<DogBreederApplicationExperience>>;
  genderPreferences?: InputMaybe<Array<GenderEnum>>;
  motive?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutApplicationNestedInput>;
  otherAnimals?: InputMaybe<Array<DogBreederApplicationOtherAnimal>>;
  otherAnimalsDescription?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  otherPreferences?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payment?: InputMaybe<PaymentUpdateOneWithoutApplicationNestedInput>;
  questions?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  rejectedReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  seenByBreeder?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  seenByBuyer?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumDogBreederApplicationStatusFieldUpdateOperationsInput>;
  statusHistory?: InputMaybe<DogBreederApplicationStatusHistoryUpdateManyWithoutApplicationNestedInput>;
  timeAlone?: InputMaybe<EnumDogBreederApplicationTimeAloneFieldUpdateOperationsInput>;
  trainers?: InputMaybe<Array<DogBreederApplicationTrainer>>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DogBreederApplicationUpdateWithoutBreedPreferenceInput = {
  accommodation?: InputMaybe<EnumDogBreederApplicationAccommodationFieldUpdateOperationsInput>;
  accommodationDescription?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  account?: InputMaybe<AccountUpdateOneRequiredWithoutApplicationsNestedInput>;
  animal?: InputMaybe<AnimalUpdateOneWithoutApplicationNestedInput>;
  archived?: InputMaybe<BoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dogBreeder?: InputMaybe<DogBreederUpdateOneRequiredWithoutApplicationsNestedInput>;
  experiences?: InputMaybe<Array<DogBreederApplicationExperience>>;
  genderPreferences?: InputMaybe<Array<GenderEnum>>;
  motive?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutApplicationNestedInput>;
  otherAnimals?: InputMaybe<Array<DogBreederApplicationOtherAnimal>>;
  otherAnimalsDescription?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  otherPreferences?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payment?: InputMaybe<PaymentUpdateOneWithoutApplicationNestedInput>;
  questions?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  rejectedReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  seenByBreeder?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  seenByBuyer?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumDogBreederApplicationStatusFieldUpdateOperationsInput>;
  statusHistory?: InputMaybe<DogBreederApplicationStatusHistoryUpdateManyWithoutApplicationNestedInput>;
  timeAlone?: InputMaybe<EnumDogBreederApplicationTimeAloneFieldUpdateOperationsInput>;
  trainers?: InputMaybe<Array<DogBreederApplicationTrainer>>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DogBreederApplicationUpdateWithoutDogBreederInput = {
  accommodation?: InputMaybe<EnumDogBreederApplicationAccommodationFieldUpdateOperationsInput>;
  accommodationDescription?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  account?: InputMaybe<AccountUpdateOneRequiredWithoutApplicationsNestedInput>;
  animal?: InputMaybe<AnimalUpdateOneWithoutApplicationNestedInput>;
  archived?: InputMaybe<BoolFieldUpdateOperationsInput>;
  breedPreference?: InputMaybe<DogBreedUpdateOneRequiredWithoutApplicationsNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  experiences?: InputMaybe<Array<DogBreederApplicationExperience>>;
  genderPreferences?: InputMaybe<Array<GenderEnum>>;
  motive?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutApplicationNestedInput>;
  otherAnimals?: InputMaybe<Array<DogBreederApplicationOtherAnimal>>;
  otherAnimalsDescription?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  otherPreferences?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payment?: InputMaybe<PaymentUpdateOneWithoutApplicationNestedInput>;
  questions?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  rejectedReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  seenByBreeder?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  seenByBuyer?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumDogBreederApplicationStatusFieldUpdateOperationsInput>;
  statusHistory?: InputMaybe<DogBreederApplicationStatusHistoryUpdateManyWithoutApplicationNestedInput>;
  timeAlone?: InputMaybe<EnumDogBreederApplicationTimeAloneFieldUpdateOperationsInput>;
  trainers?: InputMaybe<Array<DogBreederApplicationTrainer>>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DogBreederApplicationUpdateWithoutNotificationsInput = {
  accommodation?: InputMaybe<EnumDogBreederApplicationAccommodationFieldUpdateOperationsInput>;
  accommodationDescription?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  account?: InputMaybe<AccountUpdateOneRequiredWithoutApplicationsNestedInput>;
  animal?: InputMaybe<AnimalUpdateOneWithoutApplicationNestedInput>;
  archived?: InputMaybe<BoolFieldUpdateOperationsInput>;
  breedPreference?: InputMaybe<DogBreedUpdateOneRequiredWithoutApplicationsNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dogBreeder?: InputMaybe<DogBreederUpdateOneRequiredWithoutApplicationsNestedInput>;
  experiences?: InputMaybe<Array<DogBreederApplicationExperience>>;
  genderPreferences?: InputMaybe<Array<GenderEnum>>;
  motive?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  otherAnimals?: InputMaybe<Array<DogBreederApplicationOtherAnimal>>;
  otherAnimalsDescription?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  otherPreferences?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payment?: InputMaybe<PaymentUpdateOneWithoutApplicationNestedInput>;
  questions?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  rejectedReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  seenByBreeder?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  seenByBuyer?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumDogBreederApplicationStatusFieldUpdateOperationsInput>;
  statusHistory?: InputMaybe<DogBreederApplicationStatusHistoryUpdateManyWithoutApplicationNestedInput>;
  timeAlone?: InputMaybe<EnumDogBreederApplicationTimeAloneFieldUpdateOperationsInput>;
  trainers?: InputMaybe<Array<DogBreederApplicationTrainer>>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DogBreederApplicationUpdateWithoutPaymentInput = {
  accommodation?: InputMaybe<EnumDogBreederApplicationAccommodationFieldUpdateOperationsInput>;
  accommodationDescription?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  account?: InputMaybe<AccountUpdateOneRequiredWithoutApplicationsNestedInput>;
  animal?: InputMaybe<AnimalUpdateOneWithoutApplicationNestedInput>;
  archived?: InputMaybe<BoolFieldUpdateOperationsInput>;
  breedPreference?: InputMaybe<DogBreedUpdateOneRequiredWithoutApplicationsNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dogBreeder?: InputMaybe<DogBreederUpdateOneRequiredWithoutApplicationsNestedInput>;
  experiences?: InputMaybe<Array<DogBreederApplicationExperience>>;
  genderPreferences?: InputMaybe<Array<GenderEnum>>;
  motive?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutApplicationNestedInput>;
  otherAnimals?: InputMaybe<Array<DogBreederApplicationOtherAnimal>>;
  otherAnimalsDescription?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  otherPreferences?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  questions?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  rejectedReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  seenByBreeder?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  seenByBuyer?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumDogBreederApplicationStatusFieldUpdateOperationsInput>;
  statusHistory?: InputMaybe<DogBreederApplicationStatusHistoryUpdateManyWithoutApplicationNestedInput>;
  timeAlone?: InputMaybe<EnumDogBreederApplicationTimeAloneFieldUpdateOperationsInput>;
  trainers?: InputMaybe<Array<DogBreederApplicationTrainer>>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DogBreederApplicationUpdateWithoutStatusHistoryInput = {
  accommodation?: InputMaybe<EnumDogBreederApplicationAccommodationFieldUpdateOperationsInput>;
  accommodationDescription?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  account?: InputMaybe<AccountUpdateOneRequiredWithoutApplicationsNestedInput>;
  animal?: InputMaybe<AnimalUpdateOneWithoutApplicationNestedInput>;
  archived?: InputMaybe<BoolFieldUpdateOperationsInput>;
  breedPreference?: InputMaybe<DogBreedUpdateOneRequiredWithoutApplicationsNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dogBreeder?: InputMaybe<DogBreederUpdateOneRequiredWithoutApplicationsNestedInput>;
  experiences?: InputMaybe<Array<DogBreederApplicationExperience>>;
  genderPreferences?: InputMaybe<Array<GenderEnum>>;
  motive?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutApplicationNestedInput>;
  otherAnimals?: InputMaybe<Array<DogBreederApplicationOtherAnimal>>;
  otherAnimalsDescription?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  otherPreferences?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payment?: InputMaybe<PaymentUpdateOneWithoutApplicationNestedInput>;
  questions?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  rejectedReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  seenByBreeder?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  seenByBuyer?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumDogBreederApplicationStatusFieldUpdateOperationsInput>;
  timeAlone?: InputMaybe<EnumDogBreederApplicationTimeAloneFieldUpdateOperationsInput>;
  trainers?: InputMaybe<Array<DogBreederApplicationTrainer>>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DogBreederApplicationUpdateexperiencesInput = {
  push?: InputMaybe<Array<DogBreederApplicationExperience>>;
  set?: InputMaybe<Array<DogBreederApplicationExperience>>;
};

export type DogBreederApplicationUpdategenderPreferencesInput = {
  push?: InputMaybe<Array<GenderEnum>>;
  set?: InputMaybe<Array<GenderEnum>>;
};

export type DogBreederApplicationUpdateotherAnimalsInput = {
  push?: InputMaybe<Array<DogBreederApplicationOtherAnimal>>;
  set?: InputMaybe<Array<DogBreederApplicationOtherAnimal>>;
};

export type DogBreederApplicationUpdatetrainersInput = {
  push?: InputMaybe<Array<DogBreederApplicationTrainer>>;
  set?: InputMaybe<Array<DogBreederApplicationTrainer>>;
};

export type DogBreederApplicationUpsertWithWhereUniqueWithoutAccountInput = {
  create: DogBreederApplicationCreateWithoutAccountInput;
  update: DogBreederApplicationUpdateWithoutAccountInput;
  where: DogBreederApplicationWhereUniqueInput;
};

export type DogBreederApplicationUpsertWithWhereUniqueWithoutBreedPreferenceInput = {
  create: DogBreederApplicationCreateWithoutBreedPreferenceInput;
  update: DogBreederApplicationUpdateWithoutBreedPreferenceInput;
  where: DogBreederApplicationWhereUniqueInput;
};

export type DogBreederApplicationUpsertWithWhereUniqueWithoutDogBreederInput = {
  create: DogBreederApplicationCreateWithoutDogBreederInput;
  update: DogBreederApplicationUpdateWithoutDogBreederInput;
  where: DogBreederApplicationWhereUniqueInput;
};

export type DogBreederApplicationUpsertWithoutAnimalInput = {
  create: DogBreederApplicationCreateWithoutAnimalInput;
  update: DogBreederApplicationUpdateWithoutAnimalInput;
  where?: InputMaybe<DogBreederApplicationWhereInput>;
};

export type DogBreederApplicationUpsertWithoutNotificationsInput = {
  create: DogBreederApplicationCreateWithoutNotificationsInput;
  update: DogBreederApplicationUpdateWithoutNotificationsInput;
  where?: InputMaybe<DogBreederApplicationWhereInput>;
};

export type DogBreederApplicationUpsertWithoutPaymentInput = {
  create: DogBreederApplicationCreateWithoutPaymentInput;
  update: DogBreederApplicationUpdateWithoutPaymentInput;
  where?: InputMaybe<DogBreederApplicationWhereInput>;
};

export type DogBreederApplicationUpsertWithoutStatusHistoryInput = {
  create: DogBreederApplicationCreateWithoutStatusHistoryInput;
  update: DogBreederApplicationUpdateWithoutStatusHistoryInput;
  where?: InputMaybe<DogBreederApplicationWhereInput>;
};

export type DogBreederApplicationWhereInput = {
  AND?: InputMaybe<Array<DogBreederApplicationWhereInput>>;
  NOT?: InputMaybe<Array<DogBreederApplicationWhereInput>>;
  OR?: InputMaybe<Array<DogBreederApplicationWhereInput>>;
  accommodation?: InputMaybe<EnumDogBreederApplicationAccommodationFilter>;
  accommodationDescription?: InputMaybe<StringNullableFilter>;
  account?: InputMaybe<AccountRelationFilter>;
  accountId?: InputMaybe<IntFilter>;
  animal?: InputMaybe<AnimalNullableRelationFilter>;
  animalId?: InputMaybe<IntNullableFilter>;
  archived?: InputMaybe<BoolFilter>;
  breedPreference?: InputMaybe<DogBreedRelationFilter>;
  breedPreferenceId?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  dogBreeder?: InputMaybe<DogBreederRelationFilter>;
  dogBreederId?: InputMaybe<IntFilter>;
  experiences?: InputMaybe<EnumDogBreederApplicationExperienceNullableListFilter>;
  genderPreferences?: InputMaybe<EnumGenderEnumNullableListFilter>;
  id?: InputMaybe<IntFilter>;
  motive?: InputMaybe<StringNullableFilter>;
  notifications?: InputMaybe<NotificationListRelationFilter>;
  otherAnimals?: InputMaybe<EnumDogBreederApplicationOtherAnimalNullableListFilter>;
  otherAnimalsDescription?: InputMaybe<StringNullableFilter>;
  otherPreferences?: InputMaybe<StringNullableFilter>;
  payment?: InputMaybe<PaymentNullableRelationFilter>;
  paymentId?: InputMaybe<StringNullableFilter>;
  questions?: InputMaybe<StringNullableFilter>;
  rejectedReason?: InputMaybe<StringNullableFilter>;
  seenByBreeder?: InputMaybe<BoolNullableFilter>;
  seenByBuyer?: InputMaybe<BoolNullableFilter>;
  status?: InputMaybe<EnumDogBreederApplicationStatusFilter>;
  statusHistory?: InputMaybe<DogBreederApplicationStatusHistoryListRelationFilter>;
  timeAlone?: InputMaybe<EnumDogBreederApplicationTimeAloneFilter>;
  trainers?: InputMaybe<EnumDogBreederApplicationTrainerNullableListFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type DogBreederApplicationWhereUniqueInput = {
  AND?: InputMaybe<Array<DogBreederApplicationWhereInput>>;
  NOT?: InputMaybe<Array<DogBreederApplicationWhereInput>>;
  OR?: InputMaybe<Array<DogBreederApplicationWhereInput>>;
  accommodation?: InputMaybe<EnumDogBreederApplicationAccommodationFilter>;
  accommodationDescription?: InputMaybe<StringNullableFilter>;
  account?: InputMaybe<AccountRelationFilter>;
  accountId?: InputMaybe<IntFilter>;
  animal?: InputMaybe<AnimalNullableRelationFilter>;
  animalId?: InputMaybe<Scalars['Int']['input']>;
  archived?: InputMaybe<BoolFilter>;
  breedPreference?: InputMaybe<DogBreedRelationFilter>;
  breedPreferenceId?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  dogBreeder?: InputMaybe<DogBreederRelationFilter>;
  dogBreederId?: InputMaybe<IntFilter>;
  experiences?: InputMaybe<EnumDogBreederApplicationExperienceNullableListFilter>;
  genderPreferences?: InputMaybe<EnumGenderEnumNullableListFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  motive?: InputMaybe<StringNullableFilter>;
  notifications?: InputMaybe<NotificationListRelationFilter>;
  otherAnimals?: InputMaybe<EnumDogBreederApplicationOtherAnimalNullableListFilter>;
  otherAnimalsDescription?: InputMaybe<StringNullableFilter>;
  otherPreferences?: InputMaybe<StringNullableFilter>;
  payment?: InputMaybe<PaymentNullableRelationFilter>;
  paymentId?: InputMaybe<Scalars['String']['input']>;
  questions?: InputMaybe<StringNullableFilter>;
  rejectedReason?: InputMaybe<StringNullableFilter>;
  seenByBreeder?: InputMaybe<BoolNullableFilter>;
  seenByBuyer?: InputMaybe<BoolNullableFilter>;
  status?: InputMaybe<EnumDogBreederApplicationStatusFilter>;
  statusHistory?: InputMaybe<DogBreederApplicationStatusHistoryListRelationFilter>;
  timeAlone?: InputMaybe<EnumDogBreederApplicationTimeAloneFilter>;
  trainers?: InputMaybe<EnumDogBreederApplicationTrainerNullableListFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type DogBreederAvgAggregateOutputType = {
  __typename?: 'DogBreederAvgAggregateOutputType';
  emailAutomationStage?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  littersByFemaleCount?: Maybe<Scalars['Float']['output']>;
  maleBreedersCount?: Maybe<Scalars['Float']['output']>;
};

export type DogBreederAvgOrderByAggregateInput = {
  emailAutomationStage?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  littersByFemaleCount?: InputMaybe<SortOrder>;
  maleBreedersCount?: InputMaybe<SortOrder>;
};

export type DogBreederBreeds = {
  __typename?: 'DogBreederBreeds';
  createdAt: Scalars['DateTime']['output'];
  dogBreed: DogBreed;
  dogBreedId: Scalars['Int']['output'];
  dogBreeder: DogBreeder;
  dogBreederId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type DogBreederBreedsAvgAggregateOutputType = {
  __typename?: 'DogBreederBreedsAvgAggregateOutputType';
  dogBreedId?: Maybe<Scalars['Float']['output']>;
  dogBreederId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

export type DogBreederBreedsAvgOrderByAggregateInput = {
  dogBreedId?: InputMaybe<SortOrder>;
  dogBreederId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export type DogBreederBreedsCountAggregateOutputType = {
  __typename?: 'DogBreederBreedsCountAggregateOutputType';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  dogBreedId: Scalars['Int']['output'];
  dogBreederId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type DogBreederBreedsCountOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  dogBreedId?: InputMaybe<SortOrder>;
  dogBreederId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type DogBreederBreedsCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dogBreed: DogBreedCreateNestedOneWithoutDogBreedersInput;
  dogBreeder: DogBreederCreateNestedOneWithoutBreederBreedsInput;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DogBreederBreedsCreateManyDogBreedInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dogBreederId: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DogBreederBreedsCreateManyDogBreedInputEnvelope = {
  data: Array<DogBreederBreedsCreateManyDogBreedInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DogBreederBreedsCreateManyDogBreederInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dogBreedId: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DogBreederBreedsCreateManyDogBreederInputEnvelope = {
  data: Array<DogBreederBreedsCreateManyDogBreederInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DogBreederBreedsCreateManyInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dogBreedId: Scalars['Int']['input'];
  dogBreederId: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DogBreederBreedsCreateNestedManyWithoutDogBreedInput = {
  connect?: InputMaybe<Array<DogBreederBreedsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DogBreederBreedsCreateOrConnectWithoutDogBreedInput>>;
  create?: InputMaybe<Array<DogBreederBreedsCreateWithoutDogBreedInput>>;
  createMany?: InputMaybe<DogBreederBreedsCreateManyDogBreedInputEnvelope>;
};

export type DogBreederBreedsCreateNestedManyWithoutDogBreederInput = {
  connect?: InputMaybe<Array<DogBreederBreedsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DogBreederBreedsCreateOrConnectWithoutDogBreederInput>>;
  create?: InputMaybe<Array<DogBreederBreedsCreateWithoutDogBreederInput>>;
  createMany?: InputMaybe<DogBreederBreedsCreateManyDogBreederInputEnvelope>;
};

export type DogBreederBreedsCreateOrConnectWithoutDogBreedInput = {
  create: DogBreederBreedsCreateWithoutDogBreedInput;
  where: DogBreederBreedsWhereUniqueInput;
};

export type DogBreederBreedsCreateOrConnectWithoutDogBreederInput = {
  create: DogBreederBreedsCreateWithoutDogBreederInput;
  where: DogBreederBreedsWhereUniqueInput;
};

export type DogBreederBreedsCreateWithoutDogBreedInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dogBreeder: DogBreederCreateNestedOneWithoutBreederBreedsInput;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DogBreederBreedsCreateWithoutDogBreederInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dogBreed: DogBreedCreateNestedOneWithoutDogBreedersInput;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DogBreederBreedsListRelationFilter = {
  every?: InputMaybe<DogBreederBreedsWhereInput>;
  none?: InputMaybe<DogBreederBreedsWhereInput>;
  some?: InputMaybe<DogBreederBreedsWhereInput>;
};

export type DogBreederBreedsMaxAggregateOutputType = {
  __typename?: 'DogBreederBreedsMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  dogBreedId?: Maybe<Scalars['Int']['output']>;
  dogBreederId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type DogBreederBreedsMaxOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  dogBreedId?: InputMaybe<SortOrder>;
  dogBreederId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type DogBreederBreedsMinAggregateOutputType = {
  __typename?: 'DogBreederBreedsMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  dogBreedId?: Maybe<Scalars['Int']['output']>;
  dogBreederId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type DogBreederBreedsMinOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  dogBreedId?: InputMaybe<SortOrder>;
  dogBreederId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type DogBreederBreedsOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type DogBreederBreedsOrderByWithAggregationInput = {
  _avg?: InputMaybe<DogBreederBreedsAvgOrderByAggregateInput>;
  _count?: InputMaybe<DogBreederBreedsCountOrderByAggregateInput>;
  _max?: InputMaybe<DogBreederBreedsMaxOrderByAggregateInput>;
  _min?: InputMaybe<DogBreederBreedsMinOrderByAggregateInput>;
  _sum?: InputMaybe<DogBreederBreedsSumOrderByAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  dogBreedId?: InputMaybe<SortOrder>;
  dogBreederId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type DogBreederBreedsOrderByWithRelationAndSearchRelevanceInput = {
  createdAt?: InputMaybe<SortOrder>;
  dogBreed?: InputMaybe<DogBreedOrderByWithRelationAndSearchRelevanceInput>;
  dogBreedId?: InputMaybe<SortOrder>;
  dogBreeder?: InputMaybe<DogBreederOrderByWithRelationAndSearchRelevanceInput>;
  dogBreederId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum DogBreederBreedsScalarFieldEnum {
  createdAt = 'createdAt',
  dogBreedId = 'dogBreedId',
  dogBreederId = 'dogBreederId',
  id = 'id',
  updatedAt = 'updatedAt'
}

export type DogBreederBreedsScalarWhereInput = {
  AND?: InputMaybe<Array<DogBreederBreedsScalarWhereInput>>;
  NOT?: InputMaybe<Array<DogBreederBreedsScalarWhereInput>>;
  OR?: InputMaybe<Array<DogBreederBreedsScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  dogBreedId?: InputMaybe<IntFilter>;
  dogBreederId?: InputMaybe<IntFilter>;
  id?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type DogBreederBreedsScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<DogBreederBreedsScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<DogBreederBreedsScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<DogBreederBreedsScalarWhereWithAggregatesInput>>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  dogBreedId?: InputMaybe<IntWithAggregatesFilter>;
  dogBreederId?: InputMaybe<IntWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type DogBreederBreedsSumAggregateOutputType = {
  __typename?: 'DogBreederBreedsSumAggregateOutputType';
  dogBreedId?: Maybe<Scalars['Int']['output']>;
  dogBreederId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
};

export type DogBreederBreedsSumOrderByAggregateInput = {
  dogBreedId?: InputMaybe<SortOrder>;
  dogBreederId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export type DogBreederBreedsUncheckedCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dogBreedId: Scalars['Int']['input'];
  dogBreederId: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DogBreederBreedsUncheckedCreateNestedManyWithoutDogBreedInput = {
  connect?: InputMaybe<Array<DogBreederBreedsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DogBreederBreedsCreateOrConnectWithoutDogBreedInput>>;
  create?: InputMaybe<Array<DogBreederBreedsCreateWithoutDogBreedInput>>;
  createMany?: InputMaybe<DogBreederBreedsCreateManyDogBreedInputEnvelope>;
};

export type DogBreederBreedsUncheckedCreateNestedManyWithoutDogBreederInput = {
  connect?: InputMaybe<Array<DogBreederBreedsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DogBreederBreedsCreateOrConnectWithoutDogBreederInput>>;
  create?: InputMaybe<Array<DogBreederBreedsCreateWithoutDogBreederInput>>;
  createMany?: InputMaybe<DogBreederBreedsCreateManyDogBreederInputEnvelope>;
};

export type DogBreederBreedsUncheckedCreateWithoutDogBreedInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dogBreederId: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DogBreederBreedsUncheckedCreateWithoutDogBreederInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dogBreedId: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DogBreederBreedsUncheckedUpdateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dogBreedId?: InputMaybe<IntFieldUpdateOperationsInput>;
  dogBreederId?: InputMaybe<IntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DogBreederBreedsUncheckedUpdateManyInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dogBreedId?: InputMaybe<IntFieldUpdateOperationsInput>;
  dogBreederId?: InputMaybe<IntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DogBreederBreedsUncheckedUpdateManyWithoutDogBreedInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dogBreederId?: InputMaybe<IntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DogBreederBreedsUncheckedUpdateManyWithoutDogBreedNestedInput = {
  connect?: InputMaybe<Array<DogBreederBreedsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DogBreederBreedsCreateOrConnectWithoutDogBreedInput>>;
  create?: InputMaybe<Array<DogBreederBreedsCreateWithoutDogBreedInput>>;
  createMany?: InputMaybe<DogBreederBreedsCreateManyDogBreedInputEnvelope>;
  delete?: InputMaybe<Array<DogBreederBreedsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<DogBreederBreedsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<DogBreederBreedsWhereUniqueInput>>;
  set?: InputMaybe<Array<DogBreederBreedsWhereUniqueInput>>;
  update?: InputMaybe<Array<DogBreederBreedsUpdateWithWhereUniqueWithoutDogBreedInput>>;
  updateMany?: InputMaybe<Array<DogBreederBreedsUpdateManyWithWhereWithoutDogBreedInput>>;
  upsert?: InputMaybe<Array<DogBreederBreedsUpsertWithWhereUniqueWithoutDogBreedInput>>;
};

export type DogBreederBreedsUncheckedUpdateManyWithoutDogBreederInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dogBreedId?: InputMaybe<IntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DogBreederBreedsUncheckedUpdateManyWithoutDogBreederNestedInput = {
  connect?: InputMaybe<Array<DogBreederBreedsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DogBreederBreedsCreateOrConnectWithoutDogBreederInput>>;
  create?: InputMaybe<Array<DogBreederBreedsCreateWithoutDogBreederInput>>;
  createMany?: InputMaybe<DogBreederBreedsCreateManyDogBreederInputEnvelope>;
  delete?: InputMaybe<Array<DogBreederBreedsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<DogBreederBreedsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<DogBreederBreedsWhereUniqueInput>>;
  set?: InputMaybe<Array<DogBreederBreedsWhereUniqueInput>>;
  update?: InputMaybe<Array<DogBreederBreedsUpdateWithWhereUniqueWithoutDogBreederInput>>;
  updateMany?: InputMaybe<Array<DogBreederBreedsUpdateManyWithWhereWithoutDogBreederInput>>;
  upsert?: InputMaybe<Array<DogBreederBreedsUpsertWithWhereUniqueWithoutDogBreederInput>>;
};

export type DogBreederBreedsUncheckedUpdateWithoutDogBreedInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dogBreederId?: InputMaybe<IntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DogBreederBreedsUncheckedUpdateWithoutDogBreederInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dogBreedId?: InputMaybe<IntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DogBreederBreedsUpdateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dogBreed?: InputMaybe<DogBreedUpdateOneRequiredWithoutDogBreedersNestedInput>;
  dogBreeder?: InputMaybe<DogBreederUpdateOneRequiredWithoutBreederBreedsNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DogBreederBreedsUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DogBreederBreedsUpdateManyWithWhereWithoutDogBreedInput = {
  data: DogBreederBreedsUpdateManyMutationInput;
  where: DogBreederBreedsScalarWhereInput;
};

export type DogBreederBreedsUpdateManyWithWhereWithoutDogBreederInput = {
  data: DogBreederBreedsUpdateManyMutationInput;
  where: DogBreederBreedsScalarWhereInput;
};

export type DogBreederBreedsUpdateManyWithoutDogBreedNestedInput = {
  connect?: InputMaybe<Array<DogBreederBreedsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DogBreederBreedsCreateOrConnectWithoutDogBreedInput>>;
  create?: InputMaybe<Array<DogBreederBreedsCreateWithoutDogBreedInput>>;
  createMany?: InputMaybe<DogBreederBreedsCreateManyDogBreedInputEnvelope>;
  delete?: InputMaybe<Array<DogBreederBreedsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<DogBreederBreedsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<DogBreederBreedsWhereUniqueInput>>;
  set?: InputMaybe<Array<DogBreederBreedsWhereUniqueInput>>;
  update?: InputMaybe<Array<DogBreederBreedsUpdateWithWhereUniqueWithoutDogBreedInput>>;
  updateMany?: InputMaybe<Array<DogBreederBreedsUpdateManyWithWhereWithoutDogBreedInput>>;
  upsert?: InputMaybe<Array<DogBreederBreedsUpsertWithWhereUniqueWithoutDogBreedInput>>;
};

export type DogBreederBreedsUpdateManyWithoutDogBreederNestedInput = {
  connect?: InputMaybe<Array<DogBreederBreedsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DogBreederBreedsCreateOrConnectWithoutDogBreederInput>>;
  create?: InputMaybe<Array<DogBreederBreedsCreateWithoutDogBreederInput>>;
  createMany?: InputMaybe<DogBreederBreedsCreateManyDogBreederInputEnvelope>;
  delete?: InputMaybe<Array<DogBreederBreedsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<DogBreederBreedsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<DogBreederBreedsWhereUniqueInput>>;
  set?: InputMaybe<Array<DogBreederBreedsWhereUniqueInput>>;
  update?: InputMaybe<Array<DogBreederBreedsUpdateWithWhereUniqueWithoutDogBreederInput>>;
  updateMany?: InputMaybe<Array<DogBreederBreedsUpdateManyWithWhereWithoutDogBreederInput>>;
  upsert?: InputMaybe<Array<DogBreederBreedsUpsertWithWhereUniqueWithoutDogBreederInput>>;
};

export type DogBreederBreedsUpdateWithWhereUniqueWithoutDogBreedInput = {
  data: DogBreederBreedsUpdateWithoutDogBreedInput;
  where: DogBreederBreedsWhereUniqueInput;
};

export type DogBreederBreedsUpdateWithWhereUniqueWithoutDogBreederInput = {
  data: DogBreederBreedsUpdateWithoutDogBreederInput;
  where: DogBreederBreedsWhereUniqueInput;
};

export type DogBreederBreedsUpdateWithoutDogBreedInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dogBreeder?: InputMaybe<DogBreederUpdateOneRequiredWithoutBreederBreedsNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DogBreederBreedsUpdateWithoutDogBreederInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dogBreed?: InputMaybe<DogBreedUpdateOneRequiredWithoutDogBreedersNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DogBreederBreedsUpsertWithWhereUniqueWithoutDogBreedInput = {
  create: DogBreederBreedsCreateWithoutDogBreedInput;
  update: DogBreederBreedsUpdateWithoutDogBreedInput;
  where: DogBreederBreedsWhereUniqueInput;
};

export type DogBreederBreedsUpsertWithWhereUniqueWithoutDogBreederInput = {
  create: DogBreederBreedsCreateWithoutDogBreederInput;
  update: DogBreederBreedsUpdateWithoutDogBreederInput;
  where: DogBreederBreedsWhereUniqueInput;
};

export type DogBreederBreedsWhereInput = {
  AND?: InputMaybe<Array<DogBreederBreedsWhereInput>>;
  NOT?: InputMaybe<Array<DogBreederBreedsWhereInput>>;
  OR?: InputMaybe<Array<DogBreederBreedsWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  dogBreed?: InputMaybe<DogBreedRelationFilter>;
  dogBreedId?: InputMaybe<IntFilter>;
  dogBreeder?: InputMaybe<DogBreederRelationFilter>;
  dogBreederId?: InputMaybe<IntFilter>;
  id?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type DogBreederBreedsWhereUniqueInput = {
  AND?: InputMaybe<Array<DogBreederBreedsWhereInput>>;
  NOT?: InputMaybe<Array<DogBreederBreedsWhereInput>>;
  OR?: InputMaybe<Array<DogBreederBreedsWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  dogBreed?: InputMaybe<DogBreedRelationFilter>;
  dogBreedId?: InputMaybe<IntFilter>;
  dogBreeder?: InputMaybe<DogBreederRelationFilter>;
  dogBreederId?: InputMaybe<IntFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export enum DogBreederContactType {
  CONTACT = 'CONTACT',
  PURCHASE = 'PURCHASE',
  VISIT = 'VISIT'
}

export type DogBreederCountAggregateOutputType = {
  __typename?: 'DogBreederCountAggregateOutputType';
  _all: Scalars['Int']['output'];
  adminNote: Scalars['Int']['output'];
  agreementNumber: Scalars['Int']['output'];
  breedClubFiles: Scalars['Int']['output'];
  breedClubValidated: Scalars['Int']['output'];
  breedingName: Scalars['Int']['output'];
  certificationFile: Scalars['Int']['output'];
  certified: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  displayEmail: Scalars['Int']['output'];
  displayName: Scalars['Int']['output'];
  displayPhone: Scalars['Int']['output'];
  dogsConsanguinity: Scalars['Int']['output'];
  dogsPedigree: Scalars['Int']['output'];
  dogsTemper: Scalars['Int']['output'];
  emailAutomationStage: Scalars['Int']['output'];
  facebookUrl: Scalars['Int']['output'];
  failedMedicalTestsProtocol: Scalars['Int']['output'];
  hasFinishedOnboarding: Scalars['Int']['output'];
  hasStartedOnboarding: Scalars['Int']['output'];
  hkFile: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  identityFiles: Scalars['Int']['output'];
  lastAutomationEmailSentAt: Scalars['Int']['output'];
  level: Scalars['Int']['output'];
  littersByFemale: Scalars['Int']['output'];
  littersByFemaleCount: Scalars['Int']['output'];
  maleBreedersCount: Scalars['Int']['output'];
  medicalTestsPerformed: Scalars['Int']['output'];
  motherRestBetweenLitters: Scalars['Int']['output'];
  permissionFiles: Scalars['Int']['output'];
  public: Scalars['Int']['output'];
  puppiesBirthPlace: Scalars['Int']['output'];
  spokenLanguages: Scalars['Int']['output'];
  tags: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
  vatNumber: Scalars['Int']['output'];
  veterinaryInfo: Scalars['Int']['output'];
  videoUrl: Scalars['Int']['output'];
  visitedByTipaw: Scalars['Int']['output'];
  websiteUrl: Scalars['Int']['output'];
  whatsappNumber: Scalars['Int']['output'];
};

export type DogBreederCountOrderByAggregateInput = {
  adminNote?: InputMaybe<SortOrder>;
  agreementNumber?: InputMaybe<SortOrder>;
  breedClubFiles?: InputMaybe<SortOrder>;
  breedClubValidated?: InputMaybe<SortOrder>;
  breedingName?: InputMaybe<SortOrder>;
  certificationFile?: InputMaybe<SortOrder>;
  certified?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  displayEmail?: InputMaybe<SortOrder>;
  displayName?: InputMaybe<SortOrder>;
  displayPhone?: InputMaybe<SortOrder>;
  dogsConsanguinity?: InputMaybe<SortOrder>;
  dogsPedigree?: InputMaybe<SortOrder>;
  dogsTemper?: InputMaybe<SortOrder>;
  emailAutomationStage?: InputMaybe<SortOrder>;
  facebookUrl?: InputMaybe<SortOrder>;
  failedMedicalTestsProtocol?: InputMaybe<SortOrder>;
  hasFinishedOnboarding?: InputMaybe<SortOrder>;
  hasStartedOnboarding?: InputMaybe<SortOrder>;
  hkFile?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  identityFiles?: InputMaybe<SortOrder>;
  lastAutomationEmailSentAt?: InputMaybe<SortOrder>;
  level?: InputMaybe<SortOrder>;
  littersByFemale?: InputMaybe<SortOrder>;
  littersByFemaleCount?: InputMaybe<SortOrder>;
  maleBreedersCount?: InputMaybe<SortOrder>;
  medicalTestsPerformed?: InputMaybe<SortOrder>;
  motherRestBetweenLitters?: InputMaybe<SortOrder>;
  permissionFiles?: InputMaybe<SortOrder>;
  public?: InputMaybe<SortOrder>;
  puppiesBirthPlace?: InputMaybe<SortOrder>;
  spokenLanguages?: InputMaybe<SortOrder>;
  tags?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  vatNumber?: InputMaybe<SortOrder>;
  veterinaryInfo?: InputMaybe<SortOrder>;
  videoUrl?: InputMaybe<SortOrder>;
  visitedByTipaw?: InputMaybe<SortOrder>;
  websiteUrl?: InputMaybe<SortOrder>;
  whatsappNumber?: InputMaybe<SortOrder>;
};

export type DogBreederCountOutputType = {
  __typename?: 'DogBreederCountOutputType';
  applications: Scalars['Int']['output'];
  breederBreeds: Scalars['Int']['output'];
  dogInfos: Scalars['Int']['output'];
  emailHistory: Scalars['Int']['output'];
  imgs: Scalars['Int']['output'];
  litters: Scalars['Int']['output'];
  notifications: Scalars['Int']['output'];
  puppies: Scalars['Int']['output'];
  reviews: Scalars['Int']['output'];
  studInfos: Scalars['Int']['output'];
  translations: Scalars['Int']['output'];
  updates: Scalars['Int']['output'];
};

export type DogBreederCreateInput = {
  account: AccountCreateNestedOneWithoutDogBreederInput;
  adminNote?: InputMaybe<Scalars['String']['input']>;
  agreementNumber?: InputMaybe<Scalars['String']['input']>;
  applications?: InputMaybe<DogBreederApplicationCreateNestedManyWithoutDogBreederInput>;
  breedClubFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  breedClubValidated?: InputMaybe<Scalars['Boolean']['input']>;
  breederBreeds?: InputMaybe<DogBreederBreedsCreateNestedManyWithoutDogBreederInput>;
  breedingName?: InputMaybe<Scalars['String']['input']>;
  certificationFile?: InputMaybe<Scalars['String']['input']>;
  certified?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  displayEmail?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  displayPhone?: InputMaybe<Scalars['String']['input']>;
  dogInfos?: InputMaybe<DogInfoCreateNestedManyWithoutBreederInput>;
  dogsConsanguinity?: InputMaybe<Scalars['String']['input']>;
  dogsPedigree?: InputMaybe<Scalars['String']['input']>;
  dogsTemper?: InputMaybe<Scalars['String']['input']>;
  emailAutomationStage?: InputMaybe<Scalars['Int']['input']>;
  emailHistory?: InputMaybe<EmailHistoryCreateNestedManyWithoutBreederInput>;
  facebookUrl?: InputMaybe<Scalars['String']['input']>;
  failedMedicalTestsProtocol?: InputMaybe<Scalars['String']['input']>;
  hasFinishedOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  hasStartedOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  hkFile?: InputMaybe<Scalars['String']['input']>;
  identityFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  imgs?: InputMaybe<DogBreederImgCreateNestedManyWithoutDogBreederInput>;
  lastAutomationEmailSentAt?: InputMaybe<Scalars['DateTime']['input']>;
  level?: InputMaybe<Scalars['String']['input']>;
  litters?: InputMaybe<LitterCreateNestedManyWithoutBreederInput>;
  littersByFemale?: InputMaybe<Scalars['String']['input']>;
  littersByFemaleCount?: InputMaybe<Scalars['Int']['input']>;
  maleBreedersCount?: InputMaybe<Scalars['Int']['input']>;
  medicalTestsPerformed?: InputMaybe<Scalars['String']['input']>;
  motherRestBetweenLitters?: InputMaybe<Scalars['String']['input']>;
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutBreederInput>;
  permissionFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  puppies?: InputMaybe<DogPuppyCreateNestedManyWithoutBreederInput>;
  puppiesBirthPlace?: InputMaybe<Scalars['String']['input']>;
  reviews?: InputMaybe<DogBreederReviewCreateNestedManyWithoutDogBreederInput>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  studInfos?: InputMaybe<StudInfoCreateNestedManyWithoutBreederInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  translations?: InputMaybe<DogBreederTranslationCreateNestedManyWithoutDogBreederInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updates?: InputMaybe<UpdateCreateNestedManyWithoutBreederInput>;
  vatNumber?: InputMaybe<Scalars['String']['input']>;
  veterinaryInfo?: InputMaybe<Scalars['String']['input']>;
  videoUrl?: InputMaybe<Scalars['String']['input']>;
  visitedByTipaw?: InputMaybe<Scalars['Boolean']['input']>;
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
  whatsappNumber?: InputMaybe<Scalars['String']['input']>;
};

export type DogBreederCreateManyInput = {
  adminNote?: InputMaybe<Scalars['String']['input']>;
  agreementNumber?: InputMaybe<Scalars['String']['input']>;
  breedClubFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  breedClubValidated?: InputMaybe<Scalars['Boolean']['input']>;
  breedingName?: InputMaybe<Scalars['String']['input']>;
  certificationFile?: InputMaybe<Scalars['String']['input']>;
  certified?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  displayEmail?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  displayPhone?: InputMaybe<Scalars['String']['input']>;
  dogsConsanguinity?: InputMaybe<Scalars['String']['input']>;
  dogsPedigree?: InputMaybe<Scalars['String']['input']>;
  dogsTemper?: InputMaybe<Scalars['String']['input']>;
  emailAutomationStage?: InputMaybe<Scalars['Int']['input']>;
  facebookUrl?: InputMaybe<Scalars['String']['input']>;
  failedMedicalTestsProtocol?: InputMaybe<Scalars['String']['input']>;
  hasFinishedOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  hasStartedOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  hkFile?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  identityFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  lastAutomationEmailSentAt?: InputMaybe<Scalars['DateTime']['input']>;
  level?: InputMaybe<Scalars['String']['input']>;
  littersByFemale?: InputMaybe<Scalars['String']['input']>;
  littersByFemaleCount?: InputMaybe<Scalars['Int']['input']>;
  maleBreedersCount?: InputMaybe<Scalars['Int']['input']>;
  medicalTestsPerformed?: InputMaybe<Scalars['String']['input']>;
  motherRestBetweenLitters?: InputMaybe<Scalars['String']['input']>;
  permissionFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  puppiesBirthPlace?: InputMaybe<Scalars['String']['input']>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  vatNumber?: InputMaybe<Scalars['String']['input']>;
  veterinaryInfo?: InputMaybe<Scalars['String']['input']>;
  videoUrl?: InputMaybe<Scalars['String']['input']>;
  visitedByTipaw?: InputMaybe<Scalars['Boolean']['input']>;
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
  whatsappNumber?: InputMaybe<Scalars['String']['input']>;
};

export type DogBreederCreateNestedOneWithoutAccountInput = {
  connect?: InputMaybe<DogBreederWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DogBreederCreateOrConnectWithoutAccountInput>;
  create?: InputMaybe<DogBreederCreateWithoutAccountInput>;
};

export type DogBreederCreateNestedOneWithoutApplicationsInput = {
  connect?: InputMaybe<DogBreederWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DogBreederCreateOrConnectWithoutApplicationsInput>;
  create?: InputMaybe<DogBreederCreateWithoutApplicationsInput>;
};

export type DogBreederCreateNestedOneWithoutBreederBreedsInput = {
  connect?: InputMaybe<DogBreederWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DogBreederCreateOrConnectWithoutBreederBreedsInput>;
  create?: InputMaybe<DogBreederCreateWithoutBreederBreedsInput>;
};

export type DogBreederCreateNestedOneWithoutDogInfosInput = {
  connect?: InputMaybe<DogBreederWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DogBreederCreateOrConnectWithoutDogInfosInput>;
  create?: InputMaybe<DogBreederCreateWithoutDogInfosInput>;
};

export type DogBreederCreateNestedOneWithoutEmailHistoryInput = {
  connect?: InputMaybe<DogBreederWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DogBreederCreateOrConnectWithoutEmailHistoryInput>;
  create?: InputMaybe<DogBreederCreateWithoutEmailHistoryInput>;
};

export type DogBreederCreateNestedOneWithoutImgsInput = {
  connect?: InputMaybe<DogBreederWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DogBreederCreateOrConnectWithoutImgsInput>;
  create?: InputMaybe<DogBreederCreateWithoutImgsInput>;
};

export type DogBreederCreateNestedOneWithoutLittersInput = {
  connect?: InputMaybe<DogBreederWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DogBreederCreateOrConnectWithoutLittersInput>;
  create?: InputMaybe<DogBreederCreateWithoutLittersInput>;
};

export type DogBreederCreateNestedOneWithoutNotificationsInput = {
  connect?: InputMaybe<DogBreederWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DogBreederCreateOrConnectWithoutNotificationsInput>;
  create?: InputMaybe<DogBreederCreateWithoutNotificationsInput>;
};

export type DogBreederCreateNestedOneWithoutPuppiesInput = {
  connect?: InputMaybe<DogBreederWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DogBreederCreateOrConnectWithoutPuppiesInput>;
  create?: InputMaybe<DogBreederCreateWithoutPuppiesInput>;
};

export type DogBreederCreateNestedOneWithoutReviewsInput = {
  connect?: InputMaybe<DogBreederWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DogBreederCreateOrConnectWithoutReviewsInput>;
  create?: InputMaybe<DogBreederCreateWithoutReviewsInput>;
};

export type DogBreederCreateNestedOneWithoutStudInfosInput = {
  connect?: InputMaybe<DogBreederWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DogBreederCreateOrConnectWithoutStudInfosInput>;
  create?: InputMaybe<DogBreederCreateWithoutStudInfosInput>;
};

export type DogBreederCreateNestedOneWithoutTranslationsInput = {
  connect?: InputMaybe<DogBreederWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DogBreederCreateOrConnectWithoutTranslationsInput>;
  create?: InputMaybe<DogBreederCreateWithoutTranslationsInput>;
};

export type DogBreederCreateNestedOneWithoutUpdatesInput = {
  connect?: InputMaybe<DogBreederWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DogBreederCreateOrConnectWithoutUpdatesInput>;
  create?: InputMaybe<DogBreederCreateWithoutUpdatesInput>;
};

export type DogBreederCreateOrConnectWithoutAccountInput = {
  create: DogBreederCreateWithoutAccountInput;
  where: DogBreederWhereUniqueInput;
};

export type DogBreederCreateOrConnectWithoutApplicationsInput = {
  create: DogBreederCreateWithoutApplicationsInput;
  where: DogBreederWhereUniqueInput;
};

export type DogBreederCreateOrConnectWithoutBreederBreedsInput = {
  create: DogBreederCreateWithoutBreederBreedsInput;
  where: DogBreederWhereUniqueInput;
};

export type DogBreederCreateOrConnectWithoutDogInfosInput = {
  create: DogBreederCreateWithoutDogInfosInput;
  where: DogBreederWhereUniqueInput;
};

export type DogBreederCreateOrConnectWithoutEmailHistoryInput = {
  create: DogBreederCreateWithoutEmailHistoryInput;
  where: DogBreederWhereUniqueInput;
};

export type DogBreederCreateOrConnectWithoutImgsInput = {
  create: DogBreederCreateWithoutImgsInput;
  where: DogBreederWhereUniqueInput;
};

export type DogBreederCreateOrConnectWithoutLittersInput = {
  create: DogBreederCreateWithoutLittersInput;
  where: DogBreederWhereUniqueInput;
};

export type DogBreederCreateOrConnectWithoutNotificationsInput = {
  create: DogBreederCreateWithoutNotificationsInput;
  where: DogBreederWhereUniqueInput;
};

export type DogBreederCreateOrConnectWithoutPuppiesInput = {
  create: DogBreederCreateWithoutPuppiesInput;
  where: DogBreederWhereUniqueInput;
};

export type DogBreederCreateOrConnectWithoutReviewsInput = {
  create: DogBreederCreateWithoutReviewsInput;
  where: DogBreederWhereUniqueInput;
};

export type DogBreederCreateOrConnectWithoutStudInfosInput = {
  create: DogBreederCreateWithoutStudInfosInput;
  where: DogBreederWhereUniqueInput;
};

export type DogBreederCreateOrConnectWithoutTranslationsInput = {
  create: DogBreederCreateWithoutTranslationsInput;
  where: DogBreederWhereUniqueInput;
};

export type DogBreederCreateOrConnectWithoutUpdatesInput = {
  create: DogBreederCreateWithoutUpdatesInput;
  where: DogBreederWhereUniqueInput;
};

export type DogBreederCreateWithoutAccountInput = {
  adminNote?: InputMaybe<Scalars['String']['input']>;
  agreementNumber?: InputMaybe<Scalars['String']['input']>;
  applications?: InputMaybe<DogBreederApplicationCreateNestedManyWithoutDogBreederInput>;
  breedClubFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  breedClubValidated?: InputMaybe<Scalars['Boolean']['input']>;
  breederBreeds?: InputMaybe<DogBreederBreedsCreateNestedManyWithoutDogBreederInput>;
  breedingName?: InputMaybe<Scalars['String']['input']>;
  certificationFile?: InputMaybe<Scalars['String']['input']>;
  certified?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  displayEmail?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  displayPhone?: InputMaybe<Scalars['String']['input']>;
  dogInfos?: InputMaybe<DogInfoCreateNestedManyWithoutBreederInput>;
  dogsConsanguinity?: InputMaybe<Scalars['String']['input']>;
  dogsPedigree?: InputMaybe<Scalars['String']['input']>;
  dogsTemper?: InputMaybe<Scalars['String']['input']>;
  emailAutomationStage?: InputMaybe<Scalars['Int']['input']>;
  emailHistory?: InputMaybe<EmailHistoryCreateNestedManyWithoutBreederInput>;
  facebookUrl?: InputMaybe<Scalars['String']['input']>;
  failedMedicalTestsProtocol?: InputMaybe<Scalars['String']['input']>;
  hasFinishedOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  hasStartedOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  hkFile?: InputMaybe<Scalars['String']['input']>;
  identityFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  imgs?: InputMaybe<DogBreederImgCreateNestedManyWithoutDogBreederInput>;
  lastAutomationEmailSentAt?: InputMaybe<Scalars['DateTime']['input']>;
  level?: InputMaybe<Scalars['String']['input']>;
  litters?: InputMaybe<LitterCreateNestedManyWithoutBreederInput>;
  littersByFemale?: InputMaybe<Scalars['String']['input']>;
  littersByFemaleCount?: InputMaybe<Scalars['Int']['input']>;
  maleBreedersCount?: InputMaybe<Scalars['Int']['input']>;
  medicalTestsPerformed?: InputMaybe<Scalars['String']['input']>;
  motherRestBetweenLitters?: InputMaybe<Scalars['String']['input']>;
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutBreederInput>;
  permissionFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  puppies?: InputMaybe<DogPuppyCreateNestedManyWithoutBreederInput>;
  puppiesBirthPlace?: InputMaybe<Scalars['String']['input']>;
  reviews?: InputMaybe<DogBreederReviewCreateNestedManyWithoutDogBreederInput>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  studInfos?: InputMaybe<StudInfoCreateNestedManyWithoutBreederInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  translations?: InputMaybe<DogBreederTranslationCreateNestedManyWithoutDogBreederInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updates?: InputMaybe<UpdateCreateNestedManyWithoutBreederInput>;
  vatNumber?: InputMaybe<Scalars['String']['input']>;
  veterinaryInfo?: InputMaybe<Scalars['String']['input']>;
  videoUrl?: InputMaybe<Scalars['String']['input']>;
  visitedByTipaw?: InputMaybe<Scalars['Boolean']['input']>;
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
  whatsappNumber?: InputMaybe<Scalars['String']['input']>;
};

export type DogBreederCreateWithoutApplicationsInput = {
  account: AccountCreateNestedOneWithoutDogBreederInput;
  adminNote?: InputMaybe<Scalars['String']['input']>;
  agreementNumber?: InputMaybe<Scalars['String']['input']>;
  breedClubFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  breedClubValidated?: InputMaybe<Scalars['Boolean']['input']>;
  breederBreeds?: InputMaybe<DogBreederBreedsCreateNestedManyWithoutDogBreederInput>;
  breedingName?: InputMaybe<Scalars['String']['input']>;
  certificationFile?: InputMaybe<Scalars['String']['input']>;
  certified?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  displayEmail?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  displayPhone?: InputMaybe<Scalars['String']['input']>;
  dogInfos?: InputMaybe<DogInfoCreateNestedManyWithoutBreederInput>;
  dogsConsanguinity?: InputMaybe<Scalars['String']['input']>;
  dogsPedigree?: InputMaybe<Scalars['String']['input']>;
  dogsTemper?: InputMaybe<Scalars['String']['input']>;
  emailAutomationStage?: InputMaybe<Scalars['Int']['input']>;
  emailHistory?: InputMaybe<EmailHistoryCreateNestedManyWithoutBreederInput>;
  facebookUrl?: InputMaybe<Scalars['String']['input']>;
  failedMedicalTestsProtocol?: InputMaybe<Scalars['String']['input']>;
  hasFinishedOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  hasStartedOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  hkFile?: InputMaybe<Scalars['String']['input']>;
  identityFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  imgs?: InputMaybe<DogBreederImgCreateNestedManyWithoutDogBreederInput>;
  lastAutomationEmailSentAt?: InputMaybe<Scalars['DateTime']['input']>;
  level?: InputMaybe<Scalars['String']['input']>;
  litters?: InputMaybe<LitterCreateNestedManyWithoutBreederInput>;
  littersByFemale?: InputMaybe<Scalars['String']['input']>;
  littersByFemaleCount?: InputMaybe<Scalars['Int']['input']>;
  maleBreedersCount?: InputMaybe<Scalars['Int']['input']>;
  medicalTestsPerformed?: InputMaybe<Scalars['String']['input']>;
  motherRestBetweenLitters?: InputMaybe<Scalars['String']['input']>;
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutBreederInput>;
  permissionFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  puppies?: InputMaybe<DogPuppyCreateNestedManyWithoutBreederInput>;
  puppiesBirthPlace?: InputMaybe<Scalars['String']['input']>;
  reviews?: InputMaybe<DogBreederReviewCreateNestedManyWithoutDogBreederInput>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  studInfos?: InputMaybe<StudInfoCreateNestedManyWithoutBreederInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  translations?: InputMaybe<DogBreederTranslationCreateNestedManyWithoutDogBreederInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updates?: InputMaybe<UpdateCreateNestedManyWithoutBreederInput>;
  vatNumber?: InputMaybe<Scalars['String']['input']>;
  veterinaryInfo?: InputMaybe<Scalars['String']['input']>;
  videoUrl?: InputMaybe<Scalars['String']['input']>;
  visitedByTipaw?: InputMaybe<Scalars['Boolean']['input']>;
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
  whatsappNumber?: InputMaybe<Scalars['String']['input']>;
};

export type DogBreederCreateWithoutBreederBreedsInput = {
  account: AccountCreateNestedOneWithoutDogBreederInput;
  adminNote?: InputMaybe<Scalars['String']['input']>;
  agreementNumber?: InputMaybe<Scalars['String']['input']>;
  applications?: InputMaybe<DogBreederApplicationCreateNestedManyWithoutDogBreederInput>;
  breedClubFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  breedClubValidated?: InputMaybe<Scalars['Boolean']['input']>;
  breedingName?: InputMaybe<Scalars['String']['input']>;
  certificationFile?: InputMaybe<Scalars['String']['input']>;
  certified?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  displayEmail?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  displayPhone?: InputMaybe<Scalars['String']['input']>;
  dogInfos?: InputMaybe<DogInfoCreateNestedManyWithoutBreederInput>;
  dogsConsanguinity?: InputMaybe<Scalars['String']['input']>;
  dogsPedigree?: InputMaybe<Scalars['String']['input']>;
  dogsTemper?: InputMaybe<Scalars['String']['input']>;
  emailAutomationStage?: InputMaybe<Scalars['Int']['input']>;
  emailHistory?: InputMaybe<EmailHistoryCreateNestedManyWithoutBreederInput>;
  facebookUrl?: InputMaybe<Scalars['String']['input']>;
  failedMedicalTestsProtocol?: InputMaybe<Scalars['String']['input']>;
  hasFinishedOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  hasStartedOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  hkFile?: InputMaybe<Scalars['String']['input']>;
  identityFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  imgs?: InputMaybe<DogBreederImgCreateNestedManyWithoutDogBreederInput>;
  lastAutomationEmailSentAt?: InputMaybe<Scalars['DateTime']['input']>;
  level?: InputMaybe<Scalars['String']['input']>;
  litters?: InputMaybe<LitterCreateNestedManyWithoutBreederInput>;
  littersByFemale?: InputMaybe<Scalars['String']['input']>;
  littersByFemaleCount?: InputMaybe<Scalars['Int']['input']>;
  maleBreedersCount?: InputMaybe<Scalars['Int']['input']>;
  medicalTestsPerformed?: InputMaybe<Scalars['String']['input']>;
  motherRestBetweenLitters?: InputMaybe<Scalars['String']['input']>;
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutBreederInput>;
  permissionFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  puppies?: InputMaybe<DogPuppyCreateNestedManyWithoutBreederInput>;
  puppiesBirthPlace?: InputMaybe<Scalars['String']['input']>;
  reviews?: InputMaybe<DogBreederReviewCreateNestedManyWithoutDogBreederInput>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  studInfos?: InputMaybe<StudInfoCreateNestedManyWithoutBreederInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  translations?: InputMaybe<DogBreederTranslationCreateNestedManyWithoutDogBreederInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updates?: InputMaybe<UpdateCreateNestedManyWithoutBreederInput>;
  vatNumber?: InputMaybe<Scalars['String']['input']>;
  veterinaryInfo?: InputMaybe<Scalars['String']['input']>;
  videoUrl?: InputMaybe<Scalars['String']['input']>;
  visitedByTipaw?: InputMaybe<Scalars['Boolean']['input']>;
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
  whatsappNumber?: InputMaybe<Scalars['String']['input']>;
};

export type DogBreederCreateWithoutDogInfosInput = {
  account: AccountCreateNestedOneWithoutDogBreederInput;
  adminNote?: InputMaybe<Scalars['String']['input']>;
  agreementNumber?: InputMaybe<Scalars['String']['input']>;
  applications?: InputMaybe<DogBreederApplicationCreateNestedManyWithoutDogBreederInput>;
  breedClubFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  breedClubValidated?: InputMaybe<Scalars['Boolean']['input']>;
  breederBreeds?: InputMaybe<DogBreederBreedsCreateNestedManyWithoutDogBreederInput>;
  breedingName?: InputMaybe<Scalars['String']['input']>;
  certificationFile?: InputMaybe<Scalars['String']['input']>;
  certified?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  displayEmail?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  displayPhone?: InputMaybe<Scalars['String']['input']>;
  dogsConsanguinity?: InputMaybe<Scalars['String']['input']>;
  dogsPedigree?: InputMaybe<Scalars['String']['input']>;
  dogsTemper?: InputMaybe<Scalars['String']['input']>;
  emailAutomationStage?: InputMaybe<Scalars['Int']['input']>;
  emailHistory?: InputMaybe<EmailHistoryCreateNestedManyWithoutBreederInput>;
  facebookUrl?: InputMaybe<Scalars['String']['input']>;
  failedMedicalTestsProtocol?: InputMaybe<Scalars['String']['input']>;
  hasFinishedOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  hasStartedOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  hkFile?: InputMaybe<Scalars['String']['input']>;
  identityFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  imgs?: InputMaybe<DogBreederImgCreateNestedManyWithoutDogBreederInput>;
  lastAutomationEmailSentAt?: InputMaybe<Scalars['DateTime']['input']>;
  level?: InputMaybe<Scalars['String']['input']>;
  litters?: InputMaybe<LitterCreateNestedManyWithoutBreederInput>;
  littersByFemale?: InputMaybe<Scalars['String']['input']>;
  littersByFemaleCount?: InputMaybe<Scalars['Int']['input']>;
  maleBreedersCount?: InputMaybe<Scalars['Int']['input']>;
  medicalTestsPerformed?: InputMaybe<Scalars['String']['input']>;
  motherRestBetweenLitters?: InputMaybe<Scalars['String']['input']>;
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutBreederInput>;
  permissionFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  puppies?: InputMaybe<DogPuppyCreateNestedManyWithoutBreederInput>;
  puppiesBirthPlace?: InputMaybe<Scalars['String']['input']>;
  reviews?: InputMaybe<DogBreederReviewCreateNestedManyWithoutDogBreederInput>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  studInfos?: InputMaybe<StudInfoCreateNestedManyWithoutBreederInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  translations?: InputMaybe<DogBreederTranslationCreateNestedManyWithoutDogBreederInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updates?: InputMaybe<UpdateCreateNestedManyWithoutBreederInput>;
  vatNumber?: InputMaybe<Scalars['String']['input']>;
  veterinaryInfo?: InputMaybe<Scalars['String']['input']>;
  videoUrl?: InputMaybe<Scalars['String']['input']>;
  visitedByTipaw?: InputMaybe<Scalars['Boolean']['input']>;
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
  whatsappNumber?: InputMaybe<Scalars['String']['input']>;
};

export type DogBreederCreateWithoutEmailHistoryInput = {
  account: AccountCreateNestedOneWithoutDogBreederInput;
  adminNote?: InputMaybe<Scalars['String']['input']>;
  agreementNumber?: InputMaybe<Scalars['String']['input']>;
  applications?: InputMaybe<DogBreederApplicationCreateNestedManyWithoutDogBreederInput>;
  breedClubFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  breedClubValidated?: InputMaybe<Scalars['Boolean']['input']>;
  breederBreeds?: InputMaybe<DogBreederBreedsCreateNestedManyWithoutDogBreederInput>;
  breedingName?: InputMaybe<Scalars['String']['input']>;
  certificationFile?: InputMaybe<Scalars['String']['input']>;
  certified?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  displayEmail?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  displayPhone?: InputMaybe<Scalars['String']['input']>;
  dogInfos?: InputMaybe<DogInfoCreateNestedManyWithoutBreederInput>;
  dogsConsanguinity?: InputMaybe<Scalars['String']['input']>;
  dogsPedigree?: InputMaybe<Scalars['String']['input']>;
  dogsTemper?: InputMaybe<Scalars['String']['input']>;
  emailAutomationStage?: InputMaybe<Scalars['Int']['input']>;
  facebookUrl?: InputMaybe<Scalars['String']['input']>;
  failedMedicalTestsProtocol?: InputMaybe<Scalars['String']['input']>;
  hasFinishedOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  hasStartedOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  hkFile?: InputMaybe<Scalars['String']['input']>;
  identityFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  imgs?: InputMaybe<DogBreederImgCreateNestedManyWithoutDogBreederInput>;
  lastAutomationEmailSentAt?: InputMaybe<Scalars['DateTime']['input']>;
  level?: InputMaybe<Scalars['String']['input']>;
  litters?: InputMaybe<LitterCreateNestedManyWithoutBreederInput>;
  littersByFemale?: InputMaybe<Scalars['String']['input']>;
  littersByFemaleCount?: InputMaybe<Scalars['Int']['input']>;
  maleBreedersCount?: InputMaybe<Scalars['Int']['input']>;
  medicalTestsPerformed?: InputMaybe<Scalars['String']['input']>;
  motherRestBetweenLitters?: InputMaybe<Scalars['String']['input']>;
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutBreederInput>;
  permissionFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  puppies?: InputMaybe<DogPuppyCreateNestedManyWithoutBreederInput>;
  puppiesBirthPlace?: InputMaybe<Scalars['String']['input']>;
  reviews?: InputMaybe<DogBreederReviewCreateNestedManyWithoutDogBreederInput>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  studInfos?: InputMaybe<StudInfoCreateNestedManyWithoutBreederInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  translations?: InputMaybe<DogBreederTranslationCreateNestedManyWithoutDogBreederInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updates?: InputMaybe<UpdateCreateNestedManyWithoutBreederInput>;
  vatNumber?: InputMaybe<Scalars['String']['input']>;
  veterinaryInfo?: InputMaybe<Scalars['String']['input']>;
  videoUrl?: InputMaybe<Scalars['String']['input']>;
  visitedByTipaw?: InputMaybe<Scalars['Boolean']['input']>;
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
  whatsappNumber?: InputMaybe<Scalars['String']['input']>;
};

export type DogBreederCreateWithoutImgsInput = {
  account: AccountCreateNestedOneWithoutDogBreederInput;
  adminNote?: InputMaybe<Scalars['String']['input']>;
  agreementNumber?: InputMaybe<Scalars['String']['input']>;
  applications?: InputMaybe<DogBreederApplicationCreateNestedManyWithoutDogBreederInput>;
  breedClubFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  breedClubValidated?: InputMaybe<Scalars['Boolean']['input']>;
  breederBreeds?: InputMaybe<DogBreederBreedsCreateNestedManyWithoutDogBreederInput>;
  breedingName?: InputMaybe<Scalars['String']['input']>;
  certificationFile?: InputMaybe<Scalars['String']['input']>;
  certified?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  displayEmail?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  displayPhone?: InputMaybe<Scalars['String']['input']>;
  dogInfos?: InputMaybe<DogInfoCreateNestedManyWithoutBreederInput>;
  dogsConsanguinity?: InputMaybe<Scalars['String']['input']>;
  dogsPedigree?: InputMaybe<Scalars['String']['input']>;
  dogsTemper?: InputMaybe<Scalars['String']['input']>;
  emailAutomationStage?: InputMaybe<Scalars['Int']['input']>;
  emailHistory?: InputMaybe<EmailHistoryCreateNestedManyWithoutBreederInput>;
  facebookUrl?: InputMaybe<Scalars['String']['input']>;
  failedMedicalTestsProtocol?: InputMaybe<Scalars['String']['input']>;
  hasFinishedOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  hasStartedOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  hkFile?: InputMaybe<Scalars['String']['input']>;
  identityFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  lastAutomationEmailSentAt?: InputMaybe<Scalars['DateTime']['input']>;
  level?: InputMaybe<Scalars['String']['input']>;
  litters?: InputMaybe<LitterCreateNestedManyWithoutBreederInput>;
  littersByFemale?: InputMaybe<Scalars['String']['input']>;
  littersByFemaleCount?: InputMaybe<Scalars['Int']['input']>;
  maleBreedersCount?: InputMaybe<Scalars['Int']['input']>;
  medicalTestsPerformed?: InputMaybe<Scalars['String']['input']>;
  motherRestBetweenLitters?: InputMaybe<Scalars['String']['input']>;
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutBreederInput>;
  permissionFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  puppies?: InputMaybe<DogPuppyCreateNestedManyWithoutBreederInput>;
  puppiesBirthPlace?: InputMaybe<Scalars['String']['input']>;
  reviews?: InputMaybe<DogBreederReviewCreateNestedManyWithoutDogBreederInput>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  studInfos?: InputMaybe<StudInfoCreateNestedManyWithoutBreederInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  translations?: InputMaybe<DogBreederTranslationCreateNestedManyWithoutDogBreederInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updates?: InputMaybe<UpdateCreateNestedManyWithoutBreederInput>;
  vatNumber?: InputMaybe<Scalars['String']['input']>;
  veterinaryInfo?: InputMaybe<Scalars['String']['input']>;
  videoUrl?: InputMaybe<Scalars['String']['input']>;
  visitedByTipaw?: InputMaybe<Scalars['Boolean']['input']>;
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
  whatsappNumber?: InputMaybe<Scalars['String']['input']>;
};

export type DogBreederCreateWithoutLittersInput = {
  account: AccountCreateNestedOneWithoutDogBreederInput;
  adminNote?: InputMaybe<Scalars['String']['input']>;
  agreementNumber?: InputMaybe<Scalars['String']['input']>;
  applications?: InputMaybe<DogBreederApplicationCreateNestedManyWithoutDogBreederInput>;
  breedClubFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  breedClubValidated?: InputMaybe<Scalars['Boolean']['input']>;
  breederBreeds?: InputMaybe<DogBreederBreedsCreateNestedManyWithoutDogBreederInput>;
  breedingName?: InputMaybe<Scalars['String']['input']>;
  certificationFile?: InputMaybe<Scalars['String']['input']>;
  certified?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  displayEmail?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  displayPhone?: InputMaybe<Scalars['String']['input']>;
  dogInfos?: InputMaybe<DogInfoCreateNestedManyWithoutBreederInput>;
  dogsConsanguinity?: InputMaybe<Scalars['String']['input']>;
  dogsPedigree?: InputMaybe<Scalars['String']['input']>;
  dogsTemper?: InputMaybe<Scalars['String']['input']>;
  emailAutomationStage?: InputMaybe<Scalars['Int']['input']>;
  emailHistory?: InputMaybe<EmailHistoryCreateNestedManyWithoutBreederInput>;
  facebookUrl?: InputMaybe<Scalars['String']['input']>;
  failedMedicalTestsProtocol?: InputMaybe<Scalars['String']['input']>;
  hasFinishedOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  hasStartedOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  hkFile?: InputMaybe<Scalars['String']['input']>;
  identityFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  imgs?: InputMaybe<DogBreederImgCreateNestedManyWithoutDogBreederInput>;
  lastAutomationEmailSentAt?: InputMaybe<Scalars['DateTime']['input']>;
  level?: InputMaybe<Scalars['String']['input']>;
  littersByFemale?: InputMaybe<Scalars['String']['input']>;
  littersByFemaleCount?: InputMaybe<Scalars['Int']['input']>;
  maleBreedersCount?: InputMaybe<Scalars['Int']['input']>;
  medicalTestsPerformed?: InputMaybe<Scalars['String']['input']>;
  motherRestBetweenLitters?: InputMaybe<Scalars['String']['input']>;
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutBreederInput>;
  permissionFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  puppies?: InputMaybe<DogPuppyCreateNestedManyWithoutBreederInput>;
  puppiesBirthPlace?: InputMaybe<Scalars['String']['input']>;
  reviews?: InputMaybe<DogBreederReviewCreateNestedManyWithoutDogBreederInput>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  studInfos?: InputMaybe<StudInfoCreateNestedManyWithoutBreederInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  translations?: InputMaybe<DogBreederTranslationCreateNestedManyWithoutDogBreederInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updates?: InputMaybe<UpdateCreateNestedManyWithoutBreederInput>;
  vatNumber?: InputMaybe<Scalars['String']['input']>;
  veterinaryInfo?: InputMaybe<Scalars['String']['input']>;
  videoUrl?: InputMaybe<Scalars['String']['input']>;
  visitedByTipaw?: InputMaybe<Scalars['Boolean']['input']>;
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
  whatsappNumber?: InputMaybe<Scalars['String']['input']>;
};

export type DogBreederCreateWithoutNotificationsInput = {
  account: AccountCreateNestedOneWithoutDogBreederInput;
  adminNote?: InputMaybe<Scalars['String']['input']>;
  agreementNumber?: InputMaybe<Scalars['String']['input']>;
  applications?: InputMaybe<DogBreederApplicationCreateNestedManyWithoutDogBreederInput>;
  breedClubFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  breedClubValidated?: InputMaybe<Scalars['Boolean']['input']>;
  breederBreeds?: InputMaybe<DogBreederBreedsCreateNestedManyWithoutDogBreederInput>;
  breedingName?: InputMaybe<Scalars['String']['input']>;
  certificationFile?: InputMaybe<Scalars['String']['input']>;
  certified?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  displayEmail?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  displayPhone?: InputMaybe<Scalars['String']['input']>;
  dogInfos?: InputMaybe<DogInfoCreateNestedManyWithoutBreederInput>;
  dogsConsanguinity?: InputMaybe<Scalars['String']['input']>;
  dogsPedigree?: InputMaybe<Scalars['String']['input']>;
  dogsTemper?: InputMaybe<Scalars['String']['input']>;
  emailAutomationStage?: InputMaybe<Scalars['Int']['input']>;
  emailHistory?: InputMaybe<EmailHistoryCreateNestedManyWithoutBreederInput>;
  facebookUrl?: InputMaybe<Scalars['String']['input']>;
  failedMedicalTestsProtocol?: InputMaybe<Scalars['String']['input']>;
  hasFinishedOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  hasStartedOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  hkFile?: InputMaybe<Scalars['String']['input']>;
  identityFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  imgs?: InputMaybe<DogBreederImgCreateNestedManyWithoutDogBreederInput>;
  lastAutomationEmailSentAt?: InputMaybe<Scalars['DateTime']['input']>;
  level?: InputMaybe<Scalars['String']['input']>;
  litters?: InputMaybe<LitterCreateNestedManyWithoutBreederInput>;
  littersByFemale?: InputMaybe<Scalars['String']['input']>;
  littersByFemaleCount?: InputMaybe<Scalars['Int']['input']>;
  maleBreedersCount?: InputMaybe<Scalars['Int']['input']>;
  medicalTestsPerformed?: InputMaybe<Scalars['String']['input']>;
  motherRestBetweenLitters?: InputMaybe<Scalars['String']['input']>;
  permissionFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  puppies?: InputMaybe<DogPuppyCreateNestedManyWithoutBreederInput>;
  puppiesBirthPlace?: InputMaybe<Scalars['String']['input']>;
  reviews?: InputMaybe<DogBreederReviewCreateNestedManyWithoutDogBreederInput>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  studInfos?: InputMaybe<StudInfoCreateNestedManyWithoutBreederInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  translations?: InputMaybe<DogBreederTranslationCreateNestedManyWithoutDogBreederInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updates?: InputMaybe<UpdateCreateNestedManyWithoutBreederInput>;
  vatNumber?: InputMaybe<Scalars['String']['input']>;
  veterinaryInfo?: InputMaybe<Scalars['String']['input']>;
  videoUrl?: InputMaybe<Scalars['String']['input']>;
  visitedByTipaw?: InputMaybe<Scalars['Boolean']['input']>;
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
  whatsappNumber?: InputMaybe<Scalars['String']['input']>;
};

export type DogBreederCreateWithoutPuppiesInput = {
  account: AccountCreateNestedOneWithoutDogBreederInput;
  adminNote?: InputMaybe<Scalars['String']['input']>;
  agreementNumber?: InputMaybe<Scalars['String']['input']>;
  applications?: InputMaybe<DogBreederApplicationCreateNestedManyWithoutDogBreederInput>;
  breedClubFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  breedClubValidated?: InputMaybe<Scalars['Boolean']['input']>;
  breederBreeds?: InputMaybe<DogBreederBreedsCreateNestedManyWithoutDogBreederInput>;
  breedingName?: InputMaybe<Scalars['String']['input']>;
  certificationFile?: InputMaybe<Scalars['String']['input']>;
  certified?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  displayEmail?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  displayPhone?: InputMaybe<Scalars['String']['input']>;
  dogInfos?: InputMaybe<DogInfoCreateNestedManyWithoutBreederInput>;
  dogsConsanguinity?: InputMaybe<Scalars['String']['input']>;
  dogsPedigree?: InputMaybe<Scalars['String']['input']>;
  dogsTemper?: InputMaybe<Scalars['String']['input']>;
  emailAutomationStage?: InputMaybe<Scalars['Int']['input']>;
  emailHistory?: InputMaybe<EmailHistoryCreateNestedManyWithoutBreederInput>;
  facebookUrl?: InputMaybe<Scalars['String']['input']>;
  failedMedicalTestsProtocol?: InputMaybe<Scalars['String']['input']>;
  hasFinishedOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  hasStartedOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  hkFile?: InputMaybe<Scalars['String']['input']>;
  identityFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  imgs?: InputMaybe<DogBreederImgCreateNestedManyWithoutDogBreederInput>;
  lastAutomationEmailSentAt?: InputMaybe<Scalars['DateTime']['input']>;
  level?: InputMaybe<Scalars['String']['input']>;
  litters?: InputMaybe<LitterCreateNestedManyWithoutBreederInput>;
  littersByFemale?: InputMaybe<Scalars['String']['input']>;
  littersByFemaleCount?: InputMaybe<Scalars['Int']['input']>;
  maleBreedersCount?: InputMaybe<Scalars['Int']['input']>;
  medicalTestsPerformed?: InputMaybe<Scalars['String']['input']>;
  motherRestBetweenLitters?: InputMaybe<Scalars['String']['input']>;
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutBreederInput>;
  permissionFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  puppiesBirthPlace?: InputMaybe<Scalars['String']['input']>;
  reviews?: InputMaybe<DogBreederReviewCreateNestedManyWithoutDogBreederInput>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  studInfos?: InputMaybe<StudInfoCreateNestedManyWithoutBreederInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  translations?: InputMaybe<DogBreederTranslationCreateNestedManyWithoutDogBreederInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updates?: InputMaybe<UpdateCreateNestedManyWithoutBreederInput>;
  vatNumber?: InputMaybe<Scalars['String']['input']>;
  veterinaryInfo?: InputMaybe<Scalars['String']['input']>;
  videoUrl?: InputMaybe<Scalars['String']['input']>;
  visitedByTipaw?: InputMaybe<Scalars['Boolean']['input']>;
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
  whatsappNumber?: InputMaybe<Scalars['String']['input']>;
};

export type DogBreederCreateWithoutReviewsInput = {
  account: AccountCreateNestedOneWithoutDogBreederInput;
  adminNote?: InputMaybe<Scalars['String']['input']>;
  agreementNumber?: InputMaybe<Scalars['String']['input']>;
  applications?: InputMaybe<DogBreederApplicationCreateNestedManyWithoutDogBreederInput>;
  breedClubFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  breedClubValidated?: InputMaybe<Scalars['Boolean']['input']>;
  breederBreeds?: InputMaybe<DogBreederBreedsCreateNestedManyWithoutDogBreederInput>;
  breedingName?: InputMaybe<Scalars['String']['input']>;
  certificationFile?: InputMaybe<Scalars['String']['input']>;
  certified?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  displayEmail?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  displayPhone?: InputMaybe<Scalars['String']['input']>;
  dogInfos?: InputMaybe<DogInfoCreateNestedManyWithoutBreederInput>;
  dogsConsanguinity?: InputMaybe<Scalars['String']['input']>;
  dogsPedigree?: InputMaybe<Scalars['String']['input']>;
  dogsTemper?: InputMaybe<Scalars['String']['input']>;
  emailAutomationStage?: InputMaybe<Scalars['Int']['input']>;
  emailHistory?: InputMaybe<EmailHistoryCreateNestedManyWithoutBreederInput>;
  facebookUrl?: InputMaybe<Scalars['String']['input']>;
  failedMedicalTestsProtocol?: InputMaybe<Scalars['String']['input']>;
  hasFinishedOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  hasStartedOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  hkFile?: InputMaybe<Scalars['String']['input']>;
  identityFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  imgs?: InputMaybe<DogBreederImgCreateNestedManyWithoutDogBreederInput>;
  lastAutomationEmailSentAt?: InputMaybe<Scalars['DateTime']['input']>;
  level?: InputMaybe<Scalars['String']['input']>;
  litters?: InputMaybe<LitterCreateNestedManyWithoutBreederInput>;
  littersByFemale?: InputMaybe<Scalars['String']['input']>;
  littersByFemaleCount?: InputMaybe<Scalars['Int']['input']>;
  maleBreedersCount?: InputMaybe<Scalars['Int']['input']>;
  medicalTestsPerformed?: InputMaybe<Scalars['String']['input']>;
  motherRestBetweenLitters?: InputMaybe<Scalars['String']['input']>;
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutBreederInput>;
  permissionFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  puppies?: InputMaybe<DogPuppyCreateNestedManyWithoutBreederInput>;
  puppiesBirthPlace?: InputMaybe<Scalars['String']['input']>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  studInfos?: InputMaybe<StudInfoCreateNestedManyWithoutBreederInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  translations?: InputMaybe<DogBreederTranslationCreateNestedManyWithoutDogBreederInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updates?: InputMaybe<UpdateCreateNestedManyWithoutBreederInput>;
  vatNumber?: InputMaybe<Scalars['String']['input']>;
  veterinaryInfo?: InputMaybe<Scalars['String']['input']>;
  videoUrl?: InputMaybe<Scalars['String']['input']>;
  visitedByTipaw?: InputMaybe<Scalars['Boolean']['input']>;
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
  whatsappNumber?: InputMaybe<Scalars['String']['input']>;
};

export type DogBreederCreateWithoutStudInfosInput = {
  account: AccountCreateNestedOneWithoutDogBreederInput;
  adminNote?: InputMaybe<Scalars['String']['input']>;
  agreementNumber?: InputMaybe<Scalars['String']['input']>;
  applications?: InputMaybe<DogBreederApplicationCreateNestedManyWithoutDogBreederInput>;
  breedClubFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  breedClubValidated?: InputMaybe<Scalars['Boolean']['input']>;
  breederBreeds?: InputMaybe<DogBreederBreedsCreateNestedManyWithoutDogBreederInput>;
  breedingName?: InputMaybe<Scalars['String']['input']>;
  certificationFile?: InputMaybe<Scalars['String']['input']>;
  certified?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  displayEmail?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  displayPhone?: InputMaybe<Scalars['String']['input']>;
  dogInfos?: InputMaybe<DogInfoCreateNestedManyWithoutBreederInput>;
  dogsConsanguinity?: InputMaybe<Scalars['String']['input']>;
  dogsPedigree?: InputMaybe<Scalars['String']['input']>;
  dogsTemper?: InputMaybe<Scalars['String']['input']>;
  emailAutomationStage?: InputMaybe<Scalars['Int']['input']>;
  emailHistory?: InputMaybe<EmailHistoryCreateNestedManyWithoutBreederInput>;
  facebookUrl?: InputMaybe<Scalars['String']['input']>;
  failedMedicalTestsProtocol?: InputMaybe<Scalars['String']['input']>;
  hasFinishedOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  hasStartedOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  hkFile?: InputMaybe<Scalars['String']['input']>;
  identityFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  imgs?: InputMaybe<DogBreederImgCreateNestedManyWithoutDogBreederInput>;
  lastAutomationEmailSentAt?: InputMaybe<Scalars['DateTime']['input']>;
  level?: InputMaybe<Scalars['String']['input']>;
  litters?: InputMaybe<LitterCreateNestedManyWithoutBreederInput>;
  littersByFemale?: InputMaybe<Scalars['String']['input']>;
  littersByFemaleCount?: InputMaybe<Scalars['Int']['input']>;
  maleBreedersCount?: InputMaybe<Scalars['Int']['input']>;
  medicalTestsPerformed?: InputMaybe<Scalars['String']['input']>;
  motherRestBetweenLitters?: InputMaybe<Scalars['String']['input']>;
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutBreederInput>;
  permissionFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  puppies?: InputMaybe<DogPuppyCreateNestedManyWithoutBreederInput>;
  puppiesBirthPlace?: InputMaybe<Scalars['String']['input']>;
  reviews?: InputMaybe<DogBreederReviewCreateNestedManyWithoutDogBreederInput>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  translations?: InputMaybe<DogBreederTranslationCreateNestedManyWithoutDogBreederInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updates?: InputMaybe<UpdateCreateNestedManyWithoutBreederInput>;
  vatNumber?: InputMaybe<Scalars['String']['input']>;
  veterinaryInfo?: InputMaybe<Scalars['String']['input']>;
  videoUrl?: InputMaybe<Scalars['String']['input']>;
  visitedByTipaw?: InputMaybe<Scalars['Boolean']['input']>;
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
  whatsappNumber?: InputMaybe<Scalars['String']['input']>;
};

export type DogBreederCreateWithoutTranslationsInput = {
  account: AccountCreateNestedOneWithoutDogBreederInput;
  adminNote?: InputMaybe<Scalars['String']['input']>;
  agreementNumber?: InputMaybe<Scalars['String']['input']>;
  applications?: InputMaybe<DogBreederApplicationCreateNestedManyWithoutDogBreederInput>;
  breedClubFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  breedClubValidated?: InputMaybe<Scalars['Boolean']['input']>;
  breederBreeds?: InputMaybe<DogBreederBreedsCreateNestedManyWithoutDogBreederInput>;
  breedingName?: InputMaybe<Scalars['String']['input']>;
  certificationFile?: InputMaybe<Scalars['String']['input']>;
  certified?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  displayEmail?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  displayPhone?: InputMaybe<Scalars['String']['input']>;
  dogInfos?: InputMaybe<DogInfoCreateNestedManyWithoutBreederInput>;
  dogsConsanguinity?: InputMaybe<Scalars['String']['input']>;
  dogsPedigree?: InputMaybe<Scalars['String']['input']>;
  dogsTemper?: InputMaybe<Scalars['String']['input']>;
  emailAutomationStage?: InputMaybe<Scalars['Int']['input']>;
  emailHistory?: InputMaybe<EmailHistoryCreateNestedManyWithoutBreederInput>;
  facebookUrl?: InputMaybe<Scalars['String']['input']>;
  failedMedicalTestsProtocol?: InputMaybe<Scalars['String']['input']>;
  hasFinishedOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  hasStartedOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  hkFile?: InputMaybe<Scalars['String']['input']>;
  identityFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  imgs?: InputMaybe<DogBreederImgCreateNestedManyWithoutDogBreederInput>;
  lastAutomationEmailSentAt?: InputMaybe<Scalars['DateTime']['input']>;
  level?: InputMaybe<Scalars['String']['input']>;
  litters?: InputMaybe<LitterCreateNestedManyWithoutBreederInput>;
  littersByFemale?: InputMaybe<Scalars['String']['input']>;
  littersByFemaleCount?: InputMaybe<Scalars['Int']['input']>;
  maleBreedersCount?: InputMaybe<Scalars['Int']['input']>;
  medicalTestsPerformed?: InputMaybe<Scalars['String']['input']>;
  motherRestBetweenLitters?: InputMaybe<Scalars['String']['input']>;
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutBreederInput>;
  permissionFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  puppies?: InputMaybe<DogPuppyCreateNestedManyWithoutBreederInput>;
  puppiesBirthPlace?: InputMaybe<Scalars['String']['input']>;
  reviews?: InputMaybe<DogBreederReviewCreateNestedManyWithoutDogBreederInput>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  studInfos?: InputMaybe<StudInfoCreateNestedManyWithoutBreederInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updates?: InputMaybe<UpdateCreateNestedManyWithoutBreederInput>;
  vatNumber?: InputMaybe<Scalars['String']['input']>;
  veterinaryInfo?: InputMaybe<Scalars['String']['input']>;
  videoUrl?: InputMaybe<Scalars['String']['input']>;
  visitedByTipaw?: InputMaybe<Scalars['Boolean']['input']>;
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
  whatsappNumber?: InputMaybe<Scalars['String']['input']>;
};

export type DogBreederCreateWithoutUpdatesInput = {
  account: AccountCreateNestedOneWithoutDogBreederInput;
  adminNote?: InputMaybe<Scalars['String']['input']>;
  agreementNumber?: InputMaybe<Scalars['String']['input']>;
  applications?: InputMaybe<DogBreederApplicationCreateNestedManyWithoutDogBreederInput>;
  breedClubFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  breedClubValidated?: InputMaybe<Scalars['Boolean']['input']>;
  breederBreeds?: InputMaybe<DogBreederBreedsCreateNestedManyWithoutDogBreederInput>;
  breedingName?: InputMaybe<Scalars['String']['input']>;
  certificationFile?: InputMaybe<Scalars['String']['input']>;
  certified?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  displayEmail?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  displayPhone?: InputMaybe<Scalars['String']['input']>;
  dogInfos?: InputMaybe<DogInfoCreateNestedManyWithoutBreederInput>;
  dogsConsanguinity?: InputMaybe<Scalars['String']['input']>;
  dogsPedigree?: InputMaybe<Scalars['String']['input']>;
  dogsTemper?: InputMaybe<Scalars['String']['input']>;
  emailAutomationStage?: InputMaybe<Scalars['Int']['input']>;
  emailHistory?: InputMaybe<EmailHistoryCreateNestedManyWithoutBreederInput>;
  facebookUrl?: InputMaybe<Scalars['String']['input']>;
  failedMedicalTestsProtocol?: InputMaybe<Scalars['String']['input']>;
  hasFinishedOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  hasStartedOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  hkFile?: InputMaybe<Scalars['String']['input']>;
  identityFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  imgs?: InputMaybe<DogBreederImgCreateNestedManyWithoutDogBreederInput>;
  lastAutomationEmailSentAt?: InputMaybe<Scalars['DateTime']['input']>;
  level?: InputMaybe<Scalars['String']['input']>;
  litters?: InputMaybe<LitterCreateNestedManyWithoutBreederInput>;
  littersByFemale?: InputMaybe<Scalars['String']['input']>;
  littersByFemaleCount?: InputMaybe<Scalars['Int']['input']>;
  maleBreedersCount?: InputMaybe<Scalars['Int']['input']>;
  medicalTestsPerformed?: InputMaybe<Scalars['String']['input']>;
  motherRestBetweenLitters?: InputMaybe<Scalars['String']['input']>;
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutBreederInput>;
  permissionFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  puppies?: InputMaybe<DogPuppyCreateNestedManyWithoutBreederInput>;
  puppiesBirthPlace?: InputMaybe<Scalars['String']['input']>;
  reviews?: InputMaybe<DogBreederReviewCreateNestedManyWithoutDogBreederInput>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  studInfos?: InputMaybe<StudInfoCreateNestedManyWithoutBreederInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  translations?: InputMaybe<DogBreederTranslationCreateNestedManyWithoutDogBreederInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  vatNumber?: InputMaybe<Scalars['String']['input']>;
  veterinaryInfo?: InputMaybe<Scalars['String']['input']>;
  videoUrl?: InputMaybe<Scalars['String']['input']>;
  visitedByTipaw?: InputMaybe<Scalars['Boolean']['input']>;
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
  whatsappNumber?: InputMaybe<Scalars['String']['input']>;
};

export type DogBreederCreatebreedClubFilesInput = {
  set: Array<Scalars['String']['input']>;
};

export type DogBreederCreateidentityFilesInput = {
  set: Array<Scalars['String']['input']>;
};

export type DogBreederCreatepermissionFilesInput = {
  set: Array<Scalars['String']['input']>;
};

export type DogBreederCreatespokenLanguagesInput = {
  set: Array<Scalars['String']['input']>;
};

export type DogBreederCreatetagsInput = {
  set: Array<Scalars['String']['input']>;
};

export type DogBreederImg = {
  __typename?: 'DogBreederImg';
  createdAt: Scalars['DateTime']['output'];
  dogBreeder: DogBreeder;
  dogBreederId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  large?: Maybe<Scalars['String']['output']>;
  medium?: Maybe<Scalars['String']['output']>;
  small?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type DogBreederImgAvgAggregateOutputType = {
  __typename?: 'DogBreederImgAvgAggregateOutputType';
  dogBreederId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

export type DogBreederImgAvgOrderByAggregateInput = {
  dogBreederId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export type DogBreederImgCountAggregateOutputType = {
  __typename?: 'DogBreederImgCountAggregateOutputType';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  dogBreederId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  large: Scalars['Int']['output'];
  medium: Scalars['Int']['output'];
  small: Scalars['Int']['output'];
  type: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type DogBreederImgCountOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  dogBreederId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  large?: InputMaybe<SortOrder>;
  medium?: InputMaybe<SortOrder>;
  small?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type DogBreederImgCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dogBreeder: DogBreederCreateNestedOneWithoutImgsInput;
  large?: InputMaybe<Scalars['String']['input']>;
  medium?: InputMaybe<Scalars['String']['input']>;
  small?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DogBreederImgCreateManyDogBreederInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  large?: InputMaybe<Scalars['String']['input']>;
  medium?: InputMaybe<Scalars['String']['input']>;
  small?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DogBreederImgCreateManyDogBreederInputEnvelope = {
  data: Array<DogBreederImgCreateManyDogBreederInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DogBreederImgCreateManyInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dogBreederId: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  large?: InputMaybe<Scalars['String']['input']>;
  medium?: InputMaybe<Scalars['String']['input']>;
  small?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DogBreederImgCreateNestedManyWithoutDogBreederInput = {
  connect?: InputMaybe<Array<DogBreederImgWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DogBreederImgCreateOrConnectWithoutDogBreederInput>>;
  create?: InputMaybe<Array<DogBreederImgCreateWithoutDogBreederInput>>;
  createMany?: InputMaybe<DogBreederImgCreateManyDogBreederInputEnvelope>;
};

export type DogBreederImgCreateOrConnectWithoutDogBreederInput = {
  create: DogBreederImgCreateWithoutDogBreederInput;
  where: DogBreederImgWhereUniqueInput;
};

export type DogBreederImgCreateWithoutDogBreederInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  large?: InputMaybe<Scalars['String']['input']>;
  medium?: InputMaybe<Scalars['String']['input']>;
  small?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DogBreederImgListRelationFilter = {
  every?: InputMaybe<DogBreederImgWhereInput>;
  none?: InputMaybe<DogBreederImgWhereInput>;
  some?: InputMaybe<DogBreederImgWhereInput>;
};

export type DogBreederImgMaxAggregateOutputType = {
  __typename?: 'DogBreederImgMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  dogBreederId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  large?: Maybe<Scalars['String']['output']>;
  medium?: Maybe<Scalars['String']['output']>;
  small?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type DogBreederImgMaxOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  dogBreederId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  large?: InputMaybe<SortOrder>;
  medium?: InputMaybe<SortOrder>;
  small?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type DogBreederImgMinAggregateOutputType = {
  __typename?: 'DogBreederImgMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  dogBreederId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  large?: Maybe<Scalars['String']['output']>;
  medium?: Maybe<Scalars['String']['output']>;
  small?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type DogBreederImgMinOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  dogBreederId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  large?: InputMaybe<SortOrder>;
  medium?: InputMaybe<SortOrder>;
  small?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type DogBreederImgOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export enum DogBreederImgOrderByRelevanceFieldEnum {
  large = 'large',
  medium = 'medium',
  small = 'small',
  type = 'type'
}

export type DogBreederImgOrderByRelevanceInput = {
  fields: Array<DogBreederImgOrderByRelevanceFieldEnum>;
  search: Scalars['String']['input'];
  sort: SortOrder;
};

export type DogBreederImgOrderByWithAggregationInput = {
  _avg?: InputMaybe<DogBreederImgAvgOrderByAggregateInput>;
  _count?: InputMaybe<DogBreederImgCountOrderByAggregateInput>;
  _max?: InputMaybe<DogBreederImgMaxOrderByAggregateInput>;
  _min?: InputMaybe<DogBreederImgMinOrderByAggregateInput>;
  _sum?: InputMaybe<DogBreederImgSumOrderByAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  dogBreederId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  large?: InputMaybe<SortOrderInput>;
  medium?: InputMaybe<SortOrderInput>;
  small?: InputMaybe<SortOrderInput>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type DogBreederImgOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: InputMaybe<DogBreederImgOrderByRelevanceInput>;
  createdAt?: InputMaybe<SortOrder>;
  dogBreeder?: InputMaybe<DogBreederOrderByWithRelationAndSearchRelevanceInput>;
  dogBreederId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  large?: InputMaybe<SortOrderInput>;
  medium?: InputMaybe<SortOrderInput>;
  small?: InputMaybe<SortOrderInput>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum DogBreederImgScalarFieldEnum {
  createdAt = 'createdAt',
  dogBreederId = 'dogBreederId',
  id = 'id',
  large = 'large',
  medium = 'medium',
  small = 'small',
  type = 'type',
  updatedAt = 'updatedAt'
}

export type DogBreederImgScalarWhereInput = {
  AND?: InputMaybe<Array<DogBreederImgScalarWhereInput>>;
  NOT?: InputMaybe<Array<DogBreederImgScalarWhereInput>>;
  OR?: InputMaybe<Array<DogBreederImgScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  dogBreederId?: InputMaybe<IntFilter>;
  id?: InputMaybe<IntFilter>;
  large?: InputMaybe<StringNullableFilter>;
  medium?: InputMaybe<StringNullableFilter>;
  small?: InputMaybe<StringNullableFilter>;
  type?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type DogBreederImgScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<DogBreederImgScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<DogBreederImgScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<DogBreederImgScalarWhereWithAggregatesInput>>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  dogBreederId?: InputMaybe<IntWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  large?: InputMaybe<StringNullableWithAggregatesFilter>;
  medium?: InputMaybe<StringNullableWithAggregatesFilter>;
  small?: InputMaybe<StringNullableWithAggregatesFilter>;
  type?: InputMaybe<StringWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type DogBreederImgSumAggregateOutputType = {
  __typename?: 'DogBreederImgSumAggregateOutputType';
  dogBreederId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
};

export type DogBreederImgSumOrderByAggregateInput = {
  dogBreederId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export type DogBreederImgUncheckedCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dogBreederId: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  large?: InputMaybe<Scalars['String']['input']>;
  medium?: InputMaybe<Scalars['String']['input']>;
  small?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DogBreederImgUncheckedCreateNestedManyWithoutDogBreederInput = {
  connect?: InputMaybe<Array<DogBreederImgWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DogBreederImgCreateOrConnectWithoutDogBreederInput>>;
  create?: InputMaybe<Array<DogBreederImgCreateWithoutDogBreederInput>>;
  createMany?: InputMaybe<DogBreederImgCreateManyDogBreederInputEnvelope>;
};

export type DogBreederImgUncheckedCreateWithoutDogBreederInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  large?: InputMaybe<Scalars['String']['input']>;
  medium?: InputMaybe<Scalars['String']['input']>;
  small?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DogBreederImgUncheckedUpdateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dogBreederId?: InputMaybe<IntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  large?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  medium?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  small?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DogBreederImgUncheckedUpdateManyInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dogBreederId?: InputMaybe<IntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  large?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  medium?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  small?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DogBreederImgUncheckedUpdateManyWithoutDogBreederInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  large?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  medium?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  small?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DogBreederImgUncheckedUpdateManyWithoutDogBreederNestedInput = {
  connect?: InputMaybe<Array<DogBreederImgWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DogBreederImgCreateOrConnectWithoutDogBreederInput>>;
  create?: InputMaybe<Array<DogBreederImgCreateWithoutDogBreederInput>>;
  createMany?: InputMaybe<DogBreederImgCreateManyDogBreederInputEnvelope>;
  delete?: InputMaybe<Array<DogBreederImgWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<DogBreederImgScalarWhereInput>>;
  disconnect?: InputMaybe<Array<DogBreederImgWhereUniqueInput>>;
  set?: InputMaybe<Array<DogBreederImgWhereUniqueInput>>;
  update?: InputMaybe<Array<DogBreederImgUpdateWithWhereUniqueWithoutDogBreederInput>>;
  updateMany?: InputMaybe<Array<DogBreederImgUpdateManyWithWhereWithoutDogBreederInput>>;
  upsert?: InputMaybe<Array<DogBreederImgUpsertWithWhereUniqueWithoutDogBreederInput>>;
};

export type DogBreederImgUncheckedUpdateWithoutDogBreederInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  large?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  medium?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  small?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DogBreederImgUpdateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dogBreeder?: InputMaybe<DogBreederUpdateOneRequiredWithoutImgsNestedInput>;
  large?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  medium?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  small?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DogBreederImgUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  large?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  medium?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  small?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DogBreederImgUpdateManyWithWhereWithoutDogBreederInput = {
  data: DogBreederImgUpdateManyMutationInput;
  where: DogBreederImgScalarWhereInput;
};

export type DogBreederImgUpdateManyWithoutDogBreederNestedInput = {
  connect?: InputMaybe<Array<DogBreederImgWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DogBreederImgCreateOrConnectWithoutDogBreederInput>>;
  create?: InputMaybe<Array<DogBreederImgCreateWithoutDogBreederInput>>;
  createMany?: InputMaybe<DogBreederImgCreateManyDogBreederInputEnvelope>;
  delete?: InputMaybe<Array<DogBreederImgWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<DogBreederImgScalarWhereInput>>;
  disconnect?: InputMaybe<Array<DogBreederImgWhereUniqueInput>>;
  set?: InputMaybe<Array<DogBreederImgWhereUniqueInput>>;
  update?: InputMaybe<Array<DogBreederImgUpdateWithWhereUniqueWithoutDogBreederInput>>;
  updateMany?: InputMaybe<Array<DogBreederImgUpdateManyWithWhereWithoutDogBreederInput>>;
  upsert?: InputMaybe<Array<DogBreederImgUpsertWithWhereUniqueWithoutDogBreederInput>>;
};

export type DogBreederImgUpdateWithWhereUniqueWithoutDogBreederInput = {
  data: DogBreederImgUpdateWithoutDogBreederInput;
  where: DogBreederImgWhereUniqueInput;
};

export type DogBreederImgUpdateWithoutDogBreederInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  large?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  medium?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  small?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DogBreederImgUpsertWithWhereUniqueWithoutDogBreederInput = {
  create: DogBreederImgCreateWithoutDogBreederInput;
  update: DogBreederImgUpdateWithoutDogBreederInput;
  where: DogBreederImgWhereUniqueInput;
};

export type DogBreederImgWhereInput = {
  AND?: InputMaybe<Array<DogBreederImgWhereInput>>;
  NOT?: InputMaybe<Array<DogBreederImgWhereInput>>;
  OR?: InputMaybe<Array<DogBreederImgWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  dogBreeder?: InputMaybe<DogBreederRelationFilter>;
  dogBreederId?: InputMaybe<IntFilter>;
  id?: InputMaybe<IntFilter>;
  large?: InputMaybe<StringNullableFilter>;
  medium?: InputMaybe<StringNullableFilter>;
  small?: InputMaybe<StringNullableFilter>;
  type?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type DogBreederImgWhereUniqueInput = {
  AND?: InputMaybe<Array<DogBreederImgWhereInput>>;
  NOT?: InputMaybe<Array<DogBreederImgWhereInput>>;
  OR?: InputMaybe<Array<DogBreederImgWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  dogBreeder?: InputMaybe<DogBreederRelationFilter>;
  dogBreederId?: InputMaybe<IntFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  large?: InputMaybe<StringNullableFilter>;
  medium?: InputMaybe<StringNullableFilter>;
  small?: InputMaybe<StringNullableFilter>;
  type?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export enum DogBreederLastConnectedTypeEnum {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  VERY_ACTIVE = 'VERY_ACTIVE'
}

export type DogBreederMaxAggregateOutputType = {
  __typename?: 'DogBreederMaxAggregateOutputType';
  adminNote?: Maybe<Scalars['String']['output']>;
  agreementNumber?: Maybe<Scalars['String']['output']>;
  breedClubValidated?: Maybe<Scalars['Boolean']['output']>;
  breedingName?: Maybe<Scalars['String']['output']>;
  certificationFile?: Maybe<Scalars['String']['output']>;
  certified?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  displayEmail?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  displayPhone?: Maybe<Scalars['String']['output']>;
  dogsConsanguinity?: Maybe<Scalars['String']['output']>;
  dogsPedigree?: Maybe<Scalars['String']['output']>;
  dogsTemper?: Maybe<Scalars['String']['output']>;
  emailAutomationStage?: Maybe<Scalars['Int']['output']>;
  facebookUrl?: Maybe<Scalars['String']['output']>;
  failedMedicalTestsProtocol?: Maybe<Scalars['String']['output']>;
  hasFinishedOnboarding?: Maybe<Scalars['Boolean']['output']>;
  hasStartedOnboarding?: Maybe<Scalars['Boolean']['output']>;
  hkFile?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  lastAutomationEmailSentAt?: Maybe<Scalars['DateTime']['output']>;
  level?: Maybe<Scalars['String']['output']>;
  littersByFemale?: Maybe<Scalars['String']['output']>;
  littersByFemaleCount?: Maybe<Scalars['Int']['output']>;
  maleBreedersCount?: Maybe<Scalars['Int']['output']>;
  medicalTestsPerformed?: Maybe<Scalars['String']['output']>;
  motherRestBetweenLitters?: Maybe<Scalars['String']['output']>;
  public?: Maybe<Scalars['Boolean']['output']>;
  puppiesBirthPlace?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  vatNumber?: Maybe<Scalars['String']['output']>;
  veterinaryInfo?: Maybe<Scalars['String']['output']>;
  videoUrl?: Maybe<Scalars['String']['output']>;
  visitedByTipaw?: Maybe<Scalars['Boolean']['output']>;
  websiteUrl?: Maybe<Scalars['String']['output']>;
  whatsappNumber?: Maybe<Scalars['String']['output']>;
};

export type DogBreederMaxOrderByAggregateInput = {
  adminNote?: InputMaybe<SortOrder>;
  agreementNumber?: InputMaybe<SortOrder>;
  breedClubValidated?: InputMaybe<SortOrder>;
  breedingName?: InputMaybe<SortOrder>;
  certificationFile?: InputMaybe<SortOrder>;
  certified?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  displayEmail?: InputMaybe<SortOrder>;
  displayName?: InputMaybe<SortOrder>;
  displayPhone?: InputMaybe<SortOrder>;
  dogsConsanguinity?: InputMaybe<SortOrder>;
  dogsPedigree?: InputMaybe<SortOrder>;
  dogsTemper?: InputMaybe<SortOrder>;
  emailAutomationStage?: InputMaybe<SortOrder>;
  facebookUrl?: InputMaybe<SortOrder>;
  failedMedicalTestsProtocol?: InputMaybe<SortOrder>;
  hasFinishedOnboarding?: InputMaybe<SortOrder>;
  hasStartedOnboarding?: InputMaybe<SortOrder>;
  hkFile?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  lastAutomationEmailSentAt?: InputMaybe<SortOrder>;
  level?: InputMaybe<SortOrder>;
  littersByFemale?: InputMaybe<SortOrder>;
  littersByFemaleCount?: InputMaybe<SortOrder>;
  maleBreedersCount?: InputMaybe<SortOrder>;
  medicalTestsPerformed?: InputMaybe<SortOrder>;
  motherRestBetweenLitters?: InputMaybe<SortOrder>;
  public?: InputMaybe<SortOrder>;
  puppiesBirthPlace?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  vatNumber?: InputMaybe<SortOrder>;
  veterinaryInfo?: InputMaybe<SortOrder>;
  videoUrl?: InputMaybe<SortOrder>;
  visitedByTipaw?: InputMaybe<SortOrder>;
  websiteUrl?: InputMaybe<SortOrder>;
  whatsappNumber?: InputMaybe<SortOrder>;
};

export type DogBreederMinAggregateOutputType = {
  __typename?: 'DogBreederMinAggregateOutputType';
  adminNote?: Maybe<Scalars['String']['output']>;
  agreementNumber?: Maybe<Scalars['String']['output']>;
  breedClubValidated?: Maybe<Scalars['Boolean']['output']>;
  breedingName?: Maybe<Scalars['String']['output']>;
  certificationFile?: Maybe<Scalars['String']['output']>;
  certified?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  displayEmail?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  displayPhone?: Maybe<Scalars['String']['output']>;
  dogsConsanguinity?: Maybe<Scalars['String']['output']>;
  dogsPedigree?: Maybe<Scalars['String']['output']>;
  dogsTemper?: Maybe<Scalars['String']['output']>;
  emailAutomationStage?: Maybe<Scalars['Int']['output']>;
  facebookUrl?: Maybe<Scalars['String']['output']>;
  failedMedicalTestsProtocol?: Maybe<Scalars['String']['output']>;
  hasFinishedOnboarding?: Maybe<Scalars['Boolean']['output']>;
  hasStartedOnboarding?: Maybe<Scalars['Boolean']['output']>;
  hkFile?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  lastAutomationEmailSentAt?: Maybe<Scalars['DateTime']['output']>;
  level?: Maybe<Scalars['String']['output']>;
  littersByFemale?: Maybe<Scalars['String']['output']>;
  littersByFemaleCount?: Maybe<Scalars['Int']['output']>;
  maleBreedersCount?: Maybe<Scalars['Int']['output']>;
  medicalTestsPerformed?: Maybe<Scalars['String']['output']>;
  motherRestBetweenLitters?: Maybe<Scalars['String']['output']>;
  public?: Maybe<Scalars['Boolean']['output']>;
  puppiesBirthPlace?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  vatNumber?: Maybe<Scalars['String']['output']>;
  veterinaryInfo?: Maybe<Scalars['String']['output']>;
  videoUrl?: Maybe<Scalars['String']['output']>;
  visitedByTipaw?: Maybe<Scalars['Boolean']['output']>;
  websiteUrl?: Maybe<Scalars['String']['output']>;
  whatsappNumber?: Maybe<Scalars['String']['output']>;
};

export type DogBreederMinOrderByAggregateInput = {
  adminNote?: InputMaybe<SortOrder>;
  agreementNumber?: InputMaybe<SortOrder>;
  breedClubValidated?: InputMaybe<SortOrder>;
  breedingName?: InputMaybe<SortOrder>;
  certificationFile?: InputMaybe<SortOrder>;
  certified?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  displayEmail?: InputMaybe<SortOrder>;
  displayName?: InputMaybe<SortOrder>;
  displayPhone?: InputMaybe<SortOrder>;
  dogsConsanguinity?: InputMaybe<SortOrder>;
  dogsPedigree?: InputMaybe<SortOrder>;
  dogsTemper?: InputMaybe<SortOrder>;
  emailAutomationStage?: InputMaybe<SortOrder>;
  facebookUrl?: InputMaybe<SortOrder>;
  failedMedicalTestsProtocol?: InputMaybe<SortOrder>;
  hasFinishedOnboarding?: InputMaybe<SortOrder>;
  hasStartedOnboarding?: InputMaybe<SortOrder>;
  hkFile?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  lastAutomationEmailSentAt?: InputMaybe<SortOrder>;
  level?: InputMaybe<SortOrder>;
  littersByFemale?: InputMaybe<SortOrder>;
  littersByFemaleCount?: InputMaybe<SortOrder>;
  maleBreedersCount?: InputMaybe<SortOrder>;
  medicalTestsPerformed?: InputMaybe<SortOrder>;
  motherRestBetweenLitters?: InputMaybe<SortOrder>;
  public?: InputMaybe<SortOrder>;
  puppiesBirthPlace?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  vatNumber?: InputMaybe<SortOrder>;
  veterinaryInfo?: InputMaybe<SortOrder>;
  videoUrl?: InputMaybe<SortOrder>;
  visitedByTipaw?: InputMaybe<SortOrder>;
  websiteUrl?: InputMaybe<SortOrder>;
  whatsappNumber?: InputMaybe<SortOrder>;
};

export type DogBreederNullableRelationFilter = {
  is?: InputMaybe<DogBreederWhereInput>;
  isNot?: InputMaybe<DogBreederWhereInput>;
};

export enum DogBreederOrderByRelevanceFieldEnum {
  adminNote = 'adminNote',
  agreementNumber = 'agreementNumber',
  breedClubFiles = 'breedClubFiles',
  breedingName = 'breedingName',
  certificationFile = 'certificationFile',
  displayEmail = 'displayEmail',
  displayName = 'displayName',
  displayPhone = 'displayPhone',
  dogsConsanguinity = 'dogsConsanguinity',
  dogsPedigree = 'dogsPedigree',
  dogsTemper = 'dogsTemper',
  facebookUrl = 'facebookUrl',
  failedMedicalTestsProtocol = 'failedMedicalTestsProtocol',
  hkFile = 'hkFile',
  identityFiles = 'identityFiles',
  level = 'level',
  littersByFemale = 'littersByFemale',
  medicalTestsPerformed = 'medicalTestsPerformed',
  motherRestBetweenLitters = 'motherRestBetweenLitters',
  permissionFiles = 'permissionFiles',
  puppiesBirthPlace = 'puppiesBirthPlace',
  spokenLanguages = 'spokenLanguages',
  tags = 'tags',
  vatNumber = 'vatNumber',
  veterinaryInfo = 'veterinaryInfo',
  videoUrl = 'videoUrl',
  websiteUrl = 'websiteUrl',
  whatsappNumber = 'whatsappNumber'
}

export type DogBreederOrderByRelevanceInput = {
  fields: Array<DogBreederOrderByRelevanceFieldEnum>;
  search: Scalars['String']['input'];
  sort: SortOrder;
};

export type DogBreederOrderByWithAggregationInput = {
  _avg?: InputMaybe<DogBreederAvgOrderByAggregateInput>;
  _count?: InputMaybe<DogBreederCountOrderByAggregateInput>;
  _max?: InputMaybe<DogBreederMaxOrderByAggregateInput>;
  _min?: InputMaybe<DogBreederMinOrderByAggregateInput>;
  _sum?: InputMaybe<DogBreederSumOrderByAggregateInput>;
  adminNote?: InputMaybe<SortOrderInput>;
  agreementNumber?: InputMaybe<SortOrderInput>;
  breedClubFiles?: InputMaybe<SortOrder>;
  breedClubValidated?: InputMaybe<SortOrder>;
  breedingName?: InputMaybe<SortOrderInput>;
  certificationFile?: InputMaybe<SortOrderInput>;
  certified?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  displayEmail?: InputMaybe<SortOrderInput>;
  displayName?: InputMaybe<SortOrderInput>;
  displayPhone?: InputMaybe<SortOrderInput>;
  dogsConsanguinity?: InputMaybe<SortOrderInput>;
  dogsPedigree?: InputMaybe<SortOrderInput>;
  dogsTemper?: InputMaybe<SortOrderInput>;
  emailAutomationStage?: InputMaybe<SortOrder>;
  facebookUrl?: InputMaybe<SortOrderInput>;
  failedMedicalTestsProtocol?: InputMaybe<SortOrderInput>;
  hasFinishedOnboarding?: InputMaybe<SortOrder>;
  hasStartedOnboarding?: InputMaybe<SortOrder>;
  hkFile?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  identityFiles?: InputMaybe<SortOrder>;
  lastAutomationEmailSentAt?: InputMaybe<SortOrderInput>;
  level?: InputMaybe<SortOrderInput>;
  littersByFemale?: InputMaybe<SortOrderInput>;
  littersByFemaleCount?: InputMaybe<SortOrderInput>;
  maleBreedersCount?: InputMaybe<SortOrderInput>;
  medicalTestsPerformed?: InputMaybe<SortOrderInput>;
  motherRestBetweenLitters?: InputMaybe<SortOrderInput>;
  permissionFiles?: InputMaybe<SortOrder>;
  public?: InputMaybe<SortOrderInput>;
  puppiesBirthPlace?: InputMaybe<SortOrderInput>;
  spokenLanguages?: InputMaybe<SortOrder>;
  tags?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  vatNumber?: InputMaybe<SortOrderInput>;
  veterinaryInfo?: InputMaybe<SortOrderInput>;
  videoUrl?: InputMaybe<SortOrderInput>;
  visitedByTipaw?: InputMaybe<SortOrder>;
  websiteUrl?: InputMaybe<SortOrderInput>;
  whatsappNumber?: InputMaybe<SortOrderInput>;
};

export type DogBreederOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: InputMaybe<DogBreederOrderByRelevanceInput>;
  account?: InputMaybe<AccountOrderByWithRelationAndSearchRelevanceInput>;
  adminNote?: InputMaybe<SortOrderInput>;
  agreementNumber?: InputMaybe<SortOrderInput>;
  applications?: InputMaybe<DogBreederApplicationOrderByRelationAggregateInput>;
  breedClubFiles?: InputMaybe<SortOrder>;
  breedClubValidated?: InputMaybe<SortOrder>;
  breederBreeds?: InputMaybe<DogBreederBreedsOrderByRelationAggregateInput>;
  breedingName?: InputMaybe<SortOrderInput>;
  certificationFile?: InputMaybe<SortOrderInput>;
  certified?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  displayEmail?: InputMaybe<SortOrderInput>;
  displayName?: InputMaybe<SortOrderInput>;
  displayPhone?: InputMaybe<SortOrderInput>;
  dogInfos?: InputMaybe<DogInfoOrderByRelationAggregateInput>;
  dogsConsanguinity?: InputMaybe<SortOrderInput>;
  dogsPedigree?: InputMaybe<SortOrderInput>;
  dogsTemper?: InputMaybe<SortOrderInput>;
  emailAutomationStage?: InputMaybe<SortOrder>;
  emailHistory?: InputMaybe<EmailHistoryOrderByRelationAggregateInput>;
  facebookUrl?: InputMaybe<SortOrderInput>;
  failedMedicalTestsProtocol?: InputMaybe<SortOrderInput>;
  hasFinishedOnboarding?: InputMaybe<SortOrder>;
  hasStartedOnboarding?: InputMaybe<SortOrder>;
  hkFile?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  identityFiles?: InputMaybe<SortOrder>;
  imgs?: InputMaybe<DogBreederImgOrderByRelationAggregateInput>;
  lastAutomationEmailSentAt?: InputMaybe<SortOrderInput>;
  level?: InputMaybe<SortOrderInput>;
  litters?: InputMaybe<LitterOrderByRelationAggregateInput>;
  littersByFemale?: InputMaybe<SortOrderInput>;
  littersByFemaleCount?: InputMaybe<SortOrderInput>;
  maleBreedersCount?: InputMaybe<SortOrderInput>;
  medicalTestsPerformed?: InputMaybe<SortOrderInput>;
  motherRestBetweenLitters?: InputMaybe<SortOrderInput>;
  notifications?: InputMaybe<NotificationOrderByRelationAggregateInput>;
  permissionFiles?: InputMaybe<SortOrder>;
  public?: InputMaybe<SortOrderInput>;
  puppies?: InputMaybe<DogPuppyOrderByRelationAggregateInput>;
  puppiesBirthPlace?: InputMaybe<SortOrderInput>;
  reviews?: InputMaybe<DogBreederReviewOrderByRelationAggregateInput>;
  spokenLanguages?: InputMaybe<SortOrder>;
  studInfos?: InputMaybe<StudInfoOrderByRelationAggregateInput>;
  tags?: InputMaybe<SortOrder>;
  translations?: InputMaybe<DogBreederTranslationOrderByRelationAggregateInput>;
  updatedAt?: InputMaybe<SortOrder>;
  updates?: InputMaybe<UpdateOrderByRelationAggregateInput>;
  vatNumber?: InputMaybe<SortOrderInput>;
  veterinaryInfo?: InputMaybe<SortOrderInput>;
  videoUrl?: InputMaybe<SortOrderInput>;
  visitedByTipaw?: InputMaybe<SortOrder>;
  websiteUrl?: InputMaybe<SortOrderInput>;
  whatsappNumber?: InputMaybe<SortOrderInput>;
};

export type DogBreederRelationFilter = {
  is?: InputMaybe<DogBreederWhereInput>;
  isNot?: InputMaybe<DogBreederWhereInput>;
};

export type DogBreederReview = {
  __typename?: 'DogBreederReview';
  account: Account;
  accountId: Scalars['Int']['output'];
  answer?: Maybe<DogBreederReviewAnswer>;
  breederName?: Maybe<Scalars['String']['output']>;
  breederPic?: Maybe<Scalars['String']['output']>;
  contactDate?: Maybe<Scalars['DateTime']['output']>;
  contactType?: Maybe<DogBreederContactType>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  dogBreeder: DogBreeder;
  dogBreederId: Scalars['Int']['output'];
  dogsWellBeingGrade?: Maybe<Scalars['Int']['output']>;
  followUpGrade?: Maybe<Scalars['Int']['output']>;
  globalGrade?: Maybe<Scalars['Int']['output']>;
  humanContactGrade?: Maybe<Scalars['Int']['output']>;
  hygieneGrade?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  microchip?: Maybe<Scalars['String']['output']>;
  reviewerName?: Maybe<Scalars['String']['output']>;
  reviewerPic?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  verified: Scalars['Boolean']['output'];
};

export type DogBreederReviewAnswer = {
  __typename?: 'DogBreederReviewAnswer';
  content: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type DogBreederReviewAnswerAvgAggregateOutputType = {
  __typename?: 'DogBreederReviewAnswerAvgAggregateOutputType';
  id?: Maybe<Scalars['Float']['output']>;
};

export type DogBreederReviewAnswerAvgOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
};

export type DogBreederReviewAnswerCountAggregateOutputType = {
  __typename?: 'DogBreederReviewAnswerCountAggregateOutputType';
  _all: Scalars['Int']['output'];
  content: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type DogBreederReviewAnswerCountOrderByAggregateInput = {
  content?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type DogBreederReviewAnswerCreateInput = {
  content: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  review?: InputMaybe<DogBreederReviewCreateNestedOneWithoutAnswerInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DogBreederReviewAnswerCreateManyInput = {
  content: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DogBreederReviewAnswerCreateNestedOneWithoutReviewInput = {
  connect?: InputMaybe<DogBreederReviewAnswerWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DogBreederReviewAnswerCreateOrConnectWithoutReviewInput>;
  create?: InputMaybe<DogBreederReviewAnswerCreateWithoutReviewInput>;
};

export type DogBreederReviewAnswerCreateOrConnectWithoutReviewInput = {
  create: DogBreederReviewAnswerCreateWithoutReviewInput;
  where: DogBreederReviewAnswerWhereUniqueInput;
};

export type DogBreederReviewAnswerCreateWithoutReviewInput = {
  content: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DogBreederReviewAnswerMaxAggregateOutputType = {
  __typename?: 'DogBreederReviewAnswerMaxAggregateOutputType';
  content?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type DogBreederReviewAnswerMaxOrderByAggregateInput = {
  content?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type DogBreederReviewAnswerMinAggregateOutputType = {
  __typename?: 'DogBreederReviewAnswerMinAggregateOutputType';
  content?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type DogBreederReviewAnswerMinOrderByAggregateInput = {
  content?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type DogBreederReviewAnswerNullableRelationFilter = {
  is?: InputMaybe<DogBreederReviewAnswerWhereInput>;
  isNot?: InputMaybe<DogBreederReviewAnswerWhereInput>;
};

export enum DogBreederReviewAnswerOrderByRelevanceFieldEnum {
  content = 'content'
}

export type DogBreederReviewAnswerOrderByRelevanceInput = {
  fields: Array<DogBreederReviewAnswerOrderByRelevanceFieldEnum>;
  search: Scalars['String']['input'];
  sort: SortOrder;
};

export type DogBreederReviewAnswerOrderByWithAggregationInput = {
  _avg?: InputMaybe<DogBreederReviewAnswerAvgOrderByAggregateInput>;
  _count?: InputMaybe<DogBreederReviewAnswerCountOrderByAggregateInput>;
  _max?: InputMaybe<DogBreederReviewAnswerMaxOrderByAggregateInput>;
  _min?: InputMaybe<DogBreederReviewAnswerMinOrderByAggregateInput>;
  _sum?: InputMaybe<DogBreederReviewAnswerSumOrderByAggregateInput>;
  content?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type DogBreederReviewAnswerOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: InputMaybe<DogBreederReviewAnswerOrderByRelevanceInput>;
  content?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  review?: InputMaybe<DogBreederReviewOrderByWithRelationAndSearchRelevanceInput>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum DogBreederReviewAnswerScalarFieldEnum {
  content = 'content',
  createdAt = 'createdAt',
  id = 'id',
  updatedAt = 'updatedAt'
}

export type DogBreederReviewAnswerScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<DogBreederReviewAnswerScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<DogBreederReviewAnswerScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<DogBreederReviewAnswerScalarWhereWithAggregatesInput>>;
  content?: InputMaybe<StringWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type DogBreederReviewAnswerSumAggregateOutputType = {
  __typename?: 'DogBreederReviewAnswerSumAggregateOutputType';
  id?: Maybe<Scalars['Int']['output']>;
};

export type DogBreederReviewAnswerSumOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
};

export type DogBreederReviewAnswerUncheckedCreateInput = {
  content: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  review?: InputMaybe<DogBreederReviewUncheckedCreateNestedOneWithoutAnswerInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DogBreederReviewAnswerUncheckedCreateWithoutReviewInput = {
  content: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DogBreederReviewAnswerUncheckedUpdateInput = {
  content?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  review?: InputMaybe<DogBreederReviewUncheckedUpdateOneWithoutAnswerNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DogBreederReviewAnswerUncheckedUpdateManyInput = {
  content?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DogBreederReviewAnswerUncheckedUpdateWithoutReviewInput = {
  content?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DogBreederReviewAnswerUpdateInput = {
  content?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  review?: InputMaybe<DogBreederReviewUpdateOneWithoutAnswerNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DogBreederReviewAnswerUpdateManyMutationInput = {
  content?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DogBreederReviewAnswerUpdateOneWithoutReviewNestedInput = {
  connect?: InputMaybe<DogBreederReviewAnswerWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DogBreederReviewAnswerCreateOrConnectWithoutReviewInput>;
  create?: InputMaybe<DogBreederReviewAnswerCreateWithoutReviewInput>;
  delete?: InputMaybe<DogBreederReviewAnswerWhereInput>;
  disconnect?: InputMaybe<DogBreederReviewAnswerWhereInput>;
  update?: InputMaybe<DogBreederReviewAnswerUpdateToOneWithWhereWithoutReviewInput>;
  upsert?: InputMaybe<DogBreederReviewAnswerUpsertWithoutReviewInput>;
};

export type DogBreederReviewAnswerUpdateToOneWithWhereWithoutReviewInput = {
  data: DogBreederReviewAnswerUpdateWithoutReviewInput;
  where?: InputMaybe<DogBreederReviewAnswerWhereInput>;
};

export type DogBreederReviewAnswerUpdateWithoutReviewInput = {
  content?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DogBreederReviewAnswerUpsertWithoutReviewInput = {
  create: DogBreederReviewAnswerCreateWithoutReviewInput;
  update: DogBreederReviewAnswerUpdateWithoutReviewInput;
  where?: InputMaybe<DogBreederReviewAnswerWhereInput>;
};

export type DogBreederReviewAnswerWhereInput = {
  AND?: InputMaybe<Array<DogBreederReviewAnswerWhereInput>>;
  NOT?: InputMaybe<Array<DogBreederReviewAnswerWhereInput>>;
  OR?: InputMaybe<Array<DogBreederReviewAnswerWhereInput>>;
  content?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntFilter>;
  review?: InputMaybe<DogBreederReviewNullableRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type DogBreederReviewAnswerWhereUniqueInput = {
  AND?: InputMaybe<Array<DogBreederReviewAnswerWhereInput>>;
  NOT?: InputMaybe<Array<DogBreederReviewAnswerWhereInput>>;
  OR?: InputMaybe<Array<DogBreederReviewAnswerWhereInput>>;
  content?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  review?: InputMaybe<DogBreederReviewNullableRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type DogBreederReviewAvgAggregateOutputType = {
  __typename?: 'DogBreederReviewAvgAggregateOutputType';
  accountId?: Maybe<Scalars['Float']['output']>;
  answerId?: Maybe<Scalars['Float']['output']>;
  dogBreederId?: Maybe<Scalars['Float']['output']>;
  dogsWellBeingGrade?: Maybe<Scalars['Float']['output']>;
  followUpGrade?: Maybe<Scalars['Float']['output']>;
  globalGrade?: Maybe<Scalars['Float']['output']>;
  humanContactGrade?: Maybe<Scalars['Float']['output']>;
  hygieneGrade?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

export type DogBreederReviewAvgOrderByAggregateInput = {
  accountId?: InputMaybe<SortOrder>;
  answerId?: InputMaybe<SortOrder>;
  dogBreederId?: InputMaybe<SortOrder>;
  dogsWellBeingGrade?: InputMaybe<SortOrder>;
  followUpGrade?: InputMaybe<SortOrder>;
  globalGrade?: InputMaybe<SortOrder>;
  humanContactGrade?: InputMaybe<SortOrder>;
  hygieneGrade?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export type DogBreederReviewCountAggregateOutputType = {
  __typename?: 'DogBreederReviewCountAggregateOutputType';
  _all: Scalars['Int']['output'];
  accountId: Scalars['Int']['output'];
  answerId: Scalars['Int']['output'];
  contactDate: Scalars['Int']['output'];
  contactType: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  description: Scalars['Int']['output'];
  dogBreederId: Scalars['Int']['output'];
  dogsWellBeingGrade: Scalars['Int']['output'];
  followUpGrade: Scalars['Int']['output'];
  globalGrade: Scalars['Int']['output'];
  humanContactGrade: Scalars['Int']['output'];
  hygieneGrade: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  microchip: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
  verified: Scalars['Int']['output'];
};

export type DogBreederReviewCountOrderByAggregateInput = {
  accountId?: InputMaybe<SortOrder>;
  answerId?: InputMaybe<SortOrder>;
  contactDate?: InputMaybe<SortOrder>;
  contactType?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  dogBreederId?: InputMaybe<SortOrder>;
  dogsWellBeingGrade?: InputMaybe<SortOrder>;
  followUpGrade?: InputMaybe<SortOrder>;
  globalGrade?: InputMaybe<SortOrder>;
  humanContactGrade?: InputMaybe<SortOrder>;
  hygieneGrade?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  microchip?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  verified?: InputMaybe<SortOrder>;
};

export type DogBreederReviewCreateInput = {
  account: AccountCreateNestedOneWithoutDogBreederReviewInput;
  answer?: InputMaybe<DogBreederReviewAnswerCreateNestedOneWithoutReviewInput>;
  contactDate?: InputMaybe<Scalars['DateTime']['input']>;
  contactType?: InputMaybe<DogBreederContactType>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dogBreeder: DogBreederCreateNestedOneWithoutReviewsInput;
  dogsWellBeingGrade?: InputMaybe<Scalars['Int']['input']>;
  followUpGrade?: InputMaybe<Scalars['Int']['input']>;
  globalGrade?: InputMaybe<Scalars['Int']['input']>;
  humanContactGrade?: InputMaybe<Scalars['Int']['input']>;
  hygieneGrade?: InputMaybe<Scalars['Int']['input']>;
  microchip?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DogBreederReviewCreateManyAccountInput = {
  answerId?: InputMaybe<Scalars['Int']['input']>;
  contactDate?: InputMaybe<Scalars['DateTime']['input']>;
  contactType?: InputMaybe<DogBreederContactType>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dogBreederId: Scalars['Int']['input'];
  dogsWellBeingGrade?: InputMaybe<Scalars['Int']['input']>;
  followUpGrade?: InputMaybe<Scalars['Int']['input']>;
  globalGrade?: InputMaybe<Scalars['Int']['input']>;
  humanContactGrade?: InputMaybe<Scalars['Int']['input']>;
  hygieneGrade?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  microchip?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DogBreederReviewCreateManyAccountInputEnvelope = {
  data: Array<DogBreederReviewCreateManyAccountInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DogBreederReviewCreateManyDogBreederInput = {
  accountId: Scalars['Int']['input'];
  answerId?: InputMaybe<Scalars['Int']['input']>;
  contactDate?: InputMaybe<Scalars['DateTime']['input']>;
  contactType?: InputMaybe<DogBreederContactType>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dogsWellBeingGrade?: InputMaybe<Scalars['Int']['input']>;
  followUpGrade?: InputMaybe<Scalars['Int']['input']>;
  globalGrade?: InputMaybe<Scalars['Int']['input']>;
  humanContactGrade?: InputMaybe<Scalars['Int']['input']>;
  hygieneGrade?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  microchip?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DogBreederReviewCreateManyDogBreederInputEnvelope = {
  data: Array<DogBreederReviewCreateManyDogBreederInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DogBreederReviewCreateManyInput = {
  accountId: Scalars['Int']['input'];
  answerId?: InputMaybe<Scalars['Int']['input']>;
  contactDate?: InputMaybe<Scalars['DateTime']['input']>;
  contactType?: InputMaybe<DogBreederContactType>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dogBreederId: Scalars['Int']['input'];
  dogsWellBeingGrade?: InputMaybe<Scalars['Int']['input']>;
  followUpGrade?: InputMaybe<Scalars['Int']['input']>;
  globalGrade?: InputMaybe<Scalars['Int']['input']>;
  humanContactGrade?: InputMaybe<Scalars['Int']['input']>;
  hygieneGrade?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  microchip?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DogBreederReviewCreateNestedManyWithoutAccountInput = {
  connect?: InputMaybe<Array<DogBreederReviewWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DogBreederReviewCreateOrConnectWithoutAccountInput>>;
  create?: InputMaybe<Array<DogBreederReviewCreateWithoutAccountInput>>;
  createMany?: InputMaybe<DogBreederReviewCreateManyAccountInputEnvelope>;
};

export type DogBreederReviewCreateNestedManyWithoutDogBreederInput = {
  connect?: InputMaybe<Array<DogBreederReviewWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DogBreederReviewCreateOrConnectWithoutDogBreederInput>>;
  create?: InputMaybe<Array<DogBreederReviewCreateWithoutDogBreederInput>>;
  createMany?: InputMaybe<DogBreederReviewCreateManyDogBreederInputEnvelope>;
};

export type DogBreederReviewCreateNestedOneWithoutAnswerInput = {
  connect?: InputMaybe<DogBreederReviewWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DogBreederReviewCreateOrConnectWithoutAnswerInput>;
  create?: InputMaybe<DogBreederReviewCreateWithoutAnswerInput>;
};

export type DogBreederReviewCreateOrConnectWithoutAccountInput = {
  create: DogBreederReviewCreateWithoutAccountInput;
  where: DogBreederReviewWhereUniqueInput;
};

export type DogBreederReviewCreateOrConnectWithoutAnswerInput = {
  create: DogBreederReviewCreateWithoutAnswerInput;
  where: DogBreederReviewWhereUniqueInput;
};

export type DogBreederReviewCreateOrConnectWithoutDogBreederInput = {
  create: DogBreederReviewCreateWithoutDogBreederInput;
  where: DogBreederReviewWhereUniqueInput;
};

export type DogBreederReviewCreateWithoutAccountInput = {
  answer?: InputMaybe<DogBreederReviewAnswerCreateNestedOneWithoutReviewInput>;
  contactDate?: InputMaybe<Scalars['DateTime']['input']>;
  contactType?: InputMaybe<DogBreederContactType>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dogBreeder: DogBreederCreateNestedOneWithoutReviewsInput;
  dogsWellBeingGrade?: InputMaybe<Scalars['Int']['input']>;
  followUpGrade?: InputMaybe<Scalars['Int']['input']>;
  globalGrade?: InputMaybe<Scalars['Int']['input']>;
  humanContactGrade?: InputMaybe<Scalars['Int']['input']>;
  hygieneGrade?: InputMaybe<Scalars['Int']['input']>;
  microchip?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DogBreederReviewCreateWithoutAnswerInput = {
  account: AccountCreateNestedOneWithoutDogBreederReviewInput;
  contactDate?: InputMaybe<Scalars['DateTime']['input']>;
  contactType?: InputMaybe<DogBreederContactType>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dogBreeder: DogBreederCreateNestedOneWithoutReviewsInput;
  dogsWellBeingGrade?: InputMaybe<Scalars['Int']['input']>;
  followUpGrade?: InputMaybe<Scalars['Int']['input']>;
  globalGrade?: InputMaybe<Scalars['Int']['input']>;
  humanContactGrade?: InputMaybe<Scalars['Int']['input']>;
  hygieneGrade?: InputMaybe<Scalars['Int']['input']>;
  microchip?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DogBreederReviewCreateWithoutDogBreederInput = {
  account: AccountCreateNestedOneWithoutDogBreederReviewInput;
  answer?: InputMaybe<DogBreederReviewAnswerCreateNestedOneWithoutReviewInput>;
  contactDate?: InputMaybe<Scalars['DateTime']['input']>;
  contactType?: InputMaybe<DogBreederContactType>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dogsWellBeingGrade?: InputMaybe<Scalars['Int']['input']>;
  followUpGrade?: InputMaybe<Scalars['Int']['input']>;
  globalGrade?: InputMaybe<Scalars['Int']['input']>;
  humanContactGrade?: InputMaybe<Scalars['Int']['input']>;
  hygieneGrade?: InputMaybe<Scalars['Int']['input']>;
  microchip?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DogBreederReviewListRelationFilter = {
  every?: InputMaybe<DogBreederReviewWhereInput>;
  none?: InputMaybe<DogBreederReviewWhereInput>;
  some?: InputMaybe<DogBreederReviewWhereInput>;
};

export type DogBreederReviewMaxAggregateOutputType = {
  __typename?: 'DogBreederReviewMaxAggregateOutputType';
  accountId?: Maybe<Scalars['Int']['output']>;
  answerId?: Maybe<Scalars['Int']['output']>;
  contactDate?: Maybe<Scalars['DateTime']['output']>;
  contactType?: Maybe<DogBreederContactType>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dogBreederId?: Maybe<Scalars['Int']['output']>;
  dogsWellBeingGrade?: Maybe<Scalars['Int']['output']>;
  followUpGrade?: Maybe<Scalars['Int']['output']>;
  globalGrade?: Maybe<Scalars['Int']['output']>;
  humanContactGrade?: Maybe<Scalars['Int']['output']>;
  hygieneGrade?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  microchip?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  verified?: Maybe<Scalars['Boolean']['output']>;
};

export type DogBreederReviewMaxOrderByAggregateInput = {
  accountId?: InputMaybe<SortOrder>;
  answerId?: InputMaybe<SortOrder>;
  contactDate?: InputMaybe<SortOrder>;
  contactType?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  dogBreederId?: InputMaybe<SortOrder>;
  dogsWellBeingGrade?: InputMaybe<SortOrder>;
  followUpGrade?: InputMaybe<SortOrder>;
  globalGrade?: InputMaybe<SortOrder>;
  humanContactGrade?: InputMaybe<SortOrder>;
  hygieneGrade?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  microchip?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  verified?: InputMaybe<SortOrder>;
};

export type DogBreederReviewMinAggregateOutputType = {
  __typename?: 'DogBreederReviewMinAggregateOutputType';
  accountId?: Maybe<Scalars['Int']['output']>;
  answerId?: Maybe<Scalars['Int']['output']>;
  contactDate?: Maybe<Scalars['DateTime']['output']>;
  contactType?: Maybe<DogBreederContactType>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dogBreederId?: Maybe<Scalars['Int']['output']>;
  dogsWellBeingGrade?: Maybe<Scalars['Int']['output']>;
  followUpGrade?: Maybe<Scalars['Int']['output']>;
  globalGrade?: Maybe<Scalars['Int']['output']>;
  humanContactGrade?: Maybe<Scalars['Int']['output']>;
  hygieneGrade?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  microchip?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  verified?: Maybe<Scalars['Boolean']['output']>;
};

export type DogBreederReviewMinOrderByAggregateInput = {
  accountId?: InputMaybe<SortOrder>;
  answerId?: InputMaybe<SortOrder>;
  contactDate?: InputMaybe<SortOrder>;
  contactType?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  dogBreederId?: InputMaybe<SortOrder>;
  dogsWellBeingGrade?: InputMaybe<SortOrder>;
  followUpGrade?: InputMaybe<SortOrder>;
  globalGrade?: InputMaybe<SortOrder>;
  humanContactGrade?: InputMaybe<SortOrder>;
  hygieneGrade?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  microchip?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  verified?: InputMaybe<SortOrder>;
};

export type DogBreederReviewNullableRelationFilter = {
  is?: InputMaybe<DogBreederReviewWhereInput>;
  isNot?: InputMaybe<DogBreederReviewWhereInput>;
};

export type DogBreederReviewOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export enum DogBreederReviewOrderByRelevanceFieldEnum {
  description = 'description',
  microchip = 'microchip'
}

export type DogBreederReviewOrderByRelevanceInput = {
  fields: Array<DogBreederReviewOrderByRelevanceFieldEnum>;
  search: Scalars['String']['input'];
  sort: SortOrder;
};

export type DogBreederReviewOrderByWithAggregationInput = {
  _avg?: InputMaybe<DogBreederReviewAvgOrderByAggregateInput>;
  _count?: InputMaybe<DogBreederReviewCountOrderByAggregateInput>;
  _max?: InputMaybe<DogBreederReviewMaxOrderByAggregateInput>;
  _min?: InputMaybe<DogBreederReviewMinOrderByAggregateInput>;
  _sum?: InputMaybe<DogBreederReviewSumOrderByAggregateInput>;
  accountId?: InputMaybe<SortOrder>;
  answerId?: InputMaybe<SortOrderInput>;
  contactDate?: InputMaybe<SortOrderInput>;
  contactType?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrderInput>;
  dogBreederId?: InputMaybe<SortOrder>;
  dogsWellBeingGrade?: InputMaybe<SortOrderInput>;
  followUpGrade?: InputMaybe<SortOrderInput>;
  globalGrade?: InputMaybe<SortOrderInput>;
  humanContactGrade?: InputMaybe<SortOrderInput>;
  hygieneGrade?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  microchip?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
  verified?: InputMaybe<SortOrder>;
};

export type DogBreederReviewOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: InputMaybe<DogBreederReviewOrderByRelevanceInput>;
  account?: InputMaybe<AccountOrderByWithRelationAndSearchRelevanceInput>;
  accountId?: InputMaybe<SortOrder>;
  answer?: InputMaybe<DogBreederReviewAnswerOrderByWithRelationAndSearchRelevanceInput>;
  answerId?: InputMaybe<SortOrderInput>;
  contactDate?: InputMaybe<SortOrderInput>;
  contactType?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrderInput>;
  dogBreeder?: InputMaybe<DogBreederOrderByWithRelationAndSearchRelevanceInput>;
  dogBreederId?: InputMaybe<SortOrder>;
  dogsWellBeingGrade?: InputMaybe<SortOrderInput>;
  followUpGrade?: InputMaybe<SortOrderInput>;
  globalGrade?: InputMaybe<SortOrderInput>;
  humanContactGrade?: InputMaybe<SortOrderInput>;
  hygieneGrade?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  microchip?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
  verified?: InputMaybe<SortOrder>;
};

export enum DogBreederReviewScalarFieldEnum {
  accountId = 'accountId',
  answerId = 'answerId',
  contactDate = 'contactDate',
  contactType = 'contactType',
  createdAt = 'createdAt',
  description = 'description',
  dogBreederId = 'dogBreederId',
  dogsWellBeingGrade = 'dogsWellBeingGrade',
  followUpGrade = 'followUpGrade',
  globalGrade = 'globalGrade',
  humanContactGrade = 'humanContactGrade',
  hygieneGrade = 'hygieneGrade',
  id = 'id',
  microchip = 'microchip',
  updatedAt = 'updatedAt',
  verified = 'verified'
}

export type DogBreederReviewScalarWhereInput = {
  AND?: InputMaybe<Array<DogBreederReviewScalarWhereInput>>;
  NOT?: InputMaybe<Array<DogBreederReviewScalarWhereInput>>;
  OR?: InputMaybe<Array<DogBreederReviewScalarWhereInput>>;
  accountId?: InputMaybe<IntFilter>;
  answerId?: InputMaybe<IntNullableFilter>;
  contactDate?: InputMaybe<DateTimeNullableFilter>;
  contactType?: InputMaybe<EnumDogBreederContactTypeNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringNullableFilter>;
  dogBreederId?: InputMaybe<IntFilter>;
  dogsWellBeingGrade?: InputMaybe<IntNullableFilter>;
  followUpGrade?: InputMaybe<IntNullableFilter>;
  globalGrade?: InputMaybe<IntNullableFilter>;
  humanContactGrade?: InputMaybe<IntNullableFilter>;
  hygieneGrade?: InputMaybe<IntNullableFilter>;
  id?: InputMaybe<IntFilter>;
  microchip?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  verified?: InputMaybe<BoolFilter>;
};

export type DogBreederReviewScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<DogBreederReviewScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<DogBreederReviewScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<DogBreederReviewScalarWhereWithAggregatesInput>>;
  accountId?: InputMaybe<IntWithAggregatesFilter>;
  answerId?: InputMaybe<IntNullableWithAggregatesFilter>;
  contactDate?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  contactType?: InputMaybe<EnumDogBreederContactTypeNullableWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  description?: InputMaybe<StringNullableWithAggregatesFilter>;
  dogBreederId?: InputMaybe<IntWithAggregatesFilter>;
  dogsWellBeingGrade?: InputMaybe<IntNullableWithAggregatesFilter>;
  followUpGrade?: InputMaybe<IntNullableWithAggregatesFilter>;
  globalGrade?: InputMaybe<IntNullableWithAggregatesFilter>;
  humanContactGrade?: InputMaybe<IntNullableWithAggregatesFilter>;
  hygieneGrade?: InputMaybe<IntNullableWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  microchip?: InputMaybe<StringNullableWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  verified?: InputMaybe<BoolWithAggregatesFilter>;
};

export type DogBreederReviewSumAggregateOutputType = {
  __typename?: 'DogBreederReviewSumAggregateOutputType';
  accountId?: Maybe<Scalars['Int']['output']>;
  answerId?: Maybe<Scalars['Int']['output']>;
  dogBreederId?: Maybe<Scalars['Int']['output']>;
  dogsWellBeingGrade?: Maybe<Scalars['Int']['output']>;
  followUpGrade?: Maybe<Scalars['Int']['output']>;
  globalGrade?: Maybe<Scalars['Int']['output']>;
  humanContactGrade?: Maybe<Scalars['Int']['output']>;
  hygieneGrade?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
};

export type DogBreederReviewSumOrderByAggregateInput = {
  accountId?: InputMaybe<SortOrder>;
  answerId?: InputMaybe<SortOrder>;
  dogBreederId?: InputMaybe<SortOrder>;
  dogsWellBeingGrade?: InputMaybe<SortOrder>;
  followUpGrade?: InputMaybe<SortOrder>;
  globalGrade?: InputMaybe<SortOrder>;
  humanContactGrade?: InputMaybe<SortOrder>;
  hygieneGrade?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export type DogBreederReviewUncheckedCreateInput = {
  accountId: Scalars['Int']['input'];
  answerId?: InputMaybe<Scalars['Int']['input']>;
  contactDate?: InputMaybe<Scalars['DateTime']['input']>;
  contactType?: InputMaybe<DogBreederContactType>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dogBreederId: Scalars['Int']['input'];
  dogsWellBeingGrade?: InputMaybe<Scalars['Int']['input']>;
  followUpGrade?: InputMaybe<Scalars['Int']['input']>;
  globalGrade?: InputMaybe<Scalars['Int']['input']>;
  humanContactGrade?: InputMaybe<Scalars['Int']['input']>;
  hygieneGrade?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  microchip?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DogBreederReviewUncheckedCreateNestedManyWithoutAccountInput = {
  connect?: InputMaybe<Array<DogBreederReviewWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DogBreederReviewCreateOrConnectWithoutAccountInput>>;
  create?: InputMaybe<Array<DogBreederReviewCreateWithoutAccountInput>>;
  createMany?: InputMaybe<DogBreederReviewCreateManyAccountInputEnvelope>;
};

export type DogBreederReviewUncheckedCreateNestedManyWithoutDogBreederInput = {
  connect?: InputMaybe<Array<DogBreederReviewWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DogBreederReviewCreateOrConnectWithoutDogBreederInput>>;
  create?: InputMaybe<Array<DogBreederReviewCreateWithoutDogBreederInput>>;
  createMany?: InputMaybe<DogBreederReviewCreateManyDogBreederInputEnvelope>;
};

export type DogBreederReviewUncheckedCreateNestedOneWithoutAnswerInput = {
  connect?: InputMaybe<DogBreederReviewWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DogBreederReviewCreateOrConnectWithoutAnswerInput>;
  create?: InputMaybe<DogBreederReviewCreateWithoutAnswerInput>;
};

export type DogBreederReviewUncheckedCreateWithoutAccountInput = {
  answerId?: InputMaybe<Scalars['Int']['input']>;
  contactDate?: InputMaybe<Scalars['DateTime']['input']>;
  contactType?: InputMaybe<DogBreederContactType>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dogBreederId: Scalars['Int']['input'];
  dogsWellBeingGrade?: InputMaybe<Scalars['Int']['input']>;
  followUpGrade?: InputMaybe<Scalars['Int']['input']>;
  globalGrade?: InputMaybe<Scalars['Int']['input']>;
  humanContactGrade?: InputMaybe<Scalars['Int']['input']>;
  hygieneGrade?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  microchip?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DogBreederReviewUncheckedCreateWithoutAnswerInput = {
  accountId: Scalars['Int']['input'];
  contactDate?: InputMaybe<Scalars['DateTime']['input']>;
  contactType?: InputMaybe<DogBreederContactType>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dogBreederId: Scalars['Int']['input'];
  dogsWellBeingGrade?: InputMaybe<Scalars['Int']['input']>;
  followUpGrade?: InputMaybe<Scalars['Int']['input']>;
  globalGrade?: InputMaybe<Scalars['Int']['input']>;
  humanContactGrade?: InputMaybe<Scalars['Int']['input']>;
  hygieneGrade?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  microchip?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DogBreederReviewUncheckedCreateWithoutDogBreederInput = {
  accountId: Scalars['Int']['input'];
  answerId?: InputMaybe<Scalars['Int']['input']>;
  contactDate?: InputMaybe<Scalars['DateTime']['input']>;
  contactType?: InputMaybe<DogBreederContactType>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dogsWellBeingGrade?: InputMaybe<Scalars['Int']['input']>;
  followUpGrade?: InputMaybe<Scalars['Int']['input']>;
  globalGrade?: InputMaybe<Scalars['Int']['input']>;
  humanContactGrade?: InputMaybe<Scalars['Int']['input']>;
  hygieneGrade?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  microchip?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DogBreederReviewUncheckedUpdateInput = {
  accountId?: InputMaybe<IntFieldUpdateOperationsInput>;
  answerId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  contactDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  contactType?: InputMaybe<NullableEnumDogBreederContactTypeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dogBreederId?: InputMaybe<IntFieldUpdateOperationsInput>;
  dogsWellBeingGrade?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  followUpGrade?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  globalGrade?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  humanContactGrade?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  hygieneGrade?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  microchip?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  verified?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type DogBreederReviewUncheckedUpdateManyInput = {
  accountId?: InputMaybe<IntFieldUpdateOperationsInput>;
  answerId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  contactDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  contactType?: InputMaybe<NullableEnumDogBreederContactTypeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dogBreederId?: InputMaybe<IntFieldUpdateOperationsInput>;
  dogsWellBeingGrade?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  followUpGrade?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  globalGrade?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  humanContactGrade?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  hygieneGrade?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  microchip?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  verified?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type DogBreederReviewUncheckedUpdateManyWithoutAccountInput = {
  answerId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  contactDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  contactType?: InputMaybe<NullableEnumDogBreederContactTypeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dogBreederId?: InputMaybe<IntFieldUpdateOperationsInput>;
  dogsWellBeingGrade?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  followUpGrade?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  globalGrade?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  humanContactGrade?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  hygieneGrade?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  microchip?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  verified?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type DogBreederReviewUncheckedUpdateManyWithoutAccountNestedInput = {
  connect?: InputMaybe<Array<DogBreederReviewWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DogBreederReviewCreateOrConnectWithoutAccountInput>>;
  create?: InputMaybe<Array<DogBreederReviewCreateWithoutAccountInput>>;
  createMany?: InputMaybe<DogBreederReviewCreateManyAccountInputEnvelope>;
  delete?: InputMaybe<Array<DogBreederReviewWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<DogBreederReviewScalarWhereInput>>;
  disconnect?: InputMaybe<Array<DogBreederReviewWhereUniqueInput>>;
  set?: InputMaybe<Array<DogBreederReviewWhereUniqueInput>>;
  update?: InputMaybe<Array<DogBreederReviewUpdateWithWhereUniqueWithoutAccountInput>>;
  updateMany?: InputMaybe<Array<DogBreederReviewUpdateManyWithWhereWithoutAccountInput>>;
  upsert?: InputMaybe<Array<DogBreederReviewUpsertWithWhereUniqueWithoutAccountInput>>;
};

export type DogBreederReviewUncheckedUpdateManyWithoutDogBreederInput = {
  accountId?: InputMaybe<IntFieldUpdateOperationsInput>;
  answerId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  contactDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  contactType?: InputMaybe<NullableEnumDogBreederContactTypeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dogsWellBeingGrade?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  followUpGrade?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  globalGrade?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  humanContactGrade?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  hygieneGrade?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  microchip?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  verified?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type DogBreederReviewUncheckedUpdateManyWithoutDogBreederNestedInput = {
  connect?: InputMaybe<Array<DogBreederReviewWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DogBreederReviewCreateOrConnectWithoutDogBreederInput>>;
  create?: InputMaybe<Array<DogBreederReviewCreateWithoutDogBreederInput>>;
  createMany?: InputMaybe<DogBreederReviewCreateManyDogBreederInputEnvelope>;
  delete?: InputMaybe<Array<DogBreederReviewWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<DogBreederReviewScalarWhereInput>>;
  disconnect?: InputMaybe<Array<DogBreederReviewWhereUniqueInput>>;
  set?: InputMaybe<Array<DogBreederReviewWhereUniqueInput>>;
  update?: InputMaybe<Array<DogBreederReviewUpdateWithWhereUniqueWithoutDogBreederInput>>;
  updateMany?: InputMaybe<Array<DogBreederReviewUpdateManyWithWhereWithoutDogBreederInput>>;
  upsert?: InputMaybe<Array<DogBreederReviewUpsertWithWhereUniqueWithoutDogBreederInput>>;
};

export type DogBreederReviewUncheckedUpdateOneWithoutAnswerNestedInput = {
  connect?: InputMaybe<DogBreederReviewWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DogBreederReviewCreateOrConnectWithoutAnswerInput>;
  create?: InputMaybe<DogBreederReviewCreateWithoutAnswerInput>;
  delete?: InputMaybe<DogBreederReviewWhereInput>;
  disconnect?: InputMaybe<DogBreederReviewWhereInput>;
  update?: InputMaybe<DogBreederReviewUpdateToOneWithWhereWithoutAnswerInput>;
  upsert?: InputMaybe<DogBreederReviewUpsertWithoutAnswerInput>;
};

export type DogBreederReviewUncheckedUpdateWithoutAccountInput = {
  answerId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  contactDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  contactType?: InputMaybe<NullableEnumDogBreederContactTypeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dogBreederId?: InputMaybe<IntFieldUpdateOperationsInput>;
  dogsWellBeingGrade?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  followUpGrade?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  globalGrade?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  humanContactGrade?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  hygieneGrade?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  microchip?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  verified?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type DogBreederReviewUncheckedUpdateWithoutAnswerInput = {
  accountId?: InputMaybe<IntFieldUpdateOperationsInput>;
  contactDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  contactType?: InputMaybe<NullableEnumDogBreederContactTypeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dogBreederId?: InputMaybe<IntFieldUpdateOperationsInput>;
  dogsWellBeingGrade?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  followUpGrade?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  globalGrade?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  humanContactGrade?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  hygieneGrade?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  microchip?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  verified?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type DogBreederReviewUncheckedUpdateWithoutDogBreederInput = {
  accountId?: InputMaybe<IntFieldUpdateOperationsInput>;
  answerId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  contactDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  contactType?: InputMaybe<NullableEnumDogBreederContactTypeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dogsWellBeingGrade?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  followUpGrade?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  globalGrade?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  humanContactGrade?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  hygieneGrade?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  microchip?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  verified?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type DogBreederReviewUpdateInput = {
  account?: InputMaybe<AccountUpdateOneRequiredWithoutDogBreederReviewNestedInput>;
  answer?: InputMaybe<DogBreederReviewAnswerUpdateOneWithoutReviewNestedInput>;
  contactDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  contactType?: InputMaybe<NullableEnumDogBreederContactTypeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dogBreeder?: InputMaybe<DogBreederUpdateOneRequiredWithoutReviewsNestedInput>;
  dogsWellBeingGrade?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  followUpGrade?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  globalGrade?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  humanContactGrade?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  hygieneGrade?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  microchip?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  verified?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type DogBreederReviewUpdateManyMutationInput = {
  contactDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  contactType?: InputMaybe<NullableEnumDogBreederContactTypeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dogsWellBeingGrade?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  followUpGrade?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  globalGrade?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  humanContactGrade?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  hygieneGrade?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  microchip?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  verified?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type DogBreederReviewUpdateManyWithWhereWithoutAccountInput = {
  data: DogBreederReviewUpdateManyMutationInput;
  where: DogBreederReviewScalarWhereInput;
};

export type DogBreederReviewUpdateManyWithWhereWithoutDogBreederInput = {
  data: DogBreederReviewUpdateManyMutationInput;
  where: DogBreederReviewScalarWhereInput;
};

export type DogBreederReviewUpdateManyWithoutAccountNestedInput = {
  connect?: InputMaybe<Array<DogBreederReviewWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DogBreederReviewCreateOrConnectWithoutAccountInput>>;
  create?: InputMaybe<Array<DogBreederReviewCreateWithoutAccountInput>>;
  createMany?: InputMaybe<DogBreederReviewCreateManyAccountInputEnvelope>;
  delete?: InputMaybe<Array<DogBreederReviewWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<DogBreederReviewScalarWhereInput>>;
  disconnect?: InputMaybe<Array<DogBreederReviewWhereUniqueInput>>;
  set?: InputMaybe<Array<DogBreederReviewWhereUniqueInput>>;
  update?: InputMaybe<Array<DogBreederReviewUpdateWithWhereUniqueWithoutAccountInput>>;
  updateMany?: InputMaybe<Array<DogBreederReviewUpdateManyWithWhereWithoutAccountInput>>;
  upsert?: InputMaybe<Array<DogBreederReviewUpsertWithWhereUniqueWithoutAccountInput>>;
};

export type DogBreederReviewUpdateManyWithoutDogBreederNestedInput = {
  connect?: InputMaybe<Array<DogBreederReviewWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DogBreederReviewCreateOrConnectWithoutDogBreederInput>>;
  create?: InputMaybe<Array<DogBreederReviewCreateWithoutDogBreederInput>>;
  createMany?: InputMaybe<DogBreederReviewCreateManyDogBreederInputEnvelope>;
  delete?: InputMaybe<Array<DogBreederReviewWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<DogBreederReviewScalarWhereInput>>;
  disconnect?: InputMaybe<Array<DogBreederReviewWhereUniqueInput>>;
  set?: InputMaybe<Array<DogBreederReviewWhereUniqueInput>>;
  update?: InputMaybe<Array<DogBreederReviewUpdateWithWhereUniqueWithoutDogBreederInput>>;
  updateMany?: InputMaybe<Array<DogBreederReviewUpdateManyWithWhereWithoutDogBreederInput>>;
  upsert?: InputMaybe<Array<DogBreederReviewUpsertWithWhereUniqueWithoutDogBreederInput>>;
};

export type DogBreederReviewUpdateOneWithoutAnswerNestedInput = {
  connect?: InputMaybe<DogBreederReviewWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DogBreederReviewCreateOrConnectWithoutAnswerInput>;
  create?: InputMaybe<DogBreederReviewCreateWithoutAnswerInput>;
  delete?: InputMaybe<DogBreederReviewWhereInput>;
  disconnect?: InputMaybe<DogBreederReviewWhereInput>;
  update?: InputMaybe<DogBreederReviewUpdateToOneWithWhereWithoutAnswerInput>;
  upsert?: InputMaybe<DogBreederReviewUpsertWithoutAnswerInput>;
};

export type DogBreederReviewUpdateToOneWithWhereWithoutAnswerInput = {
  data: DogBreederReviewUpdateWithoutAnswerInput;
  where?: InputMaybe<DogBreederReviewWhereInput>;
};

export type DogBreederReviewUpdateWithWhereUniqueWithoutAccountInput = {
  data: DogBreederReviewUpdateWithoutAccountInput;
  where: DogBreederReviewWhereUniqueInput;
};

export type DogBreederReviewUpdateWithWhereUniqueWithoutDogBreederInput = {
  data: DogBreederReviewUpdateWithoutDogBreederInput;
  where: DogBreederReviewWhereUniqueInput;
};

export type DogBreederReviewUpdateWithoutAccountInput = {
  answer?: InputMaybe<DogBreederReviewAnswerUpdateOneWithoutReviewNestedInput>;
  contactDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  contactType?: InputMaybe<NullableEnumDogBreederContactTypeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dogBreeder?: InputMaybe<DogBreederUpdateOneRequiredWithoutReviewsNestedInput>;
  dogsWellBeingGrade?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  followUpGrade?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  globalGrade?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  humanContactGrade?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  hygieneGrade?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  microchip?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  verified?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type DogBreederReviewUpdateWithoutAnswerInput = {
  account?: InputMaybe<AccountUpdateOneRequiredWithoutDogBreederReviewNestedInput>;
  contactDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  contactType?: InputMaybe<NullableEnumDogBreederContactTypeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dogBreeder?: InputMaybe<DogBreederUpdateOneRequiredWithoutReviewsNestedInput>;
  dogsWellBeingGrade?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  followUpGrade?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  globalGrade?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  humanContactGrade?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  hygieneGrade?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  microchip?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  verified?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type DogBreederReviewUpdateWithoutDogBreederInput = {
  account?: InputMaybe<AccountUpdateOneRequiredWithoutDogBreederReviewNestedInput>;
  answer?: InputMaybe<DogBreederReviewAnswerUpdateOneWithoutReviewNestedInput>;
  contactDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  contactType?: InputMaybe<NullableEnumDogBreederContactTypeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dogsWellBeingGrade?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  followUpGrade?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  globalGrade?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  humanContactGrade?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  hygieneGrade?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  microchip?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  verified?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type DogBreederReviewUpsertWithWhereUniqueWithoutAccountInput = {
  create: DogBreederReviewCreateWithoutAccountInput;
  update: DogBreederReviewUpdateWithoutAccountInput;
  where: DogBreederReviewWhereUniqueInput;
};

export type DogBreederReviewUpsertWithWhereUniqueWithoutDogBreederInput = {
  create: DogBreederReviewCreateWithoutDogBreederInput;
  update: DogBreederReviewUpdateWithoutDogBreederInput;
  where: DogBreederReviewWhereUniqueInput;
};

export type DogBreederReviewUpsertWithoutAnswerInput = {
  create: DogBreederReviewCreateWithoutAnswerInput;
  update: DogBreederReviewUpdateWithoutAnswerInput;
  where?: InputMaybe<DogBreederReviewWhereInput>;
};

export type DogBreederReviewWhereInput = {
  AND?: InputMaybe<Array<DogBreederReviewWhereInput>>;
  NOT?: InputMaybe<Array<DogBreederReviewWhereInput>>;
  OR?: InputMaybe<Array<DogBreederReviewWhereInput>>;
  account?: InputMaybe<AccountRelationFilter>;
  accountId?: InputMaybe<IntFilter>;
  answer?: InputMaybe<DogBreederReviewAnswerNullableRelationFilter>;
  answerId?: InputMaybe<IntNullableFilter>;
  contactDate?: InputMaybe<DateTimeNullableFilter>;
  contactType?: InputMaybe<EnumDogBreederContactTypeNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringNullableFilter>;
  dogBreeder?: InputMaybe<DogBreederRelationFilter>;
  dogBreederId?: InputMaybe<IntFilter>;
  dogsWellBeingGrade?: InputMaybe<IntNullableFilter>;
  followUpGrade?: InputMaybe<IntNullableFilter>;
  globalGrade?: InputMaybe<IntNullableFilter>;
  humanContactGrade?: InputMaybe<IntNullableFilter>;
  hygieneGrade?: InputMaybe<IntNullableFilter>;
  id?: InputMaybe<IntFilter>;
  microchip?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  verified?: InputMaybe<BoolFilter>;
};

export type DogBreederReviewWhereUniqueInput = {
  AND?: InputMaybe<Array<DogBreederReviewWhereInput>>;
  NOT?: InputMaybe<Array<DogBreederReviewWhereInput>>;
  OR?: InputMaybe<Array<DogBreederReviewWhereInput>>;
  account?: InputMaybe<AccountRelationFilter>;
  accountId?: InputMaybe<IntFilter>;
  answer?: InputMaybe<DogBreederReviewAnswerNullableRelationFilter>;
  answerId?: InputMaybe<Scalars['Int']['input']>;
  contactDate?: InputMaybe<DateTimeNullableFilter>;
  contactType?: InputMaybe<EnumDogBreederContactTypeNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringNullableFilter>;
  dogBreeder?: InputMaybe<DogBreederRelationFilter>;
  dogBreederId?: InputMaybe<IntFilter>;
  dogsWellBeingGrade?: InputMaybe<IntNullableFilter>;
  followUpGrade?: InputMaybe<IntNullableFilter>;
  globalGrade?: InputMaybe<IntNullableFilter>;
  humanContactGrade?: InputMaybe<IntNullableFilter>;
  hygieneGrade?: InputMaybe<IntNullableFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  microchip?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  verified?: InputMaybe<BoolFilter>;
};

export enum DogBreederScalarFieldEnum {
  adminNote = 'adminNote',
  agreementNumber = 'agreementNumber',
  breedClubFiles = 'breedClubFiles',
  breedClubValidated = 'breedClubValidated',
  breedingName = 'breedingName',
  certificationFile = 'certificationFile',
  certified = 'certified',
  createdAt = 'createdAt',
  displayEmail = 'displayEmail',
  displayName = 'displayName',
  displayPhone = 'displayPhone',
  dogsConsanguinity = 'dogsConsanguinity',
  dogsPedigree = 'dogsPedigree',
  dogsTemper = 'dogsTemper',
  emailAutomationStage = 'emailAutomationStage',
  facebookUrl = 'facebookUrl',
  failedMedicalTestsProtocol = 'failedMedicalTestsProtocol',
  hasFinishedOnboarding = 'hasFinishedOnboarding',
  hasStartedOnboarding = 'hasStartedOnboarding',
  hkFile = 'hkFile',
  id = 'id',
  identityFiles = 'identityFiles',
  lastAutomationEmailSentAt = 'lastAutomationEmailSentAt',
  level = 'level',
  littersByFemale = 'littersByFemale',
  littersByFemaleCount = 'littersByFemaleCount',
  maleBreedersCount = 'maleBreedersCount',
  medicalTestsPerformed = 'medicalTestsPerformed',
  motherRestBetweenLitters = 'motherRestBetweenLitters',
  permissionFiles = 'permissionFiles',
  public = 'public',
  puppiesBirthPlace = 'puppiesBirthPlace',
  spokenLanguages = 'spokenLanguages',
  tags = 'tags',
  updatedAt = 'updatedAt',
  vatNumber = 'vatNumber',
  veterinaryInfo = 'veterinaryInfo',
  videoUrl = 'videoUrl',
  visitedByTipaw = 'visitedByTipaw',
  websiteUrl = 'websiteUrl',
  whatsappNumber = 'whatsappNumber'
}

export type DogBreederScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<DogBreederScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<DogBreederScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<DogBreederScalarWhereWithAggregatesInput>>;
  adminNote?: InputMaybe<StringNullableWithAggregatesFilter>;
  agreementNumber?: InputMaybe<StringNullableWithAggregatesFilter>;
  breedClubFiles?: InputMaybe<StringNullableListFilter>;
  breedClubValidated?: InputMaybe<BoolWithAggregatesFilter>;
  breedingName?: InputMaybe<StringNullableWithAggregatesFilter>;
  certificationFile?: InputMaybe<StringNullableWithAggregatesFilter>;
  certified?: InputMaybe<BoolNullableWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  displayEmail?: InputMaybe<StringNullableWithAggregatesFilter>;
  displayName?: InputMaybe<StringNullableWithAggregatesFilter>;
  displayPhone?: InputMaybe<StringNullableWithAggregatesFilter>;
  dogsConsanguinity?: InputMaybe<StringNullableWithAggregatesFilter>;
  dogsPedigree?: InputMaybe<StringNullableWithAggregatesFilter>;
  dogsTemper?: InputMaybe<StringNullableWithAggregatesFilter>;
  emailAutomationStage?: InputMaybe<IntWithAggregatesFilter>;
  facebookUrl?: InputMaybe<StringNullableWithAggregatesFilter>;
  failedMedicalTestsProtocol?: InputMaybe<StringNullableWithAggregatesFilter>;
  hasFinishedOnboarding?: InputMaybe<BoolWithAggregatesFilter>;
  hasStartedOnboarding?: InputMaybe<BoolWithAggregatesFilter>;
  hkFile?: InputMaybe<StringNullableWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  identityFiles?: InputMaybe<StringNullableListFilter>;
  lastAutomationEmailSentAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  level?: InputMaybe<StringNullableWithAggregatesFilter>;
  littersByFemale?: InputMaybe<StringNullableWithAggregatesFilter>;
  littersByFemaleCount?: InputMaybe<IntNullableWithAggregatesFilter>;
  maleBreedersCount?: InputMaybe<IntNullableWithAggregatesFilter>;
  medicalTestsPerformed?: InputMaybe<StringNullableWithAggregatesFilter>;
  motherRestBetweenLitters?: InputMaybe<StringNullableWithAggregatesFilter>;
  permissionFiles?: InputMaybe<StringNullableListFilter>;
  public?: InputMaybe<BoolNullableWithAggregatesFilter>;
  puppiesBirthPlace?: InputMaybe<StringNullableWithAggregatesFilter>;
  spokenLanguages?: InputMaybe<StringNullableListFilter>;
  tags?: InputMaybe<StringNullableListFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  vatNumber?: InputMaybe<StringNullableWithAggregatesFilter>;
  veterinaryInfo?: InputMaybe<StringNullableWithAggregatesFilter>;
  videoUrl?: InputMaybe<StringNullableWithAggregatesFilter>;
  visitedByTipaw?: InputMaybe<BoolWithAggregatesFilter>;
  websiteUrl?: InputMaybe<StringNullableWithAggregatesFilter>;
  whatsappNumber?: InputMaybe<StringNullableWithAggregatesFilter>;
};

export type DogBreederSumAggregateOutputType = {
  __typename?: 'DogBreederSumAggregateOutputType';
  emailAutomationStage?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  littersByFemaleCount?: Maybe<Scalars['Int']['output']>;
  maleBreedersCount?: Maybe<Scalars['Int']['output']>;
};

export type DogBreederSumOrderByAggregateInput = {
  emailAutomationStage?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  littersByFemaleCount?: InputMaybe<SortOrder>;
  maleBreedersCount?: InputMaybe<SortOrder>;
};

export type DogBreederTranslation = {
  __typename?: 'DogBreederTranslation';
  breederDogsSelection?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  dogBreeder: DogBreeder;
  dogBreederId: Scalars['Int']['output'];
  dogsActivities?: Maybe<Scalars['String']['output']>;
  dogsLivingPlace?: Maybe<Scalars['String']['output']>;
  health?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  idealMasterDescription?: Maybe<Scalars['String']['output']>;
  language: Scalars['String']['output'];
  puppiesLivingPlace?: Maybe<Scalars['String']['output']>;
  puppiesTraining?: Maybe<Scalars['String']['output']>;
  seoKeywords?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type DogBreederTranslationAvgAggregateOutputType = {
  __typename?: 'DogBreederTranslationAvgAggregateOutputType';
  dogBreederId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

export type DogBreederTranslationAvgOrderByAggregateInput = {
  dogBreederId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export type DogBreederTranslationCountAggregateOutputType = {
  __typename?: 'DogBreederTranslationCountAggregateOutputType';
  _all: Scalars['Int']['output'];
  breederDogsSelection: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  description: Scalars['Int']['output'];
  dogBreederId: Scalars['Int']['output'];
  dogsActivities: Scalars['Int']['output'];
  dogsLivingPlace: Scalars['Int']['output'];
  health: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  idealMasterDescription: Scalars['Int']['output'];
  language: Scalars['Int']['output'];
  puppiesLivingPlace: Scalars['Int']['output'];
  puppiesTraining: Scalars['Int']['output'];
  seoKeywords: Scalars['Int']['output'];
  title: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
  url: Scalars['Int']['output'];
};

export type DogBreederTranslationCountOrderByAggregateInput = {
  breederDogsSelection?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  dogBreederId?: InputMaybe<SortOrder>;
  dogsActivities?: InputMaybe<SortOrder>;
  dogsLivingPlace?: InputMaybe<SortOrder>;
  health?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  idealMasterDescription?: InputMaybe<SortOrder>;
  language?: InputMaybe<SortOrder>;
  puppiesLivingPlace?: InputMaybe<SortOrder>;
  puppiesTraining?: InputMaybe<SortOrder>;
  seoKeywords?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  url?: InputMaybe<SortOrder>;
};

export type DogBreederTranslationCreateInput = {
  breederDogsSelection?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dogBreeder: DogBreederCreateNestedOneWithoutTranslationsInput;
  dogsActivities?: InputMaybe<Scalars['String']['input']>;
  dogsLivingPlace?: InputMaybe<Scalars['String']['input']>;
  health?: InputMaybe<Scalars['String']['input']>;
  idealMasterDescription?: InputMaybe<Scalars['String']['input']>;
  language: Scalars['String']['input'];
  puppiesLivingPlace?: InputMaybe<Scalars['String']['input']>;
  puppiesTraining?: InputMaybe<Scalars['String']['input']>;
  seoKeywords?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type DogBreederTranslationCreateManyDogBreederInput = {
  breederDogsSelection?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dogsActivities?: InputMaybe<Scalars['String']['input']>;
  dogsLivingPlace?: InputMaybe<Scalars['String']['input']>;
  health?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  idealMasterDescription?: InputMaybe<Scalars['String']['input']>;
  language: Scalars['String']['input'];
  puppiesLivingPlace?: InputMaybe<Scalars['String']['input']>;
  puppiesTraining?: InputMaybe<Scalars['String']['input']>;
  seoKeywords?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type DogBreederTranslationCreateManyDogBreederInputEnvelope = {
  data: Array<DogBreederTranslationCreateManyDogBreederInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DogBreederTranslationCreateManyInput = {
  breederDogsSelection?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dogBreederId: Scalars['Int']['input'];
  dogsActivities?: InputMaybe<Scalars['String']['input']>;
  dogsLivingPlace?: InputMaybe<Scalars['String']['input']>;
  health?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  idealMasterDescription?: InputMaybe<Scalars['String']['input']>;
  language: Scalars['String']['input'];
  puppiesLivingPlace?: InputMaybe<Scalars['String']['input']>;
  puppiesTraining?: InputMaybe<Scalars['String']['input']>;
  seoKeywords?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type DogBreederTranslationCreateNestedManyWithoutDogBreederInput = {
  connect?: InputMaybe<Array<DogBreederTranslationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DogBreederTranslationCreateOrConnectWithoutDogBreederInput>>;
  create?: InputMaybe<Array<DogBreederTranslationCreateWithoutDogBreederInput>>;
  createMany?: InputMaybe<DogBreederTranslationCreateManyDogBreederInputEnvelope>;
};

export type DogBreederTranslationCreateOrConnectWithoutDogBreederInput = {
  create: DogBreederTranslationCreateWithoutDogBreederInput;
  where: DogBreederTranslationWhereUniqueInput;
};

export type DogBreederTranslationCreateWithoutDogBreederInput = {
  breederDogsSelection?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dogsActivities?: InputMaybe<Scalars['String']['input']>;
  dogsLivingPlace?: InputMaybe<Scalars['String']['input']>;
  health?: InputMaybe<Scalars['String']['input']>;
  idealMasterDescription?: InputMaybe<Scalars['String']['input']>;
  language: Scalars['String']['input'];
  puppiesLivingPlace?: InputMaybe<Scalars['String']['input']>;
  puppiesTraining?: InputMaybe<Scalars['String']['input']>;
  seoKeywords?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type DogBreederTranslationListRelationFilter = {
  every?: InputMaybe<DogBreederTranslationWhereInput>;
  none?: InputMaybe<DogBreederTranslationWhereInput>;
  some?: InputMaybe<DogBreederTranslationWhereInput>;
};

export type DogBreederTranslationMaxAggregateOutputType = {
  __typename?: 'DogBreederTranslationMaxAggregateOutputType';
  breederDogsSelection?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dogBreederId?: Maybe<Scalars['Int']['output']>;
  dogsActivities?: Maybe<Scalars['String']['output']>;
  dogsLivingPlace?: Maybe<Scalars['String']['output']>;
  health?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  idealMasterDescription?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  puppiesLivingPlace?: Maybe<Scalars['String']['output']>;
  puppiesTraining?: Maybe<Scalars['String']['output']>;
  seoKeywords?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type DogBreederTranslationMaxOrderByAggregateInput = {
  breederDogsSelection?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  dogBreederId?: InputMaybe<SortOrder>;
  dogsActivities?: InputMaybe<SortOrder>;
  dogsLivingPlace?: InputMaybe<SortOrder>;
  health?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  idealMasterDescription?: InputMaybe<SortOrder>;
  language?: InputMaybe<SortOrder>;
  puppiesLivingPlace?: InputMaybe<SortOrder>;
  puppiesTraining?: InputMaybe<SortOrder>;
  seoKeywords?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  url?: InputMaybe<SortOrder>;
};

export type DogBreederTranslationMinAggregateOutputType = {
  __typename?: 'DogBreederTranslationMinAggregateOutputType';
  breederDogsSelection?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dogBreederId?: Maybe<Scalars['Int']['output']>;
  dogsActivities?: Maybe<Scalars['String']['output']>;
  dogsLivingPlace?: Maybe<Scalars['String']['output']>;
  health?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  idealMasterDescription?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  puppiesLivingPlace?: Maybe<Scalars['String']['output']>;
  puppiesTraining?: Maybe<Scalars['String']['output']>;
  seoKeywords?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type DogBreederTranslationMinOrderByAggregateInput = {
  breederDogsSelection?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  dogBreederId?: InputMaybe<SortOrder>;
  dogsActivities?: InputMaybe<SortOrder>;
  dogsLivingPlace?: InputMaybe<SortOrder>;
  health?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  idealMasterDescription?: InputMaybe<SortOrder>;
  language?: InputMaybe<SortOrder>;
  puppiesLivingPlace?: InputMaybe<SortOrder>;
  puppiesTraining?: InputMaybe<SortOrder>;
  seoKeywords?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  url?: InputMaybe<SortOrder>;
};

export type DogBreederTranslationOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export enum DogBreederTranslationOrderByRelevanceFieldEnum {
  breederDogsSelection = 'breederDogsSelection',
  description = 'description',
  dogsActivities = 'dogsActivities',
  dogsLivingPlace = 'dogsLivingPlace',
  health = 'health',
  idealMasterDescription = 'idealMasterDescription',
  language = 'language',
  puppiesLivingPlace = 'puppiesLivingPlace',
  puppiesTraining = 'puppiesTraining',
  seoKeywords = 'seoKeywords',
  title = 'title',
  url = 'url'
}

export type DogBreederTranslationOrderByRelevanceInput = {
  fields: Array<DogBreederTranslationOrderByRelevanceFieldEnum>;
  search: Scalars['String']['input'];
  sort: SortOrder;
};

export type DogBreederTranslationOrderByWithAggregationInput = {
  _avg?: InputMaybe<DogBreederTranslationAvgOrderByAggregateInput>;
  _count?: InputMaybe<DogBreederTranslationCountOrderByAggregateInput>;
  _max?: InputMaybe<DogBreederTranslationMaxOrderByAggregateInput>;
  _min?: InputMaybe<DogBreederTranslationMinOrderByAggregateInput>;
  _sum?: InputMaybe<DogBreederTranslationSumOrderByAggregateInput>;
  breederDogsSelection?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrderInput>;
  dogBreederId?: InputMaybe<SortOrder>;
  dogsActivities?: InputMaybe<SortOrderInput>;
  dogsLivingPlace?: InputMaybe<SortOrderInput>;
  health?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  idealMasterDescription?: InputMaybe<SortOrderInput>;
  language?: InputMaybe<SortOrder>;
  puppiesLivingPlace?: InputMaybe<SortOrderInput>;
  puppiesTraining?: InputMaybe<SortOrderInput>;
  seoKeywords?: InputMaybe<SortOrderInput>;
  title?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
  url?: InputMaybe<SortOrderInput>;
};

export type DogBreederTranslationOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: InputMaybe<DogBreederTranslationOrderByRelevanceInput>;
  breederDogsSelection?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrderInput>;
  dogBreeder?: InputMaybe<DogBreederOrderByWithRelationAndSearchRelevanceInput>;
  dogBreederId?: InputMaybe<SortOrder>;
  dogsActivities?: InputMaybe<SortOrderInput>;
  dogsLivingPlace?: InputMaybe<SortOrderInput>;
  health?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  idealMasterDescription?: InputMaybe<SortOrderInput>;
  language?: InputMaybe<SortOrder>;
  puppiesLivingPlace?: InputMaybe<SortOrderInput>;
  puppiesTraining?: InputMaybe<SortOrderInput>;
  seoKeywords?: InputMaybe<SortOrderInput>;
  title?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
  url?: InputMaybe<SortOrderInput>;
};

export enum DogBreederTranslationScalarFieldEnum {
  breederDogsSelection = 'breederDogsSelection',
  createdAt = 'createdAt',
  description = 'description',
  dogBreederId = 'dogBreederId',
  dogsActivities = 'dogsActivities',
  dogsLivingPlace = 'dogsLivingPlace',
  health = 'health',
  id = 'id',
  idealMasterDescription = 'idealMasterDescription',
  language = 'language',
  puppiesLivingPlace = 'puppiesLivingPlace',
  puppiesTraining = 'puppiesTraining',
  seoKeywords = 'seoKeywords',
  title = 'title',
  updatedAt = 'updatedAt',
  url = 'url'
}

export type DogBreederTranslationScalarWhereInput = {
  AND?: InputMaybe<Array<DogBreederTranslationScalarWhereInput>>;
  NOT?: InputMaybe<Array<DogBreederTranslationScalarWhereInput>>;
  OR?: InputMaybe<Array<DogBreederTranslationScalarWhereInput>>;
  breederDogsSelection?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringNullableFilter>;
  dogBreederId?: InputMaybe<IntFilter>;
  dogsActivities?: InputMaybe<StringNullableFilter>;
  dogsLivingPlace?: InputMaybe<StringNullableFilter>;
  health?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<IntFilter>;
  idealMasterDescription?: InputMaybe<StringNullableFilter>;
  language?: InputMaybe<StringFilter>;
  puppiesLivingPlace?: InputMaybe<StringNullableFilter>;
  puppiesTraining?: InputMaybe<StringNullableFilter>;
  seoKeywords?: InputMaybe<StringNullableFilter>;
  title?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  url?: InputMaybe<StringNullableFilter>;
};

export type DogBreederTranslationScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<DogBreederTranslationScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<DogBreederTranslationScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<DogBreederTranslationScalarWhereWithAggregatesInput>>;
  breederDogsSelection?: InputMaybe<StringNullableWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  description?: InputMaybe<StringNullableWithAggregatesFilter>;
  dogBreederId?: InputMaybe<IntWithAggregatesFilter>;
  dogsActivities?: InputMaybe<StringNullableWithAggregatesFilter>;
  dogsLivingPlace?: InputMaybe<StringNullableWithAggregatesFilter>;
  health?: InputMaybe<StringNullableWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  idealMasterDescription?: InputMaybe<StringNullableWithAggregatesFilter>;
  language?: InputMaybe<StringWithAggregatesFilter>;
  puppiesLivingPlace?: InputMaybe<StringNullableWithAggregatesFilter>;
  puppiesTraining?: InputMaybe<StringNullableWithAggregatesFilter>;
  seoKeywords?: InputMaybe<StringNullableWithAggregatesFilter>;
  title?: InputMaybe<StringNullableWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  url?: InputMaybe<StringNullableWithAggregatesFilter>;
};

export type DogBreederTranslationSumAggregateOutputType = {
  __typename?: 'DogBreederTranslationSumAggregateOutputType';
  dogBreederId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
};

export type DogBreederTranslationSumOrderByAggregateInput = {
  dogBreederId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export type DogBreederTranslationUncheckedCreateInput = {
  breederDogsSelection?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dogBreederId: Scalars['Int']['input'];
  dogsActivities?: InputMaybe<Scalars['String']['input']>;
  dogsLivingPlace?: InputMaybe<Scalars['String']['input']>;
  health?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  idealMasterDescription?: InputMaybe<Scalars['String']['input']>;
  language: Scalars['String']['input'];
  puppiesLivingPlace?: InputMaybe<Scalars['String']['input']>;
  puppiesTraining?: InputMaybe<Scalars['String']['input']>;
  seoKeywords?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type DogBreederTranslationUncheckedCreateNestedManyWithoutDogBreederInput = {
  connect?: InputMaybe<Array<DogBreederTranslationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DogBreederTranslationCreateOrConnectWithoutDogBreederInput>>;
  create?: InputMaybe<Array<DogBreederTranslationCreateWithoutDogBreederInput>>;
  createMany?: InputMaybe<DogBreederTranslationCreateManyDogBreederInputEnvelope>;
};

export type DogBreederTranslationUncheckedCreateWithoutDogBreederInput = {
  breederDogsSelection?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dogsActivities?: InputMaybe<Scalars['String']['input']>;
  dogsLivingPlace?: InputMaybe<Scalars['String']['input']>;
  health?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  idealMasterDescription?: InputMaybe<Scalars['String']['input']>;
  language: Scalars['String']['input'];
  puppiesLivingPlace?: InputMaybe<Scalars['String']['input']>;
  puppiesTraining?: InputMaybe<Scalars['String']['input']>;
  seoKeywords?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type DogBreederTranslationUncheckedUpdateInput = {
  breederDogsSelection?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dogBreederId?: InputMaybe<IntFieldUpdateOperationsInput>;
  dogsActivities?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dogsLivingPlace?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  health?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  idealMasterDescription?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  puppiesLivingPlace?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  puppiesTraining?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  seoKeywords?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  url?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type DogBreederTranslationUncheckedUpdateManyInput = {
  breederDogsSelection?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dogBreederId?: InputMaybe<IntFieldUpdateOperationsInput>;
  dogsActivities?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dogsLivingPlace?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  health?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  idealMasterDescription?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  puppiesLivingPlace?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  puppiesTraining?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  seoKeywords?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  url?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type DogBreederTranslationUncheckedUpdateManyWithoutDogBreederInput = {
  breederDogsSelection?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dogsActivities?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dogsLivingPlace?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  health?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  idealMasterDescription?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  puppiesLivingPlace?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  puppiesTraining?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  seoKeywords?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  url?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type DogBreederTranslationUncheckedUpdateManyWithoutDogBreederNestedInput = {
  connect?: InputMaybe<Array<DogBreederTranslationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DogBreederTranslationCreateOrConnectWithoutDogBreederInput>>;
  create?: InputMaybe<Array<DogBreederTranslationCreateWithoutDogBreederInput>>;
  createMany?: InputMaybe<DogBreederTranslationCreateManyDogBreederInputEnvelope>;
  delete?: InputMaybe<Array<DogBreederTranslationWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<DogBreederTranslationScalarWhereInput>>;
  disconnect?: InputMaybe<Array<DogBreederTranslationWhereUniqueInput>>;
  set?: InputMaybe<Array<DogBreederTranslationWhereUniqueInput>>;
  update?: InputMaybe<Array<DogBreederTranslationUpdateWithWhereUniqueWithoutDogBreederInput>>;
  updateMany?: InputMaybe<Array<DogBreederTranslationUpdateManyWithWhereWithoutDogBreederInput>>;
  upsert?: InputMaybe<Array<DogBreederTranslationUpsertWithWhereUniqueWithoutDogBreederInput>>;
};

export type DogBreederTranslationUncheckedUpdateWithoutDogBreederInput = {
  breederDogsSelection?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dogsActivities?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dogsLivingPlace?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  health?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  idealMasterDescription?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  puppiesLivingPlace?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  puppiesTraining?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  seoKeywords?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  url?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type DogBreederTranslationUpdateInput = {
  breederDogsSelection?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dogBreeder?: InputMaybe<DogBreederUpdateOneRequiredWithoutTranslationsNestedInput>;
  dogsActivities?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dogsLivingPlace?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  health?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  idealMasterDescription?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  puppiesLivingPlace?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  puppiesTraining?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  seoKeywords?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  url?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type DogBreederTranslationUpdateManyMutationInput = {
  breederDogsSelection?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dogsActivities?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dogsLivingPlace?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  health?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  idealMasterDescription?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  puppiesLivingPlace?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  puppiesTraining?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  seoKeywords?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  url?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type DogBreederTranslationUpdateManyWithWhereWithoutDogBreederInput = {
  data: DogBreederTranslationUpdateManyMutationInput;
  where: DogBreederTranslationScalarWhereInput;
};

export type DogBreederTranslationUpdateManyWithoutDogBreederNestedInput = {
  connect?: InputMaybe<Array<DogBreederTranslationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DogBreederTranslationCreateOrConnectWithoutDogBreederInput>>;
  create?: InputMaybe<Array<DogBreederTranslationCreateWithoutDogBreederInput>>;
  createMany?: InputMaybe<DogBreederTranslationCreateManyDogBreederInputEnvelope>;
  delete?: InputMaybe<Array<DogBreederTranslationWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<DogBreederTranslationScalarWhereInput>>;
  disconnect?: InputMaybe<Array<DogBreederTranslationWhereUniqueInput>>;
  set?: InputMaybe<Array<DogBreederTranslationWhereUniqueInput>>;
  update?: InputMaybe<Array<DogBreederTranslationUpdateWithWhereUniqueWithoutDogBreederInput>>;
  updateMany?: InputMaybe<Array<DogBreederTranslationUpdateManyWithWhereWithoutDogBreederInput>>;
  upsert?: InputMaybe<Array<DogBreederTranslationUpsertWithWhereUniqueWithoutDogBreederInput>>;
};

export type DogBreederTranslationUpdateWithWhereUniqueWithoutDogBreederInput = {
  data: DogBreederTranslationUpdateWithoutDogBreederInput;
  where: DogBreederTranslationWhereUniqueInput;
};

export type DogBreederTranslationUpdateWithoutDogBreederInput = {
  breederDogsSelection?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dogsActivities?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dogsLivingPlace?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  health?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  idealMasterDescription?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  puppiesLivingPlace?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  puppiesTraining?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  seoKeywords?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  url?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type DogBreederTranslationUpsertWithWhereUniqueWithoutDogBreederInput = {
  create: DogBreederTranslationCreateWithoutDogBreederInput;
  update: DogBreederTranslationUpdateWithoutDogBreederInput;
  where: DogBreederTranslationWhereUniqueInput;
};

export type DogBreederTranslationWhereInput = {
  AND?: InputMaybe<Array<DogBreederTranslationWhereInput>>;
  NOT?: InputMaybe<Array<DogBreederTranslationWhereInput>>;
  OR?: InputMaybe<Array<DogBreederTranslationWhereInput>>;
  breederDogsSelection?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringNullableFilter>;
  dogBreeder?: InputMaybe<DogBreederRelationFilter>;
  dogBreederId?: InputMaybe<IntFilter>;
  dogsActivities?: InputMaybe<StringNullableFilter>;
  dogsLivingPlace?: InputMaybe<StringNullableFilter>;
  health?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<IntFilter>;
  idealMasterDescription?: InputMaybe<StringNullableFilter>;
  language?: InputMaybe<StringFilter>;
  puppiesLivingPlace?: InputMaybe<StringNullableFilter>;
  puppiesTraining?: InputMaybe<StringNullableFilter>;
  seoKeywords?: InputMaybe<StringNullableFilter>;
  title?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  url?: InputMaybe<StringNullableFilter>;
};

export type DogBreederTranslationWhereUniqueInput = {
  AND?: InputMaybe<Array<DogBreederTranslationWhereInput>>;
  NOT?: InputMaybe<Array<DogBreederTranslationWhereInput>>;
  OR?: InputMaybe<Array<DogBreederTranslationWhereInput>>;
  breederDogsSelection?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringNullableFilter>;
  dogBreeder?: InputMaybe<DogBreederRelationFilter>;
  dogBreederId?: InputMaybe<IntFilter>;
  dogsActivities?: InputMaybe<StringNullableFilter>;
  dogsLivingPlace?: InputMaybe<StringNullableFilter>;
  health?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  idealMasterDescription?: InputMaybe<StringNullableFilter>;
  language?: InputMaybe<StringFilter>;
  puppiesLivingPlace?: InputMaybe<StringNullableFilter>;
  puppiesTraining?: InputMaybe<StringNullableFilter>;
  seoKeywords?: InputMaybe<StringNullableFilter>;
  title?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  url?: InputMaybe<StringNullableFilter>;
};

export type DogBreederUncheckedCreateInput = {
  adminNote?: InputMaybe<Scalars['String']['input']>;
  agreementNumber?: InputMaybe<Scalars['String']['input']>;
  applications?: InputMaybe<DogBreederApplicationUncheckedCreateNestedManyWithoutDogBreederInput>;
  breedClubFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  breedClubValidated?: InputMaybe<Scalars['Boolean']['input']>;
  breederBreeds?: InputMaybe<DogBreederBreedsUncheckedCreateNestedManyWithoutDogBreederInput>;
  breedingName?: InputMaybe<Scalars['String']['input']>;
  certificationFile?: InputMaybe<Scalars['String']['input']>;
  certified?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  displayEmail?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  displayPhone?: InputMaybe<Scalars['String']['input']>;
  dogInfos?: InputMaybe<DogInfoUncheckedCreateNestedManyWithoutBreederInput>;
  dogsConsanguinity?: InputMaybe<Scalars['String']['input']>;
  dogsPedigree?: InputMaybe<Scalars['String']['input']>;
  dogsTemper?: InputMaybe<Scalars['String']['input']>;
  emailAutomationStage?: InputMaybe<Scalars['Int']['input']>;
  emailHistory?: InputMaybe<EmailHistoryUncheckedCreateNestedManyWithoutBreederInput>;
  facebookUrl?: InputMaybe<Scalars['String']['input']>;
  failedMedicalTestsProtocol?: InputMaybe<Scalars['String']['input']>;
  hasFinishedOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  hasStartedOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  hkFile?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  identityFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  imgs?: InputMaybe<DogBreederImgUncheckedCreateNestedManyWithoutDogBreederInput>;
  lastAutomationEmailSentAt?: InputMaybe<Scalars['DateTime']['input']>;
  level?: InputMaybe<Scalars['String']['input']>;
  litters?: InputMaybe<LitterUncheckedCreateNestedManyWithoutBreederInput>;
  littersByFemale?: InputMaybe<Scalars['String']['input']>;
  littersByFemaleCount?: InputMaybe<Scalars['Int']['input']>;
  maleBreedersCount?: InputMaybe<Scalars['Int']['input']>;
  medicalTestsPerformed?: InputMaybe<Scalars['String']['input']>;
  motherRestBetweenLitters?: InputMaybe<Scalars['String']['input']>;
  notifications?: InputMaybe<NotificationUncheckedCreateNestedManyWithoutBreederInput>;
  permissionFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  puppies?: InputMaybe<DogPuppyUncheckedCreateNestedManyWithoutBreederInput>;
  puppiesBirthPlace?: InputMaybe<Scalars['String']['input']>;
  reviews?: InputMaybe<DogBreederReviewUncheckedCreateNestedManyWithoutDogBreederInput>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  studInfos?: InputMaybe<StudInfoUncheckedCreateNestedManyWithoutBreederInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  translations?: InputMaybe<DogBreederTranslationUncheckedCreateNestedManyWithoutDogBreederInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updates?: InputMaybe<UpdateUncheckedCreateNestedManyWithoutBreederInput>;
  vatNumber?: InputMaybe<Scalars['String']['input']>;
  veterinaryInfo?: InputMaybe<Scalars['String']['input']>;
  videoUrl?: InputMaybe<Scalars['String']['input']>;
  visitedByTipaw?: InputMaybe<Scalars['Boolean']['input']>;
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
  whatsappNumber?: InputMaybe<Scalars['String']['input']>;
};

export type DogBreederUncheckedCreateNestedOneWithoutAccountInput = {
  connect?: InputMaybe<DogBreederWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DogBreederCreateOrConnectWithoutAccountInput>;
  create?: InputMaybe<DogBreederCreateWithoutAccountInput>;
};

export type DogBreederUncheckedCreateWithoutAccountInput = {
  adminNote?: InputMaybe<Scalars['String']['input']>;
  agreementNumber?: InputMaybe<Scalars['String']['input']>;
  applications?: InputMaybe<DogBreederApplicationUncheckedCreateNestedManyWithoutDogBreederInput>;
  breedClubFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  breedClubValidated?: InputMaybe<Scalars['Boolean']['input']>;
  breederBreeds?: InputMaybe<DogBreederBreedsUncheckedCreateNestedManyWithoutDogBreederInput>;
  breedingName?: InputMaybe<Scalars['String']['input']>;
  certificationFile?: InputMaybe<Scalars['String']['input']>;
  certified?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  displayEmail?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  displayPhone?: InputMaybe<Scalars['String']['input']>;
  dogInfos?: InputMaybe<DogInfoUncheckedCreateNestedManyWithoutBreederInput>;
  dogsConsanguinity?: InputMaybe<Scalars['String']['input']>;
  dogsPedigree?: InputMaybe<Scalars['String']['input']>;
  dogsTemper?: InputMaybe<Scalars['String']['input']>;
  emailAutomationStage?: InputMaybe<Scalars['Int']['input']>;
  emailHistory?: InputMaybe<EmailHistoryUncheckedCreateNestedManyWithoutBreederInput>;
  facebookUrl?: InputMaybe<Scalars['String']['input']>;
  failedMedicalTestsProtocol?: InputMaybe<Scalars['String']['input']>;
  hasFinishedOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  hasStartedOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  hkFile?: InputMaybe<Scalars['String']['input']>;
  identityFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  imgs?: InputMaybe<DogBreederImgUncheckedCreateNestedManyWithoutDogBreederInput>;
  lastAutomationEmailSentAt?: InputMaybe<Scalars['DateTime']['input']>;
  level?: InputMaybe<Scalars['String']['input']>;
  litters?: InputMaybe<LitterUncheckedCreateNestedManyWithoutBreederInput>;
  littersByFemale?: InputMaybe<Scalars['String']['input']>;
  littersByFemaleCount?: InputMaybe<Scalars['Int']['input']>;
  maleBreedersCount?: InputMaybe<Scalars['Int']['input']>;
  medicalTestsPerformed?: InputMaybe<Scalars['String']['input']>;
  motherRestBetweenLitters?: InputMaybe<Scalars['String']['input']>;
  notifications?: InputMaybe<NotificationUncheckedCreateNestedManyWithoutBreederInput>;
  permissionFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  puppies?: InputMaybe<DogPuppyUncheckedCreateNestedManyWithoutBreederInput>;
  puppiesBirthPlace?: InputMaybe<Scalars['String']['input']>;
  reviews?: InputMaybe<DogBreederReviewUncheckedCreateNestedManyWithoutDogBreederInput>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  studInfos?: InputMaybe<StudInfoUncheckedCreateNestedManyWithoutBreederInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  translations?: InputMaybe<DogBreederTranslationUncheckedCreateNestedManyWithoutDogBreederInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updates?: InputMaybe<UpdateUncheckedCreateNestedManyWithoutBreederInput>;
  vatNumber?: InputMaybe<Scalars['String']['input']>;
  veterinaryInfo?: InputMaybe<Scalars['String']['input']>;
  videoUrl?: InputMaybe<Scalars['String']['input']>;
  visitedByTipaw?: InputMaybe<Scalars['Boolean']['input']>;
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
  whatsappNumber?: InputMaybe<Scalars['String']['input']>;
};

export type DogBreederUncheckedCreateWithoutApplicationsInput = {
  adminNote?: InputMaybe<Scalars['String']['input']>;
  agreementNumber?: InputMaybe<Scalars['String']['input']>;
  breedClubFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  breedClubValidated?: InputMaybe<Scalars['Boolean']['input']>;
  breederBreeds?: InputMaybe<DogBreederBreedsUncheckedCreateNestedManyWithoutDogBreederInput>;
  breedingName?: InputMaybe<Scalars['String']['input']>;
  certificationFile?: InputMaybe<Scalars['String']['input']>;
  certified?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  displayEmail?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  displayPhone?: InputMaybe<Scalars['String']['input']>;
  dogInfos?: InputMaybe<DogInfoUncheckedCreateNestedManyWithoutBreederInput>;
  dogsConsanguinity?: InputMaybe<Scalars['String']['input']>;
  dogsPedigree?: InputMaybe<Scalars['String']['input']>;
  dogsTemper?: InputMaybe<Scalars['String']['input']>;
  emailAutomationStage?: InputMaybe<Scalars['Int']['input']>;
  emailHistory?: InputMaybe<EmailHistoryUncheckedCreateNestedManyWithoutBreederInput>;
  facebookUrl?: InputMaybe<Scalars['String']['input']>;
  failedMedicalTestsProtocol?: InputMaybe<Scalars['String']['input']>;
  hasFinishedOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  hasStartedOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  hkFile?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  identityFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  imgs?: InputMaybe<DogBreederImgUncheckedCreateNestedManyWithoutDogBreederInput>;
  lastAutomationEmailSentAt?: InputMaybe<Scalars['DateTime']['input']>;
  level?: InputMaybe<Scalars['String']['input']>;
  litters?: InputMaybe<LitterUncheckedCreateNestedManyWithoutBreederInput>;
  littersByFemale?: InputMaybe<Scalars['String']['input']>;
  littersByFemaleCount?: InputMaybe<Scalars['Int']['input']>;
  maleBreedersCount?: InputMaybe<Scalars['Int']['input']>;
  medicalTestsPerformed?: InputMaybe<Scalars['String']['input']>;
  motherRestBetweenLitters?: InputMaybe<Scalars['String']['input']>;
  notifications?: InputMaybe<NotificationUncheckedCreateNestedManyWithoutBreederInput>;
  permissionFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  puppies?: InputMaybe<DogPuppyUncheckedCreateNestedManyWithoutBreederInput>;
  puppiesBirthPlace?: InputMaybe<Scalars['String']['input']>;
  reviews?: InputMaybe<DogBreederReviewUncheckedCreateNestedManyWithoutDogBreederInput>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  studInfos?: InputMaybe<StudInfoUncheckedCreateNestedManyWithoutBreederInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  translations?: InputMaybe<DogBreederTranslationUncheckedCreateNestedManyWithoutDogBreederInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updates?: InputMaybe<UpdateUncheckedCreateNestedManyWithoutBreederInput>;
  vatNumber?: InputMaybe<Scalars['String']['input']>;
  veterinaryInfo?: InputMaybe<Scalars['String']['input']>;
  videoUrl?: InputMaybe<Scalars['String']['input']>;
  visitedByTipaw?: InputMaybe<Scalars['Boolean']['input']>;
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
  whatsappNumber?: InputMaybe<Scalars['String']['input']>;
};

export type DogBreederUncheckedCreateWithoutBreederBreedsInput = {
  adminNote?: InputMaybe<Scalars['String']['input']>;
  agreementNumber?: InputMaybe<Scalars['String']['input']>;
  applications?: InputMaybe<DogBreederApplicationUncheckedCreateNestedManyWithoutDogBreederInput>;
  breedClubFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  breedClubValidated?: InputMaybe<Scalars['Boolean']['input']>;
  breedingName?: InputMaybe<Scalars['String']['input']>;
  certificationFile?: InputMaybe<Scalars['String']['input']>;
  certified?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  displayEmail?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  displayPhone?: InputMaybe<Scalars['String']['input']>;
  dogInfos?: InputMaybe<DogInfoUncheckedCreateNestedManyWithoutBreederInput>;
  dogsConsanguinity?: InputMaybe<Scalars['String']['input']>;
  dogsPedigree?: InputMaybe<Scalars['String']['input']>;
  dogsTemper?: InputMaybe<Scalars['String']['input']>;
  emailAutomationStage?: InputMaybe<Scalars['Int']['input']>;
  emailHistory?: InputMaybe<EmailHistoryUncheckedCreateNestedManyWithoutBreederInput>;
  facebookUrl?: InputMaybe<Scalars['String']['input']>;
  failedMedicalTestsProtocol?: InputMaybe<Scalars['String']['input']>;
  hasFinishedOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  hasStartedOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  hkFile?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  identityFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  imgs?: InputMaybe<DogBreederImgUncheckedCreateNestedManyWithoutDogBreederInput>;
  lastAutomationEmailSentAt?: InputMaybe<Scalars['DateTime']['input']>;
  level?: InputMaybe<Scalars['String']['input']>;
  litters?: InputMaybe<LitterUncheckedCreateNestedManyWithoutBreederInput>;
  littersByFemale?: InputMaybe<Scalars['String']['input']>;
  littersByFemaleCount?: InputMaybe<Scalars['Int']['input']>;
  maleBreedersCount?: InputMaybe<Scalars['Int']['input']>;
  medicalTestsPerformed?: InputMaybe<Scalars['String']['input']>;
  motherRestBetweenLitters?: InputMaybe<Scalars['String']['input']>;
  notifications?: InputMaybe<NotificationUncheckedCreateNestedManyWithoutBreederInput>;
  permissionFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  puppies?: InputMaybe<DogPuppyUncheckedCreateNestedManyWithoutBreederInput>;
  puppiesBirthPlace?: InputMaybe<Scalars['String']['input']>;
  reviews?: InputMaybe<DogBreederReviewUncheckedCreateNestedManyWithoutDogBreederInput>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  studInfos?: InputMaybe<StudInfoUncheckedCreateNestedManyWithoutBreederInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  translations?: InputMaybe<DogBreederTranslationUncheckedCreateNestedManyWithoutDogBreederInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updates?: InputMaybe<UpdateUncheckedCreateNestedManyWithoutBreederInput>;
  vatNumber?: InputMaybe<Scalars['String']['input']>;
  veterinaryInfo?: InputMaybe<Scalars['String']['input']>;
  videoUrl?: InputMaybe<Scalars['String']['input']>;
  visitedByTipaw?: InputMaybe<Scalars['Boolean']['input']>;
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
  whatsappNumber?: InputMaybe<Scalars['String']['input']>;
};

export type DogBreederUncheckedCreateWithoutDogInfosInput = {
  adminNote?: InputMaybe<Scalars['String']['input']>;
  agreementNumber?: InputMaybe<Scalars['String']['input']>;
  applications?: InputMaybe<DogBreederApplicationUncheckedCreateNestedManyWithoutDogBreederInput>;
  breedClubFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  breedClubValidated?: InputMaybe<Scalars['Boolean']['input']>;
  breederBreeds?: InputMaybe<DogBreederBreedsUncheckedCreateNestedManyWithoutDogBreederInput>;
  breedingName?: InputMaybe<Scalars['String']['input']>;
  certificationFile?: InputMaybe<Scalars['String']['input']>;
  certified?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  displayEmail?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  displayPhone?: InputMaybe<Scalars['String']['input']>;
  dogsConsanguinity?: InputMaybe<Scalars['String']['input']>;
  dogsPedigree?: InputMaybe<Scalars['String']['input']>;
  dogsTemper?: InputMaybe<Scalars['String']['input']>;
  emailAutomationStage?: InputMaybe<Scalars['Int']['input']>;
  emailHistory?: InputMaybe<EmailHistoryUncheckedCreateNestedManyWithoutBreederInput>;
  facebookUrl?: InputMaybe<Scalars['String']['input']>;
  failedMedicalTestsProtocol?: InputMaybe<Scalars['String']['input']>;
  hasFinishedOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  hasStartedOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  hkFile?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  identityFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  imgs?: InputMaybe<DogBreederImgUncheckedCreateNestedManyWithoutDogBreederInput>;
  lastAutomationEmailSentAt?: InputMaybe<Scalars['DateTime']['input']>;
  level?: InputMaybe<Scalars['String']['input']>;
  litters?: InputMaybe<LitterUncheckedCreateNestedManyWithoutBreederInput>;
  littersByFemale?: InputMaybe<Scalars['String']['input']>;
  littersByFemaleCount?: InputMaybe<Scalars['Int']['input']>;
  maleBreedersCount?: InputMaybe<Scalars['Int']['input']>;
  medicalTestsPerformed?: InputMaybe<Scalars['String']['input']>;
  motherRestBetweenLitters?: InputMaybe<Scalars['String']['input']>;
  notifications?: InputMaybe<NotificationUncheckedCreateNestedManyWithoutBreederInput>;
  permissionFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  puppies?: InputMaybe<DogPuppyUncheckedCreateNestedManyWithoutBreederInput>;
  puppiesBirthPlace?: InputMaybe<Scalars['String']['input']>;
  reviews?: InputMaybe<DogBreederReviewUncheckedCreateNestedManyWithoutDogBreederInput>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  studInfos?: InputMaybe<StudInfoUncheckedCreateNestedManyWithoutBreederInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  translations?: InputMaybe<DogBreederTranslationUncheckedCreateNestedManyWithoutDogBreederInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updates?: InputMaybe<UpdateUncheckedCreateNestedManyWithoutBreederInput>;
  vatNumber?: InputMaybe<Scalars['String']['input']>;
  veterinaryInfo?: InputMaybe<Scalars['String']['input']>;
  videoUrl?: InputMaybe<Scalars['String']['input']>;
  visitedByTipaw?: InputMaybe<Scalars['Boolean']['input']>;
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
  whatsappNumber?: InputMaybe<Scalars['String']['input']>;
};

export type DogBreederUncheckedCreateWithoutEmailHistoryInput = {
  adminNote?: InputMaybe<Scalars['String']['input']>;
  agreementNumber?: InputMaybe<Scalars['String']['input']>;
  applications?: InputMaybe<DogBreederApplicationUncheckedCreateNestedManyWithoutDogBreederInput>;
  breedClubFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  breedClubValidated?: InputMaybe<Scalars['Boolean']['input']>;
  breederBreeds?: InputMaybe<DogBreederBreedsUncheckedCreateNestedManyWithoutDogBreederInput>;
  breedingName?: InputMaybe<Scalars['String']['input']>;
  certificationFile?: InputMaybe<Scalars['String']['input']>;
  certified?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  displayEmail?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  displayPhone?: InputMaybe<Scalars['String']['input']>;
  dogInfos?: InputMaybe<DogInfoUncheckedCreateNestedManyWithoutBreederInput>;
  dogsConsanguinity?: InputMaybe<Scalars['String']['input']>;
  dogsPedigree?: InputMaybe<Scalars['String']['input']>;
  dogsTemper?: InputMaybe<Scalars['String']['input']>;
  emailAutomationStage?: InputMaybe<Scalars['Int']['input']>;
  facebookUrl?: InputMaybe<Scalars['String']['input']>;
  failedMedicalTestsProtocol?: InputMaybe<Scalars['String']['input']>;
  hasFinishedOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  hasStartedOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  hkFile?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  identityFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  imgs?: InputMaybe<DogBreederImgUncheckedCreateNestedManyWithoutDogBreederInput>;
  lastAutomationEmailSentAt?: InputMaybe<Scalars['DateTime']['input']>;
  level?: InputMaybe<Scalars['String']['input']>;
  litters?: InputMaybe<LitterUncheckedCreateNestedManyWithoutBreederInput>;
  littersByFemale?: InputMaybe<Scalars['String']['input']>;
  littersByFemaleCount?: InputMaybe<Scalars['Int']['input']>;
  maleBreedersCount?: InputMaybe<Scalars['Int']['input']>;
  medicalTestsPerformed?: InputMaybe<Scalars['String']['input']>;
  motherRestBetweenLitters?: InputMaybe<Scalars['String']['input']>;
  notifications?: InputMaybe<NotificationUncheckedCreateNestedManyWithoutBreederInput>;
  permissionFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  puppies?: InputMaybe<DogPuppyUncheckedCreateNestedManyWithoutBreederInput>;
  puppiesBirthPlace?: InputMaybe<Scalars['String']['input']>;
  reviews?: InputMaybe<DogBreederReviewUncheckedCreateNestedManyWithoutDogBreederInput>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  studInfos?: InputMaybe<StudInfoUncheckedCreateNestedManyWithoutBreederInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  translations?: InputMaybe<DogBreederTranslationUncheckedCreateNestedManyWithoutDogBreederInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updates?: InputMaybe<UpdateUncheckedCreateNestedManyWithoutBreederInput>;
  vatNumber?: InputMaybe<Scalars['String']['input']>;
  veterinaryInfo?: InputMaybe<Scalars['String']['input']>;
  videoUrl?: InputMaybe<Scalars['String']['input']>;
  visitedByTipaw?: InputMaybe<Scalars['Boolean']['input']>;
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
  whatsappNumber?: InputMaybe<Scalars['String']['input']>;
};

export type DogBreederUncheckedCreateWithoutImgsInput = {
  adminNote?: InputMaybe<Scalars['String']['input']>;
  agreementNumber?: InputMaybe<Scalars['String']['input']>;
  applications?: InputMaybe<DogBreederApplicationUncheckedCreateNestedManyWithoutDogBreederInput>;
  breedClubFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  breedClubValidated?: InputMaybe<Scalars['Boolean']['input']>;
  breederBreeds?: InputMaybe<DogBreederBreedsUncheckedCreateNestedManyWithoutDogBreederInput>;
  breedingName?: InputMaybe<Scalars['String']['input']>;
  certificationFile?: InputMaybe<Scalars['String']['input']>;
  certified?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  displayEmail?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  displayPhone?: InputMaybe<Scalars['String']['input']>;
  dogInfos?: InputMaybe<DogInfoUncheckedCreateNestedManyWithoutBreederInput>;
  dogsConsanguinity?: InputMaybe<Scalars['String']['input']>;
  dogsPedigree?: InputMaybe<Scalars['String']['input']>;
  dogsTemper?: InputMaybe<Scalars['String']['input']>;
  emailAutomationStage?: InputMaybe<Scalars['Int']['input']>;
  emailHistory?: InputMaybe<EmailHistoryUncheckedCreateNestedManyWithoutBreederInput>;
  facebookUrl?: InputMaybe<Scalars['String']['input']>;
  failedMedicalTestsProtocol?: InputMaybe<Scalars['String']['input']>;
  hasFinishedOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  hasStartedOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  hkFile?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  identityFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  lastAutomationEmailSentAt?: InputMaybe<Scalars['DateTime']['input']>;
  level?: InputMaybe<Scalars['String']['input']>;
  litters?: InputMaybe<LitterUncheckedCreateNestedManyWithoutBreederInput>;
  littersByFemale?: InputMaybe<Scalars['String']['input']>;
  littersByFemaleCount?: InputMaybe<Scalars['Int']['input']>;
  maleBreedersCount?: InputMaybe<Scalars['Int']['input']>;
  medicalTestsPerformed?: InputMaybe<Scalars['String']['input']>;
  motherRestBetweenLitters?: InputMaybe<Scalars['String']['input']>;
  notifications?: InputMaybe<NotificationUncheckedCreateNestedManyWithoutBreederInput>;
  permissionFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  puppies?: InputMaybe<DogPuppyUncheckedCreateNestedManyWithoutBreederInput>;
  puppiesBirthPlace?: InputMaybe<Scalars['String']['input']>;
  reviews?: InputMaybe<DogBreederReviewUncheckedCreateNestedManyWithoutDogBreederInput>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  studInfos?: InputMaybe<StudInfoUncheckedCreateNestedManyWithoutBreederInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  translations?: InputMaybe<DogBreederTranslationUncheckedCreateNestedManyWithoutDogBreederInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updates?: InputMaybe<UpdateUncheckedCreateNestedManyWithoutBreederInput>;
  vatNumber?: InputMaybe<Scalars['String']['input']>;
  veterinaryInfo?: InputMaybe<Scalars['String']['input']>;
  videoUrl?: InputMaybe<Scalars['String']['input']>;
  visitedByTipaw?: InputMaybe<Scalars['Boolean']['input']>;
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
  whatsappNumber?: InputMaybe<Scalars['String']['input']>;
};

export type DogBreederUncheckedCreateWithoutLittersInput = {
  adminNote?: InputMaybe<Scalars['String']['input']>;
  agreementNumber?: InputMaybe<Scalars['String']['input']>;
  applications?: InputMaybe<DogBreederApplicationUncheckedCreateNestedManyWithoutDogBreederInput>;
  breedClubFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  breedClubValidated?: InputMaybe<Scalars['Boolean']['input']>;
  breederBreeds?: InputMaybe<DogBreederBreedsUncheckedCreateNestedManyWithoutDogBreederInput>;
  breedingName?: InputMaybe<Scalars['String']['input']>;
  certificationFile?: InputMaybe<Scalars['String']['input']>;
  certified?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  displayEmail?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  displayPhone?: InputMaybe<Scalars['String']['input']>;
  dogInfos?: InputMaybe<DogInfoUncheckedCreateNestedManyWithoutBreederInput>;
  dogsConsanguinity?: InputMaybe<Scalars['String']['input']>;
  dogsPedigree?: InputMaybe<Scalars['String']['input']>;
  dogsTemper?: InputMaybe<Scalars['String']['input']>;
  emailAutomationStage?: InputMaybe<Scalars['Int']['input']>;
  emailHistory?: InputMaybe<EmailHistoryUncheckedCreateNestedManyWithoutBreederInput>;
  facebookUrl?: InputMaybe<Scalars['String']['input']>;
  failedMedicalTestsProtocol?: InputMaybe<Scalars['String']['input']>;
  hasFinishedOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  hasStartedOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  hkFile?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  identityFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  imgs?: InputMaybe<DogBreederImgUncheckedCreateNestedManyWithoutDogBreederInput>;
  lastAutomationEmailSentAt?: InputMaybe<Scalars['DateTime']['input']>;
  level?: InputMaybe<Scalars['String']['input']>;
  littersByFemale?: InputMaybe<Scalars['String']['input']>;
  littersByFemaleCount?: InputMaybe<Scalars['Int']['input']>;
  maleBreedersCount?: InputMaybe<Scalars['Int']['input']>;
  medicalTestsPerformed?: InputMaybe<Scalars['String']['input']>;
  motherRestBetweenLitters?: InputMaybe<Scalars['String']['input']>;
  notifications?: InputMaybe<NotificationUncheckedCreateNestedManyWithoutBreederInput>;
  permissionFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  puppies?: InputMaybe<DogPuppyUncheckedCreateNestedManyWithoutBreederInput>;
  puppiesBirthPlace?: InputMaybe<Scalars['String']['input']>;
  reviews?: InputMaybe<DogBreederReviewUncheckedCreateNestedManyWithoutDogBreederInput>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  studInfos?: InputMaybe<StudInfoUncheckedCreateNestedManyWithoutBreederInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  translations?: InputMaybe<DogBreederTranslationUncheckedCreateNestedManyWithoutDogBreederInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updates?: InputMaybe<UpdateUncheckedCreateNestedManyWithoutBreederInput>;
  vatNumber?: InputMaybe<Scalars['String']['input']>;
  veterinaryInfo?: InputMaybe<Scalars['String']['input']>;
  videoUrl?: InputMaybe<Scalars['String']['input']>;
  visitedByTipaw?: InputMaybe<Scalars['Boolean']['input']>;
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
  whatsappNumber?: InputMaybe<Scalars['String']['input']>;
};

export type DogBreederUncheckedCreateWithoutNotificationsInput = {
  adminNote?: InputMaybe<Scalars['String']['input']>;
  agreementNumber?: InputMaybe<Scalars['String']['input']>;
  applications?: InputMaybe<DogBreederApplicationUncheckedCreateNestedManyWithoutDogBreederInput>;
  breedClubFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  breedClubValidated?: InputMaybe<Scalars['Boolean']['input']>;
  breederBreeds?: InputMaybe<DogBreederBreedsUncheckedCreateNestedManyWithoutDogBreederInput>;
  breedingName?: InputMaybe<Scalars['String']['input']>;
  certificationFile?: InputMaybe<Scalars['String']['input']>;
  certified?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  displayEmail?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  displayPhone?: InputMaybe<Scalars['String']['input']>;
  dogInfos?: InputMaybe<DogInfoUncheckedCreateNestedManyWithoutBreederInput>;
  dogsConsanguinity?: InputMaybe<Scalars['String']['input']>;
  dogsPedigree?: InputMaybe<Scalars['String']['input']>;
  dogsTemper?: InputMaybe<Scalars['String']['input']>;
  emailAutomationStage?: InputMaybe<Scalars['Int']['input']>;
  emailHistory?: InputMaybe<EmailHistoryUncheckedCreateNestedManyWithoutBreederInput>;
  facebookUrl?: InputMaybe<Scalars['String']['input']>;
  failedMedicalTestsProtocol?: InputMaybe<Scalars['String']['input']>;
  hasFinishedOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  hasStartedOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  hkFile?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  identityFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  imgs?: InputMaybe<DogBreederImgUncheckedCreateNestedManyWithoutDogBreederInput>;
  lastAutomationEmailSentAt?: InputMaybe<Scalars['DateTime']['input']>;
  level?: InputMaybe<Scalars['String']['input']>;
  litters?: InputMaybe<LitterUncheckedCreateNestedManyWithoutBreederInput>;
  littersByFemale?: InputMaybe<Scalars['String']['input']>;
  littersByFemaleCount?: InputMaybe<Scalars['Int']['input']>;
  maleBreedersCount?: InputMaybe<Scalars['Int']['input']>;
  medicalTestsPerformed?: InputMaybe<Scalars['String']['input']>;
  motherRestBetweenLitters?: InputMaybe<Scalars['String']['input']>;
  permissionFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  puppies?: InputMaybe<DogPuppyUncheckedCreateNestedManyWithoutBreederInput>;
  puppiesBirthPlace?: InputMaybe<Scalars['String']['input']>;
  reviews?: InputMaybe<DogBreederReviewUncheckedCreateNestedManyWithoutDogBreederInput>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  studInfos?: InputMaybe<StudInfoUncheckedCreateNestedManyWithoutBreederInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  translations?: InputMaybe<DogBreederTranslationUncheckedCreateNestedManyWithoutDogBreederInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updates?: InputMaybe<UpdateUncheckedCreateNestedManyWithoutBreederInput>;
  vatNumber?: InputMaybe<Scalars['String']['input']>;
  veterinaryInfo?: InputMaybe<Scalars['String']['input']>;
  videoUrl?: InputMaybe<Scalars['String']['input']>;
  visitedByTipaw?: InputMaybe<Scalars['Boolean']['input']>;
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
  whatsappNumber?: InputMaybe<Scalars['String']['input']>;
};

export type DogBreederUncheckedCreateWithoutPuppiesInput = {
  adminNote?: InputMaybe<Scalars['String']['input']>;
  agreementNumber?: InputMaybe<Scalars['String']['input']>;
  applications?: InputMaybe<DogBreederApplicationUncheckedCreateNestedManyWithoutDogBreederInput>;
  breedClubFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  breedClubValidated?: InputMaybe<Scalars['Boolean']['input']>;
  breederBreeds?: InputMaybe<DogBreederBreedsUncheckedCreateNestedManyWithoutDogBreederInput>;
  breedingName?: InputMaybe<Scalars['String']['input']>;
  certificationFile?: InputMaybe<Scalars['String']['input']>;
  certified?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  displayEmail?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  displayPhone?: InputMaybe<Scalars['String']['input']>;
  dogInfos?: InputMaybe<DogInfoUncheckedCreateNestedManyWithoutBreederInput>;
  dogsConsanguinity?: InputMaybe<Scalars['String']['input']>;
  dogsPedigree?: InputMaybe<Scalars['String']['input']>;
  dogsTemper?: InputMaybe<Scalars['String']['input']>;
  emailAutomationStage?: InputMaybe<Scalars['Int']['input']>;
  emailHistory?: InputMaybe<EmailHistoryUncheckedCreateNestedManyWithoutBreederInput>;
  facebookUrl?: InputMaybe<Scalars['String']['input']>;
  failedMedicalTestsProtocol?: InputMaybe<Scalars['String']['input']>;
  hasFinishedOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  hasStartedOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  hkFile?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  identityFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  imgs?: InputMaybe<DogBreederImgUncheckedCreateNestedManyWithoutDogBreederInput>;
  lastAutomationEmailSentAt?: InputMaybe<Scalars['DateTime']['input']>;
  level?: InputMaybe<Scalars['String']['input']>;
  litters?: InputMaybe<LitterUncheckedCreateNestedManyWithoutBreederInput>;
  littersByFemale?: InputMaybe<Scalars['String']['input']>;
  littersByFemaleCount?: InputMaybe<Scalars['Int']['input']>;
  maleBreedersCount?: InputMaybe<Scalars['Int']['input']>;
  medicalTestsPerformed?: InputMaybe<Scalars['String']['input']>;
  motherRestBetweenLitters?: InputMaybe<Scalars['String']['input']>;
  notifications?: InputMaybe<NotificationUncheckedCreateNestedManyWithoutBreederInput>;
  permissionFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  puppiesBirthPlace?: InputMaybe<Scalars['String']['input']>;
  reviews?: InputMaybe<DogBreederReviewUncheckedCreateNestedManyWithoutDogBreederInput>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  studInfos?: InputMaybe<StudInfoUncheckedCreateNestedManyWithoutBreederInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  translations?: InputMaybe<DogBreederTranslationUncheckedCreateNestedManyWithoutDogBreederInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updates?: InputMaybe<UpdateUncheckedCreateNestedManyWithoutBreederInput>;
  vatNumber?: InputMaybe<Scalars['String']['input']>;
  veterinaryInfo?: InputMaybe<Scalars['String']['input']>;
  videoUrl?: InputMaybe<Scalars['String']['input']>;
  visitedByTipaw?: InputMaybe<Scalars['Boolean']['input']>;
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
  whatsappNumber?: InputMaybe<Scalars['String']['input']>;
};

export type DogBreederUncheckedCreateWithoutReviewsInput = {
  adminNote?: InputMaybe<Scalars['String']['input']>;
  agreementNumber?: InputMaybe<Scalars['String']['input']>;
  applications?: InputMaybe<DogBreederApplicationUncheckedCreateNestedManyWithoutDogBreederInput>;
  breedClubFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  breedClubValidated?: InputMaybe<Scalars['Boolean']['input']>;
  breederBreeds?: InputMaybe<DogBreederBreedsUncheckedCreateNestedManyWithoutDogBreederInput>;
  breedingName?: InputMaybe<Scalars['String']['input']>;
  certificationFile?: InputMaybe<Scalars['String']['input']>;
  certified?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  displayEmail?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  displayPhone?: InputMaybe<Scalars['String']['input']>;
  dogInfos?: InputMaybe<DogInfoUncheckedCreateNestedManyWithoutBreederInput>;
  dogsConsanguinity?: InputMaybe<Scalars['String']['input']>;
  dogsPedigree?: InputMaybe<Scalars['String']['input']>;
  dogsTemper?: InputMaybe<Scalars['String']['input']>;
  emailAutomationStage?: InputMaybe<Scalars['Int']['input']>;
  emailHistory?: InputMaybe<EmailHistoryUncheckedCreateNestedManyWithoutBreederInput>;
  facebookUrl?: InputMaybe<Scalars['String']['input']>;
  failedMedicalTestsProtocol?: InputMaybe<Scalars['String']['input']>;
  hasFinishedOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  hasStartedOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  hkFile?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  identityFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  imgs?: InputMaybe<DogBreederImgUncheckedCreateNestedManyWithoutDogBreederInput>;
  lastAutomationEmailSentAt?: InputMaybe<Scalars['DateTime']['input']>;
  level?: InputMaybe<Scalars['String']['input']>;
  litters?: InputMaybe<LitterUncheckedCreateNestedManyWithoutBreederInput>;
  littersByFemale?: InputMaybe<Scalars['String']['input']>;
  littersByFemaleCount?: InputMaybe<Scalars['Int']['input']>;
  maleBreedersCount?: InputMaybe<Scalars['Int']['input']>;
  medicalTestsPerformed?: InputMaybe<Scalars['String']['input']>;
  motherRestBetweenLitters?: InputMaybe<Scalars['String']['input']>;
  notifications?: InputMaybe<NotificationUncheckedCreateNestedManyWithoutBreederInput>;
  permissionFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  puppies?: InputMaybe<DogPuppyUncheckedCreateNestedManyWithoutBreederInput>;
  puppiesBirthPlace?: InputMaybe<Scalars['String']['input']>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  studInfos?: InputMaybe<StudInfoUncheckedCreateNestedManyWithoutBreederInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  translations?: InputMaybe<DogBreederTranslationUncheckedCreateNestedManyWithoutDogBreederInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updates?: InputMaybe<UpdateUncheckedCreateNestedManyWithoutBreederInput>;
  vatNumber?: InputMaybe<Scalars['String']['input']>;
  veterinaryInfo?: InputMaybe<Scalars['String']['input']>;
  videoUrl?: InputMaybe<Scalars['String']['input']>;
  visitedByTipaw?: InputMaybe<Scalars['Boolean']['input']>;
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
  whatsappNumber?: InputMaybe<Scalars['String']['input']>;
};

export type DogBreederUncheckedCreateWithoutStudInfosInput = {
  adminNote?: InputMaybe<Scalars['String']['input']>;
  agreementNumber?: InputMaybe<Scalars['String']['input']>;
  applications?: InputMaybe<DogBreederApplicationUncheckedCreateNestedManyWithoutDogBreederInput>;
  breedClubFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  breedClubValidated?: InputMaybe<Scalars['Boolean']['input']>;
  breederBreeds?: InputMaybe<DogBreederBreedsUncheckedCreateNestedManyWithoutDogBreederInput>;
  breedingName?: InputMaybe<Scalars['String']['input']>;
  certificationFile?: InputMaybe<Scalars['String']['input']>;
  certified?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  displayEmail?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  displayPhone?: InputMaybe<Scalars['String']['input']>;
  dogInfos?: InputMaybe<DogInfoUncheckedCreateNestedManyWithoutBreederInput>;
  dogsConsanguinity?: InputMaybe<Scalars['String']['input']>;
  dogsPedigree?: InputMaybe<Scalars['String']['input']>;
  dogsTemper?: InputMaybe<Scalars['String']['input']>;
  emailAutomationStage?: InputMaybe<Scalars['Int']['input']>;
  emailHistory?: InputMaybe<EmailHistoryUncheckedCreateNestedManyWithoutBreederInput>;
  facebookUrl?: InputMaybe<Scalars['String']['input']>;
  failedMedicalTestsProtocol?: InputMaybe<Scalars['String']['input']>;
  hasFinishedOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  hasStartedOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  hkFile?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  identityFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  imgs?: InputMaybe<DogBreederImgUncheckedCreateNestedManyWithoutDogBreederInput>;
  lastAutomationEmailSentAt?: InputMaybe<Scalars['DateTime']['input']>;
  level?: InputMaybe<Scalars['String']['input']>;
  litters?: InputMaybe<LitterUncheckedCreateNestedManyWithoutBreederInput>;
  littersByFemale?: InputMaybe<Scalars['String']['input']>;
  littersByFemaleCount?: InputMaybe<Scalars['Int']['input']>;
  maleBreedersCount?: InputMaybe<Scalars['Int']['input']>;
  medicalTestsPerformed?: InputMaybe<Scalars['String']['input']>;
  motherRestBetweenLitters?: InputMaybe<Scalars['String']['input']>;
  notifications?: InputMaybe<NotificationUncheckedCreateNestedManyWithoutBreederInput>;
  permissionFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  puppies?: InputMaybe<DogPuppyUncheckedCreateNestedManyWithoutBreederInput>;
  puppiesBirthPlace?: InputMaybe<Scalars['String']['input']>;
  reviews?: InputMaybe<DogBreederReviewUncheckedCreateNestedManyWithoutDogBreederInput>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  translations?: InputMaybe<DogBreederTranslationUncheckedCreateNestedManyWithoutDogBreederInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updates?: InputMaybe<UpdateUncheckedCreateNestedManyWithoutBreederInput>;
  vatNumber?: InputMaybe<Scalars['String']['input']>;
  veterinaryInfo?: InputMaybe<Scalars['String']['input']>;
  videoUrl?: InputMaybe<Scalars['String']['input']>;
  visitedByTipaw?: InputMaybe<Scalars['Boolean']['input']>;
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
  whatsappNumber?: InputMaybe<Scalars['String']['input']>;
};

export type DogBreederUncheckedCreateWithoutTranslationsInput = {
  adminNote?: InputMaybe<Scalars['String']['input']>;
  agreementNumber?: InputMaybe<Scalars['String']['input']>;
  applications?: InputMaybe<DogBreederApplicationUncheckedCreateNestedManyWithoutDogBreederInput>;
  breedClubFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  breedClubValidated?: InputMaybe<Scalars['Boolean']['input']>;
  breederBreeds?: InputMaybe<DogBreederBreedsUncheckedCreateNestedManyWithoutDogBreederInput>;
  breedingName?: InputMaybe<Scalars['String']['input']>;
  certificationFile?: InputMaybe<Scalars['String']['input']>;
  certified?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  displayEmail?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  displayPhone?: InputMaybe<Scalars['String']['input']>;
  dogInfos?: InputMaybe<DogInfoUncheckedCreateNestedManyWithoutBreederInput>;
  dogsConsanguinity?: InputMaybe<Scalars['String']['input']>;
  dogsPedigree?: InputMaybe<Scalars['String']['input']>;
  dogsTemper?: InputMaybe<Scalars['String']['input']>;
  emailAutomationStage?: InputMaybe<Scalars['Int']['input']>;
  emailHistory?: InputMaybe<EmailHistoryUncheckedCreateNestedManyWithoutBreederInput>;
  facebookUrl?: InputMaybe<Scalars['String']['input']>;
  failedMedicalTestsProtocol?: InputMaybe<Scalars['String']['input']>;
  hasFinishedOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  hasStartedOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  hkFile?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  identityFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  imgs?: InputMaybe<DogBreederImgUncheckedCreateNestedManyWithoutDogBreederInput>;
  lastAutomationEmailSentAt?: InputMaybe<Scalars['DateTime']['input']>;
  level?: InputMaybe<Scalars['String']['input']>;
  litters?: InputMaybe<LitterUncheckedCreateNestedManyWithoutBreederInput>;
  littersByFemale?: InputMaybe<Scalars['String']['input']>;
  littersByFemaleCount?: InputMaybe<Scalars['Int']['input']>;
  maleBreedersCount?: InputMaybe<Scalars['Int']['input']>;
  medicalTestsPerformed?: InputMaybe<Scalars['String']['input']>;
  motherRestBetweenLitters?: InputMaybe<Scalars['String']['input']>;
  notifications?: InputMaybe<NotificationUncheckedCreateNestedManyWithoutBreederInput>;
  permissionFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  puppies?: InputMaybe<DogPuppyUncheckedCreateNestedManyWithoutBreederInput>;
  puppiesBirthPlace?: InputMaybe<Scalars['String']['input']>;
  reviews?: InputMaybe<DogBreederReviewUncheckedCreateNestedManyWithoutDogBreederInput>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  studInfos?: InputMaybe<StudInfoUncheckedCreateNestedManyWithoutBreederInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updates?: InputMaybe<UpdateUncheckedCreateNestedManyWithoutBreederInput>;
  vatNumber?: InputMaybe<Scalars['String']['input']>;
  veterinaryInfo?: InputMaybe<Scalars['String']['input']>;
  videoUrl?: InputMaybe<Scalars['String']['input']>;
  visitedByTipaw?: InputMaybe<Scalars['Boolean']['input']>;
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
  whatsappNumber?: InputMaybe<Scalars['String']['input']>;
};

export type DogBreederUncheckedCreateWithoutUpdatesInput = {
  adminNote?: InputMaybe<Scalars['String']['input']>;
  agreementNumber?: InputMaybe<Scalars['String']['input']>;
  applications?: InputMaybe<DogBreederApplicationUncheckedCreateNestedManyWithoutDogBreederInput>;
  breedClubFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  breedClubValidated?: InputMaybe<Scalars['Boolean']['input']>;
  breederBreeds?: InputMaybe<DogBreederBreedsUncheckedCreateNestedManyWithoutDogBreederInput>;
  breedingName?: InputMaybe<Scalars['String']['input']>;
  certificationFile?: InputMaybe<Scalars['String']['input']>;
  certified?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  displayEmail?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  displayPhone?: InputMaybe<Scalars['String']['input']>;
  dogInfos?: InputMaybe<DogInfoUncheckedCreateNestedManyWithoutBreederInput>;
  dogsConsanguinity?: InputMaybe<Scalars['String']['input']>;
  dogsPedigree?: InputMaybe<Scalars['String']['input']>;
  dogsTemper?: InputMaybe<Scalars['String']['input']>;
  emailAutomationStage?: InputMaybe<Scalars['Int']['input']>;
  emailHistory?: InputMaybe<EmailHistoryUncheckedCreateNestedManyWithoutBreederInput>;
  facebookUrl?: InputMaybe<Scalars['String']['input']>;
  failedMedicalTestsProtocol?: InputMaybe<Scalars['String']['input']>;
  hasFinishedOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  hasStartedOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  hkFile?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  identityFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  imgs?: InputMaybe<DogBreederImgUncheckedCreateNestedManyWithoutDogBreederInput>;
  lastAutomationEmailSentAt?: InputMaybe<Scalars['DateTime']['input']>;
  level?: InputMaybe<Scalars['String']['input']>;
  litters?: InputMaybe<LitterUncheckedCreateNestedManyWithoutBreederInput>;
  littersByFemale?: InputMaybe<Scalars['String']['input']>;
  littersByFemaleCount?: InputMaybe<Scalars['Int']['input']>;
  maleBreedersCount?: InputMaybe<Scalars['Int']['input']>;
  medicalTestsPerformed?: InputMaybe<Scalars['String']['input']>;
  motherRestBetweenLitters?: InputMaybe<Scalars['String']['input']>;
  notifications?: InputMaybe<NotificationUncheckedCreateNestedManyWithoutBreederInput>;
  permissionFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  puppies?: InputMaybe<DogPuppyUncheckedCreateNestedManyWithoutBreederInput>;
  puppiesBirthPlace?: InputMaybe<Scalars['String']['input']>;
  reviews?: InputMaybe<DogBreederReviewUncheckedCreateNestedManyWithoutDogBreederInput>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  studInfos?: InputMaybe<StudInfoUncheckedCreateNestedManyWithoutBreederInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  translations?: InputMaybe<DogBreederTranslationUncheckedCreateNestedManyWithoutDogBreederInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  vatNumber?: InputMaybe<Scalars['String']['input']>;
  veterinaryInfo?: InputMaybe<Scalars['String']['input']>;
  videoUrl?: InputMaybe<Scalars['String']['input']>;
  visitedByTipaw?: InputMaybe<Scalars['Boolean']['input']>;
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
  whatsappNumber?: InputMaybe<Scalars['String']['input']>;
};

export type DogBreederUncheckedUpdateInput = {
  adminNote?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  agreementNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  applications?: InputMaybe<DogBreederApplicationUncheckedUpdateManyWithoutDogBreederNestedInput>;
  breedClubFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  breedClubValidated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  breederBreeds?: InputMaybe<DogBreederBreedsUncheckedUpdateManyWithoutDogBreederNestedInput>;
  breedingName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  certificationFile?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  certified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  displayEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  displayName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  displayPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dogInfos?: InputMaybe<DogInfoUncheckedUpdateManyWithoutBreederNestedInput>;
  dogsConsanguinity?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dogsPedigree?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dogsTemper?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailAutomationStage?: InputMaybe<IntFieldUpdateOperationsInput>;
  emailHistory?: InputMaybe<EmailHistoryUncheckedUpdateManyWithoutBreederNestedInput>;
  facebookUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  failedMedicalTestsProtocol?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hasFinishedOnboarding?: InputMaybe<BoolFieldUpdateOperationsInput>;
  hasStartedOnboarding?: InputMaybe<BoolFieldUpdateOperationsInput>;
  hkFile?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  identityFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  imgs?: InputMaybe<DogBreederImgUncheckedUpdateManyWithoutDogBreederNestedInput>;
  lastAutomationEmailSentAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  level?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  litters?: InputMaybe<LitterUncheckedUpdateManyWithoutBreederNestedInput>;
  littersByFemale?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  littersByFemaleCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  maleBreedersCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  medicalTestsPerformed?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  motherRestBetweenLitters?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUncheckedUpdateManyWithoutBreederNestedInput>;
  permissionFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  public?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  puppies?: InputMaybe<DogPuppyUncheckedUpdateManyWithoutBreederNestedInput>;
  puppiesBirthPlace?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  reviews?: InputMaybe<DogBreederReviewUncheckedUpdateManyWithoutDogBreederNestedInput>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  studInfos?: InputMaybe<StudInfoUncheckedUpdateManyWithoutBreederNestedInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  translations?: InputMaybe<DogBreederTranslationUncheckedUpdateManyWithoutDogBreederNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updates?: InputMaybe<UpdateUncheckedUpdateManyWithoutBreederNestedInput>;
  vatNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  veterinaryInfo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  videoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  visitedByTipaw?: InputMaybe<BoolFieldUpdateOperationsInput>;
  websiteUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whatsappNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type DogBreederUncheckedUpdateManyInput = {
  adminNote?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  agreementNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  breedClubFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  breedClubValidated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  breedingName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  certificationFile?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  certified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  displayEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  displayName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  displayPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dogsConsanguinity?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dogsPedigree?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dogsTemper?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailAutomationStage?: InputMaybe<IntFieldUpdateOperationsInput>;
  facebookUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  failedMedicalTestsProtocol?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hasFinishedOnboarding?: InputMaybe<BoolFieldUpdateOperationsInput>;
  hasStartedOnboarding?: InputMaybe<BoolFieldUpdateOperationsInput>;
  hkFile?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  identityFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  lastAutomationEmailSentAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  level?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  littersByFemale?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  littersByFemaleCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  maleBreedersCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  medicalTestsPerformed?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  motherRestBetweenLitters?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  permissionFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  public?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  puppiesBirthPlace?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  vatNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  veterinaryInfo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  videoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  visitedByTipaw?: InputMaybe<BoolFieldUpdateOperationsInput>;
  websiteUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whatsappNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type DogBreederUncheckedUpdateOneWithoutAccountNestedInput = {
  connect?: InputMaybe<DogBreederWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DogBreederCreateOrConnectWithoutAccountInput>;
  create?: InputMaybe<DogBreederCreateWithoutAccountInput>;
  delete?: InputMaybe<DogBreederWhereInput>;
  disconnect?: InputMaybe<DogBreederWhereInput>;
  update?: InputMaybe<DogBreederUpdateToOneWithWhereWithoutAccountInput>;
  upsert?: InputMaybe<DogBreederUpsertWithoutAccountInput>;
};

export type DogBreederUncheckedUpdateWithoutAccountInput = {
  adminNote?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  agreementNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  applications?: InputMaybe<DogBreederApplicationUncheckedUpdateManyWithoutDogBreederNestedInput>;
  breedClubFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  breedClubValidated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  breederBreeds?: InputMaybe<DogBreederBreedsUncheckedUpdateManyWithoutDogBreederNestedInput>;
  breedingName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  certificationFile?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  certified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  displayEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  displayName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  displayPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dogInfos?: InputMaybe<DogInfoUncheckedUpdateManyWithoutBreederNestedInput>;
  dogsConsanguinity?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dogsPedigree?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dogsTemper?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailAutomationStage?: InputMaybe<IntFieldUpdateOperationsInput>;
  emailHistory?: InputMaybe<EmailHistoryUncheckedUpdateManyWithoutBreederNestedInput>;
  facebookUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  failedMedicalTestsProtocol?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hasFinishedOnboarding?: InputMaybe<BoolFieldUpdateOperationsInput>;
  hasStartedOnboarding?: InputMaybe<BoolFieldUpdateOperationsInput>;
  hkFile?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  identityFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  imgs?: InputMaybe<DogBreederImgUncheckedUpdateManyWithoutDogBreederNestedInput>;
  lastAutomationEmailSentAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  level?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  litters?: InputMaybe<LitterUncheckedUpdateManyWithoutBreederNestedInput>;
  littersByFemale?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  littersByFemaleCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  maleBreedersCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  medicalTestsPerformed?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  motherRestBetweenLitters?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUncheckedUpdateManyWithoutBreederNestedInput>;
  permissionFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  public?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  puppies?: InputMaybe<DogPuppyUncheckedUpdateManyWithoutBreederNestedInput>;
  puppiesBirthPlace?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  reviews?: InputMaybe<DogBreederReviewUncheckedUpdateManyWithoutDogBreederNestedInput>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  studInfos?: InputMaybe<StudInfoUncheckedUpdateManyWithoutBreederNestedInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  translations?: InputMaybe<DogBreederTranslationUncheckedUpdateManyWithoutDogBreederNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updates?: InputMaybe<UpdateUncheckedUpdateManyWithoutBreederNestedInput>;
  vatNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  veterinaryInfo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  videoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  visitedByTipaw?: InputMaybe<BoolFieldUpdateOperationsInput>;
  websiteUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whatsappNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type DogBreederUncheckedUpdateWithoutApplicationsInput = {
  adminNote?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  agreementNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  breedClubFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  breedClubValidated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  breederBreeds?: InputMaybe<DogBreederBreedsUncheckedUpdateManyWithoutDogBreederNestedInput>;
  breedingName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  certificationFile?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  certified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  displayEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  displayName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  displayPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dogInfos?: InputMaybe<DogInfoUncheckedUpdateManyWithoutBreederNestedInput>;
  dogsConsanguinity?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dogsPedigree?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dogsTemper?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailAutomationStage?: InputMaybe<IntFieldUpdateOperationsInput>;
  emailHistory?: InputMaybe<EmailHistoryUncheckedUpdateManyWithoutBreederNestedInput>;
  facebookUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  failedMedicalTestsProtocol?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hasFinishedOnboarding?: InputMaybe<BoolFieldUpdateOperationsInput>;
  hasStartedOnboarding?: InputMaybe<BoolFieldUpdateOperationsInput>;
  hkFile?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  identityFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  imgs?: InputMaybe<DogBreederImgUncheckedUpdateManyWithoutDogBreederNestedInput>;
  lastAutomationEmailSentAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  level?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  litters?: InputMaybe<LitterUncheckedUpdateManyWithoutBreederNestedInput>;
  littersByFemale?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  littersByFemaleCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  maleBreedersCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  medicalTestsPerformed?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  motherRestBetweenLitters?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUncheckedUpdateManyWithoutBreederNestedInput>;
  permissionFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  public?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  puppies?: InputMaybe<DogPuppyUncheckedUpdateManyWithoutBreederNestedInput>;
  puppiesBirthPlace?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  reviews?: InputMaybe<DogBreederReviewUncheckedUpdateManyWithoutDogBreederNestedInput>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  studInfos?: InputMaybe<StudInfoUncheckedUpdateManyWithoutBreederNestedInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  translations?: InputMaybe<DogBreederTranslationUncheckedUpdateManyWithoutDogBreederNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updates?: InputMaybe<UpdateUncheckedUpdateManyWithoutBreederNestedInput>;
  vatNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  veterinaryInfo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  videoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  visitedByTipaw?: InputMaybe<BoolFieldUpdateOperationsInput>;
  websiteUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whatsappNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type DogBreederUncheckedUpdateWithoutBreederBreedsInput = {
  adminNote?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  agreementNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  applications?: InputMaybe<DogBreederApplicationUncheckedUpdateManyWithoutDogBreederNestedInput>;
  breedClubFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  breedClubValidated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  breedingName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  certificationFile?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  certified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  displayEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  displayName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  displayPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dogInfos?: InputMaybe<DogInfoUncheckedUpdateManyWithoutBreederNestedInput>;
  dogsConsanguinity?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dogsPedigree?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dogsTemper?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailAutomationStage?: InputMaybe<IntFieldUpdateOperationsInput>;
  emailHistory?: InputMaybe<EmailHistoryUncheckedUpdateManyWithoutBreederNestedInput>;
  facebookUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  failedMedicalTestsProtocol?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hasFinishedOnboarding?: InputMaybe<BoolFieldUpdateOperationsInput>;
  hasStartedOnboarding?: InputMaybe<BoolFieldUpdateOperationsInput>;
  hkFile?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  identityFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  imgs?: InputMaybe<DogBreederImgUncheckedUpdateManyWithoutDogBreederNestedInput>;
  lastAutomationEmailSentAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  level?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  litters?: InputMaybe<LitterUncheckedUpdateManyWithoutBreederNestedInput>;
  littersByFemale?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  littersByFemaleCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  maleBreedersCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  medicalTestsPerformed?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  motherRestBetweenLitters?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUncheckedUpdateManyWithoutBreederNestedInput>;
  permissionFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  public?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  puppies?: InputMaybe<DogPuppyUncheckedUpdateManyWithoutBreederNestedInput>;
  puppiesBirthPlace?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  reviews?: InputMaybe<DogBreederReviewUncheckedUpdateManyWithoutDogBreederNestedInput>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  studInfos?: InputMaybe<StudInfoUncheckedUpdateManyWithoutBreederNestedInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  translations?: InputMaybe<DogBreederTranslationUncheckedUpdateManyWithoutDogBreederNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updates?: InputMaybe<UpdateUncheckedUpdateManyWithoutBreederNestedInput>;
  vatNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  veterinaryInfo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  videoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  visitedByTipaw?: InputMaybe<BoolFieldUpdateOperationsInput>;
  websiteUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whatsappNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type DogBreederUncheckedUpdateWithoutDogInfosInput = {
  adminNote?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  agreementNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  applications?: InputMaybe<DogBreederApplicationUncheckedUpdateManyWithoutDogBreederNestedInput>;
  breedClubFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  breedClubValidated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  breederBreeds?: InputMaybe<DogBreederBreedsUncheckedUpdateManyWithoutDogBreederNestedInput>;
  breedingName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  certificationFile?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  certified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  displayEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  displayName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  displayPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dogsConsanguinity?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dogsPedigree?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dogsTemper?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailAutomationStage?: InputMaybe<IntFieldUpdateOperationsInput>;
  emailHistory?: InputMaybe<EmailHistoryUncheckedUpdateManyWithoutBreederNestedInput>;
  facebookUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  failedMedicalTestsProtocol?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hasFinishedOnboarding?: InputMaybe<BoolFieldUpdateOperationsInput>;
  hasStartedOnboarding?: InputMaybe<BoolFieldUpdateOperationsInput>;
  hkFile?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  identityFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  imgs?: InputMaybe<DogBreederImgUncheckedUpdateManyWithoutDogBreederNestedInput>;
  lastAutomationEmailSentAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  level?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  litters?: InputMaybe<LitterUncheckedUpdateManyWithoutBreederNestedInput>;
  littersByFemale?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  littersByFemaleCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  maleBreedersCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  medicalTestsPerformed?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  motherRestBetweenLitters?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUncheckedUpdateManyWithoutBreederNestedInput>;
  permissionFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  public?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  puppies?: InputMaybe<DogPuppyUncheckedUpdateManyWithoutBreederNestedInput>;
  puppiesBirthPlace?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  reviews?: InputMaybe<DogBreederReviewUncheckedUpdateManyWithoutDogBreederNestedInput>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  studInfos?: InputMaybe<StudInfoUncheckedUpdateManyWithoutBreederNestedInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  translations?: InputMaybe<DogBreederTranslationUncheckedUpdateManyWithoutDogBreederNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updates?: InputMaybe<UpdateUncheckedUpdateManyWithoutBreederNestedInput>;
  vatNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  veterinaryInfo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  videoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  visitedByTipaw?: InputMaybe<BoolFieldUpdateOperationsInput>;
  websiteUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whatsappNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type DogBreederUncheckedUpdateWithoutEmailHistoryInput = {
  adminNote?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  agreementNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  applications?: InputMaybe<DogBreederApplicationUncheckedUpdateManyWithoutDogBreederNestedInput>;
  breedClubFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  breedClubValidated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  breederBreeds?: InputMaybe<DogBreederBreedsUncheckedUpdateManyWithoutDogBreederNestedInput>;
  breedingName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  certificationFile?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  certified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  displayEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  displayName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  displayPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dogInfos?: InputMaybe<DogInfoUncheckedUpdateManyWithoutBreederNestedInput>;
  dogsConsanguinity?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dogsPedigree?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dogsTemper?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailAutomationStage?: InputMaybe<IntFieldUpdateOperationsInput>;
  facebookUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  failedMedicalTestsProtocol?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hasFinishedOnboarding?: InputMaybe<BoolFieldUpdateOperationsInput>;
  hasStartedOnboarding?: InputMaybe<BoolFieldUpdateOperationsInput>;
  hkFile?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  identityFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  imgs?: InputMaybe<DogBreederImgUncheckedUpdateManyWithoutDogBreederNestedInput>;
  lastAutomationEmailSentAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  level?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  litters?: InputMaybe<LitterUncheckedUpdateManyWithoutBreederNestedInput>;
  littersByFemale?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  littersByFemaleCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  maleBreedersCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  medicalTestsPerformed?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  motherRestBetweenLitters?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUncheckedUpdateManyWithoutBreederNestedInput>;
  permissionFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  public?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  puppies?: InputMaybe<DogPuppyUncheckedUpdateManyWithoutBreederNestedInput>;
  puppiesBirthPlace?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  reviews?: InputMaybe<DogBreederReviewUncheckedUpdateManyWithoutDogBreederNestedInput>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  studInfos?: InputMaybe<StudInfoUncheckedUpdateManyWithoutBreederNestedInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  translations?: InputMaybe<DogBreederTranslationUncheckedUpdateManyWithoutDogBreederNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updates?: InputMaybe<UpdateUncheckedUpdateManyWithoutBreederNestedInput>;
  vatNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  veterinaryInfo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  videoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  visitedByTipaw?: InputMaybe<BoolFieldUpdateOperationsInput>;
  websiteUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whatsappNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type DogBreederUncheckedUpdateWithoutImgsInput = {
  adminNote?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  agreementNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  applications?: InputMaybe<DogBreederApplicationUncheckedUpdateManyWithoutDogBreederNestedInput>;
  breedClubFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  breedClubValidated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  breederBreeds?: InputMaybe<DogBreederBreedsUncheckedUpdateManyWithoutDogBreederNestedInput>;
  breedingName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  certificationFile?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  certified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  displayEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  displayName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  displayPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dogInfos?: InputMaybe<DogInfoUncheckedUpdateManyWithoutBreederNestedInput>;
  dogsConsanguinity?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dogsPedigree?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dogsTemper?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailAutomationStage?: InputMaybe<IntFieldUpdateOperationsInput>;
  emailHistory?: InputMaybe<EmailHistoryUncheckedUpdateManyWithoutBreederNestedInput>;
  facebookUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  failedMedicalTestsProtocol?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hasFinishedOnboarding?: InputMaybe<BoolFieldUpdateOperationsInput>;
  hasStartedOnboarding?: InputMaybe<BoolFieldUpdateOperationsInput>;
  hkFile?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  identityFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  lastAutomationEmailSentAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  level?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  litters?: InputMaybe<LitterUncheckedUpdateManyWithoutBreederNestedInput>;
  littersByFemale?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  littersByFemaleCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  maleBreedersCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  medicalTestsPerformed?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  motherRestBetweenLitters?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUncheckedUpdateManyWithoutBreederNestedInput>;
  permissionFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  public?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  puppies?: InputMaybe<DogPuppyUncheckedUpdateManyWithoutBreederNestedInput>;
  puppiesBirthPlace?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  reviews?: InputMaybe<DogBreederReviewUncheckedUpdateManyWithoutDogBreederNestedInput>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  studInfos?: InputMaybe<StudInfoUncheckedUpdateManyWithoutBreederNestedInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  translations?: InputMaybe<DogBreederTranslationUncheckedUpdateManyWithoutDogBreederNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updates?: InputMaybe<UpdateUncheckedUpdateManyWithoutBreederNestedInput>;
  vatNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  veterinaryInfo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  videoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  visitedByTipaw?: InputMaybe<BoolFieldUpdateOperationsInput>;
  websiteUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whatsappNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type DogBreederUncheckedUpdateWithoutLittersInput = {
  adminNote?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  agreementNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  applications?: InputMaybe<DogBreederApplicationUncheckedUpdateManyWithoutDogBreederNestedInput>;
  breedClubFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  breedClubValidated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  breederBreeds?: InputMaybe<DogBreederBreedsUncheckedUpdateManyWithoutDogBreederNestedInput>;
  breedingName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  certificationFile?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  certified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  displayEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  displayName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  displayPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dogInfos?: InputMaybe<DogInfoUncheckedUpdateManyWithoutBreederNestedInput>;
  dogsConsanguinity?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dogsPedigree?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dogsTemper?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailAutomationStage?: InputMaybe<IntFieldUpdateOperationsInput>;
  emailHistory?: InputMaybe<EmailHistoryUncheckedUpdateManyWithoutBreederNestedInput>;
  facebookUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  failedMedicalTestsProtocol?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hasFinishedOnboarding?: InputMaybe<BoolFieldUpdateOperationsInput>;
  hasStartedOnboarding?: InputMaybe<BoolFieldUpdateOperationsInput>;
  hkFile?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  identityFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  imgs?: InputMaybe<DogBreederImgUncheckedUpdateManyWithoutDogBreederNestedInput>;
  lastAutomationEmailSentAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  level?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  littersByFemale?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  littersByFemaleCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  maleBreedersCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  medicalTestsPerformed?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  motherRestBetweenLitters?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUncheckedUpdateManyWithoutBreederNestedInput>;
  permissionFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  public?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  puppies?: InputMaybe<DogPuppyUncheckedUpdateManyWithoutBreederNestedInput>;
  puppiesBirthPlace?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  reviews?: InputMaybe<DogBreederReviewUncheckedUpdateManyWithoutDogBreederNestedInput>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  studInfos?: InputMaybe<StudInfoUncheckedUpdateManyWithoutBreederNestedInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  translations?: InputMaybe<DogBreederTranslationUncheckedUpdateManyWithoutDogBreederNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updates?: InputMaybe<UpdateUncheckedUpdateManyWithoutBreederNestedInput>;
  vatNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  veterinaryInfo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  videoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  visitedByTipaw?: InputMaybe<BoolFieldUpdateOperationsInput>;
  websiteUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whatsappNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type DogBreederUncheckedUpdateWithoutNotificationsInput = {
  adminNote?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  agreementNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  applications?: InputMaybe<DogBreederApplicationUncheckedUpdateManyWithoutDogBreederNestedInput>;
  breedClubFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  breedClubValidated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  breederBreeds?: InputMaybe<DogBreederBreedsUncheckedUpdateManyWithoutDogBreederNestedInput>;
  breedingName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  certificationFile?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  certified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  displayEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  displayName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  displayPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dogInfos?: InputMaybe<DogInfoUncheckedUpdateManyWithoutBreederNestedInput>;
  dogsConsanguinity?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dogsPedigree?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dogsTemper?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailAutomationStage?: InputMaybe<IntFieldUpdateOperationsInput>;
  emailHistory?: InputMaybe<EmailHistoryUncheckedUpdateManyWithoutBreederNestedInput>;
  facebookUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  failedMedicalTestsProtocol?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hasFinishedOnboarding?: InputMaybe<BoolFieldUpdateOperationsInput>;
  hasStartedOnboarding?: InputMaybe<BoolFieldUpdateOperationsInput>;
  hkFile?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  identityFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  imgs?: InputMaybe<DogBreederImgUncheckedUpdateManyWithoutDogBreederNestedInput>;
  lastAutomationEmailSentAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  level?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  litters?: InputMaybe<LitterUncheckedUpdateManyWithoutBreederNestedInput>;
  littersByFemale?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  littersByFemaleCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  maleBreedersCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  medicalTestsPerformed?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  motherRestBetweenLitters?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  permissionFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  public?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  puppies?: InputMaybe<DogPuppyUncheckedUpdateManyWithoutBreederNestedInput>;
  puppiesBirthPlace?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  reviews?: InputMaybe<DogBreederReviewUncheckedUpdateManyWithoutDogBreederNestedInput>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  studInfos?: InputMaybe<StudInfoUncheckedUpdateManyWithoutBreederNestedInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  translations?: InputMaybe<DogBreederTranslationUncheckedUpdateManyWithoutDogBreederNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updates?: InputMaybe<UpdateUncheckedUpdateManyWithoutBreederNestedInput>;
  vatNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  veterinaryInfo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  videoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  visitedByTipaw?: InputMaybe<BoolFieldUpdateOperationsInput>;
  websiteUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whatsappNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type DogBreederUncheckedUpdateWithoutPuppiesInput = {
  adminNote?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  agreementNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  applications?: InputMaybe<DogBreederApplicationUncheckedUpdateManyWithoutDogBreederNestedInput>;
  breedClubFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  breedClubValidated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  breederBreeds?: InputMaybe<DogBreederBreedsUncheckedUpdateManyWithoutDogBreederNestedInput>;
  breedingName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  certificationFile?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  certified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  displayEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  displayName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  displayPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dogInfos?: InputMaybe<DogInfoUncheckedUpdateManyWithoutBreederNestedInput>;
  dogsConsanguinity?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dogsPedigree?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dogsTemper?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailAutomationStage?: InputMaybe<IntFieldUpdateOperationsInput>;
  emailHistory?: InputMaybe<EmailHistoryUncheckedUpdateManyWithoutBreederNestedInput>;
  facebookUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  failedMedicalTestsProtocol?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hasFinishedOnboarding?: InputMaybe<BoolFieldUpdateOperationsInput>;
  hasStartedOnboarding?: InputMaybe<BoolFieldUpdateOperationsInput>;
  hkFile?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  identityFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  imgs?: InputMaybe<DogBreederImgUncheckedUpdateManyWithoutDogBreederNestedInput>;
  lastAutomationEmailSentAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  level?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  litters?: InputMaybe<LitterUncheckedUpdateManyWithoutBreederNestedInput>;
  littersByFemale?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  littersByFemaleCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  maleBreedersCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  medicalTestsPerformed?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  motherRestBetweenLitters?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUncheckedUpdateManyWithoutBreederNestedInput>;
  permissionFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  public?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  puppiesBirthPlace?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  reviews?: InputMaybe<DogBreederReviewUncheckedUpdateManyWithoutDogBreederNestedInput>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  studInfos?: InputMaybe<StudInfoUncheckedUpdateManyWithoutBreederNestedInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  translations?: InputMaybe<DogBreederTranslationUncheckedUpdateManyWithoutDogBreederNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updates?: InputMaybe<UpdateUncheckedUpdateManyWithoutBreederNestedInput>;
  vatNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  veterinaryInfo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  videoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  visitedByTipaw?: InputMaybe<BoolFieldUpdateOperationsInput>;
  websiteUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whatsappNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type DogBreederUncheckedUpdateWithoutReviewsInput = {
  adminNote?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  agreementNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  applications?: InputMaybe<DogBreederApplicationUncheckedUpdateManyWithoutDogBreederNestedInput>;
  breedClubFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  breedClubValidated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  breederBreeds?: InputMaybe<DogBreederBreedsUncheckedUpdateManyWithoutDogBreederNestedInput>;
  breedingName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  certificationFile?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  certified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  displayEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  displayName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  displayPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dogInfos?: InputMaybe<DogInfoUncheckedUpdateManyWithoutBreederNestedInput>;
  dogsConsanguinity?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dogsPedigree?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dogsTemper?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailAutomationStage?: InputMaybe<IntFieldUpdateOperationsInput>;
  emailHistory?: InputMaybe<EmailHistoryUncheckedUpdateManyWithoutBreederNestedInput>;
  facebookUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  failedMedicalTestsProtocol?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hasFinishedOnboarding?: InputMaybe<BoolFieldUpdateOperationsInput>;
  hasStartedOnboarding?: InputMaybe<BoolFieldUpdateOperationsInput>;
  hkFile?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  identityFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  imgs?: InputMaybe<DogBreederImgUncheckedUpdateManyWithoutDogBreederNestedInput>;
  lastAutomationEmailSentAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  level?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  litters?: InputMaybe<LitterUncheckedUpdateManyWithoutBreederNestedInput>;
  littersByFemale?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  littersByFemaleCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  maleBreedersCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  medicalTestsPerformed?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  motherRestBetweenLitters?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUncheckedUpdateManyWithoutBreederNestedInput>;
  permissionFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  public?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  puppies?: InputMaybe<DogPuppyUncheckedUpdateManyWithoutBreederNestedInput>;
  puppiesBirthPlace?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  studInfos?: InputMaybe<StudInfoUncheckedUpdateManyWithoutBreederNestedInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  translations?: InputMaybe<DogBreederTranslationUncheckedUpdateManyWithoutDogBreederNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updates?: InputMaybe<UpdateUncheckedUpdateManyWithoutBreederNestedInput>;
  vatNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  veterinaryInfo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  videoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  visitedByTipaw?: InputMaybe<BoolFieldUpdateOperationsInput>;
  websiteUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whatsappNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type DogBreederUncheckedUpdateWithoutStudInfosInput = {
  adminNote?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  agreementNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  applications?: InputMaybe<DogBreederApplicationUncheckedUpdateManyWithoutDogBreederNestedInput>;
  breedClubFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  breedClubValidated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  breederBreeds?: InputMaybe<DogBreederBreedsUncheckedUpdateManyWithoutDogBreederNestedInput>;
  breedingName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  certificationFile?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  certified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  displayEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  displayName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  displayPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dogInfos?: InputMaybe<DogInfoUncheckedUpdateManyWithoutBreederNestedInput>;
  dogsConsanguinity?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dogsPedigree?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dogsTemper?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailAutomationStage?: InputMaybe<IntFieldUpdateOperationsInput>;
  emailHistory?: InputMaybe<EmailHistoryUncheckedUpdateManyWithoutBreederNestedInput>;
  facebookUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  failedMedicalTestsProtocol?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hasFinishedOnboarding?: InputMaybe<BoolFieldUpdateOperationsInput>;
  hasStartedOnboarding?: InputMaybe<BoolFieldUpdateOperationsInput>;
  hkFile?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  identityFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  imgs?: InputMaybe<DogBreederImgUncheckedUpdateManyWithoutDogBreederNestedInput>;
  lastAutomationEmailSentAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  level?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  litters?: InputMaybe<LitterUncheckedUpdateManyWithoutBreederNestedInput>;
  littersByFemale?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  littersByFemaleCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  maleBreedersCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  medicalTestsPerformed?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  motherRestBetweenLitters?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUncheckedUpdateManyWithoutBreederNestedInput>;
  permissionFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  public?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  puppies?: InputMaybe<DogPuppyUncheckedUpdateManyWithoutBreederNestedInput>;
  puppiesBirthPlace?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  reviews?: InputMaybe<DogBreederReviewUncheckedUpdateManyWithoutDogBreederNestedInput>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  translations?: InputMaybe<DogBreederTranslationUncheckedUpdateManyWithoutDogBreederNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updates?: InputMaybe<UpdateUncheckedUpdateManyWithoutBreederNestedInput>;
  vatNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  veterinaryInfo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  videoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  visitedByTipaw?: InputMaybe<BoolFieldUpdateOperationsInput>;
  websiteUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whatsappNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type DogBreederUncheckedUpdateWithoutTranslationsInput = {
  adminNote?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  agreementNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  applications?: InputMaybe<DogBreederApplicationUncheckedUpdateManyWithoutDogBreederNestedInput>;
  breedClubFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  breedClubValidated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  breederBreeds?: InputMaybe<DogBreederBreedsUncheckedUpdateManyWithoutDogBreederNestedInput>;
  breedingName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  certificationFile?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  certified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  displayEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  displayName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  displayPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dogInfos?: InputMaybe<DogInfoUncheckedUpdateManyWithoutBreederNestedInput>;
  dogsConsanguinity?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dogsPedigree?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dogsTemper?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailAutomationStage?: InputMaybe<IntFieldUpdateOperationsInput>;
  emailHistory?: InputMaybe<EmailHistoryUncheckedUpdateManyWithoutBreederNestedInput>;
  facebookUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  failedMedicalTestsProtocol?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hasFinishedOnboarding?: InputMaybe<BoolFieldUpdateOperationsInput>;
  hasStartedOnboarding?: InputMaybe<BoolFieldUpdateOperationsInput>;
  hkFile?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  identityFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  imgs?: InputMaybe<DogBreederImgUncheckedUpdateManyWithoutDogBreederNestedInput>;
  lastAutomationEmailSentAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  level?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  litters?: InputMaybe<LitterUncheckedUpdateManyWithoutBreederNestedInput>;
  littersByFemale?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  littersByFemaleCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  maleBreedersCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  medicalTestsPerformed?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  motherRestBetweenLitters?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUncheckedUpdateManyWithoutBreederNestedInput>;
  permissionFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  public?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  puppies?: InputMaybe<DogPuppyUncheckedUpdateManyWithoutBreederNestedInput>;
  puppiesBirthPlace?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  reviews?: InputMaybe<DogBreederReviewUncheckedUpdateManyWithoutDogBreederNestedInput>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  studInfos?: InputMaybe<StudInfoUncheckedUpdateManyWithoutBreederNestedInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updates?: InputMaybe<UpdateUncheckedUpdateManyWithoutBreederNestedInput>;
  vatNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  veterinaryInfo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  videoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  visitedByTipaw?: InputMaybe<BoolFieldUpdateOperationsInput>;
  websiteUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whatsappNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type DogBreederUncheckedUpdateWithoutUpdatesInput = {
  adminNote?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  agreementNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  applications?: InputMaybe<DogBreederApplicationUncheckedUpdateManyWithoutDogBreederNestedInput>;
  breedClubFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  breedClubValidated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  breederBreeds?: InputMaybe<DogBreederBreedsUncheckedUpdateManyWithoutDogBreederNestedInput>;
  breedingName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  certificationFile?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  certified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  displayEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  displayName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  displayPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dogInfos?: InputMaybe<DogInfoUncheckedUpdateManyWithoutBreederNestedInput>;
  dogsConsanguinity?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dogsPedigree?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dogsTemper?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailAutomationStage?: InputMaybe<IntFieldUpdateOperationsInput>;
  emailHistory?: InputMaybe<EmailHistoryUncheckedUpdateManyWithoutBreederNestedInput>;
  facebookUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  failedMedicalTestsProtocol?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hasFinishedOnboarding?: InputMaybe<BoolFieldUpdateOperationsInput>;
  hasStartedOnboarding?: InputMaybe<BoolFieldUpdateOperationsInput>;
  hkFile?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  identityFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  imgs?: InputMaybe<DogBreederImgUncheckedUpdateManyWithoutDogBreederNestedInput>;
  lastAutomationEmailSentAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  level?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  litters?: InputMaybe<LitterUncheckedUpdateManyWithoutBreederNestedInput>;
  littersByFemale?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  littersByFemaleCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  maleBreedersCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  medicalTestsPerformed?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  motherRestBetweenLitters?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUncheckedUpdateManyWithoutBreederNestedInput>;
  permissionFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  public?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  puppies?: InputMaybe<DogPuppyUncheckedUpdateManyWithoutBreederNestedInput>;
  puppiesBirthPlace?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  reviews?: InputMaybe<DogBreederReviewUncheckedUpdateManyWithoutDogBreederNestedInput>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  studInfos?: InputMaybe<StudInfoUncheckedUpdateManyWithoutBreederNestedInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  translations?: InputMaybe<DogBreederTranslationUncheckedUpdateManyWithoutDogBreederNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  vatNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  veterinaryInfo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  videoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  visitedByTipaw?: InputMaybe<BoolFieldUpdateOperationsInput>;
  websiteUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whatsappNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type DogBreederUpdateInput = {
  account?: InputMaybe<AccountUpdateOneRequiredWithoutDogBreederNestedInput>;
  adminNote?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  agreementNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  applications?: InputMaybe<DogBreederApplicationUpdateManyWithoutDogBreederNestedInput>;
  breedClubFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  breedClubValidated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  breederBreeds?: InputMaybe<DogBreederBreedsUpdateManyWithoutDogBreederNestedInput>;
  breedingName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  certificationFile?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  certified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  displayEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  displayName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  displayPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dogInfos?: InputMaybe<DogInfoUpdateManyWithoutBreederNestedInput>;
  dogsConsanguinity?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dogsPedigree?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dogsTemper?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailAutomationStage?: InputMaybe<IntFieldUpdateOperationsInput>;
  emailHistory?: InputMaybe<EmailHistoryUpdateManyWithoutBreederNestedInput>;
  facebookUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  failedMedicalTestsProtocol?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hasFinishedOnboarding?: InputMaybe<BoolFieldUpdateOperationsInput>;
  hasStartedOnboarding?: InputMaybe<BoolFieldUpdateOperationsInput>;
  hkFile?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  identityFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  imgs?: InputMaybe<DogBreederImgUpdateManyWithoutDogBreederNestedInput>;
  lastAutomationEmailSentAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  level?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  litters?: InputMaybe<LitterUpdateManyWithoutBreederNestedInput>;
  littersByFemale?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  littersByFemaleCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  maleBreedersCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  medicalTestsPerformed?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  motherRestBetweenLitters?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutBreederNestedInput>;
  permissionFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  public?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  puppies?: InputMaybe<DogPuppyUpdateManyWithoutBreederNestedInput>;
  puppiesBirthPlace?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  reviews?: InputMaybe<DogBreederReviewUpdateManyWithoutDogBreederNestedInput>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  studInfos?: InputMaybe<StudInfoUpdateManyWithoutBreederNestedInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  translations?: InputMaybe<DogBreederTranslationUpdateManyWithoutDogBreederNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updates?: InputMaybe<UpdateUpdateManyWithoutBreederNestedInput>;
  vatNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  veterinaryInfo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  videoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  visitedByTipaw?: InputMaybe<BoolFieldUpdateOperationsInput>;
  websiteUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whatsappNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type DogBreederUpdateManyMutationInput = {
  adminNote?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  agreementNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  breedClubFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  breedClubValidated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  breedingName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  certificationFile?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  certified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  displayEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  displayName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  displayPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dogsConsanguinity?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dogsPedigree?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dogsTemper?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailAutomationStage?: InputMaybe<IntFieldUpdateOperationsInput>;
  facebookUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  failedMedicalTestsProtocol?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hasFinishedOnboarding?: InputMaybe<BoolFieldUpdateOperationsInput>;
  hasStartedOnboarding?: InputMaybe<BoolFieldUpdateOperationsInput>;
  hkFile?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  identityFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  lastAutomationEmailSentAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  level?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  littersByFemale?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  littersByFemaleCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  maleBreedersCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  medicalTestsPerformed?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  motherRestBetweenLitters?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  permissionFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  public?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  puppiesBirthPlace?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  vatNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  veterinaryInfo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  videoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  visitedByTipaw?: InputMaybe<BoolFieldUpdateOperationsInput>;
  websiteUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whatsappNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type DogBreederUpdateOneRequiredWithoutApplicationsNestedInput = {
  connect?: InputMaybe<DogBreederWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DogBreederCreateOrConnectWithoutApplicationsInput>;
  create?: InputMaybe<DogBreederCreateWithoutApplicationsInput>;
  update?: InputMaybe<DogBreederUpdateToOneWithWhereWithoutApplicationsInput>;
  upsert?: InputMaybe<DogBreederUpsertWithoutApplicationsInput>;
};

export type DogBreederUpdateOneRequiredWithoutBreederBreedsNestedInput = {
  connect?: InputMaybe<DogBreederWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DogBreederCreateOrConnectWithoutBreederBreedsInput>;
  create?: InputMaybe<DogBreederCreateWithoutBreederBreedsInput>;
  update?: InputMaybe<DogBreederUpdateToOneWithWhereWithoutBreederBreedsInput>;
  upsert?: InputMaybe<DogBreederUpsertWithoutBreederBreedsInput>;
};

export type DogBreederUpdateOneRequiredWithoutImgsNestedInput = {
  connect?: InputMaybe<DogBreederWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DogBreederCreateOrConnectWithoutImgsInput>;
  create?: InputMaybe<DogBreederCreateWithoutImgsInput>;
  update?: InputMaybe<DogBreederUpdateToOneWithWhereWithoutImgsInput>;
  upsert?: InputMaybe<DogBreederUpsertWithoutImgsInput>;
};

export type DogBreederUpdateOneRequiredWithoutLittersNestedInput = {
  connect?: InputMaybe<DogBreederWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DogBreederCreateOrConnectWithoutLittersInput>;
  create?: InputMaybe<DogBreederCreateWithoutLittersInput>;
  update?: InputMaybe<DogBreederUpdateToOneWithWhereWithoutLittersInput>;
  upsert?: InputMaybe<DogBreederUpsertWithoutLittersInput>;
};

export type DogBreederUpdateOneRequiredWithoutPuppiesNestedInput = {
  connect?: InputMaybe<DogBreederWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DogBreederCreateOrConnectWithoutPuppiesInput>;
  create?: InputMaybe<DogBreederCreateWithoutPuppiesInput>;
  update?: InputMaybe<DogBreederUpdateToOneWithWhereWithoutPuppiesInput>;
  upsert?: InputMaybe<DogBreederUpsertWithoutPuppiesInput>;
};

export type DogBreederUpdateOneRequiredWithoutReviewsNestedInput = {
  connect?: InputMaybe<DogBreederWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DogBreederCreateOrConnectWithoutReviewsInput>;
  create?: InputMaybe<DogBreederCreateWithoutReviewsInput>;
  update?: InputMaybe<DogBreederUpdateToOneWithWhereWithoutReviewsInput>;
  upsert?: InputMaybe<DogBreederUpsertWithoutReviewsInput>;
};

export type DogBreederUpdateOneRequiredWithoutTranslationsNestedInput = {
  connect?: InputMaybe<DogBreederWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DogBreederCreateOrConnectWithoutTranslationsInput>;
  create?: InputMaybe<DogBreederCreateWithoutTranslationsInput>;
  update?: InputMaybe<DogBreederUpdateToOneWithWhereWithoutTranslationsInput>;
  upsert?: InputMaybe<DogBreederUpsertWithoutTranslationsInput>;
};

export type DogBreederUpdateOneWithoutAccountNestedInput = {
  connect?: InputMaybe<DogBreederWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DogBreederCreateOrConnectWithoutAccountInput>;
  create?: InputMaybe<DogBreederCreateWithoutAccountInput>;
  delete?: InputMaybe<DogBreederWhereInput>;
  disconnect?: InputMaybe<DogBreederWhereInput>;
  update?: InputMaybe<DogBreederUpdateToOneWithWhereWithoutAccountInput>;
  upsert?: InputMaybe<DogBreederUpsertWithoutAccountInput>;
};

export type DogBreederUpdateOneWithoutDogInfosNestedInput = {
  connect?: InputMaybe<DogBreederWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DogBreederCreateOrConnectWithoutDogInfosInput>;
  create?: InputMaybe<DogBreederCreateWithoutDogInfosInput>;
  delete?: InputMaybe<DogBreederWhereInput>;
  disconnect?: InputMaybe<DogBreederWhereInput>;
  update?: InputMaybe<DogBreederUpdateToOneWithWhereWithoutDogInfosInput>;
  upsert?: InputMaybe<DogBreederUpsertWithoutDogInfosInput>;
};

export type DogBreederUpdateOneWithoutEmailHistoryNestedInput = {
  connect?: InputMaybe<DogBreederWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DogBreederCreateOrConnectWithoutEmailHistoryInput>;
  create?: InputMaybe<DogBreederCreateWithoutEmailHistoryInput>;
  delete?: InputMaybe<DogBreederWhereInput>;
  disconnect?: InputMaybe<DogBreederWhereInput>;
  update?: InputMaybe<DogBreederUpdateToOneWithWhereWithoutEmailHistoryInput>;
  upsert?: InputMaybe<DogBreederUpsertWithoutEmailHistoryInput>;
};

export type DogBreederUpdateOneWithoutNotificationsNestedInput = {
  connect?: InputMaybe<DogBreederWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DogBreederCreateOrConnectWithoutNotificationsInput>;
  create?: InputMaybe<DogBreederCreateWithoutNotificationsInput>;
  delete?: InputMaybe<DogBreederWhereInput>;
  disconnect?: InputMaybe<DogBreederWhereInput>;
  update?: InputMaybe<DogBreederUpdateToOneWithWhereWithoutNotificationsInput>;
  upsert?: InputMaybe<DogBreederUpsertWithoutNotificationsInput>;
};

export type DogBreederUpdateOneWithoutStudInfosNestedInput = {
  connect?: InputMaybe<DogBreederWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DogBreederCreateOrConnectWithoutStudInfosInput>;
  create?: InputMaybe<DogBreederCreateWithoutStudInfosInput>;
  delete?: InputMaybe<DogBreederWhereInput>;
  disconnect?: InputMaybe<DogBreederWhereInput>;
  update?: InputMaybe<DogBreederUpdateToOneWithWhereWithoutStudInfosInput>;
  upsert?: InputMaybe<DogBreederUpsertWithoutStudInfosInput>;
};

export type DogBreederUpdateOneWithoutUpdatesNestedInput = {
  connect?: InputMaybe<DogBreederWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DogBreederCreateOrConnectWithoutUpdatesInput>;
  create?: InputMaybe<DogBreederCreateWithoutUpdatesInput>;
  delete?: InputMaybe<DogBreederWhereInput>;
  disconnect?: InputMaybe<DogBreederWhereInput>;
  update?: InputMaybe<DogBreederUpdateToOneWithWhereWithoutUpdatesInput>;
  upsert?: InputMaybe<DogBreederUpsertWithoutUpdatesInput>;
};

export type DogBreederUpdateToOneWithWhereWithoutAccountInput = {
  data: DogBreederUpdateWithoutAccountInput;
  where?: InputMaybe<DogBreederWhereInput>;
};

export type DogBreederUpdateToOneWithWhereWithoutApplicationsInput = {
  data: DogBreederUpdateWithoutApplicationsInput;
  where?: InputMaybe<DogBreederWhereInput>;
};

export type DogBreederUpdateToOneWithWhereWithoutBreederBreedsInput = {
  data: DogBreederUpdateWithoutBreederBreedsInput;
  where?: InputMaybe<DogBreederWhereInput>;
};

export type DogBreederUpdateToOneWithWhereWithoutDogInfosInput = {
  data: DogBreederUpdateWithoutDogInfosInput;
  where?: InputMaybe<DogBreederWhereInput>;
};

export type DogBreederUpdateToOneWithWhereWithoutEmailHistoryInput = {
  data: DogBreederUpdateWithoutEmailHistoryInput;
  where?: InputMaybe<DogBreederWhereInput>;
};

export type DogBreederUpdateToOneWithWhereWithoutImgsInput = {
  data: DogBreederUpdateWithoutImgsInput;
  where?: InputMaybe<DogBreederWhereInput>;
};

export type DogBreederUpdateToOneWithWhereWithoutLittersInput = {
  data: DogBreederUpdateWithoutLittersInput;
  where?: InputMaybe<DogBreederWhereInput>;
};

export type DogBreederUpdateToOneWithWhereWithoutNotificationsInput = {
  data: DogBreederUpdateWithoutNotificationsInput;
  where?: InputMaybe<DogBreederWhereInput>;
};

export type DogBreederUpdateToOneWithWhereWithoutPuppiesInput = {
  data: DogBreederUpdateWithoutPuppiesInput;
  where?: InputMaybe<DogBreederWhereInput>;
};

export type DogBreederUpdateToOneWithWhereWithoutReviewsInput = {
  data: DogBreederUpdateWithoutReviewsInput;
  where?: InputMaybe<DogBreederWhereInput>;
};

export type DogBreederUpdateToOneWithWhereWithoutStudInfosInput = {
  data: DogBreederUpdateWithoutStudInfosInput;
  where?: InputMaybe<DogBreederWhereInput>;
};

export type DogBreederUpdateToOneWithWhereWithoutTranslationsInput = {
  data: DogBreederUpdateWithoutTranslationsInput;
  where?: InputMaybe<DogBreederWhereInput>;
};

export type DogBreederUpdateToOneWithWhereWithoutUpdatesInput = {
  data: DogBreederUpdateWithoutUpdatesInput;
  where?: InputMaybe<DogBreederWhereInput>;
};

export type DogBreederUpdateWithoutAccountInput = {
  adminNote?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  agreementNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  applications?: InputMaybe<DogBreederApplicationUpdateManyWithoutDogBreederNestedInput>;
  breedClubFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  breedClubValidated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  breederBreeds?: InputMaybe<DogBreederBreedsUpdateManyWithoutDogBreederNestedInput>;
  breedingName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  certificationFile?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  certified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  displayEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  displayName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  displayPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dogInfos?: InputMaybe<DogInfoUpdateManyWithoutBreederNestedInput>;
  dogsConsanguinity?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dogsPedigree?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dogsTemper?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailAutomationStage?: InputMaybe<IntFieldUpdateOperationsInput>;
  emailHistory?: InputMaybe<EmailHistoryUpdateManyWithoutBreederNestedInput>;
  facebookUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  failedMedicalTestsProtocol?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hasFinishedOnboarding?: InputMaybe<BoolFieldUpdateOperationsInput>;
  hasStartedOnboarding?: InputMaybe<BoolFieldUpdateOperationsInput>;
  hkFile?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  identityFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  imgs?: InputMaybe<DogBreederImgUpdateManyWithoutDogBreederNestedInput>;
  lastAutomationEmailSentAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  level?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  litters?: InputMaybe<LitterUpdateManyWithoutBreederNestedInput>;
  littersByFemale?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  littersByFemaleCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  maleBreedersCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  medicalTestsPerformed?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  motherRestBetweenLitters?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutBreederNestedInput>;
  permissionFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  public?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  puppies?: InputMaybe<DogPuppyUpdateManyWithoutBreederNestedInput>;
  puppiesBirthPlace?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  reviews?: InputMaybe<DogBreederReviewUpdateManyWithoutDogBreederNestedInput>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  studInfos?: InputMaybe<StudInfoUpdateManyWithoutBreederNestedInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  translations?: InputMaybe<DogBreederTranslationUpdateManyWithoutDogBreederNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updates?: InputMaybe<UpdateUpdateManyWithoutBreederNestedInput>;
  vatNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  veterinaryInfo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  videoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  visitedByTipaw?: InputMaybe<BoolFieldUpdateOperationsInput>;
  websiteUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whatsappNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type DogBreederUpdateWithoutApplicationsInput = {
  account?: InputMaybe<AccountUpdateOneRequiredWithoutDogBreederNestedInput>;
  adminNote?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  agreementNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  breedClubFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  breedClubValidated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  breederBreeds?: InputMaybe<DogBreederBreedsUpdateManyWithoutDogBreederNestedInput>;
  breedingName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  certificationFile?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  certified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  displayEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  displayName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  displayPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dogInfos?: InputMaybe<DogInfoUpdateManyWithoutBreederNestedInput>;
  dogsConsanguinity?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dogsPedigree?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dogsTemper?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailAutomationStage?: InputMaybe<IntFieldUpdateOperationsInput>;
  emailHistory?: InputMaybe<EmailHistoryUpdateManyWithoutBreederNestedInput>;
  facebookUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  failedMedicalTestsProtocol?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hasFinishedOnboarding?: InputMaybe<BoolFieldUpdateOperationsInput>;
  hasStartedOnboarding?: InputMaybe<BoolFieldUpdateOperationsInput>;
  hkFile?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  identityFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  imgs?: InputMaybe<DogBreederImgUpdateManyWithoutDogBreederNestedInput>;
  lastAutomationEmailSentAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  level?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  litters?: InputMaybe<LitterUpdateManyWithoutBreederNestedInput>;
  littersByFemale?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  littersByFemaleCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  maleBreedersCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  medicalTestsPerformed?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  motherRestBetweenLitters?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutBreederNestedInput>;
  permissionFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  public?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  puppies?: InputMaybe<DogPuppyUpdateManyWithoutBreederNestedInput>;
  puppiesBirthPlace?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  reviews?: InputMaybe<DogBreederReviewUpdateManyWithoutDogBreederNestedInput>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  studInfos?: InputMaybe<StudInfoUpdateManyWithoutBreederNestedInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  translations?: InputMaybe<DogBreederTranslationUpdateManyWithoutDogBreederNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updates?: InputMaybe<UpdateUpdateManyWithoutBreederNestedInput>;
  vatNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  veterinaryInfo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  videoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  visitedByTipaw?: InputMaybe<BoolFieldUpdateOperationsInput>;
  websiteUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whatsappNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type DogBreederUpdateWithoutBreederBreedsInput = {
  account?: InputMaybe<AccountUpdateOneRequiredWithoutDogBreederNestedInput>;
  adminNote?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  agreementNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  applications?: InputMaybe<DogBreederApplicationUpdateManyWithoutDogBreederNestedInput>;
  breedClubFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  breedClubValidated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  breedingName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  certificationFile?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  certified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  displayEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  displayName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  displayPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dogInfos?: InputMaybe<DogInfoUpdateManyWithoutBreederNestedInput>;
  dogsConsanguinity?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dogsPedigree?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dogsTemper?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailAutomationStage?: InputMaybe<IntFieldUpdateOperationsInput>;
  emailHistory?: InputMaybe<EmailHistoryUpdateManyWithoutBreederNestedInput>;
  facebookUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  failedMedicalTestsProtocol?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hasFinishedOnboarding?: InputMaybe<BoolFieldUpdateOperationsInput>;
  hasStartedOnboarding?: InputMaybe<BoolFieldUpdateOperationsInput>;
  hkFile?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  identityFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  imgs?: InputMaybe<DogBreederImgUpdateManyWithoutDogBreederNestedInput>;
  lastAutomationEmailSentAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  level?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  litters?: InputMaybe<LitterUpdateManyWithoutBreederNestedInput>;
  littersByFemale?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  littersByFemaleCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  maleBreedersCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  medicalTestsPerformed?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  motherRestBetweenLitters?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutBreederNestedInput>;
  permissionFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  public?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  puppies?: InputMaybe<DogPuppyUpdateManyWithoutBreederNestedInput>;
  puppiesBirthPlace?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  reviews?: InputMaybe<DogBreederReviewUpdateManyWithoutDogBreederNestedInput>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  studInfos?: InputMaybe<StudInfoUpdateManyWithoutBreederNestedInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  translations?: InputMaybe<DogBreederTranslationUpdateManyWithoutDogBreederNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updates?: InputMaybe<UpdateUpdateManyWithoutBreederNestedInput>;
  vatNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  veterinaryInfo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  videoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  visitedByTipaw?: InputMaybe<BoolFieldUpdateOperationsInput>;
  websiteUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whatsappNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type DogBreederUpdateWithoutDogInfosInput = {
  account?: InputMaybe<AccountUpdateOneRequiredWithoutDogBreederNestedInput>;
  adminNote?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  agreementNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  applications?: InputMaybe<DogBreederApplicationUpdateManyWithoutDogBreederNestedInput>;
  breedClubFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  breedClubValidated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  breederBreeds?: InputMaybe<DogBreederBreedsUpdateManyWithoutDogBreederNestedInput>;
  breedingName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  certificationFile?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  certified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  displayEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  displayName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  displayPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dogsConsanguinity?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dogsPedigree?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dogsTemper?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailAutomationStage?: InputMaybe<IntFieldUpdateOperationsInput>;
  emailHistory?: InputMaybe<EmailHistoryUpdateManyWithoutBreederNestedInput>;
  facebookUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  failedMedicalTestsProtocol?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hasFinishedOnboarding?: InputMaybe<BoolFieldUpdateOperationsInput>;
  hasStartedOnboarding?: InputMaybe<BoolFieldUpdateOperationsInput>;
  hkFile?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  identityFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  imgs?: InputMaybe<DogBreederImgUpdateManyWithoutDogBreederNestedInput>;
  lastAutomationEmailSentAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  level?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  litters?: InputMaybe<LitterUpdateManyWithoutBreederNestedInput>;
  littersByFemale?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  littersByFemaleCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  maleBreedersCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  medicalTestsPerformed?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  motherRestBetweenLitters?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutBreederNestedInput>;
  permissionFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  public?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  puppies?: InputMaybe<DogPuppyUpdateManyWithoutBreederNestedInput>;
  puppiesBirthPlace?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  reviews?: InputMaybe<DogBreederReviewUpdateManyWithoutDogBreederNestedInput>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  studInfos?: InputMaybe<StudInfoUpdateManyWithoutBreederNestedInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  translations?: InputMaybe<DogBreederTranslationUpdateManyWithoutDogBreederNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updates?: InputMaybe<UpdateUpdateManyWithoutBreederNestedInput>;
  vatNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  veterinaryInfo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  videoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  visitedByTipaw?: InputMaybe<BoolFieldUpdateOperationsInput>;
  websiteUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whatsappNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type DogBreederUpdateWithoutEmailHistoryInput = {
  account?: InputMaybe<AccountUpdateOneRequiredWithoutDogBreederNestedInput>;
  adminNote?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  agreementNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  applications?: InputMaybe<DogBreederApplicationUpdateManyWithoutDogBreederNestedInput>;
  breedClubFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  breedClubValidated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  breederBreeds?: InputMaybe<DogBreederBreedsUpdateManyWithoutDogBreederNestedInput>;
  breedingName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  certificationFile?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  certified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  displayEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  displayName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  displayPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dogInfos?: InputMaybe<DogInfoUpdateManyWithoutBreederNestedInput>;
  dogsConsanguinity?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dogsPedigree?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dogsTemper?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailAutomationStage?: InputMaybe<IntFieldUpdateOperationsInput>;
  facebookUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  failedMedicalTestsProtocol?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hasFinishedOnboarding?: InputMaybe<BoolFieldUpdateOperationsInput>;
  hasStartedOnboarding?: InputMaybe<BoolFieldUpdateOperationsInput>;
  hkFile?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  identityFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  imgs?: InputMaybe<DogBreederImgUpdateManyWithoutDogBreederNestedInput>;
  lastAutomationEmailSentAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  level?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  litters?: InputMaybe<LitterUpdateManyWithoutBreederNestedInput>;
  littersByFemale?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  littersByFemaleCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  maleBreedersCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  medicalTestsPerformed?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  motherRestBetweenLitters?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutBreederNestedInput>;
  permissionFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  public?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  puppies?: InputMaybe<DogPuppyUpdateManyWithoutBreederNestedInput>;
  puppiesBirthPlace?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  reviews?: InputMaybe<DogBreederReviewUpdateManyWithoutDogBreederNestedInput>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  studInfos?: InputMaybe<StudInfoUpdateManyWithoutBreederNestedInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  translations?: InputMaybe<DogBreederTranslationUpdateManyWithoutDogBreederNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updates?: InputMaybe<UpdateUpdateManyWithoutBreederNestedInput>;
  vatNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  veterinaryInfo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  videoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  visitedByTipaw?: InputMaybe<BoolFieldUpdateOperationsInput>;
  websiteUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whatsappNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type DogBreederUpdateWithoutImgsInput = {
  account?: InputMaybe<AccountUpdateOneRequiredWithoutDogBreederNestedInput>;
  adminNote?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  agreementNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  applications?: InputMaybe<DogBreederApplicationUpdateManyWithoutDogBreederNestedInput>;
  breedClubFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  breedClubValidated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  breederBreeds?: InputMaybe<DogBreederBreedsUpdateManyWithoutDogBreederNestedInput>;
  breedingName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  certificationFile?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  certified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  displayEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  displayName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  displayPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dogInfos?: InputMaybe<DogInfoUpdateManyWithoutBreederNestedInput>;
  dogsConsanguinity?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dogsPedigree?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dogsTemper?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailAutomationStage?: InputMaybe<IntFieldUpdateOperationsInput>;
  emailHistory?: InputMaybe<EmailHistoryUpdateManyWithoutBreederNestedInput>;
  facebookUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  failedMedicalTestsProtocol?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hasFinishedOnboarding?: InputMaybe<BoolFieldUpdateOperationsInput>;
  hasStartedOnboarding?: InputMaybe<BoolFieldUpdateOperationsInput>;
  hkFile?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  identityFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  lastAutomationEmailSentAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  level?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  litters?: InputMaybe<LitterUpdateManyWithoutBreederNestedInput>;
  littersByFemale?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  littersByFemaleCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  maleBreedersCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  medicalTestsPerformed?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  motherRestBetweenLitters?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutBreederNestedInput>;
  permissionFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  public?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  puppies?: InputMaybe<DogPuppyUpdateManyWithoutBreederNestedInput>;
  puppiesBirthPlace?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  reviews?: InputMaybe<DogBreederReviewUpdateManyWithoutDogBreederNestedInput>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  studInfos?: InputMaybe<StudInfoUpdateManyWithoutBreederNestedInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  translations?: InputMaybe<DogBreederTranslationUpdateManyWithoutDogBreederNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updates?: InputMaybe<UpdateUpdateManyWithoutBreederNestedInput>;
  vatNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  veterinaryInfo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  videoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  visitedByTipaw?: InputMaybe<BoolFieldUpdateOperationsInput>;
  websiteUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whatsappNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type DogBreederUpdateWithoutLittersInput = {
  account?: InputMaybe<AccountUpdateOneRequiredWithoutDogBreederNestedInput>;
  adminNote?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  agreementNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  applications?: InputMaybe<DogBreederApplicationUpdateManyWithoutDogBreederNestedInput>;
  breedClubFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  breedClubValidated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  breederBreeds?: InputMaybe<DogBreederBreedsUpdateManyWithoutDogBreederNestedInput>;
  breedingName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  certificationFile?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  certified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  displayEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  displayName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  displayPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dogInfos?: InputMaybe<DogInfoUpdateManyWithoutBreederNestedInput>;
  dogsConsanguinity?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dogsPedigree?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dogsTemper?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailAutomationStage?: InputMaybe<IntFieldUpdateOperationsInput>;
  emailHistory?: InputMaybe<EmailHistoryUpdateManyWithoutBreederNestedInput>;
  facebookUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  failedMedicalTestsProtocol?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hasFinishedOnboarding?: InputMaybe<BoolFieldUpdateOperationsInput>;
  hasStartedOnboarding?: InputMaybe<BoolFieldUpdateOperationsInput>;
  hkFile?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  identityFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  imgs?: InputMaybe<DogBreederImgUpdateManyWithoutDogBreederNestedInput>;
  lastAutomationEmailSentAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  level?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  littersByFemale?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  littersByFemaleCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  maleBreedersCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  medicalTestsPerformed?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  motherRestBetweenLitters?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutBreederNestedInput>;
  permissionFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  public?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  puppies?: InputMaybe<DogPuppyUpdateManyWithoutBreederNestedInput>;
  puppiesBirthPlace?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  reviews?: InputMaybe<DogBreederReviewUpdateManyWithoutDogBreederNestedInput>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  studInfos?: InputMaybe<StudInfoUpdateManyWithoutBreederNestedInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  translations?: InputMaybe<DogBreederTranslationUpdateManyWithoutDogBreederNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updates?: InputMaybe<UpdateUpdateManyWithoutBreederNestedInput>;
  vatNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  veterinaryInfo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  videoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  visitedByTipaw?: InputMaybe<BoolFieldUpdateOperationsInput>;
  websiteUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whatsappNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type DogBreederUpdateWithoutNotificationsInput = {
  account?: InputMaybe<AccountUpdateOneRequiredWithoutDogBreederNestedInput>;
  adminNote?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  agreementNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  applications?: InputMaybe<DogBreederApplicationUpdateManyWithoutDogBreederNestedInput>;
  breedClubFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  breedClubValidated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  breederBreeds?: InputMaybe<DogBreederBreedsUpdateManyWithoutDogBreederNestedInput>;
  breedingName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  certificationFile?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  certified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  displayEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  displayName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  displayPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dogInfos?: InputMaybe<DogInfoUpdateManyWithoutBreederNestedInput>;
  dogsConsanguinity?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dogsPedigree?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dogsTemper?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailAutomationStage?: InputMaybe<IntFieldUpdateOperationsInput>;
  emailHistory?: InputMaybe<EmailHistoryUpdateManyWithoutBreederNestedInput>;
  facebookUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  failedMedicalTestsProtocol?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hasFinishedOnboarding?: InputMaybe<BoolFieldUpdateOperationsInput>;
  hasStartedOnboarding?: InputMaybe<BoolFieldUpdateOperationsInput>;
  hkFile?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  identityFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  imgs?: InputMaybe<DogBreederImgUpdateManyWithoutDogBreederNestedInput>;
  lastAutomationEmailSentAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  level?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  litters?: InputMaybe<LitterUpdateManyWithoutBreederNestedInput>;
  littersByFemale?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  littersByFemaleCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  maleBreedersCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  medicalTestsPerformed?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  motherRestBetweenLitters?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  permissionFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  public?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  puppies?: InputMaybe<DogPuppyUpdateManyWithoutBreederNestedInput>;
  puppiesBirthPlace?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  reviews?: InputMaybe<DogBreederReviewUpdateManyWithoutDogBreederNestedInput>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  studInfos?: InputMaybe<StudInfoUpdateManyWithoutBreederNestedInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  translations?: InputMaybe<DogBreederTranslationUpdateManyWithoutDogBreederNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updates?: InputMaybe<UpdateUpdateManyWithoutBreederNestedInput>;
  vatNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  veterinaryInfo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  videoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  visitedByTipaw?: InputMaybe<BoolFieldUpdateOperationsInput>;
  websiteUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whatsappNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type DogBreederUpdateWithoutPuppiesInput = {
  account?: InputMaybe<AccountUpdateOneRequiredWithoutDogBreederNestedInput>;
  adminNote?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  agreementNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  applications?: InputMaybe<DogBreederApplicationUpdateManyWithoutDogBreederNestedInput>;
  breedClubFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  breedClubValidated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  breederBreeds?: InputMaybe<DogBreederBreedsUpdateManyWithoutDogBreederNestedInput>;
  breedingName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  certificationFile?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  certified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  displayEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  displayName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  displayPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dogInfos?: InputMaybe<DogInfoUpdateManyWithoutBreederNestedInput>;
  dogsConsanguinity?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dogsPedigree?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dogsTemper?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailAutomationStage?: InputMaybe<IntFieldUpdateOperationsInput>;
  emailHistory?: InputMaybe<EmailHistoryUpdateManyWithoutBreederNestedInput>;
  facebookUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  failedMedicalTestsProtocol?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hasFinishedOnboarding?: InputMaybe<BoolFieldUpdateOperationsInput>;
  hasStartedOnboarding?: InputMaybe<BoolFieldUpdateOperationsInput>;
  hkFile?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  identityFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  imgs?: InputMaybe<DogBreederImgUpdateManyWithoutDogBreederNestedInput>;
  lastAutomationEmailSentAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  level?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  litters?: InputMaybe<LitterUpdateManyWithoutBreederNestedInput>;
  littersByFemale?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  littersByFemaleCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  maleBreedersCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  medicalTestsPerformed?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  motherRestBetweenLitters?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutBreederNestedInput>;
  permissionFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  public?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  puppiesBirthPlace?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  reviews?: InputMaybe<DogBreederReviewUpdateManyWithoutDogBreederNestedInput>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  studInfos?: InputMaybe<StudInfoUpdateManyWithoutBreederNestedInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  translations?: InputMaybe<DogBreederTranslationUpdateManyWithoutDogBreederNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updates?: InputMaybe<UpdateUpdateManyWithoutBreederNestedInput>;
  vatNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  veterinaryInfo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  videoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  visitedByTipaw?: InputMaybe<BoolFieldUpdateOperationsInput>;
  websiteUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whatsappNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type DogBreederUpdateWithoutReviewsInput = {
  account?: InputMaybe<AccountUpdateOneRequiredWithoutDogBreederNestedInput>;
  adminNote?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  agreementNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  applications?: InputMaybe<DogBreederApplicationUpdateManyWithoutDogBreederNestedInput>;
  breedClubFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  breedClubValidated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  breederBreeds?: InputMaybe<DogBreederBreedsUpdateManyWithoutDogBreederNestedInput>;
  breedingName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  certificationFile?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  certified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  displayEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  displayName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  displayPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dogInfos?: InputMaybe<DogInfoUpdateManyWithoutBreederNestedInput>;
  dogsConsanguinity?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dogsPedigree?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dogsTemper?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailAutomationStage?: InputMaybe<IntFieldUpdateOperationsInput>;
  emailHistory?: InputMaybe<EmailHistoryUpdateManyWithoutBreederNestedInput>;
  facebookUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  failedMedicalTestsProtocol?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hasFinishedOnboarding?: InputMaybe<BoolFieldUpdateOperationsInput>;
  hasStartedOnboarding?: InputMaybe<BoolFieldUpdateOperationsInput>;
  hkFile?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  identityFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  imgs?: InputMaybe<DogBreederImgUpdateManyWithoutDogBreederNestedInput>;
  lastAutomationEmailSentAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  level?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  litters?: InputMaybe<LitterUpdateManyWithoutBreederNestedInput>;
  littersByFemale?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  littersByFemaleCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  maleBreedersCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  medicalTestsPerformed?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  motherRestBetweenLitters?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutBreederNestedInput>;
  permissionFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  public?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  puppies?: InputMaybe<DogPuppyUpdateManyWithoutBreederNestedInput>;
  puppiesBirthPlace?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  studInfos?: InputMaybe<StudInfoUpdateManyWithoutBreederNestedInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  translations?: InputMaybe<DogBreederTranslationUpdateManyWithoutDogBreederNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updates?: InputMaybe<UpdateUpdateManyWithoutBreederNestedInput>;
  vatNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  veterinaryInfo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  videoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  visitedByTipaw?: InputMaybe<BoolFieldUpdateOperationsInput>;
  websiteUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whatsappNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type DogBreederUpdateWithoutStudInfosInput = {
  account?: InputMaybe<AccountUpdateOneRequiredWithoutDogBreederNestedInput>;
  adminNote?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  agreementNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  applications?: InputMaybe<DogBreederApplicationUpdateManyWithoutDogBreederNestedInput>;
  breedClubFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  breedClubValidated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  breederBreeds?: InputMaybe<DogBreederBreedsUpdateManyWithoutDogBreederNestedInput>;
  breedingName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  certificationFile?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  certified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  displayEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  displayName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  displayPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dogInfos?: InputMaybe<DogInfoUpdateManyWithoutBreederNestedInput>;
  dogsConsanguinity?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dogsPedigree?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dogsTemper?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailAutomationStage?: InputMaybe<IntFieldUpdateOperationsInput>;
  emailHistory?: InputMaybe<EmailHistoryUpdateManyWithoutBreederNestedInput>;
  facebookUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  failedMedicalTestsProtocol?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hasFinishedOnboarding?: InputMaybe<BoolFieldUpdateOperationsInput>;
  hasStartedOnboarding?: InputMaybe<BoolFieldUpdateOperationsInput>;
  hkFile?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  identityFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  imgs?: InputMaybe<DogBreederImgUpdateManyWithoutDogBreederNestedInput>;
  lastAutomationEmailSentAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  level?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  litters?: InputMaybe<LitterUpdateManyWithoutBreederNestedInput>;
  littersByFemale?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  littersByFemaleCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  maleBreedersCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  medicalTestsPerformed?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  motherRestBetweenLitters?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutBreederNestedInput>;
  permissionFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  public?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  puppies?: InputMaybe<DogPuppyUpdateManyWithoutBreederNestedInput>;
  puppiesBirthPlace?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  reviews?: InputMaybe<DogBreederReviewUpdateManyWithoutDogBreederNestedInput>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  translations?: InputMaybe<DogBreederTranslationUpdateManyWithoutDogBreederNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updates?: InputMaybe<UpdateUpdateManyWithoutBreederNestedInput>;
  vatNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  veterinaryInfo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  videoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  visitedByTipaw?: InputMaybe<BoolFieldUpdateOperationsInput>;
  websiteUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whatsappNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type DogBreederUpdateWithoutTranslationsInput = {
  account?: InputMaybe<AccountUpdateOneRequiredWithoutDogBreederNestedInput>;
  adminNote?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  agreementNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  applications?: InputMaybe<DogBreederApplicationUpdateManyWithoutDogBreederNestedInput>;
  breedClubFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  breedClubValidated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  breederBreeds?: InputMaybe<DogBreederBreedsUpdateManyWithoutDogBreederNestedInput>;
  breedingName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  certificationFile?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  certified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  displayEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  displayName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  displayPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dogInfos?: InputMaybe<DogInfoUpdateManyWithoutBreederNestedInput>;
  dogsConsanguinity?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dogsPedigree?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dogsTemper?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailAutomationStage?: InputMaybe<IntFieldUpdateOperationsInput>;
  emailHistory?: InputMaybe<EmailHistoryUpdateManyWithoutBreederNestedInput>;
  facebookUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  failedMedicalTestsProtocol?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hasFinishedOnboarding?: InputMaybe<BoolFieldUpdateOperationsInput>;
  hasStartedOnboarding?: InputMaybe<BoolFieldUpdateOperationsInput>;
  hkFile?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  identityFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  imgs?: InputMaybe<DogBreederImgUpdateManyWithoutDogBreederNestedInput>;
  lastAutomationEmailSentAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  level?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  litters?: InputMaybe<LitterUpdateManyWithoutBreederNestedInput>;
  littersByFemale?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  littersByFemaleCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  maleBreedersCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  medicalTestsPerformed?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  motherRestBetweenLitters?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutBreederNestedInput>;
  permissionFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  public?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  puppies?: InputMaybe<DogPuppyUpdateManyWithoutBreederNestedInput>;
  puppiesBirthPlace?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  reviews?: InputMaybe<DogBreederReviewUpdateManyWithoutDogBreederNestedInput>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  studInfos?: InputMaybe<StudInfoUpdateManyWithoutBreederNestedInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updates?: InputMaybe<UpdateUpdateManyWithoutBreederNestedInput>;
  vatNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  veterinaryInfo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  videoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  visitedByTipaw?: InputMaybe<BoolFieldUpdateOperationsInput>;
  websiteUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whatsappNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type DogBreederUpdateWithoutUpdatesInput = {
  account?: InputMaybe<AccountUpdateOneRequiredWithoutDogBreederNestedInput>;
  adminNote?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  agreementNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  applications?: InputMaybe<DogBreederApplicationUpdateManyWithoutDogBreederNestedInput>;
  breedClubFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  breedClubValidated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  breederBreeds?: InputMaybe<DogBreederBreedsUpdateManyWithoutDogBreederNestedInput>;
  breedingName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  certificationFile?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  certified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  displayEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  displayName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  displayPhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dogInfos?: InputMaybe<DogInfoUpdateManyWithoutBreederNestedInput>;
  dogsConsanguinity?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dogsPedigree?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dogsTemper?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailAutomationStage?: InputMaybe<IntFieldUpdateOperationsInput>;
  emailHistory?: InputMaybe<EmailHistoryUpdateManyWithoutBreederNestedInput>;
  facebookUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  failedMedicalTestsProtocol?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hasFinishedOnboarding?: InputMaybe<BoolFieldUpdateOperationsInput>;
  hasStartedOnboarding?: InputMaybe<BoolFieldUpdateOperationsInput>;
  hkFile?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  identityFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  imgs?: InputMaybe<DogBreederImgUpdateManyWithoutDogBreederNestedInput>;
  lastAutomationEmailSentAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  level?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  litters?: InputMaybe<LitterUpdateManyWithoutBreederNestedInput>;
  littersByFemale?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  littersByFemaleCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  maleBreedersCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  medicalTestsPerformed?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  motherRestBetweenLitters?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutBreederNestedInput>;
  permissionFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  public?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  puppies?: InputMaybe<DogPuppyUpdateManyWithoutBreederNestedInput>;
  puppiesBirthPlace?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  reviews?: InputMaybe<DogBreederReviewUpdateManyWithoutDogBreederNestedInput>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  studInfos?: InputMaybe<StudInfoUpdateManyWithoutBreederNestedInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  translations?: InputMaybe<DogBreederTranslationUpdateManyWithoutDogBreederNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  vatNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  veterinaryInfo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  videoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  visitedByTipaw?: InputMaybe<BoolFieldUpdateOperationsInput>;
  websiteUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whatsappNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type DogBreederUpdatebreedClubFilesInput = {
  push?: InputMaybe<Array<Scalars['String']['input']>>;
  set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type DogBreederUpdateidentityFilesInput = {
  push?: InputMaybe<Array<Scalars['String']['input']>>;
  set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type DogBreederUpdatepermissionFilesInput = {
  push?: InputMaybe<Array<Scalars['String']['input']>>;
  set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type DogBreederUpdatespokenLanguagesInput = {
  push?: InputMaybe<Array<Scalars['String']['input']>>;
  set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type DogBreederUpdatetagsInput = {
  push?: InputMaybe<Array<Scalars['String']['input']>>;
  set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type DogBreederUpsertWithoutAccountInput = {
  create: DogBreederCreateWithoutAccountInput;
  update: DogBreederUpdateWithoutAccountInput;
  where?: InputMaybe<DogBreederWhereInput>;
};

export type DogBreederUpsertWithoutApplicationsInput = {
  create: DogBreederCreateWithoutApplicationsInput;
  update: DogBreederUpdateWithoutApplicationsInput;
  where?: InputMaybe<DogBreederWhereInput>;
};

export type DogBreederUpsertWithoutBreederBreedsInput = {
  create: DogBreederCreateWithoutBreederBreedsInput;
  update: DogBreederUpdateWithoutBreederBreedsInput;
  where?: InputMaybe<DogBreederWhereInput>;
};

export type DogBreederUpsertWithoutDogInfosInput = {
  create: DogBreederCreateWithoutDogInfosInput;
  update: DogBreederUpdateWithoutDogInfosInput;
  where?: InputMaybe<DogBreederWhereInput>;
};

export type DogBreederUpsertWithoutEmailHistoryInput = {
  create: DogBreederCreateWithoutEmailHistoryInput;
  update: DogBreederUpdateWithoutEmailHistoryInput;
  where?: InputMaybe<DogBreederWhereInput>;
};

export type DogBreederUpsertWithoutImgsInput = {
  create: DogBreederCreateWithoutImgsInput;
  update: DogBreederUpdateWithoutImgsInput;
  where?: InputMaybe<DogBreederWhereInput>;
};

export type DogBreederUpsertWithoutLittersInput = {
  create: DogBreederCreateWithoutLittersInput;
  update: DogBreederUpdateWithoutLittersInput;
  where?: InputMaybe<DogBreederWhereInput>;
};

export type DogBreederUpsertWithoutNotificationsInput = {
  create: DogBreederCreateWithoutNotificationsInput;
  update: DogBreederUpdateWithoutNotificationsInput;
  where?: InputMaybe<DogBreederWhereInput>;
};

export type DogBreederUpsertWithoutPuppiesInput = {
  create: DogBreederCreateWithoutPuppiesInput;
  update: DogBreederUpdateWithoutPuppiesInput;
  where?: InputMaybe<DogBreederWhereInput>;
};

export type DogBreederUpsertWithoutReviewsInput = {
  create: DogBreederCreateWithoutReviewsInput;
  update: DogBreederUpdateWithoutReviewsInput;
  where?: InputMaybe<DogBreederWhereInput>;
};

export type DogBreederUpsertWithoutStudInfosInput = {
  create: DogBreederCreateWithoutStudInfosInput;
  update: DogBreederUpdateWithoutStudInfosInput;
  where?: InputMaybe<DogBreederWhereInput>;
};

export type DogBreederUpsertWithoutTranslationsInput = {
  create: DogBreederCreateWithoutTranslationsInput;
  update: DogBreederUpdateWithoutTranslationsInput;
  where?: InputMaybe<DogBreederWhereInput>;
};

export type DogBreederUpsertWithoutUpdatesInput = {
  create: DogBreederCreateWithoutUpdatesInput;
  update: DogBreederUpdateWithoutUpdatesInput;
  where?: InputMaybe<DogBreederWhereInput>;
};

export type DogBreederWhereInput = {
  AND?: InputMaybe<Array<DogBreederWhereInput>>;
  NOT?: InputMaybe<Array<DogBreederWhereInput>>;
  OR?: InputMaybe<Array<DogBreederWhereInput>>;
  account?: InputMaybe<AccountRelationFilter>;
  adminNote?: InputMaybe<StringNullableFilter>;
  agreementNumber?: InputMaybe<StringNullableFilter>;
  applications?: InputMaybe<DogBreederApplicationListRelationFilter>;
  breedClubFiles?: InputMaybe<StringNullableListFilter>;
  breedClubValidated?: InputMaybe<BoolFilter>;
  breederBreeds?: InputMaybe<DogBreederBreedsListRelationFilter>;
  breedingName?: InputMaybe<StringNullableFilter>;
  certificationFile?: InputMaybe<StringNullableFilter>;
  certified?: InputMaybe<BoolNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  displayEmail?: InputMaybe<StringNullableFilter>;
  displayName?: InputMaybe<StringNullableFilter>;
  displayPhone?: InputMaybe<StringNullableFilter>;
  dogInfos?: InputMaybe<DogInfoListRelationFilter>;
  dogsConsanguinity?: InputMaybe<StringNullableFilter>;
  dogsPedigree?: InputMaybe<StringNullableFilter>;
  dogsTemper?: InputMaybe<StringNullableFilter>;
  emailAutomationStage?: InputMaybe<IntFilter>;
  emailHistory?: InputMaybe<EmailHistoryListRelationFilter>;
  facebookUrl?: InputMaybe<StringNullableFilter>;
  failedMedicalTestsProtocol?: InputMaybe<StringNullableFilter>;
  hasFinishedOnboarding?: InputMaybe<BoolFilter>;
  hasStartedOnboarding?: InputMaybe<BoolFilter>;
  hkFile?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<IntFilter>;
  identityFiles?: InputMaybe<StringNullableListFilter>;
  imgs?: InputMaybe<DogBreederImgListRelationFilter>;
  lastAutomationEmailSentAt?: InputMaybe<DateTimeNullableFilter>;
  level?: InputMaybe<StringNullableFilter>;
  litters?: InputMaybe<LitterListRelationFilter>;
  littersByFemale?: InputMaybe<StringNullableFilter>;
  littersByFemaleCount?: InputMaybe<IntNullableFilter>;
  maleBreedersCount?: InputMaybe<IntNullableFilter>;
  medicalTestsPerformed?: InputMaybe<StringNullableFilter>;
  motherRestBetweenLitters?: InputMaybe<StringNullableFilter>;
  notifications?: InputMaybe<NotificationListRelationFilter>;
  permissionFiles?: InputMaybe<StringNullableListFilter>;
  public?: InputMaybe<BoolNullableFilter>;
  puppies?: InputMaybe<DogPuppyListRelationFilter>;
  puppiesBirthPlace?: InputMaybe<StringNullableFilter>;
  reviews?: InputMaybe<DogBreederReviewListRelationFilter>;
  spokenLanguages?: InputMaybe<StringNullableListFilter>;
  studInfos?: InputMaybe<StudInfoListRelationFilter>;
  tags?: InputMaybe<StringNullableListFilter>;
  translations?: InputMaybe<DogBreederTranslationListRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  updates?: InputMaybe<UpdateListRelationFilter>;
  vatNumber?: InputMaybe<StringNullableFilter>;
  veterinaryInfo?: InputMaybe<StringNullableFilter>;
  videoUrl?: InputMaybe<StringNullableFilter>;
  visitedByTipaw?: InputMaybe<BoolFilter>;
  websiteUrl?: InputMaybe<StringNullableFilter>;
  whatsappNumber?: InputMaybe<StringNullableFilter>;
};

export type DogBreederWhereUniqueInput = {
  AND?: InputMaybe<Array<DogBreederWhereInput>>;
  NOT?: InputMaybe<Array<DogBreederWhereInput>>;
  OR?: InputMaybe<Array<DogBreederWhereInput>>;
  account?: InputMaybe<AccountRelationFilter>;
  adminNote?: InputMaybe<StringNullableFilter>;
  agreementNumber?: InputMaybe<StringNullableFilter>;
  applications?: InputMaybe<DogBreederApplicationListRelationFilter>;
  breedClubFiles?: InputMaybe<StringNullableListFilter>;
  breedClubValidated?: InputMaybe<BoolFilter>;
  breederBreeds?: InputMaybe<DogBreederBreedsListRelationFilter>;
  breedingName?: InputMaybe<StringNullableFilter>;
  certificationFile?: InputMaybe<StringNullableFilter>;
  certified?: InputMaybe<BoolNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  displayEmail?: InputMaybe<StringNullableFilter>;
  displayName?: InputMaybe<StringNullableFilter>;
  displayPhone?: InputMaybe<StringNullableFilter>;
  dogInfos?: InputMaybe<DogInfoListRelationFilter>;
  dogsConsanguinity?: InputMaybe<StringNullableFilter>;
  dogsPedigree?: InputMaybe<StringNullableFilter>;
  dogsTemper?: InputMaybe<StringNullableFilter>;
  emailAutomationStage?: InputMaybe<IntFilter>;
  emailHistory?: InputMaybe<EmailHistoryListRelationFilter>;
  facebookUrl?: InputMaybe<StringNullableFilter>;
  failedMedicalTestsProtocol?: InputMaybe<StringNullableFilter>;
  hasFinishedOnboarding?: InputMaybe<BoolFilter>;
  hasStartedOnboarding?: InputMaybe<BoolFilter>;
  hkFile?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  identityFiles?: InputMaybe<StringNullableListFilter>;
  imgs?: InputMaybe<DogBreederImgListRelationFilter>;
  lastAutomationEmailSentAt?: InputMaybe<DateTimeNullableFilter>;
  level?: InputMaybe<StringNullableFilter>;
  litters?: InputMaybe<LitterListRelationFilter>;
  littersByFemale?: InputMaybe<StringNullableFilter>;
  littersByFemaleCount?: InputMaybe<IntNullableFilter>;
  maleBreedersCount?: InputMaybe<IntNullableFilter>;
  medicalTestsPerformed?: InputMaybe<StringNullableFilter>;
  motherRestBetweenLitters?: InputMaybe<StringNullableFilter>;
  notifications?: InputMaybe<NotificationListRelationFilter>;
  permissionFiles?: InputMaybe<StringNullableListFilter>;
  public?: InputMaybe<BoolNullableFilter>;
  puppies?: InputMaybe<DogPuppyListRelationFilter>;
  puppiesBirthPlace?: InputMaybe<StringNullableFilter>;
  reviews?: InputMaybe<DogBreederReviewListRelationFilter>;
  spokenLanguages?: InputMaybe<StringNullableListFilter>;
  studInfos?: InputMaybe<StudInfoListRelationFilter>;
  tags?: InputMaybe<StringNullableListFilter>;
  translations?: InputMaybe<DogBreederTranslationListRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  updates?: InputMaybe<UpdateListRelationFilter>;
  vatNumber?: InputMaybe<StringNullableFilter>;
  veterinaryInfo?: InputMaybe<StringNullableFilter>;
  videoUrl?: InputMaybe<StringNullableFilter>;
  visitedByTipaw?: InputMaybe<BoolFilter>;
  websiteUrl?: InputMaybe<StringNullableFilter>;
  whatsappNumber?: InputMaybe<StringNullableFilter>;
};

export enum DogCoat {
  AGOUTI = 'AGOUTI',
  ARLEQUIN = 'ARLEQUIN',
  AUBERE = 'AUBERE',
  BELTON = 'BELTON',
  BICOLORE = 'BICOLORE',
  BIGAREE = 'BIGAREE',
  BLENHEIM = 'BLENHEIM',
  BRINGEE = 'BRINGEE',
  CAILLE = 'CAILLE',
  CHARBONNEE = 'CHARBONNEE',
  DILUE = 'DILUE',
  ECLABOUSSE = 'ECLABOUSSE',
  FANTOME = 'FANTOME',
  MARBRURES = 'MARBRURES',
  MOTIFS_EN_SPIRALE = 'MOTIFS_EN_SPIRALE',
  NOIR_ET_FEU = 'NOIR_ET_FEU',
  NUAGES = 'NUAGES',
  OMBRAGE = 'OMBRAGE',
  OMBREE = 'OMBREE',
  OTHER = 'OTHER',
  PANACHEE = 'PANACHEE',
  PARSEMEE = 'PARSEMEE',
  PARTICOLORE = 'PARTICOLORE',
  PIE = 'PIE',
  PLURICOLORE = 'PLURICOLORE',
  POIVRE_AND_SEL = 'POIVRE_AND_SEL',
  ROUANNEE = 'ROUANNEE',
  TACHES_FAUVES = 'TACHES_FAUVES',
  TACHES_IRLANDAISES = 'TACHES_IRLANDAISES',
  TACHETEE = 'TACHETEE',
  TIGRE = 'TIGRE',
  TIQUETEE = 'TIQUETEE',
  TRICOLORE = 'TRICOLORE',
  ZAIN = 'ZAIN'
}

export enum DogColor {
  APRICOT = 'APRICOT',
  BLACK = 'BLACK',
  BLACK_FAWN = 'BLACK_FAWN',
  BLACK_WHITE = 'BLACK_WHITE',
  BLUE = 'BLUE',
  BROWN = 'BROWN',
  CHEVREUIL = 'CHEVREUIL',
  CHOCOLATE = 'CHOCOLATE',
  CITRON = 'CITRON',
  CREAM = 'CREAM',
  DARK_BLOND = 'DARK_BLOND',
  FAUVE = 'FAUVE',
  GINGER = 'GINGER',
  GOLD = 'GOLD',
  GOLDEN = 'GOLDEN',
  GREY = 'GREY',
  ISABELLE = 'ISABELLE',
  MAHOGANY = 'MAHOGANY',
  MERLE = 'MERLE',
  OTHER = 'OTHER',
  RED = 'RED',
  SAND = 'SAND',
  SILVER = 'SILVER',
  WHITE = 'WHITE'
}

export enum DogHairType {
  CURLY = 'CURLY',
  LONG = 'LONG',
  SEMI_LONG = 'SEMI_LONG',
  SHORT = 'SHORT'
}

export type DogInfo = {
  __typename?: 'DogInfo';
  _count: DogInfoCountOutputType;
  animal: Animal;
  animalId: Scalars['Int']['output'];
  breedType: BreedType;
  breeder?: Maybe<DogBreeder>;
  breederId?: Maybe<Scalars['Int']['output']>;
  breederIsDogOwner?: Maybe<Scalars['Boolean']['output']>;
  canStayAlone: YesNoUnknownStatus;
  catFriendly: YesNoUnknownStatus;
  coat?: Maybe<DogCoat>;
  color?: Maybe<DogColor>;
  competitionTitles?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  dogBreed?: Maybe<DogBreed>;
  dogBreedId?: Maybe<Scalars['Int']['output']>;
  femaleDogFriendly: YesNoUnknownStatus;
  healthTestsResults?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  inOption: Scalars['Boolean']['output'];
  kidsFriendly: YesNoUnknownStatus;
  maleDogFriendly: YesNoUnknownStatus;
  medicalAffections: Array<DogMedicalAffection>;
  microshipNumber?: Maybe<Scalars['String']['output']>;
  pedigree?: Maybe<Scalars['String']['output']>;
  pedigreeNumber?: Maybe<Scalars['String']['output']>;
  physicalCondition?: Maybe<DogPhysicalCondition>;
  updatedAt: Scalars['DateTime']['output'];
};


export type DogInfomedicalAffectionsArgs = {
  cursor?: InputMaybe<DogMedicalAffectionWhereUniqueInput>;
  distinct?: InputMaybe<DogMedicalAffectionScalarFieldEnum>;
  orderBy?: InputMaybe<DogMedicalAffectionOrderByWithRelationAndSearchRelevanceInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DogMedicalAffectionWhereInput>;
};

export type DogInfoAvgAggregateOutputType = {
  __typename?: 'DogInfoAvgAggregateOutputType';
  animalId?: Maybe<Scalars['Float']['output']>;
  breederId?: Maybe<Scalars['Float']['output']>;
  dogBreedId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

export type DogInfoAvgOrderByAggregateInput = {
  animalId?: InputMaybe<SortOrder>;
  breederId?: InputMaybe<SortOrder>;
  dogBreedId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export type DogInfoCountAggregateOutputType = {
  __typename?: 'DogInfoCountAggregateOutputType';
  _all: Scalars['Int']['output'];
  animalId: Scalars['Int']['output'];
  breedType: Scalars['Int']['output'];
  breederId: Scalars['Int']['output'];
  breederIsDogOwner: Scalars['Int']['output'];
  canStayAlone: Scalars['Int']['output'];
  catFriendly: Scalars['Int']['output'];
  coat: Scalars['Int']['output'];
  color: Scalars['Int']['output'];
  competitionTitles: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  description: Scalars['Int']['output'];
  dogBreedId: Scalars['Int']['output'];
  femaleDogFriendly: Scalars['Int']['output'];
  healthTestsResults: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  inOption: Scalars['Int']['output'];
  kidsFriendly: Scalars['Int']['output'];
  maleDogFriendly: Scalars['Int']['output'];
  microshipNumber: Scalars['Int']['output'];
  pedigree: Scalars['Int']['output'];
  pedigreeNumber: Scalars['Int']['output'];
  physicalCondition: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type DogInfoCountOrderByAggregateInput = {
  animalId?: InputMaybe<SortOrder>;
  breedType?: InputMaybe<SortOrder>;
  breederId?: InputMaybe<SortOrder>;
  breederIsDogOwner?: InputMaybe<SortOrder>;
  canStayAlone?: InputMaybe<SortOrder>;
  catFriendly?: InputMaybe<SortOrder>;
  coat?: InputMaybe<SortOrder>;
  color?: InputMaybe<SortOrder>;
  competitionTitles?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  dogBreedId?: InputMaybe<SortOrder>;
  femaleDogFriendly?: InputMaybe<SortOrder>;
  healthTestsResults?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  inOption?: InputMaybe<SortOrder>;
  kidsFriendly?: InputMaybe<SortOrder>;
  maleDogFriendly?: InputMaybe<SortOrder>;
  microshipNumber?: InputMaybe<SortOrder>;
  pedigree?: InputMaybe<SortOrder>;
  pedigreeNumber?: InputMaybe<SortOrder>;
  physicalCondition?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type DogInfoCountOutputType = {
  __typename?: 'DogInfoCountOutputType';
  medicalAffections: Scalars['Int']['output'];
};

export type DogInfoCreateInput = {
  animal: AnimalCreateNestedOneWithoutDogInfosInput;
  breedType?: InputMaybe<BreedType>;
  breeder?: InputMaybe<DogBreederCreateNestedOneWithoutDogInfosInput>;
  breederIsDogOwner?: InputMaybe<Scalars['Boolean']['input']>;
  canStayAlone?: InputMaybe<YesNoUnknownStatus>;
  catFriendly?: InputMaybe<YesNoUnknownStatus>;
  coat?: InputMaybe<DogCoat>;
  color?: InputMaybe<DogColor>;
  competitionTitles?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dogBreed?: InputMaybe<DogBreedCreateNestedOneWithoutDogInfosInput>;
  femaleDogFriendly?: InputMaybe<YesNoUnknownStatus>;
  healthTestsResults?: InputMaybe<Scalars['String']['input']>;
  inOption?: InputMaybe<Scalars['Boolean']['input']>;
  kidsFriendly?: InputMaybe<YesNoUnknownStatus>;
  maleDogFriendly?: InputMaybe<YesNoUnknownStatus>;
  medicalAffections?: InputMaybe<DogMedicalAffectionCreateNestedManyWithoutDogInfoInput>;
  microshipNumber?: InputMaybe<Scalars['String']['input']>;
  pedigree?: InputMaybe<Scalars['String']['input']>;
  pedigreeNumber?: InputMaybe<Scalars['String']['input']>;
  physicalCondition?: InputMaybe<DogPhysicalCondition>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DogInfoCreateManyBreederInput = {
  animalId: Scalars['Int']['input'];
  breedType?: InputMaybe<BreedType>;
  breederIsDogOwner?: InputMaybe<Scalars['Boolean']['input']>;
  canStayAlone?: InputMaybe<YesNoUnknownStatus>;
  catFriendly?: InputMaybe<YesNoUnknownStatus>;
  coat?: InputMaybe<DogCoat>;
  color?: InputMaybe<DogColor>;
  competitionTitles?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dogBreedId?: InputMaybe<Scalars['Int']['input']>;
  femaleDogFriendly?: InputMaybe<YesNoUnknownStatus>;
  healthTestsResults?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  inOption?: InputMaybe<Scalars['Boolean']['input']>;
  kidsFriendly?: InputMaybe<YesNoUnknownStatus>;
  maleDogFriendly?: InputMaybe<YesNoUnknownStatus>;
  microshipNumber?: InputMaybe<Scalars['String']['input']>;
  pedigree?: InputMaybe<Scalars['String']['input']>;
  pedigreeNumber?: InputMaybe<Scalars['String']['input']>;
  physicalCondition?: InputMaybe<DogPhysicalCondition>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DogInfoCreateManyBreederInputEnvelope = {
  data: Array<DogInfoCreateManyBreederInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DogInfoCreateManyDogBreedInput = {
  animalId: Scalars['Int']['input'];
  breedType?: InputMaybe<BreedType>;
  breederId?: InputMaybe<Scalars['Int']['input']>;
  breederIsDogOwner?: InputMaybe<Scalars['Boolean']['input']>;
  canStayAlone?: InputMaybe<YesNoUnknownStatus>;
  catFriendly?: InputMaybe<YesNoUnknownStatus>;
  coat?: InputMaybe<DogCoat>;
  color?: InputMaybe<DogColor>;
  competitionTitles?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  femaleDogFriendly?: InputMaybe<YesNoUnknownStatus>;
  healthTestsResults?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  inOption?: InputMaybe<Scalars['Boolean']['input']>;
  kidsFriendly?: InputMaybe<YesNoUnknownStatus>;
  maleDogFriendly?: InputMaybe<YesNoUnknownStatus>;
  microshipNumber?: InputMaybe<Scalars['String']['input']>;
  pedigree?: InputMaybe<Scalars['String']['input']>;
  pedigreeNumber?: InputMaybe<Scalars['String']['input']>;
  physicalCondition?: InputMaybe<DogPhysicalCondition>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DogInfoCreateManyDogBreedInputEnvelope = {
  data: Array<DogInfoCreateManyDogBreedInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DogInfoCreateManyInput = {
  animalId: Scalars['Int']['input'];
  breedType?: InputMaybe<BreedType>;
  breederId?: InputMaybe<Scalars['Int']['input']>;
  breederIsDogOwner?: InputMaybe<Scalars['Boolean']['input']>;
  canStayAlone?: InputMaybe<YesNoUnknownStatus>;
  catFriendly?: InputMaybe<YesNoUnknownStatus>;
  coat?: InputMaybe<DogCoat>;
  color?: InputMaybe<DogColor>;
  competitionTitles?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dogBreedId?: InputMaybe<Scalars['Int']['input']>;
  femaleDogFriendly?: InputMaybe<YesNoUnknownStatus>;
  healthTestsResults?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  inOption?: InputMaybe<Scalars['Boolean']['input']>;
  kidsFriendly?: InputMaybe<YesNoUnknownStatus>;
  maleDogFriendly?: InputMaybe<YesNoUnknownStatus>;
  microshipNumber?: InputMaybe<Scalars['String']['input']>;
  pedigree?: InputMaybe<Scalars['String']['input']>;
  pedigreeNumber?: InputMaybe<Scalars['String']['input']>;
  physicalCondition?: InputMaybe<DogPhysicalCondition>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DogInfoCreateNestedManyWithoutBreederInput = {
  connect?: InputMaybe<Array<DogInfoWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DogInfoCreateOrConnectWithoutBreederInput>>;
  create?: InputMaybe<Array<DogInfoCreateWithoutBreederInput>>;
  createMany?: InputMaybe<DogInfoCreateManyBreederInputEnvelope>;
};

export type DogInfoCreateNestedManyWithoutDogBreedInput = {
  connect?: InputMaybe<Array<DogInfoWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DogInfoCreateOrConnectWithoutDogBreedInput>>;
  create?: InputMaybe<Array<DogInfoCreateWithoutDogBreedInput>>;
  createMany?: InputMaybe<DogInfoCreateManyDogBreedInputEnvelope>;
};

export type DogInfoCreateNestedOneWithoutAnimalInput = {
  connect?: InputMaybe<DogInfoWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DogInfoCreateOrConnectWithoutAnimalInput>;
  create?: InputMaybe<DogInfoCreateWithoutAnimalInput>;
};

export type DogInfoCreateNestedOneWithoutMedicalAffectionsInput = {
  connect?: InputMaybe<DogInfoWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DogInfoCreateOrConnectWithoutMedicalAffectionsInput>;
  create?: InputMaybe<DogInfoCreateWithoutMedicalAffectionsInput>;
};

export type DogInfoCreateOrConnectWithoutAnimalInput = {
  create: DogInfoCreateWithoutAnimalInput;
  where: DogInfoWhereUniqueInput;
};

export type DogInfoCreateOrConnectWithoutBreederInput = {
  create: DogInfoCreateWithoutBreederInput;
  where: DogInfoWhereUniqueInput;
};

export type DogInfoCreateOrConnectWithoutDogBreedInput = {
  create: DogInfoCreateWithoutDogBreedInput;
  where: DogInfoWhereUniqueInput;
};

export type DogInfoCreateOrConnectWithoutMedicalAffectionsInput = {
  create: DogInfoCreateWithoutMedicalAffectionsInput;
  where: DogInfoWhereUniqueInput;
};

export type DogInfoCreateWithoutAnimalInput = {
  breedType?: InputMaybe<BreedType>;
  breeder?: InputMaybe<DogBreederCreateNestedOneWithoutDogInfosInput>;
  breederIsDogOwner?: InputMaybe<Scalars['Boolean']['input']>;
  canStayAlone?: InputMaybe<YesNoUnknownStatus>;
  catFriendly?: InputMaybe<YesNoUnknownStatus>;
  coat?: InputMaybe<DogCoat>;
  color?: InputMaybe<DogColor>;
  competitionTitles?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dogBreed?: InputMaybe<DogBreedCreateNestedOneWithoutDogInfosInput>;
  femaleDogFriendly?: InputMaybe<YesNoUnknownStatus>;
  healthTestsResults?: InputMaybe<Scalars['String']['input']>;
  inOption?: InputMaybe<Scalars['Boolean']['input']>;
  kidsFriendly?: InputMaybe<YesNoUnknownStatus>;
  maleDogFriendly?: InputMaybe<YesNoUnknownStatus>;
  medicalAffections?: InputMaybe<DogMedicalAffectionCreateNestedManyWithoutDogInfoInput>;
  microshipNumber?: InputMaybe<Scalars['String']['input']>;
  pedigree?: InputMaybe<Scalars['String']['input']>;
  pedigreeNumber?: InputMaybe<Scalars['String']['input']>;
  physicalCondition?: InputMaybe<DogPhysicalCondition>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DogInfoCreateWithoutBreederInput = {
  animal: AnimalCreateNestedOneWithoutDogInfosInput;
  breedType?: InputMaybe<BreedType>;
  breederIsDogOwner?: InputMaybe<Scalars['Boolean']['input']>;
  canStayAlone?: InputMaybe<YesNoUnknownStatus>;
  catFriendly?: InputMaybe<YesNoUnknownStatus>;
  coat?: InputMaybe<DogCoat>;
  color?: InputMaybe<DogColor>;
  competitionTitles?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dogBreed?: InputMaybe<DogBreedCreateNestedOneWithoutDogInfosInput>;
  femaleDogFriendly?: InputMaybe<YesNoUnknownStatus>;
  healthTestsResults?: InputMaybe<Scalars['String']['input']>;
  inOption?: InputMaybe<Scalars['Boolean']['input']>;
  kidsFriendly?: InputMaybe<YesNoUnknownStatus>;
  maleDogFriendly?: InputMaybe<YesNoUnknownStatus>;
  medicalAffections?: InputMaybe<DogMedicalAffectionCreateNestedManyWithoutDogInfoInput>;
  microshipNumber?: InputMaybe<Scalars['String']['input']>;
  pedigree?: InputMaybe<Scalars['String']['input']>;
  pedigreeNumber?: InputMaybe<Scalars['String']['input']>;
  physicalCondition?: InputMaybe<DogPhysicalCondition>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DogInfoCreateWithoutDogBreedInput = {
  animal: AnimalCreateNestedOneWithoutDogInfosInput;
  breedType?: InputMaybe<BreedType>;
  breeder?: InputMaybe<DogBreederCreateNestedOneWithoutDogInfosInput>;
  breederIsDogOwner?: InputMaybe<Scalars['Boolean']['input']>;
  canStayAlone?: InputMaybe<YesNoUnknownStatus>;
  catFriendly?: InputMaybe<YesNoUnknownStatus>;
  coat?: InputMaybe<DogCoat>;
  color?: InputMaybe<DogColor>;
  competitionTitles?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  femaleDogFriendly?: InputMaybe<YesNoUnknownStatus>;
  healthTestsResults?: InputMaybe<Scalars['String']['input']>;
  inOption?: InputMaybe<Scalars['Boolean']['input']>;
  kidsFriendly?: InputMaybe<YesNoUnknownStatus>;
  maleDogFriendly?: InputMaybe<YesNoUnknownStatus>;
  medicalAffections?: InputMaybe<DogMedicalAffectionCreateNestedManyWithoutDogInfoInput>;
  microshipNumber?: InputMaybe<Scalars['String']['input']>;
  pedigree?: InputMaybe<Scalars['String']['input']>;
  pedigreeNumber?: InputMaybe<Scalars['String']['input']>;
  physicalCondition?: InputMaybe<DogPhysicalCondition>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DogInfoCreateWithoutMedicalAffectionsInput = {
  animal: AnimalCreateNestedOneWithoutDogInfosInput;
  breedType?: InputMaybe<BreedType>;
  breeder?: InputMaybe<DogBreederCreateNestedOneWithoutDogInfosInput>;
  breederIsDogOwner?: InputMaybe<Scalars['Boolean']['input']>;
  canStayAlone?: InputMaybe<YesNoUnknownStatus>;
  catFriendly?: InputMaybe<YesNoUnknownStatus>;
  coat?: InputMaybe<DogCoat>;
  color?: InputMaybe<DogColor>;
  competitionTitles?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dogBreed?: InputMaybe<DogBreedCreateNestedOneWithoutDogInfosInput>;
  femaleDogFriendly?: InputMaybe<YesNoUnknownStatus>;
  healthTestsResults?: InputMaybe<Scalars['String']['input']>;
  inOption?: InputMaybe<Scalars['Boolean']['input']>;
  kidsFriendly?: InputMaybe<YesNoUnknownStatus>;
  maleDogFriendly?: InputMaybe<YesNoUnknownStatus>;
  microshipNumber?: InputMaybe<Scalars['String']['input']>;
  pedigree?: InputMaybe<Scalars['String']['input']>;
  pedigreeNumber?: InputMaybe<Scalars['String']['input']>;
  physicalCondition?: InputMaybe<DogPhysicalCondition>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DogInfoListRelationFilter = {
  every?: InputMaybe<DogInfoWhereInput>;
  none?: InputMaybe<DogInfoWhereInput>;
  some?: InputMaybe<DogInfoWhereInput>;
};

export type DogInfoMaxAggregateOutputType = {
  __typename?: 'DogInfoMaxAggregateOutputType';
  animalId?: Maybe<Scalars['Int']['output']>;
  breedType?: Maybe<BreedType>;
  breederId?: Maybe<Scalars['Int']['output']>;
  breederIsDogOwner?: Maybe<Scalars['Boolean']['output']>;
  canStayAlone?: Maybe<YesNoUnknownStatus>;
  catFriendly?: Maybe<YesNoUnknownStatus>;
  coat?: Maybe<DogCoat>;
  color?: Maybe<DogColor>;
  competitionTitles?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dogBreedId?: Maybe<Scalars['Int']['output']>;
  femaleDogFriendly?: Maybe<YesNoUnknownStatus>;
  healthTestsResults?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  inOption?: Maybe<Scalars['Boolean']['output']>;
  kidsFriendly?: Maybe<YesNoUnknownStatus>;
  maleDogFriendly?: Maybe<YesNoUnknownStatus>;
  microshipNumber?: Maybe<Scalars['String']['output']>;
  pedigree?: Maybe<Scalars['String']['output']>;
  pedigreeNumber?: Maybe<Scalars['String']['output']>;
  physicalCondition?: Maybe<DogPhysicalCondition>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type DogInfoMaxOrderByAggregateInput = {
  animalId?: InputMaybe<SortOrder>;
  breedType?: InputMaybe<SortOrder>;
  breederId?: InputMaybe<SortOrder>;
  breederIsDogOwner?: InputMaybe<SortOrder>;
  canStayAlone?: InputMaybe<SortOrder>;
  catFriendly?: InputMaybe<SortOrder>;
  coat?: InputMaybe<SortOrder>;
  color?: InputMaybe<SortOrder>;
  competitionTitles?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  dogBreedId?: InputMaybe<SortOrder>;
  femaleDogFriendly?: InputMaybe<SortOrder>;
  healthTestsResults?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  inOption?: InputMaybe<SortOrder>;
  kidsFriendly?: InputMaybe<SortOrder>;
  maleDogFriendly?: InputMaybe<SortOrder>;
  microshipNumber?: InputMaybe<SortOrder>;
  pedigree?: InputMaybe<SortOrder>;
  pedigreeNumber?: InputMaybe<SortOrder>;
  physicalCondition?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type DogInfoMinAggregateOutputType = {
  __typename?: 'DogInfoMinAggregateOutputType';
  animalId?: Maybe<Scalars['Int']['output']>;
  breedType?: Maybe<BreedType>;
  breederId?: Maybe<Scalars['Int']['output']>;
  breederIsDogOwner?: Maybe<Scalars['Boolean']['output']>;
  canStayAlone?: Maybe<YesNoUnknownStatus>;
  catFriendly?: Maybe<YesNoUnknownStatus>;
  coat?: Maybe<DogCoat>;
  color?: Maybe<DogColor>;
  competitionTitles?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dogBreedId?: Maybe<Scalars['Int']['output']>;
  femaleDogFriendly?: Maybe<YesNoUnknownStatus>;
  healthTestsResults?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  inOption?: Maybe<Scalars['Boolean']['output']>;
  kidsFriendly?: Maybe<YesNoUnknownStatus>;
  maleDogFriendly?: Maybe<YesNoUnknownStatus>;
  microshipNumber?: Maybe<Scalars['String']['output']>;
  pedigree?: Maybe<Scalars['String']['output']>;
  pedigreeNumber?: Maybe<Scalars['String']['output']>;
  physicalCondition?: Maybe<DogPhysicalCondition>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type DogInfoMinOrderByAggregateInput = {
  animalId?: InputMaybe<SortOrder>;
  breedType?: InputMaybe<SortOrder>;
  breederId?: InputMaybe<SortOrder>;
  breederIsDogOwner?: InputMaybe<SortOrder>;
  canStayAlone?: InputMaybe<SortOrder>;
  catFriendly?: InputMaybe<SortOrder>;
  coat?: InputMaybe<SortOrder>;
  color?: InputMaybe<SortOrder>;
  competitionTitles?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  dogBreedId?: InputMaybe<SortOrder>;
  femaleDogFriendly?: InputMaybe<SortOrder>;
  healthTestsResults?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  inOption?: InputMaybe<SortOrder>;
  kidsFriendly?: InputMaybe<SortOrder>;
  maleDogFriendly?: InputMaybe<SortOrder>;
  microshipNumber?: InputMaybe<SortOrder>;
  pedigree?: InputMaybe<SortOrder>;
  pedigreeNumber?: InputMaybe<SortOrder>;
  physicalCondition?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type DogInfoNullableRelationFilter = {
  is?: InputMaybe<DogInfoWhereInput>;
  isNot?: InputMaybe<DogInfoWhereInput>;
};

export type DogInfoOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export enum DogInfoOrderByRelevanceFieldEnum {
  competitionTitles = 'competitionTitles',
  description = 'description',
  healthTestsResults = 'healthTestsResults',
  microshipNumber = 'microshipNumber',
  pedigree = 'pedigree',
  pedigreeNumber = 'pedigreeNumber'
}

export type DogInfoOrderByRelevanceInput = {
  fields: Array<DogInfoOrderByRelevanceFieldEnum>;
  search: Scalars['String']['input'];
  sort: SortOrder;
};

export type DogInfoOrderByWithAggregationInput = {
  _avg?: InputMaybe<DogInfoAvgOrderByAggregateInput>;
  _count?: InputMaybe<DogInfoCountOrderByAggregateInput>;
  _max?: InputMaybe<DogInfoMaxOrderByAggregateInput>;
  _min?: InputMaybe<DogInfoMinOrderByAggregateInput>;
  _sum?: InputMaybe<DogInfoSumOrderByAggregateInput>;
  animalId?: InputMaybe<SortOrder>;
  breedType?: InputMaybe<SortOrder>;
  breederId?: InputMaybe<SortOrderInput>;
  breederIsDogOwner?: InputMaybe<SortOrderInput>;
  canStayAlone?: InputMaybe<SortOrder>;
  catFriendly?: InputMaybe<SortOrder>;
  coat?: InputMaybe<SortOrderInput>;
  color?: InputMaybe<SortOrderInput>;
  competitionTitles?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrderInput>;
  dogBreedId?: InputMaybe<SortOrderInput>;
  femaleDogFriendly?: InputMaybe<SortOrder>;
  healthTestsResults?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  inOption?: InputMaybe<SortOrder>;
  kidsFriendly?: InputMaybe<SortOrder>;
  maleDogFriendly?: InputMaybe<SortOrder>;
  microshipNumber?: InputMaybe<SortOrderInput>;
  pedigree?: InputMaybe<SortOrderInput>;
  pedigreeNumber?: InputMaybe<SortOrderInput>;
  physicalCondition?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type DogInfoOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: InputMaybe<DogInfoOrderByRelevanceInput>;
  animal?: InputMaybe<AnimalOrderByWithRelationAndSearchRelevanceInput>;
  animalId?: InputMaybe<SortOrder>;
  breedType?: InputMaybe<SortOrder>;
  breeder?: InputMaybe<DogBreederOrderByWithRelationAndSearchRelevanceInput>;
  breederId?: InputMaybe<SortOrderInput>;
  breederIsDogOwner?: InputMaybe<SortOrderInput>;
  canStayAlone?: InputMaybe<SortOrder>;
  catFriendly?: InputMaybe<SortOrder>;
  coat?: InputMaybe<SortOrderInput>;
  color?: InputMaybe<SortOrderInput>;
  competitionTitles?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrderInput>;
  dogBreed?: InputMaybe<DogBreedOrderByWithRelationAndSearchRelevanceInput>;
  dogBreedId?: InputMaybe<SortOrderInput>;
  femaleDogFriendly?: InputMaybe<SortOrder>;
  healthTestsResults?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  inOption?: InputMaybe<SortOrder>;
  kidsFriendly?: InputMaybe<SortOrder>;
  maleDogFriendly?: InputMaybe<SortOrder>;
  medicalAffections?: InputMaybe<DogMedicalAffectionOrderByRelationAggregateInput>;
  microshipNumber?: InputMaybe<SortOrderInput>;
  pedigree?: InputMaybe<SortOrderInput>;
  pedigreeNumber?: InputMaybe<SortOrderInput>;
  physicalCondition?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type DogInfoRelationFilter = {
  is?: InputMaybe<DogInfoWhereInput>;
  isNot?: InputMaybe<DogInfoWhereInput>;
};

export enum DogInfoScalarFieldEnum {
  animalId = 'animalId',
  breedType = 'breedType',
  breederId = 'breederId',
  breederIsDogOwner = 'breederIsDogOwner',
  canStayAlone = 'canStayAlone',
  catFriendly = 'catFriendly',
  coat = 'coat',
  color = 'color',
  competitionTitles = 'competitionTitles',
  createdAt = 'createdAt',
  description = 'description',
  dogBreedId = 'dogBreedId',
  femaleDogFriendly = 'femaleDogFriendly',
  healthTestsResults = 'healthTestsResults',
  id = 'id',
  inOption = 'inOption',
  kidsFriendly = 'kidsFriendly',
  maleDogFriendly = 'maleDogFriendly',
  microshipNumber = 'microshipNumber',
  pedigree = 'pedigree',
  pedigreeNumber = 'pedigreeNumber',
  physicalCondition = 'physicalCondition',
  updatedAt = 'updatedAt'
}

export type DogInfoScalarWhereInput = {
  AND?: InputMaybe<Array<DogInfoScalarWhereInput>>;
  NOT?: InputMaybe<Array<DogInfoScalarWhereInput>>;
  OR?: InputMaybe<Array<DogInfoScalarWhereInput>>;
  animalId?: InputMaybe<IntFilter>;
  breedType?: InputMaybe<EnumBreedTypeFilter>;
  breederId?: InputMaybe<IntNullableFilter>;
  breederIsDogOwner?: InputMaybe<BoolNullableFilter>;
  canStayAlone?: InputMaybe<EnumYesNoUnknownStatusFilter>;
  catFriendly?: InputMaybe<EnumYesNoUnknownStatusFilter>;
  coat?: InputMaybe<EnumDogCoatNullableFilter>;
  color?: InputMaybe<EnumDogColorNullableFilter>;
  competitionTitles?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringNullableFilter>;
  dogBreedId?: InputMaybe<IntNullableFilter>;
  femaleDogFriendly?: InputMaybe<EnumYesNoUnknownStatusFilter>;
  healthTestsResults?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<IntFilter>;
  inOption?: InputMaybe<BoolFilter>;
  kidsFriendly?: InputMaybe<EnumYesNoUnknownStatusFilter>;
  maleDogFriendly?: InputMaybe<EnumYesNoUnknownStatusFilter>;
  microshipNumber?: InputMaybe<StringNullableFilter>;
  pedigree?: InputMaybe<StringNullableFilter>;
  pedigreeNumber?: InputMaybe<StringNullableFilter>;
  physicalCondition?: InputMaybe<EnumDogPhysicalConditionNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type DogInfoScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<DogInfoScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<DogInfoScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<DogInfoScalarWhereWithAggregatesInput>>;
  animalId?: InputMaybe<IntWithAggregatesFilter>;
  breedType?: InputMaybe<EnumBreedTypeWithAggregatesFilter>;
  breederId?: InputMaybe<IntNullableWithAggregatesFilter>;
  breederIsDogOwner?: InputMaybe<BoolNullableWithAggregatesFilter>;
  canStayAlone?: InputMaybe<EnumYesNoUnknownStatusWithAggregatesFilter>;
  catFriendly?: InputMaybe<EnumYesNoUnknownStatusWithAggregatesFilter>;
  coat?: InputMaybe<EnumDogCoatNullableWithAggregatesFilter>;
  color?: InputMaybe<EnumDogColorNullableWithAggregatesFilter>;
  competitionTitles?: InputMaybe<StringNullableWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  description?: InputMaybe<StringNullableWithAggregatesFilter>;
  dogBreedId?: InputMaybe<IntNullableWithAggregatesFilter>;
  femaleDogFriendly?: InputMaybe<EnumYesNoUnknownStatusWithAggregatesFilter>;
  healthTestsResults?: InputMaybe<StringNullableWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  inOption?: InputMaybe<BoolWithAggregatesFilter>;
  kidsFriendly?: InputMaybe<EnumYesNoUnknownStatusWithAggregatesFilter>;
  maleDogFriendly?: InputMaybe<EnumYesNoUnknownStatusWithAggregatesFilter>;
  microshipNumber?: InputMaybe<StringNullableWithAggregatesFilter>;
  pedigree?: InputMaybe<StringNullableWithAggregatesFilter>;
  pedigreeNumber?: InputMaybe<StringNullableWithAggregatesFilter>;
  physicalCondition?: InputMaybe<EnumDogPhysicalConditionNullableWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type DogInfoSumAggregateOutputType = {
  __typename?: 'DogInfoSumAggregateOutputType';
  animalId?: Maybe<Scalars['Int']['output']>;
  breederId?: Maybe<Scalars['Int']['output']>;
  dogBreedId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
};

export type DogInfoSumOrderByAggregateInput = {
  animalId?: InputMaybe<SortOrder>;
  breederId?: InputMaybe<SortOrder>;
  dogBreedId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export type DogInfoUncheckedCreateInput = {
  animalId: Scalars['Int']['input'];
  breedType?: InputMaybe<BreedType>;
  breederId?: InputMaybe<Scalars['Int']['input']>;
  breederIsDogOwner?: InputMaybe<Scalars['Boolean']['input']>;
  canStayAlone?: InputMaybe<YesNoUnknownStatus>;
  catFriendly?: InputMaybe<YesNoUnknownStatus>;
  coat?: InputMaybe<DogCoat>;
  color?: InputMaybe<DogColor>;
  competitionTitles?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dogBreedId?: InputMaybe<Scalars['Int']['input']>;
  femaleDogFriendly?: InputMaybe<YesNoUnknownStatus>;
  healthTestsResults?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  inOption?: InputMaybe<Scalars['Boolean']['input']>;
  kidsFriendly?: InputMaybe<YesNoUnknownStatus>;
  maleDogFriendly?: InputMaybe<YesNoUnknownStatus>;
  medicalAffections?: InputMaybe<DogMedicalAffectionUncheckedCreateNestedManyWithoutDogInfoInput>;
  microshipNumber?: InputMaybe<Scalars['String']['input']>;
  pedigree?: InputMaybe<Scalars['String']['input']>;
  pedigreeNumber?: InputMaybe<Scalars['String']['input']>;
  physicalCondition?: InputMaybe<DogPhysicalCondition>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DogInfoUncheckedCreateNestedManyWithoutBreederInput = {
  connect?: InputMaybe<Array<DogInfoWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DogInfoCreateOrConnectWithoutBreederInput>>;
  create?: InputMaybe<Array<DogInfoCreateWithoutBreederInput>>;
  createMany?: InputMaybe<DogInfoCreateManyBreederInputEnvelope>;
};

export type DogInfoUncheckedCreateNestedManyWithoutDogBreedInput = {
  connect?: InputMaybe<Array<DogInfoWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DogInfoCreateOrConnectWithoutDogBreedInput>>;
  create?: InputMaybe<Array<DogInfoCreateWithoutDogBreedInput>>;
  createMany?: InputMaybe<DogInfoCreateManyDogBreedInputEnvelope>;
};

export type DogInfoUncheckedCreateNestedOneWithoutAnimalInput = {
  connect?: InputMaybe<DogInfoWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DogInfoCreateOrConnectWithoutAnimalInput>;
  create?: InputMaybe<DogInfoCreateWithoutAnimalInput>;
};

export type DogInfoUncheckedCreateWithoutAnimalInput = {
  breedType?: InputMaybe<BreedType>;
  breederId?: InputMaybe<Scalars['Int']['input']>;
  breederIsDogOwner?: InputMaybe<Scalars['Boolean']['input']>;
  canStayAlone?: InputMaybe<YesNoUnknownStatus>;
  catFriendly?: InputMaybe<YesNoUnknownStatus>;
  coat?: InputMaybe<DogCoat>;
  color?: InputMaybe<DogColor>;
  competitionTitles?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dogBreedId?: InputMaybe<Scalars['Int']['input']>;
  femaleDogFriendly?: InputMaybe<YesNoUnknownStatus>;
  healthTestsResults?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  inOption?: InputMaybe<Scalars['Boolean']['input']>;
  kidsFriendly?: InputMaybe<YesNoUnknownStatus>;
  maleDogFriendly?: InputMaybe<YesNoUnknownStatus>;
  medicalAffections?: InputMaybe<DogMedicalAffectionUncheckedCreateNestedManyWithoutDogInfoInput>;
  microshipNumber?: InputMaybe<Scalars['String']['input']>;
  pedigree?: InputMaybe<Scalars['String']['input']>;
  pedigreeNumber?: InputMaybe<Scalars['String']['input']>;
  physicalCondition?: InputMaybe<DogPhysicalCondition>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DogInfoUncheckedCreateWithoutBreederInput = {
  animalId: Scalars['Int']['input'];
  breedType?: InputMaybe<BreedType>;
  breederIsDogOwner?: InputMaybe<Scalars['Boolean']['input']>;
  canStayAlone?: InputMaybe<YesNoUnknownStatus>;
  catFriendly?: InputMaybe<YesNoUnknownStatus>;
  coat?: InputMaybe<DogCoat>;
  color?: InputMaybe<DogColor>;
  competitionTitles?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dogBreedId?: InputMaybe<Scalars['Int']['input']>;
  femaleDogFriendly?: InputMaybe<YesNoUnknownStatus>;
  healthTestsResults?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  inOption?: InputMaybe<Scalars['Boolean']['input']>;
  kidsFriendly?: InputMaybe<YesNoUnknownStatus>;
  maleDogFriendly?: InputMaybe<YesNoUnknownStatus>;
  medicalAffections?: InputMaybe<DogMedicalAffectionUncheckedCreateNestedManyWithoutDogInfoInput>;
  microshipNumber?: InputMaybe<Scalars['String']['input']>;
  pedigree?: InputMaybe<Scalars['String']['input']>;
  pedigreeNumber?: InputMaybe<Scalars['String']['input']>;
  physicalCondition?: InputMaybe<DogPhysicalCondition>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DogInfoUncheckedCreateWithoutDogBreedInput = {
  animalId: Scalars['Int']['input'];
  breedType?: InputMaybe<BreedType>;
  breederId?: InputMaybe<Scalars['Int']['input']>;
  breederIsDogOwner?: InputMaybe<Scalars['Boolean']['input']>;
  canStayAlone?: InputMaybe<YesNoUnknownStatus>;
  catFriendly?: InputMaybe<YesNoUnknownStatus>;
  coat?: InputMaybe<DogCoat>;
  color?: InputMaybe<DogColor>;
  competitionTitles?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  femaleDogFriendly?: InputMaybe<YesNoUnknownStatus>;
  healthTestsResults?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  inOption?: InputMaybe<Scalars['Boolean']['input']>;
  kidsFriendly?: InputMaybe<YesNoUnknownStatus>;
  maleDogFriendly?: InputMaybe<YesNoUnknownStatus>;
  medicalAffections?: InputMaybe<DogMedicalAffectionUncheckedCreateNestedManyWithoutDogInfoInput>;
  microshipNumber?: InputMaybe<Scalars['String']['input']>;
  pedigree?: InputMaybe<Scalars['String']['input']>;
  pedigreeNumber?: InputMaybe<Scalars['String']['input']>;
  physicalCondition?: InputMaybe<DogPhysicalCondition>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DogInfoUncheckedCreateWithoutMedicalAffectionsInput = {
  animalId: Scalars['Int']['input'];
  breedType?: InputMaybe<BreedType>;
  breederId?: InputMaybe<Scalars['Int']['input']>;
  breederIsDogOwner?: InputMaybe<Scalars['Boolean']['input']>;
  canStayAlone?: InputMaybe<YesNoUnknownStatus>;
  catFriendly?: InputMaybe<YesNoUnknownStatus>;
  coat?: InputMaybe<DogCoat>;
  color?: InputMaybe<DogColor>;
  competitionTitles?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dogBreedId?: InputMaybe<Scalars['Int']['input']>;
  femaleDogFriendly?: InputMaybe<YesNoUnknownStatus>;
  healthTestsResults?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  inOption?: InputMaybe<Scalars['Boolean']['input']>;
  kidsFriendly?: InputMaybe<YesNoUnknownStatus>;
  maleDogFriendly?: InputMaybe<YesNoUnknownStatus>;
  microshipNumber?: InputMaybe<Scalars['String']['input']>;
  pedigree?: InputMaybe<Scalars['String']['input']>;
  pedigreeNumber?: InputMaybe<Scalars['String']['input']>;
  physicalCondition?: InputMaybe<DogPhysicalCondition>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DogInfoUncheckedUpdateInput = {
  animalId?: InputMaybe<IntFieldUpdateOperationsInput>;
  breedType?: InputMaybe<EnumBreedTypeFieldUpdateOperationsInput>;
  breederId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  breederIsDogOwner?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  canStayAlone?: InputMaybe<EnumYesNoUnknownStatusFieldUpdateOperationsInput>;
  catFriendly?: InputMaybe<EnumYesNoUnknownStatusFieldUpdateOperationsInput>;
  coat?: InputMaybe<NullableEnumDogCoatFieldUpdateOperationsInput>;
  color?: InputMaybe<NullableEnumDogColorFieldUpdateOperationsInput>;
  competitionTitles?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dogBreedId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  femaleDogFriendly?: InputMaybe<EnumYesNoUnknownStatusFieldUpdateOperationsInput>;
  healthTestsResults?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  inOption?: InputMaybe<BoolFieldUpdateOperationsInput>;
  kidsFriendly?: InputMaybe<EnumYesNoUnknownStatusFieldUpdateOperationsInput>;
  maleDogFriendly?: InputMaybe<EnumYesNoUnknownStatusFieldUpdateOperationsInput>;
  medicalAffections?: InputMaybe<DogMedicalAffectionUncheckedUpdateManyWithoutDogInfoNestedInput>;
  microshipNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pedigree?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pedigreeNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  physicalCondition?: InputMaybe<NullableEnumDogPhysicalConditionFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DogInfoUncheckedUpdateManyInput = {
  animalId?: InputMaybe<IntFieldUpdateOperationsInput>;
  breedType?: InputMaybe<EnumBreedTypeFieldUpdateOperationsInput>;
  breederId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  breederIsDogOwner?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  canStayAlone?: InputMaybe<EnumYesNoUnknownStatusFieldUpdateOperationsInput>;
  catFriendly?: InputMaybe<EnumYesNoUnknownStatusFieldUpdateOperationsInput>;
  coat?: InputMaybe<NullableEnumDogCoatFieldUpdateOperationsInput>;
  color?: InputMaybe<NullableEnumDogColorFieldUpdateOperationsInput>;
  competitionTitles?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dogBreedId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  femaleDogFriendly?: InputMaybe<EnumYesNoUnknownStatusFieldUpdateOperationsInput>;
  healthTestsResults?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  inOption?: InputMaybe<BoolFieldUpdateOperationsInput>;
  kidsFriendly?: InputMaybe<EnumYesNoUnknownStatusFieldUpdateOperationsInput>;
  maleDogFriendly?: InputMaybe<EnumYesNoUnknownStatusFieldUpdateOperationsInput>;
  microshipNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pedigree?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pedigreeNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  physicalCondition?: InputMaybe<NullableEnumDogPhysicalConditionFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DogInfoUncheckedUpdateManyWithoutBreederInput = {
  animalId?: InputMaybe<IntFieldUpdateOperationsInput>;
  breedType?: InputMaybe<EnumBreedTypeFieldUpdateOperationsInput>;
  breederIsDogOwner?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  canStayAlone?: InputMaybe<EnumYesNoUnknownStatusFieldUpdateOperationsInput>;
  catFriendly?: InputMaybe<EnumYesNoUnknownStatusFieldUpdateOperationsInput>;
  coat?: InputMaybe<NullableEnumDogCoatFieldUpdateOperationsInput>;
  color?: InputMaybe<NullableEnumDogColorFieldUpdateOperationsInput>;
  competitionTitles?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dogBreedId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  femaleDogFriendly?: InputMaybe<EnumYesNoUnknownStatusFieldUpdateOperationsInput>;
  healthTestsResults?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  inOption?: InputMaybe<BoolFieldUpdateOperationsInput>;
  kidsFriendly?: InputMaybe<EnumYesNoUnknownStatusFieldUpdateOperationsInput>;
  maleDogFriendly?: InputMaybe<EnumYesNoUnknownStatusFieldUpdateOperationsInput>;
  microshipNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pedigree?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pedigreeNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  physicalCondition?: InputMaybe<NullableEnumDogPhysicalConditionFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DogInfoUncheckedUpdateManyWithoutBreederNestedInput = {
  connect?: InputMaybe<Array<DogInfoWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DogInfoCreateOrConnectWithoutBreederInput>>;
  create?: InputMaybe<Array<DogInfoCreateWithoutBreederInput>>;
  createMany?: InputMaybe<DogInfoCreateManyBreederInputEnvelope>;
  delete?: InputMaybe<Array<DogInfoWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<DogInfoScalarWhereInput>>;
  disconnect?: InputMaybe<Array<DogInfoWhereUniqueInput>>;
  set?: InputMaybe<Array<DogInfoWhereUniqueInput>>;
  update?: InputMaybe<Array<DogInfoUpdateWithWhereUniqueWithoutBreederInput>>;
  updateMany?: InputMaybe<Array<DogInfoUpdateManyWithWhereWithoutBreederInput>>;
  upsert?: InputMaybe<Array<DogInfoUpsertWithWhereUniqueWithoutBreederInput>>;
};

export type DogInfoUncheckedUpdateManyWithoutDogBreedInput = {
  animalId?: InputMaybe<IntFieldUpdateOperationsInput>;
  breedType?: InputMaybe<EnumBreedTypeFieldUpdateOperationsInput>;
  breederId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  breederIsDogOwner?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  canStayAlone?: InputMaybe<EnumYesNoUnknownStatusFieldUpdateOperationsInput>;
  catFriendly?: InputMaybe<EnumYesNoUnknownStatusFieldUpdateOperationsInput>;
  coat?: InputMaybe<NullableEnumDogCoatFieldUpdateOperationsInput>;
  color?: InputMaybe<NullableEnumDogColorFieldUpdateOperationsInput>;
  competitionTitles?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  femaleDogFriendly?: InputMaybe<EnumYesNoUnknownStatusFieldUpdateOperationsInput>;
  healthTestsResults?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  inOption?: InputMaybe<BoolFieldUpdateOperationsInput>;
  kidsFriendly?: InputMaybe<EnumYesNoUnknownStatusFieldUpdateOperationsInput>;
  maleDogFriendly?: InputMaybe<EnumYesNoUnknownStatusFieldUpdateOperationsInput>;
  microshipNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pedigree?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pedigreeNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  physicalCondition?: InputMaybe<NullableEnumDogPhysicalConditionFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DogInfoUncheckedUpdateManyWithoutDogBreedNestedInput = {
  connect?: InputMaybe<Array<DogInfoWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DogInfoCreateOrConnectWithoutDogBreedInput>>;
  create?: InputMaybe<Array<DogInfoCreateWithoutDogBreedInput>>;
  createMany?: InputMaybe<DogInfoCreateManyDogBreedInputEnvelope>;
  delete?: InputMaybe<Array<DogInfoWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<DogInfoScalarWhereInput>>;
  disconnect?: InputMaybe<Array<DogInfoWhereUniqueInput>>;
  set?: InputMaybe<Array<DogInfoWhereUniqueInput>>;
  update?: InputMaybe<Array<DogInfoUpdateWithWhereUniqueWithoutDogBreedInput>>;
  updateMany?: InputMaybe<Array<DogInfoUpdateManyWithWhereWithoutDogBreedInput>>;
  upsert?: InputMaybe<Array<DogInfoUpsertWithWhereUniqueWithoutDogBreedInput>>;
};

export type DogInfoUncheckedUpdateOneWithoutAnimalNestedInput = {
  connect?: InputMaybe<DogInfoWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DogInfoCreateOrConnectWithoutAnimalInput>;
  create?: InputMaybe<DogInfoCreateWithoutAnimalInput>;
  delete?: InputMaybe<DogInfoWhereInput>;
  disconnect?: InputMaybe<DogInfoWhereInput>;
  update?: InputMaybe<DogInfoUpdateToOneWithWhereWithoutAnimalInput>;
  upsert?: InputMaybe<DogInfoUpsertWithoutAnimalInput>;
};

export type DogInfoUncheckedUpdateWithoutAnimalInput = {
  breedType?: InputMaybe<EnumBreedTypeFieldUpdateOperationsInput>;
  breederId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  breederIsDogOwner?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  canStayAlone?: InputMaybe<EnumYesNoUnknownStatusFieldUpdateOperationsInput>;
  catFriendly?: InputMaybe<EnumYesNoUnknownStatusFieldUpdateOperationsInput>;
  coat?: InputMaybe<NullableEnumDogCoatFieldUpdateOperationsInput>;
  color?: InputMaybe<NullableEnumDogColorFieldUpdateOperationsInput>;
  competitionTitles?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dogBreedId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  femaleDogFriendly?: InputMaybe<EnumYesNoUnknownStatusFieldUpdateOperationsInput>;
  healthTestsResults?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  inOption?: InputMaybe<BoolFieldUpdateOperationsInput>;
  kidsFriendly?: InputMaybe<EnumYesNoUnknownStatusFieldUpdateOperationsInput>;
  maleDogFriendly?: InputMaybe<EnumYesNoUnknownStatusFieldUpdateOperationsInput>;
  medicalAffections?: InputMaybe<DogMedicalAffectionUncheckedUpdateManyWithoutDogInfoNestedInput>;
  microshipNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pedigree?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pedigreeNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  physicalCondition?: InputMaybe<NullableEnumDogPhysicalConditionFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DogInfoUncheckedUpdateWithoutBreederInput = {
  animalId?: InputMaybe<IntFieldUpdateOperationsInput>;
  breedType?: InputMaybe<EnumBreedTypeFieldUpdateOperationsInput>;
  breederIsDogOwner?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  canStayAlone?: InputMaybe<EnumYesNoUnknownStatusFieldUpdateOperationsInput>;
  catFriendly?: InputMaybe<EnumYesNoUnknownStatusFieldUpdateOperationsInput>;
  coat?: InputMaybe<NullableEnumDogCoatFieldUpdateOperationsInput>;
  color?: InputMaybe<NullableEnumDogColorFieldUpdateOperationsInput>;
  competitionTitles?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dogBreedId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  femaleDogFriendly?: InputMaybe<EnumYesNoUnknownStatusFieldUpdateOperationsInput>;
  healthTestsResults?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  inOption?: InputMaybe<BoolFieldUpdateOperationsInput>;
  kidsFriendly?: InputMaybe<EnumYesNoUnknownStatusFieldUpdateOperationsInput>;
  maleDogFriendly?: InputMaybe<EnumYesNoUnknownStatusFieldUpdateOperationsInput>;
  medicalAffections?: InputMaybe<DogMedicalAffectionUncheckedUpdateManyWithoutDogInfoNestedInput>;
  microshipNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pedigree?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pedigreeNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  physicalCondition?: InputMaybe<NullableEnumDogPhysicalConditionFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DogInfoUncheckedUpdateWithoutDogBreedInput = {
  animalId?: InputMaybe<IntFieldUpdateOperationsInput>;
  breedType?: InputMaybe<EnumBreedTypeFieldUpdateOperationsInput>;
  breederId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  breederIsDogOwner?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  canStayAlone?: InputMaybe<EnumYesNoUnknownStatusFieldUpdateOperationsInput>;
  catFriendly?: InputMaybe<EnumYesNoUnknownStatusFieldUpdateOperationsInput>;
  coat?: InputMaybe<NullableEnumDogCoatFieldUpdateOperationsInput>;
  color?: InputMaybe<NullableEnumDogColorFieldUpdateOperationsInput>;
  competitionTitles?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  femaleDogFriendly?: InputMaybe<EnumYesNoUnknownStatusFieldUpdateOperationsInput>;
  healthTestsResults?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  inOption?: InputMaybe<BoolFieldUpdateOperationsInput>;
  kidsFriendly?: InputMaybe<EnumYesNoUnknownStatusFieldUpdateOperationsInput>;
  maleDogFriendly?: InputMaybe<EnumYesNoUnknownStatusFieldUpdateOperationsInput>;
  medicalAffections?: InputMaybe<DogMedicalAffectionUncheckedUpdateManyWithoutDogInfoNestedInput>;
  microshipNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pedigree?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pedigreeNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  physicalCondition?: InputMaybe<NullableEnumDogPhysicalConditionFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DogInfoUncheckedUpdateWithoutMedicalAffectionsInput = {
  animalId?: InputMaybe<IntFieldUpdateOperationsInput>;
  breedType?: InputMaybe<EnumBreedTypeFieldUpdateOperationsInput>;
  breederId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  breederIsDogOwner?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  canStayAlone?: InputMaybe<EnumYesNoUnknownStatusFieldUpdateOperationsInput>;
  catFriendly?: InputMaybe<EnumYesNoUnknownStatusFieldUpdateOperationsInput>;
  coat?: InputMaybe<NullableEnumDogCoatFieldUpdateOperationsInput>;
  color?: InputMaybe<NullableEnumDogColorFieldUpdateOperationsInput>;
  competitionTitles?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dogBreedId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  femaleDogFriendly?: InputMaybe<EnumYesNoUnknownStatusFieldUpdateOperationsInput>;
  healthTestsResults?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  inOption?: InputMaybe<BoolFieldUpdateOperationsInput>;
  kidsFriendly?: InputMaybe<EnumYesNoUnknownStatusFieldUpdateOperationsInput>;
  maleDogFriendly?: InputMaybe<EnumYesNoUnknownStatusFieldUpdateOperationsInput>;
  microshipNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pedigree?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pedigreeNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  physicalCondition?: InputMaybe<NullableEnumDogPhysicalConditionFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DogInfoUpdateInput = {
  animal?: InputMaybe<AnimalUpdateOneRequiredWithoutDogInfosNestedInput>;
  breedType?: InputMaybe<EnumBreedTypeFieldUpdateOperationsInput>;
  breeder?: InputMaybe<DogBreederUpdateOneWithoutDogInfosNestedInput>;
  breederIsDogOwner?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  canStayAlone?: InputMaybe<EnumYesNoUnknownStatusFieldUpdateOperationsInput>;
  catFriendly?: InputMaybe<EnumYesNoUnknownStatusFieldUpdateOperationsInput>;
  coat?: InputMaybe<NullableEnumDogCoatFieldUpdateOperationsInput>;
  color?: InputMaybe<NullableEnumDogColorFieldUpdateOperationsInput>;
  competitionTitles?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dogBreed?: InputMaybe<DogBreedUpdateOneWithoutDogInfosNestedInput>;
  femaleDogFriendly?: InputMaybe<EnumYesNoUnknownStatusFieldUpdateOperationsInput>;
  healthTestsResults?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  inOption?: InputMaybe<BoolFieldUpdateOperationsInput>;
  kidsFriendly?: InputMaybe<EnumYesNoUnknownStatusFieldUpdateOperationsInput>;
  maleDogFriendly?: InputMaybe<EnumYesNoUnknownStatusFieldUpdateOperationsInput>;
  medicalAffections?: InputMaybe<DogMedicalAffectionUpdateManyWithoutDogInfoNestedInput>;
  microshipNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pedigree?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pedigreeNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  physicalCondition?: InputMaybe<NullableEnumDogPhysicalConditionFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DogInfoUpdateManyMutationInput = {
  breedType?: InputMaybe<EnumBreedTypeFieldUpdateOperationsInput>;
  breederIsDogOwner?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  canStayAlone?: InputMaybe<EnumYesNoUnknownStatusFieldUpdateOperationsInput>;
  catFriendly?: InputMaybe<EnumYesNoUnknownStatusFieldUpdateOperationsInput>;
  coat?: InputMaybe<NullableEnumDogCoatFieldUpdateOperationsInput>;
  color?: InputMaybe<NullableEnumDogColorFieldUpdateOperationsInput>;
  competitionTitles?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  femaleDogFriendly?: InputMaybe<EnumYesNoUnknownStatusFieldUpdateOperationsInput>;
  healthTestsResults?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  inOption?: InputMaybe<BoolFieldUpdateOperationsInput>;
  kidsFriendly?: InputMaybe<EnumYesNoUnknownStatusFieldUpdateOperationsInput>;
  maleDogFriendly?: InputMaybe<EnumYesNoUnknownStatusFieldUpdateOperationsInput>;
  microshipNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pedigree?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pedigreeNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  physicalCondition?: InputMaybe<NullableEnumDogPhysicalConditionFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DogInfoUpdateManyWithWhereWithoutBreederInput = {
  data: DogInfoUpdateManyMutationInput;
  where: DogInfoScalarWhereInput;
};

export type DogInfoUpdateManyWithWhereWithoutDogBreedInput = {
  data: DogInfoUpdateManyMutationInput;
  where: DogInfoScalarWhereInput;
};

export type DogInfoUpdateManyWithoutBreederNestedInput = {
  connect?: InputMaybe<Array<DogInfoWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DogInfoCreateOrConnectWithoutBreederInput>>;
  create?: InputMaybe<Array<DogInfoCreateWithoutBreederInput>>;
  createMany?: InputMaybe<DogInfoCreateManyBreederInputEnvelope>;
  delete?: InputMaybe<Array<DogInfoWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<DogInfoScalarWhereInput>>;
  disconnect?: InputMaybe<Array<DogInfoWhereUniqueInput>>;
  set?: InputMaybe<Array<DogInfoWhereUniqueInput>>;
  update?: InputMaybe<Array<DogInfoUpdateWithWhereUniqueWithoutBreederInput>>;
  updateMany?: InputMaybe<Array<DogInfoUpdateManyWithWhereWithoutBreederInput>>;
  upsert?: InputMaybe<Array<DogInfoUpsertWithWhereUniqueWithoutBreederInput>>;
};

export type DogInfoUpdateManyWithoutDogBreedNestedInput = {
  connect?: InputMaybe<Array<DogInfoWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DogInfoCreateOrConnectWithoutDogBreedInput>>;
  create?: InputMaybe<Array<DogInfoCreateWithoutDogBreedInput>>;
  createMany?: InputMaybe<DogInfoCreateManyDogBreedInputEnvelope>;
  delete?: InputMaybe<Array<DogInfoWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<DogInfoScalarWhereInput>>;
  disconnect?: InputMaybe<Array<DogInfoWhereUniqueInput>>;
  set?: InputMaybe<Array<DogInfoWhereUniqueInput>>;
  update?: InputMaybe<Array<DogInfoUpdateWithWhereUniqueWithoutDogBreedInput>>;
  updateMany?: InputMaybe<Array<DogInfoUpdateManyWithWhereWithoutDogBreedInput>>;
  upsert?: InputMaybe<Array<DogInfoUpsertWithWhereUniqueWithoutDogBreedInput>>;
};

export type DogInfoUpdateOneRequiredWithoutMedicalAffectionsNestedInput = {
  connect?: InputMaybe<DogInfoWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DogInfoCreateOrConnectWithoutMedicalAffectionsInput>;
  create?: InputMaybe<DogInfoCreateWithoutMedicalAffectionsInput>;
  update?: InputMaybe<DogInfoUpdateToOneWithWhereWithoutMedicalAffectionsInput>;
  upsert?: InputMaybe<DogInfoUpsertWithoutMedicalAffectionsInput>;
};

export type DogInfoUpdateOneWithoutAnimalNestedInput = {
  connect?: InputMaybe<DogInfoWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DogInfoCreateOrConnectWithoutAnimalInput>;
  create?: InputMaybe<DogInfoCreateWithoutAnimalInput>;
  delete?: InputMaybe<DogInfoWhereInput>;
  disconnect?: InputMaybe<DogInfoWhereInput>;
  update?: InputMaybe<DogInfoUpdateToOneWithWhereWithoutAnimalInput>;
  upsert?: InputMaybe<DogInfoUpsertWithoutAnimalInput>;
};

export type DogInfoUpdateToOneWithWhereWithoutAnimalInput = {
  data: DogInfoUpdateWithoutAnimalInput;
  where?: InputMaybe<DogInfoWhereInput>;
};

export type DogInfoUpdateToOneWithWhereWithoutMedicalAffectionsInput = {
  data: DogInfoUpdateWithoutMedicalAffectionsInput;
  where?: InputMaybe<DogInfoWhereInput>;
};

export type DogInfoUpdateWithWhereUniqueWithoutBreederInput = {
  data: DogInfoUpdateWithoutBreederInput;
  where: DogInfoWhereUniqueInput;
};

export type DogInfoUpdateWithWhereUniqueWithoutDogBreedInput = {
  data: DogInfoUpdateWithoutDogBreedInput;
  where: DogInfoWhereUniqueInput;
};

export type DogInfoUpdateWithoutAnimalInput = {
  breedType?: InputMaybe<EnumBreedTypeFieldUpdateOperationsInput>;
  breeder?: InputMaybe<DogBreederUpdateOneWithoutDogInfosNestedInput>;
  breederIsDogOwner?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  canStayAlone?: InputMaybe<EnumYesNoUnknownStatusFieldUpdateOperationsInput>;
  catFriendly?: InputMaybe<EnumYesNoUnknownStatusFieldUpdateOperationsInput>;
  coat?: InputMaybe<NullableEnumDogCoatFieldUpdateOperationsInput>;
  color?: InputMaybe<NullableEnumDogColorFieldUpdateOperationsInput>;
  competitionTitles?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dogBreed?: InputMaybe<DogBreedUpdateOneWithoutDogInfosNestedInput>;
  femaleDogFriendly?: InputMaybe<EnumYesNoUnknownStatusFieldUpdateOperationsInput>;
  healthTestsResults?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  inOption?: InputMaybe<BoolFieldUpdateOperationsInput>;
  kidsFriendly?: InputMaybe<EnumYesNoUnknownStatusFieldUpdateOperationsInput>;
  maleDogFriendly?: InputMaybe<EnumYesNoUnknownStatusFieldUpdateOperationsInput>;
  medicalAffections?: InputMaybe<DogMedicalAffectionUpdateManyWithoutDogInfoNestedInput>;
  microshipNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pedigree?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pedigreeNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  physicalCondition?: InputMaybe<NullableEnumDogPhysicalConditionFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DogInfoUpdateWithoutBreederInput = {
  animal?: InputMaybe<AnimalUpdateOneRequiredWithoutDogInfosNestedInput>;
  breedType?: InputMaybe<EnumBreedTypeFieldUpdateOperationsInput>;
  breederIsDogOwner?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  canStayAlone?: InputMaybe<EnumYesNoUnknownStatusFieldUpdateOperationsInput>;
  catFriendly?: InputMaybe<EnumYesNoUnknownStatusFieldUpdateOperationsInput>;
  coat?: InputMaybe<NullableEnumDogCoatFieldUpdateOperationsInput>;
  color?: InputMaybe<NullableEnumDogColorFieldUpdateOperationsInput>;
  competitionTitles?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dogBreed?: InputMaybe<DogBreedUpdateOneWithoutDogInfosNestedInput>;
  femaleDogFriendly?: InputMaybe<EnumYesNoUnknownStatusFieldUpdateOperationsInput>;
  healthTestsResults?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  inOption?: InputMaybe<BoolFieldUpdateOperationsInput>;
  kidsFriendly?: InputMaybe<EnumYesNoUnknownStatusFieldUpdateOperationsInput>;
  maleDogFriendly?: InputMaybe<EnumYesNoUnknownStatusFieldUpdateOperationsInput>;
  medicalAffections?: InputMaybe<DogMedicalAffectionUpdateManyWithoutDogInfoNestedInput>;
  microshipNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pedigree?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pedigreeNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  physicalCondition?: InputMaybe<NullableEnumDogPhysicalConditionFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DogInfoUpdateWithoutDogBreedInput = {
  animal?: InputMaybe<AnimalUpdateOneRequiredWithoutDogInfosNestedInput>;
  breedType?: InputMaybe<EnumBreedTypeFieldUpdateOperationsInput>;
  breeder?: InputMaybe<DogBreederUpdateOneWithoutDogInfosNestedInput>;
  breederIsDogOwner?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  canStayAlone?: InputMaybe<EnumYesNoUnknownStatusFieldUpdateOperationsInput>;
  catFriendly?: InputMaybe<EnumYesNoUnknownStatusFieldUpdateOperationsInput>;
  coat?: InputMaybe<NullableEnumDogCoatFieldUpdateOperationsInput>;
  color?: InputMaybe<NullableEnumDogColorFieldUpdateOperationsInput>;
  competitionTitles?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  femaleDogFriendly?: InputMaybe<EnumYesNoUnknownStatusFieldUpdateOperationsInput>;
  healthTestsResults?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  inOption?: InputMaybe<BoolFieldUpdateOperationsInput>;
  kidsFriendly?: InputMaybe<EnumYesNoUnknownStatusFieldUpdateOperationsInput>;
  maleDogFriendly?: InputMaybe<EnumYesNoUnknownStatusFieldUpdateOperationsInput>;
  medicalAffections?: InputMaybe<DogMedicalAffectionUpdateManyWithoutDogInfoNestedInput>;
  microshipNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pedigree?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pedigreeNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  physicalCondition?: InputMaybe<NullableEnumDogPhysicalConditionFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DogInfoUpdateWithoutMedicalAffectionsInput = {
  animal?: InputMaybe<AnimalUpdateOneRequiredWithoutDogInfosNestedInput>;
  breedType?: InputMaybe<EnumBreedTypeFieldUpdateOperationsInput>;
  breeder?: InputMaybe<DogBreederUpdateOneWithoutDogInfosNestedInput>;
  breederIsDogOwner?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  canStayAlone?: InputMaybe<EnumYesNoUnknownStatusFieldUpdateOperationsInput>;
  catFriendly?: InputMaybe<EnumYesNoUnknownStatusFieldUpdateOperationsInput>;
  coat?: InputMaybe<NullableEnumDogCoatFieldUpdateOperationsInput>;
  color?: InputMaybe<NullableEnumDogColorFieldUpdateOperationsInput>;
  competitionTitles?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dogBreed?: InputMaybe<DogBreedUpdateOneWithoutDogInfosNestedInput>;
  femaleDogFriendly?: InputMaybe<EnumYesNoUnknownStatusFieldUpdateOperationsInput>;
  healthTestsResults?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  inOption?: InputMaybe<BoolFieldUpdateOperationsInput>;
  kidsFriendly?: InputMaybe<EnumYesNoUnknownStatusFieldUpdateOperationsInput>;
  maleDogFriendly?: InputMaybe<EnumYesNoUnknownStatusFieldUpdateOperationsInput>;
  microshipNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pedigree?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pedigreeNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  physicalCondition?: InputMaybe<NullableEnumDogPhysicalConditionFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DogInfoUpsertWithWhereUniqueWithoutBreederInput = {
  create: DogInfoCreateWithoutBreederInput;
  update: DogInfoUpdateWithoutBreederInput;
  where: DogInfoWhereUniqueInput;
};

export type DogInfoUpsertWithWhereUniqueWithoutDogBreedInput = {
  create: DogInfoCreateWithoutDogBreedInput;
  update: DogInfoUpdateWithoutDogBreedInput;
  where: DogInfoWhereUniqueInput;
};

export type DogInfoUpsertWithoutAnimalInput = {
  create: DogInfoCreateWithoutAnimalInput;
  update: DogInfoUpdateWithoutAnimalInput;
  where?: InputMaybe<DogInfoWhereInput>;
};

export type DogInfoUpsertWithoutMedicalAffectionsInput = {
  create: DogInfoCreateWithoutMedicalAffectionsInput;
  update: DogInfoUpdateWithoutMedicalAffectionsInput;
  where?: InputMaybe<DogInfoWhereInput>;
};

export type DogInfoWhereInput = {
  AND?: InputMaybe<Array<DogInfoWhereInput>>;
  NOT?: InputMaybe<Array<DogInfoWhereInput>>;
  OR?: InputMaybe<Array<DogInfoWhereInput>>;
  animal?: InputMaybe<AnimalRelationFilter>;
  animalId?: InputMaybe<IntFilter>;
  breedType?: InputMaybe<EnumBreedTypeFilter>;
  breeder?: InputMaybe<DogBreederNullableRelationFilter>;
  breederId?: InputMaybe<IntNullableFilter>;
  breederIsDogOwner?: InputMaybe<BoolNullableFilter>;
  canStayAlone?: InputMaybe<EnumYesNoUnknownStatusFilter>;
  catFriendly?: InputMaybe<EnumYesNoUnknownStatusFilter>;
  coat?: InputMaybe<EnumDogCoatNullableFilter>;
  color?: InputMaybe<EnumDogColorNullableFilter>;
  competitionTitles?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringNullableFilter>;
  dogBreed?: InputMaybe<DogBreedNullableRelationFilter>;
  dogBreedId?: InputMaybe<IntNullableFilter>;
  femaleDogFriendly?: InputMaybe<EnumYesNoUnknownStatusFilter>;
  healthTestsResults?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<IntFilter>;
  inOption?: InputMaybe<BoolFilter>;
  kidsFriendly?: InputMaybe<EnumYesNoUnknownStatusFilter>;
  maleDogFriendly?: InputMaybe<EnumYesNoUnknownStatusFilter>;
  medicalAffections?: InputMaybe<DogMedicalAffectionListRelationFilter>;
  microshipNumber?: InputMaybe<StringNullableFilter>;
  pedigree?: InputMaybe<StringNullableFilter>;
  pedigreeNumber?: InputMaybe<StringNullableFilter>;
  physicalCondition?: InputMaybe<EnumDogPhysicalConditionNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type DogInfoWhereUniqueInput = {
  AND?: InputMaybe<Array<DogInfoWhereInput>>;
  NOT?: InputMaybe<Array<DogInfoWhereInput>>;
  OR?: InputMaybe<Array<DogInfoWhereInput>>;
  animal?: InputMaybe<AnimalRelationFilter>;
  animalId?: InputMaybe<Scalars['Int']['input']>;
  breedType?: InputMaybe<EnumBreedTypeFilter>;
  breeder?: InputMaybe<DogBreederNullableRelationFilter>;
  breederId?: InputMaybe<IntNullableFilter>;
  breederIsDogOwner?: InputMaybe<BoolNullableFilter>;
  canStayAlone?: InputMaybe<EnumYesNoUnknownStatusFilter>;
  catFriendly?: InputMaybe<EnumYesNoUnknownStatusFilter>;
  coat?: InputMaybe<EnumDogCoatNullableFilter>;
  color?: InputMaybe<EnumDogColorNullableFilter>;
  competitionTitles?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringNullableFilter>;
  dogBreed?: InputMaybe<DogBreedNullableRelationFilter>;
  dogBreedId?: InputMaybe<IntNullableFilter>;
  femaleDogFriendly?: InputMaybe<EnumYesNoUnknownStatusFilter>;
  healthTestsResults?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  inOption?: InputMaybe<BoolFilter>;
  kidsFriendly?: InputMaybe<EnumYesNoUnknownStatusFilter>;
  maleDogFriendly?: InputMaybe<EnumYesNoUnknownStatusFilter>;
  medicalAffections?: InputMaybe<DogMedicalAffectionListRelationFilter>;
  microshipNumber?: InputMaybe<StringNullableFilter>;
  pedigree?: InputMaybe<StringNullableFilter>;
  pedigreeNumber?: InputMaybe<StringNullableFilter>;
  physicalCondition?: InputMaybe<EnumDogPhysicalConditionNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type DogMedicalAffection = {
  __typename?: 'DogMedicalAffection';
  affectionType: DogMedicalAffectionType;
  createdAt: Scalars['DateTime']['output'];
  dogInfo: DogInfo;
  dogInfoId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type DogMedicalAffectionAvgAggregateOutputType = {
  __typename?: 'DogMedicalAffectionAvgAggregateOutputType';
  dogInfoId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

export type DogMedicalAffectionAvgOrderByAggregateInput = {
  dogInfoId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export type DogMedicalAffectionCountAggregateOutputType = {
  __typename?: 'DogMedicalAffectionCountAggregateOutputType';
  _all: Scalars['Int']['output'];
  affectionType: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  dogInfoId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type DogMedicalAffectionCountOrderByAggregateInput = {
  affectionType?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  dogInfoId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type DogMedicalAffectionCreateInput = {
  affectionType: DogMedicalAffectionType;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dogInfo: DogInfoCreateNestedOneWithoutMedicalAffectionsInput;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DogMedicalAffectionCreateManyDogInfoInput = {
  affectionType: DogMedicalAffectionType;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DogMedicalAffectionCreateManyDogInfoInputEnvelope = {
  data: Array<DogMedicalAffectionCreateManyDogInfoInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DogMedicalAffectionCreateManyInput = {
  affectionType: DogMedicalAffectionType;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dogInfoId: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DogMedicalAffectionCreateNestedManyWithoutDogInfoInput = {
  connect?: InputMaybe<Array<DogMedicalAffectionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DogMedicalAffectionCreateOrConnectWithoutDogInfoInput>>;
  create?: InputMaybe<Array<DogMedicalAffectionCreateWithoutDogInfoInput>>;
  createMany?: InputMaybe<DogMedicalAffectionCreateManyDogInfoInputEnvelope>;
};

export type DogMedicalAffectionCreateOrConnectWithoutDogInfoInput = {
  create: DogMedicalAffectionCreateWithoutDogInfoInput;
  where: DogMedicalAffectionWhereUniqueInput;
};

export type DogMedicalAffectionCreateWithoutDogInfoInput = {
  affectionType: DogMedicalAffectionType;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DogMedicalAffectionListRelationFilter = {
  every?: InputMaybe<DogMedicalAffectionWhereInput>;
  none?: InputMaybe<DogMedicalAffectionWhereInput>;
  some?: InputMaybe<DogMedicalAffectionWhereInput>;
};

export type DogMedicalAffectionMaxAggregateOutputType = {
  __typename?: 'DogMedicalAffectionMaxAggregateOutputType';
  affectionType?: Maybe<DogMedicalAffectionType>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  dogInfoId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type DogMedicalAffectionMaxOrderByAggregateInput = {
  affectionType?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  dogInfoId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type DogMedicalAffectionMinAggregateOutputType = {
  __typename?: 'DogMedicalAffectionMinAggregateOutputType';
  affectionType?: Maybe<DogMedicalAffectionType>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  dogInfoId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type DogMedicalAffectionMinOrderByAggregateInput = {
  affectionType?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  dogInfoId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type DogMedicalAffectionOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type DogMedicalAffectionOrderByWithAggregationInput = {
  _avg?: InputMaybe<DogMedicalAffectionAvgOrderByAggregateInput>;
  _count?: InputMaybe<DogMedicalAffectionCountOrderByAggregateInput>;
  _max?: InputMaybe<DogMedicalAffectionMaxOrderByAggregateInput>;
  _min?: InputMaybe<DogMedicalAffectionMinOrderByAggregateInput>;
  _sum?: InputMaybe<DogMedicalAffectionSumOrderByAggregateInput>;
  affectionType?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  dogInfoId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type DogMedicalAffectionOrderByWithRelationAndSearchRelevanceInput = {
  affectionType?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  dogInfo?: InputMaybe<DogInfoOrderByWithRelationAndSearchRelevanceInput>;
  dogInfoId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum DogMedicalAffectionScalarFieldEnum {
  affectionType = 'affectionType',
  createdAt = 'createdAt',
  dogInfoId = 'dogInfoId',
  id = 'id',
  updatedAt = 'updatedAt'
}

export type DogMedicalAffectionScalarWhereInput = {
  AND?: InputMaybe<Array<DogMedicalAffectionScalarWhereInput>>;
  NOT?: InputMaybe<Array<DogMedicalAffectionScalarWhereInput>>;
  OR?: InputMaybe<Array<DogMedicalAffectionScalarWhereInput>>;
  affectionType?: InputMaybe<EnumDogMedicalAffectionTypeFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  dogInfoId?: InputMaybe<IntFilter>;
  id?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type DogMedicalAffectionScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<DogMedicalAffectionScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<DogMedicalAffectionScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<DogMedicalAffectionScalarWhereWithAggregatesInput>>;
  affectionType?: InputMaybe<EnumDogMedicalAffectionTypeWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  dogInfoId?: InputMaybe<IntWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type DogMedicalAffectionSumAggregateOutputType = {
  __typename?: 'DogMedicalAffectionSumAggregateOutputType';
  dogInfoId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
};

export type DogMedicalAffectionSumOrderByAggregateInput = {
  dogInfoId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export enum DogMedicalAffectionType {
  CARDIAC_ISSUES = 'CARDIAC_ISSUES',
  DIGESTION_ISSUES = 'DIGESTION_ISSUES',
  GESTATION_OR_NURSING = 'GESTATION_OR_NURSING',
  IMMUNE_SYSTEM_ISSUES = 'IMMUNE_SYSTEM_ISSUES',
  JOINTS_ISSUES = 'JOINTS_ISSUES',
  SKIN_ISSUES = 'SKIN_ISSUES',
  STERILIZED = 'STERILIZED',
  TEETH_ISSUES = 'TEETH_ISSUES'
}

export type DogMedicalAffectionUncheckedCreateInput = {
  affectionType: DogMedicalAffectionType;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dogInfoId: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DogMedicalAffectionUncheckedCreateNestedManyWithoutDogInfoInput = {
  connect?: InputMaybe<Array<DogMedicalAffectionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DogMedicalAffectionCreateOrConnectWithoutDogInfoInput>>;
  create?: InputMaybe<Array<DogMedicalAffectionCreateWithoutDogInfoInput>>;
  createMany?: InputMaybe<DogMedicalAffectionCreateManyDogInfoInputEnvelope>;
};

export type DogMedicalAffectionUncheckedCreateWithoutDogInfoInput = {
  affectionType: DogMedicalAffectionType;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DogMedicalAffectionUncheckedUpdateInput = {
  affectionType?: InputMaybe<EnumDogMedicalAffectionTypeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dogInfoId?: InputMaybe<IntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DogMedicalAffectionUncheckedUpdateManyInput = {
  affectionType?: InputMaybe<EnumDogMedicalAffectionTypeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dogInfoId?: InputMaybe<IntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DogMedicalAffectionUncheckedUpdateManyWithoutDogInfoInput = {
  affectionType?: InputMaybe<EnumDogMedicalAffectionTypeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DogMedicalAffectionUncheckedUpdateManyWithoutDogInfoNestedInput = {
  connect?: InputMaybe<Array<DogMedicalAffectionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DogMedicalAffectionCreateOrConnectWithoutDogInfoInput>>;
  create?: InputMaybe<Array<DogMedicalAffectionCreateWithoutDogInfoInput>>;
  createMany?: InputMaybe<DogMedicalAffectionCreateManyDogInfoInputEnvelope>;
  delete?: InputMaybe<Array<DogMedicalAffectionWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<DogMedicalAffectionScalarWhereInput>>;
  disconnect?: InputMaybe<Array<DogMedicalAffectionWhereUniqueInput>>;
  set?: InputMaybe<Array<DogMedicalAffectionWhereUniqueInput>>;
  update?: InputMaybe<Array<DogMedicalAffectionUpdateWithWhereUniqueWithoutDogInfoInput>>;
  updateMany?: InputMaybe<Array<DogMedicalAffectionUpdateManyWithWhereWithoutDogInfoInput>>;
  upsert?: InputMaybe<Array<DogMedicalAffectionUpsertWithWhereUniqueWithoutDogInfoInput>>;
};

export type DogMedicalAffectionUncheckedUpdateWithoutDogInfoInput = {
  affectionType?: InputMaybe<EnumDogMedicalAffectionTypeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DogMedicalAffectionUpdateInput = {
  affectionType?: InputMaybe<EnumDogMedicalAffectionTypeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dogInfo?: InputMaybe<DogInfoUpdateOneRequiredWithoutMedicalAffectionsNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DogMedicalAffectionUpdateManyMutationInput = {
  affectionType?: InputMaybe<EnumDogMedicalAffectionTypeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DogMedicalAffectionUpdateManyWithWhereWithoutDogInfoInput = {
  data: DogMedicalAffectionUpdateManyMutationInput;
  where: DogMedicalAffectionScalarWhereInput;
};

export type DogMedicalAffectionUpdateManyWithoutDogInfoNestedInput = {
  connect?: InputMaybe<Array<DogMedicalAffectionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DogMedicalAffectionCreateOrConnectWithoutDogInfoInput>>;
  create?: InputMaybe<Array<DogMedicalAffectionCreateWithoutDogInfoInput>>;
  createMany?: InputMaybe<DogMedicalAffectionCreateManyDogInfoInputEnvelope>;
  delete?: InputMaybe<Array<DogMedicalAffectionWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<DogMedicalAffectionScalarWhereInput>>;
  disconnect?: InputMaybe<Array<DogMedicalAffectionWhereUniqueInput>>;
  set?: InputMaybe<Array<DogMedicalAffectionWhereUniqueInput>>;
  update?: InputMaybe<Array<DogMedicalAffectionUpdateWithWhereUniqueWithoutDogInfoInput>>;
  updateMany?: InputMaybe<Array<DogMedicalAffectionUpdateManyWithWhereWithoutDogInfoInput>>;
  upsert?: InputMaybe<Array<DogMedicalAffectionUpsertWithWhereUniqueWithoutDogInfoInput>>;
};

export type DogMedicalAffectionUpdateWithWhereUniqueWithoutDogInfoInput = {
  data: DogMedicalAffectionUpdateWithoutDogInfoInput;
  where: DogMedicalAffectionWhereUniqueInput;
};

export type DogMedicalAffectionUpdateWithoutDogInfoInput = {
  affectionType?: InputMaybe<EnumDogMedicalAffectionTypeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DogMedicalAffectionUpsertWithWhereUniqueWithoutDogInfoInput = {
  create: DogMedicalAffectionCreateWithoutDogInfoInput;
  update: DogMedicalAffectionUpdateWithoutDogInfoInput;
  where: DogMedicalAffectionWhereUniqueInput;
};

export type DogMedicalAffectionWhereInput = {
  AND?: InputMaybe<Array<DogMedicalAffectionWhereInput>>;
  NOT?: InputMaybe<Array<DogMedicalAffectionWhereInput>>;
  OR?: InputMaybe<Array<DogMedicalAffectionWhereInput>>;
  affectionType?: InputMaybe<EnumDogMedicalAffectionTypeFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  dogInfo?: InputMaybe<DogInfoRelationFilter>;
  dogInfoId?: InputMaybe<IntFilter>;
  id?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type DogMedicalAffectionWhereUniqueInput = {
  AND?: InputMaybe<Array<DogMedicalAffectionWhereInput>>;
  NOT?: InputMaybe<Array<DogMedicalAffectionWhereInput>>;
  OR?: InputMaybe<Array<DogMedicalAffectionWhereInput>>;
  affectionType?: InputMaybe<EnumDogMedicalAffectionTypeFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  dogInfo?: InputMaybe<DogInfoRelationFilter>;
  dogInfoId?: InputMaybe<IntFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export enum DogPhysicalCondition {
  ATHLETIC = 'ATHLETIC',
  FAT = 'FAT',
  NORMAL = 'NORMAL',
  TINY = 'TINY'
}

export type DogPuppy = {
  __typename?: 'DogPuppy';
  breed: DogBreed;
  createdAt: Scalars['DateTime']['output'];
  dateOfBirth: Scalars['DateTime']['output'];
  gender: GenderEnum;
  id: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type DogPuppyAvgAggregateOutputType = {
  __typename?: 'DogPuppyAvgAggregateOutputType';
  breedId?: Maybe<Scalars['Float']['output']>;
  breederId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

export type DogPuppyAvgOrderByAggregateInput = {
  breedId?: InputMaybe<SortOrder>;
  breederId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export type DogPuppyCountAggregateOutputType = {
  __typename?: 'DogPuppyCountAggregateOutputType';
  _all: Scalars['Int']['output'];
  breedId: Scalars['Int']['output'];
  breederId: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  dateOfBirth: Scalars['Int']['output'];
  gender: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type DogPuppyCountOrderByAggregateInput = {
  breedId?: InputMaybe<SortOrder>;
  breederId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  dateOfBirth?: InputMaybe<SortOrder>;
  gender?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type DogPuppyCreateInput = {
  breed: DogBreedCreateNestedOneWithoutPuppiesInput;
  breeder: DogBreederCreateNestedOneWithoutPuppiesInput;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dateOfBirth: Scalars['DateTime']['input'];
  gender: GenderEnum;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DogPuppyCreateManyBreedInput = {
  breederId: Scalars['Int']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dateOfBirth: Scalars['DateTime']['input'];
  gender: GenderEnum;
  id?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DogPuppyCreateManyBreedInputEnvelope = {
  data: Array<DogPuppyCreateManyBreedInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DogPuppyCreateManyBreederInput = {
  breedId: Scalars['Int']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dateOfBirth: Scalars['DateTime']['input'];
  gender: GenderEnum;
  id?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DogPuppyCreateManyBreederInputEnvelope = {
  data: Array<DogPuppyCreateManyBreederInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DogPuppyCreateManyInput = {
  breedId: Scalars['Int']['input'];
  breederId: Scalars['Int']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dateOfBirth: Scalars['DateTime']['input'];
  gender: GenderEnum;
  id?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DogPuppyCreateNestedManyWithoutBreedInput = {
  connect?: InputMaybe<Array<DogPuppyWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DogPuppyCreateOrConnectWithoutBreedInput>>;
  create?: InputMaybe<Array<DogPuppyCreateWithoutBreedInput>>;
  createMany?: InputMaybe<DogPuppyCreateManyBreedInputEnvelope>;
};

export type DogPuppyCreateNestedManyWithoutBreederInput = {
  connect?: InputMaybe<Array<DogPuppyWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DogPuppyCreateOrConnectWithoutBreederInput>>;
  create?: InputMaybe<Array<DogPuppyCreateWithoutBreederInput>>;
  createMany?: InputMaybe<DogPuppyCreateManyBreederInputEnvelope>;
};

export type DogPuppyCreateOrConnectWithoutBreedInput = {
  create: DogPuppyCreateWithoutBreedInput;
  where: DogPuppyWhereUniqueInput;
};

export type DogPuppyCreateOrConnectWithoutBreederInput = {
  create: DogPuppyCreateWithoutBreederInput;
  where: DogPuppyWhereUniqueInput;
};

export type DogPuppyCreateWithoutBreedInput = {
  breeder: DogBreederCreateNestedOneWithoutPuppiesInput;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dateOfBirth: Scalars['DateTime']['input'];
  gender: GenderEnum;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DogPuppyCreateWithoutBreederInput = {
  breed: DogBreedCreateNestedOneWithoutPuppiesInput;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dateOfBirth: Scalars['DateTime']['input'];
  gender: GenderEnum;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DogPuppyListRelationFilter = {
  every?: InputMaybe<DogPuppyWhereInput>;
  none?: InputMaybe<DogPuppyWhereInput>;
  some?: InputMaybe<DogPuppyWhereInput>;
};

export type DogPuppyMaxAggregateOutputType = {
  __typename?: 'DogPuppyMaxAggregateOutputType';
  breedId?: Maybe<Scalars['Int']['output']>;
  breederId?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  dateOfBirth?: Maybe<Scalars['DateTime']['output']>;
  gender?: Maybe<GenderEnum>;
  id?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type DogPuppyMaxOrderByAggregateInput = {
  breedId?: InputMaybe<SortOrder>;
  breederId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  dateOfBirth?: InputMaybe<SortOrder>;
  gender?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type DogPuppyMinAggregateOutputType = {
  __typename?: 'DogPuppyMinAggregateOutputType';
  breedId?: Maybe<Scalars['Int']['output']>;
  breederId?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  dateOfBirth?: Maybe<Scalars['DateTime']['output']>;
  gender?: Maybe<GenderEnum>;
  id?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type DogPuppyMinOrderByAggregateInput = {
  breedId?: InputMaybe<SortOrder>;
  breederId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  dateOfBirth?: InputMaybe<SortOrder>;
  gender?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type DogPuppyOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type DogPuppyOrderByWithAggregationInput = {
  _avg?: InputMaybe<DogPuppyAvgOrderByAggregateInput>;
  _count?: InputMaybe<DogPuppyCountOrderByAggregateInput>;
  _max?: InputMaybe<DogPuppyMaxOrderByAggregateInput>;
  _min?: InputMaybe<DogPuppyMinOrderByAggregateInput>;
  _sum?: InputMaybe<DogPuppySumOrderByAggregateInput>;
  breedId?: InputMaybe<SortOrder>;
  breederId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  dateOfBirth?: InputMaybe<SortOrder>;
  gender?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type DogPuppyOrderByWithRelationAndSearchRelevanceInput = {
  breed?: InputMaybe<DogBreedOrderByWithRelationAndSearchRelevanceInput>;
  breedId?: InputMaybe<SortOrder>;
  breeder?: InputMaybe<DogBreederOrderByWithRelationAndSearchRelevanceInput>;
  breederId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  dateOfBirth?: InputMaybe<SortOrder>;
  gender?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum DogPuppyScalarFieldEnum {
  breedId = 'breedId',
  breederId = 'breederId',
  createdAt = 'createdAt',
  dateOfBirth = 'dateOfBirth',
  gender = 'gender',
  id = 'id',
  updatedAt = 'updatedAt'
}

export type DogPuppyScalarWhereInput = {
  AND?: InputMaybe<Array<DogPuppyScalarWhereInput>>;
  NOT?: InputMaybe<Array<DogPuppyScalarWhereInput>>;
  OR?: InputMaybe<Array<DogPuppyScalarWhereInput>>;
  breedId?: InputMaybe<IntFilter>;
  breederId?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  dateOfBirth?: InputMaybe<DateTimeFilter>;
  gender?: InputMaybe<EnumGenderEnumFilter>;
  id?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type DogPuppyScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<DogPuppyScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<DogPuppyScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<DogPuppyScalarWhereWithAggregatesInput>>;
  breedId?: InputMaybe<IntWithAggregatesFilter>;
  breederId?: InputMaybe<IntWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  dateOfBirth?: InputMaybe<DateTimeWithAggregatesFilter>;
  gender?: InputMaybe<EnumGenderEnumWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type DogPuppySumAggregateOutputType = {
  __typename?: 'DogPuppySumAggregateOutputType';
  breedId?: Maybe<Scalars['Int']['output']>;
  breederId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
};

export type DogPuppySumOrderByAggregateInput = {
  breedId?: InputMaybe<SortOrder>;
  breederId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export type DogPuppyUncheckedCreateInput = {
  breedId: Scalars['Int']['input'];
  breederId: Scalars['Int']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dateOfBirth: Scalars['DateTime']['input'];
  gender: GenderEnum;
  id?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DogPuppyUncheckedCreateNestedManyWithoutBreedInput = {
  connect?: InputMaybe<Array<DogPuppyWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DogPuppyCreateOrConnectWithoutBreedInput>>;
  create?: InputMaybe<Array<DogPuppyCreateWithoutBreedInput>>;
  createMany?: InputMaybe<DogPuppyCreateManyBreedInputEnvelope>;
};

export type DogPuppyUncheckedCreateNestedManyWithoutBreederInput = {
  connect?: InputMaybe<Array<DogPuppyWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DogPuppyCreateOrConnectWithoutBreederInput>>;
  create?: InputMaybe<Array<DogPuppyCreateWithoutBreederInput>>;
  createMany?: InputMaybe<DogPuppyCreateManyBreederInputEnvelope>;
};

export type DogPuppyUncheckedCreateWithoutBreedInput = {
  breederId: Scalars['Int']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dateOfBirth: Scalars['DateTime']['input'];
  gender: GenderEnum;
  id?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DogPuppyUncheckedCreateWithoutBreederInput = {
  breedId: Scalars['Int']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dateOfBirth: Scalars['DateTime']['input'];
  gender: GenderEnum;
  id?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DogPuppyUncheckedUpdateInput = {
  breedId?: InputMaybe<IntFieldUpdateOperationsInput>;
  breederId?: InputMaybe<IntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dateOfBirth?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  gender?: InputMaybe<EnumGenderEnumFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DogPuppyUncheckedUpdateManyInput = {
  breedId?: InputMaybe<IntFieldUpdateOperationsInput>;
  breederId?: InputMaybe<IntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dateOfBirth?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  gender?: InputMaybe<EnumGenderEnumFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DogPuppyUncheckedUpdateManyWithoutBreedInput = {
  breederId?: InputMaybe<IntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dateOfBirth?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  gender?: InputMaybe<EnumGenderEnumFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DogPuppyUncheckedUpdateManyWithoutBreedNestedInput = {
  connect?: InputMaybe<Array<DogPuppyWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DogPuppyCreateOrConnectWithoutBreedInput>>;
  create?: InputMaybe<Array<DogPuppyCreateWithoutBreedInput>>;
  createMany?: InputMaybe<DogPuppyCreateManyBreedInputEnvelope>;
  delete?: InputMaybe<Array<DogPuppyWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<DogPuppyScalarWhereInput>>;
  disconnect?: InputMaybe<Array<DogPuppyWhereUniqueInput>>;
  set?: InputMaybe<Array<DogPuppyWhereUniqueInput>>;
  update?: InputMaybe<Array<DogPuppyUpdateWithWhereUniqueWithoutBreedInput>>;
  updateMany?: InputMaybe<Array<DogPuppyUpdateManyWithWhereWithoutBreedInput>>;
  upsert?: InputMaybe<Array<DogPuppyUpsertWithWhereUniqueWithoutBreedInput>>;
};

export type DogPuppyUncheckedUpdateManyWithoutBreederInput = {
  breedId?: InputMaybe<IntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dateOfBirth?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  gender?: InputMaybe<EnumGenderEnumFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DogPuppyUncheckedUpdateManyWithoutBreederNestedInput = {
  connect?: InputMaybe<Array<DogPuppyWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DogPuppyCreateOrConnectWithoutBreederInput>>;
  create?: InputMaybe<Array<DogPuppyCreateWithoutBreederInput>>;
  createMany?: InputMaybe<DogPuppyCreateManyBreederInputEnvelope>;
  delete?: InputMaybe<Array<DogPuppyWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<DogPuppyScalarWhereInput>>;
  disconnect?: InputMaybe<Array<DogPuppyWhereUniqueInput>>;
  set?: InputMaybe<Array<DogPuppyWhereUniqueInput>>;
  update?: InputMaybe<Array<DogPuppyUpdateWithWhereUniqueWithoutBreederInput>>;
  updateMany?: InputMaybe<Array<DogPuppyUpdateManyWithWhereWithoutBreederInput>>;
  upsert?: InputMaybe<Array<DogPuppyUpsertWithWhereUniqueWithoutBreederInput>>;
};

export type DogPuppyUncheckedUpdateWithoutBreedInput = {
  breederId?: InputMaybe<IntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dateOfBirth?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  gender?: InputMaybe<EnumGenderEnumFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DogPuppyUncheckedUpdateWithoutBreederInput = {
  breedId?: InputMaybe<IntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dateOfBirth?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  gender?: InputMaybe<EnumGenderEnumFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DogPuppyUpdateInput = {
  breed?: InputMaybe<DogBreedUpdateOneRequiredWithoutPuppiesNestedInput>;
  breeder?: InputMaybe<DogBreederUpdateOneRequiredWithoutPuppiesNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dateOfBirth?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  gender?: InputMaybe<EnumGenderEnumFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DogPuppyUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dateOfBirth?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  gender?: InputMaybe<EnumGenderEnumFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DogPuppyUpdateManyWithWhereWithoutBreedInput = {
  data: DogPuppyUpdateManyMutationInput;
  where: DogPuppyScalarWhereInput;
};

export type DogPuppyUpdateManyWithWhereWithoutBreederInput = {
  data: DogPuppyUpdateManyMutationInput;
  where: DogPuppyScalarWhereInput;
};

export type DogPuppyUpdateManyWithoutBreedNestedInput = {
  connect?: InputMaybe<Array<DogPuppyWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DogPuppyCreateOrConnectWithoutBreedInput>>;
  create?: InputMaybe<Array<DogPuppyCreateWithoutBreedInput>>;
  createMany?: InputMaybe<DogPuppyCreateManyBreedInputEnvelope>;
  delete?: InputMaybe<Array<DogPuppyWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<DogPuppyScalarWhereInput>>;
  disconnect?: InputMaybe<Array<DogPuppyWhereUniqueInput>>;
  set?: InputMaybe<Array<DogPuppyWhereUniqueInput>>;
  update?: InputMaybe<Array<DogPuppyUpdateWithWhereUniqueWithoutBreedInput>>;
  updateMany?: InputMaybe<Array<DogPuppyUpdateManyWithWhereWithoutBreedInput>>;
  upsert?: InputMaybe<Array<DogPuppyUpsertWithWhereUniqueWithoutBreedInput>>;
};

export type DogPuppyUpdateManyWithoutBreederNestedInput = {
  connect?: InputMaybe<Array<DogPuppyWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DogPuppyCreateOrConnectWithoutBreederInput>>;
  create?: InputMaybe<Array<DogPuppyCreateWithoutBreederInput>>;
  createMany?: InputMaybe<DogPuppyCreateManyBreederInputEnvelope>;
  delete?: InputMaybe<Array<DogPuppyWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<DogPuppyScalarWhereInput>>;
  disconnect?: InputMaybe<Array<DogPuppyWhereUniqueInput>>;
  set?: InputMaybe<Array<DogPuppyWhereUniqueInput>>;
  update?: InputMaybe<Array<DogPuppyUpdateWithWhereUniqueWithoutBreederInput>>;
  updateMany?: InputMaybe<Array<DogPuppyUpdateManyWithWhereWithoutBreederInput>>;
  upsert?: InputMaybe<Array<DogPuppyUpsertWithWhereUniqueWithoutBreederInput>>;
};

export type DogPuppyUpdateWithWhereUniqueWithoutBreedInput = {
  data: DogPuppyUpdateWithoutBreedInput;
  where: DogPuppyWhereUniqueInput;
};

export type DogPuppyUpdateWithWhereUniqueWithoutBreederInput = {
  data: DogPuppyUpdateWithoutBreederInput;
  where: DogPuppyWhereUniqueInput;
};

export type DogPuppyUpdateWithoutBreedInput = {
  breeder?: InputMaybe<DogBreederUpdateOneRequiredWithoutPuppiesNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dateOfBirth?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  gender?: InputMaybe<EnumGenderEnumFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DogPuppyUpdateWithoutBreederInput = {
  breed?: InputMaybe<DogBreedUpdateOneRequiredWithoutPuppiesNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dateOfBirth?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  gender?: InputMaybe<EnumGenderEnumFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DogPuppyUpsertWithWhereUniqueWithoutBreedInput = {
  create: DogPuppyCreateWithoutBreedInput;
  update: DogPuppyUpdateWithoutBreedInput;
  where: DogPuppyWhereUniqueInput;
};

export type DogPuppyUpsertWithWhereUniqueWithoutBreederInput = {
  create: DogPuppyCreateWithoutBreederInput;
  update: DogPuppyUpdateWithoutBreederInput;
  where: DogPuppyWhereUniqueInput;
};

export type DogPuppyWhereInput = {
  AND?: InputMaybe<Array<DogPuppyWhereInput>>;
  NOT?: InputMaybe<Array<DogPuppyWhereInput>>;
  OR?: InputMaybe<Array<DogPuppyWhereInput>>;
  breed?: InputMaybe<DogBreedRelationFilter>;
  breedId?: InputMaybe<IntFilter>;
  breeder?: InputMaybe<DogBreederRelationFilter>;
  breederId?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  dateOfBirth?: InputMaybe<DateTimeFilter>;
  gender?: InputMaybe<EnumGenderEnumFilter>;
  id?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type DogPuppyWhereUniqueInput = {
  AND?: InputMaybe<Array<DogPuppyWhereInput>>;
  NOT?: InputMaybe<Array<DogPuppyWhereInput>>;
  OR?: InputMaybe<Array<DogPuppyWhereInput>>;
  breed?: InputMaybe<DogBreedRelationFilter>;
  breedId?: InputMaybe<IntFilter>;
  breeder?: InputMaybe<DogBreederRelationFilter>;
  breederId?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  dateOfBirth?: InputMaybe<DateTimeFilter>;
  gender?: InputMaybe<EnumGenderEnumFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type DogShelter = {
  __typename?: 'DogShelter';
  _count: DogShelterCountOutputType;
  account: Account;
  additionalInfo?: Maybe<Scalars['String']['output']>;
  address?: Maybe<Address>;
  addressId?: Maybe<Scalars['Int']['output']>;
  adminValidated?: Maybe<Scalars['Boolean']['output']>;
  agreementNumber?: Maybe<Scalars['String']['output']>;
  animals: Array<Animal>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  donationInfo?: Maybe<Scalars['String']['output']>;
  emails?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  id: Scalars['Int']['output'];
  imgs: Array<DogShelterImg>;
  links?: Maybe<Array<Maybe<DogShelterLink>>>;
  name?: Maybe<Scalars['String']['output']>;
  openingHours?: Maybe<Array<Maybe<DogShelterOpeningHours>>>;
  phoneNumbers?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  spokenLanguages: Array<Scalars['String']['output']>;
  translations: Array<DogShelterTranslation>;
  updatedAt: Scalars['DateTime']['output'];
  visitedByTipaw?: Maybe<Scalars['Boolean']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};


export type DogShelteranimalsArgs = {
  cursor?: InputMaybe<AnimalWhereUniqueInput>;
  distinct?: InputMaybe<AnimalScalarFieldEnum>;
  orderBy?: InputMaybe<AnimalOrderByWithRelationAndSearchRelevanceInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AnimalWhereInput>;
};


export type DogShelterimgsArgs = {
  cursor?: InputMaybe<DogShelterImgWhereUniqueInput>;
  distinct?: InputMaybe<DogShelterImgScalarFieldEnum>;
  orderBy?: InputMaybe<DogShelterImgOrderByWithRelationAndSearchRelevanceInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DogShelterImgWhereInput>;
};


export type DogSheltertranslationsArgs = {
  cursor?: InputMaybe<DogShelterTranslationWhereUniqueInput>;
  distinct?: InputMaybe<DogShelterTranslationScalarFieldEnum>;
  orderBy?: InputMaybe<DogShelterTranslationOrderByWithRelationAndSearchRelevanceInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DogShelterTranslationWhereInput>;
};

export type DogShelterAvgAggregateOutputType = {
  __typename?: 'DogShelterAvgAggregateOutputType';
  addressId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

export type DogShelterAvgOrderByAggregateInput = {
  addressId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export type DogShelterCountAggregateOutputType = {
  __typename?: 'DogShelterCountAggregateOutputType';
  _all: Scalars['Int']['output'];
  acceptedAnimals: Scalars['Int']['output'];
  addressId: Scalars['Int']['output'];
  adminValidated: Scalars['Int']['output'];
  agreementNumber: Scalars['Int']['output'];
  associationNumber: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  donationInfo: Scalars['Int']['output'];
  emails: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['Int']['output'];
  phoneNumbers: Scalars['Int']['output'];
  spokenLanguages: Scalars['Int']['output'];
  tags: Scalars['Int']['output'];
  type: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
  visitedByTipaw: Scalars['Int']['output'];
};

export type DogShelterCountOrderByAggregateInput = {
  acceptedAnimals?: InputMaybe<SortOrder>;
  addressId?: InputMaybe<SortOrder>;
  adminValidated?: InputMaybe<SortOrder>;
  agreementNumber?: InputMaybe<SortOrder>;
  associationNumber?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  donationInfo?: InputMaybe<SortOrder>;
  emails?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  phoneNumbers?: InputMaybe<SortOrder>;
  spokenLanguages?: InputMaybe<SortOrder>;
  tags?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  visitedByTipaw?: InputMaybe<SortOrder>;
};

export type DogShelterCountOutputType = {
  __typename?: 'DogShelterCountOutputType';
  animals: Scalars['Int']['output'];
  imgs: Scalars['Int']['output'];
  links: Scalars['Int']['output'];
  openingHours: Scalars['Int']['output'];
  translations: Scalars['Int']['output'];
};

export type DogShelterCreateInput = {
  acceptedAnimals?: InputMaybe<Array<AnimalTypeEnum>>;
  address?: InputMaybe<AddressCreateNestedOneWithoutDogShelterInput>;
  adminValidated?: InputMaybe<Scalars['Boolean']['input']>;
  agreementNumber?: InputMaybe<Scalars['String']['input']>;
  animals?: InputMaybe<AnimalCreateNestedManyWithoutDogShelterInput>;
  associationNumber?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  donationInfo?: InputMaybe<Scalars['String']['input']>;
  emails?: InputMaybe<Array<Scalars['String']['input']>>;
  imgs?: InputMaybe<DogShelterImgCreateNestedManyWithoutDogShelterInput>;
  links?: InputMaybe<DogShelterLinkCreateNestedManyWithoutDogShelterInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  openingHours?: InputMaybe<DogShelterOpeningHoursCreateNestedManyWithoutDogShelterInput>;
  phoneNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  translations?: InputMaybe<DogShelterTranslationCreateNestedManyWithoutDogShelterInput>;
  type?: InputMaybe<DogShelterType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  visitedByTipaw?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DogShelterCreateManyInput = {
  acceptedAnimals?: InputMaybe<Array<AnimalTypeEnum>>;
  addressId?: InputMaybe<Scalars['Int']['input']>;
  adminValidated?: InputMaybe<Scalars['Boolean']['input']>;
  agreementNumber?: InputMaybe<Scalars['String']['input']>;
  associationNumber?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  donationInfo?: InputMaybe<Scalars['String']['input']>;
  emails?: InputMaybe<Array<Scalars['String']['input']>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phoneNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<DogShelterType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  visitedByTipaw?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DogShelterCreateNestedOneWithoutAddressInput = {
  connect?: InputMaybe<DogShelterWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DogShelterCreateOrConnectWithoutAddressInput>;
  create?: InputMaybe<DogShelterCreateWithoutAddressInput>;
};

export type DogShelterCreateNestedOneWithoutAnimalsInput = {
  connect?: InputMaybe<DogShelterWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DogShelterCreateOrConnectWithoutAnimalsInput>;
  create?: InputMaybe<DogShelterCreateWithoutAnimalsInput>;
};

export type DogShelterCreateNestedOneWithoutImgsInput = {
  connect?: InputMaybe<DogShelterWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DogShelterCreateOrConnectWithoutImgsInput>;
  create?: InputMaybe<DogShelterCreateWithoutImgsInput>;
};

export type DogShelterCreateNestedOneWithoutLinksInput = {
  connect?: InputMaybe<DogShelterWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DogShelterCreateOrConnectWithoutLinksInput>;
  create?: InputMaybe<DogShelterCreateWithoutLinksInput>;
};

export type DogShelterCreateNestedOneWithoutOpeningHoursInput = {
  connect?: InputMaybe<DogShelterWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DogShelterCreateOrConnectWithoutOpeningHoursInput>;
  create?: InputMaybe<DogShelterCreateWithoutOpeningHoursInput>;
};

export type DogShelterCreateNestedOneWithoutTranslationsInput = {
  connect?: InputMaybe<DogShelterWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DogShelterCreateOrConnectWithoutTranslationsInput>;
  create?: InputMaybe<DogShelterCreateWithoutTranslationsInput>;
};

export type DogShelterCreateOrConnectWithoutAddressInput = {
  create: DogShelterCreateWithoutAddressInput;
  where: DogShelterWhereUniqueInput;
};

export type DogShelterCreateOrConnectWithoutAnimalsInput = {
  create: DogShelterCreateWithoutAnimalsInput;
  where: DogShelterWhereUniqueInput;
};

export type DogShelterCreateOrConnectWithoutImgsInput = {
  create: DogShelterCreateWithoutImgsInput;
  where: DogShelterWhereUniqueInput;
};

export type DogShelterCreateOrConnectWithoutLinksInput = {
  create: DogShelterCreateWithoutLinksInput;
  where: DogShelterWhereUniqueInput;
};

export type DogShelterCreateOrConnectWithoutOpeningHoursInput = {
  create: DogShelterCreateWithoutOpeningHoursInput;
  where: DogShelterWhereUniqueInput;
};

export type DogShelterCreateOrConnectWithoutTranslationsInput = {
  create: DogShelterCreateWithoutTranslationsInput;
  where: DogShelterWhereUniqueInput;
};

export type DogShelterCreateWithoutAddressInput = {
  acceptedAnimals?: InputMaybe<Array<AnimalTypeEnum>>;
  adminValidated?: InputMaybe<Scalars['Boolean']['input']>;
  agreementNumber?: InputMaybe<Scalars['String']['input']>;
  animals?: InputMaybe<AnimalCreateNestedManyWithoutDogShelterInput>;
  associationNumber?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  donationInfo?: InputMaybe<Scalars['String']['input']>;
  emails?: InputMaybe<Array<Scalars['String']['input']>>;
  imgs?: InputMaybe<DogShelterImgCreateNestedManyWithoutDogShelterInput>;
  links?: InputMaybe<DogShelterLinkCreateNestedManyWithoutDogShelterInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  openingHours?: InputMaybe<DogShelterOpeningHoursCreateNestedManyWithoutDogShelterInput>;
  phoneNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  translations?: InputMaybe<DogShelterTranslationCreateNestedManyWithoutDogShelterInput>;
  type?: InputMaybe<DogShelterType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  visitedByTipaw?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DogShelterCreateWithoutAnimalsInput = {
  acceptedAnimals?: InputMaybe<Array<AnimalTypeEnum>>;
  address?: InputMaybe<AddressCreateNestedOneWithoutDogShelterInput>;
  adminValidated?: InputMaybe<Scalars['Boolean']['input']>;
  agreementNumber?: InputMaybe<Scalars['String']['input']>;
  associationNumber?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  donationInfo?: InputMaybe<Scalars['String']['input']>;
  emails?: InputMaybe<Array<Scalars['String']['input']>>;
  imgs?: InputMaybe<DogShelterImgCreateNestedManyWithoutDogShelterInput>;
  links?: InputMaybe<DogShelterLinkCreateNestedManyWithoutDogShelterInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  openingHours?: InputMaybe<DogShelterOpeningHoursCreateNestedManyWithoutDogShelterInput>;
  phoneNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  translations?: InputMaybe<DogShelterTranslationCreateNestedManyWithoutDogShelterInput>;
  type?: InputMaybe<DogShelterType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  visitedByTipaw?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DogShelterCreateWithoutImgsInput = {
  acceptedAnimals?: InputMaybe<Array<AnimalTypeEnum>>;
  address?: InputMaybe<AddressCreateNestedOneWithoutDogShelterInput>;
  adminValidated?: InputMaybe<Scalars['Boolean']['input']>;
  agreementNumber?: InputMaybe<Scalars['String']['input']>;
  animals?: InputMaybe<AnimalCreateNestedManyWithoutDogShelterInput>;
  associationNumber?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  donationInfo?: InputMaybe<Scalars['String']['input']>;
  emails?: InputMaybe<Array<Scalars['String']['input']>>;
  links?: InputMaybe<DogShelterLinkCreateNestedManyWithoutDogShelterInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  openingHours?: InputMaybe<DogShelterOpeningHoursCreateNestedManyWithoutDogShelterInput>;
  phoneNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  translations?: InputMaybe<DogShelterTranslationCreateNestedManyWithoutDogShelterInput>;
  type?: InputMaybe<DogShelterType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  visitedByTipaw?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DogShelterCreateWithoutLinksInput = {
  acceptedAnimals?: InputMaybe<Array<AnimalTypeEnum>>;
  address?: InputMaybe<AddressCreateNestedOneWithoutDogShelterInput>;
  adminValidated?: InputMaybe<Scalars['Boolean']['input']>;
  agreementNumber?: InputMaybe<Scalars['String']['input']>;
  animals?: InputMaybe<AnimalCreateNestedManyWithoutDogShelterInput>;
  associationNumber?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  donationInfo?: InputMaybe<Scalars['String']['input']>;
  emails?: InputMaybe<Array<Scalars['String']['input']>>;
  imgs?: InputMaybe<DogShelterImgCreateNestedManyWithoutDogShelterInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  openingHours?: InputMaybe<DogShelterOpeningHoursCreateNestedManyWithoutDogShelterInput>;
  phoneNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  translations?: InputMaybe<DogShelterTranslationCreateNestedManyWithoutDogShelterInput>;
  type?: InputMaybe<DogShelterType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  visitedByTipaw?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DogShelterCreateWithoutOpeningHoursInput = {
  acceptedAnimals?: InputMaybe<Array<AnimalTypeEnum>>;
  address?: InputMaybe<AddressCreateNestedOneWithoutDogShelterInput>;
  adminValidated?: InputMaybe<Scalars['Boolean']['input']>;
  agreementNumber?: InputMaybe<Scalars['String']['input']>;
  animals?: InputMaybe<AnimalCreateNestedManyWithoutDogShelterInput>;
  associationNumber?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  donationInfo?: InputMaybe<Scalars['String']['input']>;
  emails?: InputMaybe<Array<Scalars['String']['input']>>;
  imgs?: InputMaybe<DogShelterImgCreateNestedManyWithoutDogShelterInput>;
  links?: InputMaybe<DogShelterLinkCreateNestedManyWithoutDogShelterInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  phoneNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  translations?: InputMaybe<DogShelterTranslationCreateNestedManyWithoutDogShelterInput>;
  type?: InputMaybe<DogShelterType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  visitedByTipaw?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DogShelterCreateWithoutTranslationsInput = {
  acceptedAnimals?: InputMaybe<Array<AnimalTypeEnum>>;
  address?: InputMaybe<AddressCreateNestedOneWithoutDogShelterInput>;
  adminValidated?: InputMaybe<Scalars['Boolean']['input']>;
  agreementNumber?: InputMaybe<Scalars['String']['input']>;
  animals?: InputMaybe<AnimalCreateNestedManyWithoutDogShelterInput>;
  associationNumber?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  donationInfo?: InputMaybe<Scalars['String']['input']>;
  emails?: InputMaybe<Array<Scalars['String']['input']>>;
  imgs?: InputMaybe<DogShelterImgCreateNestedManyWithoutDogShelterInput>;
  links?: InputMaybe<DogShelterLinkCreateNestedManyWithoutDogShelterInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  openingHours?: InputMaybe<DogShelterOpeningHoursCreateNestedManyWithoutDogShelterInput>;
  phoneNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<DogShelterType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  visitedByTipaw?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DogShelterCreateacceptedAnimalsInput = {
  set: Array<AnimalTypeEnum>;
};

export type DogShelterCreateemailsInput = {
  set: Array<Scalars['String']['input']>;
};

export type DogShelterCreatephoneNumbersInput = {
  set: Array<Scalars['String']['input']>;
};

export type DogShelterCreatespokenLanguagesInput = {
  set: Array<Scalars['String']['input']>;
};

export type DogShelterCreatetagsInput = {
  set: Array<Scalars['String']['input']>;
};

export type DogShelterImg = {
  __typename?: 'DogShelterImg';
  createdAt: Scalars['DateTime']['output'];
  dogShelter: DogShelter;
  dogShelterId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  large?: Maybe<Scalars['String']['output']>;
  medium?: Maybe<Scalars['String']['output']>;
  small?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type DogShelterImgAvgAggregateOutputType = {
  __typename?: 'DogShelterImgAvgAggregateOutputType';
  dogShelterId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

export type DogShelterImgAvgOrderByAggregateInput = {
  dogShelterId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export type DogShelterImgCountAggregateOutputType = {
  __typename?: 'DogShelterImgCountAggregateOutputType';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  dogShelterId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  large: Scalars['Int']['output'];
  medium: Scalars['Int']['output'];
  small: Scalars['Int']['output'];
  type: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type DogShelterImgCountOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  dogShelterId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  large?: InputMaybe<SortOrder>;
  medium?: InputMaybe<SortOrder>;
  small?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type DogShelterImgCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dogShelter: DogShelterCreateNestedOneWithoutImgsInput;
  large?: InputMaybe<Scalars['String']['input']>;
  medium?: InputMaybe<Scalars['String']['input']>;
  small?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DogShelterImgCreateManyDogShelterInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  large?: InputMaybe<Scalars['String']['input']>;
  medium?: InputMaybe<Scalars['String']['input']>;
  small?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DogShelterImgCreateManyDogShelterInputEnvelope = {
  data: Array<DogShelterImgCreateManyDogShelterInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DogShelterImgCreateManyInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dogShelterId: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  large?: InputMaybe<Scalars['String']['input']>;
  medium?: InputMaybe<Scalars['String']['input']>;
  small?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DogShelterImgCreateNestedManyWithoutDogShelterInput = {
  connect?: InputMaybe<Array<DogShelterImgWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DogShelterImgCreateOrConnectWithoutDogShelterInput>>;
  create?: InputMaybe<Array<DogShelterImgCreateWithoutDogShelterInput>>;
  createMany?: InputMaybe<DogShelterImgCreateManyDogShelterInputEnvelope>;
};

export type DogShelterImgCreateOrConnectWithoutDogShelterInput = {
  create: DogShelterImgCreateWithoutDogShelterInput;
  where: DogShelterImgWhereUniqueInput;
};

export type DogShelterImgCreateWithoutDogShelterInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  large?: InputMaybe<Scalars['String']['input']>;
  medium?: InputMaybe<Scalars['String']['input']>;
  small?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DogShelterImgListRelationFilter = {
  every?: InputMaybe<DogShelterImgWhereInput>;
  none?: InputMaybe<DogShelterImgWhereInput>;
  some?: InputMaybe<DogShelterImgWhereInput>;
};

export type DogShelterImgMaxAggregateOutputType = {
  __typename?: 'DogShelterImgMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  dogShelterId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  large?: Maybe<Scalars['String']['output']>;
  medium?: Maybe<Scalars['String']['output']>;
  small?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type DogShelterImgMaxOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  dogShelterId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  large?: InputMaybe<SortOrder>;
  medium?: InputMaybe<SortOrder>;
  small?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type DogShelterImgMinAggregateOutputType = {
  __typename?: 'DogShelterImgMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  dogShelterId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  large?: Maybe<Scalars['String']['output']>;
  medium?: Maybe<Scalars['String']['output']>;
  small?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type DogShelterImgMinOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  dogShelterId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  large?: InputMaybe<SortOrder>;
  medium?: InputMaybe<SortOrder>;
  small?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type DogShelterImgOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export enum DogShelterImgOrderByRelevanceFieldEnum {
  large = 'large',
  medium = 'medium',
  small = 'small',
  type = 'type'
}

export type DogShelterImgOrderByRelevanceInput = {
  fields: Array<DogShelterImgOrderByRelevanceFieldEnum>;
  search: Scalars['String']['input'];
  sort: SortOrder;
};

export type DogShelterImgOrderByWithAggregationInput = {
  _avg?: InputMaybe<DogShelterImgAvgOrderByAggregateInput>;
  _count?: InputMaybe<DogShelterImgCountOrderByAggregateInput>;
  _max?: InputMaybe<DogShelterImgMaxOrderByAggregateInput>;
  _min?: InputMaybe<DogShelterImgMinOrderByAggregateInput>;
  _sum?: InputMaybe<DogShelterImgSumOrderByAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  dogShelterId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  large?: InputMaybe<SortOrderInput>;
  medium?: InputMaybe<SortOrderInput>;
  small?: InputMaybe<SortOrderInput>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type DogShelterImgOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: InputMaybe<DogShelterImgOrderByRelevanceInput>;
  createdAt?: InputMaybe<SortOrder>;
  dogShelter?: InputMaybe<DogShelterOrderByWithRelationAndSearchRelevanceInput>;
  dogShelterId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  large?: InputMaybe<SortOrderInput>;
  medium?: InputMaybe<SortOrderInput>;
  small?: InputMaybe<SortOrderInput>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum DogShelterImgScalarFieldEnum {
  createdAt = 'createdAt',
  dogShelterId = 'dogShelterId',
  id = 'id',
  large = 'large',
  medium = 'medium',
  small = 'small',
  type = 'type',
  updatedAt = 'updatedAt'
}

export type DogShelterImgScalarWhereInput = {
  AND?: InputMaybe<Array<DogShelterImgScalarWhereInput>>;
  NOT?: InputMaybe<Array<DogShelterImgScalarWhereInput>>;
  OR?: InputMaybe<Array<DogShelterImgScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  dogShelterId?: InputMaybe<IntFilter>;
  id?: InputMaybe<IntFilter>;
  large?: InputMaybe<StringNullableFilter>;
  medium?: InputMaybe<StringNullableFilter>;
  small?: InputMaybe<StringNullableFilter>;
  type?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type DogShelterImgScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<DogShelterImgScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<DogShelterImgScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<DogShelterImgScalarWhereWithAggregatesInput>>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  dogShelterId?: InputMaybe<IntWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  large?: InputMaybe<StringNullableWithAggregatesFilter>;
  medium?: InputMaybe<StringNullableWithAggregatesFilter>;
  small?: InputMaybe<StringNullableWithAggregatesFilter>;
  type?: InputMaybe<StringWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type DogShelterImgSumAggregateOutputType = {
  __typename?: 'DogShelterImgSumAggregateOutputType';
  dogShelterId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
};

export type DogShelterImgSumOrderByAggregateInput = {
  dogShelterId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export type DogShelterImgUncheckedCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dogShelterId: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  large?: InputMaybe<Scalars['String']['input']>;
  medium?: InputMaybe<Scalars['String']['input']>;
  small?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DogShelterImgUncheckedCreateNestedManyWithoutDogShelterInput = {
  connect?: InputMaybe<Array<DogShelterImgWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DogShelterImgCreateOrConnectWithoutDogShelterInput>>;
  create?: InputMaybe<Array<DogShelterImgCreateWithoutDogShelterInput>>;
  createMany?: InputMaybe<DogShelterImgCreateManyDogShelterInputEnvelope>;
};

export type DogShelterImgUncheckedCreateWithoutDogShelterInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  large?: InputMaybe<Scalars['String']['input']>;
  medium?: InputMaybe<Scalars['String']['input']>;
  small?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DogShelterImgUncheckedUpdateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dogShelterId?: InputMaybe<IntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  large?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  medium?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  small?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DogShelterImgUncheckedUpdateManyInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dogShelterId?: InputMaybe<IntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  large?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  medium?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  small?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DogShelterImgUncheckedUpdateManyWithoutDogShelterInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  large?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  medium?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  small?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DogShelterImgUncheckedUpdateManyWithoutDogShelterNestedInput = {
  connect?: InputMaybe<Array<DogShelterImgWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DogShelterImgCreateOrConnectWithoutDogShelterInput>>;
  create?: InputMaybe<Array<DogShelterImgCreateWithoutDogShelterInput>>;
  createMany?: InputMaybe<DogShelterImgCreateManyDogShelterInputEnvelope>;
  delete?: InputMaybe<Array<DogShelterImgWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<DogShelterImgScalarWhereInput>>;
  disconnect?: InputMaybe<Array<DogShelterImgWhereUniqueInput>>;
  set?: InputMaybe<Array<DogShelterImgWhereUniqueInput>>;
  update?: InputMaybe<Array<DogShelterImgUpdateWithWhereUniqueWithoutDogShelterInput>>;
  updateMany?: InputMaybe<Array<DogShelterImgUpdateManyWithWhereWithoutDogShelterInput>>;
  upsert?: InputMaybe<Array<DogShelterImgUpsertWithWhereUniqueWithoutDogShelterInput>>;
};

export type DogShelterImgUncheckedUpdateWithoutDogShelterInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  large?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  medium?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  small?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DogShelterImgUpdateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dogShelter?: InputMaybe<DogShelterUpdateOneRequiredWithoutImgsNestedInput>;
  large?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  medium?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  small?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DogShelterImgUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  large?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  medium?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  small?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DogShelterImgUpdateManyWithWhereWithoutDogShelterInput = {
  data: DogShelterImgUpdateManyMutationInput;
  where: DogShelterImgScalarWhereInput;
};

export type DogShelterImgUpdateManyWithoutDogShelterNestedInput = {
  connect?: InputMaybe<Array<DogShelterImgWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DogShelterImgCreateOrConnectWithoutDogShelterInput>>;
  create?: InputMaybe<Array<DogShelterImgCreateWithoutDogShelterInput>>;
  createMany?: InputMaybe<DogShelterImgCreateManyDogShelterInputEnvelope>;
  delete?: InputMaybe<Array<DogShelterImgWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<DogShelterImgScalarWhereInput>>;
  disconnect?: InputMaybe<Array<DogShelterImgWhereUniqueInput>>;
  set?: InputMaybe<Array<DogShelterImgWhereUniqueInput>>;
  update?: InputMaybe<Array<DogShelterImgUpdateWithWhereUniqueWithoutDogShelterInput>>;
  updateMany?: InputMaybe<Array<DogShelterImgUpdateManyWithWhereWithoutDogShelterInput>>;
  upsert?: InputMaybe<Array<DogShelterImgUpsertWithWhereUniqueWithoutDogShelterInput>>;
};

export type DogShelterImgUpdateWithWhereUniqueWithoutDogShelterInput = {
  data: DogShelterImgUpdateWithoutDogShelterInput;
  where: DogShelterImgWhereUniqueInput;
};

export type DogShelterImgUpdateWithoutDogShelterInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  large?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  medium?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  small?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DogShelterImgUpsertWithWhereUniqueWithoutDogShelterInput = {
  create: DogShelterImgCreateWithoutDogShelterInput;
  update: DogShelterImgUpdateWithoutDogShelterInput;
  where: DogShelterImgWhereUniqueInput;
};

export type DogShelterImgWhereInput = {
  AND?: InputMaybe<Array<DogShelterImgWhereInput>>;
  NOT?: InputMaybe<Array<DogShelterImgWhereInput>>;
  OR?: InputMaybe<Array<DogShelterImgWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  dogShelter?: InputMaybe<DogShelterRelationFilter>;
  dogShelterId?: InputMaybe<IntFilter>;
  id?: InputMaybe<IntFilter>;
  large?: InputMaybe<StringNullableFilter>;
  medium?: InputMaybe<StringNullableFilter>;
  small?: InputMaybe<StringNullableFilter>;
  type?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type DogShelterImgWhereUniqueInput = {
  AND?: InputMaybe<Array<DogShelterImgWhereInput>>;
  NOT?: InputMaybe<Array<DogShelterImgWhereInput>>;
  OR?: InputMaybe<Array<DogShelterImgWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  dogShelter?: InputMaybe<DogShelterRelationFilter>;
  dogShelterId?: InputMaybe<IntFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  large?: InputMaybe<StringNullableFilter>;
  medium?: InputMaybe<StringNullableFilter>;
  small?: InputMaybe<StringNullableFilter>;
  type?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type DogShelterLink = {
  __typename?: 'DogShelterLink';
  link?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type DogShelterLinkAvgAggregateOutputType = {
  __typename?: 'DogShelterLinkAvgAggregateOutputType';
  dogShelterId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

export type DogShelterLinkAvgOrderByAggregateInput = {
  dogShelterId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export type DogShelterLinkCountAggregateOutputType = {
  __typename?: 'DogShelterLinkCountAggregateOutputType';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  dogShelterId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  link: Scalars['Int']['output'];
  name: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type DogShelterLinkCountOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  dogShelterId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  link?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type DogShelterLinkCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dogShelter: DogShelterCreateNestedOneWithoutLinksInput;
  link: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DogShelterLinkCreateManyDogShelterInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  link: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DogShelterLinkCreateManyDogShelterInputEnvelope = {
  data: Array<DogShelterLinkCreateManyDogShelterInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DogShelterLinkCreateManyInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dogShelterId: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  link: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DogShelterLinkCreateNestedManyWithoutDogShelterInput = {
  connect?: InputMaybe<Array<DogShelterLinkWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DogShelterLinkCreateOrConnectWithoutDogShelterInput>>;
  create?: InputMaybe<Array<DogShelterLinkCreateWithoutDogShelterInput>>;
  createMany?: InputMaybe<DogShelterLinkCreateManyDogShelterInputEnvelope>;
};

export type DogShelterLinkCreateOrConnectWithoutDogShelterInput = {
  create: DogShelterLinkCreateWithoutDogShelterInput;
  where: DogShelterLinkWhereUniqueInput;
};

export type DogShelterLinkCreateWithoutDogShelterInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  link: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DogShelterLinkListRelationFilter = {
  every?: InputMaybe<DogShelterLinkWhereInput>;
  none?: InputMaybe<DogShelterLinkWhereInput>;
  some?: InputMaybe<DogShelterLinkWhereInput>;
};

export type DogShelterLinkMaxAggregateOutputType = {
  __typename?: 'DogShelterLinkMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  dogShelterId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type DogShelterLinkMaxOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  dogShelterId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  link?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type DogShelterLinkMinAggregateOutputType = {
  __typename?: 'DogShelterLinkMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  dogShelterId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type DogShelterLinkMinOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  dogShelterId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  link?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type DogShelterLinkOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export enum DogShelterLinkOrderByRelevanceFieldEnum {
  link = 'link',
  name = 'name'
}

export type DogShelterLinkOrderByRelevanceInput = {
  fields: Array<DogShelterLinkOrderByRelevanceFieldEnum>;
  search: Scalars['String']['input'];
  sort: SortOrder;
};

export type DogShelterLinkOrderByWithAggregationInput = {
  _avg?: InputMaybe<DogShelterLinkAvgOrderByAggregateInput>;
  _count?: InputMaybe<DogShelterLinkCountOrderByAggregateInput>;
  _max?: InputMaybe<DogShelterLinkMaxOrderByAggregateInput>;
  _min?: InputMaybe<DogShelterLinkMinOrderByAggregateInput>;
  _sum?: InputMaybe<DogShelterLinkSumOrderByAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  dogShelterId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  link?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type DogShelterLinkOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: InputMaybe<DogShelterLinkOrderByRelevanceInput>;
  createdAt?: InputMaybe<SortOrder>;
  dogShelter?: InputMaybe<DogShelterOrderByWithRelationAndSearchRelevanceInput>;
  dogShelterId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  link?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum DogShelterLinkScalarFieldEnum {
  createdAt = 'createdAt',
  dogShelterId = 'dogShelterId',
  id = 'id',
  link = 'link',
  name = 'name',
  updatedAt = 'updatedAt'
}

export type DogShelterLinkScalarWhereInput = {
  AND?: InputMaybe<Array<DogShelterLinkScalarWhereInput>>;
  NOT?: InputMaybe<Array<DogShelterLinkScalarWhereInput>>;
  OR?: InputMaybe<Array<DogShelterLinkScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  dogShelterId?: InputMaybe<IntFilter>;
  id?: InputMaybe<IntFilter>;
  link?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type DogShelterLinkScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<DogShelterLinkScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<DogShelterLinkScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<DogShelterLinkScalarWhereWithAggregatesInput>>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  dogShelterId?: InputMaybe<IntWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  link?: InputMaybe<StringWithAggregatesFilter>;
  name?: InputMaybe<StringNullableWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type DogShelterLinkSumAggregateOutputType = {
  __typename?: 'DogShelterLinkSumAggregateOutputType';
  dogShelterId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
};

export type DogShelterLinkSumOrderByAggregateInput = {
  dogShelterId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export type DogShelterLinkUncheckedCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dogShelterId: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  link: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DogShelterLinkUncheckedCreateNestedManyWithoutDogShelterInput = {
  connect?: InputMaybe<Array<DogShelterLinkWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DogShelterLinkCreateOrConnectWithoutDogShelterInput>>;
  create?: InputMaybe<Array<DogShelterLinkCreateWithoutDogShelterInput>>;
  createMany?: InputMaybe<DogShelterLinkCreateManyDogShelterInputEnvelope>;
};

export type DogShelterLinkUncheckedCreateWithoutDogShelterInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  link: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DogShelterLinkUncheckedUpdateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dogShelterId?: InputMaybe<IntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  link?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DogShelterLinkUncheckedUpdateManyInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dogShelterId?: InputMaybe<IntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  link?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DogShelterLinkUncheckedUpdateManyWithoutDogShelterInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  link?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DogShelterLinkUncheckedUpdateManyWithoutDogShelterNestedInput = {
  connect?: InputMaybe<Array<DogShelterLinkWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DogShelterLinkCreateOrConnectWithoutDogShelterInput>>;
  create?: InputMaybe<Array<DogShelterLinkCreateWithoutDogShelterInput>>;
  createMany?: InputMaybe<DogShelterLinkCreateManyDogShelterInputEnvelope>;
  delete?: InputMaybe<Array<DogShelterLinkWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<DogShelterLinkScalarWhereInput>>;
  disconnect?: InputMaybe<Array<DogShelterLinkWhereUniqueInput>>;
  set?: InputMaybe<Array<DogShelterLinkWhereUniqueInput>>;
  update?: InputMaybe<Array<DogShelterLinkUpdateWithWhereUniqueWithoutDogShelterInput>>;
  updateMany?: InputMaybe<Array<DogShelterLinkUpdateManyWithWhereWithoutDogShelterInput>>;
  upsert?: InputMaybe<Array<DogShelterLinkUpsertWithWhereUniqueWithoutDogShelterInput>>;
};

export type DogShelterLinkUncheckedUpdateWithoutDogShelterInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  link?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DogShelterLinkUpdateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dogShelter?: InputMaybe<DogShelterUpdateOneRequiredWithoutLinksNestedInput>;
  link?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DogShelterLinkUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  link?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DogShelterLinkUpdateManyWithWhereWithoutDogShelterInput = {
  data: DogShelterLinkUpdateManyMutationInput;
  where: DogShelterLinkScalarWhereInput;
};

export type DogShelterLinkUpdateManyWithoutDogShelterNestedInput = {
  connect?: InputMaybe<Array<DogShelterLinkWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DogShelterLinkCreateOrConnectWithoutDogShelterInput>>;
  create?: InputMaybe<Array<DogShelterLinkCreateWithoutDogShelterInput>>;
  createMany?: InputMaybe<DogShelterLinkCreateManyDogShelterInputEnvelope>;
  delete?: InputMaybe<Array<DogShelterLinkWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<DogShelterLinkScalarWhereInput>>;
  disconnect?: InputMaybe<Array<DogShelterLinkWhereUniqueInput>>;
  set?: InputMaybe<Array<DogShelterLinkWhereUniqueInput>>;
  update?: InputMaybe<Array<DogShelterLinkUpdateWithWhereUniqueWithoutDogShelterInput>>;
  updateMany?: InputMaybe<Array<DogShelterLinkUpdateManyWithWhereWithoutDogShelterInput>>;
  upsert?: InputMaybe<Array<DogShelterLinkUpsertWithWhereUniqueWithoutDogShelterInput>>;
};

export type DogShelterLinkUpdateWithWhereUniqueWithoutDogShelterInput = {
  data: DogShelterLinkUpdateWithoutDogShelterInput;
  where: DogShelterLinkWhereUniqueInput;
};

export type DogShelterLinkUpdateWithoutDogShelterInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  link?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DogShelterLinkUpsertWithWhereUniqueWithoutDogShelterInput = {
  create: DogShelterLinkCreateWithoutDogShelterInput;
  update: DogShelterLinkUpdateWithoutDogShelterInput;
  where: DogShelterLinkWhereUniqueInput;
};

export type DogShelterLinkWhereInput = {
  AND?: InputMaybe<Array<DogShelterLinkWhereInput>>;
  NOT?: InputMaybe<Array<DogShelterLinkWhereInput>>;
  OR?: InputMaybe<Array<DogShelterLinkWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  dogShelter?: InputMaybe<DogShelterRelationFilter>;
  dogShelterId?: InputMaybe<IntFilter>;
  id?: InputMaybe<IntFilter>;
  link?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type DogShelterLinkWhereUniqueInput = {
  AND?: InputMaybe<Array<DogShelterLinkWhereInput>>;
  NOT?: InputMaybe<Array<DogShelterLinkWhereInput>>;
  OR?: InputMaybe<Array<DogShelterLinkWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  dogShelter?: InputMaybe<DogShelterRelationFilter>;
  dogShelterId?: InputMaybe<IntFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  link?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type DogShelterMaxAggregateOutputType = {
  __typename?: 'DogShelterMaxAggregateOutputType';
  addressId?: Maybe<Scalars['Int']['output']>;
  adminValidated?: Maybe<Scalars['Boolean']['output']>;
  agreementNumber?: Maybe<Scalars['String']['output']>;
  associationNumber?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  donationInfo?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<DogShelterType>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  visitedByTipaw?: Maybe<Scalars['Boolean']['output']>;
};

export type DogShelterMaxOrderByAggregateInput = {
  addressId?: InputMaybe<SortOrder>;
  adminValidated?: InputMaybe<SortOrder>;
  agreementNumber?: InputMaybe<SortOrder>;
  associationNumber?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  donationInfo?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  visitedByTipaw?: InputMaybe<SortOrder>;
};

export type DogShelterMinAggregateOutputType = {
  __typename?: 'DogShelterMinAggregateOutputType';
  addressId?: Maybe<Scalars['Int']['output']>;
  adminValidated?: Maybe<Scalars['Boolean']['output']>;
  agreementNumber?: Maybe<Scalars['String']['output']>;
  associationNumber?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  donationInfo?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<DogShelterType>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  visitedByTipaw?: Maybe<Scalars['Boolean']['output']>;
};

export type DogShelterMinOrderByAggregateInput = {
  addressId?: InputMaybe<SortOrder>;
  adminValidated?: InputMaybe<SortOrder>;
  agreementNumber?: InputMaybe<SortOrder>;
  associationNumber?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  donationInfo?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  visitedByTipaw?: InputMaybe<SortOrder>;
};

export type DogShelterNullableRelationFilter = {
  is?: InputMaybe<DogShelterWhereInput>;
  isNot?: InputMaybe<DogShelterWhereInput>;
};

export type DogShelterOpeningHours = {
  __typename?: 'DogShelterOpeningHours';
  dayOfWeek?: Maybe<DayOfWeek>;
  endTime?: Maybe<Scalars['String']['output']>;
  startTime?: Maybe<Scalars['String']['output']>;
};

export type DogShelterOpeningHoursAvgAggregateOutputType = {
  __typename?: 'DogShelterOpeningHoursAvgAggregateOutputType';
  dogShelterId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

export type DogShelterOpeningHoursAvgOrderByAggregateInput = {
  dogShelterId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export type DogShelterOpeningHoursCountAggregateOutputType = {
  __typename?: 'DogShelterOpeningHoursCountAggregateOutputType';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  dayOfWeek: Scalars['Int']['output'];
  dogShelterId: Scalars['Int']['output'];
  endTime: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  startTime: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type DogShelterOpeningHoursCountOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  dayOfWeek?: InputMaybe<SortOrder>;
  dogShelterId?: InputMaybe<SortOrder>;
  endTime?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  startTime?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type DogShelterOpeningHoursCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dayOfWeek: DayOfWeek;
  dogShelter: DogShelterCreateNestedOneWithoutOpeningHoursInput;
  endTime: Scalars['String']['input'];
  startTime: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DogShelterOpeningHoursCreateManyDogShelterInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dayOfWeek: DayOfWeek;
  endTime: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  startTime: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DogShelterOpeningHoursCreateManyDogShelterInputEnvelope = {
  data: Array<DogShelterOpeningHoursCreateManyDogShelterInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DogShelterOpeningHoursCreateManyInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dayOfWeek: DayOfWeek;
  dogShelterId: Scalars['Int']['input'];
  endTime: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  startTime: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DogShelterOpeningHoursCreateNestedManyWithoutDogShelterInput = {
  connect?: InputMaybe<Array<DogShelterOpeningHoursWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DogShelterOpeningHoursCreateOrConnectWithoutDogShelterInput>>;
  create?: InputMaybe<Array<DogShelterOpeningHoursCreateWithoutDogShelterInput>>;
  createMany?: InputMaybe<DogShelterOpeningHoursCreateManyDogShelterInputEnvelope>;
};

export type DogShelterOpeningHoursCreateOrConnectWithoutDogShelterInput = {
  create: DogShelterOpeningHoursCreateWithoutDogShelterInput;
  where: DogShelterOpeningHoursWhereUniqueInput;
};

export type DogShelterOpeningHoursCreateWithoutDogShelterInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dayOfWeek: DayOfWeek;
  endTime: Scalars['String']['input'];
  startTime: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DogShelterOpeningHoursListRelationFilter = {
  every?: InputMaybe<DogShelterOpeningHoursWhereInput>;
  none?: InputMaybe<DogShelterOpeningHoursWhereInput>;
  some?: InputMaybe<DogShelterOpeningHoursWhereInput>;
};

export type DogShelterOpeningHoursMaxAggregateOutputType = {
  __typename?: 'DogShelterOpeningHoursMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  dayOfWeek?: Maybe<DayOfWeek>;
  dogShelterId?: Maybe<Scalars['Int']['output']>;
  endTime?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  startTime?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type DogShelterOpeningHoursMaxOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  dayOfWeek?: InputMaybe<SortOrder>;
  dogShelterId?: InputMaybe<SortOrder>;
  endTime?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  startTime?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type DogShelterOpeningHoursMinAggregateOutputType = {
  __typename?: 'DogShelterOpeningHoursMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  dayOfWeek?: Maybe<DayOfWeek>;
  dogShelterId?: Maybe<Scalars['Int']['output']>;
  endTime?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  startTime?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type DogShelterOpeningHoursMinOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  dayOfWeek?: InputMaybe<SortOrder>;
  dogShelterId?: InputMaybe<SortOrder>;
  endTime?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  startTime?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type DogShelterOpeningHoursOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export enum DogShelterOpeningHoursOrderByRelevanceFieldEnum {
  endTime = 'endTime',
  startTime = 'startTime'
}

export type DogShelterOpeningHoursOrderByRelevanceInput = {
  fields: Array<DogShelterOpeningHoursOrderByRelevanceFieldEnum>;
  search: Scalars['String']['input'];
  sort: SortOrder;
};

export type DogShelterOpeningHoursOrderByWithAggregationInput = {
  _avg?: InputMaybe<DogShelterOpeningHoursAvgOrderByAggregateInput>;
  _count?: InputMaybe<DogShelterOpeningHoursCountOrderByAggregateInput>;
  _max?: InputMaybe<DogShelterOpeningHoursMaxOrderByAggregateInput>;
  _min?: InputMaybe<DogShelterOpeningHoursMinOrderByAggregateInput>;
  _sum?: InputMaybe<DogShelterOpeningHoursSumOrderByAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  dayOfWeek?: InputMaybe<SortOrder>;
  dogShelterId?: InputMaybe<SortOrder>;
  endTime?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  startTime?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type DogShelterOpeningHoursOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: InputMaybe<DogShelterOpeningHoursOrderByRelevanceInput>;
  createdAt?: InputMaybe<SortOrder>;
  dayOfWeek?: InputMaybe<SortOrder>;
  dogShelter?: InputMaybe<DogShelterOrderByWithRelationAndSearchRelevanceInput>;
  dogShelterId?: InputMaybe<SortOrder>;
  endTime?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  startTime?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum DogShelterOpeningHoursScalarFieldEnum {
  createdAt = 'createdAt',
  dayOfWeek = 'dayOfWeek',
  dogShelterId = 'dogShelterId',
  endTime = 'endTime',
  id = 'id',
  startTime = 'startTime',
  updatedAt = 'updatedAt'
}

export type DogShelterOpeningHoursScalarWhereInput = {
  AND?: InputMaybe<Array<DogShelterOpeningHoursScalarWhereInput>>;
  NOT?: InputMaybe<Array<DogShelterOpeningHoursScalarWhereInput>>;
  OR?: InputMaybe<Array<DogShelterOpeningHoursScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  dayOfWeek?: InputMaybe<EnumDayOfWeekFilter>;
  dogShelterId?: InputMaybe<IntFilter>;
  endTime?: InputMaybe<StringFilter>;
  id?: InputMaybe<IntFilter>;
  startTime?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type DogShelterOpeningHoursScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<DogShelterOpeningHoursScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<DogShelterOpeningHoursScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<DogShelterOpeningHoursScalarWhereWithAggregatesInput>>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  dayOfWeek?: InputMaybe<EnumDayOfWeekWithAggregatesFilter>;
  dogShelterId?: InputMaybe<IntWithAggregatesFilter>;
  endTime?: InputMaybe<StringWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  startTime?: InputMaybe<StringWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type DogShelterOpeningHoursSumAggregateOutputType = {
  __typename?: 'DogShelterOpeningHoursSumAggregateOutputType';
  dogShelterId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
};

export type DogShelterOpeningHoursSumOrderByAggregateInput = {
  dogShelterId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export type DogShelterOpeningHoursUncheckedCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dayOfWeek: DayOfWeek;
  dogShelterId: Scalars['Int']['input'];
  endTime: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  startTime: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DogShelterOpeningHoursUncheckedCreateNestedManyWithoutDogShelterInput = {
  connect?: InputMaybe<Array<DogShelterOpeningHoursWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DogShelterOpeningHoursCreateOrConnectWithoutDogShelterInput>>;
  create?: InputMaybe<Array<DogShelterOpeningHoursCreateWithoutDogShelterInput>>;
  createMany?: InputMaybe<DogShelterOpeningHoursCreateManyDogShelterInputEnvelope>;
};

export type DogShelterOpeningHoursUncheckedCreateWithoutDogShelterInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dayOfWeek: DayOfWeek;
  endTime: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  startTime: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DogShelterOpeningHoursUncheckedUpdateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dayOfWeek?: InputMaybe<EnumDayOfWeekFieldUpdateOperationsInput>;
  dogShelterId?: InputMaybe<IntFieldUpdateOperationsInput>;
  endTime?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  startTime?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DogShelterOpeningHoursUncheckedUpdateManyInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dayOfWeek?: InputMaybe<EnumDayOfWeekFieldUpdateOperationsInput>;
  dogShelterId?: InputMaybe<IntFieldUpdateOperationsInput>;
  endTime?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  startTime?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DogShelterOpeningHoursUncheckedUpdateManyWithoutDogShelterInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dayOfWeek?: InputMaybe<EnumDayOfWeekFieldUpdateOperationsInput>;
  endTime?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  startTime?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DogShelterOpeningHoursUncheckedUpdateManyWithoutDogShelterNestedInput = {
  connect?: InputMaybe<Array<DogShelterOpeningHoursWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DogShelterOpeningHoursCreateOrConnectWithoutDogShelterInput>>;
  create?: InputMaybe<Array<DogShelterOpeningHoursCreateWithoutDogShelterInput>>;
  createMany?: InputMaybe<DogShelterOpeningHoursCreateManyDogShelterInputEnvelope>;
  delete?: InputMaybe<Array<DogShelterOpeningHoursWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<DogShelterOpeningHoursScalarWhereInput>>;
  disconnect?: InputMaybe<Array<DogShelterOpeningHoursWhereUniqueInput>>;
  set?: InputMaybe<Array<DogShelterOpeningHoursWhereUniqueInput>>;
  update?: InputMaybe<Array<DogShelterOpeningHoursUpdateWithWhereUniqueWithoutDogShelterInput>>;
  updateMany?: InputMaybe<Array<DogShelterOpeningHoursUpdateManyWithWhereWithoutDogShelterInput>>;
  upsert?: InputMaybe<Array<DogShelterOpeningHoursUpsertWithWhereUniqueWithoutDogShelterInput>>;
};

export type DogShelterOpeningHoursUncheckedUpdateWithoutDogShelterInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dayOfWeek?: InputMaybe<EnumDayOfWeekFieldUpdateOperationsInput>;
  endTime?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  startTime?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DogShelterOpeningHoursUpdateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dayOfWeek?: InputMaybe<EnumDayOfWeekFieldUpdateOperationsInput>;
  dogShelter?: InputMaybe<DogShelterUpdateOneRequiredWithoutOpeningHoursNestedInput>;
  endTime?: InputMaybe<StringFieldUpdateOperationsInput>;
  startTime?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DogShelterOpeningHoursUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dayOfWeek?: InputMaybe<EnumDayOfWeekFieldUpdateOperationsInput>;
  endTime?: InputMaybe<StringFieldUpdateOperationsInput>;
  startTime?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DogShelterOpeningHoursUpdateManyWithWhereWithoutDogShelterInput = {
  data: DogShelterOpeningHoursUpdateManyMutationInput;
  where: DogShelterOpeningHoursScalarWhereInput;
};

export type DogShelterOpeningHoursUpdateManyWithoutDogShelterNestedInput = {
  connect?: InputMaybe<Array<DogShelterOpeningHoursWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DogShelterOpeningHoursCreateOrConnectWithoutDogShelterInput>>;
  create?: InputMaybe<Array<DogShelterOpeningHoursCreateWithoutDogShelterInput>>;
  createMany?: InputMaybe<DogShelterOpeningHoursCreateManyDogShelterInputEnvelope>;
  delete?: InputMaybe<Array<DogShelterOpeningHoursWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<DogShelterOpeningHoursScalarWhereInput>>;
  disconnect?: InputMaybe<Array<DogShelterOpeningHoursWhereUniqueInput>>;
  set?: InputMaybe<Array<DogShelterOpeningHoursWhereUniqueInput>>;
  update?: InputMaybe<Array<DogShelterOpeningHoursUpdateWithWhereUniqueWithoutDogShelterInput>>;
  updateMany?: InputMaybe<Array<DogShelterOpeningHoursUpdateManyWithWhereWithoutDogShelterInput>>;
  upsert?: InputMaybe<Array<DogShelterOpeningHoursUpsertWithWhereUniqueWithoutDogShelterInput>>;
};

export type DogShelterOpeningHoursUpdateWithWhereUniqueWithoutDogShelterInput = {
  data: DogShelterOpeningHoursUpdateWithoutDogShelterInput;
  where: DogShelterOpeningHoursWhereUniqueInput;
};

export type DogShelterOpeningHoursUpdateWithoutDogShelterInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dayOfWeek?: InputMaybe<EnumDayOfWeekFieldUpdateOperationsInput>;
  endTime?: InputMaybe<StringFieldUpdateOperationsInput>;
  startTime?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DogShelterOpeningHoursUpsertWithWhereUniqueWithoutDogShelterInput = {
  create: DogShelterOpeningHoursCreateWithoutDogShelterInput;
  update: DogShelterOpeningHoursUpdateWithoutDogShelterInput;
  where: DogShelterOpeningHoursWhereUniqueInput;
};

export type DogShelterOpeningHoursWhereInput = {
  AND?: InputMaybe<Array<DogShelterOpeningHoursWhereInput>>;
  NOT?: InputMaybe<Array<DogShelterOpeningHoursWhereInput>>;
  OR?: InputMaybe<Array<DogShelterOpeningHoursWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  dayOfWeek?: InputMaybe<EnumDayOfWeekFilter>;
  dogShelter?: InputMaybe<DogShelterRelationFilter>;
  dogShelterId?: InputMaybe<IntFilter>;
  endTime?: InputMaybe<StringFilter>;
  id?: InputMaybe<IntFilter>;
  startTime?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type DogShelterOpeningHoursWhereUniqueInput = {
  AND?: InputMaybe<Array<DogShelterOpeningHoursWhereInput>>;
  NOT?: InputMaybe<Array<DogShelterOpeningHoursWhereInput>>;
  OR?: InputMaybe<Array<DogShelterOpeningHoursWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  dayOfWeek?: InputMaybe<EnumDayOfWeekFilter>;
  dogShelter?: InputMaybe<DogShelterRelationFilter>;
  dogShelterId?: InputMaybe<IntFilter>;
  endTime?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  startTime?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export enum DogShelterOrderByRelevanceFieldEnum {
  agreementNumber = 'agreementNumber',
  associationNumber = 'associationNumber',
  donationInfo = 'donationInfo',
  emails = 'emails',
  name = 'name',
  phoneNumbers = 'phoneNumbers',
  spokenLanguages = 'spokenLanguages',
  tags = 'tags'
}

export type DogShelterOrderByRelevanceInput = {
  fields: Array<DogShelterOrderByRelevanceFieldEnum>;
  search: Scalars['String']['input'];
  sort: SortOrder;
};

export type DogShelterOrderByWithAggregationInput = {
  _avg?: InputMaybe<DogShelterAvgOrderByAggregateInput>;
  _count?: InputMaybe<DogShelterCountOrderByAggregateInput>;
  _max?: InputMaybe<DogShelterMaxOrderByAggregateInput>;
  _min?: InputMaybe<DogShelterMinOrderByAggregateInput>;
  _sum?: InputMaybe<DogShelterSumOrderByAggregateInput>;
  acceptedAnimals?: InputMaybe<SortOrder>;
  addressId?: InputMaybe<SortOrderInput>;
  adminValidated?: InputMaybe<SortOrderInput>;
  agreementNumber?: InputMaybe<SortOrderInput>;
  associationNumber?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  donationInfo?: InputMaybe<SortOrderInput>;
  emails?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrderInput>;
  phoneNumbers?: InputMaybe<SortOrder>;
  spokenLanguages?: InputMaybe<SortOrder>;
  tags?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  visitedByTipaw?: InputMaybe<SortOrderInput>;
};

export type DogShelterOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: InputMaybe<DogShelterOrderByRelevanceInput>;
  acceptedAnimals?: InputMaybe<SortOrder>;
  address?: InputMaybe<AddressOrderByWithRelationAndSearchRelevanceInput>;
  addressId?: InputMaybe<SortOrderInput>;
  adminValidated?: InputMaybe<SortOrderInput>;
  agreementNumber?: InputMaybe<SortOrderInput>;
  animals?: InputMaybe<AnimalOrderByRelationAggregateInput>;
  associationNumber?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  donationInfo?: InputMaybe<SortOrderInput>;
  emails?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  imgs?: InputMaybe<DogShelterImgOrderByRelationAggregateInput>;
  links?: InputMaybe<DogShelterLinkOrderByRelationAggregateInput>;
  name?: InputMaybe<SortOrderInput>;
  openingHours?: InputMaybe<DogShelterOpeningHoursOrderByRelationAggregateInput>;
  phoneNumbers?: InputMaybe<SortOrder>;
  spokenLanguages?: InputMaybe<SortOrder>;
  tags?: InputMaybe<SortOrder>;
  translations?: InputMaybe<DogShelterTranslationOrderByRelationAggregateInput>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  visitedByTipaw?: InputMaybe<SortOrderInput>;
};

export type DogShelterRelationFilter = {
  is?: InputMaybe<DogShelterWhereInput>;
  isNot?: InputMaybe<DogShelterWhereInput>;
};

export enum DogShelterScalarFieldEnum {
  acceptedAnimals = 'acceptedAnimals',
  addressId = 'addressId',
  adminValidated = 'adminValidated',
  agreementNumber = 'agreementNumber',
  associationNumber = 'associationNumber',
  createdAt = 'createdAt',
  donationInfo = 'donationInfo',
  emails = 'emails',
  id = 'id',
  name = 'name',
  phoneNumbers = 'phoneNumbers',
  spokenLanguages = 'spokenLanguages',
  tags = 'tags',
  type = 'type',
  updatedAt = 'updatedAt',
  visitedByTipaw = 'visitedByTipaw'
}

export type DogShelterScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<DogShelterScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<DogShelterScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<DogShelterScalarWhereWithAggregatesInput>>;
  acceptedAnimals?: InputMaybe<EnumAnimalTypeEnumNullableListFilter>;
  addressId?: InputMaybe<IntNullableWithAggregatesFilter>;
  adminValidated?: InputMaybe<BoolNullableWithAggregatesFilter>;
  agreementNumber?: InputMaybe<StringNullableWithAggregatesFilter>;
  associationNumber?: InputMaybe<StringNullableWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  donationInfo?: InputMaybe<StringNullableWithAggregatesFilter>;
  emails?: InputMaybe<StringNullableListFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  name?: InputMaybe<StringNullableWithAggregatesFilter>;
  phoneNumbers?: InputMaybe<StringNullableListFilter>;
  spokenLanguages?: InputMaybe<StringNullableListFilter>;
  tags?: InputMaybe<StringNullableListFilter>;
  type?: InputMaybe<EnumDogShelterTypeWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  visitedByTipaw?: InputMaybe<BoolNullableWithAggregatesFilter>;
};

export type DogShelterSumAggregateOutputType = {
  __typename?: 'DogShelterSumAggregateOutputType';
  addressId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
};

export type DogShelterSumOrderByAggregateInput = {
  addressId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export type DogShelterTranslation = {
  __typename?: 'DogShelterTranslation';
  additionalInfo?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  dogShelter?: Maybe<Scalars['String']['output']>;
  dogShelterId?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  language?: Maybe<Scalars['String']['output']>;
  seoDescription?: Maybe<Scalars['String']['output']>;
  seoTitle?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type DogShelterTranslationAvgAggregateOutputType = {
  __typename?: 'DogShelterTranslationAvgAggregateOutputType';
  dogShelterId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

export type DogShelterTranslationAvgOrderByAggregateInput = {
  dogShelterId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export type DogShelterTranslationCountAggregateOutputType = {
  __typename?: 'DogShelterTranslationCountAggregateOutputType';
  _all: Scalars['Int']['output'];
  additionalInfo: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  description: Scalars['Int']['output'];
  dogShelterId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  language: Scalars['Int']['output'];
  seoDescription: Scalars['Int']['output'];
  seoTitle: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
  url: Scalars['Int']['output'];
};

export type DogShelterTranslationCountOrderByAggregateInput = {
  additionalInfo?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  dogShelterId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  language?: InputMaybe<SortOrder>;
  seoDescription?: InputMaybe<SortOrder>;
  seoTitle?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  url?: InputMaybe<SortOrder>;
};

export type DogShelterTranslationCreateInput = {
  additionalInfo?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dogShelter: DogShelterCreateNestedOneWithoutTranslationsInput;
  language: Scalars['String']['input'];
  seoDescription?: InputMaybe<Scalars['String']['input']>;
  seoTitle?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type DogShelterTranslationCreateManyDogShelterInput = {
  additionalInfo?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  language: Scalars['String']['input'];
  seoDescription?: InputMaybe<Scalars['String']['input']>;
  seoTitle?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type DogShelterTranslationCreateManyDogShelterInputEnvelope = {
  data: Array<DogShelterTranslationCreateManyDogShelterInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DogShelterTranslationCreateManyInput = {
  additionalInfo?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dogShelterId: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  language: Scalars['String']['input'];
  seoDescription?: InputMaybe<Scalars['String']['input']>;
  seoTitle?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type DogShelterTranslationCreateNestedManyWithoutDogShelterInput = {
  connect?: InputMaybe<Array<DogShelterTranslationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DogShelterTranslationCreateOrConnectWithoutDogShelterInput>>;
  create?: InputMaybe<Array<DogShelterTranslationCreateWithoutDogShelterInput>>;
  createMany?: InputMaybe<DogShelterTranslationCreateManyDogShelterInputEnvelope>;
};

export type DogShelterTranslationCreateOrConnectWithoutDogShelterInput = {
  create: DogShelterTranslationCreateWithoutDogShelterInput;
  where: DogShelterTranslationWhereUniqueInput;
};

export type DogShelterTranslationCreateWithoutDogShelterInput = {
  additionalInfo?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  language: Scalars['String']['input'];
  seoDescription?: InputMaybe<Scalars['String']['input']>;
  seoTitle?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type DogShelterTranslationListRelationFilter = {
  every?: InputMaybe<DogShelterTranslationWhereInput>;
  none?: InputMaybe<DogShelterTranslationWhereInput>;
  some?: InputMaybe<DogShelterTranslationWhereInput>;
};

export type DogShelterTranslationMaxAggregateOutputType = {
  __typename?: 'DogShelterTranslationMaxAggregateOutputType';
  additionalInfo?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dogShelterId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  seoDescription?: Maybe<Scalars['String']['output']>;
  seoTitle?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type DogShelterTranslationMaxOrderByAggregateInput = {
  additionalInfo?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  dogShelterId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  language?: InputMaybe<SortOrder>;
  seoDescription?: InputMaybe<SortOrder>;
  seoTitle?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  url?: InputMaybe<SortOrder>;
};

export type DogShelterTranslationMinAggregateOutputType = {
  __typename?: 'DogShelterTranslationMinAggregateOutputType';
  additionalInfo?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dogShelterId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  seoDescription?: Maybe<Scalars['String']['output']>;
  seoTitle?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type DogShelterTranslationMinOrderByAggregateInput = {
  additionalInfo?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  dogShelterId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  language?: InputMaybe<SortOrder>;
  seoDescription?: InputMaybe<SortOrder>;
  seoTitle?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  url?: InputMaybe<SortOrder>;
};

export type DogShelterTranslationOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export enum DogShelterTranslationOrderByRelevanceFieldEnum {
  additionalInfo = 'additionalInfo',
  description = 'description',
  language = 'language',
  seoDescription = 'seoDescription',
  seoTitle = 'seoTitle',
  url = 'url'
}

export type DogShelterTranslationOrderByRelevanceInput = {
  fields: Array<DogShelterTranslationOrderByRelevanceFieldEnum>;
  search: Scalars['String']['input'];
  sort: SortOrder;
};

export type DogShelterTranslationOrderByWithAggregationInput = {
  _avg?: InputMaybe<DogShelterTranslationAvgOrderByAggregateInput>;
  _count?: InputMaybe<DogShelterTranslationCountOrderByAggregateInput>;
  _max?: InputMaybe<DogShelterTranslationMaxOrderByAggregateInput>;
  _min?: InputMaybe<DogShelterTranslationMinOrderByAggregateInput>;
  _sum?: InputMaybe<DogShelterTranslationSumOrderByAggregateInput>;
  additionalInfo?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrderInput>;
  dogShelterId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  language?: InputMaybe<SortOrder>;
  seoDescription?: InputMaybe<SortOrderInput>;
  seoTitle?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
  url?: InputMaybe<SortOrderInput>;
};

export type DogShelterTranslationOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: InputMaybe<DogShelterTranslationOrderByRelevanceInput>;
  additionalInfo?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrderInput>;
  dogShelter?: InputMaybe<DogShelterOrderByWithRelationAndSearchRelevanceInput>;
  dogShelterId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  language?: InputMaybe<SortOrder>;
  seoDescription?: InputMaybe<SortOrderInput>;
  seoTitle?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
  url?: InputMaybe<SortOrderInput>;
};

export enum DogShelterTranslationScalarFieldEnum {
  additionalInfo = 'additionalInfo',
  createdAt = 'createdAt',
  description = 'description',
  dogShelterId = 'dogShelterId',
  id = 'id',
  language = 'language',
  seoDescription = 'seoDescription',
  seoTitle = 'seoTitle',
  updatedAt = 'updatedAt',
  url = 'url'
}

export type DogShelterTranslationScalarWhereInput = {
  AND?: InputMaybe<Array<DogShelterTranslationScalarWhereInput>>;
  NOT?: InputMaybe<Array<DogShelterTranslationScalarWhereInput>>;
  OR?: InputMaybe<Array<DogShelterTranslationScalarWhereInput>>;
  additionalInfo?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringNullableFilter>;
  dogShelterId?: InputMaybe<IntFilter>;
  id?: InputMaybe<IntFilter>;
  language?: InputMaybe<StringFilter>;
  seoDescription?: InputMaybe<StringNullableFilter>;
  seoTitle?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  url?: InputMaybe<StringNullableFilter>;
};

export type DogShelterTranslationScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<DogShelterTranslationScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<DogShelterTranslationScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<DogShelterTranslationScalarWhereWithAggregatesInput>>;
  additionalInfo?: InputMaybe<StringNullableWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  description?: InputMaybe<StringNullableWithAggregatesFilter>;
  dogShelterId?: InputMaybe<IntWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  language?: InputMaybe<StringWithAggregatesFilter>;
  seoDescription?: InputMaybe<StringNullableWithAggregatesFilter>;
  seoTitle?: InputMaybe<StringNullableWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  url?: InputMaybe<StringNullableWithAggregatesFilter>;
};

export type DogShelterTranslationSumAggregateOutputType = {
  __typename?: 'DogShelterTranslationSumAggregateOutputType';
  dogShelterId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
};

export type DogShelterTranslationSumOrderByAggregateInput = {
  dogShelterId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export type DogShelterTranslationUncheckedCreateInput = {
  additionalInfo?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dogShelterId: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  language: Scalars['String']['input'];
  seoDescription?: InputMaybe<Scalars['String']['input']>;
  seoTitle?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type DogShelterTranslationUncheckedCreateNestedManyWithoutDogShelterInput = {
  connect?: InputMaybe<Array<DogShelterTranslationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DogShelterTranslationCreateOrConnectWithoutDogShelterInput>>;
  create?: InputMaybe<Array<DogShelterTranslationCreateWithoutDogShelterInput>>;
  createMany?: InputMaybe<DogShelterTranslationCreateManyDogShelterInputEnvelope>;
};

export type DogShelterTranslationUncheckedCreateWithoutDogShelterInput = {
  additionalInfo?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  language: Scalars['String']['input'];
  seoDescription?: InputMaybe<Scalars['String']['input']>;
  seoTitle?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type DogShelterTranslationUncheckedUpdateInput = {
  additionalInfo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dogShelterId?: InputMaybe<IntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  seoDescription?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  seoTitle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  url?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type DogShelterTranslationUncheckedUpdateManyInput = {
  additionalInfo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dogShelterId?: InputMaybe<IntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  seoDescription?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  seoTitle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  url?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type DogShelterTranslationUncheckedUpdateManyWithoutDogShelterInput = {
  additionalInfo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  seoDescription?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  seoTitle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  url?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type DogShelterTranslationUncheckedUpdateManyWithoutDogShelterNestedInput = {
  connect?: InputMaybe<Array<DogShelterTranslationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DogShelterTranslationCreateOrConnectWithoutDogShelterInput>>;
  create?: InputMaybe<Array<DogShelterTranslationCreateWithoutDogShelterInput>>;
  createMany?: InputMaybe<DogShelterTranslationCreateManyDogShelterInputEnvelope>;
  delete?: InputMaybe<Array<DogShelterTranslationWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<DogShelterTranslationScalarWhereInput>>;
  disconnect?: InputMaybe<Array<DogShelterTranslationWhereUniqueInput>>;
  set?: InputMaybe<Array<DogShelterTranslationWhereUniqueInput>>;
  update?: InputMaybe<Array<DogShelterTranslationUpdateWithWhereUniqueWithoutDogShelterInput>>;
  updateMany?: InputMaybe<Array<DogShelterTranslationUpdateManyWithWhereWithoutDogShelterInput>>;
  upsert?: InputMaybe<Array<DogShelterTranslationUpsertWithWhereUniqueWithoutDogShelterInput>>;
};

export type DogShelterTranslationUncheckedUpdateWithoutDogShelterInput = {
  additionalInfo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  seoDescription?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  seoTitle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  url?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type DogShelterTranslationUpdateInput = {
  additionalInfo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dogShelter?: InputMaybe<DogShelterUpdateOneRequiredWithoutTranslationsNestedInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  seoDescription?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  seoTitle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  url?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type DogShelterTranslationUpdateManyMutationInput = {
  additionalInfo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  seoDescription?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  seoTitle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  url?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type DogShelterTranslationUpdateManyWithWhereWithoutDogShelterInput = {
  data: DogShelterTranslationUpdateManyMutationInput;
  where: DogShelterTranslationScalarWhereInput;
};

export type DogShelterTranslationUpdateManyWithoutDogShelterNestedInput = {
  connect?: InputMaybe<Array<DogShelterTranslationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DogShelterTranslationCreateOrConnectWithoutDogShelterInput>>;
  create?: InputMaybe<Array<DogShelterTranslationCreateWithoutDogShelterInput>>;
  createMany?: InputMaybe<DogShelterTranslationCreateManyDogShelterInputEnvelope>;
  delete?: InputMaybe<Array<DogShelterTranslationWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<DogShelterTranslationScalarWhereInput>>;
  disconnect?: InputMaybe<Array<DogShelterTranslationWhereUniqueInput>>;
  set?: InputMaybe<Array<DogShelterTranslationWhereUniqueInput>>;
  update?: InputMaybe<Array<DogShelterTranslationUpdateWithWhereUniqueWithoutDogShelterInput>>;
  updateMany?: InputMaybe<Array<DogShelterTranslationUpdateManyWithWhereWithoutDogShelterInput>>;
  upsert?: InputMaybe<Array<DogShelterTranslationUpsertWithWhereUniqueWithoutDogShelterInput>>;
};

export type DogShelterTranslationUpdateWithWhereUniqueWithoutDogShelterInput = {
  data: DogShelterTranslationUpdateWithoutDogShelterInput;
  where: DogShelterTranslationWhereUniqueInput;
};

export type DogShelterTranslationUpdateWithoutDogShelterInput = {
  additionalInfo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  seoDescription?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  seoTitle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  url?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type DogShelterTranslationUpsertWithWhereUniqueWithoutDogShelterInput = {
  create: DogShelterTranslationCreateWithoutDogShelterInput;
  update: DogShelterTranslationUpdateWithoutDogShelterInput;
  where: DogShelterTranslationWhereUniqueInput;
};

export type DogShelterTranslationWhereInput = {
  AND?: InputMaybe<Array<DogShelterTranslationWhereInput>>;
  NOT?: InputMaybe<Array<DogShelterTranslationWhereInput>>;
  OR?: InputMaybe<Array<DogShelterTranslationWhereInput>>;
  additionalInfo?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringNullableFilter>;
  dogShelter?: InputMaybe<DogShelterRelationFilter>;
  dogShelterId?: InputMaybe<IntFilter>;
  id?: InputMaybe<IntFilter>;
  language?: InputMaybe<StringFilter>;
  seoDescription?: InputMaybe<StringNullableFilter>;
  seoTitle?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  url?: InputMaybe<StringNullableFilter>;
};

export type DogShelterTranslationWhereUniqueInput = {
  AND?: InputMaybe<Array<DogShelterTranslationWhereInput>>;
  NOT?: InputMaybe<Array<DogShelterTranslationWhereInput>>;
  OR?: InputMaybe<Array<DogShelterTranslationWhereInput>>;
  additionalInfo?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringNullableFilter>;
  dogShelter?: InputMaybe<DogShelterRelationFilter>;
  dogShelterId?: InputMaybe<IntFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  language?: InputMaybe<StringFilter>;
  seoDescription?: InputMaybe<StringNullableFilter>;
  seoTitle?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  url?: InputMaybe<StringNullableFilter>;
};

export enum DogShelterType {
  ASSOCIATION = 'ASSOCIATION',
  SHELTER = 'SHELTER'
}

export type DogShelterUncheckedCreateInput = {
  acceptedAnimals?: InputMaybe<Array<AnimalTypeEnum>>;
  addressId?: InputMaybe<Scalars['Int']['input']>;
  adminValidated?: InputMaybe<Scalars['Boolean']['input']>;
  agreementNumber?: InputMaybe<Scalars['String']['input']>;
  animals?: InputMaybe<AnimalUncheckedCreateNestedManyWithoutDogShelterInput>;
  associationNumber?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  donationInfo?: InputMaybe<Scalars['String']['input']>;
  emails?: InputMaybe<Array<Scalars['String']['input']>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  imgs?: InputMaybe<DogShelterImgUncheckedCreateNestedManyWithoutDogShelterInput>;
  links?: InputMaybe<DogShelterLinkUncheckedCreateNestedManyWithoutDogShelterInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  openingHours?: InputMaybe<DogShelterOpeningHoursUncheckedCreateNestedManyWithoutDogShelterInput>;
  phoneNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  translations?: InputMaybe<DogShelterTranslationUncheckedCreateNestedManyWithoutDogShelterInput>;
  type?: InputMaybe<DogShelterType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  visitedByTipaw?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DogShelterUncheckedCreateNestedOneWithoutAddressInput = {
  connect?: InputMaybe<DogShelterWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DogShelterCreateOrConnectWithoutAddressInput>;
  create?: InputMaybe<DogShelterCreateWithoutAddressInput>;
};

export type DogShelterUncheckedCreateWithoutAddressInput = {
  acceptedAnimals?: InputMaybe<Array<AnimalTypeEnum>>;
  adminValidated?: InputMaybe<Scalars['Boolean']['input']>;
  agreementNumber?: InputMaybe<Scalars['String']['input']>;
  animals?: InputMaybe<AnimalUncheckedCreateNestedManyWithoutDogShelterInput>;
  associationNumber?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  donationInfo?: InputMaybe<Scalars['String']['input']>;
  emails?: InputMaybe<Array<Scalars['String']['input']>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  imgs?: InputMaybe<DogShelterImgUncheckedCreateNestedManyWithoutDogShelterInput>;
  links?: InputMaybe<DogShelterLinkUncheckedCreateNestedManyWithoutDogShelterInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  openingHours?: InputMaybe<DogShelterOpeningHoursUncheckedCreateNestedManyWithoutDogShelterInput>;
  phoneNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  translations?: InputMaybe<DogShelterTranslationUncheckedCreateNestedManyWithoutDogShelterInput>;
  type?: InputMaybe<DogShelterType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  visitedByTipaw?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DogShelterUncheckedCreateWithoutAnimalsInput = {
  acceptedAnimals?: InputMaybe<Array<AnimalTypeEnum>>;
  addressId?: InputMaybe<Scalars['Int']['input']>;
  adminValidated?: InputMaybe<Scalars['Boolean']['input']>;
  agreementNumber?: InputMaybe<Scalars['String']['input']>;
  associationNumber?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  donationInfo?: InputMaybe<Scalars['String']['input']>;
  emails?: InputMaybe<Array<Scalars['String']['input']>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  imgs?: InputMaybe<DogShelterImgUncheckedCreateNestedManyWithoutDogShelterInput>;
  links?: InputMaybe<DogShelterLinkUncheckedCreateNestedManyWithoutDogShelterInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  openingHours?: InputMaybe<DogShelterOpeningHoursUncheckedCreateNestedManyWithoutDogShelterInput>;
  phoneNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  translations?: InputMaybe<DogShelterTranslationUncheckedCreateNestedManyWithoutDogShelterInput>;
  type?: InputMaybe<DogShelterType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  visitedByTipaw?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DogShelterUncheckedCreateWithoutImgsInput = {
  acceptedAnimals?: InputMaybe<Array<AnimalTypeEnum>>;
  addressId?: InputMaybe<Scalars['Int']['input']>;
  adminValidated?: InputMaybe<Scalars['Boolean']['input']>;
  agreementNumber?: InputMaybe<Scalars['String']['input']>;
  animals?: InputMaybe<AnimalUncheckedCreateNestedManyWithoutDogShelterInput>;
  associationNumber?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  donationInfo?: InputMaybe<Scalars['String']['input']>;
  emails?: InputMaybe<Array<Scalars['String']['input']>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  links?: InputMaybe<DogShelterLinkUncheckedCreateNestedManyWithoutDogShelterInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  openingHours?: InputMaybe<DogShelterOpeningHoursUncheckedCreateNestedManyWithoutDogShelterInput>;
  phoneNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  translations?: InputMaybe<DogShelterTranslationUncheckedCreateNestedManyWithoutDogShelterInput>;
  type?: InputMaybe<DogShelterType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  visitedByTipaw?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DogShelterUncheckedCreateWithoutLinksInput = {
  acceptedAnimals?: InputMaybe<Array<AnimalTypeEnum>>;
  addressId?: InputMaybe<Scalars['Int']['input']>;
  adminValidated?: InputMaybe<Scalars['Boolean']['input']>;
  agreementNumber?: InputMaybe<Scalars['String']['input']>;
  animals?: InputMaybe<AnimalUncheckedCreateNestedManyWithoutDogShelterInput>;
  associationNumber?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  donationInfo?: InputMaybe<Scalars['String']['input']>;
  emails?: InputMaybe<Array<Scalars['String']['input']>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  imgs?: InputMaybe<DogShelterImgUncheckedCreateNestedManyWithoutDogShelterInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  openingHours?: InputMaybe<DogShelterOpeningHoursUncheckedCreateNestedManyWithoutDogShelterInput>;
  phoneNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  translations?: InputMaybe<DogShelterTranslationUncheckedCreateNestedManyWithoutDogShelterInput>;
  type?: InputMaybe<DogShelterType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  visitedByTipaw?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DogShelterUncheckedCreateWithoutOpeningHoursInput = {
  acceptedAnimals?: InputMaybe<Array<AnimalTypeEnum>>;
  addressId?: InputMaybe<Scalars['Int']['input']>;
  adminValidated?: InputMaybe<Scalars['Boolean']['input']>;
  agreementNumber?: InputMaybe<Scalars['String']['input']>;
  animals?: InputMaybe<AnimalUncheckedCreateNestedManyWithoutDogShelterInput>;
  associationNumber?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  donationInfo?: InputMaybe<Scalars['String']['input']>;
  emails?: InputMaybe<Array<Scalars['String']['input']>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  imgs?: InputMaybe<DogShelterImgUncheckedCreateNestedManyWithoutDogShelterInput>;
  links?: InputMaybe<DogShelterLinkUncheckedCreateNestedManyWithoutDogShelterInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  phoneNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  translations?: InputMaybe<DogShelterTranslationUncheckedCreateNestedManyWithoutDogShelterInput>;
  type?: InputMaybe<DogShelterType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  visitedByTipaw?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DogShelterUncheckedCreateWithoutTranslationsInput = {
  acceptedAnimals?: InputMaybe<Array<AnimalTypeEnum>>;
  addressId?: InputMaybe<Scalars['Int']['input']>;
  adminValidated?: InputMaybe<Scalars['Boolean']['input']>;
  agreementNumber?: InputMaybe<Scalars['String']['input']>;
  animals?: InputMaybe<AnimalUncheckedCreateNestedManyWithoutDogShelterInput>;
  associationNumber?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  donationInfo?: InputMaybe<Scalars['String']['input']>;
  emails?: InputMaybe<Array<Scalars['String']['input']>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  imgs?: InputMaybe<DogShelterImgUncheckedCreateNestedManyWithoutDogShelterInput>;
  links?: InputMaybe<DogShelterLinkUncheckedCreateNestedManyWithoutDogShelterInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  openingHours?: InputMaybe<DogShelterOpeningHoursUncheckedCreateNestedManyWithoutDogShelterInput>;
  phoneNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<DogShelterType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  visitedByTipaw?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DogShelterUncheckedUpdateInput = {
  acceptedAnimals?: InputMaybe<Array<AnimalTypeEnum>>;
  addressId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  adminValidated?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  agreementNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  animals?: InputMaybe<AnimalUncheckedUpdateManyWithoutDogShelterNestedInput>;
  associationNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  donationInfo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emails?: InputMaybe<Array<Scalars['String']['input']>>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  imgs?: InputMaybe<DogShelterImgUncheckedUpdateManyWithoutDogShelterNestedInput>;
  links?: InputMaybe<DogShelterLinkUncheckedUpdateManyWithoutDogShelterNestedInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  openingHours?: InputMaybe<DogShelterOpeningHoursUncheckedUpdateManyWithoutDogShelterNestedInput>;
  phoneNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  translations?: InputMaybe<DogShelterTranslationUncheckedUpdateManyWithoutDogShelterNestedInput>;
  type?: InputMaybe<EnumDogShelterTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  visitedByTipaw?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
};

export type DogShelterUncheckedUpdateManyInput = {
  acceptedAnimals?: InputMaybe<Array<AnimalTypeEnum>>;
  addressId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  adminValidated?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  agreementNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  associationNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  donationInfo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emails?: InputMaybe<Array<Scalars['String']['input']>>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  phoneNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<EnumDogShelterTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  visitedByTipaw?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
};

export type DogShelterUncheckedUpdateOneWithoutAddressNestedInput = {
  connect?: InputMaybe<DogShelterWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DogShelterCreateOrConnectWithoutAddressInput>;
  create?: InputMaybe<DogShelterCreateWithoutAddressInput>;
  delete?: InputMaybe<DogShelterWhereInput>;
  disconnect?: InputMaybe<DogShelterWhereInput>;
  update?: InputMaybe<DogShelterUpdateToOneWithWhereWithoutAddressInput>;
  upsert?: InputMaybe<DogShelterUpsertWithoutAddressInput>;
};

export type DogShelterUncheckedUpdateWithoutAddressInput = {
  acceptedAnimals?: InputMaybe<Array<AnimalTypeEnum>>;
  adminValidated?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  agreementNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  animals?: InputMaybe<AnimalUncheckedUpdateManyWithoutDogShelterNestedInput>;
  associationNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  donationInfo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emails?: InputMaybe<Array<Scalars['String']['input']>>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  imgs?: InputMaybe<DogShelterImgUncheckedUpdateManyWithoutDogShelterNestedInput>;
  links?: InputMaybe<DogShelterLinkUncheckedUpdateManyWithoutDogShelterNestedInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  openingHours?: InputMaybe<DogShelterOpeningHoursUncheckedUpdateManyWithoutDogShelterNestedInput>;
  phoneNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  translations?: InputMaybe<DogShelterTranslationUncheckedUpdateManyWithoutDogShelterNestedInput>;
  type?: InputMaybe<EnumDogShelterTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  visitedByTipaw?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
};

export type DogShelterUncheckedUpdateWithoutAnimalsInput = {
  acceptedAnimals?: InputMaybe<Array<AnimalTypeEnum>>;
  addressId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  adminValidated?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  agreementNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  associationNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  donationInfo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emails?: InputMaybe<Array<Scalars['String']['input']>>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  imgs?: InputMaybe<DogShelterImgUncheckedUpdateManyWithoutDogShelterNestedInput>;
  links?: InputMaybe<DogShelterLinkUncheckedUpdateManyWithoutDogShelterNestedInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  openingHours?: InputMaybe<DogShelterOpeningHoursUncheckedUpdateManyWithoutDogShelterNestedInput>;
  phoneNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  translations?: InputMaybe<DogShelterTranslationUncheckedUpdateManyWithoutDogShelterNestedInput>;
  type?: InputMaybe<EnumDogShelterTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  visitedByTipaw?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
};

export type DogShelterUncheckedUpdateWithoutImgsInput = {
  acceptedAnimals?: InputMaybe<Array<AnimalTypeEnum>>;
  addressId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  adminValidated?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  agreementNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  animals?: InputMaybe<AnimalUncheckedUpdateManyWithoutDogShelterNestedInput>;
  associationNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  donationInfo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emails?: InputMaybe<Array<Scalars['String']['input']>>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  links?: InputMaybe<DogShelterLinkUncheckedUpdateManyWithoutDogShelterNestedInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  openingHours?: InputMaybe<DogShelterOpeningHoursUncheckedUpdateManyWithoutDogShelterNestedInput>;
  phoneNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  translations?: InputMaybe<DogShelterTranslationUncheckedUpdateManyWithoutDogShelterNestedInput>;
  type?: InputMaybe<EnumDogShelterTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  visitedByTipaw?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
};

export type DogShelterUncheckedUpdateWithoutLinksInput = {
  acceptedAnimals?: InputMaybe<Array<AnimalTypeEnum>>;
  addressId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  adminValidated?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  agreementNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  animals?: InputMaybe<AnimalUncheckedUpdateManyWithoutDogShelterNestedInput>;
  associationNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  donationInfo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emails?: InputMaybe<Array<Scalars['String']['input']>>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  imgs?: InputMaybe<DogShelterImgUncheckedUpdateManyWithoutDogShelterNestedInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  openingHours?: InputMaybe<DogShelterOpeningHoursUncheckedUpdateManyWithoutDogShelterNestedInput>;
  phoneNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  translations?: InputMaybe<DogShelterTranslationUncheckedUpdateManyWithoutDogShelterNestedInput>;
  type?: InputMaybe<EnumDogShelterTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  visitedByTipaw?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
};

export type DogShelterUncheckedUpdateWithoutOpeningHoursInput = {
  acceptedAnimals?: InputMaybe<Array<AnimalTypeEnum>>;
  addressId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  adminValidated?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  agreementNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  animals?: InputMaybe<AnimalUncheckedUpdateManyWithoutDogShelterNestedInput>;
  associationNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  donationInfo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emails?: InputMaybe<Array<Scalars['String']['input']>>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  imgs?: InputMaybe<DogShelterImgUncheckedUpdateManyWithoutDogShelterNestedInput>;
  links?: InputMaybe<DogShelterLinkUncheckedUpdateManyWithoutDogShelterNestedInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  phoneNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  translations?: InputMaybe<DogShelterTranslationUncheckedUpdateManyWithoutDogShelterNestedInput>;
  type?: InputMaybe<EnumDogShelterTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  visitedByTipaw?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
};

export type DogShelterUncheckedUpdateWithoutTranslationsInput = {
  acceptedAnimals?: InputMaybe<Array<AnimalTypeEnum>>;
  addressId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  adminValidated?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  agreementNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  animals?: InputMaybe<AnimalUncheckedUpdateManyWithoutDogShelterNestedInput>;
  associationNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  donationInfo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emails?: InputMaybe<Array<Scalars['String']['input']>>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  imgs?: InputMaybe<DogShelterImgUncheckedUpdateManyWithoutDogShelterNestedInput>;
  links?: InputMaybe<DogShelterLinkUncheckedUpdateManyWithoutDogShelterNestedInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  openingHours?: InputMaybe<DogShelterOpeningHoursUncheckedUpdateManyWithoutDogShelterNestedInput>;
  phoneNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<EnumDogShelterTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  visitedByTipaw?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
};

export type DogShelterUpdateInput = {
  acceptedAnimals?: InputMaybe<Array<AnimalTypeEnum>>;
  address?: InputMaybe<AddressUpdateOneWithoutDogShelterNestedInput>;
  adminValidated?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  agreementNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  animals?: InputMaybe<AnimalUpdateManyWithoutDogShelterNestedInput>;
  associationNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  donationInfo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emails?: InputMaybe<Array<Scalars['String']['input']>>;
  imgs?: InputMaybe<DogShelterImgUpdateManyWithoutDogShelterNestedInput>;
  links?: InputMaybe<DogShelterLinkUpdateManyWithoutDogShelterNestedInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  openingHours?: InputMaybe<DogShelterOpeningHoursUpdateManyWithoutDogShelterNestedInput>;
  phoneNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  translations?: InputMaybe<DogShelterTranslationUpdateManyWithoutDogShelterNestedInput>;
  type?: InputMaybe<EnumDogShelterTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  visitedByTipaw?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
};

export type DogShelterUpdateManyMutationInput = {
  acceptedAnimals?: InputMaybe<Array<AnimalTypeEnum>>;
  adminValidated?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  agreementNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  associationNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  donationInfo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emails?: InputMaybe<Array<Scalars['String']['input']>>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  phoneNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<EnumDogShelterTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  visitedByTipaw?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
};

export type DogShelterUpdateOneRequiredWithoutImgsNestedInput = {
  connect?: InputMaybe<DogShelterWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DogShelterCreateOrConnectWithoutImgsInput>;
  create?: InputMaybe<DogShelterCreateWithoutImgsInput>;
  update?: InputMaybe<DogShelterUpdateToOneWithWhereWithoutImgsInput>;
  upsert?: InputMaybe<DogShelterUpsertWithoutImgsInput>;
};

export type DogShelterUpdateOneRequiredWithoutLinksNestedInput = {
  connect?: InputMaybe<DogShelterWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DogShelterCreateOrConnectWithoutLinksInput>;
  create?: InputMaybe<DogShelterCreateWithoutLinksInput>;
  update?: InputMaybe<DogShelterUpdateToOneWithWhereWithoutLinksInput>;
  upsert?: InputMaybe<DogShelterUpsertWithoutLinksInput>;
};

export type DogShelterUpdateOneRequiredWithoutOpeningHoursNestedInput = {
  connect?: InputMaybe<DogShelterWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DogShelterCreateOrConnectWithoutOpeningHoursInput>;
  create?: InputMaybe<DogShelterCreateWithoutOpeningHoursInput>;
  update?: InputMaybe<DogShelterUpdateToOneWithWhereWithoutOpeningHoursInput>;
  upsert?: InputMaybe<DogShelterUpsertWithoutOpeningHoursInput>;
};

export type DogShelterUpdateOneRequiredWithoutTranslationsNestedInput = {
  connect?: InputMaybe<DogShelterWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DogShelterCreateOrConnectWithoutTranslationsInput>;
  create?: InputMaybe<DogShelterCreateWithoutTranslationsInput>;
  update?: InputMaybe<DogShelterUpdateToOneWithWhereWithoutTranslationsInput>;
  upsert?: InputMaybe<DogShelterUpsertWithoutTranslationsInput>;
};

export type DogShelterUpdateOneWithoutAddressNestedInput = {
  connect?: InputMaybe<DogShelterWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DogShelterCreateOrConnectWithoutAddressInput>;
  create?: InputMaybe<DogShelterCreateWithoutAddressInput>;
  delete?: InputMaybe<DogShelterWhereInput>;
  disconnect?: InputMaybe<DogShelterWhereInput>;
  update?: InputMaybe<DogShelterUpdateToOneWithWhereWithoutAddressInput>;
  upsert?: InputMaybe<DogShelterUpsertWithoutAddressInput>;
};

export type DogShelterUpdateOneWithoutAnimalsNestedInput = {
  connect?: InputMaybe<DogShelterWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DogShelterCreateOrConnectWithoutAnimalsInput>;
  create?: InputMaybe<DogShelterCreateWithoutAnimalsInput>;
  delete?: InputMaybe<DogShelterWhereInput>;
  disconnect?: InputMaybe<DogShelterWhereInput>;
  update?: InputMaybe<DogShelterUpdateToOneWithWhereWithoutAnimalsInput>;
  upsert?: InputMaybe<DogShelterUpsertWithoutAnimalsInput>;
};

export type DogShelterUpdateToOneWithWhereWithoutAddressInput = {
  data: DogShelterUpdateWithoutAddressInput;
  where?: InputMaybe<DogShelterWhereInput>;
};

export type DogShelterUpdateToOneWithWhereWithoutAnimalsInput = {
  data: DogShelterUpdateWithoutAnimalsInput;
  where?: InputMaybe<DogShelterWhereInput>;
};

export type DogShelterUpdateToOneWithWhereWithoutImgsInput = {
  data: DogShelterUpdateWithoutImgsInput;
  where?: InputMaybe<DogShelterWhereInput>;
};

export type DogShelterUpdateToOneWithWhereWithoutLinksInput = {
  data: DogShelterUpdateWithoutLinksInput;
  where?: InputMaybe<DogShelterWhereInput>;
};

export type DogShelterUpdateToOneWithWhereWithoutOpeningHoursInput = {
  data: DogShelterUpdateWithoutOpeningHoursInput;
  where?: InputMaybe<DogShelterWhereInput>;
};

export type DogShelterUpdateToOneWithWhereWithoutTranslationsInput = {
  data: DogShelterUpdateWithoutTranslationsInput;
  where?: InputMaybe<DogShelterWhereInput>;
};

export type DogShelterUpdateWithoutAddressInput = {
  acceptedAnimals?: InputMaybe<Array<AnimalTypeEnum>>;
  adminValidated?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  agreementNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  animals?: InputMaybe<AnimalUpdateManyWithoutDogShelterNestedInput>;
  associationNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  donationInfo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emails?: InputMaybe<Array<Scalars['String']['input']>>;
  imgs?: InputMaybe<DogShelterImgUpdateManyWithoutDogShelterNestedInput>;
  links?: InputMaybe<DogShelterLinkUpdateManyWithoutDogShelterNestedInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  openingHours?: InputMaybe<DogShelterOpeningHoursUpdateManyWithoutDogShelterNestedInput>;
  phoneNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  translations?: InputMaybe<DogShelterTranslationUpdateManyWithoutDogShelterNestedInput>;
  type?: InputMaybe<EnumDogShelterTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  visitedByTipaw?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
};

export type DogShelterUpdateWithoutAnimalsInput = {
  acceptedAnimals?: InputMaybe<Array<AnimalTypeEnum>>;
  address?: InputMaybe<AddressUpdateOneWithoutDogShelterNestedInput>;
  adminValidated?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  agreementNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  associationNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  donationInfo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emails?: InputMaybe<Array<Scalars['String']['input']>>;
  imgs?: InputMaybe<DogShelterImgUpdateManyWithoutDogShelterNestedInput>;
  links?: InputMaybe<DogShelterLinkUpdateManyWithoutDogShelterNestedInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  openingHours?: InputMaybe<DogShelterOpeningHoursUpdateManyWithoutDogShelterNestedInput>;
  phoneNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  translations?: InputMaybe<DogShelterTranslationUpdateManyWithoutDogShelterNestedInput>;
  type?: InputMaybe<EnumDogShelterTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  visitedByTipaw?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
};

export type DogShelterUpdateWithoutImgsInput = {
  acceptedAnimals?: InputMaybe<Array<AnimalTypeEnum>>;
  address?: InputMaybe<AddressUpdateOneWithoutDogShelterNestedInput>;
  adminValidated?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  agreementNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  animals?: InputMaybe<AnimalUpdateManyWithoutDogShelterNestedInput>;
  associationNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  donationInfo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emails?: InputMaybe<Array<Scalars['String']['input']>>;
  links?: InputMaybe<DogShelterLinkUpdateManyWithoutDogShelterNestedInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  openingHours?: InputMaybe<DogShelterOpeningHoursUpdateManyWithoutDogShelterNestedInput>;
  phoneNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  translations?: InputMaybe<DogShelterTranslationUpdateManyWithoutDogShelterNestedInput>;
  type?: InputMaybe<EnumDogShelterTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  visitedByTipaw?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
};

export type DogShelterUpdateWithoutLinksInput = {
  acceptedAnimals?: InputMaybe<Array<AnimalTypeEnum>>;
  address?: InputMaybe<AddressUpdateOneWithoutDogShelterNestedInput>;
  adminValidated?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  agreementNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  animals?: InputMaybe<AnimalUpdateManyWithoutDogShelterNestedInput>;
  associationNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  donationInfo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emails?: InputMaybe<Array<Scalars['String']['input']>>;
  imgs?: InputMaybe<DogShelterImgUpdateManyWithoutDogShelterNestedInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  openingHours?: InputMaybe<DogShelterOpeningHoursUpdateManyWithoutDogShelterNestedInput>;
  phoneNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  translations?: InputMaybe<DogShelterTranslationUpdateManyWithoutDogShelterNestedInput>;
  type?: InputMaybe<EnumDogShelterTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  visitedByTipaw?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
};

export type DogShelterUpdateWithoutOpeningHoursInput = {
  acceptedAnimals?: InputMaybe<Array<AnimalTypeEnum>>;
  address?: InputMaybe<AddressUpdateOneWithoutDogShelterNestedInput>;
  adminValidated?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  agreementNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  animals?: InputMaybe<AnimalUpdateManyWithoutDogShelterNestedInput>;
  associationNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  donationInfo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emails?: InputMaybe<Array<Scalars['String']['input']>>;
  imgs?: InputMaybe<DogShelterImgUpdateManyWithoutDogShelterNestedInput>;
  links?: InputMaybe<DogShelterLinkUpdateManyWithoutDogShelterNestedInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  phoneNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  translations?: InputMaybe<DogShelterTranslationUpdateManyWithoutDogShelterNestedInput>;
  type?: InputMaybe<EnumDogShelterTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  visitedByTipaw?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
};

export type DogShelterUpdateWithoutTranslationsInput = {
  acceptedAnimals?: InputMaybe<Array<AnimalTypeEnum>>;
  address?: InputMaybe<AddressUpdateOneWithoutDogShelterNestedInput>;
  adminValidated?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  agreementNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  animals?: InputMaybe<AnimalUpdateManyWithoutDogShelterNestedInput>;
  associationNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  donationInfo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emails?: InputMaybe<Array<Scalars['String']['input']>>;
  imgs?: InputMaybe<DogShelterImgUpdateManyWithoutDogShelterNestedInput>;
  links?: InputMaybe<DogShelterLinkUpdateManyWithoutDogShelterNestedInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  openingHours?: InputMaybe<DogShelterOpeningHoursUpdateManyWithoutDogShelterNestedInput>;
  phoneNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<EnumDogShelterTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  visitedByTipaw?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
};

export type DogShelterUpdateacceptedAnimalsInput = {
  push?: InputMaybe<Array<AnimalTypeEnum>>;
  set?: InputMaybe<Array<AnimalTypeEnum>>;
};

export type DogShelterUpdateemailsInput = {
  push?: InputMaybe<Array<Scalars['String']['input']>>;
  set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type DogShelterUpdatephoneNumbersInput = {
  push?: InputMaybe<Array<Scalars['String']['input']>>;
  set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type DogShelterUpdatespokenLanguagesInput = {
  push?: InputMaybe<Array<Scalars['String']['input']>>;
  set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type DogShelterUpdatetagsInput = {
  push?: InputMaybe<Array<Scalars['String']['input']>>;
  set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type DogShelterUpsertWithoutAddressInput = {
  create: DogShelterCreateWithoutAddressInput;
  update: DogShelterUpdateWithoutAddressInput;
  where?: InputMaybe<DogShelterWhereInput>;
};

export type DogShelterUpsertWithoutAnimalsInput = {
  create: DogShelterCreateWithoutAnimalsInput;
  update: DogShelterUpdateWithoutAnimalsInput;
  where?: InputMaybe<DogShelterWhereInput>;
};

export type DogShelterUpsertWithoutImgsInput = {
  create: DogShelterCreateWithoutImgsInput;
  update: DogShelterUpdateWithoutImgsInput;
  where?: InputMaybe<DogShelterWhereInput>;
};

export type DogShelterUpsertWithoutLinksInput = {
  create: DogShelterCreateWithoutLinksInput;
  update: DogShelterUpdateWithoutLinksInput;
  where?: InputMaybe<DogShelterWhereInput>;
};

export type DogShelterUpsertWithoutOpeningHoursInput = {
  create: DogShelterCreateWithoutOpeningHoursInput;
  update: DogShelterUpdateWithoutOpeningHoursInput;
  where?: InputMaybe<DogShelterWhereInput>;
};

export type DogShelterUpsertWithoutTranslationsInput = {
  create: DogShelterCreateWithoutTranslationsInput;
  update: DogShelterUpdateWithoutTranslationsInput;
  where?: InputMaybe<DogShelterWhereInput>;
};

export type DogShelterWhereInput = {
  AND?: InputMaybe<Array<DogShelterWhereInput>>;
  NOT?: InputMaybe<Array<DogShelterWhereInput>>;
  OR?: InputMaybe<Array<DogShelterWhereInput>>;
  acceptedAnimals?: InputMaybe<EnumAnimalTypeEnumNullableListFilter>;
  address?: InputMaybe<AddressNullableRelationFilter>;
  addressId?: InputMaybe<IntNullableFilter>;
  adminValidated?: InputMaybe<BoolNullableFilter>;
  agreementNumber?: InputMaybe<StringNullableFilter>;
  animals?: InputMaybe<AnimalListRelationFilter>;
  associationNumber?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  donationInfo?: InputMaybe<StringNullableFilter>;
  emails?: InputMaybe<StringNullableListFilter>;
  id?: InputMaybe<IntFilter>;
  imgs?: InputMaybe<DogShelterImgListRelationFilter>;
  links?: InputMaybe<DogShelterLinkListRelationFilter>;
  name?: InputMaybe<StringNullableFilter>;
  openingHours?: InputMaybe<DogShelterOpeningHoursListRelationFilter>;
  phoneNumbers?: InputMaybe<StringNullableListFilter>;
  spokenLanguages?: InputMaybe<StringNullableListFilter>;
  tags?: InputMaybe<StringNullableListFilter>;
  translations?: InputMaybe<DogShelterTranslationListRelationFilter>;
  type?: InputMaybe<EnumDogShelterTypeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  visitedByTipaw?: InputMaybe<BoolNullableFilter>;
};

export type DogShelterWhereUniqueInput = {
  AND?: InputMaybe<Array<DogShelterWhereInput>>;
  NOT?: InputMaybe<Array<DogShelterWhereInput>>;
  OR?: InputMaybe<Array<DogShelterWhereInput>>;
  acceptedAnimals?: InputMaybe<EnumAnimalTypeEnumNullableListFilter>;
  address?: InputMaybe<AddressNullableRelationFilter>;
  addressId?: InputMaybe<Scalars['Int']['input']>;
  adminValidated?: InputMaybe<BoolNullableFilter>;
  agreementNumber?: InputMaybe<StringNullableFilter>;
  animals?: InputMaybe<AnimalListRelationFilter>;
  associationNumber?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  donationInfo?: InputMaybe<StringNullableFilter>;
  emails?: InputMaybe<StringNullableListFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  imgs?: InputMaybe<DogShelterImgListRelationFilter>;
  links?: InputMaybe<DogShelterLinkListRelationFilter>;
  name?: InputMaybe<StringNullableFilter>;
  openingHours?: InputMaybe<DogShelterOpeningHoursListRelationFilter>;
  phoneNumbers?: InputMaybe<StringNullableListFilter>;
  spokenLanguages?: InputMaybe<StringNullableListFilter>;
  tags?: InputMaybe<StringNullableListFilter>;
  translations?: InputMaybe<DogShelterTranslationListRelationFilter>;
  type?: InputMaybe<EnumDogShelterTypeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  visitedByTipaw?: InputMaybe<BoolNullableFilter>;
};

export enum DogType {
  PET = 'PET',
  SPORT = 'SPORT',
  WATCH = 'WATCH'
}

export enum EducatorPracticePlaceEnum {
  OWN_PLACE = 'OWN_PLACE',
  PUBLIC_PLACE = 'PUBLIC_PLACE',
  VIDEOCALL = 'VIDEOCALL',
  VISIT_AT_HOME = 'VISIT_AT_HOME'
}

export type EducatorReview = {
  __typename?: 'EducatorReview';
  account: Account;
  accountId: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  grade?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  professional: Professional;
  professionalId: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
  verified: Scalars['Boolean']['output'];
};

export type EducatorReviewAvgAggregateOutputType = {
  __typename?: 'EducatorReviewAvgAggregateOutputType';
  accountId?: Maybe<Scalars['Float']['output']>;
  grade?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  professionalId?: Maybe<Scalars['Float']['output']>;
};

export type EducatorReviewAvgOrderByAggregateInput = {
  accountId?: InputMaybe<SortOrder>;
  grade?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  professionalId?: InputMaybe<SortOrder>;
};

export type EducatorReviewCountAggregateOutputType = {
  __typename?: 'EducatorReviewCountAggregateOutputType';
  _all: Scalars['Int']['output'];
  accountId: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  description: Scalars['Int']['output'];
  grade: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  professionalId: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
  verified: Scalars['Int']['output'];
};

export type EducatorReviewCountOrderByAggregateInput = {
  accountId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  grade?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  professionalId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  verified?: InputMaybe<SortOrder>;
};

export type EducatorReviewCreateInput = {
  account: AccountCreateNestedOneWithoutEducatorReviewsInput;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  grade?: InputMaybe<Scalars['Int']['input']>;
  professional: ProfessionalCreateNestedOneWithoutReviewsInput;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EducatorReviewCreateManyAccountInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  grade?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  professionalId: Scalars['Int']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EducatorReviewCreateManyAccountInputEnvelope = {
  data: Array<EducatorReviewCreateManyAccountInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EducatorReviewCreateManyInput = {
  accountId: Scalars['Int']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  grade?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  professionalId: Scalars['Int']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EducatorReviewCreateManyProfessionalInput = {
  accountId: Scalars['Int']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  grade?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EducatorReviewCreateManyProfessionalInputEnvelope = {
  data: Array<EducatorReviewCreateManyProfessionalInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EducatorReviewCreateNestedManyWithoutAccountInput = {
  connect?: InputMaybe<Array<EducatorReviewWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<EducatorReviewCreateOrConnectWithoutAccountInput>>;
  create?: InputMaybe<Array<EducatorReviewCreateWithoutAccountInput>>;
  createMany?: InputMaybe<EducatorReviewCreateManyAccountInputEnvelope>;
};

export type EducatorReviewCreateNestedManyWithoutProfessionalInput = {
  connect?: InputMaybe<Array<EducatorReviewWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<EducatorReviewCreateOrConnectWithoutProfessionalInput>>;
  create?: InputMaybe<Array<EducatorReviewCreateWithoutProfessionalInput>>;
  createMany?: InputMaybe<EducatorReviewCreateManyProfessionalInputEnvelope>;
};

export type EducatorReviewCreateOrConnectWithoutAccountInput = {
  create: EducatorReviewCreateWithoutAccountInput;
  where: EducatorReviewWhereUniqueInput;
};

export type EducatorReviewCreateOrConnectWithoutProfessionalInput = {
  create: EducatorReviewCreateWithoutProfessionalInput;
  where: EducatorReviewWhereUniqueInput;
};

export type EducatorReviewCreateWithoutAccountInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  grade?: InputMaybe<Scalars['Int']['input']>;
  professional: ProfessionalCreateNestedOneWithoutReviewsInput;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EducatorReviewCreateWithoutProfessionalInput = {
  account: AccountCreateNestedOneWithoutEducatorReviewsInput;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  grade?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EducatorReviewListRelationFilter = {
  every?: InputMaybe<EducatorReviewWhereInput>;
  none?: InputMaybe<EducatorReviewWhereInput>;
  some?: InputMaybe<EducatorReviewWhereInput>;
};

export type EducatorReviewMaxAggregateOutputType = {
  __typename?: 'EducatorReviewMaxAggregateOutputType';
  accountId?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  grade?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  professionalId?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  verified?: Maybe<Scalars['Boolean']['output']>;
};

export type EducatorReviewMaxOrderByAggregateInput = {
  accountId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  grade?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  professionalId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  verified?: InputMaybe<SortOrder>;
};

export type EducatorReviewMinAggregateOutputType = {
  __typename?: 'EducatorReviewMinAggregateOutputType';
  accountId?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  grade?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  professionalId?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  verified?: Maybe<Scalars['Boolean']['output']>;
};

export type EducatorReviewMinOrderByAggregateInput = {
  accountId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  grade?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  professionalId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  verified?: InputMaybe<SortOrder>;
};

export type EducatorReviewOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export enum EducatorReviewOrderByRelevanceFieldEnum {
  description = 'description'
}

export type EducatorReviewOrderByRelevanceInput = {
  fields: Array<EducatorReviewOrderByRelevanceFieldEnum>;
  search: Scalars['String']['input'];
  sort: SortOrder;
};

export type EducatorReviewOrderByWithAggregationInput = {
  _avg?: InputMaybe<EducatorReviewAvgOrderByAggregateInput>;
  _count?: InputMaybe<EducatorReviewCountOrderByAggregateInput>;
  _max?: InputMaybe<EducatorReviewMaxOrderByAggregateInput>;
  _min?: InputMaybe<EducatorReviewMinOrderByAggregateInput>;
  _sum?: InputMaybe<EducatorReviewSumOrderByAggregateInput>;
  accountId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrderInput>;
  grade?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  professionalId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  verified?: InputMaybe<SortOrder>;
};

export type EducatorReviewOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: InputMaybe<EducatorReviewOrderByRelevanceInput>;
  account?: InputMaybe<AccountOrderByWithRelationAndSearchRelevanceInput>;
  accountId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrderInput>;
  grade?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  professional?: InputMaybe<ProfessionalOrderByWithRelationAndSearchRelevanceInput>;
  professionalId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  verified?: InputMaybe<SortOrder>;
};

export enum EducatorReviewScalarFieldEnum {
  accountId = 'accountId',
  createdAt = 'createdAt',
  description = 'description',
  grade = 'grade',
  id = 'id',
  professionalId = 'professionalId',
  updatedAt = 'updatedAt',
  verified = 'verified'
}

export type EducatorReviewScalarWhereInput = {
  AND?: InputMaybe<Array<EducatorReviewScalarWhereInput>>;
  NOT?: InputMaybe<Array<EducatorReviewScalarWhereInput>>;
  OR?: InputMaybe<Array<EducatorReviewScalarWhereInput>>;
  accountId?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringNullableFilter>;
  grade?: InputMaybe<IntNullableFilter>;
  id?: InputMaybe<IntFilter>;
  professionalId?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  verified?: InputMaybe<BoolFilter>;
};

export type EducatorReviewScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<EducatorReviewScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<EducatorReviewScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<EducatorReviewScalarWhereWithAggregatesInput>>;
  accountId?: InputMaybe<IntWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  description?: InputMaybe<StringNullableWithAggregatesFilter>;
  grade?: InputMaybe<IntNullableWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  professionalId?: InputMaybe<IntWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  verified?: InputMaybe<BoolWithAggregatesFilter>;
};

export type EducatorReviewSumAggregateOutputType = {
  __typename?: 'EducatorReviewSumAggregateOutputType';
  accountId?: Maybe<Scalars['Int']['output']>;
  grade?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  professionalId?: Maybe<Scalars['Int']['output']>;
};

export type EducatorReviewSumOrderByAggregateInput = {
  accountId?: InputMaybe<SortOrder>;
  grade?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  professionalId?: InputMaybe<SortOrder>;
};

export type EducatorReviewUncheckedCreateInput = {
  accountId: Scalars['Int']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  grade?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  professionalId: Scalars['Int']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EducatorReviewUncheckedCreateNestedManyWithoutAccountInput = {
  connect?: InputMaybe<Array<EducatorReviewWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<EducatorReviewCreateOrConnectWithoutAccountInput>>;
  create?: InputMaybe<Array<EducatorReviewCreateWithoutAccountInput>>;
  createMany?: InputMaybe<EducatorReviewCreateManyAccountInputEnvelope>;
};

export type EducatorReviewUncheckedCreateNestedManyWithoutProfessionalInput = {
  connect?: InputMaybe<Array<EducatorReviewWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<EducatorReviewCreateOrConnectWithoutProfessionalInput>>;
  create?: InputMaybe<Array<EducatorReviewCreateWithoutProfessionalInput>>;
  createMany?: InputMaybe<EducatorReviewCreateManyProfessionalInputEnvelope>;
};

export type EducatorReviewUncheckedCreateWithoutAccountInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  grade?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  professionalId: Scalars['Int']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EducatorReviewUncheckedCreateWithoutProfessionalInput = {
  accountId: Scalars['Int']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  grade?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EducatorReviewUncheckedUpdateInput = {
  accountId?: InputMaybe<IntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  grade?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  professionalId?: InputMaybe<IntFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  verified?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type EducatorReviewUncheckedUpdateManyInput = {
  accountId?: InputMaybe<IntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  grade?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  professionalId?: InputMaybe<IntFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  verified?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type EducatorReviewUncheckedUpdateManyWithoutAccountInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  grade?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  professionalId?: InputMaybe<IntFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  verified?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type EducatorReviewUncheckedUpdateManyWithoutAccountNestedInput = {
  connect?: InputMaybe<Array<EducatorReviewWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<EducatorReviewCreateOrConnectWithoutAccountInput>>;
  create?: InputMaybe<Array<EducatorReviewCreateWithoutAccountInput>>;
  createMany?: InputMaybe<EducatorReviewCreateManyAccountInputEnvelope>;
  delete?: InputMaybe<Array<EducatorReviewWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<EducatorReviewScalarWhereInput>>;
  disconnect?: InputMaybe<Array<EducatorReviewWhereUniqueInput>>;
  set?: InputMaybe<Array<EducatorReviewWhereUniqueInput>>;
  update?: InputMaybe<Array<EducatorReviewUpdateWithWhereUniqueWithoutAccountInput>>;
  updateMany?: InputMaybe<Array<EducatorReviewUpdateManyWithWhereWithoutAccountInput>>;
  upsert?: InputMaybe<Array<EducatorReviewUpsertWithWhereUniqueWithoutAccountInput>>;
};

export type EducatorReviewUncheckedUpdateManyWithoutProfessionalInput = {
  accountId?: InputMaybe<IntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  grade?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  verified?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type EducatorReviewUncheckedUpdateManyWithoutProfessionalNestedInput = {
  connect?: InputMaybe<Array<EducatorReviewWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<EducatorReviewCreateOrConnectWithoutProfessionalInput>>;
  create?: InputMaybe<Array<EducatorReviewCreateWithoutProfessionalInput>>;
  createMany?: InputMaybe<EducatorReviewCreateManyProfessionalInputEnvelope>;
  delete?: InputMaybe<Array<EducatorReviewWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<EducatorReviewScalarWhereInput>>;
  disconnect?: InputMaybe<Array<EducatorReviewWhereUniqueInput>>;
  set?: InputMaybe<Array<EducatorReviewWhereUniqueInput>>;
  update?: InputMaybe<Array<EducatorReviewUpdateWithWhereUniqueWithoutProfessionalInput>>;
  updateMany?: InputMaybe<Array<EducatorReviewUpdateManyWithWhereWithoutProfessionalInput>>;
  upsert?: InputMaybe<Array<EducatorReviewUpsertWithWhereUniqueWithoutProfessionalInput>>;
};

export type EducatorReviewUncheckedUpdateWithoutAccountInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  grade?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  professionalId?: InputMaybe<IntFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  verified?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type EducatorReviewUncheckedUpdateWithoutProfessionalInput = {
  accountId?: InputMaybe<IntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  grade?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  verified?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type EducatorReviewUpdateInput = {
  account?: InputMaybe<AccountUpdateOneRequiredWithoutEducatorReviewsNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  grade?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  professional?: InputMaybe<ProfessionalUpdateOneRequiredWithoutReviewsNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  verified?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type EducatorReviewUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  grade?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  verified?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type EducatorReviewUpdateManyWithWhereWithoutAccountInput = {
  data: EducatorReviewUpdateManyMutationInput;
  where: EducatorReviewScalarWhereInput;
};

export type EducatorReviewUpdateManyWithWhereWithoutProfessionalInput = {
  data: EducatorReviewUpdateManyMutationInput;
  where: EducatorReviewScalarWhereInput;
};

export type EducatorReviewUpdateManyWithoutAccountNestedInput = {
  connect?: InputMaybe<Array<EducatorReviewWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<EducatorReviewCreateOrConnectWithoutAccountInput>>;
  create?: InputMaybe<Array<EducatorReviewCreateWithoutAccountInput>>;
  createMany?: InputMaybe<EducatorReviewCreateManyAccountInputEnvelope>;
  delete?: InputMaybe<Array<EducatorReviewWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<EducatorReviewScalarWhereInput>>;
  disconnect?: InputMaybe<Array<EducatorReviewWhereUniqueInput>>;
  set?: InputMaybe<Array<EducatorReviewWhereUniqueInput>>;
  update?: InputMaybe<Array<EducatorReviewUpdateWithWhereUniqueWithoutAccountInput>>;
  updateMany?: InputMaybe<Array<EducatorReviewUpdateManyWithWhereWithoutAccountInput>>;
  upsert?: InputMaybe<Array<EducatorReviewUpsertWithWhereUniqueWithoutAccountInput>>;
};

export type EducatorReviewUpdateManyWithoutProfessionalNestedInput = {
  connect?: InputMaybe<Array<EducatorReviewWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<EducatorReviewCreateOrConnectWithoutProfessionalInput>>;
  create?: InputMaybe<Array<EducatorReviewCreateWithoutProfessionalInput>>;
  createMany?: InputMaybe<EducatorReviewCreateManyProfessionalInputEnvelope>;
  delete?: InputMaybe<Array<EducatorReviewWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<EducatorReviewScalarWhereInput>>;
  disconnect?: InputMaybe<Array<EducatorReviewWhereUniqueInput>>;
  set?: InputMaybe<Array<EducatorReviewWhereUniqueInput>>;
  update?: InputMaybe<Array<EducatorReviewUpdateWithWhereUniqueWithoutProfessionalInput>>;
  updateMany?: InputMaybe<Array<EducatorReviewUpdateManyWithWhereWithoutProfessionalInput>>;
  upsert?: InputMaybe<Array<EducatorReviewUpsertWithWhereUniqueWithoutProfessionalInput>>;
};

export type EducatorReviewUpdateWithWhereUniqueWithoutAccountInput = {
  data: EducatorReviewUpdateWithoutAccountInput;
  where: EducatorReviewWhereUniqueInput;
};

export type EducatorReviewUpdateWithWhereUniqueWithoutProfessionalInput = {
  data: EducatorReviewUpdateWithoutProfessionalInput;
  where: EducatorReviewWhereUniqueInput;
};

export type EducatorReviewUpdateWithoutAccountInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  grade?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  professional?: InputMaybe<ProfessionalUpdateOneRequiredWithoutReviewsNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  verified?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type EducatorReviewUpdateWithoutProfessionalInput = {
  account?: InputMaybe<AccountUpdateOneRequiredWithoutEducatorReviewsNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  grade?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  verified?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type EducatorReviewUpsertWithWhereUniqueWithoutAccountInput = {
  create: EducatorReviewCreateWithoutAccountInput;
  update: EducatorReviewUpdateWithoutAccountInput;
  where: EducatorReviewWhereUniqueInput;
};

export type EducatorReviewUpsertWithWhereUniqueWithoutProfessionalInput = {
  create: EducatorReviewCreateWithoutProfessionalInput;
  update: EducatorReviewUpdateWithoutProfessionalInput;
  where: EducatorReviewWhereUniqueInput;
};

export type EducatorReviewWhereInput = {
  AND?: InputMaybe<Array<EducatorReviewWhereInput>>;
  NOT?: InputMaybe<Array<EducatorReviewWhereInput>>;
  OR?: InputMaybe<Array<EducatorReviewWhereInput>>;
  account?: InputMaybe<AccountRelationFilter>;
  accountId?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringNullableFilter>;
  grade?: InputMaybe<IntNullableFilter>;
  id?: InputMaybe<IntFilter>;
  professional?: InputMaybe<ProfessionalRelationFilter>;
  professionalId?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  verified?: InputMaybe<BoolFilter>;
};

export type EducatorReviewWhereUniqueInput = {
  AND?: InputMaybe<Array<EducatorReviewWhereInput>>;
  NOT?: InputMaybe<Array<EducatorReviewWhereInput>>;
  OR?: InputMaybe<Array<EducatorReviewWhereInput>>;
  account?: InputMaybe<AccountRelationFilter>;
  accountId?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringNullableFilter>;
  grade?: InputMaybe<IntNullableFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  professional?: InputMaybe<ProfessionalRelationFilter>;
  professionalId?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  verified?: InputMaybe<BoolFilter>;
};

export enum EducatorTypeEnum {
  BEHAVIORIST = 'BEHAVIORIST',
  EDUCATOR = 'EDUCATOR',
  EDUCATOR_AND_BEHAVIORIST = 'EDUCATOR_AND_BEHAVIORIST'
}

export type EmailBlacklistAvgAggregateOutputType = {
  __typename?: 'EmailBlacklistAvgAggregateOutputType';
  id?: Maybe<Scalars['Float']['output']>;
};

export type EmailBlacklistAvgOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
};

export type EmailBlacklistCountAggregateOutputType = {
  __typename?: 'EmailBlacklistCountAggregateOutputType';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  email: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type EmailBlacklistCountOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type EmailBlacklistCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  email: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type EmailBlacklistCreateManyInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  email: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type EmailBlacklistMaxAggregateOutputType = {
  __typename?: 'EmailBlacklistMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type EmailBlacklistMaxOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type EmailBlacklistMinAggregateOutputType = {
  __typename?: 'EmailBlacklistMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type EmailBlacklistMinOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum EmailBlacklistOrderByRelevanceFieldEnum {
  email = 'email'
}

export type EmailBlacklistOrderByRelevanceInput = {
  fields: Array<EmailBlacklistOrderByRelevanceFieldEnum>;
  search: Scalars['String']['input'];
  sort: SortOrder;
};

export type EmailBlacklistOrderByWithAggregationInput = {
  _avg?: InputMaybe<EmailBlacklistAvgOrderByAggregateInput>;
  _count?: InputMaybe<EmailBlacklistCountOrderByAggregateInput>;
  _max?: InputMaybe<EmailBlacklistMaxOrderByAggregateInput>;
  _min?: InputMaybe<EmailBlacklistMinOrderByAggregateInput>;
  _sum?: InputMaybe<EmailBlacklistSumOrderByAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type EmailBlacklistOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: InputMaybe<EmailBlacklistOrderByRelevanceInput>;
  createdAt?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum EmailBlacklistScalarFieldEnum {
  createdAt = 'createdAt',
  email = 'email',
  id = 'id',
  updatedAt = 'updatedAt'
}

export type EmailBlacklistScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<EmailBlacklistScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<EmailBlacklistScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<EmailBlacklistScalarWhereWithAggregatesInput>>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  email?: InputMaybe<StringWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type EmailBlacklistSumAggregateOutputType = {
  __typename?: 'EmailBlacklistSumAggregateOutputType';
  id?: Maybe<Scalars['Int']['output']>;
};

export type EmailBlacklistSumOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
};

export type EmailBlacklistUncheckedCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  email: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type EmailBlacklistUncheckedUpdateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type EmailBlacklistUncheckedUpdateManyInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type EmailBlacklistUpdateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type EmailBlacklistUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type EmailBlacklistWhereInput = {
  AND?: InputMaybe<Array<EmailBlacklistWhereInput>>;
  NOT?: InputMaybe<Array<EmailBlacklistWhereInput>>;
  OR?: InputMaybe<Array<EmailBlacklistWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  email?: InputMaybe<StringFilter>;
  id?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type EmailBlacklistWhereUniqueInput = {
  AND?: InputMaybe<Array<EmailBlacklistWhereInput>>;
  NOT?: InputMaybe<Array<EmailBlacklistWhereInput>>;
  OR?: InputMaybe<Array<EmailBlacklistWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type EmailContact = {
  __typename?: 'EmailContact';
  country?: Maybe<CountryCode>;
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  hasADog: Scalars['Boolean']['output'];
  hasTakenBreedTest: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  language: Scalars['String']['output'];
  lookingFor?: Maybe<Scalars['String']['output']>;
  marketingEmailConsent: Scalars['Boolean']['output'];
  sensitivities?: Maybe<Array<Maybe<AnimalSensitivityEnum>>>;
  updatedAt: Scalars['DateTime']['output'];
};

export type EmailContactAvgAggregateOutputType = {
  __typename?: 'EmailContactAvgAggregateOutputType';
  accountId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

export type EmailContactAvgOrderByAggregateInput = {
  accountId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export type EmailContactCountAggregateOutputType = {
  __typename?: 'EmailContactCountAggregateOutputType';
  _all: Scalars['Int']['output'];
  accountId: Scalars['Int']['output'];
  contactPreferences: Scalars['Int']['output'];
  country: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  createdFrom: Scalars['Int']['output'];
  email: Scalars['Int']['output'];
  firstName: Scalars['Int']['output'];
  hasTakenBreedTest: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  language: Scalars['Int']['output'];
  lastName: Scalars['Int']['output'];
  marketingEmailConsent: Scalars['Int']['output'];
  phone: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type EmailContactCountOrderByAggregateInput = {
  accountId?: InputMaybe<SortOrder>;
  contactPreferences?: InputMaybe<SortOrder>;
  country?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  createdFrom?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  firstName?: InputMaybe<SortOrder>;
  hasTakenBreedTest?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  language?: InputMaybe<SortOrder>;
  lastName?: InputMaybe<SortOrder>;
  marketingEmailConsent?: InputMaybe<SortOrder>;
  phone?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type EmailContactCreateInput = {
  account?: InputMaybe<AccountCreateNestedOneWithoutEmailContactInput>;
  breedInterestSubscription?: InputMaybe<DogBreedInterestSubscriptionCreateNestedOneWithoutEmailContactInput>;
  contactPreferences?: InputMaybe<Array<ContactPreference>>;
  country?: InputMaybe<CountryCode>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdFrom?: InputMaybe<EmailContactCreatedFromEnum>;
  email: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  hasTakenBreedTest?: InputMaybe<Scalars['Boolean']['input']>;
  language: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  marketingEmailConsent?: InputMaybe<Scalars['Boolean']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type EmailContactCreateManyInput = {
  accountId?: InputMaybe<Scalars['Int']['input']>;
  contactPreferences?: InputMaybe<Array<ContactPreference>>;
  country?: InputMaybe<CountryCode>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdFrom?: InputMaybe<EmailContactCreatedFromEnum>;
  email: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  hasTakenBreedTest?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  language: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  marketingEmailConsent?: InputMaybe<Scalars['Boolean']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type EmailContactCreateNestedOneWithoutAccountInput = {
  connect?: InputMaybe<EmailContactWhereUniqueInput>;
  connectOrCreate?: InputMaybe<EmailContactCreateOrConnectWithoutAccountInput>;
  create?: InputMaybe<EmailContactCreateWithoutAccountInput>;
};

export type EmailContactCreateNestedOneWithoutBreedInterestSubscriptionInput = {
  connect?: InputMaybe<EmailContactWhereUniqueInput>;
  connectOrCreate?: InputMaybe<EmailContactCreateOrConnectWithoutBreedInterestSubscriptionInput>;
  create?: InputMaybe<EmailContactCreateWithoutBreedInterestSubscriptionInput>;
};

export type EmailContactCreateOrConnectWithoutAccountInput = {
  create: EmailContactCreateWithoutAccountInput;
  where: EmailContactWhereUniqueInput;
};

export type EmailContactCreateOrConnectWithoutBreedInterestSubscriptionInput = {
  create: EmailContactCreateWithoutBreedInterestSubscriptionInput;
  where: EmailContactWhereUniqueInput;
};

export type EmailContactCreateWithoutAccountInput = {
  breedInterestSubscription?: InputMaybe<DogBreedInterestSubscriptionCreateNestedOneWithoutEmailContactInput>;
  contactPreferences?: InputMaybe<Array<ContactPreference>>;
  country?: InputMaybe<CountryCode>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdFrom?: InputMaybe<EmailContactCreatedFromEnum>;
  email: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  hasTakenBreedTest?: InputMaybe<Scalars['Boolean']['input']>;
  language: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  marketingEmailConsent?: InputMaybe<Scalars['Boolean']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type EmailContactCreateWithoutBreedInterestSubscriptionInput = {
  account?: InputMaybe<AccountCreateNestedOneWithoutEmailContactInput>;
  contactPreferences?: InputMaybe<Array<ContactPreference>>;
  country?: InputMaybe<CountryCode>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdFrom?: InputMaybe<EmailContactCreatedFromEnum>;
  email: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  hasTakenBreedTest?: InputMaybe<Scalars['Boolean']['input']>;
  language: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  marketingEmailConsent?: InputMaybe<Scalars['Boolean']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type EmailContactCreatecontactPreferencesInput = {
  set: Array<ContactPreference>;
};

export enum EmailContactCreatedFromEnum {
  BREED_COMPARATOR = 'BREED_COMPARATOR',
  BREED_INTEREST = 'BREED_INTEREST',
  NEWSLETTER = 'NEWSLETTER',
  QUIZZ = 'QUIZZ',
  WHATSAPP = 'WHATSAPP',
  WHATSAPP_BREEDER = 'WHATSAPP_BREEDER',
  WHATSAPP_GROOMER = 'WHATSAPP_GROOMER'
}

export type EmailContactMaxAggregateOutputType = {
  __typename?: 'EmailContactMaxAggregateOutputType';
  accountId?: Maybe<Scalars['Int']['output']>;
  country?: Maybe<CountryCode>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdFrom?: Maybe<EmailContactCreatedFromEnum>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  hasTakenBreedTest?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  marketingEmailConsent?: Maybe<Scalars['Boolean']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type EmailContactMaxOrderByAggregateInput = {
  accountId?: InputMaybe<SortOrder>;
  country?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  createdFrom?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  firstName?: InputMaybe<SortOrder>;
  hasTakenBreedTest?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  language?: InputMaybe<SortOrder>;
  lastName?: InputMaybe<SortOrder>;
  marketingEmailConsent?: InputMaybe<SortOrder>;
  phone?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type EmailContactMinAggregateOutputType = {
  __typename?: 'EmailContactMinAggregateOutputType';
  accountId?: Maybe<Scalars['Int']['output']>;
  country?: Maybe<CountryCode>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdFrom?: Maybe<EmailContactCreatedFromEnum>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  hasTakenBreedTest?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  marketingEmailConsent?: Maybe<Scalars['Boolean']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type EmailContactMinOrderByAggregateInput = {
  accountId?: InputMaybe<SortOrder>;
  country?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  createdFrom?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  firstName?: InputMaybe<SortOrder>;
  hasTakenBreedTest?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  language?: InputMaybe<SortOrder>;
  lastName?: InputMaybe<SortOrder>;
  marketingEmailConsent?: InputMaybe<SortOrder>;
  phone?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type EmailContactNullableRelationFilter = {
  is?: InputMaybe<EmailContactWhereInput>;
  isNot?: InputMaybe<EmailContactWhereInput>;
};

export enum EmailContactOrderByRelevanceFieldEnum {
  email = 'email',
  firstName = 'firstName',
  language = 'language',
  lastName = 'lastName',
  phone = 'phone'
}

export type EmailContactOrderByRelevanceInput = {
  fields: Array<EmailContactOrderByRelevanceFieldEnum>;
  search: Scalars['String']['input'];
  sort: SortOrder;
};

export type EmailContactOrderByWithAggregationInput = {
  _avg?: InputMaybe<EmailContactAvgOrderByAggregateInput>;
  _count?: InputMaybe<EmailContactCountOrderByAggregateInput>;
  _max?: InputMaybe<EmailContactMaxOrderByAggregateInput>;
  _min?: InputMaybe<EmailContactMinOrderByAggregateInput>;
  _sum?: InputMaybe<EmailContactSumOrderByAggregateInput>;
  accountId?: InputMaybe<SortOrderInput>;
  contactPreferences?: InputMaybe<SortOrder>;
  country?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  createdFrom?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  firstName?: InputMaybe<SortOrderInput>;
  hasTakenBreedTest?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  language?: InputMaybe<SortOrder>;
  lastName?: InputMaybe<SortOrderInput>;
  marketingEmailConsent?: InputMaybe<SortOrder>;
  phone?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type EmailContactOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: InputMaybe<EmailContactOrderByRelevanceInput>;
  account?: InputMaybe<AccountOrderByWithRelationAndSearchRelevanceInput>;
  accountId?: InputMaybe<SortOrderInput>;
  breedInterestSubscription?: InputMaybe<DogBreedInterestSubscriptionOrderByWithRelationAndSearchRelevanceInput>;
  contactPreferences?: InputMaybe<SortOrder>;
  country?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  createdFrom?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  firstName?: InputMaybe<SortOrderInput>;
  hasTakenBreedTest?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  language?: InputMaybe<SortOrder>;
  lastName?: InputMaybe<SortOrderInput>;
  marketingEmailConsent?: InputMaybe<SortOrder>;
  phone?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type EmailContactRelationFilter = {
  is?: InputMaybe<EmailContactWhereInput>;
  isNot?: InputMaybe<EmailContactWhereInput>;
};

export enum EmailContactScalarFieldEnum {
  accountId = 'accountId',
  contactPreferences = 'contactPreferences',
  country = 'country',
  createdAt = 'createdAt',
  createdFrom = 'createdFrom',
  email = 'email',
  firstName = 'firstName',
  hasTakenBreedTest = 'hasTakenBreedTest',
  id = 'id',
  language = 'language',
  lastName = 'lastName',
  marketingEmailConsent = 'marketingEmailConsent',
  phone = 'phone',
  updatedAt = 'updatedAt'
}

export type EmailContactScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<EmailContactScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<EmailContactScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<EmailContactScalarWhereWithAggregatesInput>>;
  accountId?: InputMaybe<IntNullableWithAggregatesFilter>;
  contactPreferences?: InputMaybe<EnumContactPreferenceNullableListFilter>;
  country?: InputMaybe<EnumCountryCodeWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  createdFrom?: InputMaybe<EnumEmailContactCreatedFromEnumWithAggregatesFilter>;
  email?: InputMaybe<StringWithAggregatesFilter>;
  firstName?: InputMaybe<StringNullableWithAggregatesFilter>;
  hasTakenBreedTest?: InputMaybe<BoolWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  language?: InputMaybe<StringWithAggregatesFilter>;
  lastName?: InputMaybe<StringNullableWithAggregatesFilter>;
  marketingEmailConsent?: InputMaybe<BoolWithAggregatesFilter>;
  phone?: InputMaybe<StringNullableWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type EmailContactSumAggregateOutputType = {
  __typename?: 'EmailContactSumAggregateOutputType';
  accountId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
};

export type EmailContactSumOrderByAggregateInput = {
  accountId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export type EmailContactUncheckedCreateInput = {
  accountId?: InputMaybe<Scalars['Int']['input']>;
  breedInterestSubscription?: InputMaybe<DogBreedInterestSubscriptionUncheckedCreateNestedOneWithoutEmailContactInput>;
  contactPreferences?: InputMaybe<Array<ContactPreference>>;
  country?: InputMaybe<CountryCode>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdFrom?: InputMaybe<EmailContactCreatedFromEnum>;
  email: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  hasTakenBreedTest?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  language: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  marketingEmailConsent?: InputMaybe<Scalars['Boolean']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type EmailContactUncheckedCreateNestedOneWithoutAccountInput = {
  connect?: InputMaybe<EmailContactWhereUniqueInput>;
  connectOrCreate?: InputMaybe<EmailContactCreateOrConnectWithoutAccountInput>;
  create?: InputMaybe<EmailContactCreateWithoutAccountInput>;
};

export type EmailContactUncheckedCreateWithoutAccountInput = {
  breedInterestSubscription?: InputMaybe<DogBreedInterestSubscriptionUncheckedCreateNestedOneWithoutEmailContactInput>;
  contactPreferences?: InputMaybe<Array<ContactPreference>>;
  country?: InputMaybe<CountryCode>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdFrom?: InputMaybe<EmailContactCreatedFromEnum>;
  email: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  hasTakenBreedTest?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  language: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  marketingEmailConsent?: InputMaybe<Scalars['Boolean']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type EmailContactUncheckedCreateWithoutBreedInterestSubscriptionInput = {
  accountId?: InputMaybe<Scalars['Int']['input']>;
  contactPreferences?: InputMaybe<Array<ContactPreference>>;
  country?: InputMaybe<CountryCode>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdFrom?: InputMaybe<EmailContactCreatedFromEnum>;
  email: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  hasTakenBreedTest?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  language: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  marketingEmailConsent?: InputMaybe<Scalars['Boolean']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type EmailContactUncheckedUpdateInput = {
  accountId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  breedInterestSubscription?: InputMaybe<DogBreedInterestSubscriptionUncheckedUpdateOneWithoutEmailContactNestedInput>;
  contactPreferences?: InputMaybe<Array<ContactPreference>>;
  country?: InputMaybe<EnumCountryCodeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdFrom?: InputMaybe<EnumEmailContactCreatedFromEnumFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  firstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hasTakenBreedTest?: InputMaybe<BoolFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  marketingEmailConsent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type EmailContactUncheckedUpdateManyInput = {
  accountId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  contactPreferences?: InputMaybe<Array<ContactPreference>>;
  country?: InputMaybe<EnumCountryCodeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdFrom?: InputMaybe<EnumEmailContactCreatedFromEnumFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  firstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hasTakenBreedTest?: InputMaybe<BoolFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  marketingEmailConsent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type EmailContactUncheckedUpdateOneWithoutAccountNestedInput = {
  connect?: InputMaybe<EmailContactWhereUniqueInput>;
  connectOrCreate?: InputMaybe<EmailContactCreateOrConnectWithoutAccountInput>;
  create?: InputMaybe<EmailContactCreateWithoutAccountInput>;
  delete?: InputMaybe<EmailContactWhereInput>;
  disconnect?: InputMaybe<EmailContactWhereInput>;
  update?: InputMaybe<EmailContactUpdateToOneWithWhereWithoutAccountInput>;
  upsert?: InputMaybe<EmailContactUpsertWithoutAccountInput>;
};

export type EmailContactUncheckedUpdateWithoutAccountInput = {
  breedInterestSubscription?: InputMaybe<DogBreedInterestSubscriptionUncheckedUpdateOneWithoutEmailContactNestedInput>;
  contactPreferences?: InputMaybe<Array<ContactPreference>>;
  country?: InputMaybe<EnumCountryCodeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdFrom?: InputMaybe<EnumEmailContactCreatedFromEnumFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  firstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hasTakenBreedTest?: InputMaybe<BoolFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  marketingEmailConsent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type EmailContactUncheckedUpdateWithoutBreedInterestSubscriptionInput = {
  accountId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  contactPreferences?: InputMaybe<Array<ContactPreference>>;
  country?: InputMaybe<EnumCountryCodeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdFrom?: InputMaybe<EnumEmailContactCreatedFromEnumFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  firstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hasTakenBreedTest?: InputMaybe<BoolFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  marketingEmailConsent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type EmailContactUpdateInput = {
  account?: InputMaybe<AccountUpdateOneWithoutEmailContactNestedInput>;
  breedInterestSubscription?: InputMaybe<DogBreedInterestSubscriptionUpdateOneWithoutEmailContactNestedInput>;
  contactPreferences?: InputMaybe<Array<ContactPreference>>;
  country?: InputMaybe<EnumCountryCodeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdFrom?: InputMaybe<EnumEmailContactCreatedFromEnumFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  firstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hasTakenBreedTest?: InputMaybe<BoolFieldUpdateOperationsInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  marketingEmailConsent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type EmailContactUpdateManyMutationInput = {
  contactPreferences?: InputMaybe<Array<ContactPreference>>;
  country?: InputMaybe<EnumCountryCodeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdFrom?: InputMaybe<EnumEmailContactCreatedFromEnumFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  firstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hasTakenBreedTest?: InputMaybe<BoolFieldUpdateOperationsInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  marketingEmailConsent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type EmailContactUpdateOneRequiredWithoutBreedInterestSubscriptionNestedInput = {
  connect?: InputMaybe<EmailContactWhereUniqueInput>;
  connectOrCreate?: InputMaybe<EmailContactCreateOrConnectWithoutBreedInterestSubscriptionInput>;
  create?: InputMaybe<EmailContactCreateWithoutBreedInterestSubscriptionInput>;
  update?: InputMaybe<EmailContactUpdateToOneWithWhereWithoutBreedInterestSubscriptionInput>;
  upsert?: InputMaybe<EmailContactUpsertWithoutBreedInterestSubscriptionInput>;
};

export type EmailContactUpdateOneWithoutAccountNestedInput = {
  connect?: InputMaybe<EmailContactWhereUniqueInput>;
  connectOrCreate?: InputMaybe<EmailContactCreateOrConnectWithoutAccountInput>;
  create?: InputMaybe<EmailContactCreateWithoutAccountInput>;
  delete?: InputMaybe<EmailContactWhereInput>;
  disconnect?: InputMaybe<EmailContactWhereInput>;
  update?: InputMaybe<EmailContactUpdateToOneWithWhereWithoutAccountInput>;
  upsert?: InputMaybe<EmailContactUpsertWithoutAccountInput>;
};

export type EmailContactUpdateToOneWithWhereWithoutAccountInput = {
  data: EmailContactUpdateWithoutAccountInput;
  where?: InputMaybe<EmailContactWhereInput>;
};

export type EmailContactUpdateToOneWithWhereWithoutBreedInterestSubscriptionInput = {
  data: EmailContactUpdateWithoutBreedInterestSubscriptionInput;
  where?: InputMaybe<EmailContactWhereInput>;
};

export type EmailContactUpdateWithoutAccountInput = {
  breedInterestSubscription?: InputMaybe<DogBreedInterestSubscriptionUpdateOneWithoutEmailContactNestedInput>;
  contactPreferences?: InputMaybe<Array<ContactPreference>>;
  country?: InputMaybe<EnumCountryCodeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdFrom?: InputMaybe<EnumEmailContactCreatedFromEnumFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  firstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hasTakenBreedTest?: InputMaybe<BoolFieldUpdateOperationsInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  marketingEmailConsent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type EmailContactUpdateWithoutBreedInterestSubscriptionInput = {
  account?: InputMaybe<AccountUpdateOneWithoutEmailContactNestedInput>;
  contactPreferences?: InputMaybe<Array<ContactPreference>>;
  country?: InputMaybe<EnumCountryCodeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdFrom?: InputMaybe<EnumEmailContactCreatedFromEnumFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  firstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hasTakenBreedTest?: InputMaybe<BoolFieldUpdateOperationsInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  marketingEmailConsent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type EmailContactUpdatecontactPreferencesInput = {
  push?: InputMaybe<Array<ContactPreference>>;
  set?: InputMaybe<Array<ContactPreference>>;
};

export type EmailContactUpsertWithoutAccountInput = {
  create: EmailContactCreateWithoutAccountInput;
  update: EmailContactUpdateWithoutAccountInput;
  where?: InputMaybe<EmailContactWhereInput>;
};

export type EmailContactUpsertWithoutBreedInterestSubscriptionInput = {
  create: EmailContactCreateWithoutBreedInterestSubscriptionInput;
  update: EmailContactUpdateWithoutBreedInterestSubscriptionInput;
  where?: InputMaybe<EmailContactWhereInput>;
};

export type EmailContactWhereInput = {
  AND?: InputMaybe<Array<EmailContactWhereInput>>;
  NOT?: InputMaybe<Array<EmailContactWhereInput>>;
  OR?: InputMaybe<Array<EmailContactWhereInput>>;
  account?: InputMaybe<AccountNullableRelationFilter>;
  accountId?: InputMaybe<IntNullableFilter>;
  breedInterestSubscription?: InputMaybe<DogBreedInterestSubscriptionNullableRelationFilter>;
  contactPreferences?: InputMaybe<EnumContactPreferenceNullableListFilter>;
  country?: InputMaybe<EnumCountryCodeFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdFrom?: InputMaybe<EnumEmailContactCreatedFromEnumFilter>;
  email?: InputMaybe<StringFilter>;
  firstName?: InputMaybe<StringNullableFilter>;
  hasTakenBreedTest?: InputMaybe<BoolFilter>;
  id?: InputMaybe<IntFilter>;
  language?: InputMaybe<StringFilter>;
  lastName?: InputMaybe<StringNullableFilter>;
  marketingEmailConsent?: InputMaybe<BoolFilter>;
  phone?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type EmailContactWhereUniqueInput = {
  AND?: InputMaybe<Array<EmailContactWhereInput>>;
  NOT?: InputMaybe<Array<EmailContactWhereInput>>;
  OR?: InputMaybe<Array<EmailContactWhereInput>>;
  account?: InputMaybe<AccountNullableRelationFilter>;
  accountId?: InputMaybe<Scalars['Int']['input']>;
  breedInterestSubscription?: InputMaybe<DogBreedInterestSubscriptionNullableRelationFilter>;
  contactPreferences?: InputMaybe<EnumContactPreferenceNullableListFilter>;
  country?: InputMaybe<EnumCountryCodeFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdFrom?: InputMaybe<EnumEmailContactCreatedFromEnumFilter>;
  email?: InputMaybe<StringFilter>;
  firstName?: InputMaybe<StringNullableFilter>;
  hasTakenBreedTest?: InputMaybe<BoolFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  language?: InputMaybe<StringFilter>;
  lastName?: InputMaybe<StringNullableFilter>;
  marketingEmailConsent?: InputMaybe<BoolFilter>;
  phone?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type EmailHistoryAvgAggregateOutputType = {
  __typename?: 'EmailHistoryAvgAggregateOutputType';
  accountId?: Maybe<Scalars['Float']['output']>;
  bookingId?: Maybe<Scalars['Float']['output']>;
  breederId?: Maybe<Scalars['Float']['output']>;
  emailTemplateId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  proId?: Maybe<Scalars['Float']['output']>;
};

export type EmailHistoryAvgOrderByAggregateInput = {
  accountId?: InputMaybe<SortOrder>;
  bookingId?: InputMaybe<SortOrder>;
  breederId?: InputMaybe<SortOrder>;
  emailTemplateId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  proId?: InputMaybe<SortOrder>;
};

export type EmailHistoryCountAggregateOutputType = {
  __typename?: 'EmailHistoryCountAggregateOutputType';
  _all: Scalars['Int']['output'];
  accountId: Scalars['Int']['output'];
  body: Scalars['Int']['output'];
  bookingId: Scalars['Int']['output'];
  breederId: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  emailTemplateId: Scalars['Int']['output'];
  from: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  proId: Scalars['Int']['output'];
  recipients: Scalars['Int']['output'];
  sentBy: Scalars['Int']['output'];
  subject: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type EmailHistoryCountOrderByAggregateInput = {
  accountId?: InputMaybe<SortOrder>;
  body?: InputMaybe<SortOrder>;
  bookingId?: InputMaybe<SortOrder>;
  breederId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  emailTemplateId?: InputMaybe<SortOrder>;
  from?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  proId?: InputMaybe<SortOrder>;
  recipients?: InputMaybe<SortOrder>;
  sentBy?: InputMaybe<SortOrder>;
  subject?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type EmailHistoryCreateInput = {
  account?: InputMaybe<AccountCreateNestedOneWithoutEmailHistoryInput>;
  body?: InputMaybe<Scalars['String']['input']>;
  booking?: InputMaybe<BookingCreateNestedOneWithoutEmailHistoryInput>;
  breeder?: InputMaybe<DogBreederCreateNestedOneWithoutEmailHistoryInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  emailTemplate?: InputMaybe<EmailTemplateCreateNestedOneWithoutEmailHistoryInput>;
  from: Scalars['String']['input'];
  professional?: InputMaybe<ProfessionalCreateNestedOneWithoutEmailHistoryInput>;
  recipients?: InputMaybe<Array<Scalars['String']['input']>>;
  sentBy?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type EmailHistoryCreateManyAccountInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  bookingId?: InputMaybe<Scalars['Int']['input']>;
  breederId?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  emailTemplateId?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  proId?: InputMaybe<Scalars['Int']['input']>;
  recipients?: InputMaybe<Array<Scalars['String']['input']>>;
  sentBy?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type EmailHistoryCreateManyAccountInputEnvelope = {
  data: Array<EmailHistoryCreateManyAccountInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EmailHistoryCreateManyBookingInput = {
  accountId?: InputMaybe<Scalars['Int']['input']>;
  body?: InputMaybe<Scalars['String']['input']>;
  breederId?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  emailTemplateId?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  proId?: InputMaybe<Scalars['Int']['input']>;
  recipients?: InputMaybe<Array<Scalars['String']['input']>>;
  sentBy?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type EmailHistoryCreateManyBookingInputEnvelope = {
  data: Array<EmailHistoryCreateManyBookingInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EmailHistoryCreateManyBreederInput = {
  accountId?: InputMaybe<Scalars['Int']['input']>;
  body?: InputMaybe<Scalars['String']['input']>;
  bookingId?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  emailTemplateId?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  proId?: InputMaybe<Scalars['Int']['input']>;
  recipients?: InputMaybe<Array<Scalars['String']['input']>>;
  sentBy?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type EmailHistoryCreateManyBreederInputEnvelope = {
  data: Array<EmailHistoryCreateManyBreederInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EmailHistoryCreateManyEmailTemplateInput = {
  accountId?: InputMaybe<Scalars['Int']['input']>;
  body?: InputMaybe<Scalars['String']['input']>;
  bookingId?: InputMaybe<Scalars['Int']['input']>;
  breederId?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  from: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  proId?: InputMaybe<Scalars['Int']['input']>;
  recipients?: InputMaybe<Array<Scalars['String']['input']>>;
  sentBy?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type EmailHistoryCreateManyEmailTemplateInputEnvelope = {
  data: Array<EmailHistoryCreateManyEmailTemplateInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EmailHistoryCreateManyInput = {
  accountId?: InputMaybe<Scalars['Int']['input']>;
  body?: InputMaybe<Scalars['String']['input']>;
  bookingId?: InputMaybe<Scalars['Int']['input']>;
  breederId?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  emailTemplateId?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  proId?: InputMaybe<Scalars['Int']['input']>;
  recipients?: InputMaybe<Array<Scalars['String']['input']>>;
  sentBy?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type EmailHistoryCreateManyProfessionalInput = {
  accountId?: InputMaybe<Scalars['Int']['input']>;
  body?: InputMaybe<Scalars['String']['input']>;
  bookingId?: InputMaybe<Scalars['Int']['input']>;
  breederId?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  emailTemplateId?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  recipients?: InputMaybe<Array<Scalars['String']['input']>>;
  sentBy?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type EmailHistoryCreateManyProfessionalInputEnvelope = {
  data: Array<EmailHistoryCreateManyProfessionalInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EmailHistoryCreateNestedManyWithoutAccountInput = {
  connect?: InputMaybe<Array<EmailHistoryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<EmailHistoryCreateOrConnectWithoutAccountInput>>;
  create?: InputMaybe<Array<EmailHistoryCreateWithoutAccountInput>>;
  createMany?: InputMaybe<EmailHistoryCreateManyAccountInputEnvelope>;
};

export type EmailHistoryCreateNestedManyWithoutBookingInput = {
  connect?: InputMaybe<Array<EmailHistoryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<EmailHistoryCreateOrConnectWithoutBookingInput>>;
  create?: InputMaybe<Array<EmailHistoryCreateWithoutBookingInput>>;
  createMany?: InputMaybe<EmailHistoryCreateManyBookingInputEnvelope>;
};

export type EmailHistoryCreateNestedManyWithoutBreederInput = {
  connect?: InputMaybe<Array<EmailHistoryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<EmailHistoryCreateOrConnectWithoutBreederInput>>;
  create?: InputMaybe<Array<EmailHistoryCreateWithoutBreederInput>>;
  createMany?: InputMaybe<EmailHistoryCreateManyBreederInputEnvelope>;
};

export type EmailHistoryCreateNestedManyWithoutEmailTemplateInput = {
  connect?: InputMaybe<Array<EmailHistoryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<EmailHistoryCreateOrConnectWithoutEmailTemplateInput>>;
  create?: InputMaybe<Array<EmailHistoryCreateWithoutEmailTemplateInput>>;
  createMany?: InputMaybe<EmailHistoryCreateManyEmailTemplateInputEnvelope>;
};

export type EmailHistoryCreateNestedManyWithoutProfessionalInput = {
  connect?: InputMaybe<Array<EmailHistoryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<EmailHistoryCreateOrConnectWithoutProfessionalInput>>;
  create?: InputMaybe<Array<EmailHistoryCreateWithoutProfessionalInput>>;
  createMany?: InputMaybe<EmailHistoryCreateManyProfessionalInputEnvelope>;
};

export type EmailHistoryCreateOrConnectWithoutAccountInput = {
  create: EmailHistoryCreateWithoutAccountInput;
  where: EmailHistoryWhereUniqueInput;
};

export type EmailHistoryCreateOrConnectWithoutBookingInput = {
  create: EmailHistoryCreateWithoutBookingInput;
  where: EmailHistoryWhereUniqueInput;
};

export type EmailHistoryCreateOrConnectWithoutBreederInput = {
  create: EmailHistoryCreateWithoutBreederInput;
  where: EmailHistoryWhereUniqueInput;
};

export type EmailHistoryCreateOrConnectWithoutEmailTemplateInput = {
  create: EmailHistoryCreateWithoutEmailTemplateInput;
  where: EmailHistoryWhereUniqueInput;
};

export type EmailHistoryCreateOrConnectWithoutProfessionalInput = {
  create: EmailHistoryCreateWithoutProfessionalInput;
  where: EmailHistoryWhereUniqueInput;
};

export type EmailHistoryCreateWithoutAccountInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  booking?: InputMaybe<BookingCreateNestedOneWithoutEmailHistoryInput>;
  breeder?: InputMaybe<DogBreederCreateNestedOneWithoutEmailHistoryInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  emailTemplate?: InputMaybe<EmailTemplateCreateNestedOneWithoutEmailHistoryInput>;
  from: Scalars['String']['input'];
  professional?: InputMaybe<ProfessionalCreateNestedOneWithoutEmailHistoryInput>;
  recipients?: InputMaybe<Array<Scalars['String']['input']>>;
  sentBy?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type EmailHistoryCreateWithoutBookingInput = {
  account?: InputMaybe<AccountCreateNestedOneWithoutEmailHistoryInput>;
  body?: InputMaybe<Scalars['String']['input']>;
  breeder?: InputMaybe<DogBreederCreateNestedOneWithoutEmailHistoryInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  emailTemplate?: InputMaybe<EmailTemplateCreateNestedOneWithoutEmailHistoryInput>;
  from: Scalars['String']['input'];
  professional?: InputMaybe<ProfessionalCreateNestedOneWithoutEmailHistoryInput>;
  recipients?: InputMaybe<Array<Scalars['String']['input']>>;
  sentBy?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type EmailHistoryCreateWithoutBreederInput = {
  account?: InputMaybe<AccountCreateNestedOneWithoutEmailHistoryInput>;
  body?: InputMaybe<Scalars['String']['input']>;
  booking?: InputMaybe<BookingCreateNestedOneWithoutEmailHistoryInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  emailTemplate?: InputMaybe<EmailTemplateCreateNestedOneWithoutEmailHistoryInput>;
  from: Scalars['String']['input'];
  professional?: InputMaybe<ProfessionalCreateNestedOneWithoutEmailHistoryInput>;
  recipients?: InputMaybe<Array<Scalars['String']['input']>>;
  sentBy?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type EmailHistoryCreateWithoutEmailTemplateInput = {
  account?: InputMaybe<AccountCreateNestedOneWithoutEmailHistoryInput>;
  body?: InputMaybe<Scalars['String']['input']>;
  booking?: InputMaybe<BookingCreateNestedOneWithoutEmailHistoryInput>;
  breeder?: InputMaybe<DogBreederCreateNestedOneWithoutEmailHistoryInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  from: Scalars['String']['input'];
  professional?: InputMaybe<ProfessionalCreateNestedOneWithoutEmailHistoryInput>;
  recipients?: InputMaybe<Array<Scalars['String']['input']>>;
  sentBy?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type EmailHistoryCreateWithoutProfessionalInput = {
  account?: InputMaybe<AccountCreateNestedOneWithoutEmailHistoryInput>;
  body?: InputMaybe<Scalars['String']['input']>;
  booking?: InputMaybe<BookingCreateNestedOneWithoutEmailHistoryInput>;
  breeder?: InputMaybe<DogBreederCreateNestedOneWithoutEmailHistoryInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  emailTemplate?: InputMaybe<EmailTemplateCreateNestedOneWithoutEmailHistoryInput>;
  from: Scalars['String']['input'];
  recipients?: InputMaybe<Array<Scalars['String']['input']>>;
  sentBy?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type EmailHistoryCreaterecipientsInput = {
  set: Array<Scalars['String']['input']>;
};

export type EmailHistoryListRelationFilter = {
  every?: InputMaybe<EmailHistoryWhereInput>;
  none?: InputMaybe<EmailHistoryWhereInput>;
  some?: InputMaybe<EmailHistoryWhereInput>;
};

export type EmailHistoryMaxAggregateOutputType = {
  __typename?: 'EmailHistoryMaxAggregateOutputType';
  accountId?: Maybe<Scalars['Int']['output']>;
  body?: Maybe<Scalars['String']['output']>;
  bookingId?: Maybe<Scalars['Int']['output']>;
  breederId?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  emailTemplateId?: Maybe<Scalars['Int']['output']>;
  from?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  proId?: Maybe<Scalars['Int']['output']>;
  sentBy?: Maybe<Scalars['String']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type EmailHistoryMaxOrderByAggregateInput = {
  accountId?: InputMaybe<SortOrder>;
  body?: InputMaybe<SortOrder>;
  bookingId?: InputMaybe<SortOrder>;
  breederId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  emailTemplateId?: InputMaybe<SortOrder>;
  from?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  proId?: InputMaybe<SortOrder>;
  sentBy?: InputMaybe<SortOrder>;
  subject?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type EmailHistoryMinAggregateOutputType = {
  __typename?: 'EmailHistoryMinAggregateOutputType';
  accountId?: Maybe<Scalars['Int']['output']>;
  body?: Maybe<Scalars['String']['output']>;
  bookingId?: Maybe<Scalars['Int']['output']>;
  breederId?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  emailTemplateId?: Maybe<Scalars['Int']['output']>;
  from?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  proId?: Maybe<Scalars['Int']['output']>;
  sentBy?: Maybe<Scalars['String']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type EmailHistoryMinOrderByAggregateInput = {
  accountId?: InputMaybe<SortOrder>;
  body?: InputMaybe<SortOrder>;
  bookingId?: InputMaybe<SortOrder>;
  breederId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  emailTemplateId?: InputMaybe<SortOrder>;
  from?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  proId?: InputMaybe<SortOrder>;
  sentBy?: InputMaybe<SortOrder>;
  subject?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type EmailHistoryOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export enum EmailHistoryOrderByRelevanceFieldEnum {
  body = 'body',
  from = 'from',
  recipients = 'recipients',
  sentBy = 'sentBy',
  subject = 'subject'
}

export type EmailHistoryOrderByRelevanceInput = {
  fields: Array<EmailHistoryOrderByRelevanceFieldEnum>;
  search: Scalars['String']['input'];
  sort: SortOrder;
};

export type EmailHistoryOrderByWithAggregationInput = {
  _avg?: InputMaybe<EmailHistoryAvgOrderByAggregateInput>;
  _count?: InputMaybe<EmailHistoryCountOrderByAggregateInput>;
  _max?: InputMaybe<EmailHistoryMaxOrderByAggregateInput>;
  _min?: InputMaybe<EmailHistoryMinOrderByAggregateInput>;
  _sum?: InputMaybe<EmailHistorySumOrderByAggregateInput>;
  accountId?: InputMaybe<SortOrderInput>;
  body?: InputMaybe<SortOrderInput>;
  bookingId?: InputMaybe<SortOrderInput>;
  breederId?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  emailTemplateId?: InputMaybe<SortOrderInput>;
  from?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  proId?: InputMaybe<SortOrderInput>;
  recipients?: InputMaybe<SortOrder>;
  sentBy?: InputMaybe<SortOrderInput>;
  subject?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type EmailHistoryOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: InputMaybe<EmailHistoryOrderByRelevanceInput>;
  account?: InputMaybe<AccountOrderByWithRelationAndSearchRelevanceInput>;
  accountId?: InputMaybe<SortOrderInput>;
  body?: InputMaybe<SortOrderInput>;
  booking?: InputMaybe<BookingOrderByWithRelationAndSearchRelevanceInput>;
  bookingId?: InputMaybe<SortOrderInput>;
  breeder?: InputMaybe<DogBreederOrderByWithRelationAndSearchRelevanceInput>;
  breederId?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  emailTemplate?: InputMaybe<EmailTemplateOrderByWithRelationAndSearchRelevanceInput>;
  emailTemplateId?: InputMaybe<SortOrderInput>;
  from?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  proId?: InputMaybe<SortOrderInput>;
  professional?: InputMaybe<ProfessionalOrderByWithRelationAndSearchRelevanceInput>;
  recipients?: InputMaybe<SortOrder>;
  sentBy?: InputMaybe<SortOrderInput>;
  subject?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum EmailHistoryScalarFieldEnum {
  accountId = 'accountId',
  body = 'body',
  bookingId = 'bookingId',
  breederId = 'breederId',
  createdAt = 'createdAt',
  emailTemplateId = 'emailTemplateId',
  from = 'from',
  id = 'id',
  proId = 'proId',
  recipients = 'recipients',
  sentBy = 'sentBy',
  subject = 'subject',
  updatedAt = 'updatedAt'
}

export type EmailHistoryScalarWhereInput = {
  AND?: InputMaybe<Array<EmailHistoryScalarWhereInput>>;
  NOT?: InputMaybe<Array<EmailHistoryScalarWhereInput>>;
  OR?: InputMaybe<Array<EmailHistoryScalarWhereInput>>;
  accountId?: InputMaybe<IntNullableFilter>;
  body?: InputMaybe<StringNullableFilter>;
  bookingId?: InputMaybe<IntNullableFilter>;
  breederId?: InputMaybe<IntNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  emailTemplateId?: InputMaybe<IntNullableFilter>;
  from?: InputMaybe<StringFilter>;
  id?: InputMaybe<IntFilter>;
  proId?: InputMaybe<IntNullableFilter>;
  recipients?: InputMaybe<StringNullableListFilter>;
  sentBy?: InputMaybe<StringNullableFilter>;
  subject?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type EmailHistoryScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<EmailHistoryScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<EmailHistoryScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<EmailHistoryScalarWhereWithAggregatesInput>>;
  accountId?: InputMaybe<IntNullableWithAggregatesFilter>;
  body?: InputMaybe<StringNullableWithAggregatesFilter>;
  bookingId?: InputMaybe<IntNullableWithAggregatesFilter>;
  breederId?: InputMaybe<IntNullableWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  emailTemplateId?: InputMaybe<IntNullableWithAggregatesFilter>;
  from?: InputMaybe<StringWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  proId?: InputMaybe<IntNullableWithAggregatesFilter>;
  recipients?: InputMaybe<StringNullableListFilter>;
  sentBy?: InputMaybe<StringNullableWithAggregatesFilter>;
  subject?: InputMaybe<StringNullableWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type EmailHistorySumAggregateOutputType = {
  __typename?: 'EmailHistorySumAggregateOutputType';
  accountId?: Maybe<Scalars['Int']['output']>;
  bookingId?: Maybe<Scalars['Int']['output']>;
  breederId?: Maybe<Scalars['Int']['output']>;
  emailTemplateId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  proId?: Maybe<Scalars['Int']['output']>;
};

export type EmailHistorySumOrderByAggregateInput = {
  accountId?: InputMaybe<SortOrder>;
  bookingId?: InputMaybe<SortOrder>;
  breederId?: InputMaybe<SortOrder>;
  emailTemplateId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  proId?: InputMaybe<SortOrder>;
};

export type EmailHistoryUncheckedCreateInput = {
  accountId?: InputMaybe<Scalars['Int']['input']>;
  body?: InputMaybe<Scalars['String']['input']>;
  bookingId?: InputMaybe<Scalars['Int']['input']>;
  breederId?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  emailTemplateId?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  proId?: InputMaybe<Scalars['Int']['input']>;
  recipients?: InputMaybe<Array<Scalars['String']['input']>>;
  sentBy?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type EmailHistoryUncheckedCreateNestedManyWithoutAccountInput = {
  connect?: InputMaybe<Array<EmailHistoryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<EmailHistoryCreateOrConnectWithoutAccountInput>>;
  create?: InputMaybe<Array<EmailHistoryCreateWithoutAccountInput>>;
  createMany?: InputMaybe<EmailHistoryCreateManyAccountInputEnvelope>;
};

export type EmailHistoryUncheckedCreateNestedManyWithoutBookingInput = {
  connect?: InputMaybe<Array<EmailHistoryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<EmailHistoryCreateOrConnectWithoutBookingInput>>;
  create?: InputMaybe<Array<EmailHistoryCreateWithoutBookingInput>>;
  createMany?: InputMaybe<EmailHistoryCreateManyBookingInputEnvelope>;
};

export type EmailHistoryUncheckedCreateNestedManyWithoutBreederInput = {
  connect?: InputMaybe<Array<EmailHistoryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<EmailHistoryCreateOrConnectWithoutBreederInput>>;
  create?: InputMaybe<Array<EmailHistoryCreateWithoutBreederInput>>;
  createMany?: InputMaybe<EmailHistoryCreateManyBreederInputEnvelope>;
};

export type EmailHistoryUncheckedCreateNestedManyWithoutEmailTemplateInput = {
  connect?: InputMaybe<Array<EmailHistoryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<EmailHistoryCreateOrConnectWithoutEmailTemplateInput>>;
  create?: InputMaybe<Array<EmailHistoryCreateWithoutEmailTemplateInput>>;
  createMany?: InputMaybe<EmailHistoryCreateManyEmailTemplateInputEnvelope>;
};

export type EmailHistoryUncheckedCreateNestedManyWithoutProfessionalInput = {
  connect?: InputMaybe<Array<EmailHistoryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<EmailHistoryCreateOrConnectWithoutProfessionalInput>>;
  create?: InputMaybe<Array<EmailHistoryCreateWithoutProfessionalInput>>;
  createMany?: InputMaybe<EmailHistoryCreateManyProfessionalInputEnvelope>;
};

export type EmailHistoryUncheckedCreateWithoutAccountInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  bookingId?: InputMaybe<Scalars['Int']['input']>;
  breederId?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  emailTemplateId?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  proId?: InputMaybe<Scalars['Int']['input']>;
  recipients?: InputMaybe<Array<Scalars['String']['input']>>;
  sentBy?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type EmailHistoryUncheckedCreateWithoutBookingInput = {
  accountId?: InputMaybe<Scalars['Int']['input']>;
  body?: InputMaybe<Scalars['String']['input']>;
  breederId?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  emailTemplateId?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  proId?: InputMaybe<Scalars['Int']['input']>;
  recipients?: InputMaybe<Array<Scalars['String']['input']>>;
  sentBy?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type EmailHistoryUncheckedCreateWithoutBreederInput = {
  accountId?: InputMaybe<Scalars['Int']['input']>;
  body?: InputMaybe<Scalars['String']['input']>;
  bookingId?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  emailTemplateId?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  proId?: InputMaybe<Scalars['Int']['input']>;
  recipients?: InputMaybe<Array<Scalars['String']['input']>>;
  sentBy?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type EmailHistoryUncheckedCreateWithoutEmailTemplateInput = {
  accountId?: InputMaybe<Scalars['Int']['input']>;
  body?: InputMaybe<Scalars['String']['input']>;
  bookingId?: InputMaybe<Scalars['Int']['input']>;
  breederId?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  from: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  proId?: InputMaybe<Scalars['Int']['input']>;
  recipients?: InputMaybe<Array<Scalars['String']['input']>>;
  sentBy?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type EmailHistoryUncheckedCreateWithoutProfessionalInput = {
  accountId?: InputMaybe<Scalars['Int']['input']>;
  body?: InputMaybe<Scalars['String']['input']>;
  bookingId?: InputMaybe<Scalars['Int']['input']>;
  breederId?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  emailTemplateId?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  recipients?: InputMaybe<Array<Scalars['String']['input']>>;
  sentBy?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type EmailHistoryUncheckedUpdateInput = {
  accountId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  body?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  bookingId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  breederId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  emailTemplateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  from?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  proId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  recipients?: InputMaybe<Array<Scalars['String']['input']>>;
  sentBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  subject?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type EmailHistoryUncheckedUpdateManyInput = {
  accountId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  body?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  bookingId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  breederId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  emailTemplateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  from?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  proId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  recipients?: InputMaybe<Array<Scalars['String']['input']>>;
  sentBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  subject?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type EmailHistoryUncheckedUpdateManyWithoutAccountInput = {
  body?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  bookingId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  breederId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  emailTemplateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  from?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  proId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  recipients?: InputMaybe<Array<Scalars['String']['input']>>;
  sentBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  subject?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type EmailHistoryUncheckedUpdateManyWithoutAccountNestedInput = {
  connect?: InputMaybe<Array<EmailHistoryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<EmailHistoryCreateOrConnectWithoutAccountInput>>;
  create?: InputMaybe<Array<EmailHistoryCreateWithoutAccountInput>>;
  createMany?: InputMaybe<EmailHistoryCreateManyAccountInputEnvelope>;
  delete?: InputMaybe<Array<EmailHistoryWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<EmailHistoryScalarWhereInput>>;
  disconnect?: InputMaybe<Array<EmailHistoryWhereUniqueInput>>;
  set?: InputMaybe<Array<EmailHistoryWhereUniqueInput>>;
  update?: InputMaybe<Array<EmailHistoryUpdateWithWhereUniqueWithoutAccountInput>>;
  updateMany?: InputMaybe<Array<EmailHistoryUpdateManyWithWhereWithoutAccountInput>>;
  upsert?: InputMaybe<Array<EmailHistoryUpsertWithWhereUniqueWithoutAccountInput>>;
};

export type EmailHistoryUncheckedUpdateManyWithoutBookingInput = {
  accountId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  body?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  breederId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  emailTemplateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  from?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  proId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  recipients?: InputMaybe<Array<Scalars['String']['input']>>;
  sentBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  subject?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type EmailHistoryUncheckedUpdateManyWithoutBookingNestedInput = {
  connect?: InputMaybe<Array<EmailHistoryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<EmailHistoryCreateOrConnectWithoutBookingInput>>;
  create?: InputMaybe<Array<EmailHistoryCreateWithoutBookingInput>>;
  createMany?: InputMaybe<EmailHistoryCreateManyBookingInputEnvelope>;
  delete?: InputMaybe<Array<EmailHistoryWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<EmailHistoryScalarWhereInput>>;
  disconnect?: InputMaybe<Array<EmailHistoryWhereUniqueInput>>;
  set?: InputMaybe<Array<EmailHistoryWhereUniqueInput>>;
  update?: InputMaybe<Array<EmailHistoryUpdateWithWhereUniqueWithoutBookingInput>>;
  updateMany?: InputMaybe<Array<EmailHistoryUpdateManyWithWhereWithoutBookingInput>>;
  upsert?: InputMaybe<Array<EmailHistoryUpsertWithWhereUniqueWithoutBookingInput>>;
};

export type EmailHistoryUncheckedUpdateManyWithoutBreederInput = {
  accountId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  body?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  bookingId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  emailTemplateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  from?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  proId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  recipients?: InputMaybe<Array<Scalars['String']['input']>>;
  sentBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  subject?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type EmailHistoryUncheckedUpdateManyWithoutBreederNestedInput = {
  connect?: InputMaybe<Array<EmailHistoryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<EmailHistoryCreateOrConnectWithoutBreederInput>>;
  create?: InputMaybe<Array<EmailHistoryCreateWithoutBreederInput>>;
  createMany?: InputMaybe<EmailHistoryCreateManyBreederInputEnvelope>;
  delete?: InputMaybe<Array<EmailHistoryWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<EmailHistoryScalarWhereInput>>;
  disconnect?: InputMaybe<Array<EmailHistoryWhereUniqueInput>>;
  set?: InputMaybe<Array<EmailHistoryWhereUniqueInput>>;
  update?: InputMaybe<Array<EmailHistoryUpdateWithWhereUniqueWithoutBreederInput>>;
  updateMany?: InputMaybe<Array<EmailHistoryUpdateManyWithWhereWithoutBreederInput>>;
  upsert?: InputMaybe<Array<EmailHistoryUpsertWithWhereUniqueWithoutBreederInput>>;
};

export type EmailHistoryUncheckedUpdateManyWithoutEmailTemplateInput = {
  accountId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  body?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  bookingId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  breederId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  from?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  proId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  recipients?: InputMaybe<Array<Scalars['String']['input']>>;
  sentBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  subject?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type EmailHistoryUncheckedUpdateManyWithoutEmailTemplateNestedInput = {
  connect?: InputMaybe<Array<EmailHistoryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<EmailHistoryCreateOrConnectWithoutEmailTemplateInput>>;
  create?: InputMaybe<Array<EmailHistoryCreateWithoutEmailTemplateInput>>;
  createMany?: InputMaybe<EmailHistoryCreateManyEmailTemplateInputEnvelope>;
  delete?: InputMaybe<Array<EmailHistoryWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<EmailHistoryScalarWhereInput>>;
  disconnect?: InputMaybe<Array<EmailHistoryWhereUniqueInput>>;
  set?: InputMaybe<Array<EmailHistoryWhereUniqueInput>>;
  update?: InputMaybe<Array<EmailHistoryUpdateWithWhereUniqueWithoutEmailTemplateInput>>;
  updateMany?: InputMaybe<Array<EmailHistoryUpdateManyWithWhereWithoutEmailTemplateInput>>;
  upsert?: InputMaybe<Array<EmailHistoryUpsertWithWhereUniqueWithoutEmailTemplateInput>>;
};

export type EmailHistoryUncheckedUpdateManyWithoutProfessionalInput = {
  accountId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  body?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  bookingId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  breederId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  emailTemplateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  from?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  recipients?: InputMaybe<Array<Scalars['String']['input']>>;
  sentBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  subject?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type EmailHistoryUncheckedUpdateManyWithoutProfessionalNestedInput = {
  connect?: InputMaybe<Array<EmailHistoryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<EmailHistoryCreateOrConnectWithoutProfessionalInput>>;
  create?: InputMaybe<Array<EmailHistoryCreateWithoutProfessionalInput>>;
  createMany?: InputMaybe<EmailHistoryCreateManyProfessionalInputEnvelope>;
  delete?: InputMaybe<Array<EmailHistoryWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<EmailHistoryScalarWhereInput>>;
  disconnect?: InputMaybe<Array<EmailHistoryWhereUniqueInput>>;
  set?: InputMaybe<Array<EmailHistoryWhereUniqueInput>>;
  update?: InputMaybe<Array<EmailHistoryUpdateWithWhereUniqueWithoutProfessionalInput>>;
  updateMany?: InputMaybe<Array<EmailHistoryUpdateManyWithWhereWithoutProfessionalInput>>;
  upsert?: InputMaybe<Array<EmailHistoryUpsertWithWhereUniqueWithoutProfessionalInput>>;
};

export type EmailHistoryUncheckedUpdateWithoutAccountInput = {
  body?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  bookingId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  breederId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  emailTemplateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  from?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  proId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  recipients?: InputMaybe<Array<Scalars['String']['input']>>;
  sentBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  subject?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type EmailHistoryUncheckedUpdateWithoutBookingInput = {
  accountId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  body?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  breederId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  emailTemplateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  from?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  proId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  recipients?: InputMaybe<Array<Scalars['String']['input']>>;
  sentBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  subject?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type EmailHistoryUncheckedUpdateWithoutBreederInput = {
  accountId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  body?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  bookingId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  emailTemplateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  from?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  proId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  recipients?: InputMaybe<Array<Scalars['String']['input']>>;
  sentBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  subject?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type EmailHistoryUncheckedUpdateWithoutEmailTemplateInput = {
  accountId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  body?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  bookingId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  breederId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  from?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  proId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  recipients?: InputMaybe<Array<Scalars['String']['input']>>;
  sentBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  subject?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type EmailHistoryUncheckedUpdateWithoutProfessionalInput = {
  accountId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  body?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  bookingId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  breederId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  emailTemplateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  from?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  recipients?: InputMaybe<Array<Scalars['String']['input']>>;
  sentBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  subject?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type EmailHistoryUpdateInput = {
  account?: InputMaybe<AccountUpdateOneWithoutEmailHistoryNestedInput>;
  body?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  booking?: InputMaybe<BookingUpdateOneWithoutEmailHistoryNestedInput>;
  breeder?: InputMaybe<DogBreederUpdateOneWithoutEmailHistoryNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  emailTemplate?: InputMaybe<EmailTemplateUpdateOneWithoutEmailHistoryNestedInput>;
  from?: InputMaybe<StringFieldUpdateOperationsInput>;
  professional?: InputMaybe<ProfessionalUpdateOneWithoutEmailHistoryNestedInput>;
  recipients?: InputMaybe<Array<Scalars['String']['input']>>;
  sentBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  subject?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type EmailHistoryUpdateManyMutationInput = {
  body?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  from?: InputMaybe<StringFieldUpdateOperationsInput>;
  recipients?: InputMaybe<Array<Scalars['String']['input']>>;
  sentBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  subject?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type EmailHistoryUpdateManyWithWhereWithoutAccountInput = {
  data: EmailHistoryUpdateManyMutationInput;
  where: EmailHistoryScalarWhereInput;
};

export type EmailHistoryUpdateManyWithWhereWithoutBookingInput = {
  data: EmailHistoryUpdateManyMutationInput;
  where: EmailHistoryScalarWhereInput;
};

export type EmailHistoryUpdateManyWithWhereWithoutBreederInput = {
  data: EmailHistoryUpdateManyMutationInput;
  where: EmailHistoryScalarWhereInput;
};

export type EmailHistoryUpdateManyWithWhereWithoutEmailTemplateInput = {
  data: EmailHistoryUpdateManyMutationInput;
  where: EmailHistoryScalarWhereInput;
};

export type EmailHistoryUpdateManyWithWhereWithoutProfessionalInput = {
  data: EmailHistoryUpdateManyMutationInput;
  where: EmailHistoryScalarWhereInput;
};

export type EmailHistoryUpdateManyWithoutAccountNestedInput = {
  connect?: InputMaybe<Array<EmailHistoryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<EmailHistoryCreateOrConnectWithoutAccountInput>>;
  create?: InputMaybe<Array<EmailHistoryCreateWithoutAccountInput>>;
  createMany?: InputMaybe<EmailHistoryCreateManyAccountInputEnvelope>;
  delete?: InputMaybe<Array<EmailHistoryWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<EmailHistoryScalarWhereInput>>;
  disconnect?: InputMaybe<Array<EmailHistoryWhereUniqueInput>>;
  set?: InputMaybe<Array<EmailHistoryWhereUniqueInput>>;
  update?: InputMaybe<Array<EmailHistoryUpdateWithWhereUniqueWithoutAccountInput>>;
  updateMany?: InputMaybe<Array<EmailHistoryUpdateManyWithWhereWithoutAccountInput>>;
  upsert?: InputMaybe<Array<EmailHistoryUpsertWithWhereUniqueWithoutAccountInput>>;
};

export type EmailHistoryUpdateManyWithoutBookingNestedInput = {
  connect?: InputMaybe<Array<EmailHistoryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<EmailHistoryCreateOrConnectWithoutBookingInput>>;
  create?: InputMaybe<Array<EmailHistoryCreateWithoutBookingInput>>;
  createMany?: InputMaybe<EmailHistoryCreateManyBookingInputEnvelope>;
  delete?: InputMaybe<Array<EmailHistoryWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<EmailHistoryScalarWhereInput>>;
  disconnect?: InputMaybe<Array<EmailHistoryWhereUniqueInput>>;
  set?: InputMaybe<Array<EmailHistoryWhereUniqueInput>>;
  update?: InputMaybe<Array<EmailHistoryUpdateWithWhereUniqueWithoutBookingInput>>;
  updateMany?: InputMaybe<Array<EmailHistoryUpdateManyWithWhereWithoutBookingInput>>;
  upsert?: InputMaybe<Array<EmailHistoryUpsertWithWhereUniqueWithoutBookingInput>>;
};

export type EmailHistoryUpdateManyWithoutBreederNestedInput = {
  connect?: InputMaybe<Array<EmailHistoryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<EmailHistoryCreateOrConnectWithoutBreederInput>>;
  create?: InputMaybe<Array<EmailHistoryCreateWithoutBreederInput>>;
  createMany?: InputMaybe<EmailHistoryCreateManyBreederInputEnvelope>;
  delete?: InputMaybe<Array<EmailHistoryWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<EmailHistoryScalarWhereInput>>;
  disconnect?: InputMaybe<Array<EmailHistoryWhereUniqueInput>>;
  set?: InputMaybe<Array<EmailHistoryWhereUniqueInput>>;
  update?: InputMaybe<Array<EmailHistoryUpdateWithWhereUniqueWithoutBreederInput>>;
  updateMany?: InputMaybe<Array<EmailHistoryUpdateManyWithWhereWithoutBreederInput>>;
  upsert?: InputMaybe<Array<EmailHistoryUpsertWithWhereUniqueWithoutBreederInput>>;
};

export type EmailHistoryUpdateManyWithoutEmailTemplateNestedInput = {
  connect?: InputMaybe<Array<EmailHistoryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<EmailHistoryCreateOrConnectWithoutEmailTemplateInput>>;
  create?: InputMaybe<Array<EmailHistoryCreateWithoutEmailTemplateInput>>;
  createMany?: InputMaybe<EmailHistoryCreateManyEmailTemplateInputEnvelope>;
  delete?: InputMaybe<Array<EmailHistoryWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<EmailHistoryScalarWhereInput>>;
  disconnect?: InputMaybe<Array<EmailHistoryWhereUniqueInput>>;
  set?: InputMaybe<Array<EmailHistoryWhereUniqueInput>>;
  update?: InputMaybe<Array<EmailHistoryUpdateWithWhereUniqueWithoutEmailTemplateInput>>;
  updateMany?: InputMaybe<Array<EmailHistoryUpdateManyWithWhereWithoutEmailTemplateInput>>;
  upsert?: InputMaybe<Array<EmailHistoryUpsertWithWhereUniqueWithoutEmailTemplateInput>>;
};

export type EmailHistoryUpdateManyWithoutProfessionalNestedInput = {
  connect?: InputMaybe<Array<EmailHistoryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<EmailHistoryCreateOrConnectWithoutProfessionalInput>>;
  create?: InputMaybe<Array<EmailHistoryCreateWithoutProfessionalInput>>;
  createMany?: InputMaybe<EmailHistoryCreateManyProfessionalInputEnvelope>;
  delete?: InputMaybe<Array<EmailHistoryWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<EmailHistoryScalarWhereInput>>;
  disconnect?: InputMaybe<Array<EmailHistoryWhereUniqueInput>>;
  set?: InputMaybe<Array<EmailHistoryWhereUniqueInput>>;
  update?: InputMaybe<Array<EmailHistoryUpdateWithWhereUniqueWithoutProfessionalInput>>;
  updateMany?: InputMaybe<Array<EmailHistoryUpdateManyWithWhereWithoutProfessionalInput>>;
  upsert?: InputMaybe<Array<EmailHistoryUpsertWithWhereUniqueWithoutProfessionalInput>>;
};

export type EmailHistoryUpdateWithWhereUniqueWithoutAccountInput = {
  data: EmailHistoryUpdateWithoutAccountInput;
  where: EmailHistoryWhereUniqueInput;
};

export type EmailHistoryUpdateWithWhereUniqueWithoutBookingInput = {
  data: EmailHistoryUpdateWithoutBookingInput;
  where: EmailHistoryWhereUniqueInput;
};

export type EmailHistoryUpdateWithWhereUniqueWithoutBreederInput = {
  data: EmailHistoryUpdateWithoutBreederInput;
  where: EmailHistoryWhereUniqueInput;
};

export type EmailHistoryUpdateWithWhereUniqueWithoutEmailTemplateInput = {
  data: EmailHistoryUpdateWithoutEmailTemplateInput;
  where: EmailHistoryWhereUniqueInput;
};

export type EmailHistoryUpdateWithWhereUniqueWithoutProfessionalInput = {
  data: EmailHistoryUpdateWithoutProfessionalInput;
  where: EmailHistoryWhereUniqueInput;
};

export type EmailHistoryUpdateWithoutAccountInput = {
  body?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  booking?: InputMaybe<BookingUpdateOneWithoutEmailHistoryNestedInput>;
  breeder?: InputMaybe<DogBreederUpdateOneWithoutEmailHistoryNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  emailTemplate?: InputMaybe<EmailTemplateUpdateOneWithoutEmailHistoryNestedInput>;
  from?: InputMaybe<StringFieldUpdateOperationsInput>;
  professional?: InputMaybe<ProfessionalUpdateOneWithoutEmailHistoryNestedInput>;
  recipients?: InputMaybe<Array<Scalars['String']['input']>>;
  sentBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  subject?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type EmailHistoryUpdateWithoutBookingInput = {
  account?: InputMaybe<AccountUpdateOneWithoutEmailHistoryNestedInput>;
  body?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  breeder?: InputMaybe<DogBreederUpdateOneWithoutEmailHistoryNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  emailTemplate?: InputMaybe<EmailTemplateUpdateOneWithoutEmailHistoryNestedInput>;
  from?: InputMaybe<StringFieldUpdateOperationsInput>;
  professional?: InputMaybe<ProfessionalUpdateOneWithoutEmailHistoryNestedInput>;
  recipients?: InputMaybe<Array<Scalars['String']['input']>>;
  sentBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  subject?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type EmailHistoryUpdateWithoutBreederInput = {
  account?: InputMaybe<AccountUpdateOneWithoutEmailHistoryNestedInput>;
  body?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  booking?: InputMaybe<BookingUpdateOneWithoutEmailHistoryNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  emailTemplate?: InputMaybe<EmailTemplateUpdateOneWithoutEmailHistoryNestedInput>;
  from?: InputMaybe<StringFieldUpdateOperationsInput>;
  professional?: InputMaybe<ProfessionalUpdateOneWithoutEmailHistoryNestedInput>;
  recipients?: InputMaybe<Array<Scalars['String']['input']>>;
  sentBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  subject?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type EmailHistoryUpdateWithoutEmailTemplateInput = {
  account?: InputMaybe<AccountUpdateOneWithoutEmailHistoryNestedInput>;
  body?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  booking?: InputMaybe<BookingUpdateOneWithoutEmailHistoryNestedInput>;
  breeder?: InputMaybe<DogBreederUpdateOneWithoutEmailHistoryNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  from?: InputMaybe<StringFieldUpdateOperationsInput>;
  professional?: InputMaybe<ProfessionalUpdateOneWithoutEmailHistoryNestedInput>;
  recipients?: InputMaybe<Array<Scalars['String']['input']>>;
  sentBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  subject?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type EmailHistoryUpdateWithoutProfessionalInput = {
  account?: InputMaybe<AccountUpdateOneWithoutEmailHistoryNestedInput>;
  body?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  booking?: InputMaybe<BookingUpdateOneWithoutEmailHistoryNestedInput>;
  breeder?: InputMaybe<DogBreederUpdateOneWithoutEmailHistoryNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  emailTemplate?: InputMaybe<EmailTemplateUpdateOneWithoutEmailHistoryNestedInput>;
  from?: InputMaybe<StringFieldUpdateOperationsInput>;
  recipients?: InputMaybe<Array<Scalars['String']['input']>>;
  sentBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  subject?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type EmailHistoryUpdaterecipientsInput = {
  push?: InputMaybe<Array<Scalars['String']['input']>>;
  set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type EmailHistoryUpsertWithWhereUniqueWithoutAccountInput = {
  create: EmailHistoryCreateWithoutAccountInput;
  update: EmailHistoryUpdateWithoutAccountInput;
  where: EmailHistoryWhereUniqueInput;
};

export type EmailHistoryUpsertWithWhereUniqueWithoutBookingInput = {
  create: EmailHistoryCreateWithoutBookingInput;
  update: EmailHistoryUpdateWithoutBookingInput;
  where: EmailHistoryWhereUniqueInput;
};

export type EmailHistoryUpsertWithWhereUniqueWithoutBreederInput = {
  create: EmailHistoryCreateWithoutBreederInput;
  update: EmailHistoryUpdateWithoutBreederInput;
  where: EmailHistoryWhereUniqueInput;
};

export type EmailHistoryUpsertWithWhereUniqueWithoutEmailTemplateInput = {
  create: EmailHistoryCreateWithoutEmailTemplateInput;
  update: EmailHistoryUpdateWithoutEmailTemplateInput;
  where: EmailHistoryWhereUniqueInput;
};

export type EmailHistoryUpsertWithWhereUniqueWithoutProfessionalInput = {
  create: EmailHistoryCreateWithoutProfessionalInput;
  update: EmailHistoryUpdateWithoutProfessionalInput;
  where: EmailHistoryWhereUniqueInput;
};

export type EmailHistoryWhereInput = {
  AND?: InputMaybe<Array<EmailHistoryWhereInput>>;
  NOT?: InputMaybe<Array<EmailHistoryWhereInput>>;
  OR?: InputMaybe<Array<EmailHistoryWhereInput>>;
  account?: InputMaybe<AccountNullableRelationFilter>;
  accountId?: InputMaybe<IntNullableFilter>;
  body?: InputMaybe<StringNullableFilter>;
  booking?: InputMaybe<BookingNullableRelationFilter>;
  bookingId?: InputMaybe<IntNullableFilter>;
  breeder?: InputMaybe<DogBreederNullableRelationFilter>;
  breederId?: InputMaybe<IntNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  emailTemplate?: InputMaybe<EmailTemplateNullableRelationFilter>;
  emailTemplateId?: InputMaybe<IntNullableFilter>;
  from?: InputMaybe<StringFilter>;
  id?: InputMaybe<IntFilter>;
  proId?: InputMaybe<IntNullableFilter>;
  professional?: InputMaybe<ProfessionalNullableRelationFilter>;
  recipients?: InputMaybe<StringNullableListFilter>;
  sentBy?: InputMaybe<StringNullableFilter>;
  subject?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type EmailHistoryWhereUniqueInput = {
  AND?: InputMaybe<Array<EmailHistoryWhereInput>>;
  NOT?: InputMaybe<Array<EmailHistoryWhereInput>>;
  OR?: InputMaybe<Array<EmailHistoryWhereInput>>;
  account?: InputMaybe<AccountNullableRelationFilter>;
  accountId?: InputMaybe<IntNullableFilter>;
  body?: InputMaybe<StringNullableFilter>;
  booking?: InputMaybe<BookingNullableRelationFilter>;
  bookingId?: InputMaybe<IntNullableFilter>;
  breeder?: InputMaybe<DogBreederNullableRelationFilter>;
  breederId?: InputMaybe<IntNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  emailTemplate?: InputMaybe<EmailTemplateNullableRelationFilter>;
  emailTemplateId?: InputMaybe<IntNullableFilter>;
  from?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  proId?: InputMaybe<IntNullableFilter>;
  professional?: InputMaybe<ProfessionalNullableRelationFilter>;
  recipients?: InputMaybe<StringNullableListFilter>;
  sentBy?: InputMaybe<StringNullableFilter>;
  subject?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type EmailTemplate = {
  __typename?: 'EmailTemplate';
  body: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  from: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  language: Scalars['String']['output'];
  mailjetTemplateId: Scalars['Int']['output'];
  replyTo: Scalars['String']['output'];
  subject?: Maybe<Scalars['String']['output']>;
  templateKey: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type EmailTemplateAvgAggregateOutputType = {
  __typename?: 'EmailTemplateAvgAggregateOutputType';
  id?: Maybe<Scalars['Float']['output']>;
  mailjetTemplateId?: Maybe<Scalars['Float']['output']>;
};

export type EmailTemplateAvgOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
  mailjetTemplateId?: InputMaybe<SortOrder>;
};

export type EmailTemplateButtonAvgAggregateOutputType = {
  __typename?: 'EmailTemplateButtonAvgAggregateOutputType';
  emailTemplateId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

export type EmailTemplateButtonAvgOrderByAggregateInput = {
  emailTemplateId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export type EmailTemplateButtonCountAggregateOutputType = {
  __typename?: 'EmailTemplateButtonCountAggregateOutputType';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  emailTemplateId: Scalars['Int']['output'];
  href: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  label: Scalars['Int']['output'];
  type: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type EmailTemplateButtonCountOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  emailTemplateId?: InputMaybe<SortOrder>;
  href?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  label?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type EmailTemplateButtonCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  emailTemplate: EmailTemplateCreateNestedOneWithoutButtonsInput;
  href: Scalars['String']['input'];
  label: Scalars['String']['input'];
  type: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type EmailTemplateButtonCreateManyEmailTemplateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  href: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  label: Scalars['String']['input'];
  type: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type EmailTemplateButtonCreateManyEmailTemplateInputEnvelope = {
  data: Array<EmailTemplateButtonCreateManyEmailTemplateInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EmailTemplateButtonCreateManyInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  emailTemplateId: Scalars['Int']['input'];
  href: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  label: Scalars['String']['input'];
  type: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type EmailTemplateButtonCreateNestedManyWithoutEmailTemplateInput = {
  connect?: InputMaybe<Array<EmailTemplateButtonWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<EmailTemplateButtonCreateOrConnectWithoutEmailTemplateInput>>;
  create?: InputMaybe<Array<EmailTemplateButtonCreateWithoutEmailTemplateInput>>;
  createMany?: InputMaybe<EmailTemplateButtonCreateManyEmailTemplateInputEnvelope>;
};

export type EmailTemplateButtonCreateOrConnectWithoutEmailTemplateInput = {
  create: EmailTemplateButtonCreateWithoutEmailTemplateInput;
  where: EmailTemplateButtonWhereUniqueInput;
};

export type EmailTemplateButtonCreateWithoutEmailTemplateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  href: Scalars['String']['input'];
  label: Scalars['String']['input'];
  type: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type EmailTemplateButtonListRelationFilter = {
  every?: InputMaybe<EmailTemplateButtonWhereInput>;
  none?: InputMaybe<EmailTemplateButtonWhereInput>;
  some?: InputMaybe<EmailTemplateButtonWhereInput>;
};

export type EmailTemplateButtonMaxAggregateOutputType = {
  __typename?: 'EmailTemplateButtonMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  emailTemplateId?: Maybe<Scalars['Int']['output']>;
  href?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type EmailTemplateButtonMaxOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  emailTemplateId?: InputMaybe<SortOrder>;
  href?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  label?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type EmailTemplateButtonMinAggregateOutputType = {
  __typename?: 'EmailTemplateButtonMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  emailTemplateId?: Maybe<Scalars['Int']['output']>;
  href?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type EmailTemplateButtonMinOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  emailTemplateId?: InputMaybe<SortOrder>;
  href?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  label?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type EmailTemplateButtonOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export enum EmailTemplateButtonOrderByRelevanceFieldEnum {
  href = 'href',
  label = 'label',
  type = 'type'
}

export type EmailTemplateButtonOrderByRelevanceInput = {
  fields: Array<EmailTemplateButtonOrderByRelevanceFieldEnum>;
  search: Scalars['String']['input'];
  sort: SortOrder;
};

export type EmailTemplateButtonOrderByWithAggregationInput = {
  _avg?: InputMaybe<EmailTemplateButtonAvgOrderByAggregateInput>;
  _count?: InputMaybe<EmailTemplateButtonCountOrderByAggregateInput>;
  _max?: InputMaybe<EmailTemplateButtonMaxOrderByAggregateInput>;
  _min?: InputMaybe<EmailTemplateButtonMinOrderByAggregateInput>;
  _sum?: InputMaybe<EmailTemplateButtonSumOrderByAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  emailTemplateId?: InputMaybe<SortOrder>;
  href?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  label?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type EmailTemplateButtonOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: InputMaybe<EmailTemplateButtonOrderByRelevanceInput>;
  createdAt?: InputMaybe<SortOrder>;
  emailTemplate?: InputMaybe<EmailTemplateOrderByWithRelationAndSearchRelevanceInput>;
  emailTemplateId?: InputMaybe<SortOrder>;
  href?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  label?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum EmailTemplateButtonScalarFieldEnum {
  createdAt = 'createdAt',
  emailTemplateId = 'emailTemplateId',
  href = 'href',
  id = 'id',
  label = 'label',
  type = 'type',
  updatedAt = 'updatedAt'
}

export type EmailTemplateButtonScalarWhereInput = {
  AND?: InputMaybe<Array<EmailTemplateButtonScalarWhereInput>>;
  NOT?: InputMaybe<Array<EmailTemplateButtonScalarWhereInput>>;
  OR?: InputMaybe<Array<EmailTemplateButtonScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  emailTemplateId?: InputMaybe<IntFilter>;
  href?: InputMaybe<StringFilter>;
  id?: InputMaybe<IntFilter>;
  label?: InputMaybe<StringFilter>;
  type?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type EmailTemplateButtonScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<EmailTemplateButtonScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<EmailTemplateButtonScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<EmailTemplateButtonScalarWhereWithAggregatesInput>>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  emailTemplateId?: InputMaybe<IntWithAggregatesFilter>;
  href?: InputMaybe<StringWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  label?: InputMaybe<StringWithAggregatesFilter>;
  type?: InputMaybe<StringWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type EmailTemplateButtonSumAggregateOutputType = {
  __typename?: 'EmailTemplateButtonSumAggregateOutputType';
  emailTemplateId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
};

export type EmailTemplateButtonSumOrderByAggregateInput = {
  emailTemplateId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export type EmailTemplateButtonUncheckedCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  emailTemplateId: Scalars['Int']['input'];
  href: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  label: Scalars['String']['input'];
  type: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type EmailTemplateButtonUncheckedCreateNestedManyWithoutEmailTemplateInput = {
  connect?: InputMaybe<Array<EmailTemplateButtonWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<EmailTemplateButtonCreateOrConnectWithoutEmailTemplateInput>>;
  create?: InputMaybe<Array<EmailTemplateButtonCreateWithoutEmailTemplateInput>>;
  createMany?: InputMaybe<EmailTemplateButtonCreateManyEmailTemplateInputEnvelope>;
};

export type EmailTemplateButtonUncheckedCreateWithoutEmailTemplateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  href: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  label: Scalars['String']['input'];
  type: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type EmailTemplateButtonUncheckedUpdateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  emailTemplateId?: InputMaybe<IntFieldUpdateOperationsInput>;
  href?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  label?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type EmailTemplateButtonUncheckedUpdateManyInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  emailTemplateId?: InputMaybe<IntFieldUpdateOperationsInput>;
  href?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  label?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type EmailTemplateButtonUncheckedUpdateManyWithoutEmailTemplateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  href?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  label?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type EmailTemplateButtonUncheckedUpdateManyWithoutEmailTemplateNestedInput = {
  connect?: InputMaybe<Array<EmailTemplateButtonWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<EmailTemplateButtonCreateOrConnectWithoutEmailTemplateInput>>;
  create?: InputMaybe<Array<EmailTemplateButtonCreateWithoutEmailTemplateInput>>;
  createMany?: InputMaybe<EmailTemplateButtonCreateManyEmailTemplateInputEnvelope>;
  delete?: InputMaybe<Array<EmailTemplateButtonWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<EmailTemplateButtonScalarWhereInput>>;
  disconnect?: InputMaybe<Array<EmailTemplateButtonWhereUniqueInput>>;
  set?: InputMaybe<Array<EmailTemplateButtonWhereUniqueInput>>;
  update?: InputMaybe<Array<EmailTemplateButtonUpdateWithWhereUniqueWithoutEmailTemplateInput>>;
  updateMany?: InputMaybe<Array<EmailTemplateButtonUpdateManyWithWhereWithoutEmailTemplateInput>>;
  upsert?: InputMaybe<Array<EmailTemplateButtonUpsertWithWhereUniqueWithoutEmailTemplateInput>>;
};

export type EmailTemplateButtonUncheckedUpdateWithoutEmailTemplateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  href?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  label?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type EmailTemplateButtonUpdateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  emailTemplate?: InputMaybe<EmailTemplateUpdateOneRequiredWithoutButtonsNestedInput>;
  href?: InputMaybe<StringFieldUpdateOperationsInput>;
  label?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type EmailTemplateButtonUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  href?: InputMaybe<StringFieldUpdateOperationsInput>;
  label?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type EmailTemplateButtonUpdateManyWithWhereWithoutEmailTemplateInput = {
  data: EmailTemplateButtonUpdateManyMutationInput;
  where: EmailTemplateButtonScalarWhereInput;
};

export type EmailTemplateButtonUpdateManyWithoutEmailTemplateNestedInput = {
  connect?: InputMaybe<Array<EmailTemplateButtonWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<EmailTemplateButtonCreateOrConnectWithoutEmailTemplateInput>>;
  create?: InputMaybe<Array<EmailTemplateButtonCreateWithoutEmailTemplateInput>>;
  createMany?: InputMaybe<EmailTemplateButtonCreateManyEmailTemplateInputEnvelope>;
  delete?: InputMaybe<Array<EmailTemplateButtonWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<EmailTemplateButtonScalarWhereInput>>;
  disconnect?: InputMaybe<Array<EmailTemplateButtonWhereUniqueInput>>;
  set?: InputMaybe<Array<EmailTemplateButtonWhereUniqueInput>>;
  update?: InputMaybe<Array<EmailTemplateButtonUpdateWithWhereUniqueWithoutEmailTemplateInput>>;
  updateMany?: InputMaybe<Array<EmailTemplateButtonUpdateManyWithWhereWithoutEmailTemplateInput>>;
  upsert?: InputMaybe<Array<EmailTemplateButtonUpsertWithWhereUniqueWithoutEmailTemplateInput>>;
};

export type EmailTemplateButtonUpdateWithWhereUniqueWithoutEmailTemplateInput = {
  data: EmailTemplateButtonUpdateWithoutEmailTemplateInput;
  where: EmailTemplateButtonWhereUniqueInput;
};

export type EmailTemplateButtonUpdateWithoutEmailTemplateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  href?: InputMaybe<StringFieldUpdateOperationsInput>;
  label?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type EmailTemplateButtonUpsertWithWhereUniqueWithoutEmailTemplateInput = {
  create: EmailTemplateButtonCreateWithoutEmailTemplateInput;
  update: EmailTemplateButtonUpdateWithoutEmailTemplateInput;
  where: EmailTemplateButtonWhereUniqueInput;
};

export type EmailTemplateButtonWhereInput = {
  AND?: InputMaybe<Array<EmailTemplateButtonWhereInput>>;
  NOT?: InputMaybe<Array<EmailTemplateButtonWhereInput>>;
  OR?: InputMaybe<Array<EmailTemplateButtonWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  emailTemplate?: InputMaybe<EmailTemplateRelationFilter>;
  emailTemplateId?: InputMaybe<IntFilter>;
  href?: InputMaybe<StringFilter>;
  id?: InputMaybe<IntFilter>;
  label?: InputMaybe<StringFilter>;
  type?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type EmailTemplateButtonWhereUniqueInput = {
  AND?: InputMaybe<Array<EmailTemplateButtonWhereInput>>;
  NOT?: InputMaybe<Array<EmailTemplateButtonWhereInput>>;
  OR?: InputMaybe<Array<EmailTemplateButtonWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  emailTemplate?: InputMaybe<EmailTemplateRelationFilter>;
  emailTemplateId?: InputMaybe<IntFilter>;
  href?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  label?: InputMaybe<StringFilter>;
  type?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type EmailTemplateCountAggregateOutputType = {
  __typename?: 'EmailTemplateCountAggregateOutputType';
  _all: Scalars['Int']['output'];
  body: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  description: Scalars['Int']['output'];
  from: Scalars['Int']['output'];
  hyphenInterpolation: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isAccountTemplate: Scalars['Int']['output'];
  isBreederTemplate: Scalars['Int']['output'];
  isProTemplate: Scalars['Int']['output'];
  language: Scalars['Int']['output'];
  mailjetTemplateId: Scalars['Int']['output'];
  replyTo: Scalars['Int']['output'];
  subject: Scalars['Int']['output'];
  tags: Scalars['Int']['output'];
  templateKey: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type EmailTemplateCountOrderByAggregateInput = {
  body?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  from?: InputMaybe<SortOrder>;
  hyphenInterpolation?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isAccountTemplate?: InputMaybe<SortOrder>;
  isBreederTemplate?: InputMaybe<SortOrder>;
  isProTemplate?: InputMaybe<SortOrder>;
  language?: InputMaybe<SortOrder>;
  mailjetTemplateId?: InputMaybe<SortOrder>;
  replyTo?: InputMaybe<SortOrder>;
  subject?: InputMaybe<SortOrder>;
  tags?: InputMaybe<SortOrder>;
  templateKey?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type EmailTemplateCountOutputType = {
  __typename?: 'EmailTemplateCountOutputType';
  buttons: Scalars['Int']['output'];
  emailHistory: Scalars['Int']['output'];
};

export type EmailTemplateCreateInput = {
  body: Scalars['String']['input'];
  buttons?: InputMaybe<EmailTemplateButtonCreateNestedManyWithoutEmailTemplateInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  emailHistory?: InputMaybe<EmailHistoryCreateNestedManyWithoutEmailTemplateInput>;
  from?: InputMaybe<Scalars['String']['input']>;
  hyphenInterpolation?: InputMaybe<Scalars['Boolean']['input']>;
  isAccountTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  isBreederTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  isProTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  language: Scalars['String']['input'];
  mailjetTemplateId: Scalars['Int']['input'];
  replyTo?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  templateKey: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type EmailTemplateCreateManyInput = {
  body: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  from?: InputMaybe<Scalars['String']['input']>;
  hyphenInterpolation?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isAccountTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  isBreederTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  isProTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  language: Scalars['String']['input'];
  mailjetTemplateId: Scalars['Int']['input'];
  replyTo?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  templateKey: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type EmailTemplateCreateNestedOneWithoutButtonsInput = {
  connect?: InputMaybe<EmailTemplateWhereUniqueInput>;
  connectOrCreate?: InputMaybe<EmailTemplateCreateOrConnectWithoutButtonsInput>;
  create?: InputMaybe<EmailTemplateCreateWithoutButtonsInput>;
};

export type EmailTemplateCreateNestedOneWithoutEmailHistoryInput = {
  connect?: InputMaybe<EmailTemplateWhereUniqueInput>;
  connectOrCreate?: InputMaybe<EmailTemplateCreateOrConnectWithoutEmailHistoryInput>;
  create?: InputMaybe<EmailTemplateCreateWithoutEmailHistoryInput>;
};

export type EmailTemplateCreateOrConnectWithoutButtonsInput = {
  create: EmailTemplateCreateWithoutButtonsInput;
  where: EmailTemplateWhereUniqueInput;
};

export type EmailTemplateCreateOrConnectWithoutEmailHistoryInput = {
  create: EmailTemplateCreateWithoutEmailHistoryInput;
  where: EmailTemplateWhereUniqueInput;
};

export type EmailTemplateCreateWithoutButtonsInput = {
  body: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  emailHistory?: InputMaybe<EmailHistoryCreateNestedManyWithoutEmailTemplateInput>;
  from?: InputMaybe<Scalars['String']['input']>;
  hyphenInterpolation?: InputMaybe<Scalars['Boolean']['input']>;
  isAccountTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  isBreederTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  isProTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  language: Scalars['String']['input'];
  mailjetTemplateId: Scalars['Int']['input'];
  replyTo?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  templateKey: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type EmailTemplateCreateWithoutEmailHistoryInput = {
  body: Scalars['String']['input'];
  buttons?: InputMaybe<EmailTemplateButtonCreateNestedManyWithoutEmailTemplateInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  from?: InputMaybe<Scalars['String']['input']>;
  hyphenInterpolation?: InputMaybe<Scalars['Boolean']['input']>;
  isAccountTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  isBreederTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  isProTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  language: Scalars['String']['input'];
  mailjetTemplateId: Scalars['Int']['input'];
  replyTo?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  templateKey: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type EmailTemplateCreatetagsInput = {
  set: Array<Scalars['String']['input']>;
};

export type EmailTemplateMaxAggregateOutputType = {
  __typename?: 'EmailTemplateMaxAggregateOutputType';
  body?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  from?: Maybe<Scalars['String']['output']>;
  hyphenInterpolation?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isAccountTemplate?: Maybe<Scalars['Boolean']['output']>;
  isBreederTemplate?: Maybe<Scalars['Boolean']['output']>;
  isProTemplate?: Maybe<Scalars['Boolean']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  mailjetTemplateId?: Maybe<Scalars['Int']['output']>;
  replyTo?: Maybe<Scalars['String']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
  templateKey?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type EmailTemplateMaxOrderByAggregateInput = {
  body?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  from?: InputMaybe<SortOrder>;
  hyphenInterpolation?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isAccountTemplate?: InputMaybe<SortOrder>;
  isBreederTemplate?: InputMaybe<SortOrder>;
  isProTemplate?: InputMaybe<SortOrder>;
  language?: InputMaybe<SortOrder>;
  mailjetTemplateId?: InputMaybe<SortOrder>;
  replyTo?: InputMaybe<SortOrder>;
  subject?: InputMaybe<SortOrder>;
  templateKey?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type EmailTemplateMinAggregateOutputType = {
  __typename?: 'EmailTemplateMinAggregateOutputType';
  body?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  from?: Maybe<Scalars['String']['output']>;
  hyphenInterpolation?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isAccountTemplate?: Maybe<Scalars['Boolean']['output']>;
  isBreederTemplate?: Maybe<Scalars['Boolean']['output']>;
  isProTemplate?: Maybe<Scalars['Boolean']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  mailjetTemplateId?: Maybe<Scalars['Int']['output']>;
  replyTo?: Maybe<Scalars['String']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
  templateKey?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type EmailTemplateMinOrderByAggregateInput = {
  body?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  from?: InputMaybe<SortOrder>;
  hyphenInterpolation?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isAccountTemplate?: InputMaybe<SortOrder>;
  isBreederTemplate?: InputMaybe<SortOrder>;
  isProTemplate?: InputMaybe<SortOrder>;
  language?: InputMaybe<SortOrder>;
  mailjetTemplateId?: InputMaybe<SortOrder>;
  replyTo?: InputMaybe<SortOrder>;
  subject?: InputMaybe<SortOrder>;
  templateKey?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type EmailTemplateNullableRelationFilter = {
  is?: InputMaybe<EmailTemplateWhereInput>;
  isNot?: InputMaybe<EmailTemplateWhereInput>;
};

export enum EmailTemplateOrderByRelevanceFieldEnum {
  body = 'body',
  description = 'description',
  from = 'from',
  language = 'language',
  replyTo = 'replyTo',
  subject = 'subject',
  tags = 'tags',
  templateKey = 'templateKey'
}

export type EmailTemplateOrderByRelevanceInput = {
  fields: Array<EmailTemplateOrderByRelevanceFieldEnum>;
  search: Scalars['String']['input'];
  sort: SortOrder;
};

export type EmailTemplateOrderByWithAggregationInput = {
  _avg?: InputMaybe<EmailTemplateAvgOrderByAggregateInput>;
  _count?: InputMaybe<EmailTemplateCountOrderByAggregateInput>;
  _max?: InputMaybe<EmailTemplateMaxOrderByAggregateInput>;
  _min?: InputMaybe<EmailTemplateMinOrderByAggregateInput>;
  _sum?: InputMaybe<EmailTemplateSumOrderByAggregateInput>;
  body?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrderInput>;
  from?: InputMaybe<SortOrder>;
  hyphenInterpolation?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isAccountTemplate?: InputMaybe<SortOrderInput>;
  isBreederTemplate?: InputMaybe<SortOrderInput>;
  isProTemplate?: InputMaybe<SortOrderInput>;
  language?: InputMaybe<SortOrder>;
  mailjetTemplateId?: InputMaybe<SortOrder>;
  replyTo?: InputMaybe<SortOrder>;
  subject?: InputMaybe<SortOrderInput>;
  tags?: InputMaybe<SortOrder>;
  templateKey?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type EmailTemplateOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: InputMaybe<EmailTemplateOrderByRelevanceInput>;
  body?: InputMaybe<SortOrder>;
  buttons?: InputMaybe<EmailTemplateButtonOrderByRelationAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrderInput>;
  emailHistory?: InputMaybe<EmailHistoryOrderByRelationAggregateInput>;
  from?: InputMaybe<SortOrder>;
  hyphenInterpolation?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isAccountTemplate?: InputMaybe<SortOrderInput>;
  isBreederTemplate?: InputMaybe<SortOrderInput>;
  isProTemplate?: InputMaybe<SortOrderInput>;
  language?: InputMaybe<SortOrder>;
  mailjetTemplateId?: InputMaybe<SortOrder>;
  replyTo?: InputMaybe<SortOrder>;
  subject?: InputMaybe<SortOrderInput>;
  tags?: InputMaybe<SortOrder>;
  templateKey?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type EmailTemplateRelationFilter = {
  is?: InputMaybe<EmailTemplateWhereInput>;
  isNot?: InputMaybe<EmailTemplateWhereInput>;
};

export enum EmailTemplateScalarFieldEnum {
  body = 'body',
  createdAt = 'createdAt',
  description = 'description',
  from = 'from',
  hyphenInterpolation = 'hyphenInterpolation',
  id = 'id',
  isAccountTemplate = 'isAccountTemplate',
  isBreederTemplate = 'isBreederTemplate',
  isProTemplate = 'isProTemplate',
  language = 'language',
  mailjetTemplateId = 'mailjetTemplateId',
  replyTo = 'replyTo',
  subject = 'subject',
  tags = 'tags',
  templateKey = 'templateKey',
  updatedAt = 'updatedAt'
}

export type EmailTemplateScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<EmailTemplateScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<EmailTemplateScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<EmailTemplateScalarWhereWithAggregatesInput>>;
  body?: InputMaybe<StringWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  description?: InputMaybe<StringNullableWithAggregatesFilter>;
  from?: InputMaybe<StringWithAggregatesFilter>;
  hyphenInterpolation?: InputMaybe<BoolWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  isAccountTemplate?: InputMaybe<BoolNullableWithAggregatesFilter>;
  isBreederTemplate?: InputMaybe<BoolNullableWithAggregatesFilter>;
  isProTemplate?: InputMaybe<BoolNullableWithAggregatesFilter>;
  language?: InputMaybe<StringWithAggregatesFilter>;
  mailjetTemplateId?: InputMaybe<IntWithAggregatesFilter>;
  replyTo?: InputMaybe<StringWithAggregatesFilter>;
  subject?: InputMaybe<StringNullableWithAggregatesFilter>;
  tags?: InputMaybe<StringNullableListFilter>;
  templateKey?: InputMaybe<StringWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type EmailTemplateSumAggregateOutputType = {
  __typename?: 'EmailTemplateSumAggregateOutputType';
  id?: Maybe<Scalars['Int']['output']>;
  mailjetTemplateId?: Maybe<Scalars['Int']['output']>;
};

export type EmailTemplateSumOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
  mailjetTemplateId?: InputMaybe<SortOrder>;
};

export type EmailTemplateUncheckedCreateInput = {
  body: Scalars['String']['input'];
  buttons?: InputMaybe<EmailTemplateButtonUncheckedCreateNestedManyWithoutEmailTemplateInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  emailHistory?: InputMaybe<EmailHistoryUncheckedCreateNestedManyWithoutEmailTemplateInput>;
  from?: InputMaybe<Scalars['String']['input']>;
  hyphenInterpolation?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isAccountTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  isBreederTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  isProTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  language: Scalars['String']['input'];
  mailjetTemplateId: Scalars['Int']['input'];
  replyTo?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  templateKey: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type EmailTemplateUncheckedCreateWithoutButtonsInput = {
  body: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  emailHistory?: InputMaybe<EmailHistoryUncheckedCreateNestedManyWithoutEmailTemplateInput>;
  from?: InputMaybe<Scalars['String']['input']>;
  hyphenInterpolation?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isAccountTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  isBreederTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  isProTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  language: Scalars['String']['input'];
  mailjetTemplateId: Scalars['Int']['input'];
  replyTo?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  templateKey: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type EmailTemplateUncheckedCreateWithoutEmailHistoryInput = {
  body: Scalars['String']['input'];
  buttons?: InputMaybe<EmailTemplateButtonUncheckedCreateNestedManyWithoutEmailTemplateInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  from?: InputMaybe<Scalars['String']['input']>;
  hyphenInterpolation?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isAccountTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  isBreederTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  isProTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  language: Scalars['String']['input'];
  mailjetTemplateId: Scalars['Int']['input'];
  replyTo?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  templateKey: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type EmailTemplateUncheckedUpdateInput = {
  body?: InputMaybe<StringFieldUpdateOperationsInput>;
  buttons?: InputMaybe<EmailTemplateButtonUncheckedUpdateManyWithoutEmailTemplateNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailHistory?: InputMaybe<EmailHistoryUncheckedUpdateManyWithoutEmailTemplateNestedInput>;
  from?: InputMaybe<StringFieldUpdateOperationsInput>;
  hyphenInterpolation?: InputMaybe<BoolFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  isAccountTemplate?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isBreederTemplate?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isProTemplate?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  mailjetTemplateId?: InputMaybe<IntFieldUpdateOperationsInput>;
  replyTo?: InputMaybe<StringFieldUpdateOperationsInput>;
  subject?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  templateKey?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type EmailTemplateUncheckedUpdateManyInput = {
  body?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  from?: InputMaybe<StringFieldUpdateOperationsInput>;
  hyphenInterpolation?: InputMaybe<BoolFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  isAccountTemplate?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isBreederTemplate?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isProTemplate?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  mailjetTemplateId?: InputMaybe<IntFieldUpdateOperationsInput>;
  replyTo?: InputMaybe<StringFieldUpdateOperationsInput>;
  subject?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  templateKey?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type EmailTemplateUncheckedUpdateWithoutButtonsInput = {
  body?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailHistory?: InputMaybe<EmailHistoryUncheckedUpdateManyWithoutEmailTemplateNestedInput>;
  from?: InputMaybe<StringFieldUpdateOperationsInput>;
  hyphenInterpolation?: InputMaybe<BoolFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  isAccountTemplate?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isBreederTemplate?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isProTemplate?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  mailjetTemplateId?: InputMaybe<IntFieldUpdateOperationsInput>;
  replyTo?: InputMaybe<StringFieldUpdateOperationsInput>;
  subject?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  templateKey?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type EmailTemplateUncheckedUpdateWithoutEmailHistoryInput = {
  body?: InputMaybe<StringFieldUpdateOperationsInput>;
  buttons?: InputMaybe<EmailTemplateButtonUncheckedUpdateManyWithoutEmailTemplateNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  from?: InputMaybe<StringFieldUpdateOperationsInput>;
  hyphenInterpolation?: InputMaybe<BoolFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  isAccountTemplate?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isBreederTemplate?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isProTemplate?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  mailjetTemplateId?: InputMaybe<IntFieldUpdateOperationsInput>;
  replyTo?: InputMaybe<StringFieldUpdateOperationsInput>;
  subject?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  templateKey?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type EmailTemplateUpdateInput = {
  body?: InputMaybe<StringFieldUpdateOperationsInput>;
  buttons?: InputMaybe<EmailTemplateButtonUpdateManyWithoutEmailTemplateNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailHistory?: InputMaybe<EmailHistoryUpdateManyWithoutEmailTemplateNestedInput>;
  from?: InputMaybe<StringFieldUpdateOperationsInput>;
  hyphenInterpolation?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAccountTemplate?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isBreederTemplate?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isProTemplate?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  mailjetTemplateId?: InputMaybe<IntFieldUpdateOperationsInput>;
  replyTo?: InputMaybe<StringFieldUpdateOperationsInput>;
  subject?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  templateKey?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type EmailTemplateUpdateManyMutationInput = {
  body?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  from?: InputMaybe<StringFieldUpdateOperationsInput>;
  hyphenInterpolation?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAccountTemplate?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isBreederTemplate?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isProTemplate?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  mailjetTemplateId?: InputMaybe<IntFieldUpdateOperationsInput>;
  replyTo?: InputMaybe<StringFieldUpdateOperationsInput>;
  subject?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  templateKey?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type EmailTemplateUpdateOneRequiredWithoutButtonsNestedInput = {
  connect?: InputMaybe<EmailTemplateWhereUniqueInput>;
  connectOrCreate?: InputMaybe<EmailTemplateCreateOrConnectWithoutButtonsInput>;
  create?: InputMaybe<EmailTemplateCreateWithoutButtonsInput>;
  update?: InputMaybe<EmailTemplateUpdateToOneWithWhereWithoutButtonsInput>;
  upsert?: InputMaybe<EmailTemplateUpsertWithoutButtonsInput>;
};

export type EmailTemplateUpdateOneWithoutEmailHistoryNestedInput = {
  connect?: InputMaybe<EmailTemplateWhereUniqueInput>;
  connectOrCreate?: InputMaybe<EmailTemplateCreateOrConnectWithoutEmailHistoryInput>;
  create?: InputMaybe<EmailTemplateCreateWithoutEmailHistoryInput>;
  delete?: InputMaybe<EmailTemplateWhereInput>;
  disconnect?: InputMaybe<EmailTemplateWhereInput>;
  update?: InputMaybe<EmailTemplateUpdateToOneWithWhereWithoutEmailHistoryInput>;
  upsert?: InputMaybe<EmailTemplateUpsertWithoutEmailHistoryInput>;
};

export type EmailTemplateUpdateToOneWithWhereWithoutButtonsInput = {
  data: EmailTemplateUpdateWithoutButtonsInput;
  where?: InputMaybe<EmailTemplateWhereInput>;
};

export type EmailTemplateUpdateToOneWithWhereWithoutEmailHistoryInput = {
  data: EmailTemplateUpdateWithoutEmailHistoryInput;
  where?: InputMaybe<EmailTemplateWhereInput>;
};

export type EmailTemplateUpdateWithoutButtonsInput = {
  body?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailHistory?: InputMaybe<EmailHistoryUpdateManyWithoutEmailTemplateNestedInput>;
  from?: InputMaybe<StringFieldUpdateOperationsInput>;
  hyphenInterpolation?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAccountTemplate?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isBreederTemplate?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isProTemplate?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  mailjetTemplateId?: InputMaybe<IntFieldUpdateOperationsInput>;
  replyTo?: InputMaybe<StringFieldUpdateOperationsInput>;
  subject?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  templateKey?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type EmailTemplateUpdateWithoutEmailHistoryInput = {
  body?: InputMaybe<StringFieldUpdateOperationsInput>;
  buttons?: InputMaybe<EmailTemplateButtonUpdateManyWithoutEmailTemplateNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  from?: InputMaybe<StringFieldUpdateOperationsInput>;
  hyphenInterpolation?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isAccountTemplate?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isBreederTemplate?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isProTemplate?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  mailjetTemplateId?: InputMaybe<IntFieldUpdateOperationsInput>;
  replyTo?: InputMaybe<StringFieldUpdateOperationsInput>;
  subject?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  templateKey?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type EmailTemplateUpdatetagsInput = {
  push?: InputMaybe<Array<Scalars['String']['input']>>;
  set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type EmailTemplateUpsertWithoutButtonsInput = {
  create: EmailTemplateCreateWithoutButtonsInput;
  update: EmailTemplateUpdateWithoutButtonsInput;
  where?: InputMaybe<EmailTemplateWhereInput>;
};

export type EmailTemplateUpsertWithoutEmailHistoryInput = {
  create: EmailTemplateCreateWithoutEmailHistoryInput;
  update: EmailTemplateUpdateWithoutEmailHistoryInput;
  where?: InputMaybe<EmailTemplateWhereInput>;
};

export type EmailTemplateWhereInput = {
  AND?: InputMaybe<Array<EmailTemplateWhereInput>>;
  NOT?: InputMaybe<Array<EmailTemplateWhereInput>>;
  OR?: InputMaybe<Array<EmailTemplateWhereInput>>;
  body?: InputMaybe<StringFilter>;
  buttons?: InputMaybe<EmailTemplateButtonListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringNullableFilter>;
  emailHistory?: InputMaybe<EmailHistoryListRelationFilter>;
  from?: InputMaybe<StringFilter>;
  hyphenInterpolation?: InputMaybe<BoolFilter>;
  id?: InputMaybe<IntFilter>;
  isAccountTemplate?: InputMaybe<BoolNullableFilter>;
  isBreederTemplate?: InputMaybe<BoolNullableFilter>;
  isProTemplate?: InputMaybe<BoolNullableFilter>;
  language?: InputMaybe<StringFilter>;
  mailjetTemplateId?: InputMaybe<IntFilter>;
  replyTo?: InputMaybe<StringFilter>;
  subject?: InputMaybe<StringNullableFilter>;
  tags?: InputMaybe<StringNullableListFilter>;
  templateKey?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type EmailTemplateWhereUniqueInput = {
  AND?: InputMaybe<Array<EmailTemplateWhereInput>>;
  NOT?: InputMaybe<Array<EmailTemplateWhereInput>>;
  OR?: InputMaybe<Array<EmailTemplateWhereInput>>;
  body?: InputMaybe<StringFilter>;
  buttons?: InputMaybe<EmailTemplateButtonListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringNullableFilter>;
  emailHistory?: InputMaybe<EmailHistoryListRelationFilter>;
  from?: InputMaybe<StringFilter>;
  hyphenInterpolation?: InputMaybe<BoolFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isAccountTemplate?: InputMaybe<BoolNullableFilter>;
  isBreederTemplate?: InputMaybe<BoolNullableFilter>;
  isProTemplate?: InputMaybe<BoolNullableFilter>;
  language?: InputMaybe<StringFilter>;
  mailjetTemplateId?: InputMaybe<IntFilter>;
  replyTo?: InputMaybe<StringFilter>;
  subject?: InputMaybe<StringNullableFilter>;
  tags?: InputMaybe<StringNullableListFilter>;
  templateKey?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type EnumAccountImgTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<AccountImgType>;
};

export type EnumAccountImgTypeFilter = {
  equals?: InputMaybe<AccountImgType>;
  in?: InputMaybe<Array<AccountImgType>>;
  not?: InputMaybe<NestedEnumAccountImgTypeFilter>;
  notIn?: InputMaybe<Array<AccountImgType>>;
};

export type EnumAccountImgTypeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumAccountImgTypeFilter>;
  _min?: InputMaybe<NestedEnumAccountImgTypeFilter>;
  equals?: InputMaybe<AccountImgType>;
  in?: InputMaybe<Array<AccountImgType>>;
  not?: InputMaybe<NestedEnumAccountImgTypeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<AccountImgType>>;
};

export type EnumAnimalSizeEnumNullableFilter = {
  equals?: InputMaybe<AnimalSizeEnum>;
  in?: InputMaybe<Array<AnimalSizeEnum>>;
  not?: InputMaybe<NestedEnumAnimalSizeEnumNullableFilter>;
  notIn?: InputMaybe<Array<AnimalSizeEnum>>;
};

export type EnumAnimalSizeEnumNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumAnimalSizeEnumNullableFilter>;
  _min?: InputMaybe<NestedEnumAnimalSizeEnumNullableFilter>;
  equals?: InputMaybe<AnimalSizeEnum>;
  in?: InputMaybe<Array<AnimalSizeEnum>>;
  not?: InputMaybe<NestedEnumAnimalSizeEnumNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<AnimalSizeEnum>>;
};

export type EnumAnimalStatCreatedFromEnumFieldUpdateOperationsInput = {
  set?: InputMaybe<AnimalStatCreatedFromEnum>;
};

export type EnumAnimalStatCreatedFromEnumFilter = {
  equals?: InputMaybe<AnimalStatCreatedFromEnum>;
  in?: InputMaybe<Array<AnimalStatCreatedFromEnum>>;
  not?: InputMaybe<NestedEnumAnimalStatCreatedFromEnumFilter>;
  notIn?: InputMaybe<Array<AnimalStatCreatedFromEnum>>;
};

export type EnumAnimalStatCreatedFromEnumWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumAnimalStatCreatedFromEnumFilter>;
  _min?: InputMaybe<NestedEnumAnimalStatCreatedFromEnumFilter>;
  equals?: InputMaybe<AnimalStatCreatedFromEnum>;
  in?: InputMaybe<Array<AnimalStatCreatedFromEnum>>;
  not?: InputMaybe<NestedEnumAnimalStatCreatedFromEnumWithAggregatesFilter>;
  notIn?: InputMaybe<Array<AnimalStatCreatedFromEnum>>;
};

export type EnumAnimalTypeEnumFieldUpdateOperationsInput = {
  set?: InputMaybe<AnimalTypeEnum>;
};

export type EnumAnimalTypeEnumFilter = {
  equals?: InputMaybe<AnimalTypeEnum>;
  in?: InputMaybe<Array<AnimalTypeEnum>>;
  not?: InputMaybe<NestedEnumAnimalTypeEnumFilter>;
  notIn?: InputMaybe<Array<AnimalTypeEnum>>;
};

export type EnumAnimalTypeEnumNullableFilter = {
  equals?: InputMaybe<AnimalTypeEnum>;
  in?: InputMaybe<Array<AnimalTypeEnum>>;
  not?: InputMaybe<NestedEnumAnimalTypeEnumNullableFilter>;
  notIn?: InputMaybe<Array<AnimalTypeEnum>>;
};

export type EnumAnimalTypeEnumNullableListFilter = {
  equals?: InputMaybe<Array<AnimalTypeEnum>>;
  has?: InputMaybe<AnimalTypeEnum>;
  hasEvery?: InputMaybe<Array<AnimalTypeEnum>>;
  hasSome?: InputMaybe<Array<AnimalTypeEnum>>;
  isEmpty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EnumAnimalTypeEnumNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumAnimalTypeEnumNullableFilter>;
  _min?: InputMaybe<NestedEnumAnimalTypeEnumNullableFilter>;
  equals?: InputMaybe<AnimalTypeEnum>;
  in?: InputMaybe<Array<AnimalTypeEnum>>;
  not?: InputMaybe<NestedEnumAnimalTypeEnumNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<AnimalTypeEnum>>;
};

export type EnumAnimalTypeEnumWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumAnimalTypeEnumFilter>;
  _min?: InputMaybe<NestedEnumAnimalTypeEnumFilter>;
  equals?: InputMaybe<AnimalTypeEnum>;
  in?: InputMaybe<Array<AnimalTypeEnum>>;
  not?: InputMaybe<NestedEnumAnimalTypeEnumWithAggregatesFilter>;
  notIn?: InputMaybe<Array<AnimalTypeEnum>>;
};

export type EnumBirthdayTypeNullableFilter = {
  equals?: InputMaybe<BirthdayType>;
  in?: InputMaybe<Array<BirthdayType>>;
  not?: InputMaybe<NestedEnumBirthdayTypeNullableFilter>;
  notIn?: InputMaybe<Array<BirthdayType>>;
};

export type EnumBirthdayTypeNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumBirthdayTypeNullableFilter>;
  _min?: InputMaybe<NestedEnumBirthdayTypeNullableFilter>;
  equals?: InputMaybe<BirthdayType>;
  in?: InputMaybe<Array<BirthdayType>>;
  not?: InputMaybe<NestedEnumBirthdayTypeNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<BirthdayType>>;
};

export type EnumBreedGeneticAnalyzeTypeNullableFilter = {
  equals?: InputMaybe<BreedGeneticAnalyzeType>;
  in?: InputMaybe<Array<BreedGeneticAnalyzeType>>;
  not?: InputMaybe<NestedEnumBreedGeneticAnalyzeTypeNullableFilter>;
  notIn?: InputMaybe<Array<BreedGeneticAnalyzeType>>;
};

export type EnumBreedGeneticAnalyzeTypeNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumBreedGeneticAnalyzeTypeNullableFilter>;
  _min?: InputMaybe<NestedEnumBreedGeneticAnalyzeTypeNullableFilter>;
  equals?: InputMaybe<BreedGeneticAnalyzeType>;
  in?: InputMaybe<Array<BreedGeneticAnalyzeType>>;
  not?: InputMaybe<NestedEnumBreedGeneticAnalyzeTypeNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<BreedGeneticAnalyzeType>>;
};

export type EnumBreedTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<BreedType>;
};

export type EnumBreedTypeFilter = {
  equals?: InputMaybe<BreedType>;
  in?: InputMaybe<Array<BreedType>>;
  not?: InputMaybe<NestedEnumBreedTypeFilter>;
  notIn?: InputMaybe<Array<BreedType>>;
};

export type EnumBreedTypeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumBreedTypeFilter>;
  _min?: InputMaybe<NestedEnumBreedTypeFilter>;
  equals?: InputMaybe<BreedType>;
  in?: InputMaybe<Array<BreedType>>;
  not?: InputMaybe<NestedEnumBreedTypeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<BreedType>>;
};

export type EnumCenterTypeEnumNullableFilter = {
  equals?: InputMaybe<CenterTypeEnum>;
  in?: InputMaybe<Array<CenterTypeEnum>>;
  not?: InputMaybe<NestedEnumCenterTypeEnumNullableFilter>;
  notIn?: InputMaybe<Array<CenterTypeEnum>>;
};

export type EnumCenterTypeEnumNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumCenterTypeEnumNullableFilter>;
  _min?: InputMaybe<NestedEnumCenterTypeEnumNullableFilter>;
  equals?: InputMaybe<CenterTypeEnum>;
  in?: InputMaybe<Array<CenterTypeEnum>>;
  not?: InputMaybe<NestedEnumCenterTypeEnumNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<CenterTypeEnum>>;
};

export type EnumContactPreferenceNullableListFilter = {
  equals?: InputMaybe<Array<ContactPreference>>;
  has?: InputMaybe<ContactPreference>;
  hasEvery?: InputMaybe<Array<ContactPreference>>;
  hasSome?: InputMaybe<Array<ContactPreference>>;
  isEmpty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EnumCountryCodeFieldUpdateOperationsInput = {
  set?: InputMaybe<CountryCode>;
};

export type EnumCountryCodeFilter = {
  equals?: InputMaybe<CountryCode>;
  in?: InputMaybe<Array<CountryCode>>;
  not?: InputMaybe<NestedEnumCountryCodeFilter>;
  notIn?: InputMaybe<Array<CountryCode>>;
};

export type EnumCountryCodeNullableFilter = {
  equals?: InputMaybe<CountryCode>;
  in?: InputMaybe<Array<CountryCode>>;
  not?: InputMaybe<NestedEnumCountryCodeNullableFilter>;
  notIn?: InputMaybe<Array<CountryCode>>;
};

export type EnumCountryCodeNullableListFilter = {
  equals?: InputMaybe<Array<CountryCode>>;
  has?: InputMaybe<CountryCode>;
  hasEvery?: InputMaybe<Array<CountryCode>>;
  hasSome?: InputMaybe<Array<CountryCode>>;
  isEmpty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EnumCountryCodeNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumCountryCodeNullableFilter>;
  _min?: InputMaybe<NestedEnumCountryCodeNullableFilter>;
  equals?: InputMaybe<CountryCode>;
  in?: InputMaybe<Array<CountryCode>>;
  not?: InputMaybe<NestedEnumCountryCodeNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<CountryCode>>;
};

export type EnumCountryCodeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumCountryCodeFilter>;
  _min?: InputMaybe<NestedEnumCountryCodeFilter>;
  equals?: InputMaybe<CountryCode>;
  in?: InputMaybe<Array<CountryCode>>;
  not?: InputMaybe<NestedEnumCountryCodeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<CountryCode>>;
};

export type EnumCouplingTypeNullableFilter = {
  equals?: InputMaybe<CouplingType>;
  in?: InputMaybe<Array<CouplingType>>;
  not?: InputMaybe<NestedEnumCouplingTypeNullableFilter>;
  notIn?: InputMaybe<Array<CouplingType>>;
};

export type EnumCouplingTypeNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumCouplingTypeNullableFilter>;
  _min?: InputMaybe<NestedEnumCouplingTypeNullableFilter>;
  equals?: InputMaybe<CouplingType>;
  in?: InputMaybe<Array<CouplingType>>;
  not?: InputMaybe<NestedEnumCouplingTypeNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<CouplingType>>;
};

export type EnumDashboardStatsDisplayTypeEnumFieldUpdateOperationsInput = {
  set?: InputMaybe<DashboardStatsDisplayTypeEnum>;
};

export type EnumDashboardStatsDisplayTypeEnumFilter = {
  equals?: InputMaybe<DashboardStatsDisplayTypeEnum>;
  in?: InputMaybe<Array<DashboardStatsDisplayTypeEnum>>;
  not?: InputMaybe<NestedEnumDashboardStatsDisplayTypeEnumFilter>;
  notIn?: InputMaybe<Array<DashboardStatsDisplayTypeEnum>>;
};

export type EnumDashboardStatsDisplayTypeEnumWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumDashboardStatsDisplayTypeEnumFilter>;
  _min?: InputMaybe<NestedEnumDashboardStatsDisplayTypeEnumFilter>;
  equals?: InputMaybe<DashboardStatsDisplayTypeEnum>;
  in?: InputMaybe<Array<DashboardStatsDisplayTypeEnum>>;
  not?: InputMaybe<NestedEnumDashboardStatsDisplayTypeEnumWithAggregatesFilter>;
  notIn?: InputMaybe<Array<DashboardStatsDisplayTypeEnum>>;
};

export type EnumDayOfWeekFieldUpdateOperationsInput = {
  set?: InputMaybe<DayOfWeek>;
};

export type EnumDayOfWeekFilter = {
  equals?: InputMaybe<DayOfWeek>;
  in?: InputMaybe<Array<DayOfWeek>>;
  not?: InputMaybe<NestedEnumDayOfWeekFilter>;
  notIn?: InputMaybe<Array<DayOfWeek>>;
};

export type EnumDayOfWeekWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumDayOfWeekFilter>;
  _min?: InputMaybe<NestedEnumDayOfWeekFilter>;
  equals?: InputMaybe<DayOfWeek>;
  in?: InputMaybe<Array<DayOfWeek>>;
  not?: InputMaybe<NestedEnumDayOfWeekWithAggregatesFilter>;
  notIn?: InputMaybe<Array<DayOfWeek>>;
};

export type EnumDogBreedImgTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<DogBreedImgType>;
};

export type EnumDogBreedImgTypeFilter = {
  equals?: InputMaybe<DogBreedImgType>;
  in?: InputMaybe<Array<DogBreedImgType>>;
  not?: InputMaybe<NestedEnumDogBreedImgTypeFilter>;
  notIn?: InputMaybe<Array<DogBreedImgType>>;
};

export type EnumDogBreedImgTypeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumDogBreedImgTypeFilter>;
  _min?: InputMaybe<NestedEnumDogBreedImgTypeFilter>;
  equals?: InputMaybe<DogBreedImgType>;
  in?: InputMaybe<Array<DogBreedImgType>>;
  not?: InputMaybe<NestedEnumDogBreedImgTypeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<DogBreedImgType>>;
};

export type EnumDogBreederApplicationAccommodationFieldUpdateOperationsInput = {
  set?: InputMaybe<DogBreederApplicationAccommodation>;
};

export type EnumDogBreederApplicationAccommodationFilter = {
  equals?: InputMaybe<DogBreederApplicationAccommodation>;
  in?: InputMaybe<Array<DogBreederApplicationAccommodation>>;
  not?: InputMaybe<NestedEnumDogBreederApplicationAccommodationFilter>;
  notIn?: InputMaybe<Array<DogBreederApplicationAccommodation>>;
};

export type EnumDogBreederApplicationAccommodationWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumDogBreederApplicationAccommodationFilter>;
  _min?: InputMaybe<NestedEnumDogBreederApplicationAccommodationFilter>;
  equals?: InputMaybe<DogBreederApplicationAccommodation>;
  in?: InputMaybe<Array<DogBreederApplicationAccommodation>>;
  not?: InputMaybe<NestedEnumDogBreederApplicationAccommodationWithAggregatesFilter>;
  notIn?: InputMaybe<Array<DogBreederApplicationAccommodation>>;
};

export type EnumDogBreederApplicationExperienceNullableListFilter = {
  equals?: InputMaybe<Array<DogBreederApplicationExperience>>;
  has?: InputMaybe<DogBreederApplicationExperience>;
  hasEvery?: InputMaybe<Array<DogBreederApplicationExperience>>;
  hasSome?: InputMaybe<Array<DogBreederApplicationExperience>>;
  isEmpty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EnumDogBreederApplicationOtherAnimalNullableListFilter = {
  equals?: InputMaybe<Array<DogBreederApplicationOtherAnimal>>;
  has?: InputMaybe<DogBreederApplicationOtherAnimal>;
  hasEvery?: InputMaybe<Array<DogBreederApplicationOtherAnimal>>;
  hasSome?: InputMaybe<Array<DogBreederApplicationOtherAnimal>>;
  isEmpty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EnumDogBreederApplicationStatusFieldUpdateOperationsInput = {
  set?: InputMaybe<DogBreederApplicationStatus>;
};

export type EnumDogBreederApplicationStatusFilter = {
  equals?: InputMaybe<DogBreederApplicationStatus>;
  in?: InputMaybe<Array<DogBreederApplicationStatus>>;
  not?: InputMaybe<NestedEnumDogBreederApplicationStatusFilter>;
  notIn?: InputMaybe<Array<DogBreederApplicationStatus>>;
};

export type EnumDogBreederApplicationStatusWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumDogBreederApplicationStatusFilter>;
  _min?: InputMaybe<NestedEnumDogBreederApplicationStatusFilter>;
  equals?: InputMaybe<DogBreederApplicationStatus>;
  in?: InputMaybe<Array<DogBreederApplicationStatus>>;
  not?: InputMaybe<NestedEnumDogBreederApplicationStatusWithAggregatesFilter>;
  notIn?: InputMaybe<Array<DogBreederApplicationStatus>>;
};

export type EnumDogBreederApplicationTimeAloneFieldUpdateOperationsInput = {
  set?: InputMaybe<DogBreederApplicationTimeAlone>;
};

export type EnumDogBreederApplicationTimeAloneFilter = {
  equals?: InputMaybe<DogBreederApplicationTimeAlone>;
  in?: InputMaybe<Array<DogBreederApplicationTimeAlone>>;
  not?: InputMaybe<NestedEnumDogBreederApplicationTimeAloneFilter>;
  notIn?: InputMaybe<Array<DogBreederApplicationTimeAlone>>;
};

export type EnumDogBreederApplicationTimeAloneWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumDogBreederApplicationTimeAloneFilter>;
  _min?: InputMaybe<NestedEnumDogBreederApplicationTimeAloneFilter>;
  equals?: InputMaybe<DogBreederApplicationTimeAlone>;
  in?: InputMaybe<Array<DogBreederApplicationTimeAlone>>;
  not?: InputMaybe<NestedEnumDogBreederApplicationTimeAloneWithAggregatesFilter>;
  notIn?: InputMaybe<Array<DogBreederApplicationTimeAlone>>;
};

export type EnumDogBreederApplicationTrainerNullableListFilter = {
  equals?: InputMaybe<Array<DogBreederApplicationTrainer>>;
  has?: InputMaybe<DogBreederApplicationTrainer>;
  hasEvery?: InputMaybe<Array<DogBreederApplicationTrainer>>;
  hasSome?: InputMaybe<Array<DogBreederApplicationTrainer>>;
  isEmpty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EnumDogBreederContactTypeNullableFilter = {
  equals?: InputMaybe<DogBreederContactType>;
  in?: InputMaybe<Array<DogBreederContactType>>;
  not?: InputMaybe<NestedEnumDogBreederContactTypeNullableFilter>;
  notIn?: InputMaybe<Array<DogBreederContactType>>;
};

export type EnumDogBreederContactTypeNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumDogBreederContactTypeNullableFilter>;
  _min?: InputMaybe<NestedEnumDogBreederContactTypeNullableFilter>;
  equals?: InputMaybe<DogBreederContactType>;
  in?: InputMaybe<Array<DogBreederContactType>>;
  not?: InputMaybe<NestedEnumDogBreederContactTypeNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<DogBreederContactType>>;
};

export type EnumDogCoatNullableFilter = {
  equals?: InputMaybe<DogCoat>;
  in?: InputMaybe<Array<DogCoat>>;
  not?: InputMaybe<NestedEnumDogCoatNullableFilter>;
  notIn?: InputMaybe<Array<DogCoat>>;
};

export type EnumDogCoatNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumDogCoatNullableFilter>;
  _min?: InputMaybe<NestedEnumDogCoatNullableFilter>;
  equals?: InputMaybe<DogCoat>;
  in?: InputMaybe<Array<DogCoat>>;
  not?: InputMaybe<NestedEnumDogCoatNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<DogCoat>>;
};

export type EnumDogColorNullableFilter = {
  equals?: InputMaybe<DogColor>;
  in?: InputMaybe<Array<DogColor>>;
  not?: InputMaybe<NestedEnumDogColorNullableFilter>;
  notIn?: InputMaybe<Array<DogColor>>;
};

export type EnumDogColorNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumDogColorNullableFilter>;
  _min?: InputMaybe<NestedEnumDogColorNullableFilter>;
  equals?: InputMaybe<DogColor>;
  in?: InputMaybe<Array<DogColor>>;
  not?: InputMaybe<NestedEnumDogColorNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<DogColor>>;
};

export type EnumDogHairTypeNullableFilter = {
  equals?: InputMaybe<DogHairType>;
  in?: InputMaybe<Array<DogHairType>>;
  not?: InputMaybe<NestedEnumDogHairTypeNullableFilter>;
  notIn?: InputMaybe<Array<DogHairType>>;
};

export type EnumDogHairTypeNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumDogHairTypeNullableFilter>;
  _min?: InputMaybe<NestedEnumDogHairTypeNullableFilter>;
  equals?: InputMaybe<DogHairType>;
  in?: InputMaybe<Array<DogHairType>>;
  not?: InputMaybe<NestedEnumDogHairTypeNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<DogHairType>>;
};

export type EnumDogMedicalAffectionTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<DogMedicalAffectionType>;
};

export type EnumDogMedicalAffectionTypeFilter = {
  equals?: InputMaybe<DogMedicalAffectionType>;
  in?: InputMaybe<Array<DogMedicalAffectionType>>;
  not?: InputMaybe<NestedEnumDogMedicalAffectionTypeFilter>;
  notIn?: InputMaybe<Array<DogMedicalAffectionType>>;
};

export type EnumDogMedicalAffectionTypeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumDogMedicalAffectionTypeFilter>;
  _min?: InputMaybe<NestedEnumDogMedicalAffectionTypeFilter>;
  equals?: InputMaybe<DogMedicalAffectionType>;
  in?: InputMaybe<Array<DogMedicalAffectionType>>;
  not?: InputMaybe<NestedEnumDogMedicalAffectionTypeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<DogMedicalAffectionType>>;
};

export type EnumDogPhysicalConditionNullableFilter = {
  equals?: InputMaybe<DogPhysicalCondition>;
  in?: InputMaybe<Array<DogPhysicalCondition>>;
  not?: InputMaybe<NestedEnumDogPhysicalConditionNullableFilter>;
  notIn?: InputMaybe<Array<DogPhysicalCondition>>;
};

export type EnumDogPhysicalConditionNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumDogPhysicalConditionNullableFilter>;
  _min?: InputMaybe<NestedEnumDogPhysicalConditionNullableFilter>;
  equals?: InputMaybe<DogPhysicalCondition>;
  in?: InputMaybe<Array<DogPhysicalCondition>>;
  not?: InputMaybe<NestedEnumDogPhysicalConditionNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<DogPhysicalCondition>>;
};

export type EnumDogShelterTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<DogShelterType>;
};

export type EnumDogShelterTypeFilter = {
  equals?: InputMaybe<DogShelterType>;
  in?: InputMaybe<Array<DogShelterType>>;
  not?: InputMaybe<NestedEnumDogShelterTypeFilter>;
  notIn?: InputMaybe<Array<DogShelterType>>;
};

export type EnumDogShelterTypeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumDogShelterTypeFilter>;
  _min?: InputMaybe<NestedEnumDogShelterTypeFilter>;
  equals?: InputMaybe<DogShelterType>;
  in?: InputMaybe<Array<DogShelterType>>;
  not?: InputMaybe<NestedEnumDogShelterTypeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<DogShelterType>>;
};

export type EnumDogTypeNullableListFilter = {
  equals?: InputMaybe<Array<DogType>>;
  has?: InputMaybe<DogType>;
  hasEvery?: InputMaybe<Array<DogType>>;
  hasSome?: InputMaybe<Array<DogType>>;
  isEmpty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EnumEducatorPracticePlaceEnumNullableListFilter = {
  equals?: InputMaybe<Array<EducatorPracticePlaceEnum>>;
  has?: InputMaybe<EducatorPracticePlaceEnum>;
  hasEvery?: InputMaybe<Array<EducatorPracticePlaceEnum>>;
  hasSome?: InputMaybe<Array<EducatorPracticePlaceEnum>>;
  isEmpty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EnumEducatorTypeEnumNullableFilter = {
  equals?: InputMaybe<EducatorTypeEnum>;
  in?: InputMaybe<Array<EducatorTypeEnum>>;
  not?: InputMaybe<NestedEnumEducatorTypeEnumNullableFilter>;
  notIn?: InputMaybe<Array<EducatorTypeEnum>>;
};

export type EnumEducatorTypeEnumNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumEducatorTypeEnumNullableFilter>;
  _min?: InputMaybe<NestedEnumEducatorTypeEnumNullableFilter>;
  equals?: InputMaybe<EducatorTypeEnum>;
  in?: InputMaybe<Array<EducatorTypeEnum>>;
  not?: InputMaybe<NestedEnumEducatorTypeEnumNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<EducatorTypeEnum>>;
};

export type EnumEmailContactCreatedFromEnumFieldUpdateOperationsInput = {
  set?: InputMaybe<EmailContactCreatedFromEnum>;
};

export type EnumEmailContactCreatedFromEnumFilter = {
  equals?: InputMaybe<EmailContactCreatedFromEnum>;
  in?: InputMaybe<Array<EmailContactCreatedFromEnum>>;
  not?: InputMaybe<NestedEnumEmailContactCreatedFromEnumFilter>;
  notIn?: InputMaybe<Array<EmailContactCreatedFromEnum>>;
};

export type EnumEmailContactCreatedFromEnumWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumEmailContactCreatedFromEnumFilter>;
  _min?: InputMaybe<NestedEnumEmailContactCreatedFromEnumFilter>;
  equals?: InputMaybe<EmailContactCreatedFromEnum>;
  in?: InputMaybe<Array<EmailContactCreatedFromEnum>>;
  not?: InputMaybe<NestedEnumEmailContactCreatedFromEnumWithAggregatesFilter>;
  notIn?: InputMaybe<Array<EmailContactCreatedFromEnum>>;
};

export type EnumFrequencyTypeNullableFilter = {
  equals?: InputMaybe<FrequencyType>;
  in?: InputMaybe<Array<FrequencyType>>;
  not?: InputMaybe<NestedEnumFrequencyTypeNullableFilter>;
  notIn?: InputMaybe<Array<FrequencyType>>;
};

export type EnumFrequencyTypeNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumFrequencyTypeNullableFilter>;
  _min?: InputMaybe<NestedEnumFrequencyTypeNullableFilter>;
  equals?: InputMaybe<FrequencyType>;
  in?: InputMaybe<Array<FrequencyType>>;
  not?: InputMaybe<NestedEnumFrequencyTypeNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<FrequencyType>>;
};

export type EnumGenderEnumFieldUpdateOperationsInput = {
  set?: InputMaybe<GenderEnum>;
};

export type EnumGenderEnumFilter = {
  equals?: InputMaybe<GenderEnum>;
  in?: InputMaybe<Array<GenderEnum>>;
  not?: InputMaybe<NestedEnumGenderEnumFilter>;
  notIn?: InputMaybe<Array<GenderEnum>>;
};

export type EnumGenderEnumNullableFilter = {
  equals?: InputMaybe<GenderEnum>;
  in?: InputMaybe<Array<GenderEnum>>;
  not?: InputMaybe<NestedEnumGenderEnumNullableFilter>;
  notIn?: InputMaybe<Array<GenderEnum>>;
};

export type EnumGenderEnumNullableListFilter = {
  equals?: InputMaybe<Array<GenderEnum>>;
  has?: InputMaybe<GenderEnum>;
  hasEvery?: InputMaybe<Array<GenderEnum>>;
  hasSome?: InputMaybe<Array<GenderEnum>>;
  isEmpty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EnumGenderEnumNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumGenderEnumNullableFilter>;
  _min?: InputMaybe<NestedEnumGenderEnumNullableFilter>;
  equals?: InputMaybe<GenderEnum>;
  in?: InputMaybe<Array<GenderEnum>>;
  not?: InputMaybe<NestedEnumGenderEnumNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<GenderEnum>>;
};

export type EnumGenderEnumWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumGenderEnumFilter>;
  _min?: InputMaybe<NestedEnumGenderEnumFilter>;
  equals?: InputMaybe<GenderEnum>;
  in?: InputMaybe<Array<GenderEnum>>;
  not?: InputMaybe<NestedEnumGenderEnumWithAggregatesFilter>;
  notIn?: InputMaybe<Array<GenderEnum>>;
};

export type EnumHeadShapeNullableFilter = {
  equals?: InputMaybe<HeadShape>;
  in?: InputMaybe<Array<HeadShape>>;
  not?: InputMaybe<NestedEnumHeadShapeNullableFilter>;
  notIn?: InputMaybe<Array<HeadShape>>;
};

export type EnumHeadShapeNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumHeadShapeNullableFilter>;
  _min?: InputMaybe<NestedEnumHeadShapeNullableFilter>;
  equals?: InputMaybe<HeadShape>;
  in?: InputMaybe<Array<HeadShape>>;
  not?: InputMaybe<NestedEnumHeadShapeNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<HeadShape>>;
};

export type EnumLanguageCodeFieldUpdateOperationsInput = {
  set?: InputMaybe<LanguageCode>;
};

export type EnumLanguageCodeFilter = {
  equals?: InputMaybe<LanguageCode>;
  in?: InputMaybe<Array<LanguageCode>>;
  not?: InputMaybe<NestedEnumLanguageCodeFilter>;
  notIn?: InputMaybe<Array<LanguageCode>>;
};

export type EnumLanguageCodeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumLanguageCodeFilter>;
  _min?: InputMaybe<NestedEnumLanguageCodeFilter>;
  equals?: InputMaybe<LanguageCode>;
  in?: InputMaybe<Array<LanguageCode>>;
  not?: InputMaybe<NestedEnumLanguageCodeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<LanguageCode>>;
};

export type EnumLastVisitTypeNullableFilter = {
  equals?: InputMaybe<LastVisitType>;
  in?: InputMaybe<Array<LastVisitType>>;
  not?: InputMaybe<NestedEnumLastVisitTypeNullableFilter>;
  notIn?: InputMaybe<Array<LastVisitType>>;
};

export type EnumLastVisitTypeNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumLastVisitTypeNullableFilter>;
  _min?: InputMaybe<NestedEnumLastVisitTypeNullableFilter>;
  equals?: InputMaybe<LastVisitType>;
  in?: InputMaybe<Array<LastVisitType>>;
  not?: InputMaybe<NestedEnumLastVisitTypeNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<LastVisitType>>;
};

export type EnumNotificationTypeNullableFilter = {
  equals?: InputMaybe<NotificationType>;
  in?: InputMaybe<Array<NotificationType>>;
  not?: InputMaybe<NestedEnumNotificationTypeNullableFilter>;
  notIn?: InputMaybe<Array<NotificationType>>;
};

export type EnumNotificationTypeNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumNotificationTypeNullableFilter>;
  _min?: InputMaybe<NestedEnumNotificationTypeNullableFilter>;
  equals?: InputMaybe<NotificationType>;
  in?: InputMaybe<Array<NotificationType>>;
  not?: InputMaybe<NestedEnumNotificationTypeNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<NotificationType>>;
};

export type EnumParentTypeEnumFieldUpdateOperationsInput = {
  set?: InputMaybe<ParentTypeEnum>;
};

export type EnumParentTypeEnumFilter = {
  equals?: InputMaybe<ParentTypeEnum>;
  in?: InputMaybe<Array<ParentTypeEnum>>;
  not?: InputMaybe<NestedEnumParentTypeEnumFilter>;
  notIn?: InputMaybe<Array<ParentTypeEnum>>;
};

export type EnumParentTypeEnumWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumParentTypeEnumFilter>;
  _min?: InputMaybe<NestedEnumParentTypeEnumFilter>;
  equals?: InputMaybe<ParentTypeEnum>;
  in?: InputMaybe<Array<ParentTypeEnum>>;
  not?: InputMaybe<NestedEnumParentTypeEnumWithAggregatesFilter>;
  notIn?: InputMaybe<Array<ParentTypeEnum>>;
};

export type EnumPaymentStatusFieldUpdateOperationsInput = {
  set?: InputMaybe<PaymentStatus>;
};

export type EnumPaymentStatusFilter = {
  equals?: InputMaybe<PaymentStatus>;
  in?: InputMaybe<Array<PaymentStatus>>;
  not?: InputMaybe<NestedEnumPaymentStatusFilter>;
  notIn?: InputMaybe<Array<PaymentStatus>>;
};

export type EnumPaymentStatusWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumPaymentStatusFilter>;
  _min?: InputMaybe<NestedEnumPaymentStatusFilter>;
  equals?: InputMaybe<PaymentStatus>;
  in?: InputMaybe<Array<PaymentStatus>>;
  not?: InputMaybe<NestedEnumPaymentStatusWithAggregatesFilter>;
  notIn?: InputMaybe<Array<PaymentStatus>>;
};

export type EnumProfessionalTypeEnumFieldUpdateOperationsInput = {
  set?: InputMaybe<ProfessionalTypeEnum>;
};

export type EnumProfessionalTypeEnumFilter = {
  equals?: InputMaybe<ProfessionalTypeEnum>;
  in?: InputMaybe<Array<ProfessionalTypeEnum>>;
  not?: InputMaybe<NestedEnumProfessionalTypeEnumFilter>;
  notIn?: InputMaybe<Array<ProfessionalTypeEnum>>;
};

export type EnumProfessionalTypeEnumNullableFilter = {
  equals?: InputMaybe<ProfessionalTypeEnum>;
  in?: InputMaybe<Array<ProfessionalTypeEnum>>;
  not?: InputMaybe<NestedEnumProfessionalTypeEnumNullableFilter>;
  notIn?: InputMaybe<Array<ProfessionalTypeEnum>>;
};

export type EnumProfessionalTypeEnumNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumProfessionalTypeEnumNullableFilter>;
  _min?: InputMaybe<NestedEnumProfessionalTypeEnumNullableFilter>;
  equals?: InputMaybe<ProfessionalTypeEnum>;
  in?: InputMaybe<Array<ProfessionalTypeEnum>>;
  not?: InputMaybe<NestedEnumProfessionalTypeEnumNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<ProfessionalTypeEnum>>;
};

export type EnumProfessionalTypeEnumWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumProfessionalTypeEnumFilter>;
  _min?: InputMaybe<NestedEnumProfessionalTypeEnumFilter>;
  equals?: InputMaybe<ProfessionalTypeEnum>;
  in?: InputMaybe<Array<ProfessionalTypeEnum>>;
  not?: InputMaybe<NestedEnumProfessionalTypeEnumWithAggregatesFilter>;
  notIn?: InputMaybe<Array<ProfessionalTypeEnum>>;
};

export type EnumRoleFieldUpdateOperationsInput = {
  set?: InputMaybe<Role>;
};

export type EnumRoleFilter = {
  equals?: InputMaybe<Role>;
  in?: InputMaybe<Array<Role>>;
  not?: InputMaybe<NestedEnumRoleFilter>;
  notIn?: InputMaybe<Array<Role>>;
};

export type EnumRoleWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumRoleFilter>;
  _min?: InputMaybe<NestedEnumRoleFilter>;
  equals?: InputMaybe<Role>;
  in?: InputMaybe<Array<Role>>;
  not?: InputMaybe<NestedEnumRoleWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Role>>;
};

export type EnumTemperTypeNullableFilter = {
  equals?: InputMaybe<TemperType>;
  in?: InputMaybe<Array<TemperType>>;
  not?: InputMaybe<NestedEnumTemperTypeNullableFilter>;
  notIn?: InputMaybe<Array<TemperType>>;
};

export type EnumTemperTypeNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumTemperTypeNullableFilter>;
  _min?: InputMaybe<NestedEnumTemperTypeNullableFilter>;
  equals?: InputMaybe<TemperType>;
  in?: InputMaybe<Array<TemperType>>;
  not?: InputMaybe<NestedEnumTemperTypeNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<TemperType>>;
};

export type EnumUpdateTypeEnumFieldUpdateOperationsInput = {
  set?: InputMaybe<UpdateTypeEnum>;
};

export type EnumUpdateTypeEnumFilter = {
  equals?: InputMaybe<UpdateTypeEnum>;
  in?: InputMaybe<Array<UpdateTypeEnum>>;
  not?: InputMaybe<NestedEnumUpdateTypeEnumFilter>;
  notIn?: InputMaybe<Array<UpdateTypeEnum>>;
};

export type EnumUpdateTypeEnumWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumUpdateTypeEnumFilter>;
  _min?: InputMaybe<NestedEnumUpdateTypeEnumFilter>;
  equals?: InputMaybe<UpdateTypeEnum>;
  in?: InputMaybe<Array<UpdateTypeEnum>>;
  not?: InputMaybe<NestedEnumUpdateTypeEnumWithAggregatesFilter>;
  notIn?: InputMaybe<Array<UpdateTypeEnum>>;
};

export type EnumWorkerAvailabilityTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<WorkerAvailabilityType>;
};

export type EnumWorkerAvailabilityTypeFilter = {
  equals?: InputMaybe<WorkerAvailabilityType>;
  in?: InputMaybe<Array<WorkerAvailabilityType>>;
  not?: InputMaybe<NestedEnumWorkerAvailabilityTypeFilter>;
  notIn?: InputMaybe<Array<WorkerAvailabilityType>>;
};

export type EnumWorkerAvailabilityTypeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumWorkerAvailabilityTypeFilter>;
  _min?: InputMaybe<NestedEnumWorkerAvailabilityTypeFilter>;
  equals?: InputMaybe<WorkerAvailabilityType>;
  in?: InputMaybe<Array<WorkerAvailabilityType>>;
  not?: InputMaybe<NestedEnumWorkerAvailabilityTypeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<WorkerAvailabilityType>>;
};

export type EnumWorkerServicePriceTypeNullableFilter = {
  equals?: InputMaybe<WorkerServicePriceType>;
  in?: InputMaybe<Array<WorkerServicePriceType>>;
  not?: InputMaybe<NestedEnumWorkerServicePriceTypeNullableFilter>;
  notIn?: InputMaybe<Array<WorkerServicePriceType>>;
};

export type EnumWorkerServicePriceTypeNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumWorkerServicePriceTypeNullableFilter>;
  _min?: InputMaybe<NestedEnumWorkerServicePriceTypeNullableFilter>;
  equals?: InputMaybe<WorkerServicePriceType>;
  in?: InputMaybe<Array<WorkerServicePriceType>>;
  not?: InputMaybe<NestedEnumWorkerServicePriceTypeNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<WorkerServicePriceType>>;
};

export type EnumYesNoUnknownStatusFieldUpdateOperationsInput = {
  set?: InputMaybe<YesNoUnknownStatus>;
};

export type EnumYesNoUnknownStatusFilter = {
  equals?: InputMaybe<YesNoUnknownStatus>;
  in?: InputMaybe<Array<YesNoUnknownStatus>>;
  not?: InputMaybe<NestedEnumYesNoUnknownStatusFilter>;
  notIn?: InputMaybe<Array<YesNoUnknownStatus>>;
};

export type EnumYesNoUnknownStatusNullableFilter = {
  equals?: InputMaybe<YesNoUnknownStatus>;
  in?: InputMaybe<Array<YesNoUnknownStatus>>;
  not?: InputMaybe<NestedEnumYesNoUnknownStatusNullableFilter>;
  notIn?: InputMaybe<Array<YesNoUnknownStatus>>;
};

export type EnumYesNoUnknownStatusNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumYesNoUnknownStatusNullableFilter>;
  _min?: InputMaybe<NestedEnumYesNoUnknownStatusNullableFilter>;
  equals?: InputMaybe<YesNoUnknownStatus>;
  in?: InputMaybe<Array<YesNoUnknownStatus>>;
  not?: InputMaybe<NestedEnumYesNoUnknownStatusNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<YesNoUnknownStatus>>;
};

export type EnumYesNoUnknownStatusWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumYesNoUnknownStatusFilter>;
  _min?: InputMaybe<NestedEnumYesNoUnknownStatusFilter>;
  equals?: InputMaybe<YesNoUnknownStatus>;
  in?: InputMaybe<Array<YesNoUnknownStatus>>;
  not?: InputMaybe<NestedEnumYesNoUnknownStatusWithAggregatesFilter>;
  notIn?: InputMaybe<Array<YesNoUnknownStatus>>;
};

export type FloatNullableFilter = {
  equals?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<Scalars['Float']['input']>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  not?: InputMaybe<NestedFloatNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type FloatNullableWithAggregatesFilter = {
  _avg?: InputMaybe<NestedFloatNullableFilter>;
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedFloatNullableFilter>;
  _min?: InputMaybe<NestedFloatNullableFilter>;
  _sum?: InputMaybe<NestedFloatNullableFilter>;
  equals?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<Scalars['Float']['input']>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  not?: InputMaybe<NestedFloatNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export enum FrequencyType {
  RARELY = 'RARELY',
  REGULARLY = 'REGULARLY',
  SOMETIMES = 'SOMETIMES'
}

export enum GenderEnum {
  F = 'F',
  M = 'M',
  OTHER = 'OTHER'
}

export enum HeadShape {
  LONG = 'LONG',
  OVAL = 'OVAL',
  ROUND = 'ROUND',
  SQUARE = 'SQUARE',
  TRIANGLE = 'TRIANGLE'
}

export type IntFieldUpdateOperationsInput = {
  decrement?: InputMaybe<Scalars['Int']['input']>;
  divide?: InputMaybe<Scalars['Int']['input']>;
  increment?: InputMaybe<Scalars['Int']['input']>;
  multiply?: InputMaybe<Scalars['Int']['input']>;
  set?: InputMaybe<Scalars['Int']['input']>;
};

export type IntFilter = {
  equals?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<NestedIntFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type IntNullableFilter = {
  equals?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<NestedIntNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type IntNullableWithAggregatesFilter = {
  _avg?: InputMaybe<NestedFloatNullableFilter>;
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedIntNullableFilter>;
  _min?: InputMaybe<NestedIntNullableFilter>;
  _sum?: InputMaybe<NestedIntNullableFilter>;
  equals?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<NestedIntNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type IntWithAggregatesFilter = {
  _avg?: InputMaybe<NestedFloatFilter>;
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedIntFilter>;
  _min?: InputMaybe<NestedIntFilter>;
  _sum?: InputMaybe<NestedIntFilter>;
  equals?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<NestedIntWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type JsonFilter = {
  array_contains?: InputMaybe<Scalars['Json']['input']>;
  array_ends_with?: InputMaybe<Scalars['Json']['input']>;
  array_starts_with?: InputMaybe<Scalars['Json']['input']>;
  equals?: InputMaybe<Scalars['Json']['input']>;
  gt?: InputMaybe<Scalars['Json']['input']>;
  gte?: InputMaybe<Scalars['Json']['input']>;
  lt?: InputMaybe<Scalars['Json']['input']>;
  lte?: InputMaybe<Scalars['Json']['input']>;
  not?: InputMaybe<Scalars['Json']['input']>;
  path?: InputMaybe<Array<Scalars['String']['input']>>;
  string_contains?: InputMaybe<Scalars['String']['input']>;
  string_ends_with?: InputMaybe<Scalars['String']['input']>;
  string_starts_with?: InputMaybe<Scalars['String']['input']>;
};

export enum JsonNullValueFilter {
  AnyNull = 'AnyNull',
  DbNull = 'DbNull',
  JsonNull = 'JsonNull'
}

export enum JsonNullValueInput {
  JsonNull = 'JsonNull'
}

export type JsonWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedJsonFilter>;
  _min?: InputMaybe<NestedJsonFilter>;
  array_contains?: InputMaybe<Scalars['Json']['input']>;
  array_ends_with?: InputMaybe<Scalars['Json']['input']>;
  array_starts_with?: InputMaybe<Scalars['Json']['input']>;
  equals?: InputMaybe<Scalars['Json']['input']>;
  gt?: InputMaybe<Scalars['Json']['input']>;
  gte?: InputMaybe<Scalars['Json']['input']>;
  lt?: InputMaybe<Scalars['Json']['input']>;
  lte?: InputMaybe<Scalars['Json']['input']>;
  not?: InputMaybe<Scalars['Json']['input']>;
  path?: InputMaybe<Array<Scalars['String']['input']>>;
  string_contains?: InputMaybe<Scalars['String']['input']>;
  string_ends_with?: InputMaybe<Scalars['String']['input']>;
  string_starts_with?: InputMaybe<Scalars['String']['input']>;
};

export enum LanguageCode {
  CH_DE = 'CH_DE',
  CH_FR = 'CH_FR',
  DE_DE = 'DE_DE',
  EN_BE = 'EN_BE',
  EN_CA = 'EN_CA',
  EN_DE = 'EN_DE',
  EN_FR = 'EN_FR',
  EN_NL = 'EN_NL',
  FR_BE = 'FR_BE',
  FR_CA = 'FR_CA',
  FR_FR = 'FR_FR',
  NL_BE = 'NL_BE',
  NL_NL = 'NL_NL'
}

export enum LastVisitType {
  LESS_THAN_3_MONTHS = 'LESS_THAN_3_MONTHS',
  MORE_THAN_3_MONTHS = 'MORE_THAN_3_MONTHS'
}

export type LatLngPoint = {
  lat: Scalars['Float']['input'];
  lng: Scalars['Float']['input'];
};

export type Litter = {
  __typename?: 'Litter';
  _count: LitterCountOutputType;
  adminValidated?: Maybe<Scalars['Boolean']['output']>;
  adminValidationDate?: Maybe<Scalars['DateTime']['output']>;
  animalsBorn: Array<Animal>;
  archived?: Maybe<Scalars['Boolean']['output']>;
  availabilityDate?: Maybe<Scalars['DateTime']['output']>;
  availabilityReminderSent: Scalars['Boolean']['output'];
  birthday?: Maybe<Scalars['DateTime']['output']>;
  /** @TypeGraphQL.omit(output: true) */
  bookmarks: Array<Bookmark>;
  born: Scalars['Boolean']['output'];
  breeder: DogBreeder;
  breederId: Scalars['Int']['output'];
  certified?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  dewormed?: Maybe<Scalars['Boolean']['output']>;
  dogBreed?: Maybe<DogBreed>;
  dogBreedId?: Maybe<Scalars['Int']['output']>;
  femalesCount: Scalars['Int']['output'];
  femalesLeftCount?: Maybe<Scalars['Int']['output']>;
  fixedPrice?: Maybe<Scalars['Boolean']['output']>;
  hasFinishedOnboarding?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  imgs: Array<LitterImg>;
  litterCode?: Maybe<Scalars['String']['output']>;
  malesCount: Scalars['Int']['output'];
  malesLeftCount?: Maybe<Scalars['Int']['output']>;
  microchipped?: Maybe<Scalars['Boolean']['output']>;
  microchips: Array<Scalars['String']['output']>;
  parents: Array<LitterParent>;
  pedigree?: Maybe<Scalars['String']['output']>;
  pedigreeNumbers: Array<Scalars['String']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  priceFrom?: Maybe<Scalars['Float']['output']>;
  priceTo?: Maybe<Scalars['Float']['output']>;
  translations: Array<LitterTranslation>;
  updatedAt: Scalars['DateTime']['output'];
  vaccinated?: Maybe<Scalars['Boolean']['output']>;
  vaccinationDate?: Maybe<Scalars['DateTime']['output']>;
};


export type LitteranimalsBornArgs = {
  cursor?: InputMaybe<AnimalWhereUniqueInput>;
  distinct?: InputMaybe<AnimalScalarFieldEnum>;
  orderBy?: InputMaybe<AnimalOrderByWithRelationAndSearchRelevanceInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AnimalWhereInput>;
};


export type LitterbookmarksArgs = {
  cursor?: InputMaybe<BookmarkWhereUniqueInput>;
  distinct?: InputMaybe<BookmarkScalarFieldEnum>;
  orderBy?: InputMaybe<BookmarkOrderByWithRelationAndSearchRelevanceInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<BookmarkWhereInput>;
};


export type LitterimgsArgs = {
  cursor?: InputMaybe<LitterImgWhereUniqueInput>;
  distinct?: InputMaybe<LitterImgScalarFieldEnum>;
  orderBy?: InputMaybe<LitterImgOrderByWithRelationAndSearchRelevanceInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<LitterImgWhereInput>;
};


export type LitterparentsArgs = {
  cursor?: InputMaybe<LitterParentWhereUniqueInput>;
  distinct?: InputMaybe<LitterParentScalarFieldEnum>;
  orderBy?: InputMaybe<LitterParentOrderByWithRelationAndSearchRelevanceInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<LitterParentWhereInput>;
};


export type LittertranslationsArgs = {
  cursor?: InputMaybe<LitterTranslationWhereUniqueInput>;
  distinct?: InputMaybe<LitterTranslationScalarFieldEnum>;
  orderBy?: InputMaybe<LitterTranslationOrderByWithRelationAndSearchRelevanceInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<LitterTranslationWhereInput>;
};

export type LitterAvgAggregateOutputType = {
  __typename?: 'LitterAvgAggregateOutputType';
  breederId?: Maybe<Scalars['Float']['output']>;
  dogBreedId?: Maybe<Scalars['Float']['output']>;
  femalesCount?: Maybe<Scalars['Float']['output']>;
  femalesLeftCount?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  malesCount?: Maybe<Scalars['Float']['output']>;
  malesLeftCount?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  priceFrom?: Maybe<Scalars['Float']['output']>;
  priceTo?: Maybe<Scalars['Float']['output']>;
};

export type LitterAvgOrderByAggregateInput = {
  breederId?: InputMaybe<SortOrder>;
  dogBreedId?: InputMaybe<SortOrder>;
  femalesCount?: InputMaybe<SortOrder>;
  femalesLeftCount?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  malesCount?: InputMaybe<SortOrder>;
  malesLeftCount?: InputMaybe<SortOrder>;
  price?: InputMaybe<SortOrder>;
  priceFrom?: InputMaybe<SortOrder>;
  priceTo?: InputMaybe<SortOrder>;
};

export type LitterCountAggregateOutputType = {
  __typename?: 'LitterCountAggregateOutputType';
  _all: Scalars['Int']['output'];
  adminValidated: Scalars['Int']['output'];
  adminValidationDate: Scalars['Int']['output'];
  archived: Scalars['Int']['output'];
  availabilityDate: Scalars['Int']['output'];
  availabilityReminderSent: Scalars['Int']['output'];
  birthday: Scalars['Int']['output'];
  born: Scalars['Int']['output'];
  breederId: Scalars['Int']['output'];
  certified: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  description: Scalars['Int']['output'];
  dewormed: Scalars['Int']['output'];
  dogBreedId: Scalars['Int']['output'];
  femalesCount: Scalars['Int']['output'];
  femalesLeftCount: Scalars['Int']['output'];
  fixedPrice: Scalars['Int']['output'];
  hasFinishedOnboarding: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  litterCode: Scalars['Int']['output'];
  malesCount: Scalars['Int']['output'];
  malesLeftCount: Scalars['Int']['output'];
  microchipped: Scalars['Int']['output'];
  microchips: Scalars['Int']['output'];
  pedigree: Scalars['Int']['output'];
  pedigreeNumbers: Scalars['Int']['output'];
  price: Scalars['Int']['output'];
  priceFrom: Scalars['Int']['output'];
  priceTo: Scalars['Int']['output'];
  tags: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
  vaccinated: Scalars['Int']['output'];
  vaccinationDate: Scalars['Int']['output'];
};

export type LitterCountOrderByAggregateInput = {
  adminValidated?: InputMaybe<SortOrder>;
  adminValidationDate?: InputMaybe<SortOrder>;
  archived?: InputMaybe<SortOrder>;
  availabilityDate?: InputMaybe<SortOrder>;
  availabilityReminderSent?: InputMaybe<SortOrder>;
  birthday?: InputMaybe<SortOrder>;
  born?: InputMaybe<SortOrder>;
  breederId?: InputMaybe<SortOrder>;
  certified?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  dewormed?: InputMaybe<SortOrder>;
  dogBreedId?: InputMaybe<SortOrder>;
  femalesCount?: InputMaybe<SortOrder>;
  femalesLeftCount?: InputMaybe<SortOrder>;
  fixedPrice?: InputMaybe<SortOrder>;
  hasFinishedOnboarding?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  litterCode?: InputMaybe<SortOrder>;
  malesCount?: InputMaybe<SortOrder>;
  malesLeftCount?: InputMaybe<SortOrder>;
  microchipped?: InputMaybe<SortOrder>;
  microchips?: InputMaybe<SortOrder>;
  pedigree?: InputMaybe<SortOrder>;
  pedigreeNumbers?: InputMaybe<SortOrder>;
  price?: InputMaybe<SortOrder>;
  priceFrom?: InputMaybe<SortOrder>;
  priceTo?: InputMaybe<SortOrder>;
  tags?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  vaccinated?: InputMaybe<SortOrder>;
  vaccinationDate?: InputMaybe<SortOrder>;
};

export type LitterCountOutputType = {
  __typename?: 'LitterCountOutputType';
  adminNotes: Scalars['Int']['output'];
  animalsBorn: Scalars['Int']['output'];
  bookmarks: Scalars['Int']['output'];
  imgs: Scalars['Int']['output'];
  notifications: Scalars['Int']['output'];
  parents: Scalars['Int']['output'];
  translations: Scalars['Int']['output'];
  updates: Scalars['Int']['output'];
};

export type LitterCreateInput = {
  adminNotes?: InputMaybe<AdminNoteCreateNestedManyWithoutLitterInput>;
  adminValidated?: InputMaybe<Scalars['Boolean']['input']>;
  adminValidationDate?: InputMaybe<Scalars['DateTime']['input']>;
  animalsBorn?: InputMaybe<AnimalCreateNestedManyWithoutLitterInput>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  availabilityDate?: InputMaybe<Scalars['DateTime']['input']>;
  availabilityReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  birthday?: InputMaybe<Scalars['DateTime']['input']>;
  bookmarks?: InputMaybe<BookmarkCreateNestedManyWithoutLitterInput>;
  born?: InputMaybe<Scalars['Boolean']['input']>;
  breeder: DogBreederCreateNestedOneWithoutLittersInput;
  certified?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dewormed?: InputMaybe<Scalars['Boolean']['input']>;
  dogBreed?: InputMaybe<DogBreedCreateNestedOneWithoutLittersInput>;
  femalesCount?: InputMaybe<Scalars['Int']['input']>;
  femalesLeftCount?: InputMaybe<Scalars['Int']['input']>;
  fixedPrice?: InputMaybe<Scalars['Boolean']['input']>;
  hasFinishedOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  imgs?: InputMaybe<LitterImgCreateNestedManyWithoutLitterInput>;
  litterCode?: InputMaybe<Scalars['String']['input']>;
  malesCount?: InputMaybe<Scalars['Int']['input']>;
  malesLeftCount?: InputMaybe<Scalars['Int']['input']>;
  microchipped?: InputMaybe<Scalars['Boolean']['input']>;
  microchips?: InputMaybe<Array<Scalars['String']['input']>>;
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutLitterInput>;
  parents?: InputMaybe<LitterParentCreateNestedManyWithoutLitterInput>;
  pedigree?: InputMaybe<Scalars['String']['input']>;
  pedigreeNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  price?: InputMaybe<Scalars['Float']['input']>;
  priceFrom?: InputMaybe<Scalars['Float']['input']>;
  priceTo?: InputMaybe<Scalars['Float']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  translations?: InputMaybe<LitterTranslationCreateNestedManyWithoutLitterInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updates?: InputMaybe<UpdateCreateNestedManyWithoutLitterInput>;
  vaccinated?: InputMaybe<Scalars['Boolean']['input']>;
  vaccinationDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type LitterCreateManyBreederInput = {
  adminValidated?: InputMaybe<Scalars['Boolean']['input']>;
  adminValidationDate?: InputMaybe<Scalars['DateTime']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  availabilityDate?: InputMaybe<Scalars['DateTime']['input']>;
  availabilityReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  birthday?: InputMaybe<Scalars['DateTime']['input']>;
  born?: InputMaybe<Scalars['Boolean']['input']>;
  certified?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dewormed?: InputMaybe<Scalars['Boolean']['input']>;
  dogBreedId?: InputMaybe<Scalars['Int']['input']>;
  femalesCount?: InputMaybe<Scalars['Int']['input']>;
  femalesLeftCount?: InputMaybe<Scalars['Int']['input']>;
  fixedPrice?: InputMaybe<Scalars['Boolean']['input']>;
  hasFinishedOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  litterCode?: InputMaybe<Scalars['String']['input']>;
  malesCount?: InputMaybe<Scalars['Int']['input']>;
  malesLeftCount?: InputMaybe<Scalars['Int']['input']>;
  microchipped?: InputMaybe<Scalars['Boolean']['input']>;
  microchips?: InputMaybe<Array<Scalars['String']['input']>>;
  pedigree?: InputMaybe<Scalars['String']['input']>;
  pedigreeNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  price?: InputMaybe<Scalars['Float']['input']>;
  priceFrom?: InputMaybe<Scalars['Float']['input']>;
  priceTo?: InputMaybe<Scalars['Float']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  vaccinated?: InputMaybe<Scalars['Boolean']['input']>;
  vaccinationDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type LitterCreateManyBreederInputEnvelope = {
  data: Array<LitterCreateManyBreederInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LitterCreateManyDogBreedInput = {
  adminValidated?: InputMaybe<Scalars['Boolean']['input']>;
  adminValidationDate?: InputMaybe<Scalars['DateTime']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  availabilityDate?: InputMaybe<Scalars['DateTime']['input']>;
  availabilityReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  birthday?: InputMaybe<Scalars['DateTime']['input']>;
  born?: InputMaybe<Scalars['Boolean']['input']>;
  breederId: Scalars['Int']['input'];
  certified?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dewormed?: InputMaybe<Scalars['Boolean']['input']>;
  femalesCount?: InputMaybe<Scalars['Int']['input']>;
  femalesLeftCount?: InputMaybe<Scalars['Int']['input']>;
  fixedPrice?: InputMaybe<Scalars['Boolean']['input']>;
  hasFinishedOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  litterCode?: InputMaybe<Scalars['String']['input']>;
  malesCount?: InputMaybe<Scalars['Int']['input']>;
  malesLeftCount?: InputMaybe<Scalars['Int']['input']>;
  microchipped?: InputMaybe<Scalars['Boolean']['input']>;
  microchips?: InputMaybe<Array<Scalars['String']['input']>>;
  pedigree?: InputMaybe<Scalars['String']['input']>;
  pedigreeNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  price?: InputMaybe<Scalars['Float']['input']>;
  priceFrom?: InputMaybe<Scalars['Float']['input']>;
  priceTo?: InputMaybe<Scalars['Float']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  vaccinated?: InputMaybe<Scalars['Boolean']['input']>;
  vaccinationDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type LitterCreateManyDogBreedInputEnvelope = {
  data: Array<LitterCreateManyDogBreedInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LitterCreateManyInput = {
  adminValidated?: InputMaybe<Scalars['Boolean']['input']>;
  adminValidationDate?: InputMaybe<Scalars['DateTime']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  availabilityDate?: InputMaybe<Scalars['DateTime']['input']>;
  availabilityReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  birthday?: InputMaybe<Scalars['DateTime']['input']>;
  born?: InputMaybe<Scalars['Boolean']['input']>;
  breederId: Scalars['Int']['input'];
  certified?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dewormed?: InputMaybe<Scalars['Boolean']['input']>;
  dogBreedId?: InputMaybe<Scalars['Int']['input']>;
  femalesCount?: InputMaybe<Scalars['Int']['input']>;
  femalesLeftCount?: InputMaybe<Scalars['Int']['input']>;
  fixedPrice?: InputMaybe<Scalars['Boolean']['input']>;
  hasFinishedOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  litterCode?: InputMaybe<Scalars['String']['input']>;
  malesCount?: InputMaybe<Scalars['Int']['input']>;
  malesLeftCount?: InputMaybe<Scalars['Int']['input']>;
  microchipped?: InputMaybe<Scalars['Boolean']['input']>;
  microchips?: InputMaybe<Array<Scalars['String']['input']>>;
  pedigree?: InputMaybe<Scalars['String']['input']>;
  pedigreeNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  price?: InputMaybe<Scalars['Float']['input']>;
  priceFrom?: InputMaybe<Scalars['Float']['input']>;
  priceTo?: InputMaybe<Scalars['Float']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  vaccinated?: InputMaybe<Scalars['Boolean']['input']>;
  vaccinationDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type LitterCreateNestedManyWithoutBreederInput = {
  connect?: InputMaybe<Array<LitterWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LitterCreateOrConnectWithoutBreederInput>>;
  create?: InputMaybe<Array<LitterCreateWithoutBreederInput>>;
  createMany?: InputMaybe<LitterCreateManyBreederInputEnvelope>;
};

export type LitterCreateNestedManyWithoutDogBreedInput = {
  connect?: InputMaybe<Array<LitterWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LitterCreateOrConnectWithoutDogBreedInput>>;
  create?: InputMaybe<Array<LitterCreateWithoutDogBreedInput>>;
  createMany?: InputMaybe<LitterCreateManyDogBreedInputEnvelope>;
};

export type LitterCreateNestedOneWithoutAdminNotesInput = {
  connect?: InputMaybe<LitterWhereUniqueInput>;
  connectOrCreate?: InputMaybe<LitterCreateOrConnectWithoutAdminNotesInput>;
  create?: InputMaybe<LitterCreateWithoutAdminNotesInput>;
};

export type LitterCreateNestedOneWithoutAnimalsBornInput = {
  connect?: InputMaybe<LitterWhereUniqueInput>;
  connectOrCreate?: InputMaybe<LitterCreateOrConnectWithoutAnimalsBornInput>;
  create?: InputMaybe<LitterCreateWithoutAnimalsBornInput>;
};

export type LitterCreateNestedOneWithoutBookmarksInput = {
  connect?: InputMaybe<LitterWhereUniqueInput>;
  connectOrCreate?: InputMaybe<LitterCreateOrConnectWithoutBookmarksInput>;
  create?: InputMaybe<LitterCreateWithoutBookmarksInput>;
};

export type LitterCreateNestedOneWithoutImgsInput = {
  connect?: InputMaybe<LitterWhereUniqueInput>;
  connectOrCreate?: InputMaybe<LitterCreateOrConnectWithoutImgsInput>;
  create?: InputMaybe<LitterCreateWithoutImgsInput>;
};

export type LitterCreateNestedOneWithoutNotificationsInput = {
  connect?: InputMaybe<LitterWhereUniqueInput>;
  connectOrCreate?: InputMaybe<LitterCreateOrConnectWithoutNotificationsInput>;
  create?: InputMaybe<LitterCreateWithoutNotificationsInput>;
};

export type LitterCreateNestedOneWithoutParentsInput = {
  connect?: InputMaybe<LitterWhereUniqueInput>;
  connectOrCreate?: InputMaybe<LitterCreateOrConnectWithoutParentsInput>;
  create?: InputMaybe<LitterCreateWithoutParentsInput>;
};

export type LitterCreateNestedOneWithoutTranslationsInput = {
  connect?: InputMaybe<LitterWhereUniqueInput>;
  connectOrCreate?: InputMaybe<LitterCreateOrConnectWithoutTranslationsInput>;
  create?: InputMaybe<LitterCreateWithoutTranslationsInput>;
};

export type LitterCreateNestedOneWithoutUpdatesInput = {
  connect?: InputMaybe<LitterWhereUniqueInput>;
  connectOrCreate?: InputMaybe<LitterCreateOrConnectWithoutUpdatesInput>;
  create?: InputMaybe<LitterCreateWithoutUpdatesInput>;
};

export type LitterCreateOrConnectWithoutAdminNotesInput = {
  create: LitterCreateWithoutAdminNotesInput;
  where: LitterWhereUniqueInput;
};

export type LitterCreateOrConnectWithoutAnimalsBornInput = {
  create: LitterCreateWithoutAnimalsBornInput;
  where: LitterWhereUniqueInput;
};

export type LitterCreateOrConnectWithoutBookmarksInput = {
  create: LitterCreateWithoutBookmarksInput;
  where: LitterWhereUniqueInput;
};

export type LitterCreateOrConnectWithoutBreederInput = {
  create: LitterCreateWithoutBreederInput;
  where: LitterWhereUniqueInput;
};

export type LitterCreateOrConnectWithoutDogBreedInput = {
  create: LitterCreateWithoutDogBreedInput;
  where: LitterWhereUniqueInput;
};

export type LitterCreateOrConnectWithoutImgsInput = {
  create: LitterCreateWithoutImgsInput;
  where: LitterWhereUniqueInput;
};

export type LitterCreateOrConnectWithoutNotificationsInput = {
  create: LitterCreateWithoutNotificationsInput;
  where: LitterWhereUniqueInput;
};

export type LitterCreateOrConnectWithoutParentsInput = {
  create: LitterCreateWithoutParentsInput;
  where: LitterWhereUniqueInput;
};

export type LitterCreateOrConnectWithoutTranslationsInput = {
  create: LitterCreateWithoutTranslationsInput;
  where: LitterWhereUniqueInput;
};

export type LitterCreateOrConnectWithoutUpdatesInput = {
  create: LitterCreateWithoutUpdatesInput;
  where: LitterWhereUniqueInput;
};

export type LitterCreateWithoutAdminNotesInput = {
  adminValidated?: InputMaybe<Scalars['Boolean']['input']>;
  adminValidationDate?: InputMaybe<Scalars['DateTime']['input']>;
  animalsBorn?: InputMaybe<AnimalCreateNestedManyWithoutLitterInput>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  availabilityDate?: InputMaybe<Scalars['DateTime']['input']>;
  availabilityReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  birthday?: InputMaybe<Scalars['DateTime']['input']>;
  bookmarks?: InputMaybe<BookmarkCreateNestedManyWithoutLitterInput>;
  born?: InputMaybe<Scalars['Boolean']['input']>;
  breeder: DogBreederCreateNestedOneWithoutLittersInput;
  certified?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dewormed?: InputMaybe<Scalars['Boolean']['input']>;
  dogBreed?: InputMaybe<DogBreedCreateNestedOneWithoutLittersInput>;
  femalesCount?: InputMaybe<Scalars['Int']['input']>;
  femalesLeftCount?: InputMaybe<Scalars['Int']['input']>;
  fixedPrice?: InputMaybe<Scalars['Boolean']['input']>;
  hasFinishedOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  imgs?: InputMaybe<LitterImgCreateNestedManyWithoutLitterInput>;
  litterCode?: InputMaybe<Scalars['String']['input']>;
  malesCount?: InputMaybe<Scalars['Int']['input']>;
  malesLeftCount?: InputMaybe<Scalars['Int']['input']>;
  microchipped?: InputMaybe<Scalars['Boolean']['input']>;
  microchips?: InputMaybe<Array<Scalars['String']['input']>>;
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutLitterInput>;
  parents?: InputMaybe<LitterParentCreateNestedManyWithoutLitterInput>;
  pedigree?: InputMaybe<Scalars['String']['input']>;
  pedigreeNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  price?: InputMaybe<Scalars['Float']['input']>;
  priceFrom?: InputMaybe<Scalars['Float']['input']>;
  priceTo?: InputMaybe<Scalars['Float']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  translations?: InputMaybe<LitterTranslationCreateNestedManyWithoutLitterInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updates?: InputMaybe<UpdateCreateNestedManyWithoutLitterInput>;
  vaccinated?: InputMaybe<Scalars['Boolean']['input']>;
  vaccinationDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type LitterCreateWithoutAnimalsBornInput = {
  adminNotes?: InputMaybe<AdminNoteCreateNestedManyWithoutLitterInput>;
  adminValidated?: InputMaybe<Scalars['Boolean']['input']>;
  adminValidationDate?: InputMaybe<Scalars['DateTime']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  availabilityDate?: InputMaybe<Scalars['DateTime']['input']>;
  availabilityReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  birthday?: InputMaybe<Scalars['DateTime']['input']>;
  bookmarks?: InputMaybe<BookmarkCreateNestedManyWithoutLitterInput>;
  born?: InputMaybe<Scalars['Boolean']['input']>;
  breeder: DogBreederCreateNestedOneWithoutLittersInput;
  certified?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dewormed?: InputMaybe<Scalars['Boolean']['input']>;
  dogBreed?: InputMaybe<DogBreedCreateNestedOneWithoutLittersInput>;
  femalesCount?: InputMaybe<Scalars['Int']['input']>;
  femalesLeftCount?: InputMaybe<Scalars['Int']['input']>;
  fixedPrice?: InputMaybe<Scalars['Boolean']['input']>;
  hasFinishedOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  imgs?: InputMaybe<LitterImgCreateNestedManyWithoutLitterInput>;
  litterCode?: InputMaybe<Scalars['String']['input']>;
  malesCount?: InputMaybe<Scalars['Int']['input']>;
  malesLeftCount?: InputMaybe<Scalars['Int']['input']>;
  microchipped?: InputMaybe<Scalars['Boolean']['input']>;
  microchips?: InputMaybe<Array<Scalars['String']['input']>>;
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutLitterInput>;
  parents?: InputMaybe<LitterParentCreateNestedManyWithoutLitterInput>;
  pedigree?: InputMaybe<Scalars['String']['input']>;
  pedigreeNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  price?: InputMaybe<Scalars['Float']['input']>;
  priceFrom?: InputMaybe<Scalars['Float']['input']>;
  priceTo?: InputMaybe<Scalars['Float']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  translations?: InputMaybe<LitterTranslationCreateNestedManyWithoutLitterInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updates?: InputMaybe<UpdateCreateNestedManyWithoutLitterInput>;
  vaccinated?: InputMaybe<Scalars['Boolean']['input']>;
  vaccinationDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type LitterCreateWithoutBookmarksInput = {
  adminNotes?: InputMaybe<AdminNoteCreateNestedManyWithoutLitterInput>;
  adminValidated?: InputMaybe<Scalars['Boolean']['input']>;
  adminValidationDate?: InputMaybe<Scalars['DateTime']['input']>;
  animalsBorn?: InputMaybe<AnimalCreateNestedManyWithoutLitterInput>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  availabilityDate?: InputMaybe<Scalars['DateTime']['input']>;
  availabilityReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  birthday?: InputMaybe<Scalars['DateTime']['input']>;
  born?: InputMaybe<Scalars['Boolean']['input']>;
  breeder: DogBreederCreateNestedOneWithoutLittersInput;
  certified?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dewormed?: InputMaybe<Scalars['Boolean']['input']>;
  dogBreed?: InputMaybe<DogBreedCreateNestedOneWithoutLittersInput>;
  femalesCount?: InputMaybe<Scalars['Int']['input']>;
  femalesLeftCount?: InputMaybe<Scalars['Int']['input']>;
  fixedPrice?: InputMaybe<Scalars['Boolean']['input']>;
  hasFinishedOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  imgs?: InputMaybe<LitterImgCreateNestedManyWithoutLitterInput>;
  litterCode?: InputMaybe<Scalars['String']['input']>;
  malesCount?: InputMaybe<Scalars['Int']['input']>;
  malesLeftCount?: InputMaybe<Scalars['Int']['input']>;
  microchipped?: InputMaybe<Scalars['Boolean']['input']>;
  microchips?: InputMaybe<Array<Scalars['String']['input']>>;
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutLitterInput>;
  parents?: InputMaybe<LitterParentCreateNestedManyWithoutLitterInput>;
  pedigree?: InputMaybe<Scalars['String']['input']>;
  pedigreeNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  price?: InputMaybe<Scalars['Float']['input']>;
  priceFrom?: InputMaybe<Scalars['Float']['input']>;
  priceTo?: InputMaybe<Scalars['Float']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  translations?: InputMaybe<LitterTranslationCreateNestedManyWithoutLitterInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updates?: InputMaybe<UpdateCreateNestedManyWithoutLitterInput>;
  vaccinated?: InputMaybe<Scalars['Boolean']['input']>;
  vaccinationDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type LitterCreateWithoutBreederInput = {
  adminNotes?: InputMaybe<AdminNoteCreateNestedManyWithoutLitterInput>;
  adminValidated?: InputMaybe<Scalars['Boolean']['input']>;
  adminValidationDate?: InputMaybe<Scalars['DateTime']['input']>;
  animalsBorn?: InputMaybe<AnimalCreateNestedManyWithoutLitterInput>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  availabilityDate?: InputMaybe<Scalars['DateTime']['input']>;
  availabilityReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  birthday?: InputMaybe<Scalars['DateTime']['input']>;
  bookmarks?: InputMaybe<BookmarkCreateNestedManyWithoutLitterInput>;
  born?: InputMaybe<Scalars['Boolean']['input']>;
  certified?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dewormed?: InputMaybe<Scalars['Boolean']['input']>;
  dogBreed?: InputMaybe<DogBreedCreateNestedOneWithoutLittersInput>;
  femalesCount?: InputMaybe<Scalars['Int']['input']>;
  femalesLeftCount?: InputMaybe<Scalars['Int']['input']>;
  fixedPrice?: InputMaybe<Scalars['Boolean']['input']>;
  hasFinishedOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  imgs?: InputMaybe<LitterImgCreateNestedManyWithoutLitterInput>;
  litterCode?: InputMaybe<Scalars['String']['input']>;
  malesCount?: InputMaybe<Scalars['Int']['input']>;
  malesLeftCount?: InputMaybe<Scalars['Int']['input']>;
  microchipped?: InputMaybe<Scalars['Boolean']['input']>;
  microchips?: InputMaybe<Array<Scalars['String']['input']>>;
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutLitterInput>;
  parents?: InputMaybe<LitterParentCreateNestedManyWithoutLitterInput>;
  pedigree?: InputMaybe<Scalars['String']['input']>;
  pedigreeNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  price?: InputMaybe<Scalars['Float']['input']>;
  priceFrom?: InputMaybe<Scalars['Float']['input']>;
  priceTo?: InputMaybe<Scalars['Float']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  translations?: InputMaybe<LitterTranslationCreateNestedManyWithoutLitterInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updates?: InputMaybe<UpdateCreateNestedManyWithoutLitterInput>;
  vaccinated?: InputMaybe<Scalars['Boolean']['input']>;
  vaccinationDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type LitterCreateWithoutDogBreedInput = {
  adminNotes?: InputMaybe<AdminNoteCreateNestedManyWithoutLitterInput>;
  adminValidated?: InputMaybe<Scalars['Boolean']['input']>;
  adminValidationDate?: InputMaybe<Scalars['DateTime']['input']>;
  animalsBorn?: InputMaybe<AnimalCreateNestedManyWithoutLitterInput>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  availabilityDate?: InputMaybe<Scalars['DateTime']['input']>;
  availabilityReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  birthday?: InputMaybe<Scalars['DateTime']['input']>;
  bookmarks?: InputMaybe<BookmarkCreateNestedManyWithoutLitterInput>;
  born?: InputMaybe<Scalars['Boolean']['input']>;
  breeder: DogBreederCreateNestedOneWithoutLittersInput;
  certified?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dewormed?: InputMaybe<Scalars['Boolean']['input']>;
  femalesCount?: InputMaybe<Scalars['Int']['input']>;
  femalesLeftCount?: InputMaybe<Scalars['Int']['input']>;
  fixedPrice?: InputMaybe<Scalars['Boolean']['input']>;
  hasFinishedOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  imgs?: InputMaybe<LitterImgCreateNestedManyWithoutLitterInput>;
  litterCode?: InputMaybe<Scalars['String']['input']>;
  malesCount?: InputMaybe<Scalars['Int']['input']>;
  malesLeftCount?: InputMaybe<Scalars['Int']['input']>;
  microchipped?: InputMaybe<Scalars['Boolean']['input']>;
  microchips?: InputMaybe<Array<Scalars['String']['input']>>;
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutLitterInput>;
  parents?: InputMaybe<LitterParentCreateNestedManyWithoutLitterInput>;
  pedigree?: InputMaybe<Scalars['String']['input']>;
  pedigreeNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  price?: InputMaybe<Scalars['Float']['input']>;
  priceFrom?: InputMaybe<Scalars['Float']['input']>;
  priceTo?: InputMaybe<Scalars['Float']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  translations?: InputMaybe<LitterTranslationCreateNestedManyWithoutLitterInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updates?: InputMaybe<UpdateCreateNestedManyWithoutLitterInput>;
  vaccinated?: InputMaybe<Scalars['Boolean']['input']>;
  vaccinationDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type LitterCreateWithoutImgsInput = {
  adminNotes?: InputMaybe<AdminNoteCreateNestedManyWithoutLitterInput>;
  adminValidated?: InputMaybe<Scalars['Boolean']['input']>;
  adminValidationDate?: InputMaybe<Scalars['DateTime']['input']>;
  animalsBorn?: InputMaybe<AnimalCreateNestedManyWithoutLitterInput>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  availabilityDate?: InputMaybe<Scalars['DateTime']['input']>;
  availabilityReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  birthday?: InputMaybe<Scalars['DateTime']['input']>;
  bookmarks?: InputMaybe<BookmarkCreateNestedManyWithoutLitterInput>;
  born?: InputMaybe<Scalars['Boolean']['input']>;
  breeder: DogBreederCreateNestedOneWithoutLittersInput;
  certified?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dewormed?: InputMaybe<Scalars['Boolean']['input']>;
  dogBreed?: InputMaybe<DogBreedCreateNestedOneWithoutLittersInput>;
  femalesCount?: InputMaybe<Scalars['Int']['input']>;
  femalesLeftCount?: InputMaybe<Scalars['Int']['input']>;
  fixedPrice?: InputMaybe<Scalars['Boolean']['input']>;
  hasFinishedOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  litterCode?: InputMaybe<Scalars['String']['input']>;
  malesCount?: InputMaybe<Scalars['Int']['input']>;
  malesLeftCount?: InputMaybe<Scalars['Int']['input']>;
  microchipped?: InputMaybe<Scalars['Boolean']['input']>;
  microchips?: InputMaybe<Array<Scalars['String']['input']>>;
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutLitterInput>;
  parents?: InputMaybe<LitterParentCreateNestedManyWithoutLitterInput>;
  pedigree?: InputMaybe<Scalars['String']['input']>;
  pedigreeNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  price?: InputMaybe<Scalars['Float']['input']>;
  priceFrom?: InputMaybe<Scalars['Float']['input']>;
  priceTo?: InputMaybe<Scalars['Float']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  translations?: InputMaybe<LitterTranslationCreateNestedManyWithoutLitterInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updates?: InputMaybe<UpdateCreateNestedManyWithoutLitterInput>;
  vaccinated?: InputMaybe<Scalars['Boolean']['input']>;
  vaccinationDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type LitterCreateWithoutNotificationsInput = {
  adminNotes?: InputMaybe<AdminNoteCreateNestedManyWithoutLitterInput>;
  adminValidated?: InputMaybe<Scalars['Boolean']['input']>;
  adminValidationDate?: InputMaybe<Scalars['DateTime']['input']>;
  animalsBorn?: InputMaybe<AnimalCreateNestedManyWithoutLitterInput>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  availabilityDate?: InputMaybe<Scalars['DateTime']['input']>;
  availabilityReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  birthday?: InputMaybe<Scalars['DateTime']['input']>;
  bookmarks?: InputMaybe<BookmarkCreateNestedManyWithoutLitterInput>;
  born?: InputMaybe<Scalars['Boolean']['input']>;
  breeder: DogBreederCreateNestedOneWithoutLittersInput;
  certified?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dewormed?: InputMaybe<Scalars['Boolean']['input']>;
  dogBreed?: InputMaybe<DogBreedCreateNestedOneWithoutLittersInput>;
  femalesCount?: InputMaybe<Scalars['Int']['input']>;
  femalesLeftCount?: InputMaybe<Scalars['Int']['input']>;
  fixedPrice?: InputMaybe<Scalars['Boolean']['input']>;
  hasFinishedOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  imgs?: InputMaybe<LitterImgCreateNestedManyWithoutLitterInput>;
  litterCode?: InputMaybe<Scalars['String']['input']>;
  malesCount?: InputMaybe<Scalars['Int']['input']>;
  malesLeftCount?: InputMaybe<Scalars['Int']['input']>;
  microchipped?: InputMaybe<Scalars['Boolean']['input']>;
  microchips?: InputMaybe<Array<Scalars['String']['input']>>;
  parents?: InputMaybe<LitterParentCreateNestedManyWithoutLitterInput>;
  pedigree?: InputMaybe<Scalars['String']['input']>;
  pedigreeNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  price?: InputMaybe<Scalars['Float']['input']>;
  priceFrom?: InputMaybe<Scalars['Float']['input']>;
  priceTo?: InputMaybe<Scalars['Float']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  translations?: InputMaybe<LitterTranslationCreateNestedManyWithoutLitterInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updates?: InputMaybe<UpdateCreateNestedManyWithoutLitterInput>;
  vaccinated?: InputMaybe<Scalars['Boolean']['input']>;
  vaccinationDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type LitterCreateWithoutParentsInput = {
  adminNotes?: InputMaybe<AdminNoteCreateNestedManyWithoutLitterInput>;
  adminValidated?: InputMaybe<Scalars['Boolean']['input']>;
  adminValidationDate?: InputMaybe<Scalars['DateTime']['input']>;
  animalsBorn?: InputMaybe<AnimalCreateNestedManyWithoutLitterInput>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  availabilityDate?: InputMaybe<Scalars['DateTime']['input']>;
  availabilityReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  birthday?: InputMaybe<Scalars['DateTime']['input']>;
  bookmarks?: InputMaybe<BookmarkCreateNestedManyWithoutLitterInput>;
  born?: InputMaybe<Scalars['Boolean']['input']>;
  breeder: DogBreederCreateNestedOneWithoutLittersInput;
  certified?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dewormed?: InputMaybe<Scalars['Boolean']['input']>;
  dogBreed?: InputMaybe<DogBreedCreateNestedOneWithoutLittersInput>;
  femalesCount?: InputMaybe<Scalars['Int']['input']>;
  femalesLeftCount?: InputMaybe<Scalars['Int']['input']>;
  fixedPrice?: InputMaybe<Scalars['Boolean']['input']>;
  hasFinishedOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  imgs?: InputMaybe<LitterImgCreateNestedManyWithoutLitterInput>;
  litterCode?: InputMaybe<Scalars['String']['input']>;
  malesCount?: InputMaybe<Scalars['Int']['input']>;
  malesLeftCount?: InputMaybe<Scalars['Int']['input']>;
  microchipped?: InputMaybe<Scalars['Boolean']['input']>;
  microchips?: InputMaybe<Array<Scalars['String']['input']>>;
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutLitterInput>;
  pedigree?: InputMaybe<Scalars['String']['input']>;
  pedigreeNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  price?: InputMaybe<Scalars['Float']['input']>;
  priceFrom?: InputMaybe<Scalars['Float']['input']>;
  priceTo?: InputMaybe<Scalars['Float']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  translations?: InputMaybe<LitterTranslationCreateNestedManyWithoutLitterInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updates?: InputMaybe<UpdateCreateNestedManyWithoutLitterInput>;
  vaccinated?: InputMaybe<Scalars['Boolean']['input']>;
  vaccinationDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type LitterCreateWithoutTranslationsInput = {
  adminNotes?: InputMaybe<AdminNoteCreateNestedManyWithoutLitterInput>;
  adminValidated?: InputMaybe<Scalars['Boolean']['input']>;
  adminValidationDate?: InputMaybe<Scalars['DateTime']['input']>;
  animalsBorn?: InputMaybe<AnimalCreateNestedManyWithoutLitterInput>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  availabilityDate?: InputMaybe<Scalars['DateTime']['input']>;
  availabilityReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  birthday?: InputMaybe<Scalars['DateTime']['input']>;
  bookmarks?: InputMaybe<BookmarkCreateNestedManyWithoutLitterInput>;
  born?: InputMaybe<Scalars['Boolean']['input']>;
  breeder: DogBreederCreateNestedOneWithoutLittersInput;
  certified?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dewormed?: InputMaybe<Scalars['Boolean']['input']>;
  dogBreed?: InputMaybe<DogBreedCreateNestedOneWithoutLittersInput>;
  femalesCount?: InputMaybe<Scalars['Int']['input']>;
  femalesLeftCount?: InputMaybe<Scalars['Int']['input']>;
  fixedPrice?: InputMaybe<Scalars['Boolean']['input']>;
  hasFinishedOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  imgs?: InputMaybe<LitterImgCreateNestedManyWithoutLitterInput>;
  litterCode?: InputMaybe<Scalars['String']['input']>;
  malesCount?: InputMaybe<Scalars['Int']['input']>;
  malesLeftCount?: InputMaybe<Scalars['Int']['input']>;
  microchipped?: InputMaybe<Scalars['Boolean']['input']>;
  microchips?: InputMaybe<Array<Scalars['String']['input']>>;
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutLitterInput>;
  parents?: InputMaybe<LitterParentCreateNestedManyWithoutLitterInput>;
  pedigree?: InputMaybe<Scalars['String']['input']>;
  pedigreeNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  price?: InputMaybe<Scalars['Float']['input']>;
  priceFrom?: InputMaybe<Scalars['Float']['input']>;
  priceTo?: InputMaybe<Scalars['Float']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updates?: InputMaybe<UpdateCreateNestedManyWithoutLitterInput>;
  vaccinated?: InputMaybe<Scalars['Boolean']['input']>;
  vaccinationDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type LitterCreateWithoutUpdatesInput = {
  adminNotes?: InputMaybe<AdminNoteCreateNestedManyWithoutLitterInput>;
  adminValidated?: InputMaybe<Scalars['Boolean']['input']>;
  adminValidationDate?: InputMaybe<Scalars['DateTime']['input']>;
  animalsBorn?: InputMaybe<AnimalCreateNestedManyWithoutLitterInput>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  availabilityDate?: InputMaybe<Scalars['DateTime']['input']>;
  availabilityReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  birthday?: InputMaybe<Scalars['DateTime']['input']>;
  bookmarks?: InputMaybe<BookmarkCreateNestedManyWithoutLitterInput>;
  born?: InputMaybe<Scalars['Boolean']['input']>;
  breeder: DogBreederCreateNestedOneWithoutLittersInput;
  certified?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dewormed?: InputMaybe<Scalars['Boolean']['input']>;
  dogBreed?: InputMaybe<DogBreedCreateNestedOneWithoutLittersInput>;
  femalesCount?: InputMaybe<Scalars['Int']['input']>;
  femalesLeftCount?: InputMaybe<Scalars['Int']['input']>;
  fixedPrice?: InputMaybe<Scalars['Boolean']['input']>;
  hasFinishedOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  imgs?: InputMaybe<LitterImgCreateNestedManyWithoutLitterInput>;
  litterCode?: InputMaybe<Scalars['String']['input']>;
  malesCount?: InputMaybe<Scalars['Int']['input']>;
  malesLeftCount?: InputMaybe<Scalars['Int']['input']>;
  microchipped?: InputMaybe<Scalars['Boolean']['input']>;
  microchips?: InputMaybe<Array<Scalars['String']['input']>>;
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutLitterInput>;
  parents?: InputMaybe<LitterParentCreateNestedManyWithoutLitterInput>;
  pedigree?: InputMaybe<Scalars['String']['input']>;
  pedigreeNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  price?: InputMaybe<Scalars['Float']['input']>;
  priceFrom?: InputMaybe<Scalars['Float']['input']>;
  priceTo?: InputMaybe<Scalars['Float']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  translations?: InputMaybe<LitterTranslationCreateNestedManyWithoutLitterInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  vaccinated?: InputMaybe<Scalars['Boolean']['input']>;
  vaccinationDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type LitterCreatemicrochipsInput = {
  set: Array<Scalars['String']['input']>;
};

export type LitterCreatepedigreeNumbersInput = {
  set: Array<Scalars['String']['input']>;
};

export type LitterCreatetagsInput = {
  set: Array<Scalars['String']['input']>;
};

export type LitterImg = {
  __typename?: 'LitterImg';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  large?: Maybe<Scalars['String']['output']>;
  litter: Litter;
  litterId: Scalars['Int']['output'];
  medium?: Maybe<Scalars['String']['output']>;
  small?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type LitterImgAvgAggregateOutputType = {
  __typename?: 'LitterImgAvgAggregateOutputType';
  id?: Maybe<Scalars['Float']['output']>;
  litterId?: Maybe<Scalars['Float']['output']>;
};

export type LitterImgAvgOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
  litterId?: InputMaybe<SortOrder>;
};

export type LitterImgCountAggregateOutputType = {
  __typename?: 'LitterImgCountAggregateOutputType';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  large: Scalars['Int']['output'];
  litterId: Scalars['Int']['output'];
  medium: Scalars['Int']['output'];
  small: Scalars['Int']['output'];
  type: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type LitterImgCountOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  large?: InputMaybe<SortOrder>;
  litterId?: InputMaybe<SortOrder>;
  medium?: InputMaybe<SortOrder>;
  small?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type LitterImgCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  large?: InputMaybe<Scalars['String']['input']>;
  litter: LitterCreateNestedOneWithoutImgsInput;
  medium?: InputMaybe<Scalars['String']['input']>;
  small?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type LitterImgCreateManyInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  large?: InputMaybe<Scalars['String']['input']>;
  litterId: Scalars['Int']['input'];
  medium?: InputMaybe<Scalars['String']['input']>;
  small?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type LitterImgCreateManyLitterInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  large?: InputMaybe<Scalars['String']['input']>;
  medium?: InputMaybe<Scalars['String']['input']>;
  small?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type LitterImgCreateManyLitterInputEnvelope = {
  data: Array<LitterImgCreateManyLitterInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LitterImgCreateNestedManyWithoutLitterInput = {
  connect?: InputMaybe<Array<LitterImgWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LitterImgCreateOrConnectWithoutLitterInput>>;
  create?: InputMaybe<Array<LitterImgCreateWithoutLitterInput>>;
  createMany?: InputMaybe<LitterImgCreateManyLitterInputEnvelope>;
};

export type LitterImgCreateOrConnectWithoutLitterInput = {
  create: LitterImgCreateWithoutLitterInput;
  where: LitterImgWhereUniqueInput;
};

export type LitterImgCreateWithoutLitterInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  large?: InputMaybe<Scalars['String']['input']>;
  medium?: InputMaybe<Scalars['String']['input']>;
  small?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type LitterImgListRelationFilter = {
  every?: InputMaybe<LitterImgWhereInput>;
  none?: InputMaybe<LitterImgWhereInput>;
  some?: InputMaybe<LitterImgWhereInput>;
};

export type LitterImgMaxAggregateOutputType = {
  __typename?: 'LitterImgMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  large?: Maybe<Scalars['String']['output']>;
  litterId?: Maybe<Scalars['Int']['output']>;
  medium?: Maybe<Scalars['String']['output']>;
  small?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type LitterImgMaxOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  large?: InputMaybe<SortOrder>;
  litterId?: InputMaybe<SortOrder>;
  medium?: InputMaybe<SortOrder>;
  small?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type LitterImgMinAggregateOutputType = {
  __typename?: 'LitterImgMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  large?: Maybe<Scalars['String']['output']>;
  litterId?: Maybe<Scalars['Int']['output']>;
  medium?: Maybe<Scalars['String']['output']>;
  small?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type LitterImgMinOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  large?: InputMaybe<SortOrder>;
  litterId?: InputMaybe<SortOrder>;
  medium?: InputMaybe<SortOrder>;
  small?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type LitterImgOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export enum LitterImgOrderByRelevanceFieldEnum {
  large = 'large',
  medium = 'medium',
  small = 'small',
  type = 'type'
}

export type LitterImgOrderByRelevanceInput = {
  fields: Array<LitterImgOrderByRelevanceFieldEnum>;
  search: Scalars['String']['input'];
  sort: SortOrder;
};

export type LitterImgOrderByWithAggregationInput = {
  _avg?: InputMaybe<LitterImgAvgOrderByAggregateInput>;
  _count?: InputMaybe<LitterImgCountOrderByAggregateInput>;
  _max?: InputMaybe<LitterImgMaxOrderByAggregateInput>;
  _min?: InputMaybe<LitterImgMinOrderByAggregateInput>;
  _sum?: InputMaybe<LitterImgSumOrderByAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  large?: InputMaybe<SortOrderInput>;
  litterId?: InputMaybe<SortOrder>;
  medium?: InputMaybe<SortOrderInput>;
  small?: InputMaybe<SortOrderInput>;
  type?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type LitterImgOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: InputMaybe<LitterImgOrderByRelevanceInput>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  large?: InputMaybe<SortOrderInput>;
  litter?: InputMaybe<LitterOrderByWithRelationAndSearchRelevanceInput>;
  litterId?: InputMaybe<SortOrder>;
  medium?: InputMaybe<SortOrderInput>;
  small?: InputMaybe<SortOrderInput>;
  type?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum LitterImgScalarFieldEnum {
  createdAt = 'createdAt',
  id = 'id',
  large = 'large',
  litterId = 'litterId',
  medium = 'medium',
  small = 'small',
  type = 'type',
  updatedAt = 'updatedAt'
}

export type LitterImgScalarWhereInput = {
  AND?: InputMaybe<Array<LitterImgScalarWhereInput>>;
  NOT?: InputMaybe<Array<LitterImgScalarWhereInput>>;
  OR?: InputMaybe<Array<LitterImgScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntFilter>;
  large?: InputMaybe<StringNullableFilter>;
  litterId?: InputMaybe<IntFilter>;
  medium?: InputMaybe<StringNullableFilter>;
  small?: InputMaybe<StringNullableFilter>;
  type?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type LitterImgScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<LitterImgScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<LitterImgScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<LitterImgScalarWhereWithAggregatesInput>>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  large?: InputMaybe<StringNullableWithAggregatesFilter>;
  litterId?: InputMaybe<IntWithAggregatesFilter>;
  medium?: InputMaybe<StringNullableWithAggregatesFilter>;
  small?: InputMaybe<StringNullableWithAggregatesFilter>;
  type?: InputMaybe<StringNullableWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type LitterImgSumAggregateOutputType = {
  __typename?: 'LitterImgSumAggregateOutputType';
  id?: Maybe<Scalars['Int']['output']>;
  litterId?: Maybe<Scalars['Int']['output']>;
};

export type LitterImgSumOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
  litterId?: InputMaybe<SortOrder>;
};

export type LitterImgUncheckedCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  large?: InputMaybe<Scalars['String']['input']>;
  litterId: Scalars['Int']['input'];
  medium?: InputMaybe<Scalars['String']['input']>;
  small?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type LitterImgUncheckedCreateNestedManyWithoutLitterInput = {
  connect?: InputMaybe<Array<LitterImgWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LitterImgCreateOrConnectWithoutLitterInput>>;
  create?: InputMaybe<Array<LitterImgCreateWithoutLitterInput>>;
  createMany?: InputMaybe<LitterImgCreateManyLitterInputEnvelope>;
};

export type LitterImgUncheckedCreateWithoutLitterInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  large?: InputMaybe<Scalars['String']['input']>;
  medium?: InputMaybe<Scalars['String']['input']>;
  small?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type LitterImgUncheckedUpdateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  large?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  litterId?: InputMaybe<IntFieldUpdateOperationsInput>;
  medium?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  small?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type LitterImgUncheckedUpdateManyInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  large?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  litterId?: InputMaybe<IntFieldUpdateOperationsInput>;
  medium?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  small?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type LitterImgUncheckedUpdateManyWithoutLitterInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  large?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  medium?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  small?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type LitterImgUncheckedUpdateManyWithoutLitterNestedInput = {
  connect?: InputMaybe<Array<LitterImgWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LitterImgCreateOrConnectWithoutLitterInput>>;
  create?: InputMaybe<Array<LitterImgCreateWithoutLitterInput>>;
  createMany?: InputMaybe<LitterImgCreateManyLitterInputEnvelope>;
  delete?: InputMaybe<Array<LitterImgWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<LitterImgScalarWhereInput>>;
  disconnect?: InputMaybe<Array<LitterImgWhereUniqueInput>>;
  set?: InputMaybe<Array<LitterImgWhereUniqueInput>>;
  update?: InputMaybe<Array<LitterImgUpdateWithWhereUniqueWithoutLitterInput>>;
  updateMany?: InputMaybe<Array<LitterImgUpdateManyWithWhereWithoutLitterInput>>;
  upsert?: InputMaybe<Array<LitterImgUpsertWithWhereUniqueWithoutLitterInput>>;
};

export type LitterImgUncheckedUpdateWithoutLitterInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  large?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  medium?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  small?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type LitterImgUpdateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  large?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  litter?: InputMaybe<LitterUpdateOneRequiredWithoutImgsNestedInput>;
  medium?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  small?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type LitterImgUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  large?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  medium?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  small?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type LitterImgUpdateManyWithWhereWithoutLitterInput = {
  data: LitterImgUpdateManyMutationInput;
  where: LitterImgScalarWhereInput;
};

export type LitterImgUpdateManyWithoutLitterNestedInput = {
  connect?: InputMaybe<Array<LitterImgWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LitterImgCreateOrConnectWithoutLitterInput>>;
  create?: InputMaybe<Array<LitterImgCreateWithoutLitterInput>>;
  createMany?: InputMaybe<LitterImgCreateManyLitterInputEnvelope>;
  delete?: InputMaybe<Array<LitterImgWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<LitterImgScalarWhereInput>>;
  disconnect?: InputMaybe<Array<LitterImgWhereUniqueInput>>;
  set?: InputMaybe<Array<LitterImgWhereUniqueInput>>;
  update?: InputMaybe<Array<LitterImgUpdateWithWhereUniqueWithoutLitterInput>>;
  updateMany?: InputMaybe<Array<LitterImgUpdateManyWithWhereWithoutLitterInput>>;
  upsert?: InputMaybe<Array<LitterImgUpsertWithWhereUniqueWithoutLitterInput>>;
};

export type LitterImgUpdateWithWhereUniqueWithoutLitterInput = {
  data: LitterImgUpdateWithoutLitterInput;
  where: LitterImgWhereUniqueInput;
};

export type LitterImgUpdateWithoutLitterInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  large?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  medium?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  small?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type LitterImgUpsertWithWhereUniqueWithoutLitterInput = {
  create: LitterImgCreateWithoutLitterInput;
  update: LitterImgUpdateWithoutLitterInput;
  where: LitterImgWhereUniqueInput;
};

export type LitterImgWhereInput = {
  AND?: InputMaybe<Array<LitterImgWhereInput>>;
  NOT?: InputMaybe<Array<LitterImgWhereInput>>;
  OR?: InputMaybe<Array<LitterImgWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntFilter>;
  large?: InputMaybe<StringNullableFilter>;
  litter?: InputMaybe<LitterRelationFilter>;
  litterId?: InputMaybe<IntFilter>;
  medium?: InputMaybe<StringNullableFilter>;
  small?: InputMaybe<StringNullableFilter>;
  type?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type LitterImgWhereUniqueInput = {
  AND?: InputMaybe<Array<LitterImgWhereInput>>;
  NOT?: InputMaybe<Array<LitterImgWhereInput>>;
  OR?: InputMaybe<Array<LitterImgWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  large?: InputMaybe<StringNullableFilter>;
  litter?: InputMaybe<LitterRelationFilter>;
  litterId?: InputMaybe<IntFilter>;
  medium?: InputMaybe<StringNullableFilter>;
  small?: InputMaybe<StringNullableFilter>;
  type?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type LitterListRelationFilter = {
  every?: InputMaybe<LitterWhereInput>;
  none?: InputMaybe<LitterWhereInput>;
  some?: InputMaybe<LitterWhereInput>;
};

export type LitterMaxAggregateOutputType = {
  __typename?: 'LitterMaxAggregateOutputType';
  adminValidated?: Maybe<Scalars['Boolean']['output']>;
  adminValidationDate?: Maybe<Scalars['DateTime']['output']>;
  archived?: Maybe<Scalars['Boolean']['output']>;
  availabilityDate?: Maybe<Scalars['DateTime']['output']>;
  availabilityReminderSent?: Maybe<Scalars['Boolean']['output']>;
  birthday?: Maybe<Scalars['DateTime']['output']>;
  born?: Maybe<Scalars['Boolean']['output']>;
  breederId?: Maybe<Scalars['Int']['output']>;
  certified?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dewormed?: Maybe<Scalars['Boolean']['output']>;
  dogBreedId?: Maybe<Scalars['Int']['output']>;
  femalesCount?: Maybe<Scalars['Int']['output']>;
  femalesLeftCount?: Maybe<Scalars['Int']['output']>;
  fixedPrice?: Maybe<Scalars['Boolean']['output']>;
  hasFinishedOnboarding?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  litterCode?: Maybe<Scalars['String']['output']>;
  malesCount?: Maybe<Scalars['Int']['output']>;
  malesLeftCount?: Maybe<Scalars['Int']['output']>;
  microchipped?: Maybe<Scalars['Boolean']['output']>;
  pedigree?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  priceFrom?: Maybe<Scalars['Float']['output']>;
  priceTo?: Maybe<Scalars['Float']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  vaccinated?: Maybe<Scalars['Boolean']['output']>;
  vaccinationDate?: Maybe<Scalars['DateTime']['output']>;
};

export type LitterMaxOrderByAggregateInput = {
  adminValidated?: InputMaybe<SortOrder>;
  adminValidationDate?: InputMaybe<SortOrder>;
  archived?: InputMaybe<SortOrder>;
  availabilityDate?: InputMaybe<SortOrder>;
  availabilityReminderSent?: InputMaybe<SortOrder>;
  birthday?: InputMaybe<SortOrder>;
  born?: InputMaybe<SortOrder>;
  breederId?: InputMaybe<SortOrder>;
  certified?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  dewormed?: InputMaybe<SortOrder>;
  dogBreedId?: InputMaybe<SortOrder>;
  femalesCount?: InputMaybe<SortOrder>;
  femalesLeftCount?: InputMaybe<SortOrder>;
  fixedPrice?: InputMaybe<SortOrder>;
  hasFinishedOnboarding?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  litterCode?: InputMaybe<SortOrder>;
  malesCount?: InputMaybe<SortOrder>;
  malesLeftCount?: InputMaybe<SortOrder>;
  microchipped?: InputMaybe<SortOrder>;
  pedigree?: InputMaybe<SortOrder>;
  price?: InputMaybe<SortOrder>;
  priceFrom?: InputMaybe<SortOrder>;
  priceTo?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  vaccinated?: InputMaybe<SortOrder>;
  vaccinationDate?: InputMaybe<SortOrder>;
};

export type LitterMinAggregateOutputType = {
  __typename?: 'LitterMinAggregateOutputType';
  adminValidated?: Maybe<Scalars['Boolean']['output']>;
  adminValidationDate?: Maybe<Scalars['DateTime']['output']>;
  archived?: Maybe<Scalars['Boolean']['output']>;
  availabilityDate?: Maybe<Scalars['DateTime']['output']>;
  availabilityReminderSent?: Maybe<Scalars['Boolean']['output']>;
  birthday?: Maybe<Scalars['DateTime']['output']>;
  born?: Maybe<Scalars['Boolean']['output']>;
  breederId?: Maybe<Scalars['Int']['output']>;
  certified?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dewormed?: Maybe<Scalars['Boolean']['output']>;
  dogBreedId?: Maybe<Scalars['Int']['output']>;
  femalesCount?: Maybe<Scalars['Int']['output']>;
  femalesLeftCount?: Maybe<Scalars['Int']['output']>;
  fixedPrice?: Maybe<Scalars['Boolean']['output']>;
  hasFinishedOnboarding?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  litterCode?: Maybe<Scalars['String']['output']>;
  malesCount?: Maybe<Scalars['Int']['output']>;
  malesLeftCount?: Maybe<Scalars['Int']['output']>;
  microchipped?: Maybe<Scalars['Boolean']['output']>;
  pedigree?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  priceFrom?: Maybe<Scalars['Float']['output']>;
  priceTo?: Maybe<Scalars['Float']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  vaccinated?: Maybe<Scalars['Boolean']['output']>;
  vaccinationDate?: Maybe<Scalars['DateTime']['output']>;
};

export type LitterMinOrderByAggregateInput = {
  adminValidated?: InputMaybe<SortOrder>;
  adminValidationDate?: InputMaybe<SortOrder>;
  archived?: InputMaybe<SortOrder>;
  availabilityDate?: InputMaybe<SortOrder>;
  availabilityReminderSent?: InputMaybe<SortOrder>;
  birthday?: InputMaybe<SortOrder>;
  born?: InputMaybe<SortOrder>;
  breederId?: InputMaybe<SortOrder>;
  certified?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  dewormed?: InputMaybe<SortOrder>;
  dogBreedId?: InputMaybe<SortOrder>;
  femalesCount?: InputMaybe<SortOrder>;
  femalesLeftCount?: InputMaybe<SortOrder>;
  fixedPrice?: InputMaybe<SortOrder>;
  hasFinishedOnboarding?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  litterCode?: InputMaybe<SortOrder>;
  malesCount?: InputMaybe<SortOrder>;
  malesLeftCount?: InputMaybe<SortOrder>;
  microchipped?: InputMaybe<SortOrder>;
  pedigree?: InputMaybe<SortOrder>;
  price?: InputMaybe<SortOrder>;
  priceFrom?: InputMaybe<SortOrder>;
  priceTo?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  vaccinated?: InputMaybe<SortOrder>;
  vaccinationDate?: InputMaybe<SortOrder>;
};

export type LitterNullableRelationFilter = {
  is?: InputMaybe<LitterWhereInput>;
  isNot?: InputMaybe<LitterWhereInput>;
};

export type LitterOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export enum LitterOrderByRelevanceFieldEnum {
  description = 'description',
  litterCode = 'litterCode',
  microchips = 'microchips',
  pedigree = 'pedigree',
  pedigreeNumbers = 'pedigreeNumbers',
  tags = 'tags'
}

export type LitterOrderByRelevanceInput = {
  fields: Array<LitterOrderByRelevanceFieldEnum>;
  search: Scalars['String']['input'];
  sort: SortOrder;
};

export type LitterOrderByWithAggregationInput = {
  _avg?: InputMaybe<LitterAvgOrderByAggregateInput>;
  _count?: InputMaybe<LitterCountOrderByAggregateInput>;
  _max?: InputMaybe<LitterMaxOrderByAggregateInput>;
  _min?: InputMaybe<LitterMinOrderByAggregateInput>;
  _sum?: InputMaybe<LitterSumOrderByAggregateInput>;
  adminValidated?: InputMaybe<SortOrderInput>;
  adminValidationDate?: InputMaybe<SortOrderInput>;
  archived?: InputMaybe<SortOrderInput>;
  availabilityDate?: InputMaybe<SortOrderInput>;
  availabilityReminderSent?: InputMaybe<SortOrder>;
  birthday?: InputMaybe<SortOrderInput>;
  born?: InputMaybe<SortOrder>;
  breederId?: InputMaybe<SortOrder>;
  certified?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrderInput>;
  dewormed?: InputMaybe<SortOrderInput>;
  dogBreedId?: InputMaybe<SortOrderInput>;
  femalesCount?: InputMaybe<SortOrder>;
  femalesLeftCount?: InputMaybe<SortOrderInput>;
  fixedPrice?: InputMaybe<SortOrderInput>;
  hasFinishedOnboarding?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  litterCode?: InputMaybe<SortOrderInput>;
  malesCount?: InputMaybe<SortOrder>;
  malesLeftCount?: InputMaybe<SortOrderInput>;
  microchipped?: InputMaybe<SortOrderInput>;
  microchips?: InputMaybe<SortOrder>;
  pedigree?: InputMaybe<SortOrderInput>;
  pedigreeNumbers?: InputMaybe<SortOrder>;
  price?: InputMaybe<SortOrderInput>;
  priceFrom?: InputMaybe<SortOrderInput>;
  priceTo?: InputMaybe<SortOrderInput>;
  tags?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  vaccinated?: InputMaybe<SortOrderInput>;
  vaccinationDate?: InputMaybe<SortOrderInput>;
};

export type LitterOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: InputMaybe<LitterOrderByRelevanceInput>;
  adminNotes?: InputMaybe<AdminNoteOrderByRelationAggregateInput>;
  adminValidated?: InputMaybe<SortOrderInput>;
  adminValidationDate?: InputMaybe<SortOrderInput>;
  animalsBorn?: InputMaybe<AnimalOrderByRelationAggregateInput>;
  archived?: InputMaybe<SortOrderInput>;
  availabilityDate?: InputMaybe<SortOrderInput>;
  availabilityReminderSent?: InputMaybe<SortOrder>;
  birthday?: InputMaybe<SortOrderInput>;
  bookmarks?: InputMaybe<BookmarkOrderByRelationAggregateInput>;
  born?: InputMaybe<SortOrder>;
  breeder?: InputMaybe<DogBreederOrderByWithRelationAndSearchRelevanceInput>;
  breederId?: InputMaybe<SortOrder>;
  certified?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrderInput>;
  dewormed?: InputMaybe<SortOrderInput>;
  dogBreed?: InputMaybe<DogBreedOrderByWithRelationAndSearchRelevanceInput>;
  dogBreedId?: InputMaybe<SortOrderInput>;
  femalesCount?: InputMaybe<SortOrder>;
  femalesLeftCount?: InputMaybe<SortOrderInput>;
  fixedPrice?: InputMaybe<SortOrderInput>;
  hasFinishedOnboarding?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  imgs?: InputMaybe<LitterImgOrderByRelationAggregateInput>;
  litterCode?: InputMaybe<SortOrderInput>;
  malesCount?: InputMaybe<SortOrder>;
  malesLeftCount?: InputMaybe<SortOrderInput>;
  microchipped?: InputMaybe<SortOrderInput>;
  microchips?: InputMaybe<SortOrder>;
  notifications?: InputMaybe<NotificationOrderByRelationAggregateInput>;
  parents?: InputMaybe<LitterParentOrderByRelationAggregateInput>;
  pedigree?: InputMaybe<SortOrderInput>;
  pedigreeNumbers?: InputMaybe<SortOrder>;
  price?: InputMaybe<SortOrderInput>;
  priceFrom?: InputMaybe<SortOrderInput>;
  priceTo?: InputMaybe<SortOrderInput>;
  tags?: InputMaybe<SortOrder>;
  translations?: InputMaybe<LitterTranslationOrderByRelationAggregateInput>;
  updatedAt?: InputMaybe<SortOrder>;
  updates?: InputMaybe<UpdateOrderByRelationAggregateInput>;
  vaccinated?: InputMaybe<SortOrderInput>;
  vaccinationDate?: InputMaybe<SortOrderInput>;
};

export type LitterParent = {
  __typename?: 'LitterParent';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  img?: Maybe<Scalars['String']['output']>;
  litter: Litter;
  litterId: Scalars['Int']['output'];
  microshipNumber?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  parent?: Maybe<Animal>;
  parentId?: Maybe<Scalars['Int']['output']>;
  parentType: ParentTypeEnum;
  pedigreeNumber?: Maybe<Scalars['String']['output']>;
  pedigreeType?: Maybe<Scalars['String']['output']>;
  testsResults?: Maybe<Scalars['String']['output']>;
  titles?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type LitterParentAvgAggregateOutputType = {
  __typename?: 'LitterParentAvgAggregateOutputType';
  id?: Maybe<Scalars['Float']['output']>;
  litterId?: Maybe<Scalars['Float']['output']>;
  parentId?: Maybe<Scalars['Float']['output']>;
};

export type LitterParentAvgOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
  litterId?: InputMaybe<SortOrder>;
  parentId?: InputMaybe<SortOrder>;
};

export type LitterParentCountAggregateOutputType = {
  __typename?: 'LitterParentCountAggregateOutputType';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  img: Scalars['Int']['output'];
  litterId: Scalars['Int']['output'];
  microshipNumber: Scalars['Int']['output'];
  name: Scalars['Int']['output'];
  parentId: Scalars['Int']['output'];
  parentType: Scalars['Int']['output'];
  pedigreeNumber: Scalars['Int']['output'];
  pedigreeType: Scalars['Int']['output'];
  testsResults: Scalars['Int']['output'];
  titles: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type LitterParentCountOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  img?: InputMaybe<SortOrder>;
  litterId?: InputMaybe<SortOrder>;
  microshipNumber?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  parentId?: InputMaybe<SortOrder>;
  parentType?: InputMaybe<SortOrder>;
  pedigreeNumber?: InputMaybe<SortOrder>;
  pedigreeType?: InputMaybe<SortOrder>;
  testsResults?: InputMaybe<SortOrder>;
  titles?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type LitterParentCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  img?: InputMaybe<Scalars['String']['input']>;
  litter: LitterCreateNestedOneWithoutParentsInput;
  microshipNumber?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parent?: InputMaybe<AnimalCreateNestedOneWithoutBirthedLittersInput>;
  parentType: ParentTypeEnum;
  pedigreeNumber?: InputMaybe<Scalars['String']['input']>;
  pedigreeType?: InputMaybe<Scalars['String']['input']>;
  testsResults?: InputMaybe<Scalars['String']['input']>;
  titles?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type LitterParentCreateManyInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  img?: InputMaybe<Scalars['String']['input']>;
  litterId: Scalars['Int']['input'];
  microshipNumber?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['Int']['input']>;
  parentType: ParentTypeEnum;
  pedigreeNumber?: InputMaybe<Scalars['String']['input']>;
  pedigreeType?: InputMaybe<Scalars['String']['input']>;
  testsResults?: InputMaybe<Scalars['String']['input']>;
  titles?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type LitterParentCreateManyLitterInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  img?: InputMaybe<Scalars['String']['input']>;
  microshipNumber?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['Int']['input']>;
  parentType: ParentTypeEnum;
  pedigreeNumber?: InputMaybe<Scalars['String']['input']>;
  pedigreeType?: InputMaybe<Scalars['String']['input']>;
  testsResults?: InputMaybe<Scalars['String']['input']>;
  titles?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type LitterParentCreateManyLitterInputEnvelope = {
  data: Array<LitterParentCreateManyLitterInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LitterParentCreateManyParentInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  img?: InputMaybe<Scalars['String']['input']>;
  litterId: Scalars['Int']['input'];
  microshipNumber?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parentType: ParentTypeEnum;
  pedigreeNumber?: InputMaybe<Scalars['String']['input']>;
  pedigreeType?: InputMaybe<Scalars['String']['input']>;
  testsResults?: InputMaybe<Scalars['String']['input']>;
  titles?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type LitterParentCreateManyParentInputEnvelope = {
  data: Array<LitterParentCreateManyParentInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LitterParentCreateNestedManyWithoutLitterInput = {
  connect?: InputMaybe<Array<LitterParentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LitterParentCreateOrConnectWithoutLitterInput>>;
  create?: InputMaybe<Array<LitterParentCreateWithoutLitterInput>>;
  createMany?: InputMaybe<LitterParentCreateManyLitterInputEnvelope>;
};

export type LitterParentCreateNestedManyWithoutParentInput = {
  connect?: InputMaybe<Array<LitterParentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LitterParentCreateOrConnectWithoutParentInput>>;
  create?: InputMaybe<Array<LitterParentCreateWithoutParentInput>>;
  createMany?: InputMaybe<LitterParentCreateManyParentInputEnvelope>;
};

export type LitterParentCreateOrConnectWithoutLitterInput = {
  create: LitterParentCreateWithoutLitterInput;
  where: LitterParentWhereUniqueInput;
};

export type LitterParentCreateOrConnectWithoutParentInput = {
  create: LitterParentCreateWithoutParentInput;
  where: LitterParentWhereUniqueInput;
};

export type LitterParentCreateWithoutLitterInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  img?: InputMaybe<Scalars['String']['input']>;
  microshipNumber?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parent?: InputMaybe<AnimalCreateNestedOneWithoutBirthedLittersInput>;
  parentType: ParentTypeEnum;
  pedigreeNumber?: InputMaybe<Scalars['String']['input']>;
  pedigreeType?: InputMaybe<Scalars['String']['input']>;
  testsResults?: InputMaybe<Scalars['String']['input']>;
  titles?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type LitterParentCreateWithoutParentInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  img?: InputMaybe<Scalars['String']['input']>;
  litter: LitterCreateNestedOneWithoutParentsInput;
  microshipNumber?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parentType: ParentTypeEnum;
  pedigreeNumber?: InputMaybe<Scalars['String']['input']>;
  pedigreeType?: InputMaybe<Scalars['String']['input']>;
  testsResults?: InputMaybe<Scalars['String']['input']>;
  titles?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type LitterParentListRelationFilter = {
  every?: InputMaybe<LitterParentWhereInput>;
  none?: InputMaybe<LitterParentWhereInput>;
  some?: InputMaybe<LitterParentWhereInput>;
};

export type LitterParentMaxAggregateOutputType = {
  __typename?: 'LitterParentMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  img?: Maybe<Scalars['String']['output']>;
  litterId?: Maybe<Scalars['Int']['output']>;
  microshipNumber?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  parentId?: Maybe<Scalars['Int']['output']>;
  parentType?: Maybe<ParentTypeEnum>;
  pedigreeNumber?: Maybe<Scalars['String']['output']>;
  pedigreeType?: Maybe<Scalars['String']['output']>;
  testsResults?: Maybe<Scalars['String']['output']>;
  titles?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type LitterParentMaxOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  img?: InputMaybe<SortOrder>;
  litterId?: InputMaybe<SortOrder>;
  microshipNumber?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  parentId?: InputMaybe<SortOrder>;
  parentType?: InputMaybe<SortOrder>;
  pedigreeNumber?: InputMaybe<SortOrder>;
  pedigreeType?: InputMaybe<SortOrder>;
  testsResults?: InputMaybe<SortOrder>;
  titles?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type LitterParentMinAggregateOutputType = {
  __typename?: 'LitterParentMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  img?: Maybe<Scalars['String']['output']>;
  litterId?: Maybe<Scalars['Int']['output']>;
  microshipNumber?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  parentId?: Maybe<Scalars['Int']['output']>;
  parentType?: Maybe<ParentTypeEnum>;
  pedigreeNumber?: Maybe<Scalars['String']['output']>;
  pedigreeType?: Maybe<Scalars['String']['output']>;
  testsResults?: Maybe<Scalars['String']['output']>;
  titles?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type LitterParentMinOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  img?: InputMaybe<SortOrder>;
  litterId?: InputMaybe<SortOrder>;
  microshipNumber?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  parentId?: InputMaybe<SortOrder>;
  parentType?: InputMaybe<SortOrder>;
  pedigreeNumber?: InputMaybe<SortOrder>;
  pedigreeType?: InputMaybe<SortOrder>;
  testsResults?: InputMaybe<SortOrder>;
  titles?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type LitterParentOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export enum LitterParentOrderByRelevanceFieldEnum {
  img = 'img',
  microshipNumber = 'microshipNumber',
  name = 'name',
  pedigreeNumber = 'pedigreeNumber',
  pedigreeType = 'pedigreeType',
  testsResults = 'testsResults',
  titles = 'titles'
}

export type LitterParentOrderByRelevanceInput = {
  fields: Array<LitterParentOrderByRelevanceFieldEnum>;
  search: Scalars['String']['input'];
  sort: SortOrder;
};

export type LitterParentOrderByWithAggregationInput = {
  _avg?: InputMaybe<LitterParentAvgOrderByAggregateInput>;
  _count?: InputMaybe<LitterParentCountOrderByAggregateInput>;
  _max?: InputMaybe<LitterParentMaxOrderByAggregateInput>;
  _min?: InputMaybe<LitterParentMinOrderByAggregateInput>;
  _sum?: InputMaybe<LitterParentSumOrderByAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  img?: InputMaybe<SortOrderInput>;
  litterId?: InputMaybe<SortOrder>;
  microshipNumber?: InputMaybe<SortOrderInput>;
  name?: InputMaybe<SortOrderInput>;
  parentId?: InputMaybe<SortOrderInput>;
  parentType?: InputMaybe<SortOrder>;
  pedigreeNumber?: InputMaybe<SortOrderInput>;
  pedigreeType?: InputMaybe<SortOrderInput>;
  testsResults?: InputMaybe<SortOrderInput>;
  titles?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type LitterParentOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: InputMaybe<LitterParentOrderByRelevanceInput>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  img?: InputMaybe<SortOrderInput>;
  litter?: InputMaybe<LitterOrderByWithRelationAndSearchRelevanceInput>;
  litterId?: InputMaybe<SortOrder>;
  microshipNumber?: InputMaybe<SortOrderInput>;
  name?: InputMaybe<SortOrderInput>;
  parent?: InputMaybe<AnimalOrderByWithRelationAndSearchRelevanceInput>;
  parentId?: InputMaybe<SortOrderInput>;
  parentType?: InputMaybe<SortOrder>;
  pedigreeNumber?: InputMaybe<SortOrderInput>;
  pedigreeType?: InputMaybe<SortOrderInput>;
  testsResults?: InputMaybe<SortOrderInput>;
  titles?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum LitterParentScalarFieldEnum {
  createdAt = 'createdAt',
  id = 'id',
  img = 'img',
  litterId = 'litterId',
  microshipNumber = 'microshipNumber',
  name = 'name',
  parentId = 'parentId',
  parentType = 'parentType',
  pedigreeNumber = 'pedigreeNumber',
  pedigreeType = 'pedigreeType',
  testsResults = 'testsResults',
  titles = 'titles',
  updatedAt = 'updatedAt'
}

export type LitterParentScalarWhereInput = {
  AND?: InputMaybe<Array<LitterParentScalarWhereInput>>;
  NOT?: InputMaybe<Array<LitterParentScalarWhereInput>>;
  OR?: InputMaybe<Array<LitterParentScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntFilter>;
  img?: InputMaybe<StringNullableFilter>;
  litterId?: InputMaybe<IntFilter>;
  microshipNumber?: InputMaybe<StringNullableFilter>;
  name?: InputMaybe<StringNullableFilter>;
  parentId?: InputMaybe<IntNullableFilter>;
  parentType?: InputMaybe<EnumParentTypeEnumFilter>;
  pedigreeNumber?: InputMaybe<StringNullableFilter>;
  pedigreeType?: InputMaybe<StringNullableFilter>;
  testsResults?: InputMaybe<StringNullableFilter>;
  titles?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type LitterParentScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<LitterParentScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<LitterParentScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<LitterParentScalarWhereWithAggregatesInput>>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  img?: InputMaybe<StringNullableWithAggregatesFilter>;
  litterId?: InputMaybe<IntWithAggregatesFilter>;
  microshipNumber?: InputMaybe<StringNullableWithAggregatesFilter>;
  name?: InputMaybe<StringNullableWithAggregatesFilter>;
  parentId?: InputMaybe<IntNullableWithAggregatesFilter>;
  parentType?: InputMaybe<EnumParentTypeEnumWithAggregatesFilter>;
  pedigreeNumber?: InputMaybe<StringNullableWithAggregatesFilter>;
  pedigreeType?: InputMaybe<StringNullableWithAggregatesFilter>;
  testsResults?: InputMaybe<StringNullableWithAggregatesFilter>;
  titles?: InputMaybe<StringNullableWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type LitterParentSumAggregateOutputType = {
  __typename?: 'LitterParentSumAggregateOutputType';
  id?: Maybe<Scalars['Int']['output']>;
  litterId?: Maybe<Scalars['Int']['output']>;
  parentId?: Maybe<Scalars['Int']['output']>;
};

export type LitterParentSumOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
  litterId?: InputMaybe<SortOrder>;
  parentId?: InputMaybe<SortOrder>;
};

export type LitterParentUncheckedCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  img?: InputMaybe<Scalars['String']['input']>;
  litterId: Scalars['Int']['input'];
  microshipNumber?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['Int']['input']>;
  parentType: ParentTypeEnum;
  pedigreeNumber?: InputMaybe<Scalars['String']['input']>;
  pedigreeType?: InputMaybe<Scalars['String']['input']>;
  testsResults?: InputMaybe<Scalars['String']['input']>;
  titles?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type LitterParentUncheckedCreateNestedManyWithoutLitterInput = {
  connect?: InputMaybe<Array<LitterParentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LitterParentCreateOrConnectWithoutLitterInput>>;
  create?: InputMaybe<Array<LitterParentCreateWithoutLitterInput>>;
  createMany?: InputMaybe<LitterParentCreateManyLitterInputEnvelope>;
};

export type LitterParentUncheckedCreateNestedManyWithoutParentInput = {
  connect?: InputMaybe<Array<LitterParentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LitterParentCreateOrConnectWithoutParentInput>>;
  create?: InputMaybe<Array<LitterParentCreateWithoutParentInput>>;
  createMany?: InputMaybe<LitterParentCreateManyParentInputEnvelope>;
};

export type LitterParentUncheckedCreateWithoutLitterInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  img?: InputMaybe<Scalars['String']['input']>;
  microshipNumber?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['Int']['input']>;
  parentType: ParentTypeEnum;
  pedigreeNumber?: InputMaybe<Scalars['String']['input']>;
  pedigreeType?: InputMaybe<Scalars['String']['input']>;
  testsResults?: InputMaybe<Scalars['String']['input']>;
  titles?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type LitterParentUncheckedCreateWithoutParentInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  img?: InputMaybe<Scalars['String']['input']>;
  litterId: Scalars['Int']['input'];
  microshipNumber?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parentType: ParentTypeEnum;
  pedigreeNumber?: InputMaybe<Scalars['String']['input']>;
  pedigreeType?: InputMaybe<Scalars['String']['input']>;
  testsResults?: InputMaybe<Scalars['String']['input']>;
  titles?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type LitterParentUncheckedUpdateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  img?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  litterId?: InputMaybe<IntFieldUpdateOperationsInput>;
  microshipNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  parentType?: InputMaybe<EnumParentTypeEnumFieldUpdateOperationsInput>;
  pedigreeNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pedigreeType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  testsResults?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  titles?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type LitterParentUncheckedUpdateManyInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  img?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  litterId?: InputMaybe<IntFieldUpdateOperationsInput>;
  microshipNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  parentType?: InputMaybe<EnumParentTypeEnumFieldUpdateOperationsInput>;
  pedigreeNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pedigreeType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  testsResults?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  titles?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type LitterParentUncheckedUpdateManyWithoutLitterInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  img?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  microshipNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  parentType?: InputMaybe<EnumParentTypeEnumFieldUpdateOperationsInput>;
  pedigreeNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pedigreeType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  testsResults?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  titles?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type LitterParentUncheckedUpdateManyWithoutLitterNestedInput = {
  connect?: InputMaybe<Array<LitterParentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LitterParentCreateOrConnectWithoutLitterInput>>;
  create?: InputMaybe<Array<LitterParentCreateWithoutLitterInput>>;
  createMany?: InputMaybe<LitterParentCreateManyLitterInputEnvelope>;
  delete?: InputMaybe<Array<LitterParentWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<LitterParentScalarWhereInput>>;
  disconnect?: InputMaybe<Array<LitterParentWhereUniqueInput>>;
  set?: InputMaybe<Array<LitterParentWhereUniqueInput>>;
  update?: InputMaybe<Array<LitterParentUpdateWithWhereUniqueWithoutLitterInput>>;
  updateMany?: InputMaybe<Array<LitterParentUpdateManyWithWhereWithoutLitterInput>>;
  upsert?: InputMaybe<Array<LitterParentUpsertWithWhereUniqueWithoutLitterInput>>;
};

export type LitterParentUncheckedUpdateManyWithoutParentInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  img?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  litterId?: InputMaybe<IntFieldUpdateOperationsInput>;
  microshipNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentType?: InputMaybe<EnumParentTypeEnumFieldUpdateOperationsInput>;
  pedigreeNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pedigreeType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  testsResults?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  titles?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type LitterParentUncheckedUpdateManyWithoutParentNestedInput = {
  connect?: InputMaybe<Array<LitterParentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LitterParentCreateOrConnectWithoutParentInput>>;
  create?: InputMaybe<Array<LitterParentCreateWithoutParentInput>>;
  createMany?: InputMaybe<LitterParentCreateManyParentInputEnvelope>;
  delete?: InputMaybe<Array<LitterParentWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<LitterParentScalarWhereInput>>;
  disconnect?: InputMaybe<Array<LitterParentWhereUniqueInput>>;
  set?: InputMaybe<Array<LitterParentWhereUniqueInput>>;
  update?: InputMaybe<Array<LitterParentUpdateWithWhereUniqueWithoutParentInput>>;
  updateMany?: InputMaybe<Array<LitterParentUpdateManyWithWhereWithoutParentInput>>;
  upsert?: InputMaybe<Array<LitterParentUpsertWithWhereUniqueWithoutParentInput>>;
};

export type LitterParentUncheckedUpdateWithoutLitterInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  img?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  microshipNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  parentType?: InputMaybe<EnumParentTypeEnumFieldUpdateOperationsInput>;
  pedigreeNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pedigreeType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  testsResults?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  titles?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type LitterParentUncheckedUpdateWithoutParentInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  img?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  litterId?: InputMaybe<IntFieldUpdateOperationsInput>;
  microshipNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentType?: InputMaybe<EnumParentTypeEnumFieldUpdateOperationsInput>;
  pedigreeNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pedigreeType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  testsResults?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  titles?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type LitterParentUpdateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  img?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  litter?: InputMaybe<LitterUpdateOneRequiredWithoutParentsNestedInput>;
  microshipNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parent?: InputMaybe<AnimalUpdateOneWithoutBirthedLittersNestedInput>;
  parentType?: InputMaybe<EnumParentTypeEnumFieldUpdateOperationsInput>;
  pedigreeNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pedigreeType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  testsResults?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  titles?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type LitterParentUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  img?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  microshipNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentType?: InputMaybe<EnumParentTypeEnumFieldUpdateOperationsInput>;
  pedigreeNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pedigreeType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  testsResults?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  titles?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type LitterParentUpdateManyWithWhereWithoutLitterInput = {
  data: LitterParentUpdateManyMutationInput;
  where: LitterParentScalarWhereInput;
};

export type LitterParentUpdateManyWithWhereWithoutParentInput = {
  data: LitterParentUpdateManyMutationInput;
  where: LitterParentScalarWhereInput;
};

export type LitterParentUpdateManyWithoutLitterNestedInput = {
  connect?: InputMaybe<Array<LitterParentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LitterParentCreateOrConnectWithoutLitterInput>>;
  create?: InputMaybe<Array<LitterParentCreateWithoutLitterInput>>;
  createMany?: InputMaybe<LitterParentCreateManyLitterInputEnvelope>;
  delete?: InputMaybe<Array<LitterParentWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<LitterParentScalarWhereInput>>;
  disconnect?: InputMaybe<Array<LitterParentWhereUniqueInput>>;
  set?: InputMaybe<Array<LitterParentWhereUniqueInput>>;
  update?: InputMaybe<Array<LitterParentUpdateWithWhereUniqueWithoutLitterInput>>;
  updateMany?: InputMaybe<Array<LitterParentUpdateManyWithWhereWithoutLitterInput>>;
  upsert?: InputMaybe<Array<LitterParentUpsertWithWhereUniqueWithoutLitterInput>>;
};

export type LitterParentUpdateManyWithoutParentNestedInput = {
  connect?: InputMaybe<Array<LitterParentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LitterParentCreateOrConnectWithoutParentInput>>;
  create?: InputMaybe<Array<LitterParentCreateWithoutParentInput>>;
  createMany?: InputMaybe<LitterParentCreateManyParentInputEnvelope>;
  delete?: InputMaybe<Array<LitterParentWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<LitterParentScalarWhereInput>>;
  disconnect?: InputMaybe<Array<LitterParentWhereUniqueInput>>;
  set?: InputMaybe<Array<LitterParentWhereUniqueInput>>;
  update?: InputMaybe<Array<LitterParentUpdateWithWhereUniqueWithoutParentInput>>;
  updateMany?: InputMaybe<Array<LitterParentUpdateManyWithWhereWithoutParentInput>>;
  upsert?: InputMaybe<Array<LitterParentUpsertWithWhereUniqueWithoutParentInput>>;
};

export type LitterParentUpdateWithWhereUniqueWithoutLitterInput = {
  data: LitterParentUpdateWithoutLitterInput;
  where: LitterParentWhereUniqueInput;
};

export type LitterParentUpdateWithWhereUniqueWithoutParentInput = {
  data: LitterParentUpdateWithoutParentInput;
  where: LitterParentWhereUniqueInput;
};

export type LitterParentUpdateWithoutLitterInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  img?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  microshipNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parent?: InputMaybe<AnimalUpdateOneWithoutBirthedLittersNestedInput>;
  parentType?: InputMaybe<EnumParentTypeEnumFieldUpdateOperationsInput>;
  pedigreeNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pedigreeType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  testsResults?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  titles?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type LitterParentUpdateWithoutParentInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  img?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  litter?: InputMaybe<LitterUpdateOneRequiredWithoutParentsNestedInput>;
  microshipNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  parentType?: InputMaybe<EnumParentTypeEnumFieldUpdateOperationsInput>;
  pedigreeNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pedigreeType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  testsResults?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  titles?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type LitterParentUpsertWithWhereUniqueWithoutLitterInput = {
  create: LitterParentCreateWithoutLitterInput;
  update: LitterParentUpdateWithoutLitterInput;
  where: LitterParentWhereUniqueInput;
};

export type LitterParentUpsertWithWhereUniqueWithoutParentInput = {
  create: LitterParentCreateWithoutParentInput;
  update: LitterParentUpdateWithoutParentInput;
  where: LitterParentWhereUniqueInput;
};

export type LitterParentWhereInput = {
  AND?: InputMaybe<Array<LitterParentWhereInput>>;
  NOT?: InputMaybe<Array<LitterParentWhereInput>>;
  OR?: InputMaybe<Array<LitterParentWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntFilter>;
  img?: InputMaybe<StringNullableFilter>;
  litter?: InputMaybe<LitterRelationFilter>;
  litterId?: InputMaybe<IntFilter>;
  microshipNumber?: InputMaybe<StringNullableFilter>;
  name?: InputMaybe<StringNullableFilter>;
  parent?: InputMaybe<AnimalNullableRelationFilter>;
  parentId?: InputMaybe<IntNullableFilter>;
  parentType?: InputMaybe<EnumParentTypeEnumFilter>;
  pedigreeNumber?: InputMaybe<StringNullableFilter>;
  pedigreeType?: InputMaybe<StringNullableFilter>;
  testsResults?: InputMaybe<StringNullableFilter>;
  titles?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type LitterParentWhereUniqueInput = {
  AND?: InputMaybe<Array<LitterParentWhereInput>>;
  NOT?: InputMaybe<Array<LitterParentWhereInput>>;
  OR?: InputMaybe<Array<LitterParentWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  img?: InputMaybe<StringNullableFilter>;
  litter?: InputMaybe<LitterRelationFilter>;
  litterId?: InputMaybe<IntFilter>;
  microshipNumber?: InputMaybe<StringNullableFilter>;
  name?: InputMaybe<StringNullableFilter>;
  parent?: InputMaybe<AnimalNullableRelationFilter>;
  parentId?: InputMaybe<IntNullableFilter>;
  parentType?: InputMaybe<EnumParentTypeEnumFilter>;
  pedigreeNumber?: InputMaybe<StringNullableFilter>;
  pedigreeType?: InputMaybe<StringNullableFilter>;
  testsResults?: InputMaybe<StringNullableFilter>;
  titles?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type LitterRelationFilter = {
  is?: InputMaybe<LitterWhereInput>;
  isNot?: InputMaybe<LitterWhereInput>;
};

export enum LitterScalarFieldEnum {
  adminValidated = 'adminValidated',
  adminValidationDate = 'adminValidationDate',
  archived = 'archived',
  availabilityDate = 'availabilityDate',
  availabilityReminderSent = 'availabilityReminderSent',
  birthday = 'birthday',
  born = 'born',
  breederId = 'breederId',
  certified = 'certified',
  createdAt = 'createdAt',
  description = 'description',
  dewormed = 'dewormed',
  dogBreedId = 'dogBreedId',
  femalesCount = 'femalesCount',
  femalesLeftCount = 'femalesLeftCount',
  fixedPrice = 'fixedPrice',
  hasFinishedOnboarding = 'hasFinishedOnboarding',
  id = 'id',
  litterCode = 'litterCode',
  malesCount = 'malesCount',
  malesLeftCount = 'malesLeftCount',
  microchipped = 'microchipped',
  microchips = 'microchips',
  pedigree = 'pedigree',
  pedigreeNumbers = 'pedigreeNumbers',
  price = 'price',
  priceFrom = 'priceFrom',
  priceTo = 'priceTo',
  tags = 'tags',
  updatedAt = 'updatedAt',
  vaccinated = 'vaccinated',
  vaccinationDate = 'vaccinationDate'
}

export type LitterScalarWhereInput = {
  AND?: InputMaybe<Array<LitterScalarWhereInput>>;
  NOT?: InputMaybe<Array<LitterScalarWhereInput>>;
  OR?: InputMaybe<Array<LitterScalarWhereInput>>;
  adminValidated?: InputMaybe<BoolNullableFilter>;
  adminValidationDate?: InputMaybe<DateTimeNullableFilter>;
  archived?: InputMaybe<BoolNullableFilter>;
  availabilityDate?: InputMaybe<DateTimeNullableFilter>;
  availabilityReminderSent?: InputMaybe<BoolFilter>;
  birthday?: InputMaybe<DateTimeNullableFilter>;
  born?: InputMaybe<BoolFilter>;
  breederId?: InputMaybe<IntFilter>;
  certified?: InputMaybe<BoolNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringNullableFilter>;
  dewormed?: InputMaybe<BoolNullableFilter>;
  dogBreedId?: InputMaybe<IntNullableFilter>;
  femalesCount?: InputMaybe<IntFilter>;
  femalesLeftCount?: InputMaybe<IntNullableFilter>;
  fixedPrice?: InputMaybe<BoolNullableFilter>;
  hasFinishedOnboarding?: InputMaybe<BoolNullableFilter>;
  id?: InputMaybe<IntFilter>;
  litterCode?: InputMaybe<StringNullableFilter>;
  malesCount?: InputMaybe<IntFilter>;
  malesLeftCount?: InputMaybe<IntNullableFilter>;
  microchipped?: InputMaybe<BoolNullableFilter>;
  microchips?: InputMaybe<StringNullableListFilter>;
  pedigree?: InputMaybe<StringNullableFilter>;
  pedigreeNumbers?: InputMaybe<StringNullableListFilter>;
  price?: InputMaybe<FloatNullableFilter>;
  priceFrom?: InputMaybe<FloatNullableFilter>;
  priceTo?: InputMaybe<FloatNullableFilter>;
  tags?: InputMaybe<StringNullableListFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  vaccinated?: InputMaybe<BoolNullableFilter>;
  vaccinationDate?: InputMaybe<DateTimeNullableFilter>;
};

export type LitterScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<LitterScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<LitterScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<LitterScalarWhereWithAggregatesInput>>;
  adminValidated?: InputMaybe<BoolNullableWithAggregatesFilter>;
  adminValidationDate?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  archived?: InputMaybe<BoolNullableWithAggregatesFilter>;
  availabilityDate?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  availabilityReminderSent?: InputMaybe<BoolWithAggregatesFilter>;
  birthday?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  born?: InputMaybe<BoolWithAggregatesFilter>;
  breederId?: InputMaybe<IntWithAggregatesFilter>;
  certified?: InputMaybe<BoolNullableWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  description?: InputMaybe<StringNullableWithAggregatesFilter>;
  dewormed?: InputMaybe<BoolNullableWithAggregatesFilter>;
  dogBreedId?: InputMaybe<IntNullableWithAggregatesFilter>;
  femalesCount?: InputMaybe<IntWithAggregatesFilter>;
  femalesLeftCount?: InputMaybe<IntNullableWithAggregatesFilter>;
  fixedPrice?: InputMaybe<BoolNullableWithAggregatesFilter>;
  hasFinishedOnboarding?: InputMaybe<BoolNullableWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  litterCode?: InputMaybe<StringNullableWithAggregatesFilter>;
  malesCount?: InputMaybe<IntWithAggregatesFilter>;
  malesLeftCount?: InputMaybe<IntNullableWithAggregatesFilter>;
  microchipped?: InputMaybe<BoolNullableWithAggregatesFilter>;
  microchips?: InputMaybe<StringNullableListFilter>;
  pedigree?: InputMaybe<StringNullableWithAggregatesFilter>;
  pedigreeNumbers?: InputMaybe<StringNullableListFilter>;
  price?: InputMaybe<FloatNullableWithAggregatesFilter>;
  priceFrom?: InputMaybe<FloatNullableWithAggregatesFilter>;
  priceTo?: InputMaybe<FloatNullableWithAggregatesFilter>;
  tags?: InputMaybe<StringNullableListFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  vaccinated?: InputMaybe<BoolNullableWithAggregatesFilter>;
  vaccinationDate?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
};

export type LitterSumAggregateOutputType = {
  __typename?: 'LitterSumAggregateOutputType';
  breederId?: Maybe<Scalars['Int']['output']>;
  dogBreedId?: Maybe<Scalars['Int']['output']>;
  femalesCount?: Maybe<Scalars['Int']['output']>;
  femalesLeftCount?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  malesCount?: Maybe<Scalars['Int']['output']>;
  malesLeftCount?: Maybe<Scalars['Int']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  priceFrom?: Maybe<Scalars['Float']['output']>;
  priceTo?: Maybe<Scalars['Float']['output']>;
};

export type LitterSumOrderByAggregateInput = {
  breederId?: InputMaybe<SortOrder>;
  dogBreedId?: InputMaybe<SortOrder>;
  femalesCount?: InputMaybe<SortOrder>;
  femalesLeftCount?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  malesCount?: InputMaybe<SortOrder>;
  malesLeftCount?: InputMaybe<SortOrder>;
  price?: InputMaybe<SortOrder>;
  priceFrom?: InputMaybe<SortOrder>;
  priceTo?: InputMaybe<SortOrder>;
};

export type LitterTranslation = {
  __typename?: 'LitterTranslation';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  language: Scalars['String']['output'];
  litter: Litter;
  litterId: Scalars['Int']['output'];
  seoDescription?: Maybe<Scalars['String']['output']>;
  seoKeywords?: Maybe<Scalars['String']['output']>;
  seoTitle?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type LitterTranslationAvgAggregateOutputType = {
  __typename?: 'LitterTranslationAvgAggregateOutputType';
  id?: Maybe<Scalars['Float']['output']>;
  litterId?: Maybe<Scalars['Float']['output']>;
};

export type LitterTranslationAvgOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
  litterId?: InputMaybe<SortOrder>;
};

export type LitterTranslationCountAggregateOutputType = {
  __typename?: 'LitterTranslationCountAggregateOutputType';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  language: Scalars['Int']['output'];
  litterId: Scalars['Int']['output'];
  seoDescription: Scalars['Int']['output'];
  seoKeywords: Scalars['Int']['output'];
  seoTitle: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
  url: Scalars['Int']['output'];
};

export type LitterTranslationCountOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  language?: InputMaybe<SortOrder>;
  litterId?: InputMaybe<SortOrder>;
  seoDescription?: InputMaybe<SortOrder>;
  seoKeywords?: InputMaybe<SortOrder>;
  seoTitle?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  url?: InputMaybe<SortOrder>;
};

export type LitterTranslationCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  language: Scalars['String']['input'];
  litter: LitterCreateNestedOneWithoutTranslationsInput;
  seoDescription?: InputMaybe<Scalars['String']['input']>;
  seoKeywords?: InputMaybe<Scalars['String']['input']>;
  seoTitle?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type LitterTranslationCreateManyInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  language: Scalars['String']['input'];
  litterId: Scalars['Int']['input'];
  seoDescription?: InputMaybe<Scalars['String']['input']>;
  seoKeywords?: InputMaybe<Scalars['String']['input']>;
  seoTitle?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type LitterTranslationCreateManyLitterInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  language: Scalars['String']['input'];
  seoDescription?: InputMaybe<Scalars['String']['input']>;
  seoKeywords?: InputMaybe<Scalars['String']['input']>;
  seoTitle?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type LitterTranslationCreateManyLitterInputEnvelope = {
  data: Array<LitterTranslationCreateManyLitterInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LitterTranslationCreateNestedManyWithoutLitterInput = {
  connect?: InputMaybe<Array<LitterTranslationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LitterTranslationCreateOrConnectWithoutLitterInput>>;
  create?: InputMaybe<Array<LitterTranslationCreateWithoutLitterInput>>;
  createMany?: InputMaybe<LitterTranslationCreateManyLitterInputEnvelope>;
};

export type LitterTranslationCreateOrConnectWithoutLitterInput = {
  create: LitterTranslationCreateWithoutLitterInput;
  where: LitterTranslationWhereUniqueInput;
};

export type LitterTranslationCreateWithoutLitterInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  language: Scalars['String']['input'];
  seoDescription?: InputMaybe<Scalars['String']['input']>;
  seoKeywords?: InputMaybe<Scalars['String']['input']>;
  seoTitle?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type LitterTranslationListRelationFilter = {
  every?: InputMaybe<LitterTranslationWhereInput>;
  none?: InputMaybe<LitterTranslationWhereInput>;
  some?: InputMaybe<LitterTranslationWhereInput>;
};

export type LitterTranslationMaxAggregateOutputType = {
  __typename?: 'LitterTranslationMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  litterId?: Maybe<Scalars['Int']['output']>;
  seoDescription?: Maybe<Scalars['String']['output']>;
  seoKeywords?: Maybe<Scalars['String']['output']>;
  seoTitle?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type LitterTranslationMaxOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  language?: InputMaybe<SortOrder>;
  litterId?: InputMaybe<SortOrder>;
  seoDescription?: InputMaybe<SortOrder>;
  seoKeywords?: InputMaybe<SortOrder>;
  seoTitle?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  url?: InputMaybe<SortOrder>;
};

export type LitterTranslationMinAggregateOutputType = {
  __typename?: 'LitterTranslationMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  litterId?: Maybe<Scalars['Int']['output']>;
  seoDescription?: Maybe<Scalars['String']['output']>;
  seoKeywords?: Maybe<Scalars['String']['output']>;
  seoTitle?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type LitterTranslationMinOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  language?: InputMaybe<SortOrder>;
  litterId?: InputMaybe<SortOrder>;
  seoDescription?: InputMaybe<SortOrder>;
  seoKeywords?: InputMaybe<SortOrder>;
  seoTitle?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  url?: InputMaybe<SortOrder>;
};

export type LitterTranslationOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export enum LitterTranslationOrderByRelevanceFieldEnum {
  language = 'language',
  seoDescription = 'seoDescription',
  seoKeywords = 'seoKeywords',
  seoTitle = 'seoTitle',
  url = 'url'
}

export type LitterTranslationOrderByRelevanceInput = {
  fields: Array<LitterTranslationOrderByRelevanceFieldEnum>;
  search: Scalars['String']['input'];
  sort: SortOrder;
};

export type LitterTranslationOrderByWithAggregationInput = {
  _avg?: InputMaybe<LitterTranslationAvgOrderByAggregateInput>;
  _count?: InputMaybe<LitterTranslationCountOrderByAggregateInput>;
  _max?: InputMaybe<LitterTranslationMaxOrderByAggregateInput>;
  _min?: InputMaybe<LitterTranslationMinOrderByAggregateInput>;
  _sum?: InputMaybe<LitterTranslationSumOrderByAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  language?: InputMaybe<SortOrder>;
  litterId?: InputMaybe<SortOrder>;
  seoDescription?: InputMaybe<SortOrderInput>;
  seoKeywords?: InputMaybe<SortOrderInput>;
  seoTitle?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
  url?: InputMaybe<SortOrderInput>;
};

export type LitterTranslationOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: InputMaybe<LitterTranslationOrderByRelevanceInput>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  language?: InputMaybe<SortOrder>;
  litter?: InputMaybe<LitterOrderByWithRelationAndSearchRelevanceInput>;
  litterId?: InputMaybe<SortOrder>;
  seoDescription?: InputMaybe<SortOrderInput>;
  seoKeywords?: InputMaybe<SortOrderInput>;
  seoTitle?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
  url?: InputMaybe<SortOrderInput>;
};

export enum LitterTranslationScalarFieldEnum {
  createdAt = 'createdAt',
  id = 'id',
  language = 'language',
  litterId = 'litterId',
  seoDescription = 'seoDescription',
  seoKeywords = 'seoKeywords',
  seoTitle = 'seoTitle',
  updatedAt = 'updatedAt',
  url = 'url'
}

export type LitterTranslationScalarWhereInput = {
  AND?: InputMaybe<Array<LitterTranslationScalarWhereInput>>;
  NOT?: InputMaybe<Array<LitterTranslationScalarWhereInput>>;
  OR?: InputMaybe<Array<LitterTranslationScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntFilter>;
  language?: InputMaybe<StringFilter>;
  litterId?: InputMaybe<IntFilter>;
  seoDescription?: InputMaybe<StringNullableFilter>;
  seoKeywords?: InputMaybe<StringNullableFilter>;
  seoTitle?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  url?: InputMaybe<StringNullableFilter>;
};

export type LitterTranslationScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<LitterTranslationScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<LitterTranslationScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<LitterTranslationScalarWhereWithAggregatesInput>>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  language?: InputMaybe<StringWithAggregatesFilter>;
  litterId?: InputMaybe<IntWithAggregatesFilter>;
  seoDescription?: InputMaybe<StringNullableWithAggregatesFilter>;
  seoKeywords?: InputMaybe<StringNullableWithAggregatesFilter>;
  seoTitle?: InputMaybe<StringNullableWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  url?: InputMaybe<StringNullableWithAggregatesFilter>;
};

export type LitterTranslationSumAggregateOutputType = {
  __typename?: 'LitterTranslationSumAggregateOutputType';
  id?: Maybe<Scalars['Int']['output']>;
  litterId?: Maybe<Scalars['Int']['output']>;
};

export type LitterTranslationSumOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
  litterId?: InputMaybe<SortOrder>;
};

export type LitterTranslationUncheckedCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  language: Scalars['String']['input'];
  litterId: Scalars['Int']['input'];
  seoDescription?: InputMaybe<Scalars['String']['input']>;
  seoKeywords?: InputMaybe<Scalars['String']['input']>;
  seoTitle?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type LitterTranslationUncheckedCreateNestedManyWithoutLitterInput = {
  connect?: InputMaybe<Array<LitterTranslationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LitterTranslationCreateOrConnectWithoutLitterInput>>;
  create?: InputMaybe<Array<LitterTranslationCreateWithoutLitterInput>>;
  createMany?: InputMaybe<LitterTranslationCreateManyLitterInputEnvelope>;
};

export type LitterTranslationUncheckedCreateWithoutLitterInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  language: Scalars['String']['input'];
  seoDescription?: InputMaybe<Scalars['String']['input']>;
  seoKeywords?: InputMaybe<Scalars['String']['input']>;
  seoTitle?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type LitterTranslationUncheckedUpdateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  litterId?: InputMaybe<IntFieldUpdateOperationsInput>;
  seoDescription?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  seoKeywords?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  seoTitle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  url?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type LitterTranslationUncheckedUpdateManyInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  litterId?: InputMaybe<IntFieldUpdateOperationsInput>;
  seoDescription?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  seoKeywords?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  seoTitle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  url?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type LitterTranslationUncheckedUpdateManyWithoutLitterInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  seoDescription?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  seoKeywords?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  seoTitle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  url?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type LitterTranslationUncheckedUpdateManyWithoutLitterNestedInput = {
  connect?: InputMaybe<Array<LitterTranslationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LitterTranslationCreateOrConnectWithoutLitterInput>>;
  create?: InputMaybe<Array<LitterTranslationCreateWithoutLitterInput>>;
  createMany?: InputMaybe<LitterTranslationCreateManyLitterInputEnvelope>;
  delete?: InputMaybe<Array<LitterTranslationWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<LitterTranslationScalarWhereInput>>;
  disconnect?: InputMaybe<Array<LitterTranslationWhereUniqueInput>>;
  set?: InputMaybe<Array<LitterTranslationWhereUniqueInput>>;
  update?: InputMaybe<Array<LitterTranslationUpdateWithWhereUniqueWithoutLitterInput>>;
  updateMany?: InputMaybe<Array<LitterTranslationUpdateManyWithWhereWithoutLitterInput>>;
  upsert?: InputMaybe<Array<LitterTranslationUpsertWithWhereUniqueWithoutLitterInput>>;
};

export type LitterTranslationUncheckedUpdateWithoutLitterInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  seoDescription?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  seoKeywords?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  seoTitle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  url?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type LitterTranslationUpdateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  litter?: InputMaybe<LitterUpdateOneRequiredWithoutTranslationsNestedInput>;
  seoDescription?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  seoKeywords?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  seoTitle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  url?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type LitterTranslationUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  seoDescription?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  seoKeywords?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  seoTitle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  url?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type LitterTranslationUpdateManyWithWhereWithoutLitterInput = {
  data: LitterTranslationUpdateManyMutationInput;
  where: LitterTranslationScalarWhereInput;
};

export type LitterTranslationUpdateManyWithoutLitterNestedInput = {
  connect?: InputMaybe<Array<LitterTranslationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LitterTranslationCreateOrConnectWithoutLitterInput>>;
  create?: InputMaybe<Array<LitterTranslationCreateWithoutLitterInput>>;
  createMany?: InputMaybe<LitterTranslationCreateManyLitterInputEnvelope>;
  delete?: InputMaybe<Array<LitterTranslationWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<LitterTranslationScalarWhereInput>>;
  disconnect?: InputMaybe<Array<LitterTranslationWhereUniqueInput>>;
  set?: InputMaybe<Array<LitterTranslationWhereUniqueInput>>;
  update?: InputMaybe<Array<LitterTranslationUpdateWithWhereUniqueWithoutLitterInput>>;
  updateMany?: InputMaybe<Array<LitterTranslationUpdateManyWithWhereWithoutLitterInput>>;
  upsert?: InputMaybe<Array<LitterTranslationUpsertWithWhereUniqueWithoutLitterInput>>;
};

export type LitterTranslationUpdateWithWhereUniqueWithoutLitterInput = {
  data: LitterTranslationUpdateWithoutLitterInput;
  where: LitterTranslationWhereUniqueInput;
};

export type LitterTranslationUpdateWithoutLitterInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  seoDescription?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  seoKeywords?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  seoTitle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  url?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type LitterTranslationUpsertWithWhereUniqueWithoutLitterInput = {
  create: LitterTranslationCreateWithoutLitterInput;
  update: LitterTranslationUpdateWithoutLitterInput;
  where: LitterTranslationWhereUniqueInput;
};

export type LitterTranslationWhereInput = {
  AND?: InputMaybe<Array<LitterTranslationWhereInput>>;
  NOT?: InputMaybe<Array<LitterTranslationWhereInput>>;
  OR?: InputMaybe<Array<LitterTranslationWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntFilter>;
  language?: InputMaybe<StringFilter>;
  litter?: InputMaybe<LitterRelationFilter>;
  litterId?: InputMaybe<IntFilter>;
  seoDescription?: InputMaybe<StringNullableFilter>;
  seoKeywords?: InputMaybe<StringNullableFilter>;
  seoTitle?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  url?: InputMaybe<StringNullableFilter>;
};

export type LitterTranslationWhereUniqueInput = {
  AND?: InputMaybe<Array<LitterTranslationWhereInput>>;
  NOT?: InputMaybe<Array<LitterTranslationWhereInput>>;
  OR?: InputMaybe<Array<LitterTranslationWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  language?: InputMaybe<StringFilter>;
  litter?: InputMaybe<LitterRelationFilter>;
  litterId?: InputMaybe<IntFilter>;
  seoDescription?: InputMaybe<StringNullableFilter>;
  seoKeywords?: InputMaybe<StringNullableFilter>;
  seoTitle?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  url?: InputMaybe<StringNullableFilter>;
};

export type LitterUncheckedCreateInput = {
  adminNotes?: InputMaybe<AdminNoteUncheckedCreateNestedManyWithoutLitterInput>;
  adminValidated?: InputMaybe<Scalars['Boolean']['input']>;
  adminValidationDate?: InputMaybe<Scalars['DateTime']['input']>;
  animalsBorn?: InputMaybe<AnimalUncheckedCreateNestedManyWithoutLitterInput>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  availabilityDate?: InputMaybe<Scalars['DateTime']['input']>;
  availabilityReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  birthday?: InputMaybe<Scalars['DateTime']['input']>;
  bookmarks?: InputMaybe<BookmarkUncheckedCreateNestedManyWithoutLitterInput>;
  born?: InputMaybe<Scalars['Boolean']['input']>;
  breederId: Scalars['Int']['input'];
  certified?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dewormed?: InputMaybe<Scalars['Boolean']['input']>;
  dogBreedId?: InputMaybe<Scalars['Int']['input']>;
  femalesCount?: InputMaybe<Scalars['Int']['input']>;
  femalesLeftCount?: InputMaybe<Scalars['Int']['input']>;
  fixedPrice?: InputMaybe<Scalars['Boolean']['input']>;
  hasFinishedOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  imgs?: InputMaybe<LitterImgUncheckedCreateNestedManyWithoutLitterInput>;
  litterCode?: InputMaybe<Scalars['String']['input']>;
  malesCount?: InputMaybe<Scalars['Int']['input']>;
  malesLeftCount?: InputMaybe<Scalars['Int']['input']>;
  microchipped?: InputMaybe<Scalars['Boolean']['input']>;
  microchips?: InputMaybe<Array<Scalars['String']['input']>>;
  notifications?: InputMaybe<NotificationUncheckedCreateNestedManyWithoutLitterInput>;
  parents?: InputMaybe<LitterParentUncheckedCreateNestedManyWithoutLitterInput>;
  pedigree?: InputMaybe<Scalars['String']['input']>;
  pedigreeNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  price?: InputMaybe<Scalars['Float']['input']>;
  priceFrom?: InputMaybe<Scalars['Float']['input']>;
  priceTo?: InputMaybe<Scalars['Float']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  translations?: InputMaybe<LitterTranslationUncheckedCreateNestedManyWithoutLitterInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updates?: InputMaybe<UpdateUncheckedCreateNestedManyWithoutLitterInput>;
  vaccinated?: InputMaybe<Scalars['Boolean']['input']>;
  vaccinationDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type LitterUncheckedCreateNestedManyWithoutBreederInput = {
  connect?: InputMaybe<Array<LitterWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LitterCreateOrConnectWithoutBreederInput>>;
  create?: InputMaybe<Array<LitterCreateWithoutBreederInput>>;
  createMany?: InputMaybe<LitterCreateManyBreederInputEnvelope>;
};

export type LitterUncheckedCreateNestedManyWithoutDogBreedInput = {
  connect?: InputMaybe<Array<LitterWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LitterCreateOrConnectWithoutDogBreedInput>>;
  create?: InputMaybe<Array<LitterCreateWithoutDogBreedInput>>;
  createMany?: InputMaybe<LitterCreateManyDogBreedInputEnvelope>;
};

export type LitterUncheckedCreateWithoutAdminNotesInput = {
  adminValidated?: InputMaybe<Scalars['Boolean']['input']>;
  adminValidationDate?: InputMaybe<Scalars['DateTime']['input']>;
  animalsBorn?: InputMaybe<AnimalUncheckedCreateNestedManyWithoutLitterInput>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  availabilityDate?: InputMaybe<Scalars['DateTime']['input']>;
  availabilityReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  birthday?: InputMaybe<Scalars['DateTime']['input']>;
  bookmarks?: InputMaybe<BookmarkUncheckedCreateNestedManyWithoutLitterInput>;
  born?: InputMaybe<Scalars['Boolean']['input']>;
  breederId: Scalars['Int']['input'];
  certified?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dewormed?: InputMaybe<Scalars['Boolean']['input']>;
  dogBreedId?: InputMaybe<Scalars['Int']['input']>;
  femalesCount?: InputMaybe<Scalars['Int']['input']>;
  femalesLeftCount?: InputMaybe<Scalars['Int']['input']>;
  fixedPrice?: InputMaybe<Scalars['Boolean']['input']>;
  hasFinishedOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  imgs?: InputMaybe<LitterImgUncheckedCreateNestedManyWithoutLitterInput>;
  litterCode?: InputMaybe<Scalars['String']['input']>;
  malesCount?: InputMaybe<Scalars['Int']['input']>;
  malesLeftCount?: InputMaybe<Scalars['Int']['input']>;
  microchipped?: InputMaybe<Scalars['Boolean']['input']>;
  microchips?: InputMaybe<Array<Scalars['String']['input']>>;
  notifications?: InputMaybe<NotificationUncheckedCreateNestedManyWithoutLitterInput>;
  parents?: InputMaybe<LitterParentUncheckedCreateNestedManyWithoutLitterInput>;
  pedigree?: InputMaybe<Scalars['String']['input']>;
  pedigreeNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  price?: InputMaybe<Scalars['Float']['input']>;
  priceFrom?: InputMaybe<Scalars['Float']['input']>;
  priceTo?: InputMaybe<Scalars['Float']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  translations?: InputMaybe<LitterTranslationUncheckedCreateNestedManyWithoutLitterInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updates?: InputMaybe<UpdateUncheckedCreateNestedManyWithoutLitterInput>;
  vaccinated?: InputMaybe<Scalars['Boolean']['input']>;
  vaccinationDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type LitterUncheckedCreateWithoutAnimalsBornInput = {
  adminNotes?: InputMaybe<AdminNoteUncheckedCreateNestedManyWithoutLitterInput>;
  adminValidated?: InputMaybe<Scalars['Boolean']['input']>;
  adminValidationDate?: InputMaybe<Scalars['DateTime']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  availabilityDate?: InputMaybe<Scalars['DateTime']['input']>;
  availabilityReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  birthday?: InputMaybe<Scalars['DateTime']['input']>;
  bookmarks?: InputMaybe<BookmarkUncheckedCreateNestedManyWithoutLitterInput>;
  born?: InputMaybe<Scalars['Boolean']['input']>;
  breederId: Scalars['Int']['input'];
  certified?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dewormed?: InputMaybe<Scalars['Boolean']['input']>;
  dogBreedId?: InputMaybe<Scalars['Int']['input']>;
  femalesCount?: InputMaybe<Scalars['Int']['input']>;
  femalesLeftCount?: InputMaybe<Scalars['Int']['input']>;
  fixedPrice?: InputMaybe<Scalars['Boolean']['input']>;
  hasFinishedOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  imgs?: InputMaybe<LitterImgUncheckedCreateNestedManyWithoutLitterInput>;
  litterCode?: InputMaybe<Scalars['String']['input']>;
  malesCount?: InputMaybe<Scalars['Int']['input']>;
  malesLeftCount?: InputMaybe<Scalars['Int']['input']>;
  microchipped?: InputMaybe<Scalars['Boolean']['input']>;
  microchips?: InputMaybe<Array<Scalars['String']['input']>>;
  notifications?: InputMaybe<NotificationUncheckedCreateNestedManyWithoutLitterInput>;
  parents?: InputMaybe<LitterParentUncheckedCreateNestedManyWithoutLitterInput>;
  pedigree?: InputMaybe<Scalars['String']['input']>;
  pedigreeNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  price?: InputMaybe<Scalars['Float']['input']>;
  priceFrom?: InputMaybe<Scalars['Float']['input']>;
  priceTo?: InputMaybe<Scalars['Float']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  translations?: InputMaybe<LitterTranslationUncheckedCreateNestedManyWithoutLitterInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updates?: InputMaybe<UpdateUncheckedCreateNestedManyWithoutLitterInput>;
  vaccinated?: InputMaybe<Scalars['Boolean']['input']>;
  vaccinationDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type LitterUncheckedCreateWithoutBookmarksInput = {
  adminNotes?: InputMaybe<AdminNoteUncheckedCreateNestedManyWithoutLitterInput>;
  adminValidated?: InputMaybe<Scalars['Boolean']['input']>;
  adminValidationDate?: InputMaybe<Scalars['DateTime']['input']>;
  animalsBorn?: InputMaybe<AnimalUncheckedCreateNestedManyWithoutLitterInput>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  availabilityDate?: InputMaybe<Scalars['DateTime']['input']>;
  availabilityReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  birthday?: InputMaybe<Scalars['DateTime']['input']>;
  born?: InputMaybe<Scalars['Boolean']['input']>;
  breederId: Scalars['Int']['input'];
  certified?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dewormed?: InputMaybe<Scalars['Boolean']['input']>;
  dogBreedId?: InputMaybe<Scalars['Int']['input']>;
  femalesCount?: InputMaybe<Scalars['Int']['input']>;
  femalesLeftCount?: InputMaybe<Scalars['Int']['input']>;
  fixedPrice?: InputMaybe<Scalars['Boolean']['input']>;
  hasFinishedOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  imgs?: InputMaybe<LitterImgUncheckedCreateNestedManyWithoutLitterInput>;
  litterCode?: InputMaybe<Scalars['String']['input']>;
  malesCount?: InputMaybe<Scalars['Int']['input']>;
  malesLeftCount?: InputMaybe<Scalars['Int']['input']>;
  microchipped?: InputMaybe<Scalars['Boolean']['input']>;
  microchips?: InputMaybe<Array<Scalars['String']['input']>>;
  notifications?: InputMaybe<NotificationUncheckedCreateNestedManyWithoutLitterInput>;
  parents?: InputMaybe<LitterParentUncheckedCreateNestedManyWithoutLitterInput>;
  pedigree?: InputMaybe<Scalars['String']['input']>;
  pedigreeNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  price?: InputMaybe<Scalars['Float']['input']>;
  priceFrom?: InputMaybe<Scalars['Float']['input']>;
  priceTo?: InputMaybe<Scalars['Float']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  translations?: InputMaybe<LitterTranslationUncheckedCreateNestedManyWithoutLitterInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updates?: InputMaybe<UpdateUncheckedCreateNestedManyWithoutLitterInput>;
  vaccinated?: InputMaybe<Scalars['Boolean']['input']>;
  vaccinationDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type LitterUncheckedCreateWithoutBreederInput = {
  adminNotes?: InputMaybe<AdminNoteUncheckedCreateNestedManyWithoutLitterInput>;
  adminValidated?: InputMaybe<Scalars['Boolean']['input']>;
  adminValidationDate?: InputMaybe<Scalars['DateTime']['input']>;
  animalsBorn?: InputMaybe<AnimalUncheckedCreateNestedManyWithoutLitterInput>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  availabilityDate?: InputMaybe<Scalars['DateTime']['input']>;
  availabilityReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  birthday?: InputMaybe<Scalars['DateTime']['input']>;
  bookmarks?: InputMaybe<BookmarkUncheckedCreateNestedManyWithoutLitterInput>;
  born?: InputMaybe<Scalars['Boolean']['input']>;
  certified?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dewormed?: InputMaybe<Scalars['Boolean']['input']>;
  dogBreedId?: InputMaybe<Scalars['Int']['input']>;
  femalesCount?: InputMaybe<Scalars['Int']['input']>;
  femalesLeftCount?: InputMaybe<Scalars['Int']['input']>;
  fixedPrice?: InputMaybe<Scalars['Boolean']['input']>;
  hasFinishedOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  imgs?: InputMaybe<LitterImgUncheckedCreateNestedManyWithoutLitterInput>;
  litterCode?: InputMaybe<Scalars['String']['input']>;
  malesCount?: InputMaybe<Scalars['Int']['input']>;
  malesLeftCount?: InputMaybe<Scalars['Int']['input']>;
  microchipped?: InputMaybe<Scalars['Boolean']['input']>;
  microchips?: InputMaybe<Array<Scalars['String']['input']>>;
  notifications?: InputMaybe<NotificationUncheckedCreateNestedManyWithoutLitterInput>;
  parents?: InputMaybe<LitterParentUncheckedCreateNestedManyWithoutLitterInput>;
  pedigree?: InputMaybe<Scalars['String']['input']>;
  pedigreeNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  price?: InputMaybe<Scalars['Float']['input']>;
  priceFrom?: InputMaybe<Scalars['Float']['input']>;
  priceTo?: InputMaybe<Scalars['Float']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  translations?: InputMaybe<LitterTranslationUncheckedCreateNestedManyWithoutLitterInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updates?: InputMaybe<UpdateUncheckedCreateNestedManyWithoutLitterInput>;
  vaccinated?: InputMaybe<Scalars['Boolean']['input']>;
  vaccinationDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type LitterUncheckedCreateWithoutDogBreedInput = {
  adminNotes?: InputMaybe<AdminNoteUncheckedCreateNestedManyWithoutLitterInput>;
  adminValidated?: InputMaybe<Scalars['Boolean']['input']>;
  adminValidationDate?: InputMaybe<Scalars['DateTime']['input']>;
  animalsBorn?: InputMaybe<AnimalUncheckedCreateNestedManyWithoutLitterInput>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  availabilityDate?: InputMaybe<Scalars['DateTime']['input']>;
  availabilityReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  birthday?: InputMaybe<Scalars['DateTime']['input']>;
  bookmarks?: InputMaybe<BookmarkUncheckedCreateNestedManyWithoutLitterInput>;
  born?: InputMaybe<Scalars['Boolean']['input']>;
  breederId: Scalars['Int']['input'];
  certified?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dewormed?: InputMaybe<Scalars['Boolean']['input']>;
  femalesCount?: InputMaybe<Scalars['Int']['input']>;
  femalesLeftCount?: InputMaybe<Scalars['Int']['input']>;
  fixedPrice?: InputMaybe<Scalars['Boolean']['input']>;
  hasFinishedOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  imgs?: InputMaybe<LitterImgUncheckedCreateNestedManyWithoutLitterInput>;
  litterCode?: InputMaybe<Scalars['String']['input']>;
  malesCount?: InputMaybe<Scalars['Int']['input']>;
  malesLeftCount?: InputMaybe<Scalars['Int']['input']>;
  microchipped?: InputMaybe<Scalars['Boolean']['input']>;
  microchips?: InputMaybe<Array<Scalars['String']['input']>>;
  notifications?: InputMaybe<NotificationUncheckedCreateNestedManyWithoutLitterInput>;
  parents?: InputMaybe<LitterParentUncheckedCreateNestedManyWithoutLitterInput>;
  pedigree?: InputMaybe<Scalars['String']['input']>;
  pedigreeNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  price?: InputMaybe<Scalars['Float']['input']>;
  priceFrom?: InputMaybe<Scalars['Float']['input']>;
  priceTo?: InputMaybe<Scalars['Float']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  translations?: InputMaybe<LitterTranslationUncheckedCreateNestedManyWithoutLitterInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updates?: InputMaybe<UpdateUncheckedCreateNestedManyWithoutLitterInput>;
  vaccinated?: InputMaybe<Scalars['Boolean']['input']>;
  vaccinationDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type LitterUncheckedCreateWithoutImgsInput = {
  adminNotes?: InputMaybe<AdminNoteUncheckedCreateNestedManyWithoutLitterInput>;
  adminValidated?: InputMaybe<Scalars['Boolean']['input']>;
  adminValidationDate?: InputMaybe<Scalars['DateTime']['input']>;
  animalsBorn?: InputMaybe<AnimalUncheckedCreateNestedManyWithoutLitterInput>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  availabilityDate?: InputMaybe<Scalars['DateTime']['input']>;
  availabilityReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  birthday?: InputMaybe<Scalars['DateTime']['input']>;
  bookmarks?: InputMaybe<BookmarkUncheckedCreateNestedManyWithoutLitterInput>;
  born?: InputMaybe<Scalars['Boolean']['input']>;
  breederId: Scalars['Int']['input'];
  certified?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dewormed?: InputMaybe<Scalars['Boolean']['input']>;
  dogBreedId?: InputMaybe<Scalars['Int']['input']>;
  femalesCount?: InputMaybe<Scalars['Int']['input']>;
  femalesLeftCount?: InputMaybe<Scalars['Int']['input']>;
  fixedPrice?: InputMaybe<Scalars['Boolean']['input']>;
  hasFinishedOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  litterCode?: InputMaybe<Scalars['String']['input']>;
  malesCount?: InputMaybe<Scalars['Int']['input']>;
  malesLeftCount?: InputMaybe<Scalars['Int']['input']>;
  microchipped?: InputMaybe<Scalars['Boolean']['input']>;
  microchips?: InputMaybe<Array<Scalars['String']['input']>>;
  notifications?: InputMaybe<NotificationUncheckedCreateNestedManyWithoutLitterInput>;
  parents?: InputMaybe<LitterParentUncheckedCreateNestedManyWithoutLitterInput>;
  pedigree?: InputMaybe<Scalars['String']['input']>;
  pedigreeNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  price?: InputMaybe<Scalars['Float']['input']>;
  priceFrom?: InputMaybe<Scalars['Float']['input']>;
  priceTo?: InputMaybe<Scalars['Float']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  translations?: InputMaybe<LitterTranslationUncheckedCreateNestedManyWithoutLitterInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updates?: InputMaybe<UpdateUncheckedCreateNestedManyWithoutLitterInput>;
  vaccinated?: InputMaybe<Scalars['Boolean']['input']>;
  vaccinationDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type LitterUncheckedCreateWithoutNotificationsInput = {
  adminNotes?: InputMaybe<AdminNoteUncheckedCreateNestedManyWithoutLitterInput>;
  adminValidated?: InputMaybe<Scalars['Boolean']['input']>;
  adminValidationDate?: InputMaybe<Scalars['DateTime']['input']>;
  animalsBorn?: InputMaybe<AnimalUncheckedCreateNestedManyWithoutLitterInput>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  availabilityDate?: InputMaybe<Scalars['DateTime']['input']>;
  availabilityReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  birthday?: InputMaybe<Scalars['DateTime']['input']>;
  bookmarks?: InputMaybe<BookmarkUncheckedCreateNestedManyWithoutLitterInput>;
  born?: InputMaybe<Scalars['Boolean']['input']>;
  breederId: Scalars['Int']['input'];
  certified?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dewormed?: InputMaybe<Scalars['Boolean']['input']>;
  dogBreedId?: InputMaybe<Scalars['Int']['input']>;
  femalesCount?: InputMaybe<Scalars['Int']['input']>;
  femalesLeftCount?: InputMaybe<Scalars['Int']['input']>;
  fixedPrice?: InputMaybe<Scalars['Boolean']['input']>;
  hasFinishedOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  imgs?: InputMaybe<LitterImgUncheckedCreateNestedManyWithoutLitterInput>;
  litterCode?: InputMaybe<Scalars['String']['input']>;
  malesCount?: InputMaybe<Scalars['Int']['input']>;
  malesLeftCount?: InputMaybe<Scalars['Int']['input']>;
  microchipped?: InputMaybe<Scalars['Boolean']['input']>;
  microchips?: InputMaybe<Array<Scalars['String']['input']>>;
  parents?: InputMaybe<LitterParentUncheckedCreateNestedManyWithoutLitterInput>;
  pedigree?: InputMaybe<Scalars['String']['input']>;
  pedigreeNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  price?: InputMaybe<Scalars['Float']['input']>;
  priceFrom?: InputMaybe<Scalars['Float']['input']>;
  priceTo?: InputMaybe<Scalars['Float']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  translations?: InputMaybe<LitterTranslationUncheckedCreateNestedManyWithoutLitterInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updates?: InputMaybe<UpdateUncheckedCreateNestedManyWithoutLitterInput>;
  vaccinated?: InputMaybe<Scalars['Boolean']['input']>;
  vaccinationDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type LitterUncheckedCreateWithoutParentsInput = {
  adminNotes?: InputMaybe<AdminNoteUncheckedCreateNestedManyWithoutLitterInput>;
  adminValidated?: InputMaybe<Scalars['Boolean']['input']>;
  adminValidationDate?: InputMaybe<Scalars['DateTime']['input']>;
  animalsBorn?: InputMaybe<AnimalUncheckedCreateNestedManyWithoutLitterInput>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  availabilityDate?: InputMaybe<Scalars['DateTime']['input']>;
  availabilityReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  birthday?: InputMaybe<Scalars['DateTime']['input']>;
  bookmarks?: InputMaybe<BookmarkUncheckedCreateNestedManyWithoutLitterInput>;
  born?: InputMaybe<Scalars['Boolean']['input']>;
  breederId: Scalars['Int']['input'];
  certified?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dewormed?: InputMaybe<Scalars['Boolean']['input']>;
  dogBreedId?: InputMaybe<Scalars['Int']['input']>;
  femalesCount?: InputMaybe<Scalars['Int']['input']>;
  femalesLeftCount?: InputMaybe<Scalars['Int']['input']>;
  fixedPrice?: InputMaybe<Scalars['Boolean']['input']>;
  hasFinishedOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  imgs?: InputMaybe<LitterImgUncheckedCreateNestedManyWithoutLitterInput>;
  litterCode?: InputMaybe<Scalars['String']['input']>;
  malesCount?: InputMaybe<Scalars['Int']['input']>;
  malesLeftCount?: InputMaybe<Scalars['Int']['input']>;
  microchipped?: InputMaybe<Scalars['Boolean']['input']>;
  microchips?: InputMaybe<Array<Scalars['String']['input']>>;
  notifications?: InputMaybe<NotificationUncheckedCreateNestedManyWithoutLitterInput>;
  pedigree?: InputMaybe<Scalars['String']['input']>;
  pedigreeNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  price?: InputMaybe<Scalars['Float']['input']>;
  priceFrom?: InputMaybe<Scalars['Float']['input']>;
  priceTo?: InputMaybe<Scalars['Float']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  translations?: InputMaybe<LitterTranslationUncheckedCreateNestedManyWithoutLitterInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updates?: InputMaybe<UpdateUncheckedCreateNestedManyWithoutLitterInput>;
  vaccinated?: InputMaybe<Scalars['Boolean']['input']>;
  vaccinationDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type LitterUncheckedCreateWithoutTranslationsInput = {
  adminNotes?: InputMaybe<AdminNoteUncheckedCreateNestedManyWithoutLitterInput>;
  adminValidated?: InputMaybe<Scalars['Boolean']['input']>;
  adminValidationDate?: InputMaybe<Scalars['DateTime']['input']>;
  animalsBorn?: InputMaybe<AnimalUncheckedCreateNestedManyWithoutLitterInput>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  availabilityDate?: InputMaybe<Scalars['DateTime']['input']>;
  availabilityReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  birthday?: InputMaybe<Scalars['DateTime']['input']>;
  bookmarks?: InputMaybe<BookmarkUncheckedCreateNestedManyWithoutLitterInput>;
  born?: InputMaybe<Scalars['Boolean']['input']>;
  breederId: Scalars['Int']['input'];
  certified?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dewormed?: InputMaybe<Scalars['Boolean']['input']>;
  dogBreedId?: InputMaybe<Scalars['Int']['input']>;
  femalesCount?: InputMaybe<Scalars['Int']['input']>;
  femalesLeftCount?: InputMaybe<Scalars['Int']['input']>;
  fixedPrice?: InputMaybe<Scalars['Boolean']['input']>;
  hasFinishedOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  imgs?: InputMaybe<LitterImgUncheckedCreateNestedManyWithoutLitterInput>;
  litterCode?: InputMaybe<Scalars['String']['input']>;
  malesCount?: InputMaybe<Scalars['Int']['input']>;
  malesLeftCount?: InputMaybe<Scalars['Int']['input']>;
  microchipped?: InputMaybe<Scalars['Boolean']['input']>;
  microchips?: InputMaybe<Array<Scalars['String']['input']>>;
  notifications?: InputMaybe<NotificationUncheckedCreateNestedManyWithoutLitterInput>;
  parents?: InputMaybe<LitterParentUncheckedCreateNestedManyWithoutLitterInput>;
  pedigree?: InputMaybe<Scalars['String']['input']>;
  pedigreeNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  price?: InputMaybe<Scalars['Float']['input']>;
  priceFrom?: InputMaybe<Scalars['Float']['input']>;
  priceTo?: InputMaybe<Scalars['Float']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updates?: InputMaybe<UpdateUncheckedCreateNestedManyWithoutLitterInput>;
  vaccinated?: InputMaybe<Scalars['Boolean']['input']>;
  vaccinationDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type LitterUncheckedCreateWithoutUpdatesInput = {
  adminNotes?: InputMaybe<AdminNoteUncheckedCreateNestedManyWithoutLitterInput>;
  adminValidated?: InputMaybe<Scalars['Boolean']['input']>;
  adminValidationDate?: InputMaybe<Scalars['DateTime']['input']>;
  animalsBorn?: InputMaybe<AnimalUncheckedCreateNestedManyWithoutLitterInput>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  availabilityDate?: InputMaybe<Scalars['DateTime']['input']>;
  availabilityReminderSent?: InputMaybe<Scalars['Boolean']['input']>;
  birthday?: InputMaybe<Scalars['DateTime']['input']>;
  bookmarks?: InputMaybe<BookmarkUncheckedCreateNestedManyWithoutLitterInput>;
  born?: InputMaybe<Scalars['Boolean']['input']>;
  breederId: Scalars['Int']['input'];
  certified?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dewormed?: InputMaybe<Scalars['Boolean']['input']>;
  dogBreedId?: InputMaybe<Scalars['Int']['input']>;
  femalesCount?: InputMaybe<Scalars['Int']['input']>;
  femalesLeftCount?: InputMaybe<Scalars['Int']['input']>;
  fixedPrice?: InputMaybe<Scalars['Boolean']['input']>;
  hasFinishedOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  imgs?: InputMaybe<LitterImgUncheckedCreateNestedManyWithoutLitterInput>;
  litterCode?: InputMaybe<Scalars['String']['input']>;
  malesCount?: InputMaybe<Scalars['Int']['input']>;
  malesLeftCount?: InputMaybe<Scalars['Int']['input']>;
  microchipped?: InputMaybe<Scalars['Boolean']['input']>;
  microchips?: InputMaybe<Array<Scalars['String']['input']>>;
  notifications?: InputMaybe<NotificationUncheckedCreateNestedManyWithoutLitterInput>;
  parents?: InputMaybe<LitterParentUncheckedCreateNestedManyWithoutLitterInput>;
  pedigree?: InputMaybe<Scalars['String']['input']>;
  pedigreeNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  price?: InputMaybe<Scalars['Float']['input']>;
  priceFrom?: InputMaybe<Scalars['Float']['input']>;
  priceTo?: InputMaybe<Scalars['Float']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  translations?: InputMaybe<LitterTranslationUncheckedCreateNestedManyWithoutLitterInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  vaccinated?: InputMaybe<Scalars['Boolean']['input']>;
  vaccinationDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type LitterUncheckedUpdateInput = {
  adminNotes?: InputMaybe<AdminNoteUncheckedUpdateManyWithoutLitterNestedInput>;
  adminValidated?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  adminValidationDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  animalsBorn?: InputMaybe<AnimalUncheckedUpdateManyWithoutLitterNestedInput>;
  archived?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  availabilityDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  availabilityReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  bookmarks?: InputMaybe<BookmarkUncheckedUpdateManyWithoutLitterNestedInput>;
  born?: InputMaybe<BoolFieldUpdateOperationsInput>;
  breederId?: InputMaybe<IntFieldUpdateOperationsInput>;
  certified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dewormed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  dogBreedId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  femalesCount?: InputMaybe<IntFieldUpdateOperationsInput>;
  femalesLeftCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  fixedPrice?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hasFinishedOnboarding?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  imgs?: InputMaybe<LitterImgUncheckedUpdateManyWithoutLitterNestedInput>;
  litterCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  malesCount?: InputMaybe<IntFieldUpdateOperationsInput>;
  malesLeftCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  microchipped?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  microchips?: InputMaybe<Array<Scalars['String']['input']>>;
  notifications?: InputMaybe<NotificationUncheckedUpdateManyWithoutLitterNestedInput>;
  parents?: InputMaybe<LitterParentUncheckedUpdateManyWithoutLitterNestedInput>;
  pedigree?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pedigreeNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  price?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  priceFrom?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  priceTo?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  translations?: InputMaybe<LitterTranslationUncheckedUpdateManyWithoutLitterNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updates?: InputMaybe<UpdateUncheckedUpdateManyWithoutLitterNestedInput>;
  vaccinated?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  vaccinationDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type LitterUncheckedUpdateManyInput = {
  adminValidated?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  adminValidationDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  archived?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  availabilityDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  availabilityReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  born?: InputMaybe<BoolFieldUpdateOperationsInput>;
  breederId?: InputMaybe<IntFieldUpdateOperationsInput>;
  certified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dewormed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  dogBreedId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  femalesCount?: InputMaybe<IntFieldUpdateOperationsInput>;
  femalesLeftCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  fixedPrice?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hasFinishedOnboarding?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  litterCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  malesCount?: InputMaybe<IntFieldUpdateOperationsInput>;
  malesLeftCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  microchipped?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  microchips?: InputMaybe<Array<Scalars['String']['input']>>;
  pedigree?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pedigreeNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  price?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  priceFrom?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  priceTo?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  vaccinated?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  vaccinationDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type LitterUncheckedUpdateManyWithoutBreederInput = {
  adminValidated?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  adminValidationDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  archived?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  availabilityDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  availabilityReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  born?: InputMaybe<BoolFieldUpdateOperationsInput>;
  certified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dewormed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  dogBreedId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  femalesCount?: InputMaybe<IntFieldUpdateOperationsInput>;
  femalesLeftCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  fixedPrice?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hasFinishedOnboarding?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  litterCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  malesCount?: InputMaybe<IntFieldUpdateOperationsInput>;
  malesLeftCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  microchipped?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  microchips?: InputMaybe<Array<Scalars['String']['input']>>;
  pedigree?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pedigreeNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  price?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  priceFrom?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  priceTo?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  vaccinated?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  vaccinationDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type LitterUncheckedUpdateManyWithoutBreederNestedInput = {
  connect?: InputMaybe<Array<LitterWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LitterCreateOrConnectWithoutBreederInput>>;
  create?: InputMaybe<Array<LitterCreateWithoutBreederInput>>;
  createMany?: InputMaybe<LitterCreateManyBreederInputEnvelope>;
  delete?: InputMaybe<Array<LitterWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<LitterScalarWhereInput>>;
  disconnect?: InputMaybe<Array<LitterWhereUniqueInput>>;
  set?: InputMaybe<Array<LitterWhereUniqueInput>>;
  update?: InputMaybe<Array<LitterUpdateWithWhereUniqueWithoutBreederInput>>;
  updateMany?: InputMaybe<Array<LitterUpdateManyWithWhereWithoutBreederInput>>;
  upsert?: InputMaybe<Array<LitterUpsertWithWhereUniqueWithoutBreederInput>>;
};

export type LitterUncheckedUpdateManyWithoutDogBreedInput = {
  adminValidated?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  adminValidationDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  archived?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  availabilityDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  availabilityReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  born?: InputMaybe<BoolFieldUpdateOperationsInput>;
  breederId?: InputMaybe<IntFieldUpdateOperationsInput>;
  certified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dewormed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  femalesCount?: InputMaybe<IntFieldUpdateOperationsInput>;
  femalesLeftCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  fixedPrice?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hasFinishedOnboarding?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  litterCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  malesCount?: InputMaybe<IntFieldUpdateOperationsInput>;
  malesLeftCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  microchipped?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  microchips?: InputMaybe<Array<Scalars['String']['input']>>;
  pedigree?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pedigreeNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  price?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  priceFrom?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  priceTo?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  vaccinated?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  vaccinationDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type LitterUncheckedUpdateManyWithoutDogBreedNestedInput = {
  connect?: InputMaybe<Array<LitterWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LitterCreateOrConnectWithoutDogBreedInput>>;
  create?: InputMaybe<Array<LitterCreateWithoutDogBreedInput>>;
  createMany?: InputMaybe<LitterCreateManyDogBreedInputEnvelope>;
  delete?: InputMaybe<Array<LitterWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<LitterScalarWhereInput>>;
  disconnect?: InputMaybe<Array<LitterWhereUniqueInput>>;
  set?: InputMaybe<Array<LitterWhereUniqueInput>>;
  update?: InputMaybe<Array<LitterUpdateWithWhereUniqueWithoutDogBreedInput>>;
  updateMany?: InputMaybe<Array<LitterUpdateManyWithWhereWithoutDogBreedInput>>;
  upsert?: InputMaybe<Array<LitterUpsertWithWhereUniqueWithoutDogBreedInput>>;
};

export type LitterUncheckedUpdateWithoutAdminNotesInput = {
  adminValidated?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  adminValidationDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  animalsBorn?: InputMaybe<AnimalUncheckedUpdateManyWithoutLitterNestedInput>;
  archived?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  availabilityDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  availabilityReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  bookmarks?: InputMaybe<BookmarkUncheckedUpdateManyWithoutLitterNestedInput>;
  born?: InputMaybe<BoolFieldUpdateOperationsInput>;
  breederId?: InputMaybe<IntFieldUpdateOperationsInput>;
  certified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dewormed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  dogBreedId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  femalesCount?: InputMaybe<IntFieldUpdateOperationsInput>;
  femalesLeftCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  fixedPrice?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hasFinishedOnboarding?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  imgs?: InputMaybe<LitterImgUncheckedUpdateManyWithoutLitterNestedInput>;
  litterCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  malesCount?: InputMaybe<IntFieldUpdateOperationsInput>;
  malesLeftCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  microchipped?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  microchips?: InputMaybe<Array<Scalars['String']['input']>>;
  notifications?: InputMaybe<NotificationUncheckedUpdateManyWithoutLitterNestedInput>;
  parents?: InputMaybe<LitterParentUncheckedUpdateManyWithoutLitterNestedInput>;
  pedigree?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pedigreeNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  price?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  priceFrom?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  priceTo?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  translations?: InputMaybe<LitterTranslationUncheckedUpdateManyWithoutLitterNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updates?: InputMaybe<UpdateUncheckedUpdateManyWithoutLitterNestedInput>;
  vaccinated?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  vaccinationDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type LitterUncheckedUpdateWithoutAnimalsBornInput = {
  adminNotes?: InputMaybe<AdminNoteUncheckedUpdateManyWithoutLitterNestedInput>;
  adminValidated?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  adminValidationDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  archived?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  availabilityDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  availabilityReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  bookmarks?: InputMaybe<BookmarkUncheckedUpdateManyWithoutLitterNestedInput>;
  born?: InputMaybe<BoolFieldUpdateOperationsInput>;
  breederId?: InputMaybe<IntFieldUpdateOperationsInput>;
  certified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dewormed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  dogBreedId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  femalesCount?: InputMaybe<IntFieldUpdateOperationsInput>;
  femalesLeftCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  fixedPrice?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hasFinishedOnboarding?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  imgs?: InputMaybe<LitterImgUncheckedUpdateManyWithoutLitterNestedInput>;
  litterCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  malesCount?: InputMaybe<IntFieldUpdateOperationsInput>;
  malesLeftCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  microchipped?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  microchips?: InputMaybe<Array<Scalars['String']['input']>>;
  notifications?: InputMaybe<NotificationUncheckedUpdateManyWithoutLitterNestedInput>;
  parents?: InputMaybe<LitterParentUncheckedUpdateManyWithoutLitterNestedInput>;
  pedigree?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pedigreeNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  price?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  priceFrom?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  priceTo?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  translations?: InputMaybe<LitterTranslationUncheckedUpdateManyWithoutLitterNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updates?: InputMaybe<UpdateUncheckedUpdateManyWithoutLitterNestedInput>;
  vaccinated?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  vaccinationDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type LitterUncheckedUpdateWithoutBookmarksInput = {
  adminNotes?: InputMaybe<AdminNoteUncheckedUpdateManyWithoutLitterNestedInput>;
  adminValidated?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  adminValidationDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  animalsBorn?: InputMaybe<AnimalUncheckedUpdateManyWithoutLitterNestedInput>;
  archived?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  availabilityDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  availabilityReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  born?: InputMaybe<BoolFieldUpdateOperationsInput>;
  breederId?: InputMaybe<IntFieldUpdateOperationsInput>;
  certified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dewormed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  dogBreedId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  femalesCount?: InputMaybe<IntFieldUpdateOperationsInput>;
  femalesLeftCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  fixedPrice?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hasFinishedOnboarding?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  imgs?: InputMaybe<LitterImgUncheckedUpdateManyWithoutLitterNestedInput>;
  litterCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  malesCount?: InputMaybe<IntFieldUpdateOperationsInput>;
  malesLeftCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  microchipped?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  microchips?: InputMaybe<Array<Scalars['String']['input']>>;
  notifications?: InputMaybe<NotificationUncheckedUpdateManyWithoutLitterNestedInput>;
  parents?: InputMaybe<LitterParentUncheckedUpdateManyWithoutLitterNestedInput>;
  pedigree?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pedigreeNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  price?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  priceFrom?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  priceTo?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  translations?: InputMaybe<LitterTranslationUncheckedUpdateManyWithoutLitterNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updates?: InputMaybe<UpdateUncheckedUpdateManyWithoutLitterNestedInput>;
  vaccinated?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  vaccinationDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type LitterUncheckedUpdateWithoutBreederInput = {
  adminNotes?: InputMaybe<AdminNoteUncheckedUpdateManyWithoutLitterNestedInput>;
  adminValidated?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  adminValidationDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  animalsBorn?: InputMaybe<AnimalUncheckedUpdateManyWithoutLitterNestedInput>;
  archived?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  availabilityDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  availabilityReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  bookmarks?: InputMaybe<BookmarkUncheckedUpdateManyWithoutLitterNestedInput>;
  born?: InputMaybe<BoolFieldUpdateOperationsInput>;
  certified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dewormed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  dogBreedId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  femalesCount?: InputMaybe<IntFieldUpdateOperationsInput>;
  femalesLeftCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  fixedPrice?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hasFinishedOnboarding?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  imgs?: InputMaybe<LitterImgUncheckedUpdateManyWithoutLitterNestedInput>;
  litterCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  malesCount?: InputMaybe<IntFieldUpdateOperationsInput>;
  malesLeftCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  microchipped?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  microchips?: InputMaybe<Array<Scalars['String']['input']>>;
  notifications?: InputMaybe<NotificationUncheckedUpdateManyWithoutLitterNestedInput>;
  parents?: InputMaybe<LitterParentUncheckedUpdateManyWithoutLitterNestedInput>;
  pedigree?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pedigreeNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  price?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  priceFrom?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  priceTo?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  translations?: InputMaybe<LitterTranslationUncheckedUpdateManyWithoutLitterNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updates?: InputMaybe<UpdateUncheckedUpdateManyWithoutLitterNestedInput>;
  vaccinated?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  vaccinationDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type LitterUncheckedUpdateWithoutDogBreedInput = {
  adminNotes?: InputMaybe<AdminNoteUncheckedUpdateManyWithoutLitterNestedInput>;
  adminValidated?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  adminValidationDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  animalsBorn?: InputMaybe<AnimalUncheckedUpdateManyWithoutLitterNestedInput>;
  archived?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  availabilityDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  availabilityReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  bookmarks?: InputMaybe<BookmarkUncheckedUpdateManyWithoutLitterNestedInput>;
  born?: InputMaybe<BoolFieldUpdateOperationsInput>;
  breederId?: InputMaybe<IntFieldUpdateOperationsInput>;
  certified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dewormed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  femalesCount?: InputMaybe<IntFieldUpdateOperationsInput>;
  femalesLeftCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  fixedPrice?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hasFinishedOnboarding?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  imgs?: InputMaybe<LitterImgUncheckedUpdateManyWithoutLitterNestedInput>;
  litterCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  malesCount?: InputMaybe<IntFieldUpdateOperationsInput>;
  malesLeftCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  microchipped?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  microchips?: InputMaybe<Array<Scalars['String']['input']>>;
  notifications?: InputMaybe<NotificationUncheckedUpdateManyWithoutLitterNestedInput>;
  parents?: InputMaybe<LitterParentUncheckedUpdateManyWithoutLitterNestedInput>;
  pedigree?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pedigreeNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  price?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  priceFrom?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  priceTo?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  translations?: InputMaybe<LitterTranslationUncheckedUpdateManyWithoutLitterNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updates?: InputMaybe<UpdateUncheckedUpdateManyWithoutLitterNestedInput>;
  vaccinated?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  vaccinationDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type LitterUncheckedUpdateWithoutImgsInput = {
  adminNotes?: InputMaybe<AdminNoteUncheckedUpdateManyWithoutLitterNestedInput>;
  adminValidated?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  adminValidationDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  animalsBorn?: InputMaybe<AnimalUncheckedUpdateManyWithoutLitterNestedInput>;
  archived?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  availabilityDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  availabilityReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  bookmarks?: InputMaybe<BookmarkUncheckedUpdateManyWithoutLitterNestedInput>;
  born?: InputMaybe<BoolFieldUpdateOperationsInput>;
  breederId?: InputMaybe<IntFieldUpdateOperationsInput>;
  certified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dewormed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  dogBreedId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  femalesCount?: InputMaybe<IntFieldUpdateOperationsInput>;
  femalesLeftCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  fixedPrice?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hasFinishedOnboarding?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  litterCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  malesCount?: InputMaybe<IntFieldUpdateOperationsInput>;
  malesLeftCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  microchipped?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  microchips?: InputMaybe<Array<Scalars['String']['input']>>;
  notifications?: InputMaybe<NotificationUncheckedUpdateManyWithoutLitterNestedInput>;
  parents?: InputMaybe<LitterParentUncheckedUpdateManyWithoutLitterNestedInput>;
  pedigree?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pedigreeNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  price?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  priceFrom?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  priceTo?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  translations?: InputMaybe<LitterTranslationUncheckedUpdateManyWithoutLitterNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updates?: InputMaybe<UpdateUncheckedUpdateManyWithoutLitterNestedInput>;
  vaccinated?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  vaccinationDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type LitterUncheckedUpdateWithoutNotificationsInput = {
  adminNotes?: InputMaybe<AdminNoteUncheckedUpdateManyWithoutLitterNestedInput>;
  adminValidated?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  adminValidationDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  animalsBorn?: InputMaybe<AnimalUncheckedUpdateManyWithoutLitterNestedInput>;
  archived?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  availabilityDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  availabilityReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  bookmarks?: InputMaybe<BookmarkUncheckedUpdateManyWithoutLitterNestedInput>;
  born?: InputMaybe<BoolFieldUpdateOperationsInput>;
  breederId?: InputMaybe<IntFieldUpdateOperationsInput>;
  certified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dewormed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  dogBreedId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  femalesCount?: InputMaybe<IntFieldUpdateOperationsInput>;
  femalesLeftCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  fixedPrice?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hasFinishedOnboarding?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  imgs?: InputMaybe<LitterImgUncheckedUpdateManyWithoutLitterNestedInput>;
  litterCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  malesCount?: InputMaybe<IntFieldUpdateOperationsInput>;
  malesLeftCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  microchipped?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  microchips?: InputMaybe<Array<Scalars['String']['input']>>;
  parents?: InputMaybe<LitterParentUncheckedUpdateManyWithoutLitterNestedInput>;
  pedigree?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pedigreeNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  price?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  priceFrom?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  priceTo?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  translations?: InputMaybe<LitterTranslationUncheckedUpdateManyWithoutLitterNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updates?: InputMaybe<UpdateUncheckedUpdateManyWithoutLitterNestedInput>;
  vaccinated?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  vaccinationDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type LitterUncheckedUpdateWithoutParentsInput = {
  adminNotes?: InputMaybe<AdminNoteUncheckedUpdateManyWithoutLitterNestedInput>;
  adminValidated?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  adminValidationDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  animalsBorn?: InputMaybe<AnimalUncheckedUpdateManyWithoutLitterNestedInput>;
  archived?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  availabilityDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  availabilityReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  bookmarks?: InputMaybe<BookmarkUncheckedUpdateManyWithoutLitterNestedInput>;
  born?: InputMaybe<BoolFieldUpdateOperationsInput>;
  breederId?: InputMaybe<IntFieldUpdateOperationsInput>;
  certified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dewormed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  dogBreedId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  femalesCount?: InputMaybe<IntFieldUpdateOperationsInput>;
  femalesLeftCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  fixedPrice?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hasFinishedOnboarding?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  imgs?: InputMaybe<LitterImgUncheckedUpdateManyWithoutLitterNestedInput>;
  litterCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  malesCount?: InputMaybe<IntFieldUpdateOperationsInput>;
  malesLeftCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  microchipped?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  microchips?: InputMaybe<Array<Scalars['String']['input']>>;
  notifications?: InputMaybe<NotificationUncheckedUpdateManyWithoutLitterNestedInput>;
  pedigree?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pedigreeNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  price?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  priceFrom?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  priceTo?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  translations?: InputMaybe<LitterTranslationUncheckedUpdateManyWithoutLitterNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updates?: InputMaybe<UpdateUncheckedUpdateManyWithoutLitterNestedInput>;
  vaccinated?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  vaccinationDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type LitterUncheckedUpdateWithoutTranslationsInput = {
  adminNotes?: InputMaybe<AdminNoteUncheckedUpdateManyWithoutLitterNestedInput>;
  adminValidated?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  adminValidationDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  animalsBorn?: InputMaybe<AnimalUncheckedUpdateManyWithoutLitterNestedInput>;
  archived?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  availabilityDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  availabilityReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  bookmarks?: InputMaybe<BookmarkUncheckedUpdateManyWithoutLitterNestedInput>;
  born?: InputMaybe<BoolFieldUpdateOperationsInput>;
  breederId?: InputMaybe<IntFieldUpdateOperationsInput>;
  certified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dewormed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  dogBreedId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  femalesCount?: InputMaybe<IntFieldUpdateOperationsInput>;
  femalesLeftCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  fixedPrice?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hasFinishedOnboarding?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  imgs?: InputMaybe<LitterImgUncheckedUpdateManyWithoutLitterNestedInput>;
  litterCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  malesCount?: InputMaybe<IntFieldUpdateOperationsInput>;
  malesLeftCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  microchipped?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  microchips?: InputMaybe<Array<Scalars['String']['input']>>;
  notifications?: InputMaybe<NotificationUncheckedUpdateManyWithoutLitterNestedInput>;
  parents?: InputMaybe<LitterParentUncheckedUpdateManyWithoutLitterNestedInput>;
  pedigree?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pedigreeNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  price?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  priceFrom?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  priceTo?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updates?: InputMaybe<UpdateUncheckedUpdateManyWithoutLitterNestedInput>;
  vaccinated?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  vaccinationDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type LitterUncheckedUpdateWithoutUpdatesInput = {
  adminNotes?: InputMaybe<AdminNoteUncheckedUpdateManyWithoutLitterNestedInput>;
  adminValidated?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  adminValidationDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  animalsBorn?: InputMaybe<AnimalUncheckedUpdateManyWithoutLitterNestedInput>;
  archived?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  availabilityDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  availabilityReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  bookmarks?: InputMaybe<BookmarkUncheckedUpdateManyWithoutLitterNestedInput>;
  born?: InputMaybe<BoolFieldUpdateOperationsInput>;
  breederId?: InputMaybe<IntFieldUpdateOperationsInput>;
  certified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dewormed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  dogBreedId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  femalesCount?: InputMaybe<IntFieldUpdateOperationsInput>;
  femalesLeftCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  fixedPrice?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hasFinishedOnboarding?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  imgs?: InputMaybe<LitterImgUncheckedUpdateManyWithoutLitterNestedInput>;
  litterCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  malesCount?: InputMaybe<IntFieldUpdateOperationsInput>;
  malesLeftCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  microchipped?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  microchips?: InputMaybe<Array<Scalars['String']['input']>>;
  notifications?: InputMaybe<NotificationUncheckedUpdateManyWithoutLitterNestedInput>;
  parents?: InputMaybe<LitterParentUncheckedUpdateManyWithoutLitterNestedInput>;
  pedigree?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pedigreeNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  price?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  priceFrom?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  priceTo?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  translations?: InputMaybe<LitterTranslationUncheckedUpdateManyWithoutLitterNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  vaccinated?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  vaccinationDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type LitterUpdateInput = {
  adminNotes?: InputMaybe<AdminNoteUpdateManyWithoutLitterNestedInput>;
  adminValidated?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  adminValidationDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  animalsBorn?: InputMaybe<AnimalUpdateManyWithoutLitterNestedInput>;
  archived?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  availabilityDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  availabilityReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  bookmarks?: InputMaybe<BookmarkUpdateManyWithoutLitterNestedInput>;
  born?: InputMaybe<BoolFieldUpdateOperationsInput>;
  breeder?: InputMaybe<DogBreederUpdateOneRequiredWithoutLittersNestedInput>;
  certified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dewormed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  dogBreed?: InputMaybe<DogBreedUpdateOneWithoutLittersNestedInput>;
  femalesCount?: InputMaybe<IntFieldUpdateOperationsInput>;
  femalesLeftCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  fixedPrice?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hasFinishedOnboarding?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  imgs?: InputMaybe<LitterImgUpdateManyWithoutLitterNestedInput>;
  litterCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  malesCount?: InputMaybe<IntFieldUpdateOperationsInput>;
  malesLeftCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  microchipped?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  microchips?: InputMaybe<Array<Scalars['String']['input']>>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutLitterNestedInput>;
  parents?: InputMaybe<LitterParentUpdateManyWithoutLitterNestedInput>;
  pedigree?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pedigreeNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  price?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  priceFrom?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  priceTo?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  translations?: InputMaybe<LitterTranslationUpdateManyWithoutLitterNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updates?: InputMaybe<UpdateUpdateManyWithoutLitterNestedInput>;
  vaccinated?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  vaccinationDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type LitterUpdateManyMutationInput = {
  adminValidated?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  adminValidationDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  archived?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  availabilityDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  availabilityReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  born?: InputMaybe<BoolFieldUpdateOperationsInput>;
  certified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dewormed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  femalesCount?: InputMaybe<IntFieldUpdateOperationsInput>;
  femalesLeftCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  fixedPrice?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hasFinishedOnboarding?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  litterCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  malesCount?: InputMaybe<IntFieldUpdateOperationsInput>;
  malesLeftCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  microchipped?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  microchips?: InputMaybe<Array<Scalars['String']['input']>>;
  pedigree?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pedigreeNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  price?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  priceFrom?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  priceTo?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  vaccinated?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  vaccinationDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type LitterUpdateManyWithWhereWithoutBreederInput = {
  data: LitterUpdateManyMutationInput;
  where: LitterScalarWhereInput;
};

export type LitterUpdateManyWithWhereWithoutDogBreedInput = {
  data: LitterUpdateManyMutationInput;
  where: LitterScalarWhereInput;
};

export type LitterUpdateManyWithoutBreederNestedInput = {
  connect?: InputMaybe<Array<LitterWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LitterCreateOrConnectWithoutBreederInput>>;
  create?: InputMaybe<Array<LitterCreateWithoutBreederInput>>;
  createMany?: InputMaybe<LitterCreateManyBreederInputEnvelope>;
  delete?: InputMaybe<Array<LitterWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<LitterScalarWhereInput>>;
  disconnect?: InputMaybe<Array<LitterWhereUniqueInput>>;
  set?: InputMaybe<Array<LitterWhereUniqueInput>>;
  update?: InputMaybe<Array<LitterUpdateWithWhereUniqueWithoutBreederInput>>;
  updateMany?: InputMaybe<Array<LitterUpdateManyWithWhereWithoutBreederInput>>;
  upsert?: InputMaybe<Array<LitterUpsertWithWhereUniqueWithoutBreederInput>>;
};

export type LitterUpdateManyWithoutDogBreedNestedInput = {
  connect?: InputMaybe<Array<LitterWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LitterCreateOrConnectWithoutDogBreedInput>>;
  create?: InputMaybe<Array<LitterCreateWithoutDogBreedInput>>;
  createMany?: InputMaybe<LitterCreateManyDogBreedInputEnvelope>;
  delete?: InputMaybe<Array<LitterWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<LitterScalarWhereInput>>;
  disconnect?: InputMaybe<Array<LitterWhereUniqueInput>>;
  set?: InputMaybe<Array<LitterWhereUniqueInput>>;
  update?: InputMaybe<Array<LitterUpdateWithWhereUniqueWithoutDogBreedInput>>;
  updateMany?: InputMaybe<Array<LitterUpdateManyWithWhereWithoutDogBreedInput>>;
  upsert?: InputMaybe<Array<LitterUpsertWithWhereUniqueWithoutDogBreedInput>>;
};

export type LitterUpdateOneRequiredWithoutBookmarksNestedInput = {
  connect?: InputMaybe<LitterWhereUniqueInput>;
  connectOrCreate?: InputMaybe<LitterCreateOrConnectWithoutBookmarksInput>;
  create?: InputMaybe<LitterCreateWithoutBookmarksInput>;
  update?: InputMaybe<LitterUpdateToOneWithWhereWithoutBookmarksInput>;
  upsert?: InputMaybe<LitterUpsertWithoutBookmarksInput>;
};

export type LitterUpdateOneRequiredWithoutImgsNestedInput = {
  connect?: InputMaybe<LitterWhereUniqueInput>;
  connectOrCreate?: InputMaybe<LitterCreateOrConnectWithoutImgsInput>;
  create?: InputMaybe<LitterCreateWithoutImgsInput>;
  update?: InputMaybe<LitterUpdateToOneWithWhereWithoutImgsInput>;
  upsert?: InputMaybe<LitterUpsertWithoutImgsInput>;
};

export type LitterUpdateOneRequiredWithoutParentsNestedInput = {
  connect?: InputMaybe<LitterWhereUniqueInput>;
  connectOrCreate?: InputMaybe<LitterCreateOrConnectWithoutParentsInput>;
  create?: InputMaybe<LitterCreateWithoutParentsInput>;
  update?: InputMaybe<LitterUpdateToOneWithWhereWithoutParentsInput>;
  upsert?: InputMaybe<LitterUpsertWithoutParentsInput>;
};

export type LitterUpdateOneRequiredWithoutTranslationsNestedInput = {
  connect?: InputMaybe<LitterWhereUniqueInput>;
  connectOrCreate?: InputMaybe<LitterCreateOrConnectWithoutTranslationsInput>;
  create?: InputMaybe<LitterCreateWithoutTranslationsInput>;
  update?: InputMaybe<LitterUpdateToOneWithWhereWithoutTranslationsInput>;
  upsert?: InputMaybe<LitterUpsertWithoutTranslationsInput>;
};

export type LitterUpdateOneWithoutAdminNotesNestedInput = {
  connect?: InputMaybe<LitterWhereUniqueInput>;
  connectOrCreate?: InputMaybe<LitterCreateOrConnectWithoutAdminNotesInput>;
  create?: InputMaybe<LitterCreateWithoutAdminNotesInput>;
  delete?: InputMaybe<LitterWhereInput>;
  disconnect?: InputMaybe<LitterWhereInput>;
  update?: InputMaybe<LitterUpdateToOneWithWhereWithoutAdminNotesInput>;
  upsert?: InputMaybe<LitterUpsertWithoutAdminNotesInput>;
};

export type LitterUpdateOneWithoutAnimalsBornNestedInput = {
  connect?: InputMaybe<LitterWhereUniqueInput>;
  connectOrCreate?: InputMaybe<LitterCreateOrConnectWithoutAnimalsBornInput>;
  create?: InputMaybe<LitterCreateWithoutAnimalsBornInput>;
  delete?: InputMaybe<LitterWhereInput>;
  disconnect?: InputMaybe<LitterWhereInput>;
  update?: InputMaybe<LitterUpdateToOneWithWhereWithoutAnimalsBornInput>;
  upsert?: InputMaybe<LitterUpsertWithoutAnimalsBornInput>;
};

export type LitterUpdateOneWithoutNotificationsNestedInput = {
  connect?: InputMaybe<LitterWhereUniqueInput>;
  connectOrCreate?: InputMaybe<LitterCreateOrConnectWithoutNotificationsInput>;
  create?: InputMaybe<LitterCreateWithoutNotificationsInput>;
  delete?: InputMaybe<LitterWhereInput>;
  disconnect?: InputMaybe<LitterWhereInput>;
  update?: InputMaybe<LitterUpdateToOneWithWhereWithoutNotificationsInput>;
  upsert?: InputMaybe<LitterUpsertWithoutNotificationsInput>;
};

export type LitterUpdateOneWithoutUpdatesNestedInput = {
  connect?: InputMaybe<LitterWhereUniqueInput>;
  connectOrCreate?: InputMaybe<LitterCreateOrConnectWithoutUpdatesInput>;
  create?: InputMaybe<LitterCreateWithoutUpdatesInput>;
  delete?: InputMaybe<LitterWhereInput>;
  disconnect?: InputMaybe<LitterWhereInput>;
  update?: InputMaybe<LitterUpdateToOneWithWhereWithoutUpdatesInput>;
  upsert?: InputMaybe<LitterUpsertWithoutUpdatesInput>;
};

export type LitterUpdateToOneWithWhereWithoutAdminNotesInput = {
  data: LitterUpdateWithoutAdminNotesInput;
  where?: InputMaybe<LitterWhereInput>;
};

export type LitterUpdateToOneWithWhereWithoutAnimalsBornInput = {
  data: LitterUpdateWithoutAnimalsBornInput;
  where?: InputMaybe<LitterWhereInput>;
};

export type LitterUpdateToOneWithWhereWithoutBookmarksInput = {
  data: LitterUpdateWithoutBookmarksInput;
  where?: InputMaybe<LitterWhereInput>;
};

export type LitterUpdateToOneWithWhereWithoutImgsInput = {
  data: LitterUpdateWithoutImgsInput;
  where?: InputMaybe<LitterWhereInput>;
};

export type LitterUpdateToOneWithWhereWithoutNotificationsInput = {
  data: LitterUpdateWithoutNotificationsInput;
  where?: InputMaybe<LitterWhereInput>;
};

export type LitterUpdateToOneWithWhereWithoutParentsInput = {
  data: LitterUpdateWithoutParentsInput;
  where?: InputMaybe<LitterWhereInput>;
};

export type LitterUpdateToOneWithWhereWithoutTranslationsInput = {
  data: LitterUpdateWithoutTranslationsInput;
  where?: InputMaybe<LitterWhereInput>;
};

export type LitterUpdateToOneWithWhereWithoutUpdatesInput = {
  data: LitterUpdateWithoutUpdatesInput;
  where?: InputMaybe<LitterWhereInput>;
};

export type LitterUpdateWithWhereUniqueWithoutBreederInput = {
  data: LitterUpdateWithoutBreederInput;
  where: LitterWhereUniqueInput;
};

export type LitterUpdateWithWhereUniqueWithoutDogBreedInput = {
  data: LitterUpdateWithoutDogBreedInput;
  where: LitterWhereUniqueInput;
};

export type LitterUpdateWithoutAdminNotesInput = {
  adminValidated?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  adminValidationDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  animalsBorn?: InputMaybe<AnimalUpdateManyWithoutLitterNestedInput>;
  archived?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  availabilityDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  availabilityReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  bookmarks?: InputMaybe<BookmarkUpdateManyWithoutLitterNestedInput>;
  born?: InputMaybe<BoolFieldUpdateOperationsInput>;
  breeder?: InputMaybe<DogBreederUpdateOneRequiredWithoutLittersNestedInput>;
  certified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dewormed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  dogBreed?: InputMaybe<DogBreedUpdateOneWithoutLittersNestedInput>;
  femalesCount?: InputMaybe<IntFieldUpdateOperationsInput>;
  femalesLeftCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  fixedPrice?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hasFinishedOnboarding?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  imgs?: InputMaybe<LitterImgUpdateManyWithoutLitterNestedInput>;
  litterCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  malesCount?: InputMaybe<IntFieldUpdateOperationsInput>;
  malesLeftCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  microchipped?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  microchips?: InputMaybe<Array<Scalars['String']['input']>>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutLitterNestedInput>;
  parents?: InputMaybe<LitterParentUpdateManyWithoutLitterNestedInput>;
  pedigree?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pedigreeNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  price?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  priceFrom?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  priceTo?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  translations?: InputMaybe<LitterTranslationUpdateManyWithoutLitterNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updates?: InputMaybe<UpdateUpdateManyWithoutLitterNestedInput>;
  vaccinated?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  vaccinationDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type LitterUpdateWithoutAnimalsBornInput = {
  adminNotes?: InputMaybe<AdminNoteUpdateManyWithoutLitterNestedInput>;
  adminValidated?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  adminValidationDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  archived?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  availabilityDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  availabilityReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  bookmarks?: InputMaybe<BookmarkUpdateManyWithoutLitterNestedInput>;
  born?: InputMaybe<BoolFieldUpdateOperationsInput>;
  breeder?: InputMaybe<DogBreederUpdateOneRequiredWithoutLittersNestedInput>;
  certified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dewormed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  dogBreed?: InputMaybe<DogBreedUpdateOneWithoutLittersNestedInput>;
  femalesCount?: InputMaybe<IntFieldUpdateOperationsInput>;
  femalesLeftCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  fixedPrice?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hasFinishedOnboarding?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  imgs?: InputMaybe<LitterImgUpdateManyWithoutLitterNestedInput>;
  litterCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  malesCount?: InputMaybe<IntFieldUpdateOperationsInput>;
  malesLeftCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  microchipped?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  microchips?: InputMaybe<Array<Scalars['String']['input']>>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutLitterNestedInput>;
  parents?: InputMaybe<LitterParentUpdateManyWithoutLitterNestedInput>;
  pedigree?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pedigreeNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  price?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  priceFrom?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  priceTo?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  translations?: InputMaybe<LitterTranslationUpdateManyWithoutLitterNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updates?: InputMaybe<UpdateUpdateManyWithoutLitterNestedInput>;
  vaccinated?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  vaccinationDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type LitterUpdateWithoutBookmarksInput = {
  adminNotes?: InputMaybe<AdminNoteUpdateManyWithoutLitterNestedInput>;
  adminValidated?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  adminValidationDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  animalsBorn?: InputMaybe<AnimalUpdateManyWithoutLitterNestedInput>;
  archived?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  availabilityDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  availabilityReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  born?: InputMaybe<BoolFieldUpdateOperationsInput>;
  breeder?: InputMaybe<DogBreederUpdateOneRequiredWithoutLittersNestedInput>;
  certified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dewormed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  dogBreed?: InputMaybe<DogBreedUpdateOneWithoutLittersNestedInput>;
  femalesCount?: InputMaybe<IntFieldUpdateOperationsInput>;
  femalesLeftCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  fixedPrice?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hasFinishedOnboarding?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  imgs?: InputMaybe<LitterImgUpdateManyWithoutLitterNestedInput>;
  litterCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  malesCount?: InputMaybe<IntFieldUpdateOperationsInput>;
  malesLeftCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  microchipped?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  microchips?: InputMaybe<Array<Scalars['String']['input']>>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutLitterNestedInput>;
  parents?: InputMaybe<LitterParentUpdateManyWithoutLitterNestedInput>;
  pedigree?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pedigreeNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  price?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  priceFrom?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  priceTo?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  translations?: InputMaybe<LitterTranslationUpdateManyWithoutLitterNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updates?: InputMaybe<UpdateUpdateManyWithoutLitterNestedInput>;
  vaccinated?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  vaccinationDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type LitterUpdateWithoutBreederInput = {
  adminNotes?: InputMaybe<AdminNoteUpdateManyWithoutLitterNestedInput>;
  adminValidated?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  adminValidationDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  animalsBorn?: InputMaybe<AnimalUpdateManyWithoutLitterNestedInput>;
  archived?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  availabilityDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  availabilityReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  bookmarks?: InputMaybe<BookmarkUpdateManyWithoutLitterNestedInput>;
  born?: InputMaybe<BoolFieldUpdateOperationsInput>;
  certified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dewormed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  dogBreed?: InputMaybe<DogBreedUpdateOneWithoutLittersNestedInput>;
  femalesCount?: InputMaybe<IntFieldUpdateOperationsInput>;
  femalesLeftCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  fixedPrice?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hasFinishedOnboarding?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  imgs?: InputMaybe<LitterImgUpdateManyWithoutLitterNestedInput>;
  litterCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  malesCount?: InputMaybe<IntFieldUpdateOperationsInput>;
  malesLeftCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  microchipped?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  microchips?: InputMaybe<Array<Scalars['String']['input']>>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutLitterNestedInput>;
  parents?: InputMaybe<LitterParentUpdateManyWithoutLitterNestedInput>;
  pedigree?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pedigreeNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  price?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  priceFrom?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  priceTo?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  translations?: InputMaybe<LitterTranslationUpdateManyWithoutLitterNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updates?: InputMaybe<UpdateUpdateManyWithoutLitterNestedInput>;
  vaccinated?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  vaccinationDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type LitterUpdateWithoutDogBreedInput = {
  adminNotes?: InputMaybe<AdminNoteUpdateManyWithoutLitterNestedInput>;
  adminValidated?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  adminValidationDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  animalsBorn?: InputMaybe<AnimalUpdateManyWithoutLitterNestedInput>;
  archived?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  availabilityDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  availabilityReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  bookmarks?: InputMaybe<BookmarkUpdateManyWithoutLitterNestedInput>;
  born?: InputMaybe<BoolFieldUpdateOperationsInput>;
  breeder?: InputMaybe<DogBreederUpdateOneRequiredWithoutLittersNestedInput>;
  certified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dewormed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  femalesCount?: InputMaybe<IntFieldUpdateOperationsInput>;
  femalesLeftCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  fixedPrice?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hasFinishedOnboarding?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  imgs?: InputMaybe<LitterImgUpdateManyWithoutLitterNestedInput>;
  litterCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  malesCount?: InputMaybe<IntFieldUpdateOperationsInput>;
  malesLeftCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  microchipped?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  microchips?: InputMaybe<Array<Scalars['String']['input']>>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutLitterNestedInput>;
  parents?: InputMaybe<LitterParentUpdateManyWithoutLitterNestedInput>;
  pedigree?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pedigreeNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  price?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  priceFrom?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  priceTo?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  translations?: InputMaybe<LitterTranslationUpdateManyWithoutLitterNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updates?: InputMaybe<UpdateUpdateManyWithoutLitterNestedInput>;
  vaccinated?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  vaccinationDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type LitterUpdateWithoutImgsInput = {
  adminNotes?: InputMaybe<AdminNoteUpdateManyWithoutLitterNestedInput>;
  adminValidated?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  adminValidationDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  animalsBorn?: InputMaybe<AnimalUpdateManyWithoutLitterNestedInput>;
  archived?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  availabilityDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  availabilityReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  bookmarks?: InputMaybe<BookmarkUpdateManyWithoutLitterNestedInput>;
  born?: InputMaybe<BoolFieldUpdateOperationsInput>;
  breeder?: InputMaybe<DogBreederUpdateOneRequiredWithoutLittersNestedInput>;
  certified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dewormed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  dogBreed?: InputMaybe<DogBreedUpdateOneWithoutLittersNestedInput>;
  femalesCount?: InputMaybe<IntFieldUpdateOperationsInput>;
  femalesLeftCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  fixedPrice?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hasFinishedOnboarding?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  litterCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  malesCount?: InputMaybe<IntFieldUpdateOperationsInput>;
  malesLeftCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  microchipped?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  microchips?: InputMaybe<Array<Scalars['String']['input']>>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutLitterNestedInput>;
  parents?: InputMaybe<LitterParentUpdateManyWithoutLitterNestedInput>;
  pedigree?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pedigreeNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  price?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  priceFrom?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  priceTo?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  translations?: InputMaybe<LitterTranslationUpdateManyWithoutLitterNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updates?: InputMaybe<UpdateUpdateManyWithoutLitterNestedInput>;
  vaccinated?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  vaccinationDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type LitterUpdateWithoutNotificationsInput = {
  adminNotes?: InputMaybe<AdminNoteUpdateManyWithoutLitterNestedInput>;
  adminValidated?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  adminValidationDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  animalsBorn?: InputMaybe<AnimalUpdateManyWithoutLitterNestedInput>;
  archived?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  availabilityDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  availabilityReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  bookmarks?: InputMaybe<BookmarkUpdateManyWithoutLitterNestedInput>;
  born?: InputMaybe<BoolFieldUpdateOperationsInput>;
  breeder?: InputMaybe<DogBreederUpdateOneRequiredWithoutLittersNestedInput>;
  certified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dewormed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  dogBreed?: InputMaybe<DogBreedUpdateOneWithoutLittersNestedInput>;
  femalesCount?: InputMaybe<IntFieldUpdateOperationsInput>;
  femalesLeftCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  fixedPrice?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hasFinishedOnboarding?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  imgs?: InputMaybe<LitterImgUpdateManyWithoutLitterNestedInput>;
  litterCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  malesCount?: InputMaybe<IntFieldUpdateOperationsInput>;
  malesLeftCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  microchipped?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  microchips?: InputMaybe<Array<Scalars['String']['input']>>;
  parents?: InputMaybe<LitterParentUpdateManyWithoutLitterNestedInput>;
  pedigree?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pedigreeNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  price?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  priceFrom?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  priceTo?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  translations?: InputMaybe<LitterTranslationUpdateManyWithoutLitterNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updates?: InputMaybe<UpdateUpdateManyWithoutLitterNestedInput>;
  vaccinated?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  vaccinationDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type LitterUpdateWithoutParentsInput = {
  adminNotes?: InputMaybe<AdminNoteUpdateManyWithoutLitterNestedInput>;
  adminValidated?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  adminValidationDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  animalsBorn?: InputMaybe<AnimalUpdateManyWithoutLitterNestedInput>;
  archived?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  availabilityDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  availabilityReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  bookmarks?: InputMaybe<BookmarkUpdateManyWithoutLitterNestedInput>;
  born?: InputMaybe<BoolFieldUpdateOperationsInput>;
  breeder?: InputMaybe<DogBreederUpdateOneRequiredWithoutLittersNestedInput>;
  certified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dewormed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  dogBreed?: InputMaybe<DogBreedUpdateOneWithoutLittersNestedInput>;
  femalesCount?: InputMaybe<IntFieldUpdateOperationsInput>;
  femalesLeftCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  fixedPrice?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hasFinishedOnboarding?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  imgs?: InputMaybe<LitterImgUpdateManyWithoutLitterNestedInput>;
  litterCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  malesCount?: InputMaybe<IntFieldUpdateOperationsInput>;
  malesLeftCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  microchipped?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  microchips?: InputMaybe<Array<Scalars['String']['input']>>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutLitterNestedInput>;
  pedigree?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pedigreeNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  price?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  priceFrom?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  priceTo?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  translations?: InputMaybe<LitterTranslationUpdateManyWithoutLitterNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updates?: InputMaybe<UpdateUpdateManyWithoutLitterNestedInput>;
  vaccinated?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  vaccinationDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type LitterUpdateWithoutTranslationsInput = {
  adminNotes?: InputMaybe<AdminNoteUpdateManyWithoutLitterNestedInput>;
  adminValidated?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  adminValidationDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  animalsBorn?: InputMaybe<AnimalUpdateManyWithoutLitterNestedInput>;
  archived?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  availabilityDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  availabilityReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  bookmarks?: InputMaybe<BookmarkUpdateManyWithoutLitterNestedInput>;
  born?: InputMaybe<BoolFieldUpdateOperationsInput>;
  breeder?: InputMaybe<DogBreederUpdateOneRequiredWithoutLittersNestedInput>;
  certified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dewormed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  dogBreed?: InputMaybe<DogBreedUpdateOneWithoutLittersNestedInput>;
  femalesCount?: InputMaybe<IntFieldUpdateOperationsInput>;
  femalesLeftCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  fixedPrice?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hasFinishedOnboarding?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  imgs?: InputMaybe<LitterImgUpdateManyWithoutLitterNestedInput>;
  litterCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  malesCount?: InputMaybe<IntFieldUpdateOperationsInput>;
  malesLeftCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  microchipped?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  microchips?: InputMaybe<Array<Scalars['String']['input']>>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutLitterNestedInput>;
  parents?: InputMaybe<LitterParentUpdateManyWithoutLitterNestedInput>;
  pedigree?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pedigreeNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  price?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  priceFrom?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  priceTo?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updates?: InputMaybe<UpdateUpdateManyWithoutLitterNestedInput>;
  vaccinated?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  vaccinationDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type LitterUpdateWithoutUpdatesInput = {
  adminNotes?: InputMaybe<AdminNoteUpdateManyWithoutLitterNestedInput>;
  adminValidated?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  adminValidationDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  animalsBorn?: InputMaybe<AnimalUpdateManyWithoutLitterNestedInput>;
  archived?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  availabilityDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  availabilityReminderSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  bookmarks?: InputMaybe<BookmarkUpdateManyWithoutLitterNestedInput>;
  born?: InputMaybe<BoolFieldUpdateOperationsInput>;
  breeder?: InputMaybe<DogBreederUpdateOneRequiredWithoutLittersNestedInput>;
  certified?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dewormed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  dogBreed?: InputMaybe<DogBreedUpdateOneWithoutLittersNestedInput>;
  femalesCount?: InputMaybe<IntFieldUpdateOperationsInput>;
  femalesLeftCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  fixedPrice?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hasFinishedOnboarding?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  imgs?: InputMaybe<LitterImgUpdateManyWithoutLitterNestedInput>;
  litterCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  malesCount?: InputMaybe<IntFieldUpdateOperationsInput>;
  malesLeftCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  microchipped?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  microchips?: InputMaybe<Array<Scalars['String']['input']>>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutLitterNestedInput>;
  parents?: InputMaybe<LitterParentUpdateManyWithoutLitterNestedInput>;
  pedigree?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pedigreeNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  price?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  priceFrom?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  priceTo?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  translations?: InputMaybe<LitterTranslationUpdateManyWithoutLitterNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  vaccinated?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  vaccinationDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type LitterUpdatemicrochipsInput = {
  push?: InputMaybe<Array<Scalars['String']['input']>>;
  set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type LitterUpdatepedigreeNumbersInput = {
  push?: InputMaybe<Array<Scalars['String']['input']>>;
  set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type LitterUpdatetagsInput = {
  push?: InputMaybe<Array<Scalars['String']['input']>>;
  set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type LitterUpsertWithWhereUniqueWithoutBreederInput = {
  create: LitterCreateWithoutBreederInput;
  update: LitterUpdateWithoutBreederInput;
  where: LitterWhereUniqueInput;
};

export type LitterUpsertWithWhereUniqueWithoutDogBreedInput = {
  create: LitterCreateWithoutDogBreedInput;
  update: LitterUpdateWithoutDogBreedInput;
  where: LitterWhereUniqueInput;
};

export type LitterUpsertWithoutAdminNotesInput = {
  create: LitterCreateWithoutAdminNotesInput;
  update: LitterUpdateWithoutAdminNotesInput;
  where?: InputMaybe<LitterWhereInput>;
};

export type LitterUpsertWithoutAnimalsBornInput = {
  create: LitterCreateWithoutAnimalsBornInput;
  update: LitterUpdateWithoutAnimalsBornInput;
  where?: InputMaybe<LitterWhereInput>;
};

export type LitterUpsertWithoutBookmarksInput = {
  create: LitterCreateWithoutBookmarksInput;
  update: LitterUpdateWithoutBookmarksInput;
  where?: InputMaybe<LitterWhereInput>;
};

export type LitterUpsertWithoutImgsInput = {
  create: LitterCreateWithoutImgsInput;
  update: LitterUpdateWithoutImgsInput;
  where?: InputMaybe<LitterWhereInput>;
};

export type LitterUpsertWithoutNotificationsInput = {
  create: LitterCreateWithoutNotificationsInput;
  update: LitterUpdateWithoutNotificationsInput;
  where?: InputMaybe<LitterWhereInput>;
};

export type LitterUpsertWithoutParentsInput = {
  create: LitterCreateWithoutParentsInput;
  update: LitterUpdateWithoutParentsInput;
  where?: InputMaybe<LitterWhereInput>;
};

export type LitterUpsertWithoutTranslationsInput = {
  create: LitterCreateWithoutTranslationsInput;
  update: LitterUpdateWithoutTranslationsInput;
  where?: InputMaybe<LitterWhereInput>;
};

export type LitterUpsertWithoutUpdatesInput = {
  create: LitterCreateWithoutUpdatesInput;
  update: LitterUpdateWithoutUpdatesInput;
  where?: InputMaybe<LitterWhereInput>;
};

export type LitterWhereInput = {
  AND?: InputMaybe<Array<LitterWhereInput>>;
  NOT?: InputMaybe<Array<LitterWhereInput>>;
  OR?: InputMaybe<Array<LitterWhereInput>>;
  adminNotes?: InputMaybe<AdminNoteListRelationFilter>;
  adminValidated?: InputMaybe<BoolNullableFilter>;
  adminValidationDate?: InputMaybe<DateTimeNullableFilter>;
  animalsBorn?: InputMaybe<AnimalListRelationFilter>;
  archived?: InputMaybe<BoolNullableFilter>;
  availabilityDate?: InputMaybe<DateTimeNullableFilter>;
  availabilityReminderSent?: InputMaybe<BoolFilter>;
  birthday?: InputMaybe<DateTimeNullableFilter>;
  bookmarks?: InputMaybe<BookmarkListRelationFilter>;
  born?: InputMaybe<BoolFilter>;
  breeder?: InputMaybe<DogBreederRelationFilter>;
  breederId?: InputMaybe<IntFilter>;
  certified?: InputMaybe<BoolNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringNullableFilter>;
  dewormed?: InputMaybe<BoolNullableFilter>;
  dogBreed?: InputMaybe<DogBreedNullableRelationFilter>;
  dogBreedId?: InputMaybe<IntNullableFilter>;
  femalesCount?: InputMaybe<IntFilter>;
  femalesLeftCount?: InputMaybe<IntNullableFilter>;
  fixedPrice?: InputMaybe<BoolNullableFilter>;
  hasFinishedOnboarding?: InputMaybe<BoolNullableFilter>;
  id?: InputMaybe<IntFilter>;
  imgs?: InputMaybe<LitterImgListRelationFilter>;
  litterCode?: InputMaybe<StringNullableFilter>;
  malesCount?: InputMaybe<IntFilter>;
  malesLeftCount?: InputMaybe<IntNullableFilter>;
  microchipped?: InputMaybe<BoolNullableFilter>;
  microchips?: InputMaybe<StringNullableListFilter>;
  notifications?: InputMaybe<NotificationListRelationFilter>;
  parents?: InputMaybe<LitterParentListRelationFilter>;
  pedigree?: InputMaybe<StringNullableFilter>;
  pedigreeNumbers?: InputMaybe<StringNullableListFilter>;
  price?: InputMaybe<FloatNullableFilter>;
  priceFrom?: InputMaybe<FloatNullableFilter>;
  priceTo?: InputMaybe<FloatNullableFilter>;
  tags?: InputMaybe<StringNullableListFilter>;
  translations?: InputMaybe<LitterTranslationListRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  updates?: InputMaybe<UpdateListRelationFilter>;
  vaccinated?: InputMaybe<BoolNullableFilter>;
  vaccinationDate?: InputMaybe<DateTimeNullableFilter>;
};

export type LitterWhereUniqueInput = {
  AND?: InputMaybe<Array<LitterWhereInput>>;
  NOT?: InputMaybe<Array<LitterWhereInput>>;
  OR?: InputMaybe<Array<LitterWhereInput>>;
  adminNotes?: InputMaybe<AdminNoteListRelationFilter>;
  adminValidated?: InputMaybe<BoolNullableFilter>;
  adminValidationDate?: InputMaybe<DateTimeNullableFilter>;
  animalsBorn?: InputMaybe<AnimalListRelationFilter>;
  archived?: InputMaybe<BoolNullableFilter>;
  availabilityDate?: InputMaybe<DateTimeNullableFilter>;
  availabilityReminderSent?: InputMaybe<BoolFilter>;
  birthday?: InputMaybe<DateTimeNullableFilter>;
  bookmarks?: InputMaybe<BookmarkListRelationFilter>;
  born?: InputMaybe<BoolFilter>;
  breeder?: InputMaybe<DogBreederRelationFilter>;
  breederId?: InputMaybe<IntFilter>;
  certified?: InputMaybe<BoolNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringNullableFilter>;
  dewormed?: InputMaybe<BoolNullableFilter>;
  dogBreed?: InputMaybe<DogBreedNullableRelationFilter>;
  dogBreedId?: InputMaybe<IntNullableFilter>;
  femalesCount?: InputMaybe<IntFilter>;
  femalesLeftCount?: InputMaybe<IntNullableFilter>;
  fixedPrice?: InputMaybe<BoolNullableFilter>;
  hasFinishedOnboarding?: InputMaybe<BoolNullableFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  imgs?: InputMaybe<LitterImgListRelationFilter>;
  litterCode?: InputMaybe<StringNullableFilter>;
  malesCount?: InputMaybe<IntFilter>;
  malesLeftCount?: InputMaybe<IntNullableFilter>;
  microchipped?: InputMaybe<BoolNullableFilter>;
  microchips?: InputMaybe<StringNullableListFilter>;
  notifications?: InputMaybe<NotificationListRelationFilter>;
  parents?: InputMaybe<LitterParentListRelationFilter>;
  pedigree?: InputMaybe<StringNullableFilter>;
  pedigreeNumbers?: InputMaybe<StringNullableListFilter>;
  price?: InputMaybe<FloatNullableFilter>;
  priceFrom?: InputMaybe<FloatNullableFilter>;
  priceTo?: InputMaybe<FloatNullableFilter>;
  tags?: InputMaybe<StringNullableListFilter>;
  translations?: InputMaybe<LitterTranslationListRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  updates?: InputMaybe<UpdateListRelationFilter>;
  vaccinated?: InputMaybe<BoolNullableFilter>;
  vaccinationDate?: InputMaybe<DateTimeNullableFilter>;
};

export type LogInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  params?: InputMaybe<Scalars['String']['input']>;
};

export type ManageContactPreferencesInput = {
  contactPreferences?: InputMaybe<Array<InputMaybe<ContactPreference>>>;
  email: Scalars['String']['input'];
};

export type Message = {
  __typename?: 'Message';
  content?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  file?: Maybe<Scalars['String']['output']>;
  fromAccount: Account;
  fromAccountId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  img?: Maybe<Scalars['String']['output']>;
  notificationSent: Scalars['Boolean']['output'];
  reported: Scalars['Boolean']['output'];
  seen?: Maybe<Scalars['Boolean']['output']>;
  seenAt?: Maybe<Scalars['DateTime']['output']>;
  toAccount: Account;
  toAccountId: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type MessageAvgAggregateOutputType = {
  __typename?: 'MessageAvgAggregateOutputType';
  fromAccountId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  toAccountId?: Maybe<Scalars['Float']['output']>;
};

export type MessageAvgOrderByAggregateInput = {
  fromAccountId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  toAccountId?: InputMaybe<SortOrder>;
};

export type MessageCountAggregateOutputType = {
  __typename?: 'MessageCountAggregateOutputType';
  _all: Scalars['Int']['output'];
  content: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  file: Scalars['Int']['output'];
  fromAccountId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  img: Scalars['Int']['output'];
  notificationSent: Scalars['Int']['output'];
  reported: Scalars['Int']['output'];
  seen: Scalars['Int']['output'];
  seenAt: Scalars['Int']['output'];
  toAccountId: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type MessageCountOrderByAggregateInput = {
  content?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  file?: InputMaybe<SortOrder>;
  fromAccountId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  img?: InputMaybe<SortOrder>;
  notificationSent?: InputMaybe<SortOrder>;
  reported?: InputMaybe<SortOrder>;
  seen?: InputMaybe<SortOrder>;
  seenAt?: InputMaybe<SortOrder>;
  toAccountId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type MessageCreateInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  file?: InputMaybe<Scalars['String']['input']>;
  fromAccount: AccountCreateNestedOneWithoutSentMessagesInput;
  img?: InputMaybe<Scalars['String']['input']>;
  notificationSent?: InputMaybe<Scalars['Boolean']['input']>;
  reported?: InputMaybe<Scalars['Boolean']['input']>;
  seen?: InputMaybe<Scalars['Boolean']['input']>;
  seenAt?: InputMaybe<Scalars['DateTime']['input']>;
  toAccount: AccountCreateNestedOneWithoutReceivedMessagesInput;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type MessageCreateManyFromAccountInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  file?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  img?: InputMaybe<Scalars['String']['input']>;
  notificationSent?: InputMaybe<Scalars['Boolean']['input']>;
  reported?: InputMaybe<Scalars['Boolean']['input']>;
  seen?: InputMaybe<Scalars['Boolean']['input']>;
  seenAt?: InputMaybe<Scalars['DateTime']['input']>;
  toAccountId: Scalars['Int']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type MessageCreateManyFromAccountInputEnvelope = {
  data: Array<MessageCreateManyFromAccountInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MessageCreateManyInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  file?: InputMaybe<Scalars['String']['input']>;
  fromAccountId: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  img?: InputMaybe<Scalars['String']['input']>;
  notificationSent?: InputMaybe<Scalars['Boolean']['input']>;
  reported?: InputMaybe<Scalars['Boolean']['input']>;
  seen?: InputMaybe<Scalars['Boolean']['input']>;
  seenAt?: InputMaybe<Scalars['DateTime']['input']>;
  toAccountId: Scalars['Int']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type MessageCreateManyToAccountInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  file?: InputMaybe<Scalars['String']['input']>;
  fromAccountId: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  img?: InputMaybe<Scalars['String']['input']>;
  notificationSent?: InputMaybe<Scalars['Boolean']['input']>;
  reported?: InputMaybe<Scalars['Boolean']['input']>;
  seen?: InputMaybe<Scalars['Boolean']['input']>;
  seenAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type MessageCreateManyToAccountInputEnvelope = {
  data: Array<MessageCreateManyToAccountInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MessageCreateNestedManyWithoutFromAccountInput = {
  connect?: InputMaybe<Array<MessageWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MessageCreateOrConnectWithoutFromAccountInput>>;
  create?: InputMaybe<Array<MessageCreateWithoutFromAccountInput>>;
  createMany?: InputMaybe<MessageCreateManyFromAccountInputEnvelope>;
};

export type MessageCreateNestedManyWithoutToAccountInput = {
  connect?: InputMaybe<Array<MessageWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MessageCreateOrConnectWithoutToAccountInput>>;
  create?: InputMaybe<Array<MessageCreateWithoutToAccountInput>>;
  createMany?: InputMaybe<MessageCreateManyToAccountInputEnvelope>;
};

export type MessageCreateOrConnectWithoutFromAccountInput = {
  create: MessageCreateWithoutFromAccountInput;
  where: MessageWhereUniqueInput;
};

export type MessageCreateOrConnectWithoutToAccountInput = {
  create: MessageCreateWithoutToAccountInput;
  where: MessageWhereUniqueInput;
};

export type MessageCreateWithoutFromAccountInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  file?: InputMaybe<Scalars['String']['input']>;
  img?: InputMaybe<Scalars['String']['input']>;
  notificationSent?: InputMaybe<Scalars['Boolean']['input']>;
  reported?: InputMaybe<Scalars['Boolean']['input']>;
  seen?: InputMaybe<Scalars['Boolean']['input']>;
  seenAt?: InputMaybe<Scalars['DateTime']['input']>;
  toAccount: AccountCreateNestedOneWithoutReceivedMessagesInput;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type MessageCreateWithoutToAccountInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  file?: InputMaybe<Scalars['String']['input']>;
  fromAccount: AccountCreateNestedOneWithoutSentMessagesInput;
  img?: InputMaybe<Scalars['String']['input']>;
  notificationSent?: InputMaybe<Scalars['Boolean']['input']>;
  reported?: InputMaybe<Scalars['Boolean']['input']>;
  seen?: InputMaybe<Scalars['Boolean']['input']>;
  seenAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type MessageListRelationFilter = {
  every?: InputMaybe<MessageWhereInput>;
  none?: InputMaybe<MessageWhereInput>;
  some?: InputMaybe<MessageWhereInput>;
};

export type MessageMaxAggregateOutputType = {
  __typename?: 'MessageMaxAggregateOutputType';
  content?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  file?: Maybe<Scalars['String']['output']>;
  fromAccountId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  img?: Maybe<Scalars['String']['output']>;
  notificationSent?: Maybe<Scalars['Boolean']['output']>;
  reported?: Maybe<Scalars['Boolean']['output']>;
  seen?: Maybe<Scalars['Boolean']['output']>;
  seenAt?: Maybe<Scalars['DateTime']['output']>;
  toAccountId?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type MessageMaxOrderByAggregateInput = {
  content?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  file?: InputMaybe<SortOrder>;
  fromAccountId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  img?: InputMaybe<SortOrder>;
  notificationSent?: InputMaybe<SortOrder>;
  reported?: InputMaybe<SortOrder>;
  seen?: InputMaybe<SortOrder>;
  seenAt?: InputMaybe<SortOrder>;
  toAccountId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type MessageMinAggregateOutputType = {
  __typename?: 'MessageMinAggregateOutputType';
  content?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  file?: Maybe<Scalars['String']['output']>;
  fromAccountId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  img?: Maybe<Scalars['String']['output']>;
  notificationSent?: Maybe<Scalars['Boolean']['output']>;
  reported?: Maybe<Scalars['Boolean']['output']>;
  seen?: Maybe<Scalars['Boolean']['output']>;
  seenAt?: Maybe<Scalars['DateTime']['output']>;
  toAccountId?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type MessageMinOrderByAggregateInput = {
  content?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  file?: InputMaybe<SortOrder>;
  fromAccountId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  img?: InputMaybe<SortOrder>;
  notificationSent?: InputMaybe<SortOrder>;
  reported?: InputMaybe<SortOrder>;
  seen?: InputMaybe<SortOrder>;
  seenAt?: InputMaybe<SortOrder>;
  toAccountId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type MessageOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export enum MessageOrderByRelevanceFieldEnum {
  content = 'content',
  file = 'file',
  img = 'img'
}

export type MessageOrderByRelevanceInput = {
  fields: Array<MessageOrderByRelevanceFieldEnum>;
  search: Scalars['String']['input'];
  sort: SortOrder;
};

export type MessageOrderByWithAggregationInput = {
  _avg?: InputMaybe<MessageAvgOrderByAggregateInput>;
  _count?: InputMaybe<MessageCountOrderByAggregateInput>;
  _max?: InputMaybe<MessageMaxOrderByAggregateInput>;
  _min?: InputMaybe<MessageMinOrderByAggregateInput>;
  _sum?: InputMaybe<MessageSumOrderByAggregateInput>;
  content?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  file?: InputMaybe<SortOrderInput>;
  fromAccountId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  img?: InputMaybe<SortOrderInput>;
  notificationSent?: InputMaybe<SortOrder>;
  reported?: InputMaybe<SortOrder>;
  seen?: InputMaybe<SortOrderInput>;
  seenAt?: InputMaybe<SortOrderInput>;
  toAccountId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type MessageOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: InputMaybe<MessageOrderByRelevanceInput>;
  content?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  file?: InputMaybe<SortOrderInput>;
  fromAccount?: InputMaybe<AccountOrderByWithRelationAndSearchRelevanceInput>;
  fromAccountId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  img?: InputMaybe<SortOrderInput>;
  notificationSent?: InputMaybe<SortOrder>;
  reported?: InputMaybe<SortOrder>;
  seen?: InputMaybe<SortOrderInput>;
  seenAt?: InputMaybe<SortOrderInput>;
  toAccount?: InputMaybe<AccountOrderByWithRelationAndSearchRelevanceInput>;
  toAccountId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum MessageScalarFieldEnum {
  content = 'content',
  createdAt = 'createdAt',
  file = 'file',
  fromAccountId = 'fromAccountId',
  id = 'id',
  img = 'img',
  notificationSent = 'notificationSent',
  reported = 'reported',
  seen = 'seen',
  seenAt = 'seenAt',
  toAccountId = 'toAccountId',
  updatedAt = 'updatedAt'
}

export type MessageScalarWhereInput = {
  AND?: InputMaybe<Array<MessageScalarWhereInput>>;
  NOT?: InputMaybe<Array<MessageScalarWhereInput>>;
  OR?: InputMaybe<Array<MessageScalarWhereInput>>;
  content?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  file?: InputMaybe<StringNullableFilter>;
  fromAccountId?: InputMaybe<IntFilter>;
  id?: InputMaybe<IntFilter>;
  img?: InputMaybe<StringNullableFilter>;
  notificationSent?: InputMaybe<BoolFilter>;
  reported?: InputMaybe<BoolFilter>;
  seen?: InputMaybe<BoolNullableFilter>;
  seenAt?: InputMaybe<DateTimeNullableFilter>;
  toAccountId?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type MessageScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<MessageScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<MessageScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<MessageScalarWhereWithAggregatesInput>>;
  content?: InputMaybe<StringNullableWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  file?: InputMaybe<StringNullableWithAggregatesFilter>;
  fromAccountId?: InputMaybe<IntWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  img?: InputMaybe<StringNullableWithAggregatesFilter>;
  notificationSent?: InputMaybe<BoolWithAggregatesFilter>;
  reported?: InputMaybe<BoolWithAggregatesFilter>;
  seen?: InputMaybe<BoolNullableWithAggregatesFilter>;
  seenAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  toAccountId?: InputMaybe<IntWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type MessageSumAggregateOutputType = {
  __typename?: 'MessageSumAggregateOutputType';
  fromAccountId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  toAccountId?: Maybe<Scalars['Int']['output']>;
};

export type MessageSumOrderByAggregateInput = {
  fromAccountId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  toAccountId?: InputMaybe<SortOrder>;
};

export type MessageUncheckedCreateInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  file?: InputMaybe<Scalars['String']['input']>;
  fromAccountId: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  img?: InputMaybe<Scalars['String']['input']>;
  notificationSent?: InputMaybe<Scalars['Boolean']['input']>;
  reported?: InputMaybe<Scalars['Boolean']['input']>;
  seen?: InputMaybe<Scalars['Boolean']['input']>;
  seenAt?: InputMaybe<Scalars['DateTime']['input']>;
  toAccountId: Scalars['Int']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type MessageUncheckedCreateNestedManyWithoutFromAccountInput = {
  connect?: InputMaybe<Array<MessageWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MessageCreateOrConnectWithoutFromAccountInput>>;
  create?: InputMaybe<Array<MessageCreateWithoutFromAccountInput>>;
  createMany?: InputMaybe<MessageCreateManyFromAccountInputEnvelope>;
};

export type MessageUncheckedCreateNestedManyWithoutToAccountInput = {
  connect?: InputMaybe<Array<MessageWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MessageCreateOrConnectWithoutToAccountInput>>;
  create?: InputMaybe<Array<MessageCreateWithoutToAccountInput>>;
  createMany?: InputMaybe<MessageCreateManyToAccountInputEnvelope>;
};

export type MessageUncheckedCreateWithoutFromAccountInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  file?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  img?: InputMaybe<Scalars['String']['input']>;
  notificationSent?: InputMaybe<Scalars['Boolean']['input']>;
  reported?: InputMaybe<Scalars['Boolean']['input']>;
  seen?: InputMaybe<Scalars['Boolean']['input']>;
  seenAt?: InputMaybe<Scalars['DateTime']['input']>;
  toAccountId: Scalars['Int']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type MessageUncheckedCreateWithoutToAccountInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  file?: InputMaybe<Scalars['String']['input']>;
  fromAccountId: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  img?: InputMaybe<Scalars['String']['input']>;
  notificationSent?: InputMaybe<Scalars['Boolean']['input']>;
  reported?: InputMaybe<Scalars['Boolean']['input']>;
  seen?: InputMaybe<Scalars['Boolean']['input']>;
  seenAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type MessageUncheckedUpdateInput = {
  content?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  file?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  fromAccountId?: InputMaybe<IntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  img?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  notificationSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  reported?: InputMaybe<BoolFieldUpdateOperationsInput>;
  seen?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  seenAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  toAccountId?: InputMaybe<IntFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type MessageUncheckedUpdateManyInput = {
  content?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  file?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  fromAccountId?: InputMaybe<IntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  img?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  notificationSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  reported?: InputMaybe<BoolFieldUpdateOperationsInput>;
  seen?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  seenAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  toAccountId?: InputMaybe<IntFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type MessageUncheckedUpdateManyWithoutFromAccountInput = {
  content?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  file?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  img?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  notificationSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  reported?: InputMaybe<BoolFieldUpdateOperationsInput>;
  seen?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  seenAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  toAccountId?: InputMaybe<IntFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type MessageUncheckedUpdateManyWithoutFromAccountNestedInput = {
  connect?: InputMaybe<Array<MessageWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MessageCreateOrConnectWithoutFromAccountInput>>;
  create?: InputMaybe<Array<MessageCreateWithoutFromAccountInput>>;
  createMany?: InputMaybe<MessageCreateManyFromAccountInputEnvelope>;
  delete?: InputMaybe<Array<MessageWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MessageScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MessageWhereUniqueInput>>;
  set?: InputMaybe<Array<MessageWhereUniqueInput>>;
  update?: InputMaybe<Array<MessageUpdateWithWhereUniqueWithoutFromAccountInput>>;
  updateMany?: InputMaybe<Array<MessageUpdateManyWithWhereWithoutFromAccountInput>>;
  upsert?: InputMaybe<Array<MessageUpsertWithWhereUniqueWithoutFromAccountInput>>;
};

export type MessageUncheckedUpdateManyWithoutToAccountInput = {
  content?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  file?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  fromAccountId?: InputMaybe<IntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  img?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  notificationSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  reported?: InputMaybe<BoolFieldUpdateOperationsInput>;
  seen?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  seenAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type MessageUncheckedUpdateManyWithoutToAccountNestedInput = {
  connect?: InputMaybe<Array<MessageWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MessageCreateOrConnectWithoutToAccountInput>>;
  create?: InputMaybe<Array<MessageCreateWithoutToAccountInput>>;
  createMany?: InputMaybe<MessageCreateManyToAccountInputEnvelope>;
  delete?: InputMaybe<Array<MessageWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MessageScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MessageWhereUniqueInput>>;
  set?: InputMaybe<Array<MessageWhereUniqueInput>>;
  update?: InputMaybe<Array<MessageUpdateWithWhereUniqueWithoutToAccountInput>>;
  updateMany?: InputMaybe<Array<MessageUpdateManyWithWhereWithoutToAccountInput>>;
  upsert?: InputMaybe<Array<MessageUpsertWithWhereUniqueWithoutToAccountInput>>;
};

export type MessageUncheckedUpdateWithoutFromAccountInput = {
  content?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  file?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  img?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  notificationSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  reported?: InputMaybe<BoolFieldUpdateOperationsInput>;
  seen?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  seenAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  toAccountId?: InputMaybe<IntFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type MessageUncheckedUpdateWithoutToAccountInput = {
  content?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  file?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  fromAccountId?: InputMaybe<IntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  img?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  notificationSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  reported?: InputMaybe<BoolFieldUpdateOperationsInput>;
  seen?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  seenAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type MessageUpdateInput = {
  content?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  file?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  fromAccount?: InputMaybe<AccountUpdateOneRequiredWithoutSentMessagesNestedInput>;
  img?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  notificationSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  reported?: InputMaybe<BoolFieldUpdateOperationsInput>;
  seen?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  seenAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  toAccount?: InputMaybe<AccountUpdateOneRequiredWithoutReceivedMessagesNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type MessageUpdateManyMutationInput = {
  content?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  file?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  img?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  notificationSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  reported?: InputMaybe<BoolFieldUpdateOperationsInput>;
  seen?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  seenAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type MessageUpdateManyWithWhereWithoutFromAccountInput = {
  data: MessageUpdateManyMutationInput;
  where: MessageScalarWhereInput;
};

export type MessageUpdateManyWithWhereWithoutToAccountInput = {
  data: MessageUpdateManyMutationInput;
  where: MessageScalarWhereInput;
};

export type MessageUpdateManyWithoutFromAccountNestedInput = {
  connect?: InputMaybe<Array<MessageWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MessageCreateOrConnectWithoutFromAccountInput>>;
  create?: InputMaybe<Array<MessageCreateWithoutFromAccountInput>>;
  createMany?: InputMaybe<MessageCreateManyFromAccountInputEnvelope>;
  delete?: InputMaybe<Array<MessageWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MessageScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MessageWhereUniqueInput>>;
  set?: InputMaybe<Array<MessageWhereUniqueInput>>;
  update?: InputMaybe<Array<MessageUpdateWithWhereUniqueWithoutFromAccountInput>>;
  updateMany?: InputMaybe<Array<MessageUpdateManyWithWhereWithoutFromAccountInput>>;
  upsert?: InputMaybe<Array<MessageUpsertWithWhereUniqueWithoutFromAccountInput>>;
};

export type MessageUpdateManyWithoutToAccountNestedInput = {
  connect?: InputMaybe<Array<MessageWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MessageCreateOrConnectWithoutToAccountInput>>;
  create?: InputMaybe<Array<MessageCreateWithoutToAccountInput>>;
  createMany?: InputMaybe<MessageCreateManyToAccountInputEnvelope>;
  delete?: InputMaybe<Array<MessageWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MessageScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MessageWhereUniqueInput>>;
  set?: InputMaybe<Array<MessageWhereUniqueInput>>;
  update?: InputMaybe<Array<MessageUpdateWithWhereUniqueWithoutToAccountInput>>;
  updateMany?: InputMaybe<Array<MessageUpdateManyWithWhereWithoutToAccountInput>>;
  upsert?: InputMaybe<Array<MessageUpsertWithWhereUniqueWithoutToAccountInput>>;
};

export type MessageUpdateWithWhereUniqueWithoutFromAccountInput = {
  data: MessageUpdateWithoutFromAccountInput;
  where: MessageWhereUniqueInput;
};

export type MessageUpdateWithWhereUniqueWithoutToAccountInput = {
  data: MessageUpdateWithoutToAccountInput;
  where: MessageWhereUniqueInput;
};

export type MessageUpdateWithoutFromAccountInput = {
  content?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  file?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  img?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  notificationSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  reported?: InputMaybe<BoolFieldUpdateOperationsInput>;
  seen?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  seenAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  toAccount?: InputMaybe<AccountUpdateOneRequiredWithoutReceivedMessagesNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type MessageUpdateWithoutToAccountInput = {
  content?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  file?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  fromAccount?: InputMaybe<AccountUpdateOneRequiredWithoutSentMessagesNestedInput>;
  img?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  notificationSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  reported?: InputMaybe<BoolFieldUpdateOperationsInput>;
  seen?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  seenAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type MessageUpsertWithWhereUniqueWithoutFromAccountInput = {
  create: MessageCreateWithoutFromAccountInput;
  update: MessageUpdateWithoutFromAccountInput;
  where: MessageWhereUniqueInput;
};

export type MessageUpsertWithWhereUniqueWithoutToAccountInput = {
  create: MessageCreateWithoutToAccountInput;
  update: MessageUpdateWithoutToAccountInput;
  where: MessageWhereUniqueInput;
};

export type MessageWhereInput = {
  AND?: InputMaybe<Array<MessageWhereInput>>;
  NOT?: InputMaybe<Array<MessageWhereInput>>;
  OR?: InputMaybe<Array<MessageWhereInput>>;
  content?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  file?: InputMaybe<StringNullableFilter>;
  fromAccount?: InputMaybe<AccountRelationFilter>;
  fromAccountId?: InputMaybe<IntFilter>;
  id?: InputMaybe<IntFilter>;
  img?: InputMaybe<StringNullableFilter>;
  notificationSent?: InputMaybe<BoolFilter>;
  reported?: InputMaybe<BoolFilter>;
  seen?: InputMaybe<BoolNullableFilter>;
  seenAt?: InputMaybe<DateTimeNullableFilter>;
  toAccount?: InputMaybe<AccountRelationFilter>;
  toAccountId?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type MessageWhereUniqueInput = {
  AND?: InputMaybe<Array<MessageWhereInput>>;
  NOT?: InputMaybe<Array<MessageWhereInput>>;
  OR?: InputMaybe<Array<MessageWhereInput>>;
  content?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  file?: InputMaybe<StringNullableFilter>;
  fromAccount?: InputMaybe<AccountRelationFilter>;
  fromAccountId?: InputMaybe<IntFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  img?: InputMaybe<StringNullableFilter>;
  notificationSent?: InputMaybe<BoolFilter>;
  reported?: InputMaybe<BoolFilter>;
  seen?: InputMaybe<BoolNullableFilter>;
  seenAt?: InputMaybe<DateTimeNullableFilter>;
  toAccount?: InputMaybe<AccountRelationFilter>;
  toAccountId?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type MissingTranslationAvgAggregateOutputType = {
  __typename?: 'MissingTranslationAvgAggregateOutputType';
  count?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

export type MissingTranslationAvgOrderByAggregateInput = {
  count?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export type MissingTranslationCountAggregateOutputType = {
  __typename?: 'MissingTranslationCountAggregateOutputType';
  _all: Scalars['Int']['output'];
  archived: Scalars['Int']['output'];
  count: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  key: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type MissingTranslationCountOrderByAggregateInput = {
  archived?: InputMaybe<SortOrder>;
  count?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  key?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type MissingTranslationCreateInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  count?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  key: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type MissingTranslationCreateManyInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  count?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  key: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type MissingTranslationMaxAggregateOutputType = {
  __typename?: 'MissingTranslationMaxAggregateOutputType';
  archived?: Maybe<Scalars['Boolean']['output']>;
  count?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type MissingTranslationMaxOrderByAggregateInput = {
  archived?: InputMaybe<SortOrder>;
  count?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  key?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type MissingTranslationMinAggregateOutputType = {
  __typename?: 'MissingTranslationMinAggregateOutputType';
  archived?: Maybe<Scalars['Boolean']['output']>;
  count?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type MissingTranslationMinOrderByAggregateInput = {
  archived?: InputMaybe<SortOrder>;
  count?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  key?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum MissingTranslationOrderByRelevanceFieldEnum {
  key = 'key'
}

export type MissingTranslationOrderByRelevanceInput = {
  fields: Array<MissingTranslationOrderByRelevanceFieldEnum>;
  search: Scalars['String']['input'];
  sort: SortOrder;
};

export type MissingTranslationOrderByWithAggregationInput = {
  _avg?: InputMaybe<MissingTranslationAvgOrderByAggregateInput>;
  _count?: InputMaybe<MissingTranslationCountOrderByAggregateInput>;
  _max?: InputMaybe<MissingTranslationMaxOrderByAggregateInput>;
  _min?: InputMaybe<MissingTranslationMinOrderByAggregateInput>;
  _sum?: InputMaybe<MissingTranslationSumOrderByAggregateInput>;
  archived?: InputMaybe<SortOrder>;
  count?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  key?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type MissingTranslationOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: InputMaybe<MissingTranslationOrderByRelevanceInput>;
  archived?: InputMaybe<SortOrder>;
  count?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  key?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum MissingTranslationScalarFieldEnum {
  archived = 'archived',
  count = 'count',
  createdAt = 'createdAt',
  id = 'id',
  key = 'key',
  updatedAt = 'updatedAt'
}

export type MissingTranslationScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<MissingTranslationScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<MissingTranslationScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<MissingTranslationScalarWhereWithAggregatesInput>>;
  archived?: InputMaybe<BoolWithAggregatesFilter>;
  count?: InputMaybe<IntWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  key?: InputMaybe<StringWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type MissingTranslationSumAggregateOutputType = {
  __typename?: 'MissingTranslationSumAggregateOutputType';
  count?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
};

export type MissingTranslationSumOrderByAggregateInput = {
  count?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export type MissingTranslationUncheckedCreateInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  count?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  key: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type MissingTranslationUncheckedUpdateInput = {
  archived?: InputMaybe<BoolFieldUpdateOperationsInput>;
  count?: InputMaybe<IntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  key?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type MissingTranslationUncheckedUpdateManyInput = {
  archived?: InputMaybe<BoolFieldUpdateOperationsInput>;
  count?: InputMaybe<IntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  key?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type MissingTranslationUpdateInput = {
  archived?: InputMaybe<BoolFieldUpdateOperationsInput>;
  count?: InputMaybe<IntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  key?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type MissingTranslationUpdateManyMutationInput = {
  archived?: InputMaybe<BoolFieldUpdateOperationsInput>;
  count?: InputMaybe<IntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  key?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type MissingTranslationWhereInput = {
  AND?: InputMaybe<Array<MissingTranslationWhereInput>>;
  NOT?: InputMaybe<Array<MissingTranslationWhereInput>>;
  OR?: InputMaybe<Array<MissingTranslationWhereInput>>;
  archived?: InputMaybe<BoolFilter>;
  count?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntFilter>;
  key?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type MissingTranslationWhereUniqueInput = {
  AND?: InputMaybe<Array<MissingTranslationWhereInput>>;
  NOT?: InputMaybe<Array<MissingTranslationWhereInput>>;
  OR?: InputMaybe<Array<MissingTranslationWhereInput>>;
  archived?: InputMaybe<BoolFilter>;
  count?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type Mutation = {
  __typename?: 'Mutation';
  accountMeUpdate: Account;
  autocompleteSuggestions?: Maybe<Array<Maybe<AutocompleteSuggestion>>>;
  cancelApplication: DogBreederApplication;
  checkoutApplication: Scalars['String']['output'];
  confirmCreateApplication: DogBreederApplication;
  contactSupport?: Maybe<Scalars['Boolean']['output']>;
  createAccount?: Maybe<AccountWithToken>;
  createAnimal: Animal;
  createBooking: Booking;
  createDogBreedInterestSubscription: DogBreedInterestSubscription;
  createDogBreederReview: DogBreederReview;
  createDraftApplication: DogBreederApplication;
  createEducatorReview: EducatorReview;
  createEmailContact: EmailContact;
  createLitter: Litter;
  createOneBookingAnimal: BookingAnimal;
  createOneDogBreederTranslation: DogBreederTranslation;
  createOneLitterParent: LitterParent;
  createOneLitterTranslation: LitterTranslation;
  deleteAccount: Scalars['Boolean']['output'];
  deleteAnimal: Scalars['Boolean']['output'];
  deleteApplication: DogBreederApplication;
  deleteBooking: BookingDeleteOutput;
  deleteConversation: Scalars['Int']['output'];
  deleteManyBookingAnimal?: Maybe<BatchPayload>;
  deleteManyDogBreederTranslation?: Maybe<BatchPayload>;
  deleteManyLitterParent?: Maybe<BatchPayload>;
  deleteManyLitterTranslation?: Maybe<BatchPayload>;
  deleteMessage: Message;
  deleteOneBookingAnimal?: Maybe<BookingAnimal>;
  deleteOneDogBreederTranslation?: Maybe<DogBreederTranslation>;
  deleteOneLitterParent?: Maybe<LitterParent>;
  deleteOneLitterTranslation?: Maybe<LitterTranslation>;
  incrementProViewCount: Scalars['Boolean']['output'];
  linkAccount: Account;
  linkProfessionalCalendar?: Maybe<Scalars['Boolean']['output']>;
  log?: Maybe<Scalars['Boolean']['output']>;
  logContactInfoClick: Scalars['Boolean']['output'];
  logPasswordReset?: Maybe<Scalars['Boolean']['output']>;
  login?: Maybe<AccountWithToken>;
  manageContactPreferences?: Maybe<Scalars['Boolean']['output']>;
  markAsRead: Scalars['Int']['output'];
  openApplication: Scalars['Boolean']['output'];
  ownApplication: DogBreederApplication;
  persistHasADog?: Maybe<Scalars['Boolean']['output']>;
  sendMessage: Message;
  sendPasswordResetEmail: Scalars['Boolean']['output'];
  toggleDogBreedInDogBreedInterestSubscription: DogBreedInterestSubscription;
  unlinkAccount: Account;
  updateAnimal: Animal;
  updateBooking: Booking;
  updateDogBreederReview: DogBreederReview;
  updateLitter: Litter;
  updateManyBookingAnimal?: Maybe<BatchPayload>;
  updateManyDogBreederTranslation?: Maybe<BatchPayload>;
  updateManyLitterParent?: Maybe<BatchPayload>;
  updateManyLitterTranslation?: Maybe<BatchPayload>;
  updateOneBookingAnimal: BookingAnimal;
  updateOneDogBreederTranslation: DogBreederTranslation;
  updateOneLitterParent: LitterParent;
  updateOneLitterTranslation: LitterTranslation;
  updatePassword: AccountWithToken;
  upsertOneBookingAnimal?: Maybe<BookingAnimal>;
  upsertOneDogBreederTranslation?: Maybe<DogBreederTranslation>;
  upsertOneLitterParent?: Maybe<LitterParent>;
  upsertOneLitterTranslation?: Maybe<LitterTranslation>;
  waitlistApplication: DogBreederApplication;
};


export type MutationaccountMeUpdateArgs = {
  data: AccountUpdateInput;
  dogBreederBreedClubFilesUpload?: InputMaybe<Array<InputMaybe<Scalars['Upload']['input']>>>;
  dogBreederCertificationFileUpload?: InputMaybe<Scalars['Upload']['input']>;
  dogBreederHkFileUpload?: InputMaybe<Scalars['Upload']['input']>;
  dogBreederIdentityFilesUpload?: InputMaybe<Array<InputMaybe<Scalars['Upload']['input']>>>;
  dogBreederImageIdsRemoved?: InputMaybe<Array<Scalars['Int']['input']>>;
  dogBreederImagesUpload?: InputMaybe<Array<AccountDogBreederImgUploadInput>>;
  dogBreederPermissionFilesUpload?: InputMaybe<Array<InputMaybe<Scalars['Upload']['input']>>>;
  femaleBreedersCount?: InputMaybe<Scalars['Int']['input']>;
  profileImage?: InputMaybe<Scalars['Upload']['input']>;
};


export type MutationautocompleteSuggestionsArgs = {
  country?: InputMaybe<Scalars['String']['input']>;
  language: Scalars['String']['input'];
  location?: InputMaybe<Scalars['String']['input']>;
  placeId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationcancelApplicationArgs = {
  applicationId: Scalars['Int']['input'];
};


export type MutationcheckoutApplicationArgs = {
  input: CheckoutApplicationInput;
};


export type MutationconfirmCreateApplicationArgs = {
  data: CreateApplicationInput;
};


export type MutationcontactSupportArgs = {
  contactReasonType: ContactReasonTypeEnum;
  country?: InputMaybe<CountryCode>;
  email: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  language: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  messageContent?: InputMaybe<Scalars['String']['input']>;
  messageSubject?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};


export type MutationcreateAccountArgs = {
  data: AccountCreateInput;
};


export type MutationcreateAnimalArgs = {
  anonymousOwnerId?: InputMaybe<Scalars['Int']['input']>;
  createdFrom?: InputMaybe<AnimalStatCreatedFromEnum>;
  data: AnimalCreateInput;
  imageUpload?: InputMaybe<Scalars['Upload']['input']>;
  passportFileUpload?: InputMaybe<Scalars['Upload']['input']>;
};


export type MutationcreateBookingArgs = {
  bookingAnimals: Array<BookingAnimalCreate>;
  bookingReason: Scalars['String']['input'];
  forMultiAnimals?: InputMaybe<Scalars['Boolean']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  startDateTime: Scalars['DateTime']['input'];
  workerServiceId: Scalars['Int']['input'];
};


export type MutationcreateDogBreedInterestSubscriptionArgs = {
  data: CreateDogBreedInterestSubscriptionInput;
};


export type MutationcreateDogBreederReviewArgs = {
  data: CreateDogBreederReviewInput;
};


export type MutationcreateDraftApplicationArgs = {
  data: CreateApplicationInput;
};


export type MutationcreateEducatorReviewArgs = {
  data: CreateEducatorReviewInput;
};


export type MutationcreateEmailContactArgs = {
  data: CreateEmailContactInput;
};


export type MutationcreateLitterArgs = {
  data: CreateLitterInput;
  imagesUpload?: InputMaybe<Array<Scalars['Upload']['input']>>;
};


export type MutationcreateOneBookingAnimalArgs = {
  data: BookingAnimalCreateInput;
};


export type MutationcreateOneDogBreederTranslationArgs = {
  data: DogBreederTranslationCreateInput;
};


export type MutationcreateOneLitterParentArgs = {
  data: LitterParentCreateInput;
};


export type MutationcreateOneLitterTranslationArgs = {
  data: LitterTranslationCreateInput;
};


export type MutationdeleteAccountArgs = {
  feedback: Scalars['String']['input'];
};


export type MutationdeleteAnimalArgs = {
  animalId: Scalars['Int']['input'];
};


export type MutationdeleteApplicationArgs = {
  data: DeleteApplicationInput;
};


export type MutationdeleteBookingArgs = {
  bookingId: Scalars['Int']['input'];
};


export type MutationdeleteConversationArgs = {
  conversationId: Scalars['Int']['input'];
};


export type MutationdeleteManyBookingAnimalArgs = {
  where?: InputMaybe<BookingAnimalWhereInput>;
};


export type MutationdeleteManyDogBreederTranslationArgs = {
  where?: InputMaybe<DogBreederTranslationWhereInput>;
};


export type MutationdeleteManyLitterParentArgs = {
  where?: InputMaybe<LitterParentWhereInput>;
};


export type MutationdeleteManyLitterTranslationArgs = {
  where?: InputMaybe<LitterTranslationWhereInput>;
};


export type MutationdeleteMessageArgs = {
  id: Scalars['Int']['input'];
};


export type MutationdeleteOneBookingAnimalArgs = {
  where: BookingAnimalWhereUniqueInput;
};


export type MutationdeleteOneDogBreederTranslationArgs = {
  where: DogBreederTranslationWhereUniqueInput;
};


export type MutationdeleteOneLitterParentArgs = {
  where: LitterParentWhereUniqueInput;
};


export type MutationdeleteOneLitterTranslationArgs = {
  where: LitterTranslationWhereUniqueInput;
};


export type MutationincrementProViewCountArgs = {
  proId: Scalars['Int']['input'];
};


export type MutationlinkAccountArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  facebookToken?: InputMaybe<Scalars['String']['input']>;
  googleToken?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
};


export type MutationlinkProfessionalCalendarArgs = {
  code: Scalars['String']['input'];
};


export type MutationlogArgs = {
  data: LogInput;
};


export type MutationlogContactInfoClickArgs = {
  proId: Scalars['Int']['input'];
};


export type MutationlogPasswordResetArgs = {
  actionCode?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
};


export type MutationloginArgs = {
  data: AccountLoginInput;
};


export type MutationmanageContactPreferencesArgs = {
  data: ManageContactPreferencesInput;
};


export type MutationmarkAsReadArgs = {
  notificationId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationopenApplicationArgs = {
  applicationId: Scalars['Int']['input'];
};


export type MutationownApplicationArgs = {
  data: OwnApplicationInput;
};


export type MutationpersistHasADogArgs = {
  data: PersistHasADogInput;
};


export type MutationsendMessageArgs = {
  data: SendMessageInput;
};


export type MutationsendPasswordResetEmailArgs = {
  email: Scalars['String']['input'];
};


export type MutationtoggleDogBreedInDogBreedInterestSubscriptionArgs = {
  data: ToggleDogBreedInDogBreedInterestSubscriptionInput;
};


export type MutationunlinkAccountArgs = {
  type: AuthTokenInfoType;
};


export type MutationupdateAnimalArgs = {
  animalId: Scalars['Int']['input'];
  data: AnimalUpdateInput;
  imageUpload?: InputMaybe<Scalars['Upload']['input']>;
  passportFileUpload?: InputMaybe<Scalars['Upload']['input']>;
};


export type MutationupdateBookingArgs = {
  bookingId: Scalars['Int']['input'];
  startDateTime: Scalars['DateTime']['input'];
};


export type MutationupdateDogBreederReviewArgs = {
  data: DogBreederReviewUpdateInput;
  reviewId: Scalars['Int']['input'];
};


export type MutationupdateLitterArgs = {
  data: UpdateLitterInput;
  imageIdsRemoved?: InputMaybe<Array<Scalars['Int']['input']>>;
  imagesUpload?: InputMaybe<Array<Scalars['Upload']['input']>>;
  litterId: Scalars['Int']['input'];
};


export type MutationupdateManyBookingAnimalArgs = {
  data: BookingAnimalUpdateManyMutationInput;
  where?: InputMaybe<BookingAnimalWhereInput>;
};


export type MutationupdateManyDogBreederTranslationArgs = {
  data: DogBreederTranslationUpdateManyMutationInput;
  where?: InputMaybe<DogBreederTranslationWhereInput>;
};


export type MutationupdateManyLitterParentArgs = {
  data: LitterParentUpdateManyMutationInput;
  where?: InputMaybe<LitterParentWhereInput>;
};


export type MutationupdateManyLitterTranslationArgs = {
  data: LitterTranslationUpdateManyMutationInput;
  where?: InputMaybe<LitterTranslationWhereInput>;
};


export type MutationupdateOneBookingAnimalArgs = {
  data: BookingAnimalUpdateInput;
  where: BookingAnimalWhereUniqueInput;
};


export type MutationupdateOneDogBreederTranslationArgs = {
  data: DogBreederTranslationUpdateInput;
  where: DogBreederTranslationWhereUniqueInput;
};


export type MutationupdateOneLitterParentArgs = {
  data: LitterParentUpdateInput;
  where: LitterParentWhereUniqueInput;
};


export type MutationupdateOneLitterTranslationArgs = {
  data: LitterTranslationUpdateInput;
  where: LitterTranslationWhereUniqueInput;
};


export type MutationupdatePasswordArgs = {
  password: Scalars['String']['input'];
};


export type MutationupsertOneBookingAnimalArgs = {
  create: BookingAnimalCreateInput;
  update: BookingAnimalUpdateInput;
  where: BookingAnimalWhereUniqueInput;
};


export type MutationupsertOneDogBreederTranslationArgs = {
  create: DogBreederTranslationCreateInput;
  update: DogBreederTranslationUpdateInput;
  where: DogBreederTranslationWhereUniqueInput;
};


export type MutationupsertOneLitterParentArgs = {
  create: LitterParentCreateInput;
  update: LitterParentUpdateInput;
  where: LitterParentWhereUniqueInput;
};


export type MutationupsertOneLitterTranslationArgs = {
  create: LitterTranslationCreateInput;
  update: LitterTranslationUpdateInput;
  where: LitterTranslationWhereUniqueInput;
};


export type MutationwaitlistApplicationArgs = {
  data: WaitlistApplicationInput;
};

export type NestedBoolFilter = {
  equals?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedBoolFilter>;
};

export type NestedBoolNullableFilter = {
  equals?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedBoolNullableFilter>;
};

export type NestedBoolNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedBoolNullableFilter>;
  _min?: InputMaybe<NestedBoolNullableFilter>;
  equals?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedBoolNullableWithAggregatesFilter>;
};

export type NestedBoolWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedBoolFilter>;
  _min?: InputMaybe<NestedBoolFilter>;
  equals?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedBoolWithAggregatesFilter>;
};

export type NestedDateTimeFilter = {
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  not?: InputMaybe<NestedDateTimeFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

export type NestedDateTimeNullableFilter = {
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  not?: InputMaybe<NestedDateTimeNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

export type NestedDateTimeNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedDateTimeNullableFilter>;
  _min?: InputMaybe<NestedDateTimeNullableFilter>;
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  not?: InputMaybe<NestedDateTimeNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

export type NestedDateTimeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedDateTimeFilter>;
  _min?: InputMaybe<NestedDateTimeFilter>;
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  not?: InputMaybe<NestedDateTimeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

export type NestedEnumAccountImgTypeFilter = {
  equals?: InputMaybe<AccountImgType>;
  in?: InputMaybe<Array<AccountImgType>>;
  not?: InputMaybe<NestedEnumAccountImgTypeFilter>;
  notIn?: InputMaybe<Array<AccountImgType>>;
};

export type NestedEnumAccountImgTypeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumAccountImgTypeFilter>;
  _min?: InputMaybe<NestedEnumAccountImgTypeFilter>;
  equals?: InputMaybe<AccountImgType>;
  in?: InputMaybe<Array<AccountImgType>>;
  not?: InputMaybe<NestedEnumAccountImgTypeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<AccountImgType>>;
};

export type NestedEnumAnimalSizeEnumNullableFilter = {
  equals?: InputMaybe<AnimalSizeEnum>;
  in?: InputMaybe<Array<AnimalSizeEnum>>;
  not?: InputMaybe<NestedEnumAnimalSizeEnumNullableFilter>;
  notIn?: InputMaybe<Array<AnimalSizeEnum>>;
};

export type NestedEnumAnimalSizeEnumNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumAnimalSizeEnumNullableFilter>;
  _min?: InputMaybe<NestedEnumAnimalSizeEnumNullableFilter>;
  equals?: InputMaybe<AnimalSizeEnum>;
  in?: InputMaybe<Array<AnimalSizeEnum>>;
  not?: InputMaybe<NestedEnumAnimalSizeEnumNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<AnimalSizeEnum>>;
};

export type NestedEnumAnimalStatCreatedFromEnumFilter = {
  equals?: InputMaybe<AnimalStatCreatedFromEnum>;
  in?: InputMaybe<Array<AnimalStatCreatedFromEnum>>;
  not?: InputMaybe<NestedEnumAnimalStatCreatedFromEnumFilter>;
  notIn?: InputMaybe<Array<AnimalStatCreatedFromEnum>>;
};

export type NestedEnumAnimalStatCreatedFromEnumWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumAnimalStatCreatedFromEnumFilter>;
  _min?: InputMaybe<NestedEnumAnimalStatCreatedFromEnumFilter>;
  equals?: InputMaybe<AnimalStatCreatedFromEnum>;
  in?: InputMaybe<Array<AnimalStatCreatedFromEnum>>;
  not?: InputMaybe<NestedEnumAnimalStatCreatedFromEnumWithAggregatesFilter>;
  notIn?: InputMaybe<Array<AnimalStatCreatedFromEnum>>;
};

export type NestedEnumAnimalTypeEnumFilter = {
  equals?: InputMaybe<AnimalTypeEnum>;
  in?: InputMaybe<Array<AnimalTypeEnum>>;
  not?: InputMaybe<NestedEnumAnimalTypeEnumFilter>;
  notIn?: InputMaybe<Array<AnimalTypeEnum>>;
};

export type NestedEnumAnimalTypeEnumNullableFilter = {
  equals?: InputMaybe<AnimalTypeEnum>;
  in?: InputMaybe<Array<AnimalTypeEnum>>;
  not?: InputMaybe<NestedEnumAnimalTypeEnumNullableFilter>;
  notIn?: InputMaybe<Array<AnimalTypeEnum>>;
};

export type NestedEnumAnimalTypeEnumNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumAnimalTypeEnumNullableFilter>;
  _min?: InputMaybe<NestedEnumAnimalTypeEnumNullableFilter>;
  equals?: InputMaybe<AnimalTypeEnum>;
  in?: InputMaybe<Array<AnimalTypeEnum>>;
  not?: InputMaybe<NestedEnumAnimalTypeEnumNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<AnimalTypeEnum>>;
};

export type NestedEnumAnimalTypeEnumWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumAnimalTypeEnumFilter>;
  _min?: InputMaybe<NestedEnumAnimalTypeEnumFilter>;
  equals?: InputMaybe<AnimalTypeEnum>;
  in?: InputMaybe<Array<AnimalTypeEnum>>;
  not?: InputMaybe<NestedEnumAnimalTypeEnumWithAggregatesFilter>;
  notIn?: InputMaybe<Array<AnimalTypeEnum>>;
};

export type NestedEnumBirthdayTypeNullableFilter = {
  equals?: InputMaybe<BirthdayType>;
  in?: InputMaybe<Array<BirthdayType>>;
  not?: InputMaybe<NestedEnumBirthdayTypeNullableFilter>;
  notIn?: InputMaybe<Array<BirthdayType>>;
};

export type NestedEnumBirthdayTypeNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumBirthdayTypeNullableFilter>;
  _min?: InputMaybe<NestedEnumBirthdayTypeNullableFilter>;
  equals?: InputMaybe<BirthdayType>;
  in?: InputMaybe<Array<BirthdayType>>;
  not?: InputMaybe<NestedEnumBirthdayTypeNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<BirthdayType>>;
};

export type NestedEnumBreedGeneticAnalyzeTypeNullableFilter = {
  equals?: InputMaybe<BreedGeneticAnalyzeType>;
  in?: InputMaybe<Array<BreedGeneticAnalyzeType>>;
  not?: InputMaybe<NestedEnumBreedGeneticAnalyzeTypeNullableFilter>;
  notIn?: InputMaybe<Array<BreedGeneticAnalyzeType>>;
};

export type NestedEnumBreedGeneticAnalyzeTypeNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumBreedGeneticAnalyzeTypeNullableFilter>;
  _min?: InputMaybe<NestedEnumBreedGeneticAnalyzeTypeNullableFilter>;
  equals?: InputMaybe<BreedGeneticAnalyzeType>;
  in?: InputMaybe<Array<BreedGeneticAnalyzeType>>;
  not?: InputMaybe<NestedEnumBreedGeneticAnalyzeTypeNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<BreedGeneticAnalyzeType>>;
};

export type NestedEnumBreedTypeFilter = {
  equals?: InputMaybe<BreedType>;
  in?: InputMaybe<Array<BreedType>>;
  not?: InputMaybe<NestedEnumBreedTypeFilter>;
  notIn?: InputMaybe<Array<BreedType>>;
};

export type NestedEnumBreedTypeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumBreedTypeFilter>;
  _min?: InputMaybe<NestedEnumBreedTypeFilter>;
  equals?: InputMaybe<BreedType>;
  in?: InputMaybe<Array<BreedType>>;
  not?: InputMaybe<NestedEnumBreedTypeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<BreedType>>;
};

export type NestedEnumCenterTypeEnumNullableFilter = {
  equals?: InputMaybe<CenterTypeEnum>;
  in?: InputMaybe<Array<CenterTypeEnum>>;
  not?: InputMaybe<NestedEnumCenterTypeEnumNullableFilter>;
  notIn?: InputMaybe<Array<CenterTypeEnum>>;
};

export type NestedEnumCenterTypeEnumNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumCenterTypeEnumNullableFilter>;
  _min?: InputMaybe<NestedEnumCenterTypeEnumNullableFilter>;
  equals?: InputMaybe<CenterTypeEnum>;
  in?: InputMaybe<Array<CenterTypeEnum>>;
  not?: InputMaybe<NestedEnumCenterTypeEnumNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<CenterTypeEnum>>;
};

export type NestedEnumCountryCodeFilter = {
  equals?: InputMaybe<CountryCode>;
  in?: InputMaybe<Array<CountryCode>>;
  not?: InputMaybe<NestedEnumCountryCodeFilter>;
  notIn?: InputMaybe<Array<CountryCode>>;
};

export type NestedEnumCountryCodeNullableFilter = {
  equals?: InputMaybe<CountryCode>;
  in?: InputMaybe<Array<CountryCode>>;
  not?: InputMaybe<NestedEnumCountryCodeNullableFilter>;
  notIn?: InputMaybe<Array<CountryCode>>;
};

export type NestedEnumCountryCodeNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumCountryCodeNullableFilter>;
  _min?: InputMaybe<NestedEnumCountryCodeNullableFilter>;
  equals?: InputMaybe<CountryCode>;
  in?: InputMaybe<Array<CountryCode>>;
  not?: InputMaybe<NestedEnumCountryCodeNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<CountryCode>>;
};

export type NestedEnumCountryCodeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumCountryCodeFilter>;
  _min?: InputMaybe<NestedEnumCountryCodeFilter>;
  equals?: InputMaybe<CountryCode>;
  in?: InputMaybe<Array<CountryCode>>;
  not?: InputMaybe<NestedEnumCountryCodeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<CountryCode>>;
};

export type NestedEnumCouplingTypeNullableFilter = {
  equals?: InputMaybe<CouplingType>;
  in?: InputMaybe<Array<CouplingType>>;
  not?: InputMaybe<NestedEnumCouplingTypeNullableFilter>;
  notIn?: InputMaybe<Array<CouplingType>>;
};

export type NestedEnumCouplingTypeNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumCouplingTypeNullableFilter>;
  _min?: InputMaybe<NestedEnumCouplingTypeNullableFilter>;
  equals?: InputMaybe<CouplingType>;
  in?: InputMaybe<Array<CouplingType>>;
  not?: InputMaybe<NestedEnumCouplingTypeNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<CouplingType>>;
};

export type NestedEnumDashboardStatsDisplayTypeEnumFilter = {
  equals?: InputMaybe<DashboardStatsDisplayTypeEnum>;
  in?: InputMaybe<Array<DashboardStatsDisplayTypeEnum>>;
  not?: InputMaybe<NestedEnumDashboardStatsDisplayTypeEnumFilter>;
  notIn?: InputMaybe<Array<DashboardStatsDisplayTypeEnum>>;
};

export type NestedEnumDashboardStatsDisplayTypeEnumWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumDashboardStatsDisplayTypeEnumFilter>;
  _min?: InputMaybe<NestedEnumDashboardStatsDisplayTypeEnumFilter>;
  equals?: InputMaybe<DashboardStatsDisplayTypeEnum>;
  in?: InputMaybe<Array<DashboardStatsDisplayTypeEnum>>;
  not?: InputMaybe<NestedEnumDashboardStatsDisplayTypeEnumWithAggregatesFilter>;
  notIn?: InputMaybe<Array<DashboardStatsDisplayTypeEnum>>;
};

export type NestedEnumDayOfWeekFilter = {
  equals?: InputMaybe<DayOfWeek>;
  in?: InputMaybe<Array<DayOfWeek>>;
  not?: InputMaybe<NestedEnumDayOfWeekFilter>;
  notIn?: InputMaybe<Array<DayOfWeek>>;
};

export type NestedEnumDayOfWeekWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumDayOfWeekFilter>;
  _min?: InputMaybe<NestedEnumDayOfWeekFilter>;
  equals?: InputMaybe<DayOfWeek>;
  in?: InputMaybe<Array<DayOfWeek>>;
  not?: InputMaybe<NestedEnumDayOfWeekWithAggregatesFilter>;
  notIn?: InputMaybe<Array<DayOfWeek>>;
};

export type NestedEnumDogBreedImgTypeFilter = {
  equals?: InputMaybe<DogBreedImgType>;
  in?: InputMaybe<Array<DogBreedImgType>>;
  not?: InputMaybe<NestedEnumDogBreedImgTypeFilter>;
  notIn?: InputMaybe<Array<DogBreedImgType>>;
};

export type NestedEnumDogBreedImgTypeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumDogBreedImgTypeFilter>;
  _min?: InputMaybe<NestedEnumDogBreedImgTypeFilter>;
  equals?: InputMaybe<DogBreedImgType>;
  in?: InputMaybe<Array<DogBreedImgType>>;
  not?: InputMaybe<NestedEnumDogBreedImgTypeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<DogBreedImgType>>;
};

export type NestedEnumDogBreederApplicationAccommodationFilter = {
  equals?: InputMaybe<DogBreederApplicationAccommodation>;
  in?: InputMaybe<Array<DogBreederApplicationAccommodation>>;
  not?: InputMaybe<NestedEnumDogBreederApplicationAccommodationFilter>;
  notIn?: InputMaybe<Array<DogBreederApplicationAccommodation>>;
};

export type NestedEnumDogBreederApplicationAccommodationWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumDogBreederApplicationAccommodationFilter>;
  _min?: InputMaybe<NestedEnumDogBreederApplicationAccommodationFilter>;
  equals?: InputMaybe<DogBreederApplicationAccommodation>;
  in?: InputMaybe<Array<DogBreederApplicationAccommodation>>;
  not?: InputMaybe<NestedEnumDogBreederApplicationAccommodationWithAggregatesFilter>;
  notIn?: InputMaybe<Array<DogBreederApplicationAccommodation>>;
};

export type NestedEnumDogBreederApplicationStatusFilter = {
  equals?: InputMaybe<DogBreederApplicationStatus>;
  in?: InputMaybe<Array<DogBreederApplicationStatus>>;
  not?: InputMaybe<NestedEnumDogBreederApplicationStatusFilter>;
  notIn?: InputMaybe<Array<DogBreederApplicationStatus>>;
};

export type NestedEnumDogBreederApplicationStatusWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumDogBreederApplicationStatusFilter>;
  _min?: InputMaybe<NestedEnumDogBreederApplicationStatusFilter>;
  equals?: InputMaybe<DogBreederApplicationStatus>;
  in?: InputMaybe<Array<DogBreederApplicationStatus>>;
  not?: InputMaybe<NestedEnumDogBreederApplicationStatusWithAggregatesFilter>;
  notIn?: InputMaybe<Array<DogBreederApplicationStatus>>;
};

export type NestedEnumDogBreederApplicationTimeAloneFilter = {
  equals?: InputMaybe<DogBreederApplicationTimeAlone>;
  in?: InputMaybe<Array<DogBreederApplicationTimeAlone>>;
  not?: InputMaybe<NestedEnumDogBreederApplicationTimeAloneFilter>;
  notIn?: InputMaybe<Array<DogBreederApplicationTimeAlone>>;
};

export type NestedEnumDogBreederApplicationTimeAloneWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumDogBreederApplicationTimeAloneFilter>;
  _min?: InputMaybe<NestedEnumDogBreederApplicationTimeAloneFilter>;
  equals?: InputMaybe<DogBreederApplicationTimeAlone>;
  in?: InputMaybe<Array<DogBreederApplicationTimeAlone>>;
  not?: InputMaybe<NestedEnumDogBreederApplicationTimeAloneWithAggregatesFilter>;
  notIn?: InputMaybe<Array<DogBreederApplicationTimeAlone>>;
};

export type NestedEnumDogBreederContactTypeNullableFilter = {
  equals?: InputMaybe<DogBreederContactType>;
  in?: InputMaybe<Array<DogBreederContactType>>;
  not?: InputMaybe<NestedEnumDogBreederContactTypeNullableFilter>;
  notIn?: InputMaybe<Array<DogBreederContactType>>;
};

export type NestedEnumDogBreederContactTypeNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumDogBreederContactTypeNullableFilter>;
  _min?: InputMaybe<NestedEnumDogBreederContactTypeNullableFilter>;
  equals?: InputMaybe<DogBreederContactType>;
  in?: InputMaybe<Array<DogBreederContactType>>;
  not?: InputMaybe<NestedEnumDogBreederContactTypeNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<DogBreederContactType>>;
};

export type NestedEnumDogCoatNullableFilter = {
  equals?: InputMaybe<DogCoat>;
  in?: InputMaybe<Array<DogCoat>>;
  not?: InputMaybe<NestedEnumDogCoatNullableFilter>;
  notIn?: InputMaybe<Array<DogCoat>>;
};

export type NestedEnumDogCoatNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumDogCoatNullableFilter>;
  _min?: InputMaybe<NestedEnumDogCoatNullableFilter>;
  equals?: InputMaybe<DogCoat>;
  in?: InputMaybe<Array<DogCoat>>;
  not?: InputMaybe<NestedEnumDogCoatNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<DogCoat>>;
};

export type NestedEnumDogColorNullableFilter = {
  equals?: InputMaybe<DogColor>;
  in?: InputMaybe<Array<DogColor>>;
  not?: InputMaybe<NestedEnumDogColorNullableFilter>;
  notIn?: InputMaybe<Array<DogColor>>;
};

export type NestedEnumDogColorNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumDogColorNullableFilter>;
  _min?: InputMaybe<NestedEnumDogColorNullableFilter>;
  equals?: InputMaybe<DogColor>;
  in?: InputMaybe<Array<DogColor>>;
  not?: InputMaybe<NestedEnumDogColorNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<DogColor>>;
};

export type NestedEnumDogHairTypeNullableFilter = {
  equals?: InputMaybe<DogHairType>;
  in?: InputMaybe<Array<DogHairType>>;
  not?: InputMaybe<NestedEnumDogHairTypeNullableFilter>;
  notIn?: InputMaybe<Array<DogHairType>>;
};

export type NestedEnumDogHairTypeNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumDogHairTypeNullableFilter>;
  _min?: InputMaybe<NestedEnumDogHairTypeNullableFilter>;
  equals?: InputMaybe<DogHairType>;
  in?: InputMaybe<Array<DogHairType>>;
  not?: InputMaybe<NestedEnumDogHairTypeNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<DogHairType>>;
};

export type NestedEnumDogMedicalAffectionTypeFilter = {
  equals?: InputMaybe<DogMedicalAffectionType>;
  in?: InputMaybe<Array<DogMedicalAffectionType>>;
  not?: InputMaybe<NestedEnumDogMedicalAffectionTypeFilter>;
  notIn?: InputMaybe<Array<DogMedicalAffectionType>>;
};

export type NestedEnumDogMedicalAffectionTypeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumDogMedicalAffectionTypeFilter>;
  _min?: InputMaybe<NestedEnumDogMedicalAffectionTypeFilter>;
  equals?: InputMaybe<DogMedicalAffectionType>;
  in?: InputMaybe<Array<DogMedicalAffectionType>>;
  not?: InputMaybe<NestedEnumDogMedicalAffectionTypeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<DogMedicalAffectionType>>;
};

export type NestedEnumDogPhysicalConditionNullableFilter = {
  equals?: InputMaybe<DogPhysicalCondition>;
  in?: InputMaybe<Array<DogPhysicalCondition>>;
  not?: InputMaybe<NestedEnumDogPhysicalConditionNullableFilter>;
  notIn?: InputMaybe<Array<DogPhysicalCondition>>;
};

export type NestedEnumDogPhysicalConditionNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumDogPhysicalConditionNullableFilter>;
  _min?: InputMaybe<NestedEnumDogPhysicalConditionNullableFilter>;
  equals?: InputMaybe<DogPhysicalCondition>;
  in?: InputMaybe<Array<DogPhysicalCondition>>;
  not?: InputMaybe<NestedEnumDogPhysicalConditionNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<DogPhysicalCondition>>;
};

export type NestedEnumDogShelterTypeFilter = {
  equals?: InputMaybe<DogShelterType>;
  in?: InputMaybe<Array<DogShelterType>>;
  not?: InputMaybe<NestedEnumDogShelterTypeFilter>;
  notIn?: InputMaybe<Array<DogShelterType>>;
};

export type NestedEnumDogShelterTypeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumDogShelterTypeFilter>;
  _min?: InputMaybe<NestedEnumDogShelterTypeFilter>;
  equals?: InputMaybe<DogShelterType>;
  in?: InputMaybe<Array<DogShelterType>>;
  not?: InputMaybe<NestedEnumDogShelterTypeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<DogShelterType>>;
};

export type NestedEnumEducatorTypeEnumNullableFilter = {
  equals?: InputMaybe<EducatorTypeEnum>;
  in?: InputMaybe<Array<EducatorTypeEnum>>;
  not?: InputMaybe<NestedEnumEducatorTypeEnumNullableFilter>;
  notIn?: InputMaybe<Array<EducatorTypeEnum>>;
};

export type NestedEnumEducatorTypeEnumNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumEducatorTypeEnumNullableFilter>;
  _min?: InputMaybe<NestedEnumEducatorTypeEnumNullableFilter>;
  equals?: InputMaybe<EducatorTypeEnum>;
  in?: InputMaybe<Array<EducatorTypeEnum>>;
  not?: InputMaybe<NestedEnumEducatorTypeEnumNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<EducatorTypeEnum>>;
};

export type NestedEnumEmailContactCreatedFromEnumFilter = {
  equals?: InputMaybe<EmailContactCreatedFromEnum>;
  in?: InputMaybe<Array<EmailContactCreatedFromEnum>>;
  not?: InputMaybe<NestedEnumEmailContactCreatedFromEnumFilter>;
  notIn?: InputMaybe<Array<EmailContactCreatedFromEnum>>;
};

export type NestedEnumEmailContactCreatedFromEnumWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumEmailContactCreatedFromEnumFilter>;
  _min?: InputMaybe<NestedEnumEmailContactCreatedFromEnumFilter>;
  equals?: InputMaybe<EmailContactCreatedFromEnum>;
  in?: InputMaybe<Array<EmailContactCreatedFromEnum>>;
  not?: InputMaybe<NestedEnumEmailContactCreatedFromEnumWithAggregatesFilter>;
  notIn?: InputMaybe<Array<EmailContactCreatedFromEnum>>;
};

export type NestedEnumFrequencyTypeNullableFilter = {
  equals?: InputMaybe<FrequencyType>;
  in?: InputMaybe<Array<FrequencyType>>;
  not?: InputMaybe<NestedEnumFrequencyTypeNullableFilter>;
  notIn?: InputMaybe<Array<FrequencyType>>;
};

export type NestedEnumFrequencyTypeNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumFrequencyTypeNullableFilter>;
  _min?: InputMaybe<NestedEnumFrequencyTypeNullableFilter>;
  equals?: InputMaybe<FrequencyType>;
  in?: InputMaybe<Array<FrequencyType>>;
  not?: InputMaybe<NestedEnumFrequencyTypeNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<FrequencyType>>;
};

export type NestedEnumGenderEnumFilter = {
  equals?: InputMaybe<GenderEnum>;
  in?: InputMaybe<Array<GenderEnum>>;
  not?: InputMaybe<NestedEnumGenderEnumFilter>;
  notIn?: InputMaybe<Array<GenderEnum>>;
};

export type NestedEnumGenderEnumNullableFilter = {
  equals?: InputMaybe<GenderEnum>;
  in?: InputMaybe<Array<GenderEnum>>;
  not?: InputMaybe<NestedEnumGenderEnumNullableFilter>;
  notIn?: InputMaybe<Array<GenderEnum>>;
};

export type NestedEnumGenderEnumNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumGenderEnumNullableFilter>;
  _min?: InputMaybe<NestedEnumGenderEnumNullableFilter>;
  equals?: InputMaybe<GenderEnum>;
  in?: InputMaybe<Array<GenderEnum>>;
  not?: InputMaybe<NestedEnumGenderEnumNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<GenderEnum>>;
};

export type NestedEnumGenderEnumWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumGenderEnumFilter>;
  _min?: InputMaybe<NestedEnumGenderEnumFilter>;
  equals?: InputMaybe<GenderEnum>;
  in?: InputMaybe<Array<GenderEnum>>;
  not?: InputMaybe<NestedEnumGenderEnumWithAggregatesFilter>;
  notIn?: InputMaybe<Array<GenderEnum>>;
};

export type NestedEnumHeadShapeNullableFilter = {
  equals?: InputMaybe<HeadShape>;
  in?: InputMaybe<Array<HeadShape>>;
  not?: InputMaybe<NestedEnumHeadShapeNullableFilter>;
  notIn?: InputMaybe<Array<HeadShape>>;
};

export type NestedEnumHeadShapeNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumHeadShapeNullableFilter>;
  _min?: InputMaybe<NestedEnumHeadShapeNullableFilter>;
  equals?: InputMaybe<HeadShape>;
  in?: InputMaybe<Array<HeadShape>>;
  not?: InputMaybe<NestedEnumHeadShapeNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<HeadShape>>;
};

export type NestedEnumLanguageCodeFilter = {
  equals?: InputMaybe<LanguageCode>;
  in?: InputMaybe<Array<LanguageCode>>;
  not?: InputMaybe<NestedEnumLanguageCodeFilter>;
  notIn?: InputMaybe<Array<LanguageCode>>;
};

export type NestedEnumLanguageCodeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumLanguageCodeFilter>;
  _min?: InputMaybe<NestedEnumLanguageCodeFilter>;
  equals?: InputMaybe<LanguageCode>;
  in?: InputMaybe<Array<LanguageCode>>;
  not?: InputMaybe<NestedEnumLanguageCodeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<LanguageCode>>;
};

export type NestedEnumLastVisitTypeNullableFilter = {
  equals?: InputMaybe<LastVisitType>;
  in?: InputMaybe<Array<LastVisitType>>;
  not?: InputMaybe<NestedEnumLastVisitTypeNullableFilter>;
  notIn?: InputMaybe<Array<LastVisitType>>;
};

export type NestedEnumLastVisitTypeNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumLastVisitTypeNullableFilter>;
  _min?: InputMaybe<NestedEnumLastVisitTypeNullableFilter>;
  equals?: InputMaybe<LastVisitType>;
  in?: InputMaybe<Array<LastVisitType>>;
  not?: InputMaybe<NestedEnumLastVisitTypeNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<LastVisitType>>;
};

export type NestedEnumNotificationTypeNullableFilter = {
  equals?: InputMaybe<NotificationType>;
  in?: InputMaybe<Array<NotificationType>>;
  not?: InputMaybe<NestedEnumNotificationTypeNullableFilter>;
  notIn?: InputMaybe<Array<NotificationType>>;
};

export type NestedEnumNotificationTypeNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumNotificationTypeNullableFilter>;
  _min?: InputMaybe<NestedEnumNotificationTypeNullableFilter>;
  equals?: InputMaybe<NotificationType>;
  in?: InputMaybe<Array<NotificationType>>;
  not?: InputMaybe<NestedEnumNotificationTypeNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<NotificationType>>;
};

export type NestedEnumParentTypeEnumFilter = {
  equals?: InputMaybe<ParentTypeEnum>;
  in?: InputMaybe<Array<ParentTypeEnum>>;
  not?: InputMaybe<NestedEnumParentTypeEnumFilter>;
  notIn?: InputMaybe<Array<ParentTypeEnum>>;
};

export type NestedEnumParentTypeEnumWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumParentTypeEnumFilter>;
  _min?: InputMaybe<NestedEnumParentTypeEnumFilter>;
  equals?: InputMaybe<ParentTypeEnum>;
  in?: InputMaybe<Array<ParentTypeEnum>>;
  not?: InputMaybe<NestedEnumParentTypeEnumWithAggregatesFilter>;
  notIn?: InputMaybe<Array<ParentTypeEnum>>;
};

export type NestedEnumPaymentStatusFilter = {
  equals?: InputMaybe<PaymentStatus>;
  in?: InputMaybe<Array<PaymentStatus>>;
  not?: InputMaybe<NestedEnumPaymentStatusFilter>;
  notIn?: InputMaybe<Array<PaymentStatus>>;
};

export type NestedEnumPaymentStatusWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumPaymentStatusFilter>;
  _min?: InputMaybe<NestedEnumPaymentStatusFilter>;
  equals?: InputMaybe<PaymentStatus>;
  in?: InputMaybe<Array<PaymentStatus>>;
  not?: InputMaybe<NestedEnumPaymentStatusWithAggregatesFilter>;
  notIn?: InputMaybe<Array<PaymentStatus>>;
};

export type NestedEnumProfessionalTypeEnumFilter = {
  equals?: InputMaybe<ProfessionalTypeEnum>;
  in?: InputMaybe<Array<ProfessionalTypeEnum>>;
  not?: InputMaybe<NestedEnumProfessionalTypeEnumFilter>;
  notIn?: InputMaybe<Array<ProfessionalTypeEnum>>;
};

export type NestedEnumProfessionalTypeEnumNullableFilter = {
  equals?: InputMaybe<ProfessionalTypeEnum>;
  in?: InputMaybe<Array<ProfessionalTypeEnum>>;
  not?: InputMaybe<NestedEnumProfessionalTypeEnumNullableFilter>;
  notIn?: InputMaybe<Array<ProfessionalTypeEnum>>;
};

export type NestedEnumProfessionalTypeEnumNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumProfessionalTypeEnumNullableFilter>;
  _min?: InputMaybe<NestedEnumProfessionalTypeEnumNullableFilter>;
  equals?: InputMaybe<ProfessionalTypeEnum>;
  in?: InputMaybe<Array<ProfessionalTypeEnum>>;
  not?: InputMaybe<NestedEnumProfessionalTypeEnumNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<ProfessionalTypeEnum>>;
};

export type NestedEnumProfessionalTypeEnumWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumProfessionalTypeEnumFilter>;
  _min?: InputMaybe<NestedEnumProfessionalTypeEnumFilter>;
  equals?: InputMaybe<ProfessionalTypeEnum>;
  in?: InputMaybe<Array<ProfessionalTypeEnum>>;
  not?: InputMaybe<NestedEnumProfessionalTypeEnumWithAggregatesFilter>;
  notIn?: InputMaybe<Array<ProfessionalTypeEnum>>;
};

export type NestedEnumRoleFilter = {
  equals?: InputMaybe<Role>;
  in?: InputMaybe<Array<Role>>;
  not?: InputMaybe<NestedEnumRoleFilter>;
  notIn?: InputMaybe<Array<Role>>;
};

export type NestedEnumRoleWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumRoleFilter>;
  _min?: InputMaybe<NestedEnumRoleFilter>;
  equals?: InputMaybe<Role>;
  in?: InputMaybe<Array<Role>>;
  not?: InputMaybe<NestedEnumRoleWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Role>>;
};

export type NestedEnumTemperTypeNullableFilter = {
  equals?: InputMaybe<TemperType>;
  in?: InputMaybe<Array<TemperType>>;
  not?: InputMaybe<NestedEnumTemperTypeNullableFilter>;
  notIn?: InputMaybe<Array<TemperType>>;
};

export type NestedEnumTemperTypeNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumTemperTypeNullableFilter>;
  _min?: InputMaybe<NestedEnumTemperTypeNullableFilter>;
  equals?: InputMaybe<TemperType>;
  in?: InputMaybe<Array<TemperType>>;
  not?: InputMaybe<NestedEnumTemperTypeNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<TemperType>>;
};

export type NestedEnumUpdateTypeEnumFilter = {
  equals?: InputMaybe<UpdateTypeEnum>;
  in?: InputMaybe<Array<UpdateTypeEnum>>;
  not?: InputMaybe<NestedEnumUpdateTypeEnumFilter>;
  notIn?: InputMaybe<Array<UpdateTypeEnum>>;
};

export type NestedEnumUpdateTypeEnumWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumUpdateTypeEnumFilter>;
  _min?: InputMaybe<NestedEnumUpdateTypeEnumFilter>;
  equals?: InputMaybe<UpdateTypeEnum>;
  in?: InputMaybe<Array<UpdateTypeEnum>>;
  not?: InputMaybe<NestedEnumUpdateTypeEnumWithAggregatesFilter>;
  notIn?: InputMaybe<Array<UpdateTypeEnum>>;
};

export type NestedEnumWorkerAvailabilityTypeFilter = {
  equals?: InputMaybe<WorkerAvailabilityType>;
  in?: InputMaybe<Array<WorkerAvailabilityType>>;
  not?: InputMaybe<NestedEnumWorkerAvailabilityTypeFilter>;
  notIn?: InputMaybe<Array<WorkerAvailabilityType>>;
};

export type NestedEnumWorkerAvailabilityTypeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumWorkerAvailabilityTypeFilter>;
  _min?: InputMaybe<NestedEnumWorkerAvailabilityTypeFilter>;
  equals?: InputMaybe<WorkerAvailabilityType>;
  in?: InputMaybe<Array<WorkerAvailabilityType>>;
  not?: InputMaybe<NestedEnumWorkerAvailabilityTypeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<WorkerAvailabilityType>>;
};

export type NestedEnumWorkerServicePriceTypeNullableFilter = {
  equals?: InputMaybe<WorkerServicePriceType>;
  in?: InputMaybe<Array<WorkerServicePriceType>>;
  not?: InputMaybe<NestedEnumWorkerServicePriceTypeNullableFilter>;
  notIn?: InputMaybe<Array<WorkerServicePriceType>>;
};

export type NestedEnumWorkerServicePriceTypeNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumWorkerServicePriceTypeNullableFilter>;
  _min?: InputMaybe<NestedEnumWorkerServicePriceTypeNullableFilter>;
  equals?: InputMaybe<WorkerServicePriceType>;
  in?: InputMaybe<Array<WorkerServicePriceType>>;
  not?: InputMaybe<NestedEnumWorkerServicePriceTypeNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<WorkerServicePriceType>>;
};

export type NestedEnumYesNoUnknownStatusFilter = {
  equals?: InputMaybe<YesNoUnknownStatus>;
  in?: InputMaybe<Array<YesNoUnknownStatus>>;
  not?: InputMaybe<NestedEnumYesNoUnknownStatusFilter>;
  notIn?: InputMaybe<Array<YesNoUnknownStatus>>;
};

export type NestedEnumYesNoUnknownStatusNullableFilter = {
  equals?: InputMaybe<YesNoUnknownStatus>;
  in?: InputMaybe<Array<YesNoUnknownStatus>>;
  not?: InputMaybe<NestedEnumYesNoUnknownStatusNullableFilter>;
  notIn?: InputMaybe<Array<YesNoUnknownStatus>>;
};

export type NestedEnumYesNoUnknownStatusNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumYesNoUnknownStatusNullableFilter>;
  _min?: InputMaybe<NestedEnumYesNoUnknownStatusNullableFilter>;
  equals?: InputMaybe<YesNoUnknownStatus>;
  in?: InputMaybe<Array<YesNoUnknownStatus>>;
  not?: InputMaybe<NestedEnumYesNoUnknownStatusNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<YesNoUnknownStatus>>;
};

export type NestedEnumYesNoUnknownStatusWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumYesNoUnknownStatusFilter>;
  _min?: InputMaybe<NestedEnumYesNoUnknownStatusFilter>;
  equals?: InputMaybe<YesNoUnknownStatus>;
  in?: InputMaybe<Array<YesNoUnknownStatus>>;
  not?: InputMaybe<NestedEnumYesNoUnknownStatusWithAggregatesFilter>;
  notIn?: InputMaybe<Array<YesNoUnknownStatus>>;
};

export type NestedFloatFilter = {
  equals?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<Scalars['Float']['input']>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  not?: InputMaybe<NestedFloatFilter>;
  notIn?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type NestedFloatNullableFilter = {
  equals?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<Scalars['Float']['input']>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  not?: InputMaybe<NestedFloatNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type NestedFloatNullableWithAggregatesFilter = {
  _avg?: InputMaybe<NestedFloatNullableFilter>;
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedFloatNullableFilter>;
  _min?: InputMaybe<NestedFloatNullableFilter>;
  _sum?: InputMaybe<NestedFloatNullableFilter>;
  equals?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<Scalars['Float']['input']>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  not?: InputMaybe<NestedFloatNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type NestedIntFilter = {
  equals?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<NestedIntFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type NestedIntNullableFilter = {
  equals?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<NestedIntNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type NestedIntNullableWithAggregatesFilter = {
  _avg?: InputMaybe<NestedFloatNullableFilter>;
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedIntNullableFilter>;
  _min?: InputMaybe<NestedIntNullableFilter>;
  _sum?: InputMaybe<NestedIntNullableFilter>;
  equals?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<NestedIntNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type NestedIntWithAggregatesFilter = {
  _avg?: InputMaybe<NestedFloatFilter>;
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedIntFilter>;
  _min?: InputMaybe<NestedIntFilter>;
  _sum?: InputMaybe<NestedIntFilter>;
  equals?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<NestedIntWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type NestedJsonFilter = {
  array_contains?: InputMaybe<Scalars['Json']['input']>;
  array_ends_with?: InputMaybe<Scalars['Json']['input']>;
  array_starts_with?: InputMaybe<Scalars['Json']['input']>;
  equals?: InputMaybe<Scalars['Json']['input']>;
  gt?: InputMaybe<Scalars['Json']['input']>;
  gte?: InputMaybe<Scalars['Json']['input']>;
  lt?: InputMaybe<Scalars['Json']['input']>;
  lte?: InputMaybe<Scalars['Json']['input']>;
  not?: InputMaybe<Scalars['Json']['input']>;
  path?: InputMaybe<Array<Scalars['String']['input']>>;
  string_contains?: InputMaybe<Scalars['String']['input']>;
  string_ends_with?: InputMaybe<Scalars['String']['input']>;
  string_starts_with?: InputMaybe<Scalars['String']['input']>;
};

export type NestedStringFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<NestedStringFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type NestedStringNullableFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<NestedStringNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type NestedStringNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedStringNullableFilter>;
  _min?: InputMaybe<NestedStringNullableFilter>;
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<NestedStringNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type NestedStringWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedStringFilter>;
  _min?: InputMaybe<NestedStringFilter>;
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<NestedStringWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type NextAvailability = {
  __typename?: 'NextAvailability';
  date?: Maybe<Scalars['DateTime']['output']>;
  workerId?: Maybe<Scalars['Int']['output']>;
};

export type Notification = {
  __typename?: 'Notification';
  account?: Maybe<Account>;
  accountId?: Maybe<Scalars['Int']['output']>;
  application?: Maybe<DogBreederApplication>;
  applicationId?: Maybe<Scalars['Int']['output']>;
  booking?: Maybe<Booking>;
  bookingId?: Maybe<Scalars['Int']['output']>;
  breeder?: Maybe<DogBreeder>;
  breederId?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  litter?: Maybe<Litter>;
  litterId?: Maybe<Scalars['Int']['output']>;
  pro?: Maybe<Professional>;
  proId?: Maybe<Scalars['Int']['output']>;
  retries: Scalars['Int']['output'];
  success: Scalars['Boolean']['output'];
  type: NotificationType;
  updatedAt: Scalars['DateTime']['output'];
};

export type NotificationAvgAggregateOutputType = {
  __typename?: 'NotificationAvgAggregateOutputType';
  accountId?: Maybe<Scalars['Float']['output']>;
  applicationId?: Maybe<Scalars['Float']['output']>;
  bookingId?: Maybe<Scalars['Float']['output']>;
  breederId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  litterId?: Maybe<Scalars['Float']['output']>;
  proId?: Maybe<Scalars['Float']['output']>;
  retries?: Maybe<Scalars['Float']['output']>;
};

export type NotificationAvgOrderByAggregateInput = {
  accountId?: InputMaybe<SortOrder>;
  applicationId?: InputMaybe<SortOrder>;
  bookingId?: InputMaybe<SortOrder>;
  breederId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  litterId?: InputMaybe<SortOrder>;
  proId?: InputMaybe<SortOrder>;
  retries?: InputMaybe<SortOrder>;
};

export type NotificationCountAggregateOutputType = {
  __typename?: 'NotificationCountAggregateOutputType';
  _all: Scalars['Int']['output'];
  accountId: Scalars['Int']['output'];
  applicationId: Scalars['Int']['output'];
  bookingId: Scalars['Int']['output'];
  breederId: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  litterId: Scalars['Int']['output'];
  proId: Scalars['Int']['output'];
  retries: Scalars['Int']['output'];
  success: Scalars['Int']['output'];
  type: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type NotificationCountOrderByAggregateInput = {
  accountId?: InputMaybe<SortOrder>;
  applicationId?: InputMaybe<SortOrder>;
  bookingId?: InputMaybe<SortOrder>;
  breederId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  litterId?: InputMaybe<SortOrder>;
  proId?: InputMaybe<SortOrder>;
  retries?: InputMaybe<SortOrder>;
  success?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type NotificationCreateInput = {
  account?: InputMaybe<AccountCreateNestedOneWithoutNotificationsInput>;
  application?: InputMaybe<DogBreederApplicationCreateNestedOneWithoutNotificationsInput>;
  booking?: InputMaybe<BookingCreateNestedOneWithoutNotificationsInput>;
  breeder?: InputMaybe<DogBreederCreateNestedOneWithoutNotificationsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  litter?: InputMaybe<LitterCreateNestedOneWithoutNotificationsInput>;
  pro?: InputMaybe<ProfessionalCreateNestedOneWithoutNotificationsInput>;
  retries?: InputMaybe<Scalars['Int']['input']>;
  success?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<NotificationType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type NotificationCreateManyAccountInput = {
  applicationId?: InputMaybe<Scalars['Int']['input']>;
  bookingId?: InputMaybe<Scalars['Int']['input']>;
  breederId?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  litterId?: InputMaybe<Scalars['Int']['input']>;
  proId?: InputMaybe<Scalars['Int']['input']>;
  retries?: InputMaybe<Scalars['Int']['input']>;
  success?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<NotificationType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type NotificationCreateManyAccountInputEnvelope = {
  data: Array<NotificationCreateManyAccountInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NotificationCreateManyApplicationInput = {
  accountId?: InputMaybe<Scalars['Int']['input']>;
  bookingId?: InputMaybe<Scalars['Int']['input']>;
  breederId?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  litterId?: InputMaybe<Scalars['Int']['input']>;
  proId?: InputMaybe<Scalars['Int']['input']>;
  retries?: InputMaybe<Scalars['Int']['input']>;
  success?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<NotificationType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type NotificationCreateManyApplicationInputEnvelope = {
  data: Array<NotificationCreateManyApplicationInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NotificationCreateManyBookingInput = {
  accountId?: InputMaybe<Scalars['Int']['input']>;
  applicationId?: InputMaybe<Scalars['Int']['input']>;
  breederId?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  litterId?: InputMaybe<Scalars['Int']['input']>;
  proId?: InputMaybe<Scalars['Int']['input']>;
  retries?: InputMaybe<Scalars['Int']['input']>;
  success?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<NotificationType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type NotificationCreateManyBookingInputEnvelope = {
  data: Array<NotificationCreateManyBookingInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NotificationCreateManyBreederInput = {
  accountId?: InputMaybe<Scalars['Int']['input']>;
  applicationId?: InputMaybe<Scalars['Int']['input']>;
  bookingId?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  litterId?: InputMaybe<Scalars['Int']['input']>;
  proId?: InputMaybe<Scalars['Int']['input']>;
  retries?: InputMaybe<Scalars['Int']['input']>;
  success?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<NotificationType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type NotificationCreateManyBreederInputEnvelope = {
  data: Array<NotificationCreateManyBreederInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NotificationCreateManyInput = {
  accountId?: InputMaybe<Scalars['Int']['input']>;
  applicationId?: InputMaybe<Scalars['Int']['input']>;
  bookingId?: InputMaybe<Scalars['Int']['input']>;
  breederId?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  litterId?: InputMaybe<Scalars['Int']['input']>;
  proId?: InputMaybe<Scalars['Int']['input']>;
  retries?: InputMaybe<Scalars['Int']['input']>;
  success?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<NotificationType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type NotificationCreateManyLitterInput = {
  accountId?: InputMaybe<Scalars['Int']['input']>;
  applicationId?: InputMaybe<Scalars['Int']['input']>;
  bookingId?: InputMaybe<Scalars['Int']['input']>;
  breederId?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  proId?: InputMaybe<Scalars['Int']['input']>;
  retries?: InputMaybe<Scalars['Int']['input']>;
  success?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<NotificationType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type NotificationCreateManyLitterInputEnvelope = {
  data: Array<NotificationCreateManyLitterInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NotificationCreateManyProInput = {
  accountId?: InputMaybe<Scalars['Int']['input']>;
  applicationId?: InputMaybe<Scalars['Int']['input']>;
  bookingId?: InputMaybe<Scalars['Int']['input']>;
  breederId?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  litterId?: InputMaybe<Scalars['Int']['input']>;
  retries?: InputMaybe<Scalars['Int']['input']>;
  success?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<NotificationType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type NotificationCreateManyProInputEnvelope = {
  data: Array<NotificationCreateManyProInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NotificationCreateNestedManyWithoutAccountInput = {
  connect?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<NotificationCreateOrConnectWithoutAccountInput>>;
  create?: InputMaybe<Array<NotificationCreateWithoutAccountInput>>;
  createMany?: InputMaybe<NotificationCreateManyAccountInputEnvelope>;
};

export type NotificationCreateNestedManyWithoutApplicationInput = {
  connect?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<NotificationCreateOrConnectWithoutApplicationInput>>;
  create?: InputMaybe<Array<NotificationCreateWithoutApplicationInput>>;
  createMany?: InputMaybe<NotificationCreateManyApplicationInputEnvelope>;
};

export type NotificationCreateNestedManyWithoutBookingInput = {
  connect?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<NotificationCreateOrConnectWithoutBookingInput>>;
  create?: InputMaybe<Array<NotificationCreateWithoutBookingInput>>;
  createMany?: InputMaybe<NotificationCreateManyBookingInputEnvelope>;
};

export type NotificationCreateNestedManyWithoutBreederInput = {
  connect?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<NotificationCreateOrConnectWithoutBreederInput>>;
  create?: InputMaybe<Array<NotificationCreateWithoutBreederInput>>;
  createMany?: InputMaybe<NotificationCreateManyBreederInputEnvelope>;
};

export type NotificationCreateNestedManyWithoutLitterInput = {
  connect?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<NotificationCreateOrConnectWithoutLitterInput>>;
  create?: InputMaybe<Array<NotificationCreateWithoutLitterInput>>;
  createMany?: InputMaybe<NotificationCreateManyLitterInputEnvelope>;
};

export type NotificationCreateNestedManyWithoutProInput = {
  connect?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<NotificationCreateOrConnectWithoutProInput>>;
  create?: InputMaybe<Array<NotificationCreateWithoutProInput>>;
  createMany?: InputMaybe<NotificationCreateManyProInputEnvelope>;
};

export type NotificationCreateOrConnectWithoutAccountInput = {
  create: NotificationCreateWithoutAccountInput;
  where: NotificationWhereUniqueInput;
};

export type NotificationCreateOrConnectWithoutApplicationInput = {
  create: NotificationCreateWithoutApplicationInput;
  where: NotificationWhereUniqueInput;
};

export type NotificationCreateOrConnectWithoutBookingInput = {
  create: NotificationCreateWithoutBookingInput;
  where: NotificationWhereUniqueInput;
};

export type NotificationCreateOrConnectWithoutBreederInput = {
  create: NotificationCreateWithoutBreederInput;
  where: NotificationWhereUniqueInput;
};

export type NotificationCreateOrConnectWithoutLitterInput = {
  create: NotificationCreateWithoutLitterInput;
  where: NotificationWhereUniqueInput;
};

export type NotificationCreateOrConnectWithoutProInput = {
  create: NotificationCreateWithoutProInput;
  where: NotificationWhereUniqueInput;
};

export type NotificationCreateWithoutAccountInput = {
  application?: InputMaybe<DogBreederApplicationCreateNestedOneWithoutNotificationsInput>;
  booking?: InputMaybe<BookingCreateNestedOneWithoutNotificationsInput>;
  breeder?: InputMaybe<DogBreederCreateNestedOneWithoutNotificationsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  litter?: InputMaybe<LitterCreateNestedOneWithoutNotificationsInput>;
  pro?: InputMaybe<ProfessionalCreateNestedOneWithoutNotificationsInput>;
  retries?: InputMaybe<Scalars['Int']['input']>;
  success?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<NotificationType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type NotificationCreateWithoutApplicationInput = {
  account?: InputMaybe<AccountCreateNestedOneWithoutNotificationsInput>;
  booking?: InputMaybe<BookingCreateNestedOneWithoutNotificationsInput>;
  breeder?: InputMaybe<DogBreederCreateNestedOneWithoutNotificationsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  litter?: InputMaybe<LitterCreateNestedOneWithoutNotificationsInput>;
  pro?: InputMaybe<ProfessionalCreateNestedOneWithoutNotificationsInput>;
  retries?: InputMaybe<Scalars['Int']['input']>;
  success?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<NotificationType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type NotificationCreateWithoutBookingInput = {
  account?: InputMaybe<AccountCreateNestedOneWithoutNotificationsInput>;
  application?: InputMaybe<DogBreederApplicationCreateNestedOneWithoutNotificationsInput>;
  breeder?: InputMaybe<DogBreederCreateNestedOneWithoutNotificationsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  litter?: InputMaybe<LitterCreateNestedOneWithoutNotificationsInput>;
  pro?: InputMaybe<ProfessionalCreateNestedOneWithoutNotificationsInput>;
  retries?: InputMaybe<Scalars['Int']['input']>;
  success?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<NotificationType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type NotificationCreateWithoutBreederInput = {
  account?: InputMaybe<AccountCreateNestedOneWithoutNotificationsInput>;
  application?: InputMaybe<DogBreederApplicationCreateNestedOneWithoutNotificationsInput>;
  booking?: InputMaybe<BookingCreateNestedOneWithoutNotificationsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  litter?: InputMaybe<LitterCreateNestedOneWithoutNotificationsInput>;
  pro?: InputMaybe<ProfessionalCreateNestedOneWithoutNotificationsInput>;
  retries?: InputMaybe<Scalars['Int']['input']>;
  success?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<NotificationType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type NotificationCreateWithoutLitterInput = {
  account?: InputMaybe<AccountCreateNestedOneWithoutNotificationsInput>;
  application?: InputMaybe<DogBreederApplicationCreateNestedOneWithoutNotificationsInput>;
  booking?: InputMaybe<BookingCreateNestedOneWithoutNotificationsInput>;
  breeder?: InputMaybe<DogBreederCreateNestedOneWithoutNotificationsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  pro?: InputMaybe<ProfessionalCreateNestedOneWithoutNotificationsInput>;
  retries?: InputMaybe<Scalars['Int']['input']>;
  success?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<NotificationType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type NotificationCreateWithoutProInput = {
  account?: InputMaybe<AccountCreateNestedOneWithoutNotificationsInput>;
  application?: InputMaybe<DogBreederApplicationCreateNestedOneWithoutNotificationsInput>;
  booking?: InputMaybe<BookingCreateNestedOneWithoutNotificationsInput>;
  breeder?: InputMaybe<DogBreederCreateNestedOneWithoutNotificationsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  litter?: InputMaybe<LitterCreateNestedOneWithoutNotificationsInput>;
  retries?: InputMaybe<Scalars['Int']['input']>;
  success?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<NotificationType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type NotificationListRelationFilter = {
  every?: InputMaybe<NotificationWhereInput>;
  none?: InputMaybe<NotificationWhereInput>;
  some?: InputMaybe<NotificationWhereInput>;
};

export type NotificationMaxAggregateOutputType = {
  __typename?: 'NotificationMaxAggregateOutputType';
  accountId?: Maybe<Scalars['Int']['output']>;
  applicationId?: Maybe<Scalars['Int']['output']>;
  bookingId?: Maybe<Scalars['Int']['output']>;
  breederId?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  litterId?: Maybe<Scalars['Int']['output']>;
  proId?: Maybe<Scalars['Int']['output']>;
  retries?: Maybe<Scalars['Int']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
  type?: Maybe<NotificationType>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type NotificationMaxOrderByAggregateInput = {
  accountId?: InputMaybe<SortOrder>;
  applicationId?: InputMaybe<SortOrder>;
  bookingId?: InputMaybe<SortOrder>;
  breederId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  litterId?: InputMaybe<SortOrder>;
  proId?: InputMaybe<SortOrder>;
  retries?: InputMaybe<SortOrder>;
  success?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type NotificationMinAggregateOutputType = {
  __typename?: 'NotificationMinAggregateOutputType';
  accountId?: Maybe<Scalars['Int']['output']>;
  applicationId?: Maybe<Scalars['Int']['output']>;
  bookingId?: Maybe<Scalars['Int']['output']>;
  breederId?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  litterId?: Maybe<Scalars['Int']['output']>;
  proId?: Maybe<Scalars['Int']['output']>;
  retries?: Maybe<Scalars['Int']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
  type?: Maybe<NotificationType>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type NotificationMinOrderByAggregateInput = {
  accountId?: InputMaybe<SortOrder>;
  applicationId?: InputMaybe<SortOrder>;
  bookingId?: InputMaybe<SortOrder>;
  breederId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  litterId?: InputMaybe<SortOrder>;
  proId?: InputMaybe<SortOrder>;
  retries?: InputMaybe<SortOrder>;
  success?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type NotificationOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type NotificationOrderByWithAggregationInput = {
  _avg?: InputMaybe<NotificationAvgOrderByAggregateInput>;
  _count?: InputMaybe<NotificationCountOrderByAggregateInput>;
  _max?: InputMaybe<NotificationMaxOrderByAggregateInput>;
  _min?: InputMaybe<NotificationMinOrderByAggregateInput>;
  _sum?: InputMaybe<NotificationSumOrderByAggregateInput>;
  accountId?: InputMaybe<SortOrderInput>;
  applicationId?: InputMaybe<SortOrderInput>;
  bookingId?: InputMaybe<SortOrderInput>;
  breederId?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  litterId?: InputMaybe<SortOrderInput>;
  proId?: InputMaybe<SortOrderInput>;
  retries?: InputMaybe<SortOrder>;
  success?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type NotificationOrderByWithRelationAndSearchRelevanceInput = {
  account?: InputMaybe<AccountOrderByWithRelationAndSearchRelevanceInput>;
  accountId?: InputMaybe<SortOrderInput>;
  application?: InputMaybe<DogBreederApplicationOrderByWithRelationAndSearchRelevanceInput>;
  applicationId?: InputMaybe<SortOrderInput>;
  booking?: InputMaybe<BookingOrderByWithRelationAndSearchRelevanceInput>;
  bookingId?: InputMaybe<SortOrderInput>;
  breeder?: InputMaybe<DogBreederOrderByWithRelationAndSearchRelevanceInput>;
  breederId?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  litter?: InputMaybe<LitterOrderByWithRelationAndSearchRelevanceInput>;
  litterId?: InputMaybe<SortOrderInput>;
  pro?: InputMaybe<ProfessionalOrderByWithRelationAndSearchRelevanceInput>;
  proId?: InputMaybe<SortOrderInput>;
  retries?: InputMaybe<SortOrder>;
  success?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum NotificationScalarFieldEnum {
  accountId = 'accountId',
  applicationId = 'applicationId',
  bookingId = 'bookingId',
  breederId = 'breederId',
  createdAt = 'createdAt',
  id = 'id',
  litterId = 'litterId',
  proId = 'proId',
  retries = 'retries',
  success = 'success',
  type = 'type',
  updatedAt = 'updatedAt'
}

export type NotificationScalarWhereInput = {
  AND?: InputMaybe<Array<NotificationScalarWhereInput>>;
  NOT?: InputMaybe<Array<NotificationScalarWhereInput>>;
  OR?: InputMaybe<Array<NotificationScalarWhereInput>>;
  accountId?: InputMaybe<IntNullableFilter>;
  applicationId?: InputMaybe<IntNullableFilter>;
  bookingId?: InputMaybe<IntNullableFilter>;
  breederId?: InputMaybe<IntNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntFilter>;
  litterId?: InputMaybe<IntNullableFilter>;
  proId?: InputMaybe<IntNullableFilter>;
  retries?: InputMaybe<IntFilter>;
  success?: InputMaybe<BoolFilter>;
  type?: InputMaybe<EnumNotificationTypeNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type NotificationScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<NotificationScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<NotificationScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<NotificationScalarWhereWithAggregatesInput>>;
  accountId?: InputMaybe<IntNullableWithAggregatesFilter>;
  applicationId?: InputMaybe<IntNullableWithAggregatesFilter>;
  bookingId?: InputMaybe<IntNullableWithAggregatesFilter>;
  breederId?: InputMaybe<IntNullableWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  litterId?: InputMaybe<IntNullableWithAggregatesFilter>;
  proId?: InputMaybe<IntNullableWithAggregatesFilter>;
  retries?: InputMaybe<IntWithAggregatesFilter>;
  success?: InputMaybe<BoolWithAggregatesFilter>;
  type?: InputMaybe<EnumNotificationTypeNullableWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type NotificationSumAggregateOutputType = {
  __typename?: 'NotificationSumAggregateOutputType';
  accountId?: Maybe<Scalars['Int']['output']>;
  applicationId?: Maybe<Scalars['Int']['output']>;
  bookingId?: Maybe<Scalars['Int']['output']>;
  breederId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  litterId?: Maybe<Scalars['Int']['output']>;
  proId?: Maybe<Scalars['Int']['output']>;
  retries?: Maybe<Scalars['Int']['output']>;
};

export type NotificationSumOrderByAggregateInput = {
  accountId?: InputMaybe<SortOrder>;
  applicationId?: InputMaybe<SortOrder>;
  bookingId?: InputMaybe<SortOrder>;
  breederId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  litterId?: InputMaybe<SortOrder>;
  proId?: InputMaybe<SortOrder>;
  retries?: InputMaybe<SortOrder>;
};

export enum NotificationType {
  BREEDER_APPLICATION_ADOPTED = 'BREEDER_APPLICATION_ADOPTED',
  BREEDER_APPLICATION_CANCELED = 'BREEDER_APPLICATION_CANCELED',
  BREEDER_APPLICATION_CREATED = 'BREEDER_APPLICATION_CREATED',
  BREEDER_APPLICATION_PAID = 'BREEDER_APPLICATION_PAID',
  BREEDER_APPLICATION_REFUSED = 'BREEDER_APPLICATION_REFUSED',
  BREEDER_LITTER_ARCHIVED = 'BREEDER_LITTER_ARCHIVED',
  BREEDER_LITTER_SOON_AVAILABLE = 'BREEDER_LITTER_SOON_AVAILABLE',
  BREEDER_NEW_ANNOUNCEMENT = 'BREEDER_NEW_ANNOUNCEMENT',
  BREEDER_ON_APPLICATION_AWAITING = 'BREEDER_ON_APPLICATION_AWAITING',
  BREEDER_ON_APPLICATION_EXPIRED = 'BREEDER_ON_APPLICATION_EXPIRED',
  BREEDER_REVIEW_RECEIVED = 'BREEDER_REVIEW_RECEIVED',
  BUYER_APPLICATION_ACCEPTED = 'BUYER_APPLICATION_ACCEPTED',
  BUYER_APPLICATION_ADOPTED = 'BUYER_APPLICATION_ADOPTED',
  BUYER_APPLICATION_EMAIL_CONFIRM = 'BUYER_APPLICATION_EMAIL_CONFIRM',
  BUYER_APPLICATION_PAID = 'BUYER_APPLICATION_PAID',
  BUYER_APPLICATION_REFUNDED = 'BUYER_APPLICATION_REFUNDED',
  BUYER_APPLICATION_WAITLISTED = 'BUYER_APPLICATION_WAITLISTED',
  MESSAGE_RECEIVED = 'MESSAGE_RECEIVED',
  PRO_BOOKING_EMAIL_CONFIRM = 'PRO_BOOKING_EMAIL_CONFIRM',
  USER_BOOKING_EMAIL_CONFIRM = 'USER_BOOKING_EMAIL_CONFIRM',
  USER_BOOKING_EMAIL_REMINDER = 'USER_BOOKING_EMAIL_REMINDER',
  USER_BOOKING_SMS_REMINDER = 'USER_BOOKING_SMS_REMINDER'
}

export type NotificationUncheckedCreateInput = {
  accountId?: InputMaybe<Scalars['Int']['input']>;
  applicationId?: InputMaybe<Scalars['Int']['input']>;
  bookingId?: InputMaybe<Scalars['Int']['input']>;
  breederId?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  litterId?: InputMaybe<Scalars['Int']['input']>;
  proId?: InputMaybe<Scalars['Int']['input']>;
  retries?: InputMaybe<Scalars['Int']['input']>;
  success?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<NotificationType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type NotificationUncheckedCreateNestedManyWithoutAccountInput = {
  connect?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<NotificationCreateOrConnectWithoutAccountInput>>;
  create?: InputMaybe<Array<NotificationCreateWithoutAccountInput>>;
  createMany?: InputMaybe<NotificationCreateManyAccountInputEnvelope>;
};

export type NotificationUncheckedCreateNestedManyWithoutApplicationInput = {
  connect?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<NotificationCreateOrConnectWithoutApplicationInput>>;
  create?: InputMaybe<Array<NotificationCreateWithoutApplicationInput>>;
  createMany?: InputMaybe<NotificationCreateManyApplicationInputEnvelope>;
};

export type NotificationUncheckedCreateNestedManyWithoutBookingInput = {
  connect?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<NotificationCreateOrConnectWithoutBookingInput>>;
  create?: InputMaybe<Array<NotificationCreateWithoutBookingInput>>;
  createMany?: InputMaybe<NotificationCreateManyBookingInputEnvelope>;
};

export type NotificationUncheckedCreateNestedManyWithoutBreederInput = {
  connect?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<NotificationCreateOrConnectWithoutBreederInput>>;
  create?: InputMaybe<Array<NotificationCreateWithoutBreederInput>>;
  createMany?: InputMaybe<NotificationCreateManyBreederInputEnvelope>;
};

export type NotificationUncheckedCreateNestedManyWithoutLitterInput = {
  connect?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<NotificationCreateOrConnectWithoutLitterInput>>;
  create?: InputMaybe<Array<NotificationCreateWithoutLitterInput>>;
  createMany?: InputMaybe<NotificationCreateManyLitterInputEnvelope>;
};

export type NotificationUncheckedCreateNestedManyWithoutProInput = {
  connect?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<NotificationCreateOrConnectWithoutProInput>>;
  create?: InputMaybe<Array<NotificationCreateWithoutProInput>>;
  createMany?: InputMaybe<NotificationCreateManyProInputEnvelope>;
};

export type NotificationUncheckedCreateWithoutAccountInput = {
  applicationId?: InputMaybe<Scalars['Int']['input']>;
  bookingId?: InputMaybe<Scalars['Int']['input']>;
  breederId?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  litterId?: InputMaybe<Scalars['Int']['input']>;
  proId?: InputMaybe<Scalars['Int']['input']>;
  retries?: InputMaybe<Scalars['Int']['input']>;
  success?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<NotificationType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type NotificationUncheckedCreateWithoutApplicationInput = {
  accountId?: InputMaybe<Scalars['Int']['input']>;
  bookingId?: InputMaybe<Scalars['Int']['input']>;
  breederId?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  litterId?: InputMaybe<Scalars['Int']['input']>;
  proId?: InputMaybe<Scalars['Int']['input']>;
  retries?: InputMaybe<Scalars['Int']['input']>;
  success?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<NotificationType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type NotificationUncheckedCreateWithoutBookingInput = {
  accountId?: InputMaybe<Scalars['Int']['input']>;
  applicationId?: InputMaybe<Scalars['Int']['input']>;
  breederId?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  litterId?: InputMaybe<Scalars['Int']['input']>;
  proId?: InputMaybe<Scalars['Int']['input']>;
  retries?: InputMaybe<Scalars['Int']['input']>;
  success?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<NotificationType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type NotificationUncheckedCreateWithoutBreederInput = {
  accountId?: InputMaybe<Scalars['Int']['input']>;
  applicationId?: InputMaybe<Scalars['Int']['input']>;
  bookingId?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  litterId?: InputMaybe<Scalars['Int']['input']>;
  proId?: InputMaybe<Scalars['Int']['input']>;
  retries?: InputMaybe<Scalars['Int']['input']>;
  success?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<NotificationType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type NotificationUncheckedCreateWithoutLitterInput = {
  accountId?: InputMaybe<Scalars['Int']['input']>;
  applicationId?: InputMaybe<Scalars['Int']['input']>;
  bookingId?: InputMaybe<Scalars['Int']['input']>;
  breederId?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  proId?: InputMaybe<Scalars['Int']['input']>;
  retries?: InputMaybe<Scalars['Int']['input']>;
  success?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<NotificationType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type NotificationUncheckedCreateWithoutProInput = {
  accountId?: InputMaybe<Scalars['Int']['input']>;
  applicationId?: InputMaybe<Scalars['Int']['input']>;
  bookingId?: InputMaybe<Scalars['Int']['input']>;
  breederId?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  litterId?: InputMaybe<Scalars['Int']['input']>;
  retries?: InputMaybe<Scalars['Int']['input']>;
  success?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<NotificationType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type NotificationUncheckedUpdateInput = {
  accountId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  applicationId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  bookingId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  breederId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  litterId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  proId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  retries?: InputMaybe<IntFieldUpdateOperationsInput>;
  success?: InputMaybe<BoolFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumNotificationTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type NotificationUncheckedUpdateManyInput = {
  accountId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  applicationId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  bookingId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  breederId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  litterId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  proId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  retries?: InputMaybe<IntFieldUpdateOperationsInput>;
  success?: InputMaybe<BoolFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumNotificationTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type NotificationUncheckedUpdateManyWithoutAccountInput = {
  applicationId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  bookingId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  breederId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  litterId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  proId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  retries?: InputMaybe<IntFieldUpdateOperationsInput>;
  success?: InputMaybe<BoolFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumNotificationTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type NotificationUncheckedUpdateManyWithoutAccountNestedInput = {
  connect?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<NotificationCreateOrConnectWithoutAccountInput>>;
  create?: InputMaybe<Array<NotificationCreateWithoutAccountInput>>;
  createMany?: InputMaybe<NotificationCreateManyAccountInputEnvelope>;
  delete?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<NotificationScalarWhereInput>>;
  disconnect?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  set?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  update?: InputMaybe<Array<NotificationUpdateWithWhereUniqueWithoutAccountInput>>;
  updateMany?: InputMaybe<Array<NotificationUpdateManyWithWhereWithoutAccountInput>>;
  upsert?: InputMaybe<Array<NotificationUpsertWithWhereUniqueWithoutAccountInput>>;
};

export type NotificationUncheckedUpdateManyWithoutApplicationInput = {
  accountId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  bookingId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  breederId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  litterId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  proId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  retries?: InputMaybe<IntFieldUpdateOperationsInput>;
  success?: InputMaybe<BoolFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumNotificationTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type NotificationUncheckedUpdateManyWithoutApplicationNestedInput = {
  connect?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<NotificationCreateOrConnectWithoutApplicationInput>>;
  create?: InputMaybe<Array<NotificationCreateWithoutApplicationInput>>;
  createMany?: InputMaybe<NotificationCreateManyApplicationInputEnvelope>;
  delete?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<NotificationScalarWhereInput>>;
  disconnect?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  set?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  update?: InputMaybe<Array<NotificationUpdateWithWhereUniqueWithoutApplicationInput>>;
  updateMany?: InputMaybe<Array<NotificationUpdateManyWithWhereWithoutApplicationInput>>;
  upsert?: InputMaybe<Array<NotificationUpsertWithWhereUniqueWithoutApplicationInput>>;
};

export type NotificationUncheckedUpdateManyWithoutBookingInput = {
  accountId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  applicationId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  breederId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  litterId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  proId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  retries?: InputMaybe<IntFieldUpdateOperationsInput>;
  success?: InputMaybe<BoolFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumNotificationTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type NotificationUncheckedUpdateManyWithoutBookingNestedInput = {
  connect?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<NotificationCreateOrConnectWithoutBookingInput>>;
  create?: InputMaybe<Array<NotificationCreateWithoutBookingInput>>;
  createMany?: InputMaybe<NotificationCreateManyBookingInputEnvelope>;
  delete?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<NotificationScalarWhereInput>>;
  disconnect?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  set?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  update?: InputMaybe<Array<NotificationUpdateWithWhereUniqueWithoutBookingInput>>;
  updateMany?: InputMaybe<Array<NotificationUpdateManyWithWhereWithoutBookingInput>>;
  upsert?: InputMaybe<Array<NotificationUpsertWithWhereUniqueWithoutBookingInput>>;
};

export type NotificationUncheckedUpdateManyWithoutBreederInput = {
  accountId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  applicationId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  bookingId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  litterId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  proId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  retries?: InputMaybe<IntFieldUpdateOperationsInput>;
  success?: InputMaybe<BoolFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumNotificationTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type NotificationUncheckedUpdateManyWithoutBreederNestedInput = {
  connect?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<NotificationCreateOrConnectWithoutBreederInput>>;
  create?: InputMaybe<Array<NotificationCreateWithoutBreederInput>>;
  createMany?: InputMaybe<NotificationCreateManyBreederInputEnvelope>;
  delete?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<NotificationScalarWhereInput>>;
  disconnect?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  set?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  update?: InputMaybe<Array<NotificationUpdateWithWhereUniqueWithoutBreederInput>>;
  updateMany?: InputMaybe<Array<NotificationUpdateManyWithWhereWithoutBreederInput>>;
  upsert?: InputMaybe<Array<NotificationUpsertWithWhereUniqueWithoutBreederInput>>;
};

export type NotificationUncheckedUpdateManyWithoutLitterInput = {
  accountId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  applicationId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  bookingId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  breederId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  proId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  retries?: InputMaybe<IntFieldUpdateOperationsInput>;
  success?: InputMaybe<BoolFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumNotificationTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type NotificationUncheckedUpdateManyWithoutLitterNestedInput = {
  connect?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<NotificationCreateOrConnectWithoutLitterInput>>;
  create?: InputMaybe<Array<NotificationCreateWithoutLitterInput>>;
  createMany?: InputMaybe<NotificationCreateManyLitterInputEnvelope>;
  delete?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<NotificationScalarWhereInput>>;
  disconnect?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  set?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  update?: InputMaybe<Array<NotificationUpdateWithWhereUniqueWithoutLitterInput>>;
  updateMany?: InputMaybe<Array<NotificationUpdateManyWithWhereWithoutLitterInput>>;
  upsert?: InputMaybe<Array<NotificationUpsertWithWhereUniqueWithoutLitterInput>>;
};

export type NotificationUncheckedUpdateManyWithoutProInput = {
  accountId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  applicationId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  bookingId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  breederId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  litterId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  retries?: InputMaybe<IntFieldUpdateOperationsInput>;
  success?: InputMaybe<BoolFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumNotificationTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type NotificationUncheckedUpdateManyWithoutProNestedInput = {
  connect?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<NotificationCreateOrConnectWithoutProInput>>;
  create?: InputMaybe<Array<NotificationCreateWithoutProInput>>;
  createMany?: InputMaybe<NotificationCreateManyProInputEnvelope>;
  delete?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<NotificationScalarWhereInput>>;
  disconnect?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  set?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  update?: InputMaybe<Array<NotificationUpdateWithWhereUniqueWithoutProInput>>;
  updateMany?: InputMaybe<Array<NotificationUpdateManyWithWhereWithoutProInput>>;
  upsert?: InputMaybe<Array<NotificationUpsertWithWhereUniqueWithoutProInput>>;
};

export type NotificationUncheckedUpdateWithoutAccountInput = {
  applicationId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  bookingId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  breederId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  litterId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  proId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  retries?: InputMaybe<IntFieldUpdateOperationsInput>;
  success?: InputMaybe<BoolFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumNotificationTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type NotificationUncheckedUpdateWithoutApplicationInput = {
  accountId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  bookingId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  breederId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  litterId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  proId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  retries?: InputMaybe<IntFieldUpdateOperationsInput>;
  success?: InputMaybe<BoolFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumNotificationTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type NotificationUncheckedUpdateWithoutBookingInput = {
  accountId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  applicationId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  breederId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  litterId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  proId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  retries?: InputMaybe<IntFieldUpdateOperationsInput>;
  success?: InputMaybe<BoolFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumNotificationTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type NotificationUncheckedUpdateWithoutBreederInput = {
  accountId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  applicationId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  bookingId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  litterId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  proId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  retries?: InputMaybe<IntFieldUpdateOperationsInput>;
  success?: InputMaybe<BoolFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumNotificationTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type NotificationUncheckedUpdateWithoutLitterInput = {
  accountId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  applicationId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  bookingId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  breederId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  proId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  retries?: InputMaybe<IntFieldUpdateOperationsInput>;
  success?: InputMaybe<BoolFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumNotificationTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type NotificationUncheckedUpdateWithoutProInput = {
  accountId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  applicationId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  bookingId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  breederId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  litterId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  retries?: InputMaybe<IntFieldUpdateOperationsInput>;
  success?: InputMaybe<BoolFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumNotificationTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type NotificationUpdateInput = {
  account?: InputMaybe<AccountUpdateOneWithoutNotificationsNestedInput>;
  application?: InputMaybe<DogBreederApplicationUpdateOneWithoutNotificationsNestedInput>;
  booking?: InputMaybe<BookingUpdateOneWithoutNotificationsNestedInput>;
  breeder?: InputMaybe<DogBreederUpdateOneWithoutNotificationsNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  litter?: InputMaybe<LitterUpdateOneWithoutNotificationsNestedInput>;
  pro?: InputMaybe<ProfessionalUpdateOneWithoutNotificationsNestedInput>;
  retries?: InputMaybe<IntFieldUpdateOperationsInput>;
  success?: InputMaybe<BoolFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumNotificationTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type NotificationUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  retries?: InputMaybe<IntFieldUpdateOperationsInput>;
  success?: InputMaybe<BoolFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumNotificationTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type NotificationUpdateManyWithWhereWithoutAccountInput = {
  data: NotificationUpdateManyMutationInput;
  where: NotificationScalarWhereInput;
};

export type NotificationUpdateManyWithWhereWithoutApplicationInput = {
  data: NotificationUpdateManyMutationInput;
  where: NotificationScalarWhereInput;
};

export type NotificationUpdateManyWithWhereWithoutBookingInput = {
  data: NotificationUpdateManyMutationInput;
  where: NotificationScalarWhereInput;
};

export type NotificationUpdateManyWithWhereWithoutBreederInput = {
  data: NotificationUpdateManyMutationInput;
  where: NotificationScalarWhereInput;
};

export type NotificationUpdateManyWithWhereWithoutLitterInput = {
  data: NotificationUpdateManyMutationInput;
  where: NotificationScalarWhereInput;
};

export type NotificationUpdateManyWithWhereWithoutProInput = {
  data: NotificationUpdateManyMutationInput;
  where: NotificationScalarWhereInput;
};

export type NotificationUpdateManyWithoutAccountNestedInput = {
  connect?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<NotificationCreateOrConnectWithoutAccountInput>>;
  create?: InputMaybe<Array<NotificationCreateWithoutAccountInput>>;
  createMany?: InputMaybe<NotificationCreateManyAccountInputEnvelope>;
  delete?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<NotificationScalarWhereInput>>;
  disconnect?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  set?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  update?: InputMaybe<Array<NotificationUpdateWithWhereUniqueWithoutAccountInput>>;
  updateMany?: InputMaybe<Array<NotificationUpdateManyWithWhereWithoutAccountInput>>;
  upsert?: InputMaybe<Array<NotificationUpsertWithWhereUniqueWithoutAccountInput>>;
};

export type NotificationUpdateManyWithoutApplicationNestedInput = {
  connect?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<NotificationCreateOrConnectWithoutApplicationInput>>;
  create?: InputMaybe<Array<NotificationCreateWithoutApplicationInput>>;
  createMany?: InputMaybe<NotificationCreateManyApplicationInputEnvelope>;
  delete?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<NotificationScalarWhereInput>>;
  disconnect?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  set?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  update?: InputMaybe<Array<NotificationUpdateWithWhereUniqueWithoutApplicationInput>>;
  updateMany?: InputMaybe<Array<NotificationUpdateManyWithWhereWithoutApplicationInput>>;
  upsert?: InputMaybe<Array<NotificationUpsertWithWhereUniqueWithoutApplicationInput>>;
};

export type NotificationUpdateManyWithoutBookingNestedInput = {
  connect?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<NotificationCreateOrConnectWithoutBookingInput>>;
  create?: InputMaybe<Array<NotificationCreateWithoutBookingInput>>;
  createMany?: InputMaybe<NotificationCreateManyBookingInputEnvelope>;
  delete?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<NotificationScalarWhereInput>>;
  disconnect?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  set?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  update?: InputMaybe<Array<NotificationUpdateWithWhereUniqueWithoutBookingInput>>;
  updateMany?: InputMaybe<Array<NotificationUpdateManyWithWhereWithoutBookingInput>>;
  upsert?: InputMaybe<Array<NotificationUpsertWithWhereUniqueWithoutBookingInput>>;
};

export type NotificationUpdateManyWithoutBreederNestedInput = {
  connect?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<NotificationCreateOrConnectWithoutBreederInput>>;
  create?: InputMaybe<Array<NotificationCreateWithoutBreederInput>>;
  createMany?: InputMaybe<NotificationCreateManyBreederInputEnvelope>;
  delete?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<NotificationScalarWhereInput>>;
  disconnect?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  set?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  update?: InputMaybe<Array<NotificationUpdateWithWhereUniqueWithoutBreederInput>>;
  updateMany?: InputMaybe<Array<NotificationUpdateManyWithWhereWithoutBreederInput>>;
  upsert?: InputMaybe<Array<NotificationUpsertWithWhereUniqueWithoutBreederInput>>;
};

export type NotificationUpdateManyWithoutLitterNestedInput = {
  connect?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<NotificationCreateOrConnectWithoutLitterInput>>;
  create?: InputMaybe<Array<NotificationCreateWithoutLitterInput>>;
  createMany?: InputMaybe<NotificationCreateManyLitterInputEnvelope>;
  delete?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<NotificationScalarWhereInput>>;
  disconnect?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  set?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  update?: InputMaybe<Array<NotificationUpdateWithWhereUniqueWithoutLitterInput>>;
  updateMany?: InputMaybe<Array<NotificationUpdateManyWithWhereWithoutLitterInput>>;
  upsert?: InputMaybe<Array<NotificationUpsertWithWhereUniqueWithoutLitterInput>>;
};

export type NotificationUpdateManyWithoutProNestedInput = {
  connect?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<NotificationCreateOrConnectWithoutProInput>>;
  create?: InputMaybe<Array<NotificationCreateWithoutProInput>>;
  createMany?: InputMaybe<NotificationCreateManyProInputEnvelope>;
  delete?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<NotificationScalarWhereInput>>;
  disconnect?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  set?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  update?: InputMaybe<Array<NotificationUpdateWithWhereUniqueWithoutProInput>>;
  updateMany?: InputMaybe<Array<NotificationUpdateManyWithWhereWithoutProInput>>;
  upsert?: InputMaybe<Array<NotificationUpsertWithWhereUniqueWithoutProInput>>;
};

export type NotificationUpdateWithWhereUniqueWithoutAccountInput = {
  data: NotificationUpdateWithoutAccountInput;
  where: NotificationWhereUniqueInput;
};

export type NotificationUpdateWithWhereUniqueWithoutApplicationInput = {
  data: NotificationUpdateWithoutApplicationInput;
  where: NotificationWhereUniqueInput;
};

export type NotificationUpdateWithWhereUniqueWithoutBookingInput = {
  data: NotificationUpdateWithoutBookingInput;
  where: NotificationWhereUniqueInput;
};

export type NotificationUpdateWithWhereUniqueWithoutBreederInput = {
  data: NotificationUpdateWithoutBreederInput;
  where: NotificationWhereUniqueInput;
};

export type NotificationUpdateWithWhereUniqueWithoutLitterInput = {
  data: NotificationUpdateWithoutLitterInput;
  where: NotificationWhereUniqueInput;
};

export type NotificationUpdateWithWhereUniqueWithoutProInput = {
  data: NotificationUpdateWithoutProInput;
  where: NotificationWhereUniqueInput;
};

export type NotificationUpdateWithoutAccountInput = {
  application?: InputMaybe<DogBreederApplicationUpdateOneWithoutNotificationsNestedInput>;
  booking?: InputMaybe<BookingUpdateOneWithoutNotificationsNestedInput>;
  breeder?: InputMaybe<DogBreederUpdateOneWithoutNotificationsNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  litter?: InputMaybe<LitterUpdateOneWithoutNotificationsNestedInput>;
  pro?: InputMaybe<ProfessionalUpdateOneWithoutNotificationsNestedInput>;
  retries?: InputMaybe<IntFieldUpdateOperationsInput>;
  success?: InputMaybe<BoolFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumNotificationTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type NotificationUpdateWithoutApplicationInput = {
  account?: InputMaybe<AccountUpdateOneWithoutNotificationsNestedInput>;
  booking?: InputMaybe<BookingUpdateOneWithoutNotificationsNestedInput>;
  breeder?: InputMaybe<DogBreederUpdateOneWithoutNotificationsNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  litter?: InputMaybe<LitterUpdateOneWithoutNotificationsNestedInput>;
  pro?: InputMaybe<ProfessionalUpdateOneWithoutNotificationsNestedInput>;
  retries?: InputMaybe<IntFieldUpdateOperationsInput>;
  success?: InputMaybe<BoolFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumNotificationTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type NotificationUpdateWithoutBookingInput = {
  account?: InputMaybe<AccountUpdateOneWithoutNotificationsNestedInput>;
  application?: InputMaybe<DogBreederApplicationUpdateOneWithoutNotificationsNestedInput>;
  breeder?: InputMaybe<DogBreederUpdateOneWithoutNotificationsNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  litter?: InputMaybe<LitterUpdateOneWithoutNotificationsNestedInput>;
  pro?: InputMaybe<ProfessionalUpdateOneWithoutNotificationsNestedInput>;
  retries?: InputMaybe<IntFieldUpdateOperationsInput>;
  success?: InputMaybe<BoolFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumNotificationTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type NotificationUpdateWithoutBreederInput = {
  account?: InputMaybe<AccountUpdateOneWithoutNotificationsNestedInput>;
  application?: InputMaybe<DogBreederApplicationUpdateOneWithoutNotificationsNestedInput>;
  booking?: InputMaybe<BookingUpdateOneWithoutNotificationsNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  litter?: InputMaybe<LitterUpdateOneWithoutNotificationsNestedInput>;
  pro?: InputMaybe<ProfessionalUpdateOneWithoutNotificationsNestedInput>;
  retries?: InputMaybe<IntFieldUpdateOperationsInput>;
  success?: InputMaybe<BoolFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumNotificationTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type NotificationUpdateWithoutLitterInput = {
  account?: InputMaybe<AccountUpdateOneWithoutNotificationsNestedInput>;
  application?: InputMaybe<DogBreederApplicationUpdateOneWithoutNotificationsNestedInput>;
  booking?: InputMaybe<BookingUpdateOneWithoutNotificationsNestedInput>;
  breeder?: InputMaybe<DogBreederUpdateOneWithoutNotificationsNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  pro?: InputMaybe<ProfessionalUpdateOneWithoutNotificationsNestedInput>;
  retries?: InputMaybe<IntFieldUpdateOperationsInput>;
  success?: InputMaybe<BoolFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumNotificationTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type NotificationUpdateWithoutProInput = {
  account?: InputMaybe<AccountUpdateOneWithoutNotificationsNestedInput>;
  application?: InputMaybe<DogBreederApplicationUpdateOneWithoutNotificationsNestedInput>;
  booking?: InputMaybe<BookingUpdateOneWithoutNotificationsNestedInput>;
  breeder?: InputMaybe<DogBreederUpdateOneWithoutNotificationsNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  litter?: InputMaybe<LitterUpdateOneWithoutNotificationsNestedInput>;
  retries?: InputMaybe<IntFieldUpdateOperationsInput>;
  success?: InputMaybe<BoolFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumNotificationTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type NotificationUpsertWithWhereUniqueWithoutAccountInput = {
  create: NotificationCreateWithoutAccountInput;
  update: NotificationUpdateWithoutAccountInput;
  where: NotificationWhereUniqueInput;
};

export type NotificationUpsertWithWhereUniqueWithoutApplicationInput = {
  create: NotificationCreateWithoutApplicationInput;
  update: NotificationUpdateWithoutApplicationInput;
  where: NotificationWhereUniqueInput;
};

export type NotificationUpsertWithWhereUniqueWithoutBookingInput = {
  create: NotificationCreateWithoutBookingInput;
  update: NotificationUpdateWithoutBookingInput;
  where: NotificationWhereUniqueInput;
};

export type NotificationUpsertWithWhereUniqueWithoutBreederInput = {
  create: NotificationCreateWithoutBreederInput;
  update: NotificationUpdateWithoutBreederInput;
  where: NotificationWhereUniqueInput;
};

export type NotificationUpsertWithWhereUniqueWithoutLitterInput = {
  create: NotificationCreateWithoutLitterInput;
  update: NotificationUpdateWithoutLitterInput;
  where: NotificationWhereUniqueInput;
};

export type NotificationUpsertWithWhereUniqueWithoutProInput = {
  create: NotificationCreateWithoutProInput;
  update: NotificationUpdateWithoutProInput;
  where: NotificationWhereUniqueInput;
};

export type NotificationWhereInput = {
  AND?: InputMaybe<Array<NotificationWhereInput>>;
  NOT?: InputMaybe<Array<NotificationWhereInput>>;
  OR?: InputMaybe<Array<NotificationWhereInput>>;
  account?: InputMaybe<AccountNullableRelationFilter>;
  accountId?: InputMaybe<IntNullableFilter>;
  application?: InputMaybe<DogBreederApplicationNullableRelationFilter>;
  applicationId?: InputMaybe<IntNullableFilter>;
  booking?: InputMaybe<BookingNullableRelationFilter>;
  bookingId?: InputMaybe<IntNullableFilter>;
  breeder?: InputMaybe<DogBreederNullableRelationFilter>;
  breederId?: InputMaybe<IntNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntFilter>;
  litter?: InputMaybe<LitterNullableRelationFilter>;
  litterId?: InputMaybe<IntNullableFilter>;
  pro?: InputMaybe<ProfessionalNullableRelationFilter>;
  proId?: InputMaybe<IntNullableFilter>;
  retries?: InputMaybe<IntFilter>;
  success?: InputMaybe<BoolFilter>;
  type?: InputMaybe<EnumNotificationTypeNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type NotificationWhereUniqueInput = {
  AND?: InputMaybe<Array<NotificationWhereInput>>;
  NOT?: InputMaybe<Array<NotificationWhereInput>>;
  OR?: InputMaybe<Array<NotificationWhereInput>>;
  account?: InputMaybe<AccountNullableRelationFilter>;
  accountId?: InputMaybe<IntNullableFilter>;
  application?: InputMaybe<DogBreederApplicationNullableRelationFilter>;
  applicationId?: InputMaybe<IntNullableFilter>;
  booking?: InputMaybe<BookingNullableRelationFilter>;
  bookingId?: InputMaybe<IntNullableFilter>;
  breeder?: InputMaybe<DogBreederNullableRelationFilter>;
  breederId?: InputMaybe<IntNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  litter?: InputMaybe<LitterNullableRelationFilter>;
  litterId?: InputMaybe<IntNullableFilter>;
  pro?: InputMaybe<ProfessionalNullableRelationFilter>;
  proId?: InputMaybe<IntNullableFilter>;
  retries?: InputMaybe<IntFilter>;
  success?: InputMaybe<BoolFilter>;
  type?: InputMaybe<EnumNotificationTypeNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type Notifications = {
  __typename?: 'Notifications';
  count: Scalars['Int']['output'];
  items: Array<Maybe<Notification>>;
  unreadMessagesCount: Scalars['Int']['output'];
};

export type NullableBoolFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NullableDateTimeFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['DateTime']['input']>;
};

export type NullableEnumAnimalSizeEnumFieldUpdateOperationsInput = {
  set?: InputMaybe<AnimalSizeEnum>;
};

export type NullableEnumAnimalTypeEnumFieldUpdateOperationsInput = {
  set?: InputMaybe<AnimalTypeEnum>;
};

export type NullableEnumBirthdayTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<BirthdayType>;
};

export type NullableEnumBreedGeneticAnalyzeTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<BreedGeneticAnalyzeType>;
};

export type NullableEnumCenterTypeEnumFieldUpdateOperationsInput = {
  set?: InputMaybe<CenterTypeEnum>;
};

export type NullableEnumCountryCodeFieldUpdateOperationsInput = {
  set?: InputMaybe<CountryCode>;
};

export type NullableEnumCouplingTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<CouplingType>;
};

export type NullableEnumDogBreederContactTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<DogBreederContactType>;
};

export type NullableEnumDogCoatFieldUpdateOperationsInput = {
  set?: InputMaybe<DogCoat>;
};

export type NullableEnumDogColorFieldUpdateOperationsInput = {
  set?: InputMaybe<DogColor>;
};

export type NullableEnumDogHairTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<DogHairType>;
};

export type NullableEnumDogPhysicalConditionFieldUpdateOperationsInput = {
  set?: InputMaybe<DogPhysicalCondition>;
};

export type NullableEnumEducatorTypeEnumFieldUpdateOperationsInput = {
  set?: InputMaybe<EducatorTypeEnum>;
};

export type NullableEnumFrequencyTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<FrequencyType>;
};

export type NullableEnumGenderEnumFieldUpdateOperationsInput = {
  set?: InputMaybe<GenderEnum>;
};

export type NullableEnumHeadShapeFieldUpdateOperationsInput = {
  set?: InputMaybe<HeadShape>;
};

export type NullableEnumLastVisitTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<LastVisitType>;
};

export type NullableEnumNotificationTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<NotificationType>;
};

export type NullableEnumProfessionalTypeEnumFieldUpdateOperationsInput = {
  set?: InputMaybe<ProfessionalTypeEnum>;
};

export type NullableEnumTemperTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<TemperType>;
};

export type NullableEnumWorkerServicePriceTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<WorkerServicePriceType>;
};

export type NullableEnumYesNoUnknownStatusFieldUpdateOperationsInput = {
  set?: InputMaybe<YesNoUnknownStatus>;
};

export type NullableFloatFieldUpdateOperationsInput = {
  decrement?: InputMaybe<Scalars['Float']['input']>;
  divide?: InputMaybe<Scalars['Float']['input']>;
  increment?: InputMaybe<Scalars['Float']['input']>;
  multiply?: InputMaybe<Scalars['Float']['input']>;
  set?: InputMaybe<Scalars['Float']['input']>;
};

export type NullableIntFieldUpdateOperationsInput = {
  decrement?: InputMaybe<Scalars['Int']['input']>;
  divide?: InputMaybe<Scalars['Int']['input']>;
  increment?: InputMaybe<Scalars['Int']['input']>;
  multiply?: InputMaybe<Scalars['Int']['input']>;
  set?: InputMaybe<Scalars['Int']['input']>;
};

export type NullableStringFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['String']['input']>;
};

export enum NullsOrder {
  first = 'first',
  last = 'last'
}

export type OwnApplicationInput = {
  applicationId: Scalars['Int']['input'];
  breedId: Scalars['Int']['input'];
  dateOfBirth: Scalars['DateTime']['input'];
  gender: GenderEnum;
  name?: InputMaybe<Scalars['String']['input']>;
};

export enum ParentTypeEnum {
  FATHER = 'FATHER',
  MOTHER = 'MOTHER'
}

export type PaymentAvgAggregateOutputType = {
  __typename?: 'PaymentAvgAggregateOutputType';
  accountId?: Maybe<Scalars['Float']['output']>;
};

export type PaymentAvgOrderByAggregateInput = {
  accountId?: InputMaybe<SortOrder>;
};

export type PaymentCountAggregateOutputType = {
  __typename?: 'PaymentCountAggregateOutputType';
  _all: Scalars['Int']['output'];
  accountId: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  paymentIntentId: Scalars['Int']['output'];
  status: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type PaymentCountOrderByAggregateInput = {
  accountId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  paymentIntentId?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type PaymentCreateInput = {
  account: AccountCreateNestedOneWithoutPaymentsInput;
  application?: InputMaybe<DogBreederApplicationCreateNestedOneWithoutPaymentInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  paymentIntentId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<PaymentStatus>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PaymentCreateManyAccountInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  paymentIntentId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<PaymentStatus>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PaymentCreateManyAccountInputEnvelope = {
  data: Array<PaymentCreateManyAccountInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PaymentCreateManyInput = {
  accountId: Scalars['Int']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  paymentIntentId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<PaymentStatus>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PaymentCreateNestedManyWithoutAccountInput = {
  connect?: InputMaybe<Array<PaymentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PaymentCreateOrConnectWithoutAccountInput>>;
  create?: InputMaybe<Array<PaymentCreateWithoutAccountInput>>;
  createMany?: InputMaybe<PaymentCreateManyAccountInputEnvelope>;
};

export type PaymentCreateNestedOneWithoutApplicationInput = {
  connect?: InputMaybe<PaymentWhereUniqueInput>;
  connectOrCreate?: InputMaybe<PaymentCreateOrConnectWithoutApplicationInput>;
  create?: InputMaybe<PaymentCreateWithoutApplicationInput>;
};

export type PaymentCreateOrConnectWithoutAccountInput = {
  create: PaymentCreateWithoutAccountInput;
  where: PaymentWhereUniqueInput;
};

export type PaymentCreateOrConnectWithoutApplicationInput = {
  create: PaymentCreateWithoutApplicationInput;
  where: PaymentWhereUniqueInput;
};

export type PaymentCreateWithoutAccountInput = {
  application?: InputMaybe<DogBreederApplicationCreateNestedOneWithoutPaymentInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  paymentIntentId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<PaymentStatus>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PaymentCreateWithoutApplicationInput = {
  account: AccountCreateNestedOneWithoutPaymentsInput;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  paymentIntentId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<PaymentStatus>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PaymentListRelationFilter = {
  every?: InputMaybe<PaymentWhereInput>;
  none?: InputMaybe<PaymentWhereInput>;
  some?: InputMaybe<PaymentWhereInput>;
};

export type PaymentMaxAggregateOutputType = {
  __typename?: 'PaymentMaxAggregateOutputType';
  accountId?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  paymentIntentId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<PaymentStatus>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type PaymentMaxOrderByAggregateInput = {
  accountId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  paymentIntentId?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type PaymentMinAggregateOutputType = {
  __typename?: 'PaymentMinAggregateOutputType';
  accountId?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  paymentIntentId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<PaymentStatus>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type PaymentMinOrderByAggregateInput = {
  accountId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  paymentIntentId?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type PaymentNullableRelationFilter = {
  is?: InputMaybe<PaymentWhereInput>;
  isNot?: InputMaybe<PaymentWhereInput>;
};

export type PaymentOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export enum PaymentOrderByRelevanceFieldEnum {
  id = 'id',
  paymentIntentId = 'paymentIntentId'
}

export type PaymentOrderByRelevanceInput = {
  fields: Array<PaymentOrderByRelevanceFieldEnum>;
  search: Scalars['String']['input'];
  sort: SortOrder;
};

export type PaymentOrderByWithAggregationInput = {
  _avg?: InputMaybe<PaymentAvgOrderByAggregateInput>;
  _count?: InputMaybe<PaymentCountOrderByAggregateInput>;
  _max?: InputMaybe<PaymentMaxOrderByAggregateInput>;
  _min?: InputMaybe<PaymentMinOrderByAggregateInput>;
  _sum?: InputMaybe<PaymentSumOrderByAggregateInput>;
  accountId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  paymentIntentId?: InputMaybe<SortOrderInput>;
  status?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type PaymentOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: InputMaybe<PaymentOrderByRelevanceInput>;
  account?: InputMaybe<AccountOrderByWithRelationAndSearchRelevanceInput>;
  accountId?: InputMaybe<SortOrder>;
  application?: InputMaybe<DogBreederApplicationOrderByWithRelationAndSearchRelevanceInput>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  paymentIntentId?: InputMaybe<SortOrderInput>;
  status?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum PaymentScalarFieldEnum {
  accountId = 'accountId',
  createdAt = 'createdAt',
  id = 'id',
  paymentIntentId = 'paymentIntentId',
  status = 'status',
  updatedAt = 'updatedAt'
}

export type PaymentScalarWhereInput = {
  AND?: InputMaybe<Array<PaymentScalarWhereInput>>;
  NOT?: InputMaybe<Array<PaymentScalarWhereInput>>;
  OR?: InputMaybe<Array<PaymentScalarWhereInput>>;
  accountId?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  paymentIntentId?: InputMaybe<StringNullableFilter>;
  status?: InputMaybe<EnumPaymentStatusFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type PaymentScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<PaymentScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<PaymentScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<PaymentScalarWhereWithAggregatesInput>>;
  accountId?: InputMaybe<IntWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  paymentIntentId?: InputMaybe<StringNullableWithAggregatesFilter>;
  status?: InputMaybe<EnumPaymentStatusWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export enum PaymentStatus {
  FAILED = 'FAILED',
  PAID = 'PAID',
  PENDING = 'PENDING',
  REFUNDED = 'REFUNDED'
}

export type PaymentSumAggregateOutputType = {
  __typename?: 'PaymentSumAggregateOutputType';
  accountId?: Maybe<Scalars['Int']['output']>;
};

export type PaymentSumOrderByAggregateInput = {
  accountId?: InputMaybe<SortOrder>;
};

export type PaymentUncheckedCreateInput = {
  accountId: Scalars['Int']['input'];
  application?: InputMaybe<DogBreederApplicationUncheckedCreateNestedOneWithoutPaymentInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  paymentIntentId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<PaymentStatus>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PaymentUncheckedCreateNestedManyWithoutAccountInput = {
  connect?: InputMaybe<Array<PaymentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PaymentCreateOrConnectWithoutAccountInput>>;
  create?: InputMaybe<Array<PaymentCreateWithoutAccountInput>>;
  createMany?: InputMaybe<PaymentCreateManyAccountInputEnvelope>;
};

export type PaymentUncheckedCreateWithoutAccountInput = {
  application?: InputMaybe<DogBreederApplicationUncheckedCreateNestedOneWithoutPaymentInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  paymentIntentId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<PaymentStatus>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PaymentUncheckedCreateWithoutApplicationInput = {
  accountId: Scalars['Int']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  paymentIntentId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<PaymentStatus>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PaymentUncheckedUpdateInput = {
  accountId?: InputMaybe<IntFieldUpdateOperationsInput>;
  application?: InputMaybe<DogBreederApplicationUncheckedUpdateOneWithoutPaymentNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  paymentIntentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumPaymentStatusFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type PaymentUncheckedUpdateManyInput = {
  accountId?: InputMaybe<IntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  paymentIntentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumPaymentStatusFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type PaymentUncheckedUpdateManyWithoutAccountInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  paymentIntentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumPaymentStatusFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type PaymentUncheckedUpdateManyWithoutAccountNestedInput = {
  connect?: InputMaybe<Array<PaymentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PaymentCreateOrConnectWithoutAccountInput>>;
  create?: InputMaybe<Array<PaymentCreateWithoutAccountInput>>;
  createMany?: InputMaybe<PaymentCreateManyAccountInputEnvelope>;
  delete?: InputMaybe<Array<PaymentWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<PaymentScalarWhereInput>>;
  disconnect?: InputMaybe<Array<PaymentWhereUniqueInput>>;
  set?: InputMaybe<Array<PaymentWhereUniqueInput>>;
  update?: InputMaybe<Array<PaymentUpdateWithWhereUniqueWithoutAccountInput>>;
  updateMany?: InputMaybe<Array<PaymentUpdateManyWithWhereWithoutAccountInput>>;
  upsert?: InputMaybe<Array<PaymentUpsertWithWhereUniqueWithoutAccountInput>>;
};

export type PaymentUncheckedUpdateWithoutAccountInput = {
  application?: InputMaybe<DogBreederApplicationUncheckedUpdateOneWithoutPaymentNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  paymentIntentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumPaymentStatusFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type PaymentUncheckedUpdateWithoutApplicationInput = {
  accountId?: InputMaybe<IntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  paymentIntentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumPaymentStatusFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type PaymentUpdateInput = {
  account?: InputMaybe<AccountUpdateOneRequiredWithoutPaymentsNestedInput>;
  application?: InputMaybe<DogBreederApplicationUpdateOneWithoutPaymentNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  paymentIntentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumPaymentStatusFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type PaymentUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  paymentIntentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumPaymentStatusFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type PaymentUpdateManyWithWhereWithoutAccountInput = {
  data: PaymentUpdateManyMutationInput;
  where: PaymentScalarWhereInput;
};

export type PaymentUpdateManyWithoutAccountNestedInput = {
  connect?: InputMaybe<Array<PaymentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PaymentCreateOrConnectWithoutAccountInput>>;
  create?: InputMaybe<Array<PaymentCreateWithoutAccountInput>>;
  createMany?: InputMaybe<PaymentCreateManyAccountInputEnvelope>;
  delete?: InputMaybe<Array<PaymentWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<PaymentScalarWhereInput>>;
  disconnect?: InputMaybe<Array<PaymentWhereUniqueInput>>;
  set?: InputMaybe<Array<PaymentWhereUniqueInput>>;
  update?: InputMaybe<Array<PaymentUpdateWithWhereUniqueWithoutAccountInput>>;
  updateMany?: InputMaybe<Array<PaymentUpdateManyWithWhereWithoutAccountInput>>;
  upsert?: InputMaybe<Array<PaymentUpsertWithWhereUniqueWithoutAccountInput>>;
};

export type PaymentUpdateOneWithoutApplicationNestedInput = {
  connect?: InputMaybe<PaymentWhereUniqueInput>;
  connectOrCreate?: InputMaybe<PaymentCreateOrConnectWithoutApplicationInput>;
  create?: InputMaybe<PaymentCreateWithoutApplicationInput>;
  delete?: InputMaybe<PaymentWhereInput>;
  disconnect?: InputMaybe<PaymentWhereInput>;
  update?: InputMaybe<PaymentUpdateToOneWithWhereWithoutApplicationInput>;
  upsert?: InputMaybe<PaymentUpsertWithoutApplicationInput>;
};

export type PaymentUpdateToOneWithWhereWithoutApplicationInput = {
  data: PaymentUpdateWithoutApplicationInput;
  where?: InputMaybe<PaymentWhereInput>;
};

export type PaymentUpdateWithWhereUniqueWithoutAccountInput = {
  data: PaymentUpdateWithoutAccountInput;
  where: PaymentWhereUniqueInput;
};

export type PaymentUpdateWithoutAccountInput = {
  application?: InputMaybe<DogBreederApplicationUpdateOneWithoutPaymentNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  paymentIntentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumPaymentStatusFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type PaymentUpdateWithoutApplicationInput = {
  account?: InputMaybe<AccountUpdateOneRequiredWithoutPaymentsNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  paymentIntentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumPaymentStatusFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type PaymentUpsertWithWhereUniqueWithoutAccountInput = {
  create: PaymentCreateWithoutAccountInput;
  update: PaymentUpdateWithoutAccountInput;
  where: PaymentWhereUniqueInput;
};

export type PaymentUpsertWithoutApplicationInput = {
  create: PaymentCreateWithoutApplicationInput;
  update: PaymentUpdateWithoutApplicationInput;
  where?: InputMaybe<PaymentWhereInput>;
};

export type PaymentWhereInput = {
  AND?: InputMaybe<Array<PaymentWhereInput>>;
  NOT?: InputMaybe<Array<PaymentWhereInput>>;
  OR?: InputMaybe<Array<PaymentWhereInput>>;
  account?: InputMaybe<AccountRelationFilter>;
  accountId?: InputMaybe<IntFilter>;
  application?: InputMaybe<DogBreederApplicationNullableRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  paymentIntentId?: InputMaybe<StringNullableFilter>;
  status?: InputMaybe<EnumPaymentStatusFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type PaymentWhereUniqueInput = {
  AND?: InputMaybe<Array<PaymentWhereInput>>;
  NOT?: InputMaybe<Array<PaymentWhereInput>>;
  OR?: InputMaybe<Array<PaymentWhereInput>>;
  account?: InputMaybe<AccountRelationFilter>;
  accountId?: InputMaybe<IntFilter>;
  application?: InputMaybe<DogBreederApplicationNullableRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  paymentIntentId?: InputMaybe<StringNullableFilter>;
  status?: InputMaybe<EnumPaymentStatusFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type PersistHasADogInput = {
  email: Scalars['String']['input'];
  hasADog?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProAvailability = {
  __typename?: 'ProAvailability';
  createdAt: Scalars['DateTime']['output'];
  dayOfWeek: DayOfWeek;
  endTime: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  pro: Professional;
  proId: Scalars['Int']['output'];
  startTime: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ProAvailabilityAvgAggregateOutputType = {
  __typename?: 'ProAvailabilityAvgAggregateOutputType';
  id?: Maybe<Scalars['Float']['output']>;
  proId?: Maybe<Scalars['Float']['output']>;
};

export type ProAvailabilityAvgOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
  proId?: InputMaybe<SortOrder>;
};

export type ProAvailabilityCountAggregateOutputType = {
  __typename?: 'ProAvailabilityCountAggregateOutputType';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  dayOfWeek: Scalars['Int']['output'];
  endTime: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  proId: Scalars['Int']['output'];
  startTime: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type ProAvailabilityCountOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  dayOfWeek?: InputMaybe<SortOrder>;
  endTime?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  proId?: InputMaybe<SortOrder>;
  startTime?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ProAvailabilityCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dayOfWeek: DayOfWeek;
  endTime: Scalars['String']['input'];
  pro: ProfessionalCreateNestedOneWithoutAvailabilitiesInput;
  startTime: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ProAvailabilityCreateManyInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dayOfWeek: DayOfWeek;
  endTime: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  proId: Scalars['Int']['input'];
  startTime: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ProAvailabilityCreateManyProInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dayOfWeek: DayOfWeek;
  endTime: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  startTime: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ProAvailabilityCreateManyProInputEnvelope = {
  data: Array<ProAvailabilityCreateManyProInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProAvailabilityCreateNestedManyWithoutProInput = {
  connect?: InputMaybe<Array<ProAvailabilityWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProAvailabilityCreateOrConnectWithoutProInput>>;
  create?: InputMaybe<Array<ProAvailabilityCreateWithoutProInput>>;
  createMany?: InputMaybe<ProAvailabilityCreateManyProInputEnvelope>;
};

export type ProAvailabilityCreateOrConnectWithoutProInput = {
  create: ProAvailabilityCreateWithoutProInput;
  where: ProAvailabilityWhereUniqueInput;
};

export type ProAvailabilityCreateWithoutProInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dayOfWeek: DayOfWeek;
  endTime: Scalars['String']['input'];
  startTime: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ProAvailabilityListRelationFilter = {
  every?: InputMaybe<ProAvailabilityWhereInput>;
  none?: InputMaybe<ProAvailabilityWhereInput>;
  some?: InputMaybe<ProAvailabilityWhereInput>;
};

export type ProAvailabilityMaxAggregateOutputType = {
  __typename?: 'ProAvailabilityMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  dayOfWeek?: Maybe<DayOfWeek>;
  endTime?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  proId?: Maybe<Scalars['Int']['output']>;
  startTime?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ProAvailabilityMaxOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  dayOfWeek?: InputMaybe<SortOrder>;
  endTime?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  proId?: InputMaybe<SortOrder>;
  startTime?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ProAvailabilityMinAggregateOutputType = {
  __typename?: 'ProAvailabilityMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  dayOfWeek?: Maybe<DayOfWeek>;
  endTime?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  proId?: Maybe<Scalars['Int']['output']>;
  startTime?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ProAvailabilityMinOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  dayOfWeek?: InputMaybe<SortOrder>;
  endTime?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  proId?: InputMaybe<SortOrder>;
  startTime?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ProAvailabilityOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export enum ProAvailabilityOrderByRelevanceFieldEnum {
  endTime = 'endTime',
  startTime = 'startTime'
}

export type ProAvailabilityOrderByRelevanceInput = {
  fields: Array<ProAvailabilityOrderByRelevanceFieldEnum>;
  search: Scalars['String']['input'];
  sort: SortOrder;
};

export type ProAvailabilityOrderByWithAggregationInput = {
  _avg?: InputMaybe<ProAvailabilityAvgOrderByAggregateInput>;
  _count?: InputMaybe<ProAvailabilityCountOrderByAggregateInput>;
  _max?: InputMaybe<ProAvailabilityMaxOrderByAggregateInput>;
  _min?: InputMaybe<ProAvailabilityMinOrderByAggregateInput>;
  _sum?: InputMaybe<ProAvailabilitySumOrderByAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  dayOfWeek?: InputMaybe<SortOrder>;
  endTime?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  proId?: InputMaybe<SortOrder>;
  startTime?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ProAvailabilityOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: InputMaybe<ProAvailabilityOrderByRelevanceInput>;
  createdAt?: InputMaybe<SortOrder>;
  dayOfWeek?: InputMaybe<SortOrder>;
  endTime?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  pro?: InputMaybe<ProfessionalOrderByWithRelationAndSearchRelevanceInput>;
  proId?: InputMaybe<SortOrder>;
  startTime?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum ProAvailabilityScalarFieldEnum {
  createdAt = 'createdAt',
  dayOfWeek = 'dayOfWeek',
  endTime = 'endTime',
  id = 'id',
  proId = 'proId',
  startTime = 'startTime',
  updatedAt = 'updatedAt'
}

export type ProAvailabilityScalarWhereInput = {
  AND?: InputMaybe<Array<ProAvailabilityScalarWhereInput>>;
  NOT?: InputMaybe<Array<ProAvailabilityScalarWhereInput>>;
  OR?: InputMaybe<Array<ProAvailabilityScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  dayOfWeek?: InputMaybe<EnumDayOfWeekFilter>;
  endTime?: InputMaybe<StringFilter>;
  id?: InputMaybe<IntFilter>;
  proId?: InputMaybe<IntFilter>;
  startTime?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ProAvailabilityScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<ProAvailabilityScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<ProAvailabilityScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<ProAvailabilityScalarWhereWithAggregatesInput>>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  dayOfWeek?: InputMaybe<EnumDayOfWeekWithAggregatesFilter>;
  endTime?: InputMaybe<StringWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  proId?: InputMaybe<IntWithAggregatesFilter>;
  startTime?: InputMaybe<StringWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type ProAvailabilitySumAggregateOutputType = {
  __typename?: 'ProAvailabilitySumAggregateOutputType';
  id?: Maybe<Scalars['Int']['output']>;
  proId?: Maybe<Scalars['Int']['output']>;
};

export type ProAvailabilitySumOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
  proId?: InputMaybe<SortOrder>;
};

export type ProAvailabilityUncheckedCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dayOfWeek: DayOfWeek;
  endTime: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  proId: Scalars['Int']['input'];
  startTime: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ProAvailabilityUncheckedCreateNestedManyWithoutProInput = {
  connect?: InputMaybe<Array<ProAvailabilityWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProAvailabilityCreateOrConnectWithoutProInput>>;
  create?: InputMaybe<Array<ProAvailabilityCreateWithoutProInput>>;
  createMany?: InputMaybe<ProAvailabilityCreateManyProInputEnvelope>;
};

export type ProAvailabilityUncheckedCreateWithoutProInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dayOfWeek: DayOfWeek;
  endTime: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  startTime: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ProAvailabilityUncheckedUpdateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dayOfWeek?: InputMaybe<EnumDayOfWeekFieldUpdateOperationsInput>;
  endTime?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  proId?: InputMaybe<IntFieldUpdateOperationsInput>;
  startTime?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ProAvailabilityUncheckedUpdateManyInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dayOfWeek?: InputMaybe<EnumDayOfWeekFieldUpdateOperationsInput>;
  endTime?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  proId?: InputMaybe<IntFieldUpdateOperationsInput>;
  startTime?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ProAvailabilityUncheckedUpdateManyWithoutProInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dayOfWeek?: InputMaybe<EnumDayOfWeekFieldUpdateOperationsInput>;
  endTime?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  startTime?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ProAvailabilityUncheckedUpdateManyWithoutProNestedInput = {
  connect?: InputMaybe<Array<ProAvailabilityWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProAvailabilityCreateOrConnectWithoutProInput>>;
  create?: InputMaybe<Array<ProAvailabilityCreateWithoutProInput>>;
  createMany?: InputMaybe<ProAvailabilityCreateManyProInputEnvelope>;
  delete?: InputMaybe<Array<ProAvailabilityWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ProAvailabilityScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ProAvailabilityWhereUniqueInput>>;
  set?: InputMaybe<Array<ProAvailabilityWhereUniqueInput>>;
  update?: InputMaybe<Array<ProAvailabilityUpdateWithWhereUniqueWithoutProInput>>;
  updateMany?: InputMaybe<Array<ProAvailabilityUpdateManyWithWhereWithoutProInput>>;
  upsert?: InputMaybe<Array<ProAvailabilityUpsertWithWhereUniqueWithoutProInput>>;
};

export type ProAvailabilityUncheckedUpdateWithoutProInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dayOfWeek?: InputMaybe<EnumDayOfWeekFieldUpdateOperationsInput>;
  endTime?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  startTime?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ProAvailabilityUpdateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dayOfWeek?: InputMaybe<EnumDayOfWeekFieldUpdateOperationsInput>;
  endTime?: InputMaybe<StringFieldUpdateOperationsInput>;
  pro?: InputMaybe<ProfessionalUpdateOneRequiredWithoutAvailabilitiesNestedInput>;
  startTime?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ProAvailabilityUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dayOfWeek?: InputMaybe<EnumDayOfWeekFieldUpdateOperationsInput>;
  endTime?: InputMaybe<StringFieldUpdateOperationsInput>;
  startTime?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ProAvailabilityUpdateManyWithWhereWithoutProInput = {
  data: ProAvailabilityUpdateManyMutationInput;
  where: ProAvailabilityScalarWhereInput;
};

export type ProAvailabilityUpdateManyWithoutProNestedInput = {
  connect?: InputMaybe<Array<ProAvailabilityWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProAvailabilityCreateOrConnectWithoutProInput>>;
  create?: InputMaybe<Array<ProAvailabilityCreateWithoutProInput>>;
  createMany?: InputMaybe<ProAvailabilityCreateManyProInputEnvelope>;
  delete?: InputMaybe<Array<ProAvailabilityWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ProAvailabilityScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ProAvailabilityWhereUniqueInput>>;
  set?: InputMaybe<Array<ProAvailabilityWhereUniqueInput>>;
  update?: InputMaybe<Array<ProAvailabilityUpdateWithWhereUniqueWithoutProInput>>;
  updateMany?: InputMaybe<Array<ProAvailabilityUpdateManyWithWhereWithoutProInput>>;
  upsert?: InputMaybe<Array<ProAvailabilityUpsertWithWhereUniqueWithoutProInput>>;
};

export type ProAvailabilityUpdateWithWhereUniqueWithoutProInput = {
  data: ProAvailabilityUpdateWithoutProInput;
  where: ProAvailabilityWhereUniqueInput;
};

export type ProAvailabilityUpdateWithoutProInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dayOfWeek?: InputMaybe<EnumDayOfWeekFieldUpdateOperationsInput>;
  endTime?: InputMaybe<StringFieldUpdateOperationsInput>;
  startTime?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ProAvailabilityUpsertWithWhereUniqueWithoutProInput = {
  create: ProAvailabilityCreateWithoutProInput;
  update: ProAvailabilityUpdateWithoutProInput;
  where: ProAvailabilityWhereUniqueInput;
};

export type ProAvailabilityWhereInput = {
  AND?: InputMaybe<Array<ProAvailabilityWhereInput>>;
  NOT?: InputMaybe<Array<ProAvailabilityWhereInput>>;
  OR?: InputMaybe<Array<ProAvailabilityWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  dayOfWeek?: InputMaybe<EnumDayOfWeekFilter>;
  endTime?: InputMaybe<StringFilter>;
  id?: InputMaybe<IntFilter>;
  pro?: InputMaybe<ProfessionalRelationFilter>;
  proId?: InputMaybe<IntFilter>;
  startTime?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ProAvailabilityWhereUniqueInput = {
  AND?: InputMaybe<Array<ProAvailabilityWhereInput>>;
  NOT?: InputMaybe<Array<ProAvailabilityWhereInput>>;
  OR?: InputMaybe<Array<ProAvailabilityWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  dayOfWeek?: InputMaybe<EnumDayOfWeekFilter>;
  endTime?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  pro?: InputMaybe<ProfessionalRelationFilter>;
  proId?: InputMaybe<IntFilter>;
  startTime?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ProDayAvailabilities = {
  __typename?: 'ProDayAvailabilities';
  avails: Array<DayTimeRange>;
  dayOfWeek?: Maybe<DayOfWeek>;
};

export type ProDegrees = {
  __typename?: 'ProDegrees';
  createdAt: Scalars['DateTime']['output'];
  dateEnd?: Maybe<Scalars['DateTime']['output']>;
  degree?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  pro: Professional;
  proId: Scalars['Int']['output'];
  school?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type ProDegreesAvgAggregateOutputType = {
  __typename?: 'ProDegreesAvgAggregateOutputType';
  id?: Maybe<Scalars['Float']['output']>;
  proId?: Maybe<Scalars['Float']['output']>;
};

export type ProDegreesAvgOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
  proId?: InputMaybe<SortOrder>;
};

export type ProDegreesCountAggregateOutputType = {
  __typename?: 'ProDegreesCountAggregateOutputType';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  dateEnd: Scalars['Int']['output'];
  degree: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  proId: Scalars['Int']['output'];
  school: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type ProDegreesCountOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  dateEnd?: InputMaybe<SortOrder>;
  degree?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  proId?: InputMaybe<SortOrder>;
  school?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ProDegreesCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dateEnd?: InputMaybe<Scalars['DateTime']['input']>;
  degree?: InputMaybe<Scalars['String']['input']>;
  pro: ProfessionalCreateNestedOneWithoutDegreesInput;
  school?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ProDegreesCreateManyInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dateEnd?: InputMaybe<Scalars['DateTime']['input']>;
  degree?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  proId: Scalars['Int']['input'];
  school?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ProDegreesCreateManyProInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dateEnd?: InputMaybe<Scalars['DateTime']['input']>;
  degree?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  school?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ProDegreesCreateManyProInputEnvelope = {
  data: Array<ProDegreesCreateManyProInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProDegreesCreateNestedManyWithoutProInput = {
  connect?: InputMaybe<Array<ProDegreesWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProDegreesCreateOrConnectWithoutProInput>>;
  create?: InputMaybe<Array<ProDegreesCreateWithoutProInput>>;
  createMany?: InputMaybe<ProDegreesCreateManyProInputEnvelope>;
};

export type ProDegreesCreateOrConnectWithoutProInput = {
  create: ProDegreesCreateWithoutProInput;
  where: ProDegreesWhereUniqueInput;
};

export type ProDegreesCreateWithoutProInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dateEnd?: InputMaybe<Scalars['DateTime']['input']>;
  degree?: InputMaybe<Scalars['String']['input']>;
  school?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ProDegreesListRelationFilter = {
  every?: InputMaybe<ProDegreesWhereInput>;
  none?: InputMaybe<ProDegreesWhereInput>;
  some?: InputMaybe<ProDegreesWhereInput>;
};

export type ProDegreesMaxAggregateOutputType = {
  __typename?: 'ProDegreesMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  dateEnd?: Maybe<Scalars['DateTime']['output']>;
  degree?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  proId?: Maybe<Scalars['Int']['output']>;
  school?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ProDegreesMaxOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  dateEnd?: InputMaybe<SortOrder>;
  degree?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  proId?: InputMaybe<SortOrder>;
  school?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ProDegreesMinAggregateOutputType = {
  __typename?: 'ProDegreesMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  dateEnd?: Maybe<Scalars['DateTime']['output']>;
  degree?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  proId?: Maybe<Scalars['Int']['output']>;
  school?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ProDegreesMinOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  dateEnd?: InputMaybe<SortOrder>;
  degree?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  proId?: InputMaybe<SortOrder>;
  school?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ProDegreesOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export enum ProDegreesOrderByRelevanceFieldEnum {
  degree = 'degree',
  school = 'school'
}

export type ProDegreesOrderByRelevanceInput = {
  fields: Array<ProDegreesOrderByRelevanceFieldEnum>;
  search: Scalars['String']['input'];
  sort: SortOrder;
};

export type ProDegreesOrderByWithAggregationInput = {
  _avg?: InputMaybe<ProDegreesAvgOrderByAggregateInput>;
  _count?: InputMaybe<ProDegreesCountOrderByAggregateInput>;
  _max?: InputMaybe<ProDegreesMaxOrderByAggregateInput>;
  _min?: InputMaybe<ProDegreesMinOrderByAggregateInput>;
  _sum?: InputMaybe<ProDegreesSumOrderByAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  dateEnd?: InputMaybe<SortOrderInput>;
  degree?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  proId?: InputMaybe<SortOrder>;
  school?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ProDegreesOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: InputMaybe<ProDegreesOrderByRelevanceInput>;
  createdAt?: InputMaybe<SortOrder>;
  dateEnd?: InputMaybe<SortOrderInput>;
  degree?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  pro?: InputMaybe<ProfessionalOrderByWithRelationAndSearchRelevanceInput>;
  proId?: InputMaybe<SortOrder>;
  school?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum ProDegreesScalarFieldEnum {
  createdAt = 'createdAt',
  dateEnd = 'dateEnd',
  degree = 'degree',
  id = 'id',
  proId = 'proId',
  school = 'school',
  updatedAt = 'updatedAt'
}

export type ProDegreesScalarWhereInput = {
  AND?: InputMaybe<Array<ProDegreesScalarWhereInput>>;
  NOT?: InputMaybe<Array<ProDegreesScalarWhereInput>>;
  OR?: InputMaybe<Array<ProDegreesScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  dateEnd?: InputMaybe<DateTimeNullableFilter>;
  degree?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<IntFilter>;
  proId?: InputMaybe<IntFilter>;
  school?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ProDegreesScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<ProDegreesScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<ProDegreesScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<ProDegreesScalarWhereWithAggregatesInput>>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  dateEnd?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  degree?: InputMaybe<StringNullableWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  proId?: InputMaybe<IntWithAggregatesFilter>;
  school?: InputMaybe<StringNullableWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type ProDegreesSumAggregateOutputType = {
  __typename?: 'ProDegreesSumAggregateOutputType';
  id?: Maybe<Scalars['Int']['output']>;
  proId?: Maybe<Scalars['Int']['output']>;
};

export type ProDegreesSumOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
  proId?: InputMaybe<SortOrder>;
};

export type ProDegreesUncheckedCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dateEnd?: InputMaybe<Scalars['DateTime']['input']>;
  degree?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  proId: Scalars['Int']['input'];
  school?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ProDegreesUncheckedCreateNestedManyWithoutProInput = {
  connect?: InputMaybe<Array<ProDegreesWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProDegreesCreateOrConnectWithoutProInput>>;
  create?: InputMaybe<Array<ProDegreesCreateWithoutProInput>>;
  createMany?: InputMaybe<ProDegreesCreateManyProInputEnvelope>;
};

export type ProDegreesUncheckedCreateWithoutProInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dateEnd?: InputMaybe<Scalars['DateTime']['input']>;
  degree?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  school?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ProDegreesUncheckedUpdateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dateEnd?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  degree?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  proId?: InputMaybe<IntFieldUpdateOperationsInput>;
  school?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ProDegreesUncheckedUpdateManyInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dateEnd?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  degree?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  proId?: InputMaybe<IntFieldUpdateOperationsInput>;
  school?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ProDegreesUncheckedUpdateManyWithoutProInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dateEnd?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  degree?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  school?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ProDegreesUncheckedUpdateManyWithoutProNestedInput = {
  connect?: InputMaybe<Array<ProDegreesWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProDegreesCreateOrConnectWithoutProInput>>;
  create?: InputMaybe<Array<ProDegreesCreateWithoutProInput>>;
  createMany?: InputMaybe<ProDegreesCreateManyProInputEnvelope>;
  delete?: InputMaybe<Array<ProDegreesWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ProDegreesScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ProDegreesWhereUniqueInput>>;
  set?: InputMaybe<Array<ProDegreesWhereUniqueInput>>;
  update?: InputMaybe<Array<ProDegreesUpdateWithWhereUniqueWithoutProInput>>;
  updateMany?: InputMaybe<Array<ProDegreesUpdateManyWithWhereWithoutProInput>>;
  upsert?: InputMaybe<Array<ProDegreesUpsertWithWhereUniqueWithoutProInput>>;
};

export type ProDegreesUncheckedUpdateWithoutProInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dateEnd?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  degree?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  school?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ProDegreesUpdateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dateEnd?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  degree?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pro?: InputMaybe<ProfessionalUpdateOneRequiredWithoutDegreesNestedInput>;
  school?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ProDegreesUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dateEnd?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  degree?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  school?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ProDegreesUpdateManyWithWhereWithoutProInput = {
  data: ProDegreesUpdateManyMutationInput;
  where: ProDegreesScalarWhereInput;
};

export type ProDegreesUpdateManyWithoutProNestedInput = {
  connect?: InputMaybe<Array<ProDegreesWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProDegreesCreateOrConnectWithoutProInput>>;
  create?: InputMaybe<Array<ProDegreesCreateWithoutProInput>>;
  createMany?: InputMaybe<ProDegreesCreateManyProInputEnvelope>;
  delete?: InputMaybe<Array<ProDegreesWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ProDegreesScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ProDegreesWhereUniqueInput>>;
  set?: InputMaybe<Array<ProDegreesWhereUniqueInput>>;
  update?: InputMaybe<Array<ProDegreesUpdateWithWhereUniqueWithoutProInput>>;
  updateMany?: InputMaybe<Array<ProDegreesUpdateManyWithWhereWithoutProInput>>;
  upsert?: InputMaybe<Array<ProDegreesUpsertWithWhereUniqueWithoutProInput>>;
};

export type ProDegreesUpdateWithWhereUniqueWithoutProInput = {
  data: ProDegreesUpdateWithoutProInput;
  where: ProDegreesWhereUniqueInput;
};

export type ProDegreesUpdateWithoutProInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dateEnd?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  degree?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  school?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ProDegreesUpsertWithWhereUniqueWithoutProInput = {
  create: ProDegreesCreateWithoutProInput;
  update: ProDegreesUpdateWithoutProInput;
  where: ProDegreesWhereUniqueInput;
};

export type ProDegreesWhereInput = {
  AND?: InputMaybe<Array<ProDegreesWhereInput>>;
  NOT?: InputMaybe<Array<ProDegreesWhereInput>>;
  OR?: InputMaybe<Array<ProDegreesWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  dateEnd?: InputMaybe<DateTimeNullableFilter>;
  degree?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<IntFilter>;
  pro?: InputMaybe<ProfessionalRelationFilter>;
  proId?: InputMaybe<IntFilter>;
  school?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ProDegreesWhereUniqueInput = {
  AND?: InputMaybe<Array<ProDegreesWhereInput>>;
  NOT?: InputMaybe<Array<ProDegreesWhereInput>>;
  OR?: InputMaybe<Array<ProDegreesWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  dateEnd?: InputMaybe<DateTimeNullableFilter>;
  degree?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  pro?: InputMaybe<ProfessionalRelationFilter>;
  proId?: InputMaybe<IntFilter>;
  school?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ProImg = {
  __typename?: 'ProImg';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  large?: Maybe<Scalars['String']['output']>;
  medium?: Maybe<Scalars['String']['output']>;
  pro: Professional;
  proId: Scalars['Int']['output'];
  small?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type ProImgAvgAggregateOutputType = {
  __typename?: 'ProImgAvgAggregateOutputType';
  id?: Maybe<Scalars['Float']['output']>;
  proId?: Maybe<Scalars['Float']['output']>;
};

export type ProImgAvgOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
  proId?: InputMaybe<SortOrder>;
};

export type ProImgCountAggregateOutputType = {
  __typename?: 'ProImgCountAggregateOutputType';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  large: Scalars['Int']['output'];
  medium: Scalars['Int']['output'];
  proId: Scalars['Int']['output'];
  small: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type ProImgCountOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  large?: InputMaybe<SortOrder>;
  medium?: InputMaybe<SortOrder>;
  proId?: InputMaybe<SortOrder>;
  small?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ProImgCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  large?: InputMaybe<Scalars['String']['input']>;
  medium?: InputMaybe<Scalars['String']['input']>;
  pro: ProfessionalCreateNestedOneWithoutImgsInput;
  small?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ProImgCreateManyInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  large?: InputMaybe<Scalars['String']['input']>;
  medium?: InputMaybe<Scalars['String']['input']>;
  proId: Scalars['Int']['input'];
  small?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ProImgCreateManyProInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  large?: InputMaybe<Scalars['String']['input']>;
  medium?: InputMaybe<Scalars['String']['input']>;
  small?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ProImgCreateManyProInputEnvelope = {
  data: Array<ProImgCreateManyProInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProImgCreateNestedManyWithoutProInput = {
  connect?: InputMaybe<Array<ProImgWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProImgCreateOrConnectWithoutProInput>>;
  create?: InputMaybe<Array<ProImgCreateWithoutProInput>>;
  createMany?: InputMaybe<ProImgCreateManyProInputEnvelope>;
};

export type ProImgCreateOrConnectWithoutProInput = {
  create: ProImgCreateWithoutProInput;
  where: ProImgWhereUniqueInput;
};

export type ProImgCreateWithoutProInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  large?: InputMaybe<Scalars['String']['input']>;
  medium?: InputMaybe<Scalars['String']['input']>;
  small?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ProImgListRelationFilter = {
  every?: InputMaybe<ProImgWhereInput>;
  none?: InputMaybe<ProImgWhereInput>;
  some?: InputMaybe<ProImgWhereInput>;
};

export type ProImgMaxAggregateOutputType = {
  __typename?: 'ProImgMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  large?: Maybe<Scalars['String']['output']>;
  medium?: Maybe<Scalars['String']['output']>;
  proId?: Maybe<Scalars['Int']['output']>;
  small?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ProImgMaxOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  large?: InputMaybe<SortOrder>;
  medium?: InputMaybe<SortOrder>;
  proId?: InputMaybe<SortOrder>;
  small?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ProImgMinAggregateOutputType = {
  __typename?: 'ProImgMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  large?: Maybe<Scalars['String']['output']>;
  medium?: Maybe<Scalars['String']['output']>;
  proId?: Maybe<Scalars['Int']['output']>;
  small?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ProImgMinOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  large?: InputMaybe<SortOrder>;
  medium?: InputMaybe<SortOrder>;
  proId?: InputMaybe<SortOrder>;
  small?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ProImgOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export enum ProImgOrderByRelevanceFieldEnum {
  large = 'large',
  medium = 'medium',
  small = 'small'
}

export type ProImgOrderByRelevanceInput = {
  fields: Array<ProImgOrderByRelevanceFieldEnum>;
  search: Scalars['String']['input'];
  sort: SortOrder;
};

export type ProImgOrderByWithAggregationInput = {
  _avg?: InputMaybe<ProImgAvgOrderByAggregateInput>;
  _count?: InputMaybe<ProImgCountOrderByAggregateInput>;
  _max?: InputMaybe<ProImgMaxOrderByAggregateInput>;
  _min?: InputMaybe<ProImgMinOrderByAggregateInput>;
  _sum?: InputMaybe<ProImgSumOrderByAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  large?: InputMaybe<SortOrderInput>;
  medium?: InputMaybe<SortOrderInput>;
  proId?: InputMaybe<SortOrder>;
  small?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ProImgOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: InputMaybe<ProImgOrderByRelevanceInput>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  large?: InputMaybe<SortOrderInput>;
  medium?: InputMaybe<SortOrderInput>;
  pro?: InputMaybe<ProfessionalOrderByWithRelationAndSearchRelevanceInput>;
  proId?: InputMaybe<SortOrder>;
  small?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum ProImgScalarFieldEnum {
  createdAt = 'createdAt',
  id = 'id',
  large = 'large',
  medium = 'medium',
  proId = 'proId',
  small = 'small',
  updatedAt = 'updatedAt'
}

export type ProImgScalarWhereInput = {
  AND?: InputMaybe<Array<ProImgScalarWhereInput>>;
  NOT?: InputMaybe<Array<ProImgScalarWhereInput>>;
  OR?: InputMaybe<Array<ProImgScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntFilter>;
  large?: InputMaybe<StringNullableFilter>;
  medium?: InputMaybe<StringNullableFilter>;
  proId?: InputMaybe<IntFilter>;
  small?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ProImgScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<ProImgScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<ProImgScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<ProImgScalarWhereWithAggregatesInput>>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  large?: InputMaybe<StringNullableWithAggregatesFilter>;
  medium?: InputMaybe<StringNullableWithAggregatesFilter>;
  proId?: InputMaybe<IntWithAggregatesFilter>;
  small?: InputMaybe<StringNullableWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type ProImgSumAggregateOutputType = {
  __typename?: 'ProImgSumAggregateOutputType';
  id?: Maybe<Scalars['Int']['output']>;
  proId?: Maybe<Scalars['Int']['output']>;
};

export type ProImgSumOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
  proId?: InputMaybe<SortOrder>;
};

export type ProImgUncheckedCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  large?: InputMaybe<Scalars['String']['input']>;
  medium?: InputMaybe<Scalars['String']['input']>;
  proId: Scalars['Int']['input'];
  small?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ProImgUncheckedCreateNestedManyWithoutProInput = {
  connect?: InputMaybe<Array<ProImgWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProImgCreateOrConnectWithoutProInput>>;
  create?: InputMaybe<Array<ProImgCreateWithoutProInput>>;
  createMany?: InputMaybe<ProImgCreateManyProInputEnvelope>;
};

export type ProImgUncheckedCreateWithoutProInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  large?: InputMaybe<Scalars['String']['input']>;
  medium?: InputMaybe<Scalars['String']['input']>;
  small?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ProImgUncheckedUpdateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  large?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  medium?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  proId?: InputMaybe<IntFieldUpdateOperationsInput>;
  small?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ProImgUncheckedUpdateManyInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  large?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  medium?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  proId?: InputMaybe<IntFieldUpdateOperationsInput>;
  small?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ProImgUncheckedUpdateManyWithoutProInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  large?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  medium?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  small?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ProImgUncheckedUpdateManyWithoutProNestedInput = {
  connect?: InputMaybe<Array<ProImgWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProImgCreateOrConnectWithoutProInput>>;
  create?: InputMaybe<Array<ProImgCreateWithoutProInput>>;
  createMany?: InputMaybe<ProImgCreateManyProInputEnvelope>;
  delete?: InputMaybe<Array<ProImgWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ProImgScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ProImgWhereUniqueInput>>;
  set?: InputMaybe<Array<ProImgWhereUniqueInput>>;
  update?: InputMaybe<Array<ProImgUpdateWithWhereUniqueWithoutProInput>>;
  updateMany?: InputMaybe<Array<ProImgUpdateManyWithWhereWithoutProInput>>;
  upsert?: InputMaybe<Array<ProImgUpsertWithWhereUniqueWithoutProInput>>;
};

export type ProImgUncheckedUpdateWithoutProInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  large?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  medium?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  small?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ProImgUpdateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  large?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  medium?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pro?: InputMaybe<ProfessionalUpdateOneRequiredWithoutImgsNestedInput>;
  small?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ProImgUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  large?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  medium?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  small?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ProImgUpdateManyWithWhereWithoutProInput = {
  data: ProImgUpdateManyMutationInput;
  where: ProImgScalarWhereInput;
};

export type ProImgUpdateManyWithoutProNestedInput = {
  connect?: InputMaybe<Array<ProImgWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProImgCreateOrConnectWithoutProInput>>;
  create?: InputMaybe<Array<ProImgCreateWithoutProInput>>;
  createMany?: InputMaybe<ProImgCreateManyProInputEnvelope>;
  delete?: InputMaybe<Array<ProImgWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ProImgScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ProImgWhereUniqueInput>>;
  set?: InputMaybe<Array<ProImgWhereUniqueInput>>;
  update?: InputMaybe<Array<ProImgUpdateWithWhereUniqueWithoutProInput>>;
  updateMany?: InputMaybe<Array<ProImgUpdateManyWithWhereWithoutProInput>>;
  upsert?: InputMaybe<Array<ProImgUpsertWithWhereUniqueWithoutProInput>>;
};

export type ProImgUpdateWithWhereUniqueWithoutProInput = {
  data: ProImgUpdateWithoutProInput;
  where: ProImgWhereUniqueInput;
};

export type ProImgUpdateWithoutProInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  large?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  medium?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  small?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ProImgUpsertWithWhereUniqueWithoutProInput = {
  create: ProImgCreateWithoutProInput;
  update: ProImgUpdateWithoutProInput;
  where: ProImgWhereUniqueInput;
};

export type ProImgWhereInput = {
  AND?: InputMaybe<Array<ProImgWhereInput>>;
  NOT?: InputMaybe<Array<ProImgWhereInput>>;
  OR?: InputMaybe<Array<ProImgWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntFilter>;
  large?: InputMaybe<StringNullableFilter>;
  medium?: InputMaybe<StringNullableFilter>;
  pro?: InputMaybe<ProfessionalRelationFilter>;
  proId?: InputMaybe<IntFilter>;
  small?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ProImgWhereUniqueInput = {
  AND?: InputMaybe<Array<ProImgWhereInput>>;
  NOT?: InputMaybe<Array<ProImgWhereInput>>;
  OR?: InputMaybe<Array<ProImgWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  large?: InputMaybe<StringNullableFilter>;
  medium?: InputMaybe<StringNullableFilter>;
  pro?: InputMaybe<ProfessionalRelationFilter>;
  proId?: InputMaybe<IntFilter>;
  small?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ProShopOpeningHour = {
  __typename?: 'ProShopOpeningHour';
  createdAt: Scalars['DateTime']['output'];
  dayOfWeek: DayOfWeek;
  endTime: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  pro: Professional;
  proId: Scalars['Int']['output'];
  startTime: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ProShopOpeningHourAvgAggregateOutputType = {
  __typename?: 'ProShopOpeningHourAvgAggregateOutputType';
  id?: Maybe<Scalars['Float']['output']>;
  proId?: Maybe<Scalars['Float']['output']>;
};

export type ProShopOpeningHourAvgOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
  proId?: InputMaybe<SortOrder>;
};

export type ProShopOpeningHourCountAggregateOutputType = {
  __typename?: 'ProShopOpeningHourCountAggregateOutputType';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  dayOfWeek: Scalars['Int']['output'];
  endTime: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  proId: Scalars['Int']['output'];
  startTime: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type ProShopOpeningHourCountOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  dayOfWeek?: InputMaybe<SortOrder>;
  endTime?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  proId?: InputMaybe<SortOrder>;
  startTime?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ProShopOpeningHourCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dayOfWeek: DayOfWeek;
  endTime: Scalars['String']['input'];
  pro: ProfessionalCreateNestedOneWithoutShopOpeningHoursInput;
  startTime: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ProShopOpeningHourCreateManyInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dayOfWeek: DayOfWeek;
  endTime: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  proId: Scalars['Int']['input'];
  startTime: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ProShopOpeningHourCreateManyProInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dayOfWeek: DayOfWeek;
  endTime: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  startTime: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ProShopOpeningHourCreateManyProInputEnvelope = {
  data: Array<ProShopOpeningHourCreateManyProInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProShopOpeningHourCreateNestedManyWithoutProInput = {
  connect?: InputMaybe<Array<ProShopOpeningHourWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProShopOpeningHourCreateOrConnectWithoutProInput>>;
  create?: InputMaybe<Array<ProShopOpeningHourCreateWithoutProInput>>;
  createMany?: InputMaybe<ProShopOpeningHourCreateManyProInputEnvelope>;
};

export type ProShopOpeningHourCreateOrConnectWithoutProInput = {
  create: ProShopOpeningHourCreateWithoutProInput;
  where: ProShopOpeningHourWhereUniqueInput;
};

export type ProShopOpeningHourCreateWithoutProInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dayOfWeek: DayOfWeek;
  endTime: Scalars['String']['input'];
  startTime: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ProShopOpeningHourListRelationFilter = {
  every?: InputMaybe<ProShopOpeningHourWhereInput>;
  none?: InputMaybe<ProShopOpeningHourWhereInput>;
  some?: InputMaybe<ProShopOpeningHourWhereInput>;
};

export type ProShopOpeningHourMaxAggregateOutputType = {
  __typename?: 'ProShopOpeningHourMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  dayOfWeek?: Maybe<DayOfWeek>;
  endTime?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  proId?: Maybe<Scalars['Int']['output']>;
  startTime?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ProShopOpeningHourMaxOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  dayOfWeek?: InputMaybe<SortOrder>;
  endTime?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  proId?: InputMaybe<SortOrder>;
  startTime?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ProShopOpeningHourMinAggregateOutputType = {
  __typename?: 'ProShopOpeningHourMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  dayOfWeek?: Maybe<DayOfWeek>;
  endTime?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  proId?: Maybe<Scalars['Int']['output']>;
  startTime?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ProShopOpeningHourMinOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  dayOfWeek?: InputMaybe<SortOrder>;
  endTime?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  proId?: InputMaybe<SortOrder>;
  startTime?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ProShopOpeningHourOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export enum ProShopOpeningHourOrderByRelevanceFieldEnum {
  endTime = 'endTime',
  startTime = 'startTime'
}

export type ProShopOpeningHourOrderByRelevanceInput = {
  fields: Array<ProShopOpeningHourOrderByRelevanceFieldEnum>;
  search: Scalars['String']['input'];
  sort: SortOrder;
};

export type ProShopOpeningHourOrderByWithAggregationInput = {
  _avg?: InputMaybe<ProShopOpeningHourAvgOrderByAggregateInput>;
  _count?: InputMaybe<ProShopOpeningHourCountOrderByAggregateInput>;
  _max?: InputMaybe<ProShopOpeningHourMaxOrderByAggregateInput>;
  _min?: InputMaybe<ProShopOpeningHourMinOrderByAggregateInput>;
  _sum?: InputMaybe<ProShopOpeningHourSumOrderByAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  dayOfWeek?: InputMaybe<SortOrder>;
  endTime?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  proId?: InputMaybe<SortOrder>;
  startTime?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ProShopOpeningHourOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: InputMaybe<ProShopOpeningHourOrderByRelevanceInput>;
  createdAt?: InputMaybe<SortOrder>;
  dayOfWeek?: InputMaybe<SortOrder>;
  endTime?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  pro?: InputMaybe<ProfessionalOrderByWithRelationAndSearchRelevanceInput>;
  proId?: InputMaybe<SortOrder>;
  startTime?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum ProShopOpeningHourScalarFieldEnum {
  createdAt = 'createdAt',
  dayOfWeek = 'dayOfWeek',
  endTime = 'endTime',
  id = 'id',
  proId = 'proId',
  startTime = 'startTime',
  updatedAt = 'updatedAt'
}

export type ProShopOpeningHourScalarWhereInput = {
  AND?: InputMaybe<Array<ProShopOpeningHourScalarWhereInput>>;
  NOT?: InputMaybe<Array<ProShopOpeningHourScalarWhereInput>>;
  OR?: InputMaybe<Array<ProShopOpeningHourScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  dayOfWeek?: InputMaybe<EnumDayOfWeekFilter>;
  endTime?: InputMaybe<StringFilter>;
  id?: InputMaybe<IntFilter>;
  proId?: InputMaybe<IntFilter>;
  startTime?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ProShopOpeningHourScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<ProShopOpeningHourScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<ProShopOpeningHourScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<ProShopOpeningHourScalarWhereWithAggregatesInput>>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  dayOfWeek?: InputMaybe<EnumDayOfWeekWithAggregatesFilter>;
  endTime?: InputMaybe<StringWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  proId?: InputMaybe<IntWithAggregatesFilter>;
  startTime?: InputMaybe<StringWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type ProShopOpeningHourSumAggregateOutputType = {
  __typename?: 'ProShopOpeningHourSumAggregateOutputType';
  id?: Maybe<Scalars['Int']['output']>;
  proId?: Maybe<Scalars['Int']['output']>;
};

export type ProShopOpeningHourSumOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
  proId?: InputMaybe<SortOrder>;
};

export type ProShopOpeningHourUncheckedCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dayOfWeek: DayOfWeek;
  endTime: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  proId: Scalars['Int']['input'];
  startTime: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ProShopOpeningHourUncheckedCreateNestedManyWithoutProInput = {
  connect?: InputMaybe<Array<ProShopOpeningHourWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProShopOpeningHourCreateOrConnectWithoutProInput>>;
  create?: InputMaybe<Array<ProShopOpeningHourCreateWithoutProInput>>;
  createMany?: InputMaybe<ProShopOpeningHourCreateManyProInputEnvelope>;
};

export type ProShopOpeningHourUncheckedCreateWithoutProInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dayOfWeek: DayOfWeek;
  endTime: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  startTime: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ProShopOpeningHourUncheckedUpdateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dayOfWeek?: InputMaybe<EnumDayOfWeekFieldUpdateOperationsInput>;
  endTime?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  proId?: InputMaybe<IntFieldUpdateOperationsInput>;
  startTime?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ProShopOpeningHourUncheckedUpdateManyInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dayOfWeek?: InputMaybe<EnumDayOfWeekFieldUpdateOperationsInput>;
  endTime?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  proId?: InputMaybe<IntFieldUpdateOperationsInput>;
  startTime?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ProShopOpeningHourUncheckedUpdateManyWithoutProInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dayOfWeek?: InputMaybe<EnumDayOfWeekFieldUpdateOperationsInput>;
  endTime?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  startTime?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ProShopOpeningHourUncheckedUpdateManyWithoutProNestedInput = {
  connect?: InputMaybe<Array<ProShopOpeningHourWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProShopOpeningHourCreateOrConnectWithoutProInput>>;
  create?: InputMaybe<Array<ProShopOpeningHourCreateWithoutProInput>>;
  createMany?: InputMaybe<ProShopOpeningHourCreateManyProInputEnvelope>;
  delete?: InputMaybe<Array<ProShopOpeningHourWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ProShopOpeningHourScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ProShopOpeningHourWhereUniqueInput>>;
  set?: InputMaybe<Array<ProShopOpeningHourWhereUniqueInput>>;
  update?: InputMaybe<Array<ProShopOpeningHourUpdateWithWhereUniqueWithoutProInput>>;
  updateMany?: InputMaybe<Array<ProShopOpeningHourUpdateManyWithWhereWithoutProInput>>;
  upsert?: InputMaybe<Array<ProShopOpeningHourUpsertWithWhereUniqueWithoutProInput>>;
};

export type ProShopOpeningHourUncheckedUpdateWithoutProInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dayOfWeek?: InputMaybe<EnumDayOfWeekFieldUpdateOperationsInput>;
  endTime?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  startTime?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ProShopOpeningHourUpdateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dayOfWeek?: InputMaybe<EnumDayOfWeekFieldUpdateOperationsInput>;
  endTime?: InputMaybe<StringFieldUpdateOperationsInput>;
  pro?: InputMaybe<ProfessionalUpdateOneRequiredWithoutShopOpeningHoursNestedInput>;
  startTime?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ProShopOpeningHourUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dayOfWeek?: InputMaybe<EnumDayOfWeekFieldUpdateOperationsInput>;
  endTime?: InputMaybe<StringFieldUpdateOperationsInput>;
  startTime?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ProShopOpeningHourUpdateManyWithWhereWithoutProInput = {
  data: ProShopOpeningHourUpdateManyMutationInput;
  where: ProShopOpeningHourScalarWhereInput;
};

export type ProShopOpeningHourUpdateManyWithoutProNestedInput = {
  connect?: InputMaybe<Array<ProShopOpeningHourWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProShopOpeningHourCreateOrConnectWithoutProInput>>;
  create?: InputMaybe<Array<ProShopOpeningHourCreateWithoutProInput>>;
  createMany?: InputMaybe<ProShopOpeningHourCreateManyProInputEnvelope>;
  delete?: InputMaybe<Array<ProShopOpeningHourWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ProShopOpeningHourScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ProShopOpeningHourWhereUniqueInput>>;
  set?: InputMaybe<Array<ProShopOpeningHourWhereUniqueInput>>;
  update?: InputMaybe<Array<ProShopOpeningHourUpdateWithWhereUniqueWithoutProInput>>;
  updateMany?: InputMaybe<Array<ProShopOpeningHourUpdateManyWithWhereWithoutProInput>>;
  upsert?: InputMaybe<Array<ProShopOpeningHourUpsertWithWhereUniqueWithoutProInput>>;
};

export type ProShopOpeningHourUpdateWithWhereUniqueWithoutProInput = {
  data: ProShopOpeningHourUpdateWithoutProInput;
  where: ProShopOpeningHourWhereUniqueInput;
};

export type ProShopOpeningHourUpdateWithoutProInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dayOfWeek?: InputMaybe<EnumDayOfWeekFieldUpdateOperationsInput>;
  endTime?: InputMaybe<StringFieldUpdateOperationsInput>;
  startTime?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ProShopOpeningHourUpsertWithWhereUniqueWithoutProInput = {
  create: ProShopOpeningHourCreateWithoutProInput;
  update: ProShopOpeningHourUpdateWithoutProInput;
  where: ProShopOpeningHourWhereUniqueInput;
};

export type ProShopOpeningHourWhereInput = {
  AND?: InputMaybe<Array<ProShopOpeningHourWhereInput>>;
  NOT?: InputMaybe<Array<ProShopOpeningHourWhereInput>>;
  OR?: InputMaybe<Array<ProShopOpeningHourWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  dayOfWeek?: InputMaybe<EnumDayOfWeekFilter>;
  endTime?: InputMaybe<StringFilter>;
  id?: InputMaybe<IntFilter>;
  pro?: InputMaybe<ProfessionalRelationFilter>;
  proId?: InputMaybe<IntFilter>;
  startTime?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ProShopOpeningHourWhereUniqueInput = {
  AND?: InputMaybe<Array<ProShopOpeningHourWhereInput>>;
  NOT?: InputMaybe<Array<ProShopOpeningHourWhereInput>>;
  OR?: InputMaybe<Array<ProShopOpeningHourWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  dayOfWeek?: InputMaybe<EnumDayOfWeekFilter>;
  endTime?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  pro?: InputMaybe<ProfessionalRelationFilter>;
  proId?: InputMaybe<IntFilter>;
  startTime?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ProShopOpeningHours = {
  __typename?: 'ProShopOpeningHours';
  dayOfWeek?: Maybe<DayOfWeek>;
  openingHours: Array<DayTimeRange>;
};

export type ProStat = {
  __typename?: 'ProStat';
  contactInfoClickCount: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  date: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  pro: Professional;
  proId: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
  viewCount: Scalars['Int']['output'];
};

export type ProStatAvgAggregateOutputType = {
  __typename?: 'ProStatAvgAggregateOutputType';
  contactInfoClickCount?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  proId?: Maybe<Scalars['Float']['output']>;
  viewCount?: Maybe<Scalars['Float']['output']>;
};

export type ProStatAvgOrderByAggregateInput = {
  contactInfoClickCount?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  proId?: InputMaybe<SortOrder>;
  viewCount?: InputMaybe<SortOrder>;
};

export type ProStatCountAggregateOutputType = {
  __typename?: 'ProStatCountAggregateOutputType';
  _all: Scalars['Int']['output'];
  contactInfoClickCount: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  date: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  proId: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
  viewCount: Scalars['Int']['output'];
};

export type ProStatCountOrderByAggregateInput = {
  contactInfoClickCount?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  date?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  proId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  viewCount?: InputMaybe<SortOrder>;
};

export type ProStatCreateInput = {
  contactInfoClickCount?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  date: Scalars['DateTime']['input'];
  pro: ProfessionalCreateNestedOneWithoutStatsInput;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  viewCount?: InputMaybe<Scalars['Int']['input']>;
};

export type ProStatCreateManyInput = {
  contactInfoClickCount?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  date: Scalars['DateTime']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  proId: Scalars['Int']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  viewCount?: InputMaybe<Scalars['Int']['input']>;
};

export type ProStatCreateManyProInput = {
  contactInfoClickCount?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  date: Scalars['DateTime']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  viewCount?: InputMaybe<Scalars['Int']['input']>;
};

export type ProStatCreateManyProInputEnvelope = {
  data: Array<ProStatCreateManyProInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProStatCreateNestedManyWithoutProInput = {
  connect?: InputMaybe<Array<ProStatWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProStatCreateOrConnectWithoutProInput>>;
  create?: InputMaybe<Array<ProStatCreateWithoutProInput>>;
  createMany?: InputMaybe<ProStatCreateManyProInputEnvelope>;
};

export type ProStatCreateOrConnectWithoutProInput = {
  create: ProStatCreateWithoutProInput;
  where: ProStatWhereUniqueInput;
};

export type ProStatCreateWithoutProInput = {
  contactInfoClickCount?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  date: Scalars['DateTime']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  viewCount?: InputMaybe<Scalars['Int']['input']>;
};

export type ProStatListRelationFilter = {
  every?: InputMaybe<ProStatWhereInput>;
  none?: InputMaybe<ProStatWhereInput>;
  some?: InputMaybe<ProStatWhereInput>;
};

export type ProStatMaxAggregateOutputType = {
  __typename?: 'ProStatMaxAggregateOutputType';
  contactInfoClickCount?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  date?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  proId?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  viewCount?: Maybe<Scalars['Int']['output']>;
};

export type ProStatMaxOrderByAggregateInput = {
  contactInfoClickCount?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  date?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  proId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  viewCount?: InputMaybe<SortOrder>;
};

export type ProStatMinAggregateOutputType = {
  __typename?: 'ProStatMinAggregateOutputType';
  contactInfoClickCount?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  date?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  proId?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  viewCount?: Maybe<Scalars['Int']['output']>;
};

export type ProStatMinOrderByAggregateInput = {
  contactInfoClickCount?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  date?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  proId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  viewCount?: InputMaybe<SortOrder>;
};

export type ProStatOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ProStatOrderByWithAggregationInput = {
  _avg?: InputMaybe<ProStatAvgOrderByAggregateInput>;
  _count?: InputMaybe<ProStatCountOrderByAggregateInput>;
  _max?: InputMaybe<ProStatMaxOrderByAggregateInput>;
  _min?: InputMaybe<ProStatMinOrderByAggregateInput>;
  _sum?: InputMaybe<ProStatSumOrderByAggregateInput>;
  contactInfoClickCount?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  date?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  proId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  viewCount?: InputMaybe<SortOrder>;
};

export type ProStatOrderByWithRelationAndSearchRelevanceInput = {
  contactInfoClickCount?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  date?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  pro?: InputMaybe<ProfessionalOrderByWithRelationAndSearchRelevanceInput>;
  proId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  viewCount?: InputMaybe<SortOrder>;
};

export enum ProStatScalarFieldEnum {
  contactInfoClickCount = 'contactInfoClickCount',
  createdAt = 'createdAt',
  date = 'date',
  id = 'id',
  proId = 'proId',
  updatedAt = 'updatedAt',
  viewCount = 'viewCount'
}

export type ProStatScalarWhereInput = {
  AND?: InputMaybe<Array<ProStatScalarWhereInput>>;
  NOT?: InputMaybe<Array<ProStatScalarWhereInput>>;
  OR?: InputMaybe<Array<ProStatScalarWhereInput>>;
  contactInfoClickCount?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  date?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntFilter>;
  proId?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  viewCount?: InputMaybe<IntFilter>;
};

export type ProStatScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<ProStatScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<ProStatScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<ProStatScalarWhereWithAggregatesInput>>;
  contactInfoClickCount?: InputMaybe<IntWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  date?: InputMaybe<DateTimeWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  proId?: InputMaybe<IntWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  viewCount?: InputMaybe<IntWithAggregatesFilter>;
};

export type ProStatSumAggregateOutputType = {
  __typename?: 'ProStatSumAggregateOutputType';
  contactInfoClickCount?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  proId?: Maybe<Scalars['Int']['output']>;
  viewCount?: Maybe<Scalars['Int']['output']>;
};

export type ProStatSumOrderByAggregateInput = {
  contactInfoClickCount?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  proId?: InputMaybe<SortOrder>;
  viewCount?: InputMaybe<SortOrder>;
};

export type ProStatUncheckedCreateInput = {
  contactInfoClickCount?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  date: Scalars['DateTime']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  proId: Scalars['Int']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  viewCount?: InputMaybe<Scalars['Int']['input']>;
};

export type ProStatUncheckedCreateNestedManyWithoutProInput = {
  connect?: InputMaybe<Array<ProStatWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProStatCreateOrConnectWithoutProInput>>;
  create?: InputMaybe<Array<ProStatCreateWithoutProInput>>;
  createMany?: InputMaybe<ProStatCreateManyProInputEnvelope>;
};

export type ProStatUncheckedCreateWithoutProInput = {
  contactInfoClickCount?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  date: Scalars['DateTime']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  viewCount?: InputMaybe<Scalars['Int']['input']>;
};

export type ProStatUncheckedUpdateInput = {
  contactInfoClickCount?: InputMaybe<IntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  proId?: InputMaybe<IntFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  viewCount?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type ProStatUncheckedUpdateManyInput = {
  contactInfoClickCount?: InputMaybe<IntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  proId?: InputMaybe<IntFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  viewCount?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type ProStatUncheckedUpdateManyWithoutProInput = {
  contactInfoClickCount?: InputMaybe<IntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  viewCount?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type ProStatUncheckedUpdateManyWithoutProNestedInput = {
  connect?: InputMaybe<Array<ProStatWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProStatCreateOrConnectWithoutProInput>>;
  create?: InputMaybe<Array<ProStatCreateWithoutProInput>>;
  createMany?: InputMaybe<ProStatCreateManyProInputEnvelope>;
  delete?: InputMaybe<Array<ProStatWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ProStatScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ProStatWhereUniqueInput>>;
  set?: InputMaybe<Array<ProStatWhereUniqueInput>>;
  update?: InputMaybe<Array<ProStatUpdateWithWhereUniqueWithoutProInput>>;
  updateMany?: InputMaybe<Array<ProStatUpdateManyWithWhereWithoutProInput>>;
  upsert?: InputMaybe<Array<ProStatUpsertWithWhereUniqueWithoutProInput>>;
};

export type ProStatUncheckedUpdateWithoutProInput = {
  contactInfoClickCount?: InputMaybe<IntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  viewCount?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type ProStatUpdateInput = {
  contactInfoClickCount?: InputMaybe<IntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  pro?: InputMaybe<ProfessionalUpdateOneRequiredWithoutStatsNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  viewCount?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type ProStatUpdateManyMutationInput = {
  contactInfoClickCount?: InputMaybe<IntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  viewCount?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type ProStatUpdateManyWithWhereWithoutProInput = {
  data: ProStatUpdateManyMutationInput;
  where: ProStatScalarWhereInput;
};

export type ProStatUpdateManyWithoutProNestedInput = {
  connect?: InputMaybe<Array<ProStatWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProStatCreateOrConnectWithoutProInput>>;
  create?: InputMaybe<Array<ProStatCreateWithoutProInput>>;
  createMany?: InputMaybe<ProStatCreateManyProInputEnvelope>;
  delete?: InputMaybe<Array<ProStatWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ProStatScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ProStatWhereUniqueInput>>;
  set?: InputMaybe<Array<ProStatWhereUniqueInput>>;
  update?: InputMaybe<Array<ProStatUpdateWithWhereUniqueWithoutProInput>>;
  updateMany?: InputMaybe<Array<ProStatUpdateManyWithWhereWithoutProInput>>;
  upsert?: InputMaybe<Array<ProStatUpsertWithWhereUniqueWithoutProInput>>;
};

export type ProStatUpdateWithWhereUniqueWithoutProInput = {
  data: ProStatUpdateWithoutProInput;
  where: ProStatWhereUniqueInput;
};

export type ProStatUpdateWithoutProInput = {
  contactInfoClickCount?: InputMaybe<IntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  viewCount?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type ProStatUpsertWithWhereUniqueWithoutProInput = {
  create: ProStatCreateWithoutProInput;
  update: ProStatUpdateWithoutProInput;
  where: ProStatWhereUniqueInput;
};

export type ProStatWhereInput = {
  AND?: InputMaybe<Array<ProStatWhereInput>>;
  NOT?: InputMaybe<Array<ProStatWhereInput>>;
  OR?: InputMaybe<Array<ProStatWhereInput>>;
  contactInfoClickCount?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  date?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntFilter>;
  pro?: InputMaybe<ProfessionalRelationFilter>;
  proId?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  viewCount?: InputMaybe<IntFilter>;
};

export type ProStatWhereUniqueInput = {
  AND?: InputMaybe<Array<ProStatWhereInput>>;
  NOT?: InputMaybe<Array<ProStatWhereInput>>;
  OR?: InputMaybe<Array<ProStatWhereInput>>;
  contactInfoClickCount?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  date?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  pro?: InputMaybe<ProfessionalRelationFilter>;
  proId?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  viewCount?: InputMaybe<IntFilter>;
};

export type ProTranslation = {
  __typename?: 'ProTranslation';
  createdAt: Scalars['DateTime']['output'];
  customTitle: Scalars['Boolean']['output'];
  description?: Maybe<Scalars['String']['output']>;
  extraDescription?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  language: Scalars['String']['output'];
  preBookingWarning?: Maybe<Scalars['String']['output']>;
  pro: Professional;
  proId: Scalars['Int']['output'];
  seoDescription?: Maybe<Scalars['String']['output']>;
  seoFieldsAreCustom: Scalars['Boolean']['output'];
  seoKeywords?: Maybe<Scalars['String']['output']>;
  seoTitle?: Maybe<Scalars['String']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  url?: Maybe<Scalars['String']['output']>;
  wellnessEngagement?: Maybe<Scalars['String']['output']>;
};

export type ProTranslationAvgAggregateOutputType = {
  __typename?: 'ProTranslationAvgAggregateOutputType';
  id?: Maybe<Scalars['Float']['output']>;
  proId?: Maybe<Scalars['Float']['output']>;
};

export type ProTranslationAvgOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
  proId?: InputMaybe<SortOrder>;
};

export type ProTranslationCountAggregateOutputType = {
  __typename?: 'ProTranslationCountAggregateOutputType';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  customTitle: Scalars['Int']['output'];
  description: Scalars['Int']['output'];
  extraDescription: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  language: Scalars['Int']['output'];
  preBookingWarning: Scalars['Int']['output'];
  proId: Scalars['Int']['output'];
  seoDescription: Scalars['Int']['output'];
  seoFieldsAreCustom: Scalars['Int']['output'];
  seoKeywords: Scalars['Int']['output'];
  seoTitle: Scalars['Int']['output'];
  subtitle: Scalars['Int']['output'];
  title: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
  url: Scalars['Int']['output'];
  wellnessEngagement: Scalars['Int']['output'];
};

export type ProTranslationCountOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  customTitle?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  extraDescription?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  language?: InputMaybe<SortOrder>;
  preBookingWarning?: InputMaybe<SortOrder>;
  proId?: InputMaybe<SortOrder>;
  seoDescription?: InputMaybe<SortOrder>;
  seoFieldsAreCustom?: InputMaybe<SortOrder>;
  seoKeywords?: InputMaybe<SortOrder>;
  seoTitle?: InputMaybe<SortOrder>;
  subtitle?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  url?: InputMaybe<SortOrder>;
  wellnessEngagement?: InputMaybe<SortOrder>;
};

export type ProTranslationCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  customTitle?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  extraDescription?: InputMaybe<Scalars['String']['input']>;
  language: Scalars['String']['input'];
  preBookingWarning?: InputMaybe<Scalars['String']['input']>;
  pro: ProfessionalCreateNestedOneWithoutTranslationsInput;
  seoDescription?: InputMaybe<Scalars['String']['input']>;
  seoFieldsAreCustom?: InputMaybe<Scalars['Boolean']['input']>;
  seoKeywords?: InputMaybe<Scalars['String']['input']>;
  seoTitle?: InputMaybe<Scalars['String']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  wellnessEngagement?: InputMaybe<Scalars['String']['input']>;
};

export type ProTranslationCreateManyInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  customTitle?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  extraDescription?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  language: Scalars['String']['input'];
  preBookingWarning?: InputMaybe<Scalars['String']['input']>;
  proId: Scalars['Int']['input'];
  seoDescription?: InputMaybe<Scalars['String']['input']>;
  seoFieldsAreCustom?: InputMaybe<Scalars['Boolean']['input']>;
  seoKeywords?: InputMaybe<Scalars['String']['input']>;
  seoTitle?: InputMaybe<Scalars['String']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  wellnessEngagement?: InputMaybe<Scalars['String']['input']>;
};

export type ProTranslationCreateManyProInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  customTitle?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  extraDescription?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  language: Scalars['String']['input'];
  preBookingWarning?: InputMaybe<Scalars['String']['input']>;
  seoDescription?: InputMaybe<Scalars['String']['input']>;
  seoFieldsAreCustom?: InputMaybe<Scalars['Boolean']['input']>;
  seoKeywords?: InputMaybe<Scalars['String']['input']>;
  seoTitle?: InputMaybe<Scalars['String']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  wellnessEngagement?: InputMaybe<Scalars['String']['input']>;
};

export type ProTranslationCreateManyProInputEnvelope = {
  data: Array<ProTranslationCreateManyProInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProTranslationCreateNestedManyWithoutProInput = {
  connect?: InputMaybe<Array<ProTranslationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProTranslationCreateOrConnectWithoutProInput>>;
  create?: InputMaybe<Array<ProTranslationCreateWithoutProInput>>;
  createMany?: InputMaybe<ProTranslationCreateManyProInputEnvelope>;
};

export type ProTranslationCreateOrConnectWithoutProInput = {
  create: ProTranslationCreateWithoutProInput;
  where: ProTranslationWhereUniqueInput;
};

export type ProTranslationCreateWithoutProInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  customTitle?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  extraDescription?: InputMaybe<Scalars['String']['input']>;
  language: Scalars['String']['input'];
  preBookingWarning?: InputMaybe<Scalars['String']['input']>;
  seoDescription?: InputMaybe<Scalars['String']['input']>;
  seoFieldsAreCustom?: InputMaybe<Scalars['Boolean']['input']>;
  seoKeywords?: InputMaybe<Scalars['String']['input']>;
  seoTitle?: InputMaybe<Scalars['String']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  wellnessEngagement?: InputMaybe<Scalars['String']['input']>;
};

export type ProTranslationListRelationFilter = {
  every?: InputMaybe<ProTranslationWhereInput>;
  none?: InputMaybe<ProTranslationWhereInput>;
  some?: InputMaybe<ProTranslationWhereInput>;
};

export type ProTranslationMaxAggregateOutputType = {
  __typename?: 'ProTranslationMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  customTitle?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  extraDescription?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  preBookingWarning?: Maybe<Scalars['String']['output']>;
  proId?: Maybe<Scalars['Int']['output']>;
  seoDescription?: Maybe<Scalars['String']['output']>;
  seoFieldsAreCustom?: Maybe<Scalars['Boolean']['output']>;
  seoKeywords?: Maybe<Scalars['String']['output']>;
  seoTitle?: Maybe<Scalars['String']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  wellnessEngagement?: Maybe<Scalars['String']['output']>;
};

export type ProTranslationMaxOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  customTitle?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  extraDescription?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  language?: InputMaybe<SortOrder>;
  preBookingWarning?: InputMaybe<SortOrder>;
  proId?: InputMaybe<SortOrder>;
  seoDescription?: InputMaybe<SortOrder>;
  seoFieldsAreCustom?: InputMaybe<SortOrder>;
  seoKeywords?: InputMaybe<SortOrder>;
  seoTitle?: InputMaybe<SortOrder>;
  subtitle?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  url?: InputMaybe<SortOrder>;
  wellnessEngagement?: InputMaybe<SortOrder>;
};

export type ProTranslationMinAggregateOutputType = {
  __typename?: 'ProTranslationMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  customTitle?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  extraDescription?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  preBookingWarning?: Maybe<Scalars['String']['output']>;
  proId?: Maybe<Scalars['Int']['output']>;
  seoDescription?: Maybe<Scalars['String']['output']>;
  seoFieldsAreCustom?: Maybe<Scalars['Boolean']['output']>;
  seoKeywords?: Maybe<Scalars['String']['output']>;
  seoTitle?: Maybe<Scalars['String']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  wellnessEngagement?: Maybe<Scalars['String']['output']>;
};

export type ProTranslationMinOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  customTitle?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  extraDescription?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  language?: InputMaybe<SortOrder>;
  preBookingWarning?: InputMaybe<SortOrder>;
  proId?: InputMaybe<SortOrder>;
  seoDescription?: InputMaybe<SortOrder>;
  seoFieldsAreCustom?: InputMaybe<SortOrder>;
  seoKeywords?: InputMaybe<SortOrder>;
  seoTitle?: InputMaybe<SortOrder>;
  subtitle?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  url?: InputMaybe<SortOrder>;
  wellnessEngagement?: InputMaybe<SortOrder>;
};

export type ProTranslationOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export enum ProTranslationOrderByRelevanceFieldEnum {
  description = 'description',
  extraDescription = 'extraDescription',
  language = 'language',
  preBookingWarning = 'preBookingWarning',
  seoDescription = 'seoDescription',
  seoKeywords = 'seoKeywords',
  seoTitle = 'seoTitle',
  subtitle = 'subtitle',
  title = 'title',
  url = 'url',
  wellnessEngagement = 'wellnessEngagement'
}

export type ProTranslationOrderByRelevanceInput = {
  fields: Array<ProTranslationOrderByRelevanceFieldEnum>;
  search: Scalars['String']['input'];
  sort: SortOrder;
};

export type ProTranslationOrderByWithAggregationInput = {
  _avg?: InputMaybe<ProTranslationAvgOrderByAggregateInput>;
  _count?: InputMaybe<ProTranslationCountOrderByAggregateInput>;
  _max?: InputMaybe<ProTranslationMaxOrderByAggregateInput>;
  _min?: InputMaybe<ProTranslationMinOrderByAggregateInput>;
  _sum?: InputMaybe<ProTranslationSumOrderByAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  customTitle?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrderInput>;
  extraDescription?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  language?: InputMaybe<SortOrder>;
  preBookingWarning?: InputMaybe<SortOrderInput>;
  proId?: InputMaybe<SortOrder>;
  seoDescription?: InputMaybe<SortOrderInput>;
  seoFieldsAreCustom?: InputMaybe<SortOrder>;
  seoKeywords?: InputMaybe<SortOrderInput>;
  seoTitle?: InputMaybe<SortOrderInput>;
  subtitle?: InputMaybe<SortOrderInput>;
  title?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
  url?: InputMaybe<SortOrderInput>;
  wellnessEngagement?: InputMaybe<SortOrderInput>;
};

export type ProTranslationOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: InputMaybe<ProTranslationOrderByRelevanceInput>;
  createdAt?: InputMaybe<SortOrder>;
  customTitle?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrderInput>;
  extraDescription?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  language?: InputMaybe<SortOrder>;
  preBookingWarning?: InputMaybe<SortOrderInput>;
  pro?: InputMaybe<ProfessionalOrderByWithRelationAndSearchRelevanceInput>;
  proId?: InputMaybe<SortOrder>;
  seoDescription?: InputMaybe<SortOrderInput>;
  seoFieldsAreCustom?: InputMaybe<SortOrder>;
  seoKeywords?: InputMaybe<SortOrderInput>;
  seoTitle?: InputMaybe<SortOrderInput>;
  subtitle?: InputMaybe<SortOrderInput>;
  title?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
  url?: InputMaybe<SortOrderInput>;
  wellnessEngagement?: InputMaybe<SortOrderInput>;
};

export enum ProTranslationScalarFieldEnum {
  createdAt = 'createdAt',
  customTitle = 'customTitle',
  description = 'description',
  extraDescription = 'extraDescription',
  id = 'id',
  language = 'language',
  preBookingWarning = 'preBookingWarning',
  proId = 'proId',
  seoDescription = 'seoDescription',
  seoFieldsAreCustom = 'seoFieldsAreCustom',
  seoKeywords = 'seoKeywords',
  seoTitle = 'seoTitle',
  subtitle = 'subtitle',
  title = 'title',
  updatedAt = 'updatedAt',
  url = 'url',
  wellnessEngagement = 'wellnessEngagement'
}

export type ProTranslationScalarWhereInput = {
  AND?: InputMaybe<Array<ProTranslationScalarWhereInput>>;
  NOT?: InputMaybe<Array<ProTranslationScalarWhereInput>>;
  OR?: InputMaybe<Array<ProTranslationScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customTitle?: InputMaybe<BoolFilter>;
  description?: InputMaybe<StringNullableFilter>;
  extraDescription?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<IntFilter>;
  language?: InputMaybe<StringFilter>;
  preBookingWarning?: InputMaybe<StringNullableFilter>;
  proId?: InputMaybe<IntFilter>;
  seoDescription?: InputMaybe<StringNullableFilter>;
  seoFieldsAreCustom?: InputMaybe<BoolFilter>;
  seoKeywords?: InputMaybe<StringNullableFilter>;
  seoTitle?: InputMaybe<StringNullableFilter>;
  subtitle?: InputMaybe<StringNullableFilter>;
  title?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  url?: InputMaybe<StringNullableFilter>;
  wellnessEngagement?: InputMaybe<StringNullableFilter>;
};

export type ProTranslationScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<ProTranslationScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<ProTranslationScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<ProTranslationScalarWhereWithAggregatesInput>>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  customTitle?: InputMaybe<BoolWithAggregatesFilter>;
  description?: InputMaybe<StringNullableWithAggregatesFilter>;
  extraDescription?: InputMaybe<StringNullableWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  language?: InputMaybe<StringWithAggregatesFilter>;
  preBookingWarning?: InputMaybe<StringNullableWithAggregatesFilter>;
  proId?: InputMaybe<IntWithAggregatesFilter>;
  seoDescription?: InputMaybe<StringNullableWithAggregatesFilter>;
  seoFieldsAreCustom?: InputMaybe<BoolWithAggregatesFilter>;
  seoKeywords?: InputMaybe<StringNullableWithAggregatesFilter>;
  seoTitle?: InputMaybe<StringNullableWithAggregatesFilter>;
  subtitle?: InputMaybe<StringNullableWithAggregatesFilter>;
  title?: InputMaybe<StringNullableWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  url?: InputMaybe<StringNullableWithAggregatesFilter>;
  wellnessEngagement?: InputMaybe<StringNullableWithAggregatesFilter>;
};

export type ProTranslationSumAggregateOutputType = {
  __typename?: 'ProTranslationSumAggregateOutputType';
  id?: Maybe<Scalars['Int']['output']>;
  proId?: Maybe<Scalars['Int']['output']>;
};

export type ProTranslationSumOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
  proId?: InputMaybe<SortOrder>;
};

export type ProTranslationUncheckedCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  customTitle?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  extraDescription?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  language: Scalars['String']['input'];
  preBookingWarning?: InputMaybe<Scalars['String']['input']>;
  proId: Scalars['Int']['input'];
  seoDescription?: InputMaybe<Scalars['String']['input']>;
  seoFieldsAreCustom?: InputMaybe<Scalars['Boolean']['input']>;
  seoKeywords?: InputMaybe<Scalars['String']['input']>;
  seoTitle?: InputMaybe<Scalars['String']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  wellnessEngagement?: InputMaybe<Scalars['String']['input']>;
};

export type ProTranslationUncheckedCreateNestedManyWithoutProInput = {
  connect?: InputMaybe<Array<ProTranslationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProTranslationCreateOrConnectWithoutProInput>>;
  create?: InputMaybe<Array<ProTranslationCreateWithoutProInput>>;
  createMany?: InputMaybe<ProTranslationCreateManyProInputEnvelope>;
};

export type ProTranslationUncheckedCreateWithoutProInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  customTitle?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  extraDescription?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  language: Scalars['String']['input'];
  preBookingWarning?: InputMaybe<Scalars['String']['input']>;
  seoDescription?: InputMaybe<Scalars['String']['input']>;
  seoFieldsAreCustom?: InputMaybe<Scalars['Boolean']['input']>;
  seoKeywords?: InputMaybe<Scalars['String']['input']>;
  seoTitle?: InputMaybe<Scalars['String']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  wellnessEngagement?: InputMaybe<Scalars['String']['input']>;
};

export type ProTranslationUncheckedUpdateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  customTitle?: InputMaybe<BoolFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  extraDescription?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  preBookingWarning?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  proId?: InputMaybe<IntFieldUpdateOperationsInput>;
  seoDescription?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  seoFieldsAreCustom?: InputMaybe<BoolFieldUpdateOperationsInput>;
  seoKeywords?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  seoTitle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  subtitle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  url?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  wellnessEngagement?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ProTranslationUncheckedUpdateManyInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  customTitle?: InputMaybe<BoolFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  extraDescription?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  preBookingWarning?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  proId?: InputMaybe<IntFieldUpdateOperationsInput>;
  seoDescription?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  seoFieldsAreCustom?: InputMaybe<BoolFieldUpdateOperationsInput>;
  seoKeywords?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  seoTitle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  subtitle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  url?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  wellnessEngagement?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ProTranslationUncheckedUpdateManyWithoutProInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  customTitle?: InputMaybe<BoolFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  extraDescription?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  preBookingWarning?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  seoDescription?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  seoFieldsAreCustom?: InputMaybe<BoolFieldUpdateOperationsInput>;
  seoKeywords?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  seoTitle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  subtitle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  url?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  wellnessEngagement?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ProTranslationUncheckedUpdateManyWithoutProNestedInput = {
  connect?: InputMaybe<Array<ProTranslationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProTranslationCreateOrConnectWithoutProInput>>;
  create?: InputMaybe<Array<ProTranslationCreateWithoutProInput>>;
  createMany?: InputMaybe<ProTranslationCreateManyProInputEnvelope>;
  delete?: InputMaybe<Array<ProTranslationWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ProTranslationScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ProTranslationWhereUniqueInput>>;
  set?: InputMaybe<Array<ProTranslationWhereUniqueInput>>;
  update?: InputMaybe<Array<ProTranslationUpdateWithWhereUniqueWithoutProInput>>;
  updateMany?: InputMaybe<Array<ProTranslationUpdateManyWithWhereWithoutProInput>>;
  upsert?: InputMaybe<Array<ProTranslationUpsertWithWhereUniqueWithoutProInput>>;
};

export type ProTranslationUncheckedUpdateWithoutProInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  customTitle?: InputMaybe<BoolFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  extraDescription?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  preBookingWarning?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  seoDescription?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  seoFieldsAreCustom?: InputMaybe<BoolFieldUpdateOperationsInput>;
  seoKeywords?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  seoTitle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  subtitle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  url?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  wellnessEngagement?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ProTranslationUpdateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  customTitle?: InputMaybe<BoolFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  extraDescription?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  preBookingWarning?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pro?: InputMaybe<ProfessionalUpdateOneRequiredWithoutTranslationsNestedInput>;
  seoDescription?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  seoFieldsAreCustom?: InputMaybe<BoolFieldUpdateOperationsInput>;
  seoKeywords?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  seoTitle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  subtitle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  url?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  wellnessEngagement?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ProTranslationUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  customTitle?: InputMaybe<BoolFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  extraDescription?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  preBookingWarning?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  seoDescription?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  seoFieldsAreCustom?: InputMaybe<BoolFieldUpdateOperationsInput>;
  seoKeywords?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  seoTitle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  subtitle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  url?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  wellnessEngagement?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ProTranslationUpdateManyWithWhereWithoutProInput = {
  data: ProTranslationUpdateManyMutationInput;
  where: ProTranslationScalarWhereInput;
};

export type ProTranslationUpdateManyWithoutProNestedInput = {
  connect?: InputMaybe<Array<ProTranslationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProTranslationCreateOrConnectWithoutProInput>>;
  create?: InputMaybe<Array<ProTranslationCreateWithoutProInput>>;
  createMany?: InputMaybe<ProTranslationCreateManyProInputEnvelope>;
  delete?: InputMaybe<Array<ProTranslationWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ProTranslationScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ProTranslationWhereUniqueInput>>;
  set?: InputMaybe<Array<ProTranslationWhereUniqueInput>>;
  update?: InputMaybe<Array<ProTranslationUpdateWithWhereUniqueWithoutProInput>>;
  updateMany?: InputMaybe<Array<ProTranslationUpdateManyWithWhereWithoutProInput>>;
  upsert?: InputMaybe<Array<ProTranslationUpsertWithWhereUniqueWithoutProInput>>;
};

export type ProTranslationUpdateWithWhereUniqueWithoutProInput = {
  data: ProTranslationUpdateWithoutProInput;
  where: ProTranslationWhereUniqueInput;
};

export type ProTranslationUpdateWithoutProInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  customTitle?: InputMaybe<BoolFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  extraDescription?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  preBookingWarning?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  seoDescription?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  seoFieldsAreCustom?: InputMaybe<BoolFieldUpdateOperationsInput>;
  seoKeywords?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  seoTitle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  subtitle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  url?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  wellnessEngagement?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ProTranslationUpsertWithWhereUniqueWithoutProInput = {
  create: ProTranslationCreateWithoutProInput;
  update: ProTranslationUpdateWithoutProInput;
  where: ProTranslationWhereUniqueInput;
};

export type ProTranslationWhereInput = {
  AND?: InputMaybe<Array<ProTranslationWhereInput>>;
  NOT?: InputMaybe<Array<ProTranslationWhereInput>>;
  OR?: InputMaybe<Array<ProTranslationWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customTitle?: InputMaybe<BoolFilter>;
  description?: InputMaybe<StringNullableFilter>;
  extraDescription?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<IntFilter>;
  language?: InputMaybe<StringFilter>;
  preBookingWarning?: InputMaybe<StringNullableFilter>;
  pro?: InputMaybe<ProfessionalRelationFilter>;
  proId?: InputMaybe<IntFilter>;
  seoDescription?: InputMaybe<StringNullableFilter>;
  seoFieldsAreCustom?: InputMaybe<BoolFilter>;
  seoKeywords?: InputMaybe<StringNullableFilter>;
  seoTitle?: InputMaybe<StringNullableFilter>;
  subtitle?: InputMaybe<StringNullableFilter>;
  title?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  url?: InputMaybe<StringNullableFilter>;
  wellnessEngagement?: InputMaybe<StringNullableFilter>;
};

export type ProTranslationWhereUniqueInput = {
  AND?: InputMaybe<Array<ProTranslationWhereInput>>;
  NOT?: InputMaybe<Array<ProTranslationWhereInput>>;
  OR?: InputMaybe<Array<ProTranslationWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customTitle?: InputMaybe<BoolFilter>;
  description?: InputMaybe<StringNullableFilter>;
  extraDescription?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  language?: InputMaybe<StringFilter>;
  preBookingWarning?: InputMaybe<StringNullableFilter>;
  pro?: InputMaybe<ProfessionalRelationFilter>;
  proId?: InputMaybe<IntFilter>;
  seoDescription?: InputMaybe<StringNullableFilter>;
  seoFieldsAreCustom?: InputMaybe<BoolFilter>;
  seoKeywords?: InputMaybe<StringNullableFilter>;
  seoTitle?: InputMaybe<StringNullableFilter>;
  subtitle?: InputMaybe<StringNullableFilter>;
  title?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  url?: InputMaybe<StringNullableFilter>;
  wellnessEngagement?: InputMaybe<StringNullableFilter>;
};

export type ProUrgencyAvailability = {
  __typename?: 'ProUrgencyAvailability';
  createdAt: Scalars['DateTime']['output'];
  dayOfWeek: DayOfWeek;
  endTime?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  pro: Professional;
  proId: Scalars['Int']['output'];
  startTime?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type ProUrgencyAvailabilityAvgAggregateOutputType = {
  __typename?: 'ProUrgencyAvailabilityAvgAggregateOutputType';
  id?: Maybe<Scalars['Float']['output']>;
  proId?: Maybe<Scalars['Float']['output']>;
};

export type ProUrgencyAvailabilityAvgOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
  proId?: InputMaybe<SortOrder>;
};

export type ProUrgencyAvailabilityCountAggregateOutputType = {
  __typename?: 'ProUrgencyAvailabilityCountAggregateOutputType';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  dayOfWeek: Scalars['Int']['output'];
  endTime: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  phone: Scalars['Int']['output'];
  proId: Scalars['Int']['output'];
  startTime: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type ProUrgencyAvailabilityCountOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  dayOfWeek?: InputMaybe<SortOrder>;
  endTime?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  phone?: InputMaybe<SortOrder>;
  proId?: InputMaybe<SortOrder>;
  startTime?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ProUrgencyAvailabilityCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dayOfWeek: DayOfWeek;
  endTime?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pro: ProfessionalCreateNestedOneWithoutUrgencyAvailabilitiesInput;
  startTime?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ProUrgencyAvailabilityCreateManyInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dayOfWeek: DayOfWeek;
  endTime?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  proId: Scalars['Int']['input'];
  startTime?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ProUrgencyAvailabilityCreateManyProInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dayOfWeek: DayOfWeek;
  endTime?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  startTime?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ProUrgencyAvailabilityCreateManyProInputEnvelope = {
  data: Array<ProUrgencyAvailabilityCreateManyProInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProUrgencyAvailabilityCreateNestedManyWithoutProInput = {
  connect?: InputMaybe<Array<ProUrgencyAvailabilityWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProUrgencyAvailabilityCreateOrConnectWithoutProInput>>;
  create?: InputMaybe<Array<ProUrgencyAvailabilityCreateWithoutProInput>>;
  createMany?: InputMaybe<ProUrgencyAvailabilityCreateManyProInputEnvelope>;
};

export type ProUrgencyAvailabilityCreateOrConnectWithoutProInput = {
  create: ProUrgencyAvailabilityCreateWithoutProInput;
  where: ProUrgencyAvailabilityWhereUniqueInput;
};

export type ProUrgencyAvailabilityCreateWithoutProInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dayOfWeek: DayOfWeek;
  endTime?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  startTime?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ProUrgencyAvailabilityListRelationFilter = {
  every?: InputMaybe<ProUrgencyAvailabilityWhereInput>;
  none?: InputMaybe<ProUrgencyAvailabilityWhereInput>;
  some?: InputMaybe<ProUrgencyAvailabilityWhereInput>;
};

export type ProUrgencyAvailabilityMaxAggregateOutputType = {
  __typename?: 'ProUrgencyAvailabilityMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  dayOfWeek?: Maybe<DayOfWeek>;
  endTime?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  proId?: Maybe<Scalars['Int']['output']>;
  startTime?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ProUrgencyAvailabilityMaxOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  dayOfWeek?: InputMaybe<SortOrder>;
  endTime?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  phone?: InputMaybe<SortOrder>;
  proId?: InputMaybe<SortOrder>;
  startTime?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ProUrgencyAvailabilityMinAggregateOutputType = {
  __typename?: 'ProUrgencyAvailabilityMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  dayOfWeek?: Maybe<DayOfWeek>;
  endTime?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  proId?: Maybe<Scalars['Int']['output']>;
  startTime?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ProUrgencyAvailabilityMinOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  dayOfWeek?: InputMaybe<SortOrder>;
  endTime?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  phone?: InputMaybe<SortOrder>;
  proId?: InputMaybe<SortOrder>;
  startTime?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ProUrgencyAvailabilityOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export enum ProUrgencyAvailabilityOrderByRelevanceFieldEnum {
  endTime = 'endTime',
  phone = 'phone',
  startTime = 'startTime'
}

export type ProUrgencyAvailabilityOrderByRelevanceInput = {
  fields: Array<ProUrgencyAvailabilityOrderByRelevanceFieldEnum>;
  search: Scalars['String']['input'];
  sort: SortOrder;
};

export type ProUrgencyAvailabilityOrderByWithAggregationInput = {
  _avg?: InputMaybe<ProUrgencyAvailabilityAvgOrderByAggregateInput>;
  _count?: InputMaybe<ProUrgencyAvailabilityCountOrderByAggregateInput>;
  _max?: InputMaybe<ProUrgencyAvailabilityMaxOrderByAggregateInput>;
  _min?: InputMaybe<ProUrgencyAvailabilityMinOrderByAggregateInput>;
  _sum?: InputMaybe<ProUrgencyAvailabilitySumOrderByAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  dayOfWeek?: InputMaybe<SortOrder>;
  endTime?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  phone?: InputMaybe<SortOrderInput>;
  proId?: InputMaybe<SortOrder>;
  startTime?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ProUrgencyAvailabilityOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: InputMaybe<ProUrgencyAvailabilityOrderByRelevanceInput>;
  createdAt?: InputMaybe<SortOrder>;
  dayOfWeek?: InputMaybe<SortOrder>;
  endTime?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  phone?: InputMaybe<SortOrderInput>;
  pro?: InputMaybe<ProfessionalOrderByWithRelationAndSearchRelevanceInput>;
  proId?: InputMaybe<SortOrder>;
  startTime?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum ProUrgencyAvailabilityScalarFieldEnum {
  createdAt = 'createdAt',
  dayOfWeek = 'dayOfWeek',
  endTime = 'endTime',
  id = 'id',
  phone = 'phone',
  proId = 'proId',
  startTime = 'startTime',
  updatedAt = 'updatedAt'
}

export type ProUrgencyAvailabilityScalarWhereInput = {
  AND?: InputMaybe<Array<ProUrgencyAvailabilityScalarWhereInput>>;
  NOT?: InputMaybe<Array<ProUrgencyAvailabilityScalarWhereInput>>;
  OR?: InputMaybe<Array<ProUrgencyAvailabilityScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  dayOfWeek?: InputMaybe<EnumDayOfWeekFilter>;
  endTime?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<IntFilter>;
  phone?: InputMaybe<StringNullableFilter>;
  proId?: InputMaybe<IntFilter>;
  startTime?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ProUrgencyAvailabilityScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<ProUrgencyAvailabilityScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<ProUrgencyAvailabilityScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<ProUrgencyAvailabilityScalarWhereWithAggregatesInput>>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  dayOfWeek?: InputMaybe<EnumDayOfWeekWithAggregatesFilter>;
  endTime?: InputMaybe<StringNullableWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  phone?: InputMaybe<StringNullableWithAggregatesFilter>;
  proId?: InputMaybe<IntWithAggregatesFilter>;
  startTime?: InputMaybe<StringNullableWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type ProUrgencyAvailabilitySumAggregateOutputType = {
  __typename?: 'ProUrgencyAvailabilitySumAggregateOutputType';
  id?: Maybe<Scalars['Int']['output']>;
  proId?: Maybe<Scalars['Int']['output']>;
};

export type ProUrgencyAvailabilitySumOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
  proId?: InputMaybe<SortOrder>;
};

export type ProUrgencyAvailabilityUncheckedCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dayOfWeek: DayOfWeek;
  endTime?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  proId: Scalars['Int']['input'];
  startTime?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ProUrgencyAvailabilityUncheckedCreateNestedManyWithoutProInput = {
  connect?: InputMaybe<Array<ProUrgencyAvailabilityWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProUrgencyAvailabilityCreateOrConnectWithoutProInput>>;
  create?: InputMaybe<Array<ProUrgencyAvailabilityCreateWithoutProInput>>;
  createMany?: InputMaybe<ProUrgencyAvailabilityCreateManyProInputEnvelope>;
};

export type ProUrgencyAvailabilityUncheckedCreateWithoutProInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dayOfWeek: DayOfWeek;
  endTime?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  startTime?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ProUrgencyAvailabilityUncheckedUpdateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dayOfWeek?: InputMaybe<EnumDayOfWeekFieldUpdateOperationsInput>;
  endTime?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  proId?: InputMaybe<IntFieldUpdateOperationsInput>;
  startTime?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ProUrgencyAvailabilityUncheckedUpdateManyInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dayOfWeek?: InputMaybe<EnumDayOfWeekFieldUpdateOperationsInput>;
  endTime?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  proId?: InputMaybe<IntFieldUpdateOperationsInput>;
  startTime?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ProUrgencyAvailabilityUncheckedUpdateManyWithoutProInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dayOfWeek?: InputMaybe<EnumDayOfWeekFieldUpdateOperationsInput>;
  endTime?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  startTime?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ProUrgencyAvailabilityUncheckedUpdateManyWithoutProNestedInput = {
  connect?: InputMaybe<Array<ProUrgencyAvailabilityWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProUrgencyAvailabilityCreateOrConnectWithoutProInput>>;
  create?: InputMaybe<Array<ProUrgencyAvailabilityCreateWithoutProInput>>;
  createMany?: InputMaybe<ProUrgencyAvailabilityCreateManyProInputEnvelope>;
  delete?: InputMaybe<Array<ProUrgencyAvailabilityWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ProUrgencyAvailabilityScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ProUrgencyAvailabilityWhereUniqueInput>>;
  set?: InputMaybe<Array<ProUrgencyAvailabilityWhereUniqueInput>>;
  update?: InputMaybe<Array<ProUrgencyAvailabilityUpdateWithWhereUniqueWithoutProInput>>;
  updateMany?: InputMaybe<Array<ProUrgencyAvailabilityUpdateManyWithWhereWithoutProInput>>;
  upsert?: InputMaybe<Array<ProUrgencyAvailabilityUpsertWithWhereUniqueWithoutProInput>>;
};

export type ProUrgencyAvailabilityUncheckedUpdateWithoutProInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dayOfWeek?: InputMaybe<EnumDayOfWeekFieldUpdateOperationsInput>;
  endTime?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  startTime?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ProUrgencyAvailabilityUpdateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dayOfWeek?: InputMaybe<EnumDayOfWeekFieldUpdateOperationsInput>;
  endTime?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pro?: InputMaybe<ProfessionalUpdateOneRequiredWithoutUrgencyAvailabilitiesNestedInput>;
  startTime?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ProUrgencyAvailabilityUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dayOfWeek?: InputMaybe<EnumDayOfWeekFieldUpdateOperationsInput>;
  endTime?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  startTime?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ProUrgencyAvailabilityUpdateManyWithWhereWithoutProInput = {
  data: ProUrgencyAvailabilityUpdateManyMutationInput;
  where: ProUrgencyAvailabilityScalarWhereInput;
};

export type ProUrgencyAvailabilityUpdateManyWithoutProNestedInput = {
  connect?: InputMaybe<Array<ProUrgencyAvailabilityWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProUrgencyAvailabilityCreateOrConnectWithoutProInput>>;
  create?: InputMaybe<Array<ProUrgencyAvailabilityCreateWithoutProInput>>;
  createMany?: InputMaybe<ProUrgencyAvailabilityCreateManyProInputEnvelope>;
  delete?: InputMaybe<Array<ProUrgencyAvailabilityWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ProUrgencyAvailabilityScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ProUrgencyAvailabilityWhereUniqueInput>>;
  set?: InputMaybe<Array<ProUrgencyAvailabilityWhereUniqueInput>>;
  update?: InputMaybe<Array<ProUrgencyAvailabilityUpdateWithWhereUniqueWithoutProInput>>;
  updateMany?: InputMaybe<Array<ProUrgencyAvailabilityUpdateManyWithWhereWithoutProInput>>;
  upsert?: InputMaybe<Array<ProUrgencyAvailabilityUpsertWithWhereUniqueWithoutProInput>>;
};

export type ProUrgencyAvailabilityUpdateWithWhereUniqueWithoutProInput = {
  data: ProUrgencyAvailabilityUpdateWithoutProInput;
  where: ProUrgencyAvailabilityWhereUniqueInput;
};

export type ProUrgencyAvailabilityUpdateWithoutProInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dayOfWeek?: InputMaybe<EnumDayOfWeekFieldUpdateOperationsInput>;
  endTime?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  startTime?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ProUrgencyAvailabilityUpsertWithWhereUniqueWithoutProInput = {
  create: ProUrgencyAvailabilityCreateWithoutProInput;
  update: ProUrgencyAvailabilityUpdateWithoutProInput;
  where: ProUrgencyAvailabilityWhereUniqueInput;
};

export type ProUrgencyAvailabilityWhereInput = {
  AND?: InputMaybe<Array<ProUrgencyAvailabilityWhereInput>>;
  NOT?: InputMaybe<Array<ProUrgencyAvailabilityWhereInput>>;
  OR?: InputMaybe<Array<ProUrgencyAvailabilityWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  dayOfWeek?: InputMaybe<EnumDayOfWeekFilter>;
  endTime?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<IntFilter>;
  phone?: InputMaybe<StringNullableFilter>;
  pro?: InputMaybe<ProfessionalRelationFilter>;
  proId?: InputMaybe<IntFilter>;
  startTime?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ProUrgencyAvailabilityWhereUniqueInput = {
  AND?: InputMaybe<Array<ProUrgencyAvailabilityWhereInput>>;
  NOT?: InputMaybe<Array<ProUrgencyAvailabilityWhereInput>>;
  OR?: InputMaybe<Array<ProUrgencyAvailabilityWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  dayOfWeek?: InputMaybe<EnumDayOfWeekFilter>;
  endTime?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  phone?: InputMaybe<StringNullableFilter>;
  pro?: InputMaybe<ProfessionalRelationFilter>;
  proId?: InputMaybe<IntFilter>;
  startTime?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type Professional = {
  __typename?: 'Professional';
  _count: ProfessionalCountOutputType;
  acceptedAnimals: Array<AnimalTypeEnum>;
  acceptsNewClients: Scalars['Boolean']['output'];
  acceptsOnlineAppointment: Scalars['Boolean']['output'];
  address?: Maybe<Address>;
  addressId?: Maybe<Scalars['Int']['output']>;
  allowsAnyWorkerOption: Scalars['Boolean']['output'];
  assistantsCount?: Maybe<Scalars['Int']['output']>;
  availabilities: Array<ProAvailability>;
  bookingGroupingMaxSlotDistance: Scalars['Int']['output'];
  centerType?: Maybe<CenterTypeEnum>;
  createdAt: Scalars['DateTime']['output'];
  defaultServiceDurationMinute: Scalars['Int']['output'];
  degrees: Array<ProDegrees>;
  distance?: Maybe<Scalars['Float']['output']>;
  educatorType?: Maybe<EducatorTypeEnum>;
  email?: Maybe<Scalars['String']['output']>;
  employeesCount?: Maybe<Scalars['Int']['output']>;
  forceBookingGrouping: Scalars['Boolean']['output'];
  googleAccessToken?: Maybe<Scalars['String']['output']>;
  googleEmail?: Maybe<Scalars['String']['output']>;
  googleIdToken?: Maybe<Scalars['String']['output']>;
  googleRefreshToken?: Maybe<Scalars['String']['output']>;
  googleTokenExpiryDate?: Maybe<Scalars['String']['output']>;
  googleTokenScope?: Maybe<Scalars['String']['output']>;
  googleTokenType?: Maybe<Scalars['String']['output']>;
  hasShop?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  imgs: Array<ProImg>;
  isTipawPartner: Scalars['Boolean']['output'];
  language: Scalars['String']['output'];
  mainProFirstName?: Maybe<Scalars['String']['output']>;
  mainProLastName?: Maybe<Scalars['String']['output']>;
  maxSmsNotification: Scalars['Int']['output'];
  maxWeeksBeforeBooking: Scalars['Int']['output'];
  meta?: Maybe<Scalars['String']['output']>;
  minHoursBeforeBooking: Scalars['Int']['output'];
  minHoursBeforeUpdateOrCancelBooking: Scalars['Int']['output'];
  mobilePhone?: Maybe<Scalars['String']['output']>;
  namePro?: Maybe<Scalars['String']['output']>;
  notifications: Array<Notification>;
  onlineBookingEnabled: Scalars['Boolean']['output'];
  orderingIndex: Scalars['Int']['output'];
  parking?: Maybe<Scalars['Boolean']['output']>;
  paymentMethods: Array<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  practicePlaces?: Maybe<Array<Maybe<EducatorPracticePlaceEnum>>>;
  /** @TypeGraphQL.omit(output: true) */
  proMongoId?: Maybe<Scalars['String']['output']>;
  proSchedule: Array<Maybe<ProDayAvailabilities>>;
  profileVideo?: Maybe<Scalars['String']['output']>;
  profileVideoPos: Scalars['Int']['output'];
  published: Scalars['Boolean']['output'];
  reviews?: Maybe<Array<Maybe<EducatorReview>>>;
  scheduleAvailabilities?: Maybe<Array<ProfessionalScheduleAvailabilities>>;
  searchString?: Maybe<Scalars['String']['output']>;
  selfDogWash: Scalars['Boolean']['output'];
  services: Array<Maybe<ProfessionalService>>;
  shopOpeningHours: Array<ProShopOpeningHour>;
  shopSchedule: Array<Maybe<ProShopOpeningHours>>;
  smsBookingRemindersEnabled: Scalars['Boolean']['output'];
  spokenLanguages: Array<Scalars['String']['output']>;
  sranje?: Maybe<Scalars['String']['output']>;
  stats: Array<ProStat>;
  translations: Array<ProTranslation>;
  type: ProfessionalTypeEnum;
  unclaimedProfile: Scalars['Boolean']['output'];
  updatedAt: Scalars['DateTime']['output'];
  urgencyAvailabilities: Array<ProUrgencyAvailability>;
  visitAtHome?: Maybe<Scalars['Boolean']['output']>;
  website?: Maybe<Scalars['String']['output']>;
  whatsappNumber?: Maybe<Scalars['String']['output']>;
  workers: Array<Worker>;
};


export type ProfessionalavailabilitiesArgs = {
  cursor?: InputMaybe<ProAvailabilityWhereUniqueInput>;
  distinct?: InputMaybe<ProAvailabilityScalarFieldEnum>;
  orderBy?: InputMaybe<ProAvailabilityOrderByWithRelationAndSearchRelevanceInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProAvailabilityWhereInput>;
};


export type ProfessionaldegreesArgs = {
  cursor?: InputMaybe<ProDegreesWhereUniqueInput>;
  distinct?: InputMaybe<ProDegreesScalarFieldEnum>;
  orderBy?: InputMaybe<ProDegreesOrderByWithRelationAndSearchRelevanceInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProDegreesWhereInput>;
};


export type ProfessionalimgsArgs = {
  cursor?: InputMaybe<ProImgWhereUniqueInput>;
  distinct?: InputMaybe<ProImgScalarFieldEnum>;
  orderBy?: InputMaybe<ProImgOrderByWithRelationAndSearchRelevanceInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProImgWhereInput>;
};


export type ProfessionalnotificationsArgs = {
  cursor?: InputMaybe<NotificationWhereUniqueInput>;
  distinct?: InputMaybe<NotificationScalarFieldEnum>;
  orderBy?: InputMaybe<NotificationOrderByWithRelationAndSearchRelevanceInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<NotificationWhereInput>;
};


export type ProfessionalreviewsArgs = {
  cursor?: InputMaybe<EducatorReviewWhereUniqueInput>;
  orderBy?: InputMaybe<EducatorReviewOrderByWithRelationAndSearchRelevanceInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<EducatorReviewWhereInput>;
};


export type ProfessionalservicesArgs = {
  language: Scalars['String']['input'];
};


export type ProfessionalshopOpeningHoursArgs = {
  cursor?: InputMaybe<ProShopOpeningHourWhereUniqueInput>;
  distinct?: InputMaybe<ProShopOpeningHourScalarFieldEnum>;
  orderBy?: InputMaybe<ProShopOpeningHourOrderByWithRelationAndSearchRelevanceInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProShopOpeningHourWhereInput>;
};


export type ProfessionalstatsArgs = {
  cursor?: InputMaybe<ProStatWhereUniqueInput>;
  distinct?: InputMaybe<ProStatScalarFieldEnum>;
  orderBy?: InputMaybe<ProStatOrderByWithRelationAndSearchRelevanceInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProStatWhereInput>;
};


export type ProfessionaltranslationsArgs = {
  cursor?: InputMaybe<ProTranslationWhereUniqueInput>;
  distinct?: InputMaybe<ProTranslationScalarFieldEnum>;
  orderBy?: InputMaybe<ProTranslationOrderByWithRelationAndSearchRelevanceInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProTranslationWhereInput>;
};


export type ProfessionalurgencyAvailabilitiesArgs = {
  cursor?: InputMaybe<ProUrgencyAvailabilityWhereUniqueInput>;
  distinct?: InputMaybe<ProUrgencyAvailabilityScalarFieldEnum>;
  orderBy?: InputMaybe<ProUrgencyAvailabilityOrderByWithRelationAndSearchRelevanceInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProUrgencyAvailabilityWhereInput>;
};


export type ProfessionalworkersArgs = {
  cursor?: InputMaybe<WorkerWhereUniqueInput>;
  distinct?: InputMaybe<WorkerScalarFieldEnum>;
  orderBy?: InputMaybe<WorkerOrderByWithRelationAndSearchRelevanceInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<WorkerWhereInput>;
};

export type ProfessionalAvgAggregateOutputType = {
  __typename?: 'ProfessionalAvgAggregateOutputType';
  addressId?: Maybe<Scalars['Float']['output']>;
  assistantsCount?: Maybe<Scalars['Float']['output']>;
  bookingGroupingMaxSlotDistance?: Maybe<Scalars['Float']['output']>;
  defaultServiceDurationMinute?: Maybe<Scalars['Float']['output']>;
  employeesCount?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  maxSmsNotification?: Maybe<Scalars['Float']['output']>;
  maxWeeksBeforeBooking?: Maybe<Scalars['Float']['output']>;
  minHoursBeforeBooking?: Maybe<Scalars['Float']['output']>;
  minHoursBeforeUpdateOrCancelBooking?: Maybe<Scalars['Float']['output']>;
  orderingIndex?: Maybe<Scalars['Float']['output']>;
  profileVideoPos?: Maybe<Scalars['Float']['output']>;
};

export type ProfessionalAvgOrderByAggregateInput = {
  addressId?: InputMaybe<SortOrder>;
  assistantsCount?: InputMaybe<SortOrder>;
  bookingGroupingMaxSlotDistance?: InputMaybe<SortOrder>;
  defaultServiceDurationMinute?: InputMaybe<SortOrder>;
  employeesCount?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  maxSmsNotification?: InputMaybe<SortOrder>;
  maxWeeksBeforeBooking?: InputMaybe<SortOrder>;
  minHoursBeforeBooking?: InputMaybe<SortOrder>;
  minHoursBeforeUpdateOrCancelBooking?: InputMaybe<SortOrder>;
  orderingIndex?: InputMaybe<SortOrder>;
  profileVideoPos?: InputMaybe<SortOrder>;
};

export type ProfessionalCountAggregateOutputType = {
  __typename?: 'ProfessionalCountAggregateOutputType';
  _all: Scalars['Int']['output'];
  acceptedAnimals: Scalars['Int']['output'];
  acceptsNewClients: Scalars['Int']['output'];
  acceptsOnlineAppointment: Scalars['Int']['output'];
  addressId: Scalars['Int']['output'];
  allowsAnyWorkerOption: Scalars['Int']['output'];
  assistantsCount: Scalars['Int']['output'];
  bookingGroupingMaxSlotDistance: Scalars['Int']['output'];
  centerType: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  defaultServiceDurationMinute: Scalars['Int']['output'];
  educatorType: Scalars['Int']['output'];
  email: Scalars['Int']['output'];
  employeesCount: Scalars['Int']['output'];
  forceBookingGrouping: Scalars['Int']['output'];
  googleAccessToken: Scalars['Int']['output'];
  googleEmail: Scalars['Int']['output'];
  googleIdToken: Scalars['Int']['output'];
  googleRefreshToken: Scalars['Int']['output'];
  googleTokenExpiryDate: Scalars['Int']['output'];
  googleTokenScope: Scalars['Int']['output'];
  googleTokenType: Scalars['Int']['output'];
  hasShop: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isTipawPartner: Scalars['Int']['output'];
  language: Scalars['Int']['output'];
  mainProFirstName: Scalars['Int']['output'];
  mainProLastName: Scalars['Int']['output'];
  maxSmsNotification: Scalars['Int']['output'];
  maxWeeksBeforeBooking: Scalars['Int']['output'];
  meta: Scalars['Int']['output'];
  minHoursBeforeBooking: Scalars['Int']['output'];
  minHoursBeforeUpdateOrCancelBooking: Scalars['Int']['output'];
  mobilePhone: Scalars['Int']['output'];
  namePro: Scalars['Int']['output'];
  onlineBookingEnabled: Scalars['Int']['output'];
  orderingIndex: Scalars['Int']['output'];
  parking: Scalars['Int']['output'];
  paymentMethods: Scalars['Int']['output'];
  phone: Scalars['Int']['output'];
  practicePlaces: Scalars['Int']['output'];
  privateEmail: Scalars['Int']['output'];
  proMongoId: Scalars['Int']['output'];
  profileVideo: Scalars['Int']['output'];
  profileVideoPos: Scalars['Int']['output'];
  published: Scalars['Int']['output'];
  searchString: Scalars['Int']['output'];
  selfDogWash: Scalars['Int']['output'];
  smsBookingRemindersEnabled: Scalars['Int']['output'];
  spokenLanguages: Scalars['Int']['output'];
  type: Scalars['Int']['output'];
  unclaimedProfile: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
  visitAtHome: Scalars['Int']['output'];
  website: Scalars['Int']['output'];
  whatsappNumber: Scalars['Int']['output'];
};

export type ProfessionalCountOrderByAggregateInput = {
  acceptedAnimals?: InputMaybe<SortOrder>;
  acceptsNewClients?: InputMaybe<SortOrder>;
  acceptsOnlineAppointment?: InputMaybe<SortOrder>;
  addressId?: InputMaybe<SortOrder>;
  allowsAnyWorkerOption?: InputMaybe<SortOrder>;
  assistantsCount?: InputMaybe<SortOrder>;
  bookingGroupingMaxSlotDistance?: InputMaybe<SortOrder>;
  centerType?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  defaultServiceDurationMinute?: InputMaybe<SortOrder>;
  educatorType?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  employeesCount?: InputMaybe<SortOrder>;
  forceBookingGrouping?: InputMaybe<SortOrder>;
  googleAccessToken?: InputMaybe<SortOrder>;
  googleEmail?: InputMaybe<SortOrder>;
  googleIdToken?: InputMaybe<SortOrder>;
  googleRefreshToken?: InputMaybe<SortOrder>;
  googleTokenExpiryDate?: InputMaybe<SortOrder>;
  googleTokenScope?: InputMaybe<SortOrder>;
  googleTokenType?: InputMaybe<SortOrder>;
  hasShop?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isTipawPartner?: InputMaybe<SortOrder>;
  language?: InputMaybe<SortOrder>;
  mainProFirstName?: InputMaybe<SortOrder>;
  mainProLastName?: InputMaybe<SortOrder>;
  maxSmsNotification?: InputMaybe<SortOrder>;
  maxWeeksBeforeBooking?: InputMaybe<SortOrder>;
  meta?: InputMaybe<SortOrder>;
  minHoursBeforeBooking?: InputMaybe<SortOrder>;
  minHoursBeforeUpdateOrCancelBooking?: InputMaybe<SortOrder>;
  mobilePhone?: InputMaybe<SortOrder>;
  namePro?: InputMaybe<SortOrder>;
  onlineBookingEnabled?: InputMaybe<SortOrder>;
  orderingIndex?: InputMaybe<SortOrder>;
  parking?: InputMaybe<SortOrder>;
  paymentMethods?: InputMaybe<SortOrder>;
  phone?: InputMaybe<SortOrder>;
  practicePlaces?: InputMaybe<SortOrder>;
  privateEmail?: InputMaybe<SortOrder>;
  proMongoId?: InputMaybe<SortOrder>;
  profileVideo?: InputMaybe<SortOrder>;
  profileVideoPos?: InputMaybe<SortOrder>;
  published?: InputMaybe<SortOrder>;
  searchString?: InputMaybe<SortOrder>;
  selfDogWash?: InputMaybe<SortOrder>;
  smsBookingRemindersEnabled?: InputMaybe<SortOrder>;
  spokenLanguages?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  unclaimedProfile?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  visitAtHome?: InputMaybe<SortOrder>;
  website?: InputMaybe<SortOrder>;
  whatsappNumber?: InputMaybe<SortOrder>;
};

export type ProfessionalCountOutputType = {
  __typename?: 'ProfessionalCountOutputType';
  adminNotes: Scalars['Int']['output'];
  availabilities: Scalars['Int']['output'];
  degrees: Scalars['Int']['output'];
  emailHistory: Scalars['Int']['output'];
  imgs: Scalars['Int']['output'];
  notifications: Scalars['Int']['output'];
  reviews: Scalars['Int']['output'];
  shopOpeningHours: Scalars['Int']['output'];
  stats: Scalars['Int']['output'];
  translations: Scalars['Int']['output'];
  urgencyAvailabilities: Scalars['Int']['output'];
  workers: Scalars['Int']['output'];
};

export type ProfessionalCreateInput = {
  acceptedAnimals?: InputMaybe<Array<AnimalTypeEnum>>;
  acceptsNewClients?: InputMaybe<Scalars['Boolean']['input']>;
  acceptsOnlineAppointment?: InputMaybe<Scalars['Boolean']['input']>;
  address?: InputMaybe<AddressCreateNestedOneWithoutProInput>;
  adminNotes?: InputMaybe<AdminNoteCreateNestedManyWithoutProfessionalInput>;
  allowsAnyWorkerOption?: InputMaybe<Scalars['Boolean']['input']>;
  assistantsCount?: InputMaybe<Scalars['Int']['input']>;
  availabilities?: InputMaybe<ProAvailabilityCreateNestedManyWithoutProInput>;
  bookingGroupingMaxSlotDistance?: InputMaybe<Scalars['Int']['input']>;
  centerType?: InputMaybe<CenterTypeEnum>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  defaultServiceDurationMinute?: InputMaybe<Scalars['Int']['input']>;
  degrees?: InputMaybe<ProDegreesCreateNestedManyWithoutProInput>;
  educatorType?: InputMaybe<EducatorTypeEnum>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailHistory?: InputMaybe<EmailHistoryCreateNestedManyWithoutProfessionalInput>;
  employeesCount?: InputMaybe<Scalars['Int']['input']>;
  forceBookingGrouping?: InputMaybe<Scalars['Boolean']['input']>;
  googleAccessToken?: InputMaybe<Scalars['String']['input']>;
  googleEmail?: InputMaybe<Scalars['String']['input']>;
  googleIdToken?: InputMaybe<Scalars['String']['input']>;
  googleRefreshToken?: InputMaybe<Scalars['String']['input']>;
  googleTokenExpiryDate?: InputMaybe<Scalars['String']['input']>;
  googleTokenScope?: InputMaybe<Scalars['String']['input']>;
  googleTokenType?: InputMaybe<Scalars['String']['input']>;
  hasShop?: InputMaybe<Scalars['Boolean']['input']>;
  imgs?: InputMaybe<ProImgCreateNestedManyWithoutProInput>;
  isTipawPartner?: InputMaybe<Scalars['Boolean']['input']>;
  language: Scalars['String']['input'];
  mainProFirstName?: InputMaybe<Scalars['String']['input']>;
  mainProLastName?: InputMaybe<Scalars['String']['input']>;
  maxSmsNotification?: InputMaybe<Scalars['Int']['input']>;
  maxWeeksBeforeBooking?: InputMaybe<Scalars['Int']['input']>;
  meta?: InputMaybe<Scalars['String']['input']>;
  minHoursBeforeBooking?: InputMaybe<Scalars['Int']['input']>;
  minHoursBeforeUpdateOrCancelBooking?: InputMaybe<Scalars['Int']['input']>;
  mobilePhone?: InputMaybe<Scalars['String']['input']>;
  namePro?: InputMaybe<Scalars['String']['input']>;
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutProInput>;
  onlineBookingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  orderingIndex?: InputMaybe<Scalars['Int']['input']>;
  parking?: InputMaybe<Scalars['Boolean']['input']>;
  paymentMethods?: InputMaybe<Array<Scalars['String']['input']>>;
  phone?: InputMaybe<Scalars['String']['input']>;
  practicePlaces?: InputMaybe<Array<EducatorPracticePlaceEnum>>;
  privateEmail?: InputMaybe<Scalars['String']['input']>;
  proMongoId?: InputMaybe<Scalars['String']['input']>;
  profileVideo?: InputMaybe<Scalars['String']['input']>;
  profileVideoPos?: InputMaybe<Scalars['Int']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  reviews?: InputMaybe<EducatorReviewCreateNestedManyWithoutProfessionalInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  selfDogWash?: InputMaybe<Scalars['Boolean']['input']>;
  shopOpeningHours?: InputMaybe<ProShopOpeningHourCreateNestedManyWithoutProInput>;
  smsBookingRemindersEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  stats?: InputMaybe<ProStatCreateNestedManyWithoutProInput>;
  translations?: InputMaybe<ProTranslationCreateNestedManyWithoutProInput>;
  type: ProfessionalTypeEnum;
  unclaimedProfile?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  urgencyAvailabilities?: InputMaybe<ProUrgencyAvailabilityCreateNestedManyWithoutProInput>;
  visitAtHome?: InputMaybe<Scalars['Boolean']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  whatsappNumber?: InputMaybe<Scalars['String']['input']>;
  workers?: InputMaybe<WorkerCreateNestedManyWithoutProInput>;
};

export type ProfessionalCreateManyInput = {
  acceptedAnimals?: InputMaybe<Array<AnimalTypeEnum>>;
  acceptsNewClients?: InputMaybe<Scalars['Boolean']['input']>;
  acceptsOnlineAppointment?: InputMaybe<Scalars['Boolean']['input']>;
  addressId?: InputMaybe<Scalars['Int']['input']>;
  allowsAnyWorkerOption?: InputMaybe<Scalars['Boolean']['input']>;
  assistantsCount?: InputMaybe<Scalars['Int']['input']>;
  bookingGroupingMaxSlotDistance?: InputMaybe<Scalars['Int']['input']>;
  centerType?: InputMaybe<CenterTypeEnum>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  defaultServiceDurationMinute?: InputMaybe<Scalars['Int']['input']>;
  educatorType?: InputMaybe<EducatorTypeEnum>;
  email?: InputMaybe<Scalars['String']['input']>;
  employeesCount?: InputMaybe<Scalars['Int']['input']>;
  forceBookingGrouping?: InputMaybe<Scalars['Boolean']['input']>;
  googleAccessToken?: InputMaybe<Scalars['String']['input']>;
  googleEmail?: InputMaybe<Scalars['String']['input']>;
  googleIdToken?: InputMaybe<Scalars['String']['input']>;
  googleRefreshToken?: InputMaybe<Scalars['String']['input']>;
  googleTokenExpiryDate?: InputMaybe<Scalars['String']['input']>;
  googleTokenScope?: InputMaybe<Scalars['String']['input']>;
  googleTokenType?: InputMaybe<Scalars['String']['input']>;
  hasShop?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isTipawPartner?: InputMaybe<Scalars['Boolean']['input']>;
  language: Scalars['String']['input'];
  mainProFirstName?: InputMaybe<Scalars['String']['input']>;
  mainProLastName?: InputMaybe<Scalars['String']['input']>;
  maxSmsNotification?: InputMaybe<Scalars['Int']['input']>;
  maxWeeksBeforeBooking?: InputMaybe<Scalars['Int']['input']>;
  meta?: InputMaybe<Scalars['String']['input']>;
  minHoursBeforeBooking?: InputMaybe<Scalars['Int']['input']>;
  minHoursBeforeUpdateOrCancelBooking?: InputMaybe<Scalars['Int']['input']>;
  mobilePhone?: InputMaybe<Scalars['String']['input']>;
  namePro?: InputMaybe<Scalars['String']['input']>;
  onlineBookingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  orderingIndex?: InputMaybe<Scalars['Int']['input']>;
  parking?: InputMaybe<Scalars['Boolean']['input']>;
  paymentMethods?: InputMaybe<Array<Scalars['String']['input']>>;
  phone?: InputMaybe<Scalars['String']['input']>;
  practicePlaces?: InputMaybe<Array<EducatorPracticePlaceEnum>>;
  privateEmail?: InputMaybe<Scalars['String']['input']>;
  proMongoId?: InputMaybe<Scalars['String']['input']>;
  profileVideo?: InputMaybe<Scalars['String']['input']>;
  profileVideoPos?: InputMaybe<Scalars['Int']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  selfDogWash?: InputMaybe<Scalars['Boolean']['input']>;
  smsBookingRemindersEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  type: ProfessionalTypeEnum;
  unclaimedProfile?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  visitAtHome?: InputMaybe<Scalars['Boolean']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  whatsappNumber?: InputMaybe<Scalars['String']['input']>;
};

export type ProfessionalCreateNestedOneWithoutAddressInput = {
  connect?: InputMaybe<ProfessionalWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProfessionalCreateOrConnectWithoutAddressInput>;
  create?: InputMaybe<ProfessionalCreateWithoutAddressInput>;
};

export type ProfessionalCreateNestedOneWithoutAdminNotesInput = {
  connect?: InputMaybe<ProfessionalWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProfessionalCreateOrConnectWithoutAdminNotesInput>;
  create?: InputMaybe<ProfessionalCreateWithoutAdminNotesInput>;
};

export type ProfessionalCreateNestedOneWithoutAvailabilitiesInput = {
  connect?: InputMaybe<ProfessionalWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProfessionalCreateOrConnectWithoutAvailabilitiesInput>;
  create?: InputMaybe<ProfessionalCreateWithoutAvailabilitiesInput>;
};

export type ProfessionalCreateNestedOneWithoutDegreesInput = {
  connect?: InputMaybe<ProfessionalWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProfessionalCreateOrConnectWithoutDegreesInput>;
  create?: InputMaybe<ProfessionalCreateWithoutDegreesInput>;
};

export type ProfessionalCreateNestedOneWithoutEmailHistoryInput = {
  connect?: InputMaybe<ProfessionalWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProfessionalCreateOrConnectWithoutEmailHistoryInput>;
  create?: InputMaybe<ProfessionalCreateWithoutEmailHistoryInput>;
};

export type ProfessionalCreateNestedOneWithoutImgsInput = {
  connect?: InputMaybe<ProfessionalWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProfessionalCreateOrConnectWithoutImgsInput>;
  create?: InputMaybe<ProfessionalCreateWithoutImgsInput>;
};

export type ProfessionalCreateNestedOneWithoutNotificationsInput = {
  connect?: InputMaybe<ProfessionalWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProfessionalCreateOrConnectWithoutNotificationsInput>;
  create?: InputMaybe<ProfessionalCreateWithoutNotificationsInput>;
};

export type ProfessionalCreateNestedOneWithoutReviewsInput = {
  connect?: InputMaybe<ProfessionalWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProfessionalCreateOrConnectWithoutReviewsInput>;
  create?: InputMaybe<ProfessionalCreateWithoutReviewsInput>;
};

export type ProfessionalCreateNestedOneWithoutShopOpeningHoursInput = {
  connect?: InputMaybe<ProfessionalWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProfessionalCreateOrConnectWithoutShopOpeningHoursInput>;
  create?: InputMaybe<ProfessionalCreateWithoutShopOpeningHoursInput>;
};

export type ProfessionalCreateNestedOneWithoutStatsInput = {
  connect?: InputMaybe<ProfessionalWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProfessionalCreateOrConnectWithoutStatsInput>;
  create?: InputMaybe<ProfessionalCreateWithoutStatsInput>;
};

export type ProfessionalCreateNestedOneWithoutTranslationsInput = {
  connect?: InputMaybe<ProfessionalWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProfessionalCreateOrConnectWithoutTranslationsInput>;
  create?: InputMaybe<ProfessionalCreateWithoutTranslationsInput>;
};

export type ProfessionalCreateNestedOneWithoutUrgencyAvailabilitiesInput = {
  connect?: InputMaybe<ProfessionalWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProfessionalCreateOrConnectWithoutUrgencyAvailabilitiesInput>;
  create?: InputMaybe<ProfessionalCreateWithoutUrgencyAvailabilitiesInput>;
};

export type ProfessionalCreateNestedOneWithoutWorkersInput = {
  connect?: InputMaybe<ProfessionalWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProfessionalCreateOrConnectWithoutWorkersInput>;
  create?: InputMaybe<ProfessionalCreateWithoutWorkersInput>;
};

export type ProfessionalCreateOrConnectWithoutAddressInput = {
  create: ProfessionalCreateWithoutAddressInput;
  where: ProfessionalWhereUniqueInput;
};

export type ProfessionalCreateOrConnectWithoutAdminNotesInput = {
  create: ProfessionalCreateWithoutAdminNotesInput;
  where: ProfessionalWhereUniqueInput;
};

export type ProfessionalCreateOrConnectWithoutAvailabilitiesInput = {
  create: ProfessionalCreateWithoutAvailabilitiesInput;
  where: ProfessionalWhereUniqueInput;
};

export type ProfessionalCreateOrConnectWithoutDegreesInput = {
  create: ProfessionalCreateWithoutDegreesInput;
  where: ProfessionalWhereUniqueInput;
};

export type ProfessionalCreateOrConnectWithoutEmailHistoryInput = {
  create: ProfessionalCreateWithoutEmailHistoryInput;
  where: ProfessionalWhereUniqueInput;
};

export type ProfessionalCreateOrConnectWithoutImgsInput = {
  create: ProfessionalCreateWithoutImgsInput;
  where: ProfessionalWhereUniqueInput;
};

export type ProfessionalCreateOrConnectWithoutNotificationsInput = {
  create: ProfessionalCreateWithoutNotificationsInput;
  where: ProfessionalWhereUniqueInput;
};

export type ProfessionalCreateOrConnectWithoutReviewsInput = {
  create: ProfessionalCreateWithoutReviewsInput;
  where: ProfessionalWhereUniqueInput;
};

export type ProfessionalCreateOrConnectWithoutShopOpeningHoursInput = {
  create: ProfessionalCreateWithoutShopOpeningHoursInput;
  where: ProfessionalWhereUniqueInput;
};

export type ProfessionalCreateOrConnectWithoutStatsInput = {
  create: ProfessionalCreateWithoutStatsInput;
  where: ProfessionalWhereUniqueInput;
};

export type ProfessionalCreateOrConnectWithoutTranslationsInput = {
  create: ProfessionalCreateWithoutTranslationsInput;
  where: ProfessionalWhereUniqueInput;
};

export type ProfessionalCreateOrConnectWithoutUrgencyAvailabilitiesInput = {
  create: ProfessionalCreateWithoutUrgencyAvailabilitiesInput;
  where: ProfessionalWhereUniqueInput;
};

export type ProfessionalCreateOrConnectWithoutWorkersInput = {
  create: ProfessionalCreateWithoutWorkersInput;
  where: ProfessionalWhereUniqueInput;
};

export type ProfessionalCreateWithoutAddressInput = {
  acceptedAnimals?: InputMaybe<Array<AnimalTypeEnum>>;
  acceptsNewClients?: InputMaybe<Scalars['Boolean']['input']>;
  acceptsOnlineAppointment?: InputMaybe<Scalars['Boolean']['input']>;
  adminNotes?: InputMaybe<AdminNoteCreateNestedManyWithoutProfessionalInput>;
  allowsAnyWorkerOption?: InputMaybe<Scalars['Boolean']['input']>;
  assistantsCount?: InputMaybe<Scalars['Int']['input']>;
  availabilities?: InputMaybe<ProAvailabilityCreateNestedManyWithoutProInput>;
  bookingGroupingMaxSlotDistance?: InputMaybe<Scalars['Int']['input']>;
  centerType?: InputMaybe<CenterTypeEnum>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  defaultServiceDurationMinute?: InputMaybe<Scalars['Int']['input']>;
  degrees?: InputMaybe<ProDegreesCreateNestedManyWithoutProInput>;
  educatorType?: InputMaybe<EducatorTypeEnum>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailHistory?: InputMaybe<EmailHistoryCreateNestedManyWithoutProfessionalInput>;
  employeesCount?: InputMaybe<Scalars['Int']['input']>;
  forceBookingGrouping?: InputMaybe<Scalars['Boolean']['input']>;
  googleAccessToken?: InputMaybe<Scalars['String']['input']>;
  googleEmail?: InputMaybe<Scalars['String']['input']>;
  googleIdToken?: InputMaybe<Scalars['String']['input']>;
  googleRefreshToken?: InputMaybe<Scalars['String']['input']>;
  googleTokenExpiryDate?: InputMaybe<Scalars['String']['input']>;
  googleTokenScope?: InputMaybe<Scalars['String']['input']>;
  googleTokenType?: InputMaybe<Scalars['String']['input']>;
  hasShop?: InputMaybe<Scalars['Boolean']['input']>;
  imgs?: InputMaybe<ProImgCreateNestedManyWithoutProInput>;
  isTipawPartner?: InputMaybe<Scalars['Boolean']['input']>;
  language: Scalars['String']['input'];
  mainProFirstName?: InputMaybe<Scalars['String']['input']>;
  mainProLastName?: InputMaybe<Scalars['String']['input']>;
  maxSmsNotification?: InputMaybe<Scalars['Int']['input']>;
  maxWeeksBeforeBooking?: InputMaybe<Scalars['Int']['input']>;
  meta?: InputMaybe<Scalars['String']['input']>;
  minHoursBeforeBooking?: InputMaybe<Scalars['Int']['input']>;
  minHoursBeforeUpdateOrCancelBooking?: InputMaybe<Scalars['Int']['input']>;
  mobilePhone?: InputMaybe<Scalars['String']['input']>;
  namePro?: InputMaybe<Scalars['String']['input']>;
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutProInput>;
  onlineBookingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  orderingIndex?: InputMaybe<Scalars['Int']['input']>;
  parking?: InputMaybe<Scalars['Boolean']['input']>;
  paymentMethods?: InputMaybe<Array<Scalars['String']['input']>>;
  phone?: InputMaybe<Scalars['String']['input']>;
  practicePlaces?: InputMaybe<Array<EducatorPracticePlaceEnum>>;
  privateEmail?: InputMaybe<Scalars['String']['input']>;
  proMongoId?: InputMaybe<Scalars['String']['input']>;
  profileVideo?: InputMaybe<Scalars['String']['input']>;
  profileVideoPos?: InputMaybe<Scalars['Int']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  reviews?: InputMaybe<EducatorReviewCreateNestedManyWithoutProfessionalInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  selfDogWash?: InputMaybe<Scalars['Boolean']['input']>;
  shopOpeningHours?: InputMaybe<ProShopOpeningHourCreateNestedManyWithoutProInput>;
  smsBookingRemindersEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  stats?: InputMaybe<ProStatCreateNestedManyWithoutProInput>;
  translations?: InputMaybe<ProTranslationCreateNestedManyWithoutProInput>;
  type: ProfessionalTypeEnum;
  unclaimedProfile?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  urgencyAvailabilities?: InputMaybe<ProUrgencyAvailabilityCreateNestedManyWithoutProInput>;
  visitAtHome?: InputMaybe<Scalars['Boolean']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  whatsappNumber?: InputMaybe<Scalars['String']['input']>;
  workers?: InputMaybe<WorkerCreateNestedManyWithoutProInput>;
};

export type ProfessionalCreateWithoutAdminNotesInput = {
  acceptedAnimals?: InputMaybe<Array<AnimalTypeEnum>>;
  acceptsNewClients?: InputMaybe<Scalars['Boolean']['input']>;
  acceptsOnlineAppointment?: InputMaybe<Scalars['Boolean']['input']>;
  address?: InputMaybe<AddressCreateNestedOneWithoutProInput>;
  allowsAnyWorkerOption?: InputMaybe<Scalars['Boolean']['input']>;
  assistantsCount?: InputMaybe<Scalars['Int']['input']>;
  availabilities?: InputMaybe<ProAvailabilityCreateNestedManyWithoutProInput>;
  bookingGroupingMaxSlotDistance?: InputMaybe<Scalars['Int']['input']>;
  centerType?: InputMaybe<CenterTypeEnum>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  defaultServiceDurationMinute?: InputMaybe<Scalars['Int']['input']>;
  degrees?: InputMaybe<ProDegreesCreateNestedManyWithoutProInput>;
  educatorType?: InputMaybe<EducatorTypeEnum>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailHistory?: InputMaybe<EmailHistoryCreateNestedManyWithoutProfessionalInput>;
  employeesCount?: InputMaybe<Scalars['Int']['input']>;
  forceBookingGrouping?: InputMaybe<Scalars['Boolean']['input']>;
  googleAccessToken?: InputMaybe<Scalars['String']['input']>;
  googleEmail?: InputMaybe<Scalars['String']['input']>;
  googleIdToken?: InputMaybe<Scalars['String']['input']>;
  googleRefreshToken?: InputMaybe<Scalars['String']['input']>;
  googleTokenExpiryDate?: InputMaybe<Scalars['String']['input']>;
  googleTokenScope?: InputMaybe<Scalars['String']['input']>;
  googleTokenType?: InputMaybe<Scalars['String']['input']>;
  hasShop?: InputMaybe<Scalars['Boolean']['input']>;
  imgs?: InputMaybe<ProImgCreateNestedManyWithoutProInput>;
  isTipawPartner?: InputMaybe<Scalars['Boolean']['input']>;
  language: Scalars['String']['input'];
  mainProFirstName?: InputMaybe<Scalars['String']['input']>;
  mainProLastName?: InputMaybe<Scalars['String']['input']>;
  maxSmsNotification?: InputMaybe<Scalars['Int']['input']>;
  maxWeeksBeforeBooking?: InputMaybe<Scalars['Int']['input']>;
  meta?: InputMaybe<Scalars['String']['input']>;
  minHoursBeforeBooking?: InputMaybe<Scalars['Int']['input']>;
  minHoursBeforeUpdateOrCancelBooking?: InputMaybe<Scalars['Int']['input']>;
  mobilePhone?: InputMaybe<Scalars['String']['input']>;
  namePro?: InputMaybe<Scalars['String']['input']>;
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutProInput>;
  onlineBookingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  orderingIndex?: InputMaybe<Scalars['Int']['input']>;
  parking?: InputMaybe<Scalars['Boolean']['input']>;
  paymentMethods?: InputMaybe<Array<Scalars['String']['input']>>;
  phone?: InputMaybe<Scalars['String']['input']>;
  practicePlaces?: InputMaybe<Array<EducatorPracticePlaceEnum>>;
  privateEmail?: InputMaybe<Scalars['String']['input']>;
  proMongoId?: InputMaybe<Scalars['String']['input']>;
  profileVideo?: InputMaybe<Scalars['String']['input']>;
  profileVideoPos?: InputMaybe<Scalars['Int']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  reviews?: InputMaybe<EducatorReviewCreateNestedManyWithoutProfessionalInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  selfDogWash?: InputMaybe<Scalars['Boolean']['input']>;
  shopOpeningHours?: InputMaybe<ProShopOpeningHourCreateNestedManyWithoutProInput>;
  smsBookingRemindersEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  stats?: InputMaybe<ProStatCreateNestedManyWithoutProInput>;
  translations?: InputMaybe<ProTranslationCreateNestedManyWithoutProInput>;
  type: ProfessionalTypeEnum;
  unclaimedProfile?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  urgencyAvailabilities?: InputMaybe<ProUrgencyAvailabilityCreateNestedManyWithoutProInput>;
  visitAtHome?: InputMaybe<Scalars['Boolean']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  whatsappNumber?: InputMaybe<Scalars['String']['input']>;
  workers?: InputMaybe<WorkerCreateNestedManyWithoutProInput>;
};

export type ProfessionalCreateWithoutAvailabilitiesInput = {
  acceptedAnimals?: InputMaybe<Array<AnimalTypeEnum>>;
  acceptsNewClients?: InputMaybe<Scalars['Boolean']['input']>;
  acceptsOnlineAppointment?: InputMaybe<Scalars['Boolean']['input']>;
  address?: InputMaybe<AddressCreateNestedOneWithoutProInput>;
  adminNotes?: InputMaybe<AdminNoteCreateNestedManyWithoutProfessionalInput>;
  allowsAnyWorkerOption?: InputMaybe<Scalars['Boolean']['input']>;
  assistantsCount?: InputMaybe<Scalars['Int']['input']>;
  bookingGroupingMaxSlotDistance?: InputMaybe<Scalars['Int']['input']>;
  centerType?: InputMaybe<CenterTypeEnum>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  defaultServiceDurationMinute?: InputMaybe<Scalars['Int']['input']>;
  degrees?: InputMaybe<ProDegreesCreateNestedManyWithoutProInput>;
  educatorType?: InputMaybe<EducatorTypeEnum>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailHistory?: InputMaybe<EmailHistoryCreateNestedManyWithoutProfessionalInput>;
  employeesCount?: InputMaybe<Scalars['Int']['input']>;
  forceBookingGrouping?: InputMaybe<Scalars['Boolean']['input']>;
  googleAccessToken?: InputMaybe<Scalars['String']['input']>;
  googleEmail?: InputMaybe<Scalars['String']['input']>;
  googleIdToken?: InputMaybe<Scalars['String']['input']>;
  googleRefreshToken?: InputMaybe<Scalars['String']['input']>;
  googleTokenExpiryDate?: InputMaybe<Scalars['String']['input']>;
  googleTokenScope?: InputMaybe<Scalars['String']['input']>;
  googleTokenType?: InputMaybe<Scalars['String']['input']>;
  hasShop?: InputMaybe<Scalars['Boolean']['input']>;
  imgs?: InputMaybe<ProImgCreateNestedManyWithoutProInput>;
  isTipawPartner?: InputMaybe<Scalars['Boolean']['input']>;
  language: Scalars['String']['input'];
  mainProFirstName?: InputMaybe<Scalars['String']['input']>;
  mainProLastName?: InputMaybe<Scalars['String']['input']>;
  maxSmsNotification?: InputMaybe<Scalars['Int']['input']>;
  maxWeeksBeforeBooking?: InputMaybe<Scalars['Int']['input']>;
  meta?: InputMaybe<Scalars['String']['input']>;
  minHoursBeforeBooking?: InputMaybe<Scalars['Int']['input']>;
  minHoursBeforeUpdateOrCancelBooking?: InputMaybe<Scalars['Int']['input']>;
  mobilePhone?: InputMaybe<Scalars['String']['input']>;
  namePro?: InputMaybe<Scalars['String']['input']>;
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutProInput>;
  onlineBookingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  orderingIndex?: InputMaybe<Scalars['Int']['input']>;
  parking?: InputMaybe<Scalars['Boolean']['input']>;
  paymentMethods?: InputMaybe<Array<Scalars['String']['input']>>;
  phone?: InputMaybe<Scalars['String']['input']>;
  practicePlaces?: InputMaybe<Array<EducatorPracticePlaceEnum>>;
  privateEmail?: InputMaybe<Scalars['String']['input']>;
  proMongoId?: InputMaybe<Scalars['String']['input']>;
  profileVideo?: InputMaybe<Scalars['String']['input']>;
  profileVideoPos?: InputMaybe<Scalars['Int']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  reviews?: InputMaybe<EducatorReviewCreateNestedManyWithoutProfessionalInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  selfDogWash?: InputMaybe<Scalars['Boolean']['input']>;
  shopOpeningHours?: InputMaybe<ProShopOpeningHourCreateNestedManyWithoutProInput>;
  smsBookingRemindersEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  stats?: InputMaybe<ProStatCreateNestedManyWithoutProInput>;
  translations?: InputMaybe<ProTranslationCreateNestedManyWithoutProInput>;
  type: ProfessionalTypeEnum;
  unclaimedProfile?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  urgencyAvailabilities?: InputMaybe<ProUrgencyAvailabilityCreateNestedManyWithoutProInput>;
  visitAtHome?: InputMaybe<Scalars['Boolean']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  whatsappNumber?: InputMaybe<Scalars['String']['input']>;
  workers?: InputMaybe<WorkerCreateNestedManyWithoutProInput>;
};

export type ProfessionalCreateWithoutDegreesInput = {
  acceptedAnimals?: InputMaybe<Array<AnimalTypeEnum>>;
  acceptsNewClients?: InputMaybe<Scalars['Boolean']['input']>;
  acceptsOnlineAppointment?: InputMaybe<Scalars['Boolean']['input']>;
  address?: InputMaybe<AddressCreateNestedOneWithoutProInput>;
  adminNotes?: InputMaybe<AdminNoteCreateNestedManyWithoutProfessionalInput>;
  allowsAnyWorkerOption?: InputMaybe<Scalars['Boolean']['input']>;
  assistantsCount?: InputMaybe<Scalars['Int']['input']>;
  availabilities?: InputMaybe<ProAvailabilityCreateNestedManyWithoutProInput>;
  bookingGroupingMaxSlotDistance?: InputMaybe<Scalars['Int']['input']>;
  centerType?: InputMaybe<CenterTypeEnum>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  defaultServiceDurationMinute?: InputMaybe<Scalars['Int']['input']>;
  educatorType?: InputMaybe<EducatorTypeEnum>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailHistory?: InputMaybe<EmailHistoryCreateNestedManyWithoutProfessionalInput>;
  employeesCount?: InputMaybe<Scalars['Int']['input']>;
  forceBookingGrouping?: InputMaybe<Scalars['Boolean']['input']>;
  googleAccessToken?: InputMaybe<Scalars['String']['input']>;
  googleEmail?: InputMaybe<Scalars['String']['input']>;
  googleIdToken?: InputMaybe<Scalars['String']['input']>;
  googleRefreshToken?: InputMaybe<Scalars['String']['input']>;
  googleTokenExpiryDate?: InputMaybe<Scalars['String']['input']>;
  googleTokenScope?: InputMaybe<Scalars['String']['input']>;
  googleTokenType?: InputMaybe<Scalars['String']['input']>;
  hasShop?: InputMaybe<Scalars['Boolean']['input']>;
  imgs?: InputMaybe<ProImgCreateNestedManyWithoutProInput>;
  isTipawPartner?: InputMaybe<Scalars['Boolean']['input']>;
  language: Scalars['String']['input'];
  mainProFirstName?: InputMaybe<Scalars['String']['input']>;
  mainProLastName?: InputMaybe<Scalars['String']['input']>;
  maxSmsNotification?: InputMaybe<Scalars['Int']['input']>;
  maxWeeksBeforeBooking?: InputMaybe<Scalars['Int']['input']>;
  meta?: InputMaybe<Scalars['String']['input']>;
  minHoursBeforeBooking?: InputMaybe<Scalars['Int']['input']>;
  minHoursBeforeUpdateOrCancelBooking?: InputMaybe<Scalars['Int']['input']>;
  mobilePhone?: InputMaybe<Scalars['String']['input']>;
  namePro?: InputMaybe<Scalars['String']['input']>;
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutProInput>;
  onlineBookingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  orderingIndex?: InputMaybe<Scalars['Int']['input']>;
  parking?: InputMaybe<Scalars['Boolean']['input']>;
  paymentMethods?: InputMaybe<Array<Scalars['String']['input']>>;
  phone?: InputMaybe<Scalars['String']['input']>;
  practicePlaces?: InputMaybe<Array<EducatorPracticePlaceEnum>>;
  privateEmail?: InputMaybe<Scalars['String']['input']>;
  proMongoId?: InputMaybe<Scalars['String']['input']>;
  profileVideo?: InputMaybe<Scalars['String']['input']>;
  profileVideoPos?: InputMaybe<Scalars['Int']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  reviews?: InputMaybe<EducatorReviewCreateNestedManyWithoutProfessionalInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  selfDogWash?: InputMaybe<Scalars['Boolean']['input']>;
  shopOpeningHours?: InputMaybe<ProShopOpeningHourCreateNestedManyWithoutProInput>;
  smsBookingRemindersEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  stats?: InputMaybe<ProStatCreateNestedManyWithoutProInput>;
  translations?: InputMaybe<ProTranslationCreateNestedManyWithoutProInput>;
  type: ProfessionalTypeEnum;
  unclaimedProfile?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  urgencyAvailabilities?: InputMaybe<ProUrgencyAvailabilityCreateNestedManyWithoutProInput>;
  visitAtHome?: InputMaybe<Scalars['Boolean']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  whatsappNumber?: InputMaybe<Scalars['String']['input']>;
  workers?: InputMaybe<WorkerCreateNestedManyWithoutProInput>;
};

export type ProfessionalCreateWithoutEmailHistoryInput = {
  acceptedAnimals?: InputMaybe<Array<AnimalTypeEnum>>;
  acceptsNewClients?: InputMaybe<Scalars['Boolean']['input']>;
  acceptsOnlineAppointment?: InputMaybe<Scalars['Boolean']['input']>;
  address?: InputMaybe<AddressCreateNestedOneWithoutProInput>;
  adminNotes?: InputMaybe<AdminNoteCreateNestedManyWithoutProfessionalInput>;
  allowsAnyWorkerOption?: InputMaybe<Scalars['Boolean']['input']>;
  assistantsCount?: InputMaybe<Scalars['Int']['input']>;
  availabilities?: InputMaybe<ProAvailabilityCreateNestedManyWithoutProInput>;
  bookingGroupingMaxSlotDistance?: InputMaybe<Scalars['Int']['input']>;
  centerType?: InputMaybe<CenterTypeEnum>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  defaultServiceDurationMinute?: InputMaybe<Scalars['Int']['input']>;
  degrees?: InputMaybe<ProDegreesCreateNestedManyWithoutProInput>;
  educatorType?: InputMaybe<EducatorTypeEnum>;
  email?: InputMaybe<Scalars['String']['input']>;
  employeesCount?: InputMaybe<Scalars['Int']['input']>;
  forceBookingGrouping?: InputMaybe<Scalars['Boolean']['input']>;
  googleAccessToken?: InputMaybe<Scalars['String']['input']>;
  googleEmail?: InputMaybe<Scalars['String']['input']>;
  googleIdToken?: InputMaybe<Scalars['String']['input']>;
  googleRefreshToken?: InputMaybe<Scalars['String']['input']>;
  googleTokenExpiryDate?: InputMaybe<Scalars['String']['input']>;
  googleTokenScope?: InputMaybe<Scalars['String']['input']>;
  googleTokenType?: InputMaybe<Scalars['String']['input']>;
  hasShop?: InputMaybe<Scalars['Boolean']['input']>;
  imgs?: InputMaybe<ProImgCreateNestedManyWithoutProInput>;
  isTipawPartner?: InputMaybe<Scalars['Boolean']['input']>;
  language: Scalars['String']['input'];
  mainProFirstName?: InputMaybe<Scalars['String']['input']>;
  mainProLastName?: InputMaybe<Scalars['String']['input']>;
  maxSmsNotification?: InputMaybe<Scalars['Int']['input']>;
  maxWeeksBeforeBooking?: InputMaybe<Scalars['Int']['input']>;
  meta?: InputMaybe<Scalars['String']['input']>;
  minHoursBeforeBooking?: InputMaybe<Scalars['Int']['input']>;
  minHoursBeforeUpdateOrCancelBooking?: InputMaybe<Scalars['Int']['input']>;
  mobilePhone?: InputMaybe<Scalars['String']['input']>;
  namePro?: InputMaybe<Scalars['String']['input']>;
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutProInput>;
  onlineBookingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  orderingIndex?: InputMaybe<Scalars['Int']['input']>;
  parking?: InputMaybe<Scalars['Boolean']['input']>;
  paymentMethods?: InputMaybe<Array<Scalars['String']['input']>>;
  phone?: InputMaybe<Scalars['String']['input']>;
  practicePlaces?: InputMaybe<Array<EducatorPracticePlaceEnum>>;
  privateEmail?: InputMaybe<Scalars['String']['input']>;
  proMongoId?: InputMaybe<Scalars['String']['input']>;
  profileVideo?: InputMaybe<Scalars['String']['input']>;
  profileVideoPos?: InputMaybe<Scalars['Int']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  reviews?: InputMaybe<EducatorReviewCreateNestedManyWithoutProfessionalInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  selfDogWash?: InputMaybe<Scalars['Boolean']['input']>;
  shopOpeningHours?: InputMaybe<ProShopOpeningHourCreateNestedManyWithoutProInput>;
  smsBookingRemindersEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  stats?: InputMaybe<ProStatCreateNestedManyWithoutProInput>;
  translations?: InputMaybe<ProTranslationCreateNestedManyWithoutProInput>;
  type: ProfessionalTypeEnum;
  unclaimedProfile?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  urgencyAvailabilities?: InputMaybe<ProUrgencyAvailabilityCreateNestedManyWithoutProInput>;
  visitAtHome?: InputMaybe<Scalars['Boolean']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  whatsappNumber?: InputMaybe<Scalars['String']['input']>;
  workers?: InputMaybe<WorkerCreateNestedManyWithoutProInput>;
};

export type ProfessionalCreateWithoutImgsInput = {
  acceptedAnimals?: InputMaybe<Array<AnimalTypeEnum>>;
  acceptsNewClients?: InputMaybe<Scalars['Boolean']['input']>;
  acceptsOnlineAppointment?: InputMaybe<Scalars['Boolean']['input']>;
  address?: InputMaybe<AddressCreateNestedOneWithoutProInput>;
  adminNotes?: InputMaybe<AdminNoteCreateNestedManyWithoutProfessionalInput>;
  allowsAnyWorkerOption?: InputMaybe<Scalars['Boolean']['input']>;
  assistantsCount?: InputMaybe<Scalars['Int']['input']>;
  availabilities?: InputMaybe<ProAvailabilityCreateNestedManyWithoutProInput>;
  bookingGroupingMaxSlotDistance?: InputMaybe<Scalars['Int']['input']>;
  centerType?: InputMaybe<CenterTypeEnum>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  defaultServiceDurationMinute?: InputMaybe<Scalars['Int']['input']>;
  degrees?: InputMaybe<ProDegreesCreateNestedManyWithoutProInput>;
  educatorType?: InputMaybe<EducatorTypeEnum>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailHistory?: InputMaybe<EmailHistoryCreateNestedManyWithoutProfessionalInput>;
  employeesCount?: InputMaybe<Scalars['Int']['input']>;
  forceBookingGrouping?: InputMaybe<Scalars['Boolean']['input']>;
  googleAccessToken?: InputMaybe<Scalars['String']['input']>;
  googleEmail?: InputMaybe<Scalars['String']['input']>;
  googleIdToken?: InputMaybe<Scalars['String']['input']>;
  googleRefreshToken?: InputMaybe<Scalars['String']['input']>;
  googleTokenExpiryDate?: InputMaybe<Scalars['String']['input']>;
  googleTokenScope?: InputMaybe<Scalars['String']['input']>;
  googleTokenType?: InputMaybe<Scalars['String']['input']>;
  hasShop?: InputMaybe<Scalars['Boolean']['input']>;
  isTipawPartner?: InputMaybe<Scalars['Boolean']['input']>;
  language: Scalars['String']['input'];
  mainProFirstName?: InputMaybe<Scalars['String']['input']>;
  mainProLastName?: InputMaybe<Scalars['String']['input']>;
  maxSmsNotification?: InputMaybe<Scalars['Int']['input']>;
  maxWeeksBeforeBooking?: InputMaybe<Scalars['Int']['input']>;
  meta?: InputMaybe<Scalars['String']['input']>;
  minHoursBeforeBooking?: InputMaybe<Scalars['Int']['input']>;
  minHoursBeforeUpdateOrCancelBooking?: InputMaybe<Scalars['Int']['input']>;
  mobilePhone?: InputMaybe<Scalars['String']['input']>;
  namePro?: InputMaybe<Scalars['String']['input']>;
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutProInput>;
  onlineBookingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  orderingIndex?: InputMaybe<Scalars['Int']['input']>;
  parking?: InputMaybe<Scalars['Boolean']['input']>;
  paymentMethods?: InputMaybe<Array<Scalars['String']['input']>>;
  phone?: InputMaybe<Scalars['String']['input']>;
  practicePlaces?: InputMaybe<Array<EducatorPracticePlaceEnum>>;
  privateEmail?: InputMaybe<Scalars['String']['input']>;
  proMongoId?: InputMaybe<Scalars['String']['input']>;
  profileVideo?: InputMaybe<Scalars['String']['input']>;
  profileVideoPos?: InputMaybe<Scalars['Int']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  reviews?: InputMaybe<EducatorReviewCreateNestedManyWithoutProfessionalInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  selfDogWash?: InputMaybe<Scalars['Boolean']['input']>;
  shopOpeningHours?: InputMaybe<ProShopOpeningHourCreateNestedManyWithoutProInput>;
  smsBookingRemindersEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  stats?: InputMaybe<ProStatCreateNestedManyWithoutProInput>;
  translations?: InputMaybe<ProTranslationCreateNestedManyWithoutProInput>;
  type: ProfessionalTypeEnum;
  unclaimedProfile?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  urgencyAvailabilities?: InputMaybe<ProUrgencyAvailabilityCreateNestedManyWithoutProInput>;
  visitAtHome?: InputMaybe<Scalars['Boolean']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  whatsappNumber?: InputMaybe<Scalars['String']['input']>;
  workers?: InputMaybe<WorkerCreateNestedManyWithoutProInput>;
};

export type ProfessionalCreateWithoutNotificationsInput = {
  acceptedAnimals?: InputMaybe<Array<AnimalTypeEnum>>;
  acceptsNewClients?: InputMaybe<Scalars['Boolean']['input']>;
  acceptsOnlineAppointment?: InputMaybe<Scalars['Boolean']['input']>;
  address?: InputMaybe<AddressCreateNestedOneWithoutProInput>;
  adminNotes?: InputMaybe<AdminNoteCreateNestedManyWithoutProfessionalInput>;
  allowsAnyWorkerOption?: InputMaybe<Scalars['Boolean']['input']>;
  assistantsCount?: InputMaybe<Scalars['Int']['input']>;
  availabilities?: InputMaybe<ProAvailabilityCreateNestedManyWithoutProInput>;
  bookingGroupingMaxSlotDistance?: InputMaybe<Scalars['Int']['input']>;
  centerType?: InputMaybe<CenterTypeEnum>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  defaultServiceDurationMinute?: InputMaybe<Scalars['Int']['input']>;
  degrees?: InputMaybe<ProDegreesCreateNestedManyWithoutProInput>;
  educatorType?: InputMaybe<EducatorTypeEnum>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailHistory?: InputMaybe<EmailHistoryCreateNestedManyWithoutProfessionalInput>;
  employeesCount?: InputMaybe<Scalars['Int']['input']>;
  forceBookingGrouping?: InputMaybe<Scalars['Boolean']['input']>;
  googleAccessToken?: InputMaybe<Scalars['String']['input']>;
  googleEmail?: InputMaybe<Scalars['String']['input']>;
  googleIdToken?: InputMaybe<Scalars['String']['input']>;
  googleRefreshToken?: InputMaybe<Scalars['String']['input']>;
  googleTokenExpiryDate?: InputMaybe<Scalars['String']['input']>;
  googleTokenScope?: InputMaybe<Scalars['String']['input']>;
  googleTokenType?: InputMaybe<Scalars['String']['input']>;
  hasShop?: InputMaybe<Scalars['Boolean']['input']>;
  imgs?: InputMaybe<ProImgCreateNestedManyWithoutProInput>;
  isTipawPartner?: InputMaybe<Scalars['Boolean']['input']>;
  language: Scalars['String']['input'];
  mainProFirstName?: InputMaybe<Scalars['String']['input']>;
  mainProLastName?: InputMaybe<Scalars['String']['input']>;
  maxSmsNotification?: InputMaybe<Scalars['Int']['input']>;
  maxWeeksBeforeBooking?: InputMaybe<Scalars['Int']['input']>;
  meta?: InputMaybe<Scalars['String']['input']>;
  minHoursBeforeBooking?: InputMaybe<Scalars['Int']['input']>;
  minHoursBeforeUpdateOrCancelBooking?: InputMaybe<Scalars['Int']['input']>;
  mobilePhone?: InputMaybe<Scalars['String']['input']>;
  namePro?: InputMaybe<Scalars['String']['input']>;
  onlineBookingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  orderingIndex?: InputMaybe<Scalars['Int']['input']>;
  parking?: InputMaybe<Scalars['Boolean']['input']>;
  paymentMethods?: InputMaybe<Array<Scalars['String']['input']>>;
  phone?: InputMaybe<Scalars['String']['input']>;
  practicePlaces?: InputMaybe<Array<EducatorPracticePlaceEnum>>;
  privateEmail?: InputMaybe<Scalars['String']['input']>;
  proMongoId?: InputMaybe<Scalars['String']['input']>;
  profileVideo?: InputMaybe<Scalars['String']['input']>;
  profileVideoPos?: InputMaybe<Scalars['Int']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  reviews?: InputMaybe<EducatorReviewCreateNestedManyWithoutProfessionalInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  selfDogWash?: InputMaybe<Scalars['Boolean']['input']>;
  shopOpeningHours?: InputMaybe<ProShopOpeningHourCreateNestedManyWithoutProInput>;
  smsBookingRemindersEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  stats?: InputMaybe<ProStatCreateNestedManyWithoutProInput>;
  translations?: InputMaybe<ProTranslationCreateNestedManyWithoutProInput>;
  type: ProfessionalTypeEnum;
  unclaimedProfile?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  urgencyAvailabilities?: InputMaybe<ProUrgencyAvailabilityCreateNestedManyWithoutProInput>;
  visitAtHome?: InputMaybe<Scalars['Boolean']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  whatsappNumber?: InputMaybe<Scalars['String']['input']>;
  workers?: InputMaybe<WorkerCreateNestedManyWithoutProInput>;
};

export type ProfessionalCreateWithoutReviewsInput = {
  acceptedAnimals?: InputMaybe<Array<AnimalTypeEnum>>;
  acceptsNewClients?: InputMaybe<Scalars['Boolean']['input']>;
  acceptsOnlineAppointment?: InputMaybe<Scalars['Boolean']['input']>;
  address?: InputMaybe<AddressCreateNestedOneWithoutProInput>;
  adminNotes?: InputMaybe<AdminNoteCreateNestedManyWithoutProfessionalInput>;
  allowsAnyWorkerOption?: InputMaybe<Scalars['Boolean']['input']>;
  assistantsCount?: InputMaybe<Scalars['Int']['input']>;
  availabilities?: InputMaybe<ProAvailabilityCreateNestedManyWithoutProInput>;
  bookingGroupingMaxSlotDistance?: InputMaybe<Scalars['Int']['input']>;
  centerType?: InputMaybe<CenterTypeEnum>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  defaultServiceDurationMinute?: InputMaybe<Scalars['Int']['input']>;
  degrees?: InputMaybe<ProDegreesCreateNestedManyWithoutProInput>;
  educatorType?: InputMaybe<EducatorTypeEnum>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailHistory?: InputMaybe<EmailHistoryCreateNestedManyWithoutProfessionalInput>;
  employeesCount?: InputMaybe<Scalars['Int']['input']>;
  forceBookingGrouping?: InputMaybe<Scalars['Boolean']['input']>;
  googleAccessToken?: InputMaybe<Scalars['String']['input']>;
  googleEmail?: InputMaybe<Scalars['String']['input']>;
  googleIdToken?: InputMaybe<Scalars['String']['input']>;
  googleRefreshToken?: InputMaybe<Scalars['String']['input']>;
  googleTokenExpiryDate?: InputMaybe<Scalars['String']['input']>;
  googleTokenScope?: InputMaybe<Scalars['String']['input']>;
  googleTokenType?: InputMaybe<Scalars['String']['input']>;
  hasShop?: InputMaybe<Scalars['Boolean']['input']>;
  imgs?: InputMaybe<ProImgCreateNestedManyWithoutProInput>;
  isTipawPartner?: InputMaybe<Scalars['Boolean']['input']>;
  language: Scalars['String']['input'];
  mainProFirstName?: InputMaybe<Scalars['String']['input']>;
  mainProLastName?: InputMaybe<Scalars['String']['input']>;
  maxSmsNotification?: InputMaybe<Scalars['Int']['input']>;
  maxWeeksBeforeBooking?: InputMaybe<Scalars['Int']['input']>;
  meta?: InputMaybe<Scalars['String']['input']>;
  minHoursBeforeBooking?: InputMaybe<Scalars['Int']['input']>;
  minHoursBeforeUpdateOrCancelBooking?: InputMaybe<Scalars['Int']['input']>;
  mobilePhone?: InputMaybe<Scalars['String']['input']>;
  namePro?: InputMaybe<Scalars['String']['input']>;
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutProInput>;
  onlineBookingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  orderingIndex?: InputMaybe<Scalars['Int']['input']>;
  parking?: InputMaybe<Scalars['Boolean']['input']>;
  paymentMethods?: InputMaybe<Array<Scalars['String']['input']>>;
  phone?: InputMaybe<Scalars['String']['input']>;
  practicePlaces?: InputMaybe<Array<EducatorPracticePlaceEnum>>;
  privateEmail?: InputMaybe<Scalars['String']['input']>;
  proMongoId?: InputMaybe<Scalars['String']['input']>;
  profileVideo?: InputMaybe<Scalars['String']['input']>;
  profileVideoPos?: InputMaybe<Scalars['Int']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  selfDogWash?: InputMaybe<Scalars['Boolean']['input']>;
  shopOpeningHours?: InputMaybe<ProShopOpeningHourCreateNestedManyWithoutProInput>;
  smsBookingRemindersEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  stats?: InputMaybe<ProStatCreateNestedManyWithoutProInput>;
  translations?: InputMaybe<ProTranslationCreateNestedManyWithoutProInput>;
  type: ProfessionalTypeEnum;
  unclaimedProfile?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  urgencyAvailabilities?: InputMaybe<ProUrgencyAvailabilityCreateNestedManyWithoutProInput>;
  visitAtHome?: InputMaybe<Scalars['Boolean']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  whatsappNumber?: InputMaybe<Scalars['String']['input']>;
  workers?: InputMaybe<WorkerCreateNestedManyWithoutProInput>;
};

export type ProfessionalCreateWithoutShopOpeningHoursInput = {
  acceptedAnimals?: InputMaybe<Array<AnimalTypeEnum>>;
  acceptsNewClients?: InputMaybe<Scalars['Boolean']['input']>;
  acceptsOnlineAppointment?: InputMaybe<Scalars['Boolean']['input']>;
  address?: InputMaybe<AddressCreateNestedOneWithoutProInput>;
  adminNotes?: InputMaybe<AdminNoteCreateNestedManyWithoutProfessionalInput>;
  allowsAnyWorkerOption?: InputMaybe<Scalars['Boolean']['input']>;
  assistantsCount?: InputMaybe<Scalars['Int']['input']>;
  availabilities?: InputMaybe<ProAvailabilityCreateNestedManyWithoutProInput>;
  bookingGroupingMaxSlotDistance?: InputMaybe<Scalars['Int']['input']>;
  centerType?: InputMaybe<CenterTypeEnum>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  defaultServiceDurationMinute?: InputMaybe<Scalars['Int']['input']>;
  degrees?: InputMaybe<ProDegreesCreateNestedManyWithoutProInput>;
  educatorType?: InputMaybe<EducatorTypeEnum>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailHistory?: InputMaybe<EmailHistoryCreateNestedManyWithoutProfessionalInput>;
  employeesCount?: InputMaybe<Scalars['Int']['input']>;
  forceBookingGrouping?: InputMaybe<Scalars['Boolean']['input']>;
  googleAccessToken?: InputMaybe<Scalars['String']['input']>;
  googleEmail?: InputMaybe<Scalars['String']['input']>;
  googleIdToken?: InputMaybe<Scalars['String']['input']>;
  googleRefreshToken?: InputMaybe<Scalars['String']['input']>;
  googleTokenExpiryDate?: InputMaybe<Scalars['String']['input']>;
  googleTokenScope?: InputMaybe<Scalars['String']['input']>;
  googleTokenType?: InputMaybe<Scalars['String']['input']>;
  hasShop?: InputMaybe<Scalars['Boolean']['input']>;
  imgs?: InputMaybe<ProImgCreateNestedManyWithoutProInput>;
  isTipawPartner?: InputMaybe<Scalars['Boolean']['input']>;
  language: Scalars['String']['input'];
  mainProFirstName?: InputMaybe<Scalars['String']['input']>;
  mainProLastName?: InputMaybe<Scalars['String']['input']>;
  maxSmsNotification?: InputMaybe<Scalars['Int']['input']>;
  maxWeeksBeforeBooking?: InputMaybe<Scalars['Int']['input']>;
  meta?: InputMaybe<Scalars['String']['input']>;
  minHoursBeforeBooking?: InputMaybe<Scalars['Int']['input']>;
  minHoursBeforeUpdateOrCancelBooking?: InputMaybe<Scalars['Int']['input']>;
  mobilePhone?: InputMaybe<Scalars['String']['input']>;
  namePro?: InputMaybe<Scalars['String']['input']>;
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutProInput>;
  onlineBookingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  orderingIndex?: InputMaybe<Scalars['Int']['input']>;
  parking?: InputMaybe<Scalars['Boolean']['input']>;
  paymentMethods?: InputMaybe<Array<Scalars['String']['input']>>;
  phone?: InputMaybe<Scalars['String']['input']>;
  practicePlaces?: InputMaybe<Array<EducatorPracticePlaceEnum>>;
  privateEmail?: InputMaybe<Scalars['String']['input']>;
  proMongoId?: InputMaybe<Scalars['String']['input']>;
  profileVideo?: InputMaybe<Scalars['String']['input']>;
  profileVideoPos?: InputMaybe<Scalars['Int']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  reviews?: InputMaybe<EducatorReviewCreateNestedManyWithoutProfessionalInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  selfDogWash?: InputMaybe<Scalars['Boolean']['input']>;
  smsBookingRemindersEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  stats?: InputMaybe<ProStatCreateNestedManyWithoutProInput>;
  translations?: InputMaybe<ProTranslationCreateNestedManyWithoutProInput>;
  type: ProfessionalTypeEnum;
  unclaimedProfile?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  urgencyAvailabilities?: InputMaybe<ProUrgencyAvailabilityCreateNestedManyWithoutProInput>;
  visitAtHome?: InputMaybe<Scalars['Boolean']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  whatsappNumber?: InputMaybe<Scalars['String']['input']>;
  workers?: InputMaybe<WorkerCreateNestedManyWithoutProInput>;
};

export type ProfessionalCreateWithoutStatsInput = {
  acceptedAnimals?: InputMaybe<Array<AnimalTypeEnum>>;
  acceptsNewClients?: InputMaybe<Scalars['Boolean']['input']>;
  acceptsOnlineAppointment?: InputMaybe<Scalars['Boolean']['input']>;
  address?: InputMaybe<AddressCreateNestedOneWithoutProInput>;
  adminNotes?: InputMaybe<AdminNoteCreateNestedManyWithoutProfessionalInput>;
  allowsAnyWorkerOption?: InputMaybe<Scalars['Boolean']['input']>;
  assistantsCount?: InputMaybe<Scalars['Int']['input']>;
  availabilities?: InputMaybe<ProAvailabilityCreateNestedManyWithoutProInput>;
  bookingGroupingMaxSlotDistance?: InputMaybe<Scalars['Int']['input']>;
  centerType?: InputMaybe<CenterTypeEnum>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  defaultServiceDurationMinute?: InputMaybe<Scalars['Int']['input']>;
  degrees?: InputMaybe<ProDegreesCreateNestedManyWithoutProInput>;
  educatorType?: InputMaybe<EducatorTypeEnum>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailHistory?: InputMaybe<EmailHistoryCreateNestedManyWithoutProfessionalInput>;
  employeesCount?: InputMaybe<Scalars['Int']['input']>;
  forceBookingGrouping?: InputMaybe<Scalars['Boolean']['input']>;
  googleAccessToken?: InputMaybe<Scalars['String']['input']>;
  googleEmail?: InputMaybe<Scalars['String']['input']>;
  googleIdToken?: InputMaybe<Scalars['String']['input']>;
  googleRefreshToken?: InputMaybe<Scalars['String']['input']>;
  googleTokenExpiryDate?: InputMaybe<Scalars['String']['input']>;
  googleTokenScope?: InputMaybe<Scalars['String']['input']>;
  googleTokenType?: InputMaybe<Scalars['String']['input']>;
  hasShop?: InputMaybe<Scalars['Boolean']['input']>;
  imgs?: InputMaybe<ProImgCreateNestedManyWithoutProInput>;
  isTipawPartner?: InputMaybe<Scalars['Boolean']['input']>;
  language: Scalars['String']['input'];
  mainProFirstName?: InputMaybe<Scalars['String']['input']>;
  mainProLastName?: InputMaybe<Scalars['String']['input']>;
  maxSmsNotification?: InputMaybe<Scalars['Int']['input']>;
  maxWeeksBeforeBooking?: InputMaybe<Scalars['Int']['input']>;
  meta?: InputMaybe<Scalars['String']['input']>;
  minHoursBeforeBooking?: InputMaybe<Scalars['Int']['input']>;
  minHoursBeforeUpdateOrCancelBooking?: InputMaybe<Scalars['Int']['input']>;
  mobilePhone?: InputMaybe<Scalars['String']['input']>;
  namePro?: InputMaybe<Scalars['String']['input']>;
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutProInput>;
  onlineBookingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  orderingIndex?: InputMaybe<Scalars['Int']['input']>;
  parking?: InputMaybe<Scalars['Boolean']['input']>;
  paymentMethods?: InputMaybe<Array<Scalars['String']['input']>>;
  phone?: InputMaybe<Scalars['String']['input']>;
  practicePlaces?: InputMaybe<Array<EducatorPracticePlaceEnum>>;
  privateEmail?: InputMaybe<Scalars['String']['input']>;
  proMongoId?: InputMaybe<Scalars['String']['input']>;
  profileVideo?: InputMaybe<Scalars['String']['input']>;
  profileVideoPos?: InputMaybe<Scalars['Int']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  reviews?: InputMaybe<EducatorReviewCreateNestedManyWithoutProfessionalInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  selfDogWash?: InputMaybe<Scalars['Boolean']['input']>;
  shopOpeningHours?: InputMaybe<ProShopOpeningHourCreateNestedManyWithoutProInput>;
  smsBookingRemindersEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  translations?: InputMaybe<ProTranslationCreateNestedManyWithoutProInput>;
  type: ProfessionalTypeEnum;
  unclaimedProfile?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  urgencyAvailabilities?: InputMaybe<ProUrgencyAvailabilityCreateNestedManyWithoutProInput>;
  visitAtHome?: InputMaybe<Scalars['Boolean']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  whatsappNumber?: InputMaybe<Scalars['String']['input']>;
  workers?: InputMaybe<WorkerCreateNestedManyWithoutProInput>;
};

export type ProfessionalCreateWithoutTranslationsInput = {
  acceptedAnimals?: InputMaybe<Array<AnimalTypeEnum>>;
  acceptsNewClients?: InputMaybe<Scalars['Boolean']['input']>;
  acceptsOnlineAppointment?: InputMaybe<Scalars['Boolean']['input']>;
  address?: InputMaybe<AddressCreateNestedOneWithoutProInput>;
  adminNotes?: InputMaybe<AdminNoteCreateNestedManyWithoutProfessionalInput>;
  allowsAnyWorkerOption?: InputMaybe<Scalars['Boolean']['input']>;
  assistantsCount?: InputMaybe<Scalars['Int']['input']>;
  availabilities?: InputMaybe<ProAvailabilityCreateNestedManyWithoutProInput>;
  bookingGroupingMaxSlotDistance?: InputMaybe<Scalars['Int']['input']>;
  centerType?: InputMaybe<CenterTypeEnum>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  defaultServiceDurationMinute?: InputMaybe<Scalars['Int']['input']>;
  degrees?: InputMaybe<ProDegreesCreateNestedManyWithoutProInput>;
  educatorType?: InputMaybe<EducatorTypeEnum>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailHistory?: InputMaybe<EmailHistoryCreateNestedManyWithoutProfessionalInput>;
  employeesCount?: InputMaybe<Scalars['Int']['input']>;
  forceBookingGrouping?: InputMaybe<Scalars['Boolean']['input']>;
  googleAccessToken?: InputMaybe<Scalars['String']['input']>;
  googleEmail?: InputMaybe<Scalars['String']['input']>;
  googleIdToken?: InputMaybe<Scalars['String']['input']>;
  googleRefreshToken?: InputMaybe<Scalars['String']['input']>;
  googleTokenExpiryDate?: InputMaybe<Scalars['String']['input']>;
  googleTokenScope?: InputMaybe<Scalars['String']['input']>;
  googleTokenType?: InputMaybe<Scalars['String']['input']>;
  hasShop?: InputMaybe<Scalars['Boolean']['input']>;
  imgs?: InputMaybe<ProImgCreateNestedManyWithoutProInput>;
  isTipawPartner?: InputMaybe<Scalars['Boolean']['input']>;
  language: Scalars['String']['input'];
  mainProFirstName?: InputMaybe<Scalars['String']['input']>;
  mainProLastName?: InputMaybe<Scalars['String']['input']>;
  maxSmsNotification?: InputMaybe<Scalars['Int']['input']>;
  maxWeeksBeforeBooking?: InputMaybe<Scalars['Int']['input']>;
  meta?: InputMaybe<Scalars['String']['input']>;
  minHoursBeforeBooking?: InputMaybe<Scalars['Int']['input']>;
  minHoursBeforeUpdateOrCancelBooking?: InputMaybe<Scalars['Int']['input']>;
  mobilePhone?: InputMaybe<Scalars['String']['input']>;
  namePro?: InputMaybe<Scalars['String']['input']>;
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutProInput>;
  onlineBookingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  orderingIndex?: InputMaybe<Scalars['Int']['input']>;
  parking?: InputMaybe<Scalars['Boolean']['input']>;
  paymentMethods?: InputMaybe<Array<Scalars['String']['input']>>;
  phone?: InputMaybe<Scalars['String']['input']>;
  practicePlaces?: InputMaybe<Array<EducatorPracticePlaceEnum>>;
  privateEmail?: InputMaybe<Scalars['String']['input']>;
  proMongoId?: InputMaybe<Scalars['String']['input']>;
  profileVideo?: InputMaybe<Scalars['String']['input']>;
  profileVideoPos?: InputMaybe<Scalars['Int']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  reviews?: InputMaybe<EducatorReviewCreateNestedManyWithoutProfessionalInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  selfDogWash?: InputMaybe<Scalars['Boolean']['input']>;
  shopOpeningHours?: InputMaybe<ProShopOpeningHourCreateNestedManyWithoutProInput>;
  smsBookingRemindersEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  stats?: InputMaybe<ProStatCreateNestedManyWithoutProInput>;
  type: ProfessionalTypeEnum;
  unclaimedProfile?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  urgencyAvailabilities?: InputMaybe<ProUrgencyAvailabilityCreateNestedManyWithoutProInput>;
  visitAtHome?: InputMaybe<Scalars['Boolean']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  whatsappNumber?: InputMaybe<Scalars['String']['input']>;
  workers?: InputMaybe<WorkerCreateNestedManyWithoutProInput>;
};

export type ProfessionalCreateWithoutUrgencyAvailabilitiesInput = {
  acceptedAnimals?: InputMaybe<Array<AnimalTypeEnum>>;
  acceptsNewClients?: InputMaybe<Scalars['Boolean']['input']>;
  acceptsOnlineAppointment?: InputMaybe<Scalars['Boolean']['input']>;
  address?: InputMaybe<AddressCreateNestedOneWithoutProInput>;
  adminNotes?: InputMaybe<AdminNoteCreateNestedManyWithoutProfessionalInput>;
  allowsAnyWorkerOption?: InputMaybe<Scalars['Boolean']['input']>;
  assistantsCount?: InputMaybe<Scalars['Int']['input']>;
  availabilities?: InputMaybe<ProAvailabilityCreateNestedManyWithoutProInput>;
  bookingGroupingMaxSlotDistance?: InputMaybe<Scalars['Int']['input']>;
  centerType?: InputMaybe<CenterTypeEnum>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  defaultServiceDurationMinute?: InputMaybe<Scalars['Int']['input']>;
  degrees?: InputMaybe<ProDegreesCreateNestedManyWithoutProInput>;
  educatorType?: InputMaybe<EducatorTypeEnum>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailHistory?: InputMaybe<EmailHistoryCreateNestedManyWithoutProfessionalInput>;
  employeesCount?: InputMaybe<Scalars['Int']['input']>;
  forceBookingGrouping?: InputMaybe<Scalars['Boolean']['input']>;
  googleAccessToken?: InputMaybe<Scalars['String']['input']>;
  googleEmail?: InputMaybe<Scalars['String']['input']>;
  googleIdToken?: InputMaybe<Scalars['String']['input']>;
  googleRefreshToken?: InputMaybe<Scalars['String']['input']>;
  googleTokenExpiryDate?: InputMaybe<Scalars['String']['input']>;
  googleTokenScope?: InputMaybe<Scalars['String']['input']>;
  googleTokenType?: InputMaybe<Scalars['String']['input']>;
  hasShop?: InputMaybe<Scalars['Boolean']['input']>;
  imgs?: InputMaybe<ProImgCreateNestedManyWithoutProInput>;
  isTipawPartner?: InputMaybe<Scalars['Boolean']['input']>;
  language: Scalars['String']['input'];
  mainProFirstName?: InputMaybe<Scalars['String']['input']>;
  mainProLastName?: InputMaybe<Scalars['String']['input']>;
  maxSmsNotification?: InputMaybe<Scalars['Int']['input']>;
  maxWeeksBeforeBooking?: InputMaybe<Scalars['Int']['input']>;
  meta?: InputMaybe<Scalars['String']['input']>;
  minHoursBeforeBooking?: InputMaybe<Scalars['Int']['input']>;
  minHoursBeforeUpdateOrCancelBooking?: InputMaybe<Scalars['Int']['input']>;
  mobilePhone?: InputMaybe<Scalars['String']['input']>;
  namePro?: InputMaybe<Scalars['String']['input']>;
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutProInput>;
  onlineBookingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  orderingIndex?: InputMaybe<Scalars['Int']['input']>;
  parking?: InputMaybe<Scalars['Boolean']['input']>;
  paymentMethods?: InputMaybe<Array<Scalars['String']['input']>>;
  phone?: InputMaybe<Scalars['String']['input']>;
  practicePlaces?: InputMaybe<Array<EducatorPracticePlaceEnum>>;
  privateEmail?: InputMaybe<Scalars['String']['input']>;
  proMongoId?: InputMaybe<Scalars['String']['input']>;
  profileVideo?: InputMaybe<Scalars['String']['input']>;
  profileVideoPos?: InputMaybe<Scalars['Int']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  reviews?: InputMaybe<EducatorReviewCreateNestedManyWithoutProfessionalInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  selfDogWash?: InputMaybe<Scalars['Boolean']['input']>;
  shopOpeningHours?: InputMaybe<ProShopOpeningHourCreateNestedManyWithoutProInput>;
  smsBookingRemindersEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  stats?: InputMaybe<ProStatCreateNestedManyWithoutProInput>;
  translations?: InputMaybe<ProTranslationCreateNestedManyWithoutProInput>;
  type: ProfessionalTypeEnum;
  unclaimedProfile?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  visitAtHome?: InputMaybe<Scalars['Boolean']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  whatsappNumber?: InputMaybe<Scalars['String']['input']>;
  workers?: InputMaybe<WorkerCreateNestedManyWithoutProInput>;
};

export type ProfessionalCreateWithoutWorkersInput = {
  acceptedAnimals?: InputMaybe<Array<AnimalTypeEnum>>;
  acceptsNewClients?: InputMaybe<Scalars['Boolean']['input']>;
  acceptsOnlineAppointment?: InputMaybe<Scalars['Boolean']['input']>;
  address?: InputMaybe<AddressCreateNestedOneWithoutProInput>;
  adminNotes?: InputMaybe<AdminNoteCreateNestedManyWithoutProfessionalInput>;
  allowsAnyWorkerOption?: InputMaybe<Scalars['Boolean']['input']>;
  assistantsCount?: InputMaybe<Scalars['Int']['input']>;
  availabilities?: InputMaybe<ProAvailabilityCreateNestedManyWithoutProInput>;
  bookingGroupingMaxSlotDistance?: InputMaybe<Scalars['Int']['input']>;
  centerType?: InputMaybe<CenterTypeEnum>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  defaultServiceDurationMinute?: InputMaybe<Scalars['Int']['input']>;
  degrees?: InputMaybe<ProDegreesCreateNestedManyWithoutProInput>;
  educatorType?: InputMaybe<EducatorTypeEnum>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailHistory?: InputMaybe<EmailHistoryCreateNestedManyWithoutProfessionalInput>;
  employeesCount?: InputMaybe<Scalars['Int']['input']>;
  forceBookingGrouping?: InputMaybe<Scalars['Boolean']['input']>;
  googleAccessToken?: InputMaybe<Scalars['String']['input']>;
  googleEmail?: InputMaybe<Scalars['String']['input']>;
  googleIdToken?: InputMaybe<Scalars['String']['input']>;
  googleRefreshToken?: InputMaybe<Scalars['String']['input']>;
  googleTokenExpiryDate?: InputMaybe<Scalars['String']['input']>;
  googleTokenScope?: InputMaybe<Scalars['String']['input']>;
  googleTokenType?: InputMaybe<Scalars['String']['input']>;
  hasShop?: InputMaybe<Scalars['Boolean']['input']>;
  imgs?: InputMaybe<ProImgCreateNestedManyWithoutProInput>;
  isTipawPartner?: InputMaybe<Scalars['Boolean']['input']>;
  language: Scalars['String']['input'];
  mainProFirstName?: InputMaybe<Scalars['String']['input']>;
  mainProLastName?: InputMaybe<Scalars['String']['input']>;
  maxSmsNotification?: InputMaybe<Scalars['Int']['input']>;
  maxWeeksBeforeBooking?: InputMaybe<Scalars['Int']['input']>;
  meta?: InputMaybe<Scalars['String']['input']>;
  minHoursBeforeBooking?: InputMaybe<Scalars['Int']['input']>;
  minHoursBeforeUpdateOrCancelBooking?: InputMaybe<Scalars['Int']['input']>;
  mobilePhone?: InputMaybe<Scalars['String']['input']>;
  namePro?: InputMaybe<Scalars['String']['input']>;
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutProInput>;
  onlineBookingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  orderingIndex?: InputMaybe<Scalars['Int']['input']>;
  parking?: InputMaybe<Scalars['Boolean']['input']>;
  paymentMethods?: InputMaybe<Array<Scalars['String']['input']>>;
  phone?: InputMaybe<Scalars['String']['input']>;
  practicePlaces?: InputMaybe<Array<EducatorPracticePlaceEnum>>;
  privateEmail?: InputMaybe<Scalars['String']['input']>;
  proMongoId?: InputMaybe<Scalars['String']['input']>;
  profileVideo?: InputMaybe<Scalars['String']['input']>;
  profileVideoPos?: InputMaybe<Scalars['Int']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  reviews?: InputMaybe<EducatorReviewCreateNestedManyWithoutProfessionalInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  selfDogWash?: InputMaybe<Scalars['Boolean']['input']>;
  shopOpeningHours?: InputMaybe<ProShopOpeningHourCreateNestedManyWithoutProInput>;
  smsBookingRemindersEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  stats?: InputMaybe<ProStatCreateNestedManyWithoutProInput>;
  translations?: InputMaybe<ProTranslationCreateNestedManyWithoutProInput>;
  type: ProfessionalTypeEnum;
  unclaimedProfile?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  urgencyAvailabilities?: InputMaybe<ProUrgencyAvailabilityCreateNestedManyWithoutProInput>;
  visitAtHome?: InputMaybe<Scalars['Boolean']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  whatsappNumber?: InputMaybe<Scalars['String']['input']>;
};

export type ProfessionalCreateacceptedAnimalsInput = {
  set: Array<AnimalTypeEnum>;
};

export type ProfessionalCreatepaymentMethodsInput = {
  set: Array<Scalars['String']['input']>;
};

export type ProfessionalCreatepracticePlacesInput = {
  set: Array<EducatorPracticePlaceEnum>;
};

export type ProfessionalCreatespokenLanguagesInput = {
  set: Array<Scalars['String']['input']>;
};

export type ProfessionalLocations = {
  __typename?: 'ProfessionalLocations';
  city?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
};

export type ProfessionalMaxAggregateOutputType = {
  __typename?: 'ProfessionalMaxAggregateOutputType';
  acceptsNewClients?: Maybe<Scalars['Boolean']['output']>;
  acceptsOnlineAppointment?: Maybe<Scalars['Boolean']['output']>;
  addressId?: Maybe<Scalars['Int']['output']>;
  allowsAnyWorkerOption?: Maybe<Scalars['Boolean']['output']>;
  assistantsCount?: Maybe<Scalars['Int']['output']>;
  bookingGroupingMaxSlotDistance?: Maybe<Scalars['Int']['output']>;
  centerType?: Maybe<CenterTypeEnum>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  defaultServiceDurationMinute?: Maybe<Scalars['Int']['output']>;
  educatorType?: Maybe<EducatorTypeEnum>;
  email?: Maybe<Scalars['String']['output']>;
  employeesCount?: Maybe<Scalars['Int']['output']>;
  forceBookingGrouping?: Maybe<Scalars['Boolean']['output']>;
  googleAccessToken?: Maybe<Scalars['String']['output']>;
  googleEmail?: Maybe<Scalars['String']['output']>;
  googleIdToken?: Maybe<Scalars['String']['output']>;
  googleRefreshToken?: Maybe<Scalars['String']['output']>;
  googleTokenExpiryDate?: Maybe<Scalars['String']['output']>;
  googleTokenScope?: Maybe<Scalars['String']['output']>;
  googleTokenType?: Maybe<Scalars['String']['output']>;
  hasShop?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isTipawPartner?: Maybe<Scalars['Boolean']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  mainProFirstName?: Maybe<Scalars['String']['output']>;
  mainProLastName?: Maybe<Scalars['String']['output']>;
  maxSmsNotification?: Maybe<Scalars['Int']['output']>;
  maxWeeksBeforeBooking?: Maybe<Scalars['Int']['output']>;
  meta?: Maybe<Scalars['String']['output']>;
  minHoursBeforeBooking?: Maybe<Scalars['Int']['output']>;
  minHoursBeforeUpdateOrCancelBooking?: Maybe<Scalars['Int']['output']>;
  mobilePhone?: Maybe<Scalars['String']['output']>;
  namePro?: Maybe<Scalars['String']['output']>;
  onlineBookingEnabled?: Maybe<Scalars['Boolean']['output']>;
  orderingIndex?: Maybe<Scalars['Int']['output']>;
  parking?: Maybe<Scalars['Boolean']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  privateEmail?: Maybe<Scalars['String']['output']>;
  proMongoId?: Maybe<Scalars['String']['output']>;
  profileVideo?: Maybe<Scalars['String']['output']>;
  profileVideoPos?: Maybe<Scalars['Int']['output']>;
  published?: Maybe<Scalars['Boolean']['output']>;
  searchString?: Maybe<Scalars['String']['output']>;
  selfDogWash?: Maybe<Scalars['Boolean']['output']>;
  smsBookingRemindersEnabled?: Maybe<Scalars['Boolean']['output']>;
  type?: Maybe<ProfessionalTypeEnum>;
  unclaimedProfile?: Maybe<Scalars['Boolean']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  visitAtHome?: Maybe<Scalars['Boolean']['output']>;
  website?: Maybe<Scalars['String']['output']>;
  whatsappNumber?: Maybe<Scalars['String']['output']>;
};

export type ProfessionalMaxOrderByAggregateInput = {
  acceptsNewClients?: InputMaybe<SortOrder>;
  acceptsOnlineAppointment?: InputMaybe<SortOrder>;
  addressId?: InputMaybe<SortOrder>;
  allowsAnyWorkerOption?: InputMaybe<SortOrder>;
  assistantsCount?: InputMaybe<SortOrder>;
  bookingGroupingMaxSlotDistance?: InputMaybe<SortOrder>;
  centerType?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  defaultServiceDurationMinute?: InputMaybe<SortOrder>;
  educatorType?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  employeesCount?: InputMaybe<SortOrder>;
  forceBookingGrouping?: InputMaybe<SortOrder>;
  googleAccessToken?: InputMaybe<SortOrder>;
  googleEmail?: InputMaybe<SortOrder>;
  googleIdToken?: InputMaybe<SortOrder>;
  googleRefreshToken?: InputMaybe<SortOrder>;
  googleTokenExpiryDate?: InputMaybe<SortOrder>;
  googleTokenScope?: InputMaybe<SortOrder>;
  googleTokenType?: InputMaybe<SortOrder>;
  hasShop?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isTipawPartner?: InputMaybe<SortOrder>;
  language?: InputMaybe<SortOrder>;
  mainProFirstName?: InputMaybe<SortOrder>;
  mainProLastName?: InputMaybe<SortOrder>;
  maxSmsNotification?: InputMaybe<SortOrder>;
  maxWeeksBeforeBooking?: InputMaybe<SortOrder>;
  meta?: InputMaybe<SortOrder>;
  minHoursBeforeBooking?: InputMaybe<SortOrder>;
  minHoursBeforeUpdateOrCancelBooking?: InputMaybe<SortOrder>;
  mobilePhone?: InputMaybe<SortOrder>;
  namePro?: InputMaybe<SortOrder>;
  onlineBookingEnabled?: InputMaybe<SortOrder>;
  orderingIndex?: InputMaybe<SortOrder>;
  parking?: InputMaybe<SortOrder>;
  phone?: InputMaybe<SortOrder>;
  privateEmail?: InputMaybe<SortOrder>;
  proMongoId?: InputMaybe<SortOrder>;
  profileVideo?: InputMaybe<SortOrder>;
  profileVideoPos?: InputMaybe<SortOrder>;
  published?: InputMaybe<SortOrder>;
  searchString?: InputMaybe<SortOrder>;
  selfDogWash?: InputMaybe<SortOrder>;
  smsBookingRemindersEnabled?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  unclaimedProfile?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  visitAtHome?: InputMaybe<SortOrder>;
  website?: InputMaybe<SortOrder>;
  whatsappNumber?: InputMaybe<SortOrder>;
};

export type ProfessionalMinAggregateOutputType = {
  __typename?: 'ProfessionalMinAggregateOutputType';
  acceptsNewClients?: Maybe<Scalars['Boolean']['output']>;
  acceptsOnlineAppointment?: Maybe<Scalars['Boolean']['output']>;
  addressId?: Maybe<Scalars['Int']['output']>;
  allowsAnyWorkerOption?: Maybe<Scalars['Boolean']['output']>;
  assistantsCount?: Maybe<Scalars['Int']['output']>;
  bookingGroupingMaxSlotDistance?: Maybe<Scalars['Int']['output']>;
  centerType?: Maybe<CenterTypeEnum>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  defaultServiceDurationMinute?: Maybe<Scalars['Int']['output']>;
  educatorType?: Maybe<EducatorTypeEnum>;
  email?: Maybe<Scalars['String']['output']>;
  employeesCount?: Maybe<Scalars['Int']['output']>;
  forceBookingGrouping?: Maybe<Scalars['Boolean']['output']>;
  googleAccessToken?: Maybe<Scalars['String']['output']>;
  googleEmail?: Maybe<Scalars['String']['output']>;
  googleIdToken?: Maybe<Scalars['String']['output']>;
  googleRefreshToken?: Maybe<Scalars['String']['output']>;
  googleTokenExpiryDate?: Maybe<Scalars['String']['output']>;
  googleTokenScope?: Maybe<Scalars['String']['output']>;
  googleTokenType?: Maybe<Scalars['String']['output']>;
  hasShop?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isTipawPartner?: Maybe<Scalars['Boolean']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  mainProFirstName?: Maybe<Scalars['String']['output']>;
  mainProLastName?: Maybe<Scalars['String']['output']>;
  maxSmsNotification?: Maybe<Scalars['Int']['output']>;
  maxWeeksBeforeBooking?: Maybe<Scalars['Int']['output']>;
  meta?: Maybe<Scalars['String']['output']>;
  minHoursBeforeBooking?: Maybe<Scalars['Int']['output']>;
  minHoursBeforeUpdateOrCancelBooking?: Maybe<Scalars['Int']['output']>;
  mobilePhone?: Maybe<Scalars['String']['output']>;
  namePro?: Maybe<Scalars['String']['output']>;
  onlineBookingEnabled?: Maybe<Scalars['Boolean']['output']>;
  orderingIndex?: Maybe<Scalars['Int']['output']>;
  parking?: Maybe<Scalars['Boolean']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  privateEmail?: Maybe<Scalars['String']['output']>;
  proMongoId?: Maybe<Scalars['String']['output']>;
  profileVideo?: Maybe<Scalars['String']['output']>;
  profileVideoPos?: Maybe<Scalars['Int']['output']>;
  published?: Maybe<Scalars['Boolean']['output']>;
  searchString?: Maybe<Scalars['String']['output']>;
  selfDogWash?: Maybe<Scalars['Boolean']['output']>;
  smsBookingRemindersEnabled?: Maybe<Scalars['Boolean']['output']>;
  type?: Maybe<ProfessionalTypeEnum>;
  unclaimedProfile?: Maybe<Scalars['Boolean']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  visitAtHome?: Maybe<Scalars['Boolean']['output']>;
  website?: Maybe<Scalars['String']['output']>;
  whatsappNumber?: Maybe<Scalars['String']['output']>;
};

export type ProfessionalMinOrderByAggregateInput = {
  acceptsNewClients?: InputMaybe<SortOrder>;
  acceptsOnlineAppointment?: InputMaybe<SortOrder>;
  addressId?: InputMaybe<SortOrder>;
  allowsAnyWorkerOption?: InputMaybe<SortOrder>;
  assistantsCount?: InputMaybe<SortOrder>;
  bookingGroupingMaxSlotDistance?: InputMaybe<SortOrder>;
  centerType?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  defaultServiceDurationMinute?: InputMaybe<SortOrder>;
  educatorType?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  employeesCount?: InputMaybe<SortOrder>;
  forceBookingGrouping?: InputMaybe<SortOrder>;
  googleAccessToken?: InputMaybe<SortOrder>;
  googleEmail?: InputMaybe<SortOrder>;
  googleIdToken?: InputMaybe<SortOrder>;
  googleRefreshToken?: InputMaybe<SortOrder>;
  googleTokenExpiryDate?: InputMaybe<SortOrder>;
  googleTokenScope?: InputMaybe<SortOrder>;
  googleTokenType?: InputMaybe<SortOrder>;
  hasShop?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isTipawPartner?: InputMaybe<SortOrder>;
  language?: InputMaybe<SortOrder>;
  mainProFirstName?: InputMaybe<SortOrder>;
  mainProLastName?: InputMaybe<SortOrder>;
  maxSmsNotification?: InputMaybe<SortOrder>;
  maxWeeksBeforeBooking?: InputMaybe<SortOrder>;
  meta?: InputMaybe<SortOrder>;
  minHoursBeforeBooking?: InputMaybe<SortOrder>;
  minHoursBeforeUpdateOrCancelBooking?: InputMaybe<SortOrder>;
  mobilePhone?: InputMaybe<SortOrder>;
  namePro?: InputMaybe<SortOrder>;
  onlineBookingEnabled?: InputMaybe<SortOrder>;
  orderingIndex?: InputMaybe<SortOrder>;
  parking?: InputMaybe<SortOrder>;
  phone?: InputMaybe<SortOrder>;
  privateEmail?: InputMaybe<SortOrder>;
  proMongoId?: InputMaybe<SortOrder>;
  profileVideo?: InputMaybe<SortOrder>;
  profileVideoPos?: InputMaybe<SortOrder>;
  published?: InputMaybe<SortOrder>;
  searchString?: InputMaybe<SortOrder>;
  selfDogWash?: InputMaybe<SortOrder>;
  smsBookingRemindersEnabled?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  unclaimedProfile?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  visitAtHome?: InputMaybe<SortOrder>;
  website?: InputMaybe<SortOrder>;
  whatsappNumber?: InputMaybe<SortOrder>;
};

export type ProfessionalNullableRelationFilter = {
  is?: InputMaybe<ProfessionalWhereInput>;
  isNot?: InputMaybe<ProfessionalWhereInput>;
};

export enum ProfessionalOrderByRelevanceFieldEnum {
  email = 'email',
  googleAccessToken = 'googleAccessToken',
  googleEmail = 'googleEmail',
  googleIdToken = 'googleIdToken',
  googleRefreshToken = 'googleRefreshToken',
  googleTokenExpiryDate = 'googleTokenExpiryDate',
  googleTokenScope = 'googleTokenScope',
  googleTokenType = 'googleTokenType',
  language = 'language',
  mainProFirstName = 'mainProFirstName',
  mainProLastName = 'mainProLastName',
  meta = 'meta',
  mobilePhone = 'mobilePhone',
  namePro = 'namePro',
  paymentMethods = 'paymentMethods',
  phone = 'phone',
  privateEmail = 'privateEmail',
  proMongoId = 'proMongoId',
  profileVideo = 'profileVideo',
  searchString = 'searchString',
  spokenLanguages = 'spokenLanguages',
  website = 'website',
  whatsappNumber = 'whatsappNumber'
}

export type ProfessionalOrderByRelevanceInput = {
  fields: Array<ProfessionalOrderByRelevanceFieldEnum>;
  search: Scalars['String']['input'];
  sort: SortOrder;
};

export type ProfessionalOrderByWithAggregationInput = {
  _avg?: InputMaybe<ProfessionalAvgOrderByAggregateInput>;
  _count?: InputMaybe<ProfessionalCountOrderByAggregateInput>;
  _max?: InputMaybe<ProfessionalMaxOrderByAggregateInput>;
  _min?: InputMaybe<ProfessionalMinOrderByAggregateInput>;
  _sum?: InputMaybe<ProfessionalSumOrderByAggregateInput>;
  acceptedAnimals?: InputMaybe<SortOrder>;
  acceptsNewClients?: InputMaybe<SortOrder>;
  acceptsOnlineAppointment?: InputMaybe<SortOrder>;
  addressId?: InputMaybe<SortOrderInput>;
  allowsAnyWorkerOption?: InputMaybe<SortOrder>;
  assistantsCount?: InputMaybe<SortOrderInput>;
  bookingGroupingMaxSlotDistance?: InputMaybe<SortOrder>;
  centerType?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  defaultServiceDurationMinute?: InputMaybe<SortOrder>;
  educatorType?: InputMaybe<SortOrderInput>;
  email?: InputMaybe<SortOrderInput>;
  employeesCount?: InputMaybe<SortOrderInput>;
  forceBookingGrouping?: InputMaybe<SortOrder>;
  googleAccessToken?: InputMaybe<SortOrderInput>;
  googleEmail?: InputMaybe<SortOrderInput>;
  googleIdToken?: InputMaybe<SortOrderInput>;
  googleRefreshToken?: InputMaybe<SortOrderInput>;
  googleTokenExpiryDate?: InputMaybe<SortOrderInput>;
  googleTokenScope?: InputMaybe<SortOrderInput>;
  googleTokenType?: InputMaybe<SortOrderInput>;
  hasShop?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  isTipawPartner?: InputMaybe<SortOrder>;
  language?: InputMaybe<SortOrder>;
  mainProFirstName?: InputMaybe<SortOrderInput>;
  mainProLastName?: InputMaybe<SortOrderInput>;
  maxSmsNotification?: InputMaybe<SortOrder>;
  maxWeeksBeforeBooking?: InputMaybe<SortOrder>;
  meta?: InputMaybe<SortOrderInput>;
  minHoursBeforeBooking?: InputMaybe<SortOrder>;
  minHoursBeforeUpdateOrCancelBooking?: InputMaybe<SortOrder>;
  mobilePhone?: InputMaybe<SortOrderInput>;
  namePro?: InputMaybe<SortOrderInput>;
  onlineBookingEnabled?: InputMaybe<SortOrder>;
  orderingIndex?: InputMaybe<SortOrder>;
  parking?: InputMaybe<SortOrderInput>;
  paymentMethods?: InputMaybe<SortOrder>;
  phone?: InputMaybe<SortOrderInput>;
  practicePlaces?: InputMaybe<SortOrder>;
  privateEmail?: InputMaybe<SortOrderInput>;
  proMongoId?: InputMaybe<SortOrderInput>;
  profileVideo?: InputMaybe<SortOrderInput>;
  profileVideoPos?: InputMaybe<SortOrder>;
  published?: InputMaybe<SortOrder>;
  searchString?: InputMaybe<SortOrderInput>;
  selfDogWash?: InputMaybe<SortOrder>;
  smsBookingRemindersEnabled?: InputMaybe<SortOrder>;
  spokenLanguages?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  unclaimedProfile?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  visitAtHome?: InputMaybe<SortOrderInput>;
  website?: InputMaybe<SortOrderInput>;
  whatsappNumber?: InputMaybe<SortOrderInput>;
};

export type ProfessionalOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: InputMaybe<ProfessionalOrderByRelevanceInput>;
  acceptedAnimals?: InputMaybe<SortOrder>;
  acceptsNewClients?: InputMaybe<SortOrder>;
  acceptsOnlineAppointment?: InputMaybe<SortOrder>;
  address?: InputMaybe<AddressOrderByWithRelationAndSearchRelevanceInput>;
  addressId?: InputMaybe<SortOrderInput>;
  adminNotes?: InputMaybe<AdminNoteOrderByRelationAggregateInput>;
  allowsAnyWorkerOption?: InputMaybe<SortOrder>;
  assistantsCount?: InputMaybe<SortOrderInput>;
  availabilities?: InputMaybe<ProAvailabilityOrderByRelationAggregateInput>;
  bookingGroupingMaxSlotDistance?: InputMaybe<SortOrder>;
  centerType?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  defaultServiceDurationMinute?: InputMaybe<SortOrder>;
  degrees?: InputMaybe<ProDegreesOrderByRelationAggregateInput>;
  educatorType?: InputMaybe<SortOrderInput>;
  email?: InputMaybe<SortOrderInput>;
  emailHistory?: InputMaybe<EmailHistoryOrderByRelationAggregateInput>;
  employeesCount?: InputMaybe<SortOrderInput>;
  forceBookingGrouping?: InputMaybe<SortOrder>;
  googleAccessToken?: InputMaybe<SortOrderInput>;
  googleEmail?: InputMaybe<SortOrderInput>;
  googleIdToken?: InputMaybe<SortOrderInput>;
  googleRefreshToken?: InputMaybe<SortOrderInput>;
  googleTokenExpiryDate?: InputMaybe<SortOrderInput>;
  googleTokenScope?: InputMaybe<SortOrderInput>;
  googleTokenType?: InputMaybe<SortOrderInput>;
  hasShop?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  imgs?: InputMaybe<ProImgOrderByRelationAggregateInput>;
  isTipawPartner?: InputMaybe<SortOrder>;
  language?: InputMaybe<SortOrder>;
  mainProFirstName?: InputMaybe<SortOrderInput>;
  mainProLastName?: InputMaybe<SortOrderInput>;
  maxSmsNotification?: InputMaybe<SortOrder>;
  maxWeeksBeforeBooking?: InputMaybe<SortOrder>;
  meta?: InputMaybe<SortOrderInput>;
  minHoursBeforeBooking?: InputMaybe<SortOrder>;
  minHoursBeforeUpdateOrCancelBooking?: InputMaybe<SortOrder>;
  mobilePhone?: InputMaybe<SortOrderInput>;
  namePro?: InputMaybe<SortOrderInput>;
  notifications?: InputMaybe<NotificationOrderByRelationAggregateInput>;
  onlineBookingEnabled?: InputMaybe<SortOrder>;
  orderingIndex?: InputMaybe<SortOrder>;
  parking?: InputMaybe<SortOrderInput>;
  paymentMethods?: InputMaybe<SortOrder>;
  phone?: InputMaybe<SortOrderInput>;
  practicePlaces?: InputMaybe<SortOrder>;
  privateEmail?: InputMaybe<SortOrderInput>;
  proMongoId?: InputMaybe<SortOrderInput>;
  profileVideo?: InputMaybe<SortOrderInput>;
  profileVideoPos?: InputMaybe<SortOrder>;
  published?: InputMaybe<SortOrder>;
  reviews?: InputMaybe<EducatorReviewOrderByRelationAggregateInput>;
  searchString?: InputMaybe<SortOrderInput>;
  selfDogWash?: InputMaybe<SortOrder>;
  shopOpeningHours?: InputMaybe<ProShopOpeningHourOrderByRelationAggregateInput>;
  smsBookingRemindersEnabled?: InputMaybe<SortOrder>;
  spokenLanguages?: InputMaybe<SortOrder>;
  stats?: InputMaybe<ProStatOrderByRelationAggregateInput>;
  translations?: InputMaybe<ProTranslationOrderByRelationAggregateInput>;
  type?: InputMaybe<SortOrder>;
  unclaimedProfile?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  urgencyAvailabilities?: InputMaybe<ProUrgencyAvailabilityOrderByRelationAggregateInput>;
  visitAtHome?: InputMaybe<SortOrderInput>;
  website?: InputMaybe<SortOrderInput>;
  whatsappNumber?: InputMaybe<SortOrderInput>;
  workers?: InputMaybe<WorkerOrderByRelationAggregateInput>;
};

export type ProfessionalRelationFilter = {
  is?: InputMaybe<ProfessionalWhereInput>;
  isNot?: InputMaybe<ProfessionalWhereInput>;
};

export enum ProfessionalScalarFieldEnum {
  acceptedAnimals = 'acceptedAnimals',
  acceptsNewClients = 'acceptsNewClients',
  acceptsOnlineAppointment = 'acceptsOnlineAppointment',
  addressId = 'addressId',
  allowsAnyWorkerOption = 'allowsAnyWorkerOption',
  assistantsCount = 'assistantsCount',
  bookingGroupingMaxSlotDistance = 'bookingGroupingMaxSlotDistance',
  centerType = 'centerType',
  createdAt = 'createdAt',
  defaultServiceDurationMinute = 'defaultServiceDurationMinute',
  educatorType = 'educatorType',
  email = 'email',
  employeesCount = 'employeesCount',
  forceBookingGrouping = 'forceBookingGrouping',
  googleAccessToken = 'googleAccessToken',
  googleEmail = 'googleEmail',
  googleIdToken = 'googleIdToken',
  googleRefreshToken = 'googleRefreshToken',
  googleTokenExpiryDate = 'googleTokenExpiryDate',
  googleTokenScope = 'googleTokenScope',
  googleTokenType = 'googleTokenType',
  hasShop = 'hasShop',
  id = 'id',
  isTipawPartner = 'isTipawPartner',
  language = 'language',
  mainProFirstName = 'mainProFirstName',
  mainProLastName = 'mainProLastName',
  maxSmsNotification = 'maxSmsNotification',
  maxWeeksBeforeBooking = 'maxWeeksBeforeBooking',
  meta = 'meta',
  minHoursBeforeBooking = 'minHoursBeforeBooking',
  minHoursBeforeUpdateOrCancelBooking = 'minHoursBeforeUpdateOrCancelBooking',
  mobilePhone = 'mobilePhone',
  namePro = 'namePro',
  onlineBookingEnabled = 'onlineBookingEnabled',
  orderingIndex = 'orderingIndex',
  parking = 'parking',
  paymentMethods = 'paymentMethods',
  phone = 'phone',
  practicePlaces = 'practicePlaces',
  privateEmail = 'privateEmail',
  proMongoId = 'proMongoId',
  profileVideo = 'profileVideo',
  profileVideoPos = 'profileVideoPos',
  published = 'published',
  searchString = 'searchString',
  selfDogWash = 'selfDogWash',
  smsBookingRemindersEnabled = 'smsBookingRemindersEnabled',
  spokenLanguages = 'spokenLanguages',
  type = 'type',
  unclaimedProfile = 'unclaimedProfile',
  updatedAt = 'updatedAt',
  visitAtHome = 'visitAtHome',
  website = 'website',
  whatsappNumber = 'whatsappNumber'
}

export type ProfessionalScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<ProfessionalScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<ProfessionalScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<ProfessionalScalarWhereWithAggregatesInput>>;
  acceptedAnimals?: InputMaybe<EnumAnimalTypeEnumNullableListFilter>;
  acceptsNewClients?: InputMaybe<BoolWithAggregatesFilter>;
  acceptsOnlineAppointment?: InputMaybe<BoolWithAggregatesFilter>;
  addressId?: InputMaybe<IntNullableWithAggregatesFilter>;
  allowsAnyWorkerOption?: InputMaybe<BoolWithAggregatesFilter>;
  assistantsCount?: InputMaybe<IntNullableWithAggregatesFilter>;
  bookingGroupingMaxSlotDistance?: InputMaybe<IntWithAggregatesFilter>;
  centerType?: InputMaybe<EnumCenterTypeEnumNullableWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  defaultServiceDurationMinute?: InputMaybe<IntWithAggregatesFilter>;
  educatorType?: InputMaybe<EnumEducatorTypeEnumNullableWithAggregatesFilter>;
  email?: InputMaybe<StringNullableWithAggregatesFilter>;
  employeesCount?: InputMaybe<IntNullableWithAggregatesFilter>;
  forceBookingGrouping?: InputMaybe<BoolWithAggregatesFilter>;
  googleAccessToken?: InputMaybe<StringNullableWithAggregatesFilter>;
  googleEmail?: InputMaybe<StringNullableWithAggregatesFilter>;
  googleIdToken?: InputMaybe<StringNullableWithAggregatesFilter>;
  googleRefreshToken?: InputMaybe<StringNullableWithAggregatesFilter>;
  googleTokenExpiryDate?: InputMaybe<StringNullableWithAggregatesFilter>;
  googleTokenScope?: InputMaybe<StringNullableWithAggregatesFilter>;
  googleTokenType?: InputMaybe<StringNullableWithAggregatesFilter>;
  hasShop?: InputMaybe<BoolNullableWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  isTipawPartner?: InputMaybe<BoolWithAggregatesFilter>;
  language?: InputMaybe<StringWithAggregatesFilter>;
  mainProFirstName?: InputMaybe<StringNullableWithAggregatesFilter>;
  mainProLastName?: InputMaybe<StringNullableWithAggregatesFilter>;
  maxSmsNotification?: InputMaybe<IntWithAggregatesFilter>;
  maxWeeksBeforeBooking?: InputMaybe<IntWithAggregatesFilter>;
  meta?: InputMaybe<StringNullableWithAggregatesFilter>;
  minHoursBeforeBooking?: InputMaybe<IntWithAggregatesFilter>;
  minHoursBeforeUpdateOrCancelBooking?: InputMaybe<IntWithAggregatesFilter>;
  mobilePhone?: InputMaybe<StringNullableWithAggregatesFilter>;
  namePro?: InputMaybe<StringNullableWithAggregatesFilter>;
  onlineBookingEnabled?: InputMaybe<BoolWithAggregatesFilter>;
  orderingIndex?: InputMaybe<IntWithAggregatesFilter>;
  parking?: InputMaybe<BoolNullableWithAggregatesFilter>;
  paymentMethods?: InputMaybe<StringNullableListFilter>;
  phone?: InputMaybe<StringNullableWithAggregatesFilter>;
  practicePlaces?: InputMaybe<EnumEducatorPracticePlaceEnumNullableListFilter>;
  privateEmail?: InputMaybe<StringNullableWithAggregatesFilter>;
  proMongoId?: InputMaybe<StringNullableWithAggregatesFilter>;
  profileVideo?: InputMaybe<StringNullableWithAggregatesFilter>;
  profileVideoPos?: InputMaybe<IntWithAggregatesFilter>;
  published?: InputMaybe<BoolWithAggregatesFilter>;
  searchString?: InputMaybe<StringNullableWithAggregatesFilter>;
  selfDogWash?: InputMaybe<BoolWithAggregatesFilter>;
  smsBookingRemindersEnabled?: InputMaybe<BoolWithAggregatesFilter>;
  spokenLanguages?: InputMaybe<StringNullableListFilter>;
  type?: InputMaybe<EnumProfessionalTypeEnumWithAggregatesFilter>;
  unclaimedProfile?: InputMaybe<BoolWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  visitAtHome?: InputMaybe<BoolNullableWithAggregatesFilter>;
  website?: InputMaybe<StringNullableWithAggregatesFilter>;
  whatsappNumber?: InputMaybe<StringNullableWithAggregatesFilter>;
};

export type ProfessionalScheduleAvailabilities = {
  __typename?: 'ProfessionalScheduleAvailabilities';
  availabilities?: Maybe<Array<ProfessionalScheduleAvailabilitiesTimeRange>>;
  weekday?: Maybe<DayOfWeek>;
};

export type ProfessionalScheduleAvailabilitiesTimeRange = {
  __typename?: 'ProfessionalScheduleAvailabilitiesTimeRange';
  endTime: Scalars['String']['output'];
  startTime: Scalars['String']['output'];
};

export type ProfessionalService = {
  __typename?: 'ProfessionalService';
  bookable?: Maybe<Scalars['Boolean']['output']>;
  category: Category;
  fromDurationMinute?: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  price?: Maybe<Scalars['Float']['output']>;
  priceFrom?: Maybe<Scalars['Float']['output']>;
  priceTo?: Maybe<Scalars['Float']['output']>;
  priceType?: Maybe<Scalars['String']['output']>;
  service: Service;
  toDurationMinute?: Maybe<Scalars['Int']['output']>;
  workerServices: Array<WorkerServiceWithBookingDuration>;
};

export type ProfessionalSumAggregateOutputType = {
  __typename?: 'ProfessionalSumAggregateOutputType';
  addressId?: Maybe<Scalars['Int']['output']>;
  assistantsCount?: Maybe<Scalars['Int']['output']>;
  bookingGroupingMaxSlotDistance?: Maybe<Scalars['Int']['output']>;
  defaultServiceDurationMinute?: Maybe<Scalars['Int']['output']>;
  employeesCount?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  maxSmsNotification?: Maybe<Scalars['Int']['output']>;
  maxWeeksBeforeBooking?: Maybe<Scalars['Int']['output']>;
  minHoursBeforeBooking?: Maybe<Scalars['Int']['output']>;
  minHoursBeforeUpdateOrCancelBooking?: Maybe<Scalars['Int']['output']>;
  orderingIndex?: Maybe<Scalars['Int']['output']>;
  profileVideoPos?: Maybe<Scalars['Int']['output']>;
};

export type ProfessionalSumOrderByAggregateInput = {
  addressId?: InputMaybe<SortOrder>;
  assistantsCount?: InputMaybe<SortOrder>;
  bookingGroupingMaxSlotDistance?: InputMaybe<SortOrder>;
  defaultServiceDurationMinute?: InputMaybe<SortOrder>;
  employeesCount?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  maxSmsNotification?: InputMaybe<SortOrder>;
  maxWeeksBeforeBooking?: InputMaybe<SortOrder>;
  minHoursBeforeBooking?: InputMaybe<SortOrder>;
  minHoursBeforeUpdateOrCancelBooking?: InputMaybe<SortOrder>;
  orderingIndex?: InputMaybe<SortOrder>;
  profileVideoPos?: InputMaybe<SortOrder>;
};

export enum ProfessionalTypeEnum {
  EDUCATOR = 'EDUCATOR',
  GROOMER = 'GROOMER',
  VET = 'VET'
}

export type ProfessionalUncheckedCreateInput = {
  acceptedAnimals?: InputMaybe<Array<AnimalTypeEnum>>;
  acceptsNewClients?: InputMaybe<Scalars['Boolean']['input']>;
  acceptsOnlineAppointment?: InputMaybe<Scalars['Boolean']['input']>;
  addressId?: InputMaybe<Scalars['Int']['input']>;
  adminNotes?: InputMaybe<AdminNoteUncheckedCreateNestedManyWithoutProfessionalInput>;
  allowsAnyWorkerOption?: InputMaybe<Scalars['Boolean']['input']>;
  assistantsCount?: InputMaybe<Scalars['Int']['input']>;
  availabilities?: InputMaybe<ProAvailabilityUncheckedCreateNestedManyWithoutProInput>;
  bookingGroupingMaxSlotDistance?: InputMaybe<Scalars['Int']['input']>;
  centerType?: InputMaybe<CenterTypeEnum>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  defaultServiceDurationMinute?: InputMaybe<Scalars['Int']['input']>;
  degrees?: InputMaybe<ProDegreesUncheckedCreateNestedManyWithoutProInput>;
  educatorType?: InputMaybe<EducatorTypeEnum>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailHistory?: InputMaybe<EmailHistoryUncheckedCreateNestedManyWithoutProfessionalInput>;
  employeesCount?: InputMaybe<Scalars['Int']['input']>;
  forceBookingGrouping?: InputMaybe<Scalars['Boolean']['input']>;
  googleAccessToken?: InputMaybe<Scalars['String']['input']>;
  googleEmail?: InputMaybe<Scalars['String']['input']>;
  googleIdToken?: InputMaybe<Scalars['String']['input']>;
  googleRefreshToken?: InputMaybe<Scalars['String']['input']>;
  googleTokenExpiryDate?: InputMaybe<Scalars['String']['input']>;
  googleTokenScope?: InputMaybe<Scalars['String']['input']>;
  googleTokenType?: InputMaybe<Scalars['String']['input']>;
  hasShop?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  imgs?: InputMaybe<ProImgUncheckedCreateNestedManyWithoutProInput>;
  isTipawPartner?: InputMaybe<Scalars['Boolean']['input']>;
  language: Scalars['String']['input'];
  mainProFirstName?: InputMaybe<Scalars['String']['input']>;
  mainProLastName?: InputMaybe<Scalars['String']['input']>;
  maxSmsNotification?: InputMaybe<Scalars['Int']['input']>;
  maxWeeksBeforeBooking?: InputMaybe<Scalars['Int']['input']>;
  meta?: InputMaybe<Scalars['String']['input']>;
  minHoursBeforeBooking?: InputMaybe<Scalars['Int']['input']>;
  minHoursBeforeUpdateOrCancelBooking?: InputMaybe<Scalars['Int']['input']>;
  mobilePhone?: InputMaybe<Scalars['String']['input']>;
  namePro?: InputMaybe<Scalars['String']['input']>;
  notifications?: InputMaybe<NotificationUncheckedCreateNestedManyWithoutProInput>;
  onlineBookingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  orderingIndex?: InputMaybe<Scalars['Int']['input']>;
  parking?: InputMaybe<Scalars['Boolean']['input']>;
  paymentMethods?: InputMaybe<Array<Scalars['String']['input']>>;
  phone?: InputMaybe<Scalars['String']['input']>;
  practicePlaces?: InputMaybe<Array<EducatorPracticePlaceEnum>>;
  privateEmail?: InputMaybe<Scalars['String']['input']>;
  proMongoId?: InputMaybe<Scalars['String']['input']>;
  profileVideo?: InputMaybe<Scalars['String']['input']>;
  profileVideoPos?: InputMaybe<Scalars['Int']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  reviews?: InputMaybe<EducatorReviewUncheckedCreateNestedManyWithoutProfessionalInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  selfDogWash?: InputMaybe<Scalars['Boolean']['input']>;
  shopOpeningHours?: InputMaybe<ProShopOpeningHourUncheckedCreateNestedManyWithoutProInput>;
  smsBookingRemindersEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  stats?: InputMaybe<ProStatUncheckedCreateNestedManyWithoutProInput>;
  translations?: InputMaybe<ProTranslationUncheckedCreateNestedManyWithoutProInput>;
  type: ProfessionalTypeEnum;
  unclaimedProfile?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  urgencyAvailabilities?: InputMaybe<ProUrgencyAvailabilityUncheckedCreateNestedManyWithoutProInput>;
  visitAtHome?: InputMaybe<Scalars['Boolean']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  whatsappNumber?: InputMaybe<Scalars['String']['input']>;
  workers?: InputMaybe<WorkerUncheckedCreateNestedManyWithoutProInput>;
};

export type ProfessionalUncheckedCreateNestedOneWithoutAddressInput = {
  connect?: InputMaybe<ProfessionalWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProfessionalCreateOrConnectWithoutAddressInput>;
  create?: InputMaybe<ProfessionalCreateWithoutAddressInput>;
};

export type ProfessionalUncheckedCreateWithoutAddressInput = {
  acceptedAnimals?: InputMaybe<Array<AnimalTypeEnum>>;
  acceptsNewClients?: InputMaybe<Scalars['Boolean']['input']>;
  acceptsOnlineAppointment?: InputMaybe<Scalars['Boolean']['input']>;
  adminNotes?: InputMaybe<AdminNoteUncheckedCreateNestedManyWithoutProfessionalInput>;
  allowsAnyWorkerOption?: InputMaybe<Scalars['Boolean']['input']>;
  assistantsCount?: InputMaybe<Scalars['Int']['input']>;
  availabilities?: InputMaybe<ProAvailabilityUncheckedCreateNestedManyWithoutProInput>;
  bookingGroupingMaxSlotDistance?: InputMaybe<Scalars['Int']['input']>;
  centerType?: InputMaybe<CenterTypeEnum>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  defaultServiceDurationMinute?: InputMaybe<Scalars['Int']['input']>;
  degrees?: InputMaybe<ProDegreesUncheckedCreateNestedManyWithoutProInput>;
  educatorType?: InputMaybe<EducatorTypeEnum>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailHistory?: InputMaybe<EmailHistoryUncheckedCreateNestedManyWithoutProfessionalInput>;
  employeesCount?: InputMaybe<Scalars['Int']['input']>;
  forceBookingGrouping?: InputMaybe<Scalars['Boolean']['input']>;
  googleAccessToken?: InputMaybe<Scalars['String']['input']>;
  googleEmail?: InputMaybe<Scalars['String']['input']>;
  googleIdToken?: InputMaybe<Scalars['String']['input']>;
  googleRefreshToken?: InputMaybe<Scalars['String']['input']>;
  googleTokenExpiryDate?: InputMaybe<Scalars['String']['input']>;
  googleTokenScope?: InputMaybe<Scalars['String']['input']>;
  googleTokenType?: InputMaybe<Scalars['String']['input']>;
  hasShop?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  imgs?: InputMaybe<ProImgUncheckedCreateNestedManyWithoutProInput>;
  isTipawPartner?: InputMaybe<Scalars['Boolean']['input']>;
  language: Scalars['String']['input'];
  mainProFirstName?: InputMaybe<Scalars['String']['input']>;
  mainProLastName?: InputMaybe<Scalars['String']['input']>;
  maxSmsNotification?: InputMaybe<Scalars['Int']['input']>;
  maxWeeksBeforeBooking?: InputMaybe<Scalars['Int']['input']>;
  meta?: InputMaybe<Scalars['String']['input']>;
  minHoursBeforeBooking?: InputMaybe<Scalars['Int']['input']>;
  minHoursBeforeUpdateOrCancelBooking?: InputMaybe<Scalars['Int']['input']>;
  mobilePhone?: InputMaybe<Scalars['String']['input']>;
  namePro?: InputMaybe<Scalars['String']['input']>;
  notifications?: InputMaybe<NotificationUncheckedCreateNestedManyWithoutProInput>;
  onlineBookingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  orderingIndex?: InputMaybe<Scalars['Int']['input']>;
  parking?: InputMaybe<Scalars['Boolean']['input']>;
  paymentMethods?: InputMaybe<Array<Scalars['String']['input']>>;
  phone?: InputMaybe<Scalars['String']['input']>;
  practicePlaces?: InputMaybe<Array<EducatorPracticePlaceEnum>>;
  privateEmail?: InputMaybe<Scalars['String']['input']>;
  proMongoId?: InputMaybe<Scalars['String']['input']>;
  profileVideo?: InputMaybe<Scalars['String']['input']>;
  profileVideoPos?: InputMaybe<Scalars['Int']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  reviews?: InputMaybe<EducatorReviewUncheckedCreateNestedManyWithoutProfessionalInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  selfDogWash?: InputMaybe<Scalars['Boolean']['input']>;
  shopOpeningHours?: InputMaybe<ProShopOpeningHourUncheckedCreateNestedManyWithoutProInput>;
  smsBookingRemindersEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  stats?: InputMaybe<ProStatUncheckedCreateNestedManyWithoutProInput>;
  translations?: InputMaybe<ProTranslationUncheckedCreateNestedManyWithoutProInput>;
  type: ProfessionalTypeEnum;
  unclaimedProfile?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  urgencyAvailabilities?: InputMaybe<ProUrgencyAvailabilityUncheckedCreateNestedManyWithoutProInput>;
  visitAtHome?: InputMaybe<Scalars['Boolean']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  whatsappNumber?: InputMaybe<Scalars['String']['input']>;
  workers?: InputMaybe<WorkerUncheckedCreateNestedManyWithoutProInput>;
};

export type ProfessionalUncheckedCreateWithoutAdminNotesInput = {
  acceptedAnimals?: InputMaybe<Array<AnimalTypeEnum>>;
  acceptsNewClients?: InputMaybe<Scalars['Boolean']['input']>;
  acceptsOnlineAppointment?: InputMaybe<Scalars['Boolean']['input']>;
  addressId?: InputMaybe<Scalars['Int']['input']>;
  allowsAnyWorkerOption?: InputMaybe<Scalars['Boolean']['input']>;
  assistantsCount?: InputMaybe<Scalars['Int']['input']>;
  availabilities?: InputMaybe<ProAvailabilityUncheckedCreateNestedManyWithoutProInput>;
  bookingGroupingMaxSlotDistance?: InputMaybe<Scalars['Int']['input']>;
  centerType?: InputMaybe<CenterTypeEnum>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  defaultServiceDurationMinute?: InputMaybe<Scalars['Int']['input']>;
  degrees?: InputMaybe<ProDegreesUncheckedCreateNestedManyWithoutProInput>;
  educatorType?: InputMaybe<EducatorTypeEnum>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailHistory?: InputMaybe<EmailHistoryUncheckedCreateNestedManyWithoutProfessionalInput>;
  employeesCount?: InputMaybe<Scalars['Int']['input']>;
  forceBookingGrouping?: InputMaybe<Scalars['Boolean']['input']>;
  googleAccessToken?: InputMaybe<Scalars['String']['input']>;
  googleEmail?: InputMaybe<Scalars['String']['input']>;
  googleIdToken?: InputMaybe<Scalars['String']['input']>;
  googleRefreshToken?: InputMaybe<Scalars['String']['input']>;
  googleTokenExpiryDate?: InputMaybe<Scalars['String']['input']>;
  googleTokenScope?: InputMaybe<Scalars['String']['input']>;
  googleTokenType?: InputMaybe<Scalars['String']['input']>;
  hasShop?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  imgs?: InputMaybe<ProImgUncheckedCreateNestedManyWithoutProInput>;
  isTipawPartner?: InputMaybe<Scalars['Boolean']['input']>;
  language: Scalars['String']['input'];
  mainProFirstName?: InputMaybe<Scalars['String']['input']>;
  mainProLastName?: InputMaybe<Scalars['String']['input']>;
  maxSmsNotification?: InputMaybe<Scalars['Int']['input']>;
  maxWeeksBeforeBooking?: InputMaybe<Scalars['Int']['input']>;
  meta?: InputMaybe<Scalars['String']['input']>;
  minHoursBeforeBooking?: InputMaybe<Scalars['Int']['input']>;
  minHoursBeforeUpdateOrCancelBooking?: InputMaybe<Scalars['Int']['input']>;
  mobilePhone?: InputMaybe<Scalars['String']['input']>;
  namePro?: InputMaybe<Scalars['String']['input']>;
  notifications?: InputMaybe<NotificationUncheckedCreateNestedManyWithoutProInput>;
  onlineBookingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  orderingIndex?: InputMaybe<Scalars['Int']['input']>;
  parking?: InputMaybe<Scalars['Boolean']['input']>;
  paymentMethods?: InputMaybe<Array<Scalars['String']['input']>>;
  phone?: InputMaybe<Scalars['String']['input']>;
  practicePlaces?: InputMaybe<Array<EducatorPracticePlaceEnum>>;
  privateEmail?: InputMaybe<Scalars['String']['input']>;
  proMongoId?: InputMaybe<Scalars['String']['input']>;
  profileVideo?: InputMaybe<Scalars['String']['input']>;
  profileVideoPos?: InputMaybe<Scalars['Int']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  reviews?: InputMaybe<EducatorReviewUncheckedCreateNestedManyWithoutProfessionalInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  selfDogWash?: InputMaybe<Scalars['Boolean']['input']>;
  shopOpeningHours?: InputMaybe<ProShopOpeningHourUncheckedCreateNestedManyWithoutProInput>;
  smsBookingRemindersEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  stats?: InputMaybe<ProStatUncheckedCreateNestedManyWithoutProInput>;
  translations?: InputMaybe<ProTranslationUncheckedCreateNestedManyWithoutProInput>;
  type: ProfessionalTypeEnum;
  unclaimedProfile?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  urgencyAvailabilities?: InputMaybe<ProUrgencyAvailabilityUncheckedCreateNestedManyWithoutProInput>;
  visitAtHome?: InputMaybe<Scalars['Boolean']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  whatsappNumber?: InputMaybe<Scalars['String']['input']>;
  workers?: InputMaybe<WorkerUncheckedCreateNestedManyWithoutProInput>;
};

export type ProfessionalUncheckedCreateWithoutAvailabilitiesInput = {
  acceptedAnimals?: InputMaybe<Array<AnimalTypeEnum>>;
  acceptsNewClients?: InputMaybe<Scalars['Boolean']['input']>;
  acceptsOnlineAppointment?: InputMaybe<Scalars['Boolean']['input']>;
  addressId?: InputMaybe<Scalars['Int']['input']>;
  adminNotes?: InputMaybe<AdminNoteUncheckedCreateNestedManyWithoutProfessionalInput>;
  allowsAnyWorkerOption?: InputMaybe<Scalars['Boolean']['input']>;
  assistantsCount?: InputMaybe<Scalars['Int']['input']>;
  bookingGroupingMaxSlotDistance?: InputMaybe<Scalars['Int']['input']>;
  centerType?: InputMaybe<CenterTypeEnum>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  defaultServiceDurationMinute?: InputMaybe<Scalars['Int']['input']>;
  degrees?: InputMaybe<ProDegreesUncheckedCreateNestedManyWithoutProInput>;
  educatorType?: InputMaybe<EducatorTypeEnum>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailHistory?: InputMaybe<EmailHistoryUncheckedCreateNestedManyWithoutProfessionalInput>;
  employeesCount?: InputMaybe<Scalars['Int']['input']>;
  forceBookingGrouping?: InputMaybe<Scalars['Boolean']['input']>;
  googleAccessToken?: InputMaybe<Scalars['String']['input']>;
  googleEmail?: InputMaybe<Scalars['String']['input']>;
  googleIdToken?: InputMaybe<Scalars['String']['input']>;
  googleRefreshToken?: InputMaybe<Scalars['String']['input']>;
  googleTokenExpiryDate?: InputMaybe<Scalars['String']['input']>;
  googleTokenScope?: InputMaybe<Scalars['String']['input']>;
  googleTokenType?: InputMaybe<Scalars['String']['input']>;
  hasShop?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  imgs?: InputMaybe<ProImgUncheckedCreateNestedManyWithoutProInput>;
  isTipawPartner?: InputMaybe<Scalars['Boolean']['input']>;
  language: Scalars['String']['input'];
  mainProFirstName?: InputMaybe<Scalars['String']['input']>;
  mainProLastName?: InputMaybe<Scalars['String']['input']>;
  maxSmsNotification?: InputMaybe<Scalars['Int']['input']>;
  maxWeeksBeforeBooking?: InputMaybe<Scalars['Int']['input']>;
  meta?: InputMaybe<Scalars['String']['input']>;
  minHoursBeforeBooking?: InputMaybe<Scalars['Int']['input']>;
  minHoursBeforeUpdateOrCancelBooking?: InputMaybe<Scalars['Int']['input']>;
  mobilePhone?: InputMaybe<Scalars['String']['input']>;
  namePro?: InputMaybe<Scalars['String']['input']>;
  notifications?: InputMaybe<NotificationUncheckedCreateNestedManyWithoutProInput>;
  onlineBookingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  orderingIndex?: InputMaybe<Scalars['Int']['input']>;
  parking?: InputMaybe<Scalars['Boolean']['input']>;
  paymentMethods?: InputMaybe<Array<Scalars['String']['input']>>;
  phone?: InputMaybe<Scalars['String']['input']>;
  practicePlaces?: InputMaybe<Array<EducatorPracticePlaceEnum>>;
  privateEmail?: InputMaybe<Scalars['String']['input']>;
  proMongoId?: InputMaybe<Scalars['String']['input']>;
  profileVideo?: InputMaybe<Scalars['String']['input']>;
  profileVideoPos?: InputMaybe<Scalars['Int']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  reviews?: InputMaybe<EducatorReviewUncheckedCreateNestedManyWithoutProfessionalInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  selfDogWash?: InputMaybe<Scalars['Boolean']['input']>;
  shopOpeningHours?: InputMaybe<ProShopOpeningHourUncheckedCreateNestedManyWithoutProInput>;
  smsBookingRemindersEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  stats?: InputMaybe<ProStatUncheckedCreateNestedManyWithoutProInput>;
  translations?: InputMaybe<ProTranslationUncheckedCreateNestedManyWithoutProInput>;
  type: ProfessionalTypeEnum;
  unclaimedProfile?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  urgencyAvailabilities?: InputMaybe<ProUrgencyAvailabilityUncheckedCreateNestedManyWithoutProInput>;
  visitAtHome?: InputMaybe<Scalars['Boolean']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  whatsappNumber?: InputMaybe<Scalars['String']['input']>;
  workers?: InputMaybe<WorkerUncheckedCreateNestedManyWithoutProInput>;
};

export type ProfessionalUncheckedCreateWithoutDegreesInput = {
  acceptedAnimals?: InputMaybe<Array<AnimalTypeEnum>>;
  acceptsNewClients?: InputMaybe<Scalars['Boolean']['input']>;
  acceptsOnlineAppointment?: InputMaybe<Scalars['Boolean']['input']>;
  addressId?: InputMaybe<Scalars['Int']['input']>;
  adminNotes?: InputMaybe<AdminNoteUncheckedCreateNestedManyWithoutProfessionalInput>;
  allowsAnyWorkerOption?: InputMaybe<Scalars['Boolean']['input']>;
  assistantsCount?: InputMaybe<Scalars['Int']['input']>;
  availabilities?: InputMaybe<ProAvailabilityUncheckedCreateNestedManyWithoutProInput>;
  bookingGroupingMaxSlotDistance?: InputMaybe<Scalars['Int']['input']>;
  centerType?: InputMaybe<CenterTypeEnum>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  defaultServiceDurationMinute?: InputMaybe<Scalars['Int']['input']>;
  educatorType?: InputMaybe<EducatorTypeEnum>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailHistory?: InputMaybe<EmailHistoryUncheckedCreateNestedManyWithoutProfessionalInput>;
  employeesCount?: InputMaybe<Scalars['Int']['input']>;
  forceBookingGrouping?: InputMaybe<Scalars['Boolean']['input']>;
  googleAccessToken?: InputMaybe<Scalars['String']['input']>;
  googleEmail?: InputMaybe<Scalars['String']['input']>;
  googleIdToken?: InputMaybe<Scalars['String']['input']>;
  googleRefreshToken?: InputMaybe<Scalars['String']['input']>;
  googleTokenExpiryDate?: InputMaybe<Scalars['String']['input']>;
  googleTokenScope?: InputMaybe<Scalars['String']['input']>;
  googleTokenType?: InputMaybe<Scalars['String']['input']>;
  hasShop?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  imgs?: InputMaybe<ProImgUncheckedCreateNestedManyWithoutProInput>;
  isTipawPartner?: InputMaybe<Scalars['Boolean']['input']>;
  language: Scalars['String']['input'];
  mainProFirstName?: InputMaybe<Scalars['String']['input']>;
  mainProLastName?: InputMaybe<Scalars['String']['input']>;
  maxSmsNotification?: InputMaybe<Scalars['Int']['input']>;
  maxWeeksBeforeBooking?: InputMaybe<Scalars['Int']['input']>;
  meta?: InputMaybe<Scalars['String']['input']>;
  minHoursBeforeBooking?: InputMaybe<Scalars['Int']['input']>;
  minHoursBeforeUpdateOrCancelBooking?: InputMaybe<Scalars['Int']['input']>;
  mobilePhone?: InputMaybe<Scalars['String']['input']>;
  namePro?: InputMaybe<Scalars['String']['input']>;
  notifications?: InputMaybe<NotificationUncheckedCreateNestedManyWithoutProInput>;
  onlineBookingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  orderingIndex?: InputMaybe<Scalars['Int']['input']>;
  parking?: InputMaybe<Scalars['Boolean']['input']>;
  paymentMethods?: InputMaybe<Array<Scalars['String']['input']>>;
  phone?: InputMaybe<Scalars['String']['input']>;
  practicePlaces?: InputMaybe<Array<EducatorPracticePlaceEnum>>;
  privateEmail?: InputMaybe<Scalars['String']['input']>;
  proMongoId?: InputMaybe<Scalars['String']['input']>;
  profileVideo?: InputMaybe<Scalars['String']['input']>;
  profileVideoPos?: InputMaybe<Scalars['Int']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  reviews?: InputMaybe<EducatorReviewUncheckedCreateNestedManyWithoutProfessionalInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  selfDogWash?: InputMaybe<Scalars['Boolean']['input']>;
  shopOpeningHours?: InputMaybe<ProShopOpeningHourUncheckedCreateNestedManyWithoutProInput>;
  smsBookingRemindersEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  stats?: InputMaybe<ProStatUncheckedCreateNestedManyWithoutProInput>;
  translations?: InputMaybe<ProTranslationUncheckedCreateNestedManyWithoutProInput>;
  type: ProfessionalTypeEnum;
  unclaimedProfile?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  urgencyAvailabilities?: InputMaybe<ProUrgencyAvailabilityUncheckedCreateNestedManyWithoutProInput>;
  visitAtHome?: InputMaybe<Scalars['Boolean']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  whatsappNumber?: InputMaybe<Scalars['String']['input']>;
  workers?: InputMaybe<WorkerUncheckedCreateNestedManyWithoutProInput>;
};

export type ProfessionalUncheckedCreateWithoutEmailHistoryInput = {
  acceptedAnimals?: InputMaybe<Array<AnimalTypeEnum>>;
  acceptsNewClients?: InputMaybe<Scalars['Boolean']['input']>;
  acceptsOnlineAppointment?: InputMaybe<Scalars['Boolean']['input']>;
  addressId?: InputMaybe<Scalars['Int']['input']>;
  adminNotes?: InputMaybe<AdminNoteUncheckedCreateNestedManyWithoutProfessionalInput>;
  allowsAnyWorkerOption?: InputMaybe<Scalars['Boolean']['input']>;
  assistantsCount?: InputMaybe<Scalars['Int']['input']>;
  availabilities?: InputMaybe<ProAvailabilityUncheckedCreateNestedManyWithoutProInput>;
  bookingGroupingMaxSlotDistance?: InputMaybe<Scalars['Int']['input']>;
  centerType?: InputMaybe<CenterTypeEnum>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  defaultServiceDurationMinute?: InputMaybe<Scalars['Int']['input']>;
  degrees?: InputMaybe<ProDegreesUncheckedCreateNestedManyWithoutProInput>;
  educatorType?: InputMaybe<EducatorTypeEnum>;
  email?: InputMaybe<Scalars['String']['input']>;
  employeesCount?: InputMaybe<Scalars['Int']['input']>;
  forceBookingGrouping?: InputMaybe<Scalars['Boolean']['input']>;
  googleAccessToken?: InputMaybe<Scalars['String']['input']>;
  googleEmail?: InputMaybe<Scalars['String']['input']>;
  googleIdToken?: InputMaybe<Scalars['String']['input']>;
  googleRefreshToken?: InputMaybe<Scalars['String']['input']>;
  googleTokenExpiryDate?: InputMaybe<Scalars['String']['input']>;
  googleTokenScope?: InputMaybe<Scalars['String']['input']>;
  googleTokenType?: InputMaybe<Scalars['String']['input']>;
  hasShop?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  imgs?: InputMaybe<ProImgUncheckedCreateNestedManyWithoutProInput>;
  isTipawPartner?: InputMaybe<Scalars['Boolean']['input']>;
  language: Scalars['String']['input'];
  mainProFirstName?: InputMaybe<Scalars['String']['input']>;
  mainProLastName?: InputMaybe<Scalars['String']['input']>;
  maxSmsNotification?: InputMaybe<Scalars['Int']['input']>;
  maxWeeksBeforeBooking?: InputMaybe<Scalars['Int']['input']>;
  meta?: InputMaybe<Scalars['String']['input']>;
  minHoursBeforeBooking?: InputMaybe<Scalars['Int']['input']>;
  minHoursBeforeUpdateOrCancelBooking?: InputMaybe<Scalars['Int']['input']>;
  mobilePhone?: InputMaybe<Scalars['String']['input']>;
  namePro?: InputMaybe<Scalars['String']['input']>;
  notifications?: InputMaybe<NotificationUncheckedCreateNestedManyWithoutProInput>;
  onlineBookingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  orderingIndex?: InputMaybe<Scalars['Int']['input']>;
  parking?: InputMaybe<Scalars['Boolean']['input']>;
  paymentMethods?: InputMaybe<Array<Scalars['String']['input']>>;
  phone?: InputMaybe<Scalars['String']['input']>;
  practicePlaces?: InputMaybe<Array<EducatorPracticePlaceEnum>>;
  privateEmail?: InputMaybe<Scalars['String']['input']>;
  proMongoId?: InputMaybe<Scalars['String']['input']>;
  profileVideo?: InputMaybe<Scalars['String']['input']>;
  profileVideoPos?: InputMaybe<Scalars['Int']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  reviews?: InputMaybe<EducatorReviewUncheckedCreateNestedManyWithoutProfessionalInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  selfDogWash?: InputMaybe<Scalars['Boolean']['input']>;
  shopOpeningHours?: InputMaybe<ProShopOpeningHourUncheckedCreateNestedManyWithoutProInput>;
  smsBookingRemindersEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  stats?: InputMaybe<ProStatUncheckedCreateNestedManyWithoutProInput>;
  translations?: InputMaybe<ProTranslationUncheckedCreateNestedManyWithoutProInput>;
  type: ProfessionalTypeEnum;
  unclaimedProfile?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  urgencyAvailabilities?: InputMaybe<ProUrgencyAvailabilityUncheckedCreateNestedManyWithoutProInput>;
  visitAtHome?: InputMaybe<Scalars['Boolean']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  whatsappNumber?: InputMaybe<Scalars['String']['input']>;
  workers?: InputMaybe<WorkerUncheckedCreateNestedManyWithoutProInput>;
};

export type ProfessionalUncheckedCreateWithoutImgsInput = {
  acceptedAnimals?: InputMaybe<Array<AnimalTypeEnum>>;
  acceptsNewClients?: InputMaybe<Scalars['Boolean']['input']>;
  acceptsOnlineAppointment?: InputMaybe<Scalars['Boolean']['input']>;
  addressId?: InputMaybe<Scalars['Int']['input']>;
  adminNotes?: InputMaybe<AdminNoteUncheckedCreateNestedManyWithoutProfessionalInput>;
  allowsAnyWorkerOption?: InputMaybe<Scalars['Boolean']['input']>;
  assistantsCount?: InputMaybe<Scalars['Int']['input']>;
  availabilities?: InputMaybe<ProAvailabilityUncheckedCreateNestedManyWithoutProInput>;
  bookingGroupingMaxSlotDistance?: InputMaybe<Scalars['Int']['input']>;
  centerType?: InputMaybe<CenterTypeEnum>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  defaultServiceDurationMinute?: InputMaybe<Scalars['Int']['input']>;
  degrees?: InputMaybe<ProDegreesUncheckedCreateNestedManyWithoutProInput>;
  educatorType?: InputMaybe<EducatorTypeEnum>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailHistory?: InputMaybe<EmailHistoryUncheckedCreateNestedManyWithoutProfessionalInput>;
  employeesCount?: InputMaybe<Scalars['Int']['input']>;
  forceBookingGrouping?: InputMaybe<Scalars['Boolean']['input']>;
  googleAccessToken?: InputMaybe<Scalars['String']['input']>;
  googleEmail?: InputMaybe<Scalars['String']['input']>;
  googleIdToken?: InputMaybe<Scalars['String']['input']>;
  googleRefreshToken?: InputMaybe<Scalars['String']['input']>;
  googleTokenExpiryDate?: InputMaybe<Scalars['String']['input']>;
  googleTokenScope?: InputMaybe<Scalars['String']['input']>;
  googleTokenType?: InputMaybe<Scalars['String']['input']>;
  hasShop?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isTipawPartner?: InputMaybe<Scalars['Boolean']['input']>;
  language: Scalars['String']['input'];
  mainProFirstName?: InputMaybe<Scalars['String']['input']>;
  mainProLastName?: InputMaybe<Scalars['String']['input']>;
  maxSmsNotification?: InputMaybe<Scalars['Int']['input']>;
  maxWeeksBeforeBooking?: InputMaybe<Scalars['Int']['input']>;
  meta?: InputMaybe<Scalars['String']['input']>;
  minHoursBeforeBooking?: InputMaybe<Scalars['Int']['input']>;
  minHoursBeforeUpdateOrCancelBooking?: InputMaybe<Scalars['Int']['input']>;
  mobilePhone?: InputMaybe<Scalars['String']['input']>;
  namePro?: InputMaybe<Scalars['String']['input']>;
  notifications?: InputMaybe<NotificationUncheckedCreateNestedManyWithoutProInput>;
  onlineBookingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  orderingIndex?: InputMaybe<Scalars['Int']['input']>;
  parking?: InputMaybe<Scalars['Boolean']['input']>;
  paymentMethods?: InputMaybe<Array<Scalars['String']['input']>>;
  phone?: InputMaybe<Scalars['String']['input']>;
  practicePlaces?: InputMaybe<Array<EducatorPracticePlaceEnum>>;
  privateEmail?: InputMaybe<Scalars['String']['input']>;
  proMongoId?: InputMaybe<Scalars['String']['input']>;
  profileVideo?: InputMaybe<Scalars['String']['input']>;
  profileVideoPos?: InputMaybe<Scalars['Int']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  reviews?: InputMaybe<EducatorReviewUncheckedCreateNestedManyWithoutProfessionalInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  selfDogWash?: InputMaybe<Scalars['Boolean']['input']>;
  shopOpeningHours?: InputMaybe<ProShopOpeningHourUncheckedCreateNestedManyWithoutProInput>;
  smsBookingRemindersEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  stats?: InputMaybe<ProStatUncheckedCreateNestedManyWithoutProInput>;
  translations?: InputMaybe<ProTranslationUncheckedCreateNestedManyWithoutProInput>;
  type: ProfessionalTypeEnum;
  unclaimedProfile?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  urgencyAvailabilities?: InputMaybe<ProUrgencyAvailabilityUncheckedCreateNestedManyWithoutProInput>;
  visitAtHome?: InputMaybe<Scalars['Boolean']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  whatsappNumber?: InputMaybe<Scalars['String']['input']>;
  workers?: InputMaybe<WorkerUncheckedCreateNestedManyWithoutProInput>;
};

export type ProfessionalUncheckedCreateWithoutNotificationsInput = {
  acceptedAnimals?: InputMaybe<Array<AnimalTypeEnum>>;
  acceptsNewClients?: InputMaybe<Scalars['Boolean']['input']>;
  acceptsOnlineAppointment?: InputMaybe<Scalars['Boolean']['input']>;
  addressId?: InputMaybe<Scalars['Int']['input']>;
  adminNotes?: InputMaybe<AdminNoteUncheckedCreateNestedManyWithoutProfessionalInput>;
  allowsAnyWorkerOption?: InputMaybe<Scalars['Boolean']['input']>;
  assistantsCount?: InputMaybe<Scalars['Int']['input']>;
  availabilities?: InputMaybe<ProAvailabilityUncheckedCreateNestedManyWithoutProInput>;
  bookingGroupingMaxSlotDistance?: InputMaybe<Scalars['Int']['input']>;
  centerType?: InputMaybe<CenterTypeEnum>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  defaultServiceDurationMinute?: InputMaybe<Scalars['Int']['input']>;
  degrees?: InputMaybe<ProDegreesUncheckedCreateNestedManyWithoutProInput>;
  educatorType?: InputMaybe<EducatorTypeEnum>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailHistory?: InputMaybe<EmailHistoryUncheckedCreateNestedManyWithoutProfessionalInput>;
  employeesCount?: InputMaybe<Scalars['Int']['input']>;
  forceBookingGrouping?: InputMaybe<Scalars['Boolean']['input']>;
  googleAccessToken?: InputMaybe<Scalars['String']['input']>;
  googleEmail?: InputMaybe<Scalars['String']['input']>;
  googleIdToken?: InputMaybe<Scalars['String']['input']>;
  googleRefreshToken?: InputMaybe<Scalars['String']['input']>;
  googleTokenExpiryDate?: InputMaybe<Scalars['String']['input']>;
  googleTokenScope?: InputMaybe<Scalars['String']['input']>;
  googleTokenType?: InputMaybe<Scalars['String']['input']>;
  hasShop?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  imgs?: InputMaybe<ProImgUncheckedCreateNestedManyWithoutProInput>;
  isTipawPartner?: InputMaybe<Scalars['Boolean']['input']>;
  language: Scalars['String']['input'];
  mainProFirstName?: InputMaybe<Scalars['String']['input']>;
  mainProLastName?: InputMaybe<Scalars['String']['input']>;
  maxSmsNotification?: InputMaybe<Scalars['Int']['input']>;
  maxWeeksBeforeBooking?: InputMaybe<Scalars['Int']['input']>;
  meta?: InputMaybe<Scalars['String']['input']>;
  minHoursBeforeBooking?: InputMaybe<Scalars['Int']['input']>;
  minHoursBeforeUpdateOrCancelBooking?: InputMaybe<Scalars['Int']['input']>;
  mobilePhone?: InputMaybe<Scalars['String']['input']>;
  namePro?: InputMaybe<Scalars['String']['input']>;
  onlineBookingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  orderingIndex?: InputMaybe<Scalars['Int']['input']>;
  parking?: InputMaybe<Scalars['Boolean']['input']>;
  paymentMethods?: InputMaybe<Array<Scalars['String']['input']>>;
  phone?: InputMaybe<Scalars['String']['input']>;
  practicePlaces?: InputMaybe<Array<EducatorPracticePlaceEnum>>;
  privateEmail?: InputMaybe<Scalars['String']['input']>;
  proMongoId?: InputMaybe<Scalars['String']['input']>;
  profileVideo?: InputMaybe<Scalars['String']['input']>;
  profileVideoPos?: InputMaybe<Scalars['Int']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  reviews?: InputMaybe<EducatorReviewUncheckedCreateNestedManyWithoutProfessionalInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  selfDogWash?: InputMaybe<Scalars['Boolean']['input']>;
  shopOpeningHours?: InputMaybe<ProShopOpeningHourUncheckedCreateNestedManyWithoutProInput>;
  smsBookingRemindersEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  stats?: InputMaybe<ProStatUncheckedCreateNestedManyWithoutProInput>;
  translations?: InputMaybe<ProTranslationUncheckedCreateNestedManyWithoutProInput>;
  type: ProfessionalTypeEnum;
  unclaimedProfile?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  urgencyAvailabilities?: InputMaybe<ProUrgencyAvailabilityUncheckedCreateNestedManyWithoutProInput>;
  visitAtHome?: InputMaybe<Scalars['Boolean']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  whatsappNumber?: InputMaybe<Scalars['String']['input']>;
  workers?: InputMaybe<WorkerUncheckedCreateNestedManyWithoutProInput>;
};

export type ProfessionalUncheckedCreateWithoutReviewsInput = {
  acceptedAnimals?: InputMaybe<Array<AnimalTypeEnum>>;
  acceptsNewClients?: InputMaybe<Scalars['Boolean']['input']>;
  acceptsOnlineAppointment?: InputMaybe<Scalars['Boolean']['input']>;
  addressId?: InputMaybe<Scalars['Int']['input']>;
  adminNotes?: InputMaybe<AdminNoteUncheckedCreateNestedManyWithoutProfessionalInput>;
  allowsAnyWorkerOption?: InputMaybe<Scalars['Boolean']['input']>;
  assistantsCount?: InputMaybe<Scalars['Int']['input']>;
  availabilities?: InputMaybe<ProAvailabilityUncheckedCreateNestedManyWithoutProInput>;
  bookingGroupingMaxSlotDistance?: InputMaybe<Scalars['Int']['input']>;
  centerType?: InputMaybe<CenterTypeEnum>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  defaultServiceDurationMinute?: InputMaybe<Scalars['Int']['input']>;
  degrees?: InputMaybe<ProDegreesUncheckedCreateNestedManyWithoutProInput>;
  educatorType?: InputMaybe<EducatorTypeEnum>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailHistory?: InputMaybe<EmailHistoryUncheckedCreateNestedManyWithoutProfessionalInput>;
  employeesCount?: InputMaybe<Scalars['Int']['input']>;
  forceBookingGrouping?: InputMaybe<Scalars['Boolean']['input']>;
  googleAccessToken?: InputMaybe<Scalars['String']['input']>;
  googleEmail?: InputMaybe<Scalars['String']['input']>;
  googleIdToken?: InputMaybe<Scalars['String']['input']>;
  googleRefreshToken?: InputMaybe<Scalars['String']['input']>;
  googleTokenExpiryDate?: InputMaybe<Scalars['String']['input']>;
  googleTokenScope?: InputMaybe<Scalars['String']['input']>;
  googleTokenType?: InputMaybe<Scalars['String']['input']>;
  hasShop?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  imgs?: InputMaybe<ProImgUncheckedCreateNestedManyWithoutProInput>;
  isTipawPartner?: InputMaybe<Scalars['Boolean']['input']>;
  language: Scalars['String']['input'];
  mainProFirstName?: InputMaybe<Scalars['String']['input']>;
  mainProLastName?: InputMaybe<Scalars['String']['input']>;
  maxSmsNotification?: InputMaybe<Scalars['Int']['input']>;
  maxWeeksBeforeBooking?: InputMaybe<Scalars['Int']['input']>;
  meta?: InputMaybe<Scalars['String']['input']>;
  minHoursBeforeBooking?: InputMaybe<Scalars['Int']['input']>;
  minHoursBeforeUpdateOrCancelBooking?: InputMaybe<Scalars['Int']['input']>;
  mobilePhone?: InputMaybe<Scalars['String']['input']>;
  namePro?: InputMaybe<Scalars['String']['input']>;
  notifications?: InputMaybe<NotificationUncheckedCreateNestedManyWithoutProInput>;
  onlineBookingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  orderingIndex?: InputMaybe<Scalars['Int']['input']>;
  parking?: InputMaybe<Scalars['Boolean']['input']>;
  paymentMethods?: InputMaybe<Array<Scalars['String']['input']>>;
  phone?: InputMaybe<Scalars['String']['input']>;
  practicePlaces?: InputMaybe<Array<EducatorPracticePlaceEnum>>;
  privateEmail?: InputMaybe<Scalars['String']['input']>;
  proMongoId?: InputMaybe<Scalars['String']['input']>;
  profileVideo?: InputMaybe<Scalars['String']['input']>;
  profileVideoPos?: InputMaybe<Scalars['Int']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  selfDogWash?: InputMaybe<Scalars['Boolean']['input']>;
  shopOpeningHours?: InputMaybe<ProShopOpeningHourUncheckedCreateNestedManyWithoutProInput>;
  smsBookingRemindersEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  stats?: InputMaybe<ProStatUncheckedCreateNestedManyWithoutProInput>;
  translations?: InputMaybe<ProTranslationUncheckedCreateNestedManyWithoutProInput>;
  type: ProfessionalTypeEnum;
  unclaimedProfile?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  urgencyAvailabilities?: InputMaybe<ProUrgencyAvailabilityUncheckedCreateNestedManyWithoutProInput>;
  visitAtHome?: InputMaybe<Scalars['Boolean']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  whatsappNumber?: InputMaybe<Scalars['String']['input']>;
  workers?: InputMaybe<WorkerUncheckedCreateNestedManyWithoutProInput>;
};

export type ProfessionalUncheckedCreateWithoutShopOpeningHoursInput = {
  acceptedAnimals?: InputMaybe<Array<AnimalTypeEnum>>;
  acceptsNewClients?: InputMaybe<Scalars['Boolean']['input']>;
  acceptsOnlineAppointment?: InputMaybe<Scalars['Boolean']['input']>;
  addressId?: InputMaybe<Scalars['Int']['input']>;
  adminNotes?: InputMaybe<AdminNoteUncheckedCreateNestedManyWithoutProfessionalInput>;
  allowsAnyWorkerOption?: InputMaybe<Scalars['Boolean']['input']>;
  assistantsCount?: InputMaybe<Scalars['Int']['input']>;
  availabilities?: InputMaybe<ProAvailabilityUncheckedCreateNestedManyWithoutProInput>;
  bookingGroupingMaxSlotDistance?: InputMaybe<Scalars['Int']['input']>;
  centerType?: InputMaybe<CenterTypeEnum>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  defaultServiceDurationMinute?: InputMaybe<Scalars['Int']['input']>;
  degrees?: InputMaybe<ProDegreesUncheckedCreateNestedManyWithoutProInput>;
  educatorType?: InputMaybe<EducatorTypeEnum>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailHistory?: InputMaybe<EmailHistoryUncheckedCreateNestedManyWithoutProfessionalInput>;
  employeesCount?: InputMaybe<Scalars['Int']['input']>;
  forceBookingGrouping?: InputMaybe<Scalars['Boolean']['input']>;
  googleAccessToken?: InputMaybe<Scalars['String']['input']>;
  googleEmail?: InputMaybe<Scalars['String']['input']>;
  googleIdToken?: InputMaybe<Scalars['String']['input']>;
  googleRefreshToken?: InputMaybe<Scalars['String']['input']>;
  googleTokenExpiryDate?: InputMaybe<Scalars['String']['input']>;
  googleTokenScope?: InputMaybe<Scalars['String']['input']>;
  googleTokenType?: InputMaybe<Scalars['String']['input']>;
  hasShop?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  imgs?: InputMaybe<ProImgUncheckedCreateNestedManyWithoutProInput>;
  isTipawPartner?: InputMaybe<Scalars['Boolean']['input']>;
  language: Scalars['String']['input'];
  mainProFirstName?: InputMaybe<Scalars['String']['input']>;
  mainProLastName?: InputMaybe<Scalars['String']['input']>;
  maxSmsNotification?: InputMaybe<Scalars['Int']['input']>;
  maxWeeksBeforeBooking?: InputMaybe<Scalars['Int']['input']>;
  meta?: InputMaybe<Scalars['String']['input']>;
  minHoursBeforeBooking?: InputMaybe<Scalars['Int']['input']>;
  minHoursBeforeUpdateOrCancelBooking?: InputMaybe<Scalars['Int']['input']>;
  mobilePhone?: InputMaybe<Scalars['String']['input']>;
  namePro?: InputMaybe<Scalars['String']['input']>;
  notifications?: InputMaybe<NotificationUncheckedCreateNestedManyWithoutProInput>;
  onlineBookingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  orderingIndex?: InputMaybe<Scalars['Int']['input']>;
  parking?: InputMaybe<Scalars['Boolean']['input']>;
  paymentMethods?: InputMaybe<Array<Scalars['String']['input']>>;
  phone?: InputMaybe<Scalars['String']['input']>;
  practicePlaces?: InputMaybe<Array<EducatorPracticePlaceEnum>>;
  privateEmail?: InputMaybe<Scalars['String']['input']>;
  proMongoId?: InputMaybe<Scalars['String']['input']>;
  profileVideo?: InputMaybe<Scalars['String']['input']>;
  profileVideoPos?: InputMaybe<Scalars['Int']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  reviews?: InputMaybe<EducatorReviewUncheckedCreateNestedManyWithoutProfessionalInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  selfDogWash?: InputMaybe<Scalars['Boolean']['input']>;
  smsBookingRemindersEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  stats?: InputMaybe<ProStatUncheckedCreateNestedManyWithoutProInput>;
  translations?: InputMaybe<ProTranslationUncheckedCreateNestedManyWithoutProInput>;
  type: ProfessionalTypeEnum;
  unclaimedProfile?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  urgencyAvailabilities?: InputMaybe<ProUrgencyAvailabilityUncheckedCreateNestedManyWithoutProInput>;
  visitAtHome?: InputMaybe<Scalars['Boolean']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  whatsappNumber?: InputMaybe<Scalars['String']['input']>;
  workers?: InputMaybe<WorkerUncheckedCreateNestedManyWithoutProInput>;
};

export type ProfessionalUncheckedCreateWithoutStatsInput = {
  acceptedAnimals?: InputMaybe<Array<AnimalTypeEnum>>;
  acceptsNewClients?: InputMaybe<Scalars['Boolean']['input']>;
  acceptsOnlineAppointment?: InputMaybe<Scalars['Boolean']['input']>;
  addressId?: InputMaybe<Scalars['Int']['input']>;
  adminNotes?: InputMaybe<AdminNoteUncheckedCreateNestedManyWithoutProfessionalInput>;
  allowsAnyWorkerOption?: InputMaybe<Scalars['Boolean']['input']>;
  assistantsCount?: InputMaybe<Scalars['Int']['input']>;
  availabilities?: InputMaybe<ProAvailabilityUncheckedCreateNestedManyWithoutProInput>;
  bookingGroupingMaxSlotDistance?: InputMaybe<Scalars['Int']['input']>;
  centerType?: InputMaybe<CenterTypeEnum>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  defaultServiceDurationMinute?: InputMaybe<Scalars['Int']['input']>;
  degrees?: InputMaybe<ProDegreesUncheckedCreateNestedManyWithoutProInput>;
  educatorType?: InputMaybe<EducatorTypeEnum>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailHistory?: InputMaybe<EmailHistoryUncheckedCreateNestedManyWithoutProfessionalInput>;
  employeesCount?: InputMaybe<Scalars['Int']['input']>;
  forceBookingGrouping?: InputMaybe<Scalars['Boolean']['input']>;
  googleAccessToken?: InputMaybe<Scalars['String']['input']>;
  googleEmail?: InputMaybe<Scalars['String']['input']>;
  googleIdToken?: InputMaybe<Scalars['String']['input']>;
  googleRefreshToken?: InputMaybe<Scalars['String']['input']>;
  googleTokenExpiryDate?: InputMaybe<Scalars['String']['input']>;
  googleTokenScope?: InputMaybe<Scalars['String']['input']>;
  googleTokenType?: InputMaybe<Scalars['String']['input']>;
  hasShop?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  imgs?: InputMaybe<ProImgUncheckedCreateNestedManyWithoutProInput>;
  isTipawPartner?: InputMaybe<Scalars['Boolean']['input']>;
  language: Scalars['String']['input'];
  mainProFirstName?: InputMaybe<Scalars['String']['input']>;
  mainProLastName?: InputMaybe<Scalars['String']['input']>;
  maxSmsNotification?: InputMaybe<Scalars['Int']['input']>;
  maxWeeksBeforeBooking?: InputMaybe<Scalars['Int']['input']>;
  meta?: InputMaybe<Scalars['String']['input']>;
  minHoursBeforeBooking?: InputMaybe<Scalars['Int']['input']>;
  minHoursBeforeUpdateOrCancelBooking?: InputMaybe<Scalars['Int']['input']>;
  mobilePhone?: InputMaybe<Scalars['String']['input']>;
  namePro?: InputMaybe<Scalars['String']['input']>;
  notifications?: InputMaybe<NotificationUncheckedCreateNestedManyWithoutProInput>;
  onlineBookingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  orderingIndex?: InputMaybe<Scalars['Int']['input']>;
  parking?: InputMaybe<Scalars['Boolean']['input']>;
  paymentMethods?: InputMaybe<Array<Scalars['String']['input']>>;
  phone?: InputMaybe<Scalars['String']['input']>;
  practicePlaces?: InputMaybe<Array<EducatorPracticePlaceEnum>>;
  privateEmail?: InputMaybe<Scalars['String']['input']>;
  proMongoId?: InputMaybe<Scalars['String']['input']>;
  profileVideo?: InputMaybe<Scalars['String']['input']>;
  profileVideoPos?: InputMaybe<Scalars['Int']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  reviews?: InputMaybe<EducatorReviewUncheckedCreateNestedManyWithoutProfessionalInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  selfDogWash?: InputMaybe<Scalars['Boolean']['input']>;
  shopOpeningHours?: InputMaybe<ProShopOpeningHourUncheckedCreateNestedManyWithoutProInput>;
  smsBookingRemindersEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  translations?: InputMaybe<ProTranslationUncheckedCreateNestedManyWithoutProInput>;
  type: ProfessionalTypeEnum;
  unclaimedProfile?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  urgencyAvailabilities?: InputMaybe<ProUrgencyAvailabilityUncheckedCreateNestedManyWithoutProInput>;
  visitAtHome?: InputMaybe<Scalars['Boolean']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  whatsappNumber?: InputMaybe<Scalars['String']['input']>;
  workers?: InputMaybe<WorkerUncheckedCreateNestedManyWithoutProInput>;
};

export type ProfessionalUncheckedCreateWithoutTranslationsInput = {
  acceptedAnimals?: InputMaybe<Array<AnimalTypeEnum>>;
  acceptsNewClients?: InputMaybe<Scalars['Boolean']['input']>;
  acceptsOnlineAppointment?: InputMaybe<Scalars['Boolean']['input']>;
  addressId?: InputMaybe<Scalars['Int']['input']>;
  adminNotes?: InputMaybe<AdminNoteUncheckedCreateNestedManyWithoutProfessionalInput>;
  allowsAnyWorkerOption?: InputMaybe<Scalars['Boolean']['input']>;
  assistantsCount?: InputMaybe<Scalars['Int']['input']>;
  availabilities?: InputMaybe<ProAvailabilityUncheckedCreateNestedManyWithoutProInput>;
  bookingGroupingMaxSlotDistance?: InputMaybe<Scalars['Int']['input']>;
  centerType?: InputMaybe<CenterTypeEnum>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  defaultServiceDurationMinute?: InputMaybe<Scalars['Int']['input']>;
  degrees?: InputMaybe<ProDegreesUncheckedCreateNestedManyWithoutProInput>;
  educatorType?: InputMaybe<EducatorTypeEnum>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailHistory?: InputMaybe<EmailHistoryUncheckedCreateNestedManyWithoutProfessionalInput>;
  employeesCount?: InputMaybe<Scalars['Int']['input']>;
  forceBookingGrouping?: InputMaybe<Scalars['Boolean']['input']>;
  googleAccessToken?: InputMaybe<Scalars['String']['input']>;
  googleEmail?: InputMaybe<Scalars['String']['input']>;
  googleIdToken?: InputMaybe<Scalars['String']['input']>;
  googleRefreshToken?: InputMaybe<Scalars['String']['input']>;
  googleTokenExpiryDate?: InputMaybe<Scalars['String']['input']>;
  googleTokenScope?: InputMaybe<Scalars['String']['input']>;
  googleTokenType?: InputMaybe<Scalars['String']['input']>;
  hasShop?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  imgs?: InputMaybe<ProImgUncheckedCreateNestedManyWithoutProInput>;
  isTipawPartner?: InputMaybe<Scalars['Boolean']['input']>;
  language: Scalars['String']['input'];
  mainProFirstName?: InputMaybe<Scalars['String']['input']>;
  mainProLastName?: InputMaybe<Scalars['String']['input']>;
  maxSmsNotification?: InputMaybe<Scalars['Int']['input']>;
  maxWeeksBeforeBooking?: InputMaybe<Scalars['Int']['input']>;
  meta?: InputMaybe<Scalars['String']['input']>;
  minHoursBeforeBooking?: InputMaybe<Scalars['Int']['input']>;
  minHoursBeforeUpdateOrCancelBooking?: InputMaybe<Scalars['Int']['input']>;
  mobilePhone?: InputMaybe<Scalars['String']['input']>;
  namePro?: InputMaybe<Scalars['String']['input']>;
  notifications?: InputMaybe<NotificationUncheckedCreateNestedManyWithoutProInput>;
  onlineBookingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  orderingIndex?: InputMaybe<Scalars['Int']['input']>;
  parking?: InputMaybe<Scalars['Boolean']['input']>;
  paymentMethods?: InputMaybe<Array<Scalars['String']['input']>>;
  phone?: InputMaybe<Scalars['String']['input']>;
  practicePlaces?: InputMaybe<Array<EducatorPracticePlaceEnum>>;
  privateEmail?: InputMaybe<Scalars['String']['input']>;
  proMongoId?: InputMaybe<Scalars['String']['input']>;
  profileVideo?: InputMaybe<Scalars['String']['input']>;
  profileVideoPos?: InputMaybe<Scalars['Int']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  reviews?: InputMaybe<EducatorReviewUncheckedCreateNestedManyWithoutProfessionalInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  selfDogWash?: InputMaybe<Scalars['Boolean']['input']>;
  shopOpeningHours?: InputMaybe<ProShopOpeningHourUncheckedCreateNestedManyWithoutProInput>;
  smsBookingRemindersEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  stats?: InputMaybe<ProStatUncheckedCreateNestedManyWithoutProInput>;
  type: ProfessionalTypeEnum;
  unclaimedProfile?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  urgencyAvailabilities?: InputMaybe<ProUrgencyAvailabilityUncheckedCreateNestedManyWithoutProInput>;
  visitAtHome?: InputMaybe<Scalars['Boolean']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  whatsappNumber?: InputMaybe<Scalars['String']['input']>;
  workers?: InputMaybe<WorkerUncheckedCreateNestedManyWithoutProInput>;
};

export type ProfessionalUncheckedCreateWithoutUrgencyAvailabilitiesInput = {
  acceptedAnimals?: InputMaybe<Array<AnimalTypeEnum>>;
  acceptsNewClients?: InputMaybe<Scalars['Boolean']['input']>;
  acceptsOnlineAppointment?: InputMaybe<Scalars['Boolean']['input']>;
  addressId?: InputMaybe<Scalars['Int']['input']>;
  adminNotes?: InputMaybe<AdminNoteUncheckedCreateNestedManyWithoutProfessionalInput>;
  allowsAnyWorkerOption?: InputMaybe<Scalars['Boolean']['input']>;
  assistantsCount?: InputMaybe<Scalars['Int']['input']>;
  availabilities?: InputMaybe<ProAvailabilityUncheckedCreateNestedManyWithoutProInput>;
  bookingGroupingMaxSlotDistance?: InputMaybe<Scalars['Int']['input']>;
  centerType?: InputMaybe<CenterTypeEnum>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  defaultServiceDurationMinute?: InputMaybe<Scalars['Int']['input']>;
  degrees?: InputMaybe<ProDegreesUncheckedCreateNestedManyWithoutProInput>;
  educatorType?: InputMaybe<EducatorTypeEnum>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailHistory?: InputMaybe<EmailHistoryUncheckedCreateNestedManyWithoutProfessionalInput>;
  employeesCount?: InputMaybe<Scalars['Int']['input']>;
  forceBookingGrouping?: InputMaybe<Scalars['Boolean']['input']>;
  googleAccessToken?: InputMaybe<Scalars['String']['input']>;
  googleEmail?: InputMaybe<Scalars['String']['input']>;
  googleIdToken?: InputMaybe<Scalars['String']['input']>;
  googleRefreshToken?: InputMaybe<Scalars['String']['input']>;
  googleTokenExpiryDate?: InputMaybe<Scalars['String']['input']>;
  googleTokenScope?: InputMaybe<Scalars['String']['input']>;
  googleTokenType?: InputMaybe<Scalars['String']['input']>;
  hasShop?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  imgs?: InputMaybe<ProImgUncheckedCreateNestedManyWithoutProInput>;
  isTipawPartner?: InputMaybe<Scalars['Boolean']['input']>;
  language: Scalars['String']['input'];
  mainProFirstName?: InputMaybe<Scalars['String']['input']>;
  mainProLastName?: InputMaybe<Scalars['String']['input']>;
  maxSmsNotification?: InputMaybe<Scalars['Int']['input']>;
  maxWeeksBeforeBooking?: InputMaybe<Scalars['Int']['input']>;
  meta?: InputMaybe<Scalars['String']['input']>;
  minHoursBeforeBooking?: InputMaybe<Scalars['Int']['input']>;
  minHoursBeforeUpdateOrCancelBooking?: InputMaybe<Scalars['Int']['input']>;
  mobilePhone?: InputMaybe<Scalars['String']['input']>;
  namePro?: InputMaybe<Scalars['String']['input']>;
  notifications?: InputMaybe<NotificationUncheckedCreateNestedManyWithoutProInput>;
  onlineBookingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  orderingIndex?: InputMaybe<Scalars['Int']['input']>;
  parking?: InputMaybe<Scalars['Boolean']['input']>;
  paymentMethods?: InputMaybe<Array<Scalars['String']['input']>>;
  phone?: InputMaybe<Scalars['String']['input']>;
  practicePlaces?: InputMaybe<Array<EducatorPracticePlaceEnum>>;
  privateEmail?: InputMaybe<Scalars['String']['input']>;
  proMongoId?: InputMaybe<Scalars['String']['input']>;
  profileVideo?: InputMaybe<Scalars['String']['input']>;
  profileVideoPos?: InputMaybe<Scalars['Int']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  reviews?: InputMaybe<EducatorReviewUncheckedCreateNestedManyWithoutProfessionalInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  selfDogWash?: InputMaybe<Scalars['Boolean']['input']>;
  shopOpeningHours?: InputMaybe<ProShopOpeningHourUncheckedCreateNestedManyWithoutProInput>;
  smsBookingRemindersEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  stats?: InputMaybe<ProStatUncheckedCreateNestedManyWithoutProInput>;
  translations?: InputMaybe<ProTranslationUncheckedCreateNestedManyWithoutProInput>;
  type: ProfessionalTypeEnum;
  unclaimedProfile?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  visitAtHome?: InputMaybe<Scalars['Boolean']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  whatsappNumber?: InputMaybe<Scalars['String']['input']>;
  workers?: InputMaybe<WorkerUncheckedCreateNestedManyWithoutProInput>;
};

export type ProfessionalUncheckedCreateWithoutWorkersInput = {
  acceptedAnimals?: InputMaybe<Array<AnimalTypeEnum>>;
  acceptsNewClients?: InputMaybe<Scalars['Boolean']['input']>;
  acceptsOnlineAppointment?: InputMaybe<Scalars['Boolean']['input']>;
  addressId?: InputMaybe<Scalars['Int']['input']>;
  adminNotes?: InputMaybe<AdminNoteUncheckedCreateNestedManyWithoutProfessionalInput>;
  allowsAnyWorkerOption?: InputMaybe<Scalars['Boolean']['input']>;
  assistantsCount?: InputMaybe<Scalars['Int']['input']>;
  availabilities?: InputMaybe<ProAvailabilityUncheckedCreateNestedManyWithoutProInput>;
  bookingGroupingMaxSlotDistance?: InputMaybe<Scalars['Int']['input']>;
  centerType?: InputMaybe<CenterTypeEnum>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  defaultServiceDurationMinute?: InputMaybe<Scalars['Int']['input']>;
  degrees?: InputMaybe<ProDegreesUncheckedCreateNestedManyWithoutProInput>;
  educatorType?: InputMaybe<EducatorTypeEnum>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailHistory?: InputMaybe<EmailHistoryUncheckedCreateNestedManyWithoutProfessionalInput>;
  employeesCount?: InputMaybe<Scalars['Int']['input']>;
  forceBookingGrouping?: InputMaybe<Scalars['Boolean']['input']>;
  googleAccessToken?: InputMaybe<Scalars['String']['input']>;
  googleEmail?: InputMaybe<Scalars['String']['input']>;
  googleIdToken?: InputMaybe<Scalars['String']['input']>;
  googleRefreshToken?: InputMaybe<Scalars['String']['input']>;
  googleTokenExpiryDate?: InputMaybe<Scalars['String']['input']>;
  googleTokenScope?: InputMaybe<Scalars['String']['input']>;
  googleTokenType?: InputMaybe<Scalars['String']['input']>;
  hasShop?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  imgs?: InputMaybe<ProImgUncheckedCreateNestedManyWithoutProInput>;
  isTipawPartner?: InputMaybe<Scalars['Boolean']['input']>;
  language: Scalars['String']['input'];
  mainProFirstName?: InputMaybe<Scalars['String']['input']>;
  mainProLastName?: InputMaybe<Scalars['String']['input']>;
  maxSmsNotification?: InputMaybe<Scalars['Int']['input']>;
  maxWeeksBeforeBooking?: InputMaybe<Scalars['Int']['input']>;
  meta?: InputMaybe<Scalars['String']['input']>;
  minHoursBeforeBooking?: InputMaybe<Scalars['Int']['input']>;
  minHoursBeforeUpdateOrCancelBooking?: InputMaybe<Scalars['Int']['input']>;
  mobilePhone?: InputMaybe<Scalars['String']['input']>;
  namePro?: InputMaybe<Scalars['String']['input']>;
  notifications?: InputMaybe<NotificationUncheckedCreateNestedManyWithoutProInput>;
  onlineBookingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  orderingIndex?: InputMaybe<Scalars['Int']['input']>;
  parking?: InputMaybe<Scalars['Boolean']['input']>;
  paymentMethods?: InputMaybe<Array<Scalars['String']['input']>>;
  phone?: InputMaybe<Scalars['String']['input']>;
  practicePlaces?: InputMaybe<Array<EducatorPracticePlaceEnum>>;
  privateEmail?: InputMaybe<Scalars['String']['input']>;
  proMongoId?: InputMaybe<Scalars['String']['input']>;
  profileVideo?: InputMaybe<Scalars['String']['input']>;
  profileVideoPos?: InputMaybe<Scalars['Int']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  reviews?: InputMaybe<EducatorReviewUncheckedCreateNestedManyWithoutProfessionalInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  selfDogWash?: InputMaybe<Scalars['Boolean']['input']>;
  shopOpeningHours?: InputMaybe<ProShopOpeningHourUncheckedCreateNestedManyWithoutProInput>;
  smsBookingRemindersEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  stats?: InputMaybe<ProStatUncheckedCreateNestedManyWithoutProInput>;
  translations?: InputMaybe<ProTranslationUncheckedCreateNestedManyWithoutProInput>;
  type: ProfessionalTypeEnum;
  unclaimedProfile?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  urgencyAvailabilities?: InputMaybe<ProUrgencyAvailabilityUncheckedCreateNestedManyWithoutProInput>;
  visitAtHome?: InputMaybe<Scalars['Boolean']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  whatsappNumber?: InputMaybe<Scalars['String']['input']>;
};

export type ProfessionalUncheckedUpdateInput = {
  acceptedAnimals?: InputMaybe<Array<AnimalTypeEnum>>;
  acceptsNewClients?: InputMaybe<BoolFieldUpdateOperationsInput>;
  acceptsOnlineAppointment?: InputMaybe<BoolFieldUpdateOperationsInput>;
  addressId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  adminNotes?: InputMaybe<AdminNoteUncheckedUpdateManyWithoutProfessionalNestedInput>;
  allowsAnyWorkerOption?: InputMaybe<BoolFieldUpdateOperationsInput>;
  assistantsCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  availabilities?: InputMaybe<ProAvailabilityUncheckedUpdateManyWithoutProNestedInput>;
  bookingGroupingMaxSlotDistance?: InputMaybe<IntFieldUpdateOperationsInput>;
  centerType?: InputMaybe<NullableEnumCenterTypeEnumFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  defaultServiceDurationMinute?: InputMaybe<IntFieldUpdateOperationsInput>;
  degrees?: InputMaybe<ProDegreesUncheckedUpdateManyWithoutProNestedInput>;
  educatorType?: InputMaybe<NullableEnumEducatorTypeEnumFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailHistory?: InputMaybe<EmailHistoryUncheckedUpdateManyWithoutProfessionalNestedInput>;
  employeesCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  forceBookingGrouping?: InputMaybe<BoolFieldUpdateOperationsInput>;
  googleAccessToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleIdToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleRefreshToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleTokenExpiryDate?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleTokenScope?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleTokenType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hasShop?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  imgs?: InputMaybe<ProImgUncheckedUpdateManyWithoutProNestedInput>;
  isTipawPartner?: InputMaybe<BoolFieldUpdateOperationsInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  mainProFirstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainProLastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  maxSmsNotification?: InputMaybe<IntFieldUpdateOperationsInput>;
  maxWeeksBeforeBooking?: InputMaybe<IntFieldUpdateOperationsInput>;
  meta?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  minHoursBeforeBooking?: InputMaybe<IntFieldUpdateOperationsInput>;
  minHoursBeforeUpdateOrCancelBooking?: InputMaybe<IntFieldUpdateOperationsInput>;
  mobilePhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  namePro?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUncheckedUpdateManyWithoutProNestedInput>;
  onlineBookingEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  orderingIndex?: InputMaybe<IntFieldUpdateOperationsInput>;
  parking?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  paymentMethods?: InputMaybe<Array<Scalars['String']['input']>>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  practicePlaces?: InputMaybe<Array<EducatorPracticePlaceEnum>>;
  privateEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  proMongoId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  profileVideo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  profileVideoPos?: InputMaybe<IntFieldUpdateOperationsInput>;
  published?: InputMaybe<BoolFieldUpdateOperationsInput>;
  reviews?: InputMaybe<EducatorReviewUncheckedUpdateManyWithoutProfessionalNestedInput>;
  searchString?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  selfDogWash?: InputMaybe<BoolFieldUpdateOperationsInput>;
  shopOpeningHours?: InputMaybe<ProShopOpeningHourUncheckedUpdateManyWithoutProNestedInput>;
  smsBookingRemindersEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  stats?: InputMaybe<ProStatUncheckedUpdateManyWithoutProNestedInput>;
  translations?: InputMaybe<ProTranslationUncheckedUpdateManyWithoutProNestedInput>;
  type?: InputMaybe<EnumProfessionalTypeEnumFieldUpdateOperationsInput>;
  unclaimedProfile?: InputMaybe<BoolFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  urgencyAvailabilities?: InputMaybe<ProUrgencyAvailabilityUncheckedUpdateManyWithoutProNestedInput>;
  visitAtHome?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whatsappNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  workers?: InputMaybe<WorkerUncheckedUpdateManyWithoutProNestedInput>;
};

export type ProfessionalUncheckedUpdateManyInput = {
  acceptedAnimals?: InputMaybe<Array<AnimalTypeEnum>>;
  acceptsNewClients?: InputMaybe<BoolFieldUpdateOperationsInput>;
  acceptsOnlineAppointment?: InputMaybe<BoolFieldUpdateOperationsInput>;
  addressId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  allowsAnyWorkerOption?: InputMaybe<BoolFieldUpdateOperationsInput>;
  assistantsCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  bookingGroupingMaxSlotDistance?: InputMaybe<IntFieldUpdateOperationsInput>;
  centerType?: InputMaybe<NullableEnumCenterTypeEnumFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  defaultServiceDurationMinute?: InputMaybe<IntFieldUpdateOperationsInput>;
  educatorType?: InputMaybe<NullableEnumEducatorTypeEnumFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  employeesCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  forceBookingGrouping?: InputMaybe<BoolFieldUpdateOperationsInput>;
  googleAccessToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleIdToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleRefreshToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleTokenExpiryDate?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleTokenScope?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleTokenType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hasShop?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  isTipawPartner?: InputMaybe<BoolFieldUpdateOperationsInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  mainProFirstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainProLastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  maxSmsNotification?: InputMaybe<IntFieldUpdateOperationsInput>;
  maxWeeksBeforeBooking?: InputMaybe<IntFieldUpdateOperationsInput>;
  meta?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  minHoursBeforeBooking?: InputMaybe<IntFieldUpdateOperationsInput>;
  minHoursBeforeUpdateOrCancelBooking?: InputMaybe<IntFieldUpdateOperationsInput>;
  mobilePhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  namePro?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  onlineBookingEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  orderingIndex?: InputMaybe<IntFieldUpdateOperationsInput>;
  parking?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  paymentMethods?: InputMaybe<Array<Scalars['String']['input']>>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  practicePlaces?: InputMaybe<Array<EducatorPracticePlaceEnum>>;
  privateEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  proMongoId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  profileVideo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  profileVideoPos?: InputMaybe<IntFieldUpdateOperationsInput>;
  published?: InputMaybe<BoolFieldUpdateOperationsInput>;
  searchString?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  selfDogWash?: InputMaybe<BoolFieldUpdateOperationsInput>;
  smsBookingRemindersEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<EnumProfessionalTypeEnumFieldUpdateOperationsInput>;
  unclaimedProfile?: InputMaybe<BoolFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  visitAtHome?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whatsappNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ProfessionalUncheckedUpdateOneWithoutAddressNestedInput = {
  connect?: InputMaybe<ProfessionalWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProfessionalCreateOrConnectWithoutAddressInput>;
  create?: InputMaybe<ProfessionalCreateWithoutAddressInput>;
  delete?: InputMaybe<ProfessionalWhereInput>;
  disconnect?: InputMaybe<ProfessionalWhereInput>;
  update?: InputMaybe<ProfessionalUpdateToOneWithWhereWithoutAddressInput>;
  upsert?: InputMaybe<ProfessionalUpsertWithoutAddressInput>;
};

export type ProfessionalUncheckedUpdateWithoutAddressInput = {
  acceptedAnimals?: InputMaybe<Array<AnimalTypeEnum>>;
  acceptsNewClients?: InputMaybe<BoolFieldUpdateOperationsInput>;
  acceptsOnlineAppointment?: InputMaybe<BoolFieldUpdateOperationsInput>;
  adminNotes?: InputMaybe<AdminNoteUncheckedUpdateManyWithoutProfessionalNestedInput>;
  allowsAnyWorkerOption?: InputMaybe<BoolFieldUpdateOperationsInput>;
  assistantsCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  availabilities?: InputMaybe<ProAvailabilityUncheckedUpdateManyWithoutProNestedInput>;
  bookingGroupingMaxSlotDistance?: InputMaybe<IntFieldUpdateOperationsInput>;
  centerType?: InputMaybe<NullableEnumCenterTypeEnumFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  defaultServiceDurationMinute?: InputMaybe<IntFieldUpdateOperationsInput>;
  degrees?: InputMaybe<ProDegreesUncheckedUpdateManyWithoutProNestedInput>;
  educatorType?: InputMaybe<NullableEnumEducatorTypeEnumFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailHistory?: InputMaybe<EmailHistoryUncheckedUpdateManyWithoutProfessionalNestedInput>;
  employeesCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  forceBookingGrouping?: InputMaybe<BoolFieldUpdateOperationsInput>;
  googleAccessToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleIdToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleRefreshToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleTokenExpiryDate?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleTokenScope?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleTokenType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hasShop?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  imgs?: InputMaybe<ProImgUncheckedUpdateManyWithoutProNestedInput>;
  isTipawPartner?: InputMaybe<BoolFieldUpdateOperationsInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  mainProFirstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainProLastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  maxSmsNotification?: InputMaybe<IntFieldUpdateOperationsInput>;
  maxWeeksBeforeBooking?: InputMaybe<IntFieldUpdateOperationsInput>;
  meta?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  minHoursBeforeBooking?: InputMaybe<IntFieldUpdateOperationsInput>;
  minHoursBeforeUpdateOrCancelBooking?: InputMaybe<IntFieldUpdateOperationsInput>;
  mobilePhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  namePro?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUncheckedUpdateManyWithoutProNestedInput>;
  onlineBookingEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  orderingIndex?: InputMaybe<IntFieldUpdateOperationsInput>;
  parking?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  paymentMethods?: InputMaybe<Array<Scalars['String']['input']>>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  practicePlaces?: InputMaybe<Array<EducatorPracticePlaceEnum>>;
  privateEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  proMongoId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  profileVideo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  profileVideoPos?: InputMaybe<IntFieldUpdateOperationsInput>;
  published?: InputMaybe<BoolFieldUpdateOperationsInput>;
  reviews?: InputMaybe<EducatorReviewUncheckedUpdateManyWithoutProfessionalNestedInput>;
  searchString?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  selfDogWash?: InputMaybe<BoolFieldUpdateOperationsInput>;
  shopOpeningHours?: InputMaybe<ProShopOpeningHourUncheckedUpdateManyWithoutProNestedInput>;
  smsBookingRemindersEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  stats?: InputMaybe<ProStatUncheckedUpdateManyWithoutProNestedInput>;
  translations?: InputMaybe<ProTranslationUncheckedUpdateManyWithoutProNestedInput>;
  type?: InputMaybe<EnumProfessionalTypeEnumFieldUpdateOperationsInput>;
  unclaimedProfile?: InputMaybe<BoolFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  urgencyAvailabilities?: InputMaybe<ProUrgencyAvailabilityUncheckedUpdateManyWithoutProNestedInput>;
  visitAtHome?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whatsappNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  workers?: InputMaybe<WorkerUncheckedUpdateManyWithoutProNestedInput>;
};

export type ProfessionalUncheckedUpdateWithoutAdminNotesInput = {
  acceptedAnimals?: InputMaybe<Array<AnimalTypeEnum>>;
  acceptsNewClients?: InputMaybe<BoolFieldUpdateOperationsInput>;
  acceptsOnlineAppointment?: InputMaybe<BoolFieldUpdateOperationsInput>;
  addressId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  allowsAnyWorkerOption?: InputMaybe<BoolFieldUpdateOperationsInput>;
  assistantsCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  availabilities?: InputMaybe<ProAvailabilityUncheckedUpdateManyWithoutProNestedInput>;
  bookingGroupingMaxSlotDistance?: InputMaybe<IntFieldUpdateOperationsInput>;
  centerType?: InputMaybe<NullableEnumCenterTypeEnumFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  defaultServiceDurationMinute?: InputMaybe<IntFieldUpdateOperationsInput>;
  degrees?: InputMaybe<ProDegreesUncheckedUpdateManyWithoutProNestedInput>;
  educatorType?: InputMaybe<NullableEnumEducatorTypeEnumFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailHistory?: InputMaybe<EmailHistoryUncheckedUpdateManyWithoutProfessionalNestedInput>;
  employeesCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  forceBookingGrouping?: InputMaybe<BoolFieldUpdateOperationsInput>;
  googleAccessToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleIdToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleRefreshToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleTokenExpiryDate?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleTokenScope?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleTokenType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hasShop?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  imgs?: InputMaybe<ProImgUncheckedUpdateManyWithoutProNestedInput>;
  isTipawPartner?: InputMaybe<BoolFieldUpdateOperationsInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  mainProFirstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainProLastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  maxSmsNotification?: InputMaybe<IntFieldUpdateOperationsInput>;
  maxWeeksBeforeBooking?: InputMaybe<IntFieldUpdateOperationsInput>;
  meta?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  minHoursBeforeBooking?: InputMaybe<IntFieldUpdateOperationsInput>;
  minHoursBeforeUpdateOrCancelBooking?: InputMaybe<IntFieldUpdateOperationsInput>;
  mobilePhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  namePro?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUncheckedUpdateManyWithoutProNestedInput>;
  onlineBookingEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  orderingIndex?: InputMaybe<IntFieldUpdateOperationsInput>;
  parking?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  paymentMethods?: InputMaybe<Array<Scalars['String']['input']>>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  practicePlaces?: InputMaybe<Array<EducatorPracticePlaceEnum>>;
  privateEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  proMongoId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  profileVideo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  profileVideoPos?: InputMaybe<IntFieldUpdateOperationsInput>;
  published?: InputMaybe<BoolFieldUpdateOperationsInput>;
  reviews?: InputMaybe<EducatorReviewUncheckedUpdateManyWithoutProfessionalNestedInput>;
  searchString?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  selfDogWash?: InputMaybe<BoolFieldUpdateOperationsInput>;
  shopOpeningHours?: InputMaybe<ProShopOpeningHourUncheckedUpdateManyWithoutProNestedInput>;
  smsBookingRemindersEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  stats?: InputMaybe<ProStatUncheckedUpdateManyWithoutProNestedInput>;
  translations?: InputMaybe<ProTranslationUncheckedUpdateManyWithoutProNestedInput>;
  type?: InputMaybe<EnumProfessionalTypeEnumFieldUpdateOperationsInput>;
  unclaimedProfile?: InputMaybe<BoolFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  urgencyAvailabilities?: InputMaybe<ProUrgencyAvailabilityUncheckedUpdateManyWithoutProNestedInput>;
  visitAtHome?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whatsappNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  workers?: InputMaybe<WorkerUncheckedUpdateManyWithoutProNestedInput>;
};

export type ProfessionalUncheckedUpdateWithoutAvailabilitiesInput = {
  acceptedAnimals?: InputMaybe<Array<AnimalTypeEnum>>;
  acceptsNewClients?: InputMaybe<BoolFieldUpdateOperationsInput>;
  acceptsOnlineAppointment?: InputMaybe<BoolFieldUpdateOperationsInput>;
  addressId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  adminNotes?: InputMaybe<AdminNoteUncheckedUpdateManyWithoutProfessionalNestedInput>;
  allowsAnyWorkerOption?: InputMaybe<BoolFieldUpdateOperationsInput>;
  assistantsCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  bookingGroupingMaxSlotDistance?: InputMaybe<IntFieldUpdateOperationsInput>;
  centerType?: InputMaybe<NullableEnumCenterTypeEnumFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  defaultServiceDurationMinute?: InputMaybe<IntFieldUpdateOperationsInput>;
  degrees?: InputMaybe<ProDegreesUncheckedUpdateManyWithoutProNestedInput>;
  educatorType?: InputMaybe<NullableEnumEducatorTypeEnumFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailHistory?: InputMaybe<EmailHistoryUncheckedUpdateManyWithoutProfessionalNestedInput>;
  employeesCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  forceBookingGrouping?: InputMaybe<BoolFieldUpdateOperationsInput>;
  googleAccessToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleIdToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleRefreshToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleTokenExpiryDate?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleTokenScope?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleTokenType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hasShop?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  imgs?: InputMaybe<ProImgUncheckedUpdateManyWithoutProNestedInput>;
  isTipawPartner?: InputMaybe<BoolFieldUpdateOperationsInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  mainProFirstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainProLastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  maxSmsNotification?: InputMaybe<IntFieldUpdateOperationsInput>;
  maxWeeksBeforeBooking?: InputMaybe<IntFieldUpdateOperationsInput>;
  meta?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  minHoursBeforeBooking?: InputMaybe<IntFieldUpdateOperationsInput>;
  minHoursBeforeUpdateOrCancelBooking?: InputMaybe<IntFieldUpdateOperationsInput>;
  mobilePhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  namePro?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUncheckedUpdateManyWithoutProNestedInput>;
  onlineBookingEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  orderingIndex?: InputMaybe<IntFieldUpdateOperationsInput>;
  parking?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  paymentMethods?: InputMaybe<Array<Scalars['String']['input']>>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  practicePlaces?: InputMaybe<Array<EducatorPracticePlaceEnum>>;
  privateEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  proMongoId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  profileVideo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  profileVideoPos?: InputMaybe<IntFieldUpdateOperationsInput>;
  published?: InputMaybe<BoolFieldUpdateOperationsInput>;
  reviews?: InputMaybe<EducatorReviewUncheckedUpdateManyWithoutProfessionalNestedInput>;
  searchString?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  selfDogWash?: InputMaybe<BoolFieldUpdateOperationsInput>;
  shopOpeningHours?: InputMaybe<ProShopOpeningHourUncheckedUpdateManyWithoutProNestedInput>;
  smsBookingRemindersEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  stats?: InputMaybe<ProStatUncheckedUpdateManyWithoutProNestedInput>;
  translations?: InputMaybe<ProTranslationUncheckedUpdateManyWithoutProNestedInput>;
  type?: InputMaybe<EnumProfessionalTypeEnumFieldUpdateOperationsInput>;
  unclaimedProfile?: InputMaybe<BoolFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  urgencyAvailabilities?: InputMaybe<ProUrgencyAvailabilityUncheckedUpdateManyWithoutProNestedInput>;
  visitAtHome?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whatsappNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  workers?: InputMaybe<WorkerUncheckedUpdateManyWithoutProNestedInput>;
};

export type ProfessionalUncheckedUpdateWithoutDegreesInput = {
  acceptedAnimals?: InputMaybe<Array<AnimalTypeEnum>>;
  acceptsNewClients?: InputMaybe<BoolFieldUpdateOperationsInput>;
  acceptsOnlineAppointment?: InputMaybe<BoolFieldUpdateOperationsInput>;
  addressId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  adminNotes?: InputMaybe<AdminNoteUncheckedUpdateManyWithoutProfessionalNestedInput>;
  allowsAnyWorkerOption?: InputMaybe<BoolFieldUpdateOperationsInput>;
  assistantsCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  availabilities?: InputMaybe<ProAvailabilityUncheckedUpdateManyWithoutProNestedInput>;
  bookingGroupingMaxSlotDistance?: InputMaybe<IntFieldUpdateOperationsInput>;
  centerType?: InputMaybe<NullableEnumCenterTypeEnumFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  defaultServiceDurationMinute?: InputMaybe<IntFieldUpdateOperationsInput>;
  educatorType?: InputMaybe<NullableEnumEducatorTypeEnumFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailHistory?: InputMaybe<EmailHistoryUncheckedUpdateManyWithoutProfessionalNestedInput>;
  employeesCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  forceBookingGrouping?: InputMaybe<BoolFieldUpdateOperationsInput>;
  googleAccessToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleIdToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleRefreshToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleTokenExpiryDate?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleTokenScope?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleTokenType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hasShop?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  imgs?: InputMaybe<ProImgUncheckedUpdateManyWithoutProNestedInput>;
  isTipawPartner?: InputMaybe<BoolFieldUpdateOperationsInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  mainProFirstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainProLastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  maxSmsNotification?: InputMaybe<IntFieldUpdateOperationsInput>;
  maxWeeksBeforeBooking?: InputMaybe<IntFieldUpdateOperationsInput>;
  meta?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  minHoursBeforeBooking?: InputMaybe<IntFieldUpdateOperationsInput>;
  minHoursBeforeUpdateOrCancelBooking?: InputMaybe<IntFieldUpdateOperationsInput>;
  mobilePhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  namePro?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUncheckedUpdateManyWithoutProNestedInput>;
  onlineBookingEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  orderingIndex?: InputMaybe<IntFieldUpdateOperationsInput>;
  parking?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  paymentMethods?: InputMaybe<Array<Scalars['String']['input']>>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  practicePlaces?: InputMaybe<Array<EducatorPracticePlaceEnum>>;
  privateEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  proMongoId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  profileVideo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  profileVideoPos?: InputMaybe<IntFieldUpdateOperationsInput>;
  published?: InputMaybe<BoolFieldUpdateOperationsInput>;
  reviews?: InputMaybe<EducatorReviewUncheckedUpdateManyWithoutProfessionalNestedInput>;
  searchString?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  selfDogWash?: InputMaybe<BoolFieldUpdateOperationsInput>;
  shopOpeningHours?: InputMaybe<ProShopOpeningHourUncheckedUpdateManyWithoutProNestedInput>;
  smsBookingRemindersEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  stats?: InputMaybe<ProStatUncheckedUpdateManyWithoutProNestedInput>;
  translations?: InputMaybe<ProTranslationUncheckedUpdateManyWithoutProNestedInput>;
  type?: InputMaybe<EnumProfessionalTypeEnumFieldUpdateOperationsInput>;
  unclaimedProfile?: InputMaybe<BoolFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  urgencyAvailabilities?: InputMaybe<ProUrgencyAvailabilityUncheckedUpdateManyWithoutProNestedInput>;
  visitAtHome?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whatsappNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  workers?: InputMaybe<WorkerUncheckedUpdateManyWithoutProNestedInput>;
};

export type ProfessionalUncheckedUpdateWithoutEmailHistoryInput = {
  acceptedAnimals?: InputMaybe<Array<AnimalTypeEnum>>;
  acceptsNewClients?: InputMaybe<BoolFieldUpdateOperationsInput>;
  acceptsOnlineAppointment?: InputMaybe<BoolFieldUpdateOperationsInput>;
  addressId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  adminNotes?: InputMaybe<AdminNoteUncheckedUpdateManyWithoutProfessionalNestedInput>;
  allowsAnyWorkerOption?: InputMaybe<BoolFieldUpdateOperationsInput>;
  assistantsCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  availabilities?: InputMaybe<ProAvailabilityUncheckedUpdateManyWithoutProNestedInput>;
  bookingGroupingMaxSlotDistance?: InputMaybe<IntFieldUpdateOperationsInput>;
  centerType?: InputMaybe<NullableEnumCenterTypeEnumFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  defaultServiceDurationMinute?: InputMaybe<IntFieldUpdateOperationsInput>;
  degrees?: InputMaybe<ProDegreesUncheckedUpdateManyWithoutProNestedInput>;
  educatorType?: InputMaybe<NullableEnumEducatorTypeEnumFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  employeesCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  forceBookingGrouping?: InputMaybe<BoolFieldUpdateOperationsInput>;
  googleAccessToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleIdToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleRefreshToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleTokenExpiryDate?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleTokenScope?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleTokenType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hasShop?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  imgs?: InputMaybe<ProImgUncheckedUpdateManyWithoutProNestedInput>;
  isTipawPartner?: InputMaybe<BoolFieldUpdateOperationsInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  mainProFirstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainProLastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  maxSmsNotification?: InputMaybe<IntFieldUpdateOperationsInput>;
  maxWeeksBeforeBooking?: InputMaybe<IntFieldUpdateOperationsInput>;
  meta?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  minHoursBeforeBooking?: InputMaybe<IntFieldUpdateOperationsInput>;
  minHoursBeforeUpdateOrCancelBooking?: InputMaybe<IntFieldUpdateOperationsInput>;
  mobilePhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  namePro?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUncheckedUpdateManyWithoutProNestedInput>;
  onlineBookingEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  orderingIndex?: InputMaybe<IntFieldUpdateOperationsInput>;
  parking?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  paymentMethods?: InputMaybe<Array<Scalars['String']['input']>>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  practicePlaces?: InputMaybe<Array<EducatorPracticePlaceEnum>>;
  privateEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  proMongoId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  profileVideo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  profileVideoPos?: InputMaybe<IntFieldUpdateOperationsInput>;
  published?: InputMaybe<BoolFieldUpdateOperationsInput>;
  reviews?: InputMaybe<EducatorReviewUncheckedUpdateManyWithoutProfessionalNestedInput>;
  searchString?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  selfDogWash?: InputMaybe<BoolFieldUpdateOperationsInput>;
  shopOpeningHours?: InputMaybe<ProShopOpeningHourUncheckedUpdateManyWithoutProNestedInput>;
  smsBookingRemindersEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  stats?: InputMaybe<ProStatUncheckedUpdateManyWithoutProNestedInput>;
  translations?: InputMaybe<ProTranslationUncheckedUpdateManyWithoutProNestedInput>;
  type?: InputMaybe<EnumProfessionalTypeEnumFieldUpdateOperationsInput>;
  unclaimedProfile?: InputMaybe<BoolFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  urgencyAvailabilities?: InputMaybe<ProUrgencyAvailabilityUncheckedUpdateManyWithoutProNestedInput>;
  visitAtHome?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whatsappNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  workers?: InputMaybe<WorkerUncheckedUpdateManyWithoutProNestedInput>;
};

export type ProfessionalUncheckedUpdateWithoutImgsInput = {
  acceptedAnimals?: InputMaybe<Array<AnimalTypeEnum>>;
  acceptsNewClients?: InputMaybe<BoolFieldUpdateOperationsInput>;
  acceptsOnlineAppointment?: InputMaybe<BoolFieldUpdateOperationsInput>;
  addressId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  adminNotes?: InputMaybe<AdminNoteUncheckedUpdateManyWithoutProfessionalNestedInput>;
  allowsAnyWorkerOption?: InputMaybe<BoolFieldUpdateOperationsInput>;
  assistantsCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  availabilities?: InputMaybe<ProAvailabilityUncheckedUpdateManyWithoutProNestedInput>;
  bookingGroupingMaxSlotDistance?: InputMaybe<IntFieldUpdateOperationsInput>;
  centerType?: InputMaybe<NullableEnumCenterTypeEnumFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  defaultServiceDurationMinute?: InputMaybe<IntFieldUpdateOperationsInput>;
  degrees?: InputMaybe<ProDegreesUncheckedUpdateManyWithoutProNestedInput>;
  educatorType?: InputMaybe<NullableEnumEducatorTypeEnumFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailHistory?: InputMaybe<EmailHistoryUncheckedUpdateManyWithoutProfessionalNestedInput>;
  employeesCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  forceBookingGrouping?: InputMaybe<BoolFieldUpdateOperationsInput>;
  googleAccessToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleIdToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleRefreshToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleTokenExpiryDate?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleTokenScope?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleTokenType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hasShop?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  isTipawPartner?: InputMaybe<BoolFieldUpdateOperationsInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  mainProFirstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainProLastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  maxSmsNotification?: InputMaybe<IntFieldUpdateOperationsInput>;
  maxWeeksBeforeBooking?: InputMaybe<IntFieldUpdateOperationsInput>;
  meta?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  minHoursBeforeBooking?: InputMaybe<IntFieldUpdateOperationsInput>;
  minHoursBeforeUpdateOrCancelBooking?: InputMaybe<IntFieldUpdateOperationsInput>;
  mobilePhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  namePro?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUncheckedUpdateManyWithoutProNestedInput>;
  onlineBookingEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  orderingIndex?: InputMaybe<IntFieldUpdateOperationsInput>;
  parking?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  paymentMethods?: InputMaybe<Array<Scalars['String']['input']>>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  practicePlaces?: InputMaybe<Array<EducatorPracticePlaceEnum>>;
  privateEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  proMongoId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  profileVideo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  profileVideoPos?: InputMaybe<IntFieldUpdateOperationsInput>;
  published?: InputMaybe<BoolFieldUpdateOperationsInput>;
  reviews?: InputMaybe<EducatorReviewUncheckedUpdateManyWithoutProfessionalNestedInput>;
  searchString?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  selfDogWash?: InputMaybe<BoolFieldUpdateOperationsInput>;
  shopOpeningHours?: InputMaybe<ProShopOpeningHourUncheckedUpdateManyWithoutProNestedInput>;
  smsBookingRemindersEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  stats?: InputMaybe<ProStatUncheckedUpdateManyWithoutProNestedInput>;
  translations?: InputMaybe<ProTranslationUncheckedUpdateManyWithoutProNestedInput>;
  type?: InputMaybe<EnumProfessionalTypeEnumFieldUpdateOperationsInput>;
  unclaimedProfile?: InputMaybe<BoolFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  urgencyAvailabilities?: InputMaybe<ProUrgencyAvailabilityUncheckedUpdateManyWithoutProNestedInput>;
  visitAtHome?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whatsappNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  workers?: InputMaybe<WorkerUncheckedUpdateManyWithoutProNestedInput>;
};

export type ProfessionalUncheckedUpdateWithoutNotificationsInput = {
  acceptedAnimals?: InputMaybe<Array<AnimalTypeEnum>>;
  acceptsNewClients?: InputMaybe<BoolFieldUpdateOperationsInput>;
  acceptsOnlineAppointment?: InputMaybe<BoolFieldUpdateOperationsInput>;
  addressId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  adminNotes?: InputMaybe<AdminNoteUncheckedUpdateManyWithoutProfessionalNestedInput>;
  allowsAnyWorkerOption?: InputMaybe<BoolFieldUpdateOperationsInput>;
  assistantsCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  availabilities?: InputMaybe<ProAvailabilityUncheckedUpdateManyWithoutProNestedInput>;
  bookingGroupingMaxSlotDistance?: InputMaybe<IntFieldUpdateOperationsInput>;
  centerType?: InputMaybe<NullableEnumCenterTypeEnumFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  defaultServiceDurationMinute?: InputMaybe<IntFieldUpdateOperationsInput>;
  degrees?: InputMaybe<ProDegreesUncheckedUpdateManyWithoutProNestedInput>;
  educatorType?: InputMaybe<NullableEnumEducatorTypeEnumFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailHistory?: InputMaybe<EmailHistoryUncheckedUpdateManyWithoutProfessionalNestedInput>;
  employeesCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  forceBookingGrouping?: InputMaybe<BoolFieldUpdateOperationsInput>;
  googleAccessToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleIdToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleRefreshToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleTokenExpiryDate?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleTokenScope?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleTokenType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hasShop?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  imgs?: InputMaybe<ProImgUncheckedUpdateManyWithoutProNestedInput>;
  isTipawPartner?: InputMaybe<BoolFieldUpdateOperationsInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  mainProFirstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainProLastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  maxSmsNotification?: InputMaybe<IntFieldUpdateOperationsInput>;
  maxWeeksBeforeBooking?: InputMaybe<IntFieldUpdateOperationsInput>;
  meta?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  minHoursBeforeBooking?: InputMaybe<IntFieldUpdateOperationsInput>;
  minHoursBeforeUpdateOrCancelBooking?: InputMaybe<IntFieldUpdateOperationsInput>;
  mobilePhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  namePro?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  onlineBookingEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  orderingIndex?: InputMaybe<IntFieldUpdateOperationsInput>;
  parking?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  paymentMethods?: InputMaybe<Array<Scalars['String']['input']>>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  practicePlaces?: InputMaybe<Array<EducatorPracticePlaceEnum>>;
  privateEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  proMongoId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  profileVideo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  profileVideoPos?: InputMaybe<IntFieldUpdateOperationsInput>;
  published?: InputMaybe<BoolFieldUpdateOperationsInput>;
  reviews?: InputMaybe<EducatorReviewUncheckedUpdateManyWithoutProfessionalNestedInput>;
  searchString?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  selfDogWash?: InputMaybe<BoolFieldUpdateOperationsInput>;
  shopOpeningHours?: InputMaybe<ProShopOpeningHourUncheckedUpdateManyWithoutProNestedInput>;
  smsBookingRemindersEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  stats?: InputMaybe<ProStatUncheckedUpdateManyWithoutProNestedInput>;
  translations?: InputMaybe<ProTranslationUncheckedUpdateManyWithoutProNestedInput>;
  type?: InputMaybe<EnumProfessionalTypeEnumFieldUpdateOperationsInput>;
  unclaimedProfile?: InputMaybe<BoolFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  urgencyAvailabilities?: InputMaybe<ProUrgencyAvailabilityUncheckedUpdateManyWithoutProNestedInput>;
  visitAtHome?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whatsappNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  workers?: InputMaybe<WorkerUncheckedUpdateManyWithoutProNestedInput>;
};

export type ProfessionalUncheckedUpdateWithoutReviewsInput = {
  acceptedAnimals?: InputMaybe<Array<AnimalTypeEnum>>;
  acceptsNewClients?: InputMaybe<BoolFieldUpdateOperationsInput>;
  acceptsOnlineAppointment?: InputMaybe<BoolFieldUpdateOperationsInput>;
  addressId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  adminNotes?: InputMaybe<AdminNoteUncheckedUpdateManyWithoutProfessionalNestedInput>;
  allowsAnyWorkerOption?: InputMaybe<BoolFieldUpdateOperationsInput>;
  assistantsCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  availabilities?: InputMaybe<ProAvailabilityUncheckedUpdateManyWithoutProNestedInput>;
  bookingGroupingMaxSlotDistance?: InputMaybe<IntFieldUpdateOperationsInput>;
  centerType?: InputMaybe<NullableEnumCenterTypeEnumFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  defaultServiceDurationMinute?: InputMaybe<IntFieldUpdateOperationsInput>;
  degrees?: InputMaybe<ProDegreesUncheckedUpdateManyWithoutProNestedInput>;
  educatorType?: InputMaybe<NullableEnumEducatorTypeEnumFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailHistory?: InputMaybe<EmailHistoryUncheckedUpdateManyWithoutProfessionalNestedInput>;
  employeesCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  forceBookingGrouping?: InputMaybe<BoolFieldUpdateOperationsInput>;
  googleAccessToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleIdToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleRefreshToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleTokenExpiryDate?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleTokenScope?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleTokenType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hasShop?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  imgs?: InputMaybe<ProImgUncheckedUpdateManyWithoutProNestedInput>;
  isTipawPartner?: InputMaybe<BoolFieldUpdateOperationsInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  mainProFirstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainProLastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  maxSmsNotification?: InputMaybe<IntFieldUpdateOperationsInput>;
  maxWeeksBeforeBooking?: InputMaybe<IntFieldUpdateOperationsInput>;
  meta?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  minHoursBeforeBooking?: InputMaybe<IntFieldUpdateOperationsInput>;
  minHoursBeforeUpdateOrCancelBooking?: InputMaybe<IntFieldUpdateOperationsInput>;
  mobilePhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  namePro?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUncheckedUpdateManyWithoutProNestedInput>;
  onlineBookingEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  orderingIndex?: InputMaybe<IntFieldUpdateOperationsInput>;
  parking?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  paymentMethods?: InputMaybe<Array<Scalars['String']['input']>>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  practicePlaces?: InputMaybe<Array<EducatorPracticePlaceEnum>>;
  privateEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  proMongoId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  profileVideo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  profileVideoPos?: InputMaybe<IntFieldUpdateOperationsInput>;
  published?: InputMaybe<BoolFieldUpdateOperationsInput>;
  searchString?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  selfDogWash?: InputMaybe<BoolFieldUpdateOperationsInput>;
  shopOpeningHours?: InputMaybe<ProShopOpeningHourUncheckedUpdateManyWithoutProNestedInput>;
  smsBookingRemindersEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  stats?: InputMaybe<ProStatUncheckedUpdateManyWithoutProNestedInput>;
  translations?: InputMaybe<ProTranslationUncheckedUpdateManyWithoutProNestedInput>;
  type?: InputMaybe<EnumProfessionalTypeEnumFieldUpdateOperationsInput>;
  unclaimedProfile?: InputMaybe<BoolFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  urgencyAvailabilities?: InputMaybe<ProUrgencyAvailabilityUncheckedUpdateManyWithoutProNestedInput>;
  visitAtHome?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whatsappNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  workers?: InputMaybe<WorkerUncheckedUpdateManyWithoutProNestedInput>;
};

export type ProfessionalUncheckedUpdateWithoutShopOpeningHoursInput = {
  acceptedAnimals?: InputMaybe<Array<AnimalTypeEnum>>;
  acceptsNewClients?: InputMaybe<BoolFieldUpdateOperationsInput>;
  acceptsOnlineAppointment?: InputMaybe<BoolFieldUpdateOperationsInput>;
  addressId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  adminNotes?: InputMaybe<AdminNoteUncheckedUpdateManyWithoutProfessionalNestedInput>;
  allowsAnyWorkerOption?: InputMaybe<BoolFieldUpdateOperationsInput>;
  assistantsCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  availabilities?: InputMaybe<ProAvailabilityUncheckedUpdateManyWithoutProNestedInput>;
  bookingGroupingMaxSlotDistance?: InputMaybe<IntFieldUpdateOperationsInput>;
  centerType?: InputMaybe<NullableEnumCenterTypeEnumFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  defaultServiceDurationMinute?: InputMaybe<IntFieldUpdateOperationsInput>;
  degrees?: InputMaybe<ProDegreesUncheckedUpdateManyWithoutProNestedInput>;
  educatorType?: InputMaybe<NullableEnumEducatorTypeEnumFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailHistory?: InputMaybe<EmailHistoryUncheckedUpdateManyWithoutProfessionalNestedInput>;
  employeesCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  forceBookingGrouping?: InputMaybe<BoolFieldUpdateOperationsInput>;
  googleAccessToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleIdToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleRefreshToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleTokenExpiryDate?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleTokenScope?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleTokenType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hasShop?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  imgs?: InputMaybe<ProImgUncheckedUpdateManyWithoutProNestedInput>;
  isTipawPartner?: InputMaybe<BoolFieldUpdateOperationsInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  mainProFirstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainProLastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  maxSmsNotification?: InputMaybe<IntFieldUpdateOperationsInput>;
  maxWeeksBeforeBooking?: InputMaybe<IntFieldUpdateOperationsInput>;
  meta?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  minHoursBeforeBooking?: InputMaybe<IntFieldUpdateOperationsInput>;
  minHoursBeforeUpdateOrCancelBooking?: InputMaybe<IntFieldUpdateOperationsInput>;
  mobilePhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  namePro?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUncheckedUpdateManyWithoutProNestedInput>;
  onlineBookingEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  orderingIndex?: InputMaybe<IntFieldUpdateOperationsInput>;
  parking?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  paymentMethods?: InputMaybe<Array<Scalars['String']['input']>>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  practicePlaces?: InputMaybe<Array<EducatorPracticePlaceEnum>>;
  privateEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  proMongoId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  profileVideo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  profileVideoPos?: InputMaybe<IntFieldUpdateOperationsInput>;
  published?: InputMaybe<BoolFieldUpdateOperationsInput>;
  reviews?: InputMaybe<EducatorReviewUncheckedUpdateManyWithoutProfessionalNestedInput>;
  searchString?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  selfDogWash?: InputMaybe<BoolFieldUpdateOperationsInput>;
  smsBookingRemindersEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  stats?: InputMaybe<ProStatUncheckedUpdateManyWithoutProNestedInput>;
  translations?: InputMaybe<ProTranslationUncheckedUpdateManyWithoutProNestedInput>;
  type?: InputMaybe<EnumProfessionalTypeEnumFieldUpdateOperationsInput>;
  unclaimedProfile?: InputMaybe<BoolFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  urgencyAvailabilities?: InputMaybe<ProUrgencyAvailabilityUncheckedUpdateManyWithoutProNestedInput>;
  visitAtHome?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whatsappNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  workers?: InputMaybe<WorkerUncheckedUpdateManyWithoutProNestedInput>;
};

export type ProfessionalUncheckedUpdateWithoutStatsInput = {
  acceptedAnimals?: InputMaybe<Array<AnimalTypeEnum>>;
  acceptsNewClients?: InputMaybe<BoolFieldUpdateOperationsInput>;
  acceptsOnlineAppointment?: InputMaybe<BoolFieldUpdateOperationsInput>;
  addressId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  adminNotes?: InputMaybe<AdminNoteUncheckedUpdateManyWithoutProfessionalNestedInput>;
  allowsAnyWorkerOption?: InputMaybe<BoolFieldUpdateOperationsInput>;
  assistantsCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  availabilities?: InputMaybe<ProAvailabilityUncheckedUpdateManyWithoutProNestedInput>;
  bookingGroupingMaxSlotDistance?: InputMaybe<IntFieldUpdateOperationsInput>;
  centerType?: InputMaybe<NullableEnumCenterTypeEnumFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  defaultServiceDurationMinute?: InputMaybe<IntFieldUpdateOperationsInput>;
  degrees?: InputMaybe<ProDegreesUncheckedUpdateManyWithoutProNestedInput>;
  educatorType?: InputMaybe<NullableEnumEducatorTypeEnumFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailHistory?: InputMaybe<EmailHistoryUncheckedUpdateManyWithoutProfessionalNestedInput>;
  employeesCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  forceBookingGrouping?: InputMaybe<BoolFieldUpdateOperationsInput>;
  googleAccessToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleIdToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleRefreshToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleTokenExpiryDate?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleTokenScope?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleTokenType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hasShop?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  imgs?: InputMaybe<ProImgUncheckedUpdateManyWithoutProNestedInput>;
  isTipawPartner?: InputMaybe<BoolFieldUpdateOperationsInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  mainProFirstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainProLastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  maxSmsNotification?: InputMaybe<IntFieldUpdateOperationsInput>;
  maxWeeksBeforeBooking?: InputMaybe<IntFieldUpdateOperationsInput>;
  meta?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  minHoursBeforeBooking?: InputMaybe<IntFieldUpdateOperationsInput>;
  minHoursBeforeUpdateOrCancelBooking?: InputMaybe<IntFieldUpdateOperationsInput>;
  mobilePhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  namePro?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUncheckedUpdateManyWithoutProNestedInput>;
  onlineBookingEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  orderingIndex?: InputMaybe<IntFieldUpdateOperationsInput>;
  parking?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  paymentMethods?: InputMaybe<Array<Scalars['String']['input']>>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  practicePlaces?: InputMaybe<Array<EducatorPracticePlaceEnum>>;
  privateEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  proMongoId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  profileVideo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  profileVideoPos?: InputMaybe<IntFieldUpdateOperationsInput>;
  published?: InputMaybe<BoolFieldUpdateOperationsInput>;
  reviews?: InputMaybe<EducatorReviewUncheckedUpdateManyWithoutProfessionalNestedInput>;
  searchString?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  selfDogWash?: InputMaybe<BoolFieldUpdateOperationsInput>;
  shopOpeningHours?: InputMaybe<ProShopOpeningHourUncheckedUpdateManyWithoutProNestedInput>;
  smsBookingRemindersEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  translations?: InputMaybe<ProTranslationUncheckedUpdateManyWithoutProNestedInput>;
  type?: InputMaybe<EnumProfessionalTypeEnumFieldUpdateOperationsInput>;
  unclaimedProfile?: InputMaybe<BoolFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  urgencyAvailabilities?: InputMaybe<ProUrgencyAvailabilityUncheckedUpdateManyWithoutProNestedInput>;
  visitAtHome?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whatsappNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  workers?: InputMaybe<WorkerUncheckedUpdateManyWithoutProNestedInput>;
};

export type ProfessionalUncheckedUpdateWithoutTranslationsInput = {
  acceptedAnimals?: InputMaybe<Array<AnimalTypeEnum>>;
  acceptsNewClients?: InputMaybe<BoolFieldUpdateOperationsInput>;
  acceptsOnlineAppointment?: InputMaybe<BoolFieldUpdateOperationsInput>;
  addressId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  adminNotes?: InputMaybe<AdminNoteUncheckedUpdateManyWithoutProfessionalNestedInput>;
  allowsAnyWorkerOption?: InputMaybe<BoolFieldUpdateOperationsInput>;
  assistantsCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  availabilities?: InputMaybe<ProAvailabilityUncheckedUpdateManyWithoutProNestedInput>;
  bookingGroupingMaxSlotDistance?: InputMaybe<IntFieldUpdateOperationsInput>;
  centerType?: InputMaybe<NullableEnumCenterTypeEnumFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  defaultServiceDurationMinute?: InputMaybe<IntFieldUpdateOperationsInput>;
  degrees?: InputMaybe<ProDegreesUncheckedUpdateManyWithoutProNestedInput>;
  educatorType?: InputMaybe<NullableEnumEducatorTypeEnumFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailHistory?: InputMaybe<EmailHistoryUncheckedUpdateManyWithoutProfessionalNestedInput>;
  employeesCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  forceBookingGrouping?: InputMaybe<BoolFieldUpdateOperationsInput>;
  googleAccessToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleIdToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleRefreshToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleTokenExpiryDate?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleTokenScope?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleTokenType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hasShop?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  imgs?: InputMaybe<ProImgUncheckedUpdateManyWithoutProNestedInput>;
  isTipawPartner?: InputMaybe<BoolFieldUpdateOperationsInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  mainProFirstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainProLastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  maxSmsNotification?: InputMaybe<IntFieldUpdateOperationsInput>;
  maxWeeksBeforeBooking?: InputMaybe<IntFieldUpdateOperationsInput>;
  meta?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  minHoursBeforeBooking?: InputMaybe<IntFieldUpdateOperationsInput>;
  minHoursBeforeUpdateOrCancelBooking?: InputMaybe<IntFieldUpdateOperationsInput>;
  mobilePhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  namePro?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUncheckedUpdateManyWithoutProNestedInput>;
  onlineBookingEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  orderingIndex?: InputMaybe<IntFieldUpdateOperationsInput>;
  parking?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  paymentMethods?: InputMaybe<Array<Scalars['String']['input']>>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  practicePlaces?: InputMaybe<Array<EducatorPracticePlaceEnum>>;
  privateEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  proMongoId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  profileVideo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  profileVideoPos?: InputMaybe<IntFieldUpdateOperationsInput>;
  published?: InputMaybe<BoolFieldUpdateOperationsInput>;
  reviews?: InputMaybe<EducatorReviewUncheckedUpdateManyWithoutProfessionalNestedInput>;
  searchString?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  selfDogWash?: InputMaybe<BoolFieldUpdateOperationsInput>;
  shopOpeningHours?: InputMaybe<ProShopOpeningHourUncheckedUpdateManyWithoutProNestedInput>;
  smsBookingRemindersEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  stats?: InputMaybe<ProStatUncheckedUpdateManyWithoutProNestedInput>;
  type?: InputMaybe<EnumProfessionalTypeEnumFieldUpdateOperationsInput>;
  unclaimedProfile?: InputMaybe<BoolFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  urgencyAvailabilities?: InputMaybe<ProUrgencyAvailabilityUncheckedUpdateManyWithoutProNestedInput>;
  visitAtHome?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whatsappNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  workers?: InputMaybe<WorkerUncheckedUpdateManyWithoutProNestedInput>;
};

export type ProfessionalUncheckedUpdateWithoutUrgencyAvailabilitiesInput = {
  acceptedAnimals?: InputMaybe<Array<AnimalTypeEnum>>;
  acceptsNewClients?: InputMaybe<BoolFieldUpdateOperationsInput>;
  acceptsOnlineAppointment?: InputMaybe<BoolFieldUpdateOperationsInput>;
  addressId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  adminNotes?: InputMaybe<AdminNoteUncheckedUpdateManyWithoutProfessionalNestedInput>;
  allowsAnyWorkerOption?: InputMaybe<BoolFieldUpdateOperationsInput>;
  assistantsCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  availabilities?: InputMaybe<ProAvailabilityUncheckedUpdateManyWithoutProNestedInput>;
  bookingGroupingMaxSlotDistance?: InputMaybe<IntFieldUpdateOperationsInput>;
  centerType?: InputMaybe<NullableEnumCenterTypeEnumFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  defaultServiceDurationMinute?: InputMaybe<IntFieldUpdateOperationsInput>;
  degrees?: InputMaybe<ProDegreesUncheckedUpdateManyWithoutProNestedInput>;
  educatorType?: InputMaybe<NullableEnumEducatorTypeEnumFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailHistory?: InputMaybe<EmailHistoryUncheckedUpdateManyWithoutProfessionalNestedInput>;
  employeesCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  forceBookingGrouping?: InputMaybe<BoolFieldUpdateOperationsInput>;
  googleAccessToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleIdToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleRefreshToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleTokenExpiryDate?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleTokenScope?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleTokenType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hasShop?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  imgs?: InputMaybe<ProImgUncheckedUpdateManyWithoutProNestedInput>;
  isTipawPartner?: InputMaybe<BoolFieldUpdateOperationsInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  mainProFirstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainProLastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  maxSmsNotification?: InputMaybe<IntFieldUpdateOperationsInput>;
  maxWeeksBeforeBooking?: InputMaybe<IntFieldUpdateOperationsInput>;
  meta?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  minHoursBeforeBooking?: InputMaybe<IntFieldUpdateOperationsInput>;
  minHoursBeforeUpdateOrCancelBooking?: InputMaybe<IntFieldUpdateOperationsInput>;
  mobilePhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  namePro?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUncheckedUpdateManyWithoutProNestedInput>;
  onlineBookingEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  orderingIndex?: InputMaybe<IntFieldUpdateOperationsInput>;
  parking?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  paymentMethods?: InputMaybe<Array<Scalars['String']['input']>>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  practicePlaces?: InputMaybe<Array<EducatorPracticePlaceEnum>>;
  privateEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  proMongoId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  profileVideo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  profileVideoPos?: InputMaybe<IntFieldUpdateOperationsInput>;
  published?: InputMaybe<BoolFieldUpdateOperationsInput>;
  reviews?: InputMaybe<EducatorReviewUncheckedUpdateManyWithoutProfessionalNestedInput>;
  searchString?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  selfDogWash?: InputMaybe<BoolFieldUpdateOperationsInput>;
  shopOpeningHours?: InputMaybe<ProShopOpeningHourUncheckedUpdateManyWithoutProNestedInput>;
  smsBookingRemindersEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  stats?: InputMaybe<ProStatUncheckedUpdateManyWithoutProNestedInput>;
  translations?: InputMaybe<ProTranslationUncheckedUpdateManyWithoutProNestedInput>;
  type?: InputMaybe<EnumProfessionalTypeEnumFieldUpdateOperationsInput>;
  unclaimedProfile?: InputMaybe<BoolFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  visitAtHome?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whatsappNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  workers?: InputMaybe<WorkerUncheckedUpdateManyWithoutProNestedInput>;
};

export type ProfessionalUncheckedUpdateWithoutWorkersInput = {
  acceptedAnimals?: InputMaybe<Array<AnimalTypeEnum>>;
  acceptsNewClients?: InputMaybe<BoolFieldUpdateOperationsInput>;
  acceptsOnlineAppointment?: InputMaybe<BoolFieldUpdateOperationsInput>;
  addressId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  adminNotes?: InputMaybe<AdminNoteUncheckedUpdateManyWithoutProfessionalNestedInput>;
  allowsAnyWorkerOption?: InputMaybe<BoolFieldUpdateOperationsInput>;
  assistantsCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  availabilities?: InputMaybe<ProAvailabilityUncheckedUpdateManyWithoutProNestedInput>;
  bookingGroupingMaxSlotDistance?: InputMaybe<IntFieldUpdateOperationsInput>;
  centerType?: InputMaybe<NullableEnumCenterTypeEnumFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  defaultServiceDurationMinute?: InputMaybe<IntFieldUpdateOperationsInput>;
  degrees?: InputMaybe<ProDegreesUncheckedUpdateManyWithoutProNestedInput>;
  educatorType?: InputMaybe<NullableEnumEducatorTypeEnumFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailHistory?: InputMaybe<EmailHistoryUncheckedUpdateManyWithoutProfessionalNestedInput>;
  employeesCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  forceBookingGrouping?: InputMaybe<BoolFieldUpdateOperationsInput>;
  googleAccessToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleIdToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleRefreshToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleTokenExpiryDate?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleTokenScope?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleTokenType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hasShop?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  imgs?: InputMaybe<ProImgUncheckedUpdateManyWithoutProNestedInput>;
  isTipawPartner?: InputMaybe<BoolFieldUpdateOperationsInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  mainProFirstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainProLastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  maxSmsNotification?: InputMaybe<IntFieldUpdateOperationsInput>;
  maxWeeksBeforeBooking?: InputMaybe<IntFieldUpdateOperationsInput>;
  meta?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  minHoursBeforeBooking?: InputMaybe<IntFieldUpdateOperationsInput>;
  minHoursBeforeUpdateOrCancelBooking?: InputMaybe<IntFieldUpdateOperationsInput>;
  mobilePhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  namePro?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUncheckedUpdateManyWithoutProNestedInput>;
  onlineBookingEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  orderingIndex?: InputMaybe<IntFieldUpdateOperationsInput>;
  parking?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  paymentMethods?: InputMaybe<Array<Scalars['String']['input']>>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  practicePlaces?: InputMaybe<Array<EducatorPracticePlaceEnum>>;
  privateEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  proMongoId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  profileVideo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  profileVideoPos?: InputMaybe<IntFieldUpdateOperationsInput>;
  published?: InputMaybe<BoolFieldUpdateOperationsInput>;
  reviews?: InputMaybe<EducatorReviewUncheckedUpdateManyWithoutProfessionalNestedInput>;
  searchString?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  selfDogWash?: InputMaybe<BoolFieldUpdateOperationsInput>;
  shopOpeningHours?: InputMaybe<ProShopOpeningHourUncheckedUpdateManyWithoutProNestedInput>;
  smsBookingRemindersEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  stats?: InputMaybe<ProStatUncheckedUpdateManyWithoutProNestedInput>;
  translations?: InputMaybe<ProTranslationUncheckedUpdateManyWithoutProNestedInput>;
  type?: InputMaybe<EnumProfessionalTypeEnumFieldUpdateOperationsInput>;
  unclaimedProfile?: InputMaybe<BoolFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  urgencyAvailabilities?: InputMaybe<ProUrgencyAvailabilityUncheckedUpdateManyWithoutProNestedInput>;
  visitAtHome?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whatsappNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ProfessionalUpdateInput = {
  acceptedAnimals?: InputMaybe<Array<AnimalTypeEnum>>;
  acceptsNewClients?: InputMaybe<BoolFieldUpdateOperationsInput>;
  acceptsOnlineAppointment?: InputMaybe<BoolFieldUpdateOperationsInput>;
  address?: InputMaybe<AddressUpdateOneWithoutProNestedInput>;
  adminNotes?: InputMaybe<AdminNoteUpdateManyWithoutProfessionalNestedInput>;
  allowsAnyWorkerOption?: InputMaybe<BoolFieldUpdateOperationsInput>;
  assistantsCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  availabilities?: InputMaybe<ProAvailabilityUpdateManyWithoutProNestedInput>;
  bookingGroupingMaxSlotDistance?: InputMaybe<IntFieldUpdateOperationsInput>;
  centerType?: InputMaybe<NullableEnumCenterTypeEnumFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  defaultServiceDurationMinute?: InputMaybe<IntFieldUpdateOperationsInput>;
  degrees?: InputMaybe<ProDegreesUpdateManyWithoutProNestedInput>;
  educatorType?: InputMaybe<NullableEnumEducatorTypeEnumFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailHistory?: InputMaybe<EmailHistoryUpdateManyWithoutProfessionalNestedInput>;
  employeesCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  forceBookingGrouping?: InputMaybe<BoolFieldUpdateOperationsInput>;
  googleAccessToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleIdToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleRefreshToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleTokenExpiryDate?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleTokenScope?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleTokenType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hasShop?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  imgs?: InputMaybe<ProImgUpdateManyWithoutProNestedInput>;
  isTipawPartner?: InputMaybe<BoolFieldUpdateOperationsInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  mainProFirstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainProLastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  maxSmsNotification?: InputMaybe<IntFieldUpdateOperationsInput>;
  maxWeeksBeforeBooking?: InputMaybe<IntFieldUpdateOperationsInput>;
  meta?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  minHoursBeforeBooking?: InputMaybe<IntFieldUpdateOperationsInput>;
  minHoursBeforeUpdateOrCancelBooking?: InputMaybe<IntFieldUpdateOperationsInput>;
  mobilePhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  namePro?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutProNestedInput>;
  onlineBookingEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  orderingIndex?: InputMaybe<IntFieldUpdateOperationsInput>;
  parking?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  paymentMethods?: InputMaybe<Array<Scalars['String']['input']>>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  practicePlaces?: InputMaybe<Array<EducatorPracticePlaceEnum>>;
  privateEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  proMongoId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  profileVideo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  profileVideoPos?: InputMaybe<IntFieldUpdateOperationsInput>;
  published?: InputMaybe<BoolFieldUpdateOperationsInput>;
  reviews?: InputMaybe<EducatorReviewUpdateManyWithoutProfessionalNestedInput>;
  searchString?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  selfDogWash?: InputMaybe<BoolFieldUpdateOperationsInput>;
  shopOpeningHours?: InputMaybe<ProShopOpeningHourUpdateManyWithoutProNestedInput>;
  smsBookingRemindersEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  stats?: InputMaybe<ProStatUpdateManyWithoutProNestedInput>;
  translations?: InputMaybe<ProTranslationUpdateManyWithoutProNestedInput>;
  type?: InputMaybe<EnumProfessionalTypeEnumFieldUpdateOperationsInput>;
  unclaimedProfile?: InputMaybe<BoolFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  urgencyAvailabilities?: InputMaybe<ProUrgencyAvailabilityUpdateManyWithoutProNestedInput>;
  visitAtHome?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whatsappNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  workers?: InputMaybe<WorkerUpdateManyWithoutProNestedInput>;
};

export type ProfessionalUpdateManyMutationInput = {
  acceptedAnimals?: InputMaybe<Array<AnimalTypeEnum>>;
  acceptsNewClients?: InputMaybe<BoolFieldUpdateOperationsInput>;
  acceptsOnlineAppointment?: InputMaybe<BoolFieldUpdateOperationsInput>;
  allowsAnyWorkerOption?: InputMaybe<BoolFieldUpdateOperationsInput>;
  assistantsCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  bookingGroupingMaxSlotDistance?: InputMaybe<IntFieldUpdateOperationsInput>;
  centerType?: InputMaybe<NullableEnumCenterTypeEnumFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  defaultServiceDurationMinute?: InputMaybe<IntFieldUpdateOperationsInput>;
  educatorType?: InputMaybe<NullableEnumEducatorTypeEnumFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  employeesCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  forceBookingGrouping?: InputMaybe<BoolFieldUpdateOperationsInput>;
  googleAccessToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleIdToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleRefreshToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleTokenExpiryDate?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleTokenScope?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleTokenType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hasShop?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isTipawPartner?: InputMaybe<BoolFieldUpdateOperationsInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  mainProFirstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainProLastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  maxSmsNotification?: InputMaybe<IntFieldUpdateOperationsInput>;
  maxWeeksBeforeBooking?: InputMaybe<IntFieldUpdateOperationsInput>;
  meta?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  minHoursBeforeBooking?: InputMaybe<IntFieldUpdateOperationsInput>;
  minHoursBeforeUpdateOrCancelBooking?: InputMaybe<IntFieldUpdateOperationsInput>;
  mobilePhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  namePro?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  onlineBookingEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  orderingIndex?: InputMaybe<IntFieldUpdateOperationsInput>;
  parking?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  paymentMethods?: InputMaybe<Array<Scalars['String']['input']>>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  practicePlaces?: InputMaybe<Array<EducatorPracticePlaceEnum>>;
  privateEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  proMongoId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  profileVideo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  profileVideoPos?: InputMaybe<IntFieldUpdateOperationsInput>;
  published?: InputMaybe<BoolFieldUpdateOperationsInput>;
  searchString?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  selfDogWash?: InputMaybe<BoolFieldUpdateOperationsInput>;
  smsBookingRemindersEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<EnumProfessionalTypeEnumFieldUpdateOperationsInput>;
  unclaimedProfile?: InputMaybe<BoolFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  visitAtHome?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whatsappNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ProfessionalUpdateOneRequiredWithoutAvailabilitiesNestedInput = {
  connect?: InputMaybe<ProfessionalWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProfessionalCreateOrConnectWithoutAvailabilitiesInput>;
  create?: InputMaybe<ProfessionalCreateWithoutAvailabilitiesInput>;
  update?: InputMaybe<ProfessionalUpdateToOneWithWhereWithoutAvailabilitiesInput>;
  upsert?: InputMaybe<ProfessionalUpsertWithoutAvailabilitiesInput>;
};

export type ProfessionalUpdateOneRequiredWithoutDegreesNestedInput = {
  connect?: InputMaybe<ProfessionalWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProfessionalCreateOrConnectWithoutDegreesInput>;
  create?: InputMaybe<ProfessionalCreateWithoutDegreesInput>;
  update?: InputMaybe<ProfessionalUpdateToOneWithWhereWithoutDegreesInput>;
  upsert?: InputMaybe<ProfessionalUpsertWithoutDegreesInput>;
};

export type ProfessionalUpdateOneRequiredWithoutImgsNestedInput = {
  connect?: InputMaybe<ProfessionalWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProfessionalCreateOrConnectWithoutImgsInput>;
  create?: InputMaybe<ProfessionalCreateWithoutImgsInput>;
  update?: InputMaybe<ProfessionalUpdateToOneWithWhereWithoutImgsInput>;
  upsert?: InputMaybe<ProfessionalUpsertWithoutImgsInput>;
};

export type ProfessionalUpdateOneRequiredWithoutReviewsNestedInput = {
  connect?: InputMaybe<ProfessionalWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProfessionalCreateOrConnectWithoutReviewsInput>;
  create?: InputMaybe<ProfessionalCreateWithoutReviewsInput>;
  update?: InputMaybe<ProfessionalUpdateToOneWithWhereWithoutReviewsInput>;
  upsert?: InputMaybe<ProfessionalUpsertWithoutReviewsInput>;
};

export type ProfessionalUpdateOneRequiredWithoutShopOpeningHoursNestedInput = {
  connect?: InputMaybe<ProfessionalWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProfessionalCreateOrConnectWithoutShopOpeningHoursInput>;
  create?: InputMaybe<ProfessionalCreateWithoutShopOpeningHoursInput>;
  update?: InputMaybe<ProfessionalUpdateToOneWithWhereWithoutShopOpeningHoursInput>;
  upsert?: InputMaybe<ProfessionalUpsertWithoutShopOpeningHoursInput>;
};

export type ProfessionalUpdateOneRequiredWithoutStatsNestedInput = {
  connect?: InputMaybe<ProfessionalWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProfessionalCreateOrConnectWithoutStatsInput>;
  create?: InputMaybe<ProfessionalCreateWithoutStatsInput>;
  update?: InputMaybe<ProfessionalUpdateToOneWithWhereWithoutStatsInput>;
  upsert?: InputMaybe<ProfessionalUpsertWithoutStatsInput>;
};

export type ProfessionalUpdateOneRequiredWithoutTranslationsNestedInput = {
  connect?: InputMaybe<ProfessionalWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProfessionalCreateOrConnectWithoutTranslationsInput>;
  create?: InputMaybe<ProfessionalCreateWithoutTranslationsInput>;
  update?: InputMaybe<ProfessionalUpdateToOneWithWhereWithoutTranslationsInput>;
  upsert?: InputMaybe<ProfessionalUpsertWithoutTranslationsInput>;
};

export type ProfessionalUpdateOneRequiredWithoutUrgencyAvailabilitiesNestedInput = {
  connect?: InputMaybe<ProfessionalWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProfessionalCreateOrConnectWithoutUrgencyAvailabilitiesInput>;
  create?: InputMaybe<ProfessionalCreateWithoutUrgencyAvailabilitiesInput>;
  update?: InputMaybe<ProfessionalUpdateToOneWithWhereWithoutUrgencyAvailabilitiesInput>;
  upsert?: InputMaybe<ProfessionalUpsertWithoutUrgencyAvailabilitiesInput>;
};

export type ProfessionalUpdateOneRequiredWithoutWorkersNestedInput = {
  connect?: InputMaybe<ProfessionalWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProfessionalCreateOrConnectWithoutWorkersInput>;
  create?: InputMaybe<ProfessionalCreateWithoutWorkersInput>;
  update?: InputMaybe<ProfessionalUpdateToOneWithWhereWithoutWorkersInput>;
  upsert?: InputMaybe<ProfessionalUpsertWithoutWorkersInput>;
};

export type ProfessionalUpdateOneWithoutAddressNestedInput = {
  connect?: InputMaybe<ProfessionalWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProfessionalCreateOrConnectWithoutAddressInput>;
  create?: InputMaybe<ProfessionalCreateWithoutAddressInput>;
  delete?: InputMaybe<ProfessionalWhereInput>;
  disconnect?: InputMaybe<ProfessionalWhereInput>;
  update?: InputMaybe<ProfessionalUpdateToOneWithWhereWithoutAddressInput>;
  upsert?: InputMaybe<ProfessionalUpsertWithoutAddressInput>;
};

export type ProfessionalUpdateOneWithoutAdminNotesNestedInput = {
  connect?: InputMaybe<ProfessionalWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProfessionalCreateOrConnectWithoutAdminNotesInput>;
  create?: InputMaybe<ProfessionalCreateWithoutAdminNotesInput>;
  delete?: InputMaybe<ProfessionalWhereInput>;
  disconnect?: InputMaybe<ProfessionalWhereInput>;
  update?: InputMaybe<ProfessionalUpdateToOneWithWhereWithoutAdminNotesInput>;
  upsert?: InputMaybe<ProfessionalUpsertWithoutAdminNotesInput>;
};

export type ProfessionalUpdateOneWithoutEmailHistoryNestedInput = {
  connect?: InputMaybe<ProfessionalWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProfessionalCreateOrConnectWithoutEmailHistoryInput>;
  create?: InputMaybe<ProfessionalCreateWithoutEmailHistoryInput>;
  delete?: InputMaybe<ProfessionalWhereInput>;
  disconnect?: InputMaybe<ProfessionalWhereInput>;
  update?: InputMaybe<ProfessionalUpdateToOneWithWhereWithoutEmailHistoryInput>;
  upsert?: InputMaybe<ProfessionalUpsertWithoutEmailHistoryInput>;
};

export type ProfessionalUpdateOneWithoutNotificationsNestedInput = {
  connect?: InputMaybe<ProfessionalWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProfessionalCreateOrConnectWithoutNotificationsInput>;
  create?: InputMaybe<ProfessionalCreateWithoutNotificationsInput>;
  delete?: InputMaybe<ProfessionalWhereInput>;
  disconnect?: InputMaybe<ProfessionalWhereInput>;
  update?: InputMaybe<ProfessionalUpdateToOneWithWhereWithoutNotificationsInput>;
  upsert?: InputMaybe<ProfessionalUpsertWithoutNotificationsInput>;
};

export type ProfessionalUpdateToOneWithWhereWithoutAddressInput = {
  data: ProfessionalUpdateWithoutAddressInput;
  where?: InputMaybe<ProfessionalWhereInput>;
};

export type ProfessionalUpdateToOneWithWhereWithoutAdminNotesInput = {
  data: ProfessionalUpdateWithoutAdminNotesInput;
  where?: InputMaybe<ProfessionalWhereInput>;
};

export type ProfessionalUpdateToOneWithWhereWithoutAvailabilitiesInput = {
  data: ProfessionalUpdateWithoutAvailabilitiesInput;
  where?: InputMaybe<ProfessionalWhereInput>;
};

export type ProfessionalUpdateToOneWithWhereWithoutDegreesInput = {
  data: ProfessionalUpdateWithoutDegreesInput;
  where?: InputMaybe<ProfessionalWhereInput>;
};

export type ProfessionalUpdateToOneWithWhereWithoutEmailHistoryInput = {
  data: ProfessionalUpdateWithoutEmailHistoryInput;
  where?: InputMaybe<ProfessionalWhereInput>;
};

export type ProfessionalUpdateToOneWithWhereWithoutImgsInput = {
  data: ProfessionalUpdateWithoutImgsInput;
  where?: InputMaybe<ProfessionalWhereInput>;
};

export type ProfessionalUpdateToOneWithWhereWithoutNotificationsInput = {
  data: ProfessionalUpdateWithoutNotificationsInput;
  where?: InputMaybe<ProfessionalWhereInput>;
};

export type ProfessionalUpdateToOneWithWhereWithoutReviewsInput = {
  data: ProfessionalUpdateWithoutReviewsInput;
  where?: InputMaybe<ProfessionalWhereInput>;
};

export type ProfessionalUpdateToOneWithWhereWithoutShopOpeningHoursInput = {
  data: ProfessionalUpdateWithoutShopOpeningHoursInput;
  where?: InputMaybe<ProfessionalWhereInput>;
};

export type ProfessionalUpdateToOneWithWhereWithoutStatsInput = {
  data: ProfessionalUpdateWithoutStatsInput;
  where?: InputMaybe<ProfessionalWhereInput>;
};

export type ProfessionalUpdateToOneWithWhereWithoutTranslationsInput = {
  data: ProfessionalUpdateWithoutTranslationsInput;
  where?: InputMaybe<ProfessionalWhereInput>;
};

export type ProfessionalUpdateToOneWithWhereWithoutUrgencyAvailabilitiesInput = {
  data: ProfessionalUpdateWithoutUrgencyAvailabilitiesInput;
  where?: InputMaybe<ProfessionalWhereInput>;
};

export type ProfessionalUpdateToOneWithWhereWithoutWorkersInput = {
  data: ProfessionalUpdateWithoutWorkersInput;
  where?: InputMaybe<ProfessionalWhereInput>;
};

export type ProfessionalUpdateWithoutAddressInput = {
  acceptedAnimals?: InputMaybe<Array<AnimalTypeEnum>>;
  acceptsNewClients?: InputMaybe<BoolFieldUpdateOperationsInput>;
  acceptsOnlineAppointment?: InputMaybe<BoolFieldUpdateOperationsInput>;
  adminNotes?: InputMaybe<AdminNoteUpdateManyWithoutProfessionalNestedInput>;
  allowsAnyWorkerOption?: InputMaybe<BoolFieldUpdateOperationsInput>;
  assistantsCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  availabilities?: InputMaybe<ProAvailabilityUpdateManyWithoutProNestedInput>;
  bookingGroupingMaxSlotDistance?: InputMaybe<IntFieldUpdateOperationsInput>;
  centerType?: InputMaybe<NullableEnumCenterTypeEnumFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  defaultServiceDurationMinute?: InputMaybe<IntFieldUpdateOperationsInput>;
  degrees?: InputMaybe<ProDegreesUpdateManyWithoutProNestedInput>;
  educatorType?: InputMaybe<NullableEnumEducatorTypeEnumFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailHistory?: InputMaybe<EmailHistoryUpdateManyWithoutProfessionalNestedInput>;
  employeesCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  forceBookingGrouping?: InputMaybe<BoolFieldUpdateOperationsInput>;
  googleAccessToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleIdToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleRefreshToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleTokenExpiryDate?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleTokenScope?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleTokenType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hasShop?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  imgs?: InputMaybe<ProImgUpdateManyWithoutProNestedInput>;
  isTipawPartner?: InputMaybe<BoolFieldUpdateOperationsInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  mainProFirstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainProLastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  maxSmsNotification?: InputMaybe<IntFieldUpdateOperationsInput>;
  maxWeeksBeforeBooking?: InputMaybe<IntFieldUpdateOperationsInput>;
  meta?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  minHoursBeforeBooking?: InputMaybe<IntFieldUpdateOperationsInput>;
  minHoursBeforeUpdateOrCancelBooking?: InputMaybe<IntFieldUpdateOperationsInput>;
  mobilePhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  namePro?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutProNestedInput>;
  onlineBookingEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  orderingIndex?: InputMaybe<IntFieldUpdateOperationsInput>;
  parking?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  paymentMethods?: InputMaybe<Array<Scalars['String']['input']>>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  practicePlaces?: InputMaybe<Array<EducatorPracticePlaceEnum>>;
  privateEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  proMongoId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  profileVideo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  profileVideoPos?: InputMaybe<IntFieldUpdateOperationsInput>;
  published?: InputMaybe<BoolFieldUpdateOperationsInput>;
  reviews?: InputMaybe<EducatorReviewUpdateManyWithoutProfessionalNestedInput>;
  searchString?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  selfDogWash?: InputMaybe<BoolFieldUpdateOperationsInput>;
  shopOpeningHours?: InputMaybe<ProShopOpeningHourUpdateManyWithoutProNestedInput>;
  smsBookingRemindersEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  stats?: InputMaybe<ProStatUpdateManyWithoutProNestedInput>;
  translations?: InputMaybe<ProTranslationUpdateManyWithoutProNestedInput>;
  type?: InputMaybe<EnumProfessionalTypeEnumFieldUpdateOperationsInput>;
  unclaimedProfile?: InputMaybe<BoolFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  urgencyAvailabilities?: InputMaybe<ProUrgencyAvailabilityUpdateManyWithoutProNestedInput>;
  visitAtHome?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whatsappNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  workers?: InputMaybe<WorkerUpdateManyWithoutProNestedInput>;
};

export type ProfessionalUpdateWithoutAdminNotesInput = {
  acceptedAnimals?: InputMaybe<Array<AnimalTypeEnum>>;
  acceptsNewClients?: InputMaybe<BoolFieldUpdateOperationsInput>;
  acceptsOnlineAppointment?: InputMaybe<BoolFieldUpdateOperationsInput>;
  address?: InputMaybe<AddressUpdateOneWithoutProNestedInput>;
  allowsAnyWorkerOption?: InputMaybe<BoolFieldUpdateOperationsInput>;
  assistantsCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  availabilities?: InputMaybe<ProAvailabilityUpdateManyWithoutProNestedInput>;
  bookingGroupingMaxSlotDistance?: InputMaybe<IntFieldUpdateOperationsInput>;
  centerType?: InputMaybe<NullableEnumCenterTypeEnumFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  defaultServiceDurationMinute?: InputMaybe<IntFieldUpdateOperationsInput>;
  degrees?: InputMaybe<ProDegreesUpdateManyWithoutProNestedInput>;
  educatorType?: InputMaybe<NullableEnumEducatorTypeEnumFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailHistory?: InputMaybe<EmailHistoryUpdateManyWithoutProfessionalNestedInput>;
  employeesCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  forceBookingGrouping?: InputMaybe<BoolFieldUpdateOperationsInput>;
  googleAccessToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleIdToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleRefreshToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleTokenExpiryDate?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleTokenScope?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleTokenType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hasShop?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  imgs?: InputMaybe<ProImgUpdateManyWithoutProNestedInput>;
  isTipawPartner?: InputMaybe<BoolFieldUpdateOperationsInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  mainProFirstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainProLastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  maxSmsNotification?: InputMaybe<IntFieldUpdateOperationsInput>;
  maxWeeksBeforeBooking?: InputMaybe<IntFieldUpdateOperationsInput>;
  meta?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  minHoursBeforeBooking?: InputMaybe<IntFieldUpdateOperationsInput>;
  minHoursBeforeUpdateOrCancelBooking?: InputMaybe<IntFieldUpdateOperationsInput>;
  mobilePhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  namePro?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutProNestedInput>;
  onlineBookingEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  orderingIndex?: InputMaybe<IntFieldUpdateOperationsInput>;
  parking?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  paymentMethods?: InputMaybe<Array<Scalars['String']['input']>>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  practicePlaces?: InputMaybe<Array<EducatorPracticePlaceEnum>>;
  privateEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  proMongoId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  profileVideo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  profileVideoPos?: InputMaybe<IntFieldUpdateOperationsInput>;
  published?: InputMaybe<BoolFieldUpdateOperationsInput>;
  reviews?: InputMaybe<EducatorReviewUpdateManyWithoutProfessionalNestedInput>;
  searchString?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  selfDogWash?: InputMaybe<BoolFieldUpdateOperationsInput>;
  shopOpeningHours?: InputMaybe<ProShopOpeningHourUpdateManyWithoutProNestedInput>;
  smsBookingRemindersEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  stats?: InputMaybe<ProStatUpdateManyWithoutProNestedInput>;
  translations?: InputMaybe<ProTranslationUpdateManyWithoutProNestedInput>;
  type?: InputMaybe<EnumProfessionalTypeEnumFieldUpdateOperationsInput>;
  unclaimedProfile?: InputMaybe<BoolFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  urgencyAvailabilities?: InputMaybe<ProUrgencyAvailabilityUpdateManyWithoutProNestedInput>;
  visitAtHome?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whatsappNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  workers?: InputMaybe<WorkerUpdateManyWithoutProNestedInput>;
};

export type ProfessionalUpdateWithoutAvailabilitiesInput = {
  acceptedAnimals?: InputMaybe<Array<AnimalTypeEnum>>;
  acceptsNewClients?: InputMaybe<BoolFieldUpdateOperationsInput>;
  acceptsOnlineAppointment?: InputMaybe<BoolFieldUpdateOperationsInput>;
  address?: InputMaybe<AddressUpdateOneWithoutProNestedInput>;
  adminNotes?: InputMaybe<AdminNoteUpdateManyWithoutProfessionalNestedInput>;
  allowsAnyWorkerOption?: InputMaybe<BoolFieldUpdateOperationsInput>;
  assistantsCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  bookingGroupingMaxSlotDistance?: InputMaybe<IntFieldUpdateOperationsInput>;
  centerType?: InputMaybe<NullableEnumCenterTypeEnumFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  defaultServiceDurationMinute?: InputMaybe<IntFieldUpdateOperationsInput>;
  degrees?: InputMaybe<ProDegreesUpdateManyWithoutProNestedInput>;
  educatorType?: InputMaybe<NullableEnumEducatorTypeEnumFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailHistory?: InputMaybe<EmailHistoryUpdateManyWithoutProfessionalNestedInput>;
  employeesCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  forceBookingGrouping?: InputMaybe<BoolFieldUpdateOperationsInput>;
  googleAccessToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleIdToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleRefreshToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleTokenExpiryDate?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleTokenScope?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleTokenType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hasShop?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  imgs?: InputMaybe<ProImgUpdateManyWithoutProNestedInput>;
  isTipawPartner?: InputMaybe<BoolFieldUpdateOperationsInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  mainProFirstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainProLastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  maxSmsNotification?: InputMaybe<IntFieldUpdateOperationsInput>;
  maxWeeksBeforeBooking?: InputMaybe<IntFieldUpdateOperationsInput>;
  meta?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  minHoursBeforeBooking?: InputMaybe<IntFieldUpdateOperationsInput>;
  minHoursBeforeUpdateOrCancelBooking?: InputMaybe<IntFieldUpdateOperationsInput>;
  mobilePhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  namePro?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutProNestedInput>;
  onlineBookingEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  orderingIndex?: InputMaybe<IntFieldUpdateOperationsInput>;
  parking?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  paymentMethods?: InputMaybe<Array<Scalars['String']['input']>>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  practicePlaces?: InputMaybe<Array<EducatorPracticePlaceEnum>>;
  privateEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  proMongoId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  profileVideo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  profileVideoPos?: InputMaybe<IntFieldUpdateOperationsInput>;
  published?: InputMaybe<BoolFieldUpdateOperationsInput>;
  reviews?: InputMaybe<EducatorReviewUpdateManyWithoutProfessionalNestedInput>;
  searchString?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  selfDogWash?: InputMaybe<BoolFieldUpdateOperationsInput>;
  shopOpeningHours?: InputMaybe<ProShopOpeningHourUpdateManyWithoutProNestedInput>;
  smsBookingRemindersEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  stats?: InputMaybe<ProStatUpdateManyWithoutProNestedInput>;
  translations?: InputMaybe<ProTranslationUpdateManyWithoutProNestedInput>;
  type?: InputMaybe<EnumProfessionalTypeEnumFieldUpdateOperationsInput>;
  unclaimedProfile?: InputMaybe<BoolFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  urgencyAvailabilities?: InputMaybe<ProUrgencyAvailabilityUpdateManyWithoutProNestedInput>;
  visitAtHome?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whatsappNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  workers?: InputMaybe<WorkerUpdateManyWithoutProNestedInput>;
};

export type ProfessionalUpdateWithoutDegreesInput = {
  acceptedAnimals?: InputMaybe<Array<AnimalTypeEnum>>;
  acceptsNewClients?: InputMaybe<BoolFieldUpdateOperationsInput>;
  acceptsOnlineAppointment?: InputMaybe<BoolFieldUpdateOperationsInput>;
  address?: InputMaybe<AddressUpdateOneWithoutProNestedInput>;
  adminNotes?: InputMaybe<AdminNoteUpdateManyWithoutProfessionalNestedInput>;
  allowsAnyWorkerOption?: InputMaybe<BoolFieldUpdateOperationsInput>;
  assistantsCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  availabilities?: InputMaybe<ProAvailabilityUpdateManyWithoutProNestedInput>;
  bookingGroupingMaxSlotDistance?: InputMaybe<IntFieldUpdateOperationsInput>;
  centerType?: InputMaybe<NullableEnumCenterTypeEnumFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  defaultServiceDurationMinute?: InputMaybe<IntFieldUpdateOperationsInput>;
  educatorType?: InputMaybe<NullableEnumEducatorTypeEnumFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailHistory?: InputMaybe<EmailHistoryUpdateManyWithoutProfessionalNestedInput>;
  employeesCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  forceBookingGrouping?: InputMaybe<BoolFieldUpdateOperationsInput>;
  googleAccessToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleIdToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleRefreshToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleTokenExpiryDate?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleTokenScope?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleTokenType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hasShop?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  imgs?: InputMaybe<ProImgUpdateManyWithoutProNestedInput>;
  isTipawPartner?: InputMaybe<BoolFieldUpdateOperationsInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  mainProFirstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainProLastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  maxSmsNotification?: InputMaybe<IntFieldUpdateOperationsInput>;
  maxWeeksBeforeBooking?: InputMaybe<IntFieldUpdateOperationsInput>;
  meta?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  minHoursBeforeBooking?: InputMaybe<IntFieldUpdateOperationsInput>;
  minHoursBeforeUpdateOrCancelBooking?: InputMaybe<IntFieldUpdateOperationsInput>;
  mobilePhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  namePro?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutProNestedInput>;
  onlineBookingEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  orderingIndex?: InputMaybe<IntFieldUpdateOperationsInput>;
  parking?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  paymentMethods?: InputMaybe<Array<Scalars['String']['input']>>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  practicePlaces?: InputMaybe<Array<EducatorPracticePlaceEnum>>;
  privateEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  proMongoId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  profileVideo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  profileVideoPos?: InputMaybe<IntFieldUpdateOperationsInput>;
  published?: InputMaybe<BoolFieldUpdateOperationsInput>;
  reviews?: InputMaybe<EducatorReviewUpdateManyWithoutProfessionalNestedInput>;
  searchString?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  selfDogWash?: InputMaybe<BoolFieldUpdateOperationsInput>;
  shopOpeningHours?: InputMaybe<ProShopOpeningHourUpdateManyWithoutProNestedInput>;
  smsBookingRemindersEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  stats?: InputMaybe<ProStatUpdateManyWithoutProNestedInput>;
  translations?: InputMaybe<ProTranslationUpdateManyWithoutProNestedInput>;
  type?: InputMaybe<EnumProfessionalTypeEnumFieldUpdateOperationsInput>;
  unclaimedProfile?: InputMaybe<BoolFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  urgencyAvailabilities?: InputMaybe<ProUrgencyAvailabilityUpdateManyWithoutProNestedInput>;
  visitAtHome?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whatsappNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  workers?: InputMaybe<WorkerUpdateManyWithoutProNestedInput>;
};

export type ProfessionalUpdateWithoutEmailHistoryInput = {
  acceptedAnimals?: InputMaybe<Array<AnimalTypeEnum>>;
  acceptsNewClients?: InputMaybe<BoolFieldUpdateOperationsInput>;
  acceptsOnlineAppointment?: InputMaybe<BoolFieldUpdateOperationsInput>;
  address?: InputMaybe<AddressUpdateOneWithoutProNestedInput>;
  adminNotes?: InputMaybe<AdminNoteUpdateManyWithoutProfessionalNestedInput>;
  allowsAnyWorkerOption?: InputMaybe<BoolFieldUpdateOperationsInput>;
  assistantsCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  availabilities?: InputMaybe<ProAvailabilityUpdateManyWithoutProNestedInput>;
  bookingGroupingMaxSlotDistance?: InputMaybe<IntFieldUpdateOperationsInput>;
  centerType?: InputMaybe<NullableEnumCenterTypeEnumFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  defaultServiceDurationMinute?: InputMaybe<IntFieldUpdateOperationsInput>;
  degrees?: InputMaybe<ProDegreesUpdateManyWithoutProNestedInput>;
  educatorType?: InputMaybe<NullableEnumEducatorTypeEnumFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  employeesCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  forceBookingGrouping?: InputMaybe<BoolFieldUpdateOperationsInput>;
  googleAccessToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleIdToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleRefreshToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleTokenExpiryDate?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleTokenScope?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleTokenType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hasShop?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  imgs?: InputMaybe<ProImgUpdateManyWithoutProNestedInput>;
  isTipawPartner?: InputMaybe<BoolFieldUpdateOperationsInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  mainProFirstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainProLastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  maxSmsNotification?: InputMaybe<IntFieldUpdateOperationsInput>;
  maxWeeksBeforeBooking?: InputMaybe<IntFieldUpdateOperationsInput>;
  meta?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  minHoursBeforeBooking?: InputMaybe<IntFieldUpdateOperationsInput>;
  minHoursBeforeUpdateOrCancelBooking?: InputMaybe<IntFieldUpdateOperationsInput>;
  mobilePhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  namePro?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutProNestedInput>;
  onlineBookingEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  orderingIndex?: InputMaybe<IntFieldUpdateOperationsInput>;
  parking?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  paymentMethods?: InputMaybe<Array<Scalars['String']['input']>>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  practicePlaces?: InputMaybe<Array<EducatorPracticePlaceEnum>>;
  privateEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  proMongoId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  profileVideo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  profileVideoPos?: InputMaybe<IntFieldUpdateOperationsInput>;
  published?: InputMaybe<BoolFieldUpdateOperationsInput>;
  reviews?: InputMaybe<EducatorReviewUpdateManyWithoutProfessionalNestedInput>;
  searchString?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  selfDogWash?: InputMaybe<BoolFieldUpdateOperationsInput>;
  shopOpeningHours?: InputMaybe<ProShopOpeningHourUpdateManyWithoutProNestedInput>;
  smsBookingRemindersEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  stats?: InputMaybe<ProStatUpdateManyWithoutProNestedInput>;
  translations?: InputMaybe<ProTranslationUpdateManyWithoutProNestedInput>;
  type?: InputMaybe<EnumProfessionalTypeEnumFieldUpdateOperationsInput>;
  unclaimedProfile?: InputMaybe<BoolFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  urgencyAvailabilities?: InputMaybe<ProUrgencyAvailabilityUpdateManyWithoutProNestedInput>;
  visitAtHome?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whatsappNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  workers?: InputMaybe<WorkerUpdateManyWithoutProNestedInput>;
};

export type ProfessionalUpdateWithoutImgsInput = {
  acceptedAnimals?: InputMaybe<Array<AnimalTypeEnum>>;
  acceptsNewClients?: InputMaybe<BoolFieldUpdateOperationsInput>;
  acceptsOnlineAppointment?: InputMaybe<BoolFieldUpdateOperationsInput>;
  address?: InputMaybe<AddressUpdateOneWithoutProNestedInput>;
  adminNotes?: InputMaybe<AdminNoteUpdateManyWithoutProfessionalNestedInput>;
  allowsAnyWorkerOption?: InputMaybe<BoolFieldUpdateOperationsInput>;
  assistantsCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  availabilities?: InputMaybe<ProAvailabilityUpdateManyWithoutProNestedInput>;
  bookingGroupingMaxSlotDistance?: InputMaybe<IntFieldUpdateOperationsInput>;
  centerType?: InputMaybe<NullableEnumCenterTypeEnumFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  defaultServiceDurationMinute?: InputMaybe<IntFieldUpdateOperationsInput>;
  degrees?: InputMaybe<ProDegreesUpdateManyWithoutProNestedInput>;
  educatorType?: InputMaybe<NullableEnumEducatorTypeEnumFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailHistory?: InputMaybe<EmailHistoryUpdateManyWithoutProfessionalNestedInput>;
  employeesCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  forceBookingGrouping?: InputMaybe<BoolFieldUpdateOperationsInput>;
  googleAccessToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleIdToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleRefreshToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleTokenExpiryDate?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleTokenScope?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleTokenType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hasShop?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isTipawPartner?: InputMaybe<BoolFieldUpdateOperationsInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  mainProFirstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainProLastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  maxSmsNotification?: InputMaybe<IntFieldUpdateOperationsInput>;
  maxWeeksBeforeBooking?: InputMaybe<IntFieldUpdateOperationsInput>;
  meta?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  minHoursBeforeBooking?: InputMaybe<IntFieldUpdateOperationsInput>;
  minHoursBeforeUpdateOrCancelBooking?: InputMaybe<IntFieldUpdateOperationsInput>;
  mobilePhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  namePro?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutProNestedInput>;
  onlineBookingEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  orderingIndex?: InputMaybe<IntFieldUpdateOperationsInput>;
  parking?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  paymentMethods?: InputMaybe<Array<Scalars['String']['input']>>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  practicePlaces?: InputMaybe<Array<EducatorPracticePlaceEnum>>;
  privateEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  proMongoId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  profileVideo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  profileVideoPos?: InputMaybe<IntFieldUpdateOperationsInput>;
  published?: InputMaybe<BoolFieldUpdateOperationsInput>;
  reviews?: InputMaybe<EducatorReviewUpdateManyWithoutProfessionalNestedInput>;
  searchString?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  selfDogWash?: InputMaybe<BoolFieldUpdateOperationsInput>;
  shopOpeningHours?: InputMaybe<ProShopOpeningHourUpdateManyWithoutProNestedInput>;
  smsBookingRemindersEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  stats?: InputMaybe<ProStatUpdateManyWithoutProNestedInput>;
  translations?: InputMaybe<ProTranslationUpdateManyWithoutProNestedInput>;
  type?: InputMaybe<EnumProfessionalTypeEnumFieldUpdateOperationsInput>;
  unclaimedProfile?: InputMaybe<BoolFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  urgencyAvailabilities?: InputMaybe<ProUrgencyAvailabilityUpdateManyWithoutProNestedInput>;
  visitAtHome?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whatsappNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  workers?: InputMaybe<WorkerUpdateManyWithoutProNestedInput>;
};

export type ProfessionalUpdateWithoutNotificationsInput = {
  acceptedAnimals?: InputMaybe<Array<AnimalTypeEnum>>;
  acceptsNewClients?: InputMaybe<BoolFieldUpdateOperationsInput>;
  acceptsOnlineAppointment?: InputMaybe<BoolFieldUpdateOperationsInput>;
  address?: InputMaybe<AddressUpdateOneWithoutProNestedInput>;
  adminNotes?: InputMaybe<AdminNoteUpdateManyWithoutProfessionalNestedInput>;
  allowsAnyWorkerOption?: InputMaybe<BoolFieldUpdateOperationsInput>;
  assistantsCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  availabilities?: InputMaybe<ProAvailabilityUpdateManyWithoutProNestedInput>;
  bookingGroupingMaxSlotDistance?: InputMaybe<IntFieldUpdateOperationsInput>;
  centerType?: InputMaybe<NullableEnumCenterTypeEnumFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  defaultServiceDurationMinute?: InputMaybe<IntFieldUpdateOperationsInput>;
  degrees?: InputMaybe<ProDegreesUpdateManyWithoutProNestedInput>;
  educatorType?: InputMaybe<NullableEnumEducatorTypeEnumFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailHistory?: InputMaybe<EmailHistoryUpdateManyWithoutProfessionalNestedInput>;
  employeesCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  forceBookingGrouping?: InputMaybe<BoolFieldUpdateOperationsInput>;
  googleAccessToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleIdToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleRefreshToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleTokenExpiryDate?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleTokenScope?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleTokenType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hasShop?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  imgs?: InputMaybe<ProImgUpdateManyWithoutProNestedInput>;
  isTipawPartner?: InputMaybe<BoolFieldUpdateOperationsInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  mainProFirstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainProLastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  maxSmsNotification?: InputMaybe<IntFieldUpdateOperationsInput>;
  maxWeeksBeforeBooking?: InputMaybe<IntFieldUpdateOperationsInput>;
  meta?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  minHoursBeforeBooking?: InputMaybe<IntFieldUpdateOperationsInput>;
  minHoursBeforeUpdateOrCancelBooking?: InputMaybe<IntFieldUpdateOperationsInput>;
  mobilePhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  namePro?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  onlineBookingEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  orderingIndex?: InputMaybe<IntFieldUpdateOperationsInput>;
  parking?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  paymentMethods?: InputMaybe<Array<Scalars['String']['input']>>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  practicePlaces?: InputMaybe<Array<EducatorPracticePlaceEnum>>;
  privateEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  proMongoId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  profileVideo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  profileVideoPos?: InputMaybe<IntFieldUpdateOperationsInput>;
  published?: InputMaybe<BoolFieldUpdateOperationsInput>;
  reviews?: InputMaybe<EducatorReviewUpdateManyWithoutProfessionalNestedInput>;
  searchString?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  selfDogWash?: InputMaybe<BoolFieldUpdateOperationsInput>;
  shopOpeningHours?: InputMaybe<ProShopOpeningHourUpdateManyWithoutProNestedInput>;
  smsBookingRemindersEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  stats?: InputMaybe<ProStatUpdateManyWithoutProNestedInput>;
  translations?: InputMaybe<ProTranslationUpdateManyWithoutProNestedInput>;
  type?: InputMaybe<EnumProfessionalTypeEnumFieldUpdateOperationsInput>;
  unclaimedProfile?: InputMaybe<BoolFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  urgencyAvailabilities?: InputMaybe<ProUrgencyAvailabilityUpdateManyWithoutProNestedInput>;
  visitAtHome?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whatsappNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  workers?: InputMaybe<WorkerUpdateManyWithoutProNestedInput>;
};

export type ProfessionalUpdateWithoutReviewsInput = {
  acceptedAnimals?: InputMaybe<Array<AnimalTypeEnum>>;
  acceptsNewClients?: InputMaybe<BoolFieldUpdateOperationsInput>;
  acceptsOnlineAppointment?: InputMaybe<BoolFieldUpdateOperationsInput>;
  address?: InputMaybe<AddressUpdateOneWithoutProNestedInput>;
  adminNotes?: InputMaybe<AdminNoteUpdateManyWithoutProfessionalNestedInput>;
  allowsAnyWorkerOption?: InputMaybe<BoolFieldUpdateOperationsInput>;
  assistantsCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  availabilities?: InputMaybe<ProAvailabilityUpdateManyWithoutProNestedInput>;
  bookingGroupingMaxSlotDistance?: InputMaybe<IntFieldUpdateOperationsInput>;
  centerType?: InputMaybe<NullableEnumCenterTypeEnumFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  defaultServiceDurationMinute?: InputMaybe<IntFieldUpdateOperationsInput>;
  degrees?: InputMaybe<ProDegreesUpdateManyWithoutProNestedInput>;
  educatorType?: InputMaybe<NullableEnumEducatorTypeEnumFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailHistory?: InputMaybe<EmailHistoryUpdateManyWithoutProfessionalNestedInput>;
  employeesCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  forceBookingGrouping?: InputMaybe<BoolFieldUpdateOperationsInput>;
  googleAccessToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleIdToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleRefreshToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleTokenExpiryDate?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleTokenScope?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleTokenType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hasShop?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  imgs?: InputMaybe<ProImgUpdateManyWithoutProNestedInput>;
  isTipawPartner?: InputMaybe<BoolFieldUpdateOperationsInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  mainProFirstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainProLastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  maxSmsNotification?: InputMaybe<IntFieldUpdateOperationsInput>;
  maxWeeksBeforeBooking?: InputMaybe<IntFieldUpdateOperationsInput>;
  meta?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  minHoursBeforeBooking?: InputMaybe<IntFieldUpdateOperationsInput>;
  minHoursBeforeUpdateOrCancelBooking?: InputMaybe<IntFieldUpdateOperationsInput>;
  mobilePhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  namePro?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutProNestedInput>;
  onlineBookingEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  orderingIndex?: InputMaybe<IntFieldUpdateOperationsInput>;
  parking?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  paymentMethods?: InputMaybe<Array<Scalars['String']['input']>>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  practicePlaces?: InputMaybe<Array<EducatorPracticePlaceEnum>>;
  privateEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  proMongoId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  profileVideo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  profileVideoPos?: InputMaybe<IntFieldUpdateOperationsInput>;
  published?: InputMaybe<BoolFieldUpdateOperationsInput>;
  searchString?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  selfDogWash?: InputMaybe<BoolFieldUpdateOperationsInput>;
  shopOpeningHours?: InputMaybe<ProShopOpeningHourUpdateManyWithoutProNestedInput>;
  smsBookingRemindersEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  stats?: InputMaybe<ProStatUpdateManyWithoutProNestedInput>;
  translations?: InputMaybe<ProTranslationUpdateManyWithoutProNestedInput>;
  type?: InputMaybe<EnumProfessionalTypeEnumFieldUpdateOperationsInput>;
  unclaimedProfile?: InputMaybe<BoolFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  urgencyAvailabilities?: InputMaybe<ProUrgencyAvailabilityUpdateManyWithoutProNestedInput>;
  visitAtHome?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whatsappNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  workers?: InputMaybe<WorkerUpdateManyWithoutProNestedInput>;
};

export type ProfessionalUpdateWithoutShopOpeningHoursInput = {
  acceptedAnimals?: InputMaybe<Array<AnimalTypeEnum>>;
  acceptsNewClients?: InputMaybe<BoolFieldUpdateOperationsInput>;
  acceptsOnlineAppointment?: InputMaybe<BoolFieldUpdateOperationsInput>;
  address?: InputMaybe<AddressUpdateOneWithoutProNestedInput>;
  adminNotes?: InputMaybe<AdminNoteUpdateManyWithoutProfessionalNestedInput>;
  allowsAnyWorkerOption?: InputMaybe<BoolFieldUpdateOperationsInput>;
  assistantsCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  availabilities?: InputMaybe<ProAvailabilityUpdateManyWithoutProNestedInput>;
  bookingGroupingMaxSlotDistance?: InputMaybe<IntFieldUpdateOperationsInput>;
  centerType?: InputMaybe<NullableEnumCenterTypeEnumFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  defaultServiceDurationMinute?: InputMaybe<IntFieldUpdateOperationsInput>;
  degrees?: InputMaybe<ProDegreesUpdateManyWithoutProNestedInput>;
  educatorType?: InputMaybe<NullableEnumEducatorTypeEnumFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailHistory?: InputMaybe<EmailHistoryUpdateManyWithoutProfessionalNestedInput>;
  employeesCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  forceBookingGrouping?: InputMaybe<BoolFieldUpdateOperationsInput>;
  googleAccessToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleIdToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleRefreshToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleTokenExpiryDate?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleTokenScope?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleTokenType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hasShop?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  imgs?: InputMaybe<ProImgUpdateManyWithoutProNestedInput>;
  isTipawPartner?: InputMaybe<BoolFieldUpdateOperationsInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  mainProFirstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainProLastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  maxSmsNotification?: InputMaybe<IntFieldUpdateOperationsInput>;
  maxWeeksBeforeBooking?: InputMaybe<IntFieldUpdateOperationsInput>;
  meta?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  minHoursBeforeBooking?: InputMaybe<IntFieldUpdateOperationsInput>;
  minHoursBeforeUpdateOrCancelBooking?: InputMaybe<IntFieldUpdateOperationsInput>;
  mobilePhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  namePro?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutProNestedInput>;
  onlineBookingEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  orderingIndex?: InputMaybe<IntFieldUpdateOperationsInput>;
  parking?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  paymentMethods?: InputMaybe<Array<Scalars['String']['input']>>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  practicePlaces?: InputMaybe<Array<EducatorPracticePlaceEnum>>;
  privateEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  proMongoId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  profileVideo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  profileVideoPos?: InputMaybe<IntFieldUpdateOperationsInput>;
  published?: InputMaybe<BoolFieldUpdateOperationsInput>;
  reviews?: InputMaybe<EducatorReviewUpdateManyWithoutProfessionalNestedInput>;
  searchString?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  selfDogWash?: InputMaybe<BoolFieldUpdateOperationsInput>;
  smsBookingRemindersEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  stats?: InputMaybe<ProStatUpdateManyWithoutProNestedInput>;
  translations?: InputMaybe<ProTranslationUpdateManyWithoutProNestedInput>;
  type?: InputMaybe<EnumProfessionalTypeEnumFieldUpdateOperationsInput>;
  unclaimedProfile?: InputMaybe<BoolFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  urgencyAvailabilities?: InputMaybe<ProUrgencyAvailabilityUpdateManyWithoutProNestedInput>;
  visitAtHome?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whatsappNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  workers?: InputMaybe<WorkerUpdateManyWithoutProNestedInput>;
};

export type ProfessionalUpdateWithoutStatsInput = {
  acceptedAnimals?: InputMaybe<Array<AnimalTypeEnum>>;
  acceptsNewClients?: InputMaybe<BoolFieldUpdateOperationsInput>;
  acceptsOnlineAppointment?: InputMaybe<BoolFieldUpdateOperationsInput>;
  address?: InputMaybe<AddressUpdateOneWithoutProNestedInput>;
  adminNotes?: InputMaybe<AdminNoteUpdateManyWithoutProfessionalNestedInput>;
  allowsAnyWorkerOption?: InputMaybe<BoolFieldUpdateOperationsInput>;
  assistantsCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  availabilities?: InputMaybe<ProAvailabilityUpdateManyWithoutProNestedInput>;
  bookingGroupingMaxSlotDistance?: InputMaybe<IntFieldUpdateOperationsInput>;
  centerType?: InputMaybe<NullableEnumCenterTypeEnumFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  defaultServiceDurationMinute?: InputMaybe<IntFieldUpdateOperationsInput>;
  degrees?: InputMaybe<ProDegreesUpdateManyWithoutProNestedInput>;
  educatorType?: InputMaybe<NullableEnumEducatorTypeEnumFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailHistory?: InputMaybe<EmailHistoryUpdateManyWithoutProfessionalNestedInput>;
  employeesCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  forceBookingGrouping?: InputMaybe<BoolFieldUpdateOperationsInput>;
  googleAccessToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleIdToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleRefreshToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleTokenExpiryDate?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleTokenScope?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleTokenType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hasShop?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  imgs?: InputMaybe<ProImgUpdateManyWithoutProNestedInput>;
  isTipawPartner?: InputMaybe<BoolFieldUpdateOperationsInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  mainProFirstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainProLastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  maxSmsNotification?: InputMaybe<IntFieldUpdateOperationsInput>;
  maxWeeksBeforeBooking?: InputMaybe<IntFieldUpdateOperationsInput>;
  meta?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  minHoursBeforeBooking?: InputMaybe<IntFieldUpdateOperationsInput>;
  minHoursBeforeUpdateOrCancelBooking?: InputMaybe<IntFieldUpdateOperationsInput>;
  mobilePhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  namePro?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutProNestedInput>;
  onlineBookingEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  orderingIndex?: InputMaybe<IntFieldUpdateOperationsInput>;
  parking?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  paymentMethods?: InputMaybe<Array<Scalars['String']['input']>>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  practicePlaces?: InputMaybe<Array<EducatorPracticePlaceEnum>>;
  privateEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  proMongoId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  profileVideo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  profileVideoPos?: InputMaybe<IntFieldUpdateOperationsInput>;
  published?: InputMaybe<BoolFieldUpdateOperationsInput>;
  reviews?: InputMaybe<EducatorReviewUpdateManyWithoutProfessionalNestedInput>;
  searchString?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  selfDogWash?: InputMaybe<BoolFieldUpdateOperationsInput>;
  shopOpeningHours?: InputMaybe<ProShopOpeningHourUpdateManyWithoutProNestedInput>;
  smsBookingRemindersEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  translations?: InputMaybe<ProTranslationUpdateManyWithoutProNestedInput>;
  type?: InputMaybe<EnumProfessionalTypeEnumFieldUpdateOperationsInput>;
  unclaimedProfile?: InputMaybe<BoolFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  urgencyAvailabilities?: InputMaybe<ProUrgencyAvailabilityUpdateManyWithoutProNestedInput>;
  visitAtHome?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whatsappNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  workers?: InputMaybe<WorkerUpdateManyWithoutProNestedInput>;
};

export type ProfessionalUpdateWithoutTranslationsInput = {
  acceptedAnimals?: InputMaybe<Array<AnimalTypeEnum>>;
  acceptsNewClients?: InputMaybe<BoolFieldUpdateOperationsInput>;
  acceptsOnlineAppointment?: InputMaybe<BoolFieldUpdateOperationsInput>;
  address?: InputMaybe<AddressUpdateOneWithoutProNestedInput>;
  adminNotes?: InputMaybe<AdminNoteUpdateManyWithoutProfessionalNestedInput>;
  allowsAnyWorkerOption?: InputMaybe<BoolFieldUpdateOperationsInput>;
  assistantsCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  availabilities?: InputMaybe<ProAvailabilityUpdateManyWithoutProNestedInput>;
  bookingGroupingMaxSlotDistance?: InputMaybe<IntFieldUpdateOperationsInput>;
  centerType?: InputMaybe<NullableEnumCenterTypeEnumFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  defaultServiceDurationMinute?: InputMaybe<IntFieldUpdateOperationsInput>;
  degrees?: InputMaybe<ProDegreesUpdateManyWithoutProNestedInput>;
  educatorType?: InputMaybe<NullableEnumEducatorTypeEnumFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailHistory?: InputMaybe<EmailHistoryUpdateManyWithoutProfessionalNestedInput>;
  employeesCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  forceBookingGrouping?: InputMaybe<BoolFieldUpdateOperationsInput>;
  googleAccessToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleIdToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleRefreshToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleTokenExpiryDate?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleTokenScope?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleTokenType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hasShop?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  imgs?: InputMaybe<ProImgUpdateManyWithoutProNestedInput>;
  isTipawPartner?: InputMaybe<BoolFieldUpdateOperationsInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  mainProFirstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainProLastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  maxSmsNotification?: InputMaybe<IntFieldUpdateOperationsInput>;
  maxWeeksBeforeBooking?: InputMaybe<IntFieldUpdateOperationsInput>;
  meta?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  minHoursBeforeBooking?: InputMaybe<IntFieldUpdateOperationsInput>;
  minHoursBeforeUpdateOrCancelBooking?: InputMaybe<IntFieldUpdateOperationsInput>;
  mobilePhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  namePro?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutProNestedInput>;
  onlineBookingEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  orderingIndex?: InputMaybe<IntFieldUpdateOperationsInput>;
  parking?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  paymentMethods?: InputMaybe<Array<Scalars['String']['input']>>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  practicePlaces?: InputMaybe<Array<EducatorPracticePlaceEnum>>;
  privateEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  proMongoId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  profileVideo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  profileVideoPos?: InputMaybe<IntFieldUpdateOperationsInput>;
  published?: InputMaybe<BoolFieldUpdateOperationsInput>;
  reviews?: InputMaybe<EducatorReviewUpdateManyWithoutProfessionalNestedInput>;
  searchString?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  selfDogWash?: InputMaybe<BoolFieldUpdateOperationsInput>;
  shopOpeningHours?: InputMaybe<ProShopOpeningHourUpdateManyWithoutProNestedInput>;
  smsBookingRemindersEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  stats?: InputMaybe<ProStatUpdateManyWithoutProNestedInput>;
  type?: InputMaybe<EnumProfessionalTypeEnumFieldUpdateOperationsInput>;
  unclaimedProfile?: InputMaybe<BoolFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  urgencyAvailabilities?: InputMaybe<ProUrgencyAvailabilityUpdateManyWithoutProNestedInput>;
  visitAtHome?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whatsappNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  workers?: InputMaybe<WorkerUpdateManyWithoutProNestedInput>;
};

export type ProfessionalUpdateWithoutUrgencyAvailabilitiesInput = {
  acceptedAnimals?: InputMaybe<Array<AnimalTypeEnum>>;
  acceptsNewClients?: InputMaybe<BoolFieldUpdateOperationsInput>;
  acceptsOnlineAppointment?: InputMaybe<BoolFieldUpdateOperationsInput>;
  address?: InputMaybe<AddressUpdateOneWithoutProNestedInput>;
  adminNotes?: InputMaybe<AdminNoteUpdateManyWithoutProfessionalNestedInput>;
  allowsAnyWorkerOption?: InputMaybe<BoolFieldUpdateOperationsInput>;
  assistantsCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  availabilities?: InputMaybe<ProAvailabilityUpdateManyWithoutProNestedInput>;
  bookingGroupingMaxSlotDistance?: InputMaybe<IntFieldUpdateOperationsInput>;
  centerType?: InputMaybe<NullableEnumCenterTypeEnumFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  defaultServiceDurationMinute?: InputMaybe<IntFieldUpdateOperationsInput>;
  degrees?: InputMaybe<ProDegreesUpdateManyWithoutProNestedInput>;
  educatorType?: InputMaybe<NullableEnumEducatorTypeEnumFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailHistory?: InputMaybe<EmailHistoryUpdateManyWithoutProfessionalNestedInput>;
  employeesCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  forceBookingGrouping?: InputMaybe<BoolFieldUpdateOperationsInput>;
  googleAccessToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleIdToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleRefreshToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleTokenExpiryDate?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleTokenScope?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleTokenType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hasShop?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  imgs?: InputMaybe<ProImgUpdateManyWithoutProNestedInput>;
  isTipawPartner?: InputMaybe<BoolFieldUpdateOperationsInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  mainProFirstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainProLastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  maxSmsNotification?: InputMaybe<IntFieldUpdateOperationsInput>;
  maxWeeksBeforeBooking?: InputMaybe<IntFieldUpdateOperationsInput>;
  meta?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  minHoursBeforeBooking?: InputMaybe<IntFieldUpdateOperationsInput>;
  minHoursBeforeUpdateOrCancelBooking?: InputMaybe<IntFieldUpdateOperationsInput>;
  mobilePhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  namePro?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutProNestedInput>;
  onlineBookingEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  orderingIndex?: InputMaybe<IntFieldUpdateOperationsInput>;
  parking?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  paymentMethods?: InputMaybe<Array<Scalars['String']['input']>>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  practicePlaces?: InputMaybe<Array<EducatorPracticePlaceEnum>>;
  privateEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  proMongoId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  profileVideo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  profileVideoPos?: InputMaybe<IntFieldUpdateOperationsInput>;
  published?: InputMaybe<BoolFieldUpdateOperationsInput>;
  reviews?: InputMaybe<EducatorReviewUpdateManyWithoutProfessionalNestedInput>;
  searchString?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  selfDogWash?: InputMaybe<BoolFieldUpdateOperationsInput>;
  shopOpeningHours?: InputMaybe<ProShopOpeningHourUpdateManyWithoutProNestedInput>;
  smsBookingRemindersEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  stats?: InputMaybe<ProStatUpdateManyWithoutProNestedInput>;
  translations?: InputMaybe<ProTranslationUpdateManyWithoutProNestedInput>;
  type?: InputMaybe<EnumProfessionalTypeEnumFieldUpdateOperationsInput>;
  unclaimedProfile?: InputMaybe<BoolFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  visitAtHome?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whatsappNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  workers?: InputMaybe<WorkerUpdateManyWithoutProNestedInput>;
};

export type ProfessionalUpdateWithoutWorkersInput = {
  acceptedAnimals?: InputMaybe<Array<AnimalTypeEnum>>;
  acceptsNewClients?: InputMaybe<BoolFieldUpdateOperationsInput>;
  acceptsOnlineAppointment?: InputMaybe<BoolFieldUpdateOperationsInput>;
  address?: InputMaybe<AddressUpdateOneWithoutProNestedInput>;
  adminNotes?: InputMaybe<AdminNoteUpdateManyWithoutProfessionalNestedInput>;
  allowsAnyWorkerOption?: InputMaybe<BoolFieldUpdateOperationsInput>;
  assistantsCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  availabilities?: InputMaybe<ProAvailabilityUpdateManyWithoutProNestedInput>;
  bookingGroupingMaxSlotDistance?: InputMaybe<IntFieldUpdateOperationsInput>;
  centerType?: InputMaybe<NullableEnumCenterTypeEnumFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  defaultServiceDurationMinute?: InputMaybe<IntFieldUpdateOperationsInput>;
  degrees?: InputMaybe<ProDegreesUpdateManyWithoutProNestedInput>;
  educatorType?: InputMaybe<NullableEnumEducatorTypeEnumFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailHistory?: InputMaybe<EmailHistoryUpdateManyWithoutProfessionalNestedInput>;
  employeesCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  forceBookingGrouping?: InputMaybe<BoolFieldUpdateOperationsInput>;
  googleAccessToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleIdToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleRefreshToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleTokenExpiryDate?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleTokenScope?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleTokenType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hasShop?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  imgs?: InputMaybe<ProImgUpdateManyWithoutProNestedInput>;
  isTipawPartner?: InputMaybe<BoolFieldUpdateOperationsInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  mainProFirstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mainProLastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  maxSmsNotification?: InputMaybe<IntFieldUpdateOperationsInput>;
  maxWeeksBeforeBooking?: InputMaybe<IntFieldUpdateOperationsInput>;
  meta?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  minHoursBeforeBooking?: InputMaybe<IntFieldUpdateOperationsInput>;
  minHoursBeforeUpdateOrCancelBooking?: InputMaybe<IntFieldUpdateOperationsInput>;
  mobilePhone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  namePro?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutProNestedInput>;
  onlineBookingEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  orderingIndex?: InputMaybe<IntFieldUpdateOperationsInput>;
  parking?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  paymentMethods?: InputMaybe<Array<Scalars['String']['input']>>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  practicePlaces?: InputMaybe<Array<EducatorPracticePlaceEnum>>;
  privateEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  proMongoId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  profileVideo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  profileVideoPos?: InputMaybe<IntFieldUpdateOperationsInput>;
  published?: InputMaybe<BoolFieldUpdateOperationsInput>;
  reviews?: InputMaybe<EducatorReviewUpdateManyWithoutProfessionalNestedInput>;
  searchString?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  selfDogWash?: InputMaybe<BoolFieldUpdateOperationsInput>;
  shopOpeningHours?: InputMaybe<ProShopOpeningHourUpdateManyWithoutProNestedInput>;
  smsBookingRemindersEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  stats?: InputMaybe<ProStatUpdateManyWithoutProNestedInput>;
  translations?: InputMaybe<ProTranslationUpdateManyWithoutProNestedInput>;
  type?: InputMaybe<EnumProfessionalTypeEnumFieldUpdateOperationsInput>;
  unclaimedProfile?: InputMaybe<BoolFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  urgencyAvailabilities?: InputMaybe<ProUrgencyAvailabilityUpdateManyWithoutProNestedInput>;
  visitAtHome?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  whatsappNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ProfessionalUpdateacceptedAnimalsInput = {
  push?: InputMaybe<Array<AnimalTypeEnum>>;
  set?: InputMaybe<Array<AnimalTypeEnum>>;
};

export type ProfessionalUpdatepaymentMethodsInput = {
  push?: InputMaybe<Array<Scalars['String']['input']>>;
  set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ProfessionalUpdatepracticePlacesInput = {
  push?: InputMaybe<Array<EducatorPracticePlaceEnum>>;
  set?: InputMaybe<Array<EducatorPracticePlaceEnum>>;
};

export type ProfessionalUpdatespokenLanguagesInput = {
  push?: InputMaybe<Array<Scalars['String']['input']>>;
  set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ProfessionalUpsertWithoutAddressInput = {
  create: ProfessionalCreateWithoutAddressInput;
  update: ProfessionalUpdateWithoutAddressInput;
  where?: InputMaybe<ProfessionalWhereInput>;
};

export type ProfessionalUpsertWithoutAdminNotesInput = {
  create: ProfessionalCreateWithoutAdminNotesInput;
  update: ProfessionalUpdateWithoutAdminNotesInput;
  where?: InputMaybe<ProfessionalWhereInput>;
};

export type ProfessionalUpsertWithoutAvailabilitiesInput = {
  create: ProfessionalCreateWithoutAvailabilitiesInput;
  update: ProfessionalUpdateWithoutAvailabilitiesInput;
  where?: InputMaybe<ProfessionalWhereInput>;
};

export type ProfessionalUpsertWithoutDegreesInput = {
  create: ProfessionalCreateWithoutDegreesInput;
  update: ProfessionalUpdateWithoutDegreesInput;
  where?: InputMaybe<ProfessionalWhereInput>;
};

export type ProfessionalUpsertWithoutEmailHistoryInput = {
  create: ProfessionalCreateWithoutEmailHistoryInput;
  update: ProfessionalUpdateWithoutEmailHistoryInput;
  where?: InputMaybe<ProfessionalWhereInput>;
};

export type ProfessionalUpsertWithoutImgsInput = {
  create: ProfessionalCreateWithoutImgsInput;
  update: ProfessionalUpdateWithoutImgsInput;
  where?: InputMaybe<ProfessionalWhereInput>;
};

export type ProfessionalUpsertWithoutNotificationsInput = {
  create: ProfessionalCreateWithoutNotificationsInput;
  update: ProfessionalUpdateWithoutNotificationsInput;
  where?: InputMaybe<ProfessionalWhereInput>;
};

export type ProfessionalUpsertWithoutReviewsInput = {
  create: ProfessionalCreateWithoutReviewsInput;
  update: ProfessionalUpdateWithoutReviewsInput;
  where?: InputMaybe<ProfessionalWhereInput>;
};

export type ProfessionalUpsertWithoutShopOpeningHoursInput = {
  create: ProfessionalCreateWithoutShopOpeningHoursInput;
  update: ProfessionalUpdateWithoutShopOpeningHoursInput;
  where?: InputMaybe<ProfessionalWhereInput>;
};

export type ProfessionalUpsertWithoutStatsInput = {
  create: ProfessionalCreateWithoutStatsInput;
  update: ProfessionalUpdateWithoutStatsInput;
  where?: InputMaybe<ProfessionalWhereInput>;
};

export type ProfessionalUpsertWithoutTranslationsInput = {
  create: ProfessionalCreateWithoutTranslationsInput;
  update: ProfessionalUpdateWithoutTranslationsInput;
  where?: InputMaybe<ProfessionalWhereInput>;
};

export type ProfessionalUpsertWithoutUrgencyAvailabilitiesInput = {
  create: ProfessionalCreateWithoutUrgencyAvailabilitiesInput;
  update: ProfessionalUpdateWithoutUrgencyAvailabilitiesInput;
  where?: InputMaybe<ProfessionalWhereInput>;
};

export type ProfessionalUpsertWithoutWorkersInput = {
  create: ProfessionalCreateWithoutWorkersInput;
  update: ProfessionalUpdateWithoutWorkersInput;
  where?: InputMaybe<ProfessionalWhereInput>;
};

export type ProfessionalWhereInput = {
  AND?: InputMaybe<Array<ProfessionalWhereInput>>;
  NOT?: InputMaybe<Array<ProfessionalWhereInput>>;
  OR?: InputMaybe<Array<ProfessionalWhereInput>>;
  acceptedAnimals?: InputMaybe<EnumAnimalTypeEnumNullableListFilter>;
  acceptsNewClients?: InputMaybe<BoolFilter>;
  acceptsOnlineAppointment?: InputMaybe<BoolFilter>;
  address?: InputMaybe<AddressNullableRelationFilter>;
  addressId?: InputMaybe<IntNullableFilter>;
  adminNotes?: InputMaybe<AdminNoteListRelationFilter>;
  allowsAnyWorkerOption?: InputMaybe<BoolFilter>;
  assistantsCount?: InputMaybe<IntNullableFilter>;
  availabilities?: InputMaybe<ProAvailabilityListRelationFilter>;
  bookingGroupingMaxSlotDistance?: InputMaybe<IntFilter>;
  centerType?: InputMaybe<EnumCenterTypeEnumNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  defaultServiceDurationMinute?: InputMaybe<IntFilter>;
  degrees?: InputMaybe<ProDegreesListRelationFilter>;
  educatorType?: InputMaybe<EnumEducatorTypeEnumNullableFilter>;
  email?: InputMaybe<StringNullableFilter>;
  emailHistory?: InputMaybe<EmailHistoryListRelationFilter>;
  employeesCount?: InputMaybe<IntNullableFilter>;
  forceBookingGrouping?: InputMaybe<BoolFilter>;
  googleAccessToken?: InputMaybe<StringNullableFilter>;
  googleEmail?: InputMaybe<StringNullableFilter>;
  googleIdToken?: InputMaybe<StringNullableFilter>;
  googleRefreshToken?: InputMaybe<StringNullableFilter>;
  googleTokenExpiryDate?: InputMaybe<StringNullableFilter>;
  googleTokenScope?: InputMaybe<StringNullableFilter>;
  googleTokenType?: InputMaybe<StringNullableFilter>;
  hasShop?: InputMaybe<BoolNullableFilter>;
  id?: InputMaybe<IntFilter>;
  imgs?: InputMaybe<ProImgListRelationFilter>;
  isTipawPartner?: InputMaybe<BoolFilter>;
  language?: InputMaybe<StringFilter>;
  mainProFirstName?: InputMaybe<StringNullableFilter>;
  mainProLastName?: InputMaybe<StringNullableFilter>;
  maxSmsNotification?: InputMaybe<IntFilter>;
  maxWeeksBeforeBooking?: InputMaybe<IntFilter>;
  meta?: InputMaybe<StringNullableFilter>;
  minHoursBeforeBooking?: InputMaybe<IntFilter>;
  minHoursBeforeUpdateOrCancelBooking?: InputMaybe<IntFilter>;
  mobilePhone?: InputMaybe<StringNullableFilter>;
  namePro?: InputMaybe<StringNullableFilter>;
  notifications?: InputMaybe<NotificationListRelationFilter>;
  onlineBookingEnabled?: InputMaybe<BoolFilter>;
  orderingIndex?: InputMaybe<IntFilter>;
  parking?: InputMaybe<BoolNullableFilter>;
  paymentMethods?: InputMaybe<StringNullableListFilter>;
  phone?: InputMaybe<StringNullableFilter>;
  practicePlaces?: InputMaybe<EnumEducatorPracticePlaceEnumNullableListFilter>;
  privateEmail?: InputMaybe<StringNullableFilter>;
  proMongoId?: InputMaybe<StringNullableFilter>;
  profileVideo?: InputMaybe<StringNullableFilter>;
  profileVideoPos?: InputMaybe<IntFilter>;
  published?: InputMaybe<BoolFilter>;
  reviews?: InputMaybe<EducatorReviewListRelationFilter>;
  searchString?: InputMaybe<StringNullableFilter>;
  selfDogWash?: InputMaybe<BoolFilter>;
  shopOpeningHours?: InputMaybe<ProShopOpeningHourListRelationFilter>;
  smsBookingRemindersEnabled?: InputMaybe<BoolFilter>;
  spokenLanguages?: InputMaybe<StringNullableListFilter>;
  stats?: InputMaybe<ProStatListRelationFilter>;
  translations?: InputMaybe<ProTranslationListRelationFilter>;
  type?: InputMaybe<EnumProfessionalTypeEnumFilter>;
  unclaimedProfile?: InputMaybe<BoolFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  urgencyAvailabilities?: InputMaybe<ProUrgencyAvailabilityListRelationFilter>;
  visitAtHome?: InputMaybe<BoolNullableFilter>;
  website?: InputMaybe<StringNullableFilter>;
  whatsappNumber?: InputMaybe<StringNullableFilter>;
  workers?: InputMaybe<WorkerListRelationFilter>;
};

export type ProfessionalWhereUniqueInput = {
  AND?: InputMaybe<Array<ProfessionalWhereInput>>;
  NOT?: InputMaybe<Array<ProfessionalWhereInput>>;
  OR?: InputMaybe<Array<ProfessionalWhereInput>>;
  acceptedAnimals?: InputMaybe<EnumAnimalTypeEnumNullableListFilter>;
  acceptsNewClients?: InputMaybe<BoolFilter>;
  acceptsOnlineAppointment?: InputMaybe<BoolFilter>;
  address?: InputMaybe<AddressNullableRelationFilter>;
  addressId?: InputMaybe<Scalars['Int']['input']>;
  adminNotes?: InputMaybe<AdminNoteListRelationFilter>;
  allowsAnyWorkerOption?: InputMaybe<BoolFilter>;
  assistantsCount?: InputMaybe<IntNullableFilter>;
  availabilities?: InputMaybe<ProAvailabilityListRelationFilter>;
  bookingGroupingMaxSlotDistance?: InputMaybe<IntFilter>;
  centerType?: InputMaybe<EnumCenterTypeEnumNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  defaultServiceDurationMinute?: InputMaybe<IntFilter>;
  degrees?: InputMaybe<ProDegreesListRelationFilter>;
  educatorType?: InputMaybe<EnumEducatorTypeEnumNullableFilter>;
  email?: InputMaybe<StringNullableFilter>;
  emailHistory?: InputMaybe<EmailHistoryListRelationFilter>;
  employeesCount?: InputMaybe<IntNullableFilter>;
  forceBookingGrouping?: InputMaybe<BoolFilter>;
  googleAccessToken?: InputMaybe<StringNullableFilter>;
  googleEmail?: InputMaybe<StringNullableFilter>;
  googleIdToken?: InputMaybe<StringNullableFilter>;
  googleRefreshToken?: InputMaybe<StringNullableFilter>;
  googleTokenExpiryDate?: InputMaybe<StringNullableFilter>;
  googleTokenScope?: InputMaybe<StringNullableFilter>;
  googleTokenType?: InputMaybe<StringNullableFilter>;
  hasShop?: InputMaybe<BoolNullableFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  imgs?: InputMaybe<ProImgListRelationFilter>;
  isTipawPartner?: InputMaybe<BoolFilter>;
  language?: InputMaybe<StringFilter>;
  mainProFirstName?: InputMaybe<StringNullableFilter>;
  mainProLastName?: InputMaybe<StringNullableFilter>;
  maxSmsNotification?: InputMaybe<IntFilter>;
  maxWeeksBeforeBooking?: InputMaybe<IntFilter>;
  meta?: InputMaybe<StringNullableFilter>;
  minHoursBeforeBooking?: InputMaybe<IntFilter>;
  minHoursBeforeUpdateOrCancelBooking?: InputMaybe<IntFilter>;
  mobilePhone?: InputMaybe<StringNullableFilter>;
  namePro?: InputMaybe<StringNullableFilter>;
  notifications?: InputMaybe<NotificationListRelationFilter>;
  onlineBookingEnabled?: InputMaybe<BoolFilter>;
  orderingIndex?: InputMaybe<IntFilter>;
  parking?: InputMaybe<BoolNullableFilter>;
  paymentMethods?: InputMaybe<StringNullableListFilter>;
  phone?: InputMaybe<StringNullableFilter>;
  practicePlaces?: InputMaybe<EnumEducatorPracticePlaceEnumNullableListFilter>;
  privateEmail?: InputMaybe<StringNullableFilter>;
  proMongoId?: InputMaybe<Scalars['String']['input']>;
  profileVideo?: InputMaybe<StringNullableFilter>;
  profileVideoPos?: InputMaybe<IntFilter>;
  published?: InputMaybe<BoolFilter>;
  reviews?: InputMaybe<EducatorReviewListRelationFilter>;
  searchString?: InputMaybe<StringNullableFilter>;
  selfDogWash?: InputMaybe<BoolFilter>;
  shopOpeningHours?: InputMaybe<ProShopOpeningHourListRelationFilter>;
  smsBookingRemindersEnabled?: InputMaybe<BoolFilter>;
  spokenLanguages?: InputMaybe<StringNullableListFilter>;
  stats?: InputMaybe<ProStatListRelationFilter>;
  translations?: InputMaybe<ProTranslationListRelationFilter>;
  type?: InputMaybe<EnumProfessionalTypeEnumFilter>;
  unclaimedProfile?: InputMaybe<BoolFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  urgencyAvailabilities?: InputMaybe<ProUrgencyAvailabilityListRelationFilter>;
  visitAtHome?: InputMaybe<BoolNullableFilter>;
  website?: InputMaybe<StringNullableFilter>;
  whatsappNumber?: InputMaybe<StringNullableFilter>;
  workers?: InputMaybe<WorkerListRelationFilter>;
};

export type Query = {
  __typename?: 'Query';
  accountMe?: Maybe<Account>;
  aggregateAnimal?: Maybe<AggregateAnimal>;
  aggregateAnnouncement?: Maybe<AggregateAnnouncement>;
  aggregateArticle?: Maybe<AggregateArticle>;
  aggregateBookingAnimal?: Maybe<AggregateBookingAnimal>;
  aggregateDogBreed?: Maybe<AggregateDogBreed>;
  aggregateDogBreeder?: Maybe<AggregateDogBreeder>;
  aggregateDogBreederReview?: Maybe<AggregateDogBreederReview>;
  aggregateDogBreederTranslation?: Maybe<AggregateDogBreederTranslation>;
  aggregateDogShelter?: Maybe<AggregateDogShelter>;
  aggregateEducatorReview?: Maybe<AggregateEducatorReview>;
  aggregateLitter?: Maybe<AggregateLitter>;
  aggregateLitterParent?: Maybe<AggregateLitterParent>;
  aggregateLitterTranslation?: Maybe<AggregateLitterTranslation>;
  conversations: Array<Conversation>;
  findBookingAvailabilities?: Maybe<BookingAvailabilities>;
  findFirstBookingAnimal?: Maybe<BookingAnimal>;
  findFirstDogBreederTranslation?: Maybe<DogBreederTranslation>;
  findFirstLitterParent?: Maybe<LitterParent>;
  findFirstLitterTranslation?: Maybe<LitterTranslation>;
  findManyAnimal?: Maybe<Array<Animal>>;
  findManyAnnouncement?: Maybe<Array<Announcement>>;
  findManyArticle?: Maybe<Array<Article>>;
  findManyBookingAnimal?: Maybe<Array<BookingAnimal>>;
  findManyBookingAnimalCount: Scalars['Int']['output'];
  findManyDogBreed?: Maybe<Array<DogBreed>>;
  findManyDogBreedInterestSubscription?: Maybe<Array<DogBreedInterestSubscription>>;
  findManyDogBreeder?: Maybe<Array<DogBreeder>>;
  findManyDogBreederTranslation?: Maybe<Array<DogBreederTranslation>>;
  findManyDogBreederTranslationCount: Scalars['Int']['output'];
  findManyDogShelter?: Maybe<Array<DogShelter>>;
  findManyLitter?: Maybe<Array<Litter>>;
  findManyLitterParent?: Maybe<Array<LitterParent>>;
  findManyLitterParentCount: Scalars['Int']['output'];
  findManyLitterTranslation?: Maybe<Array<LitterTranslation>>;
  findManyLitterTranslationCount: Scalars['Int']['output'];
  findManyNotification: Notifications;
  findManyService?: Maybe<Array<Service>>;
  findUniqueApplication?: Maybe<DogBreederApplication>;
  findUniqueBookingAnimal?: Maybe<BookingAnimal>;
  findUniqueDogBreeder?: Maybe<DogBreeder>;
  findUniqueDogBreederTranslation?: Maybe<DogBreederTranslation>;
  findUniqueLitterParent?: Maybe<LitterParent>;
  findUniqueLitterTranslation?: Maybe<LitterTranslation>;
  getContactPreferences: CustomContactPreferences;
  locationCountry?: Maybe<Scalars['String']['output']>;
  messages: Array<Message>;
  newNotificationsCount: Scalars['Int']['output'];
  professionalCalendarRequestAccessUrl: Scalars['String']['output'];
  professionalLocations: Array<Maybe<ProfessionalLocations>>;
  relatedProfessionals: RelatedProfessionals;
  searchProfessionals: SearchProfessionalsOutput;
  servicesLocations: ServiceLocationsOutput;
  unseenMessages: Array<Message>;
  unsubscribe: CustomContactPreferences;
};


export type QueryaggregateAnimalArgs = {
  orderBy?: InputMaybe<AnimalOrderByWithRelationAndSearchRelevanceInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AnimalWhereInput>;
};


export type QueryaggregateAnnouncementArgs = {
  cursor?: InputMaybe<AnnouncementWhereUniqueInput>;
  orderBy?: InputMaybe<Array<InputMaybe<AnnouncementOrderByWithRelationAndSearchRelevanceInput>>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AnnouncementWhereInput>;
};


export type QueryaggregateArticleArgs = {
  cursor?: InputMaybe<ArticleWhereUniqueInput>;
  orderBy?: InputMaybe<Array<InputMaybe<ArticleOrderByWithRelationAndSearchRelevanceInput>>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ArticleWhereInput>;
};


export type QueryaggregateBookingAnimalArgs = {
  cursor?: InputMaybe<BookingAnimalWhereUniqueInput>;
  orderBy?: InputMaybe<Array<InputMaybe<BookingAnimalOrderByWithRelationAndSearchRelevanceInput>>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<BookingAnimalWhereInput>;
};


export type QueryaggregateDogBreedArgs = {
  cursor?: InputMaybe<DogBreedWhereUniqueInput>;
  orderBy?: InputMaybe<Array<InputMaybe<DogBreedOrderByWithRelationAndSearchRelevanceInput>>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DogBreedWhereInput>;
};


export type QueryaggregateDogBreederArgs = {
  cursor?: InputMaybe<DogBreederWhereUniqueInput>;
  orderBy?: InputMaybe<Array<InputMaybe<DogBreederOrderByWithRelationAndSearchRelevanceInput>>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DogBreederWhereInput>;
};


export type QueryaggregateDogBreederReviewArgs = {
  cursor?: InputMaybe<DogBreederReviewWhereUniqueInput>;
  orderBy?: InputMaybe<Array<InputMaybe<DogBreederReviewOrderByWithRelationAndSearchRelevanceInput>>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DogBreederReviewWhereInput>;
};


export type QueryaggregateDogBreederTranslationArgs = {
  cursor?: InputMaybe<DogBreederTranslationWhereUniqueInput>;
  orderBy?: InputMaybe<Array<InputMaybe<DogBreederTranslationOrderByWithRelationAndSearchRelevanceInput>>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DogBreederTranslationWhereInput>;
};


export type QueryaggregateDogShelterArgs = {
  orderBy?: InputMaybe<DogShelterOrderByWithRelationAndSearchRelevanceInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DogShelterWhereInput>;
};


export type QueryaggregateEducatorReviewArgs = {
  cursor?: InputMaybe<EducatorReviewWhereUniqueInput>;
  orderBy?: InputMaybe<Array<InputMaybe<EducatorReviewOrderByWithRelationAndSearchRelevanceInput>>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<EducatorReviewWhereInput>;
};


export type QueryaggregateLitterArgs = {
  cursor?: InputMaybe<LitterWhereUniqueInput>;
  orderBy?: InputMaybe<Array<InputMaybe<LitterOrderByWithRelationAndSearchRelevanceInput>>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<LitterWhereInput>;
};


export type QueryaggregateLitterParentArgs = {
  cursor?: InputMaybe<LitterParentWhereUniqueInput>;
  orderBy?: InputMaybe<Array<InputMaybe<LitterParentOrderByWithRelationAndSearchRelevanceInput>>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<LitterParentWhereInput>;
};


export type QueryaggregateLitterTranslationArgs = {
  cursor?: InputMaybe<LitterTranslationWhereUniqueInput>;
  orderBy?: InputMaybe<Array<InputMaybe<LitterTranslationOrderByWithRelationAndSearchRelevanceInput>>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<LitterTranslationWhereInput>;
};


export type QueryfindBookingAvailabilitiesArgs = {
  forMultiAnimals: Scalars['Boolean']['input'];
  fromDate: Scalars['DateTime']['input'];
  proId: Scalars['Int']['input'];
  proServiceId?: InputMaybe<Scalars['String']['input']>;
  workerServiceId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryfindFirstBookingAnimalArgs = {
  cursor?: InputMaybe<BookingAnimalWhereUniqueInput>;
  distinct?: InputMaybe<Array<InputMaybe<BookingAnimalScalarFieldEnum>>>;
  orderBy?: InputMaybe<Array<InputMaybe<BookingAnimalOrderByWithRelationAndSearchRelevanceInput>>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<BookingAnimalWhereInput>;
};


export type QueryfindFirstDogBreederTranslationArgs = {
  cursor?: InputMaybe<DogBreederTranslationWhereUniqueInput>;
  distinct?: InputMaybe<Array<InputMaybe<DogBreederTranslationScalarFieldEnum>>>;
  orderBy?: InputMaybe<Array<InputMaybe<DogBreederTranslationOrderByWithRelationAndSearchRelevanceInput>>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DogBreederTranslationWhereInput>;
};


export type QueryfindFirstLitterParentArgs = {
  cursor?: InputMaybe<LitterParentWhereUniqueInput>;
  distinct?: InputMaybe<Array<InputMaybe<LitterParentScalarFieldEnum>>>;
  orderBy?: InputMaybe<Array<InputMaybe<LitterParentOrderByWithRelationAndSearchRelevanceInput>>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<LitterParentWhereInput>;
};


export type QueryfindFirstLitterTranslationArgs = {
  cursor?: InputMaybe<LitterTranslationWhereUniqueInput>;
  distinct?: InputMaybe<Array<InputMaybe<LitterTranslationScalarFieldEnum>>>;
  orderBy?: InputMaybe<Array<InputMaybe<LitterTranslationOrderByWithRelationAndSearchRelevanceInput>>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<LitterTranslationWhereInput>;
};


export type QueryfindManyAnimalArgs = {
  orderBy?: InputMaybe<Array<InputMaybe<AnimalOrderByWithRelationAndSearchRelevanceInput>>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AnimalWhereInput>;
};


export type QueryfindManyAnnouncementArgs = {
  cursor?: InputMaybe<AnnouncementWhereUniqueInput>;
  distinct?: InputMaybe<Array<InputMaybe<AnnouncementScalarFieldEnum>>>;
  orderBy?: InputMaybe<Array<InputMaybe<AnnouncementOrderByWithRelationAndSearchRelevanceInput>>>;
  randomOrder?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AnnouncementWhereInput>;
};


export type QueryfindManyArticleArgs = {
  cursor?: InputMaybe<ArticleWhereUniqueInput>;
  distinct?: InputMaybe<Array<InputMaybe<ArticleScalarFieldEnum>>>;
  orderBy?: InputMaybe<Array<InputMaybe<ArticleOrderByWithRelationAndSearchRelevanceInput>>>;
  randomOrder?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ArticleWhereInput>;
};


export type QueryfindManyBookingAnimalArgs = {
  cursor?: InputMaybe<BookingAnimalWhereUniqueInput>;
  distinct?: InputMaybe<Array<InputMaybe<BookingAnimalScalarFieldEnum>>>;
  orderBy?: InputMaybe<Array<InputMaybe<BookingAnimalOrderByWithRelationAndSearchRelevanceInput>>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<BookingAnimalWhereInput>;
};


export type QueryfindManyBookingAnimalCountArgs = {
  cursor?: InputMaybe<BookingAnimalWhereUniqueInput>;
  distinct?: InputMaybe<Array<InputMaybe<BookingAnimalScalarFieldEnum>>>;
  orderBy?: InputMaybe<Array<InputMaybe<BookingAnimalOrderByWithRelationAndSearchRelevanceInput>>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<BookingAnimalWhereInput>;
};


export type QueryfindManyDogBreedArgs = {
  cursor?: InputMaybe<DogBreedWhereUniqueInput>;
  distinct?: InputMaybe<Array<InputMaybe<DogBreedScalarFieldEnum>>>;
  orderBy?: InputMaybe<Array<InputMaybe<DogBreedOrderByWithRelationAndSearchRelevanceInput>>>;
  randomOrder?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DogBreedWhereInput>;
};


export type QueryfindManyDogBreedInterestSubscriptionArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DogBreedInterestSubscriptionWhereInput>;
};


export type QueryfindManyDogBreederArgs = {
  cursor?: InputMaybe<DogBreederWhereUniqueInput>;
  distinct?: InputMaybe<Array<InputMaybe<DogBreederScalarFieldEnum>>>;
  orderBy?: InputMaybe<Array<InputMaybe<DogBreederOrderByWithRelationAndSearchRelevanceInput>>>;
  randomOrder?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DogBreederWhereInput>;
};


export type QueryfindManyDogBreederTranslationArgs = {
  cursor?: InputMaybe<DogBreederTranslationWhereUniqueInput>;
  distinct?: InputMaybe<Array<InputMaybe<DogBreederTranslationScalarFieldEnum>>>;
  orderBy?: InputMaybe<Array<InputMaybe<DogBreederTranslationOrderByWithRelationAndSearchRelevanceInput>>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DogBreederTranslationWhereInput>;
};


export type QueryfindManyDogBreederTranslationCountArgs = {
  cursor?: InputMaybe<DogBreederTranslationWhereUniqueInput>;
  distinct?: InputMaybe<Array<InputMaybe<DogBreederTranslationScalarFieldEnum>>>;
  orderBy?: InputMaybe<Array<InputMaybe<DogBreederTranslationOrderByWithRelationAndSearchRelevanceInput>>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DogBreederTranslationWhereInput>;
};


export type QueryfindManyDogShelterArgs = {
  orderBy?: InputMaybe<Array<InputMaybe<DogShelterOrderByWithRelationAndSearchRelevanceInput>>>;
  randomOrder?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DogShelterWhereInput>;
};


export type QueryfindManyLitterArgs = {
  cursor?: InputMaybe<LitterWhereUniqueInput>;
  distinct?: InputMaybe<Array<InputMaybe<LitterScalarFieldEnum>>>;
  orderBy?: InputMaybe<Array<InputMaybe<LitterOrderByWithRelationAndSearchRelevanceInput>>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<LitterWhereInput>;
};


export type QueryfindManyLitterParentArgs = {
  cursor?: InputMaybe<LitterParentWhereUniqueInput>;
  distinct?: InputMaybe<Array<InputMaybe<LitterParentScalarFieldEnum>>>;
  orderBy?: InputMaybe<Array<InputMaybe<LitterParentOrderByWithRelationAndSearchRelevanceInput>>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<LitterParentWhereInput>;
};


export type QueryfindManyLitterParentCountArgs = {
  cursor?: InputMaybe<LitterParentWhereUniqueInput>;
  distinct?: InputMaybe<Array<InputMaybe<LitterParentScalarFieldEnum>>>;
  orderBy?: InputMaybe<Array<InputMaybe<LitterParentOrderByWithRelationAndSearchRelevanceInput>>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<LitterParentWhereInput>;
};


export type QueryfindManyLitterTranslationArgs = {
  cursor?: InputMaybe<LitterTranslationWhereUniqueInput>;
  distinct?: InputMaybe<Array<InputMaybe<LitterTranslationScalarFieldEnum>>>;
  orderBy?: InputMaybe<Array<InputMaybe<LitterTranslationOrderByWithRelationAndSearchRelevanceInput>>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<LitterTranslationWhereInput>;
};


export type QueryfindManyLitterTranslationCountArgs = {
  cursor?: InputMaybe<LitterTranslationWhereUniqueInput>;
  distinct?: InputMaybe<Array<InputMaybe<LitterTranslationScalarFieldEnum>>>;
  orderBy?: InputMaybe<Array<InputMaybe<LitterTranslationOrderByWithRelationAndSearchRelevanceInput>>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<LitterTranslationWhereInput>;
};


export type QueryfindManyNotificationArgs = {
  orderBy?: InputMaybe<NotificationOrderByWithRelationAndSearchRelevanceInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<NotificationWhereInput>;
};


export type QueryfindManyServiceArgs = {
  cursor?: InputMaybe<ServiceWhereUniqueInput>;
  distinct?: InputMaybe<Array<InputMaybe<ServiceScalarFieldEnum>>>;
  orderBy?: InputMaybe<Array<InputMaybe<ServiceOrderByWithRelationAndSearchRelevanceInput>>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ServiceWhereInput>;
};


export type QueryfindUniqueApplicationArgs = {
  where: DogBreederApplicationWhereUniqueInput;
};


export type QueryfindUniqueBookingAnimalArgs = {
  where: BookingAnimalWhereUniqueInput;
};


export type QueryfindUniqueDogBreederArgs = {
  where: DogBreederWhereUniqueInput;
};


export type QueryfindUniqueDogBreederTranslationArgs = {
  where: DogBreederTranslationWhereUniqueInput;
};


export type QueryfindUniqueLitterParentArgs = {
  where: LitterParentWhereUniqueInput;
};


export type QueryfindUniqueLitterTranslationArgs = {
  where: LitterTranslationWhereUniqueInput;
};


export type QuerygetContactPreferencesArgs = {
  email: Scalars['String']['input'];
};


export type QuerylocationCountryArgs = {
  location: Scalars['String']['input'];
};


export type QuerymessagesArgs = {
  otherAccountId: Scalars['Int']['input'];
};


export type QueryprofessionalLocationsArgs = {
  country?: InputMaybe<CountryCode>;
  maxDistance?: InputMaybe<Scalars['Int']['input']>;
  nearByPoint?: InputMaybe<LatLngPoint>;
  proType?: InputMaybe<ProfessionalTypeEnum>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryrelatedProfessionalsArgs = {
  country: CountryCode;
  language: Scalars['String']['input'];
  nearByPoint?: InputMaybe<LatLngPoint>;
  proId?: InputMaybe<Scalars['Int']['input']>;
  proType?: InputMaybe<ProfessionalTypeEnum>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerysearchProfessionalsArgs = {
  cursor?: InputMaybe<ProfessionalWhereUniqueInput>;
  distinct?: InputMaybe<Array<InputMaybe<ProfessionalScalarFieldEnum>>>;
  language?: InputMaybe<Scalars['String']['input']>;
  maxDistance?: InputMaybe<Scalars['Int']['input']>;
  nearByAddress?: InputMaybe<Scalars['String']['input']>;
  nearByPoint?: InputMaybe<LatLngPoint>;
  orderBy?: InputMaybe<Array<InputMaybe<ProfessionalOrderByWithRelationAndSearchRelevanceInput>>>;
  serviceId?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProfessionalWhereInput>;
};


export type QueryservicesLocationsArgs = {
  country: CountryCode;
};


export type QueryunsubscribeArgs = {
  contactPreferenceToDisable?: InputMaybe<Scalars['String']['input']>;
  cryptedEmail: Scalars['String']['input'];
};

export enum QueryMode {
  default = 'default',
  insensitive = 'insensitive'
}

export type RelatedProfessionals = {
  __typename?: 'RelatedProfessionals';
  locations: Array<Maybe<ProfessionalLocations>>;
  pros: Array<Maybe<Professional>>;
};

export enum Role {
  ADMIN = 'ADMIN',
  USER = 'USER'
}

export type SMSTemplateAvgAggregateOutputType = {
  __typename?: 'SMSTemplateAvgAggregateOutputType';
  id?: Maybe<Scalars['Float']['output']>;
};

export type SMSTemplateAvgOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
};

export type SMSTemplateCountAggregateOutputType = {
  __typename?: 'SMSTemplateCountAggregateOutputType';
  _all: Scalars['Int']['output'];
  body: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  language: Scalars['Int']['output'];
  templateKey: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type SMSTemplateCountOrderByAggregateInput = {
  body?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  language?: InputMaybe<SortOrder>;
  templateKey?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type SMSTemplateCreateInput = {
  body: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  language: Scalars['String']['input'];
  templateKey: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SMSTemplateCreateManyInput = {
  body: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  language: Scalars['String']['input'];
  templateKey: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SMSTemplateMaxAggregateOutputType = {
  __typename?: 'SMSTemplateMaxAggregateOutputType';
  body?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  templateKey?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type SMSTemplateMaxOrderByAggregateInput = {
  body?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  language?: InputMaybe<SortOrder>;
  templateKey?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type SMSTemplateMinAggregateOutputType = {
  __typename?: 'SMSTemplateMinAggregateOutputType';
  body?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  templateKey?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type SMSTemplateMinOrderByAggregateInput = {
  body?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  language?: InputMaybe<SortOrder>;
  templateKey?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum SMSTemplateOrderByRelevanceFieldEnum {
  body = 'body',
  language = 'language',
  templateKey = 'templateKey'
}

export type SMSTemplateOrderByRelevanceInput = {
  fields: Array<SMSTemplateOrderByRelevanceFieldEnum>;
  search: Scalars['String']['input'];
  sort: SortOrder;
};

export type SMSTemplateOrderByWithAggregationInput = {
  _avg?: InputMaybe<SMSTemplateAvgOrderByAggregateInput>;
  _count?: InputMaybe<SMSTemplateCountOrderByAggregateInput>;
  _max?: InputMaybe<SMSTemplateMaxOrderByAggregateInput>;
  _min?: InputMaybe<SMSTemplateMinOrderByAggregateInput>;
  _sum?: InputMaybe<SMSTemplateSumOrderByAggregateInput>;
  body?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  language?: InputMaybe<SortOrder>;
  templateKey?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type SMSTemplateOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: InputMaybe<SMSTemplateOrderByRelevanceInput>;
  body?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  language?: InputMaybe<SortOrder>;
  templateKey?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum SMSTemplateScalarFieldEnum {
  body = 'body',
  createdAt = 'createdAt',
  id = 'id',
  language = 'language',
  templateKey = 'templateKey',
  updatedAt = 'updatedAt'
}

export type SMSTemplateScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<SMSTemplateScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<SMSTemplateScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<SMSTemplateScalarWhereWithAggregatesInput>>;
  body?: InputMaybe<StringWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  language?: InputMaybe<StringWithAggregatesFilter>;
  templateKey?: InputMaybe<StringWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type SMSTemplateSumAggregateOutputType = {
  __typename?: 'SMSTemplateSumAggregateOutputType';
  id?: Maybe<Scalars['Int']['output']>;
};

export type SMSTemplateSumOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
};

export type SMSTemplateUncheckedCreateInput = {
  body: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  language: Scalars['String']['input'];
  templateKey: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SMSTemplateUncheckedUpdateInput = {
  body?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  templateKey?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type SMSTemplateUncheckedUpdateManyInput = {
  body?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  templateKey?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type SMSTemplateUpdateInput = {
  body?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  templateKey?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type SMSTemplateUpdateManyMutationInput = {
  body?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  templateKey?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type SMSTemplateWhereInput = {
  AND?: InputMaybe<Array<SMSTemplateWhereInput>>;
  NOT?: InputMaybe<Array<SMSTemplateWhereInput>>;
  OR?: InputMaybe<Array<SMSTemplateWhereInput>>;
  body?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntFilter>;
  language?: InputMaybe<StringFilter>;
  templateKey?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type SMSTemplateWhereUniqueInput = {
  AND?: InputMaybe<Array<SMSTemplateWhereInput>>;
  NOT?: InputMaybe<Array<SMSTemplateWhereInput>>;
  OR?: InputMaybe<Array<SMSTemplateWhereInput>>;
  body?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  language?: InputMaybe<StringFilter>;
  templateKey?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type SearchProfessionalsOutput = {
  __typename?: 'SearchProfessionalsOutput';
  professionals: Array<Professional>;
  totalCount: Scalars['Int']['output'];
};

export type SendMessageInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['String']['input']>;
  file?: InputMaybe<Scalars['Upload']['input']>;
  fromAccountId?: InputMaybe<Scalars['Int']['input']>;
  image?: InputMaybe<Scalars['Upload']['input']>;
  reported?: InputMaybe<Scalars['Boolean']['input']>;
  seen?: InputMaybe<Scalars['Boolean']['input']>;
  toAccountId: Scalars['Int']['input'];
};

export type Service = {
  __typename?: 'Service';
  _count: ServiceCountOutputType;
  createdAt: Scalars['DateTime']['output'];
  disabled: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  proType: ProfessionalTypeEnum;
  recognisedByEUCollege?: Maybe<Scalars['Boolean']['output']>;
  requiresEmptyStomach?: Maybe<Scalars['Boolean']['output']>;
  translations: Array<ServiceTranslation>;
  updatedAt: Scalars['DateTime']['output'];
  workerServices: Array<WorkerService>;
};


export type ServicetranslationsArgs = {
  cursor?: InputMaybe<ServiceTranslationWhereUniqueInput>;
  distinct?: InputMaybe<ServiceTranslationScalarFieldEnum>;
  orderBy?: InputMaybe<ServiceTranslationOrderByWithRelationAndSearchRelevanceInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ServiceTranslationWhereInput>;
};


export type ServiceworkerServicesArgs = {
  cursor?: InputMaybe<WorkerServiceWhereUniqueInput>;
  distinct?: InputMaybe<WorkerServiceScalarFieldEnum>;
  orderBy?: InputMaybe<WorkerServiceOrderByWithRelationAndSearchRelevanceInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<WorkerServiceWhereInput>;
};

export type ServiceAvgAggregateOutputType = {
  __typename?: 'ServiceAvgAggregateOutputType';
  id?: Maybe<Scalars['Float']['output']>;
};

export type ServiceAvgOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
};

export type ServiceCountAggregateOutputType = {
  __typename?: 'ServiceCountAggregateOutputType';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  disabled: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  proType: Scalars['Int']['output'];
  recognisedByEUCollege: Scalars['Int']['output'];
  requiresEmptyStomach: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type ServiceCountOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  disabled?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  proType?: InputMaybe<SortOrder>;
  recognisedByEUCollege?: InputMaybe<SortOrder>;
  requiresEmptyStomach?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ServiceCountOutputType = {
  __typename?: 'ServiceCountOutputType';
  translations: Scalars['Int']['output'];
  workerServices: Scalars['Int']['output'];
};

export type ServiceCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  proType: ProfessionalTypeEnum;
  recognisedByEUCollege?: InputMaybe<Scalars['Boolean']['input']>;
  requiresEmptyStomach?: InputMaybe<Scalars['Boolean']['input']>;
  translations?: InputMaybe<ServiceTranslationCreateNestedManyWithoutServiceInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  workerServices?: InputMaybe<WorkerServiceCreateNestedManyWithoutServiceInput>;
};

export type ServiceCreateManyInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  proType: ProfessionalTypeEnum;
  recognisedByEUCollege?: InputMaybe<Scalars['Boolean']['input']>;
  requiresEmptyStomach?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ServiceCreateNestedOneWithoutTranslationsInput = {
  connect?: InputMaybe<ServiceWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ServiceCreateOrConnectWithoutTranslationsInput>;
  create?: InputMaybe<ServiceCreateWithoutTranslationsInput>;
};

export type ServiceCreateNestedOneWithoutWorkerServicesInput = {
  connect?: InputMaybe<ServiceWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ServiceCreateOrConnectWithoutWorkerServicesInput>;
  create?: InputMaybe<ServiceCreateWithoutWorkerServicesInput>;
};

export type ServiceCreateOrConnectWithoutTranslationsInput = {
  create: ServiceCreateWithoutTranslationsInput;
  where: ServiceWhereUniqueInput;
};

export type ServiceCreateOrConnectWithoutWorkerServicesInput = {
  create: ServiceCreateWithoutWorkerServicesInput;
  where: ServiceWhereUniqueInput;
};

export type ServiceCreateWithoutTranslationsInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  proType: ProfessionalTypeEnum;
  recognisedByEUCollege?: InputMaybe<Scalars['Boolean']['input']>;
  requiresEmptyStomach?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  workerServices?: InputMaybe<WorkerServiceCreateNestedManyWithoutServiceInput>;
};

export type ServiceCreateWithoutWorkerServicesInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  proType: ProfessionalTypeEnum;
  recognisedByEUCollege?: InputMaybe<Scalars['Boolean']['input']>;
  requiresEmptyStomach?: InputMaybe<Scalars['Boolean']['input']>;
  translations?: InputMaybe<ServiceTranslationCreateNestedManyWithoutServiceInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ServiceLocationsOutput = {
  __typename?: 'ServiceLocationsOutput';
  services: Array<Service>;
  servicesByLocations: Array<ServicesByLocation>;
};

export type ServiceMaxAggregateOutputType = {
  __typename?: 'ServiceMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  disabled?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  proType?: Maybe<ProfessionalTypeEnum>;
  recognisedByEUCollege?: Maybe<Scalars['Boolean']['output']>;
  requiresEmptyStomach?: Maybe<Scalars['Boolean']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ServiceMaxOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  disabled?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  proType?: InputMaybe<SortOrder>;
  recognisedByEUCollege?: InputMaybe<SortOrder>;
  requiresEmptyStomach?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ServiceMinAggregateOutputType = {
  __typename?: 'ServiceMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  disabled?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  proType?: Maybe<ProfessionalTypeEnum>;
  recognisedByEUCollege?: Maybe<Scalars['Boolean']['output']>;
  requiresEmptyStomach?: Maybe<Scalars['Boolean']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ServiceMinOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  disabled?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  proType?: InputMaybe<SortOrder>;
  recognisedByEUCollege?: InputMaybe<SortOrder>;
  requiresEmptyStomach?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ServiceOrderByWithAggregationInput = {
  _avg?: InputMaybe<ServiceAvgOrderByAggregateInput>;
  _count?: InputMaybe<ServiceCountOrderByAggregateInput>;
  _max?: InputMaybe<ServiceMaxOrderByAggregateInput>;
  _min?: InputMaybe<ServiceMinOrderByAggregateInput>;
  _sum?: InputMaybe<ServiceSumOrderByAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  disabled?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  proType?: InputMaybe<SortOrder>;
  recognisedByEUCollege?: InputMaybe<SortOrderInput>;
  requiresEmptyStomach?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ServiceOrderByWithRelationAndSearchRelevanceInput = {
  createdAt?: InputMaybe<SortOrder>;
  disabled?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  proType?: InputMaybe<SortOrder>;
  recognisedByEUCollege?: InputMaybe<SortOrderInput>;
  requiresEmptyStomach?: InputMaybe<SortOrderInput>;
  translations?: InputMaybe<ServiceTranslationOrderByRelationAggregateInput>;
  updatedAt?: InputMaybe<SortOrder>;
  workerServices?: InputMaybe<WorkerServiceOrderByRelationAggregateInput>;
};

export type ServiceRelationFilter = {
  is?: InputMaybe<ServiceWhereInput>;
  isNot?: InputMaybe<ServiceWhereInput>;
};

export enum ServiceScalarFieldEnum {
  createdAt = 'createdAt',
  disabled = 'disabled',
  id = 'id',
  proType = 'proType',
  recognisedByEUCollege = 'recognisedByEUCollege',
  requiresEmptyStomach = 'requiresEmptyStomach',
  updatedAt = 'updatedAt'
}

export type ServiceScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<ServiceScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<ServiceScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<ServiceScalarWhereWithAggregatesInput>>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  disabled?: InputMaybe<BoolWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  proType?: InputMaybe<EnumProfessionalTypeEnumWithAggregatesFilter>;
  recognisedByEUCollege?: InputMaybe<BoolNullableWithAggregatesFilter>;
  requiresEmptyStomach?: InputMaybe<BoolNullableWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type ServiceSumAggregateOutputType = {
  __typename?: 'ServiceSumAggregateOutputType';
  id?: Maybe<Scalars['Int']['output']>;
};

export type ServiceSumOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
};

export type ServiceTranslation = {
  __typename?: 'ServiceTranslation';
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  howItWorks?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  language: Scalars['String']['output'];
  seoDescription?: Maybe<Scalars['String']['output']>;
  seoKeywords?: Maybe<Scalars['String']['output']>;
  seoTitle?: Maybe<Scalars['String']['output']>;
  service: Service;
  serviceId: Scalars['Int']['output'];
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type ServiceTranslationAvgAggregateOutputType = {
  __typename?: 'ServiceTranslationAvgAggregateOutputType';
  id?: Maybe<Scalars['Float']['output']>;
  serviceId?: Maybe<Scalars['Float']['output']>;
};

export type ServiceTranslationAvgOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
  serviceId?: InputMaybe<SortOrder>;
};

export type ServiceTranslationCountAggregateOutputType = {
  __typename?: 'ServiceTranslationCountAggregateOutputType';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  description: Scalars['Int']['output'];
  howItWorks: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  language: Scalars['Int']['output'];
  seoDescription: Scalars['Int']['output'];
  seoKeywords: Scalars['Int']['output'];
  seoTitle: Scalars['Int']['output'];
  serviceId: Scalars['Int']['output'];
  title: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
  url: Scalars['Int']['output'];
};

export type ServiceTranslationCountOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  howItWorks?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  language?: InputMaybe<SortOrder>;
  seoDescription?: InputMaybe<SortOrder>;
  seoKeywords?: InputMaybe<SortOrder>;
  seoTitle?: InputMaybe<SortOrder>;
  serviceId?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  url?: InputMaybe<SortOrder>;
};

export type ServiceTranslationCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  howItWorks?: InputMaybe<Scalars['String']['input']>;
  language: Scalars['String']['input'];
  seoDescription?: InputMaybe<Scalars['String']['input']>;
  seoKeywords?: InputMaybe<Scalars['String']['input']>;
  seoTitle?: InputMaybe<Scalars['String']['input']>;
  service: ServiceCreateNestedOneWithoutTranslationsInput;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type ServiceTranslationCreateManyInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  howItWorks?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  language: Scalars['String']['input'];
  seoDescription?: InputMaybe<Scalars['String']['input']>;
  seoKeywords?: InputMaybe<Scalars['String']['input']>;
  seoTitle?: InputMaybe<Scalars['String']['input']>;
  serviceId: Scalars['Int']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type ServiceTranslationCreateManyServiceInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  howItWorks?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  language: Scalars['String']['input'];
  seoDescription?: InputMaybe<Scalars['String']['input']>;
  seoKeywords?: InputMaybe<Scalars['String']['input']>;
  seoTitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type ServiceTranslationCreateManyServiceInputEnvelope = {
  data: Array<ServiceTranslationCreateManyServiceInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ServiceTranslationCreateNestedManyWithoutServiceInput = {
  connect?: InputMaybe<Array<ServiceTranslationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ServiceTranslationCreateOrConnectWithoutServiceInput>>;
  create?: InputMaybe<Array<ServiceTranslationCreateWithoutServiceInput>>;
  createMany?: InputMaybe<ServiceTranslationCreateManyServiceInputEnvelope>;
};

export type ServiceTranslationCreateOrConnectWithoutServiceInput = {
  create: ServiceTranslationCreateWithoutServiceInput;
  where: ServiceTranslationWhereUniqueInput;
};

export type ServiceTranslationCreateWithoutServiceInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  howItWorks?: InputMaybe<Scalars['String']['input']>;
  language: Scalars['String']['input'];
  seoDescription?: InputMaybe<Scalars['String']['input']>;
  seoKeywords?: InputMaybe<Scalars['String']['input']>;
  seoTitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type ServiceTranslationListRelationFilter = {
  every?: InputMaybe<ServiceTranslationWhereInput>;
  none?: InputMaybe<ServiceTranslationWhereInput>;
  some?: InputMaybe<ServiceTranslationWhereInput>;
};

export type ServiceTranslationMaxAggregateOutputType = {
  __typename?: 'ServiceTranslationMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  howItWorks?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  seoDescription?: Maybe<Scalars['String']['output']>;
  seoKeywords?: Maybe<Scalars['String']['output']>;
  seoTitle?: Maybe<Scalars['String']['output']>;
  serviceId?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type ServiceTranslationMaxOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  howItWorks?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  language?: InputMaybe<SortOrder>;
  seoDescription?: InputMaybe<SortOrder>;
  seoKeywords?: InputMaybe<SortOrder>;
  seoTitle?: InputMaybe<SortOrder>;
  serviceId?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  url?: InputMaybe<SortOrder>;
};

export type ServiceTranslationMinAggregateOutputType = {
  __typename?: 'ServiceTranslationMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  howItWorks?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  seoDescription?: Maybe<Scalars['String']['output']>;
  seoKeywords?: Maybe<Scalars['String']['output']>;
  seoTitle?: Maybe<Scalars['String']['output']>;
  serviceId?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type ServiceTranslationMinOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  howItWorks?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  language?: InputMaybe<SortOrder>;
  seoDescription?: InputMaybe<SortOrder>;
  seoKeywords?: InputMaybe<SortOrder>;
  seoTitle?: InputMaybe<SortOrder>;
  serviceId?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  url?: InputMaybe<SortOrder>;
};

export type ServiceTranslationOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export enum ServiceTranslationOrderByRelevanceFieldEnum {
  description = 'description',
  howItWorks = 'howItWorks',
  language = 'language',
  seoDescription = 'seoDescription',
  seoKeywords = 'seoKeywords',
  seoTitle = 'seoTitle',
  title = 'title',
  url = 'url'
}

export type ServiceTranslationOrderByRelevanceInput = {
  fields: Array<ServiceTranslationOrderByRelevanceFieldEnum>;
  search: Scalars['String']['input'];
  sort: SortOrder;
};

export type ServiceTranslationOrderByWithAggregationInput = {
  _avg?: InputMaybe<ServiceTranslationAvgOrderByAggregateInput>;
  _count?: InputMaybe<ServiceTranslationCountOrderByAggregateInput>;
  _max?: InputMaybe<ServiceTranslationMaxOrderByAggregateInput>;
  _min?: InputMaybe<ServiceTranslationMinOrderByAggregateInput>;
  _sum?: InputMaybe<ServiceTranslationSumOrderByAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrderInput>;
  howItWorks?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  language?: InputMaybe<SortOrder>;
  seoDescription?: InputMaybe<SortOrderInput>;
  seoKeywords?: InputMaybe<SortOrderInput>;
  seoTitle?: InputMaybe<SortOrderInput>;
  serviceId?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
  url?: InputMaybe<SortOrderInput>;
};

export type ServiceTranslationOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: InputMaybe<ServiceTranslationOrderByRelevanceInput>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrderInput>;
  howItWorks?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  language?: InputMaybe<SortOrder>;
  seoDescription?: InputMaybe<SortOrderInput>;
  seoKeywords?: InputMaybe<SortOrderInput>;
  seoTitle?: InputMaybe<SortOrderInput>;
  service?: InputMaybe<ServiceOrderByWithRelationAndSearchRelevanceInput>;
  serviceId?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
  url?: InputMaybe<SortOrderInput>;
};

export enum ServiceTranslationScalarFieldEnum {
  createdAt = 'createdAt',
  description = 'description',
  howItWorks = 'howItWorks',
  id = 'id',
  language = 'language',
  seoDescription = 'seoDescription',
  seoKeywords = 'seoKeywords',
  seoTitle = 'seoTitle',
  serviceId = 'serviceId',
  title = 'title',
  updatedAt = 'updatedAt',
  url = 'url'
}

export type ServiceTranslationScalarWhereInput = {
  AND?: InputMaybe<Array<ServiceTranslationScalarWhereInput>>;
  NOT?: InputMaybe<Array<ServiceTranslationScalarWhereInput>>;
  OR?: InputMaybe<Array<ServiceTranslationScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringNullableFilter>;
  howItWorks?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<IntFilter>;
  language?: InputMaybe<StringFilter>;
  seoDescription?: InputMaybe<StringNullableFilter>;
  seoKeywords?: InputMaybe<StringNullableFilter>;
  seoTitle?: InputMaybe<StringNullableFilter>;
  serviceId?: InputMaybe<IntFilter>;
  title?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  url?: InputMaybe<StringNullableFilter>;
};

export type ServiceTranslationScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<ServiceTranslationScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<ServiceTranslationScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<ServiceTranslationScalarWhereWithAggregatesInput>>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  description?: InputMaybe<StringNullableWithAggregatesFilter>;
  howItWorks?: InputMaybe<StringNullableWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  language?: InputMaybe<StringWithAggregatesFilter>;
  seoDescription?: InputMaybe<StringNullableWithAggregatesFilter>;
  seoKeywords?: InputMaybe<StringNullableWithAggregatesFilter>;
  seoTitle?: InputMaybe<StringNullableWithAggregatesFilter>;
  serviceId?: InputMaybe<IntWithAggregatesFilter>;
  title?: InputMaybe<StringNullableWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  url?: InputMaybe<StringNullableWithAggregatesFilter>;
};

export type ServiceTranslationSumAggregateOutputType = {
  __typename?: 'ServiceTranslationSumAggregateOutputType';
  id?: Maybe<Scalars['Int']['output']>;
  serviceId?: Maybe<Scalars['Int']['output']>;
};

export type ServiceTranslationSumOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
  serviceId?: InputMaybe<SortOrder>;
};

export type ServiceTranslationUncheckedCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  howItWorks?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  language: Scalars['String']['input'];
  seoDescription?: InputMaybe<Scalars['String']['input']>;
  seoKeywords?: InputMaybe<Scalars['String']['input']>;
  seoTitle?: InputMaybe<Scalars['String']['input']>;
  serviceId: Scalars['Int']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type ServiceTranslationUncheckedCreateNestedManyWithoutServiceInput = {
  connect?: InputMaybe<Array<ServiceTranslationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ServiceTranslationCreateOrConnectWithoutServiceInput>>;
  create?: InputMaybe<Array<ServiceTranslationCreateWithoutServiceInput>>;
  createMany?: InputMaybe<ServiceTranslationCreateManyServiceInputEnvelope>;
};

export type ServiceTranslationUncheckedCreateWithoutServiceInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  howItWorks?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  language: Scalars['String']['input'];
  seoDescription?: InputMaybe<Scalars['String']['input']>;
  seoKeywords?: InputMaybe<Scalars['String']['input']>;
  seoTitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type ServiceTranslationUncheckedUpdateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  howItWorks?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  seoDescription?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  seoKeywords?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  seoTitle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  serviceId?: InputMaybe<IntFieldUpdateOperationsInput>;
  title?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  url?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ServiceTranslationUncheckedUpdateManyInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  howItWorks?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  seoDescription?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  seoKeywords?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  seoTitle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  serviceId?: InputMaybe<IntFieldUpdateOperationsInput>;
  title?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  url?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ServiceTranslationUncheckedUpdateManyWithoutServiceInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  howItWorks?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  seoDescription?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  seoKeywords?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  seoTitle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  url?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ServiceTranslationUncheckedUpdateManyWithoutServiceNestedInput = {
  connect?: InputMaybe<Array<ServiceTranslationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ServiceTranslationCreateOrConnectWithoutServiceInput>>;
  create?: InputMaybe<Array<ServiceTranslationCreateWithoutServiceInput>>;
  createMany?: InputMaybe<ServiceTranslationCreateManyServiceInputEnvelope>;
  delete?: InputMaybe<Array<ServiceTranslationWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ServiceTranslationScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ServiceTranslationWhereUniqueInput>>;
  set?: InputMaybe<Array<ServiceTranslationWhereUniqueInput>>;
  update?: InputMaybe<Array<ServiceTranslationUpdateWithWhereUniqueWithoutServiceInput>>;
  updateMany?: InputMaybe<Array<ServiceTranslationUpdateManyWithWhereWithoutServiceInput>>;
  upsert?: InputMaybe<Array<ServiceTranslationUpsertWithWhereUniqueWithoutServiceInput>>;
};

export type ServiceTranslationUncheckedUpdateWithoutServiceInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  howItWorks?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  seoDescription?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  seoKeywords?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  seoTitle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  url?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ServiceTranslationUpdateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  howItWorks?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  seoDescription?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  seoKeywords?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  seoTitle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  service?: InputMaybe<ServiceUpdateOneRequiredWithoutTranslationsNestedInput>;
  title?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  url?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ServiceTranslationUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  howItWorks?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  seoDescription?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  seoKeywords?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  seoTitle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  url?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ServiceTranslationUpdateManyWithWhereWithoutServiceInput = {
  data: ServiceTranslationUpdateManyMutationInput;
  where: ServiceTranslationScalarWhereInput;
};

export type ServiceTranslationUpdateManyWithoutServiceNestedInput = {
  connect?: InputMaybe<Array<ServiceTranslationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ServiceTranslationCreateOrConnectWithoutServiceInput>>;
  create?: InputMaybe<Array<ServiceTranslationCreateWithoutServiceInput>>;
  createMany?: InputMaybe<ServiceTranslationCreateManyServiceInputEnvelope>;
  delete?: InputMaybe<Array<ServiceTranslationWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ServiceTranslationScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ServiceTranslationWhereUniqueInput>>;
  set?: InputMaybe<Array<ServiceTranslationWhereUniqueInput>>;
  update?: InputMaybe<Array<ServiceTranslationUpdateWithWhereUniqueWithoutServiceInput>>;
  updateMany?: InputMaybe<Array<ServiceTranslationUpdateManyWithWhereWithoutServiceInput>>;
  upsert?: InputMaybe<Array<ServiceTranslationUpsertWithWhereUniqueWithoutServiceInput>>;
};

export type ServiceTranslationUpdateWithWhereUniqueWithoutServiceInput = {
  data: ServiceTranslationUpdateWithoutServiceInput;
  where: ServiceTranslationWhereUniqueInput;
};

export type ServiceTranslationUpdateWithoutServiceInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  howItWorks?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  seoDescription?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  seoKeywords?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  seoTitle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  url?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ServiceTranslationUpsertWithWhereUniqueWithoutServiceInput = {
  create: ServiceTranslationCreateWithoutServiceInput;
  update: ServiceTranslationUpdateWithoutServiceInput;
  where: ServiceTranslationWhereUniqueInput;
};

export type ServiceTranslationWhereInput = {
  AND?: InputMaybe<Array<ServiceTranslationWhereInput>>;
  NOT?: InputMaybe<Array<ServiceTranslationWhereInput>>;
  OR?: InputMaybe<Array<ServiceTranslationWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringNullableFilter>;
  howItWorks?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<IntFilter>;
  language?: InputMaybe<StringFilter>;
  seoDescription?: InputMaybe<StringNullableFilter>;
  seoKeywords?: InputMaybe<StringNullableFilter>;
  seoTitle?: InputMaybe<StringNullableFilter>;
  service?: InputMaybe<ServiceRelationFilter>;
  serviceId?: InputMaybe<IntFilter>;
  title?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  url?: InputMaybe<StringNullableFilter>;
};

export type ServiceTranslationWhereUniqueInput = {
  AND?: InputMaybe<Array<ServiceTranslationWhereInput>>;
  NOT?: InputMaybe<Array<ServiceTranslationWhereInput>>;
  OR?: InputMaybe<Array<ServiceTranslationWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringNullableFilter>;
  howItWorks?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  language?: InputMaybe<StringFilter>;
  seoDescription?: InputMaybe<StringNullableFilter>;
  seoKeywords?: InputMaybe<StringNullableFilter>;
  seoTitle?: InputMaybe<StringNullableFilter>;
  service?: InputMaybe<ServiceRelationFilter>;
  serviceId?: InputMaybe<IntFilter>;
  title?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  url?: InputMaybe<StringNullableFilter>;
};

export type ServiceUncheckedCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  proType: ProfessionalTypeEnum;
  recognisedByEUCollege?: InputMaybe<Scalars['Boolean']['input']>;
  requiresEmptyStomach?: InputMaybe<Scalars['Boolean']['input']>;
  translations?: InputMaybe<ServiceTranslationUncheckedCreateNestedManyWithoutServiceInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  workerServices?: InputMaybe<WorkerServiceUncheckedCreateNestedManyWithoutServiceInput>;
};

export type ServiceUncheckedCreateWithoutTranslationsInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  proType: ProfessionalTypeEnum;
  recognisedByEUCollege?: InputMaybe<Scalars['Boolean']['input']>;
  requiresEmptyStomach?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  workerServices?: InputMaybe<WorkerServiceUncheckedCreateNestedManyWithoutServiceInput>;
};

export type ServiceUncheckedCreateWithoutWorkerServicesInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  proType: ProfessionalTypeEnum;
  recognisedByEUCollege?: InputMaybe<Scalars['Boolean']['input']>;
  requiresEmptyStomach?: InputMaybe<Scalars['Boolean']['input']>;
  translations?: InputMaybe<ServiceTranslationUncheckedCreateNestedManyWithoutServiceInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ServiceUncheckedUpdateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  disabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  proType?: InputMaybe<EnumProfessionalTypeEnumFieldUpdateOperationsInput>;
  recognisedByEUCollege?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  requiresEmptyStomach?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  translations?: InputMaybe<ServiceTranslationUncheckedUpdateManyWithoutServiceNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  workerServices?: InputMaybe<WorkerServiceUncheckedUpdateManyWithoutServiceNestedInput>;
};

export type ServiceUncheckedUpdateManyInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  disabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  proType?: InputMaybe<EnumProfessionalTypeEnumFieldUpdateOperationsInput>;
  recognisedByEUCollege?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  requiresEmptyStomach?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ServiceUncheckedUpdateWithoutTranslationsInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  disabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  proType?: InputMaybe<EnumProfessionalTypeEnumFieldUpdateOperationsInput>;
  recognisedByEUCollege?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  requiresEmptyStomach?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  workerServices?: InputMaybe<WorkerServiceUncheckedUpdateManyWithoutServiceNestedInput>;
};

export type ServiceUncheckedUpdateWithoutWorkerServicesInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  disabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  proType?: InputMaybe<EnumProfessionalTypeEnumFieldUpdateOperationsInput>;
  recognisedByEUCollege?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  requiresEmptyStomach?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  translations?: InputMaybe<ServiceTranslationUncheckedUpdateManyWithoutServiceNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ServiceUpdateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  disabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  proType?: InputMaybe<EnumProfessionalTypeEnumFieldUpdateOperationsInput>;
  recognisedByEUCollege?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  requiresEmptyStomach?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  translations?: InputMaybe<ServiceTranslationUpdateManyWithoutServiceNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  workerServices?: InputMaybe<WorkerServiceUpdateManyWithoutServiceNestedInput>;
};

export type ServiceUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  disabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  proType?: InputMaybe<EnumProfessionalTypeEnumFieldUpdateOperationsInput>;
  recognisedByEUCollege?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  requiresEmptyStomach?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ServiceUpdateOneRequiredWithoutTranslationsNestedInput = {
  connect?: InputMaybe<ServiceWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ServiceCreateOrConnectWithoutTranslationsInput>;
  create?: InputMaybe<ServiceCreateWithoutTranslationsInput>;
  update?: InputMaybe<ServiceUpdateToOneWithWhereWithoutTranslationsInput>;
  upsert?: InputMaybe<ServiceUpsertWithoutTranslationsInput>;
};

export type ServiceUpdateOneRequiredWithoutWorkerServicesNestedInput = {
  connect?: InputMaybe<ServiceWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ServiceCreateOrConnectWithoutWorkerServicesInput>;
  create?: InputMaybe<ServiceCreateWithoutWorkerServicesInput>;
  update?: InputMaybe<ServiceUpdateToOneWithWhereWithoutWorkerServicesInput>;
  upsert?: InputMaybe<ServiceUpsertWithoutWorkerServicesInput>;
};

export type ServiceUpdateToOneWithWhereWithoutTranslationsInput = {
  data: ServiceUpdateWithoutTranslationsInput;
  where?: InputMaybe<ServiceWhereInput>;
};

export type ServiceUpdateToOneWithWhereWithoutWorkerServicesInput = {
  data: ServiceUpdateWithoutWorkerServicesInput;
  where?: InputMaybe<ServiceWhereInput>;
};

export type ServiceUpdateWithoutTranslationsInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  disabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  proType?: InputMaybe<EnumProfessionalTypeEnumFieldUpdateOperationsInput>;
  recognisedByEUCollege?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  requiresEmptyStomach?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  workerServices?: InputMaybe<WorkerServiceUpdateManyWithoutServiceNestedInput>;
};

export type ServiceUpdateWithoutWorkerServicesInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  disabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  proType?: InputMaybe<EnumProfessionalTypeEnumFieldUpdateOperationsInput>;
  recognisedByEUCollege?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  requiresEmptyStomach?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  translations?: InputMaybe<ServiceTranslationUpdateManyWithoutServiceNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ServiceUpsertWithoutTranslationsInput = {
  create: ServiceCreateWithoutTranslationsInput;
  update: ServiceUpdateWithoutTranslationsInput;
  where?: InputMaybe<ServiceWhereInput>;
};

export type ServiceUpsertWithoutWorkerServicesInput = {
  create: ServiceCreateWithoutWorkerServicesInput;
  update: ServiceUpdateWithoutWorkerServicesInput;
  where?: InputMaybe<ServiceWhereInput>;
};

export type ServiceWhereInput = {
  AND?: InputMaybe<Array<ServiceWhereInput>>;
  NOT?: InputMaybe<Array<ServiceWhereInput>>;
  OR?: InputMaybe<Array<ServiceWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  disabled?: InputMaybe<BoolFilter>;
  id?: InputMaybe<IntFilter>;
  proType?: InputMaybe<EnumProfessionalTypeEnumFilter>;
  recognisedByEUCollege?: InputMaybe<BoolNullableFilter>;
  requiresEmptyStomach?: InputMaybe<BoolNullableFilter>;
  translations?: InputMaybe<ServiceTranslationListRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  workerServices?: InputMaybe<WorkerServiceListRelationFilter>;
};

export type ServiceWhereUniqueInput = {
  AND?: InputMaybe<Array<ServiceWhereInput>>;
  NOT?: InputMaybe<Array<ServiceWhereInput>>;
  OR?: InputMaybe<Array<ServiceWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  disabled?: InputMaybe<BoolFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  proType?: InputMaybe<EnumProfessionalTypeEnumFilter>;
  recognisedByEUCollege?: InputMaybe<BoolNullableFilter>;
  requiresEmptyStomach?: InputMaybe<BoolNullableFilter>;
  translations?: InputMaybe<ServiceTranslationListRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  workerServices?: InputMaybe<WorkerServiceListRelationFilter>;
};

export type ServicesByLocation = {
  __typename?: 'ServicesByLocation';
  city: Scalars['String']['output'];
  region: Scalars['String']['output'];
  serviceIds: Array<Scalars['Int']['output']>;
};

export enum SortOrder {
  asc = 'asc',
  desc = 'desc'
}

export type SortOrderInput = {
  nulls?: InputMaybe<NullsOrder>;
  sort: SortOrder;
};

export type StringFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['String']['input']>;
};

export type StringFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<NestedStringFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type StringNullableFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<NestedStringNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type StringNullableListFilter = {
  equals?: InputMaybe<Array<Scalars['String']['input']>>;
  has?: InputMaybe<Scalars['String']['input']>;
  hasEvery?: InputMaybe<Array<Scalars['String']['input']>>;
  hasSome?: InputMaybe<Array<Scalars['String']['input']>>;
  isEmpty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StringNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedStringNullableFilter>;
  _min?: InputMaybe<NestedStringNullableFilter>;
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<NestedStringNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type StringWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedStringFilter>;
  _min?: InputMaybe<NestedStringFilter>;
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<NestedStringWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type StudInfo = {
  __typename?: 'StudInfo';
  accomodation?: Maybe<Scalars['Boolean']['output']>;
  adn?: Maybe<Scalars['String']['output']>;
  animal: Animal;
  animalId: Scalars['Int']['output'];
  availableForBreeding: Scalars['Boolean']['output'];
  champion?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  price?: Maybe<Scalars['Float']['output']>;
  type?: Maybe<CouplingType>;
  updatedAt: Scalars['DateTime']['output'];
};

export type StudInfoAvgAggregateOutputType = {
  __typename?: 'StudInfoAvgAggregateOutputType';
  animalId?: Maybe<Scalars['Float']['output']>;
  breederId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
};

export type StudInfoAvgOrderByAggregateInput = {
  animalId?: InputMaybe<SortOrder>;
  breederId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  price?: InputMaybe<SortOrder>;
};

export type StudInfoCountAggregateOutputType = {
  __typename?: 'StudInfoCountAggregateOutputType';
  _all: Scalars['Int']['output'];
  accomodation: Scalars['Int']['output'];
  adn: Scalars['Int']['output'];
  animalId: Scalars['Int']['output'];
  availableForBreeding: Scalars['Int']['output'];
  breederId: Scalars['Int']['output'];
  champion: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  description: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  price: Scalars['Int']['output'];
  type: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type StudInfoCountOrderByAggregateInput = {
  accomodation?: InputMaybe<SortOrder>;
  adn?: InputMaybe<SortOrder>;
  animalId?: InputMaybe<SortOrder>;
  availableForBreeding?: InputMaybe<SortOrder>;
  breederId?: InputMaybe<SortOrder>;
  champion?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  price?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type StudInfoCreateInput = {
  accomodation?: InputMaybe<Scalars['Boolean']['input']>;
  adn?: InputMaybe<Scalars['String']['input']>;
  animal: AnimalCreateNestedOneWithoutStudInfosInput;
  availableForBreeding?: InputMaybe<Scalars['Boolean']['input']>;
  breeder?: InputMaybe<DogBreederCreateNestedOneWithoutStudInfosInput>;
  champion?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<CouplingType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type StudInfoCreateManyBreederInput = {
  accomodation?: InputMaybe<Scalars['Boolean']['input']>;
  adn?: InputMaybe<Scalars['String']['input']>;
  animalId: Scalars['Int']['input'];
  availableForBreeding?: InputMaybe<Scalars['Boolean']['input']>;
  champion?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<CouplingType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type StudInfoCreateManyBreederInputEnvelope = {
  data: Array<StudInfoCreateManyBreederInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StudInfoCreateManyInput = {
  accomodation?: InputMaybe<Scalars['Boolean']['input']>;
  adn?: InputMaybe<Scalars['String']['input']>;
  animalId: Scalars['Int']['input'];
  availableForBreeding?: InputMaybe<Scalars['Boolean']['input']>;
  breederId?: InputMaybe<Scalars['Int']['input']>;
  champion?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<CouplingType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type StudInfoCreateNestedManyWithoutBreederInput = {
  connect?: InputMaybe<Array<StudInfoWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<StudInfoCreateOrConnectWithoutBreederInput>>;
  create?: InputMaybe<Array<StudInfoCreateWithoutBreederInput>>;
  createMany?: InputMaybe<StudInfoCreateManyBreederInputEnvelope>;
};

export type StudInfoCreateNestedOneWithoutAnimalInput = {
  connect?: InputMaybe<StudInfoWhereUniqueInput>;
  connectOrCreate?: InputMaybe<StudInfoCreateOrConnectWithoutAnimalInput>;
  create?: InputMaybe<StudInfoCreateWithoutAnimalInput>;
};

export type StudInfoCreateOrConnectWithoutAnimalInput = {
  create: StudInfoCreateWithoutAnimalInput;
  where: StudInfoWhereUniqueInput;
};

export type StudInfoCreateOrConnectWithoutBreederInput = {
  create: StudInfoCreateWithoutBreederInput;
  where: StudInfoWhereUniqueInput;
};

export type StudInfoCreateWithoutAnimalInput = {
  accomodation?: InputMaybe<Scalars['Boolean']['input']>;
  adn?: InputMaybe<Scalars['String']['input']>;
  availableForBreeding?: InputMaybe<Scalars['Boolean']['input']>;
  breeder?: InputMaybe<DogBreederCreateNestedOneWithoutStudInfosInput>;
  champion?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<CouplingType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type StudInfoCreateWithoutBreederInput = {
  accomodation?: InputMaybe<Scalars['Boolean']['input']>;
  adn?: InputMaybe<Scalars['String']['input']>;
  animal: AnimalCreateNestedOneWithoutStudInfosInput;
  availableForBreeding?: InputMaybe<Scalars['Boolean']['input']>;
  champion?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<CouplingType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type StudInfoListRelationFilter = {
  every?: InputMaybe<StudInfoWhereInput>;
  none?: InputMaybe<StudInfoWhereInput>;
  some?: InputMaybe<StudInfoWhereInput>;
};

export type StudInfoMaxAggregateOutputType = {
  __typename?: 'StudInfoMaxAggregateOutputType';
  accomodation?: Maybe<Scalars['Boolean']['output']>;
  adn?: Maybe<Scalars['String']['output']>;
  animalId?: Maybe<Scalars['Int']['output']>;
  availableForBreeding?: Maybe<Scalars['Boolean']['output']>;
  breederId?: Maybe<Scalars['Int']['output']>;
  champion?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  type?: Maybe<CouplingType>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type StudInfoMaxOrderByAggregateInput = {
  accomodation?: InputMaybe<SortOrder>;
  adn?: InputMaybe<SortOrder>;
  animalId?: InputMaybe<SortOrder>;
  availableForBreeding?: InputMaybe<SortOrder>;
  breederId?: InputMaybe<SortOrder>;
  champion?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  price?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type StudInfoMinAggregateOutputType = {
  __typename?: 'StudInfoMinAggregateOutputType';
  accomodation?: Maybe<Scalars['Boolean']['output']>;
  adn?: Maybe<Scalars['String']['output']>;
  animalId?: Maybe<Scalars['Int']['output']>;
  availableForBreeding?: Maybe<Scalars['Boolean']['output']>;
  breederId?: Maybe<Scalars['Int']['output']>;
  champion?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  type?: Maybe<CouplingType>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type StudInfoMinOrderByAggregateInput = {
  accomodation?: InputMaybe<SortOrder>;
  adn?: InputMaybe<SortOrder>;
  animalId?: InputMaybe<SortOrder>;
  availableForBreeding?: InputMaybe<SortOrder>;
  breederId?: InputMaybe<SortOrder>;
  champion?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  price?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type StudInfoNullableRelationFilter = {
  is?: InputMaybe<StudInfoWhereInput>;
  isNot?: InputMaybe<StudInfoWhereInput>;
};

export type StudInfoOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export enum StudInfoOrderByRelevanceFieldEnum {
  adn = 'adn',
  description = 'description'
}

export type StudInfoOrderByRelevanceInput = {
  fields: Array<StudInfoOrderByRelevanceFieldEnum>;
  search: Scalars['String']['input'];
  sort: SortOrder;
};

export type StudInfoOrderByWithAggregationInput = {
  _avg?: InputMaybe<StudInfoAvgOrderByAggregateInput>;
  _count?: InputMaybe<StudInfoCountOrderByAggregateInput>;
  _max?: InputMaybe<StudInfoMaxOrderByAggregateInput>;
  _min?: InputMaybe<StudInfoMinOrderByAggregateInput>;
  _sum?: InputMaybe<StudInfoSumOrderByAggregateInput>;
  accomodation?: InputMaybe<SortOrderInput>;
  adn?: InputMaybe<SortOrderInput>;
  animalId?: InputMaybe<SortOrder>;
  availableForBreeding?: InputMaybe<SortOrder>;
  breederId?: InputMaybe<SortOrderInput>;
  champion?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  price?: InputMaybe<SortOrderInput>;
  type?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type StudInfoOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: InputMaybe<StudInfoOrderByRelevanceInput>;
  accomodation?: InputMaybe<SortOrderInput>;
  adn?: InputMaybe<SortOrderInput>;
  animal?: InputMaybe<AnimalOrderByWithRelationAndSearchRelevanceInput>;
  animalId?: InputMaybe<SortOrder>;
  availableForBreeding?: InputMaybe<SortOrder>;
  breeder?: InputMaybe<DogBreederOrderByWithRelationAndSearchRelevanceInput>;
  breederId?: InputMaybe<SortOrderInput>;
  champion?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  price?: InputMaybe<SortOrderInput>;
  type?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum StudInfoScalarFieldEnum {
  accomodation = 'accomodation',
  adn = 'adn',
  animalId = 'animalId',
  availableForBreeding = 'availableForBreeding',
  breederId = 'breederId',
  champion = 'champion',
  createdAt = 'createdAt',
  description = 'description',
  id = 'id',
  price = 'price',
  type = 'type',
  updatedAt = 'updatedAt'
}

export type StudInfoScalarWhereInput = {
  AND?: InputMaybe<Array<StudInfoScalarWhereInput>>;
  NOT?: InputMaybe<Array<StudInfoScalarWhereInput>>;
  OR?: InputMaybe<Array<StudInfoScalarWhereInput>>;
  accomodation?: InputMaybe<BoolNullableFilter>;
  adn?: InputMaybe<StringNullableFilter>;
  animalId?: InputMaybe<IntFilter>;
  availableForBreeding?: InputMaybe<BoolFilter>;
  breederId?: InputMaybe<IntNullableFilter>;
  champion?: InputMaybe<BoolNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<IntFilter>;
  price?: InputMaybe<FloatNullableFilter>;
  type?: InputMaybe<EnumCouplingTypeNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type StudInfoScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<StudInfoScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<StudInfoScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<StudInfoScalarWhereWithAggregatesInput>>;
  accomodation?: InputMaybe<BoolNullableWithAggregatesFilter>;
  adn?: InputMaybe<StringNullableWithAggregatesFilter>;
  animalId?: InputMaybe<IntWithAggregatesFilter>;
  availableForBreeding?: InputMaybe<BoolWithAggregatesFilter>;
  breederId?: InputMaybe<IntNullableWithAggregatesFilter>;
  champion?: InputMaybe<BoolNullableWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  description?: InputMaybe<StringNullableWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  price?: InputMaybe<FloatNullableWithAggregatesFilter>;
  type?: InputMaybe<EnumCouplingTypeNullableWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type StudInfoSumAggregateOutputType = {
  __typename?: 'StudInfoSumAggregateOutputType';
  animalId?: Maybe<Scalars['Int']['output']>;
  breederId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
};

export type StudInfoSumOrderByAggregateInput = {
  animalId?: InputMaybe<SortOrder>;
  breederId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  price?: InputMaybe<SortOrder>;
};

export type StudInfoUncheckedCreateInput = {
  accomodation?: InputMaybe<Scalars['Boolean']['input']>;
  adn?: InputMaybe<Scalars['String']['input']>;
  animalId: Scalars['Int']['input'];
  availableForBreeding?: InputMaybe<Scalars['Boolean']['input']>;
  breederId?: InputMaybe<Scalars['Int']['input']>;
  champion?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<CouplingType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type StudInfoUncheckedCreateNestedManyWithoutBreederInput = {
  connect?: InputMaybe<Array<StudInfoWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<StudInfoCreateOrConnectWithoutBreederInput>>;
  create?: InputMaybe<Array<StudInfoCreateWithoutBreederInput>>;
  createMany?: InputMaybe<StudInfoCreateManyBreederInputEnvelope>;
};

export type StudInfoUncheckedCreateNestedOneWithoutAnimalInput = {
  connect?: InputMaybe<StudInfoWhereUniqueInput>;
  connectOrCreate?: InputMaybe<StudInfoCreateOrConnectWithoutAnimalInput>;
  create?: InputMaybe<StudInfoCreateWithoutAnimalInput>;
};

export type StudInfoUncheckedCreateWithoutAnimalInput = {
  accomodation?: InputMaybe<Scalars['Boolean']['input']>;
  adn?: InputMaybe<Scalars['String']['input']>;
  availableForBreeding?: InputMaybe<Scalars['Boolean']['input']>;
  breederId?: InputMaybe<Scalars['Int']['input']>;
  champion?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<CouplingType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type StudInfoUncheckedCreateWithoutBreederInput = {
  accomodation?: InputMaybe<Scalars['Boolean']['input']>;
  adn?: InputMaybe<Scalars['String']['input']>;
  animalId: Scalars['Int']['input'];
  availableForBreeding?: InputMaybe<Scalars['Boolean']['input']>;
  champion?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<CouplingType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type StudInfoUncheckedUpdateInput = {
  accomodation?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  adn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  animalId?: InputMaybe<IntFieldUpdateOperationsInput>;
  availableForBreeding?: InputMaybe<BoolFieldUpdateOperationsInput>;
  breederId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  champion?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  price?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumCouplingTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type StudInfoUncheckedUpdateManyInput = {
  accomodation?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  adn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  animalId?: InputMaybe<IntFieldUpdateOperationsInput>;
  availableForBreeding?: InputMaybe<BoolFieldUpdateOperationsInput>;
  breederId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  champion?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  price?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumCouplingTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type StudInfoUncheckedUpdateManyWithoutBreederInput = {
  accomodation?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  adn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  animalId?: InputMaybe<IntFieldUpdateOperationsInput>;
  availableForBreeding?: InputMaybe<BoolFieldUpdateOperationsInput>;
  champion?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  price?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumCouplingTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type StudInfoUncheckedUpdateManyWithoutBreederNestedInput = {
  connect?: InputMaybe<Array<StudInfoWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<StudInfoCreateOrConnectWithoutBreederInput>>;
  create?: InputMaybe<Array<StudInfoCreateWithoutBreederInput>>;
  createMany?: InputMaybe<StudInfoCreateManyBreederInputEnvelope>;
  delete?: InputMaybe<Array<StudInfoWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<StudInfoScalarWhereInput>>;
  disconnect?: InputMaybe<Array<StudInfoWhereUniqueInput>>;
  set?: InputMaybe<Array<StudInfoWhereUniqueInput>>;
  update?: InputMaybe<Array<StudInfoUpdateWithWhereUniqueWithoutBreederInput>>;
  updateMany?: InputMaybe<Array<StudInfoUpdateManyWithWhereWithoutBreederInput>>;
  upsert?: InputMaybe<Array<StudInfoUpsertWithWhereUniqueWithoutBreederInput>>;
};

export type StudInfoUncheckedUpdateOneWithoutAnimalNestedInput = {
  connect?: InputMaybe<StudInfoWhereUniqueInput>;
  connectOrCreate?: InputMaybe<StudInfoCreateOrConnectWithoutAnimalInput>;
  create?: InputMaybe<StudInfoCreateWithoutAnimalInput>;
  delete?: InputMaybe<StudInfoWhereInput>;
  disconnect?: InputMaybe<StudInfoWhereInput>;
  update?: InputMaybe<StudInfoUpdateToOneWithWhereWithoutAnimalInput>;
  upsert?: InputMaybe<StudInfoUpsertWithoutAnimalInput>;
};

export type StudInfoUncheckedUpdateWithoutAnimalInput = {
  accomodation?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  adn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  availableForBreeding?: InputMaybe<BoolFieldUpdateOperationsInput>;
  breederId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  champion?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  price?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumCouplingTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type StudInfoUncheckedUpdateWithoutBreederInput = {
  accomodation?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  adn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  animalId?: InputMaybe<IntFieldUpdateOperationsInput>;
  availableForBreeding?: InputMaybe<BoolFieldUpdateOperationsInput>;
  champion?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  price?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumCouplingTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type StudInfoUpdateInput = {
  accomodation?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  adn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  animal?: InputMaybe<AnimalUpdateOneRequiredWithoutStudInfosNestedInput>;
  availableForBreeding?: InputMaybe<BoolFieldUpdateOperationsInput>;
  breeder?: InputMaybe<DogBreederUpdateOneWithoutStudInfosNestedInput>;
  champion?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  price?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumCouplingTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type StudInfoUpdateManyMutationInput = {
  accomodation?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  adn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  availableForBreeding?: InputMaybe<BoolFieldUpdateOperationsInput>;
  champion?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  price?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumCouplingTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type StudInfoUpdateManyWithWhereWithoutBreederInput = {
  data: StudInfoUpdateManyMutationInput;
  where: StudInfoScalarWhereInput;
};

export type StudInfoUpdateManyWithoutBreederNestedInput = {
  connect?: InputMaybe<Array<StudInfoWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<StudInfoCreateOrConnectWithoutBreederInput>>;
  create?: InputMaybe<Array<StudInfoCreateWithoutBreederInput>>;
  createMany?: InputMaybe<StudInfoCreateManyBreederInputEnvelope>;
  delete?: InputMaybe<Array<StudInfoWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<StudInfoScalarWhereInput>>;
  disconnect?: InputMaybe<Array<StudInfoWhereUniqueInput>>;
  set?: InputMaybe<Array<StudInfoWhereUniqueInput>>;
  update?: InputMaybe<Array<StudInfoUpdateWithWhereUniqueWithoutBreederInput>>;
  updateMany?: InputMaybe<Array<StudInfoUpdateManyWithWhereWithoutBreederInput>>;
  upsert?: InputMaybe<Array<StudInfoUpsertWithWhereUniqueWithoutBreederInput>>;
};

export type StudInfoUpdateOneWithoutAnimalNestedInput = {
  connect?: InputMaybe<StudInfoWhereUniqueInput>;
  connectOrCreate?: InputMaybe<StudInfoCreateOrConnectWithoutAnimalInput>;
  create?: InputMaybe<StudInfoCreateWithoutAnimalInput>;
  delete?: InputMaybe<StudInfoWhereInput>;
  disconnect?: InputMaybe<StudInfoWhereInput>;
  update?: InputMaybe<StudInfoUpdateToOneWithWhereWithoutAnimalInput>;
  upsert?: InputMaybe<StudInfoUpsertWithoutAnimalInput>;
};

export type StudInfoUpdateToOneWithWhereWithoutAnimalInput = {
  data: StudInfoUpdateWithoutAnimalInput;
  where?: InputMaybe<StudInfoWhereInput>;
};

export type StudInfoUpdateWithWhereUniqueWithoutBreederInput = {
  data: StudInfoUpdateWithoutBreederInput;
  where: StudInfoWhereUniqueInput;
};

export type StudInfoUpdateWithoutAnimalInput = {
  accomodation?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  adn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  availableForBreeding?: InputMaybe<BoolFieldUpdateOperationsInput>;
  breeder?: InputMaybe<DogBreederUpdateOneWithoutStudInfosNestedInput>;
  champion?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  price?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumCouplingTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type StudInfoUpdateWithoutBreederInput = {
  accomodation?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  adn?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  animal?: InputMaybe<AnimalUpdateOneRequiredWithoutStudInfosNestedInput>;
  availableForBreeding?: InputMaybe<BoolFieldUpdateOperationsInput>;
  champion?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  price?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumCouplingTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type StudInfoUpsertWithWhereUniqueWithoutBreederInput = {
  create: StudInfoCreateWithoutBreederInput;
  update: StudInfoUpdateWithoutBreederInput;
  where: StudInfoWhereUniqueInput;
};

export type StudInfoUpsertWithoutAnimalInput = {
  create: StudInfoCreateWithoutAnimalInput;
  update: StudInfoUpdateWithoutAnimalInput;
  where?: InputMaybe<StudInfoWhereInput>;
};

export type StudInfoWhereInput = {
  AND?: InputMaybe<Array<StudInfoWhereInput>>;
  NOT?: InputMaybe<Array<StudInfoWhereInput>>;
  OR?: InputMaybe<Array<StudInfoWhereInput>>;
  accomodation?: InputMaybe<BoolNullableFilter>;
  adn?: InputMaybe<StringNullableFilter>;
  animal?: InputMaybe<AnimalRelationFilter>;
  animalId?: InputMaybe<IntFilter>;
  availableForBreeding?: InputMaybe<BoolFilter>;
  breeder?: InputMaybe<DogBreederNullableRelationFilter>;
  breederId?: InputMaybe<IntNullableFilter>;
  champion?: InputMaybe<BoolNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<IntFilter>;
  price?: InputMaybe<FloatNullableFilter>;
  type?: InputMaybe<EnumCouplingTypeNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type StudInfoWhereUniqueInput = {
  AND?: InputMaybe<Array<StudInfoWhereInput>>;
  NOT?: InputMaybe<Array<StudInfoWhereInput>>;
  OR?: InputMaybe<Array<StudInfoWhereInput>>;
  accomodation?: InputMaybe<BoolNullableFilter>;
  adn?: InputMaybe<StringNullableFilter>;
  animal?: InputMaybe<AnimalRelationFilter>;
  animalId?: InputMaybe<Scalars['Int']['input']>;
  availableForBreeding?: InputMaybe<BoolFilter>;
  breeder?: InputMaybe<DogBreederNullableRelationFilter>;
  breederId?: InputMaybe<IntNullableFilter>;
  champion?: InputMaybe<BoolNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  price?: InputMaybe<FloatNullableFilter>;
  type?: InputMaybe<EnumCouplingTypeNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export enum SubscriptionTypeEnum {
  DISCOVER = 'DISCOVER',
  ENGAGED = 'ENGAGED',
  IDEAL = 'IDEAL',
  SUBSCRIBER = 'SUBSCRIBER',
  UNPAID = 'UNPAID'
}

export enum TemperType {
  AGGRESSIVE = 'AGGRESSIVE',
  ANXIOUS = 'ANXIOUS',
  BEHAVED = 'BEHAVED'
}

export type ToggleDogBreedInDogBreedInterestSubscriptionInput = {
  country?: InputMaybe<CountryCode>;
  dogBreedName: Scalars['String']['input'];
  email: Scalars['String']['input'];
  hasADog?: InputMaybe<Scalars['Boolean']['input']>;
  language: Scalars['String']['input'];
};

export enum TransactionIsolationLevel {
  ReadCommitted = 'ReadCommitted',
  ReadUncommitted = 'ReadUncommitted',
  RepeatableRead = 'RepeatableRead',
  Serializable = 'Serializable'
}

export type Update = {
  __typename?: 'Update';
  account?: Maybe<Account>;
  accountId?: Maybe<Scalars['Int']['output']>;
  breeder?: Maybe<DogBreeder>;
  breederId?: Maybe<Scalars['Int']['output']>;
  changes?: Maybe<Scalars['Json']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  litter?: Maybe<Litter>;
  litterId?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type UpdateAvgAggregateOutputType = {
  __typename?: 'UpdateAvgAggregateOutputType';
  accountId?: Maybe<Scalars['Float']['output']>;
  breederId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  litterId?: Maybe<Scalars['Float']['output']>;
};

export type UpdateAvgOrderByAggregateInput = {
  accountId?: InputMaybe<SortOrder>;
  breederId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  litterId?: InputMaybe<SortOrder>;
};

export type UpdateCountAggregateOutputType = {
  __typename?: 'UpdateCountAggregateOutputType';
  _all: Scalars['Int']['output'];
  accountId: Scalars['Int']['output'];
  archived: Scalars['Int']['output'];
  breederId: Scalars['Int']['output'];
  changes: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  litterId: Scalars['Int']['output'];
  type: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
  updatedBy: Scalars['Int']['output'];
};

export type UpdateCountOrderByAggregateInput = {
  accountId?: InputMaybe<SortOrder>;
  archived?: InputMaybe<SortOrder>;
  breederId?: InputMaybe<SortOrder>;
  changes?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  litterId?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  updatedBy?: InputMaybe<SortOrder>;
};

export type UpdateCreateInput = {
  account?: InputMaybe<AccountCreateNestedOneWithoutUpdatesInput>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  breeder?: InputMaybe<DogBreederCreateNestedOneWithoutUpdatesInput>;
  changes: Scalars['Json']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  litter?: InputMaybe<LitterCreateNestedOneWithoutUpdatesInput>;
  type?: InputMaybe<UpdateTypeEnum>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCreateManyAccountInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  breederId?: InputMaybe<Scalars['Int']['input']>;
  changes: Scalars['Json']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  litterId?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<UpdateTypeEnum>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCreateManyAccountInputEnvelope = {
  data: Array<UpdateCreateManyAccountInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateCreateManyBreederInput = {
  accountId?: InputMaybe<Scalars['Int']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  changes: Scalars['Json']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  litterId?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<UpdateTypeEnum>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCreateManyBreederInputEnvelope = {
  data: Array<UpdateCreateManyBreederInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateCreateManyInput = {
  accountId?: InputMaybe<Scalars['Int']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  breederId?: InputMaybe<Scalars['Int']['input']>;
  changes: Scalars['Json']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  litterId?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<UpdateTypeEnum>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCreateManyLitterInput = {
  accountId?: InputMaybe<Scalars['Int']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  breederId?: InputMaybe<Scalars['Int']['input']>;
  changes: Scalars['Json']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<UpdateTypeEnum>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCreateManyLitterInputEnvelope = {
  data: Array<UpdateCreateManyLitterInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateCreateNestedManyWithoutAccountInput = {
  connect?: InputMaybe<Array<UpdateWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UpdateCreateOrConnectWithoutAccountInput>>;
  create?: InputMaybe<Array<UpdateCreateWithoutAccountInput>>;
  createMany?: InputMaybe<UpdateCreateManyAccountInputEnvelope>;
};

export type UpdateCreateNestedManyWithoutBreederInput = {
  connect?: InputMaybe<Array<UpdateWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UpdateCreateOrConnectWithoutBreederInput>>;
  create?: InputMaybe<Array<UpdateCreateWithoutBreederInput>>;
  createMany?: InputMaybe<UpdateCreateManyBreederInputEnvelope>;
};

export type UpdateCreateNestedManyWithoutLitterInput = {
  connect?: InputMaybe<Array<UpdateWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UpdateCreateOrConnectWithoutLitterInput>>;
  create?: InputMaybe<Array<UpdateCreateWithoutLitterInput>>;
  createMany?: InputMaybe<UpdateCreateManyLitterInputEnvelope>;
};

export type UpdateCreateOrConnectWithoutAccountInput = {
  create: UpdateCreateWithoutAccountInput;
  where: UpdateWhereUniqueInput;
};

export type UpdateCreateOrConnectWithoutBreederInput = {
  create: UpdateCreateWithoutBreederInput;
  where: UpdateWhereUniqueInput;
};

export type UpdateCreateOrConnectWithoutLitterInput = {
  create: UpdateCreateWithoutLitterInput;
  where: UpdateWhereUniqueInput;
};

export type UpdateCreateWithoutAccountInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  breeder?: InputMaybe<DogBreederCreateNestedOneWithoutUpdatesInput>;
  changes: Scalars['Json']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  litter?: InputMaybe<LitterCreateNestedOneWithoutUpdatesInput>;
  type?: InputMaybe<UpdateTypeEnum>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCreateWithoutBreederInput = {
  account?: InputMaybe<AccountCreateNestedOneWithoutUpdatesInput>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  changes: Scalars['Json']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  litter?: InputMaybe<LitterCreateNestedOneWithoutUpdatesInput>;
  type?: InputMaybe<UpdateTypeEnum>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCreateWithoutLitterInput = {
  account?: InputMaybe<AccountCreateNestedOneWithoutUpdatesInput>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  breeder?: InputMaybe<DogBreederCreateNestedOneWithoutUpdatesInput>;
  changes: Scalars['Json']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  type?: InputMaybe<UpdateTypeEnum>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateDogBreederReviewInput = {
  contactDate?: InputMaybe<Scalars['DateTime']['input']>;
  contactType?: InputMaybe<DogBreederContactType>;
  description?: InputMaybe<Scalars['String']['input']>;
  dogBreederId: Scalars['Int']['input'];
  dogsWellBeingGrade?: InputMaybe<Scalars['Int']['input']>;
  followUpGrade?: InputMaybe<Scalars['Int']['input']>;
  globalGrade?: InputMaybe<Scalars['Int']['input']>;
  humanContactGrade?: InputMaybe<Scalars['Int']['input']>;
  hygieneGrade?: InputMaybe<Scalars['Int']['input']>;
  microchip?: InputMaybe<Scalars['String']['input']>;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateListRelationFilter = {
  every?: InputMaybe<UpdateWhereInput>;
  none?: InputMaybe<UpdateWhereInput>;
  some?: InputMaybe<UpdateWhereInput>;
};

export type UpdateLitterInput = {
  archived?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  availabilityDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  birthday?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  born?: InputMaybe<BoolFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dewormed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  dogBreedId?: InputMaybe<Scalars['Int']['input']>;
  fatherParentId?: InputMaybe<Scalars['Int']['input']>;
  femalesCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  femalesLeftCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  fixedPrice?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  hasFinishedOnboarding?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  litterCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  malesCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  malesLeftCount?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  microchipped?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  microchips?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  motherParentId?: InputMaybe<Scalars['Int']['input']>;
  pedigree?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  price?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  priceFrom?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  priceTo?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  vaccinated?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  vaccinationDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type UpdateMaxAggregateOutputType = {
  __typename?: 'UpdateMaxAggregateOutputType';
  accountId?: Maybe<Scalars['Int']['output']>;
  archived?: Maybe<Scalars['Boolean']['output']>;
  breederId?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  litterId?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<UpdateTypeEnum>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type UpdateMaxOrderByAggregateInput = {
  accountId?: InputMaybe<SortOrder>;
  archived?: InputMaybe<SortOrder>;
  breederId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  litterId?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  updatedBy?: InputMaybe<SortOrder>;
};

export type UpdateMinAggregateOutputType = {
  __typename?: 'UpdateMinAggregateOutputType';
  accountId?: Maybe<Scalars['Int']['output']>;
  archived?: Maybe<Scalars['Boolean']['output']>;
  breederId?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  litterId?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<UpdateTypeEnum>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type UpdateMinOrderByAggregateInput = {
  accountId?: InputMaybe<SortOrder>;
  archived?: InputMaybe<SortOrder>;
  breederId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  litterId?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  updatedBy?: InputMaybe<SortOrder>;
};

export type UpdateNotificationInput = {
  success?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type UpdateOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export enum UpdateOrderByRelevanceFieldEnum {
  updatedBy = 'updatedBy'
}

export type UpdateOrderByRelevanceInput = {
  fields: Array<UpdateOrderByRelevanceFieldEnum>;
  search: Scalars['String']['input'];
  sort: SortOrder;
};

export type UpdateOrderByWithAggregationInput = {
  _avg?: InputMaybe<UpdateAvgOrderByAggregateInput>;
  _count?: InputMaybe<UpdateCountOrderByAggregateInput>;
  _max?: InputMaybe<UpdateMaxOrderByAggregateInput>;
  _min?: InputMaybe<UpdateMinOrderByAggregateInput>;
  _sum?: InputMaybe<UpdateSumOrderByAggregateInput>;
  accountId?: InputMaybe<SortOrderInput>;
  archived?: InputMaybe<SortOrder>;
  breederId?: InputMaybe<SortOrderInput>;
  changes?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  litterId?: InputMaybe<SortOrderInput>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  updatedBy?: InputMaybe<SortOrderInput>;
};

export type UpdateOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: InputMaybe<UpdateOrderByRelevanceInput>;
  account?: InputMaybe<AccountOrderByWithRelationAndSearchRelevanceInput>;
  accountId?: InputMaybe<SortOrderInput>;
  archived?: InputMaybe<SortOrder>;
  breeder?: InputMaybe<DogBreederOrderByWithRelationAndSearchRelevanceInput>;
  breederId?: InputMaybe<SortOrderInput>;
  changes?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  litter?: InputMaybe<LitterOrderByWithRelationAndSearchRelevanceInput>;
  litterId?: InputMaybe<SortOrderInput>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  updatedBy?: InputMaybe<SortOrderInput>;
};

export enum UpdateScalarFieldEnum {
  accountId = 'accountId',
  archived = 'archived',
  breederId = 'breederId',
  changes = 'changes',
  createdAt = 'createdAt',
  id = 'id',
  litterId = 'litterId',
  type = 'type',
  updatedAt = 'updatedAt',
  updatedBy = 'updatedBy'
}

export type UpdateScalarWhereInput = {
  AND?: InputMaybe<Array<UpdateScalarWhereInput>>;
  NOT?: InputMaybe<Array<UpdateScalarWhereInput>>;
  OR?: InputMaybe<Array<UpdateScalarWhereInput>>;
  accountId?: InputMaybe<IntNullableFilter>;
  archived?: InputMaybe<BoolFilter>;
  breederId?: InputMaybe<IntNullableFilter>;
  changes?: InputMaybe<JsonFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntFilter>;
  litterId?: InputMaybe<IntNullableFilter>;
  type?: InputMaybe<EnumUpdateTypeEnumFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  updatedBy?: InputMaybe<StringNullableFilter>;
};

export type UpdateScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<UpdateScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<UpdateScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<UpdateScalarWhereWithAggregatesInput>>;
  accountId?: InputMaybe<IntNullableWithAggregatesFilter>;
  archived?: InputMaybe<BoolWithAggregatesFilter>;
  breederId?: InputMaybe<IntNullableWithAggregatesFilter>;
  changes?: InputMaybe<JsonWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  litterId?: InputMaybe<IntNullableWithAggregatesFilter>;
  type?: InputMaybe<EnumUpdateTypeEnumWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  updatedBy?: InputMaybe<StringNullableWithAggregatesFilter>;
};

export type UpdateSumAggregateOutputType = {
  __typename?: 'UpdateSumAggregateOutputType';
  accountId?: Maybe<Scalars['Int']['output']>;
  breederId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  litterId?: Maybe<Scalars['Int']['output']>;
};

export type UpdateSumOrderByAggregateInput = {
  accountId?: InputMaybe<SortOrder>;
  breederId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  litterId?: InputMaybe<SortOrder>;
};

export enum UpdateTypeEnum {
  Account = 'Account',
  Breeder = 'Breeder',
  DuplicateAgreementNum = 'DuplicateAgreementNum',
  ImageFlagged = 'ImageFlagged',
  Litter = 'Litter'
}

export type UpdateUncheckedCreateInput = {
  accountId?: InputMaybe<Scalars['Int']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  breederId?: InputMaybe<Scalars['Int']['input']>;
  changes: Scalars['Json']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  litterId?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<UpdateTypeEnum>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateUncheckedCreateNestedManyWithoutAccountInput = {
  connect?: InputMaybe<Array<UpdateWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UpdateCreateOrConnectWithoutAccountInput>>;
  create?: InputMaybe<Array<UpdateCreateWithoutAccountInput>>;
  createMany?: InputMaybe<UpdateCreateManyAccountInputEnvelope>;
};

export type UpdateUncheckedCreateNestedManyWithoutBreederInput = {
  connect?: InputMaybe<Array<UpdateWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UpdateCreateOrConnectWithoutBreederInput>>;
  create?: InputMaybe<Array<UpdateCreateWithoutBreederInput>>;
  createMany?: InputMaybe<UpdateCreateManyBreederInputEnvelope>;
};

export type UpdateUncheckedCreateNestedManyWithoutLitterInput = {
  connect?: InputMaybe<Array<UpdateWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UpdateCreateOrConnectWithoutLitterInput>>;
  create?: InputMaybe<Array<UpdateCreateWithoutLitterInput>>;
  createMany?: InputMaybe<UpdateCreateManyLitterInputEnvelope>;
};

export type UpdateUncheckedCreateWithoutAccountInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  breederId?: InputMaybe<Scalars['Int']['input']>;
  changes: Scalars['Json']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  litterId?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<UpdateTypeEnum>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateUncheckedCreateWithoutBreederInput = {
  accountId?: InputMaybe<Scalars['Int']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  changes: Scalars['Json']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  litterId?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<UpdateTypeEnum>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateUncheckedCreateWithoutLitterInput = {
  accountId?: InputMaybe<Scalars['Int']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  breederId?: InputMaybe<Scalars['Int']['input']>;
  changes: Scalars['Json']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<UpdateTypeEnum>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateUncheckedUpdateInput = {
  accountId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  archived?: InputMaybe<BoolFieldUpdateOperationsInput>;
  breederId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  changes?: InputMaybe<Scalars['Json']['input']>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  litterId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumUpdateTypeEnumFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type UpdateUncheckedUpdateManyInput = {
  accountId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  archived?: InputMaybe<BoolFieldUpdateOperationsInput>;
  breederId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  changes?: InputMaybe<Scalars['Json']['input']>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  litterId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumUpdateTypeEnumFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type UpdateUncheckedUpdateManyWithoutAccountInput = {
  archived?: InputMaybe<BoolFieldUpdateOperationsInput>;
  breederId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  changes?: InputMaybe<Scalars['Json']['input']>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  litterId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumUpdateTypeEnumFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type UpdateUncheckedUpdateManyWithoutAccountNestedInput = {
  connect?: InputMaybe<Array<UpdateWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UpdateCreateOrConnectWithoutAccountInput>>;
  create?: InputMaybe<Array<UpdateCreateWithoutAccountInput>>;
  createMany?: InputMaybe<UpdateCreateManyAccountInputEnvelope>;
  delete?: InputMaybe<Array<UpdateWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<UpdateScalarWhereInput>>;
  disconnect?: InputMaybe<Array<UpdateWhereUniqueInput>>;
  set?: InputMaybe<Array<UpdateWhereUniqueInput>>;
  update?: InputMaybe<Array<UpdateUpdateWithWhereUniqueWithoutAccountInput>>;
  updateMany?: InputMaybe<Array<UpdateUpdateManyWithWhereWithoutAccountInput>>;
  upsert?: InputMaybe<Array<UpdateUpsertWithWhereUniqueWithoutAccountInput>>;
};

export type UpdateUncheckedUpdateManyWithoutBreederInput = {
  accountId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  archived?: InputMaybe<BoolFieldUpdateOperationsInput>;
  changes?: InputMaybe<Scalars['Json']['input']>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  litterId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumUpdateTypeEnumFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type UpdateUncheckedUpdateManyWithoutBreederNestedInput = {
  connect?: InputMaybe<Array<UpdateWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UpdateCreateOrConnectWithoutBreederInput>>;
  create?: InputMaybe<Array<UpdateCreateWithoutBreederInput>>;
  createMany?: InputMaybe<UpdateCreateManyBreederInputEnvelope>;
  delete?: InputMaybe<Array<UpdateWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<UpdateScalarWhereInput>>;
  disconnect?: InputMaybe<Array<UpdateWhereUniqueInput>>;
  set?: InputMaybe<Array<UpdateWhereUniqueInput>>;
  update?: InputMaybe<Array<UpdateUpdateWithWhereUniqueWithoutBreederInput>>;
  updateMany?: InputMaybe<Array<UpdateUpdateManyWithWhereWithoutBreederInput>>;
  upsert?: InputMaybe<Array<UpdateUpsertWithWhereUniqueWithoutBreederInput>>;
};

export type UpdateUncheckedUpdateManyWithoutLitterInput = {
  accountId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  archived?: InputMaybe<BoolFieldUpdateOperationsInput>;
  breederId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  changes?: InputMaybe<Scalars['Json']['input']>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumUpdateTypeEnumFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type UpdateUncheckedUpdateManyWithoutLitterNestedInput = {
  connect?: InputMaybe<Array<UpdateWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UpdateCreateOrConnectWithoutLitterInput>>;
  create?: InputMaybe<Array<UpdateCreateWithoutLitterInput>>;
  createMany?: InputMaybe<UpdateCreateManyLitterInputEnvelope>;
  delete?: InputMaybe<Array<UpdateWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<UpdateScalarWhereInput>>;
  disconnect?: InputMaybe<Array<UpdateWhereUniqueInput>>;
  set?: InputMaybe<Array<UpdateWhereUniqueInput>>;
  update?: InputMaybe<Array<UpdateUpdateWithWhereUniqueWithoutLitterInput>>;
  updateMany?: InputMaybe<Array<UpdateUpdateManyWithWhereWithoutLitterInput>>;
  upsert?: InputMaybe<Array<UpdateUpsertWithWhereUniqueWithoutLitterInput>>;
};

export type UpdateUncheckedUpdateWithoutAccountInput = {
  archived?: InputMaybe<BoolFieldUpdateOperationsInput>;
  breederId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  changes?: InputMaybe<Scalars['Json']['input']>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  litterId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumUpdateTypeEnumFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type UpdateUncheckedUpdateWithoutBreederInput = {
  accountId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  archived?: InputMaybe<BoolFieldUpdateOperationsInput>;
  changes?: InputMaybe<Scalars['Json']['input']>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  litterId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumUpdateTypeEnumFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type UpdateUncheckedUpdateWithoutLitterInput = {
  accountId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  archived?: InputMaybe<BoolFieldUpdateOperationsInput>;
  breederId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  changes?: InputMaybe<Scalars['Json']['input']>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumUpdateTypeEnumFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type UpdateUpdateInput = {
  account?: InputMaybe<AccountUpdateOneWithoutUpdatesNestedInput>;
  archived?: InputMaybe<BoolFieldUpdateOperationsInput>;
  breeder?: InputMaybe<DogBreederUpdateOneWithoutUpdatesNestedInput>;
  changes?: InputMaybe<Scalars['Json']['input']>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  litter?: InputMaybe<LitterUpdateOneWithoutUpdatesNestedInput>;
  type?: InputMaybe<EnumUpdateTypeEnumFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type UpdateUpdateManyMutationInput = {
  archived?: InputMaybe<BoolFieldUpdateOperationsInput>;
  changes?: InputMaybe<Scalars['Json']['input']>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumUpdateTypeEnumFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type UpdateUpdateManyWithWhereWithoutAccountInput = {
  data: UpdateUpdateManyMutationInput;
  where: UpdateScalarWhereInput;
};

export type UpdateUpdateManyWithWhereWithoutBreederInput = {
  data: UpdateUpdateManyMutationInput;
  where: UpdateScalarWhereInput;
};

export type UpdateUpdateManyWithWhereWithoutLitterInput = {
  data: UpdateUpdateManyMutationInput;
  where: UpdateScalarWhereInput;
};

export type UpdateUpdateManyWithoutAccountNestedInput = {
  connect?: InputMaybe<Array<UpdateWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UpdateCreateOrConnectWithoutAccountInput>>;
  create?: InputMaybe<Array<UpdateCreateWithoutAccountInput>>;
  createMany?: InputMaybe<UpdateCreateManyAccountInputEnvelope>;
  delete?: InputMaybe<Array<UpdateWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<UpdateScalarWhereInput>>;
  disconnect?: InputMaybe<Array<UpdateWhereUniqueInput>>;
  set?: InputMaybe<Array<UpdateWhereUniqueInput>>;
  update?: InputMaybe<Array<UpdateUpdateWithWhereUniqueWithoutAccountInput>>;
  updateMany?: InputMaybe<Array<UpdateUpdateManyWithWhereWithoutAccountInput>>;
  upsert?: InputMaybe<Array<UpdateUpsertWithWhereUniqueWithoutAccountInput>>;
};

export type UpdateUpdateManyWithoutBreederNestedInput = {
  connect?: InputMaybe<Array<UpdateWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UpdateCreateOrConnectWithoutBreederInput>>;
  create?: InputMaybe<Array<UpdateCreateWithoutBreederInput>>;
  createMany?: InputMaybe<UpdateCreateManyBreederInputEnvelope>;
  delete?: InputMaybe<Array<UpdateWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<UpdateScalarWhereInput>>;
  disconnect?: InputMaybe<Array<UpdateWhereUniqueInput>>;
  set?: InputMaybe<Array<UpdateWhereUniqueInput>>;
  update?: InputMaybe<Array<UpdateUpdateWithWhereUniqueWithoutBreederInput>>;
  updateMany?: InputMaybe<Array<UpdateUpdateManyWithWhereWithoutBreederInput>>;
  upsert?: InputMaybe<Array<UpdateUpsertWithWhereUniqueWithoutBreederInput>>;
};

export type UpdateUpdateManyWithoutLitterNestedInput = {
  connect?: InputMaybe<Array<UpdateWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UpdateCreateOrConnectWithoutLitterInput>>;
  create?: InputMaybe<Array<UpdateCreateWithoutLitterInput>>;
  createMany?: InputMaybe<UpdateCreateManyLitterInputEnvelope>;
  delete?: InputMaybe<Array<UpdateWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<UpdateScalarWhereInput>>;
  disconnect?: InputMaybe<Array<UpdateWhereUniqueInput>>;
  set?: InputMaybe<Array<UpdateWhereUniqueInput>>;
  update?: InputMaybe<Array<UpdateUpdateWithWhereUniqueWithoutLitterInput>>;
  updateMany?: InputMaybe<Array<UpdateUpdateManyWithWhereWithoutLitterInput>>;
  upsert?: InputMaybe<Array<UpdateUpsertWithWhereUniqueWithoutLitterInput>>;
};

export type UpdateUpdateWithWhereUniqueWithoutAccountInput = {
  data: UpdateUpdateWithoutAccountInput;
  where: UpdateWhereUniqueInput;
};

export type UpdateUpdateWithWhereUniqueWithoutBreederInput = {
  data: UpdateUpdateWithoutBreederInput;
  where: UpdateWhereUniqueInput;
};

export type UpdateUpdateWithWhereUniqueWithoutLitterInput = {
  data: UpdateUpdateWithoutLitterInput;
  where: UpdateWhereUniqueInput;
};

export type UpdateUpdateWithoutAccountInput = {
  archived?: InputMaybe<BoolFieldUpdateOperationsInput>;
  breeder?: InputMaybe<DogBreederUpdateOneWithoutUpdatesNestedInput>;
  changes?: InputMaybe<Scalars['Json']['input']>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  litter?: InputMaybe<LitterUpdateOneWithoutUpdatesNestedInput>;
  type?: InputMaybe<EnumUpdateTypeEnumFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type UpdateUpdateWithoutBreederInput = {
  account?: InputMaybe<AccountUpdateOneWithoutUpdatesNestedInput>;
  archived?: InputMaybe<BoolFieldUpdateOperationsInput>;
  changes?: InputMaybe<Scalars['Json']['input']>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  litter?: InputMaybe<LitterUpdateOneWithoutUpdatesNestedInput>;
  type?: InputMaybe<EnumUpdateTypeEnumFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type UpdateUpdateWithoutLitterInput = {
  account?: InputMaybe<AccountUpdateOneWithoutUpdatesNestedInput>;
  archived?: InputMaybe<BoolFieldUpdateOperationsInput>;
  breeder?: InputMaybe<DogBreederUpdateOneWithoutUpdatesNestedInput>;
  changes?: InputMaybe<Scalars['Json']['input']>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumUpdateTypeEnumFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type UpdateUpsertWithWhereUniqueWithoutAccountInput = {
  create: UpdateCreateWithoutAccountInput;
  update: UpdateUpdateWithoutAccountInput;
  where: UpdateWhereUniqueInput;
};

export type UpdateUpsertWithWhereUniqueWithoutBreederInput = {
  create: UpdateCreateWithoutBreederInput;
  update: UpdateUpdateWithoutBreederInput;
  where: UpdateWhereUniqueInput;
};

export type UpdateUpsertWithWhereUniqueWithoutLitterInput = {
  create: UpdateCreateWithoutLitterInput;
  update: UpdateUpdateWithoutLitterInput;
  where: UpdateWhereUniqueInput;
};

export type UpdateWhereInput = {
  AND?: InputMaybe<Array<UpdateWhereInput>>;
  NOT?: InputMaybe<Array<UpdateWhereInput>>;
  OR?: InputMaybe<Array<UpdateWhereInput>>;
  account?: InputMaybe<AccountNullableRelationFilter>;
  accountId?: InputMaybe<IntNullableFilter>;
  archived?: InputMaybe<BoolFilter>;
  breeder?: InputMaybe<DogBreederNullableRelationFilter>;
  breederId?: InputMaybe<IntNullableFilter>;
  changes?: InputMaybe<JsonFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntFilter>;
  litter?: InputMaybe<LitterNullableRelationFilter>;
  litterId?: InputMaybe<IntNullableFilter>;
  type?: InputMaybe<EnumUpdateTypeEnumFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  updatedBy?: InputMaybe<StringNullableFilter>;
};

export type UpdateWhereUniqueInput = {
  AND?: InputMaybe<Array<UpdateWhereInput>>;
  NOT?: InputMaybe<Array<UpdateWhereInput>>;
  OR?: InputMaybe<Array<UpdateWhereInput>>;
  account?: InputMaybe<AccountNullableRelationFilter>;
  accountId?: InputMaybe<IntNullableFilter>;
  archived?: InputMaybe<BoolFilter>;
  breeder?: InputMaybe<DogBreederNullableRelationFilter>;
  breederId?: InputMaybe<IntNullableFilter>;
  changes?: InputMaybe<JsonFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  litter?: InputMaybe<LitterNullableRelationFilter>;
  litterId?: InputMaybe<IntNullableFilter>;
  type?: InputMaybe<EnumUpdateTypeEnumFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  updatedBy?: InputMaybe<StringNullableFilter>;
};

export type UserEvent = {
  __typename?: 'UserEvent';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type WaitlistApplicationInput = {
  applicationId: Scalars['Int']['input'];
  breedId: Scalars['Int']['input'];
  dateOfBirth?: InputMaybe<Scalars['DateTime']['input']>;
  gender?: InputMaybe<GenderEnum>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type WebsiteTranslationAvgAggregateOutputType = {
  __typename?: 'WebsiteTranslationAvgAggregateOutputType';
  id?: Maybe<Scalars['Float']['output']>;
};

export type WebsiteTranslationAvgOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
};

export type WebsiteTranslationCountAggregateOutputType = {
  __typename?: 'WebsiteTranslationCountAggregateOutputType';
  _all: Scalars['Int']['output'];
  content: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  deUrl: Scalars['Int']['output'];
  enUrl: Scalars['Int']['output'];
  frUrl: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  nlUrl: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type WebsiteTranslationCountOrderByAggregateInput = {
  content?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  deUrl?: InputMaybe<SortOrder>;
  enUrl?: InputMaybe<SortOrder>;
  frUrl?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  nlUrl?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type WebsiteTranslationCreateInput = {
  content: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deUrl?: InputMaybe<Scalars['String']['input']>;
  enUrl?: InputMaybe<Scalars['String']['input']>;
  frUrl?: InputMaybe<Scalars['String']['input']>;
  nlUrl?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type WebsiteTranslationCreateManyInput = {
  content: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deUrl?: InputMaybe<Scalars['String']['input']>;
  enUrl?: InputMaybe<Scalars['String']['input']>;
  frUrl?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  nlUrl?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type WebsiteTranslationMaxAggregateOutputType = {
  __typename?: 'WebsiteTranslationMaxAggregateOutputType';
  content?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deUrl?: Maybe<Scalars['String']['output']>;
  enUrl?: Maybe<Scalars['String']['output']>;
  frUrl?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  nlUrl?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type WebsiteTranslationMaxOrderByAggregateInput = {
  content?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  deUrl?: InputMaybe<SortOrder>;
  enUrl?: InputMaybe<SortOrder>;
  frUrl?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  nlUrl?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type WebsiteTranslationMinAggregateOutputType = {
  __typename?: 'WebsiteTranslationMinAggregateOutputType';
  content?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deUrl?: Maybe<Scalars['String']['output']>;
  enUrl?: Maybe<Scalars['String']['output']>;
  frUrl?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  nlUrl?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type WebsiteTranslationMinOrderByAggregateInput = {
  content?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  deUrl?: InputMaybe<SortOrder>;
  enUrl?: InputMaybe<SortOrder>;
  frUrl?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  nlUrl?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum WebsiteTranslationOrderByRelevanceFieldEnum {
  content = 'content',
  deUrl = 'deUrl',
  enUrl = 'enUrl',
  frUrl = 'frUrl',
  nlUrl = 'nlUrl'
}

export type WebsiteTranslationOrderByRelevanceInput = {
  fields: Array<WebsiteTranslationOrderByRelevanceFieldEnum>;
  search: Scalars['String']['input'];
  sort: SortOrder;
};

export type WebsiteTranslationOrderByWithAggregationInput = {
  _avg?: InputMaybe<WebsiteTranslationAvgOrderByAggregateInput>;
  _count?: InputMaybe<WebsiteTranslationCountOrderByAggregateInput>;
  _max?: InputMaybe<WebsiteTranslationMaxOrderByAggregateInput>;
  _min?: InputMaybe<WebsiteTranslationMinOrderByAggregateInput>;
  _sum?: InputMaybe<WebsiteTranslationSumOrderByAggregateInput>;
  content?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  deUrl?: InputMaybe<SortOrderInput>;
  enUrl?: InputMaybe<SortOrderInput>;
  frUrl?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  nlUrl?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type WebsiteTranslationOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: InputMaybe<WebsiteTranslationOrderByRelevanceInput>;
  content?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  deUrl?: InputMaybe<SortOrderInput>;
  enUrl?: InputMaybe<SortOrderInput>;
  frUrl?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  nlUrl?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum WebsiteTranslationScalarFieldEnum {
  content = 'content',
  createdAt = 'createdAt',
  deUrl = 'deUrl',
  enUrl = 'enUrl',
  frUrl = 'frUrl',
  id = 'id',
  nlUrl = 'nlUrl',
  updatedAt = 'updatedAt'
}

export type WebsiteTranslationScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<WebsiteTranslationScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<WebsiteTranslationScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<WebsiteTranslationScalarWhereWithAggregatesInput>>;
  content?: InputMaybe<StringWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  deUrl?: InputMaybe<StringNullableWithAggregatesFilter>;
  enUrl?: InputMaybe<StringNullableWithAggregatesFilter>;
  frUrl?: InputMaybe<StringNullableWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  nlUrl?: InputMaybe<StringNullableWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type WebsiteTranslationSumAggregateOutputType = {
  __typename?: 'WebsiteTranslationSumAggregateOutputType';
  id?: Maybe<Scalars['Int']['output']>;
};

export type WebsiteTranslationSumOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
};

export type WebsiteTranslationUncheckedCreateInput = {
  content: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deUrl?: InputMaybe<Scalars['String']['input']>;
  enUrl?: InputMaybe<Scalars['String']['input']>;
  frUrl?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  nlUrl?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type WebsiteTranslationUncheckedUpdateInput = {
  content?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  enUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  frUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  nlUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type WebsiteTranslationUncheckedUpdateManyInput = {
  content?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  enUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  frUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  nlUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type WebsiteTranslationUpdateInput = {
  content?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  enUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  frUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nlUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type WebsiteTranslationUpdateManyMutationInput = {
  content?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  enUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  frUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nlUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type WebsiteTranslationWhereInput = {
  AND?: InputMaybe<Array<WebsiteTranslationWhereInput>>;
  NOT?: InputMaybe<Array<WebsiteTranslationWhereInput>>;
  OR?: InputMaybe<Array<WebsiteTranslationWhereInput>>;
  content?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deUrl?: InputMaybe<StringNullableFilter>;
  enUrl?: InputMaybe<StringNullableFilter>;
  frUrl?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<IntFilter>;
  nlUrl?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type WebsiteTranslationWhereUniqueInput = {
  AND?: InputMaybe<Array<WebsiteTranslationWhereInput>>;
  NOT?: InputMaybe<Array<WebsiteTranslationWhereInput>>;
  OR?: InputMaybe<Array<WebsiteTranslationWhereInput>>;
  content?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deUrl?: InputMaybe<StringNullableFilter>;
  enUrl?: InputMaybe<StringNullableFilter>;
  frUrl?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  nlUrl?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type Worker = {
  __typename?: 'Worker';
  _count: WorkerCountOutputType;
  /** @TypeGraphQL.omit(output: true) */
  bookings: Array<Booking>;
  createdAt: Scalars['DateTime']['output'];
  defaultServiceDurationMinute?: Maybe<Scalars['Int']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  googleCalendarId?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  pro: Professional;
  proId: Scalars['Int']['output'];
  services: Array<WorkerService>;
  syncToken?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  workerAvailabilities: Array<WorkerAvailability>;
};


export type WorkerbookingsArgs = {
  cursor?: InputMaybe<BookingWhereUniqueInput>;
  distinct?: InputMaybe<BookingScalarFieldEnum>;
  orderBy?: InputMaybe<BookingOrderByWithRelationAndSearchRelevanceInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<BookingWhereInput>;
};


export type WorkerservicesArgs = {
  cursor?: InputMaybe<WorkerServiceWhereUniqueInput>;
  distinct?: InputMaybe<WorkerServiceScalarFieldEnum>;
  orderBy?: InputMaybe<WorkerServiceOrderByWithRelationAndSearchRelevanceInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<WorkerServiceWhereInput>;
};


export type WorkerworkerAvailabilitiesArgs = {
  cursor?: InputMaybe<WorkerAvailabilityWhereUniqueInput>;
  distinct?: InputMaybe<WorkerAvailabilityScalarFieldEnum>;
  orderBy?: InputMaybe<WorkerAvailabilityOrderByWithRelationAndSearchRelevanceInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<WorkerAvailabilityWhereInput>;
};

export type WorkerAvailability = {
  __typename?: 'WorkerAvailability';
  createdAt: Scalars['DateTime']['output'];
  dayOfWeek: DayOfWeek;
  endTime: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  startTime: Scalars['String']['output'];
  type: WorkerAvailabilityType;
  updatedAt: Scalars['DateTime']['output'];
  worker: Worker;
  workerId: Scalars['Int']['output'];
  workerService?: Maybe<WorkerService>;
  workerServiceId?: Maybe<Scalars['Int']['output']>;
};

export type WorkerAvailabilityAvgAggregateOutputType = {
  __typename?: 'WorkerAvailabilityAvgAggregateOutputType';
  id?: Maybe<Scalars['Float']['output']>;
  workerId?: Maybe<Scalars['Float']['output']>;
  workerServiceId?: Maybe<Scalars['Float']['output']>;
};

export type WorkerAvailabilityAvgOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
  workerId?: InputMaybe<SortOrder>;
  workerServiceId?: InputMaybe<SortOrder>;
};

export type WorkerAvailabilityCountAggregateOutputType = {
  __typename?: 'WorkerAvailabilityCountAggregateOutputType';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  dayOfWeek: Scalars['Int']['output'];
  endTime: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  startTime: Scalars['Int']['output'];
  type: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
  workerId: Scalars['Int']['output'];
  workerServiceId: Scalars['Int']['output'];
};

export type WorkerAvailabilityCountOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  dayOfWeek?: InputMaybe<SortOrder>;
  endTime?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  startTime?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  workerId?: InputMaybe<SortOrder>;
  workerServiceId?: InputMaybe<SortOrder>;
};

export type WorkerAvailabilityCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dayOfWeek: DayOfWeek;
  endTime: Scalars['String']['input'];
  startTime: Scalars['String']['input'];
  type?: InputMaybe<WorkerAvailabilityType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  worker: WorkerCreateNestedOneWithoutWorkerAvailabilitiesInput;
  workerService?: InputMaybe<WorkerServiceCreateNestedOneWithoutWorkerAvailabilitiesInput>;
};

export type WorkerAvailabilityCreateManyInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dayOfWeek: DayOfWeek;
  endTime: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  startTime: Scalars['String']['input'];
  type?: InputMaybe<WorkerAvailabilityType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  workerId: Scalars['Int']['input'];
  workerServiceId?: InputMaybe<Scalars['Int']['input']>;
};

export type WorkerAvailabilityCreateManyWorkerInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dayOfWeek: DayOfWeek;
  endTime: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  startTime: Scalars['String']['input'];
  type?: InputMaybe<WorkerAvailabilityType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  workerServiceId?: InputMaybe<Scalars['Int']['input']>;
};

export type WorkerAvailabilityCreateManyWorkerInputEnvelope = {
  data: Array<WorkerAvailabilityCreateManyWorkerInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WorkerAvailabilityCreateManyWorkerServiceInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dayOfWeek: DayOfWeek;
  endTime: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  startTime: Scalars['String']['input'];
  type?: InputMaybe<WorkerAvailabilityType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  workerId: Scalars['Int']['input'];
};

export type WorkerAvailabilityCreateManyWorkerServiceInputEnvelope = {
  data: Array<WorkerAvailabilityCreateManyWorkerServiceInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WorkerAvailabilityCreateNestedManyWithoutWorkerInput = {
  connect?: InputMaybe<Array<WorkerAvailabilityWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<WorkerAvailabilityCreateOrConnectWithoutWorkerInput>>;
  create?: InputMaybe<Array<WorkerAvailabilityCreateWithoutWorkerInput>>;
  createMany?: InputMaybe<WorkerAvailabilityCreateManyWorkerInputEnvelope>;
};

export type WorkerAvailabilityCreateNestedManyWithoutWorkerServiceInput = {
  connect?: InputMaybe<Array<WorkerAvailabilityWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<WorkerAvailabilityCreateOrConnectWithoutWorkerServiceInput>>;
  create?: InputMaybe<Array<WorkerAvailabilityCreateWithoutWorkerServiceInput>>;
  createMany?: InputMaybe<WorkerAvailabilityCreateManyWorkerServiceInputEnvelope>;
};

export type WorkerAvailabilityCreateOrConnectWithoutWorkerInput = {
  create: WorkerAvailabilityCreateWithoutWorkerInput;
  where: WorkerAvailabilityWhereUniqueInput;
};

export type WorkerAvailabilityCreateOrConnectWithoutWorkerServiceInput = {
  create: WorkerAvailabilityCreateWithoutWorkerServiceInput;
  where: WorkerAvailabilityWhereUniqueInput;
};

export type WorkerAvailabilityCreateWithoutWorkerInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dayOfWeek: DayOfWeek;
  endTime: Scalars['String']['input'];
  startTime: Scalars['String']['input'];
  type?: InputMaybe<WorkerAvailabilityType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  workerService?: InputMaybe<WorkerServiceCreateNestedOneWithoutWorkerAvailabilitiesInput>;
};

export type WorkerAvailabilityCreateWithoutWorkerServiceInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dayOfWeek: DayOfWeek;
  endTime: Scalars['String']['input'];
  startTime: Scalars['String']['input'];
  type?: InputMaybe<WorkerAvailabilityType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  worker: WorkerCreateNestedOneWithoutWorkerAvailabilitiesInput;
};

export type WorkerAvailabilityListRelationFilter = {
  every?: InputMaybe<WorkerAvailabilityWhereInput>;
  none?: InputMaybe<WorkerAvailabilityWhereInput>;
  some?: InputMaybe<WorkerAvailabilityWhereInput>;
};

export type WorkerAvailabilityMaxAggregateOutputType = {
  __typename?: 'WorkerAvailabilityMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  dayOfWeek?: Maybe<DayOfWeek>;
  endTime?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  startTime?: Maybe<Scalars['String']['output']>;
  type?: Maybe<WorkerAvailabilityType>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  workerId?: Maybe<Scalars['Int']['output']>;
  workerServiceId?: Maybe<Scalars['Int']['output']>;
};

export type WorkerAvailabilityMaxOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  dayOfWeek?: InputMaybe<SortOrder>;
  endTime?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  startTime?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  workerId?: InputMaybe<SortOrder>;
  workerServiceId?: InputMaybe<SortOrder>;
};

export type WorkerAvailabilityMinAggregateOutputType = {
  __typename?: 'WorkerAvailabilityMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  dayOfWeek?: Maybe<DayOfWeek>;
  endTime?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  startTime?: Maybe<Scalars['String']['output']>;
  type?: Maybe<WorkerAvailabilityType>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  workerId?: Maybe<Scalars['Int']['output']>;
  workerServiceId?: Maybe<Scalars['Int']['output']>;
};

export type WorkerAvailabilityMinOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  dayOfWeek?: InputMaybe<SortOrder>;
  endTime?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  startTime?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  workerId?: InputMaybe<SortOrder>;
  workerServiceId?: InputMaybe<SortOrder>;
};

export type WorkerAvailabilityOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export enum WorkerAvailabilityOrderByRelevanceFieldEnum {
  endTime = 'endTime',
  startTime = 'startTime'
}

export type WorkerAvailabilityOrderByRelevanceInput = {
  fields: Array<WorkerAvailabilityOrderByRelevanceFieldEnum>;
  search: Scalars['String']['input'];
  sort: SortOrder;
};

export type WorkerAvailabilityOrderByWithAggregationInput = {
  _avg?: InputMaybe<WorkerAvailabilityAvgOrderByAggregateInput>;
  _count?: InputMaybe<WorkerAvailabilityCountOrderByAggregateInput>;
  _max?: InputMaybe<WorkerAvailabilityMaxOrderByAggregateInput>;
  _min?: InputMaybe<WorkerAvailabilityMinOrderByAggregateInput>;
  _sum?: InputMaybe<WorkerAvailabilitySumOrderByAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  dayOfWeek?: InputMaybe<SortOrder>;
  endTime?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  startTime?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  workerId?: InputMaybe<SortOrder>;
  workerServiceId?: InputMaybe<SortOrderInput>;
};

export type WorkerAvailabilityOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: InputMaybe<WorkerAvailabilityOrderByRelevanceInput>;
  createdAt?: InputMaybe<SortOrder>;
  dayOfWeek?: InputMaybe<SortOrder>;
  endTime?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  startTime?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  worker?: InputMaybe<WorkerOrderByWithRelationAndSearchRelevanceInput>;
  workerId?: InputMaybe<SortOrder>;
  workerService?: InputMaybe<WorkerServiceOrderByWithRelationAndSearchRelevanceInput>;
  workerServiceId?: InputMaybe<SortOrderInput>;
};

export enum WorkerAvailabilityScalarFieldEnum {
  createdAt = 'createdAt',
  dayOfWeek = 'dayOfWeek',
  endTime = 'endTime',
  id = 'id',
  startTime = 'startTime',
  type = 'type',
  updatedAt = 'updatedAt',
  workerId = 'workerId',
  workerServiceId = 'workerServiceId'
}

export type WorkerAvailabilityScalarWhereInput = {
  AND?: InputMaybe<Array<WorkerAvailabilityScalarWhereInput>>;
  NOT?: InputMaybe<Array<WorkerAvailabilityScalarWhereInput>>;
  OR?: InputMaybe<Array<WorkerAvailabilityScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  dayOfWeek?: InputMaybe<EnumDayOfWeekFilter>;
  endTime?: InputMaybe<StringFilter>;
  id?: InputMaybe<IntFilter>;
  startTime?: InputMaybe<StringFilter>;
  type?: InputMaybe<EnumWorkerAvailabilityTypeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  workerId?: InputMaybe<IntFilter>;
  workerServiceId?: InputMaybe<IntNullableFilter>;
};

export type WorkerAvailabilityScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<WorkerAvailabilityScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<WorkerAvailabilityScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<WorkerAvailabilityScalarWhereWithAggregatesInput>>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  dayOfWeek?: InputMaybe<EnumDayOfWeekWithAggregatesFilter>;
  endTime?: InputMaybe<StringWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  startTime?: InputMaybe<StringWithAggregatesFilter>;
  type?: InputMaybe<EnumWorkerAvailabilityTypeWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  workerId?: InputMaybe<IntWithAggregatesFilter>;
  workerServiceId?: InputMaybe<IntNullableWithAggregatesFilter>;
};

export type WorkerAvailabilitySumAggregateOutputType = {
  __typename?: 'WorkerAvailabilitySumAggregateOutputType';
  id?: Maybe<Scalars['Int']['output']>;
  workerId?: Maybe<Scalars['Int']['output']>;
  workerServiceId?: Maybe<Scalars['Int']['output']>;
};

export type WorkerAvailabilitySumOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
  workerId?: InputMaybe<SortOrder>;
  workerServiceId?: InputMaybe<SortOrder>;
};

export enum WorkerAvailabilityType {
  GENERAL_AVAIL = 'GENERAL_AVAIL',
  SERVICE_AVAIL = 'SERVICE_AVAIL'
}

export type WorkerAvailabilityUncheckedCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dayOfWeek: DayOfWeek;
  endTime: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  startTime: Scalars['String']['input'];
  type?: InputMaybe<WorkerAvailabilityType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  workerId: Scalars['Int']['input'];
  workerServiceId?: InputMaybe<Scalars['Int']['input']>;
};

export type WorkerAvailabilityUncheckedCreateNestedManyWithoutWorkerInput = {
  connect?: InputMaybe<Array<WorkerAvailabilityWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<WorkerAvailabilityCreateOrConnectWithoutWorkerInput>>;
  create?: InputMaybe<Array<WorkerAvailabilityCreateWithoutWorkerInput>>;
  createMany?: InputMaybe<WorkerAvailabilityCreateManyWorkerInputEnvelope>;
};

export type WorkerAvailabilityUncheckedCreateNestedManyWithoutWorkerServiceInput = {
  connect?: InputMaybe<Array<WorkerAvailabilityWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<WorkerAvailabilityCreateOrConnectWithoutWorkerServiceInput>>;
  create?: InputMaybe<Array<WorkerAvailabilityCreateWithoutWorkerServiceInput>>;
  createMany?: InputMaybe<WorkerAvailabilityCreateManyWorkerServiceInputEnvelope>;
};

export type WorkerAvailabilityUncheckedCreateWithoutWorkerInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dayOfWeek: DayOfWeek;
  endTime: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  startTime: Scalars['String']['input'];
  type?: InputMaybe<WorkerAvailabilityType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  workerServiceId?: InputMaybe<Scalars['Int']['input']>;
};

export type WorkerAvailabilityUncheckedCreateWithoutWorkerServiceInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dayOfWeek: DayOfWeek;
  endTime: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  startTime: Scalars['String']['input'];
  type?: InputMaybe<WorkerAvailabilityType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  workerId: Scalars['Int']['input'];
};

export type WorkerAvailabilityUncheckedUpdateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dayOfWeek?: InputMaybe<EnumDayOfWeekFieldUpdateOperationsInput>;
  endTime?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  startTime?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumWorkerAvailabilityTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  workerId?: InputMaybe<IntFieldUpdateOperationsInput>;
  workerServiceId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type WorkerAvailabilityUncheckedUpdateManyInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dayOfWeek?: InputMaybe<EnumDayOfWeekFieldUpdateOperationsInput>;
  endTime?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  startTime?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumWorkerAvailabilityTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  workerId?: InputMaybe<IntFieldUpdateOperationsInput>;
  workerServiceId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type WorkerAvailabilityUncheckedUpdateManyWithoutWorkerInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dayOfWeek?: InputMaybe<EnumDayOfWeekFieldUpdateOperationsInput>;
  endTime?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  startTime?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumWorkerAvailabilityTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  workerServiceId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type WorkerAvailabilityUncheckedUpdateManyWithoutWorkerNestedInput = {
  connect?: InputMaybe<Array<WorkerAvailabilityWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<WorkerAvailabilityCreateOrConnectWithoutWorkerInput>>;
  create?: InputMaybe<Array<WorkerAvailabilityCreateWithoutWorkerInput>>;
  createMany?: InputMaybe<WorkerAvailabilityCreateManyWorkerInputEnvelope>;
  delete?: InputMaybe<Array<WorkerAvailabilityWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<WorkerAvailabilityScalarWhereInput>>;
  disconnect?: InputMaybe<Array<WorkerAvailabilityWhereUniqueInput>>;
  set?: InputMaybe<Array<WorkerAvailabilityWhereUniqueInput>>;
  update?: InputMaybe<Array<WorkerAvailabilityUpdateWithWhereUniqueWithoutWorkerInput>>;
  updateMany?: InputMaybe<Array<WorkerAvailabilityUpdateManyWithWhereWithoutWorkerInput>>;
  upsert?: InputMaybe<Array<WorkerAvailabilityUpsertWithWhereUniqueWithoutWorkerInput>>;
};

export type WorkerAvailabilityUncheckedUpdateManyWithoutWorkerServiceInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dayOfWeek?: InputMaybe<EnumDayOfWeekFieldUpdateOperationsInput>;
  endTime?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  startTime?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumWorkerAvailabilityTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  workerId?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type WorkerAvailabilityUncheckedUpdateManyWithoutWorkerServiceNestedInput = {
  connect?: InputMaybe<Array<WorkerAvailabilityWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<WorkerAvailabilityCreateOrConnectWithoutWorkerServiceInput>>;
  create?: InputMaybe<Array<WorkerAvailabilityCreateWithoutWorkerServiceInput>>;
  createMany?: InputMaybe<WorkerAvailabilityCreateManyWorkerServiceInputEnvelope>;
  delete?: InputMaybe<Array<WorkerAvailabilityWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<WorkerAvailabilityScalarWhereInput>>;
  disconnect?: InputMaybe<Array<WorkerAvailabilityWhereUniqueInput>>;
  set?: InputMaybe<Array<WorkerAvailabilityWhereUniqueInput>>;
  update?: InputMaybe<Array<WorkerAvailabilityUpdateWithWhereUniqueWithoutWorkerServiceInput>>;
  updateMany?: InputMaybe<Array<WorkerAvailabilityUpdateManyWithWhereWithoutWorkerServiceInput>>;
  upsert?: InputMaybe<Array<WorkerAvailabilityUpsertWithWhereUniqueWithoutWorkerServiceInput>>;
};

export type WorkerAvailabilityUncheckedUpdateWithoutWorkerInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dayOfWeek?: InputMaybe<EnumDayOfWeekFieldUpdateOperationsInput>;
  endTime?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  startTime?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumWorkerAvailabilityTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  workerServiceId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type WorkerAvailabilityUncheckedUpdateWithoutWorkerServiceInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dayOfWeek?: InputMaybe<EnumDayOfWeekFieldUpdateOperationsInput>;
  endTime?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  startTime?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumWorkerAvailabilityTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  workerId?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type WorkerAvailabilityUpdateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dayOfWeek?: InputMaybe<EnumDayOfWeekFieldUpdateOperationsInput>;
  endTime?: InputMaybe<StringFieldUpdateOperationsInput>;
  startTime?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumWorkerAvailabilityTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  worker?: InputMaybe<WorkerUpdateOneRequiredWithoutWorkerAvailabilitiesNestedInput>;
  workerService?: InputMaybe<WorkerServiceUpdateOneWithoutWorkerAvailabilitiesNestedInput>;
};

export type WorkerAvailabilityUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dayOfWeek?: InputMaybe<EnumDayOfWeekFieldUpdateOperationsInput>;
  endTime?: InputMaybe<StringFieldUpdateOperationsInput>;
  startTime?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumWorkerAvailabilityTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type WorkerAvailabilityUpdateManyWithWhereWithoutWorkerInput = {
  data: WorkerAvailabilityUpdateManyMutationInput;
  where: WorkerAvailabilityScalarWhereInput;
};

export type WorkerAvailabilityUpdateManyWithWhereWithoutWorkerServiceInput = {
  data: WorkerAvailabilityUpdateManyMutationInput;
  where: WorkerAvailabilityScalarWhereInput;
};

export type WorkerAvailabilityUpdateManyWithoutWorkerNestedInput = {
  connect?: InputMaybe<Array<WorkerAvailabilityWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<WorkerAvailabilityCreateOrConnectWithoutWorkerInput>>;
  create?: InputMaybe<Array<WorkerAvailabilityCreateWithoutWorkerInput>>;
  createMany?: InputMaybe<WorkerAvailabilityCreateManyWorkerInputEnvelope>;
  delete?: InputMaybe<Array<WorkerAvailabilityWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<WorkerAvailabilityScalarWhereInput>>;
  disconnect?: InputMaybe<Array<WorkerAvailabilityWhereUniqueInput>>;
  set?: InputMaybe<Array<WorkerAvailabilityWhereUniqueInput>>;
  update?: InputMaybe<Array<WorkerAvailabilityUpdateWithWhereUniqueWithoutWorkerInput>>;
  updateMany?: InputMaybe<Array<WorkerAvailabilityUpdateManyWithWhereWithoutWorkerInput>>;
  upsert?: InputMaybe<Array<WorkerAvailabilityUpsertWithWhereUniqueWithoutWorkerInput>>;
};

export type WorkerAvailabilityUpdateManyWithoutWorkerServiceNestedInput = {
  connect?: InputMaybe<Array<WorkerAvailabilityWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<WorkerAvailabilityCreateOrConnectWithoutWorkerServiceInput>>;
  create?: InputMaybe<Array<WorkerAvailabilityCreateWithoutWorkerServiceInput>>;
  createMany?: InputMaybe<WorkerAvailabilityCreateManyWorkerServiceInputEnvelope>;
  delete?: InputMaybe<Array<WorkerAvailabilityWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<WorkerAvailabilityScalarWhereInput>>;
  disconnect?: InputMaybe<Array<WorkerAvailabilityWhereUniqueInput>>;
  set?: InputMaybe<Array<WorkerAvailabilityWhereUniqueInput>>;
  update?: InputMaybe<Array<WorkerAvailabilityUpdateWithWhereUniqueWithoutWorkerServiceInput>>;
  updateMany?: InputMaybe<Array<WorkerAvailabilityUpdateManyWithWhereWithoutWorkerServiceInput>>;
  upsert?: InputMaybe<Array<WorkerAvailabilityUpsertWithWhereUniqueWithoutWorkerServiceInput>>;
};

export type WorkerAvailabilityUpdateWithWhereUniqueWithoutWorkerInput = {
  data: WorkerAvailabilityUpdateWithoutWorkerInput;
  where: WorkerAvailabilityWhereUniqueInput;
};

export type WorkerAvailabilityUpdateWithWhereUniqueWithoutWorkerServiceInput = {
  data: WorkerAvailabilityUpdateWithoutWorkerServiceInput;
  where: WorkerAvailabilityWhereUniqueInput;
};

export type WorkerAvailabilityUpdateWithoutWorkerInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dayOfWeek?: InputMaybe<EnumDayOfWeekFieldUpdateOperationsInput>;
  endTime?: InputMaybe<StringFieldUpdateOperationsInput>;
  startTime?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumWorkerAvailabilityTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  workerService?: InputMaybe<WorkerServiceUpdateOneWithoutWorkerAvailabilitiesNestedInput>;
};

export type WorkerAvailabilityUpdateWithoutWorkerServiceInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dayOfWeek?: InputMaybe<EnumDayOfWeekFieldUpdateOperationsInput>;
  endTime?: InputMaybe<StringFieldUpdateOperationsInput>;
  startTime?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumWorkerAvailabilityTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  worker?: InputMaybe<WorkerUpdateOneRequiredWithoutWorkerAvailabilitiesNestedInput>;
};

export type WorkerAvailabilityUpsertWithWhereUniqueWithoutWorkerInput = {
  create: WorkerAvailabilityCreateWithoutWorkerInput;
  update: WorkerAvailabilityUpdateWithoutWorkerInput;
  where: WorkerAvailabilityWhereUniqueInput;
};

export type WorkerAvailabilityUpsertWithWhereUniqueWithoutWorkerServiceInput = {
  create: WorkerAvailabilityCreateWithoutWorkerServiceInput;
  update: WorkerAvailabilityUpdateWithoutWorkerServiceInput;
  where: WorkerAvailabilityWhereUniqueInput;
};

export type WorkerAvailabilityWhereInput = {
  AND?: InputMaybe<Array<WorkerAvailabilityWhereInput>>;
  NOT?: InputMaybe<Array<WorkerAvailabilityWhereInput>>;
  OR?: InputMaybe<Array<WorkerAvailabilityWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  dayOfWeek?: InputMaybe<EnumDayOfWeekFilter>;
  endTime?: InputMaybe<StringFilter>;
  id?: InputMaybe<IntFilter>;
  startTime?: InputMaybe<StringFilter>;
  type?: InputMaybe<EnumWorkerAvailabilityTypeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  worker?: InputMaybe<WorkerRelationFilter>;
  workerId?: InputMaybe<IntFilter>;
  workerService?: InputMaybe<WorkerServiceNullableRelationFilter>;
  workerServiceId?: InputMaybe<IntNullableFilter>;
};

export type WorkerAvailabilityWhereUniqueInput = {
  AND?: InputMaybe<Array<WorkerAvailabilityWhereInput>>;
  NOT?: InputMaybe<Array<WorkerAvailabilityWhereInput>>;
  OR?: InputMaybe<Array<WorkerAvailabilityWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  dayOfWeek?: InputMaybe<EnumDayOfWeekFilter>;
  endTime?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  startTime?: InputMaybe<StringFilter>;
  type?: InputMaybe<EnumWorkerAvailabilityTypeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  worker?: InputMaybe<WorkerRelationFilter>;
  workerId?: InputMaybe<IntFilter>;
  workerService?: InputMaybe<WorkerServiceNullableRelationFilter>;
  workerServiceId?: InputMaybe<IntNullableFilter>;
};

export type WorkerAvgAggregateOutputType = {
  __typename?: 'WorkerAvgAggregateOutputType';
  defaultServiceDurationMinute?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  proId?: Maybe<Scalars['Float']['output']>;
};

export type WorkerAvgOrderByAggregateInput = {
  defaultServiceDurationMinute?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  proId?: InputMaybe<SortOrder>;
};

export type WorkerCountAggregateOutputType = {
  __typename?: 'WorkerCountAggregateOutputType';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  defaultServiceDurationMinute: Scalars['Int']['output'];
  email: Scalars['Int']['output'];
  firstName: Scalars['Int']['output'];
  googleCalendarId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  lastName: Scalars['Int']['output'];
  phone: Scalars['Int']['output'];
  proId: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type WorkerCountOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  defaultServiceDurationMinute?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  firstName?: InputMaybe<SortOrder>;
  googleCalendarId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  lastName?: InputMaybe<SortOrder>;
  phone?: InputMaybe<SortOrder>;
  proId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type WorkerCountOutputType = {
  __typename?: 'WorkerCountOutputType';
  bookings: Scalars['Int']['output'];
  services: Scalars['Int']['output'];
  workerAvailabilities: Scalars['Int']['output'];
};

export type WorkerCreateInput = {
  bookings?: InputMaybe<BookingCreateNestedManyWithoutWorkerInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  defaultServiceDurationMinute?: InputMaybe<Scalars['Int']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  googleCalendarId?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pro: ProfessionalCreateNestedOneWithoutWorkersInput;
  services?: InputMaybe<WorkerServiceCreateNestedManyWithoutWorkerInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  workerAvailabilities?: InputMaybe<WorkerAvailabilityCreateNestedManyWithoutWorkerInput>;
};

export type WorkerCreateManyInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  defaultServiceDurationMinute?: InputMaybe<Scalars['Int']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  googleCalendarId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  proId: Scalars['Int']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type WorkerCreateManyProInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  defaultServiceDurationMinute?: InputMaybe<Scalars['Int']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  googleCalendarId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type WorkerCreateManyProInputEnvelope = {
  data: Array<WorkerCreateManyProInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WorkerCreateNestedManyWithoutProInput = {
  connect?: InputMaybe<Array<WorkerWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<WorkerCreateOrConnectWithoutProInput>>;
  create?: InputMaybe<Array<WorkerCreateWithoutProInput>>;
  createMany?: InputMaybe<WorkerCreateManyProInputEnvelope>;
};

export type WorkerCreateNestedOneWithoutBookingsInput = {
  connect?: InputMaybe<WorkerWhereUniqueInput>;
  connectOrCreate?: InputMaybe<WorkerCreateOrConnectWithoutBookingsInput>;
  create?: InputMaybe<WorkerCreateWithoutBookingsInput>;
};

export type WorkerCreateNestedOneWithoutServicesInput = {
  connect?: InputMaybe<WorkerWhereUniqueInput>;
  connectOrCreate?: InputMaybe<WorkerCreateOrConnectWithoutServicesInput>;
  create?: InputMaybe<WorkerCreateWithoutServicesInput>;
};

export type WorkerCreateNestedOneWithoutWorkerAvailabilitiesInput = {
  connect?: InputMaybe<WorkerWhereUniqueInput>;
  connectOrCreate?: InputMaybe<WorkerCreateOrConnectWithoutWorkerAvailabilitiesInput>;
  create?: InputMaybe<WorkerCreateWithoutWorkerAvailabilitiesInput>;
};

export type WorkerCreateOrConnectWithoutBookingsInput = {
  create: WorkerCreateWithoutBookingsInput;
  where: WorkerWhereUniqueInput;
};

export type WorkerCreateOrConnectWithoutProInput = {
  create: WorkerCreateWithoutProInput;
  where: WorkerWhereUniqueInput;
};

export type WorkerCreateOrConnectWithoutServicesInput = {
  create: WorkerCreateWithoutServicesInput;
  where: WorkerWhereUniqueInput;
};

export type WorkerCreateOrConnectWithoutWorkerAvailabilitiesInput = {
  create: WorkerCreateWithoutWorkerAvailabilitiesInput;
  where: WorkerWhereUniqueInput;
};

export type WorkerCreateWithoutBookingsInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  defaultServiceDurationMinute?: InputMaybe<Scalars['Int']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  googleCalendarId?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pro: ProfessionalCreateNestedOneWithoutWorkersInput;
  services?: InputMaybe<WorkerServiceCreateNestedManyWithoutWorkerInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  workerAvailabilities?: InputMaybe<WorkerAvailabilityCreateNestedManyWithoutWorkerInput>;
};

export type WorkerCreateWithoutProInput = {
  bookings?: InputMaybe<BookingCreateNestedManyWithoutWorkerInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  defaultServiceDurationMinute?: InputMaybe<Scalars['Int']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  googleCalendarId?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  services?: InputMaybe<WorkerServiceCreateNestedManyWithoutWorkerInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  workerAvailabilities?: InputMaybe<WorkerAvailabilityCreateNestedManyWithoutWorkerInput>;
};

export type WorkerCreateWithoutServicesInput = {
  bookings?: InputMaybe<BookingCreateNestedManyWithoutWorkerInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  defaultServiceDurationMinute?: InputMaybe<Scalars['Int']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  googleCalendarId?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pro: ProfessionalCreateNestedOneWithoutWorkersInput;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  workerAvailabilities?: InputMaybe<WorkerAvailabilityCreateNestedManyWithoutWorkerInput>;
};

export type WorkerCreateWithoutWorkerAvailabilitiesInput = {
  bookings?: InputMaybe<BookingCreateNestedManyWithoutWorkerInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  defaultServiceDurationMinute?: InputMaybe<Scalars['Int']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  googleCalendarId?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pro: ProfessionalCreateNestedOneWithoutWorkersInput;
  services?: InputMaybe<WorkerServiceCreateNestedManyWithoutWorkerInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type WorkerListRelationFilter = {
  every?: InputMaybe<WorkerWhereInput>;
  none?: InputMaybe<WorkerWhereInput>;
  some?: InputMaybe<WorkerWhereInput>;
};

export type WorkerMaxAggregateOutputType = {
  __typename?: 'WorkerMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  defaultServiceDurationMinute?: Maybe<Scalars['Int']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  googleCalendarId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  proId?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type WorkerMaxOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  defaultServiceDurationMinute?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  firstName?: InputMaybe<SortOrder>;
  googleCalendarId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  lastName?: InputMaybe<SortOrder>;
  phone?: InputMaybe<SortOrder>;
  proId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type WorkerMinAggregateOutputType = {
  __typename?: 'WorkerMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  defaultServiceDurationMinute?: Maybe<Scalars['Int']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  googleCalendarId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  proId?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type WorkerMinOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  defaultServiceDurationMinute?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  firstName?: InputMaybe<SortOrder>;
  googleCalendarId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  lastName?: InputMaybe<SortOrder>;
  phone?: InputMaybe<SortOrder>;
  proId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type WorkerOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export enum WorkerOrderByRelevanceFieldEnum {
  email = 'email',
  firstName = 'firstName',
  googleCalendarId = 'googleCalendarId',
  lastName = 'lastName',
  phone = 'phone'
}

export type WorkerOrderByRelevanceInput = {
  fields: Array<WorkerOrderByRelevanceFieldEnum>;
  search: Scalars['String']['input'];
  sort: SortOrder;
};

export type WorkerOrderByWithAggregationInput = {
  _avg?: InputMaybe<WorkerAvgOrderByAggregateInput>;
  _count?: InputMaybe<WorkerCountOrderByAggregateInput>;
  _max?: InputMaybe<WorkerMaxOrderByAggregateInput>;
  _min?: InputMaybe<WorkerMinOrderByAggregateInput>;
  _sum?: InputMaybe<WorkerSumOrderByAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  defaultServiceDurationMinute?: InputMaybe<SortOrderInput>;
  email?: InputMaybe<SortOrderInput>;
  firstName?: InputMaybe<SortOrderInput>;
  googleCalendarId?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  lastName?: InputMaybe<SortOrderInput>;
  phone?: InputMaybe<SortOrderInput>;
  proId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type WorkerOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: InputMaybe<WorkerOrderByRelevanceInput>;
  bookings?: InputMaybe<BookingOrderByRelationAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  defaultServiceDurationMinute?: InputMaybe<SortOrderInput>;
  email?: InputMaybe<SortOrderInput>;
  firstName?: InputMaybe<SortOrderInput>;
  googleCalendarId?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  lastName?: InputMaybe<SortOrderInput>;
  phone?: InputMaybe<SortOrderInput>;
  pro?: InputMaybe<ProfessionalOrderByWithRelationAndSearchRelevanceInput>;
  proId?: InputMaybe<SortOrder>;
  services?: InputMaybe<WorkerServiceOrderByRelationAggregateInput>;
  updatedAt?: InputMaybe<SortOrder>;
  workerAvailabilities?: InputMaybe<WorkerAvailabilityOrderByRelationAggregateInput>;
};

export type WorkerRelationFilter = {
  is?: InputMaybe<WorkerWhereInput>;
  isNot?: InputMaybe<WorkerWhereInput>;
};

export enum WorkerScalarFieldEnum {
  createdAt = 'createdAt',
  defaultServiceDurationMinute = 'defaultServiceDurationMinute',
  email = 'email',
  firstName = 'firstName',
  googleCalendarId = 'googleCalendarId',
  id = 'id',
  lastName = 'lastName',
  phone = 'phone',
  proId = 'proId',
  updatedAt = 'updatedAt'
}

export type WorkerScalarWhereInput = {
  AND?: InputMaybe<Array<WorkerScalarWhereInput>>;
  NOT?: InputMaybe<Array<WorkerScalarWhereInput>>;
  OR?: InputMaybe<Array<WorkerScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  defaultServiceDurationMinute?: InputMaybe<IntNullableFilter>;
  email?: InputMaybe<StringNullableFilter>;
  firstName?: InputMaybe<StringNullableFilter>;
  googleCalendarId?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<IntFilter>;
  lastName?: InputMaybe<StringNullableFilter>;
  phone?: InputMaybe<StringNullableFilter>;
  proId?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type WorkerScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<WorkerScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<WorkerScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<WorkerScalarWhereWithAggregatesInput>>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  defaultServiceDurationMinute?: InputMaybe<IntNullableWithAggregatesFilter>;
  email?: InputMaybe<StringNullableWithAggregatesFilter>;
  firstName?: InputMaybe<StringNullableWithAggregatesFilter>;
  googleCalendarId?: InputMaybe<StringNullableWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  lastName?: InputMaybe<StringNullableWithAggregatesFilter>;
  phone?: InputMaybe<StringNullableWithAggregatesFilter>;
  proId?: InputMaybe<IntWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type WorkerService = {
  __typename?: 'WorkerService';
  _count: WorkerServiceCountOutputType;
  animalSize?: Maybe<AnimalSizeEnum>;
  animalType?: Maybe<AnimalTypeEnum>;
  bookable: Scalars['Boolean']['output'];
  /** @TypeGraphQL.omit(output: true) */
  bookings: Array<Booking>;
  category: Category;
  categoryId: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  enabled: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  isProSpecialist: Scalars['Boolean']['output'];
  maximumDuration?: Maybe<Scalars['Int']['output']>;
  minimumDuration?: Maybe<Scalars['Int']['output']>;
  multiAnimalsBookingEnabled: Scalars['Boolean']['output'];
  multiAnimalsDuration?: Maybe<Scalars['Int']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  priceFrom?: Maybe<Scalars['Float']['output']>;
  priceTo?: Maybe<Scalars['Float']['output']>;
  priceType?: Maybe<WorkerServicePriceType>;
  service: Service;
  serviceId: Scalars['Int']['output'];
  translations: Array<WorkerServiceTranslation>;
  updatedAt: Scalars['DateTime']['output'];
  worker: Worker;
  workerAvailabilities: Array<WorkerAvailability>;
  workerId: Scalars['Int']['output'];
};


export type WorkerServicebookingsArgs = {
  cursor?: InputMaybe<BookingWhereUniqueInput>;
  distinct?: InputMaybe<BookingScalarFieldEnum>;
  orderBy?: InputMaybe<BookingOrderByWithRelationAndSearchRelevanceInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<BookingWhereInput>;
};


export type WorkerServicetranslationsArgs = {
  cursor?: InputMaybe<WorkerServiceTranslationWhereUniqueInput>;
  distinct?: InputMaybe<WorkerServiceTranslationScalarFieldEnum>;
  orderBy?: InputMaybe<WorkerServiceTranslationOrderByWithRelationAndSearchRelevanceInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<WorkerServiceTranslationWhereInput>;
};


export type WorkerServiceworkerAvailabilitiesArgs = {
  cursor?: InputMaybe<WorkerAvailabilityWhereUniqueInput>;
  distinct?: InputMaybe<WorkerAvailabilityScalarFieldEnum>;
  orderBy?: InputMaybe<WorkerAvailabilityOrderByWithRelationAndSearchRelevanceInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<WorkerAvailabilityWhereInput>;
};

export type WorkerServiceAvgAggregateOutputType = {
  __typename?: 'WorkerServiceAvgAggregateOutputType';
  categoryId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  maximumDuration?: Maybe<Scalars['Float']['output']>;
  minimumDuration?: Maybe<Scalars['Float']['output']>;
  multiAnimalsDuration?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  priceFrom?: Maybe<Scalars['Float']['output']>;
  priceTo?: Maybe<Scalars['Float']['output']>;
  serviceId?: Maybe<Scalars['Float']['output']>;
  workerId?: Maybe<Scalars['Float']['output']>;
};

export type WorkerServiceAvgOrderByAggregateInput = {
  categoryId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  maximumDuration?: InputMaybe<SortOrder>;
  minimumDuration?: InputMaybe<SortOrder>;
  multiAnimalsDuration?: InputMaybe<SortOrder>;
  price?: InputMaybe<SortOrder>;
  priceFrom?: InputMaybe<SortOrder>;
  priceTo?: InputMaybe<SortOrder>;
  serviceId?: InputMaybe<SortOrder>;
  workerId?: InputMaybe<SortOrder>;
};

export type WorkerServiceCountAggregateOutputType = {
  __typename?: 'WorkerServiceCountAggregateOutputType';
  _all: Scalars['Int']['output'];
  animalSize: Scalars['Int']['output'];
  animalType: Scalars['Int']['output'];
  bookable: Scalars['Int']['output'];
  categoryId: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  enabled: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isProSpecialist: Scalars['Int']['output'];
  maximumDuration: Scalars['Int']['output'];
  minimumDuration: Scalars['Int']['output'];
  multiAnimalsBookingEnabled: Scalars['Int']['output'];
  multiAnimalsDuration: Scalars['Int']['output'];
  price: Scalars['Int']['output'];
  priceFrom: Scalars['Int']['output'];
  priceTo: Scalars['Int']['output'];
  priceType: Scalars['Int']['output'];
  serviceId: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
  workerId: Scalars['Int']['output'];
};

export type WorkerServiceCountOrderByAggregateInput = {
  animalSize?: InputMaybe<SortOrder>;
  animalType?: InputMaybe<SortOrder>;
  bookable?: InputMaybe<SortOrder>;
  categoryId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  enabled?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isProSpecialist?: InputMaybe<SortOrder>;
  maximumDuration?: InputMaybe<SortOrder>;
  minimumDuration?: InputMaybe<SortOrder>;
  multiAnimalsBookingEnabled?: InputMaybe<SortOrder>;
  multiAnimalsDuration?: InputMaybe<SortOrder>;
  price?: InputMaybe<SortOrder>;
  priceFrom?: InputMaybe<SortOrder>;
  priceTo?: InputMaybe<SortOrder>;
  priceType?: InputMaybe<SortOrder>;
  serviceId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  workerId?: InputMaybe<SortOrder>;
};

export type WorkerServiceCountOutputType = {
  __typename?: 'WorkerServiceCountOutputType';
  bookings: Scalars['Int']['output'];
  translations: Scalars['Int']['output'];
  workerAvailabilities: Scalars['Int']['output'];
};

export type WorkerServiceCreateInput = {
  animalSize?: InputMaybe<AnimalSizeEnum>;
  animalType?: InputMaybe<AnimalTypeEnum>;
  bookable?: InputMaybe<Scalars['Boolean']['input']>;
  bookings?: InputMaybe<BookingCreateNestedManyWithoutWorkerServiceInput>;
  category: CategoryCreateNestedOneWithoutWorkerServicesInput;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  isProSpecialist?: InputMaybe<Scalars['Boolean']['input']>;
  maximumDuration?: InputMaybe<Scalars['Int']['input']>;
  minimumDuration?: InputMaybe<Scalars['Int']['input']>;
  multiAnimalsBookingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  multiAnimalsDuration?: InputMaybe<Scalars['Int']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  priceFrom?: InputMaybe<Scalars['Float']['input']>;
  priceTo?: InputMaybe<Scalars['Float']['input']>;
  priceType?: InputMaybe<WorkerServicePriceType>;
  service: ServiceCreateNestedOneWithoutWorkerServicesInput;
  translations?: InputMaybe<WorkerServiceTranslationCreateNestedManyWithoutWorkerServiceInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  worker: WorkerCreateNestedOneWithoutServicesInput;
  workerAvailabilities?: InputMaybe<WorkerAvailabilityCreateNestedManyWithoutWorkerServiceInput>;
};

export type WorkerServiceCreateManyCategoryInput = {
  animalSize?: InputMaybe<AnimalSizeEnum>;
  animalType?: InputMaybe<AnimalTypeEnum>;
  bookable?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isProSpecialist?: InputMaybe<Scalars['Boolean']['input']>;
  maximumDuration?: InputMaybe<Scalars['Int']['input']>;
  minimumDuration?: InputMaybe<Scalars['Int']['input']>;
  multiAnimalsBookingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  multiAnimalsDuration?: InputMaybe<Scalars['Int']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  priceFrom?: InputMaybe<Scalars['Float']['input']>;
  priceTo?: InputMaybe<Scalars['Float']['input']>;
  priceType?: InputMaybe<WorkerServicePriceType>;
  serviceId: Scalars['Int']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  workerId: Scalars['Int']['input'];
};

export type WorkerServiceCreateManyCategoryInputEnvelope = {
  data: Array<WorkerServiceCreateManyCategoryInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WorkerServiceCreateManyInput = {
  animalSize?: InputMaybe<AnimalSizeEnum>;
  animalType?: InputMaybe<AnimalTypeEnum>;
  bookable?: InputMaybe<Scalars['Boolean']['input']>;
  categoryId: Scalars['Int']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isProSpecialist?: InputMaybe<Scalars['Boolean']['input']>;
  maximumDuration?: InputMaybe<Scalars['Int']['input']>;
  minimumDuration?: InputMaybe<Scalars['Int']['input']>;
  multiAnimalsBookingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  multiAnimalsDuration?: InputMaybe<Scalars['Int']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  priceFrom?: InputMaybe<Scalars['Float']['input']>;
  priceTo?: InputMaybe<Scalars['Float']['input']>;
  priceType?: InputMaybe<WorkerServicePriceType>;
  serviceId: Scalars['Int']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  workerId: Scalars['Int']['input'];
};

export type WorkerServiceCreateManyServiceInput = {
  animalSize?: InputMaybe<AnimalSizeEnum>;
  animalType?: InputMaybe<AnimalTypeEnum>;
  bookable?: InputMaybe<Scalars['Boolean']['input']>;
  categoryId: Scalars['Int']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isProSpecialist?: InputMaybe<Scalars['Boolean']['input']>;
  maximumDuration?: InputMaybe<Scalars['Int']['input']>;
  minimumDuration?: InputMaybe<Scalars['Int']['input']>;
  multiAnimalsBookingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  multiAnimalsDuration?: InputMaybe<Scalars['Int']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  priceFrom?: InputMaybe<Scalars['Float']['input']>;
  priceTo?: InputMaybe<Scalars['Float']['input']>;
  priceType?: InputMaybe<WorkerServicePriceType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  workerId: Scalars['Int']['input'];
};

export type WorkerServiceCreateManyServiceInputEnvelope = {
  data: Array<WorkerServiceCreateManyServiceInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WorkerServiceCreateManyWorkerInput = {
  animalSize?: InputMaybe<AnimalSizeEnum>;
  animalType?: InputMaybe<AnimalTypeEnum>;
  bookable?: InputMaybe<Scalars['Boolean']['input']>;
  categoryId: Scalars['Int']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isProSpecialist?: InputMaybe<Scalars['Boolean']['input']>;
  maximumDuration?: InputMaybe<Scalars['Int']['input']>;
  minimumDuration?: InputMaybe<Scalars['Int']['input']>;
  multiAnimalsBookingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  multiAnimalsDuration?: InputMaybe<Scalars['Int']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  priceFrom?: InputMaybe<Scalars['Float']['input']>;
  priceTo?: InputMaybe<Scalars['Float']['input']>;
  priceType?: InputMaybe<WorkerServicePriceType>;
  serviceId: Scalars['Int']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type WorkerServiceCreateManyWorkerInputEnvelope = {
  data: Array<WorkerServiceCreateManyWorkerInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WorkerServiceCreateNestedManyWithoutCategoryInput = {
  connect?: InputMaybe<Array<WorkerServiceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<WorkerServiceCreateOrConnectWithoutCategoryInput>>;
  create?: InputMaybe<Array<WorkerServiceCreateWithoutCategoryInput>>;
  createMany?: InputMaybe<WorkerServiceCreateManyCategoryInputEnvelope>;
};

export type WorkerServiceCreateNestedManyWithoutServiceInput = {
  connect?: InputMaybe<Array<WorkerServiceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<WorkerServiceCreateOrConnectWithoutServiceInput>>;
  create?: InputMaybe<Array<WorkerServiceCreateWithoutServiceInput>>;
  createMany?: InputMaybe<WorkerServiceCreateManyServiceInputEnvelope>;
};

export type WorkerServiceCreateNestedManyWithoutWorkerInput = {
  connect?: InputMaybe<Array<WorkerServiceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<WorkerServiceCreateOrConnectWithoutWorkerInput>>;
  create?: InputMaybe<Array<WorkerServiceCreateWithoutWorkerInput>>;
  createMany?: InputMaybe<WorkerServiceCreateManyWorkerInputEnvelope>;
};

export type WorkerServiceCreateNestedOneWithoutBookingsInput = {
  connect?: InputMaybe<WorkerServiceWhereUniqueInput>;
  connectOrCreate?: InputMaybe<WorkerServiceCreateOrConnectWithoutBookingsInput>;
  create?: InputMaybe<WorkerServiceCreateWithoutBookingsInput>;
};

export type WorkerServiceCreateNestedOneWithoutTranslationsInput = {
  connect?: InputMaybe<WorkerServiceWhereUniqueInput>;
  connectOrCreate?: InputMaybe<WorkerServiceCreateOrConnectWithoutTranslationsInput>;
  create?: InputMaybe<WorkerServiceCreateWithoutTranslationsInput>;
};

export type WorkerServiceCreateNestedOneWithoutWorkerAvailabilitiesInput = {
  connect?: InputMaybe<WorkerServiceWhereUniqueInput>;
  connectOrCreate?: InputMaybe<WorkerServiceCreateOrConnectWithoutWorkerAvailabilitiesInput>;
  create?: InputMaybe<WorkerServiceCreateWithoutWorkerAvailabilitiesInput>;
};

export type WorkerServiceCreateOrConnectWithoutBookingsInput = {
  create: WorkerServiceCreateWithoutBookingsInput;
  where: WorkerServiceWhereUniqueInput;
};

export type WorkerServiceCreateOrConnectWithoutCategoryInput = {
  create: WorkerServiceCreateWithoutCategoryInput;
  where: WorkerServiceWhereUniqueInput;
};

export type WorkerServiceCreateOrConnectWithoutServiceInput = {
  create: WorkerServiceCreateWithoutServiceInput;
  where: WorkerServiceWhereUniqueInput;
};

export type WorkerServiceCreateOrConnectWithoutTranslationsInput = {
  create: WorkerServiceCreateWithoutTranslationsInput;
  where: WorkerServiceWhereUniqueInput;
};

export type WorkerServiceCreateOrConnectWithoutWorkerAvailabilitiesInput = {
  create: WorkerServiceCreateWithoutWorkerAvailabilitiesInput;
  where: WorkerServiceWhereUniqueInput;
};

export type WorkerServiceCreateOrConnectWithoutWorkerInput = {
  create: WorkerServiceCreateWithoutWorkerInput;
  where: WorkerServiceWhereUniqueInput;
};

export type WorkerServiceCreateWithoutBookingsInput = {
  animalSize?: InputMaybe<AnimalSizeEnum>;
  animalType?: InputMaybe<AnimalTypeEnum>;
  bookable?: InputMaybe<Scalars['Boolean']['input']>;
  category: CategoryCreateNestedOneWithoutWorkerServicesInput;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  isProSpecialist?: InputMaybe<Scalars['Boolean']['input']>;
  maximumDuration?: InputMaybe<Scalars['Int']['input']>;
  minimumDuration?: InputMaybe<Scalars['Int']['input']>;
  multiAnimalsBookingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  multiAnimalsDuration?: InputMaybe<Scalars['Int']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  priceFrom?: InputMaybe<Scalars['Float']['input']>;
  priceTo?: InputMaybe<Scalars['Float']['input']>;
  priceType?: InputMaybe<WorkerServicePriceType>;
  service: ServiceCreateNestedOneWithoutWorkerServicesInput;
  translations?: InputMaybe<WorkerServiceTranslationCreateNestedManyWithoutWorkerServiceInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  worker: WorkerCreateNestedOneWithoutServicesInput;
  workerAvailabilities?: InputMaybe<WorkerAvailabilityCreateNestedManyWithoutWorkerServiceInput>;
};

export type WorkerServiceCreateWithoutCategoryInput = {
  animalSize?: InputMaybe<AnimalSizeEnum>;
  animalType?: InputMaybe<AnimalTypeEnum>;
  bookable?: InputMaybe<Scalars['Boolean']['input']>;
  bookings?: InputMaybe<BookingCreateNestedManyWithoutWorkerServiceInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  isProSpecialist?: InputMaybe<Scalars['Boolean']['input']>;
  maximumDuration?: InputMaybe<Scalars['Int']['input']>;
  minimumDuration?: InputMaybe<Scalars['Int']['input']>;
  multiAnimalsBookingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  multiAnimalsDuration?: InputMaybe<Scalars['Int']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  priceFrom?: InputMaybe<Scalars['Float']['input']>;
  priceTo?: InputMaybe<Scalars['Float']['input']>;
  priceType?: InputMaybe<WorkerServicePriceType>;
  service: ServiceCreateNestedOneWithoutWorkerServicesInput;
  translations?: InputMaybe<WorkerServiceTranslationCreateNestedManyWithoutWorkerServiceInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  worker: WorkerCreateNestedOneWithoutServicesInput;
  workerAvailabilities?: InputMaybe<WorkerAvailabilityCreateNestedManyWithoutWorkerServiceInput>;
};

export type WorkerServiceCreateWithoutServiceInput = {
  animalSize?: InputMaybe<AnimalSizeEnum>;
  animalType?: InputMaybe<AnimalTypeEnum>;
  bookable?: InputMaybe<Scalars['Boolean']['input']>;
  bookings?: InputMaybe<BookingCreateNestedManyWithoutWorkerServiceInput>;
  category: CategoryCreateNestedOneWithoutWorkerServicesInput;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  isProSpecialist?: InputMaybe<Scalars['Boolean']['input']>;
  maximumDuration?: InputMaybe<Scalars['Int']['input']>;
  minimumDuration?: InputMaybe<Scalars['Int']['input']>;
  multiAnimalsBookingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  multiAnimalsDuration?: InputMaybe<Scalars['Int']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  priceFrom?: InputMaybe<Scalars['Float']['input']>;
  priceTo?: InputMaybe<Scalars['Float']['input']>;
  priceType?: InputMaybe<WorkerServicePriceType>;
  translations?: InputMaybe<WorkerServiceTranslationCreateNestedManyWithoutWorkerServiceInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  worker: WorkerCreateNestedOneWithoutServicesInput;
  workerAvailabilities?: InputMaybe<WorkerAvailabilityCreateNestedManyWithoutWorkerServiceInput>;
};

export type WorkerServiceCreateWithoutTranslationsInput = {
  animalSize?: InputMaybe<AnimalSizeEnum>;
  animalType?: InputMaybe<AnimalTypeEnum>;
  bookable?: InputMaybe<Scalars['Boolean']['input']>;
  bookings?: InputMaybe<BookingCreateNestedManyWithoutWorkerServiceInput>;
  category: CategoryCreateNestedOneWithoutWorkerServicesInput;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  isProSpecialist?: InputMaybe<Scalars['Boolean']['input']>;
  maximumDuration?: InputMaybe<Scalars['Int']['input']>;
  minimumDuration?: InputMaybe<Scalars['Int']['input']>;
  multiAnimalsBookingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  multiAnimalsDuration?: InputMaybe<Scalars['Int']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  priceFrom?: InputMaybe<Scalars['Float']['input']>;
  priceTo?: InputMaybe<Scalars['Float']['input']>;
  priceType?: InputMaybe<WorkerServicePriceType>;
  service: ServiceCreateNestedOneWithoutWorkerServicesInput;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  worker: WorkerCreateNestedOneWithoutServicesInput;
  workerAvailabilities?: InputMaybe<WorkerAvailabilityCreateNestedManyWithoutWorkerServiceInput>;
};

export type WorkerServiceCreateWithoutWorkerAvailabilitiesInput = {
  animalSize?: InputMaybe<AnimalSizeEnum>;
  animalType?: InputMaybe<AnimalTypeEnum>;
  bookable?: InputMaybe<Scalars['Boolean']['input']>;
  bookings?: InputMaybe<BookingCreateNestedManyWithoutWorkerServiceInput>;
  category: CategoryCreateNestedOneWithoutWorkerServicesInput;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  isProSpecialist?: InputMaybe<Scalars['Boolean']['input']>;
  maximumDuration?: InputMaybe<Scalars['Int']['input']>;
  minimumDuration?: InputMaybe<Scalars['Int']['input']>;
  multiAnimalsBookingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  multiAnimalsDuration?: InputMaybe<Scalars['Int']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  priceFrom?: InputMaybe<Scalars['Float']['input']>;
  priceTo?: InputMaybe<Scalars['Float']['input']>;
  priceType?: InputMaybe<WorkerServicePriceType>;
  service: ServiceCreateNestedOneWithoutWorkerServicesInput;
  translations?: InputMaybe<WorkerServiceTranslationCreateNestedManyWithoutWorkerServiceInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  worker: WorkerCreateNestedOneWithoutServicesInput;
};

export type WorkerServiceCreateWithoutWorkerInput = {
  animalSize?: InputMaybe<AnimalSizeEnum>;
  animalType?: InputMaybe<AnimalTypeEnum>;
  bookable?: InputMaybe<Scalars['Boolean']['input']>;
  bookings?: InputMaybe<BookingCreateNestedManyWithoutWorkerServiceInput>;
  category: CategoryCreateNestedOneWithoutWorkerServicesInput;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  isProSpecialist?: InputMaybe<Scalars['Boolean']['input']>;
  maximumDuration?: InputMaybe<Scalars['Int']['input']>;
  minimumDuration?: InputMaybe<Scalars['Int']['input']>;
  multiAnimalsBookingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  multiAnimalsDuration?: InputMaybe<Scalars['Int']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  priceFrom?: InputMaybe<Scalars['Float']['input']>;
  priceTo?: InputMaybe<Scalars['Float']['input']>;
  priceType?: InputMaybe<WorkerServicePriceType>;
  service: ServiceCreateNestedOneWithoutWorkerServicesInput;
  translations?: InputMaybe<WorkerServiceTranslationCreateNestedManyWithoutWorkerServiceInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  workerAvailabilities?: InputMaybe<WorkerAvailabilityCreateNestedManyWithoutWorkerServiceInput>;
};

export type WorkerServiceListRelationFilter = {
  every?: InputMaybe<WorkerServiceWhereInput>;
  none?: InputMaybe<WorkerServiceWhereInput>;
  some?: InputMaybe<WorkerServiceWhereInput>;
};

export type WorkerServiceMaxAggregateOutputType = {
  __typename?: 'WorkerServiceMaxAggregateOutputType';
  animalSize?: Maybe<AnimalSizeEnum>;
  animalType?: Maybe<AnimalTypeEnum>;
  bookable?: Maybe<Scalars['Boolean']['output']>;
  categoryId?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isProSpecialist?: Maybe<Scalars['Boolean']['output']>;
  maximumDuration?: Maybe<Scalars['Int']['output']>;
  minimumDuration?: Maybe<Scalars['Int']['output']>;
  multiAnimalsBookingEnabled?: Maybe<Scalars['Boolean']['output']>;
  multiAnimalsDuration?: Maybe<Scalars['Int']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  priceFrom?: Maybe<Scalars['Float']['output']>;
  priceTo?: Maybe<Scalars['Float']['output']>;
  priceType?: Maybe<WorkerServicePriceType>;
  serviceId?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  workerId?: Maybe<Scalars['Int']['output']>;
};

export type WorkerServiceMaxOrderByAggregateInput = {
  animalSize?: InputMaybe<SortOrder>;
  animalType?: InputMaybe<SortOrder>;
  bookable?: InputMaybe<SortOrder>;
  categoryId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  enabled?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isProSpecialist?: InputMaybe<SortOrder>;
  maximumDuration?: InputMaybe<SortOrder>;
  minimumDuration?: InputMaybe<SortOrder>;
  multiAnimalsBookingEnabled?: InputMaybe<SortOrder>;
  multiAnimalsDuration?: InputMaybe<SortOrder>;
  price?: InputMaybe<SortOrder>;
  priceFrom?: InputMaybe<SortOrder>;
  priceTo?: InputMaybe<SortOrder>;
  priceType?: InputMaybe<SortOrder>;
  serviceId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  workerId?: InputMaybe<SortOrder>;
};

export type WorkerServiceMinAggregateOutputType = {
  __typename?: 'WorkerServiceMinAggregateOutputType';
  animalSize?: Maybe<AnimalSizeEnum>;
  animalType?: Maybe<AnimalTypeEnum>;
  bookable?: Maybe<Scalars['Boolean']['output']>;
  categoryId?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isProSpecialist?: Maybe<Scalars['Boolean']['output']>;
  maximumDuration?: Maybe<Scalars['Int']['output']>;
  minimumDuration?: Maybe<Scalars['Int']['output']>;
  multiAnimalsBookingEnabled?: Maybe<Scalars['Boolean']['output']>;
  multiAnimalsDuration?: Maybe<Scalars['Int']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  priceFrom?: Maybe<Scalars['Float']['output']>;
  priceTo?: Maybe<Scalars['Float']['output']>;
  priceType?: Maybe<WorkerServicePriceType>;
  serviceId?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  workerId?: Maybe<Scalars['Int']['output']>;
};

export type WorkerServiceMinOrderByAggregateInput = {
  animalSize?: InputMaybe<SortOrder>;
  animalType?: InputMaybe<SortOrder>;
  bookable?: InputMaybe<SortOrder>;
  categoryId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  enabled?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isProSpecialist?: InputMaybe<SortOrder>;
  maximumDuration?: InputMaybe<SortOrder>;
  minimumDuration?: InputMaybe<SortOrder>;
  multiAnimalsBookingEnabled?: InputMaybe<SortOrder>;
  multiAnimalsDuration?: InputMaybe<SortOrder>;
  price?: InputMaybe<SortOrder>;
  priceFrom?: InputMaybe<SortOrder>;
  priceTo?: InputMaybe<SortOrder>;
  priceType?: InputMaybe<SortOrder>;
  serviceId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  workerId?: InputMaybe<SortOrder>;
};

export type WorkerServiceNullableRelationFilter = {
  is?: InputMaybe<WorkerServiceWhereInput>;
  isNot?: InputMaybe<WorkerServiceWhereInput>;
};

export type WorkerServiceOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type WorkerServiceOrderByWithAggregationInput = {
  _avg?: InputMaybe<WorkerServiceAvgOrderByAggregateInput>;
  _count?: InputMaybe<WorkerServiceCountOrderByAggregateInput>;
  _max?: InputMaybe<WorkerServiceMaxOrderByAggregateInput>;
  _min?: InputMaybe<WorkerServiceMinOrderByAggregateInput>;
  _sum?: InputMaybe<WorkerServiceSumOrderByAggregateInput>;
  animalSize?: InputMaybe<SortOrderInput>;
  animalType?: InputMaybe<SortOrderInput>;
  bookable?: InputMaybe<SortOrder>;
  categoryId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  enabled?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isProSpecialist?: InputMaybe<SortOrder>;
  maximumDuration?: InputMaybe<SortOrderInput>;
  minimumDuration?: InputMaybe<SortOrderInput>;
  multiAnimalsBookingEnabled?: InputMaybe<SortOrder>;
  multiAnimalsDuration?: InputMaybe<SortOrderInput>;
  price?: InputMaybe<SortOrderInput>;
  priceFrom?: InputMaybe<SortOrderInput>;
  priceTo?: InputMaybe<SortOrderInput>;
  priceType?: InputMaybe<SortOrderInput>;
  serviceId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  workerId?: InputMaybe<SortOrder>;
};

export type WorkerServiceOrderByWithRelationAndSearchRelevanceInput = {
  animalSize?: InputMaybe<SortOrderInput>;
  animalType?: InputMaybe<SortOrderInput>;
  bookable?: InputMaybe<SortOrder>;
  bookings?: InputMaybe<BookingOrderByRelationAggregateInput>;
  category?: InputMaybe<CategoryOrderByWithRelationAndSearchRelevanceInput>;
  categoryId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  enabled?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isProSpecialist?: InputMaybe<SortOrder>;
  maximumDuration?: InputMaybe<SortOrderInput>;
  minimumDuration?: InputMaybe<SortOrderInput>;
  multiAnimalsBookingEnabled?: InputMaybe<SortOrder>;
  multiAnimalsDuration?: InputMaybe<SortOrderInput>;
  price?: InputMaybe<SortOrderInput>;
  priceFrom?: InputMaybe<SortOrderInput>;
  priceTo?: InputMaybe<SortOrderInput>;
  priceType?: InputMaybe<SortOrderInput>;
  service?: InputMaybe<ServiceOrderByWithRelationAndSearchRelevanceInput>;
  serviceId?: InputMaybe<SortOrder>;
  translations?: InputMaybe<WorkerServiceTranslationOrderByRelationAggregateInput>;
  updatedAt?: InputMaybe<SortOrder>;
  worker?: InputMaybe<WorkerOrderByWithRelationAndSearchRelevanceInput>;
  workerAvailabilities?: InputMaybe<WorkerAvailabilityOrderByRelationAggregateInput>;
  workerId?: InputMaybe<SortOrder>;
};

export enum WorkerServicePriceType {
  FIXED = 'FIXED',
  HOURLY = 'HOURLY',
  RANGE = 'RANGE'
}

export type WorkerServiceRelationFilter = {
  is?: InputMaybe<WorkerServiceWhereInput>;
  isNot?: InputMaybe<WorkerServiceWhereInput>;
};

export enum WorkerServiceScalarFieldEnum {
  animalSize = 'animalSize',
  animalType = 'animalType',
  bookable = 'bookable',
  categoryId = 'categoryId',
  createdAt = 'createdAt',
  enabled = 'enabled',
  id = 'id',
  isProSpecialist = 'isProSpecialist',
  maximumDuration = 'maximumDuration',
  minimumDuration = 'minimumDuration',
  multiAnimalsBookingEnabled = 'multiAnimalsBookingEnabled',
  multiAnimalsDuration = 'multiAnimalsDuration',
  price = 'price',
  priceFrom = 'priceFrom',
  priceTo = 'priceTo',
  priceType = 'priceType',
  serviceId = 'serviceId',
  updatedAt = 'updatedAt',
  workerId = 'workerId'
}

export type WorkerServiceScalarWhereInput = {
  AND?: InputMaybe<Array<WorkerServiceScalarWhereInput>>;
  NOT?: InputMaybe<Array<WorkerServiceScalarWhereInput>>;
  OR?: InputMaybe<Array<WorkerServiceScalarWhereInput>>;
  animalSize?: InputMaybe<EnumAnimalSizeEnumNullableFilter>;
  animalType?: InputMaybe<EnumAnimalTypeEnumNullableFilter>;
  bookable?: InputMaybe<BoolFilter>;
  categoryId?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  enabled?: InputMaybe<BoolFilter>;
  id?: InputMaybe<IntFilter>;
  isProSpecialist?: InputMaybe<BoolFilter>;
  maximumDuration?: InputMaybe<IntNullableFilter>;
  minimumDuration?: InputMaybe<IntNullableFilter>;
  multiAnimalsBookingEnabled?: InputMaybe<BoolFilter>;
  multiAnimalsDuration?: InputMaybe<IntNullableFilter>;
  price?: InputMaybe<FloatNullableFilter>;
  priceFrom?: InputMaybe<FloatNullableFilter>;
  priceTo?: InputMaybe<FloatNullableFilter>;
  priceType?: InputMaybe<EnumWorkerServicePriceTypeNullableFilter>;
  serviceId?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  workerId?: InputMaybe<IntFilter>;
};

export type WorkerServiceScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<WorkerServiceScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<WorkerServiceScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<WorkerServiceScalarWhereWithAggregatesInput>>;
  animalSize?: InputMaybe<EnumAnimalSizeEnumNullableWithAggregatesFilter>;
  animalType?: InputMaybe<EnumAnimalTypeEnumNullableWithAggregatesFilter>;
  bookable?: InputMaybe<BoolWithAggregatesFilter>;
  categoryId?: InputMaybe<IntWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  enabled?: InputMaybe<BoolWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  isProSpecialist?: InputMaybe<BoolWithAggregatesFilter>;
  maximumDuration?: InputMaybe<IntNullableWithAggregatesFilter>;
  minimumDuration?: InputMaybe<IntNullableWithAggregatesFilter>;
  multiAnimalsBookingEnabled?: InputMaybe<BoolWithAggregatesFilter>;
  multiAnimalsDuration?: InputMaybe<IntNullableWithAggregatesFilter>;
  price?: InputMaybe<FloatNullableWithAggregatesFilter>;
  priceFrom?: InputMaybe<FloatNullableWithAggregatesFilter>;
  priceTo?: InputMaybe<FloatNullableWithAggregatesFilter>;
  priceType?: InputMaybe<EnumWorkerServicePriceTypeNullableWithAggregatesFilter>;
  serviceId?: InputMaybe<IntWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  workerId?: InputMaybe<IntWithAggregatesFilter>;
};

export type WorkerServiceSumAggregateOutputType = {
  __typename?: 'WorkerServiceSumAggregateOutputType';
  categoryId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  maximumDuration?: Maybe<Scalars['Int']['output']>;
  minimumDuration?: Maybe<Scalars['Int']['output']>;
  multiAnimalsDuration?: Maybe<Scalars['Int']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  priceFrom?: Maybe<Scalars['Float']['output']>;
  priceTo?: Maybe<Scalars['Float']['output']>;
  serviceId?: Maybe<Scalars['Int']['output']>;
  workerId?: Maybe<Scalars['Int']['output']>;
};

export type WorkerServiceSumOrderByAggregateInput = {
  categoryId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  maximumDuration?: InputMaybe<SortOrder>;
  minimumDuration?: InputMaybe<SortOrder>;
  multiAnimalsDuration?: InputMaybe<SortOrder>;
  price?: InputMaybe<SortOrder>;
  priceFrom?: InputMaybe<SortOrder>;
  priceTo?: InputMaybe<SortOrder>;
  serviceId?: InputMaybe<SortOrder>;
  workerId?: InputMaybe<SortOrder>;
};

export type WorkerServiceTranslation = {
  __typename?: 'WorkerServiceTranslation';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  language: Scalars['String']['output'];
  preBookingWarning?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  workerService: WorkerService;
  workerServiceId: Scalars['Int']['output'];
};

export type WorkerServiceTranslationAvgAggregateOutputType = {
  __typename?: 'WorkerServiceTranslationAvgAggregateOutputType';
  id?: Maybe<Scalars['Float']['output']>;
  workerServiceId?: Maybe<Scalars['Float']['output']>;
};

export type WorkerServiceTranslationAvgOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
  workerServiceId?: InputMaybe<SortOrder>;
};

export type WorkerServiceTranslationCountAggregateOutputType = {
  __typename?: 'WorkerServiceTranslationCountAggregateOutputType';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  language: Scalars['Int']['output'];
  preBookingWarning: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
  workerServiceId: Scalars['Int']['output'];
};

export type WorkerServiceTranslationCountOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  language?: InputMaybe<SortOrder>;
  preBookingWarning?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  workerServiceId?: InputMaybe<SortOrder>;
};

export type WorkerServiceTranslationCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  language: Scalars['String']['input'];
  preBookingWarning?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  workerService: WorkerServiceCreateNestedOneWithoutTranslationsInput;
};

export type WorkerServiceTranslationCreateManyInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  language: Scalars['String']['input'];
  preBookingWarning?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  workerServiceId: Scalars['Int']['input'];
};

export type WorkerServiceTranslationCreateManyWorkerServiceInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  language: Scalars['String']['input'];
  preBookingWarning?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type WorkerServiceTranslationCreateManyWorkerServiceInputEnvelope = {
  data: Array<WorkerServiceTranslationCreateManyWorkerServiceInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WorkerServiceTranslationCreateNestedManyWithoutWorkerServiceInput = {
  connect?: InputMaybe<Array<WorkerServiceTranslationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<WorkerServiceTranslationCreateOrConnectWithoutWorkerServiceInput>>;
  create?: InputMaybe<Array<WorkerServiceTranslationCreateWithoutWorkerServiceInput>>;
  createMany?: InputMaybe<WorkerServiceTranslationCreateManyWorkerServiceInputEnvelope>;
};

export type WorkerServiceTranslationCreateOrConnectWithoutWorkerServiceInput = {
  create: WorkerServiceTranslationCreateWithoutWorkerServiceInput;
  where: WorkerServiceTranslationWhereUniqueInput;
};

export type WorkerServiceTranslationCreateWithoutWorkerServiceInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  language: Scalars['String']['input'];
  preBookingWarning?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type WorkerServiceTranslationListRelationFilter = {
  every?: InputMaybe<WorkerServiceTranslationWhereInput>;
  none?: InputMaybe<WorkerServiceTranslationWhereInput>;
  some?: InputMaybe<WorkerServiceTranslationWhereInput>;
};

export type WorkerServiceTranslationMaxAggregateOutputType = {
  __typename?: 'WorkerServiceTranslationMaxAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  preBookingWarning?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  workerServiceId?: Maybe<Scalars['Int']['output']>;
};

export type WorkerServiceTranslationMaxOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  language?: InputMaybe<SortOrder>;
  preBookingWarning?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  workerServiceId?: InputMaybe<SortOrder>;
};

export type WorkerServiceTranslationMinAggregateOutputType = {
  __typename?: 'WorkerServiceTranslationMinAggregateOutputType';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  preBookingWarning?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  workerServiceId?: Maybe<Scalars['Int']['output']>;
};

export type WorkerServiceTranslationMinOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  language?: InputMaybe<SortOrder>;
  preBookingWarning?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  workerServiceId?: InputMaybe<SortOrder>;
};

export type WorkerServiceTranslationOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export enum WorkerServiceTranslationOrderByRelevanceFieldEnum {
  language = 'language',
  preBookingWarning = 'preBookingWarning'
}

export type WorkerServiceTranslationOrderByRelevanceInput = {
  fields: Array<WorkerServiceTranslationOrderByRelevanceFieldEnum>;
  search: Scalars['String']['input'];
  sort: SortOrder;
};

export type WorkerServiceTranslationOrderByWithAggregationInput = {
  _avg?: InputMaybe<WorkerServiceTranslationAvgOrderByAggregateInput>;
  _count?: InputMaybe<WorkerServiceTranslationCountOrderByAggregateInput>;
  _max?: InputMaybe<WorkerServiceTranslationMaxOrderByAggregateInput>;
  _min?: InputMaybe<WorkerServiceTranslationMinOrderByAggregateInput>;
  _sum?: InputMaybe<WorkerServiceTranslationSumOrderByAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  language?: InputMaybe<SortOrder>;
  preBookingWarning?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
  workerServiceId?: InputMaybe<SortOrder>;
};

export type WorkerServiceTranslationOrderByWithRelationAndSearchRelevanceInput = {
  _relevance?: InputMaybe<WorkerServiceTranslationOrderByRelevanceInput>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  language?: InputMaybe<SortOrder>;
  preBookingWarning?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
  workerService?: InputMaybe<WorkerServiceOrderByWithRelationAndSearchRelevanceInput>;
  workerServiceId?: InputMaybe<SortOrder>;
};

export enum WorkerServiceTranslationScalarFieldEnum {
  createdAt = 'createdAt',
  id = 'id',
  language = 'language',
  preBookingWarning = 'preBookingWarning',
  updatedAt = 'updatedAt',
  workerServiceId = 'workerServiceId'
}

export type WorkerServiceTranslationScalarWhereInput = {
  AND?: InputMaybe<Array<WorkerServiceTranslationScalarWhereInput>>;
  NOT?: InputMaybe<Array<WorkerServiceTranslationScalarWhereInput>>;
  OR?: InputMaybe<Array<WorkerServiceTranslationScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntFilter>;
  language?: InputMaybe<StringFilter>;
  preBookingWarning?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  workerServiceId?: InputMaybe<IntFilter>;
};

export type WorkerServiceTranslationScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<WorkerServiceTranslationScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<WorkerServiceTranslationScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<WorkerServiceTranslationScalarWhereWithAggregatesInput>>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  language?: InputMaybe<StringWithAggregatesFilter>;
  preBookingWarning?: InputMaybe<StringNullableWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  workerServiceId?: InputMaybe<IntWithAggregatesFilter>;
};

export type WorkerServiceTranslationSumAggregateOutputType = {
  __typename?: 'WorkerServiceTranslationSumAggregateOutputType';
  id?: Maybe<Scalars['Int']['output']>;
  workerServiceId?: Maybe<Scalars['Int']['output']>;
};

export type WorkerServiceTranslationSumOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
  workerServiceId?: InputMaybe<SortOrder>;
};

export type WorkerServiceTranslationUncheckedCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  language: Scalars['String']['input'];
  preBookingWarning?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  workerServiceId: Scalars['Int']['input'];
};

export type WorkerServiceTranslationUncheckedCreateNestedManyWithoutWorkerServiceInput = {
  connect?: InputMaybe<Array<WorkerServiceTranslationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<WorkerServiceTranslationCreateOrConnectWithoutWorkerServiceInput>>;
  create?: InputMaybe<Array<WorkerServiceTranslationCreateWithoutWorkerServiceInput>>;
  createMany?: InputMaybe<WorkerServiceTranslationCreateManyWorkerServiceInputEnvelope>;
};

export type WorkerServiceTranslationUncheckedCreateWithoutWorkerServiceInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  language: Scalars['String']['input'];
  preBookingWarning?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type WorkerServiceTranslationUncheckedUpdateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  preBookingWarning?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  workerServiceId?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type WorkerServiceTranslationUncheckedUpdateManyInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  preBookingWarning?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  workerServiceId?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type WorkerServiceTranslationUncheckedUpdateManyWithoutWorkerServiceInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  preBookingWarning?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type WorkerServiceTranslationUncheckedUpdateManyWithoutWorkerServiceNestedInput = {
  connect?: InputMaybe<Array<WorkerServiceTranslationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<WorkerServiceTranslationCreateOrConnectWithoutWorkerServiceInput>>;
  create?: InputMaybe<Array<WorkerServiceTranslationCreateWithoutWorkerServiceInput>>;
  createMany?: InputMaybe<WorkerServiceTranslationCreateManyWorkerServiceInputEnvelope>;
  delete?: InputMaybe<Array<WorkerServiceTranslationWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<WorkerServiceTranslationScalarWhereInput>>;
  disconnect?: InputMaybe<Array<WorkerServiceTranslationWhereUniqueInput>>;
  set?: InputMaybe<Array<WorkerServiceTranslationWhereUniqueInput>>;
  update?: InputMaybe<Array<WorkerServiceTranslationUpdateWithWhereUniqueWithoutWorkerServiceInput>>;
  updateMany?: InputMaybe<Array<WorkerServiceTranslationUpdateManyWithWhereWithoutWorkerServiceInput>>;
  upsert?: InputMaybe<Array<WorkerServiceTranslationUpsertWithWhereUniqueWithoutWorkerServiceInput>>;
};

export type WorkerServiceTranslationUncheckedUpdateWithoutWorkerServiceInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  preBookingWarning?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type WorkerServiceTranslationUpdateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  preBookingWarning?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  workerService?: InputMaybe<WorkerServiceUpdateOneRequiredWithoutTranslationsNestedInput>;
};

export type WorkerServiceTranslationUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  preBookingWarning?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type WorkerServiceTranslationUpdateManyWithWhereWithoutWorkerServiceInput = {
  data: WorkerServiceTranslationUpdateManyMutationInput;
  where: WorkerServiceTranslationScalarWhereInput;
};

export type WorkerServiceTranslationUpdateManyWithoutWorkerServiceNestedInput = {
  connect?: InputMaybe<Array<WorkerServiceTranslationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<WorkerServiceTranslationCreateOrConnectWithoutWorkerServiceInput>>;
  create?: InputMaybe<Array<WorkerServiceTranslationCreateWithoutWorkerServiceInput>>;
  createMany?: InputMaybe<WorkerServiceTranslationCreateManyWorkerServiceInputEnvelope>;
  delete?: InputMaybe<Array<WorkerServiceTranslationWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<WorkerServiceTranslationScalarWhereInput>>;
  disconnect?: InputMaybe<Array<WorkerServiceTranslationWhereUniqueInput>>;
  set?: InputMaybe<Array<WorkerServiceTranslationWhereUniqueInput>>;
  update?: InputMaybe<Array<WorkerServiceTranslationUpdateWithWhereUniqueWithoutWorkerServiceInput>>;
  updateMany?: InputMaybe<Array<WorkerServiceTranslationUpdateManyWithWhereWithoutWorkerServiceInput>>;
  upsert?: InputMaybe<Array<WorkerServiceTranslationUpsertWithWhereUniqueWithoutWorkerServiceInput>>;
};

export type WorkerServiceTranslationUpdateWithWhereUniqueWithoutWorkerServiceInput = {
  data: WorkerServiceTranslationUpdateWithoutWorkerServiceInput;
  where: WorkerServiceTranslationWhereUniqueInput;
};

export type WorkerServiceTranslationUpdateWithoutWorkerServiceInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  language?: InputMaybe<StringFieldUpdateOperationsInput>;
  preBookingWarning?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type WorkerServiceTranslationUpsertWithWhereUniqueWithoutWorkerServiceInput = {
  create: WorkerServiceTranslationCreateWithoutWorkerServiceInput;
  update: WorkerServiceTranslationUpdateWithoutWorkerServiceInput;
  where: WorkerServiceTranslationWhereUniqueInput;
};

export type WorkerServiceTranslationWhereInput = {
  AND?: InputMaybe<Array<WorkerServiceTranslationWhereInput>>;
  NOT?: InputMaybe<Array<WorkerServiceTranslationWhereInput>>;
  OR?: InputMaybe<Array<WorkerServiceTranslationWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntFilter>;
  language?: InputMaybe<StringFilter>;
  preBookingWarning?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  workerService?: InputMaybe<WorkerServiceRelationFilter>;
  workerServiceId?: InputMaybe<IntFilter>;
};

export type WorkerServiceTranslationWhereUniqueInput = {
  AND?: InputMaybe<Array<WorkerServiceTranslationWhereInput>>;
  NOT?: InputMaybe<Array<WorkerServiceTranslationWhereInput>>;
  OR?: InputMaybe<Array<WorkerServiceTranslationWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  language?: InputMaybe<StringFilter>;
  preBookingWarning?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  workerService?: InputMaybe<WorkerServiceRelationFilter>;
  workerServiceId?: InputMaybe<IntFilter>;
};

export type WorkerServiceUncheckedCreateInput = {
  animalSize?: InputMaybe<AnimalSizeEnum>;
  animalType?: InputMaybe<AnimalTypeEnum>;
  bookable?: InputMaybe<Scalars['Boolean']['input']>;
  bookings?: InputMaybe<BookingUncheckedCreateNestedManyWithoutWorkerServiceInput>;
  categoryId: Scalars['Int']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isProSpecialist?: InputMaybe<Scalars['Boolean']['input']>;
  maximumDuration?: InputMaybe<Scalars['Int']['input']>;
  minimumDuration?: InputMaybe<Scalars['Int']['input']>;
  multiAnimalsBookingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  multiAnimalsDuration?: InputMaybe<Scalars['Int']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  priceFrom?: InputMaybe<Scalars['Float']['input']>;
  priceTo?: InputMaybe<Scalars['Float']['input']>;
  priceType?: InputMaybe<WorkerServicePriceType>;
  serviceId: Scalars['Int']['input'];
  translations?: InputMaybe<WorkerServiceTranslationUncheckedCreateNestedManyWithoutWorkerServiceInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  workerAvailabilities?: InputMaybe<WorkerAvailabilityUncheckedCreateNestedManyWithoutWorkerServiceInput>;
  workerId: Scalars['Int']['input'];
};

export type WorkerServiceUncheckedCreateNestedManyWithoutCategoryInput = {
  connect?: InputMaybe<Array<WorkerServiceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<WorkerServiceCreateOrConnectWithoutCategoryInput>>;
  create?: InputMaybe<Array<WorkerServiceCreateWithoutCategoryInput>>;
  createMany?: InputMaybe<WorkerServiceCreateManyCategoryInputEnvelope>;
};

export type WorkerServiceUncheckedCreateNestedManyWithoutServiceInput = {
  connect?: InputMaybe<Array<WorkerServiceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<WorkerServiceCreateOrConnectWithoutServiceInput>>;
  create?: InputMaybe<Array<WorkerServiceCreateWithoutServiceInput>>;
  createMany?: InputMaybe<WorkerServiceCreateManyServiceInputEnvelope>;
};

export type WorkerServiceUncheckedCreateNestedManyWithoutWorkerInput = {
  connect?: InputMaybe<Array<WorkerServiceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<WorkerServiceCreateOrConnectWithoutWorkerInput>>;
  create?: InputMaybe<Array<WorkerServiceCreateWithoutWorkerInput>>;
  createMany?: InputMaybe<WorkerServiceCreateManyWorkerInputEnvelope>;
};

export type WorkerServiceUncheckedCreateWithoutBookingsInput = {
  animalSize?: InputMaybe<AnimalSizeEnum>;
  animalType?: InputMaybe<AnimalTypeEnum>;
  bookable?: InputMaybe<Scalars['Boolean']['input']>;
  categoryId: Scalars['Int']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isProSpecialist?: InputMaybe<Scalars['Boolean']['input']>;
  maximumDuration?: InputMaybe<Scalars['Int']['input']>;
  minimumDuration?: InputMaybe<Scalars['Int']['input']>;
  multiAnimalsBookingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  multiAnimalsDuration?: InputMaybe<Scalars['Int']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  priceFrom?: InputMaybe<Scalars['Float']['input']>;
  priceTo?: InputMaybe<Scalars['Float']['input']>;
  priceType?: InputMaybe<WorkerServicePriceType>;
  serviceId: Scalars['Int']['input'];
  translations?: InputMaybe<WorkerServiceTranslationUncheckedCreateNestedManyWithoutWorkerServiceInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  workerAvailabilities?: InputMaybe<WorkerAvailabilityUncheckedCreateNestedManyWithoutWorkerServiceInput>;
  workerId: Scalars['Int']['input'];
};

export type WorkerServiceUncheckedCreateWithoutCategoryInput = {
  animalSize?: InputMaybe<AnimalSizeEnum>;
  animalType?: InputMaybe<AnimalTypeEnum>;
  bookable?: InputMaybe<Scalars['Boolean']['input']>;
  bookings?: InputMaybe<BookingUncheckedCreateNestedManyWithoutWorkerServiceInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isProSpecialist?: InputMaybe<Scalars['Boolean']['input']>;
  maximumDuration?: InputMaybe<Scalars['Int']['input']>;
  minimumDuration?: InputMaybe<Scalars['Int']['input']>;
  multiAnimalsBookingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  multiAnimalsDuration?: InputMaybe<Scalars['Int']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  priceFrom?: InputMaybe<Scalars['Float']['input']>;
  priceTo?: InputMaybe<Scalars['Float']['input']>;
  priceType?: InputMaybe<WorkerServicePriceType>;
  serviceId: Scalars['Int']['input'];
  translations?: InputMaybe<WorkerServiceTranslationUncheckedCreateNestedManyWithoutWorkerServiceInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  workerAvailabilities?: InputMaybe<WorkerAvailabilityUncheckedCreateNestedManyWithoutWorkerServiceInput>;
  workerId: Scalars['Int']['input'];
};

export type WorkerServiceUncheckedCreateWithoutServiceInput = {
  animalSize?: InputMaybe<AnimalSizeEnum>;
  animalType?: InputMaybe<AnimalTypeEnum>;
  bookable?: InputMaybe<Scalars['Boolean']['input']>;
  bookings?: InputMaybe<BookingUncheckedCreateNestedManyWithoutWorkerServiceInput>;
  categoryId: Scalars['Int']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isProSpecialist?: InputMaybe<Scalars['Boolean']['input']>;
  maximumDuration?: InputMaybe<Scalars['Int']['input']>;
  minimumDuration?: InputMaybe<Scalars['Int']['input']>;
  multiAnimalsBookingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  multiAnimalsDuration?: InputMaybe<Scalars['Int']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  priceFrom?: InputMaybe<Scalars['Float']['input']>;
  priceTo?: InputMaybe<Scalars['Float']['input']>;
  priceType?: InputMaybe<WorkerServicePriceType>;
  translations?: InputMaybe<WorkerServiceTranslationUncheckedCreateNestedManyWithoutWorkerServiceInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  workerAvailabilities?: InputMaybe<WorkerAvailabilityUncheckedCreateNestedManyWithoutWorkerServiceInput>;
  workerId: Scalars['Int']['input'];
};

export type WorkerServiceUncheckedCreateWithoutTranslationsInput = {
  animalSize?: InputMaybe<AnimalSizeEnum>;
  animalType?: InputMaybe<AnimalTypeEnum>;
  bookable?: InputMaybe<Scalars['Boolean']['input']>;
  bookings?: InputMaybe<BookingUncheckedCreateNestedManyWithoutWorkerServiceInput>;
  categoryId: Scalars['Int']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isProSpecialist?: InputMaybe<Scalars['Boolean']['input']>;
  maximumDuration?: InputMaybe<Scalars['Int']['input']>;
  minimumDuration?: InputMaybe<Scalars['Int']['input']>;
  multiAnimalsBookingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  multiAnimalsDuration?: InputMaybe<Scalars['Int']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  priceFrom?: InputMaybe<Scalars['Float']['input']>;
  priceTo?: InputMaybe<Scalars['Float']['input']>;
  priceType?: InputMaybe<WorkerServicePriceType>;
  serviceId: Scalars['Int']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  workerAvailabilities?: InputMaybe<WorkerAvailabilityUncheckedCreateNestedManyWithoutWorkerServiceInput>;
  workerId: Scalars['Int']['input'];
};

export type WorkerServiceUncheckedCreateWithoutWorkerAvailabilitiesInput = {
  animalSize?: InputMaybe<AnimalSizeEnum>;
  animalType?: InputMaybe<AnimalTypeEnum>;
  bookable?: InputMaybe<Scalars['Boolean']['input']>;
  bookings?: InputMaybe<BookingUncheckedCreateNestedManyWithoutWorkerServiceInput>;
  categoryId: Scalars['Int']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isProSpecialist?: InputMaybe<Scalars['Boolean']['input']>;
  maximumDuration?: InputMaybe<Scalars['Int']['input']>;
  minimumDuration?: InputMaybe<Scalars['Int']['input']>;
  multiAnimalsBookingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  multiAnimalsDuration?: InputMaybe<Scalars['Int']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  priceFrom?: InputMaybe<Scalars['Float']['input']>;
  priceTo?: InputMaybe<Scalars['Float']['input']>;
  priceType?: InputMaybe<WorkerServicePriceType>;
  serviceId: Scalars['Int']['input'];
  translations?: InputMaybe<WorkerServiceTranslationUncheckedCreateNestedManyWithoutWorkerServiceInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  workerId: Scalars['Int']['input'];
};

export type WorkerServiceUncheckedCreateWithoutWorkerInput = {
  animalSize?: InputMaybe<AnimalSizeEnum>;
  animalType?: InputMaybe<AnimalTypeEnum>;
  bookable?: InputMaybe<Scalars['Boolean']['input']>;
  bookings?: InputMaybe<BookingUncheckedCreateNestedManyWithoutWorkerServiceInput>;
  categoryId: Scalars['Int']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isProSpecialist?: InputMaybe<Scalars['Boolean']['input']>;
  maximumDuration?: InputMaybe<Scalars['Int']['input']>;
  minimumDuration?: InputMaybe<Scalars['Int']['input']>;
  multiAnimalsBookingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  multiAnimalsDuration?: InputMaybe<Scalars['Int']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  priceFrom?: InputMaybe<Scalars['Float']['input']>;
  priceTo?: InputMaybe<Scalars['Float']['input']>;
  priceType?: InputMaybe<WorkerServicePriceType>;
  serviceId: Scalars['Int']['input'];
  translations?: InputMaybe<WorkerServiceTranslationUncheckedCreateNestedManyWithoutWorkerServiceInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  workerAvailabilities?: InputMaybe<WorkerAvailabilityUncheckedCreateNestedManyWithoutWorkerServiceInput>;
};

export type WorkerServiceUncheckedUpdateInput = {
  animalSize?: InputMaybe<NullableEnumAnimalSizeEnumFieldUpdateOperationsInput>;
  animalType?: InputMaybe<NullableEnumAnimalTypeEnumFieldUpdateOperationsInput>;
  bookable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  bookings?: InputMaybe<BookingUncheckedUpdateManyWithoutWorkerServiceNestedInput>;
  categoryId?: InputMaybe<IntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  enabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  isProSpecialist?: InputMaybe<BoolFieldUpdateOperationsInput>;
  maximumDuration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  minimumDuration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  multiAnimalsBookingEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  multiAnimalsDuration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  price?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  priceFrom?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  priceTo?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  priceType?: InputMaybe<NullableEnumWorkerServicePriceTypeFieldUpdateOperationsInput>;
  serviceId?: InputMaybe<IntFieldUpdateOperationsInput>;
  translations?: InputMaybe<WorkerServiceTranslationUncheckedUpdateManyWithoutWorkerServiceNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  workerAvailabilities?: InputMaybe<WorkerAvailabilityUncheckedUpdateManyWithoutWorkerServiceNestedInput>;
  workerId?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type WorkerServiceUncheckedUpdateManyInput = {
  animalSize?: InputMaybe<NullableEnumAnimalSizeEnumFieldUpdateOperationsInput>;
  animalType?: InputMaybe<NullableEnumAnimalTypeEnumFieldUpdateOperationsInput>;
  bookable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  categoryId?: InputMaybe<IntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  enabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  isProSpecialist?: InputMaybe<BoolFieldUpdateOperationsInput>;
  maximumDuration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  minimumDuration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  multiAnimalsBookingEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  multiAnimalsDuration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  price?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  priceFrom?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  priceTo?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  priceType?: InputMaybe<NullableEnumWorkerServicePriceTypeFieldUpdateOperationsInput>;
  serviceId?: InputMaybe<IntFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  workerId?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type WorkerServiceUncheckedUpdateManyWithoutCategoryInput = {
  animalSize?: InputMaybe<NullableEnumAnimalSizeEnumFieldUpdateOperationsInput>;
  animalType?: InputMaybe<NullableEnumAnimalTypeEnumFieldUpdateOperationsInput>;
  bookable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  enabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  isProSpecialist?: InputMaybe<BoolFieldUpdateOperationsInput>;
  maximumDuration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  minimumDuration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  multiAnimalsBookingEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  multiAnimalsDuration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  price?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  priceFrom?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  priceTo?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  priceType?: InputMaybe<NullableEnumWorkerServicePriceTypeFieldUpdateOperationsInput>;
  serviceId?: InputMaybe<IntFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  workerId?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type WorkerServiceUncheckedUpdateManyWithoutCategoryNestedInput = {
  connect?: InputMaybe<Array<WorkerServiceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<WorkerServiceCreateOrConnectWithoutCategoryInput>>;
  create?: InputMaybe<Array<WorkerServiceCreateWithoutCategoryInput>>;
  createMany?: InputMaybe<WorkerServiceCreateManyCategoryInputEnvelope>;
  delete?: InputMaybe<Array<WorkerServiceWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<WorkerServiceScalarWhereInput>>;
  disconnect?: InputMaybe<Array<WorkerServiceWhereUniqueInput>>;
  set?: InputMaybe<Array<WorkerServiceWhereUniqueInput>>;
  update?: InputMaybe<Array<WorkerServiceUpdateWithWhereUniqueWithoutCategoryInput>>;
  updateMany?: InputMaybe<Array<WorkerServiceUpdateManyWithWhereWithoutCategoryInput>>;
  upsert?: InputMaybe<Array<WorkerServiceUpsertWithWhereUniqueWithoutCategoryInput>>;
};

export type WorkerServiceUncheckedUpdateManyWithoutServiceInput = {
  animalSize?: InputMaybe<NullableEnumAnimalSizeEnumFieldUpdateOperationsInput>;
  animalType?: InputMaybe<NullableEnumAnimalTypeEnumFieldUpdateOperationsInput>;
  bookable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  categoryId?: InputMaybe<IntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  enabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  isProSpecialist?: InputMaybe<BoolFieldUpdateOperationsInput>;
  maximumDuration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  minimumDuration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  multiAnimalsBookingEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  multiAnimalsDuration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  price?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  priceFrom?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  priceTo?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  priceType?: InputMaybe<NullableEnumWorkerServicePriceTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  workerId?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type WorkerServiceUncheckedUpdateManyWithoutServiceNestedInput = {
  connect?: InputMaybe<Array<WorkerServiceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<WorkerServiceCreateOrConnectWithoutServiceInput>>;
  create?: InputMaybe<Array<WorkerServiceCreateWithoutServiceInput>>;
  createMany?: InputMaybe<WorkerServiceCreateManyServiceInputEnvelope>;
  delete?: InputMaybe<Array<WorkerServiceWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<WorkerServiceScalarWhereInput>>;
  disconnect?: InputMaybe<Array<WorkerServiceWhereUniqueInput>>;
  set?: InputMaybe<Array<WorkerServiceWhereUniqueInput>>;
  update?: InputMaybe<Array<WorkerServiceUpdateWithWhereUniqueWithoutServiceInput>>;
  updateMany?: InputMaybe<Array<WorkerServiceUpdateManyWithWhereWithoutServiceInput>>;
  upsert?: InputMaybe<Array<WorkerServiceUpsertWithWhereUniqueWithoutServiceInput>>;
};

export type WorkerServiceUncheckedUpdateManyWithoutWorkerInput = {
  animalSize?: InputMaybe<NullableEnumAnimalSizeEnumFieldUpdateOperationsInput>;
  animalType?: InputMaybe<NullableEnumAnimalTypeEnumFieldUpdateOperationsInput>;
  bookable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  categoryId?: InputMaybe<IntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  enabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  isProSpecialist?: InputMaybe<BoolFieldUpdateOperationsInput>;
  maximumDuration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  minimumDuration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  multiAnimalsBookingEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  multiAnimalsDuration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  price?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  priceFrom?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  priceTo?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  priceType?: InputMaybe<NullableEnumWorkerServicePriceTypeFieldUpdateOperationsInput>;
  serviceId?: InputMaybe<IntFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type WorkerServiceUncheckedUpdateManyWithoutWorkerNestedInput = {
  connect?: InputMaybe<Array<WorkerServiceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<WorkerServiceCreateOrConnectWithoutWorkerInput>>;
  create?: InputMaybe<Array<WorkerServiceCreateWithoutWorkerInput>>;
  createMany?: InputMaybe<WorkerServiceCreateManyWorkerInputEnvelope>;
  delete?: InputMaybe<Array<WorkerServiceWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<WorkerServiceScalarWhereInput>>;
  disconnect?: InputMaybe<Array<WorkerServiceWhereUniqueInput>>;
  set?: InputMaybe<Array<WorkerServiceWhereUniqueInput>>;
  update?: InputMaybe<Array<WorkerServiceUpdateWithWhereUniqueWithoutWorkerInput>>;
  updateMany?: InputMaybe<Array<WorkerServiceUpdateManyWithWhereWithoutWorkerInput>>;
  upsert?: InputMaybe<Array<WorkerServiceUpsertWithWhereUniqueWithoutWorkerInput>>;
};

export type WorkerServiceUncheckedUpdateWithoutBookingsInput = {
  animalSize?: InputMaybe<NullableEnumAnimalSizeEnumFieldUpdateOperationsInput>;
  animalType?: InputMaybe<NullableEnumAnimalTypeEnumFieldUpdateOperationsInput>;
  bookable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  categoryId?: InputMaybe<IntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  enabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  isProSpecialist?: InputMaybe<BoolFieldUpdateOperationsInput>;
  maximumDuration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  minimumDuration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  multiAnimalsBookingEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  multiAnimalsDuration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  price?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  priceFrom?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  priceTo?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  priceType?: InputMaybe<NullableEnumWorkerServicePriceTypeFieldUpdateOperationsInput>;
  serviceId?: InputMaybe<IntFieldUpdateOperationsInput>;
  translations?: InputMaybe<WorkerServiceTranslationUncheckedUpdateManyWithoutWorkerServiceNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  workerAvailabilities?: InputMaybe<WorkerAvailabilityUncheckedUpdateManyWithoutWorkerServiceNestedInput>;
  workerId?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type WorkerServiceUncheckedUpdateWithoutCategoryInput = {
  animalSize?: InputMaybe<NullableEnumAnimalSizeEnumFieldUpdateOperationsInput>;
  animalType?: InputMaybe<NullableEnumAnimalTypeEnumFieldUpdateOperationsInput>;
  bookable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  bookings?: InputMaybe<BookingUncheckedUpdateManyWithoutWorkerServiceNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  enabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  isProSpecialist?: InputMaybe<BoolFieldUpdateOperationsInput>;
  maximumDuration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  minimumDuration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  multiAnimalsBookingEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  multiAnimalsDuration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  price?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  priceFrom?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  priceTo?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  priceType?: InputMaybe<NullableEnumWorkerServicePriceTypeFieldUpdateOperationsInput>;
  serviceId?: InputMaybe<IntFieldUpdateOperationsInput>;
  translations?: InputMaybe<WorkerServiceTranslationUncheckedUpdateManyWithoutWorkerServiceNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  workerAvailabilities?: InputMaybe<WorkerAvailabilityUncheckedUpdateManyWithoutWorkerServiceNestedInput>;
  workerId?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type WorkerServiceUncheckedUpdateWithoutServiceInput = {
  animalSize?: InputMaybe<NullableEnumAnimalSizeEnumFieldUpdateOperationsInput>;
  animalType?: InputMaybe<NullableEnumAnimalTypeEnumFieldUpdateOperationsInput>;
  bookable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  bookings?: InputMaybe<BookingUncheckedUpdateManyWithoutWorkerServiceNestedInput>;
  categoryId?: InputMaybe<IntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  enabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  isProSpecialist?: InputMaybe<BoolFieldUpdateOperationsInput>;
  maximumDuration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  minimumDuration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  multiAnimalsBookingEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  multiAnimalsDuration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  price?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  priceFrom?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  priceTo?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  priceType?: InputMaybe<NullableEnumWorkerServicePriceTypeFieldUpdateOperationsInput>;
  translations?: InputMaybe<WorkerServiceTranslationUncheckedUpdateManyWithoutWorkerServiceNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  workerAvailabilities?: InputMaybe<WorkerAvailabilityUncheckedUpdateManyWithoutWorkerServiceNestedInput>;
  workerId?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type WorkerServiceUncheckedUpdateWithoutTranslationsInput = {
  animalSize?: InputMaybe<NullableEnumAnimalSizeEnumFieldUpdateOperationsInput>;
  animalType?: InputMaybe<NullableEnumAnimalTypeEnumFieldUpdateOperationsInput>;
  bookable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  bookings?: InputMaybe<BookingUncheckedUpdateManyWithoutWorkerServiceNestedInput>;
  categoryId?: InputMaybe<IntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  enabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  isProSpecialist?: InputMaybe<BoolFieldUpdateOperationsInput>;
  maximumDuration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  minimumDuration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  multiAnimalsBookingEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  multiAnimalsDuration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  price?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  priceFrom?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  priceTo?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  priceType?: InputMaybe<NullableEnumWorkerServicePriceTypeFieldUpdateOperationsInput>;
  serviceId?: InputMaybe<IntFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  workerAvailabilities?: InputMaybe<WorkerAvailabilityUncheckedUpdateManyWithoutWorkerServiceNestedInput>;
  workerId?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type WorkerServiceUncheckedUpdateWithoutWorkerAvailabilitiesInput = {
  animalSize?: InputMaybe<NullableEnumAnimalSizeEnumFieldUpdateOperationsInput>;
  animalType?: InputMaybe<NullableEnumAnimalTypeEnumFieldUpdateOperationsInput>;
  bookable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  bookings?: InputMaybe<BookingUncheckedUpdateManyWithoutWorkerServiceNestedInput>;
  categoryId?: InputMaybe<IntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  enabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  isProSpecialist?: InputMaybe<BoolFieldUpdateOperationsInput>;
  maximumDuration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  minimumDuration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  multiAnimalsBookingEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  multiAnimalsDuration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  price?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  priceFrom?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  priceTo?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  priceType?: InputMaybe<NullableEnumWorkerServicePriceTypeFieldUpdateOperationsInput>;
  serviceId?: InputMaybe<IntFieldUpdateOperationsInput>;
  translations?: InputMaybe<WorkerServiceTranslationUncheckedUpdateManyWithoutWorkerServiceNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  workerId?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type WorkerServiceUncheckedUpdateWithoutWorkerInput = {
  animalSize?: InputMaybe<NullableEnumAnimalSizeEnumFieldUpdateOperationsInput>;
  animalType?: InputMaybe<NullableEnumAnimalTypeEnumFieldUpdateOperationsInput>;
  bookable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  bookings?: InputMaybe<BookingUncheckedUpdateManyWithoutWorkerServiceNestedInput>;
  categoryId?: InputMaybe<IntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  enabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  isProSpecialist?: InputMaybe<BoolFieldUpdateOperationsInput>;
  maximumDuration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  minimumDuration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  multiAnimalsBookingEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  multiAnimalsDuration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  price?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  priceFrom?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  priceTo?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  priceType?: InputMaybe<NullableEnumWorkerServicePriceTypeFieldUpdateOperationsInput>;
  serviceId?: InputMaybe<IntFieldUpdateOperationsInput>;
  translations?: InputMaybe<WorkerServiceTranslationUncheckedUpdateManyWithoutWorkerServiceNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  workerAvailabilities?: InputMaybe<WorkerAvailabilityUncheckedUpdateManyWithoutWorkerServiceNestedInput>;
};

export type WorkerServiceUpdateInput = {
  animalSize?: InputMaybe<NullableEnumAnimalSizeEnumFieldUpdateOperationsInput>;
  animalType?: InputMaybe<NullableEnumAnimalTypeEnumFieldUpdateOperationsInput>;
  bookable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  bookings?: InputMaybe<BookingUpdateManyWithoutWorkerServiceNestedInput>;
  category?: InputMaybe<CategoryUpdateOneRequiredWithoutWorkerServicesNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  enabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isProSpecialist?: InputMaybe<BoolFieldUpdateOperationsInput>;
  maximumDuration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  minimumDuration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  multiAnimalsBookingEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  multiAnimalsDuration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  price?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  priceFrom?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  priceTo?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  priceType?: InputMaybe<NullableEnumWorkerServicePriceTypeFieldUpdateOperationsInput>;
  service?: InputMaybe<ServiceUpdateOneRequiredWithoutWorkerServicesNestedInput>;
  translations?: InputMaybe<WorkerServiceTranslationUpdateManyWithoutWorkerServiceNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  worker?: InputMaybe<WorkerUpdateOneRequiredWithoutServicesNestedInput>;
  workerAvailabilities?: InputMaybe<WorkerAvailabilityUpdateManyWithoutWorkerServiceNestedInput>;
};

export type WorkerServiceUpdateManyMutationInput = {
  animalSize?: InputMaybe<NullableEnumAnimalSizeEnumFieldUpdateOperationsInput>;
  animalType?: InputMaybe<NullableEnumAnimalTypeEnumFieldUpdateOperationsInput>;
  bookable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  enabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isProSpecialist?: InputMaybe<BoolFieldUpdateOperationsInput>;
  maximumDuration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  minimumDuration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  multiAnimalsBookingEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  multiAnimalsDuration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  price?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  priceFrom?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  priceTo?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  priceType?: InputMaybe<NullableEnumWorkerServicePriceTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type WorkerServiceUpdateManyWithWhereWithoutCategoryInput = {
  data: WorkerServiceUpdateManyMutationInput;
  where: WorkerServiceScalarWhereInput;
};

export type WorkerServiceUpdateManyWithWhereWithoutServiceInput = {
  data: WorkerServiceUpdateManyMutationInput;
  where: WorkerServiceScalarWhereInput;
};

export type WorkerServiceUpdateManyWithWhereWithoutWorkerInput = {
  data: WorkerServiceUpdateManyMutationInput;
  where: WorkerServiceScalarWhereInput;
};

export type WorkerServiceUpdateManyWithoutCategoryNestedInput = {
  connect?: InputMaybe<Array<WorkerServiceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<WorkerServiceCreateOrConnectWithoutCategoryInput>>;
  create?: InputMaybe<Array<WorkerServiceCreateWithoutCategoryInput>>;
  createMany?: InputMaybe<WorkerServiceCreateManyCategoryInputEnvelope>;
  delete?: InputMaybe<Array<WorkerServiceWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<WorkerServiceScalarWhereInput>>;
  disconnect?: InputMaybe<Array<WorkerServiceWhereUniqueInput>>;
  set?: InputMaybe<Array<WorkerServiceWhereUniqueInput>>;
  update?: InputMaybe<Array<WorkerServiceUpdateWithWhereUniqueWithoutCategoryInput>>;
  updateMany?: InputMaybe<Array<WorkerServiceUpdateManyWithWhereWithoutCategoryInput>>;
  upsert?: InputMaybe<Array<WorkerServiceUpsertWithWhereUniqueWithoutCategoryInput>>;
};

export type WorkerServiceUpdateManyWithoutServiceNestedInput = {
  connect?: InputMaybe<Array<WorkerServiceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<WorkerServiceCreateOrConnectWithoutServiceInput>>;
  create?: InputMaybe<Array<WorkerServiceCreateWithoutServiceInput>>;
  createMany?: InputMaybe<WorkerServiceCreateManyServiceInputEnvelope>;
  delete?: InputMaybe<Array<WorkerServiceWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<WorkerServiceScalarWhereInput>>;
  disconnect?: InputMaybe<Array<WorkerServiceWhereUniqueInput>>;
  set?: InputMaybe<Array<WorkerServiceWhereUniqueInput>>;
  update?: InputMaybe<Array<WorkerServiceUpdateWithWhereUniqueWithoutServiceInput>>;
  updateMany?: InputMaybe<Array<WorkerServiceUpdateManyWithWhereWithoutServiceInput>>;
  upsert?: InputMaybe<Array<WorkerServiceUpsertWithWhereUniqueWithoutServiceInput>>;
};

export type WorkerServiceUpdateManyWithoutWorkerNestedInput = {
  connect?: InputMaybe<Array<WorkerServiceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<WorkerServiceCreateOrConnectWithoutWorkerInput>>;
  create?: InputMaybe<Array<WorkerServiceCreateWithoutWorkerInput>>;
  createMany?: InputMaybe<WorkerServiceCreateManyWorkerInputEnvelope>;
  delete?: InputMaybe<Array<WorkerServiceWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<WorkerServiceScalarWhereInput>>;
  disconnect?: InputMaybe<Array<WorkerServiceWhereUniqueInput>>;
  set?: InputMaybe<Array<WorkerServiceWhereUniqueInput>>;
  update?: InputMaybe<Array<WorkerServiceUpdateWithWhereUniqueWithoutWorkerInput>>;
  updateMany?: InputMaybe<Array<WorkerServiceUpdateManyWithWhereWithoutWorkerInput>>;
  upsert?: InputMaybe<Array<WorkerServiceUpsertWithWhereUniqueWithoutWorkerInput>>;
};

export type WorkerServiceUpdateOneRequiredWithoutBookingsNestedInput = {
  connect?: InputMaybe<WorkerServiceWhereUniqueInput>;
  connectOrCreate?: InputMaybe<WorkerServiceCreateOrConnectWithoutBookingsInput>;
  create?: InputMaybe<WorkerServiceCreateWithoutBookingsInput>;
  update?: InputMaybe<WorkerServiceUpdateToOneWithWhereWithoutBookingsInput>;
  upsert?: InputMaybe<WorkerServiceUpsertWithoutBookingsInput>;
};

export type WorkerServiceUpdateOneRequiredWithoutTranslationsNestedInput = {
  connect?: InputMaybe<WorkerServiceWhereUniqueInput>;
  connectOrCreate?: InputMaybe<WorkerServiceCreateOrConnectWithoutTranslationsInput>;
  create?: InputMaybe<WorkerServiceCreateWithoutTranslationsInput>;
  update?: InputMaybe<WorkerServiceUpdateToOneWithWhereWithoutTranslationsInput>;
  upsert?: InputMaybe<WorkerServiceUpsertWithoutTranslationsInput>;
};

export type WorkerServiceUpdateOneWithoutWorkerAvailabilitiesNestedInput = {
  connect?: InputMaybe<WorkerServiceWhereUniqueInput>;
  connectOrCreate?: InputMaybe<WorkerServiceCreateOrConnectWithoutWorkerAvailabilitiesInput>;
  create?: InputMaybe<WorkerServiceCreateWithoutWorkerAvailabilitiesInput>;
  delete?: InputMaybe<WorkerServiceWhereInput>;
  disconnect?: InputMaybe<WorkerServiceWhereInput>;
  update?: InputMaybe<WorkerServiceUpdateToOneWithWhereWithoutWorkerAvailabilitiesInput>;
  upsert?: InputMaybe<WorkerServiceUpsertWithoutWorkerAvailabilitiesInput>;
};

export type WorkerServiceUpdateToOneWithWhereWithoutBookingsInput = {
  data: WorkerServiceUpdateWithoutBookingsInput;
  where?: InputMaybe<WorkerServiceWhereInput>;
};

export type WorkerServiceUpdateToOneWithWhereWithoutTranslationsInput = {
  data: WorkerServiceUpdateWithoutTranslationsInput;
  where?: InputMaybe<WorkerServiceWhereInput>;
};

export type WorkerServiceUpdateToOneWithWhereWithoutWorkerAvailabilitiesInput = {
  data: WorkerServiceUpdateWithoutWorkerAvailabilitiesInput;
  where?: InputMaybe<WorkerServiceWhereInput>;
};

export type WorkerServiceUpdateWithWhereUniqueWithoutCategoryInput = {
  data: WorkerServiceUpdateWithoutCategoryInput;
  where: WorkerServiceWhereUniqueInput;
};

export type WorkerServiceUpdateWithWhereUniqueWithoutServiceInput = {
  data: WorkerServiceUpdateWithoutServiceInput;
  where: WorkerServiceWhereUniqueInput;
};

export type WorkerServiceUpdateWithWhereUniqueWithoutWorkerInput = {
  data: WorkerServiceUpdateWithoutWorkerInput;
  where: WorkerServiceWhereUniqueInput;
};

export type WorkerServiceUpdateWithoutBookingsInput = {
  animalSize?: InputMaybe<NullableEnumAnimalSizeEnumFieldUpdateOperationsInput>;
  animalType?: InputMaybe<NullableEnumAnimalTypeEnumFieldUpdateOperationsInput>;
  bookable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  category?: InputMaybe<CategoryUpdateOneRequiredWithoutWorkerServicesNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  enabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isProSpecialist?: InputMaybe<BoolFieldUpdateOperationsInput>;
  maximumDuration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  minimumDuration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  multiAnimalsBookingEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  multiAnimalsDuration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  price?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  priceFrom?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  priceTo?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  priceType?: InputMaybe<NullableEnumWorkerServicePriceTypeFieldUpdateOperationsInput>;
  service?: InputMaybe<ServiceUpdateOneRequiredWithoutWorkerServicesNestedInput>;
  translations?: InputMaybe<WorkerServiceTranslationUpdateManyWithoutWorkerServiceNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  worker?: InputMaybe<WorkerUpdateOneRequiredWithoutServicesNestedInput>;
  workerAvailabilities?: InputMaybe<WorkerAvailabilityUpdateManyWithoutWorkerServiceNestedInput>;
};

export type WorkerServiceUpdateWithoutCategoryInput = {
  animalSize?: InputMaybe<NullableEnumAnimalSizeEnumFieldUpdateOperationsInput>;
  animalType?: InputMaybe<NullableEnumAnimalTypeEnumFieldUpdateOperationsInput>;
  bookable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  bookings?: InputMaybe<BookingUpdateManyWithoutWorkerServiceNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  enabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isProSpecialist?: InputMaybe<BoolFieldUpdateOperationsInput>;
  maximumDuration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  minimumDuration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  multiAnimalsBookingEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  multiAnimalsDuration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  price?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  priceFrom?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  priceTo?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  priceType?: InputMaybe<NullableEnumWorkerServicePriceTypeFieldUpdateOperationsInput>;
  service?: InputMaybe<ServiceUpdateOneRequiredWithoutWorkerServicesNestedInput>;
  translations?: InputMaybe<WorkerServiceTranslationUpdateManyWithoutWorkerServiceNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  worker?: InputMaybe<WorkerUpdateOneRequiredWithoutServicesNestedInput>;
  workerAvailabilities?: InputMaybe<WorkerAvailabilityUpdateManyWithoutWorkerServiceNestedInput>;
};

export type WorkerServiceUpdateWithoutServiceInput = {
  animalSize?: InputMaybe<NullableEnumAnimalSizeEnumFieldUpdateOperationsInput>;
  animalType?: InputMaybe<NullableEnumAnimalTypeEnumFieldUpdateOperationsInput>;
  bookable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  bookings?: InputMaybe<BookingUpdateManyWithoutWorkerServiceNestedInput>;
  category?: InputMaybe<CategoryUpdateOneRequiredWithoutWorkerServicesNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  enabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isProSpecialist?: InputMaybe<BoolFieldUpdateOperationsInput>;
  maximumDuration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  minimumDuration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  multiAnimalsBookingEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  multiAnimalsDuration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  price?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  priceFrom?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  priceTo?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  priceType?: InputMaybe<NullableEnumWorkerServicePriceTypeFieldUpdateOperationsInput>;
  translations?: InputMaybe<WorkerServiceTranslationUpdateManyWithoutWorkerServiceNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  worker?: InputMaybe<WorkerUpdateOneRequiredWithoutServicesNestedInput>;
  workerAvailabilities?: InputMaybe<WorkerAvailabilityUpdateManyWithoutWorkerServiceNestedInput>;
};

export type WorkerServiceUpdateWithoutTranslationsInput = {
  animalSize?: InputMaybe<NullableEnumAnimalSizeEnumFieldUpdateOperationsInput>;
  animalType?: InputMaybe<NullableEnumAnimalTypeEnumFieldUpdateOperationsInput>;
  bookable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  bookings?: InputMaybe<BookingUpdateManyWithoutWorkerServiceNestedInput>;
  category?: InputMaybe<CategoryUpdateOneRequiredWithoutWorkerServicesNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  enabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isProSpecialist?: InputMaybe<BoolFieldUpdateOperationsInput>;
  maximumDuration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  minimumDuration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  multiAnimalsBookingEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  multiAnimalsDuration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  price?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  priceFrom?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  priceTo?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  priceType?: InputMaybe<NullableEnumWorkerServicePriceTypeFieldUpdateOperationsInput>;
  service?: InputMaybe<ServiceUpdateOneRequiredWithoutWorkerServicesNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  worker?: InputMaybe<WorkerUpdateOneRequiredWithoutServicesNestedInput>;
  workerAvailabilities?: InputMaybe<WorkerAvailabilityUpdateManyWithoutWorkerServiceNestedInput>;
};

export type WorkerServiceUpdateWithoutWorkerAvailabilitiesInput = {
  animalSize?: InputMaybe<NullableEnumAnimalSizeEnumFieldUpdateOperationsInput>;
  animalType?: InputMaybe<NullableEnumAnimalTypeEnumFieldUpdateOperationsInput>;
  bookable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  bookings?: InputMaybe<BookingUpdateManyWithoutWorkerServiceNestedInput>;
  category?: InputMaybe<CategoryUpdateOneRequiredWithoutWorkerServicesNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  enabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isProSpecialist?: InputMaybe<BoolFieldUpdateOperationsInput>;
  maximumDuration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  minimumDuration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  multiAnimalsBookingEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  multiAnimalsDuration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  price?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  priceFrom?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  priceTo?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  priceType?: InputMaybe<NullableEnumWorkerServicePriceTypeFieldUpdateOperationsInput>;
  service?: InputMaybe<ServiceUpdateOneRequiredWithoutWorkerServicesNestedInput>;
  translations?: InputMaybe<WorkerServiceTranslationUpdateManyWithoutWorkerServiceNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  worker?: InputMaybe<WorkerUpdateOneRequiredWithoutServicesNestedInput>;
};

export type WorkerServiceUpdateWithoutWorkerInput = {
  animalSize?: InputMaybe<NullableEnumAnimalSizeEnumFieldUpdateOperationsInput>;
  animalType?: InputMaybe<NullableEnumAnimalTypeEnumFieldUpdateOperationsInput>;
  bookable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  bookings?: InputMaybe<BookingUpdateManyWithoutWorkerServiceNestedInput>;
  category?: InputMaybe<CategoryUpdateOneRequiredWithoutWorkerServicesNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  enabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isProSpecialist?: InputMaybe<BoolFieldUpdateOperationsInput>;
  maximumDuration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  minimumDuration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  multiAnimalsBookingEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  multiAnimalsDuration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  price?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  priceFrom?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  priceTo?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  priceType?: InputMaybe<NullableEnumWorkerServicePriceTypeFieldUpdateOperationsInput>;
  service?: InputMaybe<ServiceUpdateOneRequiredWithoutWorkerServicesNestedInput>;
  translations?: InputMaybe<WorkerServiceTranslationUpdateManyWithoutWorkerServiceNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  workerAvailabilities?: InputMaybe<WorkerAvailabilityUpdateManyWithoutWorkerServiceNestedInput>;
};

export type WorkerServiceUpsertWithWhereUniqueWithoutCategoryInput = {
  create: WorkerServiceCreateWithoutCategoryInput;
  update: WorkerServiceUpdateWithoutCategoryInput;
  where: WorkerServiceWhereUniqueInput;
};

export type WorkerServiceUpsertWithWhereUniqueWithoutServiceInput = {
  create: WorkerServiceCreateWithoutServiceInput;
  update: WorkerServiceUpdateWithoutServiceInput;
  where: WorkerServiceWhereUniqueInput;
};

export type WorkerServiceUpsertWithWhereUniqueWithoutWorkerInput = {
  create: WorkerServiceCreateWithoutWorkerInput;
  update: WorkerServiceUpdateWithoutWorkerInput;
  where: WorkerServiceWhereUniqueInput;
};

export type WorkerServiceUpsertWithoutBookingsInput = {
  create: WorkerServiceCreateWithoutBookingsInput;
  update: WorkerServiceUpdateWithoutBookingsInput;
  where?: InputMaybe<WorkerServiceWhereInput>;
};

export type WorkerServiceUpsertWithoutTranslationsInput = {
  create: WorkerServiceCreateWithoutTranslationsInput;
  update: WorkerServiceUpdateWithoutTranslationsInput;
  where?: InputMaybe<WorkerServiceWhereInput>;
};

export type WorkerServiceUpsertWithoutWorkerAvailabilitiesInput = {
  create: WorkerServiceCreateWithoutWorkerAvailabilitiesInput;
  update: WorkerServiceUpdateWithoutWorkerAvailabilitiesInput;
  where?: InputMaybe<WorkerServiceWhereInput>;
};

export type WorkerServiceWhereInput = {
  AND?: InputMaybe<Array<WorkerServiceWhereInput>>;
  NOT?: InputMaybe<Array<WorkerServiceWhereInput>>;
  OR?: InputMaybe<Array<WorkerServiceWhereInput>>;
  animalSize?: InputMaybe<EnumAnimalSizeEnumNullableFilter>;
  animalType?: InputMaybe<EnumAnimalTypeEnumNullableFilter>;
  bookable?: InputMaybe<BoolFilter>;
  bookings?: InputMaybe<BookingListRelationFilter>;
  category?: InputMaybe<CategoryRelationFilter>;
  categoryId?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  enabled?: InputMaybe<BoolFilter>;
  id?: InputMaybe<IntFilter>;
  isProSpecialist?: InputMaybe<BoolFilter>;
  maximumDuration?: InputMaybe<IntNullableFilter>;
  minimumDuration?: InputMaybe<IntNullableFilter>;
  multiAnimalsBookingEnabled?: InputMaybe<BoolFilter>;
  multiAnimalsDuration?: InputMaybe<IntNullableFilter>;
  price?: InputMaybe<FloatNullableFilter>;
  priceFrom?: InputMaybe<FloatNullableFilter>;
  priceTo?: InputMaybe<FloatNullableFilter>;
  priceType?: InputMaybe<EnumWorkerServicePriceTypeNullableFilter>;
  service?: InputMaybe<ServiceRelationFilter>;
  serviceId?: InputMaybe<IntFilter>;
  translations?: InputMaybe<WorkerServiceTranslationListRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  worker?: InputMaybe<WorkerRelationFilter>;
  workerAvailabilities?: InputMaybe<WorkerAvailabilityListRelationFilter>;
  workerId?: InputMaybe<IntFilter>;
};

export type WorkerServiceWhereUniqueInput = {
  AND?: InputMaybe<Array<WorkerServiceWhereInput>>;
  NOT?: InputMaybe<Array<WorkerServiceWhereInput>>;
  OR?: InputMaybe<Array<WorkerServiceWhereInput>>;
  animalSize?: InputMaybe<EnumAnimalSizeEnumNullableFilter>;
  animalType?: InputMaybe<EnumAnimalTypeEnumNullableFilter>;
  bookable?: InputMaybe<BoolFilter>;
  bookings?: InputMaybe<BookingListRelationFilter>;
  category?: InputMaybe<CategoryRelationFilter>;
  categoryId?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  enabled?: InputMaybe<BoolFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isProSpecialist?: InputMaybe<BoolFilter>;
  maximumDuration?: InputMaybe<IntNullableFilter>;
  minimumDuration?: InputMaybe<IntNullableFilter>;
  multiAnimalsBookingEnabled?: InputMaybe<BoolFilter>;
  multiAnimalsDuration?: InputMaybe<IntNullableFilter>;
  price?: InputMaybe<FloatNullableFilter>;
  priceFrom?: InputMaybe<FloatNullableFilter>;
  priceTo?: InputMaybe<FloatNullableFilter>;
  priceType?: InputMaybe<EnumWorkerServicePriceTypeNullableFilter>;
  service?: InputMaybe<ServiceRelationFilter>;
  serviceId?: InputMaybe<IntFilter>;
  translations?: InputMaybe<WorkerServiceTranslationListRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  worker?: InputMaybe<WorkerRelationFilter>;
  workerAvailabilities?: InputMaybe<WorkerAvailabilityListRelationFilter>;
  workerId?: InputMaybe<IntFilter>;
  workerId_serviceId_categoryId?: InputMaybe<WorkerServiceWorkerIdServiceIdCategoryIdCompoundUniqueInput>;
};

export type WorkerServiceWithBookingDuration = {
  __typename?: 'WorkerServiceWithBookingDuration';
  _count: WorkerServiceCountOutputType;
  animalSize?: Maybe<AnimalSizeEnum>;
  animalType?: Maybe<AnimalTypeEnum>;
  bookable: Scalars['Boolean']['output'];
  bookingDuration: Scalars['Int']['output'];
  /** @TypeGraphQL.omit(output: true) */
  bookings: Array<Booking>;
  category: Category;
  categoryId: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  enabled: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  isProSpecialist: Scalars['Boolean']['output'];
  maximumDuration?: Maybe<Scalars['Int']['output']>;
  minimumDuration?: Maybe<Scalars['Int']['output']>;
  multiAnimalsBookingEnabled: Scalars['Boolean']['output'];
  multiAnimalsDuration?: Maybe<Scalars['Int']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  priceFrom?: Maybe<Scalars['Float']['output']>;
  priceTo?: Maybe<Scalars['Float']['output']>;
  priceType?: Maybe<WorkerServicePriceType>;
  service: Service;
  serviceId: Scalars['Int']['output'];
  translations: Array<WorkerServiceTranslation>;
  updatedAt: Scalars['DateTime']['output'];
  worker: Worker;
  workerAvailabilities: Array<WorkerAvailability>;
  workerId: Scalars['Int']['output'];
};


export type WorkerServiceWithBookingDurationbookingsArgs = {
  cursor?: InputMaybe<BookingWhereUniqueInput>;
  distinct?: InputMaybe<BookingScalarFieldEnum>;
  orderBy?: InputMaybe<BookingOrderByWithRelationAndSearchRelevanceInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<BookingWhereInput>;
};


export type WorkerServiceWithBookingDurationtranslationsArgs = {
  cursor?: InputMaybe<WorkerServiceTranslationWhereUniqueInput>;
  distinct?: InputMaybe<WorkerServiceTranslationScalarFieldEnum>;
  orderBy?: InputMaybe<WorkerServiceTranslationOrderByWithRelationAndSearchRelevanceInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<WorkerServiceTranslationWhereInput>;
};


export type WorkerServiceWithBookingDurationworkerAvailabilitiesArgs = {
  cursor?: InputMaybe<WorkerAvailabilityWhereUniqueInput>;
  distinct?: InputMaybe<WorkerAvailabilityScalarFieldEnum>;
  orderBy?: InputMaybe<WorkerAvailabilityOrderByWithRelationAndSearchRelevanceInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<WorkerAvailabilityWhereInput>;
};

export type WorkerServiceWorkerIdServiceIdCategoryIdCompoundUniqueInput = {
  categoryId: Scalars['Int']['input'];
  serviceId: Scalars['Int']['input'];
  workerId: Scalars['Int']['input'];
};

export type WorkerSumAggregateOutputType = {
  __typename?: 'WorkerSumAggregateOutputType';
  defaultServiceDurationMinute?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  proId?: Maybe<Scalars['Int']['output']>;
};

export type WorkerSumOrderByAggregateInput = {
  defaultServiceDurationMinute?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  proId?: InputMaybe<SortOrder>;
};

export type WorkerUncheckedCreateInput = {
  bookings?: InputMaybe<BookingUncheckedCreateNestedManyWithoutWorkerInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  defaultServiceDurationMinute?: InputMaybe<Scalars['Int']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  googleCalendarId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  proId: Scalars['Int']['input'];
  services?: InputMaybe<WorkerServiceUncheckedCreateNestedManyWithoutWorkerInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  workerAvailabilities?: InputMaybe<WorkerAvailabilityUncheckedCreateNestedManyWithoutWorkerInput>;
};

export type WorkerUncheckedCreateNestedManyWithoutProInput = {
  connect?: InputMaybe<Array<WorkerWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<WorkerCreateOrConnectWithoutProInput>>;
  create?: InputMaybe<Array<WorkerCreateWithoutProInput>>;
  createMany?: InputMaybe<WorkerCreateManyProInputEnvelope>;
};

export type WorkerUncheckedCreateWithoutBookingsInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  defaultServiceDurationMinute?: InputMaybe<Scalars['Int']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  googleCalendarId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  proId: Scalars['Int']['input'];
  services?: InputMaybe<WorkerServiceUncheckedCreateNestedManyWithoutWorkerInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  workerAvailabilities?: InputMaybe<WorkerAvailabilityUncheckedCreateNestedManyWithoutWorkerInput>;
};

export type WorkerUncheckedCreateWithoutProInput = {
  bookings?: InputMaybe<BookingUncheckedCreateNestedManyWithoutWorkerInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  defaultServiceDurationMinute?: InputMaybe<Scalars['Int']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  googleCalendarId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  services?: InputMaybe<WorkerServiceUncheckedCreateNestedManyWithoutWorkerInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  workerAvailabilities?: InputMaybe<WorkerAvailabilityUncheckedCreateNestedManyWithoutWorkerInput>;
};

export type WorkerUncheckedCreateWithoutServicesInput = {
  bookings?: InputMaybe<BookingUncheckedCreateNestedManyWithoutWorkerInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  defaultServiceDurationMinute?: InputMaybe<Scalars['Int']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  googleCalendarId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  proId: Scalars['Int']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  workerAvailabilities?: InputMaybe<WorkerAvailabilityUncheckedCreateNestedManyWithoutWorkerInput>;
};

export type WorkerUncheckedCreateWithoutWorkerAvailabilitiesInput = {
  bookings?: InputMaybe<BookingUncheckedCreateNestedManyWithoutWorkerInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  defaultServiceDurationMinute?: InputMaybe<Scalars['Int']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  googleCalendarId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  proId: Scalars['Int']['input'];
  services?: InputMaybe<WorkerServiceUncheckedCreateNestedManyWithoutWorkerInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type WorkerUncheckedUpdateInput = {
  bookings?: InputMaybe<BookingUncheckedUpdateManyWithoutWorkerNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  defaultServiceDurationMinute?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleCalendarId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  proId?: InputMaybe<IntFieldUpdateOperationsInput>;
  services?: InputMaybe<WorkerServiceUncheckedUpdateManyWithoutWorkerNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  workerAvailabilities?: InputMaybe<WorkerAvailabilityUncheckedUpdateManyWithoutWorkerNestedInput>;
};

export type WorkerUncheckedUpdateManyInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  defaultServiceDurationMinute?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleCalendarId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  proId?: InputMaybe<IntFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type WorkerUncheckedUpdateManyWithoutProInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  defaultServiceDurationMinute?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleCalendarId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type WorkerUncheckedUpdateManyWithoutProNestedInput = {
  connect?: InputMaybe<Array<WorkerWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<WorkerCreateOrConnectWithoutProInput>>;
  create?: InputMaybe<Array<WorkerCreateWithoutProInput>>;
  createMany?: InputMaybe<WorkerCreateManyProInputEnvelope>;
  delete?: InputMaybe<Array<WorkerWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<WorkerScalarWhereInput>>;
  disconnect?: InputMaybe<Array<WorkerWhereUniqueInput>>;
  set?: InputMaybe<Array<WorkerWhereUniqueInput>>;
  update?: InputMaybe<Array<WorkerUpdateWithWhereUniqueWithoutProInput>>;
  updateMany?: InputMaybe<Array<WorkerUpdateManyWithWhereWithoutProInput>>;
  upsert?: InputMaybe<Array<WorkerUpsertWithWhereUniqueWithoutProInput>>;
};

export type WorkerUncheckedUpdateWithoutBookingsInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  defaultServiceDurationMinute?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleCalendarId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  proId?: InputMaybe<IntFieldUpdateOperationsInput>;
  services?: InputMaybe<WorkerServiceUncheckedUpdateManyWithoutWorkerNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  workerAvailabilities?: InputMaybe<WorkerAvailabilityUncheckedUpdateManyWithoutWorkerNestedInput>;
};

export type WorkerUncheckedUpdateWithoutProInput = {
  bookings?: InputMaybe<BookingUncheckedUpdateManyWithoutWorkerNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  defaultServiceDurationMinute?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleCalendarId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  services?: InputMaybe<WorkerServiceUncheckedUpdateManyWithoutWorkerNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  workerAvailabilities?: InputMaybe<WorkerAvailabilityUncheckedUpdateManyWithoutWorkerNestedInput>;
};

export type WorkerUncheckedUpdateWithoutServicesInput = {
  bookings?: InputMaybe<BookingUncheckedUpdateManyWithoutWorkerNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  defaultServiceDurationMinute?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleCalendarId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  proId?: InputMaybe<IntFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  workerAvailabilities?: InputMaybe<WorkerAvailabilityUncheckedUpdateManyWithoutWorkerNestedInput>;
};

export type WorkerUncheckedUpdateWithoutWorkerAvailabilitiesInput = {
  bookings?: InputMaybe<BookingUncheckedUpdateManyWithoutWorkerNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  defaultServiceDurationMinute?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleCalendarId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  proId?: InputMaybe<IntFieldUpdateOperationsInput>;
  services?: InputMaybe<WorkerServiceUncheckedUpdateManyWithoutWorkerNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type WorkerUpdateInput = {
  bookings?: InputMaybe<BookingUpdateManyWithoutWorkerNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  defaultServiceDurationMinute?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleCalendarId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pro?: InputMaybe<ProfessionalUpdateOneRequiredWithoutWorkersNestedInput>;
  services?: InputMaybe<WorkerServiceUpdateManyWithoutWorkerNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  workerAvailabilities?: InputMaybe<WorkerAvailabilityUpdateManyWithoutWorkerNestedInput>;
};

export type WorkerUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  defaultServiceDurationMinute?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleCalendarId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type WorkerUpdateManyWithWhereWithoutProInput = {
  data: WorkerUpdateManyMutationInput;
  where: WorkerScalarWhereInput;
};

export type WorkerUpdateManyWithoutProNestedInput = {
  connect?: InputMaybe<Array<WorkerWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<WorkerCreateOrConnectWithoutProInput>>;
  create?: InputMaybe<Array<WorkerCreateWithoutProInput>>;
  createMany?: InputMaybe<WorkerCreateManyProInputEnvelope>;
  delete?: InputMaybe<Array<WorkerWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<WorkerScalarWhereInput>>;
  disconnect?: InputMaybe<Array<WorkerWhereUniqueInput>>;
  set?: InputMaybe<Array<WorkerWhereUniqueInput>>;
  update?: InputMaybe<Array<WorkerUpdateWithWhereUniqueWithoutProInput>>;
  updateMany?: InputMaybe<Array<WorkerUpdateManyWithWhereWithoutProInput>>;
  upsert?: InputMaybe<Array<WorkerUpsertWithWhereUniqueWithoutProInput>>;
};

export type WorkerUpdateOneRequiredWithoutBookingsNestedInput = {
  connect?: InputMaybe<WorkerWhereUniqueInput>;
  connectOrCreate?: InputMaybe<WorkerCreateOrConnectWithoutBookingsInput>;
  create?: InputMaybe<WorkerCreateWithoutBookingsInput>;
  update?: InputMaybe<WorkerUpdateToOneWithWhereWithoutBookingsInput>;
  upsert?: InputMaybe<WorkerUpsertWithoutBookingsInput>;
};

export type WorkerUpdateOneRequiredWithoutServicesNestedInput = {
  connect?: InputMaybe<WorkerWhereUniqueInput>;
  connectOrCreate?: InputMaybe<WorkerCreateOrConnectWithoutServicesInput>;
  create?: InputMaybe<WorkerCreateWithoutServicesInput>;
  update?: InputMaybe<WorkerUpdateToOneWithWhereWithoutServicesInput>;
  upsert?: InputMaybe<WorkerUpsertWithoutServicesInput>;
};

export type WorkerUpdateOneRequiredWithoutWorkerAvailabilitiesNestedInput = {
  connect?: InputMaybe<WorkerWhereUniqueInput>;
  connectOrCreate?: InputMaybe<WorkerCreateOrConnectWithoutWorkerAvailabilitiesInput>;
  create?: InputMaybe<WorkerCreateWithoutWorkerAvailabilitiesInput>;
  update?: InputMaybe<WorkerUpdateToOneWithWhereWithoutWorkerAvailabilitiesInput>;
  upsert?: InputMaybe<WorkerUpsertWithoutWorkerAvailabilitiesInput>;
};

export type WorkerUpdateToOneWithWhereWithoutBookingsInput = {
  data: WorkerUpdateWithoutBookingsInput;
  where?: InputMaybe<WorkerWhereInput>;
};

export type WorkerUpdateToOneWithWhereWithoutServicesInput = {
  data: WorkerUpdateWithoutServicesInput;
  where?: InputMaybe<WorkerWhereInput>;
};

export type WorkerUpdateToOneWithWhereWithoutWorkerAvailabilitiesInput = {
  data: WorkerUpdateWithoutWorkerAvailabilitiesInput;
  where?: InputMaybe<WorkerWhereInput>;
};

export type WorkerUpdateWithWhereUniqueWithoutProInput = {
  data: WorkerUpdateWithoutProInput;
  where: WorkerWhereUniqueInput;
};

export type WorkerUpdateWithoutBookingsInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  defaultServiceDurationMinute?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleCalendarId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pro?: InputMaybe<ProfessionalUpdateOneRequiredWithoutWorkersNestedInput>;
  services?: InputMaybe<WorkerServiceUpdateManyWithoutWorkerNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  workerAvailabilities?: InputMaybe<WorkerAvailabilityUpdateManyWithoutWorkerNestedInput>;
};

export type WorkerUpdateWithoutProInput = {
  bookings?: InputMaybe<BookingUpdateManyWithoutWorkerNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  defaultServiceDurationMinute?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleCalendarId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  services?: InputMaybe<WorkerServiceUpdateManyWithoutWorkerNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  workerAvailabilities?: InputMaybe<WorkerAvailabilityUpdateManyWithoutWorkerNestedInput>;
};

export type WorkerUpdateWithoutServicesInput = {
  bookings?: InputMaybe<BookingUpdateManyWithoutWorkerNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  defaultServiceDurationMinute?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleCalendarId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pro?: InputMaybe<ProfessionalUpdateOneRequiredWithoutWorkersNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  workerAvailabilities?: InputMaybe<WorkerAvailabilityUpdateManyWithoutWorkerNestedInput>;
};

export type WorkerUpdateWithoutWorkerAvailabilitiesInput = {
  bookings?: InputMaybe<BookingUpdateManyWithoutWorkerNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  defaultServiceDurationMinute?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleCalendarId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pro?: InputMaybe<ProfessionalUpdateOneRequiredWithoutWorkersNestedInput>;
  services?: InputMaybe<WorkerServiceUpdateManyWithoutWorkerNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type WorkerUpsertWithWhereUniqueWithoutProInput = {
  create: WorkerCreateWithoutProInput;
  update: WorkerUpdateWithoutProInput;
  where: WorkerWhereUniqueInput;
};

export type WorkerUpsertWithoutBookingsInput = {
  create: WorkerCreateWithoutBookingsInput;
  update: WorkerUpdateWithoutBookingsInput;
  where?: InputMaybe<WorkerWhereInput>;
};

export type WorkerUpsertWithoutServicesInput = {
  create: WorkerCreateWithoutServicesInput;
  update: WorkerUpdateWithoutServicesInput;
  where?: InputMaybe<WorkerWhereInput>;
};

export type WorkerUpsertWithoutWorkerAvailabilitiesInput = {
  create: WorkerCreateWithoutWorkerAvailabilitiesInput;
  update: WorkerUpdateWithoutWorkerAvailabilitiesInput;
  where?: InputMaybe<WorkerWhereInput>;
};

export type WorkerWhereInput = {
  AND?: InputMaybe<Array<WorkerWhereInput>>;
  NOT?: InputMaybe<Array<WorkerWhereInput>>;
  OR?: InputMaybe<Array<WorkerWhereInput>>;
  bookings?: InputMaybe<BookingListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  defaultServiceDurationMinute?: InputMaybe<IntNullableFilter>;
  email?: InputMaybe<StringNullableFilter>;
  firstName?: InputMaybe<StringNullableFilter>;
  googleCalendarId?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<IntFilter>;
  lastName?: InputMaybe<StringNullableFilter>;
  phone?: InputMaybe<StringNullableFilter>;
  pro?: InputMaybe<ProfessionalRelationFilter>;
  proId?: InputMaybe<IntFilter>;
  services?: InputMaybe<WorkerServiceListRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  workerAvailabilities?: InputMaybe<WorkerAvailabilityListRelationFilter>;
};

export type WorkerWhereUniqueInput = {
  AND?: InputMaybe<Array<WorkerWhereInput>>;
  NOT?: InputMaybe<Array<WorkerWhereInput>>;
  OR?: InputMaybe<Array<WorkerWhereInput>>;
  bookings?: InputMaybe<BookingListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  defaultServiceDurationMinute?: InputMaybe<IntNullableFilter>;
  email?: InputMaybe<StringNullableFilter>;
  firstName?: InputMaybe<StringNullableFilter>;
  googleCalendarId?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  lastName?: InputMaybe<StringNullableFilter>;
  phone?: InputMaybe<StringNullableFilter>;
  pro?: InputMaybe<ProfessionalRelationFilter>;
  proId?: InputMaybe<IntFilter>;
  services?: InputMaybe<WorkerServiceListRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  workerAvailabilities?: InputMaybe<WorkerAvailabilityListRelationFilter>;
};

export enum YesNoUnknownStatus {
  NO = 'NO',
  UNKNOWN = 'UNKNOWN',
  YES = 'YES'
}

export type AccountBuyerGetAnimalsQueryVariables = Exact<{
  orderBy: AnimalOrderByWithRelationAndSearchRelevanceInput;
  where?: InputMaybe<AnimalWhereInput>;
}>;


export type AccountBuyerGetAnimalsQuery = { __typename?: 'Query', accountMe?: { __typename?: 'Account', id: number, animals: Array<{ __typename?: 'Animal', id: number, type: AnimalTypeEnum, name?: string | null, birthday?: any | null, birthdayType?: BirthdayType | null, gender?: GenderEnum | null, sterilized?: boolean | null, size?: AnimalSizeEnum | null, archived: boolean, calved?: boolean | null, sensitivities?: Array<AnimalSensitivityEnum | null> | null, imgs: Array<{ __typename?: 'AnimalImg', id: number, small?: string | null, medium?: string | null }>, dogInfos?: { __typename?: 'DogInfo', id: number, physicalCondition?: DogPhysicalCondition | null, pedigree?: string | null, medicalAffections: Array<{ __typename?: 'DogMedicalAffection', id: number, affectionType: DogMedicalAffectionType }>, dogBreed?: { __typename?: 'DogBreed', id: number, name: string } | null } | null }> } | null };

export type AccountGetAnimalSensitivitiesQueryVariables = Exact<{
  where?: InputMaybe<AnimalWhereInput>;
}>;


export type AccountGetAnimalSensitivitiesQuery = { __typename?: 'Query', accountMe?: { __typename?: 'Account', id: number, animals: Array<{ __typename?: 'Animal', sensitivities?: Array<AnimalSensitivityEnum | null> | null }> } | null };

export type ApplicationGetApplicationExistsForBreederIdQueryVariables = Exact<{
  where?: InputMaybe<DogBreederApplicationWhereInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ApplicationGetApplicationExistsForBreederIdQuery = { __typename?: 'Query', accountMe?: { __typename?: 'Account', id: number, applications: Array<{ __typename?: 'DogBreederApplication', id: number }> } | null };

export type ApplicationGetApplicationForBreederIdQueryVariables = Exact<{
  where?: InputMaybe<DogBreederApplicationWhereInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ApplicationGetApplicationForBreederIdQuery = { __typename?: 'Query', accountMe?: { __typename?: 'Account', id: number, applications: Array<{ __typename?: 'DogBreederApplication', id: number }> } | null };

export type AccountGetBreederApplicationsQueryVariables = Exact<{
  breedTranslationsWhere?: InputMaybe<DogBreedTranslationWhereInput>;
  orderBy?: InputMaybe<DogBreederApplicationOrderByWithRelationAndSearchRelevanceInput>;
  where?: InputMaybe<DogBreederApplicationWhereInput>;
}>;


export type AccountGetBreederApplicationsQuery = { __typename?: 'Query', accountMe?: { __typename?: 'Account', id: number, dogBreeder?: { __typename?: 'DogBreeder', id: number, breederBreeds: Array<{ __typename?: 'DogBreederBreeds', id: number, dogBreedId: number }>, applications: Array<{ __typename?: 'DogBreederApplication', id: number, createdAt: any, status: DogBreederApplicationStatus, seenByBreeder?: boolean | null, breedPreference: { __typename?: 'DogBreed', id: number, translations: Array<{ __typename?: 'DogBreedTranslation', id: number, name?: string | null }>, imgs: Array<{ __typename?: 'DogBreedImg', id: number, small?: string | null }> }, animal?: { __typename?: 'Animal', id: number, birthday?: any | null } | null, account: { __typename?: 'DogBreederApplicationAccount', id: number, firstName?: string | null, lastName?: string | null, imgs: Array<{ __typename?: 'AccountImg', id: number, small?: string | null }> } }> } | null } | null };

export type AccountGetBuyerApplicationsQueryVariables = Exact<{
  breedTranslationsWhere?: InputMaybe<DogBreedTranslationWhereInput>;
  orderBy?: InputMaybe<DogBreederApplicationOrderByWithRelationAndSearchRelevanceInput>;
  where?: InputMaybe<DogBreederApplicationWhereInput>;
}>;


export type AccountGetBuyerApplicationsQuery = { __typename?: 'Query', accountMe?: { __typename?: 'Account', id: number, applications: Array<{ __typename?: 'DogBreederApplication', id: number, createdAt: any, status: DogBreederApplicationStatus, seenByBuyer?: boolean | null, breedPreference: { __typename?: 'DogBreed', id: number, translations: Array<{ __typename?: 'DogBreedTranslation', id: number, name?: string | null }>, imgs: Array<{ __typename?: 'DogBreedImg', id: number, small?: string | null }> }, puppy?: { __typename?: 'DogPuppy', id: number, dateOfBirth: any } | null, dogBreeder: { __typename?: 'DogBreeder', id: number, profileImg?: string | null, account: { __typename?: 'DogBreederAccount', id: number, firstName?: string | null, lastName?: string | null }, breederBreeds: Array<{ __typename?: 'DogBreederBreeds', dogBreedId: number }> } }> } | null };

export type AccountGetBuyerDraftAnimalsQueryVariables = Exact<{
  where?: InputMaybe<AnimalWhereInput>;
}>;


export type AccountGetBuyerDraftAnimalsQuery = { __typename?: 'Query', accountMe?: { __typename?: 'Account', id: number, animals: Array<{ __typename?: 'Animal', id: number }> } | null };

export type AccountGetBuyerUnpaidApplicationsQueryVariables = Exact<{
  where?: InputMaybe<DogBreederApplicationWhereInput>;
}>;


export type AccountGetBuyerUnpaidApplicationsQuery = { __typename?: 'Query', accountMe?: { __typename?: 'Account', id: number, applications: Array<{ __typename?: 'DogBreederApplication', id: number, dogBreeder: { __typename?: 'DogBreeder', id: number, profileImg?: string | null }, breedPreference: { __typename?: 'DogBreed', translations: Array<{ __typename?: 'DogBreedTranslation', language: string, name?: string | null }> } }> } | null };

export type AccountCreateMutationVariables = Exact<{
  data: AccountCreateInput;
}>;


export type AccountCreateMutation = { __typename?: 'Mutation', createAccount?: { __typename?: 'AccountWithToken', token?: string | null, account?: { __typename?: 'Account', id: number, email: string, lastName?: string | null, firstName?: string | null, name?: string | null, phone?: string | null, firebaseId?: string | null, language: string, dogBreeder?: { __typename?: 'DogBreeder', id: number, certified?: boolean | null, hasStartedOnboarding: boolean } | null, imgs: Array<{ __typename?: 'AccountImg', id: number, small?: string | null }> } | null } | null };

export type CurrentAccountQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentAccountQuery = { __typename?: 'Query', accountMe?: { __typename?: 'Account', accountRemainingDaysForFreeApplications?: number | null, hasADog?: boolean | null, id: number, email: string, lastName?: string | null, firstName?: string | null, name?: string | null, phone?: string | null, firebaseId?: string | null, language: string, dogBreeder?: { __typename?: 'DogBreeder', id: number, certified?: boolean | null, hasStartedOnboarding: boolean } | null, imgs: Array<{ __typename?: 'AccountImg', id: number, small?: string | null }> } | null };

export type JoinBuyerSendMessageMutationVariables = Exact<{
  data: SendMessageInput;
}>;


export type JoinBuyerSendMessageMutation = { __typename?: 'Mutation', sendMessage: { __typename?: 'Message', id: number } };

export type AccountDeleteAccountMutationVariables = Exact<{
  feedback: Scalars['String']['input'];
}>;


export type AccountDeleteAccountMutation = { __typename?: 'Mutation', deleteAccount: boolean };

export type AccountLoginMutationVariables = Exact<{
  data: AccountLoginInput;
}>;


export type AccountLoginMutation = { __typename?: 'Mutation', login?: { __typename?: 'AccountWithToken', token?: string | null, account?: { __typename?: 'Account', id: number, email: string, lastName?: string | null, firstName?: string | null, name?: string | null, phone?: string | null, firebaseId?: string | null, language: string, dogBreeder?: { __typename?: 'DogBreeder', id: number, certified?: boolean | null, hasStartedOnboarding: boolean } | null, imgs: Array<{ __typename?: 'AccountImg', id: number, small?: string | null }> } | null } | null };

export type AccountResetPasswordMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type AccountResetPasswordMutation = { __typename?: 'Mutation', sendPasswordResetEmail: boolean };

export type AccountGetUnseenMessagesQueryVariables = Exact<{ [key: string]: never; }>;


export type AccountGetUnseenMessagesQuery = { __typename?: 'Query', unseenMessages: Array<{ __typename?: 'Message', id: number, fromAccountId: number }> };

export type AccountUpdateAccountLanuageMutationVariables = Exact<{
  data: AccountUpdateInput;
}>;


export type AccountUpdateAccountLanuageMutation = { __typename?: 'Mutation', accountMeUpdate: { __typename?: 'Account', id: number, email: string, lastName?: string | null, firstName?: string | null, name?: string | null, phone?: string | null, firebaseId?: string | null, language: string, dogBreeder?: { __typename?: 'DogBreeder', id: number, certified?: boolean | null, hasStartedOnboarding: boolean } | null, imgs: Array<{ __typename?: 'AccountImg', id: number, small?: string | null }> } };

export type AccountUpdatePasswordMutationVariables = Exact<{
  password: Scalars['String']['input'];
}>;


export type AccountUpdatePasswordMutation = { __typename?: 'Mutation', updatePassword: { __typename?: 'AccountWithToken', token?: string | null, account?: { __typename?: 'Account', id: number, email: string, lastName?: string | null, firstName?: string | null, name?: string | null, phone?: string | null, firebaseId?: string | null, language: string, dogBreeder?: { __typename?: 'DogBreeder', id: number, certified?: boolean | null, hasStartedOnboarding: boolean } | null, imgs: Array<{ __typename?: 'AccountImg', id: number, small?: string | null }> } | null } };

export type BreederLitterListGetBreedQueryVariables = Exact<{
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DogBreedWhereInput>;
}>;


export type BreederLitterListGetBreedQuery = { __typename?: 'Query', findManyDogBreed?: Array<{ __typename?: 'DogBreed', id: number, name: string, headShape?: HeadShape | null, fciGroup?: string | null, hairType?: DogHairType | null, imgs: Array<{ __typename?: 'DogBreedImg', id: number, type: DogBreedImgType, small?: string | null, medium?: string | null, large?: string | null }>, translations: Array<{ __typename?: 'DogBreedTranslation', id: number, language: string, name?: string | null, description?: string | null, otherNames: Array<string> }> }> | null };

export type GetBreedsQueryVariables = Exact<{
  where?: InputMaybe<DogBreedWhereInput>;
  translationsWhere?: InputMaybe<DogBreedTranslationWhereInput>;
}>;


export type GetBreedsQuery = { __typename?: 'Query', findManyDogBreed?: Array<{ __typename?: 'DogBreed', id: number, name: string, sizeCategory?: AnimalSizeEnum | null, baseBreedName?: string | null, isSubBreed: boolean, translations: Array<{ __typename?: 'DogBreedTranslation', id: number, name?: string | null, otherNames: Array<string> }> }> | null };

export type DogBreedInterestSubscriptionQueryVariables = Exact<{
  where?: InputMaybe<DogBreedInterestSubscriptionWhereInput>;
}>;


export type DogBreedInterestSubscriptionQuery = { __typename?: 'Query', findManyDogBreedInterestSubscription?: Array<{ __typename?: 'DogBreedInterestSubscription', id: number, dogBreeds: Array<{ __typename?: 'DogBreed', id: number, name: string }> }> | null };

export type CurrentAccountInfoFragment = { __typename?: 'Account', id: number, email: string, lastName?: string | null, firstName?: string | null, name?: string | null, phone?: string | null, firebaseId?: string | null, language: string, dogBreeder?: { __typename?: 'DogBreeder', id: number, certified?: boolean | null, hasStartedOnboarding: boolean } | null, imgs: Array<{ __typename?: 'AccountImg', id: number, small?: string | null }> };

export type BuyerAnimalInfoFragment = { __typename?: 'Animal', id: number, type: AnimalTypeEnum, name?: string | null, birthday?: any | null, birthdayType?: BirthdayType | null, gender?: GenderEnum | null, sterilized?: boolean | null, size?: AnimalSizeEnum | null, archived: boolean, calved?: boolean | null, sensitivities?: Array<AnimalSensitivityEnum | null> | null, imgs: Array<{ __typename?: 'AnimalImg', id: number, small?: string | null, medium?: string | null }>, dogInfos?: { __typename?: 'DogInfo', id: number, physicalCondition?: DogPhysicalCondition | null, pedigree?: string | null, medicalAffections: Array<{ __typename?: 'DogMedicalAffection', id: number, affectionType: DogMedicalAffectionType }>, dogBreed?: { __typename?: 'DogBreed', id: number, name: string } | null } | null };

export type ArticleCardInfoFragment = { __typename?: 'Article', id: number, reviewed: boolean, coverImg?: string | null, tags: Array<string>, translations: Array<{ __typename?: 'ArticleTranslations', id: number, url: string, title: string }> };

export type BookingCardInfoFragment = { __typename?: 'Booking', id: number, startDateTime: any, endDateTime: any, worker: { __typename?: 'Worker', id: number, fullName?: string | null, pro: { __typename?: 'Professional', id: number, minHoursBeforeUpdateOrCancelBooking: number, type: ProfessionalTypeEnum, email?: string | null, phone?: string | null, mobilePhone?: string | null, imgs: Array<{ __typename?: 'ProImg', id: number, small?: string | null }>, translations: Array<{ __typename?: 'ProTranslation', id: number, language: string, url?: string | null }> } }, bookingAnimals: Array<{ __typename?: 'BookingAnimal', id: number, animal: { __typename?: 'Animal', id: number, type: AnimalTypeEnum, name?: string | null, gender?: GenderEnum | null, birthday?: any | null, imgs: Array<{ __typename?: 'AnimalImg', id: number, small?: string | null }>, dogInfos?: { __typename?: 'DogInfo', id: number, dogBreedId?: number | null } | null } }>, workerService: { __typename?: 'WorkerService', id: number, categoryId: number, service: { __typename?: 'Service', id: number, translations: Array<{ __typename?: 'ServiceTranslation', id: number, language: string, title?: string | null }> } } };

export type BreedCardInfoFragment = { __typename?: 'DogBreed', id: number, name: string, exerciseIndex?: number | null, educationIndex?: number | null, careIndex?: number | null, sociabilityIndex?: number | null, translations: Array<{ __typename?: 'DogBreedTranslation', id: number, name?: string | null, description?: string | null, url?: string | null, language: string }>, imgs: Array<{ __typename?: 'DogBreedImg', id: number, small?: string | null }> };

export type BreedDetailsInfoFragment = { __typename?: 'DogBreed', id: number, headShape?: HeadShape | null, sizeCategory?: AnimalSizeEnum | null, fciGroup?: string | null, homeCountryCode?: string | null, adultSizeAge?: number | null, name: string, baseBreedName?: string | null, careIndex?: number | null, educationIndex?: number | null, sociabilityIndex?: number | null, sortingIndex?: number | null, exerciseIndex?: number | null, robustnessIndex?: number | null, maintenanceIndex?: number | null, hairLossIndex?: number | null, coldToleranceIndex?: number | null, heatToleranceIndex?: number | null, predatoryInstinctIndex?: number | null, barkingTendancyIndex?: number | null, independenceIndex?: number | null, foreignerSociabilityIndex?: number | null, intellectualActivityNeedIndex?: number | null, physicalActivityNeedIndex?: number | null, hairType?: DogHairType | null, imgs: Array<{ __typename?: 'DogBreedImg', id: number, type: DogBreedImgType, small?: string | null, medium?: string | null, large?: string | null }>, translations: Array<{ __typename?: 'DogBreedTranslation', id: number, language: string, description?: string | null, title?: string | null, seoDescription?: string | null, seoKeywords?: string | null, name?: string | null, synologyRank?: string | null, temper?: string | null, historic?: string | null, morphology?: string | null, fragilities?: string | null, advices?: string | null, otherNames: Array<string>, url?: string | null, geneticAnalyzeType?: BreedGeneticAnalyzeType | null, genetics?: Array<string> | null }> };

export type BreederCardInfoFragment = { __typename?: 'DogBreeder', id: number, spokenLanguages: Array<string>, dogsPedigree?: string | null, lastConnectedType?: DogBreederLastConnectedTypeEnum | null, certificationFile?: string | null, breedClubValidated?: boolean | null, account: { __typename?: 'DogBreederAccount', id: number, connectedAt: any, address?: { __typename?: 'Address', id: number, country?: CountryCode | null, region?: string | null } | null }, translations: Array<{ __typename?: 'DogBreederTranslation', id: number, url?: string | null }>, reviews: Array<{ __typename?: 'DogBreederReview', id: number, globalGrade?: number | null, accountId: number }>, imgs: Array<{ __typename?: 'DogBreederImg', id: number, small?: string | null, type: string }>, breederBreeds: Array<{ __typename?: 'DogBreederBreeds', id: number, dogBreed: { __typename?: 'DogBreed', id: number, imgs: Array<{ __typename?: 'DogBreedImg', id: number, medium?: string | null }>, translations: Array<{ __typename?: 'DogBreedTranslation', id: number, name?: string | null }> } }>, litters: Array<{ __typename?: 'Litter', id: number }> };

export type LitterCardInfoFragment = { __typename?: 'Litter', id: number, price?: number | null, priceFrom?: number | null, priceTo?: number | null, fixedPrice?: boolean | null, description?: string | null, birthday?: any | null, availabilityDate?: any | null, born: boolean, pedigree?: string | null, malesLeftCount?: number | null, femalesLeftCount?: number | null, imgs: Array<{ __typename?: 'LitterImg', id: number, small?: string | null, medium?: string | null }>, translations: Array<{ __typename?: 'LitterTranslation', id: number, url?: string | null }>, breeder: { __typename?: 'DogBreeder', id: number, account: { __typename?: 'DogBreederAccount', id: number, address?: { __typename?: 'Address', id: number, region?: string | null, country?: CountryCode | null } | null } }, dogBreed?: { __typename?: 'DogBreed', id: number, name: string, baseBreedName?: string | null, imgs: Array<{ __typename?: 'DogBreedImg', id: number, large?: string | null, type: DogBreedImgType }>, translations: Array<{ __typename?: 'DogBreedTranslation', id: number, name?: string | null }> } | null };

export type ShelterCardInfoFragment = { __typename?: 'DogShelter', id: number, name?: string | null, spokenLanguages: Array<string>, imgs: Array<{ __typename?: 'DogShelterImg', id: number, small?: string | null }>, address?: { __typename?: 'Address', id: number, country?: CountryCode | null, region?: string | null, city?: string | null, zip?: string | null } | null, translations: Array<{ __typename?: 'DogShelterTranslation', id: number, url?: string | null, language?: string | null }> };

export type LogMutationVariables = Exact<{
  data: LogInput;
}>;


export type LogMutation = { __typename?: 'Mutation', log?: boolean | null };

export type CreateApplicationForSuggestedBreederMutationVariables = Exact<{
  data: CreateApplicationInput;
}>;


export type CreateApplicationForSuggestedBreederMutation = { __typename?: 'Mutation', confirmCreateApplication: { __typename?: 'DogBreederApplication', id: number } };

export type ApplicationGetSuggestedBreedersQueryVariables = Exact<{
  where?: InputMaybe<DogBreederWhereInput>;
  orderBy?: InputMaybe<Array<DogBreederOrderByWithRelationAndSearchRelevanceInput> | DogBreederOrderByWithRelationAndSearchRelevanceInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  breederCardInfoTranslationsWhere?: InputMaybe<DogBreederTranslationWhereInput>;
  breederCardInfoTranslationsWhereBreed?: InputMaybe<DogBreedTranslationWhereInput>;
  breederCardInfoBreedImgsTake?: InputMaybe<Scalars['Int']['input']>;
  breederCardInfoLittersWhere?: InputMaybe<LitterWhereInput>;
}>;


export type ApplicationGetSuggestedBreedersQuery = { __typename?: 'Query', findManyDogBreeder?: Array<{ __typename?: 'DogBreeder', id: number, spokenLanguages: Array<string>, dogsPedigree?: string | null, lastConnectedType?: DogBreederLastConnectedTypeEnum | null, certificationFile?: string | null, breedClubValidated?: boolean | null, account: { __typename?: 'DogBreederAccount', id: number, connectedAt: any, address?: { __typename?: 'Address', id: number, country?: CountryCode | null, region?: string | null } | null }, translations: Array<{ __typename?: 'DogBreederTranslation', id: number, url?: string | null }>, reviews: Array<{ __typename?: 'DogBreederReview', id: number, globalGrade?: number | null, accountId: number }>, imgs: Array<{ __typename?: 'DogBreederImg', id: number, small?: string | null, type: string }>, breederBreeds: Array<{ __typename?: 'DogBreederBreeds', id: number, dogBreed: { __typename?: 'DogBreed', id: number, imgs: Array<{ __typename?: 'DogBreedImg', id: number, medium?: string | null }>, translations: Array<{ __typename?: 'DogBreedTranslation', id: number, name?: string | null }> } }>, litters: Array<{ __typename?: 'Litter', id: number }> }> | null };

export type getLocationCountryQueryVariables = Exact<{
  location: Scalars['String']['input'];
}>;


export type getLocationCountryQuery = { __typename?: 'Query', locationCountry?: string | null };

export type ProWorkerGetAvailabilitiesQueryVariables = Exact<{
  fromDate: Scalars['DateTime']['input'];
  proId: Scalars['Int']['input'];
  workerServiceId?: InputMaybe<Scalars['Int']['input']>;
  proServiceId?: InputMaybe<Scalars['String']['input']>;
  forMultiAnimals: Scalars['Boolean']['input'];
}>;


export type ProWorkerGetAvailabilitiesQuery = { __typename?: 'Query', findBookingAvailabilities?: { __typename?: 'BookingAvailabilities', mergedWorkerAvailabilities?: Array<{ __typename?: 'BookingAvailability', startDateTime: any, endDateTime: any, workerServiceIds?: Array<number | null> | null, workerIds?: Array<number | null> | null } | null> | null, nextAvailability?: { __typename?: 'NextAvailability', workerId?: number | null, date?: any | null } | null } | null };

export type BookingSlotPickerGetProQueryVariables = Exact<{
  where: ProfessionalWhereInput;
  serviceLanguage: Scalars['String']['input'];
  translationsWhere?: InputMaybe<ProTranslationWhereInput>;
  serviceTranslationsWhere?: InputMaybe<ServiceTranslationWhereInput>;
  workerServiceTranslationsWhere?: InputMaybe<WorkerServiceTranslationWhereInput>;
}>;


export type BookingSlotPickerGetProQuery = { __typename?: 'Query', searchProfessionals: { __typename?: 'SearchProfessionalsOutput', professionals: Array<{ __typename?: 'Professional', id: number, minHoursBeforeUpdateOrCancelBooking: number, allowsAnyWorkerOption: boolean, acceptedAnimals: Array<AnimalTypeEnum>, onlineBookingEnabled: boolean, type: ProfessionalTypeEnum, workers: Array<{ __typename?: 'Worker', id: number, fullName?: string | null }>, services: Array<{ __typename?: 'ProfessionalService', id: string, bookable?: boolean | null, service: { __typename?: 'Service', id: number, translations: Array<{ __typename?: 'ServiceTranslation', title?: string | null }> }, workerServices: Array<{ __typename?: 'WorkerServiceWithBookingDuration', animalSize?: AnimalSizeEnum | null, animalType?: AnimalTypeEnum | null, id: number, workerId: number, bookable: boolean, multiAnimalsBookingEnabled: boolean, multiAnimalsDuration?: number | null, translations: Array<{ __typename?: 'WorkerServiceTranslation', id: number, preBookingWarning?: string | null }> }> } | null>, translations: Array<{ __typename?: 'ProTranslation', id: number, preBookingWarning?: string | null }> }> } };

export type BreederOverviewGetBreederQueryVariables = Exact<{
  where: DogBreederWhereInput;
  take?: InputMaybe<Scalars['Int']['input']>;
  breedCardInfoTranslationsWhere: DogBreedTranslationWhereInput;
}>;


export type BreederOverviewGetBreederQuery = { __typename?: 'Query', findManyDogBreeder?: Array<{ __typename?: 'DogBreeder', id: number, agreementNumber?: string | null, websiteUrl?: string | null, certificationFile?: string | null, level?: string | null, spokenLanguages: Array<string>, breedingName?: string | null, profileImg?: string | null, lastConnectedType?: DogBreederLastConnectedTypeEnum | null, imgs: Array<{ __typename?: 'DogBreederImg', id: number, small?: string | null, type: string, large?: string | null }>, translations: Array<{ __typename?: 'DogBreederTranslation', id: number, title?: string | null, description?: string | null, seoKeywords?: string | null, dogsActivities?: string | null, puppiesLivingPlace?: string | null, dogsLivingPlace?: string | null, health?: string | null, breederDogsSelection?: string | null, puppiesTraining?: string | null, url?: string | null, language: string }>, account: { __typename?: 'DogBreederAccount', id: number, connectedAt: any, firstName?: string | null, lastName?: string | null, address?: { __typename?: 'Address', id: number, zip?: string | null, city?: string | null, country?: CountryCode | null, street?: string | null } | null }, breederBreeds: Array<{ __typename?: 'DogBreederBreeds', id: number, dogBreed: { __typename?: 'DogBreed', baseBreedName?: string | null, name: string, translations: Array<{ __typename?: 'DogBreedTranslation', id: number, name?: string | null, description?: string | null, url?: string | null, language: string }> } }> }> | null };

export type ContactSendContactMessageMutationVariables = Exact<{
  email: Scalars['String']['input'];
  language: Scalars['String']['input'];
  messageContent: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  contactReasonType: ContactReasonTypeEnum;
  country?: InputMaybe<CountryCode>;
}>;


export type ContactSendContactMessageMutation = { __typename?: 'Mutation', contactSupport?: boolean | null };

export type BreedInterestCreateDogBreedInterestSubscriptionMutationVariables = Exact<{
  data: CreateDogBreedInterestSubscriptionInput;
}>;


export type BreedInterestCreateDogBreedInterestSubscriptionMutation = { __typename?: 'Mutation', createDogBreedInterestSubscription: { __typename?: 'DogBreedInterestSubscription', id: number } };

export type BreederReviewsGetReviewsQueryVariables = Exact<{
  where?: InputMaybe<DogBreederReviewWhereInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  breederWhere?: InputMaybe<DogBreederWhereInput>;
  orderBy: DogBreederReviewOrderByWithRelationAndSearchRelevanceInput;
}>;


export type BreederReviewsGetReviewsQuery = { __typename?: 'Query', findManyDogBreeder?: Array<{ __typename?: 'DogBreeder', id: number, reviews: Array<{ __typename?: 'DogBreederReview', id: number, createdAt: any, globalGrade?: number | null, verified: boolean, description?: string | null, contactType?: DogBreederContactType | null, contactDate?: any | null, reviewerPic?: string | null, reviewerName?: string | null, breederName?: string | null, account: { __typename?: 'Account', id: number, firstName?: string | null, lastName?: string | null, imgs: Array<{ __typename?: 'AccountImg', id: number, small?: string | null }> }, answer?: { __typename?: 'DogBreederReviewAnswer', content: string, createdAt: any } | null, dogBreeder: { __typename?: 'DogBreeder', id: number, profileImg?: string | null } }> }> | null, aggregateDogBreederReview?: { __typename?: 'AggregateDogBreederReview', _count?: { __typename?: 'DogBreederReviewCountAggregateOutputType', _all: number } | null, _avg?: { __typename?: 'DogBreederReviewAvgAggregateOutputType', humanContactGrade?: number | null, hygieneGrade?: number | null, globalGrade?: number | null, dogsWellBeingGrade?: number | null, followUpGrade?: number | null } | null } | null };

export type BreederUpdateReviewMutationVariables = Exact<{
  data: DogBreederReviewUpdateInput;
  reviewId: Scalars['Int']['input'];
}>;


export type BreederUpdateReviewMutation = { __typename?: 'Mutation', updateDogBreederReview: { __typename?: 'DogBreederReview', id: number } };

export type FooterGetBreedsQueryVariables = Exact<{
  where?: InputMaybe<DogBreedWhereInput>;
  breedCardInfoTranslationsWhere?: InputMaybe<DogBreedTranslationWhereInput>;
  randomOrder?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type FooterGetBreedsQuery = { __typename?: 'Query', findManyDogBreed?: Array<{ __typename?: 'DogBreed', id: number, name: string, baseBreedName?: string | null, translations: Array<{ __typename?: 'DogBreedTranslation', id: number, name?: string | null, url?: string | null, language: string }>, _count: { __typename?: 'DogBreedCountOutputType', dogBreeders: number, litters: number } }> | null };

export type JoinProSendContactMessageMutationVariables = Exact<{
  email: Scalars['String']['input'];
  language: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  messageContent?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  contactReasonType: ContactReasonTypeEnum;
}>;


export type JoinProSendContactMessageMutation = { __typename?: 'Mutation', contactSupport?: boolean | null };

export type MtApplicationsBuyerCheckoutApplicationMutationVariables = Exact<{
  input: CheckoutApplicationInput;
}>;


export type MtApplicationsBuyerCheckoutApplicationMutation = { __typename?: 'Mutation', checkoutApplication: string };

export type ApplicationGetApplicationQueryVariables = Exact<{
  where: DogBreederApplicationWhereUniqueInput;
}>;


export type ApplicationGetApplicationQuery = { __typename?: 'Query', findUniqueApplication?: { __typename?: 'DogBreederApplication', id: number, status: DogBreederApplicationStatus, animal?: { __typename?: 'Animal', id: number, birthday?: any | null, gender?: GenderEnum | null, name?: string | null, dogInfos?: { __typename?: 'DogInfo', id: number, dogBreedId?: number | null } | null } | null } | null };

export type MtApplicationsOwnApplicationMutationVariables = Exact<{
  data: OwnApplicationInput;
}>;


export type MtApplicationsOwnApplicationMutation = { __typename?: 'Mutation', ownApplication: { __typename?: 'DogBreederApplication', id: number, status: DogBreederApplicationStatus } };

export type MtApplicationsWaitlistApplicationMutationVariables = Exact<{
  data: WaitlistApplicationInput;
}>;


export type MtApplicationsWaitlistApplicationMutation = { __typename?: 'Mutation', waitlistApplication: { __typename?: 'DogBreederApplication', id: number, status: DogBreederApplicationStatus } };

export type MtNotificationsGetNotificationsQueryVariables = Exact<{
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<NotificationWhereInput>;
  orderBy?: InputMaybe<NotificationOrderByWithRelationAndSearchRelevanceInput>;
}>;


export type MtNotificationsGetNotificationsQuery = { __typename?: 'Query', findManyNotification: { __typename?: 'Notifications', count: number, unreadMessagesCount: number, items: Array<{ __typename?: 'Notification', id: number, createdAt: any, type: NotificationType, success: boolean, applicationId?: number | null, litterId?: number | null, account?: { __typename?: 'Account', id: number, language: string } | null, breeder?: { __typename?: 'DogBreeder', id: number, displayName?: string | null, translations: Array<{ __typename?: 'DogBreederTranslation', language: string, url?: string | null }> } | null, application?: { __typename?: 'DogBreederApplication', dogBreeder: { __typename?: 'DogBreeder', displayName?: string | null }, account: { __typename?: 'DogBreederApplicationAccount', name?: string | null, firstName?: string | null, lastName?: string | null, language?: string | null }, breedPreference: { __typename?: 'DogBreed', translations: Array<{ __typename?: 'DogBreedTranslation', name?: string | null, language: string }> } } | null } | null> } };

export type MtNotificationMarkAsReadMutationVariables = Exact<{
  notificationId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type MtNotificationMarkAsReadMutation = { __typename?: 'Mutation', markAsRead: number };

export type AccountNewNotificationsCountQueryVariables = Exact<{ [key: string]: never; }>;


export type AccountNewNotificationsCountQuery = { __typename?: 'Query', newNotificationsCount: number };

export type MtSocialProvidersAccountProvidersQueryVariables = Exact<{ [key: string]: never; }>;


export type MtSocialProvidersAccountProvidersQuery = { __typename?: 'Query', accountMe?: { __typename?: 'Account', id: number, googleId?: string | null, firebaseId?: string | null, facebookId?: string | null } | null };

export type MtSocialProvidersLinkAccountMutationVariables = Exact<{
  email?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  googleToken?: InputMaybe<Scalars['String']['input']>;
  facebookToken?: InputMaybe<Scalars['String']['input']>;
}>;


export type MtSocialProvidersLinkAccountMutation = { __typename?: 'Mutation', linkAccount: { __typename?: 'Account', id: number } };

export type MtSocialProvidersUnlinkAccountMutationVariables = Exact<{
  type: AuthTokenInfoType;
}>;


export type MtSocialProvidersUnlinkAccountMutation = { __typename?: 'Mutation', unlinkAccount: { __typename?: 'Account', id: number } };

export type UpdateLitterModalCountLittersQueryVariables = Exact<{
  where?: InputMaybe<LitterWhereInput>;
}>;


export type UpdateLitterModalCountLittersQuery = { __typename?: 'Query', aggregateLitter?: { __typename?: 'AggregateLitter', _count?: { __typename?: 'LitterCountAggregateOutputType', _all: number } | null } | null };

export type OldProRedirectionGetProQueryVariables = Exact<{
  where: ProfessionalWhereInput;
  translationsWhere: ProTranslationWhereInput;
}>;


export type OldProRedirectionGetProQuery = { __typename?: 'Query', searchProfessionals: { __typename?: 'SearchProfessionalsOutput', professionals: Array<{ __typename?: 'Professional', id: number, type: ProfessionalTypeEnum, translations: Array<{ __typename?: 'ProTranslation', id: number, url?: string | null }> }> } };

export type ToggleDogBreedInterestToSubscriptionMutationVariables = Exact<{
  data: ToggleDogBreedInDogBreedInterestSubscriptionInput;
}>;


export type ToggleDogBreedInterestToSubscriptionMutation = { __typename?: 'Mutation', toggleDogBreedInDogBreedInterestSubscription: { __typename?: 'DogBreedInterestSubscription', id: number } };

export type BreederGetWhatsappInfoQueryVariables = Exact<{
  where: DogBreederWhereInput;
}>;


export type BreederGetWhatsappInfoQuery = { __typename?: 'Query', findManyDogBreeder?: Array<{ __typename?: 'DogBreeder', id: number, whatsappNumber?: string | null, profileImg?: string | null, spokenLanguages: Array<string>, account: { __typename?: 'DogBreederAccount', id: number, address?: { __typename?: 'Address', id: number, city?: string | null, country?: CountryCode | null } | null }, breederBreeds: Array<{ __typename?: 'DogBreederBreeds', id: number, dogBreed: { __typename?: 'DogBreed', id: number, baseBreedName?: string | null, name: string, translations: Array<{ __typename?: 'DogBreedTranslation', id: number, language: string, name?: string | null }> } }> }> | null };

export type ProGetWhatsappInfoQueryVariables = Exact<{
  where: ProfessionalWhereInput;
}>;


export type ProGetWhatsappInfoQuery = { __typename?: 'Query', searchProfessionals: { __typename?: 'SearchProfessionalsOutput', professionals: Array<{ __typename?: 'Professional', id: number, whatsappNumber?: string | null, type: ProfessionalTypeEnum, imgs: Array<{ __typename?: 'ProImg', id: number, small?: string | null }>, translations: Array<{ __typename?: 'ProTranslation', id: number, language: string, title?: string | null }> }> } };

export type LinkProCalendarMutationMutationVariables = Exact<{
  code: Scalars['String']['input'];
}>;


export type LinkProCalendarMutationMutation = { __typename?: 'Mutation', linkProfessionalCalendar?: boolean | null };

export type ProfessionalCalendarRequestAccessUrlQueryVariables = Exact<{ [key: string]: never; }>;


export type ProfessionalCalendarRequestAccessUrlQuery = { __typename?: 'Query', professionalCalendarRequestAccessUrl: string };

export type ApplicationConfirmCreateApplicationMutationVariables = Exact<{
  data: CreateApplicationInput;
}>;


export type ApplicationConfirmCreateApplicationMutation = { __typename?: 'Mutation', confirmCreateApplication: { __typename?: 'DogBreederApplication', id: number } };

export type ApplicationCreateDraftApplicationMutationVariables = Exact<{
  data: CreateApplicationInput;
}>;


export type ApplicationCreateDraftApplicationMutation = { __typename?: 'Mutation', createDraftApplication: { __typename?: 'DogBreederApplication', id: number } };

export type ApplicationGetBreederQueryVariables = Exact<{
  where: DogBreederWhereUniqueInput;
  translationsWhere: DogBreederTranslationWhereInput;
  breederCardInfoTranslationsWhereBreed: DogBreedTranslationWhereInput;
}>;


export type ApplicationGetBreederQuery = { __typename?: 'Query', findUniqueDogBreeder?: { __typename?: 'DogBreeder', id: number, spokenLanguages: Array<string>, translations: Array<{ __typename?: 'DogBreederTranslation', id: number, url?: string | null }>, breederBreeds: Array<{ __typename?: 'DogBreederBreeds', id: number, dogBreed: { __typename?: 'DogBreed', id: number, translations: Array<{ __typename?: 'DogBreedTranslation', id: number, name?: string | null }> } }> } | null };

export type ApplicationGetLatestApplicationQueryVariables = Exact<{
  where?: InputMaybe<DogBreederApplicationWhereInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<DogBreederApplicationOrderByWithRelationAndSearchRelevanceInput>;
}>;


export type ApplicationGetLatestApplicationQuery = { __typename?: 'Query', accountMe?: { __typename?: 'Account', id: number, applications: Array<{ __typename?: 'DogBreederApplication', id: number, motive?: string | null, otherAnimals: Array<DogBreederApplicationOtherAnimal>, accommodation: DogBreederApplicationAccommodation, experiences: Array<DogBreederApplicationExperience>, timeAlone: DogBreederApplicationTimeAlone, trainers: Array<DogBreederApplicationTrainer>, genderPreferences: Array<GenderEnum>, otherPreferences?: string | null, status: DogBreederApplicationStatus, questions?: string | null, breedPreference: { __typename?: 'DogBreed', id: number } }> } | null };

export type ArticlesGetArticlesQueryVariables = Exact<{
  where?: InputMaybe<ArticleWhereInput>;
  orderBy?: InputMaybe<Array<ArticleOrderByWithRelationAndSearchRelevanceInput> | ArticleOrderByWithRelationAndSearchRelevanceInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  articleCardInfoTranslationsWhere?: InputMaybe<ArticleTranslationsWhereInput>;
}>;


export type ArticlesGetArticlesQuery = { __typename?: 'Query', aggregateArticle?: { __typename?: 'AggregateArticle', _count?: { __typename?: 'ArticleCountAggregateOutputType', _all: number } | null } | null, findManyArticle?: Array<{ __typename?: 'Article', id: number, reviewed: boolean, coverImg?: string | null, tags: Array<string>, translations: Array<{ __typename?: 'ArticleTranslations', id: number, url: string, title: string }> }> | null };

export type ArticleGetArticleQueryVariables = Exact<{
  where: ArticleWhereInput;
  take?: InputMaybe<Scalars['Int']['input']>;
  translationsWhere?: InputMaybe<ArticleTranslationsWhereInput>;
  takeArticles?: InputMaybe<Scalars['Int']['input']>;
  articlesWhere?: InputMaybe<ArticleWhereInput>;
  articleCardInfoTranslationsWhere?: InputMaybe<ArticleTranslationsWhereInput>;
}>;


export type ArticleGetArticleQuery = { __typename?: 'Query', article?: Array<{ __typename?: 'Article', id: number, reviewed: boolean, coverImg?: string | null, createdAt: any, authorName?: string | null, tags: Array<string>, translations: Array<{ __typename?: 'ArticleTranslations', id: number, url: string, title: string, content: string, seoKeywords?: string | null, seoTitle?: string | null, seoDescription?: string | null, languageCode: LanguageCode }> }> | null, articles?: Array<{ __typename?: 'Article', id: number, reviewed: boolean, coverImg?: string | null, tags: Array<string>, translations: Array<{ __typename?: 'ArticleTranslations', id: number, url: string, title: string }> }> | null };

export type CreateBookingMutationVariables = Exact<{
  workerServiceId: Scalars['Int']['input'];
  bookingReason: Scalars['String']['input'];
  startDateTime: Scalars['DateTime']['input'];
  bookingCardInfoProTranslationsWhere: ProTranslationWhereInput;
  bookingCardInfoServiceTranslationsWhere: ServiceTranslationWhereInput;
  bookingAnimals: Array<BookingAnimalCreate> | BookingAnimalCreate;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  forMultiAnimals?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateBookingMutation = { __typename?: 'Mutation', createBooking: { __typename?: 'Booking', id: number, startDateTime: any, endDateTime: any, worker: { __typename?: 'Worker', id: number, fullName?: string | null, pro: { __typename?: 'Professional', id: number, minHoursBeforeUpdateOrCancelBooking: number, type: ProfessionalTypeEnum, email?: string | null, phone?: string | null, mobilePhone?: string | null, imgs: Array<{ __typename?: 'ProImg', id: number, small?: string | null }>, translations: Array<{ __typename?: 'ProTranslation', id: number, language: string, url?: string | null }> } }, bookingAnimals: Array<{ __typename?: 'BookingAnimal', id: number, animal: { __typename?: 'Animal', id: number, type: AnimalTypeEnum, name?: string | null, gender?: GenderEnum | null, birthday?: any | null, imgs: Array<{ __typename?: 'AnimalImg', id: number, small?: string | null }>, dogInfos?: { __typename?: 'DogInfo', id: number, dogBreedId?: number | null } | null } }>, workerService: { __typename?: 'WorkerService', id: number, categoryId: number, service: { __typename?: 'Service', id: number, translations: Array<{ __typename?: 'ServiceTranslation', id: number, language: string, title?: string | null }> } } } };

export type BookingGetProQueryVariables = Exact<{
  where: ProfessionalWhereInput;
  language: Scalars['String']['input'];
}>;


export type BookingGetProQuery = { __typename?: 'Query', searchProfessionals: { __typename?: 'SearchProfessionalsOutput', professionals: Array<{ __typename?: 'Professional', id: number, type: ProfessionalTypeEnum, acceptedAnimals: Array<AnimalTypeEnum>, onlineBookingEnabled: boolean, imgs: Array<{ __typename?: 'ProImg', id: number, small?: string | null }>, address?: { __typename?: 'Address', id: number, zip?: string | null, city?: string | null } | null, translations: Array<{ __typename?: 'ProTranslation', id: number, language: string, title?: string | null, preBookingWarning?: string | null }>, workers: Array<{ __typename?: 'Worker', id: number, fullName?: string | null }>, services: Array<{ __typename?: 'ProfessionalService', id: string, service: { __typename?: 'Service', id: number, translations: Array<{ __typename?: 'ServiceTranslation', id: number, language: string, title?: string | null }> }, workerServices: Array<{ __typename?: 'WorkerServiceWithBookingDuration', id: number, bookingDuration: number, multiAnimalsBookingEnabled: boolean, multiAnimalsDuration?: number | null, price?: number | null, priceType?: WorkerServicePriceType | null, priceFrom?: number | null, priceTo?: number | null, translations: Array<{ __typename?: 'WorkerServiceTranslation', id: number, language: string, preBookingWarning?: string | null }> }> } | null> }> } };

export type BreedComparatorGetBreedsQueryVariables = Exact<{
  where?: InputMaybe<DogBreedWhereInput>;
}>;


export type BreedComparatorGetBreedsQuery = { __typename?: 'Query', findManyDogBreed?: Array<{ __typename?: 'DogBreed', id: number, headShape?: HeadShape | null, sizeCategory?: AnimalSizeEnum | null, fciGroup?: string | null, homeCountryCode?: string | null, adultSizeAge?: number | null, name: string, baseBreedName?: string | null, careIndex?: number | null, educationIndex?: number | null, sociabilityIndex?: number | null, sortingIndex?: number | null, exerciseIndex?: number | null, robustnessIndex?: number | null, maintenanceIndex?: number | null, hairLossIndex?: number | null, coldToleranceIndex?: number | null, heatToleranceIndex?: number | null, predatoryInstinctIndex?: number | null, barkingTendancyIndex?: number | null, independenceIndex?: number | null, foreignerSociabilityIndex?: number | null, intellectualActivityNeedIndex?: number | null, physicalActivityNeedIndex?: number | null, hairType?: DogHairType | null, imgs: Array<{ __typename?: 'DogBreedImg', id: number, type: DogBreedImgType, small?: string | null, medium?: string | null, large?: string | null }>, translations: Array<{ __typename?: 'DogBreedTranslation', id: number, language: string, description?: string | null, title?: string | null, seoDescription?: string | null, seoKeywords?: string | null, name?: string | null, synologyRank?: string | null, temper?: string | null, historic?: string | null, morphology?: string | null, fragilities?: string | null, advices?: string | null, otherNames: Array<string>, url?: string | null, geneticAnalyzeType?: BreedGeneticAnalyzeType | null, genetics?: Array<string> | null }> }> | null };

export type BreedsGetBreedsQueryVariables = Exact<{
  orderBy?: InputMaybe<Array<DogBreedOrderByWithRelationAndSearchRelevanceInput> | DogBreedOrderByWithRelationAndSearchRelevanceInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DogBreedWhereInput>;
  breedCardInfoTranslationsWhere?: InputMaybe<DogBreedTranslationWhereInput>;
}>;


export type BreedsGetBreedsQuery = { __typename?: 'Query', findManyDogBreed?: Array<{ __typename?: 'DogBreed', id: number, name: string, exerciseIndex?: number | null, educationIndex?: number | null, careIndex?: number | null, sociabilityIndex?: number | null, translations: Array<{ __typename?: 'DogBreedTranslation', id: number, name?: string | null, description?: string | null, url?: string | null, language: string }>, imgs: Array<{ __typename?: 'DogBreedImg', id: number, small?: string | null }> }> | null, aggregateDogBreed?: { __typename?: 'AggregateDogBreed', _count?: { __typename?: 'DogBreedCountAggregateOutputType', _all: number } | null } | null };

export type BreedListGetAllBreedsQueryVariables = Exact<{
  where?: InputMaybe<DogBreedWhereInput>;
  translationsWhere?: InputMaybe<DogBreedTranslationWhereInput>;
}>;


export type BreedListGetAllBreedsQuery = { __typename?: 'Query', findManyDogBreed?: Array<{ __typename?: 'DogBreed', id: number, name: string, baseBreedName?: string | null, translations: Array<{ __typename?: 'DogBreedTranslation', id: number, name?: string | null, otherNames: Array<string>, url?: string | null }>, imgs: Array<{ __typename?: 'DogBreedImg', id: number, small?: string | null }> }> | null };

export type BreedGetBreedQueryVariables = Exact<{
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DogBreedWhereInput>;
}>;


export type BreedGetBreedQuery = { __typename?: 'Query', findManyDogBreed?: Array<{ __typename?: 'DogBreed', id: number, headShape?: HeadShape | null, sizeCategory?: AnimalSizeEnum | null, fciGroup?: string | null, homeCountryCode?: string | null, adultSizeAge?: number | null, name: string, baseBreedName?: string | null, careIndex?: number | null, educationIndex?: number | null, sociabilityIndex?: number | null, sortingIndex?: number | null, exerciseIndex?: number | null, robustnessIndex?: number | null, maintenanceIndex?: number | null, hairLossIndex?: number | null, coldToleranceIndex?: number | null, heatToleranceIndex?: number | null, predatoryInstinctIndex?: number | null, barkingTendancyIndex?: number | null, independenceIndex?: number | null, foreignerSociabilityIndex?: number | null, intellectualActivityNeedIndex?: number | null, physicalActivityNeedIndex?: number | null, hairType?: DogHairType | null, imgs: Array<{ __typename?: 'DogBreedImg', id: number, type: DogBreedImgType, small?: string | null, medium?: string | null, large?: string | null }>, translations: Array<{ __typename?: 'DogBreedTranslation', id: number, language: string, description?: string | null, title?: string | null, seoDescription?: string | null, seoKeywords?: string | null, name?: string | null, synologyRank?: string | null, temper?: string | null, historic?: string | null, morphology?: string | null, fragilities?: string | null, advices?: string | null, otherNames: Array<string>, url?: string | null, geneticAnalyzeType?: BreedGeneticAnalyzeType | null, genetics?: Array<string> | null }> }> | null };

export type BreedGetBreedersQueryVariables = Exact<{
  where?: InputMaybe<DogBreederWhereInput>;
  orderBy?: InputMaybe<Array<DogBreederOrderByWithRelationAndSearchRelevanceInput> | DogBreederOrderByWithRelationAndSearchRelevanceInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  breederCardInfoTranslationsWhere?: InputMaybe<DogBreederTranslationWhereInput>;
  breederCardInfoTranslationsWhereBreed?: InputMaybe<DogBreedTranslationWhereInput>;
  breederCardInfoBreedImgsTake?: InputMaybe<Scalars['Int']['input']>;
  breederCardInfoLittersWhere?: InputMaybe<LitterWhereInput>;
}>;


export type BreedGetBreedersQuery = { __typename?: 'Query', findManyDogBreeder?: Array<{ __typename?: 'DogBreeder', id: number, spokenLanguages: Array<string>, dogsPedigree?: string | null, lastConnectedType?: DogBreederLastConnectedTypeEnum | null, certificationFile?: string | null, breedClubValidated?: boolean | null, account: { __typename?: 'DogBreederAccount', id: number, connectedAt: any, address?: { __typename?: 'Address', id: number, country?: CountryCode | null, region?: string | null } | null }, translations: Array<{ __typename?: 'DogBreederTranslation', id: number, url?: string | null }>, reviews: Array<{ __typename?: 'DogBreederReview', id: number, globalGrade?: number | null, accountId: number }>, imgs: Array<{ __typename?: 'DogBreederImg', id: number, small?: string | null, type: string }>, breederBreeds: Array<{ __typename?: 'DogBreederBreeds', id: number, dogBreed: { __typename?: 'DogBreed', id: number, imgs: Array<{ __typename?: 'DogBreedImg', id: number, medium?: string | null }>, translations: Array<{ __typename?: 'DogBreedTranslation', id: number, name?: string | null }> } }>, litters: Array<{ __typename?: 'Litter', id: number }> }> | null };

export type BreedGetLittersQueryVariables = Exact<{
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<LitterWhereInput>;
  orderBy?: InputMaybe<Array<LitterOrderByWithRelationAndSearchRelevanceInput> | LitterOrderByWithRelationAndSearchRelevanceInput>;
  litterCardInfoImgsTake: Scalars['Int']['input'];
  litterCardInfoTranslationsWhere: LitterTranslationWhereInput;
  litterCardInfoBreedTranslationsWhere: DogBreedTranslationWhereInput;
}>;


export type BreedGetLittersQuery = { __typename?: 'Query', findManyLitter?: Array<{ __typename?: 'Litter', id: number, price?: number | null, priceFrom?: number | null, priceTo?: number | null, fixedPrice?: boolean | null, description?: string | null, birthday?: any | null, availabilityDate?: any | null, born: boolean, pedigree?: string | null, malesLeftCount?: number | null, femalesLeftCount?: number | null, imgs: Array<{ __typename?: 'LitterImg', id: number, small?: string | null, medium?: string | null }>, translations: Array<{ __typename?: 'LitterTranslation', id: number, url?: string | null }>, breeder: { __typename?: 'DogBreeder', id: number, account: { __typename?: 'DogBreederAccount', id: number, address?: { __typename?: 'Address', id: number, region?: string | null, country?: CountryCode | null } | null } }, dogBreed?: { __typename?: 'DogBreed', id: number, name: string, baseBreedName?: string | null, imgs: Array<{ __typename?: 'DogBreedImg', id: number, large?: string | null, type: DogBreedImgType }>, translations: Array<{ __typename?: 'DogBreedTranslation', id: number, name?: string | null }> } | null }> | null };

export type BreederLinksGetBreedsQueryVariables = Exact<{
  where?: InputMaybe<DogBreedWhereInput>;
  translationsWhere?: InputMaybe<DogBreedTranslationWhereInput>;
}>;


export type BreederLinksGetBreedsQuery = { __typename?: 'Query', findManyDogBreed?: Array<{ __typename?: 'DogBreed', id: number, name: string, sizeCategory?: AnimalSizeEnum | null, baseBreedName?: string | null, translations: Array<{ __typename?: 'DogBreedTranslation', id: number, name?: string | null, otherNames: Array<string> }> }> | null };

export type BreederListGetBreedersQueryVariables = Exact<{
  where?: InputMaybe<DogBreederWhereInput>;
  orderBy?: InputMaybe<Array<DogBreederOrderByWithRelationAndSearchRelevanceInput> | DogBreederOrderByWithRelationAndSearchRelevanceInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  breederCardInfoTranslationsWhere?: InputMaybe<DogBreederTranslationWhereInput>;
  breederCardInfoTranslationsWhereBreed?: InputMaybe<DogBreedTranslationWhereInput>;
  breederCardInfoLittersWhere?: InputMaybe<LitterWhereInput>;
  breederCardInfoBreedImgsTake?: InputMaybe<Scalars['Int']['input']>;
}>;


export type BreederListGetBreedersQuery = { __typename?: 'Query', findManyDogBreeder?: Array<{ __typename?: 'DogBreeder', id: number, spokenLanguages: Array<string>, dogsPedigree?: string | null, lastConnectedType?: DogBreederLastConnectedTypeEnum | null, certificationFile?: string | null, breedClubValidated?: boolean | null, account: { __typename?: 'DogBreederAccount', id: number, connectedAt: any, address?: { __typename?: 'Address', id: number, country?: CountryCode | null, region?: string | null } | null }, translations: Array<{ __typename?: 'DogBreederTranslation', id: number, url?: string | null }>, reviews: Array<{ __typename?: 'DogBreederReview', id: number, globalGrade?: number | null, accountId: number }>, imgs: Array<{ __typename?: 'DogBreederImg', id: number, small?: string | null, type: string }>, breederBreeds: Array<{ __typename?: 'DogBreederBreeds', id: number, dogBreed: { __typename?: 'DogBreed', id: number, imgs: Array<{ __typename?: 'DogBreedImg', id: number, medium?: string | null }>, translations: Array<{ __typename?: 'DogBreedTranslation', id: number, name?: string | null }> } }>, litters: Array<{ __typename?: 'Litter', id: number }> }> | null, aggregateDogBreeder?: { __typename?: 'AggregateDogBreeder', _count?: { __typename?: 'DogBreederCountAggregateOutputType', _all: number } | null } | null };

export type BreederListGetLittersQueryVariables = Exact<{
  where?: InputMaybe<LitterWhereInput>;
  orderBy?: InputMaybe<Array<LitterOrderByWithRelationAndSearchRelevanceInput> | LitterOrderByWithRelationAndSearchRelevanceInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  litterCardInfoTranslationsWhere?: InputMaybe<LitterTranslationWhereInput>;
  litterCardInfoBreedTranslationsWhere?: InputMaybe<DogBreedTranslationWhereInput>;
  litterCardInfoImgsTake: Scalars['Int']['input'];
}>;


export type BreederListGetLittersQuery = { __typename?: 'Query', findManyLitter?: Array<{ __typename?: 'Litter', id: number, price?: number | null, priceFrom?: number | null, priceTo?: number | null, fixedPrice?: boolean | null, description?: string | null, birthday?: any | null, availabilityDate?: any | null, born: boolean, pedigree?: string | null, malesLeftCount?: number | null, femalesLeftCount?: number | null, imgs: Array<{ __typename?: 'LitterImg', id: number, small?: string | null, medium?: string | null }>, translations: Array<{ __typename?: 'LitterTranslation', id: number, url?: string | null }>, breeder: { __typename?: 'DogBreeder', id: number, account: { __typename?: 'DogBreederAccount', id: number, address?: { __typename?: 'Address', id: number, region?: string | null, country?: CountryCode | null } | null } }, dogBreed?: { __typename?: 'DogBreed', id: number, name: string, baseBreedName?: string | null, imgs: Array<{ __typename?: 'DogBreedImg', id: number, large?: string | null, type: DogBreedImgType }>, translations: Array<{ __typename?: 'DogBreedTranslation', id: number, name?: string | null }> } | null }> | null, aggregateLitter?: { __typename?: 'AggregateLitter', _count?: { __typename?: 'LitterCountAggregateOutputType', _all: number } | null } | null };

export type BreederGetBreederQueryVariables = Exact<{
  where: DogBreederWhereInput;
  take?: InputMaybe<Scalars['Int']['input']>;
  littersWhere?: InputMaybe<LitterWhereInput>;
  applicationsWhere: DogBreederApplicationWhereInput;
  breedCardInfoTranslationsWhere: DogBreedTranslationWhereInput;
  litterCardInfoImgsTake: Scalars['Int']['input'];
  litterCardInfoTranslationsWhere: LitterTranslationWhereInput;
  litterCardInfoBreedTranslationsWhere: DogBreedTranslationWhereInput;
}>;


export type BreederGetBreederQuery = { __typename?: 'Query', findManyDogBreeder?: Array<{ __typename?: 'DogBreeder', id: number, displayName?: string | null, whatsappNumber?: string | null, certified?: boolean | null, public?: boolean | null, dogsPedigree?: string | null, puppiesBirthPlace?: string | null, agreementNumber?: string | null, websiteUrl?: string | null, certificationFile?: string | null, level?: string | null, spokenLanguages: Array<string>, breedingName?: string | null, profileImg?: string | null, lastConnectedType?: DogBreederLastConnectedTypeEnum | null, imgs: Array<{ __typename?: 'DogBreederImg', id: number, small?: string | null, medium?: string | null, type: string, large?: string | null }>, translations: Array<{ __typename?: 'DogBreederTranslation', id: number, title?: string | null, description?: string | null, seoKeywords?: string | null, dogsActivities?: string | null, puppiesLivingPlace?: string | null, dogsLivingPlace?: string | null, health?: string | null, breederDogsSelection?: string | null, puppiesTraining?: string | null, url?: string | null, language: string }>, account: { __typename?: 'DogBreederAccount', id: number, connectedAt: any, firstName?: string | null, lastName?: string | null, language?: string | null, address?: { __typename?: 'Address', id: number, zip?: string | null, city?: string | null, country?: CountryCode | null, street?: string | null, region?: string | null } | null }, reviews: Array<{ __typename?: 'DogBreederReview', accountId: number, id: number, globalGrade?: number | null }>, breederBreeds: Array<{ __typename?: 'DogBreederBreeds', id: number, dogBreed: { __typename?: 'DogBreed', id: number, isSubBreed: boolean, baseBreedName?: string | null, name: string, exerciseIndex?: number | null, educationIndex?: number | null, careIndex?: number | null, sociabilityIndex?: number | null, translations: Array<{ __typename?: 'DogBreedTranslation', id: number, name?: string | null, description?: string | null, url?: string | null, language: string }>, imgs: Array<{ __typename?: 'DogBreedImg', id: number, small?: string | null }> } }>, litters: Array<{ __typename?: 'Litter', id: number, price?: number | null, priceFrom?: number | null, priceTo?: number | null, fixedPrice?: boolean | null, description?: string | null, birthday?: any | null, availabilityDate?: any | null, born: boolean, pedigree?: string | null, malesLeftCount?: number | null, femalesLeftCount?: number | null, imgs: Array<{ __typename?: 'LitterImg', id: number, small?: string | null, medium?: string | null }>, translations: Array<{ __typename?: 'LitterTranslation', id: number, url?: string | null }>, breeder: { __typename?: 'DogBreeder', id: number, account: { __typename?: 'DogBreederAccount', id: number, address?: { __typename?: 'Address', id: number, region?: string | null, country?: CountryCode | null } | null } }, dogBreed?: { __typename?: 'DogBreed', id: number, name: string, baseBreedName?: string | null, imgs: Array<{ __typename?: 'DogBreedImg', id: number, large?: string | null, type: DogBreedImgType }>, translations: Array<{ __typename?: 'DogBreedTranslation', id: number, name?: string | null }> } | null }>, applications: Array<{ __typename?: 'DogBreederApplication', id: number }> }> | null };

export type BreederGetBreedersQueryVariables = Exact<{
  where?: InputMaybe<DogBreederWhereInput>;
  orderBy?: InputMaybe<Array<DogBreederOrderByWithRelationAndSearchRelevanceInput> | DogBreederOrderByWithRelationAndSearchRelevanceInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  breederCardInfoTranslationsWhere?: InputMaybe<DogBreederTranslationWhereInput>;
  breederCardInfoTranslationsWhereBreed?: InputMaybe<DogBreedTranslationWhereInput>;
  breederCardInfoBreedImgsTake?: InputMaybe<Scalars['Int']['input']>;
  breederCardInfoLittersWhere?: InputMaybe<LitterWhereInput>;
}>;


export type BreederGetBreedersQuery = { __typename?: 'Query', findManyDogBreeder?: Array<{ __typename?: 'DogBreeder', id: number, spokenLanguages: Array<string>, dogsPedigree?: string | null, lastConnectedType?: DogBreederLastConnectedTypeEnum | null, certificationFile?: string | null, breedClubValidated?: boolean | null, account: { __typename?: 'DogBreederAccount', id: number, connectedAt: any, address?: { __typename?: 'Address', id: number, country?: CountryCode | null, region?: string | null } | null }, translations: Array<{ __typename?: 'DogBreederTranslation', id: number, url?: string | null }>, reviews: Array<{ __typename?: 'DogBreederReview', id: number, globalGrade?: number | null, accountId: number }>, imgs: Array<{ __typename?: 'DogBreederImg', id: number, small?: string | null, type: string }>, breederBreeds: Array<{ __typename?: 'DogBreederBreeds', id: number, dogBreed: { __typename?: 'DogBreed', id: number, imgs: Array<{ __typename?: 'DogBreedImg', id: number, medium?: string | null }>, translations: Array<{ __typename?: 'DogBreedTranslation', id: number, name?: string | null }> } }>, litters: Array<{ __typename?: 'Litter', id: number }> }> | null };

export type BreederGetLittersQueryVariables = Exact<{
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<LitterWhereInput>;
  orderBy?: InputMaybe<Array<LitterOrderByWithRelationAndSearchRelevanceInput> | LitterOrderByWithRelationAndSearchRelevanceInput>;
  litterCardInfoImgsTake: Scalars['Int']['input'];
  litterCardInfoTranslationsWhere: LitterTranslationWhereInput;
  litterCardInfoBreedTranslationsWhere: DogBreedTranslationWhereInput;
}>;


export type BreederGetLittersQuery = { __typename?: 'Query', findManyLitter?: Array<{ __typename?: 'Litter', id: number, price?: number | null, priceFrom?: number | null, priceTo?: number | null, fixedPrice?: boolean | null, description?: string | null, birthday?: any | null, availabilityDate?: any | null, born: boolean, pedigree?: string | null, malesLeftCount?: number | null, femalesLeftCount?: number | null, imgs: Array<{ __typename?: 'LitterImg', id: number, small?: string | null, medium?: string | null }>, translations: Array<{ __typename?: 'LitterTranslation', id: number, url?: string | null }>, breeder: { __typename?: 'DogBreeder', id: number, account: { __typename?: 'DogBreederAccount', id: number, address?: { __typename?: 'Address', id: number, region?: string | null, country?: CountryCode | null } | null } }, dogBreed?: { __typename?: 'DogBreed', id: number, name: string, baseBreedName?: string | null, imgs: Array<{ __typename?: 'DogBreedImg', id: number, large?: string | null, type: DogBreedImgType }>, translations: Array<{ __typename?: 'DogBreedTranslation', id: number, name?: string | null }> } | null }> | null };

export type BreederGetReviewsQueryVariables = Exact<{
  where?: InputMaybe<DogBreederReviewWhereInput>;
}>;


export type BreederGetReviewsQuery = { __typename?: 'Query', aggregateDogBreederReview?: { __typename?: 'AggregateDogBreederReview', _count?: { __typename?: 'DogBreederReviewCountAggregateOutputType', _all: number } | null, _avg?: { __typename?: 'DogBreederReviewAvgAggregateOutputType', humanContactGrade?: number | null, hygieneGrade?: number | null, globalGrade?: number | null, dogsWellBeingGrade?: number | null, followUpGrade?: number | null } | null } | null };

export type BreederRelatedLinksGetArticlesQueryVariables = Exact<{
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ArticleWhereInput>;
  translationsWhere?: InputMaybe<ArticleTranslationsWhereInput>;
}>;


export type BreederRelatedLinksGetArticlesQuery = { __typename?: 'Query', findManyArticle?: Array<{ __typename?: 'Article', id: number, translations: Array<{ __typename?: 'ArticleTranslations', id: number, url: string, title: string }> }> | null };

export type BreederRelatedLinksGetBreedersQueryVariables = Exact<{
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DogBreederWhereInput>;
  translationsWhere?: InputMaybe<DogBreederTranslationWhereInput>;
  translationsWhereBreed?: InputMaybe<DogBreedTranslationWhereInput>;
}>;


export type BreederRelatedLinksGetBreedersQuery = { __typename?: 'Query', findManyDogBreeder?: Array<{ __typename?: 'DogBreeder', id: number, translations: Array<{ __typename?: 'DogBreederTranslation', id: number, url?: string | null }>, breederBreeds: Array<{ __typename?: 'DogBreederBreeds', id: number, dogBreed: { __typename?: 'DogBreed', id: number, translations: Array<{ __typename?: 'DogBreedTranslation', id: number, name?: string | null }> } }> }> | null };

export type BreederRelatedLinksGetBreedsQueryVariables = Exact<{
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DogBreedWhereInput>;
  translationsWhere?: InputMaybe<DogBreedTranslationWhereInput>;
}>;


export type BreederRelatedLinksGetBreedsQuery = { __typename?: 'Query', findManyDogBreed?: Array<{ __typename?: 'DogBreed', id: number, translations: Array<{ __typename?: 'DogBreedTranslation', id: number, url?: string | null, name?: string | null }> }> | null };

export type BreederReviewGetBreederQueryVariables = Exact<{
  where: DogBreederWhereInput;
  take?: InputMaybe<Scalars['Int']['input']>;
}>;


export type BreederReviewGetBreederQuery = { __typename?: 'Query', findManyDogBreeder?: Array<{ __typename?: 'DogBreeder', id: number, displayName?: string | null, reviews: Array<{ __typename?: 'DogBreederReview', id: number, globalGrade?: number | null, accountId: number }> }> | null };

export type BreederWriteReviewCreateReviewMutationVariables = Exact<{
  data: CreateDogBreederReviewInput;
}>;


export type BreederWriteReviewCreateReviewMutation = { __typename?: 'Mutation', createDogBreederReview: { __typename?: 'DogBreederReview', id: number } };

export type EducatorGetEducatorQueryVariables = Exact<{
  where: ProfessionalWhereInput;
}>;


export type EducatorGetEducatorQuery = { __typename?: 'Query', searchProfessionals: { __typename?: 'SearchProfessionalsOutput', professionals: Array<{ __typename?: 'Professional', id: number, educatorType?: EducatorTypeEnum | null, email?: string | null, spokenLanguages: Array<string>, namePro?: string | null, mainProFirstName?: string | null, mainProLastName?: string | null, phone?: string | null, mobilePhone?: string | null, hasShop?: boolean | null, website?: string | null, isTipawPartner: boolean, practicePlaces?: Array<EducatorPracticePlaceEnum | null> | null, acceptsNewClients: boolean, acceptedAnimals: Array<AnimalTypeEnum>, paymentMethods: Array<string>, profileVideo?: string | null, profileVideoPos: number, proSchedule: Array<{ __typename?: 'ProDayAvailabilities', dayOfWeek?: DayOfWeek | null, avails: Array<{ __typename?: 'DayTimeRange', start: string, end: string }> } | null>, degrees: Array<{ __typename?: 'ProDegrees', degree?: string | null, school?: string | null, dateEnd?: any | null }>, imgs: Array<{ __typename?: 'ProImg', id: number, large?: string | null }>, address?: { __typename?: 'Address', id: number, formatted?: string | null, street?: string | null, streetNumber?: string | null, city?: string | null, zip?: string | null, lat?: number | null, lng?: number | null, country?: CountryCode | null } | null, translations: Array<{ __typename?: 'ProTranslation', id: number, language: string, url?: string | null, title?: string | null, description?: string | null, extraDescription?: string | null, subtitle?: string | null, wellnessEngagement?: string | null, preBookingWarning?: string | null, seoTitle?: string | null, seoDescription?: string | null, seoKeywords?: string | null }> }> } };

export type EducatorGetReviewsQueryVariables = Exact<{
  where?: InputMaybe<EducatorReviewWhereInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  professionalWhere?: InputMaybe<ProfessionalWhereInput>;
  orderBy: EducatorReviewOrderByWithRelationAndSearchRelevanceInput;
}>;


export type EducatorGetReviewsQuery = { __typename?: 'Query', searchProfessionals: { __typename?: 'SearchProfessionalsOutput', professionals: Array<{ __typename?: 'Professional', id: number, reviews?: Array<{ __typename?: 'EducatorReview', id: number, createdAt: any, grade?: number | null, verified: boolean, description?: string | null, account: { __typename?: 'Account', id: number, firstName?: string | null, lastName?: string | null, imgs: Array<{ __typename?: 'AccountImg', id: number, small?: string | null }> } } | null> | null }> }, aggregateEducatorReview?: { __typename?: 'AggregateEducatorReview', _count?: { __typename?: 'EducatorReviewCountAggregateOutputType', _all: number } | null, _avg?: { __typename?: 'EducatorReviewAvgAggregateOutputType', grade?: number | null } | null } | null };

export type EducatorWriteReviewCreateReviewMutationVariables = Exact<{
  data: CreateEducatorReviewInput;
}>;


export type EducatorWriteReviewCreateReviewMutation = { __typename?: 'Mutation', createEducatorReview: { __typename?: 'EducatorReview', id: number } };

export type EducatorReviewGetEducatorQueryVariables = Exact<{
  where: ProfessionalWhereInput;
  take?: InputMaybe<Scalars['Int']['input']>;
}>;


export type EducatorReviewGetEducatorQuery = { __typename?: 'Query', searchProfessionals: { __typename?: 'SearchProfessionalsOutput', professionals: Array<{ __typename?: 'Professional', id: number, namePro?: string | null, reviews?: Array<{ __typename?: 'EducatorReview', id: number, grade?: number | null, accountId: number } | null> | null }> } };

export type HomeLandingGetAdditionalPopularBreedsQueryVariables = Exact<{
  where?: InputMaybe<DogBreedWhereInput>;
  breedCardInfoTranslationsWhere?: InputMaybe<DogBreedTranslationWhereInput>;
}>;


export type HomeLandingGetAdditionalPopularBreedsQuery = { __typename?: 'Query', findManyDogBreed?: Array<{ __typename?: 'DogBreed', id: number, name: string, translations: Array<{ __typename?: 'DogBreedTranslation', id: number, name?: string | null }> }> | null };

export type AdoptionsLandingGetBreedersQueryVariables = Exact<{
  where?: InputMaybe<DogBreederWhereInput>;
  orderBy?: InputMaybe<Array<DogBreederOrderByWithRelationAndSearchRelevanceInput> | DogBreederOrderByWithRelationAndSearchRelevanceInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  breederCardInfoTranslationsWhere?: InputMaybe<DogBreederTranslationWhereInput>;
  breederCardInfoTranslationsWhereBreed?: InputMaybe<DogBreedTranslationWhereInput>;
  breederCardInfoBreedImgsTake?: InputMaybe<Scalars['Int']['input']>;
  breederCardInfoLittersWhere?: InputMaybe<LitterWhereInput>;
}>;


export type AdoptionsLandingGetBreedersQuery = { __typename?: 'Query', findManyDogBreeder?: Array<{ __typename?: 'DogBreeder', id: number, spokenLanguages: Array<string>, dogsPedigree?: string | null, lastConnectedType?: DogBreederLastConnectedTypeEnum | null, certificationFile?: string | null, breedClubValidated?: boolean | null, account: { __typename?: 'DogBreederAccount', id: number, connectedAt: any, address?: { __typename?: 'Address', id: number, country?: CountryCode | null, region?: string | null } | null }, translations: Array<{ __typename?: 'DogBreederTranslation', id: number, url?: string | null }>, reviews: Array<{ __typename?: 'DogBreederReview', id: number, globalGrade?: number | null, accountId: number }>, imgs: Array<{ __typename?: 'DogBreederImg', id: number, small?: string | null, type: string }>, breederBreeds: Array<{ __typename?: 'DogBreederBreeds', id: number, dogBreed: { __typename?: 'DogBreed', id: number, imgs: Array<{ __typename?: 'DogBreedImg', id: number, medium?: string | null }>, translations: Array<{ __typename?: 'DogBreedTranslation', id: number, name?: string | null }> } }>, litters: Array<{ __typename?: 'Litter', id: number }> }> | null };

export type AdoptionsLandingGetLittersQueryVariables = Exact<{
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<LitterWhereInput>;
  orderBy?: InputMaybe<Array<LitterOrderByWithRelationAndSearchRelevanceInput> | LitterOrderByWithRelationAndSearchRelevanceInput>;
  litterCardInfoImgsTake: Scalars['Int']['input'];
  litterCardInfoTranslationsWhere: LitterTranslationWhereInput;
  litterCardInfoBreedTranslationsWhere: DogBreedTranslationWhereInput;
}>;


export type AdoptionsLandingGetLittersQuery = { __typename?: 'Query', findManyLitter?: Array<{ __typename?: 'Litter', id: number, price?: number | null, priceFrom?: number | null, priceTo?: number | null, fixedPrice?: boolean | null, description?: string | null, birthday?: any | null, availabilityDate?: any | null, born: boolean, pedigree?: string | null, malesLeftCount?: number | null, femalesLeftCount?: number | null, imgs: Array<{ __typename?: 'LitterImg', id: number, small?: string | null, medium?: string | null }>, translations: Array<{ __typename?: 'LitterTranslation', id: number, url?: string | null }>, breeder: { __typename?: 'DogBreeder', id: number, account: { __typename?: 'DogBreederAccount', id: number, address?: { __typename?: 'Address', id: number, region?: string | null, country?: CountryCode | null } | null } }, dogBreed?: { __typename?: 'DogBreed', id: number, name: string, baseBreedName?: string | null, imgs: Array<{ __typename?: 'DogBreedImg', id: number, large?: string | null, type: DogBreedImgType }>, translations: Array<{ __typename?: 'DogBreedTranslation', id: number, name?: string | null }> } | null }> | null };

export type HomeLandingGetPopularBreedsQueryVariables = Exact<{
  where?: InputMaybe<DogBreedWhereInput>;
  breedCardInfoTranslationsWhere?: InputMaybe<DogBreedTranslationWhereInput>;
}>;


export type HomeLandingGetPopularBreedsQuery = { __typename?: 'Query', findManyDogBreed?: Array<{ __typename?: 'DogBreed', id: number, name: string, exerciseIndex?: number | null, educationIndex?: number | null, careIndex?: number | null, sociabilityIndex?: number | null, translations: Array<{ __typename?: 'DogBreedTranslation', id: number, name?: string | null, description?: string | null, url?: string | null, language: string }>, imgs: Array<{ __typename?: 'DogBreedImg', id: number, small?: string | null }> }> | null };

export type JoinShelterSendContactMessageMutationVariables = Exact<{
  email: Scalars['String']['input'];
  language: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  contactReasonType: ContactReasonTypeEnum;
}>;


export type JoinShelterSendContactMessageMutation = { __typename?: 'Mutation', contactSupport?: boolean | null };

export type LitterLinksGetBreedsQueryVariables = Exact<{
  where?: InputMaybe<DogBreedWhereInput>;
  translationsWhere?: InputMaybe<DogBreedTranslationWhereInput>;
}>;


export type LitterLinksGetBreedsQuery = { __typename?: 'Query', findManyDogBreed?: Array<{ __typename?: 'DogBreed', id: number, name: string, sizeCategory?: AnimalSizeEnum | null, baseBreedName?: string | null, translations: Array<{ __typename?: 'DogBreedTranslation', id: number, name?: string | null, otherNames: Array<string> }> }> | null };

export type LitterListGetLittersQueryVariables = Exact<{
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<LitterWhereInput>;
  orderBy?: InputMaybe<Array<LitterOrderByWithRelationAndSearchRelevanceInput> | LitterOrderByWithRelationAndSearchRelevanceInput>;
  distinct?: InputMaybe<Array<LitterScalarFieldEnum> | LitterScalarFieldEnum>;
  litterCardInfoImgsTake: Scalars['Int']['input'];
  litterCardInfoTranslationsWhere: LitterTranslationWhereInput;
  litterCardInfoBreedTranslationsWhere: DogBreedTranslationWhereInput;
}>;


export type LitterListGetLittersQuery = { __typename?: 'Query', findManyLitter?: Array<{ __typename?: 'Litter', id: number, price?: number | null, priceFrom?: number | null, priceTo?: number | null, fixedPrice?: boolean | null, description?: string | null, birthday?: any | null, availabilityDate?: any | null, born: boolean, pedigree?: string | null, malesLeftCount?: number | null, femalesLeftCount?: number | null, imgs: Array<{ __typename?: 'LitterImg', id: number, small?: string | null, medium?: string | null }>, translations: Array<{ __typename?: 'LitterTranslation', id: number, url?: string | null }>, breeder: { __typename?: 'DogBreeder', id: number, account: { __typename?: 'DogBreederAccount', id: number, address?: { __typename?: 'Address', id: number, region?: string | null, country?: CountryCode | null } | null } }, dogBreed?: { __typename?: 'DogBreed', id: number, name: string, baseBreedName?: string | null, imgs: Array<{ __typename?: 'DogBreedImg', id: number, large?: string | null, type: DogBreedImgType }>, translations: Array<{ __typename?: 'DogBreedTranslation', id: number, name?: string | null }> } | null }> | null, aggregateLitter?: { __typename?: 'AggregateLitter', _count?: { __typename?: 'LitterCountAggregateOutputType', _all: number } | null } | null };

export type LitterListGetBreedersQueryVariables = Exact<{
  where?: InputMaybe<DogBreederWhereInput>;
  orderBy?: InputMaybe<Array<DogBreederOrderByWithRelationAndSearchRelevanceInput> | DogBreederOrderByWithRelationAndSearchRelevanceInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  breederCardInfoTranslationsWhere?: InputMaybe<DogBreederTranslationWhereInput>;
  breederCardInfoTranslationsWhereBreed?: InputMaybe<DogBreedTranslationWhereInput>;
  breederCardInfoBreedImgsTake?: InputMaybe<Scalars['Int']['input']>;
  breederCardInfoLittersWhere?: InputMaybe<LitterWhereInput>;
}>;


export type LitterListGetBreedersQuery = { __typename?: 'Query', findManyDogBreeder?: Array<{ __typename?: 'DogBreeder', id: number, spokenLanguages: Array<string>, dogsPedigree?: string | null, lastConnectedType?: DogBreederLastConnectedTypeEnum | null, certificationFile?: string | null, breedClubValidated?: boolean | null, breederBreeds: Array<{ __typename?: 'DogBreederBreeds', id: number, dogBreed: { __typename?: 'DogBreed', id: number, name: string, baseBreedName?: string | null, imgs: Array<{ __typename?: 'DogBreedImg', id: number, medium?: string | null }>, translations: Array<{ __typename?: 'DogBreedTranslation', id: number, name?: string | null }> } }>, account: { __typename?: 'DogBreederAccount', id: number, connectedAt: any, address?: { __typename?: 'Address', id: number, country?: CountryCode | null, region?: string | null } | null }, translations: Array<{ __typename?: 'DogBreederTranslation', id: number, url?: string | null }>, reviews: Array<{ __typename?: 'DogBreederReview', id: number, globalGrade?: number | null, accountId: number }>, imgs: Array<{ __typename?: 'DogBreederImg', id: number, small?: string | null, type: string }>, litters: Array<{ __typename?: 'Litter', id: number }> }> | null, aggregateDogBreeder?: { __typename?: 'AggregateDogBreeder', _count?: { __typename?: 'DogBreederCountAggregateOutputType', _all: number } | null } | null };

export type LitterAddBookmarkMutationVariables = Exact<{
  data: AccountUpdateInput;
}>;


export type LitterAddBookmarkMutation = { __typename?: 'Mutation', accountMeUpdate: { __typename?: 'Account', id: number, bookmarks: Array<{ __typename?: 'Bookmark', id: number, litter: { __typename?: 'Litter', id: number } }> } };

export type LitterGetBookmarkQueryVariables = Exact<{
  bookmarksWhere?: InputMaybe<BookmarkWhereInput>;
  bookmarksTake?: InputMaybe<Scalars['Int']['input']>;
}>;


export type LitterGetBookmarkQuery = { __typename?: 'Query', accountMe?: { __typename?: 'Account', id: number, bookmarks: Array<{ __typename?: 'Bookmark', id: number }> } | null };

export type LitterGetBreedersQueryVariables = Exact<{
  where?: InputMaybe<DogBreederWhereInput>;
  orderBy?: InputMaybe<Array<DogBreederOrderByWithRelationAndSearchRelevanceInput> | DogBreederOrderByWithRelationAndSearchRelevanceInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  breederCardInfoTranslationsWhere?: InputMaybe<DogBreederTranslationWhereInput>;
  breederCardInfoTranslationsWhereBreed?: InputMaybe<DogBreedTranslationWhereInput>;
  breederCardInfoBreedImgsTake?: InputMaybe<Scalars['Int']['input']>;
  breederCardInfoLittersWhere?: InputMaybe<LitterWhereInput>;
}>;


export type LitterGetBreedersQuery = { __typename?: 'Query', findManyDogBreeder?: Array<{ __typename?: 'DogBreeder', id: number, spokenLanguages: Array<string>, dogsPedigree?: string | null, lastConnectedType?: DogBreederLastConnectedTypeEnum | null, certificationFile?: string | null, breedClubValidated?: boolean | null, account: { __typename?: 'DogBreederAccount', id: number, connectedAt: any, address?: { __typename?: 'Address', id: number, country?: CountryCode | null, region?: string | null } | null }, translations: Array<{ __typename?: 'DogBreederTranslation', id: number, url?: string | null }>, reviews: Array<{ __typename?: 'DogBreederReview', id: number, globalGrade?: number | null, accountId: number }>, imgs: Array<{ __typename?: 'DogBreederImg', id: number, small?: string | null, type: string }>, breederBreeds: Array<{ __typename?: 'DogBreederBreeds', id: number, dogBreed: { __typename?: 'DogBreed', id: number, imgs: Array<{ __typename?: 'DogBreedImg', id: number, medium?: string | null }>, translations: Array<{ __typename?: 'DogBreedTranslation', id: number, name?: string | null }> } }>, litters: Array<{ __typename?: 'Litter', id: number }> }> | null };

export type LitterGetLitterQueryVariables = Exact<{
  litterWhere: LitterWhereInput;
  breedCardInfoTranslationsWhere?: InputMaybe<DogBreedTranslationWhereInput>;
  breederCardInfoTranslationsWhere?: InputMaybe<DogBreederTranslationWhereInput>;
  breederCardInfoTranslationsWhereBreed?: InputMaybe<DogBreedTranslationWhereInput>;
  breederCardInfoBreedImgsTake?: InputMaybe<Scalars['Int']['input']>;
  breederCardInfoLittersWhere?: InputMaybe<LitterWhereInput>;
}>;


export type LitterGetLitterQuery = { __typename?: 'Query', findManyLitter?: Array<{ __typename?: 'Litter', id: number, availabilityDate?: any | null, birthday?: any | null, microchipped?: boolean | null, vaccinationDate?: any | null, vaccinated?: boolean | null, dewormed?: boolean | null, pedigree?: string | null, pedigreeNumbers: Array<string>, certified?: boolean | null, price?: number | null, priceFrom?: number | null, priceTo?: number | null, fixedPrice?: boolean | null, description?: string | null, malesCount: number, femalesCount: number, malesLeftCount?: number | null, femalesLeftCount?: number | null, microchips: Array<string>, born: boolean, translations: Array<{ __typename?: 'LitterTranslation', id: number, url?: string | null, seoKeywords?: string | null, seoDescription?: string | null, seoTitle?: string | null, language: string }>, imgs: Array<{ __typename?: 'LitterImg', id: number, small?: string | null, medium?: string | null, large?: string | null }>, dogBreed?: { __typename?: 'DogBreed', name: string, baseBreedName?: string | null, id: number, exerciseIndex?: number | null, educationIndex?: number | null, careIndex?: number | null, sociabilityIndex?: number | null, translations: Array<{ __typename?: 'DogBreedTranslation', id: number, name?: string | null, description?: string | null, url?: string | null, language: string }>, imgs: Array<{ __typename?: 'DogBreedImg', id: number, small?: string | null }> } | null, breeder: { __typename?: 'DogBreeder', level?: string | null, profileImg?: string | null, agreementNumber?: string | null, lastConnectedType?: DogBreederLastConnectedTypeEnum | null, whatsappNumber?: string | null, id: number, spokenLanguages: Array<string>, dogsPedigree?: string | null, certificationFile?: string | null, breedClubValidated?: boolean | null, account: { __typename?: 'DogBreederAccount', language?: string | null, id: number, connectedAt: any, address?: { __typename?: 'Address', zip?: string | null, street?: string | null, city?: string | null, region?: string | null, country?: CountryCode | null, id: number } | null }, translations: Array<{ __typename?: 'DogBreederTranslation', id: number, url?: string | null }>, reviews: Array<{ __typename?: 'DogBreederReview', id: number, globalGrade?: number | null, accountId: number }>, imgs: Array<{ __typename?: 'DogBreederImg', id: number, small?: string | null, type: string }>, breederBreeds: Array<{ __typename?: 'DogBreederBreeds', id: number, dogBreed: { __typename?: 'DogBreed', id: number, imgs: Array<{ __typename?: 'DogBreedImg', id: number, medium?: string | null }>, translations: Array<{ __typename?: 'DogBreedTranslation', id: number, name?: string | null }> } }>, litters: Array<{ __typename?: 'Litter', id: number }> }, parents: Array<{ __typename?: 'LitterParent', id: number, parentType: ParentTypeEnum, parent?: { __typename?: 'Animal', id: number, name?: string | null, birthday?: any | null, imgs: Array<{ __typename?: 'AnimalImg', id: number, small?: string | null, large?: string | null }>, dogInfos?: { __typename?: 'DogInfo', id: number, microshipNumber?: string | null, pedigreeNumber?: string | null, pedigree?: string | null, competitionTitles?: string | null, healthTestsResults?: string | null } | null } | null }> }> | null };

export type LitterGetLittersQueryVariables = Exact<{
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<LitterWhereInput>;
  orderBy?: InputMaybe<Array<LitterOrderByWithRelationAndSearchRelevanceInput> | LitterOrderByWithRelationAndSearchRelevanceInput>;
  litterCardInfoImgsTake: Scalars['Int']['input'];
  litterCardInfoTranslationsWhere: LitterTranslationWhereInput;
  litterCardInfoBreedTranslationsWhere: DogBreedTranslationWhereInput;
}>;


export type LitterGetLittersQuery = { __typename?: 'Query', findManyLitter?: Array<{ __typename?: 'Litter', id: number, price?: number | null, priceFrom?: number | null, priceTo?: number | null, fixedPrice?: boolean | null, description?: string | null, birthday?: any | null, availabilityDate?: any | null, born: boolean, pedigree?: string | null, malesLeftCount?: number | null, femalesLeftCount?: number | null, imgs: Array<{ __typename?: 'LitterImg', id: number, small?: string | null, medium?: string | null }>, translations: Array<{ __typename?: 'LitterTranslation', id: number, url?: string | null }>, breeder: { __typename?: 'DogBreeder', id: number, account: { __typename?: 'DogBreederAccount', id: number, address?: { __typename?: 'Address', id: number, region?: string | null, country?: CountryCode | null } | null } }, dogBreed?: { __typename?: 'DogBreed', id: number, name: string, baseBreedName?: string | null, imgs: Array<{ __typename?: 'DogBreedImg', id: number, large?: string | null, type: DogBreedImgType }>, translations: Array<{ __typename?: 'DogBreedTranslation', id: number, name?: string | null }> } | null }> | null };

export type LitterRemoveBookmarkMutationVariables = Exact<{
  data: AccountUpdateInput;
}>;


export type LitterRemoveBookmarkMutation = { __typename?: 'Mutation', accountMeUpdate: { __typename?: 'Account', id: number, bookmarks: Array<{ __typename?: 'Bookmark', id: number, litter: { __typename?: 'Litter', id: number } }> } };

export type LocationLinksLocationsQueryVariables = Exact<{
  country: CountryCode;
  proType: ProfessionalTypeEnum;
}>;


export type LocationLinksLocationsQuery = { __typename?: 'Query', professionalLocations: Array<{ __typename?: 'ProfessionalLocations', city?: string | null, region?: string | null } | null> };

export type MtAnimalBreederCreateAnimalMutationVariables = Exact<{
  data: AnimalCreateInput;
  imageUpload?: InputMaybe<Scalars['Upload']['input']>;
  passportFileUpload?: InputMaybe<Scalars['Upload']['input']>;
  createdFrom?: InputMaybe<AnimalStatCreatedFromEnum>;
}>;


export type MtAnimalBreederCreateAnimalMutation = { __typename?: 'Mutation', createAnimal: { __typename?: 'Animal', id: number, dogInfos?: { __typename?: 'DogInfo', pedigree?: string | null } | null } };

export type MtAnimalBreederGetAnimalQueryVariables = Exact<{
  animalsWhere?: InputMaybe<AnimalWhereInput>;
  animalsTake?: InputMaybe<Scalars['Int']['input']>;
}>;


export type MtAnimalBreederGetAnimalQuery = { __typename?: 'Query', accountMe?: { __typename?: 'Account', id: number, animals: Array<{ __typename?: 'Animal', id: number, type: AnimalTypeEnum, name?: string | null, birthday?: any | null, birthdayType?: BirthdayType | null, gender?: GenderEnum | null, archived: boolean, passportFile?: string | null, size?: AnimalSizeEnum | null, sensitivities?: Array<AnimalSensitivityEnum | null> | null, weight?: number | null, imgs: Array<{ __typename?: 'AnimalImg', id: number, medium?: string | null }>, dogInfos?: { __typename?: 'DogInfo', id: number, pedigree?: string | null, breederIsDogOwner?: boolean | null, pedigreeNumber?: string | null, competitionTitles?: string | null, healthTestsResults?: string | null, microshipNumber?: string | null, color?: DogColor | null, coat?: DogCoat | null, dogBreed?: { __typename?: 'DogBreed', id: number, name: string } | null } | null, studInfos?: { __typename?: 'StudInfo', id: number, availableForBreeding: boolean, price?: number | null, champion?: boolean | null, type?: CouplingType | null, adn?: string | null, accomodation?: boolean | null, description?: string | null } | null }> } | null };

export type MtAnimalBreederUpdateAnimalMutationVariables = Exact<{
  data: AnimalUpdateInput;
  animalId: Scalars['Int']['input'];
  imageUpload?: InputMaybe<Scalars['Upload']['input']>;
  passportFileUpload?: InputMaybe<Scalars['Upload']['input']>;
}>;


export type MtAnimalBreederUpdateAnimalMutation = { __typename?: 'Mutation', updateAnimal: { __typename?: 'Animal', id: number } };

export type MtAnimalBuyerCreateAnimalMutationVariables = Exact<{
  data: AnimalCreateInput;
  imageUpload?: InputMaybe<Scalars['Upload']['input']>;
  createdFrom?: InputMaybe<AnimalStatCreatedFromEnum>;
}>;


export type MtAnimalBuyerCreateAnimalMutation = { __typename?: 'Mutation', createAnimal: { __typename?: 'Animal', id: number, type: AnimalTypeEnum, name?: string | null, birthday?: any | null, birthdayType?: BirthdayType | null, gender?: GenderEnum | null, sterilized?: boolean | null, size?: AnimalSizeEnum | null, archived: boolean, calved?: boolean | null, sensitivities?: Array<AnimalSensitivityEnum | null> | null, imgs: Array<{ __typename?: 'AnimalImg', id: number, small?: string | null, medium?: string | null }>, dogInfos?: { __typename?: 'DogInfo', id: number, physicalCondition?: DogPhysicalCondition | null, pedigree?: string | null, medicalAffections: Array<{ __typename?: 'DogMedicalAffection', id: number, affectionType: DogMedicalAffectionType }>, dogBreed?: { __typename?: 'DogBreed', id: number, name: string } | null } | null } };

export type MtAnimalBuyerGetAnimalQueryVariables = Exact<{
  animalsWhere?: InputMaybe<AnimalWhereInput>;
}>;


export type MtAnimalBuyerGetAnimalQuery = { __typename?: 'Query', accountMe?: { __typename?: 'Account', id: number, animals: Array<{ __typename?: 'Animal', id: number, type: AnimalTypeEnum, name?: string | null, birthday?: any | null, birthdayType?: BirthdayType | null, gender?: GenderEnum | null, sterilized?: boolean | null, size?: AnimalSizeEnum | null, archived: boolean, calved?: boolean | null, sensitivities?: Array<AnimalSensitivityEnum | null> | null, imgs: Array<{ __typename?: 'AnimalImg', id: number, small?: string | null, medium?: string | null }>, dogInfos?: { __typename?: 'DogInfo', id: number, physicalCondition?: DogPhysicalCondition | null, pedigree?: string | null, medicalAffections: Array<{ __typename?: 'DogMedicalAffection', id: number, affectionType: DogMedicalAffectionType }>, dogBreed?: { __typename?: 'DogBreed', id: number, name: string } | null } | null }> } | null };

export type MtAnimalBuyerUpdateAnimalMutationVariables = Exact<{
  data: AnimalUpdateInput;
  animalId: Scalars['Int']['input'];
  imageUpload?: InputMaybe<Scalars['Upload']['input']>;
}>;


export type MtAnimalBuyerUpdateAnimalMutation = { __typename?: 'Mutation', updateAnimal: { __typename?: 'Animal', id: number, type: AnimalTypeEnum, name?: string | null, birthday?: any | null, birthdayType?: BirthdayType | null, gender?: GenderEnum | null, sterilized?: boolean | null, size?: AnimalSizeEnum | null, archived: boolean, calved?: boolean | null, sensitivities?: Array<AnimalSensitivityEnum | null> | null, imgs: Array<{ __typename?: 'AnimalImg', id: number, small?: string | null, medium?: string | null }>, dogInfos?: { __typename?: 'DogInfo', id: number, physicalCondition?: DogPhysicalCondition | null, pedigree?: string | null, medicalAffections: Array<{ __typename?: 'DogMedicalAffection', id: number, affectionType: DogMedicalAffectionType }>, dogBreed?: { __typename?: 'DogBreed', id: number, name: string } | null } | null } };

export type MtAnimalsBreederGetAnimalsQueryVariables = Exact<{
  orderBy?: InputMaybe<AnimalOrderByWithRelationAndSearchRelevanceInput>;
  animalsWhere?: InputMaybe<AnimalWhereInput>;
}>;


export type MtAnimalsBreederGetAnimalsQuery = { __typename?: 'Query', accountMe?: { __typename?: 'Account', id: number, animals: Array<{ __typename?: 'Animal', id: number, type: AnimalTypeEnum, name?: string | null, birthday?: any | null, gender?: GenderEnum | null, archived: boolean, studInfos?: { __typename?: 'StudInfo', id: number, availableForBreeding: boolean } | null, imgs: Array<{ __typename?: 'AnimalImg', id: number, small?: string | null }> }> } | null };

export type MtApplicationBreederGetApplicationQueryVariables = Exact<{
  applicationWhere?: InputMaybe<DogBreederApplicationWhereInput>;
  breedTranslationWhere?: InputMaybe<DogBreedTranslationWhereInput>;
}>;


export type MtApplicationBreederGetApplicationQuery = { __typename?: 'Query', accountMe?: { __typename?: 'Account', id: number, address?: { __typename?: 'Address', country?: CountryCode | null } | null, dogBreeder?: { __typename?: 'DogBreeder', id: number, breederBreeds: Array<{ __typename?: 'DogBreederBreeds', dogBreedId: number }>, applications: Array<{ __typename?: 'DogBreederApplication', id: number, createdAt: any, accommodation: DogBreederApplicationAccommodation, experiences: Array<DogBreederApplicationExperience>, timeAlone: DogBreederApplicationTimeAlone, trainers: Array<DogBreederApplicationTrainer>, genderPreferences: Array<GenderEnum>, otherPreferences?: string | null, status: DogBreederApplicationStatus, motive?: string | null, otherAnimals: Array<DogBreederApplicationOtherAnimal>, questions?: string | null, seenByBreeder?: boolean | null, breedPreference: { __typename?: 'DogBreed', id: number, imgs: Array<{ __typename?: 'DogBreedImg', id: number, small?: string | null }>, translations: Array<{ __typename?: 'DogBreedTranslation', id: number, name?: string | null }> }, account: { __typename?: 'DogBreederApplicationAccount', id: number, firstName?: string | null, lastName?: string | null, phone?: string | null, email?: string | null, address?: { __typename?: 'Address', country?: CountryCode | null } | null }, animal?: { __typename?: 'Animal', id: number, name?: string | null, birthday?: any | null } | null }> } | null } | null };

export type MtApplicationsBreederOpenApplicationMutationVariables = Exact<{
  applicationId: Scalars['Int']['input'];
}>;


export type MtApplicationsBreederOpenApplicationMutation = { __typename?: 'Mutation', openApplication: boolean };

export type MtApplicationsBreederDeleteApplicationMutationVariables = Exact<{
  data: DeleteApplicationInput;
}>;


export type MtApplicationsBreederDeleteApplicationMutation = { __typename?: 'Mutation', deleteApplication: { __typename?: 'DogBreederApplication', id: number, status: DogBreederApplicationStatus } };

export type MtApplicationsBuyerCancelApplicationMutationVariables = Exact<{
  applicationId: Scalars['Int']['input'];
}>;


export type MtApplicationsBuyerCancelApplicationMutation = { __typename?: 'Mutation', cancelApplication: { __typename?: 'DogBreederApplication', id: number, status: DogBreederApplicationStatus } };

export type MtApplicationBuyerGetApplicationQueryVariables = Exact<{
  applicationWhere?: InputMaybe<DogBreederApplicationWhereInput>;
  breedTranslationWhere?: InputMaybe<DogBreedTranslationWhereInput>;
  breederTranslationWhere?: InputMaybe<DogBreederTranslationWhereInput>;
}>;


export type MtApplicationBuyerGetApplicationQuery = { __typename?: 'Query', accountMe?: { __typename?: 'Account', id: number, address?: { __typename?: 'Address', country?: CountryCode | null } | null, applications: Array<{ __typename?: 'DogBreederApplication', id: number, createdAt: any, accommodation: DogBreederApplicationAccommodation, experiences: Array<DogBreederApplicationExperience>, timeAlone: DogBreederApplicationTimeAlone, trainers: Array<DogBreederApplicationTrainer>, genderPreferences: Array<GenderEnum>, otherPreferences?: string | null, status: DogBreederApplicationStatus, motive?: string | null, otherAnimals: Array<DogBreederApplicationOtherAnimal>, questions?: string | null, seenByBuyer?: boolean | null, breedPreference: { __typename?: 'DogBreed', id: number, imgs: Array<{ __typename?: 'DogBreedImg', id: number, small?: string | null }>, translations: Array<{ __typename?: 'DogBreedTranslation', id: number, name?: string | null }> }, dogBreeder: { __typename?: 'DogBreeder', id: number, profileImg?: string | null, agreementNumber?: string | null, translations: Array<{ __typename?: 'DogBreederTranslation', id: number, url?: string | null }>, account: { __typename?: 'DogBreederAccount', id: number, firstName?: string | null, lastName?: string | null, phone?: string | null, email?: string | null, address?: { __typename?: 'Address', country?: CountryCode | null } | null }, breederBreeds: Array<{ __typename?: 'DogBreederBreeds', id: number, dogBreedId: number }> }, animal?: { __typename?: 'Animal', id: number, name?: string | null, birthday?: any | null } | null }> } | null };

export type MtApplicationsBuyerOpenApplicationMutationVariables = Exact<{
  applicationId: Scalars['Int']['input'];
}>;


export type MtApplicationsBuyerOpenApplicationMutation = { __typename?: 'Mutation', openApplication: boolean };

export type DeleteBookingMutationMutationVariables = Exact<{
  bookingId: Scalars['Int']['input'];
}>;


export type DeleteBookingMutationMutation = { __typename?: 'Mutation', deleteBooking: { __typename?: 'BookingDeleteOutput', deletedBookingId?: number | null } };

export type BookingListGetBookingsQueryVariables = Exact<{
  bookingsOrderBy?: InputMaybe<BookingOrderByWithRelationAndSearchRelevanceInput>;
  bookingCardInfoProTranslationsWhere: ProTranslationWhereInput;
  bookingCardInfoServiceTranslationsWhere: ServiceTranslationWhereInput;
}>;


export type BookingListGetBookingsQuery = { __typename?: 'Query', accountMe?: { __typename?: 'Account', id: number, bookings: Array<{ __typename?: 'Booking', id: number, startDateTime: any, endDateTime: any, worker: { __typename?: 'Worker', id: number, fullName?: string | null, pro: { __typename?: 'Professional', id: number, minHoursBeforeUpdateOrCancelBooking: number, type: ProfessionalTypeEnum, email?: string | null, phone?: string | null, mobilePhone?: string | null, imgs: Array<{ __typename?: 'ProImg', id: number, small?: string | null }>, translations: Array<{ __typename?: 'ProTranslation', id: number, language: string, url?: string | null }> } }, bookingAnimals: Array<{ __typename?: 'BookingAnimal', id: number, animal: { __typename?: 'Animal', id: number, type: AnimalTypeEnum, name?: string | null, gender?: GenderEnum | null, birthday?: any | null, imgs: Array<{ __typename?: 'AnimalImg', id: number, small?: string | null }>, dogInfos?: { __typename?: 'DogInfo', id: number, dogBreedId?: number | null } | null } }>, workerService: { __typename?: 'WorkerService', id: number, categoryId: number, service: { __typename?: 'Service', id: number, translations: Array<{ __typename?: 'ServiceTranslation', id: number, language: string, title?: string | null }> } } }> } | null };

export type UpdateBookingMutationMutationVariables = Exact<{
  bookingId: Scalars['Int']['input'];
  startDateTime: Scalars['DateTime']['input'];
}>;


export type UpdateBookingMutationMutation = { __typename?: 'Mutation', updateBooking: { __typename?: 'Booking', id: number } };

export type MtBreederOnboardingGetProfileQueryVariables = Exact<{ [key: string]: never; }>;


export type MtBreederOnboardingGetProfileQuery = { __typename?: 'Query', accountMe?: { __typename?: 'Account', id: number, firstName?: string | null, lastName?: string | null, birthday?: any | null, gender?: GenderEnum | null, language: string, address?: { __typename?: 'Address', id: number, streetNumber?: string | null, country?: CountryCode | null, city?: string | null, region?: string | null, zip?: string | null, street?: string | null } | null, imgs: Array<{ __typename?: 'AccountImg', id: number, small?: string | null }>, animals: Array<{ __typename?: 'Animal', id: number }>, dogBreeder?: { __typename?: 'DogBreeder', id: number, dogsPedigree?: string | null, motherRestBetweenLitters?: string | null, littersByFemale?: string | null, femaleBreedersCount?: number | null, dogsConsanguinity?: string | null, medicalTestsPerformed?: string | null, failedMedicalTestsProtocol?: string | null, puppiesBirthPlace?: string | null, veterinaryInfo?: string | null, displayEmail?: string | null, displayPhone?: string | null, breedingName?: string | null, certified?: boolean | null, hkFile?: string | null, permissionFiles?: Array<string> | null, identityFiles?: Array<string> | null, breedClubFiles?: Array<string> | null, certificationFile?: string | null, hasFinishedOnboarding: boolean, displayName?: string | null, agreementNumber?: string | null, level?: string | null, websiteUrl?: string | null, facebookUrl?: string | null, spokenLanguages: Array<string>, imgs: Array<{ __typename?: 'DogBreederImg', id: number, small?: string | null, type: string }>, translations: Array<{ __typename?: 'DogBreederTranslation', id: number, url?: string | null, language: string, description?: string | null, breederDogsSelection?: string | null, dogsActivities?: string | null, dogsLivingPlace?: string | null, health?: string | null, puppiesTraining?: string | null, puppiesLivingPlace?: string | null }>, breederBreeds: Array<{ __typename?: 'DogBreederBreeds', id: number, dogBreedId: number }>, litters: Array<{ __typename?: 'Litter', id: number }> } | null } | null };

export type MtBreederOnboardingUpdateProfileMutationVariables = Exact<{
  data: AccountUpdateInput;
  profileImage?: InputMaybe<Scalars['Upload']['input']>;
  dogBreederHkFileUpload?: InputMaybe<Scalars['Upload']['input']>;
  dogBreederPermissionFilesUpload?: InputMaybe<Array<InputMaybe<Scalars['Upload']['input']>> | InputMaybe<Scalars['Upload']['input']>>;
  dogBreederIdentityFilesUpload?: InputMaybe<Array<InputMaybe<Scalars['Upload']['input']>> | InputMaybe<Scalars['Upload']['input']>>;
  dogBreederBreedClubFilesUpload?: InputMaybe<Array<InputMaybe<Scalars['Upload']['input']>> | InputMaybe<Scalars['Upload']['input']>>;
  dogBreederCertificationFileUpload?: InputMaybe<Scalars['Upload']['input']>;
  dogBreederImagesUpload?: InputMaybe<Array<AccountDogBreederImgUploadInput> | AccountDogBreederImgUploadInput>;
  dogBreederImageIdsRemoved?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  femaleBreedersCount?: InputMaybe<Scalars['Int']['input']>;
}>;


export type MtBreederOnboardingUpdateProfileMutation = { __typename?: 'Mutation', accountMeUpdate: { __typename?: 'Account', id: number } };

export type AnnouncementsGetAnnouncementsQueryVariables = Exact<{
  orderBy?: InputMaybe<Array<AnnouncementOrderByWithRelationAndSearchRelevanceInput> | AnnouncementOrderByWithRelationAndSearchRelevanceInput>;
  translationWhere?: InputMaybe<AnnouncementTranslationWhereInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AnnouncementWhereInput>;
}>;


export type AnnouncementsGetAnnouncementsQuery = { __typename?: 'Query', findManyAnnouncement?: Array<{ __typename?: 'Announcement', id: number, published: boolean, countries: Array<CountryCode>, createdAt: any, translations: Array<{ __typename?: 'AnnouncementTranslation', id: number, title: string, content?: string | null, language: string }> }> | null, aggregateAnnouncement?: { __typename?: 'AggregateAnnouncement', _count?: { __typename?: 'AnnouncementCountAggregateOutputType', _all: number } | null } | null };

export type MtLandingBreederUpdateProfileMutationVariables = Exact<{
  data: AccountUpdateInput;
}>;


export type MtLandingBreederUpdateProfileMutation = { __typename?: 'Mutation', accountMeUpdate: { __typename?: 'Account', id: number, dogBreeder?: { __typename?: 'DogBreeder', id: number, hasStartedOnboarding: boolean } | null } };

export type MtLitterCreateLitterMutationVariables = Exact<{
  data: CreateLitterInput;
  imageUpload?: InputMaybe<Array<Scalars['Upload']['input']> | Scalars['Upload']['input']>;
}>;


export type MtLitterCreateLitterMutation = { __typename?: 'Mutation', createLitter: { __typename?: 'Litter', id: number } };

export type MtLitterGetAnimalsQueryVariables = Exact<{
  animalsWhere?: InputMaybe<AnimalWhereInput>;
}>;


export type MtLitterGetAnimalsQuery = { __typename?: 'Query', accountMe?: { __typename?: 'Account', id: number, animals: Array<{ __typename?: 'Animal', id: number, name?: string | null, gender?: GenderEnum | null, dogInfos?: { __typename?: 'DogInfo', pedigree?: string | null } | null }> } | null };

export type MtLitterGetBreederBreedsQueryVariables = Exact<{
  translationsWhere?: InputMaybe<DogBreedTranslationWhereInput>;
}>;


export type MtLitterGetBreederBreedsQuery = { __typename?: 'Query', accountMe?: { __typename?: 'Account', id: number, dogBreeder?: { __typename?: 'DogBreeder', id: number, breederBreeds: Array<{ __typename?: 'DogBreederBreeds', id: number, dogBreed: { __typename?: 'DogBreed', id: number, name: string, sizeCategory?: AnimalSizeEnum | null, baseBreedName?: string | null, translations: Array<{ __typename?: 'DogBreedTranslation', id: number, name?: string | null, otherNames: Array<string> }> } }> } | null } | null };

export type MtLitterGetLitterQueryVariables = Exact<{
  translationsWhere: LitterTranslationWhereInput;
  dogBreedTranslationsWhere: DogBreedTranslationWhereInput;
  where?: InputMaybe<LitterWhereInput>;
}>;


export type MtLitterGetLitterQuery = { __typename?: 'Query', accountMe?: { __typename?: 'Account', id: number, dogBreeder?: { __typename?: 'DogBreeder', id: number, account: { __typename?: 'DogBreederAccount', address?: { __typename?: 'Address', country?: CountryCode | null } | null }, litters: Array<{ __typename?: 'Litter', id: number, adminValidated?: boolean | null, archived?: boolean | null, born: boolean, createdAt: any, price?: number | null, priceFrom?: number | null, priceTo?: number | null, fixedPrice?: boolean | null, birthday?: any | null, availabilityDate?: any | null, description?: string | null, malesCount: number, malesLeftCount?: number | null, femalesCount: number, femalesLeftCount?: number | null, microchipped?: boolean | null, microchips: Array<string>, vaccinated?: boolean | null, vaccinationDate?: any | null, pedigree?: string | null, pedigreeNumbers: Array<string>, dewormed?: boolean | null, litterCode?: string | null, imgs: Array<{ __typename?: 'LitterImg', id: number, small?: string | null }>, parents: Array<{ __typename?: 'LitterParent', id: number, parentType: ParentTypeEnum, parentId?: number | null, parent?: { __typename?: 'Animal', dogInfos?: { __typename?: 'DogInfo', pedigreeNumber?: string | null } | null } | null }>, translations: Array<{ __typename?: 'LitterTranslation', id: number, url?: string | null, language: string }>, dogBreed?: { __typename?: 'DogBreed', id: number, name: string, translations: Array<{ __typename?: 'DogBreedTranslation', name?: string | null }>, imgs: Array<{ __typename?: 'DogBreedImg', id: number, small?: string | null }> } | null }> } | null } | null };

export type MtLitterUpdateLitterMutationVariables = Exact<{
  data: UpdateLitterInput;
  litterId: Scalars['Int']['input'];
  imageUpload?: InputMaybe<Array<Scalars['Upload']['input']> | Scalars['Upload']['input']>;
  imageIdsRemoved?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
}>;


export type MtLitterUpdateLitterMutation = { __typename?: 'Mutation', updateLitter: { __typename?: 'Litter', id: number } };

export type MtLittersGetLittersQueryVariables = Exact<{
  orderBy?: InputMaybe<LitterOrderByWithRelationAndSearchRelevanceInput>;
  where: LitterWhereInput;
  translationsWhere: DogBreedTranslationWhereInput;
}>;


export type MtLittersGetLittersQuery = { __typename?: 'Query', accountMe?: { __typename?: 'Account', id: number, dogBreeder?: { __typename?: 'DogBreeder', id: number, litters: Array<{ __typename?: 'Litter', id: number, adminValidated?: boolean | null, archived?: boolean | null, price?: number | null, priceFrom?: number | null, priceTo?: number | null, fixedPrice?: boolean | null, birthday?: any | null, availabilityDate?: any | null, description?: string | null, malesLeftCount?: number | null, femalesLeftCount?: number | null, malesCount: number, femalesCount: number, microchipped?: boolean | null, microchips: Array<string>, vaccinated?: boolean | null, vaccinationDate?: any | null, pedigree?: string | null, pedigreeNumbers: Array<string>, dewormed?: boolean | null, imgs: Array<{ __typename?: 'LitterImg', id: number, small?: string | null }>, parents: Array<{ __typename?: 'LitterParent', id: number, parentType: ParentTypeEnum, name?: string | null, testsResults?: string | null, titles?: string | null, microshipNumber?: string | null, pedigreeType?: string | null, pedigreeNumber?: string | null, img?: string | null }>, dogBreed?: { __typename?: 'DogBreed', id: number, name: string, translations: Array<{ __typename?: 'DogBreedTranslation', id: number, name?: string | null }>, imgs: Array<{ __typename?: 'DogBreedImg', id: number, small?: string | null }> } | null }> } | null } | null };

export type DeleteConversationMutationVariables = Exact<{
  conversationId: Scalars['Int']['input'];
}>;


export type DeleteConversationMutation = { __typename?: 'Mutation', deleteConversation: number };

export type DeleteMessageMutationMutationVariables = Exact<{
  messageId: Scalars['Int']['input'];
}>;


export type DeleteMessageMutationMutation = { __typename?: 'Mutation', deleteMessage: { __typename?: 'Message', id: number } };

export type AccountGetConversationsQueryVariables = Exact<{ [key: string]: never; }>;


export type AccountGetConversationsQuery = { __typename?: 'Query', conversations: Array<{ __typename?: 'Conversation', id: number, otherAccountId: number, otherAccountFullName: string, otherAccountProfileImage?: string | null, otherAccountIsDeleted: boolean, otherAccountType: string }> };

export type AccountGetMessagesQueryVariables = Exact<{
  otherAccountId: Scalars['Int']['input'];
}>;


export type AccountGetMessagesQuery = { __typename?: 'Query', messages: Array<{ __typename?: 'Message', id: number, seen?: boolean | null, seenAt?: any | null, img?: string | null, file?: string | null, content?: string | null, reported: boolean, fromAccountId: number, toAccountId: number, createdAt: any }> };

export type SendMessageMutationMutationVariables = Exact<{
  data: SendMessageInput;
}>;


export type SendMessageMutationMutation = { __typename?: 'Mutation', sendMessage: { __typename?: 'Message', id: number, content?: string | null, createdAt: any, seen?: boolean | null, img?: string | null, file?: string | null, reported: boolean, fromAccountId: number, toAccountId: number } };

export type MtProfileBreederUpdateProfileMutationVariables = Exact<{
  data: AccountUpdateInput;
  profileImage?: InputMaybe<Scalars['Upload']['input']>;
  dogBreederHkFileUpload?: InputMaybe<Scalars['Upload']['input']>;
  dogBreederPermissionFilesUpload?: InputMaybe<Array<InputMaybe<Scalars['Upload']['input']>> | InputMaybe<Scalars['Upload']['input']>>;
  dogBreederIdentityFilesUpload?: InputMaybe<Array<InputMaybe<Scalars['Upload']['input']>> | InputMaybe<Scalars['Upload']['input']>>;
  dogBreederBreedClubFilesUpload?: InputMaybe<Array<InputMaybe<Scalars['Upload']['input']>> | InputMaybe<Scalars['Upload']['input']>>;
  dogBreederCertificationFileUpload?: InputMaybe<Scalars['Upload']['input']>;
  dogBreederImagesUpload?: InputMaybe<Array<AccountDogBreederImgUploadInput> | AccountDogBreederImgUploadInput>;
  dogBreederImageIdsRemoved?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  femaleBreedersCount?: InputMaybe<Scalars['Int']['input']>;
}>;


export type MtProfileBreederUpdateProfileMutation = { __typename?: 'Mutation', accountMeUpdate: { __typename?: 'Account', id: number } };

export type MtSettingsBreederProfileFragment = { __typename?: 'Account', id: number, email: string, lastName?: string | null, firstName?: string | null, name?: string | null, phone?: string | null, firebaseId?: string | null, language: string, dogBreeder?: { __typename?: 'DogBreeder', id: number, certified?: boolean | null, hasStartedOnboarding: boolean } | null, imgs: Array<{ __typename?: 'AccountImg', id: number, small?: string | null }> };

export type MtSettingsBreederGetProfileQueryVariables = Exact<{ [key: string]: never; }>;


export type MtSettingsBreederGetProfileQuery = { __typename?: 'Query', accountMe?: { __typename?: 'Account', birthday?: any | null, gender?: GenderEnum | null, contactPreferences?: Array<ContactPreference | null> | null, id: number, email: string, lastName?: string | null, firstName?: string | null, name?: string | null, phone?: string | null, firebaseId?: string | null, language: string, dogBreeder?: { __typename?: 'DogBreeder', id: number, certified?: boolean | null, hasStartedOnboarding: boolean } | null, imgs: Array<{ __typename?: 'AccountImg', id: number, small?: string | null }> } | null };

export type MtSettingsBreederUpdateProfileMutationVariables = Exact<{
  data: AccountUpdateInput;
}>;


export type MtSettingsBreederUpdateProfileMutation = { __typename?: 'Mutation', accountMeUpdate: { __typename?: 'Account', contactPreferences?: Array<ContactPreference | null> | null, id: number, email: string, lastName?: string | null, firstName?: string | null, name?: string | null, phone?: string | null, firebaseId?: string | null, language: string, dogBreeder?: { __typename?: 'DogBreeder', id: number, certified?: boolean | null, hasStartedOnboarding: boolean } | null, imgs: Array<{ __typename?: 'AccountImg', id: number, small?: string | null }> } };

export type MtSettingsBuyerProfileFragment = { __typename?: 'Account', birthday?: any | null, gender?: GenderEnum | null, id: number, email: string, lastName?: string | null, firstName?: string | null, name?: string | null, phone?: string | null, firebaseId?: string | null, language: string, dogBreeder?: { __typename?: 'DogBreeder', id: number, certified?: boolean | null, hasStartedOnboarding: boolean } | null, imgs: Array<{ __typename?: 'AccountImg', id: number, small?: string | null }> };

export type MtSettingsBuyerGetProfileQueryVariables = Exact<{ [key: string]: never; }>;


export type MtSettingsBuyerGetProfileQuery = { __typename?: 'Query', accountMe?: { __typename?: 'Account', birthday?: any | null, gender?: GenderEnum | null, contactPreferences?: Array<ContactPreference | null> | null, id: number, email: string, lastName?: string | null, firstName?: string | null, name?: string | null, phone?: string | null, firebaseId?: string | null, language: string, dogBreeder?: { __typename?: 'DogBreeder', id: number, certified?: boolean | null, hasStartedOnboarding: boolean } | null, imgs: Array<{ __typename?: 'AccountImg', id: number, small?: string | null }> } | null };

export type MtSettingsBuyerUpdateProfileMutationVariables = Exact<{
  data: AccountUpdateInput;
  profileImage?: InputMaybe<Scalars['Upload']['input']>;
}>;


export type MtSettingsBuyerUpdateProfileMutation = { __typename?: 'Mutation', accountMeUpdate: { __typename?: 'Account', birthday?: any | null, gender?: GenderEnum | null, id: number, email: string, lastName?: string | null, firstName?: string | null, name?: string | null, phone?: string | null, firebaseId?: string | null, language: string, dogBreeder?: { __typename?: 'DogBreeder', id: number, certified?: boolean | null, hasStartedOnboarding: boolean } | null, imgs: Array<{ __typename?: 'AccountImg', id: number, small?: string | null }> } };

export type MtWishlistGetBookmarksQueryVariables = Exact<{
  orderBy?: InputMaybe<BookmarkOrderByWithRelationAndSearchRelevanceInput>;
  bookmarksWhere: BookmarkWhereInput;
  litterCardInfoImgsTake: Scalars['Int']['input'];
  litterCardInfoTranslationsWhere: LitterTranslationWhereInput;
  litterCardInfoBreedTranslationsWhere: DogBreedTranslationWhereInput;
}>;


export type MtWishlistGetBookmarksQuery = { __typename?: 'Query', accountMe?: { __typename?: 'Account', id: number, bookmarks: Array<{ __typename?: 'Bookmark', id: number, litter: { __typename?: 'Litter', id: number, price?: number | null, priceFrom?: number | null, priceTo?: number | null, fixedPrice?: boolean | null, description?: string | null, birthday?: any | null, availabilityDate?: any | null, born: boolean, pedigree?: string | null, malesLeftCount?: number | null, femalesLeftCount?: number | null, imgs: Array<{ __typename?: 'LitterImg', id: number, small?: string | null, medium?: string | null }>, translations: Array<{ __typename?: 'LitterTranslation', id: number, url?: string | null }>, breeder: { __typename?: 'DogBreeder', id: number, account: { __typename?: 'DogBreederAccount', id: number, address?: { __typename?: 'Address', id: number, region?: string | null, country?: CountryCode | null } | null } }, dogBreed?: { __typename?: 'DogBreed', id: number, name: string, baseBreedName?: string | null, imgs: Array<{ __typename?: 'DogBreedImg', id: number, large?: string | null, type: DogBreedImgType }>, translations: Array<{ __typename?: 'DogBreedTranslation', id: number, name?: string | null }> } | null } }> } | null };

export type ProLandingGetGroomersQueryVariables = Exact<{
  orderBy?: InputMaybe<Array<ProfessionalOrderByWithRelationAndSearchRelevanceInput> | ProfessionalOrderByWithRelationAndSearchRelevanceInput>;
  where?: InputMaybe<ProfessionalWhereInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  imgsTake?: InputMaybe<Scalars['Int']['input']>;
  translationsWhere?: InputMaybe<ProTranslationWhereInput>;
}>;


export type ProLandingGetGroomersQuery = { __typename?: 'Query', searchProfessionals: { __typename?: 'SearchProfessionalsOutput', professionals: Array<{ __typename?: 'Professional', id: number, namePro?: string | null, mainProFirstName?: string | null, mainProLastName?: string | null, type: ProfessionalTypeEnum, imgs: Array<{ __typename?: 'ProImg', id: number, small?: string | null }>, translations: Array<{ __typename?: 'ProTranslation', id: number, url?: string | null, title?: string | null }>, address?: { __typename?: 'Address', id: number, zip?: string | null, city?: string | null } | null }> } };

export type ProLandingGetVetsQueryVariables = Exact<{
  orderBy?: InputMaybe<Array<ProfessionalOrderByWithRelationAndSearchRelevanceInput> | ProfessionalOrderByWithRelationAndSearchRelevanceInput>;
  where?: InputMaybe<ProfessionalWhereInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  imgsTake?: InputMaybe<Scalars['Int']['input']>;
  translationsWhere?: InputMaybe<ProTranslationWhereInput>;
}>;


export type ProLandingGetVetsQuery = { __typename?: 'Query', searchProfessionals: { __typename?: 'SearchProfessionalsOutput', professionals: Array<{ __typename?: 'Professional', id: number, namePro?: string | null, mainProFirstName?: string | null, mainProLastName?: string | null, type: ProfessionalTypeEnum, imgs: Array<{ __typename?: 'ProImg', id: number, small?: string | null }>, translations: Array<{ __typename?: 'ProTranslation', id: number, url?: string | null, title?: string | null }>, address?: { __typename?: 'Address', id: number, zip?: string | null, city?: string | null } | null }> } };

export type ProsListMapGetProQueryVariables = Exact<{
  where: ProfessionalWhereInput;
}>;


export type ProsListMapGetProQuery = { __typename?: 'Query', searchProfessionals: { __typename?: 'SearchProfessionalsOutput', professionals: Array<{ __typename?: 'Professional', id: number, type: ProfessionalTypeEnum, centerType?: CenterTypeEnum | null, educatorType?: EducatorTypeEnum | null, email?: string | null, spokenLanguages: Array<string>, distance?: number | null, onlineBookingEnabled: boolean, unclaimedProfile: boolean, reviews?: Array<{ __typename?: 'EducatorReview', id: number, grade?: number | null } | null> | null, imgs: Array<{ __typename?: 'ProImg', id: number, small?: string | null }>, address?: { __typename?: 'Address', id: number, city?: string | null, lat?: number | null, lng?: number | null } | null, translations: Array<{ __typename?: 'ProTranslation', id: number, language: string, url?: string | null, title?: string | null, description?: string | null }> }> } };

export type ProsListGetProMapMarkerQueryVariables = Exact<{
  where: ProfessionalWhereInput;
}>;


export type ProsListGetProMapMarkerQuery = { __typename?: 'Query', searchProfessionals: { __typename?: 'SearchProfessionalsOutput', professionals: Array<{ __typename?: 'Professional', id: number, onlineBookingEnabled: boolean, unclaimedProfile: boolean, address?: { __typename?: 'Address', id: number, formatted?: string | null } | null, imgs: Array<{ __typename?: 'ProImg', id: number, medium?: string | null }>, translations: Array<{ __typename?: 'ProTranslation', id: number, language: string, title?: string | null, url?: string | null }> }> } };

export type ProsListGetProsQueryVariables = Exact<{
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProfessionalWhereInput>;
  orderBy?: InputMaybe<Array<ProfessionalOrderByWithRelationAndSearchRelevanceInput> | ProfessionalOrderByWithRelationAndSearchRelevanceInput>;
  serviceId?: InputMaybe<Scalars['Int']['input']>;
  nearByPoint?: InputMaybe<LatLngPoint>;
  maxDistance?: InputMaybe<Scalars['Int']['input']>;
  nearByAddress?: InputMaybe<Scalars['String']['input']>;
}>;


export type ProsListGetProsQuery = { __typename?: 'Query', searchProfessionals: { __typename?: 'SearchProfessionalsOutput', totalCount: number, professionals: Array<{ __typename?: 'Professional', id: number, type: ProfessionalTypeEnum, centerType?: CenterTypeEnum | null, educatorType?: EducatorTypeEnum | null, email?: string | null, spokenLanguages: Array<string>, distance?: number | null, onlineBookingEnabled: boolean, unclaimedProfile: boolean, imgs: Array<{ __typename?: 'ProImg', id: number, small?: string | null }>, reviews?: Array<{ __typename?: 'EducatorReview', id: number, grade?: number | null } | null> | null, address?: { __typename?: 'Address', id: number, city?: string | null, lat?: number | null, lng?: number | null } | null, translations: Array<{ __typename?: 'ProTranslation', id: number, language: string, url?: string | null, title?: string | null, description?: string | null }> }> } };

export type ProsListMapGetProsQueryVariables = Exact<{
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProfessionalWhereInput>;
  serviceId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ProsListMapGetProsQuery = { __typename?: 'Query', searchProfessionals: { __typename?: 'SearchProfessionalsOutput', professionals: Array<{ __typename?: 'Professional', id: number, onlineBookingEnabled: boolean, unclaimedProfile: boolean, address?: { __typename?: 'Address', id: number, lat?: number | null, lng?: number | null } | null }> } };

export type ProGetProQueryVariables = Exact<{
  where: ProfessionalWhereInput;
  serviceTranslationsWhere?: InputMaybe<ServiceTranslationWhereInput>;
  categoryTranslationsWhere?: InputMaybe<CategoryTranslationWhereInput>;
  proServiceLanguage: Scalars['String']['input'];
}>;


export type ProGetProQuery = { __typename?: 'Query', searchProfessionals: { __typename?: 'SearchProfessionalsOutput', professionals: Array<{ __typename?: 'Professional', id: number, type: ProfessionalTypeEnum, centerType?: CenterTypeEnum | null, email?: string | null, spokenLanguages: Array<string>, whatsappNumber?: string | null, phone?: string | null, language: string, mobilePhone?: string | null, hasShop?: boolean | null, website?: string | null, visitAtHome?: boolean | null, selfDogWash: boolean, parking?: boolean | null, acceptedAnimals: Array<AnimalTypeEnum>, onlineBookingEnabled: boolean, acceptsOnlineAppointment: boolean, paymentMethods: Array<string>, employeesCount?: number | null, assistantsCount?: number | null, unclaimedProfile: boolean, acceptsNewClients: boolean, profileVideo?: string | null, profileVideoPos: number, isTipawPartner: boolean, proSchedule: Array<{ __typename?: 'ProDayAvailabilities', dayOfWeek?: DayOfWeek | null, avails: Array<{ __typename?: 'DayTimeRange', start: string, end: string }> } | null>, shopSchedule: Array<{ __typename?: 'ProShopOpeningHours', dayOfWeek?: DayOfWeek | null, openingHours: Array<{ __typename?: 'DayTimeRange', start: string, end: string }> } | null>, degrees: Array<{ __typename?: 'ProDegrees', degree?: string | null, school?: string | null, dateEnd?: any | null }>, imgs: Array<{ __typename?: 'ProImg', id: number, large?: string | null, medium?: string | null }>, workers: Array<{ __typename?: 'Worker', id: number, fullName?: string | null }>, address?: { __typename?: 'Address', id: number, formatted?: string | null, street?: string | null, streetNumber?: string | null, city?: string | null, zip?: string | null, lat?: number | null, lng?: number | null, country?: CountryCode | null } | null, urgencyAvailabilities: Array<{ __typename?: 'ProUrgencyAvailability', id: number, dayOfWeek: DayOfWeek }>, services: Array<{ __typename?: 'ProfessionalService', id: string, fromDurationMinute?: number | null, toDurationMinute?: number | null, bookable?: boolean | null, priceType?: string | null, price?: number | null, priceFrom?: number | null, priceTo?: number | null, workerServices: Array<{ __typename?: 'WorkerServiceWithBookingDuration', id: number, workerId: number, minimumDuration?: number | null, maximumDuration?: number | null, bookingDuration: number, animalSize?: AnimalSizeEnum | null, animalType?: AnimalTypeEnum | null, isProSpecialist: boolean, translations: Array<{ __typename?: 'WorkerServiceTranslation', id: number, language: string, preBookingWarning?: string | null }> }>, service: { __typename?: 'Service', id: number, translations: Array<{ __typename?: 'ServiceTranslation', title?: string | null }> }, category: { __typename?: 'Category', id: number, translations: Array<{ __typename?: 'CategoryTranslation', title: string }> } } | null>, translations: Array<{ __typename?: 'ProTranslation', id: number, language: string, url?: string | null, title?: string | null, description?: string | null, extraDescription?: string | null, subtitle?: string | null, wellnessEngagement?: string | null, preBookingWarning?: string | null, seoTitle?: string | null, seoDescription?: string | null, seoKeywords?: string | null }> }> } };

export type ProIncreamentViewCountMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type ProIncreamentViewCountMutation = { __typename?: 'Mutation', incrementProViewCount: boolean };

export type ProLogContactInfoClickMutationVariables = Exact<{
  proId: Scalars['Int']['input'];
}>;


export type ProLogContactInfoClickMutation = { __typename?: 'Mutation', logContactInfoClick: boolean };

export type ProGetRelatedProfessionalsQueryVariables = Exact<{
  nearByPoint?: InputMaybe<LatLngPoint>;
  take?: InputMaybe<Scalars['Int']['input']>;
  proId?: InputMaybe<Scalars['Int']['input']>;
  country: CountryCode;
  language: Scalars['String']['input'];
  proType?: InputMaybe<ProfessionalTypeEnum>;
}>;


export type ProGetRelatedProfessionalsQuery = { __typename?: 'Query', relatedProfessionals: { __typename?: 'RelatedProfessionals', locations: Array<{ __typename?: 'ProfessionalLocations', city?: string | null, region?: string | null } | null>, pros: Array<{ __typename?: 'Professional', id: number, type: ProfessionalTypeEnum, translations: Array<{ __typename?: 'ProTranslation', id: number, url?: string | null, title?: string | null, language: string }> } | null> } };

export type ProRelatedLinksGetServicesQueryVariables = Exact<{
  where?: InputMaybe<ServiceWhereInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ServiceOrderByWithRelationAndSearchRelevanceInput> | ServiceOrderByWithRelationAndSearchRelevanceInput>;
}>;


export type ProRelatedLinksGetServicesQuery = { __typename?: 'Query', findManyService?: Array<{ __typename?: 'Service', id: number, translations: Array<{ __typename?: 'ServiceTranslation', id: number, url?: string | null, language: string, title?: string | null }> }> | null };

export type QuizResultsGetBreedsQueryVariables = Exact<{
  where?: InputMaybe<DogBreedWhereInput>;
  translationsWhere?: InputMaybe<DogBreedTranslationWhereInput>;
}>;


export type QuizResultsGetBreedsQuery = { __typename?: 'Query', findManyDogBreed?: Array<{ __typename?: 'DogBreed', id: number, name: string, baseBreedName?: string | null, exerciseIndex?: number | null, educationIndex?: number | null, careIndex?: number | null, sociabilityIndex?: number | null, independenceIndex?: number | null, physicalActivityNeedIndex?: number | null, predatoryInstinctIndex?: number | null, foreignerSociabilityIndex?: number | null, barkingTendancyIndex?: number | null, sizeCategory?: AnimalSizeEnum | null, dogBreeders: Array<{ __typename?: 'DogBreederBreeds', dogBreeder: { __typename?: 'DogBreeder', id: number, public?: boolean | null } }>, litters: Array<{ __typename?: 'Litter', id: number, adminValidated?: boolean | null, archived?: boolean | null }>, translations: Array<{ __typename?: 'DogBreedTranslation', id: number, name?: string | null, url?: string | null }>, imgs: Array<{ __typename?: 'DogBreedImg', id: number, small?: string | null }> }> | null };

export type AccountLogPasswordResetMutationVariables = Exact<{
  actionCode?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
}>;


export type AccountLogPasswordResetMutation = { __typename?: 'Mutation', logPasswordReset?: boolean | null };

export type ShelterListGetSheltersQueryVariables = Exact<{
  where?: InputMaybe<DogShelterWhereInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DogShelterOrderByWithRelationAndSearchRelevanceInput> | DogShelterOrderByWithRelationAndSearchRelevanceInput>;
  translationWhere?: InputMaybe<DogShelterTranslationWhereInput>;
}>;


export type ShelterListGetSheltersQuery = { __typename?: 'Query', findManyDogShelter?: Array<{ __typename?: 'DogShelter', id: number, name?: string | null, spokenLanguages: Array<string>, imgs: Array<{ __typename?: 'DogShelterImg', id: number, small?: string | null }>, address?: { __typename?: 'Address', id: number, country?: CountryCode | null, region?: string | null, city?: string | null, zip?: string | null } | null, translations: Array<{ __typename?: 'DogShelterTranslation', id: number, url?: string | null, language?: string | null }> }> | null, aggregateDogShelter?: { __typename?: 'AggregateDogShelter', _count?: { __typename?: 'DogShelterCountAggregateOutputType', _all: number } | null } | null };

export type ShelterGetArticlesQueryVariables = Exact<{
  where?: InputMaybe<ArticleWhereInput>;
  orderBy?: InputMaybe<Array<ArticleOrderByWithRelationAndSearchRelevanceInput> | ArticleOrderByWithRelationAndSearchRelevanceInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  articleCardInfoTranslationsWhere?: InputMaybe<ArticleTranslationsWhereInput>;
}>;


export type ShelterGetArticlesQuery = { __typename?: 'Query', findManyArticle?: Array<{ __typename?: 'Article', id: number, reviewed: boolean, coverImg?: string | null, tags: Array<string>, translations: Array<{ __typename?: 'ArticleTranslations', id: number, url: string, title: string }> }> | null };

export type ShelterGetShelterQueryVariables = Exact<{
  where?: InputMaybe<DogShelterWhereInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ShelterGetShelterQuery = { __typename?: 'Query', findManyDogShelter?: Array<{ __typename?: 'DogShelter', id: number, name?: string | null, agreementNumber?: string | null, emails?: Array<string | null> | null, phoneNumbers?: Array<string | null> | null, spokenLanguages: Array<string>, links?: Array<{ __typename?: 'DogShelterLink', link?: string | null, name?: string | null } | null> | null, translations: Array<{ __typename?: 'DogShelterTranslation', id: number, language?: string | null, description?: string | null, additionalInfo?: string | null }>, openingHours?: Array<{ __typename?: 'DogShelterOpeningHours', dayOfWeek?: DayOfWeek | null, startTime?: string | null, endTime?: string | null } | null> | null, imgs: Array<{ __typename?: 'DogShelterImg', id: number, small?: string | null, medium?: string | null, large?: string | null }>, address?: { __typename?: 'Address', id: number, country?: CountryCode | null, city?: string | null, street?: string | null, region?: string | null, zip?: string | null, lng?: number | null, lat?: number | null } | null }> | null };

export type ShelterGetSheltersQueryVariables = Exact<{
  where?: InputMaybe<DogShelterWhereInput>;
  translationWhere?: InputMaybe<DogShelterTranslationWhereInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ShelterGetSheltersQuery = { __typename?: 'Query', findManyDogShelter?: Array<{ __typename?: 'DogShelter', id: number, name?: string | null, spokenLanguages: Array<string>, imgs: Array<{ __typename?: 'DogShelterImg', id: number, small?: string | null }>, address?: { __typename?: 'Address', id: number, country?: CountryCode | null, region?: string | null, city?: string | null, zip?: string | null } | null, translations: Array<{ __typename?: 'DogShelterTranslation', id: number, url?: string | null, language?: string | null }> }> | null };

export type ShelterRelatedLinksGetArticlesQueryVariables = Exact<{
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ArticleWhereInput>;
  translationsWhere?: InputMaybe<ArticleTranslationsWhereInput>;
}>;


export type ShelterRelatedLinksGetArticlesQuery = { __typename?: 'Query', findManyArticle?: Array<{ __typename?: 'Article', id: number, translations: Array<{ __typename?: 'ArticleTranslations', id: number, url: string, title: string }> }> | null };

export type ShelterRelatedLinksGetBreedsQueryVariables = Exact<{
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DogBreedWhereInput>;
  translationsWhere?: InputMaybe<DogBreedTranslationWhereInput>;
}>;


export type ShelterRelatedLinksGetBreedsQuery = { __typename?: 'Query', findManyDogBreed?: Array<{ __typename?: 'DogBreed', id: number, translations: Array<{ __typename?: 'DogBreedTranslation', id: number, url?: string | null, name?: string | null }> }> | null };

export type ShelterRelatedLinksGetSheltersQueryVariables = Exact<{
  where?: InputMaybe<DogShelterWhereInput>;
  translationWhere?: InputMaybe<DogShelterTranslationWhereInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  randomOrder?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ShelterRelatedLinksGetSheltersQuery = { __typename?: 'Query', findManyDogShelter?: Array<{ __typename?: 'DogShelter', id: number, name?: string | null, translations: Array<{ __typename?: 'DogShelterTranslation', id: number, url?: string | null }> }> | null };

export type StudListGetStudsQueryVariables = Exact<{
  where?: InputMaybe<AnimalWhereInput>;
  breedingCardInfoTranslationsWhereBreed?: InputMaybe<DogBreedTranslationWhereInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AnimalOrderByWithRelationAndSearchRelevanceInput> | AnimalOrderByWithRelationAndSearchRelevanceInput>;
}>;


export type StudListGetStudsQuery = { __typename?: 'Query', findManyAnimal?: Array<{ __typename?: 'Animal', id: number, name?: string | null, imgs: Array<{ __typename?: 'AnimalImg', id: number, small?: string | null }>, dogInfos?: { __typename?: 'DogInfo', id: number, pedigree?: string | null, dogBreed?: { __typename?: 'DogBreed', translations: Array<{ __typename?: 'DogBreedTranslation', id: number, name?: string | null }> } | null } | null, studInfos?: { __typename?: 'StudInfo', id: number, price?: number | null, champion?: boolean | null } | null, owner: { __typename?: 'Account', address?: { __typename?: 'Address', region?: string | null, country?: CountryCode | null } | null } }> | null, aggregateAnimal?: { __typename?: 'AggregateAnimal', _count?: { __typename?: 'AnimalCountAggregateOutputType', _all: number } | null } | null };

export type StudGetBreedersQueryVariables = Exact<{
  where?: InputMaybe<DogBreederWhereInput>;
  orderBy?: InputMaybe<Array<DogBreederOrderByWithRelationAndSearchRelevanceInput> | DogBreederOrderByWithRelationAndSearchRelevanceInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  breederCardInfoTranslationsWhere?: InputMaybe<DogBreederTranslationWhereInput>;
  breederCardInfoTranslationsWhereBreed?: InputMaybe<DogBreedTranslationWhereInput>;
  breederCardInfoBreedImgsTake?: InputMaybe<Scalars['Int']['input']>;
  breederCardInfoLittersWhere?: InputMaybe<LitterWhereInput>;
}>;


export type StudGetBreedersQuery = { __typename?: 'Query', findManyDogBreeder?: Array<{ __typename?: 'DogBreeder', id: number, spokenLanguages: Array<string>, dogsPedigree?: string | null, lastConnectedType?: DogBreederLastConnectedTypeEnum | null, certificationFile?: string | null, breedClubValidated?: boolean | null, account: { __typename?: 'DogBreederAccount', id: number, connectedAt: any, address?: { __typename?: 'Address', id: number, country?: CountryCode | null, region?: string | null } | null }, translations: Array<{ __typename?: 'DogBreederTranslation', id: number, url?: string | null }>, reviews: Array<{ __typename?: 'DogBreederReview', id: number, globalGrade?: number | null, accountId: number }>, imgs: Array<{ __typename?: 'DogBreederImg', id: number, small?: string | null, type: string }>, breederBreeds: Array<{ __typename?: 'DogBreederBreeds', id: number, dogBreed: { __typename?: 'DogBreed', id: number, imgs: Array<{ __typename?: 'DogBreedImg', id: number, medium?: string | null }>, translations: Array<{ __typename?: 'DogBreedTranslation', id: number, name?: string | null }> } }>, litters: Array<{ __typename?: 'Litter', id: number }> }> | null };

export type StudGetStudQueryVariables = Exact<{
  where: AnimalWhereInput;
  breedCardInfoTranslationsWhere?: InputMaybe<DogBreedTranslationWhereInput>;
  breederCardInfoTranslationsWhere?: InputMaybe<DogBreederTranslationWhereInput>;
}>;


export type StudGetStudQuery = { __typename?: 'Query', findManyAnimal?: Array<{ __typename?: 'Animal', id: number, name?: string | null, weight?: number | null, size?: AnimalSizeEnum | null, imgs: Array<{ __typename?: 'AnimalImg', id: number, small?: string | null, medium?: string | null, large?: string | null }>, dogInfos?: { __typename?: 'DogInfo', id: number, pedigree?: string | null, color?: DogColor | null, coat?: DogCoat | null, dogBreed?: { __typename?: 'DogBreed', id: number, name: string, exerciseIndex?: number | null, educationIndex?: number | null, careIndex?: number | null, sociabilityIndex?: number | null, translations: Array<{ __typename?: 'DogBreedTranslation', id: number, name?: string | null, description?: string | null, url?: string | null, language: string }>, imgs: Array<{ __typename?: 'DogBreedImg', id: number, small?: string | null }> } | null } | null, studInfos?: { __typename?: 'StudInfo', id: number, price?: number | null, description?: string | null, champion?: boolean | null, type?: CouplingType | null, accomodation?: boolean | null } | null, owner: { __typename?: 'Account', id: number, dogBreeder?: { __typename?: 'DogBreeder', id: number, breedingName?: string | null, level?: string | null, profileImg?: string | null, certificationFile?: string | null, agreementNumber?: string | null, lastConnectedType?: DogBreederLastConnectedTypeEnum | null, spokenLanguages: Array<string>, translations: Array<{ __typename?: 'DogBreederTranslation', id: number, url?: string | null, language: string }>, account: { __typename?: 'DogBreederAccount', id: number, firstName?: string | null, lastName?: string | null, connectedAt: any, address?: { __typename?: 'Address', id: number, region?: string | null, country?: CountryCode | null } | null } } | null } }> | null };

export type UnsubscribeManageContactPreferencesMutationVariables = Exact<{
  data: ManageContactPreferencesInput;
}>;


export type UnsubscribeManageContactPreferencesMutation = { __typename?: 'Mutation', manageContactPreferences?: boolean | null };

export type UnsubscribeQueryVariables = Exact<{
  cryptedEmail: Scalars['String']['input'];
  contactPreferenceToDisable?: InputMaybe<Scalars['String']['input']>;
}>;


export type UnsubscribeQuery = { __typename?: 'Query', unsubscribe: { __typename?: 'CustomContactPreferences', email: string, contactPreferences: Array<ContactPreference>, isRegisteredUser?: boolean | null } };

export type GetContactPreferencesQueryVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type GetContactPreferencesQuery = { __typename?: 'Query', getContactPreferences: { __typename?: 'CustomContactPreferences', email: string, contactPreferences: Array<ContactPreference>, isRegisteredUser?: boolean | null } };

export type NewsletterCreateEmailContactMutationVariables = Exact<{
  data: CreateEmailContactInput;
}>;


export type NewsletterCreateEmailContactMutation = { __typename?: 'Mutation', createEmailContact: { __typename?: 'EmailContact', id: number } };

export type PersistHasADogMutationVariables = Exact<{
  data: PersistHasADogInput;
}>;


export type PersistHasADogMutation = { __typename?: 'Mutation', persistHasADog?: boolean | null };

export type GetAutocompleteResultsMutationVariables = Exact<{
  language: Scalars['String']['input'];
  location?: InputMaybe<Scalars['String']['input']>;
  placeId?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetAutocompleteResultsMutation = { __typename?: 'Mutation', autocompleteSuggestions?: Array<{ __typename?: 'AutocompleteSuggestion', placeId?: string | null, lon?: string | null, lat?: string | null, label?: string | null } | null> | null };

export type ProSearchGetProsQueryVariables = Exact<{
  where?: InputMaybe<ProfessionalWhereInput>;
}>;


export type ProSearchGetProsQuery = { __typename?: 'Query', searchProfessionals: { __typename?: 'SearchProfessionalsOutput', professionals: Array<{ __typename?: 'Professional', id: number, type: ProfessionalTypeEnum, centerType?: CenterTypeEnum | null, address?: { __typename?: 'Address', id: number, city?: string | null } | null, imgs: Array<{ __typename?: 'ProImg', id: number, medium?: string | null }>, translations: Array<{ __typename?: 'ProTranslation', id: number, language: string, url?: string | null, title?: string | null }> }> } };

export type ServiceSearchGetServicesQueryVariables = Exact<{
  servicesWhere?: InputMaybe<ServiceWhereInput>;
  serviceTranslationsWhere?: InputMaybe<ServiceTranslationWhereInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ServiceSearchGetServicesQuery = { __typename?: 'Query', findManyService?: Array<{ __typename?: 'Service', id: number, proType: ProfessionalTypeEnum, translations: Array<{ __typename?: 'ServiceTranslation', id: number, url?: string | null, language: string, title?: string | null }> }> | null };

export const BuyerAnimalInfoFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BuyerAnimalInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Animal"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"birthday"}},{"kind":"Field","name":{"kind":"Name","value":"birthdayType"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"sterilized"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"archived"}},{"kind":"Field","name":{"kind":"Name","value":"calved"}},{"kind":"Field","name":{"kind":"Name","value":"sensitivities"}},{"kind":"Field","name":{"kind":"Name","value":"imgs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"small"}},{"kind":"Field","name":{"kind":"Name","value":"medium"}}]}},{"kind":"Field","name":{"kind":"Name","value":"dogInfos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"physicalCondition"}},{"kind":"Field","name":{"kind":"Name","value":"pedigree"}},{"kind":"Field","name":{"kind":"Name","value":"medicalAffections"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"affectionType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"dogBreed"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<BuyerAnimalInfoFragment, unknown>;
export const ArticleCardInfoFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ArticleCardInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"reviewed"}},{"kind":"Field","name":{"kind":"Name","value":"coverImg"}},{"kind":"Field","name":{"kind":"Name","value":"tags"}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"articleCardInfoTranslationsWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]} as unknown as DocumentNode<ArticleCardInfoFragment, unknown>;
export const BookingCardInfoFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BookingCardInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Booking"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startDateTime"}},{"kind":"Field","name":{"kind":"Name","value":"endDateTime"}},{"kind":"Field","name":{"kind":"Name","value":"worker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"pro"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"minHoursBeforeUpdateOrCancelBooking"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"mobilePhone"}},{"kind":"Field","name":{"kind":"Name","value":"imgs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"small"}}]}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"bookingCardInfoProTranslationsWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"bookingAnimals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"animal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"birthday"}},{"kind":"Field","name":{"kind":"Name","value":"imgs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"small"}}]}},{"kind":"Field","name":{"kind":"Name","value":"dogInfos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"dogBreedId"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"workerService"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"categoryId"}},{"kind":"Field","name":{"kind":"Name","value":"service"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"bookingCardInfoServiceTranslationsWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]}}]}}]} as unknown as DocumentNode<BookingCardInfoFragment, unknown>;
export const BreedCardInfoFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BreedCardInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DogBreed"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"exerciseIndex"}},{"kind":"Field","name":{"kind":"Name","value":"educationIndex"}},{"kind":"Field","name":{"kind":"Name","value":"careIndex"}},{"kind":"Field","name":{"kind":"Name","value":"sociabilityIndex"}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"breedCardInfoTranslationsWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"language"}}]}},{"kind":"Field","name":{"kind":"Name","value":"imgs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"small"}}]}}]}}]} as unknown as DocumentNode<BreedCardInfoFragment, unknown>;
export const BreedDetailsInfoFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BreedDetailsInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DogBreed"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"headShape"}},{"kind":"Field","name":{"kind":"Name","value":"sizeCategory"}},{"kind":"Field","name":{"kind":"Name","value":"fciGroup"}},{"kind":"Field","name":{"kind":"Name","value":"homeCountryCode"}},{"kind":"Field","name":{"kind":"Name","value":"adultSizeAge"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"baseBreedName"}},{"kind":"Field","name":{"kind":"Name","value":"careIndex"}},{"kind":"Field","name":{"kind":"Name","value":"educationIndex"}},{"kind":"Field","name":{"kind":"Name","value":"sociabilityIndex"}},{"kind":"Field","name":{"kind":"Name","value":"sortingIndex"}},{"kind":"Field","name":{"kind":"Name","value":"exerciseIndex"}},{"kind":"Field","name":{"kind":"Name","value":"robustnessIndex"}},{"kind":"Field","name":{"kind":"Name","value":"maintenanceIndex"}},{"kind":"Field","name":{"kind":"Name","value":"hairLossIndex"}},{"kind":"Field","name":{"kind":"Name","value":"coldToleranceIndex"}},{"kind":"Field","name":{"kind":"Name","value":"heatToleranceIndex"}},{"kind":"Field","name":{"kind":"Name","value":"predatoryInstinctIndex"}},{"kind":"Field","name":{"kind":"Name","value":"barkingTendancyIndex"}},{"kind":"Field","name":{"kind":"Name","value":"independenceIndex"}},{"kind":"Field","name":{"kind":"Name","value":"foreignerSociabilityIndex"}},{"kind":"Field","name":{"kind":"Name","value":"intellectualActivityNeedIndex"}},{"kind":"Field","name":{"kind":"Name","value":"physicalActivityNeedIndex"}},{"kind":"Field","name":{"kind":"Name","value":"hairType"}},{"kind":"Field","name":{"kind":"Name","value":"imgs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"small"}},{"kind":"Field","name":{"kind":"Name","value":"medium"}},{"kind":"Field","name":{"kind":"Name","value":"large"}}]}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"seoDescription"}},{"kind":"Field","name":{"kind":"Name","value":"seoKeywords"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"synologyRank"}},{"kind":"Field","name":{"kind":"Name","value":"temper"}},{"kind":"Field","name":{"kind":"Name","value":"historic"}},{"kind":"Field","name":{"kind":"Name","value":"morphology"}},{"kind":"Field","name":{"kind":"Name","value":"fragilities"}},{"kind":"Field","name":{"kind":"Name","value":"advices"}},{"kind":"Field","name":{"kind":"Name","value":"otherNames"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"geneticAnalyzeType"}},{"kind":"Field","name":{"kind":"Name","value":"genetics"}}]}}]}}]} as unknown as DocumentNode<BreedDetailsInfoFragment, unknown>;
export const BreederCardInfoFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BreederCardInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DogBreeder"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"spokenLanguages"}},{"kind":"Field","name":{"kind":"Name","value":"dogsPedigree"}},{"kind":"Field","name":{"kind":"Name","value":"lastConnectedType"}},{"kind":"Field","name":{"kind":"Name","value":"certificationFile"}},{"kind":"Field","name":{"kind":"Name","value":"breedClubValidated"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"connectedAt"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"region"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"breederCardInfoTranslationsWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"reviews"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"globalGrade"}},{"kind":"Field","name":{"kind":"Name","value":"accountId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"imgs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"small"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"breederBreeds"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"dogBreed"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"imgs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"breederCardInfoBreedImgsTake"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"medium"}}]}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"breederCardInfoTranslationsWhereBreed"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"litters"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"breederCardInfoLittersWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<BreederCardInfoFragment, unknown>;
export const LitterCardInfoFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LitterCardInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Litter"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"priceFrom"}},{"kind":"Field","name":{"kind":"Name","value":"priceTo"}},{"kind":"Field","name":{"kind":"Name","value":"fixedPrice"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"birthday"}},{"kind":"Field","name":{"kind":"Name","value":"availabilityDate"}},{"kind":"Field","name":{"kind":"Name","value":"born"}},{"kind":"Field","name":{"kind":"Name","value":"pedigree"}},{"kind":"Field","name":{"kind":"Name","value":"malesLeftCount"}},{"kind":"Field","name":{"kind":"Name","value":"femalesLeftCount"}},{"kind":"Field","name":{"kind":"Name","value":"imgs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"litterCardInfoImgsTake"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"small"}},{"kind":"Field","name":{"kind":"Name","value":"medium"}}]}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"litterCardInfoTranslationsWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"breeder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"dogBreed"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"baseBreedName"}},{"kind":"Field","name":{"kind":"Name","value":"imgs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"large"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"litterCardInfoBreedTranslationsWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<LitterCardInfoFragment, unknown>;
export const ShelterCardInfoFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ShelterCardInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DogShelter"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"imgs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"small"}}]}},{"kind":"Field","name":{"kind":"Name","value":"spokenLanguages"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"zip"}}]}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"translationWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"language"}}]}}]}}]} as unknown as DocumentNode<ShelterCardInfoFragment, unknown>;
export const CurrentAccountInfoFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CurrentAccountInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Account"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"firebaseId"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"dogBreeder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"certified"}},{"kind":"Field","name":{"kind":"Name","value":"hasStartedOnboarding"}}]}},{"kind":"Field","name":{"kind":"Name","value":"imgs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"EnumValue","value":"PROFILE"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"small"}}]}}]}}]} as unknown as DocumentNode<CurrentAccountInfoFragment, unknown>;
export const MtSettingsBreederProfileFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MtSettingsBreederProfile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Account"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CurrentAccountInfo"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CurrentAccountInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Account"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"firebaseId"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"dogBreeder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"certified"}},{"kind":"Field","name":{"kind":"Name","value":"hasStartedOnboarding"}}]}},{"kind":"Field","name":{"kind":"Name","value":"imgs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"EnumValue","value":"PROFILE"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"small"}}]}}]}}]} as unknown as DocumentNode<MtSettingsBreederProfileFragment, unknown>;
export const MtSettingsBuyerProfileFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MtSettingsBuyerProfile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Account"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CurrentAccountInfo"}},{"kind":"Field","name":{"kind":"Name","value":"birthday"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CurrentAccountInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Account"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"firebaseId"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"dogBreeder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"certified"}},{"kind":"Field","name":{"kind":"Name","value":"hasStartedOnboarding"}}]}},{"kind":"Field","name":{"kind":"Name","value":"imgs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"EnumValue","value":"PROFILE"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"small"}}]}}]}}]} as unknown as DocumentNode<MtSettingsBuyerProfileFragment, unknown>;
export const AccountBuyerGetAnimalsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AccountBuyerGetAnimals"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AnimalOrderByWithRelationAndSearchRelevanceInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AnimalWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountMe"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"animals"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BuyerAnimalInfo"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BuyerAnimalInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Animal"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"birthday"}},{"kind":"Field","name":{"kind":"Name","value":"birthdayType"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"sterilized"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"archived"}},{"kind":"Field","name":{"kind":"Name","value":"calved"}},{"kind":"Field","name":{"kind":"Name","value":"sensitivities"}},{"kind":"Field","name":{"kind":"Name","value":"imgs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"small"}},{"kind":"Field","name":{"kind":"Name","value":"medium"}}]}},{"kind":"Field","name":{"kind":"Name","value":"dogInfos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"physicalCondition"}},{"kind":"Field","name":{"kind":"Name","value":"pedigree"}},{"kind":"Field","name":{"kind":"Name","value":"medicalAffections"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"affectionType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"dogBreed"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<AccountBuyerGetAnimalsQuery, AccountBuyerGetAnimalsQueryVariables>;
export const AccountGetAnimalSensitivitiesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AccountGetAnimalSensitivities"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AnimalWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountMe"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"animals"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sensitivities"}}]}}]}}]}}]} as unknown as DocumentNode<AccountGetAnimalSensitivitiesQuery, AccountGetAnimalSensitivitiesQueryVariables>;
export const ApplicationGetApplicationExistsForBreederIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ApplicationGetApplicationExistsForBreederId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DogBreederApplicationWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountMe"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"applications"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<ApplicationGetApplicationExistsForBreederIdQuery, ApplicationGetApplicationExistsForBreederIdQueryVariables>;
export const ApplicationGetApplicationForBreederIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ApplicationGetApplicationForBreederId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DogBreederApplicationWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountMe"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"applications"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<ApplicationGetApplicationForBreederIdQuery, ApplicationGetApplicationForBreederIdQueryVariables>;
export const AccountGetBreederApplicationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AccountGetBreederApplications"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"breedTranslationsWhere"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DogBreedTranslationWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DogBreederApplicationOrderByWithRelationAndSearchRelevanceInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DogBreederApplicationWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountMe"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"dogBreeder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"breederBreeds"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"dogBreedId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"applications"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"seenByBreeder"}},{"kind":"Field","name":{"kind":"Name","value":"breedPreference"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"breedTranslationsWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"imgs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"EnumValue","value":"COVER"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"small"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"animal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"birthday"}}]}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"imgs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"small"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<AccountGetBreederApplicationsQuery, AccountGetBreederApplicationsQueryVariables>;
export const AccountGetBuyerApplicationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AccountGetBuyerApplications"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"breedTranslationsWhere"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DogBreedTranslationWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DogBreederApplicationOrderByWithRelationAndSearchRelevanceInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DogBreederApplicationWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountMe"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"applications"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"seenByBuyer"}},{"kind":"Field","name":{"kind":"Name","value":"breedPreference"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"breedTranslationsWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"imgs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"EnumValue","value":"COVER"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"small"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"puppy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"dateOfBirth"}}]}},{"kind":"Field","name":{"kind":"Name","value":"dogBreeder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"profileImg"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"breederBreeds"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dogBreedId"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<AccountGetBuyerApplicationsQuery, AccountGetBuyerApplicationsQueryVariables>;
export const AccountGetBuyerDraftAnimalsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AccountGetBuyerDraftAnimals"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AnimalWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountMe"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"animals"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<AccountGetBuyerDraftAnimalsQuery, AccountGetBuyerDraftAnimalsQueryVariables>;
export const AccountGetBuyerUnpaidApplicationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AccountGetBuyerUnpaidApplications"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DogBreederApplicationWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountMe"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"applications"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"dogBreeder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"profileImg"}}]}},{"kind":"Field","name":{"kind":"Name","value":"breedPreference"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"translations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<AccountGetBuyerUnpaidApplicationsQuery, AccountGetBuyerUnpaidApplicationsQueryVariables>;
export const AccountCreateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AccountCreate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AccountCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createAccount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"token"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CurrentAccountInfo"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CurrentAccountInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Account"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"firebaseId"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"dogBreeder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"certified"}},{"kind":"Field","name":{"kind":"Name","value":"hasStartedOnboarding"}}]}},{"kind":"Field","name":{"kind":"Name","value":"imgs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"EnumValue","value":"PROFILE"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"small"}}]}}]}}]} as unknown as DocumentNode<AccountCreateMutation, AccountCreateMutationVariables>;
export const CurrentAccountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CurrentAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountMe"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CurrentAccountInfo"}},{"kind":"Field","name":{"kind":"Name","value":"accountRemainingDaysForFreeApplications"}},{"kind":"Field","name":{"kind":"Name","value":"hasADog"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CurrentAccountInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Account"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"firebaseId"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"dogBreeder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"certified"}},{"kind":"Field","name":{"kind":"Name","value":"hasStartedOnboarding"}}]}},{"kind":"Field","name":{"kind":"Name","value":"imgs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"EnumValue","value":"PROFILE"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"small"}}]}}]}}]} as unknown as DocumentNode<CurrentAccountQuery, CurrentAccountQueryVariables>;
export const JoinBuyerSendMessageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"JoinBuyerSendMessage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SendMessageInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sendMessage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<JoinBuyerSendMessageMutation, JoinBuyerSendMessageMutationVariables>;
export const AccountDeleteAccountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AccountDeleteAccount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"feedback"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteAccount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"feedback"},"value":{"kind":"Variable","name":{"kind":"Name","value":"feedback"}}}]}]}}]} as unknown as DocumentNode<AccountDeleteAccountMutation, AccountDeleteAccountMutationVariables>;
export const AccountLoginDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AccountLogin"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AccountLoginInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"login"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"token"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CurrentAccountInfo"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CurrentAccountInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Account"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"firebaseId"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"dogBreeder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"certified"}},{"kind":"Field","name":{"kind":"Name","value":"hasStartedOnboarding"}}]}},{"kind":"Field","name":{"kind":"Name","value":"imgs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"EnumValue","value":"PROFILE"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"small"}}]}}]}}]} as unknown as DocumentNode<AccountLoginMutation, AccountLoginMutationVariables>;
export const AccountResetPasswordDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AccountResetPassword"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sendPasswordResetEmail"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}}]}]}}]} as unknown as DocumentNode<AccountResetPasswordMutation, AccountResetPasswordMutationVariables>;
export const AccountGetUnseenMessagesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AccountGetUnseenMessages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unseenMessages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fromAccountId"}}]}}]}}]} as unknown as DocumentNode<AccountGetUnseenMessagesQuery, AccountGetUnseenMessagesQueryVariables>;
export const AccountUpdateAccountLanuageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AccountUpdateAccountLanuage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AccountUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountMeUpdate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CurrentAccountInfo"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CurrentAccountInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Account"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"firebaseId"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"dogBreeder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"certified"}},{"kind":"Field","name":{"kind":"Name","value":"hasStartedOnboarding"}}]}},{"kind":"Field","name":{"kind":"Name","value":"imgs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"EnumValue","value":"PROFILE"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"small"}}]}}]}}]} as unknown as DocumentNode<AccountUpdateAccountLanuageMutation, AccountUpdateAccountLanuageMutationVariables>;
export const AccountUpdatePasswordDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AccountUpdatePassword"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"password"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatePassword"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"password"},"value":{"kind":"Variable","name":{"kind":"Name","value":"password"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"token"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CurrentAccountInfo"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CurrentAccountInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Account"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"firebaseId"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"dogBreeder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"certified"}},{"kind":"Field","name":{"kind":"Name","value":"hasStartedOnboarding"}}]}},{"kind":"Field","name":{"kind":"Name","value":"imgs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"EnumValue","value":"PROFILE"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"small"}}]}}]}}]} as unknown as DocumentNode<AccountUpdatePasswordMutation, AccountUpdatePasswordMutationVariables>;
export const BreederLitterListGetBreedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BreederLitterListGetBreed"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DogBreedWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findManyDogBreed"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"headShape"}},{"kind":"Field","name":{"kind":"Name","value":"fciGroup"}},{"kind":"Field","name":{"kind":"Name","value":"hairType"}},{"kind":"Field","name":{"kind":"Name","value":"imgs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"small"}},{"kind":"Field","name":{"kind":"Name","value":"medium"}},{"kind":"Field","name":{"kind":"Name","value":"large"}}]}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"otherNames"}}]}}]}}]}}]} as unknown as DocumentNode<BreederLitterListGetBreedQuery, BreederLitterListGetBreedQueryVariables>;
export const GetBreedsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetBreeds"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DogBreedWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"translationsWhere"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DogBreedTranslationWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findManyDogBreed"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"sizeCategory"}},{"kind":"Field","name":{"kind":"Name","value":"baseBreedName"}},{"kind":"Field","name":{"kind":"Name","value":"isSubBreed"}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"translationsWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"otherNames"}}]}}]}}]}}]} as unknown as DocumentNode<GetBreedsQuery, GetBreedsQueryVariables>;
export const DogBreedInterestSubscriptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DogBreedInterestSubscription"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DogBreedInterestSubscriptionWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findManyDogBreedInterestSubscription"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"dogBreeds"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<DogBreedInterestSubscriptionQuery, DogBreedInterestSubscriptionQueryVariables>;
export const LogDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"Log"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LogInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"log"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}]}]}}]} as unknown as DocumentNode<LogMutation, LogMutationVariables>;
export const CreateApplicationForSuggestedBreederDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateApplicationForSuggestedBreeder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateApplicationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"confirmCreateApplication"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateApplicationForSuggestedBreederMutation, CreateApplicationForSuggestedBreederMutationVariables>;
export const ApplicationGetSuggestedBreedersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ApplicationGetSuggestedBreeders"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DogBreederWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DogBreederOrderByWithRelationAndSearchRelevanceInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"breederCardInfoTranslationsWhere"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DogBreederTranslationWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"breederCardInfoTranslationsWhereBreed"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DogBreedTranslationWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"breederCardInfoBreedImgsTake"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"breederCardInfoLittersWhere"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LitterWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findManyDogBreeder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BreederCardInfo"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BreederCardInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DogBreeder"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"spokenLanguages"}},{"kind":"Field","name":{"kind":"Name","value":"dogsPedigree"}},{"kind":"Field","name":{"kind":"Name","value":"lastConnectedType"}},{"kind":"Field","name":{"kind":"Name","value":"certificationFile"}},{"kind":"Field","name":{"kind":"Name","value":"breedClubValidated"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"connectedAt"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"region"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"breederCardInfoTranslationsWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"reviews"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"globalGrade"}},{"kind":"Field","name":{"kind":"Name","value":"accountId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"imgs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"small"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"breederBreeds"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"dogBreed"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"imgs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"breederCardInfoBreedImgsTake"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"medium"}}]}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"breederCardInfoTranslationsWhereBreed"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"litters"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"breederCardInfoLittersWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<ApplicationGetSuggestedBreedersQuery, ApplicationGetSuggestedBreedersQueryVariables>;
export const getLocationCountryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getLocationCountry"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"location"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locationCountry"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"location"},"value":{"kind":"Variable","name":{"kind":"Name","value":"location"}}}]}]}}]} as unknown as DocumentNode<getLocationCountryQuery, getLocationCountryQueryVariables>;
export const ProWorkerGetAvailabilitiesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProWorkerGetAvailabilities"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fromDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"proId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workerServiceId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"proServiceId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"forMultiAnimals"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findBookingAvailabilities"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workerServiceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workerServiceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"fromDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fromDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"proId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"proId"}}},{"kind":"Argument","name":{"kind":"Name","value":"proServiceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"proServiceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"forMultiAnimals"},"value":{"kind":"Variable","name":{"kind":"Name","value":"forMultiAnimals"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mergedWorkerAvailabilities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startDateTime"}},{"kind":"Field","name":{"kind":"Name","value":"endDateTime"}},{"kind":"Field","name":{"kind":"Name","value":"workerServiceIds"}},{"kind":"Field","name":{"kind":"Name","value":"workerIds"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nextAvailability"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workerId"}},{"kind":"Field","name":{"kind":"Name","value":"date"}}]}}]}}]}}]} as unknown as DocumentNode<ProWorkerGetAvailabilitiesQuery, ProWorkerGetAvailabilitiesQueryVariables>;
export const BookingSlotPickerGetProDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BookingSlotPickerGetPro"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProfessionalWhereInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"serviceLanguage"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"translationsWhere"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ProTranslationWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"serviceTranslationsWhere"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ServiceTranslationWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workerServiceTranslationsWhere"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"WorkerServiceTranslationWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchProfessionals"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"professionals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"minHoursBeforeUpdateOrCancelBooking"}},{"kind":"Field","name":{"kind":"Name","value":"allowsAnyWorkerOption"}},{"kind":"Field","name":{"kind":"Name","value":"acceptedAnimals"}},{"kind":"Field","name":{"kind":"Name","value":"onlineBookingEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"workers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"services"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"language"},"value":{"kind":"Variable","name":{"kind":"Name","value":"serviceLanguage"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"bookable"}},{"kind":"Field","name":{"kind":"Name","value":"service"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"serviceTranslationsWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"workerServices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"animalSize"}},{"kind":"Field","name":{"kind":"Name","value":"animalType"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"workerId"}},{"kind":"Field","name":{"kind":"Name","value":"bookable"}},{"kind":"Field","name":{"kind":"Name","value":"multiAnimalsBookingEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"multiAnimalsDuration"}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workerServiceTranslationsWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"preBookingWarning"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"translationsWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"preBookingWarning"}}]}}]}}]}}]}}]} as unknown as DocumentNode<BookingSlotPickerGetProQuery, BookingSlotPickerGetProQueryVariables>;
export const BreederOverviewGetBreederDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BreederOverviewGetBreeder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DogBreederWhereInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"breedCardInfoTranslationsWhere"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DogBreedTranslationWhereInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findManyDogBreeder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"agreementNumber"}},{"kind":"Field","name":{"kind":"Name","value":"websiteUrl"}},{"kind":"Field","name":{"kind":"Name","value":"certificationFile"}},{"kind":"Field","name":{"kind":"Name","value":"level"}},{"kind":"Field","name":{"kind":"Name","value":"spokenLanguages"}},{"kind":"Field","name":{"kind":"Name","value":"breedingName"}},{"kind":"Field","name":{"kind":"Name","value":"profileImg"}},{"kind":"Field","name":{"kind":"Name","value":"lastConnectedType"}},{"kind":"Field","name":{"kind":"Name","value":"imgs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"small"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"large"}}]}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"seoKeywords"}},{"kind":"Field","name":{"kind":"Name","value":"dogsActivities"}},{"kind":"Field","name":{"kind":"Name","value":"puppiesLivingPlace"}},{"kind":"Field","name":{"kind":"Name","value":"dogsLivingPlace"}},{"kind":"Field","name":{"kind":"Name","value":"health"}},{"kind":"Field","name":{"kind":"Name","value":"breederDogsSelection"}},{"kind":"Field","name":{"kind":"Name","value":"puppiesTraining"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"language"}}]}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"connectedAt"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"zip"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"street"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"breederBreeds"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"dogBreed"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseBreedName"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"breedCardInfoTranslationsWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"language"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<BreederOverviewGetBreederQuery, BreederOverviewGetBreederQueryVariables>;
export const ContactSendContactMessageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ContactSendContactMessage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"language"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"messageContent"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"phone"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lastName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"firstName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contactReasonType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ContactReasonTypeEnum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"country"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CountryCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contactSupport"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"Argument","name":{"kind":"Name","value":"language"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}},{"kind":"Argument","name":{"kind":"Name","value":"messageContent"},"value":{"kind":"Variable","name":{"kind":"Name","value":"messageContent"}}},{"kind":"Argument","name":{"kind":"Name","value":"phone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"phone"}}},{"kind":"Argument","name":{"kind":"Name","value":"lastName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lastName"}}},{"kind":"Argument","name":{"kind":"Name","value":"firstName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"firstName"}}},{"kind":"Argument","name":{"kind":"Name","value":"contactReasonType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contactReasonType"}}},{"kind":"Argument","name":{"kind":"Name","value":"country"},"value":{"kind":"Variable","name":{"kind":"Name","value":"country"}}}]}]}}]} as unknown as DocumentNode<ContactSendContactMessageMutation, ContactSendContactMessageMutationVariables>;
export const BreedInterestCreateDogBreedInterestSubscriptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"BreedInterestCreateDogBreedInterestSubscription"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateDogBreedInterestSubscriptionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createDogBreedInterestSubscription"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<BreedInterestCreateDogBreedInterestSubscriptionMutation, BreedInterestCreateDogBreedInterestSubscriptionMutationVariables>;
export const BreederReviewsGetReviewsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BreederReviewsGetReviews"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DogBreederReviewWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"breederWhere"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DogBreederWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DogBreederReviewOrderByWithRelationAndSearchRelevanceInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findManyDogBreeder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"breederWhere"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"reviews"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"globalGrade"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"contactType"}},{"kind":"Field","name":{"kind":"Name","value":"contactDate"}},{"kind":"Field","name":{"kind":"Name","value":"reviewerPic"}},{"kind":"Field","name":{"kind":"Name","value":"reviewerName"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"imgs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"small"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"answer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"breederName"}},{"kind":"Field","name":{"kind":"Name","value":"dogBreeder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"profileImg"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"aggregateDogBreederReview"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_count"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_all"}}]}},{"kind":"Field","name":{"kind":"Name","value":"_avg"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"humanContactGrade"}},{"kind":"Field","name":{"kind":"Name","value":"hygieneGrade"}},{"kind":"Field","name":{"kind":"Name","value":"globalGrade"}},{"kind":"Field","name":{"kind":"Name","value":"dogsWellBeingGrade"}},{"kind":"Field","name":{"kind":"Name","value":"followUpGrade"}}]}}]}}]}}]} as unknown as DocumentNode<BreederReviewsGetReviewsQuery, BreederReviewsGetReviewsQueryVariables>;
export const BreederUpdateReviewDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"BreederUpdateReview"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DogBreederReviewUpdateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reviewId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateDogBreederReview"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}},{"kind":"Argument","name":{"kind":"Name","value":"reviewId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reviewId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<BreederUpdateReviewMutation, BreederUpdateReviewMutationVariables>;
export const FooterGetBreedsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FooterGetBreeds"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DogBreedWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"breedCardInfoTranslationsWhere"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DogBreedTranslationWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"randomOrder"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findManyDogBreed"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"randomOrder"},"value":{"kind":"Variable","name":{"kind":"Name","value":"randomOrder"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"baseBreedName"}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"breedCardInfoTranslationsWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"language"}}]}},{"kind":"Field","name":{"kind":"Name","value":"_count"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dogBreeders"}},{"kind":"Field","name":{"kind":"Name","value":"litters"}}]}}]}}]}}]} as unknown as DocumentNode<FooterGetBreedsQuery, FooterGetBreedsQueryVariables>;
export const JoinProSendContactMessageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"JoinProSendContactMessage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"language"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"phone"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lastName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"messageContent"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"firstName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contactReasonType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ContactReasonTypeEnum"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contactSupport"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"messageContent"},"value":{"kind":"Variable","name":{"kind":"Name","value":"messageContent"}}},{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"Argument","name":{"kind":"Name","value":"language"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}},{"kind":"Argument","name":{"kind":"Name","value":"phone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"phone"}}},{"kind":"Argument","name":{"kind":"Name","value":"lastName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lastName"}}},{"kind":"Argument","name":{"kind":"Name","value":"firstName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"firstName"}}},{"kind":"Argument","name":{"kind":"Name","value":"contactReasonType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contactReasonType"}}}]}]}}]} as unknown as DocumentNode<JoinProSendContactMessageMutation, JoinProSendContactMessageMutationVariables>;
export const MtApplicationsBuyerCheckoutApplicationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MtApplicationsBuyerCheckoutApplication"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CheckoutApplicationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"checkoutApplication"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<MtApplicationsBuyerCheckoutApplicationMutation, MtApplicationsBuyerCheckoutApplicationMutationVariables>;
export const ApplicationGetApplicationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ApplicationGetApplication"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DogBreederApplicationWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findUniqueApplication"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"animal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"birthday"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"dogInfos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"dogBreedId"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ApplicationGetApplicationQuery, ApplicationGetApplicationQueryVariables>;
export const MtApplicationsOwnApplicationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MtApplicationsOwnApplication"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OwnApplicationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ownApplication"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]} as unknown as DocumentNode<MtApplicationsOwnApplicationMutation, MtApplicationsOwnApplicationMutationVariables>;
export const MtApplicationsWaitlistApplicationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MtApplicationsWaitlistApplication"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"WaitlistApplicationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"waitlistApplication"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]} as unknown as DocumentNode<MtApplicationsWaitlistApplicationMutation, MtApplicationsWaitlistApplicationMutationVariables>;
export const MtNotificationsGetNotificationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MtNotificationsGetNotifications"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"NotificationWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"NotificationOrderByWithRelationAndSearchRelevanceInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findManyNotification"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"applicationId"}},{"kind":"Field","name":{"kind":"Name","value":"litterId"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"language"}}]}},{"kind":"Field","name":{"kind":"Name","value":"breeder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"application"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dogBreeder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"language"}}]}},{"kind":"Field","name":{"kind":"Name","value":"breedPreference"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"translations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"language"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"unreadMessagesCount"}}]}}]}}]} as unknown as DocumentNode<MtNotificationsGetNotificationsQuery, MtNotificationsGetNotificationsQueryVariables>;
export const MtNotificationMarkAsReadDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MtNotificationMarkAsRead"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"notificationId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"markAsRead"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"notificationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"notificationId"}}}]}]}}]} as unknown as DocumentNode<MtNotificationMarkAsReadMutation, MtNotificationMarkAsReadMutationVariables>;
export const AccountNewNotificationsCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AccountNewNotificationsCount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"newNotificationsCount"}}]}}]} as unknown as DocumentNode<AccountNewNotificationsCountQuery, AccountNewNotificationsCountQueryVariables>;
export const MtSocialProvidersAccountProvidersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MtSocialProvidersAccountProviders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountMe"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"googleId"}},{"kind":"Field","name":{"kind":"Name","value":"firebaseId"}},{"kind":"Field","name":{"kind":"Name","value":"facebookId"}}]}}]}}]} as unknown as DocumentNode<MtSocialProvidersAccountProvidersQuery, MtSocialProvidersAccountProvidersQueryVariables>;
export const MtSocialProvidersLinkAccountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MtSocialProvidersLinkAccount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"password"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"googleToken"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"facebookToken"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"linkAccount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"Argument","name":{"kind":"Name","value":"password"},"value":{"kind":"Variable","name":{"kind":"Name","value":"password"}}},{"kind":"Argument","name":{"kind":"Name","value":"googleToken"},"value":{"kind":"Variable","name":{"kind":"Name","value":"googleToken"}}},{"kind":"Argument","name":{"kind":"Name","value":"facebookToken"},"value":{"kind":"Variable","name":{"kind":"Name","value":"facebookToken"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<MtSocialProvidersLinkAccountMutation, MtSocialProvidersLinkAccountMutationVariables>;
export const MtSocialProvidersUnlinkAccountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MtSocialProvidersUnlinkAccount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"type"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AuthTokenInfoType"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unlinkAccount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"type"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<MtSocialProvidersUnlinkAccountMutation, MtSocialProvidersUnlinkAccountMutationVariables>;
export const UpdateLitterModalCountLittersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UpdateLitterModalCountLitters"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LitterWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregateLitter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_count"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_all"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateLitterModalCountLittersQuery, UpdateLitterModalCountLittersQueryVariables>;
export const OldProRedirectionGetProDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OldProRedirectionGetPro"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProfessionalWhereInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"translationsWhere"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProTranslationWhereInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchProfessionals"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"professionals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"translationsWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]} as unknown as DocumentNode<OldProRedirectionGetProQuery, OldProRedirectionGetProQueryVariables>;
export const ToggleDogBreedInterestToSubscriptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ToggleDogBreedInterestToSubscription"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ToggleDogBreedInDogBreedInterestSubscriptionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"toggleDogBreedInDogBreedInterestSubscription"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<ToggleDogBreedInterestToSubscriptionMutation, ToggleDogBreedInterestToSubscriptionMutationVariables>;
export const BreederGetWhatsappInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BreederGetWhatsappInfo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DogBreederWhereInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findManyDogBreeder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"whatsappNumber"}},{"kind":"Field","name":{"kind":"Name","value":"profileImg"}},{"kind":"Field","name":{"kind":"Name","value":"spokenLanguages"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"breederBreeds"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"dogBreed"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"baseBreedName"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<BreederGetWhatsappInfoQuery, BreederGetWhatsappInfoQueryVariables>;
export const ProGetWhatsappInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProGetWhatsappInfo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProfessionalWhereInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchProfessionals"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"professionals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"whatsappNumber"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"imgs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"small"}}]}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ProGetWhatsappInfoQuery, ProGetWhatsappInfoQueryVariables>;
export const LinkProCalendarMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"LinkProCalendarMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"code"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"linkProfessionalCalendar"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"code"},"value":{"kind":"Variable","name":{"kind":"Name","value":"code"}}}]}]}}]} as unknown as DocumentNode<LinkProCalendarMutationMutation, LinkProCalendarMutationMutationVariables>;
export const ProfessionalCalendarRequestAccessUrlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProfessionalCalendarRequestAccessUrl"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"professionalCalendarRequestAccessUrl"}}]}}]} as unknown as DocumentNode<ProfessionalCalendarRequestAccessUrlQuery, ProfessionalCalendarRequestAccessUrlQueryVariables>;
export const ApplicationConfirmCreateApplicationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ApplicationConfirmCreateApplication"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateApplicationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"confirmCreateApplication"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<ApplicationConfirmCreateApplicationMutation, ApplicationConfirmCreateApplicationMutationVariables>;
export const ApplicationCreateDraftApplicationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ApplicationCreateDraftApplication"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateApplicationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createDraftApplication"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<ApplicationCreateDraftApplicationMutation, ApplicationCreateDraftApplicationMutationVariables>;
export const ApplicationGetBreederDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ApplicationGetBreeder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DogBreederWhereUniqueInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"translationsWhere"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DogBreederTranslationWhereInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"breederCardInfoTranslationsWhereBreed"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DogBreedTranslationWhereInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findUniqueDogBreeder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"spokenLanguages"}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"translationsWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"breederBreeds"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"dogBreed"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"breederCardInfoTranslationsWhereBreed"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ApplicationGetBreederQuery, ApplicationGetBreederQueryVariables>;
export const ApplicationGetLatestApplicationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ApplicationGetLatestApplication"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DogBreederApplicationWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DogBreederApplicationOrderByWithRelationAndSearchRelevanceInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountMe"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"applications"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"motive"}},{"kind":"Field","name":{"kind":"Name","value":"otherAnimals"}},{"kind":"Field","name":{"kind":"Name","value":"accommodation"}},{"kind":"Field","name":{"kind":"Name","value":"experiences"}},{"kind":"Field","name":{"kind":"Name","value":"timeAlone"}},{"kind":"Field","name":{"kind":"Name","value":"trainers"}},{"kind":"Field","name":{"kind":"Name","value":"genderPreferences"}},{"kind":"Field","name":{"kind":"Name","value":"otherPreferences"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"questions"}},{"kind":"Field","name":{"kind":"Name","value":"breedPreference"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ApplicationGetLatestApplicationQuery, ApplicationGetLatestApplicationQueryVariables>;
export const ArticlesGetArticlesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ArticlesGetArticles"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ArticleWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ArticleOrderByWithRelationAndSearchRelevanceInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"articleCardInfoTranslationsWhere"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ArticleTranslationsWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregateArticle"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_count"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_all"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"findManyArticle"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ArticleCardInfo"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ArticleCardInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"reviewed"}},{"kind":"Field","name":{"kind":"Name","value":"coverImg"}},{"kind":"Field","name":{"kind":"Name","value":"tags"}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"articleCardInfoTranslationsWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]} as unknown as DocumentNode<ArticlesGetArticlesQuery, ArticlesGetArticlesQueryVariables>;
export const ArticleGetArticleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ArticleGetArticle"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ArticleWhereInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"translationsWhere"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ArticleTranslationsWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"takeArticles"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"articlesWhere"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ArticleWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"articleCardInfoTranslationsWhere"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ArticleTranslationsWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"article"},"name":{"kind":"Name","value":"findManyArticle"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"reviewed"}},{"kind":"Field","name":{"kind":"Name","value":"coverImg"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"authorName"}},{"kind":"Field","name":{"kind":"Name","value":"tags"}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"translationsWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"seoKeywords"}},{"kind":"Field","name":{"kind":"Name","value":"seoTitle"}},{"kind":"Field","name":{"kind":"Name","value":"seoDescription"}},{"kind":"Field","name":{"kind":"Name","value":"languageCode"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"articles"},"name":{"kind":"Name","value":"findManyArticle"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"articlesWhere"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"takeArticles"}}},{"kind":"Argument","name":{"kind":"Name","value":"randomOrder"},"value":{"kind":"BooleanValue","value":true}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ArticleCardInfo"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ArticleCardInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"reviewed"}},{"kind":"Field","name":{"kind":"Name","value":"coverImg"}},{"kind":"Field","name":{"kind":"Name","value":"tags"}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"articleCardInfoTranslationsWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]} as unknown as DocumentNode<ArticleGetArticleQuery, ArticleGetArticleQueryVariables>;
export const CreateBookingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateBooking"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workerServiceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"bookingReason"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startDateTime"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"bookingCardInfoProTranslationsWhere"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProTranslationWhereInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"bookingCardInfoServiceTranslationsWhere"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ServiceTranslationWhereInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"bookingAnimals"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BookingAnimalCreate"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"phoneNumber"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"forMultiAnimals"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createBooking"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workerServiceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workerServiceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"bookingReason"},"value":{"kind":"Variable","name":{"kind":"Name","value":"bookingReason"}}},{"kind":"Argument","name":{"kind":"Name","value":"startDateTime"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDateTime"}}},{"kind":"Argument","name":{"kind":"Name","value":"phoneNumber"},"value":{"kind":"Variable","name":{"kind":"Name","value":"phoneNumber"}}},{"kind":"Argument","name":{"kind":"Name","value":"bookingAnimals"},"value":{"kind":"Variable","name":{"kind":"Name","value":"bookingAnimals"}}},{"kind":"Argument","name":{"kind":"Name","value":"forMultiAnimals"},"value":{"kind":"Variable","name":{"kind":"Name","value":"forMultiAnimals"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BookingCardInfo"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BookingCardInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Booking"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startDateTime"}},{"kind":"Field","name":{"kind":"Name","value":"endDateTime"}},{"kind":"Field","name":{"kind":"Name","value":"worker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"pro"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"minHoursBeforeUpdateOrCancelBooking"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"mobilePhone"}},{"kind":"Field","name":{"kind":"Name","value":"imgs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"small"}}]}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"bookingCardInfoProTranslationsWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"bookingAnimals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"animal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"birthday"}},{"kind":"Field","name":{"kind":"Name","value":"imgs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"small"}}]}},{"kind":"Field","name":{"kind":"Name","value":"dogInfos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"dogBreedId"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"workerService"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"categoryId"}},{"kind":"Field","name":{"kind":"Name","value":"service"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"bookingCardInfoServiceTranslationsWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CreateBookingMutation, CreateBookingMutationVariables>;
export const BookingGetProDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BookingGetPro"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProfessionalWhereInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"language"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchProfessionals"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"professionals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"acceptedAnimals"}},{"kind":"Field","name":{"kind":"Name","value":"onlineBookingEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"imgs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"small"}}]}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"zip"}},{"kind":"Field","name":{"kind":"Name","value":"city"}}]}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"preBookingWarning"}}]}},{"kind":"Field","name":{"kind":"Name","value":"workers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"services"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"language"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"service"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"workerServices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"bookingDuration"}},{"kind":"Field","name":{"kind":"Name","value":"multiAnimalsBookingEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"multiAnimalsDuration"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"priceType"}},{"kind":"Field","name":{"kind":"Name","value":"priceFrom"}},{"kind":"Field","name":{"kind":"Name","value":"priceTo"}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"preBookingWarning"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<BookingGetProQuery, BookingGetProQueryVariables>;
export const BreedComparatorGetBreedsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BreedComparatorGetBreeds"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DogBreedWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findManyDogBreed"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BreedDetailsInfo"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BreedDetailsInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DogBreed"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"headShape"}},{"kind":"Field","name":{"kind":"Name","value":"sizeCategory"}},{"kind":"Field","name":{"kind":"Name","value":"fciGroup"}},{"kind":"Field","name":{"kind":"Name","value":"homeCountryCode"}},{"kind":"Field","name":{"kind":"Name","value":"adultSizeAge"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"baseBreedName"}},{"kind":"Field","name":{"kind":"Name","value":"careIndex"}},{"kind":"Field","name":{"kind":"Name","value":"educationIndex"}},{"kind":"Field","name":{"kind":"Name","value":"sociabilityIndex"}},{"kind":"Field","name":{"kind":"Name","value":"sortingIndex"}},{"kind":"Field","name":{"kind":"Name","value":"exerciseIndex"}},{"kind":"Field","name":{"kind":"Name","value":"robustnessIndex"}},{"kind":"Field","name":{"kind":"Name","value":"maintenanceIndex"}},{"kind":"Field","name":{"kind":"Name","value":"hairLossIndex"}},{"kind":"Field","name":{"kind":"Name","value":"coldToleranceIndex"}},{"kind":"Field","name":{"kind":"Name","value":"heatToleranceIndex"}},{"kind":"Field","name":{"kind":"Name","value":"predatoryInstinctIndex"}},{"kind":"Field","name":{"kind":"Name","value":"barkingTendancyIndex"}},{"kind":"Field","name":{"kind":"Name","value":"independenceIndex"}},{"kind":"Field","name":{"kind":"Name","value":"foreignerSociabilityIndex"}},{"kind":"Field","name":{"kind":"Name","value":"intellectualActivityNeedIndex"}},{"kind":"Field","name":{"kind":"Name","value":"physicalActivityNeedIndex"}},{"kind":"Field","name":{"kind":"Name","value":"hairType"}},{"kind":"Field","name":{"kind":"Name","value":"imgs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"small"}},{"kind":"Field","name":{"kind":"Name","value":"medium"}},{"kind":"Field","name":{"kind":"Name","value":"large"}}]}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"seoDescription"}},{"kind":"Field","name":{"kind":"Name","value":"seoKeywords"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"synologyRank"}},{"kind":"Field","name":{"kind":"Name","value":"temper"}},{"kind":"Field","name":{"kind":"Name","value":"historic"}},{"kind":"Field","name":{"kind":"Name","value":"morphology"}},{"kind":"Field","name":{"kind":"Name","value":"fragilities"}},{"kind":"Field","name":{"kind":"Name","value":"advices"}},{"kind":"Field","name":{"kind":"Name","value":"otherNames"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"geneticAnalyzeType"}},{"kind":"Field","name":{"kind":"Name","value":"genetics"}}]}}]}}]} as unknown as DocumentNode<BreedComparatorGetBreedsQuery, BreedComparatorGetBreedsQueryVariables>;
export const BreedsGetBreedsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BreedsGetBreeds"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DogBreedOrderByWithRelationAndSearchRelevanceInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DogBreedWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"breedCardInfoTranslationsWhere"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DogBreedTranslationWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findManyDogBreed"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BreedCardInfo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"aggregateDogBreed"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_count"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_all"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BreedCardInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DogBreed"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"exerciseIndex"}},{"kind":"Field","name":{"kind":"Name","value":"educationIndex"}},{"kind":"Field","name":{"kind":"Name","value":"careIndex"}},{"kind":"Field","name":{"kind":"Name","value":"sociabilityIndex"}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"breedCardInfoTranslationsWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"language"}}]}},{"kind":"Field","name":{"kind":"Name","value":"imgs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"small"}}]}}]}}]} as unknown as DocumentNode<BreedsGetBreedsQuery, BreedsGetBreedsQueryVariables>;
export const BreedListGetAllBreedsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BreedListGetAllBreeds"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DogBreedWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"translationsWhere"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DogBreedTranslationWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findManyDogBreed"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"baseBreedName"}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"translationsWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"otherNames"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"imgs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"small"}}]}}]}}]}}]} as unknown as DocumentNode<BreedListGetAllBreedsQuery, BreedListGetAllBreedsQueryVariables>;
export const BreedGetBreedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BreedGetBreed"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DogBreedWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findManyDogBreed"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BreedDetailsInfo"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BreedDetailsInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DogBreed"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"headShape"}},{"kind":"Field","name":{"kind":"Name","value":"sizeCategory"}},{"kind":"Field","name":{"kind":"Name","value":"fciGroup"}},{"kind":"Field","name":{"kind":"Name","value":"homeCountryCode"}},{"kind":"Field","name":{"kind":"Name","value":"adultSizeAge"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"baseBreedName"}},{"kind":"Field","name":{"kind":"Name","value":"careIndex"}},{"kind":"Field","name":{"kind":"Name","value":"educationIndex"}},{"kind":"Field","name":{"kind":"Name","value":"sociabilityIndex"}},{"kind":"Field","name":{"kind":"Name","value":"sortingIndex"}},{"kind":"Field","name":{"kind":"Name","value":"exerciseIndex"}},{"kind":"Field","name":{"kind":"Name","value":"robustnessIndex"}},{"kind":"Field","name":{"kind":"Name","value":"maintenanceIndex"}},{"kind":"Field","name":{"kind":"Name","value":"hairLossIndex"}},{"kind":"Field","name":{"kind":"Name","value":"coldToleranceIndex"}},{"kind":"Field","name":{"kind":"Name","value":"heatToleranceIndex"}},{"kind":"Field","name":{"kind":"Name","value":"predatoryInstinctIndex"}},{"kind":"Field","name":{"kind":"Name","value":"barkingTendancyIndex"}},{"kind":"Field","name":{"kind":"Name","value":"independenceIndex"}},{"kind":"Field","name":{"kind":"Name","value":"foreignerSociabilityIndex"}},{"kind":"Field","name":{"kind":"Name","value":"intellectualActivityNeedIndex"}},{"kind":"Field","name":{"kind":"Name","value":"physicalActivityNeedIndex"}},{"kind":"Field","name":{"kind":"Name","value":"hairType"}},{"kind":"Field","name":{"kind":"Name","value":"imgs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"small"}},{"kind":"Field","name":{"kind":"Name","value":"medium"}},{"kind":"Field","name":{"kind":"Name","value":"large"}}]}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"seoDescription"}},{"kind":"Field","name":{"kind":"Name","value":"seoKeywords"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"synologyRank"}},{"kind":"Field","name":{"kind":"Name","value":"temper"}},{"kind":"Field","name":{"kind":"Name","value":"historic"}},{"kind":"Field","name":{"kind":"Name","value":"morphology"}},{"kind":"Field","name":{"kind":"Name","value":"fragilities"}},{"kind":"Field","name":{"kind":"Name","value":"advices"}},{"kind":"Field","name":{"kind":"Name","value":"otherNames"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"geneticAnalyzeType"}},{"kind":"Field","name":{"kind":"Name","value":"genetics"}}]}}]}}]} as unknown as DocumentNode<BreedGetBreedQuery, BreedGetBreedQueryVariables>;
export const BreedGetBreedersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BreedGetBreeders"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DogBreederWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DogBreederOrderByWithRelationAndSearchRelevanceInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"breederCardInfoTranslationsWhere"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DogBreederTranslationWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"breederCardInfoTranslationsWhereBreed"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DogBreedTranslationWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"breederCardInfoBreedImgsTake"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"breederCardInfoLittersWhere"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LitterWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findManyDogBreeder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BreederCardInfo"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BreederCardInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DogBreeder"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"spokenLanguages"}},{"kind":"Field","name":{"kind":"Name","value":"dogsPedigree"}},{"kind":"Field","name":{"kind":"Name","value":"lastConnectedType"}},{"kind":"Field","name":{"kind":"Name","value":"certificationFile"}},{"kind":"Field","name":{"kind":"Name","value":"breedClubValidated"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"connectedAt"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"region"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"breederCardInfoTranslationsWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"reviews"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"globalGrade"}},{"kind":"Field","name":{"kind":"Name","value":"accountId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"imgs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"small"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"breederBreeds"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"dogBreed"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"imgs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"breederCardInfoBreedImgsTake"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"medium"}}]}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"breederCardInfoTranslationsWhereBreed"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"litters"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"breederCardInfoLittersWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<BreedGetBreedersQuery, BreedGetBreedersQueryVariables>;
export const BreedGetLittersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BreedGetLitters"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LitterWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LitterOrderByWithRelationAndSearchRelevanceInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"litterCardInfoImgsTake"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"litterCardInfoTranslationsWhere"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LitterTranslationWhereInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"litterCardInfoBreedTranslationsWhere"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DogBreedTranslationWhereInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findManyLitter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LitterCardInfo"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LitterCardInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Litter"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"priceFrom"}},{"kind":"Field","name":{"kind":"Name","value":"priceTo"}},{"kind":"Field","name":{"kind":"Name","value":"fixedPrice"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"birthday"}},{"kind":"Field","name":{"kind":"Name","value":"availabilityDate"}},{"kind":"Field","name":{"kind":"Name","value":"born"}},{"kind":"Field","name":{"kind":"Name","value":"pedigree"}},{"kind":"Field","name":{"kind":"Name","value":"malesLeftCount"}},{"kind":"Field","name":{"kind":"Name","value":"femalesLeftCount"}},{"kind":"Field","name":{"kind":"Name","value":"imgs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"litterCardInfoImgsTake"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"small"}},{"kind":"Field","name":{"kind":"Name","value":"medium"}}]}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"litterCardInfoTranslationsWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"breeder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"dogBreed"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"baseBreedName"}},{"kind":"Field","name":{"kind":"Name","value":"imgs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"large"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"litterCardInfoBreedTranslationsWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<BreedGetLittersQuery, BreedGetLittersQueryVariables>;
export const BreederLinksGetBreedsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BreederLinksGetBreeds"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DogBreedWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"translationsWhere"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DogBreedTranslationWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findManyDogBreed"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"sizeCategory"}},{"kind":"Field","name":{"kind":"Name","value":"baseBreedName"}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"translationsWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"otherNames"}}]}}]}}]}}]} as unknown as DocumentNode<BreederLinksGetBreedsQuery, BreederLinksGetBreedsQueryVariables>;
export const BreederListGetBreedersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BreederListGetBreeders"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DogBreederWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DogBreederOrderByWithRelationAndSearchRelevanceInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"breederCardInfoTranslationsWhere"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DogBreederTranslationWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"breederCardInfoTranslationsWhereBreed"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DogBreedTranslationWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"breederCardInfoLittersWhere"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LitterWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"breederCardInfoBreedImgsTake"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findManyDogBreeder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BreederCardInfo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"aggregateDogBreeder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_count"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_all"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BreederCardInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DogBreeder"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"spokenLanguages"}},{"kind":"Field","name":{"kind":"Name","value":"dogsPedigree"}},{"kind":"Field","name":{"kind":"Name","value":"lastConnectedType"}},{"kind":"Field","name":{"kind":"Name","value":"certificationFile"}},{"kind":"Field","name":{"kind":"Name","value":"breedClubValidated"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"connectedAt"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"region"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"breederCardInfoTranslationsWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"reviews"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"globalGrade"}},{"kind":"Field","name":{"kind":"Name","value":"accountId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"imgs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"small"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"breederBreeds"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"dogBreed"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"imgs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"breederCardInfoBreedImgsTake"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"medium"}}]}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"breederCardInfoTranslationsWhereBreed"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"litters"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"breederCardInfoLittersWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<BreederListGetBreedersQuery, BreederListGetBreedersQueryVariables>;
export const BreederListGetLittersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BreederListGetLitters"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LitterWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LitterOrderByWithRelationAndSearchRelevanceInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"litterCardInfoTranslationsWhere"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LitterTranslationWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"litterCardInfoBreedTranslationsWhere"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DogBreedTranslationWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"litterCardInfoImgsTake"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findManyLitter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LitterCardInfo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"aggregateLitter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_count"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_all"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LitterCardInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Litter"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"priceFrom"}},{"kind":"Field","name":{"kind":"Name","value":"priceTo"}},{"kind":"Field","name":{"kind":"Name","value":"fixedPrice"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"birthday"}},{"kind":"Field","name":{"kind":"Name","value":"availabilityDate"}},{"kind":"Field","name":{"kind":"Name","value":"born"}},{"kind":"Field","name":{"kind":"Name","value":"pedigree"}},{"kind":"Field","name":{"kind":"Name","value":"malesLeftCount"}},{"kind":"Field","name":{"kind":"Name","value":"femalesLeftCount"}},{"kind":"Field","name":{"kind":"Name","value":"imgs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"litterCardInfoImgsTake"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"small"}},{"kind":"Field","name":{"kind":"Name","value":"medium"}}]}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"litterCardInfoTranslationsWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"breeder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"dogBreed"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"baseBreedName"}},{"kind":"Field","name":{"kind":"Name","value":"imgs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"large"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"litterCardInfoBreedTranslationsWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<BreederListGetLittersQuery, BreederListGetLittersQueryVariables>;
export const BreederGetBreederDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BreederGetBreeder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DogBreederWhereInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"littersWhere"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LitterWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"applicationsWhere"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DogBreederApplicationWhereInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"breedCardInfoTranslationsWhere"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DogBreedTranslationWhereInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"litterCardInfoImgsTake"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"litterCardInfoTranslationsWhere"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LitterTranslationWhereInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"litterCardInfoBreedTranslationsWhere"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DogBreedTranslationWhereInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findManyDogBreeder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"whatsappNumber"}},{"kind":"Field","name":{"kind":"Name","value":"certified"}},{"kind":"Field","name":{"kind":"Name","value":"public"}},{"kind":"Field","name":{"kind":"Name","value":"dogsPedigree"}},{"kind":"Field","name":{"kind":"Name","value":"puppiesBirthPlace"}},{"kind":"Field","name":{"kind":"Name","value":"agreementNumber"}},{"kind":"Field","name":{"kind":"Name","value":"websiteUrl"}},{"kind":"Field","name":{"kind":"Name","value":"certificationFile"}},{"kind":"Field","name":{"kind":"Name","value":"level"}},{"kind":"Field","name":{"kind":"Name","value":"spokenLanguages"}},{"kind":"Field","name":{"kind":"Name","value":"breedingName"}},{"kind":"Field","name":{"kind":"Name","value":"profileImg"}},{"kind":"Field","name":{"kind":"Name","value":"lastConnectedType"}},{"kind":"Field","name":{"kind":"Name","value":"imgs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"small"}},{"kind":"Field","name":{"kind":"Name","value":"medium"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"large"}}]}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"seoKeywords"}},{"kind":"Field","name":{"kind":"Name","value":"dogsActivities"}},{"kind":"Field","name":{"kind":"Name","value":"puppiesLivingPlace"}},{"kind":"Field","name":{"kind":"Name","value":"dogsLivingPlace"}},{"kind":"Field","name":{"kind":"Name","value":"health"}},{"kind":"Field","name":{"kind":"Name","value":"breederDogsSelection"}},{"kind":"Field","name":{"kind":"Name","value":"puppiesTraining"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"language"}}]}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"connectedAt"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"zip"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"region"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"reviews"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"globalGrade"}}]}},{"kind":"Field","name":{"kind":"Name","value":"breederBreeds"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"dogBreed"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isSubBreed"}},{"kind":"Field","name":{"kind":"Name","value":"baseBreedName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BreedCardInfo"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"litters"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"littersWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LitterCardInfo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"applications"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"applicationsWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BreedCardInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DogBreed"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"exerciseIndex"}},{"kind":"Field","name":{"kind":"Name","value":"educationIndex"}},{"kind":"Field","name":{"kind":"Name","value":"careIndex"}},{"kind":"Field","name":{"kind":"Name","value":"sociabilityIndex"}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"breedCardInfoTranslationsWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"language"}}]}},{"kind":"Field","name":{"kind":"Name","value":"imgs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"small"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LitterCardInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Litter"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"priceFrom"}},{"kind":"Field","name":{"kind":"Name","value":"priceTo"}},{"kind":"Field","name":{"kind":"Name","value":"fixedPrice"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"birthday"}},{"kind":"Field","name":{"kind":"Name","value":"availabilityDate"}},{"kind":"Field","name":{"kind":"Name","value":"born"}},{"kind":"Field","name":{"kind":"Name","value":"pedigree"}},{"kind":"Field","name":{"kind":"Name","value":"malesLeftCount"}},{"kind":"Field","name":{"kind":"Name","value":"femalesLeftCount"}},{"kind":"Field","name":{"kind":"Name","value":"imgs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"litterCardInfoImgsTake"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"small"}},{"kind":"Field","name":{"kind":"Name","value":"medium"}}]}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"litterCardInfoTranslationsWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"breeder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"dogBreed"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"baseBreedName"}},{"kind":"Field","name":{"kind":"Name","value":"imgs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"large"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"litterCardInfoBreedTranslationsWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<BreederGetBreederQuery, BreederGetBreederQueryVariables>;
export const BreederGetBreedersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BreederGetBreeders"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DogBreederWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DogBreederOrderByWithRelationAndSearchRelevanceInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"breederCardInfoTranslationsWhere"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DogBreederTranslationWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"breederCardInfoTranslationsWhereBreed"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DogBreedTranslationWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"breederCardInfoBreedImgsTake"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"breederCardInfoLittersWhere"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LitterWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findManyDogBreeder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BreederCardInfo"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BreederCardInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DogBreeder"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"spokenLanguages"}},{"kind":"Field","name":{"kind":"Name","value":"dogsPedigree"}},{"kind":"Field","name":{"kind":"Name","value":"lastConnectedType"}},{"kind":"Field","name":{"kind":"Name","value":"certificationFile"}},{"kind":"Field","name":{"kind":"Name","value":"breedClubValidated"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"connectedAt"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"region"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"breederCardInfoTranslationsWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"reviews"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"globalGrade"}},{"kind":"Field","name":{"kind":"Name","value":"accountId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"imgs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"small"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"breederBreeds"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"dogBreed"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"imgs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"breederCardInfoBreedImgsTake"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"medium"}}]}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"breederCardInfoTranslationsWhereBreed"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"litters"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"breederCardInfoLittersWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<BreederGetBreedersQuery, BreederGetBreedersQueryVariables>;
export const BreederGetLittersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BreederGetLitters"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LitterWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LitterOrderByWithRelationAndSearchRelevanceInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"litterCardInfoImgsTake"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"litterCardInfoTranslationsWhere"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LitterTranslationWhereInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"litterCardInfoBreedTranslationsWhere"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DogBreedTranslationWhereInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findManyLitter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LitterCardInfo"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LitterCardInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Litter"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"priceFrom"}},{"kind":"Field","name":{"kind":"Name","value":"priceTo"}},{"kind":"Field","name":{"kind":"Name","value":"fixedPrice"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"birthday"}},{"kind":"Field","name":{"kind":"Name","value":"availabilityDate"}},{"kind":"Field","name":{"kind":"Name","value":"born"}},{"kind":"Field","name":{"kind":"Name","value":"pedigree"}},{"kind":"Field","name":{"kind":"Name","value":"malesLeftCount"}},{"kind":"Field","name":{"kind":"Name","value":"femalesLeftCount"}},{"kind":"Field","name":{"kind":"Name","value":"imgs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"litterCardInfoImgsTake"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"small"}},{"kind":"Field","name":{"kind":"Name","value":"medium"}}]}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"litterCardInfoTranslationsWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"breeder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"dogBreed"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"baseBreedName"}},{"kind":"Field","name":{"kind":"Name","value":"imgs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"large"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"litterCardInfoBreedTranslationsWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<BreederGetLittersQuery, BreederGetLittersQueryVariables>;
export const BreederGetReviewsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BreederGetReviews"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DogBreederReviewWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregateDogBreederReview"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_count"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_all"}}]}},{"kind":"Field","name":{"kind":"Name","value":"_avg"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"humanContactGrade"}},{"kind":"Field","name":{"kind":"Name","value":"hygieneGrade"}},{"kind":"Field","name":{"kind":"Name","value":"globalGrade"}},{"kind":"Field","name":{"kind":"Name","value":"dogsWellBeingGrade"}},{"kind":"Field","name":{"kind":"Name","value":"followUpGrade"}}]}}]}}]}}]} as unknown as DocumentNode<BreederGetReviewsQuery, BreederGetReviewsQueryVariables>;
export const BreederRelatedLinksGetArticlesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BreederRelatedLinksGetArticles"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ArticleWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"translationsWhere"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ArticleTranslationsWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findManyArticle"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"randomOrder"},"value":{"kind":"BooleanValue","value":true}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"translationsWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]}}]} as unknown as DocumentNode<BreederRelatedLinksGetArticlesQuery, BreederRelatedLinksGetArticlesQueryVariables>;
export const BreederRelatedLinksGetBreedersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BreederRelatedLinksGetBreeders"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DogBreederWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"translationsWhere"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DogBreederTranslationWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"translationsWhereBreed"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DogBreedTranslationWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findManyDogBreeder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"randomOrder"},"value":{"kind":"BooleanValue","value":true}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"translationsWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"breederBreeds"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"dogBreed"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"translationsWhereBreed"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<BreederRelatedLinksGetBreedersQuery, BreederRelatedLinksGetBreedersQueryVariables>;
export const BreederRelatedLinksGetBreedsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BreederRelatedLinksGetBreeds"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DogBreedWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"translationsWhere"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DogBreedTranslationWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findManyDogBreed"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"randomOrder"},"value":{"kind":"BooleanValue","value":true}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"translationsWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<BreederRelatedLinksGetBreedsQuery, BreederRelatedLinksGetBreedsQueryVariables>;
export const BreederReviewGetBreederDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BreederReviewGetBreeder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DogBreederWhereInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findManyDogBreeder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"reviews"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"globalGrade"}},{"kind":"Field","name":{"kind":"Name","value":"accountId"}}]}}]}}]}}]} as unknown as DocumentNode<BreederReviewGetBreederQuery, BreederReviewGetBreederQueryVariables>;
export const BreederWriteReviewCreateReviewDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"BreederWriteReviewCreateReview"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateDogBreederReviewInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createDogBreederReview"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<BreederWriteReviewCreateReviewMutation, BreederWriteReviewCreateReviewMutationVariables>;
export const EducatorGetEducatorDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EducatorGetEducator"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProfessionalWhereInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchProfessionals"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"professionals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"educatorType"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"spokenLanguages"}},{"kind":"Field","name":{"kind":"Name","value":"namePro"}},{"kind":"Field","name":{"kind":"Name","value":"mainProFirstName"}},{"kind":"Field","name":{"kind":"Name","value":"mainProLastName"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"mobilePhone"}},{"kind":"Field","name":{"kind":"Name","value":"hasShop"}},{"kind":"Field","name":{"kind":"Name","value":"website"}},{"kind":"Field","name":{"kind":"Name","value":"isTipawPartner"}},{"kind":"Field","name":{"kind":"Name","value":"practicePlaces"}},{"kind":"Field","name":{"kind":"Name","value":"acceptsNewClients"}},{"kind":"Field","name":{"kind":"Name","value":"acceptedAnimals"}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethods"}},{"kind":"Field","name":{"kind":"Name","value":"profileVideo"}},{"kind":"Field","name":{"kind":"Name","value":"profileVideoPos"}},{"kind":"Field","name":{"kind":"Name","value":"proSchedule"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dayOfWeek"}},{"kind":"Field","name":{"kind":"Name","value":"avails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"degrees"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"degree"}},{"kind":"Field","name":{"kind":"Name","value":"school"}},{"kind":"Field","name":{"kind":"Name","value":"dateEnd"}}]}},{"kind":"Field","name":{"kind":"Name","value":"imgs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"large"}}]}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"formatted"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"streetNumber"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"zip"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"extraDescription"}},{"kind":"Field","name":{"kind":"Name","value":"subtitle"}},{"kind":"Field","name":{"kind":"Name","value":"wellnessEngagement"}},{"kind":"Field","name":{"kind":"Name","value":"preBookingWarning"}},{"kind":"Field","name":{"kind":"Name","value":"seoTitle"}},{"kind":"Field","name":{"kind":"Name","value":"seoDescription"}},{"kind":"Field","name":{"kind":"Name","value":"seoKeywords"}}]}}]}}]}}]}}]} as unknown as DocumentNode<EducatorGetEducatorQuery, EducatorGetEducatorQueryVariables>;
export const EducatorGetReviewsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EducatorGetReviews"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"EducatorReviewWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"professionalWhere"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ProfessionalWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EducatorReviewOrderByWithRelationAndSearchRelevanceInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchProfessionals"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"professionalWhere"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"professionals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"reviews"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"grade"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"imgs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"small"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"aggregateEducatorReview"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_count"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_all"}}]}},{"kind":"Field","name":{"kind":"Name","value":"_avg"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grade"}}]}}]}}]}}]} as unknown as DocumentNode<EducatorGetReviewsQuery, EducatorGetReviewsQueryVariables>;
export const EducatorWriteReviewCreateReviewDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"EducatorWriteReviewCreateReview"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateEducatorReviewInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createEducatorReview"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<EducatorWriteReviewCreateReviewMutation, EducatorWriteReviewCreateReviewMutationVariables>;
export const EducatorReviewGetEducatorDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EducatorReviewGetEducator"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProfessionalWhereInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchProfessionals"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"professionals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"namePro"}},{"kind":"Field","name":{"kind":"Name","value":"reviews"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"grade"}},{"kind":"Field","name":{"kind":"Name","value":"accountId"}}]}}]}}]}}]}}]} as unknown as DocumentNode<EducatorReviewGetEducatorQuery, EducatorReviewGetEducatorQueryVariables>;
export const HomeLandingGetAdditionalPopularBreedsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"HomeLandingGetAdditionalPopularBreeds"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DogBreedWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"breedCardInfoTranslationsWhere"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DogBreedTranslationWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findManyDogBreed"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"breedCardInfoTranslationsWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<HomeLandingGetAdditionalPopularBreedsQuery, HomeLandingGetAdditionalPopularBreedsQueryVariables>;
export const AdoptionsLandingGetBreedersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AdoptionsLandingGetBreeders"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DogBreederWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DogBreederOrderByWithRelationAndSearchRelevanceInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"breederCardInfoTranslationsWhere"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DogBreederTranslationWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"breederCardInfoTranslationsWhereBreed"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DogBreedTranslationWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"breederCardInfoBreedImgsTake"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"breederCardInfoLittersWhere"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LitterWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findManyDogBreeder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BreederCardInfo"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BreederCardInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DogBreeder"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"spokenLanguages"}},{"kind":"Field","name":{"kind":"Name","value":"dogsPedigree"}},{"kind":"Field","name":{"kind":"Name","value":"lastConnectedType"}},{"kind":"Field","name":{"kind":"Name","value":"certificationFile"}},{"kind":"Field","name":{"kind":"Name","value":"breedClubValidated"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"connectedAt"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"region"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"breederCardInfoTranslationsWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"reviews"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"globalGrade"}},{"kind":"Field","name":{"kind":"Name","value":"accountId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"imgs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"small"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"breederBreeds"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"dogBreed"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"imgs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"breederCardInfoBreedImgsTake"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"medium"}}]}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"breederCardInfoTranslationsWhereBreed"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"litters"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"breederCardInfoLittersWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<AdoptionsLandingGetBreedersQuery, AdoptionsLandingGetBreedersQueryVariables>;
export const AdoptionsLandingGetLittersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AdoptionsLandingGetLitters"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LitterWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LitterOrderByWithRelationAndSearchRelevanceInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"litterCardInfoImgsTake"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"litterCardInfoTranslationsWhere"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LitterTranslationWhereInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"litterCardInfoBreedTranslationsWhere"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DogBreedTranslationWhereInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findManyLitter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LitterCardInfo"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LitterCardInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Litter"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"priceFrom"}},{"kind":"Field","name":{"kind":"Name","value":"priceTo"}},{"kind":"Field","name":{"kind":"Name","value":"fixedPrice"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"birthday"}},{"kind":"Field","name":{"kind":"Name","value":"availabilityDate"}},{"kind":"Field","name":{"kind":"Name","value":"born"}},{"kind":"Field","name":{"kind":"Name","value":"pedigree"}},{"kind":"Field","name":{"kind":"Name","value":"malesLeftCount"}},{"kind":"Field","name":{"kind":"Name","value":"femalesLeftCount"}},{"kind":"Field","name":{"kind":"Name","value":"imgs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"litterCardInfoImgsTake"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"small"}},{"kind":"Field","name":{"kind":"Name","value":"medium"}}]}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"litterCardInfoTranslationsWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"breeder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"dogBreed"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"baseBreedName"}},{"kind":"Field","name":{"kind":"Name","value":"imgs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"large"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"litterCardInfoBreedTranslationsWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<AdoptionsLandingGetLittersQuery, AdoptionsLandingGetLittersQueryVariables>;
export const HomeLandingGetPopularBreedsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"HomeLandingGetPopularBreeds"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DogBreedWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"breedCardInfoTranslationsWhere"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DogBreedTranslationWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findManyDogBreed"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BreedCardInfo"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BreedCardInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DogBreed"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"exerciseIndex"}},{"kind":"Field","name":{"kind":"Name","value":"educationIndex"}},{"kind":"Field","name":{"kind":"Name","value":"careIndex"}},{"kind":"Field","name":{"kind":"Name","value":"sociabilityIndex"}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"breedCardInfoTranslationsWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"language"}}]}},{"kind":"Field","name":{"kind":"Name","value":"imgs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"small"}}]}}]}}]} as unknown as DocumentNode<HomeLandingGetPopularBreedsQuery, HomeLandingGetPopularBreedsQueryVariables>;
export const JoinShelterSendContactMessageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"JoinShelterSendContactMessage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"language"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"phone"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lastName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"firstName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contactReasonType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ContactReasonTypeEnum"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contactSupport"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"Argument","name":{"kind":"Name","value":"language"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}},{"kind":"Argument","name":{"kind":"Name","value":"phone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"phone"}}},{"kind":"Argument","name":{"kind":"Name","value":"lastName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lastName"}}},{"kind":"Argument","name":{"kind":"Name","value":"firstName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"firstName"}}},{"kind":"Argument","name":{"kind":"Name","value":"contactReasonType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contactReasonType"}}}]}]}}]} as unknown as DocumentNode<JoinShelterSendContactMessageMutation, JoinShelterSendContactMessageMutationVariables>;
export const LitterLinksGetBreedsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LitterLinksGetBreeds"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DogBreedWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"translationsWhere"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DogBreedTranslationWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findManyDogBreed"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"sizeCategory"}},{"kind":"Field","name":{"kind":"Name","value":"baseBreedName"}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"translationsWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"otherNames"}}]}}]}}]}}]} as unknown as DocumentNode<LitterLinksGetBreedsQuery, LitterLinksGetBreedsQueryVariables>;
export const LitterListGetLittersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LitterListGetLitters"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LitterWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LitterOrderByWithRelationAndSearchRelevanceInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"distinct"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LitterScalarFieldEnum"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"litterCardInfoImgsTake"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"litterCardInfoTranslationsWhere"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LitterTranslationWhereInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"litterCardInfoBreedTranslationsWhere"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DogBreedTranslationWhereInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findManyLitter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"distinct"},"value":{"kind":"Variable","name":{"kind":"Name","value":"distinct"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LitterCardInfo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"aggregateLitter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_count"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_all"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LitterCardInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Litter"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"priceFrom"}},{"kind":"Field","name":{"kind":"Name","value":"priceTo"}},{"kind":"Field","name":{"kind":"Name","value":"fixedPrice"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"birthday"}},{"kind":"Field","name":{"kind":"Name","value":"availabilityDate"}},{"kind":"Field","name":{"kind":"Name","value":"born"}},{"kind":"Field","name":{"kind":"Name","value":"pedigree"}},{"kind":"Field","name":{"kind":"Name","value":"malesLeftCount"}},{"kind":"Field","name":{"kind":"Name","value":"femalesLeftCount"}},{"kind":"Field","name":{"kind":"Name","value":"imgs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"litterCardInfoImgsTake"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"small"}},{"kind":"Field","name":{"kind":"Name","value":"medium"}}]}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"litterCardInfoTranslationsWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"breeder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"dogBreed"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"baseBreedName"}},{"kind":"Field","name":{"kind":"Name","value":"imgs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"large"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"litterCardInfoBreedTranslationsWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<LitterListGetLittersQuery, LitterListGetLittersQueryVariables>;
export const LitterListGetBreedersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LitterListGetBreeders"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DogBreederWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DogBreederOrderByWithRelationAndSearchRelevanceInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"breederCardInfoTranslationsWhere"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DogBreederTranslationWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"breederCardInfoTranslationsWhereBreed"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DogBreedTranslationWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"breederCardInfoBreedImgsTake"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"breederCardInfoLittersWhere"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LitterWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findManyDogBreeder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BreederCardInfo"}},{"kind":"Field","name":{"kind":"Name","value":"breederBreeds"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"dogBreed"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"baseBreedName"}},{"kind":"Field","name":{"kind":"Name","value":"imgs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"breederCardInfoBreedImgsTake"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"medium"}}]}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"breederCardInfoTranslationsWhereBreed"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"aggregateDogBreeder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_count"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_all"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BreederCardInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DogBreeder"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"spokenLanguages"}},{"kind":"Field","name":{"kind":"Name","value":"dogsPedigree"}},{"kind":"Field","name":{"kind":"Name","value":"lastConnectedType"}},{"kind":"Field","name":{"kind":"Name","value":"certificationFile"}},{"kind":"Field","name":{"kind":"Name","value":"breedClubValidated"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"connectedAt"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"region"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"breederCardInfoTranslationsWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"reviews"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"globalGrade"}},{"kind":"Field","name":{"kind":"Name","value":"accountId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"imgs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"small"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"breederBreeds"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"dogBreed"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"imgs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"breederCardInfoBreedImgsTake"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"medium"}}]}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"breederCardInfoTranslationsWhereBreed"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"litters"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"breederCardInfoLittersWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<LitterListGetBreedersQuery, LitterListGetBreedersQueryVariables>;
export const LitterAddBookmarkDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"LitterAddBookmark"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AccountUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountMeUpdate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"bookmarks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"litter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<LitterAddBookmarkMutation, LitterAddBookmarkMutationVariables>;
export const LitterGetBookmarkDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LitterGetBookmark"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"bookmarksWhere"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"BookmarkWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"bookmarksTake"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountMe"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"bookmarks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"bookmarksWhere"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"bookmarksTake"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<LitterGetBookmarkQuery, LitterGetBookmarkQueryVariables>;
export const LitterGetBreedersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LitterGetBreeders"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DogBreederWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DogBreederOrderByWithRelationAndSearchRelevanceInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"breederCardInfoTranslationsWhere"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DogBreederTranslationWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"breederCardInfoTranslationsWhereBreed"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DogBreedTranslationWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"breederCardInfoBreedImgsTake"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"breederCardInfoLittersWhere"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LitterWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findManyDogBreeder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BreederCardInfo"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BreederCardInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DogBreeder"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"spokenLanguages"}},{"kind":"Field","name":{"kind":"Name","value":"dogsPedigree"}},{"kind":"Field","name":{"kind":"Name","value":"lastConnectedType"}},{"kind":"Field","name":{"kind":"Name","value":"certificationFile"}},{"kind":"Field","name":{"kind":"Name","value":"breedClubValidated"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"connectedAt"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"region"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"breederCardInfoTranslationsWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"reviews"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"globalGrade"}},{"kind":"Field","name":{"kind":"Name","value":"accountId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"imgs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"small"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"breederBreeds"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"dogBreed"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"imgs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"breederCardInfoBreedImgsTake"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"medium"}}]}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"breederCardInfoTranslationsWhereBreed"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"litters"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"breederCardInfoLittersWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<LitterGetBreedersQuery, LitterGetBreedersQueryVariables>;
export const LitterGetLitterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LitterGetLitter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"litterWhere"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LitterWhereInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"breedCardInfoTranslationsWhere"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DogBreedTranslationWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"breederCardInfoTranslationsWhere"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DogBreederTranslationWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"breederCardInfoTranslationsWhereBreed"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DogBreedTranslationWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"breederCardInfoBreedImgsTake"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"breederCardInfoLittersWhere"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LitterWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findManyLitter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"litterWhere"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"availabilityDate"}},{"kind":"Field","name":{"kind":"Name","value":"birthday"}},{"kind":"Field","name":{"kind":"Name","value":"microchipped"}},{"kind":"Field","name":{"kind":"Name","value":"vaccinationDate"}},{"kind":"Field","name":{"kind":"Name","value":"vaccinated"}},{"kind":"Field","name":{"kind":"Name","value":"dewormed"}},{"kind":"Field","name":{"kind":"Name","value":"pedigree"}},{"kind":"Field","name":{"kind":"Name","value":"pedigreeNumbers"}},{"kind":"Field","name":{"kind":"Name","value":"certified"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"priceFrom"}},{"kind":"Field","name":{"kind":"Name","value":"priceTo"}},{"kind":"Field","name":{"kind":"Name","value":"fixedPrice"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"malesCount"}},{"kind":"Field","name":{"kind":"Name","value":"femalesCount"}},{"kind":"Field","name":{"kind":"Name","value":"malesLeftCount"}},{"kind":"Field","name":{"kind":"Name","value":"femalesLeftCount"}},{"kind":"Field","name":{"kind":"Name","value":"microchips"}},{"kind":"Field","name":{"kind":"Name","value":"born"}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"seoKeywords"}},{"kind":"Field","name":{"kind":"Name","value":"seoDescription"}},{"kind":"Field","name":{"kind":"Name","value":"seoTitle"}},{"kind":"Field","name":{"kind":"Name","value":"language"}}]}},{"kind":"Field","name":{"kind":"Name","value":"imgs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"small"}},{"kind":"Field","name":{"kind":"Name","value":"medium"}},{"kind":"Field","name":{"kind":"Name","value":"large"}}]}},{"kind":"Field","name":{"kind":"Name","value":"dogBreed"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BreedCardInfo"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"baseBreedName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"breeder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BreederCardInfo"}},{"kind":"Field","name":{"kind":"Name","value":"level"}},{"kind":"Field","name":{"kind":"Name","value":"profileImg"}},{"kind":"Field","name":{"kind":"Name","value":"agreementNumber"}},{"kind":"Field","name":{"kind":"Name","value":"lastConnectedType"}},{"kind":"Field","name":{"kind":"Name","value":"whatsappNumber"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"zip"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"parents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"parentType"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"imgs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"small"}},{"kind":"Field","name":{"kind":"Name","value":"large"}}]}},{"kind":"Field","name":{"kind":"Name","value":"birthday"}},{"kind":"Field","name":{"kind":"Name","value":"dogInfos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"microshipNumber"}},{"kind":"Field","name":{"kind":"Name","value":"pedigreeNumber"}},{"kind":"Field","name":{"kind":"Name","value":"pedigree"}},{"kind":"Field","name":{"kind":"Name","value":"competitionTitles"}},{"kind":"Field","name":{"kind":"Name","value":"healthTestsResults"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BreedCardInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DogBreed"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"exerciseIndex"}},{"kind":"Field","name":{"kind":"Name","value":"educationIndex"}},{"kind":"Field","name":{"kind":"Name","value":"careIndex"}},{"kind":"Field","name":{"kind":"Name","value":"sociabilityIndex"}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"breedCardInfoTranslationsWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"language"}}]}},{"kind":"Field","name":{"kind":"Name","value":"imgs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"small"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BreederCardInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DogBreeder"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"spokenLanguages"}},{"kind":"Field","name":{"kind":"Name","value":"dogsPedigree"}},{"kind":"Field","name":{"kind":"Name","value":"lastConnectedType"}},{"kind":"Field","name":{"kind":"Name","value":"certificationFile"}},{"kind":"Field","name":{"kind":"Name","value":"breedClubValidated"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"connectedAt"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"region"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"breederCardInfoTranslationsWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"reviews"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"globalGrade"}},{"kind":"Field","name":{"kind":"Name","value":"accountId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"imgs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"small"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"breederBreeds"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"dogBreed"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"imgs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"breederCardInfoBreedImgsTake"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"medium"}}]}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"breederCardInfoTranslationsWhereBreed"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"litters"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"breederCardInfoLittersWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<LitterGetLitterQuery, LitterGetLitterQueryVariables>;
export const LitterGetLittersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LitterGetLitters"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LitterWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LitterOrderByWithRelationAndSearchRelevanceInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"litterCardInfoImgsTake"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"litterCardInfoTranslationsWhere"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LitterTranslationWhereInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"litterCardInfoBreedTranslationsWhere"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DogBreedTranslationWhereInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findManyLitter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LitterCardInfo"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LitterCardInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Litter"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"priceFrom"}},{"kind":"Field","name":{"kind":"Name","value":"priceTo"}},{"kind":"Field","name":{"kind":"Name","value":"fixedPrice"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"birthday"}},{"kind":"Field","name":{"kind":"Name","value":"availabilityDate"}},{"kind":"Field","name":{"kind":"Name","value":"born"}},{"kind":"Field","name":{"kind":"Name","value":"pedigree"}},{"kind":"Field","name":{"kind":"Name","value":"malesLeftCount"}},{"kind":"Field","name":{"kind":"Name","value":"femalesLeftCount"}},{"kind":"Field","name":{"kind":"Name","value":"imgs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"litterCardInfoImgsTake"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"small"}},{"kind":"Field","name":{"kind":"Name","value":"medium"}}]}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"litterCardInfoTranslationsWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"breeder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"dogBreed"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"baseBreedName"}},{"kind":"Field","name":{"kind":"Name","value":"imgs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"large"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"litterCardInfoBreedTranslationsWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<LitterGetLittersQuery, LitterGetLittersQueryVariables>;
export const LitterRemoveBookmarkDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"LitterRemoveBookmark"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AccountUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountMeUpdate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"bookmarks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"litter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<LitterRemoveBookmarkMutation, LitterRemoveBookmarkMutationVariables>;
export const LocationLinksLocationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LocationLinksLocations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"country"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CountryCode"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"proType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProfessionalTypeEnum"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"professionalLocations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"country"},"value":{"kind":"Variable","name":{"kind":"Name","value":"country"}}},{"kind":"Argument","name":{"kind":"Name","value":"proType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"proType"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"region"}}]}}]}}]} as unknown as DocumentNode<LocationLinksLocationsQuery, LocationLinksLocationsQueryVariables>;
export const MtAnimalBreederCreateAnimalDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MtAnimalBreederCreateAnimal"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AnimalCreateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"imageUpload"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Upload"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"passportFileUpload"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Upload"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"createdFrom"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AnimalStatCreatedFromEnum"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createAnimal"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}},{"kind":"Argument","name":{"kind":"Name","value":"imageUpload"},"value":{"kind":"Variable","name":{"kind":"Name","value":"imageUpload"}}},{"kind":"Argument","name":{"kind":"Name","value":"passportFileUpload"},"value":{"kind":"Variable","name":{"kind":"Name","value":"passportFileUpload"}}},{"kind":"Argument","name":{"kind":"Name","value":"createdFrom"},"value":{"kind":"Variable","name":{"kind":"Name","value":"createdFrom"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"dogInfos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pedigree"}}]}}]}}]}}]} as unknown as DocumentNode<MtAnimalBreederCreateAnimalMutation, MtAnimalBreederCreateAnimalMutationVariables>;
export const MtAnimalBreederGetAnimalDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MtAnimalBreederGetAnimal"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"animalsWhere"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AnimalWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"animalsTake"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountMe"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"animals"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"animalsWhere"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"animalsTake"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"birthday"}},{"kind":"Field","name":{"kind":"Name","value":"birthdayType"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"archived"}},{"kind":"Field","name":{"kind":"Name","value":"passportFile"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"sensitivities"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"imgs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"medium"}}]}},{"kind":"Field","name":{"kind":"Name","value":"dogInfos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"pedigree"}},{"kind":"Field","name":{"kind":"Name","value":"breederIsDogOwner"}},{"kind":"Field","name":{"kind":"Name","value":"pedigreeNumber"}},{"kind":"Field","name":{"kind":"Name","value":"competitionTitles"}},{"kind":"Field","name":{"kind":"Name","value":"healthTestsResults"}},{"kind":"Field","name":{"kind":"Name","value":"microshipNumber"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"coat"}},{"kind":"Field","name":{"kind":"Name","value":"dogBreed"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"studInfos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"availableForBreeding"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"champion"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"adn"}},{"kind":"Field","name":{"kind":"Name","value":"accomodation"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]}}]}}]} as unknown as DocumentNode<MtAnimalBreederGetAnimalQuery, MtAnimalBreederGetAnimalQueryVariables>;
export const MtAnimalBreederUpdateAnimalDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MtAnimalBreederUpdateAnimal"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AnimalUpdateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"animalId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"imageUpload"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Upload"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"passportFileUpload"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Upload"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateAnimal"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}},{"kind":"Argument","name":{"kind":"Name","value":"animalId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"animalId"}}},{"kind":"Argument","name":{"kind":"Name","value":"imageUpload"},"value":{"kind":"Variable","name":{"kind":"Name","value":"imageUpload"}}},{"kind":"Argument","name":{"kind":"Name","value":"passportFileUpload"},"value":{"kind":"Variable","name":{"kind":"Name","value":"passportFileUpload"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<MtAnimalBreederUpdateAnimalMutation, MtAnimalBreederUpdateAnimalMutationVariables>;
export const MtAnimalBuyerCreateAnimalDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MtAnimalBuyerCreateAnimal"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AnimalCreateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"imageUpload"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Upload"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"createdFrom"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AnimalStatCreatedFromEnum"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createAnimal"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}},{"kind":"Argument","name":{"kind":"Name","value":"imageUpload"},"value":{"kind":"Variable","name":{"kind":"Name","value":"imageUpload"}}},{"kind":"Argument","name":{"kind":"Name","value":"createdFrom"},"value":{"kind":"Variable","name":{"kind":"Name","value":"createdFrom"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BuyerAnimalInfo"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BuyerAnimalInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Animal"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"birthday"}},{"kind":"Field","name":{"kind":"Name","value":"birthdayType"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"sterilized"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"archived"}},{"kind":"Field","name":{"kind":"Name","value":"calved"}},{"kind":"Field","name":{"kind":"Name","value":"sensitivities"}},{"kind":"Field","name":{"kind":"Name","value":"imgs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"small"}},{"kind":"Field","name":{"kind":"Name","value":"medium"}}]}},{"kind":"Field","name":{"kind":"Name","value":"dogInfos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"physicalCondition"}},{"kind":"Field","name":{"kind":"Name","value":"pedigree"}},{"kind":"Field","name":{"kind":"Name","value":"medicalAffections"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"affectionType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"dogBreed"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<MtAnimalBuyerCreateAnimalMutation, MtAnimalBuyerCreateAnimalMutationVariables>;
export const MtAnimalBuyerGetAnimalDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MtAnimalBuyerGetAnimal"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"animalsWhere"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AnimalWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountMe"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"animals"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"animalsWhere"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BuyerAnimalInfo"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BuyerAnimalInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Animal"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"birthday"}},{"kind":"Field","name":{"kind":"Name","value":"birthdayType"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"sterilized"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"archived"}},{"kind":"Field","name":{"kind":"Name","value":"calved"}},{"kind":"Field","name":{"kind":"Name","value":"sensitivities"}},{"kind":"Field","name":{"kind":"Name","value":"imgs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"small"}},{"kind":"Field","name":{"kind":"Name","value":"medium"}}]}},{"kind":"Field","name":{"kind":"Name","value":"dogInfos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"physicalCondition"}},{"kind":"Field","name":{"kind":"Name","value":"pedigree"}},{"kind":"Field","name":{"kind":"Name","value":"medicalAffections"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"affectionType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"dogBreed"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<MtAnimalBuyerGetAnimalQuery, MtAnimalBuyerGetAnimalQueryVariables>;
export const MtAnimalBuyerUpdateAnimalDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MtAnimalBuyerUpdateAnimal"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AnimalUpdateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"animalId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"imageUpload"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Upload"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateAnimal"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}},{"kind":"Argument","name":{"kind":"Name","value":"animalId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"animalId"}}},{"kind":"Argument","name":{"kind":"Name","value":"imageUpload"},"value":{"kind":"Variable","name":{"kind":"Name","value":"imageUpload"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BuyerAnimalInfo"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BuyerAnimalInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Animal"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"birthday"}},{"kind":"Field","name":{"kind":"Name","value":"birthdayType"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"sterilized"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"archived"}},{"kind":"Field","name":{"kind":"Name","value":"calved"}},{"kind":"Field","name":{"kind":"Name","value":"sensitivities"}},{"kind":"Field","name":{"kind":"Name","value":"imgs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"small"}},{"kind":"Field","name":{"kind":"Name","value":"medium"}}]}},{"kind":"Field","name":{"kind":"Name","value":"dogInfos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"physicalCondition"}},{"kind":"Field","name":{"kind":"Name","value":"pedigree"}},{"kind":"Field","name":{"kind":"Name","value":"medicalAffections"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"affectionType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"dogBreed"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<MtAnimalBuyerUpdateAnimalMutation, MtAnimalBuyerUpdateAnimalMutationVariables>;
export const MtAnimalsBreederGetAnimalsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MtAnimalsBreederGetAnimals"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AnimalOrderByWithRelationAndSearchRelevanceInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"animalsWhere"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AnimalWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountMe"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"animals"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"animalsWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"birthday"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"archived"}},{"kind":"Field","name":{"kind":"Name","value":"studInfos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"availableForBreeding"}}]}},{"kind":"Field","name":{"kind":"Name","value":"imgs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"small"}}]}}]}}]}}]}}]} as unknown as DocumentNode<MtAnimalsBreederGetAnimalsQuery, MtAnimalsBreederGetAnimalsQueryVariables>;
export const MtApplicationBreederGetApplicationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MtApplicationBreederGetApplication"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"applicationWhere"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DogBreederApplicationWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"breedTranslationWhere"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DogBreedTranslationWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountMe"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"Field","name":{"kind":"Name","value":"dogBreeder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"breederBreeds"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dogBreedId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"applications"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"applicationWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"accommodation"}},{"kind":"Field","name":{"kind":"Name","value":"experiences"}},{"kind":"Field","name":{"kind":"Name","value":"timeAlone"}},{"kind":"Field","name":{"kind":"Name","value":"trainers"}},{"kind":"Field","name":{"kind":"Name","value":"genderPreferences"}},{"kind":"Field","name":{"kind":"Name","value":"otherPreferences"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"motive"}},{"kind":"Field","name":{"kind":"Name","value":"otherAnimals"}},{"kind":"Field","name":{"kind":"Name","value":"questions"}},{"kind":"Field","name":{"kind":"Name","value":"seenByBreeder"}},{"kind":"Field","name":{"kind":"Name","value":"breedPreference"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"imgs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"EnumValue","value":"MAIN"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"small"}}]}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"breedTranslationWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"country"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"animal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"birthday"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<MtApplicationBreederGetApplicationQuery, MtApplicationBreederGetApplicationQueryVariables>;
export const MtApplicationsBreederOpenApplicationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MtApplicationsBreederOpenApplication"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"applicationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"openApplication"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"applicationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"applicationId"}}}]}]}}]} as unknown as DocumentNode<MtApplicationsBreederOpenApplicationMutation, MtApplicationsBreederOpenApplicationMutationVariables>;
export const MtApplicationsBreederDeleteApplicationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MtApplicationsBreederDeleteApplication"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteApplicationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteApplication"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]} as unknown as DocumentNode<MtApplicationsBreederDeleteApplicationMutation, MtApplicationsBreederDeleteApplicationMutationVariables>;
export const MtApplicationsBuyerCancelApplicationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MtApplicationsBuyerCancelApplication"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"applicationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cancelApplication"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"applicationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"applicationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]} as unknown as DocumentNode<MtApplicationsBuyerCancelApplicationMutation, MtApplicationsBuyerCancelApplicationMutationVariables>;
export const MtApplicationBuyerGetApplicationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MtApplicationBuyerGetApplication"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"applicationWhere"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DogBreederApplicationWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"breedTranslationWhere"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DogBreedTranslationWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"breederTranslationWhere"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DogBreederTranslationWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountMe"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"Field","name":{"kind":"Name","value":"applications"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"applicationWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"accommodation"}},{"kind":"Field","name":{"kind":"Name","value":"experiences"}},{"kind":"Field","name":{"kind":"Name","value":"timeAlone"}},{"kind":"Field","name":{"kind":"Name","value":"trainers"}},{"kind":"Field","name":{"kind":"Name","value":"genderPreferences"}},{"kind":"Field","name":{"kind":"Name","value":"otherPreferences"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"motive"}},{"kind":"Field","name":{"kind":"Name","value":"otherAnimals"}},{"kind":"Field","name":{"kind":"Name","value":"questions"}},{"kind":"Field","name":{"kind":"Name","value":"seenByBuyer"}},{"kind":"Field","name":{"kind":"Name","value":"breedPreference"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"imgs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"EnumValue","value":"MAIN"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"small"}}]}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"breedTranslationWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"dogBreeder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"profileImg"}},{"kind":"Field","name":{"kind":"Name","value":"agreementNumber"}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"breederTranslationWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"country"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"breederBreeds"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"dogBreedId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"animal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"birthday"}}]}}]}}]}}]}}]} as unknown as DocumentNode<MtApplicationBuyerGetApplicationQuery, MtApplicationBuyerGetApplicationQueryVariables>;
export const MtApplicationsBuyerOpenApplicationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MtApplicationsBuyerOpenApplication"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"applicationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"openApplication"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"applicationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"applicationId"}}}]}]}}]} as unknown as DocumentNode<MtApplicationsBuyerOpenApplicationMutation, MtApplicationsBuyerOpenApplicationMutationVariables>;
export const DeleteBookingMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteBookingMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"bookingId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteBooking"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"bookingId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"bookingId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deletedBookingId"}}]}}]}}]} as unknown as DocumentNode<DeleteBookingMutationMutation, DeleteBookingMutationMutationVariables>;
export const BookingListGetBookingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BookingListGetBookings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"bookingsOrderBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"BookingOrderByWithRelationAndSearchRelevanceInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"bookingCardInfoProTranslationsWhere"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProTranslationWhereInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"bookingCardInfoServiceTranslationsWhere"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ServiceTranslationWhereInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountMe"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"bookings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"bookingsOrderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BookingCardInfo"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BookingCardInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Booking"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startDateTime"}},{"kind":"Field","name":{"kind":"Name","value":"endDateTime"}},{"kind":"Field","name":{"kind":"Name","value":"worker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"pro"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"minHoursBeforeUpdateOrCancelBooking"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"mobilePhone"}},{"kind":"Field","name":{"kind":"Name","value":"imgs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"small"}}]}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"bookingCardInfoProTranslationsWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"bookingAnimals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"animal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"birthday"}},{"kind":"Field","name":{"kind":"Name","value":"imgs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"small"}}]}},{"kind":"Field","name":{"kind":"Name","value":"dogInfos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"dogBreedId"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"workerService"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"categoryId"}},{"kind":"Field","name":{"kind":"Name","value":"service"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"bookingCardInfoServiceTranslationsWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]}}]}}]} as unknown as DocumentNode<BookingListGetBookingsQuery, BookingListGetBookingsQueryVariables>;
export const UpdateBookingMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateBookingMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"bookingId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startDateTime"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateBooking"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"bookingId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"bookingId"}}},{"kind":"Argument","name":{"kind":"Name","value":"startDateTime"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDateTime"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateBookingMutationMutation, UpdateBookingMutationMutationVariables>;
export const MtBreederOnboardingGetProfileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MtBreederOnboardingGetProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountMe"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"birthday"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"streetNumber"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"zip"}},{"kind":"Field","name":{"kind":"Name","value":"street"}}]}},{"kind":"Field","name":{"kind":"Name","value":"imgs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"EnumValue","value":"PROFILE"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"small"}}]}},{"kind":"Field","name":{"kind":"Name","value":"animals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"dogBreeder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"dogsPedigree"}},{"kind":"Field","name":{"kind":"Name","value":"motherRestBetweenLitters"}},{"kind":"Field","name":{"kind":"Name","value":"littersByFemale"}},{"kind":"Field","name":{"kind":"Name","value":"femaleBreedersCount"}},{"kind":"Field","name":{"kind":"Name","value":"dogsConsanguinity"}},{"kind":"Field","name":{"kind":"Name","value":"medicalTestsPerformed"}},{"kind":"Field","name":{"kind":"Name","value":"failedMedicalTestsProtocol"}},{"kind":"Field","name":{"kind":"Name","value":"puppiesBirthPlace"}},{"kind":"Field","name":{"kind":"Name","value":"veterinaryInfo"}},{"kind":"Field","name":{"kind":"Name","value":"displayEmail"}},{"kind":"Field","name":{"kind":"Name","value":"displayPhone"}},{"kind":"Field","name":{"kind":"Name","value":"breedingName"}},{"kind":"Field","name":{"kind":"Name","value":"femaleBreedersCount"}},{"kind":"Field","name":{"kind":"Name","value":"certified"}},{"kind":"Field","name":{"kind":"Name","value":"hkFile"}},{"kind":"Field","name":{"kind":"Name","value":"permissionFiles"}},{"kind":"Field","name":{"kind":"Name","value":"identityFiles"}},{"kind":"Field","name":{"kind":"Name","value":"breedClubFiles"}},{"kind":"Field","name":{"kind":"Name","value":"certificationFile"}},{"kind":"Field","name":{"kind":"Name","value":"hasFinishedOnboarding"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"agreementNumber"}},{"kind":"Field","name":{"kind":"Name","value":"level"}},{"kind":"Field","name":{"kind":"Name","value":"websiteUrl"}},{"kind":"Field","name":{"kind":"Name","value":"facebookUrl"}},{"kind":"Field","name":{"kind":"Name","value":"spokenLanguages"}},{"kind":"Field","name":{"kind":"Name","value":"breedingName"}},{"kind":"Field","name":{"kind":"Name","value":"imgs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"small"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"breederDogsSelection"}},{"kind":"Field","name":{"kind":"Name","value":"dogsActivities"}},{"kind":"Field","name":{"kind":"Name","value":"dogsLivingPlace"}},{"kind":"Field","name":{"kind":"Name","value":"health"}},{"kind":"Field","name":{"kind":"Name","value":"puppiesTraining"}},{"kind":"Field","name":{"kind":"Name","value":"puppiesLivingPlace"}}]}},{"kind":"Field","name":{"kind":"Name","value":"breederBreeds"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"dogBreedId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"litters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<MtBreederOnboardingGetProfileQuery, MtBreederOnboardingGetProfileQueryVariables>;
export const MtBreederOnboardingUpdateProfileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MtBreederOnboardingUpdateProfile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AccountUpdateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"profileImage"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Upload"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dogBreederHkFileUpload"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Upload"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dogBreederPermissionFilesUpload"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Upload"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dogBreederIdentityFilesUpload"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Upload"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dogBreederBreedClubFilesUpload"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Upload"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dogBreederCertificationFileUpload"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Upload"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dogBreederImagesUpload"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AccountDogBreederImgUploadInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dogBreederImageIdsRemoved"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"femaleBreedersCount"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountMeUpdate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}},{"kind":"Argument","name":{"kind":"Name","value":"profileImage"},"value":{"kind":"Variable","name":{"kind":"Name","value":"profileImage"}}},{"kind":"Argument","name":{"kind":"Name","value":"dogBreederImagesUpload"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dogBreederImagesUpload"}}},{"kind":"Argument","name":{"kind":"Name","value":"dogBreederHkFileUpload"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dogBreederHkFileUpload"}}},{"kind":"Argument","name":{"kind":"Name","value":"dogBreederPermissionFilesUpload"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dogBreederPermissionFilesUpload"}}},{"kind":"Argument","name":{"kind":"Name","value":"dogBreederIdentityFilesUpload"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dogBreederIdentityFilesUpload"}}},{"kind":"Argument","name":{"kind":"Name","value":"dogBreederBreedClubFilesUpload"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dogBreederBreedClubFilesUpload"}}},{"kind":"Argument","name":{"kind":"Name","value":"dogBreederCertificationFileUpload"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dogBreederCertificationFileUpload"}}},{"kind":"Argument","name":{"kind":"Name","value":"dogBreederImageIdsRemoved"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dogBreederImageIdsRemoved"}}},{"kind":"Argument","name":{"kind":"Name","value":"femaleBreedersCount"},"value":{"kind":"Variable","name":{"kind":"Name","value":"femaleBreedersCount"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<MtBreederOnboardingUpdateProfileMutation, MtBreederOnboardingUpdateProfileMutationVariables>;
export const AnnouncementsGetAnnouncementsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AnnouncementsGetAnnouncements"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AnnouncementOrderByWithRelationAndSearchRelevanceInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"translationWhere"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AnnouncementTranslationWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AnnouncementWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findManyAnnouncement"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"published"}},{"kind":"Field","name":{"kind":"Name","value":"countries"}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"translationWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"language"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"aggregateAnnouncement"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_count"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_all"}}]}}]}}]}}]} as unknown as DocumentNode<AnnouncementsGetAnnouncementsQuery, AnnouncementsGetAnnouncementsQueryVariables>;
export const MtLandingBreederUpdateProfileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MtLandingBreederUpdateProfile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AccountUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountMeUpdate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"dogBreeder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"hasStartedOnboarding"}}]}}]}}]}}]} as unknown as DocumentNode<MtLandingBreederUpdateProfileMutation, MtLandingBreederUpdateProfileMutationVariables>;
export const MtLitterCreateLitterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MtLitterCreateLitter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateLitterInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"imageUpload"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Upload"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createLitter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}},{"kind":"Argument","name":{"kind":"Name","value":"imagesUpload"},"value":{"kind":"Variable","name":{"kind":"Name","value":"imageUpload"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<MtLitterCreateLitterMutation, MtLitterCreateLitterMutationVariables>;
export const MtLitterGetAnimalsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MtLitterGetAnimals"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"animalsWhere"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AnimalWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountMe"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"animals"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"animalsWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"dogInfos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pedigree"}}]}}]}}]}}]}}]} as unknown as DocumentNode<MtLitterGetAnimalsQuery, MtLitterGetAnimalsQueryVariables>;
export const MtLitterGetBreederBreedsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MtLitterGetBreederBreeds"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"translationsWhere"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DogBreedTranslationWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountMe"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"dogBreeder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"breederBreeds"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"dogBreed"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"sizeCategory"}},{"kind":"Field","name":{"kind":"Name","value":"baseBreedName"}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"translationsWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"otherNames"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<MtLitterGetBreederBreedsQuery, MtLitterGetBreederBreedsQueryVariables>;
export const MtLitterGetLitterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MtLitterGetLitter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"translationsWhere"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LitterTranslationWhereInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dogBreedTranslationsWhere"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DogBreedTranslationWhereInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LitterWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountMe"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"dogBreeder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"country"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"litters"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"adminValidated"}},{"kind":"Field","name":{"kind":"Name","value":"archived"}},{"kind":"Field","name":{"kind":"Name","value":"born"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"priceFrom"}},{"kind":"Field","name":{"kind":"Name","value":"priceTo"}},{"kind":"Field","name":{"kind":"Name","value":"fixedPrice"}},{"kind":"Field","name":{"kind":"Name","value":"birthday"}},{"kind":"Field","name":{"kind":"Name","value":"availabilityDate"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"malesCount"}},{"kind":"Field","name":{"kind":"Name","value":"malesLeftCount"}},{"kind":"Field","name":{"kind":"Name","value":"femalesCount"}},{"kind":"Field","name":{"kind":"Name","value":"femalesLeftCount"}},{"kind":"Field","name":{"kind":"Name","value":"microchipped"}},{"kind":"Field","name":{"kind":"Name","value":"microchips"}},{"kind":"Field","name":{"kind":"Name","value":"vaccinated"}},{"kind":"Field","name":{"kind":"Name","value":"vaccinationDate"}},{"kind":"Field","name":{"kind":"Name","value":"pedigree"}},{"kind":"Field","name":{"kind":"Name","value":"pedigreeNumbers"}},{"kind":"Field","name":{"kind":"Name","value":"dewormed"}},{"kind":"Field","name":{"kind":"Name","value":"litterCode"}},{"kind":"Field","name":{"kind":"Name","value":"imgs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"small"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"parentType"}},{"kind":"Field","name":{"kind":"Name","value":"parentId"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dogInfos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pedigreeNumber"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"translationsWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"language"}}]}},{"kind":"Field","name":{"kind":"Name","value":"dogBreed"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dogBreedTranslationsWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"imgs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"small"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<MtLitterGetLitterQuery, MtLitterGetLitterQueryVariables>;
export const MtLitterUpdateLitterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MtLitterUpdateLitter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateLitterInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"litterId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"imageUpload"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Upload"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"imageIdsRemoved"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateLitter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}},{"kind":"Argument","name":{"kind":"Name","value":"litterId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"litterId"}}},{"kind":"Argument","name":{"kind":"Name","value":"imagesUpload"},"value":{"kind":"Variable","name":{"kind":"Name","value":"imageUpload"}}},{"kind":"Argument","name":{"kind":"Name","value":"imageIdsRemoved"},"value":{"kind":"Variable","name":{"kind":"Name","value":"imageIdsRemoved"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<MtLitterUpdateLitterMutation, MtLitterUpdateLitterMutationVariables>;
export const MtLittersGetLittersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MtLittersGetLitters"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LitterOrderByWithRelationAndSearchRelevanceInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LitterWhereInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"translationsWhere"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DogBreedTranslationWhereInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountMe"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"dogBreeder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"litters"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"adminValidated"}},{"kind":"Field","name":{"kind":"Name","value":"archived"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"priceFrom"}},{"kind":"Field","name":{"kind":"Name","value":"priceTo"}},{"kind":"Field","name":{"kind":"Name","value":"fixedPrice"}},{"kind":"Field","name":{"kind":"Name","value":"birthday"}},{"kind":"Field","name":{"kind":"Name","value":"availabilityDate"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"malesLeftCount"}},{"kind":"Field","name":{"kind":"Name","value":"femalesLeftCount"}},{"kind":"Field","name":{"kind":"Name","value":"malesCount"}},{"kind":"Field","name":{"kind":"Name","value":"femalesCount"}},{"kind":"Field","name":{"kind":"Name","value":"microchipped"}},{"kind":"Field","name":{"kind":"Name","value":"microchips"}},{"kind":"Field","name":{"kind":"Name","value":"vaccinated"}},{"kind":"Field","name":{"kind":"Name","value":"vaccinationDate"}},{"kind":"Field","name":{"kind":"Name","value":"pedigree"}},{"kind":"Field","name":{"kind":"Name","value":"pedigreeNumbers"}},{"kind":"Field","name":{"kind":"Name","value":"dewormed"}},{"kind":"Field","name":{"kind":"Name","value":"imgs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"small"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"parentType"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"testsResults"}},{"kind":"Field","name":{"kind":"Name","value":"titles"}},{"kind":"Field","name":{"kind":"Name","value":"microshipNumber"}},{"kind":"Field","name":{"kind":"Name","value":"pedigreeType"}},{"kind":"Field","name":{"kind":"Name","value":"pedigreeNumber"}},{"kind":"Field","name":{"kind":"Name","value":"img"}}]}},{"kind":"Field","name":{"kind":"Name","value":"dogBreed"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"translationsWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"imgs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"small"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<MtLittersGetLittersQuery, MtLittersGetLittersQueryVariables>;
export const DeleteConversationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteConversation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"conversationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteConversation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"conversationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"conversationId"}}}]}]}}]} as unknown as DocumentNode<DeleteConversationMutation, DeleteConversationMutationVariables>;
export const DeleteMessageMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteMessageMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"messageId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteMessage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"messageId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteMessageMutationMutation, DeleteMessageMutationMutationVariables>;
export const AccountGetConversationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AccountGetConversations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"conversations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"otherAccountId"}},{"kind":"Field","name":{"kind":"Name","value":"otherAccountFullName"}},{"kind":"Field","name":{"kind":"Name","value":"otherAccountProfileImage"}},{"kind":"Field","name":{"kind":"Name","value":"otherAccountIsDeleted"}},{"kind":"Field","name":{"kind":"Name","value":"otherAccountType"}}]}}]}}]} as unknown as DocumentNode<AccountGetConversationsQuery, AccountGetConversationsQueryVariables>;
export const AccountGetMessagesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AccountGetMessages"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"otherAccountId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"messages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"otherAccountId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"otherAccountId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"seen"}},{"kind":"Field","name":{"kind":"Name","value":"seenAt"}},{"kind":"Field","name":{"kind":"Name","value":"img"}},{"kind":"Field","name":{"kind":"Name","value":"file"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"reported"}},{"kind":"Field","name":{"kind":"Name","value":"fromAccountId"}},{"kind":"Field","name":{"kind":"Name","value":"toAccountId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]} as unknown as DocumentNode<AccountGetMessagesQuery, AccountGetMessagesQueryVariables>;
export const SendMessageMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SendMessageMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SendMessageInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sendMessage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"seen"}},{"kind":"Field","name":{"kind":"Name","value":"img"}},{"kind":"Field","name":{"kind":"Name","value":"file"}},{"kind":"Field","name":{"kind":"Name","value":"reported"}},{"kind":"Field","name":{"kind":"Name","value":"fromAccountId"}},{"kind":"Field","name":{"kind":"Name","value":"toAccountId"}}]}}]}}]} as unknown as DocumentNode<SendMessageMutationMutation, SendMessageMutationMutationVariables>;
export const MtProfileBreederUpdateProfileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MtProfileBreederUpdateProfile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AccountUpdateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"profileImage"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Upload"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dogBreederHkFileUpload"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Upload"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dogBreederPermissionFilesUpload"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Upload"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dogBreederIdentityFilesUpload"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Upload"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dogBreederBreedClubFilesUpload"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Upload"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dogBreederCertificationFileUpload"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Upload"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dogBreederImagesUpload"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AccountDogBreederImgUploadInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dogBreederImageIdsRemoved"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"femaleBreedersCount"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountMeUpdate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}},{"kind":"Argument","name":{"kind":"Name","value":"profileImage"},"value":{"kind":"Variable","name":{"kind":"Name","value":"profileImage"}}},{"kind":"Argument","name":{"kind":"Name","value":"dogBreederImagesUpload"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dogBreederImagesUpload"}}},{"kind":"Argument","name":{"kind":"Name","value":"dogBreederHkFileUpload"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dogBreederHkFileUpload"}}},{"kind":"Argument","name":{"kind":"Name","value":"dogBreederPermissionFilesUpload"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dogBreederPermissionFilesUpload"}}},{"kind":"Argument","name":{"kind":"Name","value":"dogBreederIdentityFilesUpload"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dogBreederIdentityFilesUpload"}}},{"kind":"Argument","name":{"kind":"Name","value":"dogBreederBreedClubFilesUpload"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dogBreederBreedClubFilesUpload"}}},{"kind":"Argument","name":{"kind":"Name","value":"dogBreederCertificationFileUpload"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dogBreederCertificationFileUpload"}}},{"kind":"Argument","name":{"kind":"Name","value":"dogBreederImageIdsRemoved"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dogBreederImageIdsRemoved"}}},{"kind":"Argument","name":{"kind":"Name","value":"femaleBreedersCount"},"value":{"kind":"Variable","name":{"kind":"Name","value":"femaleBreedersCount"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<MtProfileBreederUpdateProfileMutation, MtProfileBreederUpdateProfileMutationVariables>;
export const MtSettingsBreederGetProfileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MtSettingsBreederGetProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountMe"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CurrentAccountInfo"}},{"kind":"Field","name":{"kind":"Name","value":"birthday"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"contactPreferences"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CurrentAccountInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Account"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"firebaseId"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"dogBreeder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"certified"}},{"kind":"Field","name":{"kind":"Name","value":"hasStartedOnboarding"}}]}},{"kind":"Field","name":{"kind":"Name","value":"imgs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"EnumValue","value":"PROFILE"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"small"}}]}}]}}]} as unknown as DocumentNode<MtSettingsBreederGetProfileQuery, MtSettingsBreederGetProfileQueryVariables>;
export const MtSettingsBreederUpdateProfileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MtSettingsBreederUpdateProfile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AccountUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountMeUpdate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MtSettingsBreederProfile"}},{"kind":"Field","name":{"kind":"Name","value":"contactPreferences"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CurrentAccountInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Account"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"firebaseId"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"dogBreeder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"certified"}},{"kind":"Field","name":{"kind":"Name","value":"hasStartedOnboarding"}}]}},{"kind":"Field","name":{"kind":"Name","value":"imgs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"EnumValue","value":"PROFILE"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"small"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MtSettingsBreederProfile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Account"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CurrentAccountInfo"}}]}}]} as unknown as DocumentNode<MtSettingsBreederUpdateProfileMutation, MtSettingsBreederUpdateProfileMutationVariables>;
export const MtSettingsBuyerGetProfileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MtSettingsBuyerGetProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountMe"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CurrentAccountInfo"}},{"kind":"Field","name":{"kind":"Name","value":"birthday"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"contactPreferences"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CurrentAccountInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Account"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"firebaseId"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"dogBreeder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"certified"}},{"kind":"Field","name":{"kind":"Name","value":"hasStartedOnboarding"}}]}},{"kind":"Field","name":{"kind":"Name","value":"imgs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"EnumValue","value":"PROFILE"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"small"}}]}}]}}]} as unknown as DocumentNode<MtSettingsBuyerGetProfileQuery, MtSettingsBuyerGetProfileQueryVariables>;
export const MtSettingsBuyerUpdateProfileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MtSettingsBuyerUpdateProfile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AccountUpdateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"profileImage"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Upload"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountMeUpdate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}},{"kind":"Argument","name":{"kind":"Name","value":"profileImage"},"value":{"kind":"Variable","name":{"kind":"Name","value":"profileImage"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MtSettingsBuyerProfile"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CurrentAccountInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Account"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"firebaseId"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"dogBreeder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"certified"}},{"kind":"Field","name":{"kind":"Name","value":"hasStartedOnboarding"}}]}},{"kind":"Field","name":{"kind":"Name","value":"imgs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"EnumValue","value":"PROFILE"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"small"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MtSettingsBuyerProfile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Account"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CurrentAccountInfo"}},{"kind":"Field","name":{"kind":"Name","value":"birthday"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}}]}}]} as unknown as DocumentNode<MtSettingsBuyerUpdateProfileMutation, MtSettingsBuyerUpdateProfileMutationVariables>;
export const MtWishlistGetBookmarksDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MtWishlistGetBookmarks"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"BookmarkOrderByWithRelationAndSearchRelevanceInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"bookmarksWhere"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BookmarkWhereInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"litterCardInfoImgsTake"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"litterCardInfoTranslationsWhere"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LitterTranslationWhereInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"litterCardInfoBreedTranslationsWhere"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DogBreedTranslationWhereInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountMe"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"bookmarks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"bookmarksWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"litter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LitterCardInfo"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LitterCardInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Litter"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"priceFrom"}},{"kind":"Field","name":{"kind":"Name","value":"priceTo"}},{"kind":"Field","name":{"kind":"Name","value":"fixedPrice"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"birthday"}},{"kind":"Field","name":{"kind":"Name","value":"availabilityDate"}},{"kind":"Field","name":{"kind":"Name","value":"born"}},{"kind":"Field","name":{"kind":"Name","value":"pedigree"}},{"kind":"Field","name":{"kind":"Name","value":"malesLeftCount"}},{"kind":"Field","name":{"kind":"Name","value":"femalesLeftCount"}},{"kind":"Field","name":{"kind":"Name","value":"imgs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"litterCardInfoImgsTake"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"small"}},{"kind":"Field","name":{"kind":"Name","value":"medium"}}]}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"litterCardInfoTranslationsWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"breeder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"dogBreed"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"baseBreedName"}},{"kind":"Field","name":{"kind":"Name","value":"imgs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"large"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"litterCardInfoBreedTranslationsWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<MtWishlistGetBookmarksQuery, MtWishlistGetBookmarksQueryVariables>;
export const ProLandingGetGroomersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProLandingGetGroomers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProfessionalOrderByWithRelationAndSearchRelevanceInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ProfessionalWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"imgsTake"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"translationsWhere"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ProTranslationWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchProfessionals"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"professionals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"namePro"}},{"kind":"Field","name":{"kind":"Name","value":"mainProFirstName"}},{"kind":"Field","name":{"kind":"Name","value":"mainProLastName"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"imgs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"imgsTake"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"small"}}]}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"translationsWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"zip"}},{"kind":"Field","name":{"kind":"Name","value":"city"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ProLandingGetGroomersQuery, ProLandingGetGroomersQueryVariables>;
export const ProLandingGetVetsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProLandingGetVets"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProfessionalOrderByWithRelationAndSearchRelevanceInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ProfessionalWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"imgsTake"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"translationsWhere"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ProTranslationWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchProfessionals"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"professionals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"namePro"}},{"kind":"Field","name":{"kind":"Name","value":"mainProFirstName"}},{"kind":"Field","name":{"kind":"Name","value":"mainProLastName"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"imgs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"imgsTake"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"small"}}]}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"translationsWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"zip"}},{"kind":"Field","name":{"kind":"Name","value":"city"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ProLandingGetVetsQuery, ProLandingGetVetsQueryVariables>;
export const ProsListMapGetProDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProsListMapGetPro"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProfessionalWhereInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchProfessionals"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"professionals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"centerType"}},{"kind":"Field","name":{"kind":"Name","value":"educatorType"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"spokenLanguages"}},{"kind":"Field","name":{"kind":"Name","value":"centerType"}},{"kind":"Field","name":{"kind":"Name","value":"distance"}},{"kind":"Field","name":{"kind":"Name","value":"onlineBookingEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"unclaimedProfile"}},{"kind":"Field","name":{"kind":"Name","value":"reviews"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"grade"}}]}},{"kind":"Field","name":{"kind":"Name","value":"imgs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"small"}}]}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}}]}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ProsListMapGetProQuery, ProsListMapGetProQueryVariables>;
export const ProsListGetProMapMarkerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProsListGetProMapMarker"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProfessionalWhereInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchProfessionals"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"professionals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"onlineBookingEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"unclaimedProfile"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"formatted"}}]}},{"kind":"Field","name":{"kind":"Name","value":"imgs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"medium"}}]}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ProsListGetProMapMarkerQuery, ProsListGetProMapMarkerQueryVariables>;
export const ProsListGetProsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProsListGetPros"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ProfessionalWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProfessionalOrderByWithRelationAndSearchRelevanceInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"serviceId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"nearByPoint"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LatLngPoint"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"maxDistance"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"nearByAddress"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchProfessionals"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"nearByPoint"},"value":{"kind":"Variable","name":{"kind":"Name","value":"nearByPoint"}}},{"kind":"Argument","name":{"kind":"Name","value":"nearByAddress"},"value":{"kind":"Variable","name":{"kind":"Name","value":"nearByAddress"}}},{"kind":"Argument","name":{"kind":"Name","value":"serviceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"serviceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"maxDistance"},"value":{"kind":"Variable","name":{"kind":"Name","value":"maxDistance"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"professionals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"centerType"}},{"kind":"Field","name":{"kind":"Name","value":"educatorType"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"spokenLanguages"}},{"kind":"Field","name":{"kind":"Name","value":"centerType"}},{"kind":"Field","name":{"kind":"Name","value":"distance"}},{"kind":"Field","name":{"kind":"Name","value":"onlineBookingEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"unclaimedProfile"}},{"kind":"Field","name":{"kind":"Name","value":"imgs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"small"}}]}},{"kind":"Field","name":{"kind":"Name","value":"reviews"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"grade"}}]}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}}]}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<ProsListGetProsQuery, ProsListGetProsQueryVariables>;
export const ProsListMapGetProsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProsListMapGetPros"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ProfessionalWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"serviceId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchProfessionals"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"serviceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"serviceId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"professionals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"onlineBookingEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"unclaimedProfile"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ProsListMapGetProsQuery, ProsListMapGetProsQueryVariables>;
export const ProGetProDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProGetPro"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProfessionalWhereInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"serviceTranslationsWhere"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ServiceTranslationWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"categoryTranslationsWhere"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CategoryTranslationWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"proServiceLanguage"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchProfessionals"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"professionals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"centerType"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"spokenLanguages"}},{"kind":"Field","name":{"kind":"Name","value":"centerType"}},{"kind":"Field","name":{"kind":"Name","value":"whatsappNumber"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"mobilePhone"}},{"kind":"Field","name":{"kind":"Name","value":"hasShop"}},{"kind":"Field","name":{"kind":"Name","value":"website"}},{"kind":"Field","name":{"kind":"Name","value":"visitAtHome"}},{"kind":"Field","name":{"kind":"Name","value":"selfDogWash"}},{"kind":"Field","name":{"kind":"Name","value":"parking"}},{"kind":"Field","name":{"kind":"Name","value":"acceptedAnimals"}},{"kind":"Field","name":{"kind":"Name","value":"onlineBookingEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"acceptsOnlineAppointment"}},{"kind":"Field","name":{"kind":"Name","value":"visitAtHome"}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethods"}},{"kind":"Field","name":{"kind":"Name","value":"employeesCount"}},{"kind":"Field","name":{"kind":"Name","value":"assistantsCount"}},{"kind":"Field","name":{"kind":"Name","value":"unclaimedProfile"}},{"kind":"Field","name":{"kind":"Name","value":"acceptsNewClients"}},{"kind":"Field","name":{"kind":"Name","value":"profileVideo"}},{"kind":"Field","name":{"kind":"Name","value":"profileVideoPos"}},{"kind":"Field","name":{"kind":"Name","value":"isTipawPartner"}},{"kind":"Field","name":{"kind":"Name","value":"proSchedule"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dayOfWeek"}},{"kind":"Field","name":{"kind":"Name","value":"avails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"shopSchedule"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dayOfWeek"}},{"kind":"Field","name":{"kind":"Name","value":"openingHours"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"degrees"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"degree"}},{"kind":"Field","name":{"kind":"Name","value":"school"}},{"kind":"Field","name":{"kind":"Name","value":"dateEnd"}}]}},{"kind":"Field","name":{"kind":"Name","value":"imgs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"large"}},{"kind":"Field","name":{"kind":"Name","value":"medium"}}]}},{"kind":"Field","name":{"kind":"Name","value":"workers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"formatted"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"streetNumber"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"zip"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"Field","name":{"kind":"Name","value":"urgencyAvailabilities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"dayOfWeek"}}]}},{"kind":"Field","name":{"kind":"Name","value":"services"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"language"},"value":{"kind":"Variable","name":{"kind":"Name","value":"proServiceLanguage"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fromDurationMinute"}},{"kind":"Field","name":{"kind":"Name","value":"toDurationMinute"}},{"kind":"Field","name":{"kind":"Name","value":"bookable"}},{"kind":"Field","name":{"kind":"Name","value":"priceType"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"priceFrom"}},{"kind":"Field","name":{"kind":"Name","value":"priceTo"}},{"kind":"Field","name":{"kind":"Name","value":"workerServices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"workerId"}},{"kind":"Field","name":{"kind":"Name","value":"minimumDuration"}},{"kind":"Field","name":{"kind":"Name","value":"maximumDuration"}},{"kind":"Field","name":{"kind":"Name","value":"bookingDuration"}},{"kind":"Field","name":{"kind":"Name","value":"animalSize"}},{"kind":"Field","name":{"kind":"Name","value":"animalType"}},{"kind":"Field","name":{"kind":"Name","value":"isProSpecialist"}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"preBookingWarning"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"service"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"serviceTranslationsWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"categoryTranslationsWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"extraDescription"}},{"kind":"Field","name":{"kind":"Name","value":"subtitle"}},{"kind":"Field","name":{"kind":"Name","value":"wellnessEngagement"}},{"kind":"Field","name":{"kind":"Name","value":"preBookingWarning"}},{"kind":"Field","name":{"kind":"Name","value":"seoTitle"}},{"kind":"Field","name":{"kind":"Name","value":"seoDescription"}},{"kind":"Field","name":{"kind":"Name","value":"seoKeywords"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ProGetProQuery, ProGetProQueryVariables>;
export const ProIncreamentViewCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ProIncreamentViewCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"incrementProViewCount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"proId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]} as unknown as DocumentNode<ProIncreamentViewCountMutation, ProIncreamentViewCountMutationVariables>;
export const ProLogContactInfoClickDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ProLogContactInfoClick"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"proId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"logContactInfoClick"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"proId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"proId"}}}]}]}}]} as unknown as DocumentNode<ProLogContactInfoClickMutation, ProLogContactInfoClickMutationVariables>;
export const ProGetRelatedProfessionalsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProGetRelatedProfessionals"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"nearByPoint"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LatLngPoint"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"proId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"country"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CountryCode"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"language"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"proType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ProfessionalTypeEnum"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"relatedProfessionals"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"nearByPoint"},"value":{"kind":"Variable","name":{"kind":"Name","value":"nearByPoint"}}},{"kind":"Argument","name":{"kind":"Name","value":"country"},"value":{"kind":"Variable","name":{"kind":"Name","value":"country"}}},{"kind":"Argument","name":{"kind":"Name","value":"language"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}},{"kind":"Argument","name":{"kind":"Name","value":"proId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"proId"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"proType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"proType"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"region"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pros"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"language"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ProGetRelatedProfessionalsQuery, ProGetRelatedProfessionalsQueryVariables>;
export const ProRelatedLinksGetServicesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProRelatedLinksGetServices"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ServiceWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ServiceOrderByWithRelationAndSearchRelevanceInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findManyService"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]}}]} as unknown as DocumentNode<ProRelatedLinksGetServicesQuery, ProRelatedLinksGetServicesQueryVariables>;
export const QuizResultsGetBreedsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"QuizResultsGetBreeds"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DogBreedWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"translationsWhere"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DogBreedTranslationWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findManyDogBreed"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"baseBreedName"}},{"kind":"Field","name":{"kind":"Name","value":"exerciseIndex"}},{"kind":"Field","name":{"kind":"Name","value":"educationIndex"}},{"kind":"Field","name":{"kind":"Name","value":"careIndex"}},{"kind":"Field","name":{"kind":"Name","value":"sociabilityIndex"}},{"kind":"Field","name":{"kind":"Name","value":"independenceIndex"}},{"kind":"Field","name":{"kind":"Name","value":"physicalActivityNeedIndex"}},{"kind":"Field","name":{"kind":"Name","value":"predatoryInstinctIndex"}},{"kind":"Field","name":{"kind":"Name","value":"foreignerSociabilityIndex"}},{"kind":"Field","name":{"kind":"Name","value":"barkingTendancyIndex"}},{"kind":"Field","name":{"kind":"Name","value":"sizeCategory"}},{"kind":"Field","name":{"kind":"Name","value":"dogBreeders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dogBreeder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"public"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"litters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"adminValidated"}},{"kind":"Field","name":{"kind":"Name","value":"archived"}}]}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"translationsWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"imgs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"small"}}]}}]}}]}}]} as unknown as DocumentNode<QuizResultsGetBreedsQuery, QuizResultsGetBreedsQueryVariables>;
export const AccountLogPasswordResetDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AccountLogPasswordReset"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"actionCode"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"message"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"logPasswordReset"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"actionCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"actionCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"message"},"value":{"kind":"Variable","name":{"kind":"Name","value":"message"}}}]}]}}]} as unknown as DocumentNode<AccountLogPasswordResetMutation, AccountLogPasswordResetMutationVariables>;
export const ShelterListGetSheltersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ShelterListGetShelters"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DogShelterWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DogShelterOrderByWithRelationAndSearchRelevanceInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"translationWhere"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DogShelterTranslationWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findManyDogShelter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ShelterCardInfo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"aggregateDogShelter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_count"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_all"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ShelterCardInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DogShelter"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"imgs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"small"}}]}},{"kind":"Field","name":{"kind":"Name","value":"spokenLanguages"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"zip"}}]}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"translationWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"language"}}]}}]}}]} as unknown as DocumentNode<ShelterListGetSheltersQuery, ShelterListGetSheltersQueryVariables>;
export const ShelterGetArticlesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ShelterGetArticles"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ArticleWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ArticleOrderByWithRelationAndSearchRelevanceInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"articleCardInfoTranslationsWhere"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ArticleTranslationsWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findManyArticle"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"randomOrder"},"value":{"kind":"BooleanValue","value":true}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ArticleCardInfo"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ArticleCardInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"reviewed"}},{"kind":"Field","name":{"kind":"Name","value":"coverImg"}},{"kind":"Field","name":{"kind":"Name","value":"tags"}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"articleCardInfoTranslationsWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]} as unknown as DocumentNode<ShelterGetArticlesQuery, ShelterGetArticlesQueryVariables>;
export const ShelterGetShelterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ShelterGetShelter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DogShelterWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findManyDogShelter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"agreementNumber"}},{"kind":"Field","name":{"kind":"Name","value":"emails"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumbers"}},{"kind":"Field","name":{"kind":"Name","value":"links"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"additionalInfo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"openingHours"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dayOfWeek"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}}]}},{"kind":"Field","name":{"kind":"Name","value":"spokenLanguages"}},{"kind":"Field","name":{"kind":"Name","value":"imgs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"small"}},{"kind":"Field","name":{"kind":"Name","value":"medium"}},{"kind":"Field","name":{"kind":"Name","value":"large"}}]}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"zip"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}}]}}]}}]}}]} as unknown as DocumentNode<ShelterGetShelterQuery, ShelterGetShelterQueryVariables>;
export const ShelterGetSheltersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ShelterGetShelters"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DogShelterWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"translationWhere"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DogShelterTranslationWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findManyDogShelter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ShelterCardInfo"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ShelterCardInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DogShelter"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"imgs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"small"}}]}},{"kind":"Field","name":{"kind":"Name","value":"spokenLanguages"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"zip"}}]}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"translationWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"language"}}]}}]}}]} as unknown as DocumentNode<ShelterGetSheltersQuery, ShelterGetSheltersQueryVariables>;
export const ShelterRelatedLinksGetArticlesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ShelterRelatedLinksGetArticles"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ArticleWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"translationsWhere"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ArticleTranslationsWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findManyArticle"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"randomOrder"},"value":{"kind":"BooleanValue","value":true}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"translationsWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]}}]} as unknown as DocumentNode<ShelterRelatedLinksGetArticlesQuery, ShelterRelatedLinksGetArticlesQueryVariables>;
export const ShelterRelatedLinksGetBreedsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ShelterRelatedLinksGetBreeds"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DogBreedWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"translationsWhere"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DogBreedTranslationWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findManyDogBreed"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"translationsWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<ShelterRelatedLinksGetBreedsQuery, ShelterRelatedLinksGetBreedsQueryVariables>;
export const ShelterRelatedLinksGetSheltersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ShelterRelatedLinksGetShelters"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DogShelterWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"translationWhere"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DogShelterTranslationWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"randomOrder"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findManyDogShelter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"randomOrder"},"value":{"kind":"Variable","name":{"kind":"Name","value":"randomOrder"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"translationWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]} as unknown as DocumentNode<ShelterRelatedLinksGetSheltersQuery, ShelterRelatedLinksGetSheltersQueryVariables>;
export const StudListGetStudsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"StudListGetStuds"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AnimalWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"breedingCardInfoTranslationsWhereBreed"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DogBreedTranslationWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AnimalOrderByWithRelationAndSearchRelevanceInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findManyAnimal"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"imgs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"small"}}]}},{"kind":"Field","name":{"kind":"Name","value":"dogInfos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"pedigree"}},{"kind":"Field","name":{"kind":"Name","value":"dogBreed"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"translations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"breedingCardInfoTranslationsWhereBreed"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"studInfos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"champion"}}]}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"aggregateAnimal"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_count"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_all"}}]}}]}}]}}]} as unknown as DocumentNode<StudListGetStudsQuery, StudListGetStudsQueryVariables>;
export const StudGetBreedersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"StudGetBreeders"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DogBreederWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DogBreederOrderByWithRelationAndSearchRelevanceInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"breederCardInfoTranslationsWhere"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DogBreederTranslationWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"breederCardInfoTranslationsWhereBreed"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DogBreedTranslationWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"breederCardInfoBreedImgsTake"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"breederCardInfoLittersWhere"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LitterWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findManyDogBreeder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BreederCardInfo"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BreederCardInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DogBreeder"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"spokenLanguages"}},{"kind":"Field","name":{"kind":"Name","value":"dogsPedigree"}},{"kind":"Field","name":{"kind":"Name","value":"lastConnectedType"}},{"kind":"Field","name":{"kind":"Name","value":"certificationFile"}},{"kind":"Field","name":{"kind":"Name","value":"breedClubValidated"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"connectedAt"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"region"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"breederCardInfoTranslationsWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"reviews"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"globalGrade"}},{"kind":"Field","name":{"kind":"Name","value":"accountId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"imgs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"small"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"breederBreeds"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"dogBreed"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"imgs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"breederCardInfoBreedImgsTake"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"medium"}}]}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"breederCardInfoTranslationsWhereBreed"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"litters"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"breederCardInfoLittersWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<StudGetBreedersQuery, StudGetBreedersQueryVariables>;
export const StudGetStudDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"StudGetStud"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AnimalWhereInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"breedCardInfoTranslationsWhere"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DogBreedTranslationWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"breederCardInfoTranslationsWhere"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DogBreederTranslationWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findManyAnimal"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"imgs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"small"}},{"kind":"Field","name":{"kind":"Name","value":"medium"}},{"kind":"Field","name":{"kind":"Name","value":"large"}}]}},{"kind":"Field","name":{"kind":"Name","value":"dogInfos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"pedigree"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"coat"}},{"kind":"Field","name":{"kind":"Name","value":"dogBreed"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BreedCardInfo"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"studInfos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"champion"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"accomodation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"dogBreeder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"breedingName"}},{"kind":"Field","name":{"kind":"Name","value":"level"}},{"kind":"Field","name":{"kind":"Name","value":"profileImg"}},{"kind":"Field","name":{"kind":"Name","value":"certificationFile"}},{"kind":"Field","name":{"kind":"Name","value":"agreementNumber"}},{"kind":"Field","name":{"kind":"Name","value":"lastConnectedType"}},{"kind":"Field","name":{"kind":"Name","value":"spokenLanguages"}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"breederCardInfoTranslationsWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"language"}}]}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"connectedAt"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BreedCardInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DogBreed"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"exerciseIndex"}},{"kind":"Field","name":{"kind":"Name","value":"educationIndex"}},{"kind":"Field","name":{"kind":"Name","value":"careIndex"}},{"kind":"Field","name":{"kind":"Name","value":"sociabilityIndex"}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"breedCardInfoTranslationsWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"language"}}]}},{"kind":"Field","name":{"kind":"Name","value":"imgs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"small"}}]}}]}}]} as unknown as DocumentNode<StudGetStudQuery, StudGetStudQueryVariables>;
export const UnsubscribeManageContactPreferencesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UnsubscribeManageContactPreferences"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ManageContactPreferencesInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"manageContactPreferences"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}]}]}}]} as unknown as DocumentNode<UnsubscribeManageContactPreferencesMutation, UnsubscribeManageContactPreferencesMutationVariables>;
export const UnsubscribeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Unsubscribe"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cryptedEmail"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contactPreferenceToDisable"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unsubscribe"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"cryptedEmail"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cryptedEmail"}}},{"kind":"Argument","name":{"kind":"Name","value":"contactPreferenceToDisable"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contactPreferenceToDisable"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"contactPreferences"}},{"kind":"Field","name":{"kind":"Name","value":"isRegisteredUser"}}]}}]}}]} as unknown as DocumentNode<UnsubscribeQuery, UnsubscribeQueryVariables>;
export const GetContactPreferencesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetContactPreferences"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getContactPreferences"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"contactPreferences"}},{"kind":"Field","name":{"kind":"Name","value":"isRegisteredUser"}}]}}]}}]} as unknown as DocumentNode<GetContactPreferencesQuery, GetContactPreferencesQueryVariables>;
export const NewsletterCreateEmailContactDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"NewsletterCreateEmailContact"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateEmailContactInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createEmailContact"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<NewsletterCreateEmailContactMutation, NewsletterCreateEmailContactMutationVariables>;
export const PersistHasADogDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"PersistHasADog"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PersistHasADogInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"persistHasADog"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}]}]}}]} as unknown as DocumentNode<PersistHasADogMutation, PersistHasADogMutationVariables>;
export const GetAutocompleteResultsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"GetAutocompleteResults"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"language"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"location"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"placeId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"country"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"autocompleteSuggestions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"language"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}},{"kind":"Argument","name":{"kind":"Name","value":"location"},"value":{"kind":"Variable","name":{"kind":"Name","value":"location"}}},{"kind":"Argument","name":{"kind":"Name","value":"placeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"placeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"country"},"value":{"kind":"Variable","name":{"kind":"Name","value":"country"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"placeId"}},{"kind":"Field","name":{"kind":"Name","value":"lon"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]} as unknown as DocumentNode<GetAutocompleteResultsMutation, GetAutocompleteResultsMutationVariables>;
export const ProSearchGetProsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProSearchGetPros"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ProfessionalWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchProfessionals"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"5"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"professionals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"centerType"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"city"}}]}},{"kind":"Field","name":{"kind":"Name","value":"imgs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"medium"}}]}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ProSearchGetProsQuery, ProSearchGetProsQueryVariables>;
export const ServiceSearchGetServicesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ServiceSearchGetServices"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"servicesWhere"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ServiceWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"serviceTranslationsWhere"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ServiceTranslationWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findManyService"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"servicesWhere"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"proType"}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"serviceTranslationsWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]}}]} as unknown as DocumentNode<ServiceSearchGetServicesQuery, ServiceSearchGetServicesQueryVariables>;